
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("b3YrF", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kkhbp = parcelRequire("kkhbp");


var $a4TK8 = parcelRequire("a4TK8");


var $6qdjm = parcelRequire("6qdjm");

function $9b7d71e0ed14ef6d$export$feb16861fe41d066(api, plugin, options = {}) {
    const transformer = (0, $42omo.useCallback)((pluginState)=>{
        const [pluginName, ...properties] = plugin.split('.');
        if (!pluginState || properties?.length === 0) return undefined;
        return (0, (/*@__PURE__*/$parcel$interopDefault($kkhbp)))(pluginState?.[`${pluginName}State`], properties);
    }, [
        plugin
    ]);
    const pluginNameArray = (0, $42omo.useMemo)(()=>{
        const [pluginName] = plugin.split('.');
        return [
            pluginName
        ];
    }, [
        plugin
    ]);
    const initialState = (0, $42omo.useMemo)(()=>{
        if (options.disabled) return;
        const [pluginName] = plugin.split('.');
        return transformer({
            [`${pluginName}State`]: api?.[pluginName]?.sharedState.currentState()
        });
    }, [
        plugin,
        api,
        options.disabled,
        transformer
    ]);
    return $9b7d71e0ed14ef6d$var$useSharedPluginStateSelectorInternal(api, pluginNameArray, transformer, initialState, options);
}
function $9b7d71e0ed14ef6d$var$useSharedPluginStateSelectorInternal(api, plugins, transformer, initialState, options = {}) {
    const [selectedPluginState, setSelectedPluginState] = (0, $42omo.useState)(()=>initialState);
    (0, $6qdjm.usePluginStateEffect)(api, plugins, (pluginStates)=>{
        // `pluginStates`: This is the same type through inference - but typescript doesn't recognise them as they are computed slightly differently
        const transformedValue = transformer(pluginStates);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(transformedValue, selectedPluginState)) setSelectedPluginState(()=>transformedValue);
    }, options);
    return selectedPluginState;
}
module.exports["useSharedPluginStateSelector"] = $9b7d71e0ed14ef6d$export$feb16861fe41d066;

});

parcelRegister("1JdaQ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bupcf = parcelRequire("bupcf");

function $8ff7e207bc73753f$export$1d81a44583df97d2(createPreset, dependencies = []) {
    const [editorApi, setAPI] = (0, $42omo.useState)(undefined);
    const preset = (0, $42omo.useMemo)(()=>createPreset(new (0, $bupcf.EditorPresetBuilder)()), // eslint-disable-next-line react-hooks/exhaustive-deps
    dependencies);
    (0, $42omo.useLayoutEffect)(()=>{
        return preset.apiResolver.on((api)=>{
            setAPI(api);
        });
    }, [
        preset.apiResolver
    ]);
    return {
        editorApi: editorApi,
        preset: preset
    };
}
module.exports["usePreset"] = $8ff7e207bc73753f$export$1d81a44583df97d2;

});

parcelRegister("bupcf", function(module, exports) {

var $1oCLl = parcelRequire("1oCLl");


var $5vVM5 = parcelRequire("5vVM5");

class $c3fd9cf3aa7963e8$export$dab03ba05a79e5c7 {
    add(nextOrTuple) {
        return new $c3fd9cf3aa7963e8$export$dab03ba05a79e5c7(/**
     * re-cast this to NewPlugin as we've done all the type
     * safety, dependency checking, narrowing, during
     * `SafePresetCheck & VerifyPluginDependencies`
     */ nextOrTuple, ...this.data);
    }
    maybeAdd(pluginToAdd, shouldAdd) {
        const pluginOrBuilder = typeof shouldAdd === 'function' ? // @ts-expect-error Argument of type 'SafePresetCheck<ToAddPlugin, StackPlugins>' is not assignable to parameter of type 'ToAddPlugin'.
        shouldAdd(pluginToAdd, this) : shouldAdd;
        if (pluginOrBuilder instanceof $c3fd9cf3aa7963e8$export$dab03ba05a79e5c7) return pluginOrBuilder;
        const nextPluginStack = [
            /**
     * re-cast this to NewPlugin as we've done all the type
     * safety, dependency checking, narrowing, during
     * `SafePresetCheck & VerifyPluginDependencies`
     */ pluginOrBuilder ? pluginToAdd : undefined,
            ...this.data
        ];
        const nextEditorPresetBuilder = new $c3fd9cf3aa7963e8$export$dab03ba05a79e5c7(...nextPluginStack);
        return nextEditorPresetBuilder;
    }
    has(plugin) {
        return this.data.some((pluginPreset)=>{
            if (Array.isArray(pluginPreset)) return pluginPreset[0] === plugin;
            return pluginPreset === plugin;
        });
    }
    build({ pluginInjectionAPI: pluginInjectionAPI, excludePlugins: maybeExcludePlugins } = {}) {
        const excludePlugins = new Set(maybeExcludePlugins ? maybeExcludePlugins : []);
        const editorPlugins = this.processEditorPlugins({
            pluginInjectionAPI: pluginInjectionAPI,
            excludePlugins: excludePlugins
        });
        if (pluginInjectionAPI) {
            // The pluginInjectionAPI API doesn't have information enough to build a proper type for the API.
            // It is returning a generic type but on top of the Proxy system
            // So, we can safely recast it here
            this.apiEmitter(pluginInjectionAPI.api());
            // Deprecated approach
            this.resolver?.(pluginInjectionAPI.api());
        }
        return this.removeExcludedPlugins(editorPlugins, excludePlugins);
    }
    verifyDuplicatedPlugins() {
        const cache = new Set();
        this.data.filter(Boolean).forEach((pluginEntry)=>{
            const [pluginFn, _] = Array.isArray(pluginEntry) ? pluginEntry : [
                pluginEntry,
                undefined
            ];
            if (cache.has(pluginFn)) throw new Error(`${pluginFn} is already included!`);
            cache.add(pluginFn);
        });
        return true;
    }
    processEditorPlugins({ pluginInjectionAPI: pluginInjectionAPI, excludePlugins: excludePlugins }) {
        this.verifyDuplicatedPlugins();
        const seen = new Set();
        const pluginsDataCopy = this.data.slice();
        const plugins = pluginsDataCopy.reverse().filter(Boolean).map((entry)=>{
            const [fn, config] = this.safeEntry(entry);
            if (seen.has(fn)) return null;
            seen.add(fn);
            if (typeof fn !== 'function') return null;
            let plugin;
            if ((0, $1oCLl.expValEquals)('platform_editor_improve_preset_builder_logging', 'isEnabled', true)) try {
                plugin = pluginInjectionAPI ? fn({
                    config: config,
                    api: pluginInjectionAPI.api()
                }) : fn({
                    config: config
                });
            } catch (error) {
                const pluginName = fn.name || 'unknown';
                const enhancedError = error instanceof Error ? new Error(`Failed to initialize plugin '${pluginName}': ${error.message}`) : new Error(`Failed to initialize plugin '${pluginName}'`);
                throw enhancedError;
            }
            else plugin = pluginInjectionAPI ? fn({
                config: config,
                api: pluginInjectionAPI.api()
            }) : fn({
                config: config
            });
            if (plugin && excludePlugins?.has(plugin.name)) return null;
            if (!pluginInjectionAPI) return plugin;
            pluginInjectionAPI.onEditorPluginInitialized(plugin);
            return plugin;
        }).filter(Boolean);
        return plugins;
    }
    removeExcludedPlugins(plugins, excludes) {
        if (excludes) return plugins.filter((plugin)=>!plugin || !excludes.has(plugin.name));
        return plugins;
    }
    constructor(...more){
        this.data = void 0;
        // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
        /**
     * @deprecated Use `apiResolver` instead
     */ this.apiPromise = void 0;
        this.resolver = void 0;
        /**
     * Returns the editor API when resolved.
     * This occurs when the preset is initially built.
     */ this.apiResolver = void 0;
        this.apiEmitter = ()=>{};
        this.safeEntry = (plugin)=>Array.isArray(plugin) ? plugin : [
                plugin,
                undefined
            ];
        // @ts-ignore - TS2872 TypeScript 5.9.2 upgrade
        this.data = [
            ...more
        ];
        this.apiPromise = new Promise((r)=>this.resolver = r);
        this.apiResolver = new $c3fd9cf3aa7963e8$var$APIDispatcher((emitter)=>this.apiEmitter = emitter);
    }
}
/**
 * WARNING: Internal object
 *
 * Dedicated wrapper around EventDispatcher for public API around the editor API.
 * This only has the public method `on` which is used to listen to updates to the editor API.
 *
 * This shouldn't really be used externally - the `editorAPI` should be accessed via `usePreset`.
 */ class $c3fd9cf3aa7963e8$var$APIDispatcher {
    /**
   * Used to observe Editor API events
   *
   * @param cb Callback to listen to the editor API.
   * This will also emit the last event if the stream has already started.
   * @returns Cleanup function to cleanup the listener
   */ on(cb) {
        if (this.initialEvent !== undefined) // Keeps timing consistent with old approach - certain products
        // ie. ai-mate relied on this.
        Promise.resolve().then(()=>cb(this.initialEvent));
        this.eventDispatcher.on(this.key, cb);
        return ()=>{
            this.eventDispatcher.off(this.key, cb);
        };
    }
    destroy() {
        this.eventDispatcher.destroy();
    }
    constructor(emitter){
        this.emitter = emitter;
        this.eventDispatcher = new (0, $5vVM5.EventDispatcher)();
        this.key = 'api-resolved-event';
        // Need to store the last event created in case we subscribe after the fact
        this.initialEvent = undefined;
        this.emitter((v)=>{
            this.initialEvent = v;
            this.eventDispatcher.emit(this.key, v);
        });
    }
}
module.exports["EditorPresetBuilder"] = $c3fd9cf3aa7963e8$export$dab03ba05a79e5c7;

});

parcelRegister("lkJUe", function(module, exports) {
/**
 * Creates a ProseMirror plugin's state and handles UI updates.
 *
 * Here's a few things to keep in mind:
 * - plugin's state is stored as a single object
 * - `Reducer` specifies how plugin's state changes in response to commands
 * - `Command` describes only what happen, but not how state changes
 * - `mapping` could be used to map ProseMirror positions stored in plugin's state
 *
 * Example:
 *  const { createPluginState, createCommand, getPluginState } = pluginFactory(
 *    reducer,
 *    pluginKey
 *  );
 *
 *  export const createPlugin = (dispatch: Dispatch, initialState) =>
 *    new SafePlugin({
 *      state: createPluginState(dispatch, initialState),
 *      key: pluginKey
 *    });
 *
 * Example of a reducer:
 *
 *  export const reducer = (
 *    state: TablePluginState,
 *    action: TableAction,
 *  ): TablePluginState => {
 *    switch (action.type) {
 *      case 'TOGGLE_CONTEXTUAL_MENU':
 *      return {
 *        ...state,
 *        isContextualMenuOpen: !state.isContextualMenuOpen,
 *      };
 *    default:
 *      return state;
 *    }
 *  };
 *
 *
 * Example of a command:
 *
 * export const toggleContextualMenu = createCommand({
 *   type: 'TOGGLE_CONTEXTUAL_MENU',
 * }, tr => tr.setMeta('addToHistory', false));
 *
 */ // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $6882d98e64286c4c$var$isFunction(x) {
    return typeof x === 'function';
}
function $6882d98e64286c4c$export$3dd00fb488ab385a(pluginKey, reducer, options = {}) {
    const { mapping: mapping, onDocChanged: onDocChanged, onSelectionChanged: onSelectionChanged } = options;
    return {
        createPluginState (dispatch, initialState) {
            return {
                init: (_, state)=>$6882d98e64286c4c$var$isFunction(initialState) ? initialState(state) : initialState,
                apply: (tr, _pluginState, _oldEditorState, newEditorState)=>{
                    const oldPluginState = mapping ? mapping(tr, _pluginState, newEditorState) : _pluginState;
                    let newPluginState = oldPluginState;
                    const meta = tr.getMeta(pluginKey);
                    if (meta) newPluginState = reducer(oldPluginState, meta);
                    if (onDocChanged && tr.docChanged) newPluginState = onDocChanged(tr, newPluginState, newEditorState);
                    else if (onSelectionChanged && tr.selectionSet) newPluginState = onSelectionChanged(tr, newPluginState, newEditorState);
                    if (newPluginState !== oldPluginState) dispatch(pluginKey, newPluginState);
                    return newPluginState;
                }
            };
        },
        createCommand (action, transform) {
            return (state, dispatch)=>{
                if (dispatch) {
                    const tr = transform ? transform(state.tr, state) : state.tr;
                    const resolvedAction = $6882d98e64286c4c$var$isFunction(action) ? action(state) : action;
                    if (tr && resolvedAction) dispatch(tr.setMeta(pluginKey, resolvedAction));
                    else return false;
                }
                return true;
            };
        },
        getPluginState (state) {
            return pluginKey.getState(state);
        }
    };
}
module.exports["pluginFactory"] = $6882d98e64286c4c$export$3dd00fb488ab385a;

});

parcelRegister("zT4ZO", function(module, exports) {

var $5SAOw = parcelRequire("5SAOw");


var $ks2lK = parcelRequire("ks2lK");


var $aXG5V = parcelRequire("aXG5V");


var $8m4tT = parcelRequire("8m4tT");


var $adhil = parcelRequire("adhil");

var $9GYNY = parcelRequire("9GYNY");

parcelRequire("l9G9n");
var $jMZUD = parcelRequire("jMZUD");

var $4DdJm = parcelRequire("4DdJm");

var $e5b978def8a005db$export$cbdce50c60b34c89 = /*#__PURE__*/ function(LookDirection) {
    LookDirection["Before"] = "before";
    LookDirection["After"] = "after";
    return LookDirection;
}({});
const $e5b978def8a005db$export$9a3d0d2a50538e52 = ({ selection: selection, doc: doc }, node)=>{
    if (selection.$from.depth > 1) {
        if (node.attrs.layout && node.attrs.layout !== 'default') return node.type.createChecked({
            ...node.attrs,
            layout: 'default'
        }, node.content, node.marks);
        // If its a breakout layout, we can remove the mark
        // Since default isn't a valid breakout mode.
        const breakoutMark = doc.type.schema.marks.breakout;
        if (breakoutMark && breakoutMark.isInSet(node.marks)) {
            const newMarks = breakoutMark.removeFromSet(node.marks);
            return node.type.createChecked(node.attrs, node.content, newMarks);
        }
    }
    return node;
};
const $e5b978def8a005db$var$isLastChild = ($pos, doc)=>doc.resolve($pos.after()).node().lastChild === $pos.node();
const $e5b978def8a005db$var$isFirstChild = ($pos, doc)=>doc.resolve($pos.before()).node().firstChild === $pos.node();
const $e5b978def8a005db$var$nodeIsInsideAList = (tr)=>{
    const { nodes: nodes } = tr.doc.type.schema;
    return (0, $8m4tT.hasParentNodeOfType)([
        nodes.orderedList,
        nodes.bulletList
    ])(tr.selection);
};
const $e5b978def8a005db$var$selectionIsInsideAPanel = (tr)=>{
    const { nodes: nodes } = tr.doc.type.schema;
    return (0, $8m4tT.hasParentNodeOfType)(nodes.panel)(tr.selection);
};
const $e5b978def8a005db$var$selectionIsInNestedList = (tr)=>{
    const { nodes: nodes } = tr.doc.type.schema;
    const parentListNode = (0, $8m4tT.findParentNodeOfType)([
        nodes.orderedList,
        nodes.bulletList
    ])(tr.selection);
    if (!parentListNode) return false;
    return (0, $4DdJm.isListItemNode)(tr.doc.resolve(parentListNode.pos).parent);
};
const $e5b978def8a005db$var$insertBeforeOrAfter = (tr, lookDirection, $parentPos, $proposedPosition, content)=>{
    /**
	 * This block caters for the first item in a parent with the cursor being at the very start
	 * or the last item with the cursor being at the very end
	 *
	 * e.g.
	 * ul
	 *  li {<>}Scenario one
	 *  li
	 *  li Scenario two{<>}
	 */ if ($e5b978def8a005db$var$isFirstChild($proposedPosition, tr.doc) && lookDirection === "before" || $e5b978def8a005db$var$isLastChild($proposedPosition, tr.doc) && lookDirection === "after") return tr.insert($parentPos[lookDirection](), content);
    return tr.insert($proposedPosition[lookDirection](), content);
};
// Ignored via go/ees007
// eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
// FIXME: A more sustainable and configurable way to choose when to split
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e5b978def8a005db$var$shouldSplit = (nodeType, schemaNodes)=>{
    return [
        schemaNodes.bulletList,
        schemaNodes.orderedList,
        schemaNodes.panel
    ].includes(nodeType);
};
const $e5b978def8a005db$export$5fe92db78385e37c = (content, position)=>(tr)=>{
        const { nodes: nodes } = tr.doc.type.schema;
        const whitelist = [
            nodes.rule,
            nodes.mediaSingle
        ];
        if (content instanceof (0, $5SAOw.Fragment) || !whitelist.includes(content.type)) return null;
        // Check for selection
        if (!tr.selection.empty || (0, $8m4tT.isNodeSelection)(tr.selection)) // NOT IMPLEMENTED
        return null;
        const { $from: $from } = tr.selection;
        const $insertPos = position ? tr.doc.resolve(position) : (0, $8m4tT.isNodeSelection)(tr.selection) ? tr.doc.resolve($from.pos + 1) : $from;
        let lookDirection;
        const insertPosEnd = $insertPos.end();
        const insertPosStart = $insertPos.start();
        // When parent node is an empty paragraph,
        // check the empty paragraph is the first or last node of its parent.
        if ((0, $jMZUD.isEmptyParagraph)($insertPos.parent)) {
            if ($e5b978def8a005db$var$isLastChild($insertPos, tr.doc)) lookDirection = "after";
            else if ($e5b978def8a005db$var$isFirstChild($insertPos, tr.doc)) lookDirection = "before";
        } else {
            if ($insertPos.pos === insertPosEnd) lookDirection = "after";
            else if ($insertPos.pos === insertPosStart) lookDirection = "before";
        }
        const grandParentNodeType = tr.selection.$from.node(-1)?.type;
        const parentNodeType = tr.selection.$from.parent.type;
        // if there is no direction, and cannot split for this particular node
        const noDirectionAndShouldNotSplit = !lookDirection && !$e5b978def8a005db$export$b80431b156693a98({
            parentNodeType: parentNodeType,
            grandParentNodeType: grandParentNodeType,
            content: content
        });
        const ruleNodeInANestedListNode = content.type === nodes.rule && $e5b978def8a005db$var$selectionIsInNestedList(tr);
        const nonRuleNodeInListNode = !(content.type === nodes.rule) && $e5b978def8a005db$var$nodeIsInsideAList(tr);
        if (ruleNodeInANestedListNode || noDirectionAndShouldNotSplit && nonRuleNodeInListNode || noDirectionAndShouldNotSplit && !$e5b978def8a005db$var$nodeIsInsideAList(tr)) // node to be inserted is an invalid child of selection so insert below selected node
        return (0, $8m4tT.safeInsert)(content, tr.selection.from)(tr);
        // if node is a rule and that is a flat list splitting and not at the end of a list
        const { from: from, to: to } = tr.selection;
        const ruleTypeInAList = content.type === nodes.rule && $e5b978def8a005db$var$nodeIsInsideAList(tr);
        if (ruleTypeInAList && !($insertPos.pos === insertPosEnd)) return tr.replaceRange(from, to, new (0, $5SAOw.Slice)((0, $5SAOw.Fragment).from(nodes.rule.createChecked()), 0, 0));
        if (!lookDirection) // fallback to consumer for now
        return null;
        // Replace empty paragraph
        if ((0, $jMZUD.isEmptyParagraph)($insertPos.parent) && (0, $8m4tT.canInsert)(tr.doc.resolve($insertPos[lookDirection]()), content)) return $e5b978def8a005db$var$finaliseInsert(tr.replaceWith($insertPos.before(), $insertPos.after(), content), -1);
        let $proposedPosition = $insertPos;
        while($proposedPosition.depth > 0){
            const $parentPos = tr.doc.resolve($proposedPosition[lookDirection]());
            const parentNode = $parentPos.node();
            // Insert at position (before or after target pos)
            if ((0, $8m4tT.canInsert)($proposedPosition, content)) return $e5b978def8a005db$var$finaliseInsert(tr.insert($proposedPosition.pos, content), content.nodeSize);
            // If we can't insert, and we think we should split, we fallback to consumer for now
            if ($e5b978def8a005db$var$shouldSplit(parentNode.type, tr.doc.type.schema.nodes)) {
                const nextTr = $e5b978def8a005db$var$finaliseInsert($e5b978def8a005db$var$insertBeforeOrAfter(tr, lookDirection, $parentPos, $proposedPosition, content), content.nodeSize);
                // Move selection to the closest text node, otherwise it defaults to the whatever the lookDirection is set to above
                if ([
                    nodes.orderedList,
                    nodes.bulletList
                ].includes(parentNode.type) && nextTr) return nextTr.setSelection((0, $ks2lK.TextSelection).between(nextTr.selection.$from, nextTr.selection.$from));
                else return nextTr;
            }
            // Can not insert into current parent, step up one parent
            $proposedPosition = $parentPos;
        }
        return $e5b978def8a005db$var$finaliseInsert(tr.insert($proposedPosition.pos, content), content.nodeSize);
    };
const $e5b978def8a005db$var$finaliseInsert = (tr, nodeLength)=>{
    const lastStep = tr.steps[tr.steps.length - 1];
    if (!(lastStep instanceof (0, $aXG5V.ReplaceStep) || lastStep instanceof (0, $aXG5V.ReplaceAroundStep))) return null;
    // Place gap cursor after the newly inserted node
    const gapCursorPos = lastStep.to + lastStep.slice.openStart + nodeLength;
    return tr.setSelection(new (0, $adhil.GapCursorSelection)(tr.doc.resolve(gapCursorPos), (0, $9GYNY.Side).RIGHT)).scrollIntoView();
};
const $e5b978def8a005db$export$e3c00faab58641c5 = (maybeNode, opts = {})=>(state, tr, start)=>{
        if (!maybeNode) return tr;
        const isInputFragment = maybeNode instanceof (0, $5SAOw.Fragment);
        let node;
        try {
            node = maybeNode instanceof (0, $5SAOw.Node) || isInputFragment ? maybeNode : typeof maybeNode === 'string' ? state.schema.text(maybeNode) : (0, $5SAOw.Node).fromJSON(state.schema, maybeNode);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
            return tr;
        }
        if (node instanceof (0, $5SAOw.Node) && node.isText) tr = tr.replaceWith(start, start, node);
        else if (node instanceof (0, $5SAOw.Node) && node.isBlock) {
            /**
			 *
			 * Rule has unique insertion behaviour
			 * so using this safeInsert function in order to handle specific cases in flat list vs nested list
			 * instead of a generic pmSafeInsert (i.e appending at the end)
			 *
			 */ const selectionInsideAPanel = $e5b978def8a005db$var$selectionIsInsideAPanel(tr);
            if (node.type.name === 'rule' && !selectionInsideAPanel && // ED-17438 If the selection is not an empty paragraph we want to use pmSafeInsert
            // This fixes a bug where if a rule was inserted using safeInsert and the selection
            // was an empty paragraph it would not be inserted
            !(0, $jMZUD.isEmptyParagraph)(tr.selection.$from.parent)) tr = $e5b978def8a005db$export$5fe92db78385e37c(node, tr.selection.from)(tr) ?? tr;
            else tr = (0, $8m4tT.safeInsert)($e5b978def8a005db$export$9a3d0d2a50538e52(state, node), undefined, true)(tr);
        /**
			 *
			 * Replacing a type ahead query mark with an inline node.
			 *
			 */ } else if (node instanceof (0, $5SAOw.Node) && node.isInline || isInputFragment) {
            const fragment = isInputFragment ? node : (0, $5SAOw.Fragment).fromArray([
                node,
                state.schema.text(' ')
            ]);
            tr = tr.replaceWith(start, start, fragment);
            if (opts.selectInlineNode) // Select inserted node
            tr = tr.setSelection((0, $ks2lK.NodeSelection).create(tr.doc, start));
            else // Placing cursor after node + space.
            tr = tr.setSelection((0, $ks2lK.Selection).near(tr.doc.resolve(start + fragment.size)));
        }
        return tr;
    };
const $e5b978def8a005db$export$b80431b156693a98 = ({ parentNodeType: parentNodeType, grandParentNodeType: grandParentNodeType, content: content })=>{
    if (parentNodeType.name === 'doc' || parentNodeType.name === 'paragraph' && grandParentNodeType.validContent((0, $5SAOw.Fragment).from(content))) return true;
    return false;
};
function $e5b978def8a005db$export$b6980e4b8ea578a5(state) {
    const { $from: $from, $to: $to } = state.selection;
    let isAllowedChild = true;
    state.doc.nodesBetween($from.pos, $to.pos, (node, pos)=>{
        const withinSelection = $from.pos <= pos && pos + node.nodeSize <= $to.pos;
        if (!withinSelection) return;
        if (!isAllowedChild) return false;
        return isAllowedChild = node.type === state.schema.nodes.listItem || node.type === state.schema.nodes.bulletList || node.type === state.schema.nodes.orderedList || node.type === state.schema.nodes.paragraph || node.isInline || node.type === state.schema.nodes.panel || node.isText;
    });
    return isAllowedChild;
}
function $e5b978def8a005db$export$2b1594c8921b5b2e(fragment, nodeType) {
    let doesContainNodeType = false;
    fragment.descendants((node)=>{
        if (node.type === nodeType) {
            doesContainNodeType = true;
            // Stop looking
            return false;
        }
        return true;
    });
    return doesContainNodeType;
}
module.exports["normaliseNestedLayout"] = $e5b978def8a005db$export$9a3d0d2a50538e52;
module.exports["safeInsert"] = $e5b978def8a005db$export$5fe92db78385e37c;
module.exports["shouldSplitSelectedNodeOnNodeInsertion"] = $e5b978def8a005db$export$b80431b156693a98;
module.exports["insertSelectedItem"] = $e5b978def8a005db$export$e3c00faab58641c5;
module.exports["contentAllowedInCodeBlock"] = $e5b978def8a005db$export$b6980e4b8ea578a5;
module.exports["fragmentContainsNodeType"] = $e5b978def8a005db$export$2b1594c8921b5b2e;

});

parcelRegister("l9G9n", function(module, exports) {
$parcel$export(module.exports, "isEmptyParagraph", () => (parcelRequire("jMZUD")).isEmptyParagraph);
$parcel$export(module.exports, "hasDocAsParent", () => (parcelRequire("eCZpC")).hasDocAsParent);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $8m4tT = parcelRequire("8m4tT");


var $eCZpC = parcelRequire("eCZpC");


var $jMZUD = parcelRequire("jMZUD");


var $azNN5 = parcelRequire("azNN5");


var $bYZ53 = parcelRequire("bYZ53");


var $21PP6 = parcelRequire("21PP6");


var $dSVmA = parcelRequire("dSVmA");


var $dIxHZ = parcelRequire("dIxHZ");


var $kTbzR = parcelRequire("kTbzR");


var $jI93b = parcelRequire("jI93b");


var $bGUOY = parcelRequire("bGUOY");


var $fQWbQ = parcelRequire("fQWbQ");


var $lMavH = parcelRequire("lMavH");


var $9aQ58 = parcelRequire("9aQ58");


var $1XMEN = parcelRequire("1XMEN");


var $5xSjx = parcelRequire("5xSjx");


var $8iQsB = parcelRequire("8iQsB");




var $jVsXB = parcelRequire("jVsXB");


var $3PDVp = parcelRequire("3PDVp");


var $iJNG5 = parcelRequire("iJNG5");


var $8Doca = parcelRequire("8Doca");


var $fJNzZ = parcelRequire("fJNzZ");


var $lqCVa = parcelRequire("lqCVa");


var $cH6oz = parcelRequire("cH6oz");


var $2INgX = parcelRequire("2INgX");


var $7YVJA = parcelRequire("7YVJA");


var $bHQxW = parcelRequire("bHQxW");



var $eYkDj = parcelRequire("eYkDj");


var $cMz8d = parcelRequire("cMz8d");


var $d3YeI = parcelRequire("d3YeI");


var $7iE7T = parcelRequire("7iE7T");



var $lkJUe = parcelRequire("lkJUe");


var $bxcxa = parcelRequire("bxcxa");


var $3Ter7 = parcelRequire("3Ter7");


var $kKgJl = parcelRequire("kKgJl");


var $4vlwG = parcelRequire("4vlwG");


var $a8v5u = parcelRequire("a8v5u");


var $gK9Ck = parcelRequire("gK9Ck");


var $f14He = parcelRequire("f14He");


var $i1Isf = parcelRequire("i1Isf");




var $lWghV = parcelRequire("lWghV");


var $fLvO8 = parcelRequire("fLvO8");




var $kOYZR = parcelRequire("kOYZR");


var $juTiU = parcelRequire("juTiU");











var $2diEG = parcelRequire("2diEG");


var $hyVjW = parcelRequire("hyVjW");


var $8l0kQ = parcelRequire("8l0kQ");


var $1d0KH = parcelRequire("1d0KH");


var $caYZ2 = parcelRequire("caYZ2");


var $d4WtM = parcelRequire("d4WtM");


var $cN8vw = parcelRequire("cN8vw");


var $5mxQU = parcelRequire("5mxQU");


var $TfRUG = parcelRequire("TfRUG");


var $NPJKR = parcelRequire("NPJKR");



var $led7c = parcelRequire("led7c");


var $6B1pv = parcelRequire("6B1pv");


var $1HVk8 = parcelRequire("1HVk8");



var $6aq5c = parcelRequire("6aq5c");




var $56SXY = parcelRequire("56SXY");


var $hokts = parcelRequire("hokts");


var $5GR8v = parcelRequire("5GR8v");


var $jjJ59 = parcelRequire("jjJ59");


var $4DdJm = parcelRequire("4DdJm");


var $jshjN = parcelRequire("jshjN");


var $69yJQ = parcelRequire("69yJQ");


var $irKZA = parcelRequire("irKZA");


var $dMNMt = parcelRequire("dMNMt");



var $hoQ9u = parcelRequire("hoQ9u");


var $j9WGh = parcelRequire("j9WGh");


var $d2M6W = parcelRequire("d2M6W");


var $b0F8r = parcelRequire("b0F8r");


var $lSdQB = parcelRequire("lSdQB");


var $eYlm5 = parcelRequire("eYlm5");


var $2pjJ5 = parcelRequire("2pjJ5");


var $65MHe = parcelRequire("65MHe");


var $eluto = parcelRequire("eluto");


var $bI3mS = parcelRequire("bI3mS");


var $6qPH4 = parcelRequire("6qPH4");


var $6tl2G = parcelRequire("6tl2G");


var $hcUEx = parcelRequire("hcUEx");


var $7F8k7 = parcelRequire("7F8k7");


var $jcsKQ = parcelRequire("jcsKQ");


var $3ZFfQ = parcelRequire("3ZFfQ");


var $lqWNh = parcelRequire("lqWNh");



var $16GCc = parcelRequire("16GCc");


var $jjaSx = parcelRequire("jjaSx");


var $e7tBw = parcelRequire("e7tBw");

var $WGctw = parcelRequire("WGctw");


var $gm0lv = parcelRequire("gm0lv");





var $4VXMf = parcelRequire("4VXMf");


var $l03WE = parcelRequire("l03WE");


var $i4oLV = parcelRequire("i4oLV");


var $l9FJJ = parcelRequire("l9FJJ");


var $eDabt = parcelRequire("eDabt");


var $8vgNB = parcelRequire("8vgNB");


var $lNDSG = parcelRequire("lNDSG");


var $2bi6l = parcelRequire("2bi6l");


var $3JtSu = parcelRequire("3JtSu");


const $2af6a548343f3667$export$d4f2631252432abf = 'history$';
function $2af6a548343f3667$export$d36bdfa510afb180(obj1 = {}, obj2 = {}) {
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
    return keys1.length === keys2.length && keys1.reduce((acc, key)=>acc && obj1[key] === obj2[key], true);
}
function $2af6a548343f3667$export$51bf7c6695e13879(selection) {
    const docNode = selection.$anchor.node(0);
    const rootNode = selection.$anchor.node(1);
    return docNode.lastChild === rootNode;
}
const $2af6a548343f3667$export$92d47fcf661e090e = (state)=>{
    return (0, $8m4tT.hasParentNodeOfType)(state.schema.nodes.listItem)(state.selection);
};
const $2af6a548343f3667$export$6b982788a5f0ccef = (predicate)=>($pos)=>{
        let candidate = null;
        for(let i = $pos.depth; i > 0; i--){
            const node = $pos.node(i);
            if (predicate(node)) candidate = {
                pos: i > 0 ? $pos.before(i) : 0,
                start: $pos.start(i),
                depth: i,
                node: node
            };
        }
        return candidate;
    };
const $2af6a548343f3667$export$1350ff12653c84d4 = (state)=>{
    const { tableCell: tableCell, tableHeader: tableHeader } = state.schema.nodes;
    return (0, $8m4tT.hasParentNodeOfType)([
        tableCell,
        tableHeader
    ])(state.selection);
};
/**
 * Traverse the document until an "ancestor" is found. Any nestable block can be an ancestor.
 */ // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $2af6a548343f3667$var$findAncestorPosition(doc, pos) {
    const nestableBlocks = [
        'blockquote',
        'bulletList',
        'orderedList'
    ];
    if (pos.depth === 1) return pos;
    let node = pos.node(pos.depth);
    let newPos = pos;
    while(pos.depth >= 1){
        pos = doc.resolve(pos.before(pos.depth));
        node = pos.node(pos.depth);
        if (node && nestableBlocks.indexOf(node.type.name) !== -1) newPos = pos;
    }
    return newPos;
}
function $2af6a548343f3667$export$d0951c59cd3dac0f(selection, doc, filter) {
    const ancestorDepth = $2af6a548343f3667$var$findAncestorPosition(doc, selection.$to).depth;
    // Top level node
    if (ancestorDepth === 0) return false;
    const res = doc.resolve(selection.$to.after(ancestorDepth));
    return res.nodeAfter ? filter(res.nodeAfter) : false;
}
const $2af6a548343f3667$export$641fdf56f693bfbc = (schema)=>{
    const { doc: doc, paragraph: paragraph, expand: expand, codeBlock: codeBlock, blockquote: blockquote, panel: panel, heading: heading, listItem: listItem, bulletList: bulletList, orderedList: orderedList, taskList: taskList, taskItem: taskItem, decisionList: decisionList, decisionItem: decisionItem, media: media, mediaGroup: mediaGroup, mediaSingle: mediaSingle } = schema.nodes;
    const innerIsEmptyNode = (node)=>{
        switch(node.type){
            case media:
            case mediaGroup:
            case mediaSingle:
                return false;
            case paragraph:
            case codeBlock:
            case heading:
            case taskItem:
            case decisionItem:
                return node.content.size === 0;
            case expand:
            case blockquote:
            case panel:
            case listItem:
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                return node.content.size === 2 && innerIsEmptyNode(node.content.firstChild);
            case bulletList:
            case orderedList:
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                return node.content.size === 4 && innerIsEmptyNode(node.content.firstChild);
            case taskList:
            case decisionList:
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                return node.content.size === 2 && innerIsEmptyNode(node.content.firstChild);
            case doc:
                let isEmpty = true;
                node.content.forEach((child)=>{
                    isEmpty = isEmpty && innerIsEmptyNode(child);
                });
                return isEmpty;
            default:
                return $2af6a548343f3667$export$cd58ff1081f6abe9(node);
        }
    };
    return innerIsEmptyNode;
};
function $2af6a548343f3667$export$cd58ff1081f6abe9(node) {
    if (node && node.textContent) return false;
    if (!node || !node.childCount || node.childCount === 1 && (0, $jMZUD.isEmptyParagraph)(node.firstChild)) return true;
    const block = [];
    const nonBlock = [];
    node.forEach((child)=>{
        child.isInline ? nonBlock.push(child) : block.push(child);
    });
    return !nonBlock.length && !block.filter((childNode)=>!!childNode.childCount && !(childNode.childCount === 1 && (0, $jMZUD.isEmptyParagraph)(childNode.firstChild)) || childNode.isAtom).length;
}
function $2af6a548343f3667$export$3b68253250b41118(state) {
    const { selection: selection } = state;
    const { $cursor: $cursor, $anchor: $anchor } = selection;
    if (!$cursor) return false;
    const node = $cursor.node();
    if (!node) return false;
    return (0, $jMZUD.isEmptyParagraph)(node) && (0, $eCZpC.hasDocAsParent)($anchor);
}
module.exports["pmHistoryPluginKey"] = $2af6a548343f3667$export$d4f2631252432abf;
module.exports["shallowEqual"] = $2af6a548343f3667$export$d36bdfa510afb180;
module.exports["isSelectionInsideLastNodeInDocument"] = $2af6a548343f3667$export$51bf7c6695e13879;
module.exports["isInListItem"] = $2af6a548343f3667$export$92d47fcf661e090e;
module.exports["findFarthestParentNode"] = $2af6a548343f3667$export$6b982788a5f0ccef;
module.exports["insideTableCell"] = $2af6a548343f3667$export$1350ff12653c84d4;
module.exports["checkNodeDown"] = $2af6a548343f3667$export$d0951c59cd3dac0f;
module.exports["isEmptyNode"] = $2af6a548343f3667$export$641fdf56f693bfbc;
module.exports["isNodeEmpty"] = $2af6a548343f3667$export$cd58ff1081f6abe9;
module.exports["isInEmptyLine"] = $2af6a548343f3667$export$3b68253250b41118;

});

parcelRegister("kTbzR", function(module, exports) {

var $iJNG5 = parcelRequire("iJNG5");














function $ab19fe955bb1fbb0$export$f4d51ccab05f55c9(step, nodeTypes) {
    let adds = false;
    if (!(0, $iJNG5.stepHasSlice)(step)) return adds;
    step.slice.content.descendants((node)=>{
        if (nodeTypes.has(node.type)) adds = true;
        return !adds;
    });
    return adds;
}
const $ab19fe955bb1fbb0$export$fba8af3b998832b9 = (state, marks)=>{
    const { selection: selection, schema: schema } = state;
    let { tr: tr } = state;
    // Marks might not exist in Schema
    const marksToRemove = marks.filter(Boolean);
    if (marksToRemove.length === 0) return undefined;
    /** Saves an extra dispatch */ let blockMarksExists = false;
    const hasMark = (mark)=>marksToRemove.indexOf(mark.type) > -1;
    /**
	 * When you need to toggle the selection
	 * when another type which does not allow alignment is applied
	 */ state.doc.nodesBetween(selection.from, selection.to, (node, pos)=>{
        if (node.type === schema.nodes.paragraph && node.marks.some(hasMark)) {
            blockMarksExists = true;
            const resolvedPos = state.doc.resolve(pos);
            const withoutBlockMarks = node.marks.filter($ab19fe955bb1fbb0$var$not(hasMark));
            tr = tr.setNodeMarkup(resolvedPos.pos, undefined, node.attrs, withoutBlockMarks);
        }
    });
    return blockMarksExists ? tr : undefined;
};
const $ab19fe955bb1fbb0$var$not = (fn)=>(arg)=>!fn(arg);
module.exports["stepAddsOneOf"] = $ab19fe955bb1fbb0$export$f4d51ccab05f55c9;
module.exports["removeBlockMarks"] = $ab19fe955bb1fbb0$export$fba8af3b998832b9;

});

parcelRegister("iJNG5", function(module, exports) {
const $1eb56bc6fcf51bf2$export$53780b185b887309 = (step)=>step && step.hasOwnProperty('slice');
module.exports["stepHasSlice"] = $1eb56bc6fcf51bf2$export$53780b185b887309;

});

parcelRegister("1XMEN", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");

const $7fd94897c79aae16$export$38b50bf35e79aaf3 = (selection)=>selection instanceof (0, $ks2lK.TextSelection);
module.exports["isTextSelection"] = $7fd94897c79aae16$export$38b50bf35e79aaf3;

});

parcelRegister("fQWbQ", function(module, exports) {

var $4vlwG = parcelRequire("4vlwG");

const $a6976d231ddb45e2$export$5588122b9eea7733 = (element)=>{
    return (0, $4vlwG.closest)(element, 'td, th');
};
module.exports["isElementInTableCell"] = $a6976d231ddb45e2$export$5588122b9eea7733;

});

parcelRegister("9aQ58", function(module, exports) {
const $d71843b1af8830b8$export$142c0ee6457f50d6 = (node)=>{
    const { content: content } = node;
    return !!content.lastChild && content.lastChild.type.name === 'mediaGroup';
};
module.exports["isLastItemMediaGroup"] = $d71843b1af8830b8$export$142c0ee6457f50d6;

});

parcelRegister("jVsXB", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");

const $f2dd946f04534e8e$export$a367515ca2c9ace1 = (view, pos)=>{
    const { state: state, dispatch: dispatch } = view;
    if (!isFinite(pos)) return;
    const tr = state.tr.setSelection((0, $ks2lK.NodeSelection).create(state.doc, pos));
    dispatch(tr);
};
module.exports["setNodeSelection"] = $f2dd946f04534e8e$export$a367515ca2c9ace1;

});

parcelRegister("3PDVp", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");

function $1e04eaa715169ce1$export$1df6d14df6b0b758(view, anchor, head) {
    const { state: state, dispatch: dispatch } = view;
    const tr = state.tr.setSelection((0, $ks2lK.TextSelection).create(state.doc, anchor, head));
    dispatch(tr);
}
module.exports["setTextSelection"] = $1e04eaa715169ce1$export$1df6d14df6b0b758;

});

parcelRegister("8iQsB", function(module, exports) {
function $def15c386ebdcb6d$export$26128561c93f5847(value) {
    return value !== null && value !== undefined;
}
module.exports["nonNullable"] = $def15c386ebdcb6d$export$26128561c93f5847;

});

parcelRegister("5xSjx", function(module, exports) {
const $cb21d8558662a4b8$export$de0495c7bd37bf4e = (pos, state)=>{
    if (typeof pos !== 'number') return false;
    if (pos >= 0 && pos <= state.doc.resolve(0).end()) return true;
    return false;
};
module.exports["isValidPosition"] = $cb21d8558662a4b8$export$de0495c7bd37bf4e;

});

parcelRegister("lMavH", function(module, exports) {

var $8m4tT = parcelRequire("8m4tT");

const $3fc219c75669203a$export$2de06a6e688827fd = (state)=>{
    return (0, $8m4tT.hasParentNodeOfType)(state.schema.nodes.layoutSection)(state.selection);
};
module.exports["isInLayoutColumn"] = $3fc219c75669203a$export$2de06a6e688827fd;

});

parcelRegister("lqCVa", function(module, exports) {
const $ba750af018a7adf9$export$2626b4a7243208a1 = [
    'expand',
    'layoutSection',
    'codeBlock',
    'syncBlock',
    'bodiedSyncBlock'
];
module.exports["breakoutResizableNodes"] = $ba750af018a7adf9$export$2626b4a7243208a1;

});

parcelRegister("cH6oz", function(module, exports) {
const $64d498658ffc2ad9$export$c2c078d93ed82790 = (schema)=>{
    const { expand: expand, codeBlock: codeBlock, layoutSection: layoutSection, syncBlock: syncBlock, bodiedSyncBlock: bodiedSyncBlock } = schema.nodes;
    return new Set([
        expand,
        codeBlock,
        layoutSection,
        syncBlock,
        bodiedSyncBlock
    ]);
};
module.exports["getBreakoutResizableNodeTypes"] = $64d498658ffc2ad9$export$c2c078d93ed82790;

});

parcelRegister("2INgX", function(module, exports) {
const $0788963fa4e90a26$export$7eb758567e6644fd = (currentMode)=>{
    if (currentMode === 'full-width') return 'center';
    else if (currentMode === 'wide') return 'full-width';
    return 'wide';
};
module.exports["getNextBreakoutMode"] = $0788963fa4e90a26$export$7eb758567e6644fd;

});

parcelRegister("7YVJA", function(module, exports) {

var $61p3e = parcelRequire("61p3e");

const $3e36799af1cc638b$export$70d1bf7729efff40 = (layout)=>{
    switch(layout){
        case 'full-width':
            return (0, $61p3e.default).layoutFixedWidth;
        case 'wide':
            return (0, $61p3e.default).layoutFullWidth;
        default:
            return (0, $61p3e.default).layoutWide;
    }
};
module.exports["getTitle"] = $3e36799af1cc638b$export$70d1bf7729efff40;

});

parcelRegister("eYkDj", function(module, exports) {
const $61cc995d0537b0a2$export$d6ca4605aefeca32 = (node)=>{
    return [
        'media',
        'mediaInline',
        'mediaGroup',
        'mediaSingle'
    ].includes(node.type.name);
};
module.exports["isMediaNode"] = $61cc995d0537b0a2$export$d6ca4605aefeca32;

});

parcelRegister("cMz8d", function(module, exports) {

var $8m4tT = parcelRequire("8m4tT");

const $a0d48cf280e7f419$export$cfaa7840b0c93780 = ($pos, state)=>{
    let nodeBefore = $pos.nodeBefore;
    if (!nodeBefore) {
        const depthOfParent = $pos.depth - 1 || 1;
        const parentNode = (0, $8m4tT.findParentNodeOfType)([
            state.schema.nodes[`${$pos.node(depthOfParent).type.name}`]
        ])(state.selection);
        const resolvedPosOfParentNode = parentNode ? state.tr.doc.resolve(parentNode.pos) : undefined;
        const nodeBeforeParent = resolvedPosOfParentNode && resolvedPosOfParentNode.pos < state.doc.nodeSize ? resolvedPosOfParentNode.nodeBefore : undefined;
        if (nodeBeforeParent) nodeBefore = nodeBeforeParent;
    }
    if (nodeBefore) return [
        'media',
        'mediaInline',
        'mediaGroup',
        'mediaSingle'
    ].includes(nodeBefore.type.name);
    return false;
};
module.exports["isNodeBeforeMediaNode"] = $a0d48cf280e7f419$export$cfaa7840b0c93780;

});

parcelRegister("d3YeI", function(module, exports) {
const $5ae4de58e12b08b1$export$b6e38334b1fb4d1b = (state, fragment, currentAppearance)=>{
    const depth = currentAppearance === 'embed' || currentAppearance === 'block' ? undefined : -1;
    const parent = state.selection.$from.node(depth);
    return parent && parent.type.validContent(fragment);
};
module.exports["isSupportedInParent"] = $5ae4de58e12b08b1$export$b6e38334b1fb4d1b;

});

parcelRegister("kKgJl", function(module, exports) {
/**
 * IE11 doesn't support classList to SVGElements
 **/ const $70b66396b9a07941$export$c8913a477cc44663 = (node, className)=>{
    if (!node) return false;
    if (node.classList && node.classList.contains) return node.classList.contains(className);
    if (!node.className) return false;
    const classNames = typeof node.className.baseVal === 'string' ? node.className.baseVal : node.className;
    return classNames.split(' ').indexOf(className) !== -1;
};
module.exports["containsClassName"] = $70b66396b9a07941$export$c8913a477cc44663;

});

parcelRegister("gK9Ck", function(module, exports) {
/**
 * Walks up DOM removing elements if they are empty until it finds
 * one that is not
 */ function $7aa28254440ea423$export$5b66dc78851adb5e(el) {
    while(el.parentElement && el.childElementCount === 0 && el.textContent === ''){
        const parentEl = el.parentElement;
        parentEl.removeChild(el);
        el = parentEl;
    }
}
module.exports["removeNestedEmptyEls"] = $7aa28254440ea423$export$5b66dc78851adb5e;

});

parcelRegister("f14He", function(module, exports) {
/**
 * Takes all children out from wrapped el and puts them directly inside
 * the parent el, at the wrapped el's position
 */ function $8140fd1c3f1577cc$export$debb760848ca95a(parent, wrapped) {
    const docsFragment = document.createDocumentFragment();
    Array.from(wrapped.children).forEach((child)=>{
        docsFragment.appendChild(child);
    });
    parent.replaceChild(docsFragment, wrapped);
}
module.exports["unwrap"] = $8140fd1c3f1577cc$export$debb760848ca95a;

});

parcelRegister("i1Isf", function(module, exports) {
/**
 * Walks a DOM tree up to the provided `stopElement`, or if falsy before.
 * @param element
 * @param stopElement
 */ function $3845d7a8313f37b0$export$df14aaf7a527ab0c(element, shouldStop) {
    let rootElement = element;
    while(rootElement && rootElement.parentElement && !shouldStop(rootElement))rootElement = rootElement.parentElement;
    return rootElement;
}
module.exports["walkUpTreeUntil"] = $3845d7a8313f37b0$export$df14aaf7a527ab0c;

});

parcelRegister("1d0KH", function(module, exports) {
function $d91ae2729e71f1a4$export$889a8e446452be16(pos, schema, direction) {
    if (!schema.nodes.tableRow) return false;
    const doc = pos.doc;
    let resolved = pos;
    const sibling = direction === 'before' ? 'nodeBefore' : 'nodeAfter';
    while(resolved.depth > 0){
        const siblingType = resolved[sibling]?.type;
        if (siblingType === schema.nodes.tableRow) return true;
        resolved = doc.resolve(resolved[direction]());
    }
    return false;
}
module.exports["isPositionNearTableRow"] = $d91ae2729e71f1a4$export$889a8e446452be16;

});

parcelRegister("5mxQU", function(module, exports) {

var $aXG5V = parcelRequire("aXG5V");

const $02615ba219e18bae$export$3e6057b9bf6b0bbb = (tr)=>{
    const [step] = tr.steps;
    if (!step || !(step instanceof (0, $aXG5V.ReplaceStep))) return false;
    const { slice: { content: content }, from: from, to: to } = step;
    const char = content.firstChild;
    return from === to && content.childCount === 1 && !!char && !!char.text && char.text.length === 1;
};
module.exports["isTextInput"] = $02615ba219e18bae$export$3e6057b9bf6b0bbb;

});

parcelRegister("1HVk8", function(module, exports) {
const $a8192fbeb99723d4$var$registerDetectors = (targetExtensions, supportedDetectors)=>{
    const detectors = supportedDetectors.filter((registration)=>targetExtensions.includes(registration.name));
    return detectors.map((detector)=>({
            name: detector.name,
            state: {
                detected: false
            },
            fns: {
                async: detector.fns.async,
                sync: detector.fns.sync
            }
        }));
};
const $a8192fbeb99723d4$var$RACE_COMPLETE = 'race_complete';
const $a8192fbeb99723d4$var$SELECTORS = {
    GRAMMARLY: 'grammarly-extension, grammarly-popups, [data-grammarly-shadow-root]'
};
/**
 * This is the official list of supported browser extension detectors. To add support
 * for detecting an additional browser extension, simply add a (DetectorRegistration)
 * object like below to the list:
 *
 * ```
 * {
 *  name: 'exampleExtension',
 *  fns: {
 *    // a synchronous check that should return true if the extension is detected
 *    sync: () => !!document.querySelector(".some-example-class"),
 *    // an asynchronous check that should invoke 'detected' if the extension is detected.
 *    // it can also invoke 'cleanup' with a callback to schedule cleanup tasks
 *    // (such as disconnecting observers).
 *    async: (detected, cleanup) => {
 *      if (document.querySelector(".some-example-class")) {
 *        detected();
 *      }
 *    }
 *  }
 * }
 * ```
 */ const $a8192fbeb99723d4$var$supportedDetectors = [
    {
        name: 'grammarly',
        fns: {
            sync: ()=>Boolean(document?.querySelector($a8192fbeb99723d4$var$SELECTORS.GRAMMARLY)),
            async: (detected, cleanup)=>{
                // First check to see if grammarly already exists on page
                const exists = Boolean(document?.querySelector($a8192fbeb99723d4$var$SELECTORS.GRAMMARLY));
                if (exists) detected();
                // Otherwise, setup a mutation observer to observe the page and its children
                // for newly added nodes. Collect observed mutations in a queue and in 1 second
                // intervals either process the queue or schedule the processing task for when
                // the user agent's main thread is idle (if possible).
                let queue = [];
                const processQueue = ()=>{
                    for (const mutations of queue){
                        for (const mutation of mutations)if (mutation?.type === 'childList' && mutation?.addedNodes?.length) {
                            const exists = Array.from(mutation.addedNodes).some((node)=>node.parentElement?.querySelector($a8192fbeb99723d4$var$SELECTORS.GRAMMARLY));
                            if (exists) detected();
                        }
                    }
                    queue = [];
                };
                const intervalId = setInterval(()=>{
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    if (typeof window.requestIdleCallback === 'function') // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    window.requestIdleCallback(processQueue);
                    else window.requestAnimationFrame(processQueue);
                }, 1000);
                const observer = new MutationObserver((mutations)=>{
                    queue.push(mutations);
                });
                cleanup(()=>{
                    queue = [];
                    clearInterval(intervalId);
                    observer?.disconnect();
                });
                observer.observe(document.documentElement, {
                    childList: true,
                    subtree: true
                });
            }
        }
    }
];
function $a8192fbeb99723d4$export$4cd1ca2600761f65(options) {
    try {
        // First we filter out supported extensions that aren't requested through options. We also
        // prepare detector objects with some initial internal state (e.g. detector.state.detected = false)
        const detectors = $a8192fbeb99723d4$var$registerDetectors(options.extensions, $a8192fbeb99723d4$var$supportedDetectors);
        // If async mode is enabled, we convert the list of detector objects to a list of promises
        // that resolve when the detector invokes detected() during its asynchronous check.
        // We also track any scheduled cleanup() tasks.
        if (options.async === true) {
            const asyncCleanups = [];
            const asyncDetections = Promise.all(detectors.map((detector)=>{
                return new Promise((resolve)=>{
                    const detected = ()=>{
                        detector.state.detected = true;
                        resolve();
                    };
                    const cleanup = (cb)=>{
                        asyncCleanups.push(cb);
                    };
                    if (typeof detector.fns.async === 'function') detector.fns.async(detected, cleanup);
                    else {
                        detector.state.detected = false;
                        resolve();
                    }
                });
            }));
            // We race all asynchronous checkers against a user-defined timeout (asyncTimeoutMs).
            // When asynchronous checks are finalised first,or if the timeout elapses, we return
            // the list of extensions detected up until that point.
            const globalTimeout = new Promise((resolve)=>setTimeout(resolve, options.asyncTimeoutMs, $a8192fbeb99723d4$var$RACE_COMPLETE));
            return Promise.race([
                asyncDetections,
                globalTimeout
            ]).then(()=>{
                return detectors.filter((detector)=>detector.state.detected).map((detector)=>detector.name);
            })// If there are any errors, we fail safely and silently with zero detected extensions.
            .catch(()=>[]).finally(()=>asyncCleanups.map((cleanup)=>cleanup()));
        } else // If sync mode, we immediately execute synchronous checks
        // and return a list of extensions whose synchronous checks returned true.
        return detectors.filter((detector)=>detector.fns.sync?.()).map((detector)=>detector.name);
    } catch (err) {
        // If there are any unhandled errors, we fail safely and silently with zero detected extensions.
        return options.async ? Promise.resolve([]) : [];
    }
}
module.exports["sniffUserBrowserExtensions"] = $a8192fbeb99723d4$export$4cd1ca2600761f65;

});

parcelRegister("56SXY", function(module, exports) {

var $aXG5V = parcelRequire("aXG5V");

function $052f9b220c82ebdf$export$c7c1e59168a7f554(tr, isJoinable) {
    if (Array.isArray(isJoinable)) {
        const types = isJoinable;
        isJoinable = (node)=>types.indexOf(node.type.name) > -1;
    }
    const ranges = [];
    for(let i = 0; i < tr.mapping.maps.length; i++){
        const map = tr.mapping.maps[i];
        for(let j = 0; j < ranges.length; j++)ranges[j] = map.map(ranges[j]);
        map.forEach((_s, _e, from, to)=>ranges.push(from, to));
    }
    // Figure out which joinable points exist inside those ranges,
    // by checking all node boundaries in their parent nodes.
    const joinable = [];
    for(let i = 0; i < ranges.length; i += 2){
        const from = ranges[i];
        const to = ranges[i + 1];
        const $from = tr.doc.resolve(from);
        const depth = $from.sharedDepth(to);
        const parent = $from.node(depth);
        for(let index = $from.indexAfter(depth), pos = $from.after(depth + 1); pos <= to; ++index){
            const after = parent.maybeChild(index);
            if (!after) break;
            if (index && joinable.indexOf(pos) === -1) {
                const before = parent.child(index - 1);
                if (before.type === after.type && isJoinable(before, after)) joinable.push(pos);
            }
            pos += after.nodeSize;
        }
    }
    // Join the joinable points
    joinable.sort((a, b)=>a - b);
    for(let i = joinable.length - 1; i >= 0; i--)if ((0, $aXG5V.canJoin)(tr.doc, joinable[i])) tr.join(joinable[i]);
}
module.exports["autoJoinTr"] = $052f9b220c82ebdf$export$c7c1e59168a7f554;

});

parcelRegister("hokts", function(module, exports) {
const $129c101e94951fd4$export$651544f548703224 = (state, node)=>{
    return node?.marks?.find((mark)=>mark.type === state.schema.marks.fragment)?.attrs?.name ?? '';
};
module.exports["getNodeName"] = $129c101e94951fd4$export$651544f548703224;

});

parcelRegister("5GR8v", function(module, exports) {

const $219363623091e0b7$export$d35a68bd2e0b55da = (state, node)=>{
    if (!node) return false;
    let found = false;
    // Handle nodes having 2 uuids. They could have a localId or a fragment. Regardless this needs
    // to check if either id is used by a data consumer.
    const localIds = new Set([
        node.attrs?.localId,
        node.marks?.find((mark)=>mark.type === state.schema.marks.fragment)?.attrs?.localId
    ].filter(Boolean));
    // If there are no uuids on the node then it's not possible for it to be referenced anywhere.
    if (!localIds.size) return false;
    state.doc.descendants((node)=>{
        if (found) return false;
        const dataConsumer = node.marks.find((mark)=>mark.type === state.schema.marks.dataConsumer);
        if (!dataConsumer) return true;
        found = dataConsumer.attrs.sources?.some((src)=>localIds.has(src)) ?? false;
        return !found;
    });
    return found;
};
const $219363623091e0b7$export$82b9f8f75cc709b4 = (state)=>{
    const result = {};
    const { doc: doc, schema: schema } = state;
    // Keeps a map of all raw ids -> to their preferred normalised varient. A node with both fragmentMark & localId will
    // have both ids mapped here to the same normalized version.
    const normalizedIds = new Map();
    const dataConsumerSources = new Map();
    // Perform a prelim scan creating the initial id to connection link mappings.
    // This will also save a list of data sources consumed per node.
    doc.descendants((node, pos)=>{
        let dataConsumer;
        let fragmentMark;
        node.marks.some((mark)=>{
            if (mark.type === schema.marks.dataConsumer) dataConsumer = mark;
            else if (mark.type === schema.marks.fragment) fragmentMark = mark;
            // Stop searching marks if we've found both consumer and fragment.
            return !!dataConsumer && !!fragmentMark;
        });
        // If node cannot be referenced by any means then abort.
        if (!fragmentMark && !node.attrs?.localId) return true;
        const normalizedId = fragmentMark?.attrs?.localId ?? node.attrs?.localId;
        if (!normalizedId) return true;
        if (!!fragmentMark?.attrs?.localId) normalizedIds.set(fragmentMark.attrs.localId, normalizedId);
        if (!!node.attrs?.localId) normalizedIds.set(node.attrs.localId, normalizedId);
        if (!!result[normalizedId]) // Duplicate ID has been found, we'll care about the first one for now.
        return true;
        result[normalizedId] = {
            localId: normalizedId,
            name: fragmentMark?.attrs?.name,
            node: node,
            pos: pos,
            targets: []
        };
        if (!!dataConsumer && dataConsumer.attrs.sources.length) dataConsumerSources.set(normalizedId, dataConsumer.attrs.sources);
        // Do not descend into children of a node which has a dataConsumer attached. This assumes all children of the node cannot
        // be referenced by another node.
        return !dataConsumer;
    });
    // This 2nd-pass only looks at the consumer sources and updates all connections with the correct id refs.
    for (const [localId, sources] of dataConsumerSources)// This is a ref to the node (connection link) which contains the consumer.
    sources.forEach((src)=>{
        const normalizedId = normalizedIds.get(src) ?? src;
        const srcLink = result[normalizedId];
        if (srcLink && normalizedId !== localId) srcLink.targets.push(localId);
    });
    return result;
};
const $219363623091e0b7$export$657e59857351232d = (state, node)=>{
    if (!node) return state.tr;
    const selectedLocalIds = $219363623091e0b7$var$getSelectedLocalIds(state, node);
    const allNodes = $219363623091e0b7$export$82b9f8f75cc709b4(state);
    const idsToBeDeleted = $219363623091e0b7$var$getIdsToBeDeleted(selectedLocalIds, allNodes);
    if (!idsToBeDeleted?.length) return state.tr;
    const { tr: tr } = state;
    let newTr = tr;
    idsToBeDeleted.forEach((id)=>{
        if (!allNodes[id]) return;
        const { node: node, pos: pos } = allNodes[id];
        newTr = newTr.delete(newTr.mapping.map(pos), newTr.mapping.map(node.nodeSize + pos));
    });
    return newTr;
};
// find all ids need to be remove connected to selected extension
const $219363623091e0b7$var$getIdsToBeDeleted = (selectedIds, allNodes)=>{
    if (!selectedIds.size) return [];
    let searchSet = [
        ...selectedIds
    ];
    const deletedIds = new Set();
    while(searchSet.length){
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const id = searchSet.pop();
        if (allNodes[id]) {
            deletedIds.add(allNodes[id].localId);
            searchSet = searchSet.concat(allNodes[id]?.targets.filter((targetId)=>!deletedIds.has(allNodes[targetId]?.localId)) ?? []);
        }
    }
    return Array.from(deletedIds);
};
const $219363623091e0b7$export$c98d43680e607ac1 = (state, node)=>{
    let allChildrenHadName = true;
    if (!node) return [];
    const childrenIdSet = new Set();
    const childrenInfoArray = [];
    const allNodes = $219363623091e0b7$export$82b9f8f75cc709b4(state);
    const selectedNodeIds = $219363623091e0b7$var$getSelectedLocalIds(state, node);
    selectedNodeIds.forEach((id)=>{
        if (allNodes[id]) allNodes[id].targets.forEach(childrenIdSet.add, childrenIdSet);
    });
    for (const id of childrenIdSet)if (!$219363623091e0b7$var$getNodeNameById(id, allNodes)) {
        allChildrenHadName = false;
        break;
    } else childrenInfoArray.push({
        id: id,
        name: $219363623091e0b7$var$getNodeNameById(id, allNodes),
        amount: $219363623091e0b7$var$getChildrenNodeAmount(id, allNodes)
    });
    return allChildrenHadName ? childrenInfoArray : [];
};
const $219363623091e0b7$var$getChildrenNodeAmount = (id, allNodes)=>{
    const searchTerms = new Set([
        id
    ]);
    const traverseHistory = new Map();
    const childrenIds = new Set();
    traverseHistory.set(id, false);
    while(searchTerms.size > 0){
        const [currTerm] = searchTerms;
        const targets = $219363623091e0b7$var$getNodeTargetsById(currTerm, allNodes);
        targets.forEach((target)=>{
            const isTargetCounted = traverseHistory.get(target);
            if (!isTargetCounted) {
                searchTerms.add(target);
                childrenIds.add(target);
            }
            target !== id && childrenIds.add(target);
        });
        traverseHistory.set(currTerm, true);
        searchTerms.delete(currTerm);
    }
    return childrenIds.size;
};
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $219363623091e0b7$var$getNodeTargetsById = (id, allNodes)=>{
    if (!id || !allNodes[id]) return [];
    return allNodes[id].targets;
};
const $219363623091e0b7$var$getNodeNameById = (id, allNodes)=>{
    if (typeof id === 'object') {
        let name;
        id.forEach((localId)=>{
            name = name ?? allNodes[localId]?.name;
        });
        return name || null;
    }
    if (!id || !allNodes[id]) return null;
    return allNodes[id].name;
};
const $219363623091e0b7$var$getSelectedLocalIds = (state, node)=>{
    if (!node) return new Set([]);
    const localIds = new Set([
        node.attrs?.localId,
        node.marks?.find((mark)=>mark.type === state.schema.marks.fragment)?.attrs?.localId
    ].filter(Boolean));
    return localIds;
};
module.exports["isReferencedSource"] = $219363623091e0b7$export$d35a68bd2e0b55da;
module.exports["removeConnectedNodes"] = $219363623091e0b7$export$657e59857351232d;
module.exports["getChildrenInfo"] = $219363623091e0b7$export$c98d43680e607ac1;

});

parcelRegister("jjJ59", function(module, exports) {
function $7f47fcc5aee2c06e$export$35b2f400604e700(node) {
    return Boolean(node && node.type && 'bulletList' === node.type.name);
}
module.exports["isBulletList"] = $7f47fcc5aee2c06e$export$35b2f400604e700;

});

parcelRegister("4DdJm", function(module, exports) {
function $5bcd9baa826f9b44$export$2ddb0a75547407f6(node) {
    return Boolean(node && node.type && 'listItem' === node.type.name);
}
module.exports["isListItemNode"] = $5bcd9baa826f9b44$export$2ddb0a75547407f6;

});

parcelRegister("jshjN", function(module, exports) {
function $e935f24e3c9a2c94$export$a7d7d2b9ba4d4dbb(node) {
    return Boolean(node && node.type && [
        'orderedList',
        'bulletList'
    ].includes(node.type.name));
}
module.exports["isListNode"] = $e935f24e3c9a2c94$export$a7d7d2b9ba4d4dbb;

});

parcelRegister("69yJQ", function(module, exports) {
function $15fb895fbf654bcf$export$35f600abfe6f0127(node) {
    return Boolean(node && node.type && 'paragraph' === node.type.name);
}
module.exports["isParagraphNode"] = $15fb895fbf654bcf$export$35f600abfe6f0127;

});

parcelRegister("hoQ9u", function(module, exports) {

var $81OAa = parcelRequire("81OAa");


var $b0F8r = parcelRequire("b0F8r");

class $0fd9cefae95b5e0e$export$4490385c12bf3d4 {
    static create() {
        class LinkMatcherRegex {
            exec(str) {
                const stringsBySpace = str.slice(0, str.length - 1).split(' ');
                const lastStringBeforeSpace = stringsBySpace[stringsBySpace.length - 1];
                const isLastStringValid = lastStringBeforeSpace.length > 0;
                if (!str.endsWith(' ') || !isLastStringValid) return null;
                if ((0, $b0F8r.DONTLINKIFY_REGEXP).test(lastStringBeforeSpace)) return null;
                const links = (0, $81OAa.linkify).match(lastStringBeforeSpace);
                if (!links || links.length === 0) return null;
                const lastMatch = links[links.length - 1];
                const lastLink = links[links.length - 1];
                lastLink.input = str.substring(lastMatch.index);
                lastLink.length = lastLink.lastIndex - lastLink.index + 1;
                lastLink.index = str.lastIndexOf(lastStringBeforeSpace) + lastMatch.index;
                return lastLink;
            }
        }
        return new LinkMatcherRegex();
    }
}
module.exports["LinkMatcher"] = $0fd9cefae95b5e0e$export$4490385c12bf3d4;

});

parcelRegister("j9WGh", function(module, exports) {
const $6b47a2dab5c45051$export$b7392a423e62dc8c = (from, to)=>(state)=>{
        if (!state.doc.rangeHasMark(from, to, state.schema.marks.link)) {
            const $from = state.doc.resolve(from);
            const $to = state.doc.resolve(to);
            const link = state.schema.marks.link;
            if ($from.parent === $to.parent && $from.parent.isTextblock) {
                if ($from.parent.type.allowsMarkType(link)) {
                    let allowed = true;
                    state.doc.nodesBetween(from, to, (node)=>{
                        const hasInlineCard = node.type === state.schema.nodes.inlineCard;
                        allowed = allowed && !node.marks.some((m)=>m.type.excludes(link)) && !hasInlineCard;
                        return allowed;
                    });
                    return allowed;
                }
            }
        }
        return false;
    };
module.exports["canLinkBeCreatedInRange"] = $6b47a2dab5c45051$export$b7392a423e62dc8c;

});

parcelRegister("eYlm5", function(module, exports) {
const $42b7f669665818db$export$27813bf9aa3826dc = (layout)=>layout === 'wrap-left' || layout === 'wrap-right' ? 'wrapped' : 'full';
module.exports["gridTypeForLayout"] = $42b7f669665818db$export$27813bf9aa3826dc;

});

parcelRegister("eluto", function(module, exports) {
function $2f7c3587c5368080$export$c9083db5521330d3(node) {
    const isInlineNodeHasVisibleContent = (inlineNode)=>{
        return inlineNode.isText ? !!inlineNode.textContent.trim() : inlineNode.type.name !== 'hardBreak';
    };
    if (node.isInline) return isInlineNodeHasVisibleContent(node);
    else if (node.isBlock && (node.isLeaf || node.isAtom)) return true;
    else if (!node.childCount) return false;
    for(let index = 0; index < node.childCount; index++){
        const child = node.child(index);
        const invisibleNodeTypes = [
            'paragraph',
            'text',
            'hardBreak'
        ];
        if (!invisibleNodeTypes.includes(child.type.name) || $2f7c3587c5368080$export$c9083db5521330d3(child)) return true;
    }
    return false;
}
module.exports["hasVisibleContent"] = $2f7c3587c5368080$export$c9083db5521330d3;

});

parcelRegister("6qPH4", function(module, exports) {
const $861a8f6b4e6f8e6b$export$435c1d4e61a8723b = (state)=>state.selection.$to.parent.type === state.schema.nodes.paragraph && state.selection.$to.pos === state.doc.resolve(state.selection.$to.pos).end();
module.exports["isSelectionEndOfParagraph"] = $861a8f6b4e6f8e6b$export$435c1d4e61a8723b;

});

parcelRegister("hcUEx", function(module, exports) {

var $aFUXX = parcelRequire("aFUXX");


var $7RmbT = parcelRequire("7RmbT");

function $49664c9c159f1ace$export$de65085e667b4bf1({ $pos: $pos, akEditorWideLayoutWidth: akEditorWideLayoutWidth, allowBreakoutSnapPoints: allowBreakoutSnapPoints, containerWidth: containerWidth, gridSize: gridSize, gridWidth: gridWidth, insideInlineLike: insideInlineLike, insideLayout: insideLayout, isVideoFile: isVideoFile, lineLength: lineLength, offsetLeft: offsetLeft, wrappedLayout: wrappedLayout }) {
    const snapTargets = [];
    for(let i = 0; i < gridWidth; i++){
        const pxFromColumns = (0, $7RmbT.calcPxFromColumns)(i, lineLength, gridWidth);
        snapTargets.push(insideLayout ? pxFromColumns : pxFromColumns - offsetLeft);
    }
    // full width
    snapTargets.push(lineLength - offsetLeft);
    const columns = wrappedLayout || insideInlineLike ? 1 : 2;
    const minimumWidth = (0, $7RmbT.calcPxFromColumns)(columns, lineLength, gridSize);
    let snapPoints = snapTargets.filter((width)=>width >= minimumWidth);
    if (!$pos) return snapPoints;
    snapPoints = isVideoFile ? snapPoints.filter((width)=>width > 320) : snapPoints;
    const isTopLevel = $pos.parent.type.name === 'doc';
    if (isTopLevel && allowBreakoutSnapPoints) {
        snapPoints.push(akEditorWideLayoutWidth);
        const fullWidthPoint = containerWidth - (0, $aFUXX.akEditorBreakoutPadding);
        if (fullWidthPoint > akEditorWideLayoutWidth) snapPoints.push(fullWidthPoint);
    }
    // EDM-1107: Ensure new snapPoints are sorted with existing points
    snapPoints = snapPoints.sort((a, b)=>a - b);
    return snapPoints;
}
module.exports["calculateSnapPoints"] = $49664c9c159f1ace$export$de65085e667b4bf1;

});

parcelRegister("7RmbT", function(module, exports) {

var $gAARK = parcelRequire("gAARK");

function $de34bc7e1b01772e$export$1e3701608f0cee80(columns, lineLength, gridSize) {
    const maxWidth = lineLength + (0, $gAARK.MEDIA_SINGLE_GUTTER_SIZE);
    return maxWidth / gridSize * columns - (0, $gAARK.MEDIA_SINGLE_GUTTER_SIZE);
}
module.exports["calcPxFromColumns"] = $de34bc7e1b01772e$export$1e3701608f0cee80;

});

parcelRegister("7F8k7", function(module, exports) {
const $491d4f1ebe7eaf31$export$7c0073a4d21b222d = [
    'wrap-left',
    'wrap-right'
];
module.exports["floatingLayouts"] = $491d4f1ebe7eaf31$export$7c0073a4d21b222d;

});

parcelRegister("jcsKQ", function(module, exports) {

var $8m4tT = parcelRequire("8m4tT");


var $iu6m9 = parcelRequire("iu6m9");

const $b8f96000cb332fe5$export$55fb9d6810f2e04b = (view, pos)=>{
    if (typeof pos !== 'number' || isNaN(pos) || !view) return false;
    const $pos = view.state.doc.resolve(pos);
    const { expand: expand, nestedExpand: nestedExpand, layoutColumn: layoutColumn, bodiedSyncBlock: bodiedSyncBlock } = view.state.schema.nodes;
    if ((0, $iu6m9.editorExperiment)('platform_synced_block', true)) return !!(0, $8m4tT.findParentNodeOfTypeClosestToPos)($pos, [
        expand,
        nestedExpand,
        layoutColumn,
        bodiedSyncBlock
    ]);
    return !!(0, $8m4tT.findParentNodeOfTypeClosestToPos)($pos, [
        expand,
        nestedExpand,
        layoutColumn
    ]);
};
module.exports["isRichMediaInsideOfBlockNode"] = $b8f96000cb332fe5$export$55fb9d6810f2e04b;

});

parcelRegister("lqWNh", function(module, exports) {

var $c6YWU = parcelRequire("c6YWU");


var $3ZFfQ = parcelRequire("3ZFfQ");


var $8K67p = parcelRequire("8K67p");




const $f9e9293fb4fd549c$export$b2258912a400ba32 = (layout, oldAttrs, gridSize = 12, originalWidth, lineLength)=>{
    let width = oldAttrs.width;
    const oldLayout = oldAttrs.layout;
    const oldLayoutIsNonWrapped = (0, $3ZFfQ.nonWrappedLayouts).indexOf(oldLayout) > -1;
    const newLayoutIsNonWrapped = (0, $3ZFfQ.nonWrappedLayouts).indexOf(layout) > -1;
    const newLayoutIsWrapped = (0, $c6YWU.wrappedLayouts).indexOf(layout) > -1;
    const oldLayoutIsWrapped = (0, $c6YWU.wrappedLayouts).indexOf(oldLayout) > -1;
    if (oldLayoutIsNonWrapped && (0, $8K67p.shouldAddDefaultWrappedWidth)(layout, originalWidth, lineLength)) // 'full-width' or 'wide' or 'center' -> 'wrap-left' or 'wrap-right' or 'align-end' or 'align-start'
    {
        if (!width || width >= 100 || oldLayout !== 'center' // == 'full-width' or 'wide'
        ) width = 50;
    } else if (layout !== oldLayout && [
        'full-width',
        'wide'
    ].indexOf(oldLayout) > -1) // 'full-width' -> 'center' or 'wide'
    // 'wide' -> 'center' or 'full-width'
    // unset width
    width = undefined;
    else if (width) {
        const cols = Math.round(width / 100 * gridSize);
        let targetCols = cols;
        if (oldLayoutIsWrapped && newLayoutIsNonWrapped) {
            // wrap -> center needs to align to even grid
            targetCols = Math.floor(targetCols / 2) * 2;
            width = undefined;
        } else if (oldLayoutIsNonWrapped && newLayoutIsWrapped) {
            // Can be here only if
            // 'full-width' or 'wide' or 'center' -> 'wrap-left' or 'wrap-right' or 'align-end' or 'align-start'
            // AND
            // !originalWidth || !lineLength || small image
            // AND
            // width defined!
            // cannot resize to full column width, and cannot resize to 1 column
            if (cols <= 1) targetCols = 2;
            else if (cols >= gridSize) targetCols = 10;
        }
        if (targetCols !== cols) width = targetCols / gridSize * 100;
    }
    return {
        ...oldAttrs,
        layout: layout,
        width: width
    };
};
module.exports["alignAttributes"] = $f9e9293fb4fd549c$export$b2258912a400ba32;

});

parcelRegister("e7tBw", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");


var $iu6m9 = parcelRequire("iu6m9");


var $d925B = parcelRequire("d925B");


var $dAtrv = parcelRequire("dAtrv");


var $adhil = parcelRequire("adhil");


var $b20Th = parcelRequire("b20Th");


var $sU9ED = parcelRequire("sU9ED");


var $WGctw = parcelRequire("WGctw");


var $fDECt = parcelRequire("fDECt");


var $jMZUD = parcelRequire("jMZUD");


var $eYkDj = parcelRequire("eYkDj");


const $4be293a911874993$export$a5ae75c0b3dfe1c0 = ($startPos)=>{
    let $pos = $startPos;
    // invariant 1: don't walk past the end of the document
    // invariant 2: we are at the beginning or
    //              we haven't walked to the start of *any* node
    //              parentOffset includes textOffset.
    while($pos.pos < $pos.doc.nodeSize - 2 && ($pos.pos === $startPos.pos || $pos.parentOffset > 0))$pos = $pos.doc.resolve($pos.pos + 1);
    return {
        $pos: $pos,
        foundNode: $pos.pos < $pos.doc.nodeSize - 2
    };
};
const $4be293a911874993$export$cab15df6ad89b5a0 = ($startPos)=>{
    let $pos = $startPos;
    while($pos.pos > 0 && ($pos.pos === $startPos.pos || $pos.parentOffset < $pos.parent.nodeSize - 2))$pos = $pos.doc.resolve($pos.pos - 1);
    return {
        $pos: $pos,
        foundNode: $pos.pos > 0
    };
};
const $4be293a911874993$export$67efd148fa31066c = (editorAnalyticsAPI)=>(0, $dAtrv.withAnalytics)(editorAnalyticsAPI, {
        action: (0, $d925B.ACTION).INSERTED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).LINE_BREAK,
        eventType: (0, $d925B.EVENT_TYPE).TRACK
    })((0, $fDECt.insertNewLine)());
const $4be293a911874993$export$fd094c1e3c1540bf = (state, dispatch)=>{
    const append = false;
    if (!$4be293a911874993$var$canMoveUp(state) && $4be293a911874993$var$canCreateParagraphNear(state)) {
        $4be293a911874993$export$d0f80ac1b4510888(append)(state, dispatch);
        return true;
    }
    return false;
};
const $4be293a911874993$export$d4296e42f66d8dc6 = (state, dispatch)=>{
    const append = true;
    if (!$4be293a911874993$var$canMoveDown(state) && $4be293a911874993$var$canCreateParagraphNear(state)) {
        $4be293a911874993$export$d0f80ac1b4510888(append)(state, dispatch);
        return true;
    }
    return false;
};
function $4be293a911874993$var$canCreateParagraphNear(state) {
    const { selection: { $from: $from } } = state;
    const node = $from.node($from.depth);
    const insideCodeBlock = !!node && node.type === state.schema.nodes.codeBlock;
    const isNodeSelection = state.selection instanceof (0, $ks2lK.NodeSelection);
    return $from.depth > 1 || isNodeSelection || insideCodeBlock;
}
function $4be293a911874993$export$d0f80ac1b4510888(append = true) {
    return function(state, dispatch) {
        const paragraph = state.schema.nodes.paragraph;
        if (!paragraph) return false;
        let insertPos;
        if (state.selection instanceof (0, $ks2lK.TextSelection)) {
            if ($4be293a911874993$var$topLevelNodeIsEmptyTextBlock(state)) return false;
            insertPos = $4be293a911874993$var$getInsertPosFromTextBlock(state, append);
        } else insertPos = $4be293a911874993$var$getInsertPosFromNonTextBlock(state, append);
        const tr = state.tr.insert(insertPos, paragraph.createAndFill());
        tr.setSelection((0, $ks2lK.TextSelection).create(tr.doc, insertPos + 1));
        if (dispatch) dispatch(tr);
        return true;
    };
}
function $4be293a911874993$var$getInsertPosFromTextBlock(state, append) {
    const { $from: $from, $to: $to } = state.selection;
    let pos;
    if (!append) pos = $from.start(0);
    else pos = $to.end(0);
    return pos;
}
function $4be293a911874993$var$getInsertPosFromNonTextBlock(state, append) {
    const { $from: $from, $to: $to } = state.selection;
    const nodeAtSelection = state.selection instanceof (0, $ks2lK.NodeSelection) && state.doc.nodeAt(state.selection.$anchor.pos);
    const isMediaSelection = nodeAtSelection && nodeAtSelection.type.name === 'mediaGroup';
    let pos;
    if (!append) {
        // The start position is different with text block because it starts from 0
        pos = $from.start($from.depth);
        // The depth is different with text block because it starts from 0
        pos = $from.depth > 0 && !isMediaSelection ? pos - 1 : pos;
    } else {
        pos = $to.end($to.depth);
        pos = $to.depth > 0 && !isMediaSelection ? pos + 1 : pos;
    }
    return pos;
}
function $4be293a911874993$var$topLevelNodeIsEmptyTextBlock(state) {
    const topLevelNode = state.selection.$from.node(1);
    return topLevelNode.isTextblock && topLevelNode.type !== state.schema.nodes.codeBlock && topLevelNode.nodeSize === 2;
}
function $4be293a911874993$var$canMoveUp(state) {
    const { selection: selection } = state;
    /**
	 * If there's a media element on the selection it will use a gap cursor to move
	 */ if (selection instanceof (0, $ks2lK.NodeSelection) && (0, $eYkDj.isMediaNode)(selection.node)) return true;
    if (selection instanceof (0, $ks2lK.TextSelection) && !(0, $iu6m9.editorExperiment)('platform_editor_block_menu', true)) {
        if (!selection.empty) return true;
    }
    return !(0, $b20Th.atTheBeginningOfDoc)(state);
}
function $4be293a911874993$var$canMoveDown(state) {
    const { selection: selection } = state;
    /**
	 * If there's a media element on the selection it will use a gap cursor to move
	 */ if (selection instanceof (0, $ks2lK.NodeSelection) && (0, $eYkDj.isMediaNode)(selection.node)) return true;
    if (selection instanceof (0, $ks2lK.TextSelection) && !(0, $iu6m9.editorExperiment)('platform_editor_block_menu', true)) {
        if (!selection.empty) return true;
    }
    return !(0, $sU9ED.atTheEndOfDoc)(state);
}
const $4be293a911874993$export$a52ade1f964aef2c = (canNextNodeMoveUp)=>{
    return (state, dispatch, view)=>{
        const { selection: { $from: { pos: pos, parent: parent }, $head: $head, empty: empty }, tr: tr, doc: doc } = state;
        const { $pos: $pos } = $4be293a911874993$export$a5ae75c0b3dfe1c0($head);
        const nextPMNode = doc.nodeAt($pos.pos - 1);
        if (empty && nextPMNode && canNextNodeMoveUp(nextPMNode) && (0, $jMZUD.isEmptyParagraph)(parent) && view?.endOfTextblock('right')) {
            tr.deleteRange(pos - 1, pos + 1);
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };
};
const $4be293a911874993$export$55f1e30b4664ff16 = (state)=>{
    const { blockTaskItem: blockTaskItem } = state.schema.nodes;
    const { empty: empty, $from: $from } = state.selection;
    // If blockTaskItem is in the schema,
    // we need to check if the selection is inside a blockTaskItem
    if (blockTaskItem && empty) {
        // If the parent is in a textblock,
        // check if it's nested inside a blockTaskItem
        if ($from.parent.isTextblock) {
            const $posAtStartOfTextBlock = state.doc.resolve($from.start($from.depth - 1));
            const parentOfTextBlock = $posAtStartOfTextBlock.parent;
            // If the parent of the textblock is a blockTaskItem,
            // we need to if the textblock is the first node in the blockTaskItem
            if (parentOfTextBlock.type === blockTaskItem) {
                const firstChildOfBlockTaskItem = parentOfTextBlock.firstChild;
                if (firstChildOfBlockTaskItem === $from.parent) {
                    // If the textblock is the first node in the blockTaskItem,
                    // check if the selection is at the start of the textblock
                    const firstTextPosInTextBlock = $from.start($from.depth);
                    return $from.pos === firstTextPosInTextBlock;
                } else return false;
            }
        } else if ($from.parent.type === blockTaskItem) {
            // Check if the selection is at the start of the blockTaskItem
            const blockTaskItemDepth = $from.depth;
            const firstPosInBlockTaskItem = $from.start(blockTaskItemDepth);
            // Is the selection at the first possible position inside the blockTaskItem
            return $from.pos === firstPosInBlockTaskItem;
        }
    }
    return empty && ($from.parentOffset === 0 || state.selection instanceof (0, $adhil.GapCursorSelection));
};
const $4be293a911874993$export$aedf35c057f77b82 = (state)=>{
    const { blockTaskItem: blockTaskItem } = state.schema.nodes;
    const { empty: empty, $from: $from } = state.selection;
    // If blockTaskItem is in the schema,
    // we need to check if the selection is inside a blockTaskItem
    if (blockTaskItem && empty) {
        // If the parent is in a textblock,
        // check if it's nested inside a blockTaskItem
        if ($from.parent.isTextblock) {
            const $posAtEndOfTextBlock = state.doc.resolve($from.end($from.depth - 1));
            const parentOfTextBlock = $posAtEndOfTextBlock.parent;
            // If the parent of the textblock is a blockTaskItem,
            // we need to know if the textblock is the last node in the blockTaskItem
            if (parentOfTextBlock.type === blockTaskItem) {
                const lastChildOfBlockTaskItem = parentOfTextBlock.lastChild;
                if (lastChildOfBlockTaskItem === $from.parent) {
                    // If the textblock is the last node in the blockTaskItem,
                    // check if the selection is at the end of the textblock
                    const lastTextPosInTextBlock = $from.end($from.depth);
                    return $from.pos === lastTextPosInTextBlock;
                } else return false;
            }
        } else if ($from.parent.type === blockTaskItem) {
            // Check if the selection is at the end of the blockTaskItem
            const lastPosInBlockTaskItem = $from.end();
            return $from.pos === lastPosInBlockTaskItem;
        }
    }
    return empty && ($from.end() === $from.pos || state.selection instanceof (0, $adhil.GapCursorSelection));
};
module.exports["walkNextNode"] = $4be293a911874993$export$a5ae75c0b3dfe1c0;
module.exports["walkPrevNode"] = $4be293a911874993$export$cab15df6ad89b5a0;
module.exports["insertNewLineWithAnalytics"] = $4be293a911874993$export$67efd148fa31066c;
module.exports["createNewParagraphAbove"] = $4be293a911874993$export$fd094c1e3c1540bf;
module.exports["createParagraphNear"] = $4be293a911874993$export$d0f80ac1b4510888;
module.exports["createNewParagraphBelow"] = $4be293a911874993$export$d4296e42f66d8dc6;
module.exports["deleteEmptyParagraphAndMoveBlockUp"] = $4be293a911874993$export$a52ade1f964aef2c;
module.exports["isEmptySelectionAtStart"] = $4be293a911874993$export$55f1e30b4664ff16;
module.exports["isEmptySelectionAtEnd"] = $4be293a911874993$export$aedf35c057f77b82;

});

parcelRegister("dAtrv", function(module, exports) {
function $3f18fece9c4d518d$export$af9baadf0e4f6e13(analyticsApi, payload, channel) {
    return (command)=>(state, dispatch, view)=>command(state, (tr)=>{
                if (dispatch) {
                    if (payload instanceof Function) {
                        const dynamicPayload = payload(state, {
                            currentDoc: tr.doc
                        });
                        if (dynamicPayload) {
                            analyticsApi?.attachAnalyticsEvent(dynamicPayload, channel)(tr);
                            dispatch(tr);
                        }
                    } else {
                        analyticsApi?.attachAnalyticsEvent(payload, channel)(tr);
                        dispatch(tr);
                    }
                }
            }, view);
}
module.exports["withAnalytics"] = $3f18fece9c4d518d$export$af9baadf0e4f6e13;

});

parcelRegister("WGctw", function(module, exports) {
const $b191a3d3ed5e8763$export$3dea766d36a8935f = (predicates, cmd)=>{
    return function(state, dispatch, view) {
        if (!Array.isArray(predicates)) predicates = [
            predicates
        ];
        if (predicates.some((pred)=>!pred(state, view))) return false;
        return cmd(state, dispatch, view) || false;
    };
};
module.exports["filter"] = $b191a3d3ed5e8763$export$3dea766d36a8935f;

});

parcelRegister("gm0lv", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");

const $d66a814afa63d7c2$export$1a87582f65bdc5db = (tr, getSelectionResolvedPos, insertions, deletions)=>{
    insertions.forEach((contentInsert)=>{
        const [content, pos] = contentInsert;
        tr.insert(tr.mapping.map(pos), content);
    });
    deletions.forEach((deleteRange)=>{
        const [firstPos, lastPos] = deleteRange;
        tr.delete(tr.mapping.map(firstPos), tr.mapping.map(lastPos));
    });
    tr.setSelection(new (0, $ks2lK.TextSelection)(getSelectionResolvedPos(tr)));
};
module.exports["insertContentDeleteRange"] = $d66a814afa63d7c2$export$1a87582f65bdc5db;

});

parcelRegister("4VXMf", function(module, exports) {

var $ke2AI = parcelRequire("ke2AI");

const $47863787abaaf2f4$export$56e87122f905fac0 = (match, handler, allowsBackwardMatch = false)=>{
    return {
        match: match,
        handler: handler,
        onHandlerApply: (_state, tr)=>{
            (0, $ke2AI.closeHistory)(tr);
        },
        allowsBackwardMatch: allowsBackwardMatch
    };
};
module.exports["createRule"] = $47863787abaaf2f4$export$56e87122f905fac0;

});

parcelRegister("l03WE", function(module, exports) {

var $aXG5V = parcelRequire("aXG5V");


var $jbKei = parcelRequire("jbKei");


var $4VXMf = parcelRequire("4VXMf");

const $675194dd3a255bc3$export$333ee6e3f01bb8f9 = (getPayload, analyticsApi)=>{
    return (originalRule)=>{
        const onHandlerApply = (state, tr, matchResult)=>{
            const payload = typeof getPayload === 'function' ? getPayload(state, matchResult) : getPayload;
            if (payload && payload.attributes) payload.attributes.formatSize = typeof matchResult[0] === 'string' ? matchResult[0].length : 0;
            analyticsApi?.attachAnalyticsEvent(payload)(tr);
            if (originalRule.onHandlerApply) originalRule.onHandlerApply(state, tr, matchResult);
        };
        return {
            ...originalRule,
            onHandlerApply: onHandlerApply
        };
    };
};
const $675194dd3a255bc3$export$6341edfa2d147bc = ({ match: match, nodeType: nodeType, getAttrs: getAttrs, joinPredicate: joinPredicate })=>{
    const handler = (state, match, start, end)=>{
        const attrs = (getAttrs instanceof Function ? getAttrs(match) : getAttrs) || {};
        const tr = state.tr;
        const fixedStart = Math.max(start, 1);
        tr.delete(fixedStart, end);
        const $start = tr.doc.resolve(fixedStart);
        const range = $start.blockRange();
        const wrapping = range && (0, $aXG5V.findWrapping)(range, nodeType, attrs);
        if (!wrapping || !range) return null;
        const parentNodePosMapped = tr.mapping.map(range.start);
        const parentNode = tr.doc.nodeAt(parentNodePosMapped);
        const lastWrap = wrapping[wrapping.length - 1];
        if (parentNode && lastWrap) {
            const allowedMarks = lastWrap.type.allowedMarks(parentNode.marks) || [];
            tr.setNodeMarkup(parentNodePosMapped, parentNode.type, parentNode.attrs, allowedMarks);
        }
        tr.wrap(range, wrapping);
        const before = tr.doc.resolve(fixedStart - 1).nodeBefore;
        if (before && before.type === nodeType && (0, $aXG5V.canJoin)(tr.doc, fixedStart - 1) && (!joinPredicate || joinPredicate(match, before, (0, $jbKei.JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST).JOINED_TO_LIST_ABOVE))) tr.join(fixedStart - 1);
        return tr;
    };
    return (0, $4VXMf.createRule)(match, handler);
};
module.exports["inputRuleWithAnalytics"] = $675194dd3a255bc3$export$333ee6e3f01bb8f9;
module.exports["createWrappingJoinRule"] = $675194dd3a255bc3$export$6341edfa2d147bc;

});

parcelRegister("jbKei", function(module, exports) {
var $d8e57328e993bafb$export$a9b79b94eb5ffad = /*#__PURE__*/ function(DELETE_DIRECTION) {
    DELETE_DIRECTION["BACKWARD"] = "backward";
    DELETE_DIRECTION["FORWARD"] = "forward";
    return DELETE_DIRECTION;
}({});
var $d8e57328e993bafb$export$c3c848735ee9408a = /*#__PURE__*/ function(LIST_TEXT_SCENARIOS) {
    LIST_TEXT_SCENARIOS["JOIN_SIBLINGS"] = "joinSiblings";
    LIST_TEXT_SCENARIOS["JOIN_DESCENDANT_TO_PARENT"] = "joinDescendantToParent";
    LIST_TEXT_SCENARIOS["JOIN_TO_SIBLING_DESCENDANT"] = "joinToSiblingDescendant";
    LIST_TEXT_SCENARIOS["JOIN_PARAGRAPH_WITH_LIST"] = "joinParagraphWithList";
    LIST_TEXT_SCENARIOS["JOIN_PARENT_SIBLING_TO_PARENT_CHILD"] = "joinParentSiblingToParentChild";
    LIST_TEXT_SCENARIOS["JOIN_LIST_ITEM_WITH_PARAGRAPH"] = "joinListItemWithParagraph";
    return LIST_TEXT_SCENARIOS;
}({});
var $d8e57328e993bafb$export$43e6a678b13eb45f = /*#__PURE__*/ function(JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST) {
    JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST["NO_JOIN"] = "noJoin";
    JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST["JOINED_TO_LIST_ABOVE"] = "joinedToListAbove";
    JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST["JOINED_TO_LIST_BELOW"] = "joinedToListBelow";
    return JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST;
}({});
var $d8e57328e993bafb$export$ed4ba8ac11f6cbc8 = /*#__PURE__*/ function(OUTDENT_SCENARIOS) {
    OUTDENT_SCENARIOS["SPLIT_LIST"] = "splitList";
    return OUTDENT_SCENARIOS;
}({});
module.exports["DELETE_DIRECTION"] = $d8e57328e993bafb$export$a9b79b94eb5ffad;
module.exports["LIST_TEXT_SCENARIOS"] = $d8e57328e993bafb$export$c3c848735ee9408a;
module.exports["JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST"] = $d8e57328e993bafb$export$43e6a678b13eb45f;
module.exports["OUTDENT_SCENARIOS"] = $d8e57328e993bafb$export$ed4ba8ac11f6cbc8;

});

parcelRegister("l9FJJ", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");


var $aXG5V = parcelRequire("aXG5V");


var $8m4tT = parcelRequire("8m4tT");


var $kTbzR = parcelRequire("kTbzR");

function $a4e77ca3d010585b$export$d5c308539c2b2123({ state: state, type: type, nodeAttributes: nodeAttributes }) {
    let { tr: tr } = state;
    const { alignment: alignment, indentation: indentation } = state.schema.marks;
    /** Alignment or Indentation is not valid inside block types */ const removeAlignTr = (0, $kTbzR.removeBlockMarks)(state, [
        alignment,
        indentation
    ]);
    tr = removeAlignTr || tr;
    /**Get range and wrapping needed for the selection*/ const { range: range, wrapping: wrapping } = $a4e77ca3d010585b$export$656aa714448bfa8a(state, type, nodeAttributes);
    if (wrapping) tr.wrap(range, wrapping).scrollIntoView();
    else /** We always want to append a block type */ (0, $8m4tT.safeInsert)(type.createAndFill(nodeAttributes))(tr).scrollIntoView();
    return tr;
}
function $a4e77ca3d010585b$export$656aa714448bfa8a(state, type, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
nodeAttributes) {
    const { $from: $from, $to: $to, from: from } = state.selection;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let range = $from.blockRange($to);
    const isMediaSelection = state.selection instanceof (0, $ks2lK.NodeSelection) && state.selection.node.type === state.schema.nodes.media;
    /**
	 * To wrap a media group we need to start the range from one position
	 * before a media selection's from position.
	 */ if (isMediaSelection) {
        const prev = from - 1;
        range = state.doc.resolve(from > 0 ? prev : from).blockRange($to);
    }
    let isAllowedChild = true;
    /**
	 * Added a check to avoid wrapping codeblock
	 */ if (state.selection.empty) state.doc.nodesBetween($from.pos, $to.pos, (node)=>{
        if (!isAllowedChild) return false;
        return isAllowedChild = node.type !== state.schema.nodes.codeBlock;
    });
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const wrapping = isAllowedChild && range && (0, $aXG5V.findWrapping)(range, type, nodeAttributes);
    return {
        range: range,
        wrapping: wrapping
    };
}
module.exports["createWrapSelectionTransaction"] = $a4e77ca3d010585b$export$d5c308539c2b2123;

});

parcelRegister("lNDSG", function(module, exports) {

var $8m4tT = parcelRequire("8m4tT");


var $7XFGZ = parcelRequire("7XFGZ");

const $68fa3b7808a54c2b$var$MAXIMUM_BROWSER_SCROLLBAR_WIDTH = 20;
const $68fa3b7808a54c2b$export$5966a251e0deb6ac = (toolbarTitle)=>(editorView, nextPos)=>{
        const toolbar = document.querySelector(`div[aria-label="${toolbarTitle}"]`);
        if (!toolbar) return nextPos;
        // scroll wrapper for full page, fall back to document body
        // Ignored via go/ees007
        // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
        // TODO: look into using getScrollGutterOptions()
        const scrollWrapper = editorView.dom.closest('.fabric-editor-popup-scroll-parent') || document.body;
        const wrapperBounds = scrollWrapper.getBoundingClientRect();
        const selection = window && window.getSelection();
        const range = selection && !selection.isCollapsed && selection.getRangeAt(0);
        if (!range) return nextPos;
        const toolbarRect = toolbar.getBoundingClientRect();
        const { head: head, anchor: anchor } = editorView.state.selection;
        const topCoords = editorView.coordsAtPos(Math.min(head, anchor));
        const bottomCoords = editorView.coordsAtPos(Math.max(head, anchor) - Math.min(range.endOffset, 1));
        let top = (topCoords.top || 0) - toolbarRect.height * 1.5;
        let left = 0;
        // If not on the same line
        if (topCoords.top !== bottomCoords.top) {
            // selecting downwards
            if (head > anchor) left = Math.max(topCoords.right, bottomCoords.right);
            else left = Math.min(topCoords.left, bottomCoords.left);
            /*
        short selection above a long paragraph
        eg. short {<}heading
        The purpose of this text is to show the selection range{>}.
        The horizontal positioning should center around "heading",
        not where it ends at "range".
        Note: if it was "head<b>ing</b>" then it would only center
        around "head". Undesireable but matches the current renderer.
      */ const cliffPosition = range.getClientRects()[0];
            if (cliffPosition.right < left) left = cliffPosition.left + cliffPosition.width / 2;
        } else // Otherwise center on the single line selection
        left = topCoords.left + (bottomCoords.right - topCoords.left) / 2;
        left -= toolbarRect.width / 2;
        // Place toolbar below selection if not sufficient space above
        if (top < wrapperBounds.top) ({ top: top, left: left } = $68fa3b7808a54c2b$var$getCoordsBelowSelection(bottomCoords, toolbarRect));
        // remap positions from browser document to wrapperBounds
        return {
            top: top - wrapperBounds.top + scrollWrapper.scrollTop,
            left: Math.max(0, left - wrapperBounds.left)
        };
    };
const $68fa3b7808a54c2b$export$4fdfbe77de19eec = (toolbarTitle)=>(editorView, nextPos)=>{
        const toolbar = document.querySelector(`div[aria-label="${toolbarTitle}"]`);
        if (!toolbar) return nextPos;
        // scroll wrapper for full page, fall back to document body
        // Ignored via go/ees007
        // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
        // TODO: look into using getScrollGutterOptions()
        const scrollWrapper = editorView.dom.closest('.fabric-editor-popup-scroll-parent') || document.body;
        const wrapperBounds = scrollWrapper.getBoundingClientRect();
        const selection = window && window.getSelection();
        const moreRovoOptionsButton = document.querySelector('button[aria-label="More Rovo options"], [aria-label="More Rovo options"]');
        const isMoreRovoOptionsButtonVisible = !!moreRovoOptionsButton && moreRovoOptionsButton instanceof HTMLElement && !!moreRovoOptionsButton.offsetParent;
        let range = null;
        if (isMoreRovoOptionsButtonVisible) {
            if (selection && selection.getRangeAt && selection.rangeCount > 0) {
                const maybeRange = selection.getRangeAt(0);
                if (maybeRange instanceof Range) range = maybeRange;
            }
        } else if (selection && !selection.isCollapsed && selection.getRangeAt && selection.rangeCount > 0) {
            const maybeRange = selection.getRangeAt(0);
            if (maybeRange instanceof Range) range = maybeRange;
        }
        if (!range) return nextPos;
        const toolbarRect = toolbar.getBoundingClientRect();
        const { head: head, anchor: anchor } = editorView.state.selection;
        const topCoords = editorView.coordsAtPos(Math.min(head, anchor));
        const bottomCoords = editorView.coordsAtPos(Math.max(head, anchor) - Math.min(range.endOffset, 1));
        let top;
        // If not the same line, display toolbar below.
        if (head > anchor && topCoords.top !== bottomCoords.top) // We are taking the previous pos to the maxium, so avoid end of line positions
        // returning the next line's rect.
        top = (bottomCoords.top || 0) + toolbarRect.height / 1.15;
        else top = (topCoords.top || 0) - toolbarRect.height * 1.5;
        let left = (head > anchor ? bottomCoords.right : topCoords.left) - toolbarRect.width / 2;
        // Place toolbar below selection if not sufficient space above
        if (top < wrapperBounds.top) ({ top: top, left: left } = $68fa3b7808a54c2b$var$getCoordsBelowSelection(bottomCoords, toolbarRect));
        let leftCoord = Math.max(0, left - wrapperBounds.left);
        if (leftCoord + toolbarRect.width > wrapperBounds.width) {
            const scrollbarWidth = $68fa3b7808a54c2b$var$MAXIMUM_BROWSER_SCROLLBAR_WIDTH;
            leftCoord = Math.max(0, wrapperBounds.width - (toolbarRect.width + scrollbarWidth));
        }
        // remap positions from browser document to wrapperBounds
        return {
            top: top - wrapperBounds.top + scrollWrapper.scrollTop,
            left: leftCoord
        };
    };
/**
 * Returns the coordintes at the bottom the selection.
 */ const $68fa3b7808a54c2b$var$getCoordsBelowSelection = (bottomCoords, toolbarRect)=>{
    return {
        top: (bottomCoords.top || 0) + toolbarRect.height / 1.15,
        left: bottomCoords.right - toolbarRect.width / 2
    };
};
const $68fa3b7808a54c2b$var$cellSelectionToolbarOffsetTop = 10;
const $68fa3b7808a54c2b$var$scrollbarWidth = 20;
const $68fa3b7808a54c2b$var$offsetTopOnColumnSelection = 4;
const $68fa3b7808a54c2b$export$2d9cc331fb808a87 = (toolbarTitle)=>(editorView, nextPos)=>{
        const toolbar = document.querySelector(`div[aria-label="${toolbarTitle}"]`);
        if (!toolbar) return nextPos;
        const { selection: selection } = editorView.state;
        if (!(selection instanceof (0, $7XFGZ.CellSelection))) return nextPos;
        const { $anchorCell: $anchorCell, $headCell: $headCell } = selection;
        const domAtPos = editorView.domAtPos.bind(editorView);
        const anchorCellDOM = (0, $8m4tT.findDomRefAtPos)($anchorCell.pos, domAtPos);
        const headCellDOM = (0, $8m4tT.findDomRefAtPos)($headCell.pos, domAtPos);
        if (!(anchorCellDOM instanceof HTMLElement) || !(headCellDOM instanceof HTMLElement)) return nextPos;
        const anchorCellRect = anchorCellDOM.getBoundingClientRect();
        const headCellRect = headCellDOM.getBoundingClientRect();
        const toolbarRect = toolbar.getBoundingClientRect();
        let top;
        if (headCellRect.top <= anchorCellRect.top) // Display Selection toolbar at the top of the selection
        top = headCellRect.top - toolbarRect.height - $68fa3b7808a54c2b$var$cellSelectionToolbarOffsetTop;
        else // Display Selection toolbar at the bottom of the selection
        top = headCellRect.bottom + $68fa3b7808a54c2b$var$cellSelectionToolbarOffsetTop;
        // scroll wrapper for full page, fall back to document body
        // Ignored via go/ees007
        // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
        // TODO: look into using getScrollGutterOptions()
        const scrollWrapper = editorView.dom.closest('.fabric-editor-popup-scroll-parent') || document.body;
        const wrapperBounds = scrollWrapper.getBoundingClientRect();
        // Place toolbar below selection if not sufficient space above
        if (top < wrapperBounds.top && headCellRect.top <= anchorCellRect.top) top = anchorCellRect.bottom + $68fa3b7808a54c2b$var$cellSelectionToolbarOffsetTop;
        let left;
        if (headCellRect.left < anchorCellRect.left) left = headCellRect.left;
        else if (headCellRect.left === anchorCellRect.left) left = headCellRect.left + headCellRect.width / 2;
        else left = headCellRect.right;
        // If a user selected multiple columns via clicking on a drag handle
        // (clicking first on the left column and then shift clicking on the right column),
        // the $headcell stays in place and $anchorcell changes position. If they clicked on the right column
        // and then shift clicked on the left, the $headCell will change while $anchor stays in place.
        // Where is no way to know if user was dragging to select the cells or clicking on the drag handle.
        // So if all cells in columns are selected, we will align the Text Formatting toolbar
        // relative to center of the selected area.
        if (selection.isColSelection()) {
            if (headCellRect.left < anchorCellRect.left) left = headCellRect.left + (anchorCellRect.right - headCellRect.left) / 2;
            else if (headCellRect.left === anchorCellRect.left) left;
            else left = anchorCellRect.left + (headCellRect.right - anchorCellRect.left) / 2;
            // When column is selected, adjust top position to ensure that the toolbar does not
            // touch column drag handle
            top = top - $68fa3b7808a54c2b$var$offsetTopOnColumnSelection;
        }
        let adjustedLeft = Math.max(0, left - toolbarRect.width / 2 - wrapperBounds.left);
        if (adjustedLeft + toolbarRect.width > wrapperBounds.width) adjustedLeft = Math.max(0, wrapperBounds.width - (toolbarRect.width + $68fa3b7808a54c2b$var$scrollbarWidth));
        // If the toolbar is to be placed at the bottom of the selection (it happens when
        // there is no sufficient space above) and the bottom of the selection is not in the view,
        // place the toolbar at the bottom of the visible part of selection
        if (selection.isColSelection() && top + toolbarRect.height > wrapperBounds.bottom) top = top - (top - wrapperBounds.bottom) - (toolbarRect.height + 2 * $68fa3b7808a54c2b$var$cellSelectionToolbarOffsetTop);
        return {
            top: top - wrapperBounds.top + scrollWrapper.scrollTop,
            left: adjustedLeft
        };
    };
module.exports["calculateToolbarPositionAboveSelection"] = $68fa3b7808a54c2b$export$5966a251e0deb6ac;
module.exports["calculateToolbarPositionTrackHead"] = $68fa3b7808a54c2b$export$4fdfbe77de19eec;
module.exports["calculateToolbarPositionOnCellSelection"] = $68fa3b7808a54c2b$export$2d9cc331fb808a87;

});

parcelRegister("2bi6l", function(module, exports) {
const $501c60a5b21a582b$export$947fc26275418e36 = (state, ids, option = {})=>{
    if (ids.length === 0) return [];
    const nodes = [];
    const localIdSet = new Set(ids);
    if (option.includeDocNode && localIdSet.has(state.doc.attrs?.localId)) nodes.push({
        node: state.doc,
        pos: 0
    });
    state.doc.descendants((node, pos)=>{
        if (localIdSet.has(node.attrs?.localId)) nodes.push({
            node: node,
            pos: pos
        });
        // stop traversing once we found all the nodes
        return localIdSet.size !== nodes.length;
    });
    return nodes;
};
module.exports["findNodePosByLocalIds"] = $501c60a5b21a582b$export$947fc26275418e36;

});

parcelRegister("kAKYF", function(module, exports) {
const $f205113631ecb9f1$export$d5cbd8b17958f08b = (nodeType)=>($pos)=>{
        let count = 0;
        // Loop through parent nodes from bottom to top
        for(let depth = $pos.depth; depth > 0; depth--){
            const node = $pos.node(depth);
            // Count the table nodes
            if (node.type === nodeType) count++;
        }
        return count;
    };
module.exports["getParentOfTypeCount"] = $f205113631ecb9f1$export$d5cbd8b17958f08b;

});

parcelRegister("20bG5", function(module, exports) {
const $7ad46bf3fbc01231$export$ae584b8f0be37f04 = (nodeType)=>($pos)=>{
        // Loop through parent nodes from top to bottom
        for(let depth = 1; depth <= $pos.depth; depth++){
            const node = $pos.node(depth);
            // Count the table nodes
            if (node.type === nodeType) return $pos.after(depth);
        }
    };
module.exports["getPositionAfterTopParentNodeOfType"] = $7ad46bf3fbc01231$export$ae584b8f0be37f04;

});

parcelRegister("aeAfU", function(module, exports) {

var $c6GJD = parcelRequire("c6GJD");


var $dh538 = parcelRequire("dh538");


var $g68Gk = parcelRequire("g68Gk");


var $7Rqpr = parcelRequire("7Rqpr");


var $8ihu7 = parcelRequire("8ihu7");

function $92366aa0166a9d31$var$expValInternal({ experimentName: experimentName, experimentParam: experimentParam, defaultValue: defaultValue, fireExperimentExposure: fireExperimentExposure }) {
    const experimentConfig = (0, $7Rqpr.editorExperimentsConfig)[experimentName];
    if (experimentConfig === undefined) // Warning! If a product is improperly configured (ie. their editor packages are misaligned)
    // it can cause the editor to crash here or if the experiment does not exist.
    // We will definitely crash via any code path later in this function - this just makes the error explicit and clear.
    throw new Error(`Editor experiment configuration is not defined ${experimentName}. Likely the experiment does not exist or editor package versions are misaligned`);
    // @ts-ignore need to loosen the type here to allow for any experiment name
    if ((0, $8ihu7._overrides)[experimentName] !== undefined) // This will be hit in the case of a test setting an override
    // @ts-ignore need to loosen the type here to allow for any experiment name
    return (0, $8ihu7._overrides)[experimentName];
    // Check for parameter overrides
    const paramOverride = (0, $8ihu7._paramOverrides)[experimentName]?.[experimentParam];
    if (paramOverride !== undefined) return paramOverride;
    // If client is not initialized, we return the default value
    if (!(0, $c6GJD.default).initializeCompleted()) return defaultValue;
    if (!(0, $8ihu7._product)) // This will be hit in the case of a product not having setup the editor experiment tooling
    return defaultValue;
    // Typescript is complaining here about accessing the productKeys property
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const experimentKey = experimentConfig?.productKeys?.[0, $8ihu7._product];
    if (!experimentKey) // This will be hit in the case of an experiment not being set up for the product
    return defaultValue;
    const resolvedExperimentKey = !(0, $7Rqpr.disallowsProductKeys).includes(experimentName) && (0, $dh538.fg)('platform_editor_experiments_use_product_keys') ? experimentKey : experimentName;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $c6GJD.default).getExperimentValue(resolvedExperimentKey, experimentParam, defaultValue, {
        fireExperimentExposure: fireExperimentExposure
    });
    if (// eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    (0, $c6GJD.default).getExperimentValue('cc_editor_experiments_ufo_gate_reporting_expval', 'isEnabled', false)) // Duplicated from /confluence/next/packages/feature-experiments/src/index.ts
    (0, $g68Gk.addFeatureFlagAccessed)(`${resolvedExperimentKey}:${experimentParam}`, experimentValue);
    return experimentValue;
}
function $92366aa0166a9d31$export$9db1624a8af791a4(experimentName, experimentParam, defaultValue) {
    return $92366aa0166a9d31$var$expValInternal({
        experimentName: experimentName,
        experimentParam: experimentParam,
        defaultValue: defaultValue,
        fireExperimentExposure: true
    });
} /**
 * Use to check a any param value for an experiment without firing an exposure event
 *
 * **Note**: this will return the default value when the experiment;
 * - is not being served to the client (ie. pre start)
 * - or is not configured in experiments-config
 *
 * @example
 * ```ts
 * const delay = expParamEqualsNoExposure('experiment-name', 'param-name', defaultValue)
 * await new Promise(res => setTimeout(res, delay)
 * ```
 */ 
function $92366aa0166a9d31$export$94f132839aec533f(experimentName, experimentParam, defaultValue) {
    return $92366aa0166a9d31$var$expValInternal({
        experimentName: experimentName,
        experimentParam: experimentParam,
        defaultValue: defaultValue,
        fireExperimentExposure: false
    });
}
module.exports["expVal"] = $92366aa0166a9d31$export$9db1624a8af791a4;
module.exports["expValNoExposure"] = $92366aa0166a9d31$export$94f132839aec533f;

});

parcelRegister("ei5Ah", function(module, exports) {
const $c93fbce734c57660$export$5762916b8b83bc6d = ($pos, parentNode)=>{
    if (!parentNode) return false;
    for(let i = $pos.depth + 1; i > 0; i--){
        const node = $pos.node(i);
        if (node && node.eq(parentNode)) break;
        if (i > 1 && $pos.after(i) !== $pos.after(i - 1) - 1) return false;
    }
    return true;
};
module.exports["isSelectionAtEndOfNode"] = $c93fbce734c57660$export$5762916b8b83bc6d;

});

parcelRegister("1ts3S", function(module, exports) {
const $9c5a01a0363e898b$export$2543715425b0bf0b = ($pos, parentNode)=>{
    if (!parentNode) return false;
    for(let i = $pos.depth + 1; i > 0; i--){
        const node = $pos.node(i);
        if (node && node.eq(parentNode)) break;
        if (i > 1 && $pos.before(i) !== $pos.before(i - 1) + 1) return false;
    }
    return true;
};
module.exports["isSelectionAtStartOfNode"] = $9c5a01a0363e898b$export$2543715425b0bf0b;

});

parcelRegister("7YjFd", function(module, exports) {

var $gxRcs = parcelRequire("gxRcs");


var $ik7A9 = parcelRequire("ik7A9");


function $72ae86d282e56916$export$ba5b1093dd832251(target, boundariesElement, fitHeight, alignY, forcePlacement, preventOverflow) {
    if (forcePlacement && alignY) return alignY;
    if (!fitHeight) return 'bottom';
    if ((0, $ik7A9.isTextNode)(target)) // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    target = target.parentElement;
    const boundariesClientRect = boundariesElement.getBoundingClientRect();
    const { height: boundariesHeight } = boundariesClientRect;
    const boundariesTop = (0, $gxRcs.isBody)(boundariesElement) ? 0 : boundariesClientRect.top;
    const { top: targetTop, height: targetHeight } = target.getBoundingClientRect();
    const spaceAbove = targetTop - (boundariesTop - boundariesElement.scrollTop);
    const spaceBelow = boundariesTop + boundariesHeight - (targetTop + targetHeight);
    // Force vertical placement to bottom if the space above doesn't accomodate the fitHeight
    if (preventOverflow) {
        if (spaceAbove <= fitHeight) return 'bottom';
    }
    if (spaceBelow >= fitHeight || spaceBelow >= spaceAbove) return 'bottom';
    return 'top';
}
function $72ae86d282e56916$export$af26c34d66be95d6(target, boundariesElement, fitWidth, alignX, forcePlacement, preventOverflow) {
    // force placement unless preventOverflow is enabled
    if (forcePlacement && alignX && !preventOverflow) return alignX;
    if (!fitWidth) return alignX || 'left';
    if ((0, $ik7A9.isTextNode)(target)) // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    target = target.parentElement;
    const { left: targetLeft, width: targetWidth } = target.getBoundingClientRect();
    const { left: boundariesLeft, width: boundariesWidth } = boundariesElement.getBoundingClientRect();
    const spaceLeft = targetLeft - boundariesLeft + targetWidth;
    const spaceRight = boundariesLeft + boundariesWidth - targetLeft;
    if (alignX && spaceLeft > fitWidth && spaceRight > fitWidth) return alignX;
    else if (spaceRight >= fitWidth || spaceRight >= spaceLeft && !alignX) return 'left';
    return 'right';
}
function $72ae86d282e56916$export$b81415a09b611cb(target, boundariesElement, fitWidth, fitHeight, alignX, alignY, forcePlacement, preventOverflow) {
    return [
        $72ae86d282e56916$export$ba5b1093dd832251(target, boundariesElement, fitHeight, alignY, forcePlacement, preventOverflow),
        $72ae86d282e56916$export$af26c34d66be95d6(target, boundariesElement, fitWidth, alignX, forcePlacement, preventOverflow)
    ];
}
const $72ae86d282e56916$var$calculateHorizontalPlacement = ({ placement: placement, targetLeft: targetLeft, targetRight: targetRight, targetWidth: targetWidth, isPopupParentBody: isPopupParentBody, popupOffsetParentLeft: popupOffsetParentLeft, popupOffsetParentRight: popupOffsetParentRight, popupOffsetParentScrollLeft: popupOffsetParentScrollLeft, popupOffsetParentClientWidth: popupOffsetParentClientWidth, popupClientWidth: popupClientWidth, offset: offset, allowOutOfBounds: allowOutOfBounds = false, minPopupMargin: minPopupMargin })=>{
    const position = {};
    if (placement === 'left') position.left = Math.ceil(targetLeft - popupOffsetParentLeft + (isPopupParentBody ? 0 : popupOffsetParentScrollLeft) + offset[0]);
    else if (placement === 'center') position.left = Math.ceil(targetLeft - popupOffsetParentLeft + (isPopupParentBody ? 0 : popupOffsetParentScrollLeft) + offset[0] + targetWidth / 2 - popupClientWidth / 2);
    else if (placement === 'end') {
        const left = Math.ceil(targetRight - popupOffsetParentLeft + (isPopupParentBody ? 0 : popupOffsetParentScrollLeft) + offset[0]);
        position.left = left;
    } else position.right = Math.ceil(popupOffsetParentRight - targetRight - (isPopupParentBody ? 0 : popupOffsetParentScrollLeft) + offset[0]);
    if (!allowOutOfBounds) {
        if (position.left !== undefined) position.left = $72ae86d282e56916$var$getPopupXInsideParent(position.left, popupClientWidth, popupOffsetParentClientWidth, minPopupMargin);
        if (position.right !== undefined) position.right = $72ae86d282e56916$var$getPopupXInsideParent(position.right, popupClientWidth, popupOffsetParentClientWidth, minPopupMargin);
    }
    return position;
};
const $72ae86d282e56916$var$getPopupXInsideParent = (x, popupClientWidth, popupOffsetParentClientWidth, minPopupMargin = 1)=>{
    // prevent going too far right
    if (popupOffsetParentClientWidth < x + popupClientWidth) x = popupOffsetParentClientWidth - popupClientWidth - minPopupMargin;
    // prevent going too far left
    return Math.max(minPopupMargin, x);
};
const $72ae86d282e56916$var$calculateVerticalStickBottom = ({ target: target, targetTop: targetTop, targetHeight: targetHeight, popup: popup, offset: offset, position: position, boundariesElement: boundariesElement, scrollableElement: scrollableElement })=>{
    const scrollParent = scrollableElement || $72ae86d282e56916$export$69742dd9a26edd3e(target) || boundariesElement;
    const newPos = {
        ...position
    };
    if (scrollParent) {
        const topOffsetTop = targetTop - scrollParent.getBoundingClientRect().top;
        const targetEnd = targetHeight + topOffsetTop;
        if (scrollParent.clientHeight - targetEnd <= popup.clientHeight + offset[1] * 2 && topOffsetTop < scrollParent.clientHeight) {
            const scroll = targetEnd - scrollParent.clientHeight + offset[1] * 2;
            let top = newPos.top || 0;
            top = top - (scroll + popup.clientHeight);
            newPos.top = top;
        }
    }
    return newPos;
};
const $72ae86d282e56916$var$calculateVerticalStickTop = ({ target: target, targetTop: targetTop, targetHeight: targetHeight, popupOffsetParentHeight: popupOffsetParentHeight, popupOffsetParent: popupOffsetParent, offset: offset, position: position, placement: placement, boundariesElement: boundariesElement, scrollableElement: scrollableElement })=>{
    const scrollParent = scrollableElement || $72ae86d282e56916$export$69742dd9a26edd3e(target) || boundariesElement;
    const newPos = {
        ...position
    };
    if (scrollParent) {
        const { top: scrollParentTop } = scrollParent.getBoundingClientRect();
        const topBoundary = targetTop - scrollParentTop;
        const scrollParentScrollTop = scrollParent.scrollTop;
        if (topBoundary < 0) {
            const isBelowNodeBoundary = targetTop + (scrollParentScrollTop - scrollParentTop) + targetHeight + offset[1] < scrollParentScrollTop;
            if (placement === 'top') {
                if (isBelowNodeBoundary) newPos.bottom = popupOffsetParentHeight - (topBoundary + popupOffsetParent.scrollTop + targetHeight);
                else newPos.bottom = topBoundary + (newPos.bottom || 0);
            }
            if (placement === 'start') {
                if (isBelowNodeBoundary) newPos.top = topBoundary + popupOffsetParent.scrollTop + targetHeight;
                else newPos.top = Math.abs(topBoundary) + (newPos.top || 0) + offset[1];
            }
        }
    }
    return newPos;
};
const $72ae86d282e56916$var$calculateVerticalPlacement = ({ placement: placement, targetTop: targetTop, targetHeight: targetHeight, isPopupParentBody: isPopupParentBody, popupOffsetParentHeight: popupOffsetParentHeight, popupOffsetParentTop: popupOffsetParentTop, popupOffsetParentScrollTop: popupOffsetParentScrollTop, borderBottomWidth: borderBottomWidth, offset: offset })=>{
    const position = {};
    if (placement === 'top') position.bottom = Math.ceil(popupOffsetParentHeight - (targetTop - popupOffsetParentTop) - (isPopupParentBody ? 0 : popupOffsetParentScrollTop) - borderBottomWidth + offset[1]);
    else if (placement === 'start') position.top = Math.ceil(targetTop - popupOffsetParentTop - offset[1] + (isPopupParentBody ? 0 : popupOffsetParentScrollTop));
    else {
        const top = Math.ceil(targetTop - popupOffsetParentTop + targetHeight + (isPopupParentBody ? 0 : popupOffsetParentScrollTop) - borderBottomWidth + offset[1]);
        position.top = top;
    }
    return position;
};
function $72ae86d282e56916$export$b3ceb0cbf1056d98({ placement: placement, target: target, popup: popup, offset: offset, stick: stick, allowOutOfBounds: allowOutOfBounds = false, rect: rect, boundariesElement: boundariesElement, minPopupMargin: minPopupMargin, scrollableElement: scrollableElement }) {
    let position = {};
    if (!target || !popup || !popup.offsetParent || !$72ae86d282e56916$var$isHTMLElementNode(popup.offsetParent)) return position;
    if ((0, $ik7A9.isTextNode)(target)) // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    target = target.parentElement;
    const popupOffsetParent = popup.offsetParent;
    const offsetParentStyle = popupOffsetParent.style;
    let borderBottomWidth = 0;
    if (offsetParentStyle && offsetParentStyle.borderBottomWidth) borderBottomWidth = parseInt(offsetParentStyle.borderBottomWidth, 10);
    const [verticalPlacement, horizontalPlacement] = placement;
    const { top: popupOffsetParentTop, left: popupOffsetParentLeft, right: popupOffsetParentRight, height: popupOffsetParentHeight } = rect ? rect : popupOffsetParent.getBoundingClientRect();
    // Calculate scrollbar dimensions to adjust positions
    // clientWidth/Height excludes scrollbars, offsetWidth/Height includes them
    const scrollbarWidth = popupOffsetParent.offsetWidth - popupOffsetParent.clientWidth;
    const scrollbarHeight = popupOffsetParent.offsetHeight - popupOffsetParent.clientHeight;
    const { top: targetTop, left: targetLeft, right: targetRight, height: targetHeight, width: targetWidth } = target.getBoundingClientRect();
    const isPopupParentBody = (0, $gxRcs.isBody)(popupOffsetParent);
    const verticalPosition = $72ae86d282e56916$var$calculateVerticalPlacement({
        placement: verticalPlacement,
        targetTop: targetTop,
        isPopupParentBody: isPopupParentBody,
        popupOffsetParentHeight: popupOffsetParentHeight - (isPopupParentBody ? 0 : scrollbarHeight),
        popupOffsetParentTop: popupOffsetParentTop,
        popupOffsetParentScrollTop: popupOffsetParent.scrollTop || 0,
        targetHeight: targetHeight,
        borderBottomWidth: borderBottomWidth,
        offset: offset
    });
    position = {
        ...position,
        ...verticalPosition
    };
    if ((verticalPlacement === 'top' || verticalPlacement === 'start') && stick) position = $72ae86d282e56916$var$calculateVerticalStickTop({
        target: target,
        targetTop: targetTop,
        targetHeight: targetHeight,
        popupOffsetParentHeight: popupOffsetParentHeight,
        popupOffsetParent: popupOffsetParent,
        popup: popup,
        offset: offset,
        position: position,
        placement: verticalPlacement,
        boundariesElement: boundariesElement,
        scrollableElement: scrollableElement
    });
    if (verticalPlacement !== 'top' && verticalPlacement !== 'start' && stick) position = $72ae86d282e56916$var$calculateVerticalStickBottom({
        target: target,
        targetTop: targetTop,
        targetHeight: targetHeight,
        popup: popup,
        offset: offset,
        position: position,
        boundariesElement: boundariesElement,
        scrollableElement: scrollableElement
    });
    const horizontalPosition = $72ae86d282e56916$var$calculateHorizontalPlacement({
        placement: horizontalPlacement,
        targetLeft: targetLeft,
        targetRight: targetRight,
        targetWidth: targetWidth,
        isPopupParentBody: isPopupParentBody,
        popupOffsetParentLeft: popupOffsetParentLeft,
        popupOffsetParentRight: popupOffsetParentRight - (isPopupParentBody ? 0 : scrollbarWidth),
        popupOffsetParentScrollLeft: popupOffsetParent.scrollLeft || 0,
        popupOffsetParentClientWidth: popup.offsetParent.clientWidth,
        popupClientWidth: popup.clientWidth || 0,
        offset: offset,
        allowOutOfBounds: allowOutOfBounds,
        minPopupMargin: minPopupMargin
    });
    position = {
        ...position,
        ...horizontalPosition
    };
    return position;
}
function $72ae86d282e56916$export$69742dd9a26edd3e(popup) {
    let parent = popup;
    if (!parent) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    while(parent = parent.parentElement){
        // IE11 on Window 8 doesn't show styles from CSS when accessing through element.style property.
        const style = window.getComputedStyle(parent);
        if (style.overflow === 'scroll' || style.overflowX === 'scroll' || style.overflowY === 'scroll' || parent.classList.contains('fabric-editor-popup-scroll-parent')) return parent;
    }
    return false;
}
// Helper function to check if the passed node is of Element class
function $72ae86d282e56916$var$isElementNode(node) {
    return node.nodeType === 1;
}
// Helper function to check if the passed node is of HTMLElement class
function $72ae86d282e56916$var$isHTMLElementNode(node) {
    return $72ae86d282e56916$var$isElementNode(node) && node.namespaceURI === 'http://www.w3.org/1999/xhtml';
}
module.exports["calculatePlacement"] = $72ae86d282e56916$export$b81415a09b611cb;
module.exports["findOverflowScrollParent"] = $72ae86d282e56916$export$69742dd9a26edd3e;
module.exports["calculatePosition"] = $72ae86d282e56916$export$b3ceb0cbf1056d98;

});

parcelRegister("btNLq", function(module, exports) {
// Transformation
const $0700c48fa4209742$export$a3c0fcb7531fdfae = {
    key: 'transform-menu-section'
};
const $0700c48fa4209742$export$3ca3ae97eef4f3f0 = {
    key: 'transform-menu-item'
};
const $0700c48fa4209742$export$34447db936e8c6fc = {
    key: 'transform-create-menu-section'
};
const $0700c48fa4209742$export$385a1c1d9736262f = {
    key: 'transform-headings-menu-secion'
};
const $0700c48fa4209742$export$80e640e763379a61 = {
    key: 'transform-headings-h1-menu-item'
};
const $0700c48fa4209742$export$d31447f17d5c40f8 = {
    key: 'transform-headings-heading-2-menu-item'
};
const $0700c48fa4209742$export$2d9132330244bad7 = {
    key: 'transform-headings-heading-3-menu-item'
};
const $0700c48fa4209742$export$b5bbd55812f553dd = {
    key: 'transform-headings-heading-4-menu-item'
};
const $0700c48fa4209742$export$33814ca575ac386 = {
    key: 'transform-headings-heading-5-menu-item'
};
const $0700c48fa4209742$export$a8ceacf53925c4c2 = {
    key: 'transform-headings-heading-6-menu-item'
};
const $0700c48fa4209742$export$bbc46da54e477efa = {
    key: 'transform-suggested-menu-section'
};
const $0700c48fa4209742$export$c2d6d85aaa7f89 = {
    key: 'transform-structure-menu-section'
};
const $0700c48fa4209742$export$d816a8e427c44cab = {
    key: 'transform-suggested-menu-item'
};
const $0700c48fa4209742$export$e99d73a096eba9d8 = {
    key: 'transform-structure-bulleted-list-menu-item'
};
const $0700c48fa4209742$export$4f5251553e2c0d3b = {
    key: 'transform-structure-task-list-menu-item'
};
const $0700c48fa4209742$export$320d169c65770531 = {
    key: 'transform-structure-numbered-list-menu-item'
};
const $0700c48fa4209742$export$5bbaff6e2e9a6ff0 = {
    key: 'transform-structure-code-block-menu-item'
};
const $0700c48fa4209742$export$3017e11a8c1f80da = {
    key: 'transform-structure-panel-menu-item'
};
const $0700c48fa4209742$export$6177b4b3a7cfe84a = {
    key: 'transform-structure-expand-menu-item'
};
const $0700c48fa4209742$export$63f059e253c26b26 = {
    key: 'transform-structure-layout-menu-item'
};
const $0700c48fa4209742$export$f2570dad43233f20 = {
    key: 'transform-structure-quote-menu-item'
};
const $0700c48fa4209742$export$6f504bddd3dd2224 = {
    key: 'transform-structure-decision-menu-item'
};
const $0700c48fa4209742$export$cc2e3e5d65e6f0d4 = {
    key: 'transform-structure-paragraph-menu-item'
};
const $0700c48fa4209742$export$a23188d593dca4ea = {
    key: 'transform-clear-menu-section'
};
const $0700c48fa4209742$export$745da57990b04239 = {
    key: 'transform-clear-menu-item'
};
const $0700c48fa4209742$export$a3f6bf14b5ca64b8 = {
    key: 'transform-default-extension-slot-menu-item'
};
const $0700c48fa4209742$export$c1df15c59989a309 = {
    key: 'block-actions-featured-extension-slot-menu-item'
};
const $0700c48fa4209742$export$3867fe0cfddbf139 = {
    key: 'block-actions-template-section'
};
const $0700c48fa4209742$export$6fea06990444f5d3 = [
    'block-actions-template-section'
];
const $0700c48fa4209742$export$ac3b29d06d42b0ea = {
    key: 'block-actions-menu-section'
};
const $0700c48fa4209742$export$cfe82275ae8140a2 = {
    key: 'block-actions-create-synced-block-menu-item'
};
const $0700c48fa4209742$export$b20c456de8129c0 = {
    key: 'block-actions-copy-link-to-block-menu-item'
};
const $0700c48fa4209742$export$483ea0be292b7dac = {
    key: 'block-actions-copy-menu-section'
};
const $0700c48fa4209742$export$770efbdcddf7d03b = {
    key: 'position-menu-section'
};
const $0700c48fa4209742$export$f74c131f207c4e6e = {
    key: 'position-move-up-menu-item'
};
const $0700c48fa4209742$export$849e72f364364410 = {
    key: 'position-move-down-menu-item'
};
const $0700c48fa4209742$export$ca2108a38e6280a5 = {
    key: 'delete-menu-section'
};
const $0700c48fa4209742$export$1bb697e1417f5dce = {
    key: 'delete-menu-item'
};
const $0700c48fa4209742$export$f826d1887c683892 = 'editor-block-menu';
const $0700c48fa4209742$export$58ecf5644244b209 = {
    MOVE_UP: 'block-menu-move-up',
    MOVE_DOWN: 'block-menu-move-down',
    DELETE: 'block-menu-delete',
    COPY_LINK: 'block-menu-copy-link'
};
const $0700c48fa4209742$export$9bac3cc6a7894e2 = 'extension-menu-item';
const $0700c48fa4209742$export$8ee5435f172be1d5 = {
    key: 'ai-menu-section'
};
const $0700c48fa4209742$export$e118f97623bf0ced = {
    key: 'block-menu-ai-ask-rovo-menu-item'
};
const $0700c48fa4209742$export$3c7acd6b38230e6c = {
    key: 'block-menu-ai-improve-writing-menu-item'
};
const $0700c48fa4209742$export$1aa04b5aeed1c667 = {
    key: 'block-menu-ai-polish-menu-item'
};
const $0700c48fa4209742$export$c5db784a4bf3dac3 = {
    key: 'block-menu-ai-remix-menu-item'
};
module.exports["TRANSFORM_MENU_SECTION"] = $0700c48fa4209742$export$a3c0fcb7531fdfae;
module.exports["TRANSFORM_MENU_ITEM"] = $0700c48fa4209742$export$3ca3ae97eef4f3f0;
module.exports["TRANSFORM_CREATE_MENU_SECTION"] = $0700c48fa4209742$export$34447db936e8c6fc;
module.exports["TRANSFORM_HEADINGS_MENU_SECTION"] = $0700c48fa4209742$export$385a1c1d9736262f;
module.exports["TRANSFORM_HEADINGS_H1_MENU_ITEM"] = $0700c48fa4209742$export$80e640e763379a61;
module.exports["TRANSFORM_HEADINGS_H2_MENU_ITEM"] = $0700c48fa4209742$export$d31447f17d5c40f8;
module.exports["TRANSFORM_HEADINGS_H3_MENU_ITEM"] = $0700c48fa4209742$export$2d9132330244bad7;
module.exports["TRANSFORM_HEADINGS_H4_MENU_ITEM"] = $0700c48fa4209742$export$b5bbd55812f553dd;
module.exports["TRANSFORM_HEADINGS_H5_MENU_ITEM"] = $0700c48fa4209742$export$33814ca575ac386;
module.exports["TRANSFORM_HEADINGS_H6_MENU_ITEM"] = $0700c48fa4209742$export$a8ceacf53925c4c2;
module.exports["TRANSFORM_SUGGESTED_MENU_SECTION"] = $0700c48fa4209742$export$bbc46da54e477efa;
module.exports["TRANSFORM_STRUCTURE_MENU_SECTION"] = $0700c48fa4209742$export$c2d6d85aaa7f89;
module.exports["TRANSFORM_SUGGESTED_MENU_ITEM"] = $0700c48fa4209742$export$d816a8e427c44cab;
module.exports["TRANSFORM_STRUCTURE_BULLETED_LIST_MENU_ITEM"] = $0700c48fa4209742$export$e99d73a096eba9d8;
module.exports["TRANSFORM_STRUCTURE_TASK_LIST_MENU_ITEM"] = $0700c48fa4209742$export$4f5251553e2c0d3b;
module.exports["TRANSFORM_STRUCTURE_NUMBERED_LIST_MENU_ITEM"] = $0700c48fa4209742$export$320d169c65770531;
module.exports["TRANSFORM_STRUCTURE_CODE_BLOCK_MENU_ITEM"] = $0700c48fa4209742$export$5bbaff6e2e9a6ff0;
module.exports["TRANSFORM_STRUCTURE_PANEL_MENU_ITEM"] = $0700c48fa4209742$export$3017e11a8c1f80da;
module.exports["TRANSFORM_STRUCTURE_EXPAND_MENU_ITEM"] = $0700c48fa4209742$export$6177b4b3a7cfe84a;
module.exports["TRANSFORM_STRUCTURE_LAYOUT_MENU_ITEM"] = $0700c48fa4209742$export$63f059e253c26b26;
module.exports["TRANSFORM_STRUCTURE_QUOTE_MENU_ITEM"] = $0700c48fa4209742$export$f2570dad43233f20;
module.exports["TRANSFORM_STRUCTURE_DECISION_MENU_ITEM"] = $0700c48fa4209742$export$6f504bddd3dd2224;
module.exports["TRANSFORM_STRUCTURE_PARAGRAPH_MENU_ITEM"] = $0700c48fa4209742$export$cc2e3e5d65e6f0d4;
module.exports["TRANSFORM_CLEAR_MENU_SECTION"] = $0700c48fa4209742$export$a23188d593dca4ea;
module.exports["TRANSFORM_CLEAR_MENU_ITEM"] = $0700c48fa4209742$export$745da57990b04239;
module.exports["TRANSFORM_DEFAULT_EXTENSION_SLOT_MENU_ITEM"] = $0700c48fa4209742$export$a3f6bf14b5ca64b8;
module.exports["BLOCK_ACTIONS_FEATURED_EXTENSION_SLOT_MENU_ITEM"] = $0700c48fa4209742$export$c1df15c59989a309;
module.exports["BLOCK_ACTIONS_TEMPLATE_SECTION"] = $0700c48fa4209742$export$3867fe0cfddbf139;
module.exports["BLOCK_ACTIONS_MENU_SECTION"] = $0700c48fa4209742$export$ac3b29d06d42b0ea;
module.exports["BLOCK_ACTIONS_CREATE_SYNCED_BLOCK_MENU_ITEM"] = $0700c48fa4209742$export$cfe82275ae8140a2;
module.exports["BLOCK_ACTIONS_COPY_LINK_TO_BLOCK_MENU_ITEM"] = $0700c48fa4209742$export$b20c456de8129c0;
module.exports["BLOCK_ACTIONS_COPY_MENU_SECTION"] = $0700c48fa4209742$export$483ea0be292b7dac;
module.exports["POSITION_MENU_SECTION"] = $0700c48fa4209742$export$770efbdcddf7d03b;
module.exports["POSITION_MOVE_UP_MENU_ITEM"] = $0700c48fa4209742$export$f74c131f207c4e6e;
module.exports["POSITION_MOVE_DOWN_MENU_ITEM"] = $0700c48fa4209742$export$849e72f364364410;
module.exports["DELETE_MENU_SECTION"] = $0700c48fa4209742$export$ca2108a38e6280a5;
module.exports["DELETE_MENU_ITEM"] = $0700c48fa4209742$export$1bb697e1417f5dce;
module.exports["BLOCK_MENU_TEST_ID"] = $0700c48fa4209742$export$f826d1887c683892;
module.exports["BLOCK_MENU_ACTION_TEST_ID"] = $0700c48fa4209742$export$58ecf5644244b209;
module.exports["EXTENSION_MENU_ITEM_TEST_ID"] = $0700c48fa4209742$export$9bac3cc6a7894e2;
module.exports["AI_MENU_SECTION"] = $0700c48fa4209742$export$8ee5435f172be1d5;
module.exports["AI_ASK_ROVO_MENU_ITEM"] = $0700c48fa4209742$export$e118f97623bf0ced;
module.exports["AI_IMPROVE_WRITING_MENU_ITEM"] = $0700c48fa4209742$export$3c7acd6b38230e6c;
module.exports["AI_POLISH_MENU_ITEM"] = $0700c48fa4209742$export$1aa04b5aeed1c667;
module.exports["AI_REMIX_MENU_ITEM"] = $0700c48fa4209742$export$c5db784a4bf3dac3;

});

parcelRegister("gEb6G", function(module, exports) {

var $btNLq = parcelRequire("btNLq");

const $003b093c54581a3c$export$1fa59ca2cd42fda1 = {
    [(0, $btNLq.AI_MENU_SECTION).key]: 100,
    [(0, $btNLq.TRANSFORM_MENU_SECTION).key]: 200,
    [(0, $btNLq.BLOCK_ACTIONS_TEMPLATE_SECTION).key]: 250,
    [(0, $btNLq.BLOCK_ACTIONS_MENU_SECTION).key]: 300,
    [(0, $btNLq.BLOCK_ACTIONS_COPY_MENU_SECTION).key]: 350,
    [(0, $btNLq.POSITION_MENU_SECTION).key]: 400,
    [(0, $btNLq.DELETE_MENU_SECTION).key]: 500
};
const $003b093c54581a3c$export$f6e766e0dc1b4cae = {
    [(0, $btNLq.AI_ASK_ROVO_MENU_ITEM).key]: 100
};
const $003b093c54581a3c$export$9e41545bda08797e = {
    [(0, $btNLq.TRANSFORM_MENU_ITEM).key]: 100,
    [(0, $btNLq.BLOCK_ACTIONS_CREATE_SYNCED_BLOCK_MENU_ITEM).key]: 200,
    [(0, $btNLq.BLOCK_ACTIONS_FEATURED_EXTENSION_SLOT_MENU_ITEM).key]: 300
};
const $003b093c54581a3c$export$d0040892fb8e31d3 = {
    [(0, $btNLq.BLOCK_ACTIONS_FEATURED_EXTENSION_SLOT_MENU_ITEM).key]: 100
};
const $003b093c54581a3c$export$b3f35fbdee992328 = {
    [(0, $btNLq.TRANSFORM_SUGGESTED_MENU_ITEM).key]: 100
};
const $003b093c54581a3c$export$fb745cd9e8ece9b3 = {
    [(0, $btNLq.TRANSFORM_SUGGESTED_MENU_SECTION).key]: 100,
    [(0, $btNLq.TRANSFORM_CREATE_MENU_SECTION).key]: 200,
    [(0, $btNLq.TRANSFORM_STRUCTURE_MENU_SECTION).key]: 300,
    [(0, $btNLq.TRANSFORM_HEADINGS_MENU_SECTION).key]: 400,
    [(0, $btNLq.TRANSFORM_CLEAR_MENU_SECTION).key]: 500
};
const $003b093c54581a3c$export$8a17e62e7bf2e23a = {
    [(0, $btNLq.TRANSFORM_DEFAULT_EXTENSION_SLOT_MENU_ITEM).key]: 1000
};
const $003b093c54581a3c$export$41ce132dcee74abf = {
    [(0, $btNLq.TRANSFORM_HEADINGS_H1_MENU_ITEM).key]: 100,
    [(0, $btNLq.TRANSFORM_HEADINGS_H2_MENU_ITEM).key]: 200,
    [(0, $btNLq.TRANSFORM_HEADINGS_H3_MENU_ITEM).key]: 300,
    [(0, $btNLq.TRANSFORM_HEADINGS_H4_MENU_ITEM).key]: 400,
    [(0, $btNLq.TRANSFORM_HEADINGS_H5_MENU_ITEM).key]: 500,
    [(0, $btNLq.TRANSFORM_HEADINGS_H6_MENU_ITEM).key]: 600
};
const $003b093c54581a3c$export$575896636002a88 = {
    [(0, $btNLq.TRANSFORM_STRUCTURE_BULLETED_LIST_MENU_ITEM).key]: 100,
    [(0, $btNLq.TRANSFORM_STRUCTURE_TASK_LIST_MENU_ITEM).key]: 200,
    [(0, $btNLq.TRANSFORM_STRUCTURE_NUMBERED_LIST_MENU_ITEM).key]: 300,
    [(0, $btNLq.TRANSFORM_STRUCTURE_CODE_BLOCK_MENU_ITEM).key]: 400,
    [(0, $btNLq.TRANSFORM_STRUCTURE_PANEL_MENU_ITEM).key]: 500,
    [(0, $btNLq.TRANSFORM_STRUCTURE_EXPAND_MENU_ITEM).key]: 600,
    [(0, $btNLq.TRANSFORM_STRUCTURE_LAYOUT_MENU_ITEM).key]: 700,
    [(0, $btNLq.TRANSFORM_STRUCTURE_QUOTE_MENU_ITEM).key]: 800,
    [(0, $btNLq.TRANSFORM_STRUCTURE_DECISION_MENU_ITEM).key]: 900,
    [(0, $btNLq.TRANSFORM_STRUCTURE_PARAGRAPH_MENU_ITEM).key]: 1000
};
const $003b093c54581a3c$export$a36e8b8d5a6bf549 = {
    [(0, $btNLq.TRANSFORM_CLEAR_MENU_ITEM).key]: 100
};
const $003b093c54581a3c$export$ad596cf0c7684e08 = {
    [(0, $btNLq.BLOCK_ACTIONS_CREATE_SYNCED_BLOCK_MENU_ITEM).key]: 100,
    [(0, $btNLq.BLOCK_ACTIONS_FEATURED_EXTENSION_SLOT_MENU_ITEM).key]: 200,
    [(0, $btNLq.BLOCK_ACTIONS_COPY_LINK_TO_BLOCK_MENU_ITEM).key]: 300
};
const $003b093c54581a3c$export$15097da746e4c9f2 = {
    [(0, $btNLq.BLOCK_ACTIONS_COPY_LINK_TO_BLOCK_MENU_ITEM).key]: 100
};
const $003b093c54581a3c$export$5d8a5a6209dd67c3 = {
    [(0, $btNLq.POSITION_MOVE_UP_MENU_ITEM).key]: 100,
    [(0, $btNLq.POSITION_MOVE_DOWN_MENU_ITEM).key]: 200
};
const $003b093c54581a3c$export$c635062ff5e2cdef = {
    [(0, $btNLq.DELETE_MENU_ITEM).key]: 100
};
module.exports["MAIN_BLOCK_MENU_SECTION_RANK"] = $003b093c54581a3c$export$1fa59ca2cd42fda1;
module.exports["AI_MENU_SECTION_RANK"] = $003b093c54581a3c$export$f6e766e0dc1b4cae;
module.exports["TRANSFORM_MENU_SECTION_RANK"] = $003b093c54581a3c$export$9e41545bda08797e;
module.exports["BLOCK_ACTIONS_FEATURED_EXTENSION_ITEM_RANK"] = $003b093c54581a3c$export$d0040892fb8e31d3;
module.exports["TRANSFORM_SUGGESTED_MENU_SECTION_RANK"] = $003b093c54581a3c$export$b3f35fbdee992328;
module.exports["TRANSFORM_MENU_ITEM_RANK"] = $003b093c54581a3c$export$fb745cd9e8ece9b3;
module.exports["TRANSFORM_CREATE_MENU_SECTION_RANK"] = $003b093c54581a3c$export$8a17e62e7bf2e23a;
module.exports["TRANSFORM_HEADINGS_MENU_SECTION_RANK"] = $003b093c54581a3c$export$41ce132dcee74abf;
module.exports["TRANSFORM_STRUCTURE_MENU_SECTION_RANK"] = $003b093c54581a3c$export$575896636002a88;
module.exports["BLOCK_ACTIONS_COPY_MENU_SECTION_RANK"] = $003b093c54581a3c$export$15097da746e4c9f2;
module.exports["POSITION_MENU_SECTION_RANK"] = $003b093c54581a3c$export$5d8a5a6209dd67c3;
module.exports["DELETE_MENU_SECTION_RANK"] = $003b093c54581a3c$export$c635062ff5e2cdef;

});

parcelRegister("fi7Vj", function(module, exports) {

var $jRrsu = parcelRequire("jRrsu");

var $eK2Ov = parcelRequire("eK2Ov");

var $bSuKu = parcelRequire("bSuKu");


var $60bKU = parcelRequire("60bKU");


var $astHL = parcelRequire("astHL");


var $ke2AI = parcelRequire("ke2AI");


var $ks2lK = parcelRequire("ks2lK");

const $36e73f8e769b8277$export$54fdd3c2782161ea = new (0, $ks2lK.PluginKey)('scrollGutter');
const $36e73f8e769b8277$export$a237783470abe542 = (state)=>{
    if (state) return $36e73f8e769b8277$export$54fdd3c2782161ea.getState(state);
};


const $d1751fed1c95125c$export$b8c3ea160300668d = (keyboardHeight)=>(state, dispatch)=>{
        const { tr: tr } = state;
        tr.setMeta((0, $36e73f8e769b8277$export$54fdd3c2782161ea), {
            keyboardHeight: keyboardHeight
        });
        if (dispatch) dispatch(tr);
        return true;
    };



var $d7ZU3 = parcelRequire("d7ZU3");


var $1S4f7 = parcelRequire("1S4f7");




function $5b91204662c41c7e$var$getCurrentBrowserAndVersion(browserEnv) {
    switch(true){
        case browserEnv.chrome === true:
            return {
                browser: 'chrome',
                version: browserEnv.chrome_version
            };
        case browserEnv.ie === true:
            return {
                browser: 'ie',
                version: browserEnv.ie_version
            };
        case browserEnv.gecko === true:
            return {
                browser: 'gecko',
                version: browserEnv.gecko_version
            };
        case browserEnv.safari === true:
            return {
                browser: 'safari',
                version: browserEnv.safari_version
            };
    }
    return undefined;
}
var $5b91204662c41c7e$export$2e2bcd8739ae039 = (featureFlags)=>new (0, $1S4f7.SafePlugin)({
        key: new (0, $ks2lK.PluginKey)('disableSpellchecking'),
        props: {
            attributes: (editorState)=>{
                if (!featureFlags) return {};
                const browserConfigFeatureFlag = featureFlags.disableSpellcheckByBrowser;
                const browserEnv = (0, $d7ZU3.getBrowserInfo)();
                const userCurrentBrowserAndVersion = $5b91204662c41c7e$var$getCurrentBrowserAndVersion(browserEnv);
                if (!userCurrentBrowserAndVersion || !browserConfigFeatureFlag) return {};
                const browserVersionDisableRange = // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                browserConfigFeatureFlag[userCurrentBrowserAndVersion.browser];
                if (!browserVersionDisableRange || !browserEnv[userCurrentBrowserAndVersion.browser]) return {};
                const shouldDisableSpellcheck = !!browserVersionDisableRange.maximum ? userCurrentBrowserAndVersion.version >= browserVersionDisableRange.minimum && userCurrentBrowserAndVersion.version <= browserVersionDisableRange.maximum : browserEnv[userCurrentBrowserAndVersion.browser] && userCurrentBrowserAndVersion.version >= browserVersionDisableRange.minimum;
                if (shouldDisableSpellcheck) return {
                    spellcheck: 'false'
                };
                return {};
            }
        }
    });



var $d925B = parcelRequire("d925B");

var $4VpM8 = parcelRequire("4VpM8");




const $435bf10412a4bca8$var$hasInvalidSteps = (tr)=>(tr.steps || []).some((step)=>step.from > step.to);
var $435bf10412a4bca8$export$2e2bcd8739ae039 = (dispatchAnalyticsEvent)=>{
    return new (0, $1S4f7.SafePlugin)({
        filterTransaction (transaction) {
            if ($435bf10412a4bca8$var$hasInvalidSteps(transaction)) {
                // eslint-disable-next-line no-console
                console.warn('The transaction was blocked because it contains invalid steps', transaction.steps);
                dispatchAnalyticsEvent({
                    action: (0, $d925B.ACTION).DISCARDED_INVALID_STEPS_FROM_TRANSACTION,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
                    attributes: {
                        analyticsEventPayloads: (0, $4VpM8.getAnalyticsEventsFromTransaction)(transaction)
                    },
                    eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
                });
                return false;
            }
            return true;
        }
    });
};





var $e2wMq = parcelRequire("e2wMq");


var $dFD5l = parcelRequire("dFD5l");


var $aAn37 = parcelRequire("aAn37");





var $lWghV = parcelRequire("lWghV");




/** Allows the possibility of overriding interaction type values in unit tests via jest.mock or spyOn. */ const $2d2b68f5b89c09ee$export$324d9bc8f4935d84 = (value)=>value;





/**
 * Calculate the difference between performance.now() and the given startTime.
 * This allows for the timing to be overridable during tests.
 *
 * @param startTime DOMHighResTimeStamp
 * @returns DOMHighResTimeStamp
 */ const $988a50e526ea117e$export$a26b90db2c8f1b97 = (startTime)=>performance.now() - startTime;


class $79a9709deb10971b$export$2e2bcd8739ae039 {
    start() {
        const currentStart = performance.now();
        if (this.samples.length + 1 === this.samplingRate) this.onSampleStart?.();
        const end = ()=>{
            if (currentStart === null) return;
            let isSlow = false;
            const time = (0, $988a50e526ea117e$export$a26b90db2c8f1b97)(currentStart);
            this.push(time);
            if (time > this.slowThreshold) {
                this.onSlowInput?.(time);
                isSlow = true;
            }
            if (this.samples.length === this.samplingRate) {
                this.flush();
                this.onSampleEnd?.(time, {
                    isSlow: isSlow,
                    severity: this.severity(time)
                });
            }
        };
        return end;
    }
    flush() {
        if (this.samples.length === 0) return;
        this.dispatch();
        this.samples = [];
        this.total = 0;
    }
    dispatch() {
        this.dispatchSample?.(this.getLast(), this.severity(this.getLast()));
        // cache
        const median = this.getMedian();
        this.dispatchAverage?.({
            mean: this.getMean(),
            median: median,
            sampleSize: this.samples.length
        }, this.severity(median));
    }
    push(latency) {
        this.samples.push(latency);
        this.total += latency;
    }
    severity(time) {
        return (0, $lWghV.getAnalyticsEventSeverity)(time, this.normalThreshold, this.degradedThreshold);
    }
    getLast() {
        return this.samples[this.samples.length - 1];
    }
    getMean() {
        return this.total / this.samples.length;
    }
    getMedian() {
        if (this.samples.length === 1) return this.samples[0];
        this.samples.sort((a, b)=>a - b);
        const middle = (this.samples.length + 1) / 2;
        const floorMiddle = Math.floor(middle);
        const remainder = middle % floorMiddle;
        if (remainder === 0) return this.samples[middle - 1];
        const left = this.samples[floorMiddle - 1];
        const right = this.samples[floorMiddle];
        return (left + right) / 2;
    }
    constructor({ samplingRate: samplingRate, slowThreshold: slowThreshold, normalThreshold: normalThreshold, degradedThreshold: degradedThreshold, dispatchAverage: dispatchAverage, dispatchSample: dispatchSample, onSampleStart: onSampleStart, onSampleEnd: onSampleEnd, onSlowInput: onSlowInput }){
        this.samples = [];
        this.total = 0;
        this.samplingRate = void 0;
        this.slowThreshold = void 0;
        this.normalThreshold = void 0;
        this.degradedThreshold = void 0;
        this.dispatchAverage = void 0;
        this.dispatchSample = void 0;
        this.onSampleStart = void 0;
        this.onSampleEnd = void 0;
        this.onSlowInput = void 0;
        this.samplingRate = samplingRate;
        this.slowThreshold = slowThreshold;
        this.normalThreshold = normalThreshold;
        this.degradedThreshold = degradedThreshold;
        this.dispatchAverage = dispatchAverage;
        this.dispatchSample = dispatchSample;
        this.onSampleStart = onSampleStart;
        this.onSampleEnd = onSampleEnd;
        this.onSlowInput = onSlowInput;
    }
}


const $b00d2499ea4ffe69$export$70246689264eff75 = new (0, $ks2lK.PluginKey)('frozenEditor');
const $b00d2499ea4ffe69$var$DEFAULT_KEYSTROKE_SAMPLING_LIMIT = 100;
const $b00d2499ea4ffe69$var$DEFAULT_SLOW_THRESHOLD = 300;
const $b00d2499ea4ffe69$export$c8d5b833abcf8e80 = 600;
const $b00d2499ea4ffe69$export$47b2879ca9bbf67a = 2000;
const $b00d2499ea4ffe69$export$1b622068be977101 = 3000;
const $b00d2499ea4ffe69$var$DEFAULT_TRACK_SEVERITY_ENABLED = false;
const $b00d2499ea4ffe69$export$5705ac5f923a65e7 = 100;
const $b00d2499ea4ffe69$export$1c6feb3429832c55 = 500;
const $b00d2499ea4ffe69$var$dispatchLongTaskEvent = (contextIdentifierPlugin)=>(dispatchAnalyticsEvent, view, time, getNodeCount, interactionType, severity)=>{
        const { state: state } = view;
        const nodesCount = getNodeCount(state);
        return dispatchAnalyticsEvent({
            action: (0, $d925B.ACTION).BROWSER_FREEZE,
            actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
            attributes: {
                objectId: contextIdentifierPlugin?.sharedState.currentState()?.contextIdentifierProvider?.objectId,
                freezeTime: time,
                nodeSize: state.doc.nodeSize,
                ...nodesCount,
                interactionType: interactionType,
                severity: severity
            },
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
        });
    };
var $b00d2499ea4ffe69$export$2e2bcd8739ae039 = (contextIdentifierPlugin)=>(dispatchAnalyticsEvent, inputTracking, browserFreezeTracking)=>{
        let interactionType;
        let inputLatencyTracker = null;
        if (browserFreezeTracking?.trackInteractionType) interactionType = (0, $2d2b68f5b89c09ee$export$324d9bc8f4935d84)((0, $e2wMq.BROWSER_FREEZE_INTERACTION_TYPE).LOADING);
        const samplingRate = inputTracking && typeof inputTracking.samplingRate === 'number' ? inputTracking.samplingRate : $b00d2499ea4ffe69$var$DEFAULT_KEYSTROKE_SAMPLING_LIMIT;
        // TODO: ED-26959 - get right values here based on appearance
        const slowThreshold = $b00d2499ea4ffe69$var$DEFAULT_SLOW_THRESHOLD;
        // TODO: ED-26959 - get right values here based on appearance
        const freezeThreshold = $b00d2499ea4ffe69$export$c8d5b833abcf8e80;
        const allowCountNodes = inputTracking && inputTracking.countNodes;
        let prevNodeCountState = null;
        let prevNodeCount = {};
        // Cache the result as we were calling this multiple times
        // and has potential to be expensive
        const getNodeCount = (state)=>{
            if (state === prevNodeCountState) return prevNodeCount;
            prevNodeCount = allowCountNodes ? (0, $dFD5l.countNodes)(state) : {};
            prevNodeCountState = state;
            return prevNodeCount;
        };
        const shouldTrackSeverity = inputTracking?.trackSeverity || $b00d2499ea4ffe69$var$DEFAULT_TRACK_SEVERITY_ENABLED;
        const severityThresholdNormal = inputTracking?.severityNormalThreshold || $b00d2499ea4ffe69$export$5705ac5f923a65e7;
        const severityThresholdDegraded = inputTracking?.severityDegradedThreshold || $b00d2499ea4ffe69$export$1c6feb3429832c55;
        const createDispatchSample = (action, view)=>(time, severity)=>{
                const { state: state } = view;
                const nodesCount = getNodeCount(state);
                const samplePayload = {
                    action: action,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
                    attributes: {
                        time: time,
                        nodeSize: state.doc.nodeSize,
                        ...nodesCount,
                        objectId: contextIdentifierPlugin?.sharedState.currentState()?.contextIdentifierProvider?.objectId,
                        severity: shouldTrackSeverity ? severity : undefined
                    },
                    eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
                };
                dispatchAnalyticsEvent(samplePayload);
            };
        const createDispatchAverage = (action, view)=>({ mean: mean, median: median, sampleSize: sampleSize }, severity)=>{
                const { state: state } = view;
                const nodeCount = getNodeCount(state);
                const averagePayload = {
                    action: action,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
                    attributes: {
                        mean: mean,
                        median: median,
                        sampleSize: sampleSize,
                        ...nodeCount,
                        nodeSize: state.doc.nodeSize,
                        severity: shouldTrackSeverity ? severity : undefined,
                        objectId: contextIdentifierPlugin?.sharedState.currentState()?.contextIdentifierProvider?.objectId
                    },
                    eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
                };
                dispatchAnalyticsEvent(averagePayload);
            };
        return new (0, $1S4f7.SafePlugin)({
            key: $b00d2499ea4ffe69$export$70246689264eff75,
            props: (0, $aAn37.isPerformanceAPIAvailable)() ? {
                handleTextInput (view) {
                    if (browserFreezeTracking?.trackInteractionType) interactionType = (0, $e2wMq.BROWSER_FREEZE_INTERACTION_TYPE).TYPING;
                    if (inputLatencyTracker) {
                        const end = inputLatencyTracker.start();
                        // This is called after all handleTextInput events are executed which means first handleTextInput time incorporates following handleTextInput processing time
                        // Also this is called before browser rendering so it doesn't count it.
                        requestAnimationFrame(end);
                    }
                    return false;
                },
                handleDOMEvents: browserFreezeTracking?.trackInteractionType ? {
                    click: ()=>{
                        interactionType = (0, $2d2b68f5b89c09ee$export$324d9bc8f4935d84)((0, $e2wMq.BROWSER_FREEZE_INTERACTION_TYPE).CLICKING);
                        return false;
                    },
                    paste: ()=>{
                        interactionType = (0, $2d2b68f5b89c09ee$export$324d9bc8f4935d84)((0, $e2wMq.BROWSER_FREEZE_INTERACTION_TYPE).PASTING);
                        return false;
                    }
                } : undefined
            } : undefined,
            view (view) {
                if (!(0, $aAn37.isPerformanceObserverAvailable)()) return {};
                inputLatencyTracker = new (0, $79a9709deb10971b$export$2e2bcd8739ae039)({
                    samplingRate: samplingRate,
                    slowThreshold: slowThreshold,
                    normalThreshold: severityThresholdNormal,
                    degradedThreshold: severityThresholdDegraded,
                    dispatchSample: createDispatchSample((0, $d925B.ACTION).INPUT_PERF_SAMPLING, view),
                    dispatchAverage: createDispatchAverage((0, $d925B.ACTION).INPUT_PERF_SAMPLING_AVG, view),
                    onSlowInput: (time)=>{
                        const { state: state } = view;
                        const nodesCount = getNodeCount(state);
                        dispatchAnalyticsEvent({
                            action: (0, $d925B.ACTION).SLOW_INPUT,
                            actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
                            attributes: {
                                time: time,
                                nodeSize: state.doc.nodeSize,
                                ...nodesCount,
                                objectId: contextIdentifierPlugin?.sharedState.currentState()?.contextIdentifierProvider?.objectId
                            },
                            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
                        });
                    }
                });
                let observer;
                try {
                    observer = new PerformanceObserver((list)=>{
                        const perfEntries = list.getEntries();
                        for(let i = 0; i < perfEntries.length; i++){
                            const { duration: duration } = perfEntries[i];
                            if (duration > freezeThreshold) $b00d2499ea4ffe69$var$dispatchLongTaskEvent(contextIdentifierPlugin)(dispatchAnalyticsEvent, view, duration, getNodeCount, browserFreezeTracking?.trackInteractionType ? interactionType : undefined, (0, $lWghV.getAnalyticsEventSeverity)(duration, // Ignored via go/ees007
                            // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
                            //TODO: get right values here
                            severityThresholdNormal, severityThresholdDegraded));
                        }
                    });
                    // register observer for long task notifications
                    observer.observe({
                        entryTypes: [
                            'longtask'
                        ]
                    });
                } catch (e) {}
                return {
                    destroy: ()=>{
                        inputLatencyTracker?.flush();
                        observer?.disconnect();
                    }
                };
            }
        });
    };









var $1XMEN = parcelRequire("1XMEN");


var $TfRUG = parcelRequire("TfRUG");





var $ftzrq = parcelRequire("ftzrq");

const $67462b32d888ce63$export$8836bfc6be4cb708 = new (0, $ks2lK.PluginKey)('inlineCursorTargetPlugin');
const $67462b32d888ce63$var$isInlineNodeView = (node)=>{
    /**
   * If inlineNodeView is a hardbreak we don't want to add decorations
   * as it breaks soft line breaks for Japanese/Chinese keyboards.
   */ const isHardBreak = node?.type === node?.type.schema.nodes.hardBreak;
    return node && node.type.isInline && !node.type.isText && !isHardBreak;
};
var $67462b32d888ce63$export$2e2bcd8739ae039 = ()=>{
    return new (0, $1S4f7.SafePlugin)({
        key: $67462b32d888ce63$export$8836bfc6be4cb708,
        state: {
            init: ()=>({
                    cursorTarget: undefined
                }),
            apply (tr) {
                const { selection: selection, doc: doc } = tr;
                const { $from: $from, $to: $to } = selection;
                // In Safari, if the cursor target is to the right of the cursor it will block selections
                // made with shift + arrowRight and vice versa for shift + arrowLeft. This is due to a
                // contenteditable bug in safari, where editable elements block the selection but we need
                // the cursor target to be editable for the following:
                // - Ability to navigate with down/up arrows when between inline nodes
                // - Ability to navigate with down/up arrows when between the start of a paragraph & an inline node
                // - Ability to click and drag to select an inline node if it is the first node
                // To prevent blocking the selection, we check handleDOMEvents and add meta to
                // the transaction to prevent the plugin from making cursor target decorations.
                const safariShiftSelection = tr.getMeta($67462b32d888ce63$export$8836bfc6be4cb708);
                if (selection && (0, $1XMEN.isTextSelection)(selection) && !safariShiftSelection) {
                    const hasInlineNodeViewAfter = $67462b32d888ce63$var$isInlineNodeView($from.nodeAfter);
                    const hasInlineNodeViewBefore = $67462b32d888ce63$var$isInlineNodeView($from.nodeBefore);
                    const isAtStartAndInlineNodeViewAfter = $from.parentOffset === 0 && $67462b32d888ce63$var$isInlineNodeView($from.nodeAfter);
                    const isAtEndAndInlineNodeViewBefore = doc.resolve($from.pos).node().lastChild === $from.nodeBefore && $67462b32d888ce63$var$isInlineNodeView($from.nodeBefore);
                    const createWidget = (side)=>{
                        const node = document.createElement('span');
                        node.contentEditable = 'true';
                        node.setAttribute('aria-hidden', 'true');
                        node.appendChild(document.createTextNode((0, $TfRUG.ZERO_WIDTH_SPACE)));
                        node.className = 'cursor-target';
                        const { $from: $from } = selection;
                        const rightPosition = $from.pos;
                        const leftPosition = $from.posAtIndex(Math.max($from.index() - 1, 0));
                        const widgetPos = side === 'left' ? leftPosition : rightPosition;
                        return (0, $ftzrq.Decoration).widget(widgetPos, node, {
                            raw: true,
                            key: 'inlineCursor'
                        });
                    };
                    // Create editable decoration widgets around the current inline node to allow proper cursor navigation.
                    if ((hasInlineNodeViewAfter || isAtEndAndInlineNodeViewBefore) && (hasInlineNodeViewBefore || isAtStartAndInlineNodeViewAfter)) return {
                        cursorTarget: {
                            decorations: [
                                createWidget('left'),
                                createWidget('right')
                            ],
                            positions: {
                                from: $from.pos,
                                to: $to.pos
                            }
                        }
                    };
                }
                return {
                    cursorTarget: undefined
                };
            }
        },
        props: {
            decorations (state) {
                const { doc: doc } = state;
                const { cursorTarget: cursorTarget } = $67462b32d888ce63$export$8836bfc6be4cb708.getState(state);
                if ($67462b32d888ce63$var$cursorTargetHasValidDecorations(cursorTarget)) return (0, $ftzrq.DecorationSet).create(doc, cursorTarget.decorations);
                return null;
            },
            handleDOMEvents: {
                // Workaround to prevent the decorations created by the plugin from
                // blocking shift + arrow left/right selections in safari. When
                // a shift + arrow left/right event is detected, send meta data to the
                // plugin to prevent it from creating decorations.
                // TODO: ED-26959 - We may be able to remove this when playing the following ticket:
                // https://product-fabric.atlassian.net/browse/ED-14938
                keydown: (view, event)=>{
                    const browser = (0, $d7ZU3.getBrowserInfo)();
                    if (browser.safari && event instanceof KeyboardEvent && event.shiftKey && (event.key === 'ArrowLeft' || event.key === 'ArrowRight')) view.dispatch(view.state.tr.setMeta($67462b32d888ce63$export$8836bfc6be4cb708, {
                        cursorTarget: undefined
                    }));
                    return false;
                },
                // Check the DOM to see if there are inline cursor targets
                // after a composition event ends. If so, manually insert the
                // event data in order to prevent contents ending up inside
                // of the cursor target decorations.
                compositionend: (view, incorrectlyTypedEvent)=>{
                    // This is typed by the prosemirror definitions as Event,
                    // this type is incorrect, and it is actually an InputEvent
                    const event = incorrectlyTypedEvent;
                    const { state: state } = view;
                    const { cursorTarget: cursorTarget } = $67462b32d888ce63$export$8836bfc6be4cb708.getState(state);
                    if (cursorTarget !== undefined) {
                        $67462b32d888ce63$var$handleTextInputInsideCursorTargetDecoration({
                            event: event,
                            cursorTarget: cursorTarget,
                            view: view
                        });
                        return true;
                    }
                    return false;
                },
                // Check the DOM to see if there are inline cursor targets
                // before any input event. If so, manually insert the
                // event data in order to prevent contents ending up inside
                // of the cursor target decorations.
                beforeinput: (view, incorrectlyTypedEvent)=>{
                    // This is typed by the prosemirror definitions as Event,
                    // this type is incorrect, and it is actually an InputEvent
                    const event = incorrectlyTypedEvent;
                    const { state: state } = view;
                    const { cursorTarget: cursorTarget } = $67462b32d888ce63$export$8836bfc6be4cb708.getState(state);
                    if (!event.isComposing && cursorTarget !== undefined) {
                        $67462b32d888ce63$var$handleTextInputInsideCursorTargetDecoration({
                            event: event,
                            cursorTarget: cursorTarget,
                            view: view
                        });
                        return true;
                    }
                    return false;
                }
            }
        }
    });
};
function $67462b32d888ce63$var$cursorTargetHasValidDecorations(cursorTarget) {
    if (!cursorTarget || // Decorations can end up as null when the decorations prop is
    // called after the decorations have been removed from the dom.
    // https://github.com/ProseMirror/prosemirror-view/blob/8f0d313a6389b86a335274fba36534ba1cb21f12/src/decoration.js#L30
    cursorTarget.decorations.includes(null)) return false;
    return true;
}
function $67462b32d888ce63$var$handleTextInputInsideCursorTargetDecoration({ event: event, view: view, cursorTarget: cursorTarget }) {
    event.stopPropagation();
    event.preventDefault();
    const content = event.data || '';
    // ensure any custom handleTextInput handlers are called for the input event
    // ie. type ahead, emoji shortcuts.
    const defaultTransaction = ()=>view.state.tr.insertText(content, cursorTarget.positions.from, cursorTarget.positions.to);
    const potentiallyHandleByHandleTextInput = view.someProp('handleTextInput', (f)=>f(view, cursorTarget.positions.from, cursorTarget.positions.to, content, defaultTransaction));
    if (potentiallyHandleByHandleTextInput) // if a handleTextInput handler has handled the event, we don't want to
    // manually update the document.
    return;
    view.dispatch(defaultTransaction());
}



var $ftpVl = parcelRequire("ftpVl");







const $01e967d9952d1631$var$LAZY_NODE_VIEW_DECORATION_CLASS = '__lazy-node-view-decoration__';
function $01e967d9952d1631$export$650082547b31be68() {
    return new (0, $1S4f7.SafePlugin)({
        key: (0, $ftpVl.lazyNodeViewDecorationPluginKey),
        state: {
            init: ()=>{
                return {
                    decorations: (0, $ftzrq.DecorationSet).empty,
                    nodeTypes: []
                };
            },
            apply (tr, _oldState, newState) {
                const actionPayload = tr.getMeta((0, $ftpVl.lazyNodeViewDecorationPluginKey));
                const pluginState = (0, $ftpVl.lazyNodeViewDecorationPluginKey).getState(newState);
                if (actionPayload?.type === 'add' && actionPayload.nodeTypes.size) {
                    const decorations = [];
                    tr.doc.nodesBetween(0, tr.doc.nodeSize - 2, (node, pos)=>{
                        if (actionPayload.nodeTypes.has(node.type.name)) decorations.push((0, $ftzrq.Decoration).node(pos, pos + node.nodeSize, {
                            class: $01e967d9952d1631$var$LAZY_NODE_VIEW_DECORATION_CLASS
                        }));
                    });
                    return {
                        decorations: (0, $ftzrq.DecorationSet).create(tr.doc, decorations)
                    };
                }
                if (actionPayload?.type === 'clear') return {
                    decorations: (0, $ftzrq.DecorationSet).empty
                };
                if (tr.docChanged) return {
                    decorations: pluginState?.decorations.map(tr.mapping, tr.doc)
                };
                return pluginState;
            }
        },
        props: {
            decorations: (state)=>{
                return (0, $ftpVl.lazyNodeViewDecorationPluginKey).getState(state)?.decorations;
            }
        },
        view (editorView) {
            return {
                update () {
                    /**
           * After view update can clean up decorations...
           */ const pluginState = (0, $ftpVl.lazyNodeViewDecorationPluginKey).getState(editorView.state);
                    if (pluginState.decorations !== (0, $ftzrq.DecorationSet).empty) {
                        const tr = editorView.state.tr;
                        tr.setMeta((0, $ftpVl.lazyNodeViewDecorationPluginKey), {
                            type: 'clear'
                        });
                        editorView.dispatch(tr);
                    }
                }
            };
        }
    });
}






var $WGctw = parcelRequire("WGctw");

var $6qPH4 = parcelRequire("6qPH4");


var $dus6D = parcelRequire("dus6D");





var $1oCLl = parcelRequire("1oCLl");

const $d09e83e77d74078b$export$2f489388b18569dd = new (0, $ks2lK.PluginKey)('newlinePreserveMarksPlugin');
const $d09e83e77d74078b$var$isSelectionAligned = (state)=>!!state.selection.$to.parent.marks.find((m)=>m.type === state.schema.marks.alignment);
const $d09e83e77d74078b$var$isSelectionFontSized = (state)=>{
    const { blockTaskItem: blockTaskItem, listItem: listItem } = state.schema.nodes;
    const { fontSize: fontSize } = state.schema.marks;
    const $to = state.selection.$to;
    const grandParent = $to.node($to.depth - 1);
    if (!fontSize || // don't intercept Enter inside blockTaskItem or listItem
    grandParent && (grandParent.type === blockTaskItem || grandParent.type === listItem)) return false;
    return !!$to.parent.marks.find((m)=>m.type === fontSize);
};
const $d09e83e77d74078b$var$hasBlockMarksToPreserve = (state)=>$d09e83e77d74078b$var$isSelectionAligned(state) || $d09e83e77d74078b$var$isSelectionFontSized(state);
const $d09e83e77d74078b$var$splitBlockPreservingMarks = (state, dispatch)=>{
    if (dispatch) dispatch(state.tr.split(state.tr.mapping.map(state.selection.$from.pos), 1));
    return true;
};
var $d09e83e77d74078b$export$2e2bcd8739ae039 = ()=>new (0, $1S4f7.SafePlugin)({
        key: $d09e83e77d74078b$export$2f489388b18569dd,
        props: {
            handleKeyDown: (0, $dus6D.keydownHandler)({
                Enter: (0, $1oCLl.expValEquals)('platform_editor_small_font_size', 'isEnabled', true) ? (0, $WGctw.filter)([
                    (0, $6qPH4.isSelectionEndOfParagraph),
                    $d09e83e77d74078b$var$hasBlockMarksToPreserve
                ], $d09e83e77d74078b$var$splitBlockPreservingMarks) : (0, $WGctw.filter)([
                    (0, $6qPH4.isSelectionEndOfParagraph),
                    $d09e83e77d74078b$var$isSelectionAligned
                ], $d09e83e77d74078b$var$splitBlockPreservingMarks)
            })
        }
    });






var $iu6m9 = parcelRequire("iu6m9");


const $270ca4541606fa18$var$GUTTER_SIZE_IN_PX = 120;
const $270ca4541606fa18$var$GUTTER_SELECTOR_NAME = 'editor-scroll-gutter';
const $270ca4541606fa18$var$GUTTER_ATTR = 'data-editor-scroll-gutter';
/**
 * Create a gutter element that can be added or removed from the DOM.
 */ function $270ca4541606fa18$var$createGutter(gutterSize, parent) {
    if ((0, $iu6m9.editorExperiment)('platform_editor_blocks', true)) {
        if (!parent) return ()=>{};
        const existing = parent.querySelector(`[${$270ca4541606fa18$var$GUTTER_ATTR}]`);
        if (existing instanceof HTMLElement) return ()=>parent.removeChild(existing);
        const gutter = document.createElement('div');
        gutter.style.paddingBottom = `${gutterSize}px`;
        gutter.setAttribute('data-vc', 'scroll-gutter');
        gutter.setAttribute($270ca4541606fa18$var$GUTTER_ATTR, 'true');
        parent.appendChild(gutter);
        return ()=>parent.removeChild(gutter);
    }
    const gutterRef = document.getElementById($270ca4541606fa18$var$GUTTER_SELECTOR_NAME);
    if (gutterRef) return ()=>parent?.removeChild(gutterRef);
    const gutter = document.createElement('div');
    gutter.style.paddingBottom = `${gutterSize}px`;
    gutter.setAttribute('data-vc', 'scroll-gutter');
    gutter.id = $270ca4541606fa18$var$GUTTER_SELECTOR_NAME;
    if (parent) parent.appendChild(gutter);
    return ()=>parent?.removeChild(gutter);
}
var // eslint-disable-next-line @typescript-eslint/no-empty-object-type
$270ca4541606fa18$export$2e2bcd8739ae039 = (pluginOptions = {})=>{
    const { getScrollElement: getScrollElement, gutterSize: gutterSize = $270ca4541606fa18$var$GUTTER_SIZE_IN_PX } = pluginOptions;
    if (!getScrollElement) return undefined;
    return new (0, $1S4f7.SafePlugin)({
        key: (0, $36e73f8e769b8277$export$54fdd3c2782161ea),
        state: {
            init: ()=>({}),
            apply: (tr, pluginState)=>{
                if (tr.getMeta((0, $36e73f8e769b8277$export$54fdd3c2782161ea))) return tr.getMeta((0, $36e73f8e769b8277$export$54fdd3c2782161ea));
                return pluginState;
            }
        },
        props: {
            // Determines the distance (in pixels) between the cursor and the end of the visible viewport at which point,
            // when scrolling the cursor into view, scrolling takes place.
            // Defaults to 0: https://prosemirror.net/docs/ref/#view.EditorProps.scrollThreshold
            scrollThreshold: gutterSize,
            // Determines the extra space (in pixels) that is left above or below the cursor when it is scrolled into view.
            // Defaults to 5: https://prosemirror.net/docs/ref/#view.EditorProps.scrollMargin
            scrollMargin: gutterSize
        },
        view (view) {
            // Store references to avoid lookups on successive checks.
            const scrollElement = getScrollElement(view);
            let editorElement = view.dom instanceof HTMLElement ? view.dom : null;
            let editorParentElement = editorElement?.parentElement;
            let cleanup = ()=>{};
            if (editorParentElement && scrollElement) cleanup = $270ca4541606fa18$var$createGutter(gutterSize, editorParentElement);
            return {
                destroy () {
                    cleanup();
                    editorParentElement = editorElement = null;
                }
            };
        }
    });
};



const $49b9f421228fc218$export$af5702f0c69bf4d7 = (state)=>{
    if (state) {
        const scrollGutterPluginState = (0, $36e73f8e769b8277$export$a237783470abe542)(state);
        return scrollGutterPluginState ? scrollGutterPluginState.keyboardHeight : undefined;
    }
};


const $09a279115301f266$export$30b652f8daa79df4 = {
    enabled: true,
    samplingRate: 100,
    countNodes: true,
    trackSeverity: true,
    trackRenderingTime: false,
    trackSingleKeypress: false,
    // TODO: ED-26959 - change this based on appearance due to SLOs - need to make ticket for both
    severityDegradedThreshold: 273,
    severityNormalThreshold: 143
};


function $a1e7cd6e59d035e7$export$edcd20463038b9e1(from, to, tr, callbacks) {
    const { doc: doc } = tr;
    doc.nodesBetween(from, to, (node, pos)=>{
        callbacks.forEach((cb)=>cb({
                tr: tr,
                node: node,
                pos: pos,
                from: from,
                to: to
            }));
    });
}
const $a1e7cd6e59d035e7$var$SMART_TO_ASCII = {
    "\u2026": '...',
    "\u2192": '->',
    "\u2190": '<-',
    "\u2013": '--',
    "\u201C": '"',
    "\u201D": '"',
    "\u2018": "'",
    "\u2019": "'"
};
// eslint-disable-next-line require-unicode-regexp
const $a1e7cd6e59d035e7$var$FIND_SMART_CHAR = new RegExp(`[${Object.keys($a1e7cd6e59d035e7$var$SMART_TO_ASCII).join('')}]`, 'g');
const $a1e7cd6e59d035e7$var$basePlugin = ({ config: options, api: api })=>{
    const featureFlags = api?.featureFlags?.sharedState.currentState() || {};
    const callbacks = [];
    api?.base?.actions.registerMarks(({ tr: tr, node: node, pos: pos, from: from, to: to })=>{
        const { doc: doc } = tr;
        const { schema: schema } = doc.type;
        const { text: textNodeType } = schema.nodes;
        if (node.type === textNodeType && node.text) {
            // Find a valid start and end position because the text may be partially selected.
            const startPositionInSelection = Math.max(pos, from);
            const endPositionInSelection = Math.min(pos + node.nodeSize, to);
            const textForReplacing = doc.textBetween(startPositionInSelection, endPositionInSelection);
            const newText = textForReplacing.replace($a1e7cd6e59d035e7$var$FIND_SMART_CHAR, (match)=>$a1e7cd6e59d035e7$var$SMART_TO_ASCII[match] ?? match);
            const currentStartPos = tr.mapping.map(startPositionInSelection);
            const currentEndPos = tr.mapping.map(endPositionInSelection);
            tr.replaceWith(currentStartPos, currentEndPos, schema.text(newText, node.marks));
        }
    });
    return {
        name: 'base',
        getSharedState (editorState) {
            return {
                allowScrollGutter: options?.allowScrollGutter,
                keyboardHeight: (0, $49b9f421228fc218$export$af5702f0c69bf4d7)(editorState)
            };
        },
        actions: {
            setKeyboardHeight: $d1751fed1c95125c$export$b8c3ea160300668d,
            resolveMarks: (from, to, tr)=>$a1e7cd6e59d035e7$export$edcd20463038b9e1(from, to, tr, callbacks),
            registerMarks: (callback)=>{
                callbacks.push(callback);
            }
        },
        pmPlugins () {
            const plugins = [
                {
                    name: 'filterStepsPlugin',
                    plugin: ({ dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>(0, $435bf10412a4bca8$export$2e2bcd8739ae039)(dispatchAnalyticsEvent)
                }
            ];
            plugins.push({
                name: 'lazyNodeViewDecorationsPlugin',
                plugin: ()=>(0, $01e967d9952d1631$export$650082547b31be68)()
            });
            // In Chrome, when the selection is placed between adjacent nodes which are not contenteditatble
            // the cursor appears at the right most point of the parent container.
            //
            // In Firefox, when the selection is placed between adjacent nodes which are not contenteditatble
            // no cursor is presented to users.
            //
            // In Safari, when the selection is placed between adjacent nodes which are not contenteditatble
            // it is not possible to navigate with arrow keys.
            //
            // This plugin works around the issues by inserting decorations between
            // inline nodes which are set as contenteditable, and have a zero width space.
            plugins.push({
                name: 'inlineCursorTargetPlugin',
                plugin: ()=>options && options.allowInlineCursorTarget ? (0, $67462b32d888ce63$export$2e2bcd8739ae039)() : undefined
            });
            plugins.push({
                name: 'newlinePreserveMarksPlugin',
                plugin: (0, $d09e83e77d74078b$export$2e2bcd8739ae039)
            }, {
                name: 'frozenEditor',
                plugin: ({ dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
                    return (0, $b00d2499ea4ffe69$export$2e2bcd8739ae039)(api?.contextIdentifier)(dispatchAnalyticsEvent, (0, $09a279115301f266$export$30b652f8daa79df4), undefined);
                }
            }, {
                name: 'history',
                plugin: ()=>(0, $ke2AI.history)()
            }, // should be last :(
            {
                name: 'codeBlockIndent',
                plugin: ()=>(0, $60bKU.keymap)({
                        ...(0, $astHL.baseKeymap),
                        'Mod-[': ()=>true,
                        'Mod-]': ()=>true
                    })
            });
            if (options && options.allowScrollGutter) plugins.push({
                name: 'scrollGutterPlugin',
                plugin: ()=>(0, $270ca4541606fa18$export$2e2bcd8739ae039)(options.allowScrollGutter)
            });
            plugins.push({
                name: 'disableSpellcheckingPlugin',
                plugin: ()=>(0, $5b91204662c41c7e$export$2e2bcd8739ae039)(featureFlags)
            });
            return plugins;
        },
        nodes () {
            return [
                {
                    name: 'doc',
                    node: (0, $jRrsu.doc)
                },
                {
                    name: 'paragraph',
                    node: (0, $eK2Ov.paragraph)
                },
                {
                    name: 'text',
                    node: (0, $bSuKu.text)
                }
            ];
        }
    };
};
var $a1e7cd6e59d035e7$export$2e2bcd8739ae039 = $a1e7cd6e59d035e7$var$basePlugin;
module.exports["default"] = $a1e7cd6e59d035e7$export$2e2bcd8739ae039;

});

parcelRegister("ftpVl", function(module, exports) {
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $ks2lK = parcelRequire("ks2lK");

const $0947d7f38625a698$var$hasIdleCallback = 'requestIdleCallback' in window;
const $0947d7f38625a698$export$4db3c991f22dbc2d = (cb, options)=>{
    return $0947d7f38625a698$var$hasIdleCallback ? requestIdleCallback(cb, {
        timeout: 5000,
        ...options
    }) : requestAnimationFrame(cb);
};
const $0947d7f38625a698$export$b888d8f981c07a46 = (id)=>{
    return $0947d7f38625a698$var$hasIdleCallback ? cancelIdleCallback(id) : cancelAnimationFrame(id);
};



var $iMBUc = parcelRequire("iMBUc");


var $560vg = parcelRequire("560vg");


var $24P9d = parcelRequire("24P9d");

const $470e47a9d4d9006c$export$325659f41b2239a7 = new (0, $ks2lK.PluginKey)('lazyNodeViewDecoration');
/**
 * 🧱 Internal: Editor FE Platform
 *
 * Controls which node was scheduled to load the original node view code
 */ const $470e47a9d4d9006c$var$requestedNodesPerEditorView = new WeakMap();
/**
 * 🧱 Internal: Editor FE Platform
 *
 * Caches loaded node view factory functions for each editor view
 */ const $470e47a9d4d9006c$var$resolvedNodesPerEditorView = new WeakMap();
/**
 * 🧱 Internal: Editor FE Platform
 *
 * Stores editorView -> raf to debounce NodeView updates.
 */ const $470e47a9d4d9006c$var$debounceToEditorViewMap = new WeakMap();
const $470e47a9d4d9006c$var$testOnlyIgnoreLazyNodeViewSet = new WeakSet();
function $470e47a9d4d9006c$export$6c7e823c919edf69(view) {
    $470e47a9d4d9006c$var$testOnlyIgnoreLazyNodeViewSet.add(view);
}
const $470e47a9d4d9006c$export$6b97b121e15a69b7 = ({ nodeName: nodeName, loader: loader, getNodeViewOptions: getNodeViewOptions })=>{
    return (node, view, getPos, decorations, innerDecorations)=>{
        let requestedNodes = $470e47a9d4d9006c$var$requestedNodesPerEditorView.get(view);
        if (!requestedNodes) {
            requestedNodes = new Map();
            $470e47a9d4d9006c$var$requestedNodesPerEditorView.set(view, requestedNodes);
        }
        const resolvedNodeViews = $470e47a9d4d9006c$var$resolvedNodesPerEditorView.get(view);
        if (!resolvedNodeViews) $470e47a9d4d9006c$var$resolvedNodesPerEditorView.set(view, new Map());
        const wasAlreadyRequested = requestedNodes.has(nodeName);
        if (wasAlreadyRequested) {
            const resolvedNodeView = resolvedNodeViews?.get(nodeName);
            if (resolvedNodeView && !$470e47a9d4d9006c$var$testOnlyIgnoreLazyNodeViewSet.has(view)) return resolvedNodeView(node, view, getPos, decorations, innerDecorations);
            return new (0, $560vg.LazyNodeView)(node, view, getPos, decorations);
        }
        const loaderPromise = loader().then((nodeViewFuncModule)=>{
            const nodeViewFunc = (node, view, getPos, decorations, innerDecorations)=>{
                const nodeView = nodeViewFuncModule(node, view, getPos, decorations, getNodeViewOptions, innerDecorations);
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = nodeView.dom;
                dom.setAttribute('data-vc', `editor-lnv-loaded--${node.type.name}`);
                const pos = getPos();
                if (pos !== undefined) dom.setAttribute('data-editor-lnv-placeholder-replace', (0, $iMBUc.makeNodePlaceholderId)(node.type.name, pos));
                return nodeView;
            };
            $470e47a9d4d9006c$var$resolvedNodesPerEditorView.get(view)?.set(nodeName, nodeViewFunc);
            /**
			 * Triggering lazyNodeViewDecoration plugin to apply decorations
			 * to nodes with newly loaded NodeViews.
			 */ const [callbackId, nodeTypes] = $470e47a9d4d9006c$var$debounceToEditorViewMap.get(view) || [
                null,
                new Set()
            ];
            if (callbackId) (0, $0947d7f38625a698$export$b888d8f981c07a46)(callbackId);
            nodeTypes.add(node.type.name);
            const nextCallbackId = (0, $0947d7f38625a698$export$4db3c991f22dbc2d)(()=>{
                $470e47a9d4d9006c$var$debounceToEditorViewMap.set(view, [
                    null,
                    new Set()
                ]);
                const tr = view.state.tr;
                tr.setMeta($470e47a9d4d9006c$export$325659f41b2239a7, {
                    type: 'add',
                    nodeTypes: nodeTypes
                });
                view.dispatch(tr);
            });
            $470e47a9d4d9006c$var$debounceToEditorViewMap.set(view, [
                nextCallbackId,
                nodeTypes
            ]);
            /**
			 * END triggering LazyNodeViewDecoration plugin
			 */ return nodeViewFunc;
        });
        requestedNodes.set(nodeName, loaderPromise);
        typeof node.type?.spec?.toDOM;
        return new (0, $560vg.LazyNodeView)(node, view, getPos, decorations);
    };
};
module.exports["lazyNodeViewDecorationPluginKey"] = $470e47a9d4d9006c$export$325659f41b2239a7;
module.exports["withLazyLoading"] = $470e47a9d4d9006c$export$6b97b121e15a69b7;

});

parcelRegister("24P9d", function(module, exports) {
/**
 * Converts a camelCased CSS property name to a hyphenated CSS property name.
 *
 * @param property - CamelCased CSS property name.
 * @returns Hyphenated CSS property name.
 */ function $b61d755b6665d630$var$hyphenate(property) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return property.replace(/[A-Z]/g, (match)=>`-${match.toLowerCase()}`).replace(/^ms/, '-ms');
}
function $b61d755b6665d630$export$7da93c9174ab9340(properties) {
    const cssString = Object.entries(properties).sort(([a], [b])=>a.localeCompare(b)).map(([property, value])=>`${property.startsWith('--') ? property : $b61d755b6665d630$var$hyphenate(property)}: ${value};`).join(' ');
    return cssString;
}
module.exports["convertToInlineCss"] = $b61d755b6665d630$export$7da93c9174ab9340;

});

parcelRegister("55skd", function(module, exports) {

var $1S4f7 = parcelRequire("1S4f7");


var $jI93b = parcelRequire("jI93b");


var $5SAOw = parcelRequire("5SAOw");


var $ks2lK = parcelRequire("ks2lK");


var $aXG5V = parcelRequire("aXG5V");


var $ke2AI = parcelRequire("ke2AI");




const $68e8ed80db053f45$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('betterTypeHistoryPlugin');


const $6ae66225a7e02c06$var$getEnterKeyboardActionStep = (trs)=>{
    const firstTr = trs.length === 1 && trs[0];
    if (!firstTr || !firstTr.docChanged || !firstTr.isGeneric || !(firstTr.selection instanceof (0, $ks2lK.TextSelection))) return null;
    const { selection: selection, steps: steps } = firstTr;
    const replaceSteps = steps.filter((step)=>step instanceof (0, $aXG5V.ReplaceStep) || step instanceof (0, $aXG5V.ReplaceAroundStep));
    if (!selection.$cursor || replaceSteps.length !== 1) return null;
    return replaceSteps[0];
};
const $6ae66225a7e02c06$var$isSliceSplittingBlockNode = (slice)=>{
    const hasOnlyTwoChildren = slice.size > 1 && slice.content.childCount === 2;
    if (!hasOnlyTwoChildren) return false;
    const firstNode = slice.content.child(0);
    const secondNode = slice.content.child(1);
    return firstNode && secondNode && firstNode.type === secondNode.type;
};
const $6ae66225a7e02c06$var$isSliceAddingNewlineChar = (slice, schema)=>{
    const newLine = (0, $5SAOw.Fragment).from(schema.text('\n'));
    return slice.content.eq(newLine);
};
var $6ae66225a7e02c06$export$2e2bcd8739ae039 = ()=>{
    return new (0, $1S4f7.SafePlugin)({
        key: (0, $68e8ed80db053f45$export$18d4026d1ea86bb1),
        appendTransaction: (transactions, oldState, newState)=>{
            const hasHandlePasteMeta = transactions.find((tran)=>tran.getMeta((0, $68e8ed80db053f45$export$18d4026d1ea86bb1)));
            if (hasHandlePasteMeta) return (0, $ke2AI.closeHistory)(newState.tr);
            const enterStep = $6ae66225a7e02c06$var$getEnterKeyboardActionStep(transactions);
            if (!enterStep) return;
            const slice = (0, $jI93b.extractSliceFromStep)(enterStep);
            const { schema: schema } = newState;
            if (slice && ($6ae66225a7e02c06$var$isSliceSplittingBlockNode(slice) || $6ae66225a7e02c06$var$isSliceAddingNewlineChar(slice, schema))) return (0, $ke2AI.closeHistory)(newState.tr);
        }
    });
};



/**
 * This plugin is aiming to improve undo behaviour for some of our more custom applications, very specific text
 * paste events, splitting blocks of text, new lines.
 */ const $92a1d8330a723d82$export$5587393ddd97118a = ()=>{
    return {
        name: 'betterTypeHistory',
        actions: {
            flagPasteEvent (tr) {
                tr.setMeta((0, $68e8ed80db053f45$export$18d4026d1ea86bb1), true);
                return tr;
            }
        },
        pmPlugins () {
            return [
                {
                    name: 'betterTypeHistory',
                    plugin: ()=>(0, $6ae66225a7e02c06$export$2e2bcd8739ae039)()
                }
            ];
        }
    };
};
module.exports["betterTypeHistoryPlugin"] = $92a1d8330a723d82$export$5587393ddd97118a;

});

parcelRegister("l6okE", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");


var $id9O1 = parcelRequire("id9O1");

var $iYC9s = parcelRequire("iYC9s");


var $jshjN = parcelRequire("jshjN");


var $1iYLq = parcelRequire("1iYLq");


var $adhil = parcelRequire("adhil");


var $aBqgN = parcelRequire("aBqgN");


var $fJNAd = parcelRequire("fJNAd");






function $7ef1eeb841c51b00$export$6f303ca7dac350ae(state) {
    const { selection: selection } = state;
    const { $to: $to } = selection;
    if (selection instanceof (0, $adhil.GapCursorSelection)) return false;
    if (selection instanceof (0, $ks2lK.NodeSelection) && selection.node.isBlock) return true;
    return (0, $1iYLq.endPositionOfParent)($to) === $to.pos + 1;
}
function $7ef1eeb841c51b00$export$8351d833af62ae68(state) {
    const { selection: selection } = state;
    return $7ef1eeb841c51b00$export$dba2543e302d55ed(selection);
}
function $7ef1eeb841c51b00$export$dba2543e302d55ed(selection) {
    const { $from: $from } = selection;
    if (selection instanceof (0, $adhil.GapCursorSelection)) return false;
    if (selection instanceof (0, $ks2lK.NodeSelection) && selection.node.isBlock) return true;
    return (0, $fJNAd.startPositionOfParent)($from) === $from.pos;
}
const $7ef1eeb841c51b00$export$2c0117b92050cffe = (tr, selectionToUse)=>{
    const selection = selectionToUse || tr.selection;
    let from = selection.$from.pos;
    let to = selection.$to.pos;
    if (selection instanceof (0, $ks2lK.TextSelection)) {
        // Expand just the from position to the start of the block
        // This ensures entire paragraphs are deleted instead of just
        // the text content, which avoids leaving an empty line behind
        const expanded = $7ef1eeb841c51b00$export$f69f5016bc6a173(selection.$from, selection.$to);
        from = expanded.$from.pos;
    } else if ((0, $iYC9s.isTableSelected)(selection)) {
        const table = (0, $id9O1.findTable)(selection);
        if (table) {
            from = table.pos;
            to = table.pos + table.node.nodeSize;
        }
    }
    tr.deleteRange(from, to);
    return tr;
};
const $7ef1eeb841c51b00$var$getDefaultPredicate = ({ nodes: nodes })=>{
    const requiresFurtherExpansion = new Set([
        nodes.bulletList,
        nodes.orderedList,
        nodes.taskList,
        nodes.listItem,
        nodes.taskItem,
        nodes.tableHeader,
        nodes.tableRow,
        nodes.tableCell,
        nodes.table,
        nodes.mediaGroup,
        nodes.mediaSingle
    ]);
    return (node)=>!requiresFurtherExpansion.has(node.type);
};
const $7ef1eeb841c51b00$export$f69f5016bc6a173 = ($from, $to, predicate = $7ef1eeb841c51b00$var$getDefaultPredicate($from.doc.type.schema))=>{
    const range = $from.blockRange($to, predicate);
    if (!range) return {
        $from: $from,
        $to: $to
    };
    return {
        $from: $from.doc.resolve(range.start),
        $to: $to.doc.resolve(range.end),
        range: range
    };
};
const $7ef1eeb841c51b00$export$cf7b5a42a57ba7c7 = ({ $from: $from, $to: $to })=>{
    return $7ef1eeb841c51b00$export$f69f5016bc6a173($from, $to);
};
function $7ef1eeb841c51b00$export$87365ac27c0f1ed1(selection) {
    const { range: range } = $7ef1eeb841c51b00$export$cf7b5a42a57ba7c7(selection);
    if (!range) return false;
    return (0, $aBqgN.isMultiBlockRange)(range);
}
function $7ef1eeb841c51b00$export$d9d2142e5263c662(tr, selection) {
    const { $from: $from, $to: $to } = $7ef1eeb841c51b00$export$cf7b5a42a57ba7c7(selection);
    const selectedParent = $from.parent;
    const isList = (0, $jshjN.isListNode)(selectedParent);
    const sliceStart = isList ? $from.pos - 1 : $from.pos;
    const sliceEnd = isList ? $to.pos + 1 : $to.pos;
    const slice = tr.doc.slice(sliceStart, sliceEnd);
    return [
        ...slice.content.content
    ];
}
module.exports["atTheEndOfBlock"] = $7ef1eeb841c51b00$export$6f303ca7dac350ae;
module.exports["atTheBeginningOfBlock"] = $7ef1eeb841c51b00$export$8351d833af62ae68;
module.exports["selectionIsAtTheBeginningOfBlock"] = $7ef1eeb841c51b00$export$dba2543e302d55ed;
module.exports["deleteSelectedRange"] = $7ef1eeb841c51b00$export$2c0117b92050cffe;
module.exports["expandToBlockRange"] = $7ef1eeb841c51b00$export$f69f5016bc6a173;
module.exports["expandSelectionToBlockRange"] = $7ef1eeb841c51b00$export$cf7b5a42a57ba7c7;
module.exports["isMultiBlockSelection"] = $7ef1eeb841c51b00$export$87365ac27c0f1ed1;
module.exports["getSourceNodesFromSelectionRange"] = $7ef1eeb841c51b00$export$d9d2142e5263c662;

});

parcelRegister("id9O1", function(module, exports) {

var $8m4tT = parcelRequire("8m4tT");


var $LmqWp = parcelRequire("LmqWp");

const $3161ce52b09cb4d1$export$1ae6a0a4f7784fc4 = (selection)=>(0, $8m4tT.findParentNode)((node)=>node.type.spec.tableRole && node.type.spec.tableRole === 'table')(selection);
const $3161ce52b09cb4d1$export$9323c80f9a3e899f = ($pos)=>{
    const predicate = (node)=>node.type.spec.tableRole && node.type.spec.tableRole === 'table';
    return (0, $8m4tT.findParentNodeClosestToPos)($pos, predicate);
};
const $3161ce52b09cb4d1$export$3ac56532a0bf4018 = ($pos)=>{
    const predicate = (node)=>// Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        node.type.spec.tableRole && /cell/i.test(node.type.spec.tableRole);
    return (0, $8m4tT.findParentNodeClosestToPos)($pos, predicate);
};
const $3161ce52b09cb4d1$export$68680ae223aebfa7 = ($pos)=>{
    const cell = $3161ce52b09cb4d1$export$3ac56532a0bf4018($pos);
    if (cell) {
        const table = $3161ce52b09cb4d1$export$9323c80f9a3e899f($pos);
        if (table) {
            const map = (0, $LmqWp.TableMap).get(table.node);
            const cellPos = cell.pos - table.start;
            return map.rectBetween(cellPos, cellPos);
        }
    }
};
module.exports["findTable"] = $3161ce52b09cb4d1$export$1ae6a0a4f7784fc4;
module.exports["findTableClosestToPos"] = $3161ce52b09cb4d1$export$9323c80f9a3e899f;
module.exports["findCellClosestToPos"] = $3161ce52b09cb4d1$export$3ac56532a0bf4018;
module.exports["findCellRectClosestToPos"] = $3161ce52b09cb4d1$export$68680ae223aebfa7;

});

parcelRegister("iYC9s", function(module, exports) {

var $LmqWp = parcelRequire("LmqWp");


var $BW42l = parcelRequire("BW42l");

const $340f46ec00d34d8f$export$d06743a3adc2076d = (rect)=>(selection)=>{
        if (!(0, $BW42l.isSelectionType)(selection, 'cell')) return false;
        const map = (0, $LmqWp.TableMap).get(selection.$anchorCell.node(-1));
        const start = selection.$anchorCell.start(-1);
        const cells = map.cellsInRect(rect);
        const selectedCells = map.cellsInRect(map.rectBetween(selection.$anchorCell.pos - start, selection.$headCell.pos - start));
        for(let i = 0, count = cells.length; i < count; i++){
            if (selectedCells.indexOf(cells[i]) === -1) return false;
        }
        return true;
    };
const $340f46ec00d34d8f$export$8db1cdcc0c397a6d = (columnIndex)=>(selection)=>{
        if ((0, $BW42l.isSelectionType)(selection, 'cell')) {
            const map = (0, $LmqWp.TableMap).get(selection.$anchorCell.node(-1));
            return $340f46ec00d34d8f$export$d06743a3adc2076d({
                left: columnIndex,
                right: columnIndex + 1,
                top: 0,
                bottom: map.height
            })(selection);
        }
        return false;
    };
const $340f46ec00d34d8f$export$710e11cf672b86c = (rowIndex)=>(selection)=>{
        if ((0, $BW42l.isSelectionType)(selection, 'cell')) {
            const map = (0, $LmqWp.TableMap).get(selection.$anchorCell.node(-1));
            return $340f46ec00d34d8f$export$d06743a3adc2076d({
                left: 0,
                right: map.width,
                top: rowIndex,
                bottom: rowIndex + 1
            })(selection);
        }
        return false;
    };
const $340f46ec00d34d8f$export$5d08de4a0eeb0408 = (selection)=>{
    if ((0, $BW42l.isSelectionType)(selection, 'cell')) {
        const map = (0, $LmqWp.TableMap).get(selection.$anchorCell.node(-1));
        return $340f46ec00d34d8f$export$d06743a3adc2076d({
            left: 0,
            right: map.width,
            top: 0,
            bottom: map.height
        })(selection);
    }
    return false;
};
module.exports["isColumnSelected"] = $340f46ec00d34d8f$export$8db1cdcc0c397a6d;
module.exports["isRowSelected"] = $340f46ec00d34d8f$export$710e11cf672b86c;
module.exports["isTableSelected"] = $340f46ec00d34d8f$export$5d08de4a0eeb0408;

});

parcelRegister("BW42l", function(module, exports) {
function $c9f280cebbd11740$export$626dcc173023aed7(selection, type) {
    if (!selection) return false;
    const serialized = selection.toJSON();
    return serialized.type === type;
}
module.exports["isSelectionType"] = $c9f280cebbd11740$export$626dcc173023aed7;

});

parcelRegister("1iYLq", function(module, exports) {
function $ac0f79cc78614181$export$8e09b50c60354750(resolvedPos) {
    return resolvedPos.end(resolvedPos.depth) + 1;
}
module.exports["endPositionOfParent"] = $ac0f79cc78614181$export$8e09b50c60354750;

});

parcelRegister("aBqgN", function(module, exports) {
const $43b3ebcbcee73060$export$4327aeb0536d2384 = (range)=>{
    if (range.endIndex - range.startIndex <= 1) return false; // At most one child
    // Count block nodes in the range, return true if more than one
    let blockCount = 0;
    for(let i = range.startIndex; i < range.endIndex; i++){
        if (range.parent.child(i).isBlock) blockCount++;
        if (blockCount > 1) return true;
    }
    return false;
};
module.exports["isMultiBlockRange"] = $43b3ebcbcee73060$export$4327aeb0536d2384;

});

parcelRegister("fJNAd", function(module, exports) {
function $e235675b60b98985$export$ced77c72038c89cb(resolvedPos) {
    return resolvedPos.start(resolvedPos.depth);
}
module.exports["startPositionOfParent"] = $e235675b60b98985$export$ced77c72038c89cb;

});

parcelRegister("laABt", function(module, exports) {
function $82746d592c88aa73$export$4ca816540352da02(state) {
    const { selection: selection, doc: doc } = state;
    return doc.nodeSize - selection.$to.pos - 2 === selection.$to.depth;
}
module.exports["atTheEndOfDoc"] = $82746d592c88aa73$export$4ca816540352da02;

});

parcelRegister("e2a9y", function(module, exports) {
function $55452f8d8adc23de$export$e9083e8cbe24bec0(state) {
    const { selection: selection } = state;
    return selection.$from.pos === selection.$from.depth;
}
module.exports["atTheBeginningOfDoc"] = $55452f8d8adc23de$export$e9083e8cbe24bec0;

});

parcelRegister("eYkq0", function(module, exports) {
const $0a108eb6789097f6$export$748c2428d313e6d0 = ($anchor, $head)=>{
    const sharedDepth = $anchor.sharedDepth($head.pos) + 1;
    const $from = $anchor.min($head);
    const $to = $anchor.max($head);
    const fromDepth = $from.depth;
    const toDepth = $to.depth;
    let selectionStart;
    let selectionEnd;
    const selectionHasGrandparent = toDepth > 1 && fromDepth > 1;
    const selectionIsAcrossDiffParents = selectionHasGrandparent && !$to.parent.isTextblock && !$to.sameParent($from);
    const selectionIsAcrossTextBlocksWithDiffParents = selectionHasGrandparent && $to.parent.isTextblock && $to.before(toDepth - 1) !== $from.before(fromDepth - 1);
    if (toDepth > fromDepth) {
        selectionStart = $from.before(sharedDepth);
        selectionEnd = $to.after(sharedDepth);
    } else if (toDepth < fromDepth) {
        selectionStart = $from.before(sharedDepth);
        selectionEnd = $to.after(sharedDepth);
    } else if (selectionIsAcrossDiffParents || selectionIsAcrossTextBlocksWithDiffParents) {
        // when selection from/to share same depth with different parents, hoist up the selection to the parent of the highest depth in the selection
        selectionStart = $from.before(sharedDepth);
        selectionEnd = $to.after(sharedDepth);
    } else if (!$from.node().inlineContent) // when selection might be a Node selection, return what was passed in
    return {
        $anchor: $anchor,
        $head: $head
    };
    else {
        selectionStart = fromDepth ? $from.before() : $from.pos;
        selectionEnd = toDepth ? $to.after() : $to.pos;
    }
    const $expandedFrom = $anchor.doc.resolve(selectionStart);
    const $expandedTo = $anchor.doc.resolve(selectionEnd);
    return {
        $anchor: $anchor === $from ? $expandedFrom : $expandedTo,
        $head: $head === $to ? $expandedTo : $expandedFrom
    };
};
module.exports["expandSelectionBounds"] = $0a108eb6789097f6$export$748c2428d313e6d0;

});

parcelRegister("cX9xt", function(module, exports) {

var $5SAOw = parcelRequire("5SAOw");

/**
 * Returns the base name of a node type, stripping known variant suffixes.
 */ const $1e6e8cf5eafc0018$var$variantToBaseNameMap = {
    panel_c1: 'panel'
};
function $1e6e8cf5eafc0018$export$e7c4aaf94dfc397d(nodeType) {
    return $1e6e8cf5eafc0018$var$variantToBaseNameMap[nodeType.name] ?? nodeType.name;
}
function $1e6e8cf5eafc0018$export$7138504956ccb99(a, b) {
    return $1e6e8cf5eafc0018$export$e7c4aaf94dfc397d(a) === $1e6e8cf5eafc0018$export$e7c4aaf94dfc397d(b);
}
function $1e6e8cf5eafc0018$export$5131954471e1003(childTypeName, parentNode, schema) {
    const childType = schema.nodes[childTypeName];
    if (!childType) return false;
    const candidate = childType.createAndFill();
    if (!candidate) return false;
    return parentNode.type.validContent((0, $5SAOw.Fragment).from(candidate));
}
function $1e6e8cf5eafc0018$export$1dccb55ec61cba15($from) {
    const schema = $from.doc.type.schema;
    const { panel: panel, panel_c1: panel_c1 } = schema.nodes;
    if (!panel_c1) return panel;
    for(let depth = $from.depth; depth >= 0; depth--){
        const parent = $from.node(depth);
        const index = $from.index(depth);
        if (parent.canReplaceWith(index, index, panel_c1)) return panel_c1;
        const spec = parent.type.spec;
        // Stop at isolating containers (e.g. expand, tableCell) — hard walls where
        // the panel stays inside and should use the regular panel type.
        if (spec.isolating) return panel;
    }
    return panel;
}
module.exports["getBaseNodeTypeName"] = $1e6e8cf5eafc0018$export$e7c4aaf94dfc397d;
module.exports["isNodeOfSameBaseType"] = $1e6e8cf5eafc0018$export$7138504956ccb99;
module.exports["isNodeTypeValidChildOf"] = $1e6e8cf5eafc0018$export$5131954471e1003;
module.exports["pickPanelTypeForInsertion"] = $1e6e8cf5eafc0018$export$1dccb55ec61cba15;

});

parcelRegister("7LzxJ", function(module, exports) {
const $d1b2b9c81bbba6d6$export$d295c32f32566012 = ({ attrs: attrs, content: content, marks: marks, schema: schema })=>{
    const { blockTaskItem: blockTaskItem, paragraph: paragraph } = schema.nodes;
    const newParagraph = paragraph.createChecked(null, content, marks?.filter((mark)=>blockTaskItem.allowsMarkType(mark.type)));
    return blockTaskItem.create(attrs ?? null, newParagraph);
};
module.exports["createBlockTaskItem"] = $d1b2b9c81bbba6d6$export$d295c32f32566012;

});

parcelRegister("dNXVc", function(module, exports) {

var $fO7hX = parcelRequire("fO7hX");


var $aXG5V = parcelRequire("aXG5V");


var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");


var $3Ter7 = parcelRequire("3Ter7");

const $c8dabbeb1a5f978a$export$dea78458f6234074 = false;
const $c8dabbeb1a5f978a$export$15e74cb2b99d4f44 = new WeakMap();
const $c8dabbeb1a5f978a$export$f86d342c9776cad6 = (attrs)=>{
    const localId = attrs?.localId ?? // eslint-disable-next-line @atlaskit/platform/no-preconditioning -- Auto-detection uses the q4 experiment, a kill switch, and the existing localId gate.
    ((0, $1oCLl.expValEquals)('platform_editor_code_block_q4_lovability', 'isEnabled', true) && (0, $dh538.fg)('platform_editor_code_block_language_detection_flow') && (0, $dh538.fg)('platform_editor_add_code_block_localid') ? (0, $fO7hX.uuid).generate() : undefined);
    const attrsWithLocalId = localId ? {
        ...attrs,
        localId: localId
    } : attrs;
    if (!(0, $1oCLl.expValEquals)('platform_editor_code_block_q4_lovability', 'isEnabled', true)) return attrsWithLocalId;
    // Only boolean wrap values represent caller intent. null/undefined means unset.
    if (attrs?.wrap === true || attrs?.wrap === false) return attrsWithLocalId;
    return {
        ...attrsWithLocalId,
        wrap: true
    };
};
const $c8dabbeb1a5f978a$export$95a2b1adfd5a9190 = (slice, schema)=>{
    if (!(0, $1oCLl.expValEquals)('platform_editor_code_block_q4_lovability', 'isEnabled', true)) return slice;
    return (0, $3Ter7.mapSlice)(slice, (node)=>{
        if (node.type !== schema.nodes.codeBlock || node.attrs.wrap === true) return node;
        // Markdown conversion uses MarkdownParser token mappings and creates code block nodes
        // with the schema-default wrap:false. Since Markdown has no wrap syntax, treat that
        // default as missing user intent and change it to wrap:true.
        return node.type.create($c8dabbeb1a5f978a$export$f86d342c9776cad6(node.attrs), node.content, node.marks);
    });
};
const $c8dabbeb1a5f978a$var$isReplaceStep = (step)=>step instanceof (0, $aXG5V.ReplaceStep) || step instanceof (0, $aXG5V.ReplaceAroundStep);
const $c8dabbeb1a5f978a$var$hasInsertedCodeBlockInStep = (step, codeBlockType, filter)=>{
    let hasInsertedCodeBlock = false;
    step.slice.content.descendants((node)=>{
        if (node.type === codeBlockType && (!filter || filter(node))) {
            hasInsertedCodeBlock = true;
            return false;
        }
        return !hasInsertedCodeBlock;
    });
    return hasInsertedCodeBlock;
};
const $c8dabbeb1a5f978a$var$collectMappedInsertedRanges = (tr, stepIndex)=>{
    const ranges = [];
    const stepMap = tr.mapping.maps[stepIndex];
    const remainingMaps = tr.mapping.slice(stepIndex + 1);
    stepMap.forEach((_oldStart, _oldEnd, newStart, newEnd)=>{
        if (newStart === newEnd) return;
        const finalFrom = remainingMaps.map(newStart, 1);
        const finalTo = remainingMaps.map(newEnd, -1);
        if (finalFrom < finalTo) ranges.push([
            finalFrom,
            finalTo
        ]);
    });
    return ranges;
};
const $c8dabbeb1a5f978a$export$ee996fbdea8dfc30 = (tr, codeBlockType, options = {})=>{
    const insertedCodeBlocks = [];
    const seenPositions = new Set();
    tr.steps.forEach((step, stepIndex)=>{
        if (!$c8dabbeb1a5f978a$var$isReplaceStep(step)) return;
        const insertedCodeBlockByStep = $c8dabbeb1a5f978a$var$hasInsertedCodeBlockInStep(step, codeBlockType, options.filter);
        if (!insertedCodeBlockByStep) return;
        $c8dabbeb1a5f978a$var$collectMappedInsertedRanges(tr, stepIndex).forEach(([from, to])=>{
            tr.doc.nodesBetween(from, to, (node, pos)=>{
                if (pos >= from && node.type === codeBlockType && (!options.filter || options.filter(node)) && !seenPositions.has(pos)) {
                    seenPositions.add(pos);
                    insertedCodeBlocks.push({
                        node: node,
                        pos: pos
                    });
                    return false;
                }
                return true;
            });
        });
    });
    return insertedCodeBlocks;
};
const $c8dabbeb1a5f978a$var$codeBlockFoldStates = new WeakMap();
const $c8dabbeb1a5f978a$export$ca74aa614fc297de = (codeBlockNode)=>{
    if ((0, $1oCLl.expValEquals)('platform_editor_code_block_q4_lovability', 'isEnabled', true)) return Boolean(codeBlockNode.attrs.wrap);
    const currentNodeWordWrapState = $c8dabbeb1a5f978a$export$15e74cb2b99d4f44.get(codeBlockNode);
    return currentNodeWordWrapState !== undefined ? currentNodeWordWrapState : $c8dabbeb1a5f978a$export$dea78458f6234074;
};
const $c8dabbeb1a5f978a$export$ae57f08acfae6877 = (codeBlockNode)=>{
    if (!(0, $1oCLl.expValEquals)('platform_editor_code_block_q4_lovability', 'isEnabled', true)) return false;
    return Boolean(codeBlockNode.attrs.hideLineNumbers);
};
const $c8dabbeb1a5f978a$export$17fa4cce31080ba8 = (codeBlockNode)=>!$c8dabbeb1a5f978a$export$ae57f08acfae6877(codeBlockNode);
const $c8dabbeb1a5f978a$export$dd8d371c28bc93ab = (codeBlockNode)=>{
    const currentNodeFoldState = $c8dabbeb1a5f978a$var$codeBlockFoldStates.get(codeBlockNode);
    return currentNodeFoldState || [];
};
const $c8dabbeb1a5f978a$export$84bbe896418e05aa = (codeBlockNode, foldRanges)=>{
    $c8dabbeb1a5f978a$var$codeBlockFoldStates.set(codeBlockNode, foldRanges);
};
const $c8dabbeb1a5f978a$export$8de8069131d61656 = (oldCodeBlockNode, newCodeBlockNode)=>{
    if ((0, $1oCLl.expValEquals)('platform_editor_code_block_fold_gutter', 'isEnabled', true)) $c8dabbeb1a5f978a$var$transferCodeBlockFoldValue(oldCodeBlockNode, newCodeBlockNode);
    // Don't overwrite the value for the new node if it already exists.
    // This can happen when a drag&drop is swapping nodes.
    if ($c8dabbeb1a5f978a$export$15e74cb2b99d4f44.has(newCodeBlockNode)) return;
    const previousValue = $c8dabbeb1a5f978a$export$ca74aa614fc297de(oldCodeBlockNode);
    $c8dabbeb1a5f978a$export$15e74cb2b99d4f44.set(newCodeBlockNode, previousValue);
    $c8dabbeb1a5f978a$export$15e74cb2b99d4f44.delete(oldCodeBlockNode);
};
/**
 * Swap the old node key with the new node key in the fold states WeakMap.
 */ const $c8dabbeb1a5f978a$var$transferCodeBlockFoldValue = (oldCodeBlockNode, newCodeBlockNode)=>{
    // Don't overwrite the value for the new node if it already exists.
    // This can happen when a drag&drop is swapping nodes.
    if ($c8dabbeb1a5f978a$var$codeBlockFoldStates.has(newCodeBlockNode)) return;
    const previousValue = $c8dabbeb1a5f978a$export$dd8d371c28bc93ab(oldCodeBlockNode);
    $c8dabbeb1a5f978a$var$codeBlockFoldStates.set(newCodeBlockNode, previousValue);
    $c8dabbeb1a5f978a$var$codeBlockFoldStates.delete(oldCodeBlockNode);
};
const $c8dabbeb1a5f978a$export$de41d58f29620282 = (newCodeBlockNodes, oldState)=>{
    newCodeBlockNodes.forEach((newCodeBlockNode)=>{
        if ((0, $1oCLl.expValEquals)('platform_editor_code_block_fold_gutter', 'isEnabled', true)) $c8dabbeb1a5f978a$var$updateCodeBlockFoldStateNodeKeys(newCodeBlockNode, oldState);
        // Don't overwrite the value for the new node if it already exists.
        // This can happen when a drag&drop is swapping nodes.
        if ($c8dabbeb1a5f978a$export$15e74cb2b99d4f44.has(newCodeBlockNode.node)) return;
        // Do not go out of range on the oldState doc. Happens on initial load.
        if (oldState.doc.content.size <= newCodeBlockNode.pos) return;
        const oldCodeBlockNode = oldState.doc.nodeAt(newCodeBlockNode.pos);
        if (!oldCodeBlockNode || oldCodeBlockNode.type !== oldState.schema.nodes.codeBlock) return;
        const previousValue = $c8dabbeb1a5f978a$export$ca74aa614fc297de(oldCodeBlockNode);
        $c8dabbeb1a5f978a$export$15e74cb2b99d4f44.set(newCodeBlockNode.node, previousValue);
    });
};
/**
 * As the code block node is used as the fold state key, there is instances where the node will be destroyed & recreated and is no longer a valid key.
 * In these instances, we must get the value from that old node and set it to the value of the new node.
 * This function takes all the given nodes, finds their old nodes from the old state and updates these old node keys.
 */ const $c8dabbeb1a5f978a$var$updateCodeBlockFoldStateNodeKeys = (newCodeBlockNode, oldState)=>{
    // Don't overwrite the value for the new node if it already exists.
    // This can happen when a drag&drop is swapping nodes.
    if ($c8dabbeb1a5f978a$var$codeBlockFoldStates.has(newCodeBlockNode.node)) return;
    // Do not go out of range on the oldState doc. Happens on initial load.
    if (oldState.doc.content.size <= newCodeBlockNode.pos) return;
    const oldCodeBlockNode = oldState.doc.nodeAt(newCodeBlockNode.pos);
    if (!oldCodeBlockNode || oldCodeBlockNode.type !== oldState.schema.nodes.codeBlock) return;
    const previousValue = $c8dabbeb1a5f978a$export$dd8d371c28bc93ab(oldCodeBlockNode);
    $c8dabbeb1a5f978a$var$codeBlockFoldStates.set(newCodeBlockNode.node, previousValue);
};
module.exports["defaultWordWrapState"] = $c8dabbeb1a5f978a$export$dea78458f6234074;
module.exports["codeBlockWrappedStates"] = $c8dabbeb1a5f978a$export$15e74cb2b99d4f44;
module.exports["getDefaultCodeBlockAttrs"] = $c8dabbeb1a5f978a$export$f86d342c9776cad6;
module.exports["normalizeMarkdownCodeBlockAttrsInSlice"] = $c8dabbeb1a5f978a$export$95a2b1adfd5a9190;
module.exports["getInsertedCodeBlocksInTransaction"] = $c8dabbeb1a5f978a$export$ee996fbdea8dfc30;
module.exports["isCodeBlockWordWrapEnabled"] = $c8dabbeb1a5f978a$export$ca74aa614fc297de;
module.exports["areCodeBlockLineNumbersHidden"] = $c8dabbeb1a5f978a$export$ae57f08acfae6877;
module.exports["areCodeBlockLineNumbersVisible"] = $c8dabbeb1a5f978a$export$17fa4cce31080ba8;
module.exports["getCodeBlockFoldState"] = $c8dabbeb1a5f978a$export$dd8d371c28bc93ab;
module.exports["setCodeBlockFoldState"] = $c8dabbeb1a5f978a$export$84bbe896418e05aa;
module.exports["transferCodeBlockWrappedValue"] = $c8dabbeb1a5f978a$export$8de8069131d61656;
module.exports["updateCodeBlockWrappedStateNodeKeys"] = $c8dabbeb1a5f978a$export$de41d58f29620282;

});

parcelRegister("SI3ya", function(module, exports) {

var $8kPu1 = parcelRequire("8kPu1");

class $ef97e3c1f1bfeb18$export$e76932dc77daa06a {
    start(callback) {
        this.stop();
        const configResult = this.observeConfig();
        const configs = Array.isArray(configResult) ? configResult : [
            configResult
        ];
        const validConfigs = configs.filter((config)=>!!config?.target);
        if (validConfigs.length === 0) {
            callback({
                status: 'failure',
                reason: (0, $8kPu1.EXPERIENCE_FAILURE_REASON).DOM_MUTATION_TARGET_NOT_FOUND
            });
            return;
        }
        this.mutationObserver = new MutationObserver((mutations)=>{
            try {
                const result = this.onDomMutation({
                    mutations: mutations
                });
                if (result) callback(result);
            } catch  {
                callback({
                    status: 'failure',
                    reason: (0, $8kPu1.EXPERIENCE_FAILURE_REASON).DOM_MUTATION_CHECK_ERROR
                });
            }
        });
        for (const config of validConfigs){
            const { target: target, options: options } = config;
            if (target) this.mutationObserver.observe(target, options ?? {
                childList: true
            });
        }
    }
    stop() {
        if (this.mutationObserver) {
            this.mutationObserver.disconnect();
            this.mutationObserver = undefined;
        }
    }
    constructor({ onDomMutation: onDomMutation, observeConfig: observeConfig }){
        this.mutationObserver = void 0;
        this.onDomMutation = void 0;
        this.observeConfig = void 0;
        this.onDomMutation = onDomMutation;
        this.observeConfig = observeConfig;
    }
}
module.exports["ExperienceCheckDomMutation"] = $ef97e3c1f1bfeb18$export$e76932dc77daa06a;

});

parcelRegister("97Zg0", function(module, exports) {

var $hTKp4 = parcelRequire("hTKp4");


var $8kPu1 = parcelRequire("8kPu1");


var $7MBf1 = parcelRequire("7MBf1");

const $6b9aa370e3bd43e2$var$PORTAL_CONTAINER_SELECTOR = 'body > .atlaskit-portal-container';
class $6b9aa370e3bd43e2$export$10f7d66405927699 {
    /**
   * Returns the list of DOM elements to observe based on popup type.
   */ getObserveTargets() {
        const { config: config } = this;
        switch(config.type){
            case 'inline':
                return this.getInlineTargets(config);
            case 'editorRoot':
                return this.getEditorRootTargets(config);
            case 'editorContent':
                return this.getEditorContentTargets(config);
            case 'portalRoot':
                return this.getPortalRootTargets();
        }
    }
    /**
   * For 'portalRoot' type: observe .atlaskit-portal-container.
   * Popups like flags and modals render in body > .atlaskit-portal-container.
   */ getPortalRootTargets() {
        const portalContainer = (0, $hTKp4.getDocument)()?.querySelector($6b9aa370e3bd43e2$var$PORTAL_CONTAINER_SELECTOR);
        return portalContainer ? [
            portalContainer
        ] : [];
    }
    /**
   * For 'editorContent' type: observe the target (mount point) and any existing
   * [data-editor-popup] wrappers within it. Content-level popups and modals
   * appear in portal containers.
   */ getEditorContentTargets(config) {
        const target = config.getTarget();
        if (!target) return [];
        const targets = [
            target
        ];
        const wrappers = target.querySelectorAll('[data-editor-popup]');
        for (const wrapper of wrappers)targets.push(wrapper);
        return targets;
    }
    /**
   * For 'inline' type: observe the target element directly.
   * The caller is responsible for resolving the correct container
   * (e.g. the toolbar button-group) via the getTarget function.
   */ getInlineTargets(config) {
        const target = config.getTarget();
        if (!target) return [];
        return [
            target
        ];
    }
    /**
   * For 'editorRoot' type: observe the actual editor root container.
   * The editorDom is the ProseMirror element, but popups appear as direct children
   * of the parent .akEditor container. So we observe the parent of editorDom.
   */ getEditorRootTargets(config) {
        const targets = [];
        const editorDom = config.getEditorDom();
        if (editorDom) {
            const editorRoot = editorDom.closest('.akEditor') || editorDom.parentElement;
            if (editorRoot instanceof HTMLElement) targets.push(editorRoot);
        }
        return targets;
    }
    start(callback) {
        const doc = (0, $hTKp4.getDocument)();
        const observeTargets = this.getObserveTargets();
        if (!doc || !observeTargets.length) {
            callback({
                status: 'failure',
                reason: (0, $8kPu1.EXPERIENCE_FAILURE_REASON).DOM_MUTATION_TARGET_NOT_FOUND
            });
            return;
        }
        const query = this.config.nestedElementQuery;
        const subtree = this.config.type === 'inline' && this.config.subtree === true;
        const observe = (el)=>{
            const observer = new MutationObserver(onMutation);
            observer.observe(el, {
                childList: true,
                subtree: subtree
            });
            this.observers.push(observer);
        };
        const onMutation = (mutations)=>{
            const found = mutations.some(({ type: type, addedNodes: addedNodes })=>type === 'childList' && [
                    ...addedNodes
                ].some((node)=>node instanceof HTMLElement && ((0, $7MBf1.popupWithNestedElement)(node, query) || node.matches(query) || node.querySelector(query) !== null)));
            if (found) {
                callback({
                    status: 'success'
                });
                return;
            }
        };
        for (const observeTarget of observeTargets)observe(observeTarget);
    }
    stop() {
        for (const observer of this.observers)observer.disconnect();
        this.observers = [];
    }
    constructor(config){
        this.config = void 0;
        this.observers = [];
        this.config = config;
    }
}
module.exports["ExperienceCheckPopupMutation"] = $6b9aa370e3bd43e2$export$10f7d66405927699;

});

parcelRegister("7MBf1", function(module, exports) {
/**
 * Returns the popup with a nested element identified by a specific test ID if it exists.
 *
 * @param node - The node to check.
 * @param nestedElementQuery - The query to look for the nested element.
 * @returns Element if the node contains the popup, undefined otherwise.
 */ const $81e32bedc24fe97f$export$8a7378047752ffb6 = (node, nestedElementQuery)=>{
    if (!(node instanceof HTMLElement)) return undefined;
    // Check if node itself has the popup attribute and contains the element matching the nestedElementQuery
    if (node.matches('[data-editor-popup="true"]')) return node.querySelector(nestedElementQuery);
    // Check if any direct child with popup attribute contains the element matching the nestedElementQuery
    return node.querySelector(`:scope > [data-editor-popup="true"] ${nestedElementQuery}`);
};
module.exports["popupWithNestedElement"] = $81e32bedc24fe97f$export$8a7378047752ffb6;

});

parcelRegister("6pIOC", function(module, exports) {
/**
 * Searches for the popup container element relative to the provided editor view element.
 *
 * @param editorViewEl - The editor view HTMLElement.
 * @returns The popup container HTMLElement if found, otherwise undefined.
 */ const $d3e68692beaa23af$export$f562a1e3da45e3ca = (editorViewEl)=>{
    const editorContentArea = editorViewEl?.closest('.ak-editor-content-area');
    const pluginsComponentsWrapper = editorContentArea?.querySelector(':scope > [data-testid="plugins-components-wrapper"]');
    return pluginsComponentsWrapper || undefined;
};
module.exports["getPopupContainerFromEditorView"] = $d3e68692beaa23af$export$f562a1e3da45e3ca;

});

parcelRegister("h2tni", function(module, exports) {
const $c9c70b2ae36edf91$export$fe7123d322bc7614 = (editorView)=>{
    if (!editorView) return null;
    const pmDom = editorView.dom;
    const { selection: selection } = editorView.state;
    // nodeDOM can return null when editor loses focus (e.g. toolbar click) or for certain positions.
    // Fall back to domAtPos which resolves the DOM node at the given position.
    let currentNode = editorView.nodeDOM(selection.from);
    if (!currentNode) try {
        const { node: node } = editorView.domAtPos(selection.from);
        currentNode = node instanceof HTMLElement ? node : node.parentElement;
    } catch  {
        return null;
    }
    let lastValidAncestor = currentNode;
    while(currentNode instanceof HTMLElement && currentNode !== pmDom){
        lastValidAncestor = currentNode;
        currentNode = currentNode.parentElement;
    }
    return lastValidAncestor instanceof HTMLElement ? lastValidAncestor : null;
};
module.exports["getSelectionAncestorDOM"] = $c9c70b2ae36edf91$export$fe7123d322bc7614;

});

parcelRegister("cMZNY", function(module, exports) {
// Ignored via go/ees005
// eslint-disable-next-line import/no-namespace
// src/clipboard-polyfill/ClipboardItem/data-types.ts
var $7813eb29dc3c6007$var$TEXT_PLAIN = "text/plain";
var $7813eb29dc3c6007$var$TEXT_HTML = "text/html";
// src/clipboard-polyfill/debug.ts
var $7813eb29dc3c6007$var$debugLogImpl = (s)=>{};
function $7813eb29dc3c6007$var$debugLog(s) {
    $7813eb29dc3c6007$var$debugLogImpl(s);
}
function $7813eb29dc3c6007$export$e014146e87162c32(logFn) {
    $7813eb29dc3c6007$var$debugLogImpl = logFn;
}
var $7813eb29dc3c6007$var$showWarnings = true;
function $7813eb29dc3c6007$export$ba5c9528becaaf25() {
    $7813eb29dc3c6007$var$showWarnings = false;
}
function $7813eb29dc3c6007$var$shouldShowWarnings() {
    return $7813eb29dc3c6007$var$showWarnings;
}
function $7813eb29dc3c6007$var$warnOrLog() {
    (console.warn || console.log).apply(console, arguments);
}
var $7813eb29dc3c6007$var$warn = $7813eb29dc3c6007$var$warnOrLog.bind("[clipboard-polyfill]");
// src/clipboard-polyfill/builtins/window-globalThis.ts
var $7813eb29dc3c6007$var$originalWindow = typeof window === "undefined" ? void 0 : window;
var $7813eb29dc3c6007$var$originalGlobalThis = typeof globalThis === "undefined" ? void 0 : globalThis;
// src/clipboard-polyfill/builtins/promise-constructor.ts
var $7813eb29dc3c6007$var$_a, $7813eb29dc3c6007$var$_b, $7813eb29dc3c6007$var$_c;
var $7813eb29dc3c6007$var$promiseConstructorImpl = ($7813eb29dc3c6007$var$_c = ($7813eb29dc3c6007$var$_a = $7813eb29dc3c6007$var$originalWindow) == null ? void 0 : $7813eb29dc3c6007$var$_a.Promise) != null ? $7813eb29dc3c6007$var$_c : ($7813eb29dc3c6007$var$_b = $7813eb29dc3c6007$var$originalGlobalThis) == null ? void 0 : $7813eb29dc3c6007$var$_b.Promise;
function $7813eb29dc3c6007$var$getPromiseConstructor() {
    if (!$7813eb29dc3c6007$var$promiseConstructorImpl) throw new Error("No `Promise` implementation available for `clipboard-polyfill`. Consider using: https://github.com/lgarron/clipboard-polyfill#flat-file-version-with-promise-included");
    return $7813eb29dc3c6007$var$promiseConstructorImpl;
}
// src/clipboard-polyfill/builtins/builtin-globals.ts
var $7813eb29dc3c6007$var$originalNavigator = typeof navigator === "undefined" ? void 0 : navigator;
var $7813eb29dc3c6007$var$originalNavigatorClipboard = $7813eb29dc3c6007$var$originalNavigator == null ? void 0 : $7813eb29dc3c6007$var$originalNavigator.clipboard;
var $7813eb29dc3c6007$var$_a2;
var $7813eb29dc3c6007$var$originalNavigatorClipboardRead = ($7813eb29dc3c6007$var$_a2 = $7813eb29dc3c6007$var$originalNavigatorClipboard == null ? void 0 : $7813eb29dc3c6007$var$originalNavigatorClipboard.read) == null ? void 0 : $7813eb29dc3c6007$var$_a2.bind($7813eb29dc3c6007$var$originalNavigatorClipboard);
var $7813eb29dc3c6007$var$_a3;
var $7813eb29dc3c6007$var$originalNavigatorClipboardReadText = ($7813eb29dc3c6007$var$_a3 = $7813eb29dc3c6007$var$originalNavigatorClipboard == null ? void 0 : $7813eb29dc3c6007$var$originalNavigatorClipboard.readText) == null ? void 0 : $7813eb29dc3c6007$var$_a3.bind($7813eb29dc3c6007$var$originalNavigatorClipboard);
var $7813eb29dc3c6007$var$_a4;
var $7813eb29dc3c6007$var$originalNavigatorClipboardWrite = ($7813eb29dc3c6007$var$_a4 = $7813eb29dc3c6007$var$originalNavigatorClipboard == null ? void 0 : $7813eb29dc3c6007$var$originalNavigatorClipboard.write) == null ? void 0 : $7813eb29dc3c6007$var$_a4.bind($7813eb29dc3c6007$var$originalNavigatorClipboard);
var $7813eb29dc3c6007$var$_a5;
var $7813eb29dc3c6007$var$originalNavigatorClipboardWriteText = ($7813eb29dc3c6007$var$_a5 = $7813eb29dc3c6007$var$originalNavigatorClipboard == null ? void 0 : $7813eb29dc3c6007$var$originalNavigatorClipboard.writeText) == null ? void 0 : $7813eb29dc3c6007$var$_a5.bind($7813eb29dc3c6007$var$originalNavigatorClipboard);
var $7813eb29dc3c6007$var$_a6;
var $7813eb29dc3c6007$var$originalWindowClipboardItem = ($7813eb29dc3c6007$var$_a6 = $7813eb29dc3c6007$var$originalWindow) == null ? void 0 : $7813eb29dc3c6007$var$_a6.ClipboardItem;
var $7813eb29dc3c6007$var$promiseConstructor = $7813eb29dc3c6007$var$getPromiseConstructor();
// src/clipboard-polyfill/strategies/internet-explorer.ts
var $7813eb29dc3c6007$var$ieWindow = $7813eb29dc3c6007$var$originalWindow;
function $7813eb29dc3c6007$var$seemToBeInIE() {
    return typeof ClipboardEvent === "undefined" && typeof ($7813eb29dc3c6007$var$ieWindow == null ? void 0 : $7813eb29dc3c6007$var$ieWindow.clipboardData) !== "undefined" && typeof ($7813eb29dc3c6007$var$ieWindow == null ? void 0 : $7813eb29dc3c6007$var$ieWindow.clipboardData.setData) !== "undefined";
}
function $7813eb29dc3c6007$var$writeTextIE(text) {
    if (!$7813eb29dc3c6007$var$ieWindow.clipboardData) return false;
    var success = $7813eb29dc3c6007$var$ieWindow.clipboardData.setData("Text", text);
    if (success) $7813eb29dc3c6007$var$debugLog("writeTextIE worked");
    return success;
}
function $7813eb29dc3c6007$var$readTextIE() {
    if (!$7813eb29dc3c6007$var$ieWindow.clipboardData) throw new Error("Cannot read IE clipboard Data ");
    var text = $7813eb29dc3c6007$var$ieWindow.clipboardData.getData("Text");
    if (text === "") throw new Error("Empty clipboard or could not read plain text from clipboard");
    return text;
}
// src/clipboard-polyfill/strategies/dom.ts
function $7813eb29dc3c6007$var$copyListener(tracker, data, e) {
    $7813eb29dc3c6007$var$debugLog("listener called");
    tracker.success = true;
    for(var type in data){
        var value = data[type];
        var clipboardData = e.clipboardData;
        clipboardData.setData(type, value);
        if (type === $7813eb29dc3c6007$var$TEXT_PLAIN && clipboardData.getData(type) !== value) {
            $7813eb29dc3c6007$var$debugLog("setting text/plain failed");
            tracker.success = false;
        }
    }
    e.preventDefault();
}
function $7813eb29dc3c6007$var$execCopy(data) {
    var tracker = {
        success: false
    };
    var listener = $7813eb29dc3c6007$var$copyListener.bind(this, tracker, data);
    document.addEventListener("copy", listener);
    try {
        document.execCommand("copy");
    } finally{
        document.removeEventListener("copy", listener);
    }
    return tracker.success;
}
function $7813eb29dc3c6007$var$copyUsingTempSelection(e, data) {
    $7813eb29dc3c6007$var$selectionSet(e);
    var success = $7813eb29dc3c6007$var$execCopy(data);
    $7813eb29dc3c6007$var$selectionClear();
    return success;
}
function $7813eb29dc3c6007$var$copyUsingTempElem(data) {
    var tempElem = document.createElement("div");
    tempElem.setAttribute("style", "-webkit-user-select: text !important");
    tempElem.textContent = "temporary element";
    document.body.appendChild(tempElem);
    var success = $7813eb29dc3c6007$var$copyUsingTempSelection(tempElem, data);
    document.body.removeChild(tempElem);
    return success;
}
function $7813eb29dc3c6007$var$copyTextUsingDOM(str) {
    $7813eb29dc3c6007$var$debugLog("copyTextUsingDOM");
    var tempElem = document.createElement("div");
    tempElem.setAttribute("style", "-webkit-user-select: text !important");
    var spanParent = tempElem;
    if (tempElem.attachShadow) {
        $7813eb29dc3c6007$var$debugLog("Using shadow DOM.");
        spanParent = tempElem.attachShadow({
            mode: "open"
        });
    }
    var span = document.createElement("span");
    span.innerText = str;
    spanParent.appendChild(span);
    document.body.appendChild(tempElem);
    $7813eb29dc3c6007$var$selectionSet(span);
    var result = document.execCommand("copy");
    $7813eb29dc3c6007$var$selectionClear();
    document.body.removeChild(tempElem);
    return result;
}
function $7813eb29dc3c6007$var$selectionSet(elem) {
    var sel = document.getSelection();
    if (sel) {
        var range = document.createRange();
        range.selectNodeContents(elem);
        sel.removeAllRanges();
        sel.addRange(range);
    }
}
function $7813eb29dc3c6007$var$selectionClear() {
    var sel = document.getSelection();
    if (sel) sel.removeAllRanges();
}
// src/clipboard-polyfill/implementations/write-fallback.ts
function $7813eb29dc3c6007$var$writeFallback(stringItem) {
    var hasTextPlain = $7813eb29dc3c6007$var$TEXT_PLAIN in stringItem;
    if ($7813eb29dc3c6007$var$seemToBeInIE()) {
        if (!hasTextPlain) throw new Error("No `text/plain` value was specified.");
        if ($7813eb29dc3c6007$var$writeTextIE(stringItem[$7813eb29dc3c6007$var$TEXT_PLAIN])) return true;
        else throw new Error("Copying failed, possibly because the user rejected it.");
    }
    if ($7813eb29dc3c6007$var$execCopy(stringItem)) {
        $7813eb29dc3c6007$var$debugLog("regular execCopy worked");
        return true;
    }
    if (navigator.userAgent.indexOf("Edge") > -1) {
        $7813eb29dc3c6007$var$debugLog('UA "Edge" => assuming success');
        return true;
    }
    if ($7813eb29dc3c6007$var$copyUsingTempSelection(document.body, stringItem)) {
        $7813eb29dc3c6007$var$debugLog("copyUsingTempSelection worked");
        return true;
    }
    if ($7813eb29dc3c6007$var$copyUsingTempElem(stringItem)) {
        $7813eb29dc3c6007$var$debugLog("copyUsingTempElem worked");
        return true;
    }
    if ($7813eb29dc3c6007$var$copyTextUsingDOM(stringItem[$7813eb29dc3c6007$var$TEXT_PLAIN])) {
        $7813eb29dc3c6007$var$debugLog("copyTextUsingDOM worked");
        return true;
    }
    return false;
}
// src/clipboard-polyfill/promise/promise-compat.ts
function $7813eb29dc3c6007$var$promiseRecordMap(keys, f) {
    var promiseList = [];
    for(var i in keys){
        var key = keys[i];
        promiseList.push(f(key));
    }
    return $7813eb29dc3c6007$var$promiseConstructor.all(promiseList).then((vList)=>{
        var dataOut = {};
        for(var i2 = 0; i2 < keys.length; i2++)dataOut[keys[i2]] = vList[i2];
        return dataOut;
    });
}
var $7813eb29dc3c6007$var$voidPromise = $7813eb29dc3c6007$var$promiseConstructor.resolve();
var $7813eb29dc3c6007$var$truePromiseFn = ()=>$7813eb29dc3c6007$var$promiseConstructor.resolve(true);
var $7813eb29dc3c6007$var$falsePromise = $7813eb29dc3c6007$var$promiseConstructor.resolve(false);
function $7813eb29dc3c6007$var$rejectThrownErrors(executor) {
    return new $7813eb29dc3c6007$var$promiseConstructor((resolve, reject)=>{
        try {
            resolve(executor());
        } catch (e) {
            reject(e);
        }
    });
}
// src/clipboard-polyfill/implementations/text.ts
function $7813eb29dc3c6007$var$stringToStringItem(s) {
    var stringItem = {};
    stringItem[$7813eb29dc3c6007$var$TEXT_PLAIN] = s;
    return stringItem;
}
function $7813eb29dc3c6007$export$bec150f75a9b8f11(s) {
    return $7813eb29dc3c6007$var$rejectThrownErrors(()=>{
        if ($7813eb29dc3c6007$var$originalNavigatorClipboardWriteText) {
            $7813eb29dc3c6007$var$debugLog("Using `navigator.clipboard.writeText()`.");
            return $7813eb29dc3c6007$var$originalNavigatorClipboardWriteText(s).catch($7813eb29dc3c6007$var$writeTextStringFallback);
        }
        return $7813eb29dc3c6007$var$promiseConstructor.resolve($7813eb29dc3c6007$var$writeTextStringFallback(s));
    });
}
function $7813eb29dc3c6007$var$writeTextStringFallback(s) {
    if (!$7813eb29dc3c6007$var$writeFallback($7813eb29dc3c6007$var$stringToStringItem(s))) throw new Error("writeText() failed");
}
function $7813eb29dc3c6007$export$bee0113684d8879b() {
    return $7813eb29dc3c6007$var$rejectThrownErrors(()=>{
        if ($7813eb29dc3c6007$var$originalNavigatorClipboardReadText) {
            $7813eb29dc3c6007$var$debugLog("Using `navigator.clipboard.readText()`.");
            return $7813eb29dc3c6007$var$originalNavigatorClipboardReadText();
        }
        if ($7813eb29dc3c6007$var$seemToBeInIE()) {
            var result = $7813eb29dc3c6007$var$readTextIE();
            return $7813eb29dc3c6007$var$promiseConstructor.resolve(result);
        }
        throw new Error("Read is not supported in your browser.");
    });
}
// src/clipboard-polyfill/ClipboardItem/check.ts
function $7813eb29dc3c6007$var$hasItemWithType(clipboardItems, typeName) {
    for(var i in clipboardItems){
        var item = clipboardItems[i];
        if (item.types.indexOf(typeName) !== -1) return true;
    }
    return false;
}
// src/clipboard-polyfill/ClipboardItem/ClipboardItemPolyfill.ts
function $7813eb29dc3c6007$var$ClipboardItemPolyfillImpl(items, options) {
    var _a7;
    var types = Object.keys(items);
    var _items = {};
    for(var type in items){
        var item = items[type];
        if (typeof item === "string") _items[type] = $7813eb29dc3c6007$var$stringToBlob(type, item);
        else _items[type] = item;
    }
    var presentationStyle = (_a7 = options == null ? void 0 : options.presentationStyle) != null ? _a7 : "unspecified";
    function getType(type2) {
        return $7813eb29dc3c6007$var$promiseConstructor.resolve(_items[type2]);
    }
    return {
        types: types,
        presentationStyle: presentationStyle,
        getType: getType
    };
}
var $7813eb29dc3c6007$export$3b1380c0957dc8fe = $7813eb29dc3c6007$var$ClipboardItemPolyfillImpl;
// src/clipboard-polyfill/ClipboardItem/convert.ts
function $7813eb29dc3c6007$var$stringToBlob(type, str) {
    return new Blob([
        str
    ], {
        type: type
    });
}
function $7813eb29dc3c6007$var$blobToString(blob) {
    return new $7813eb29dc3c6007$var$promiseConstructor((resolve, reject)=>{
        var fileReader = new FileReader();
        fileReader.addEventListener("load", ()=>{
            var result = fileReader.result;
            if (typeof result === "string") resolve(result);
            else reject("could not convert blob to string");
        });
        fileReader.readAsText(blob);
    });
}
function $7813eb29dc3c6007$var$clipboardItemToGlobalClipboardItem(clipboardItem) {
    return $7813eb29dc3c6007$var$promiseRecordMap(clipboardItem.types, function(type) {
        return clipboardItem.getType(type);
    }).then((items)=>{
        return new Promise((resolve, reject)=>{
            var options = {};
            if (clipboardItem.presentationStyle) options.presentationStyle = clipboardItem.presentationStyle;
            if ($7813eb29dc3c6007$var$originalWindowClipboardItem) resolve(new $7813eb29dc3c6007$var$originalWindowClipboardItem(items, options));
            else reject("window.ClipboardItem is not defined");
        });
    });
}
function $7813eb29dc3c6007$var$textToClipboardItem(text) {
    var items = {};
    items[$7813eb29dc3c6007$var$TEXT_PLAIN] = $7813eb29dc3c6007$var$stringToBlob(text, $7813eb29dc3c6007$var$TEXT_PLAIN);
    return new $7813eb29dc3c6007$export$3b1380c0957dc8fe(items);
}
function $7813eb29dc3c6007$var$getTypeAsString(clipboardItem, type) {
    return clipboardItem.getType(type).then((text)=>{
        return $7813eb29dc3c6007$var$blobToString(text);
    });
}
function $7813eb29dc3c6007$var$toStringItem(data) {
    return $7813eb29dc3c6007$var$promiseRecordMap(data.types, function(type) {
        return $7813eb29dc3c6007$var$getTypeAsString(data, type);
    });
}
// src/clipboard-polyfill/implementations/blob.ts
function $7813eb29dc3c6007$export$68d8715fc104d294(data) {
    return $7813eb29dc3c6007$var$rejectThrownErrors(()=>{
        if ($7813eb29dc3c6007$var$originalNavigatorClipboardWrite && $7813eb29dc3c6007$var$originalWindowClipboardItem) {
            var originalNavigatorClipboardWriteCached = $7813eb29dc3c6007$var$originalNavigatorClipboardWrite;
            $7813eb29dc3c6007$var$debugLog("Using `navigator.clipboard.write()`.");
            return $7813eb29dc3c6007$var$promiseConstructor.all(data.map($7813eb29dc3c6007$var$clipboardItemToGlobalClipboardItem)).then((globalClipboardItems)=>{
                return originalNavigatorClipboardWriteCached(globalClipboardItems).then($7813eb29dc3c6007$var$truePromiseFn).catch((e)=>{
                    if (!$7813eb29dc3c6007$var$hasItemWithType(data, $7813eb29dc3c6007$var$TEXT_PLAIN) && !$7813eb29dc3c6007$var$hasItemWithType(data, $7813eb29dc3c6007$var$TEXT_HTML)) throw e;
                    return $7813eb29dc3c6007$var$falsePromise;
                });
            });
        }
        return $7813eb29dc3c6007$var$falsePromise;
    }).then((success)=>{
        if (success) return $7813eb29dc3c6007$var$voidPromise;
        var hasTextPlain = $7813eb29dc3c6007$var$hasItemWithType(data, $7813eb29dc3c6007$var$TEXT_PLAIN);
        if ($7813eb29dc3c6007$var$shouldShowWarnings() && !hasTextPlain) $7813eb29dc3c6007$var$debugLog("clipboard.write() was called without a `text/plain` data type. On some platforms, this may result in an empty clipboard. Call suppressWarnings() to suppress this warning.");
        return $7813eb29dc3c6007$var$toStringItem(data[0]).then((stringItem)=>{
            if (!$7813eb29dc3c6007$var$writeFallback(stringItem)) throw new Error("write() failed");
        });
    });
}
function $7813eb29dc3c6007$export$aafa59e2e03f2942() {
    return $7813eb29dc3c6007$var$rejectThrownErrors(()=>{
        if ($7813eb29dc3c6007$var$originalNavigatorClipboardRead) {
            $7813eb29dc3c6007$var$debugLog("Using `navigator.clipboard.read()`.");
            return $7813eb29dc3c6007$var$originalNavigatorClipboardRead();
        }
        return $7813eb29dc3c6007$export$bee0113684d8879b().then((text)=>{
            return [
                $7813eb29dc3c6007$var$textToClipboardItem(text)
            ];
        });
    });
}



var $ks2lK = parcelRequire("ks2lK");


var $d925B = parcelRequire("d925B");


var $3tffm = parcelRequire("3tffm");

const $3f954b662a01f19d$var$isClipboardApiSupported = ()=>!!navigator.clipboard && typeof navigator.clipboard.writeText === 'function';
const $3f954b662a01f19d$var$isIEClipboardApiSupported = ()=>// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.clipboardData && typeof window.clipboardData.setData === 'function';
const $3f954b662a01f19d$var$isExtensionNode = (node)=>{
    if (node === 'extension' || node === 'bodiedExtension' || node === 'inlineExtension' || node === 'multiBodiedExtension') return true;
    return false;
};
const $3f954b662a01f19d$export$2cdf1b96a9f86d16 = async (textToCopy)=>{
    if ($3f954b662a01f19d$var$isClipboardApiSupported()) try {
        await navigator.clipboard.writeText(textToCopy);
    } catch (error) {
        throw new Error('Clipboard api is not supported');
    }
    else if ($3f954b662a01f19d$var$isIEClipboardApiSupported()) try {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        await window.clipboardData.setData('text', textToCopy);
    } catch (error) {
        throw new Error('IE clipboard api is not supported');
    }
    else throw new Error('Clipboard api is not supported');
};
const $3f954b662a01f19d$export$8b344d2a6a3e9af3 = async (elementToCopy, plainTextToCopy)=>{
    // @ts-ignore
    if ($3f954b662a01f19d$var$isClipboardApiSupported() && typeof ClipboardItem !== 'undefined') try {
        const data = new ClipboardItem({
            'text/plain': new Blob([
                plainTextToCopy || elementToCopy.innerText
            ], {
                type: 'text/plain'
            }),
            'text/html': new Blob([
                elementToCopy.innerHTML
            ], {
                type: 'text/html'
            })
        });
        // @ts-ignore
        await navigator.clipboard.write([
            data
        ]);
    } catch (error) {
        throw new Error('Clipboard api is not supported');
    }
    else if (!!document && typeof document === 'object') try {
        // ED-17083 extension copy seems have issue with ClipboardItem API
        // Hence of use of this polyfill
        $3f954b662a01f19d$export$97e18ff8b98c7078(elementToCopy, plainTextToCopy);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
    }
};
const $3f954b662a01f19d$export$97e18ff8b98c7078 = async (elementToCopy, plainTextToCopy)=>{
    const dt = new $7813eb29dc3c6007$export$3b1380c0957dc8fe({
        'text/html': new Blob([
            elementToCopy.innerHTML
        ], {
            type: 'text/html'
        }),
        'text/plain': new Blob([
            plainTextToCopy || elementToCopy.innerText
        ], {
            type: 'text/plain'
        })
    });
    await $7813eb29dc3c6007$export$68d8715fc104d294([
        dt
    ]);
};
const $3f954b662a01f19d$export$4feda93c1c6b2d80 = (state, action)=>{
    const { selection: selection, doc: doc } = state;
    const selectionAnalyticsPayload = (0, $3tffm.getNodeSelectionAnalyticsPayload)(selection) || (0, $3tffm.getRangeSelectionAnalyticsPayload)(selection, doc) || (0, $3tffm.getAllSelectionAnalyticsPayload)(selection) || (0, $3tffm.getCellSelectionAnalyticsPayload)(state);
    if (selectionAnalyticsPayload) {
        const { actionSubjectId: selectionActionSubjectId } = selectionAnalyticsPayload;
        const node = selectionAnalyticsPayload.attributes?.node;
        const content = [];
        let extensionType;
        let extensionKey;
        switch(selectionActionSubjectId){
            case (0, $d925B.ACTION_SUBJECT_ID).NODE:
                if (node) {
                    content.push(node);
                    if ($3f954b662a01f19d$var$isExtensionNode(node)) {
                        extensionType = selection.node.attrs.extensionType;
                        extensionKey = selection.node.attrs.extensionKey;
                    }
                }
                break;
            case (0, $d925B.ACTION_SUBJECT_ID).RANGE:
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                content.push(...selectionAnalyticsPayload.attributes.nodes);
                break;
            case (0, $d925B.ACTION_SUBJECT_ID).ALL:
                content.push('all');
                break;
            case (0, $d925B.ACTION_SUBJECT_ID).CELL:
                {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    const { selectedCells: selectedCells } = selectionAnalyticsPayload.attributes;
                    content.push(...Array(selectedCells).fill('tableCell'));
                    break;
                }
        }
        if ($3f954b662a01f19d$var$isExtensionNode(node)) return {
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            action: action,
            actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
            attributes: {
                content: content,
                extensionKey: extensionKey,
                extensionType: extensionType
            }
        };
        return {
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            action: action,
            actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
            attributes: {
                content: content
            }
        };
    }
    if (selection instanceof (0, $ks2lK.TextSelection) && selection.$cursor) return {
        eventType: (0, $d925B.EVENT_TYPE).TRACK,
        action: action,
        actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
        attributes: {
            content: [
                'caret'
            ]
        }
    };
};
const $3f954b662a01f19d$export$f8811fa45a00fd64 = (node, inputMethod)=>{
    const nodeType = node.type.name;
    let extensionType;
    let extensionKey;
    if ($3f954b662a01f19d$var$isExtensionNode(nodeType)) {
        extensionType = node.attrs.extensionType;
        extensionKey = node.attrs.extensionKey;
    }
    const payload = {
        eventType: (0, $d925B.EVENT_TYPE).TRACK,
        action: (0, $d925B.ACTION).COPIED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
        attributes: {
            content: [
                nodeType
            ],
            inputMethod: inputMethod,
            nodeType: nodeType,
            ...extensionType ? {
                extensionType: extensionType
            } : {},
            ...extensionKey ? {
                extensionKey: extensionKey
            } : {}
        }
    };
    return payload;
};
module.exports["copyToClipboard"] = $3f954b662a01f19d$export$2cdf1b96a9f86d16;
module.exports["copyHTMLToClipboard"] = $3f954b662a01f19d$export$8b344d2a6a3e9af3;
module.exports["copyHTMLToClipboardPolyfill"] = $3f954b662a01f19d$export$97e18ff8b98c7078;
module.exports["getAnalyticsPayload"] = $3f954b662a01f19d$export$4feda93c1c6b2d80;
module.exports["getNodeCopiedAnalyticsPayload"] = $3f954b662a01f19d$export$f8811fa45a00fd64;

});

parcelRegister("3tffm", function(module, exports) {
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $ks2lK = parcelRequire("ks2lK");


var $7XFGZ = parcelRequire("7XFGZ");


var $2QyFu = parcelRequire("2QyFu");


var $d925B = parcelRequire("d925B");


var $cQ4aK = parcelRequire("cQ4aK");


var $9GYNY = parcelRequire("9GYNY");


var $adhil = parcelRequire("adhil");


var $1zPzM = parcelRequire("1zPzM");


var $4Wd8f = parcelRequire("4Wd8f");


var $1gpr6 = parcelRequire("1gpr6");


var $7MBVC = parcelRequire("7MBVC");


var $4AaC5 = parcelRequire("4AaC5");


var $e2a9y = parcelRequire("e2a9y");


var $laABt = parcelRequire("laABt");


var $1iYLq = parcelRequire("1iYLq");


var $eYkq0 = parcelRequire("eYkq0");


var $aBqgN = parcelRequire("aBqgN");


var $ei5Ah = parcelRequire("ei5Ah");


var $1ts3S = parcelRequire("1ts3S");


var $fJNAd = parcelRequire("fJNAd");


var $l6okE = parcelRequire("l6okE");



var $B9v3F = parcelRequire("B9v3F");


var $g4GD8 = parcelRequire("g4GD8");

function $a29160445daaaad7$export$3162c38157c33ee6(selection) {
    if (selection instanceof (0, $ks2lK.NodeSelection)) return {
        action: (0, $d925B.ACTION).SELECTED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).NODE,
        eventType: (0, $d925B.EVENT_TYPE).TRACK,
        attributes: {
            node: selection.node.type.name
        }
    };
}
function $a29160445daaaad7$export$9f3a063378bdcaa1(selection) {
    if (selection instanceof (0, $ks2lK.AllSelection)) return {
        action: (0, $d925B.ACTION).SELECTED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).ALL,
        eventType: (0, $d925B.EVENT_TYPE).TRACK
    };
}
function $a29160445daaaad7$export$dcdd07dcad6adb98(state) {
    if (state.selection instanceof (0, $7XFGZ.CellSelection)) {
        const rect = (0, $2QyFu.selectedRect)(state);
        const selectedCells = rect.map.cellsInRect(rect).length;
        const totalCells = rect.map.map.length;
        return {
            action: (0, $d925B.ACTION).SELECTED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).CELL,
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            attributes: {
                selectedCells: selectedCells,
                totalCells: totalCells
            }
        };
    }
}
function $a29160445daaaad7$export$bf6883b886d952b0(selection, doc) {
    if (selection instanceof (0, $ks2lK.TextSelection) && selection.from !== selection.to) {
        const { from: from, to: to, anchor: anchor, head: head } = selection;
        const nodes = [];
        doc.nodesBetween(from, to, (node, pos)=>{
            // We want to send top-level nodes only, ie.the nodes that would have the selection styling
            // We allow text nodes that are not fully covered as they are a special case
            if (node.isText || pos >= from && pos + node.nodeSize <= to) {
                nodes.push(node.type.name);
                return false;
            }
        });
        return {
            action: (0, $d925B.ACTION).SELECTED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).RANGE,
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            attributes: {
                from: anchor,
                to: head,
                nodes: nodes
            }
        };
    }
}
const $a29160445daaaad7$export$cbcb4f775d907a9e = (pos)=>(state, dispatch)=>{
        if (dispatch) dispatch(state.tr.setSelection(new (0, $ks2lK.NodeSelection)(state.doc.resolve(pos))));
        return true;
    };
function $a29160445daaaad7$export$563f7987ca7936f1(nodes, isValidTarget, options) {
    return function handleClickOn(view, _pos, node, nodePos, event, direct) {
        if (options.useLongPressSelection) return false;
        if (direct && nodes.indexOf(node.type.name) !== -1) {
            const target = event.target;
            if (target instanceof HTMLElement && isValidTarget(target)) {
                const selectionPos = options.getNodeSelectionPos ? options.getNodeSelectionPos(view.state, nodePos) : nodePos;
                $a29160445daaaad7$export$cbcb4f775d907a9e(selectionPos)(view.state, view.dispatch);
                return true;
            }
        }
        return false;
    };
}
module.exports["getNodeSelectionAnalyticsPayload"] = $a29160445daaaad7$export$3162c38157c33ee6;
module.exports["getAllSelectionAnalyticsPayload"] = $a29160445daaaad7$export$9f3a063378bdcaa1;
module.exports["getCellSelectionAnalyticsPayload"] = $a29160445daaaad7$export$dcdd07dcad6adb98;
module.exports["getRangeSelectionAnalyticsPayload"] = $a29160445daaaad7$export$bf6883b886d952b0;
module.exports["createSelectionClickHandler"] = $a29160445daaaad7$export$563f7987ca7936f1;

});

parcelRegister("2QyFu", function(module, exports) {

var $7XFGZ = parcelRequire("7XFGZ");


var $LmqWp = parcelRequire("LmqWp");


var $bzgWU = parcelRequire("bzgWU");

function $a1ed12d37858472c$export$39ce22e69aa9ed17(state) {
    const sel = state.selection;
    const $pos = (0, $bzgWU.selectionCell)(sel);
    if (!$pos) throw new Error(`selectedRect: invalid $pos for selection`);
    const table = $pos.node(-1);
    const tableStart = $pos.start(-1);
    const map = (0, $LmqWp.TableMap).get(table);
    let rect;
    if (sel instanceof (0, $7XFGZ.CellSelection)) rect = map.rectBetween(sel.$anchorCell.pos - tableStart, sel.$headCell.pos - tableStart);
    else rect = map.findCell($pos.pos - tableStart);
    rect.tableStart = tableStart;
    rect.map = map;
    rect.table = table;
    return rect;
}
module.exports["selectedRect"] = $a1ed12d37858472c$export$39ce22e69aa9ed17;

});

parcelRegister("bzgWU", function(module, exports) {

var $3gZJH = parcelRequire("3gZJH");


var $BW42l = parcelRequire("BW42l");

function $bfcd59b788b6891b$export$aad75348c8f2d244(selection) {
    if ((0, $BW42l.isSelectionType)(selection, 'cell')) return selection.$anchorCell.pos > selection.$headCell.pos ? selection.$anchorCell : selection.$headCell;
    if ((0, $BW42l.isSelectionType)(selection, 'node') && selection.node.type.spec.tableRole === 'cell') return selection.$anchor;
    return (0, $3gZJH.cellAround)(selection.$head) || (0, $3gZJH.cellNear)(selection.$head);
}
module.exports["selectionCell"] = $bfcd59b788b6891b$export$aad75348c8f2d244;

});

parcelRegister("cQ4aK", function(module, exports) {
var $690bdb97400535ac$export$cb9005d223ae8de7 = /*#__PURE__*/ function(RelativeSelectionPos) {
    RelativeSelectionPos["Before"] = "Before";
    RelativeSelectionPos["Start"] = "Start";
    RelativeSelectionPos["Inside"] = "Inside";
    RelativeSelectionPos["End"] = "End";
    return RelativeSelectionPos;
}({});
module.exports["RelativeSelectionPos"] = $690bdb97400535ac$export$cb9005d223ae8de7;

});

parcelRegister("7MBVC", function(module, exports) {

var $adhil = parcelRequire("adhil");

function $14cc120ba181cab8$export$a8946811e8b82dd(view, pos, side) {
    const { state: state } = view;
    view.dispatch(state.tr.setSelection(new (0, $adhil.GapCursorSelection)(state.doc.resolve(pos), side)));
}
module.exports["setGapCursorSelection"] = $14cc120ba181cab8$export$a8946811e8b82dd;

});

parcelRegister("4AaC5", function(module, exports) {
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");

const $952b6472eb391b70$var$gapCursorBlink = (0, $9K4OG.keyframes)({
    'from, to': {
        opacity: 0
    },
    '50%': {
        opacity: 1
    }
});
const $952b6472eb391b70$export$8adc5edbc4a22166 = 'ProseMirror-hide-gapcursor';
const $952b6472eb391b70$var$gapCursor = '.ProseMirror-gapcursor';
const $952b6472eb391b70$var$prosemirrorwidgetNotBlock = '.ProseMirror-widget:not([data-blocks-decoration-container="true"]):not([data-blocks-drag-handle-container="true"]):not([data-blocks-quick-insert-container="true"])';
const $952b6472eb391b70$var$wrapLeft = '[layout="wrap-left"]';
const $952b6472eb391b70$var$wrapRight = '[layout="wrap-right"]';
const $952b6472eb391b70$export$f6b9d90c2745834e = /*#__PURE__*/ (0, $9K4OG.css)(".ProseMirror{&.", $952b6472eb391b70$export$8adc5edbc4a22166, "{caret-color:transparent;}", $952b6472eb391b70$var$gapCursor, "{display:none;pointer-events:none;position:relative;& span{caret-color:transparent;position:absolute;height:100%;width:100%;display:block;}& span::after{animation:1s ", $952b6472eb391b70$var$gapCursorBlink, " step-start infinite;border-left:1px solid;content:'';display:block;position:absolute;top:0;height:100%;}&.-left span::after{left:var(--ds-space-negative-050, -4px);}&.-right span::after{right:var(--ds-space-negative-050, -4px);}& span[layout='full-width'],& span[layout='wide'],& span[layout='fixed-width']{margin-left:50%;transform:translateX(-50%);}&", $952b6472eb391b70$var$wrapRight, "{float:right;}&:first-of-type+ul,&:first-of-type+span+ul,&:first-of-type+ol,&:first-of-type+span+ol,&:first-of-type+pre,&:first-of-type+span+pre,&:first-of-type+blockquote,&:first-of-type+span+blockquote{margin-top:0;}}&.ProseMirror-focused ", $952b6472eb391b70$var$gapCursor, "{display:block;border-color:transparent;}}", $952b6472eb391b70$var$gapCursor, $952b6472eb391b70$var$wrapLeft, "+span+", $952b6472eb391b70$var$wrapLeft, ",", $952b6472eb391b70$var$gapCursor, $952b6472eb391b70$var$wrapRight, "+span+", $952b6472eb391b70$var$wrapRight, ",", $952b6472eb391b70$var$gapCursor, "+", $952b6472eb391b70$var$wrapLeft, "+", $952b6472eb391b70$var$wrapRight, ",", $952b6472eb391b70$var$gapCursor, "+", $952b6472eb391b70$var$wrapLeft, "+span+", $952b6472eb391b70$var$wrapRight, ",", $952b6472eb391b70$var$gapCursor, "+", $952b6472eb391b70$var$wrapRight, "+", $952b6472eb391b70$var$wrapLeft, ",", $952b6472eb391b70$var$gapCursor, "+", $952b6472eb391b70$var$wrapRight, "+span+", $952b6472eb391b70$var$wrapLeft, ",", $952b6472eb391b70$var$wrapLeft, "+", $952b6472eb391b70$var$gapCursor, "+", $952b6472eb391b70$var$wrapRight, ",", $952b6472eb391b70$var$wrapLeft, "+", $952b6472eb391b70$var$gapCursor, "+span ", $952b6472eb391b70$var$wrapRight, ",", $952b6472eb391b70$var$wrapRight, "+", $952b6472eb391b70$var$gapCursor, "+", $952b6472eb391b70$var$wrapLeft, ",", $952b6472eb391b70$var$wrapRight, "+", $952b6472eb391b70$var$gapCursor, "+span+", $952b6472eb391b70$var$wrapLeft, ",", $952b6472eb391b70$var$wrapLeft, "+", $952b6472eb391b70$var$gapCursor, "{clear:none;}", $952b6472eb391b70$var$wrapLeft, "+", $952b6472eb391b70$var$gapCursor, "+", $952b6472eb391b70$var$wrapRight, ">div,", $952b6472eb391b70$var$wrapLeft, "+", $952b6472eb391b70$var$gapCursor, "+span+", $952b6472eb391b70$var$wrapRight, ">div,", $952b6472eb391b70$var$wrapRight, "+", $952b6472eb391b70$var$gapCursor, "+", $952b6472eb391b70$var$wrapLeft, ">div,", $952b6472eb391b70$var$wrapRight, "+", $952b6472eb391b70$var$gapCursor, "+span+", $952b6472eb391b70$var$wrapLeft, ">div,", $952b6472eb391b70$var$gapCursor, "+", $952b6472eb391b70$var$wrapRight, "+", $952b6472eb391b70$var$wrapLeft, ">div,", $952b6472eb391b70$var$gapCursor, "+", $952b6472eb391b70$var$wrapRight, "+span+", $952b6472eb391b70$var$wrapLeft, ">div,", $952b6472eb391b70$var$gapCursor, "+", $952b6472eb391b70$var$wrapLeft, "+", $952b6472eb391b70$var$wrapRight, ">div,", $952b6472eb391b70$var$gapCursor, "+", $952b6472eb391b70$var$wrapLeft, "+span+", $952b6472eb391b70$var$wrapRight, ">div{margin-right:0;margin-left:0;margin-bottom:0;}", $952b6472eb391b70$var$wrapLeft, "+", $952b6472eb391b70$var$gapCursor, ",", $952b6472eb391b70$var$wrapRight, "+", $952b6472eb391b70$var$gapCursor, "{float:left;}", $952b6472eb391b70$var$gapCursor, "+", $952b6472eb391b70$var$wrapLeft, "+span+", $952b6472eb391b70$var$wrapRight, "::after,", $952b6472eb391b70$var$gapCursor, "+", $952b6472eb391b70$var$wrapRight, "+span+", $952b6472eb391b70$var$wrapLeft, "::after,", $952b6472eb391b70$var$wrapLeft, "+", $952b6472eb391b70$var$gapCursor, "+", $952b6472eb391b70$var$wrapRight, "::after,", $952b6472eb391b70$var$wrapLeft, "+", $952b6472eb391b70$var$gapCursor, "+span+", $952b6472eb391b70$var$wrapRight, "::after,", $952b6472eb391b70$var$wrapRight, "+", $952b6472eb391b70$var$gapCursor, "+", $952b6472eb391b70$var$wrapLeft, "::after,", $952b6472eb391b70$var$wrapRight, "+", $952b6472eb391b70$var$gapCursor, "+span+", $952b6472eb391b70$var$wrapLeft, "::after{visibility:hidden;display:block;font-size:0;content:' ';clear:both;height:0;}", $952b6472eb391b70$var$wrapLeft, "+", $952b6472eb391b70$var$gapCursor, "+", $952b6472eb391b70$var$wrapRight, "+*,", $952b6472eb391b70$var$wrapLeft, "+", $952b6472eb391b70$var$gapCursor, "+", $952b6472eb391b70$var$wrapRight, "+span+*,", $952b6472eb391b70$var$wrapRight, "+", $952b6472eb391b70$var$gapCursor, "+", $952b6472eb391b70$var$wrapLeft, "+*,", $952b6472eb391b70$var$wrapRight, "+", $952b6472eb391b70$var$gapCursor, "+", $952b6472eb391b70$var$wrapLeft, "+span+*,", $952b6472eb391b70$var$wrapLeft, "+", $952b6472eb391b70$var$gapCursor, "+span+", $952b6472eb391b70$var$wrapRight, "+*,", $952b6472eb391b70$var$wrapRight, "+", $952b6472eb391b70$var$gapCursor, "+span+", $952b6472eb391b70$var$wrapLeft, "+*,", $952b6472eb391b70$var$gapCursor, "+", $952b6472eb391b70$var$wrapLeft, "+span+", $952b6472eb391b70$var$wrapRight, "+*,", $952b6472eb391b70$var$gapCursor, "+", $952b6472eb391b70$var$wrapRight, "+span+", $952b6472eb391b70$var$wrapLeft, "+*,", $952b6472eb391b70$var$wrapLeft, "+", $952b6472eb391b70$var$gapCursor, "+", $952b6472eb391b70$var$wrapRight, "+*>*,", $952b6472eb391b70$var$wrapLeft, "+", $952b6472eb391b70$var$gapCursor, "+", $952b6472eb391b70$var$wrapRight, "+span+*>*,", $952b6472eb391b70$var$wrapRight, "+", $952b6472eb391b70$var$gapCursor, "+", $952b6472eb391b70$var$wrapLeft, "+*>*,", $952b6472eb391b70$var$wrapRight, "+", $952b6472eb391b70$var$gapCursor, "+", $952b6472eb391b70$var$wrapLeft, "+span+*>*,", $952b6472eb391b70$var$wrapLeft, "+", $952b6472eb391b70$var$gapCursor, "+span+", $952b6472eb391b70$var$wrapRight, "+*>*,", $952b6472eb391b70$var$wrapRight, "+", $952b6472eb391b70$var$gapCursor, "+span+", $952b6472eb391b70$var$wrapLeft, "+*>*,", $952b6472eb391b70$var$gapCursor, "+", $952b6472eb391b70$var$wrapLeft, "+span+", $952b6472eb391b70$var$wrapRight, "+*>*,", $952b6472eb391b70$var$gapCursor, "+", $952b6472eb391b70$var$wrapRight, "+span+", $952b6472eb391b70$var$wrapLeft, "+*>*,", $952b6472eb391b70$var$prosemirrorwidgetNotBlock, "+", $952b6472eb391b70$var$gapCursor, "+*,", $952b6472eb391b70$var$prosemirrorwidgetNotBlock, "+", $952b6472eb391b70$var$gapCursor, "+span+*{margin-top:0;}");
module.exports["hideCaretModifier"] = $952b6472eb391b70$export$8adc5edbc4a22166;

});

parcelRegister("jwWgu", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $iqsGx = parcelRequire("iqsGx");


var $2P8Ax = parcelRequire("2P8Ax");


var $jTxSS = parcelRequire("jTxSS");


var $aFUXX = parcelRequire("aFUXX");


var $dh538 = parcelRequire("dh538");


var $dZ8uq = parcelRequire("dZ8uq");


var $iu6m9 = parcelRequire("iu6m9");


var $7YjFd = parcelRequire("7YjFd");


var $26U6p = parcelRequire("26U6p");

class $c7500ff5662ba7c5$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    /**
   * Calculates new popup position
   */ calculatePosition(props, popup) {
        const { target: target, fitHeight: fitHeight, fitWidth: fitWidth, boundariesElement: boundariesElement, minPopupMargin: minPopupMargin, offset: offset, onPositionCalculated: onPositionCalculated, onPlacementChanged: onPlacementChanged, alignX: alignX, alignY: alignY, stick: stick, forcePlacement: forcePlacement, allowOutOfBounds: allowOutOfBounds, rect: rect, preventOverflow: preventOverflow, absoluteOffset: absoluteOffset } = props;
        if (!target || !popup) return {};
        const placement = (0, $7YjFd.calculatePlacement)(target, // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- Existing Popup positioning fallback; keep unchanged for safety.
        boundariesElement || document.body, fitWidth, fitHeight, alignX, alignY, forcePlacement, preventOverflow);
        if (onPlacementChanged && this.placement.join('') !== placement.join('')) {
            onPlacementChanged(placement);
            this.placement = placement;
        }
        let position = (0, $7YjFd.calculatePosition)({
            placement: placement,
            popup: popup,
            target: target,
            stick: stick,
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            offset: offset,
            allowOutOfBounds: allowOutOfBounds,
            rect: rect,
            // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- Existing Popup positioning fallback; keep unchanged for safety.
            boundariesElement: boundariesElement || document.body,
            minPopupMargin: minPopupMargin,
            scrollableElement: stick ? this.scrollElement : undefined
        });
        position = onPositionCalculated ? onPositionCalculated(position) : position;
        if (typeof position.top !== 'undefined' && absoluteOffset?.top) position.top = position.top + absoluteOffset.top;
        if (typeof position.bottom !== 'undefined' && absoluteOffset?.bottom) position.bottom = position.bottom + absoluteOffset.bottom;
        if (typeof position.right !== 'undefined' && absoluteOffset?.right) position.right = position.right + absoluteOffset.right;
        if (typeof position.left !== 'undefined' && absoluteOffset?.left) position.left = position.left + absoluteOffset.left;
        return {
            position: position,
            validPosition: (0, $26U6p.validatePosition)(target)
        };
    }
    updatePosition(props = this.props, state = this.state) {
        const { popup: popup } = state;
        const { position: position, validPosition: validPosition } = this.calculatePosition(props, popup);
        if (position && validPosition) (0, $jTxSS.flushSync)(()=>{
            this.setState({
                position: position,
                validPosition: validPosition
            });
        });
    }
    cannotSetPopup(popup, target, overflowScrollParent) {
        /**
     * Check whether:
     * 1. Popup's offset targets which means whether or not its possible to correctly position popup along with given target.
     * 2. Popup is inside "overflow: scroll" container, but its offset parent isn't.
     *
     * Currently Popup isn't capable of position itself correctly in case 2,
     * Add "position: relative" to "overflow: scroll" container or to some other FloatingPanel wrapper inside it.
     */ return !target || // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- Existing Popup containment check; keep unchanged for safety.
        document.body.contains(target) && popup.offsetParent && // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        !popup.offsetParent.contains(target) || overflowScrollParent && !overflowScrollParent.contains(popup.offsetParent);
    }
    /**
   * Popup initialization.
   * Checks whether it's possible to position popup along given target, and if it's not throws an error.
   */ initPopup(popup) {
        if (this.popupRef.current) this.resizeObserver?.unobserve(this.popupRef.current);
        this.popupRef.current = popup;
        const { target: target } = this.props;
        const overflowScrollParent = (0, $7YjFd.findOverflowScrollParent)(popup);
        if (this.cannotSetPopup(popup, target, overflowScrollParent)) return;
        this.setState({
            popup: popup
        });
        /**
     * Some plugins (like image) have async rendering of component in floating toolbar(which is popup).
     * Now, floating toolbar position depends on it's size.
     * Size of floating toolbar changes, when async component renders.
     * There is currently, no way to re position floating toolbar or
     *  better to not show floating toolbar till all the async component are ready to render.
     * Also, it is not even Popup's responsibility to take care of it as popup's children are passed
     *  as a prop.
     * So, calling scheduledUpdatePosition to position popup on next request animation frame,
     * which is currently working for most of the floating toolbar and other popups.
     */ this.scheduledUpdatePosition(this.props);
        if (this.props.focusTrap) this.initFocusTrap();
        if (this.popupRef.current) this.resizeObserver?.observe(this.popupRef.current);
    }
    /**
   * Cancels the initialisation of the focus trap if it has not yet occured
   * Deactivates the focus trap if it exists
   */ destroyFocusTrap() {
        this.initFocusTrap.cancel();
        this.focusTrap?.deactivate();
    }
    /**
   * Handle pausing, unpausing, and initialising (if not yet initialised) of the focus trap
   */ handleChangedFocusTrapProp(prevProps) {
        if (prevProps.focusTrap !== this.props.focusTrap) {
            // If currently set to disable, then pause the trap if it exists
            if (!this.props.focusTrap) return this.focusTrap?.pause();
            // If set to enabled and trap already exists, unpause
            if (this.focusTrap) this.focusTrap.unpause();
            // Else initialise the focus trap
            return this.initFocusTrap();
        }
    }
    /**
   * Idempotent scroll element setup — tears down any previous listener/observer
   * then attaches to the current scroll parent.
   */ initScrollElement() {
        const { stick: stick, target: target, scrollableElement: scrollableElement } = this.props;
        this.unbindScroll?.();
        if (this.scrollElement && this.resizeObserver) this.resizeObserver.unobserve(this.scrollElement);
        this.scrollElement = scrollableElement;
        if (stick && !this.scrollElement && target) this.scrollElement = (0, $7YjFd.findOverflowScrollParent)(target);
        if (this.scrollElement) {
            if (this.resizeObserver) this.resizeObserver.observe(this.scrollElement);
            this.unbindScroll = (0, $fFa3V.bind)(this.scrollElement, {
                type: 'scroll',
                listener: this.onResize
            });
        }
    }
    componentDidUpdate(prevProps) {
        this.handleChangedFocusTrapProp(prevProps);
        if (prevProps.scrollableElement !== this.props.scrollableElement) this.initScrollElement();
        if (this.props !== prevProps) this.scheduledUpdatePosition(prevProps);
    }
    componentDidMount() {
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.addEventListener('resize', this.onResize);
        this.initScrollElement();
    }
    componentWillUnmount() {
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.removeEventListener('resize', this.onResize);
        this.unbindScroll?.();
        if (this.scrollElement) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.scrollElement.removeEventListener('scroll', this.onResize);
        this.resizeObserver?.disconnect();
        this.scheduledUpdatePosition.cancel();
        this.destroyFocusTrap();
        const { onUnmount: onUnmount } = this.props;
        if (onUnmount) onUnmount();
    }
    renderPopup() {
        const { position: position } = this.state;
        const { shouldRenderPopup: shouldRenderPopup } = this.props;
        if (shouldRenderPopup && !shouldRenderPopup(position || {})) return null;
        /**
     * https://a11y.atlassian.net/browse/A11Y-9995
     * We set aria-label to undefined if it's null, no more 'Popup' fallback.
     * It is meaningless for screen readers and causes confusion.
     */ const ariaLabel = (0, $dh538.fg)('_editor_a11y_aria_label_removal_popup') ? this.props.ariaLabel ?? undefined : this.props.ariaLabel === null ? undefined : this.props.ariaLabel || 'Popup';
        const getRole = ()=>{
            // Provide a valid role only when aria-label is present to satisfy a11y rules, as when aria-label is present, role is required
            // use role = dialog as default role, as dialog role itself is not a parent role that requires specific children to function as some other ARIA roles(menu) do
            // if set default role to menu, tons of integration tests will fail as many of our popup usages do not have children that satisfy menu role requirements
            if (ariaLabel) return this.props.role || 'dialog';
            return undefined;
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            ref: this.handleRef,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                position: 'absolute',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                zIndex: this.props.zIndex || (0, $aFUXX.akEditorFloatingPanelZIndex),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                ...position,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                ...this.props.style
            },
            role: getRole(),
            "aria-label": ariaLabel,
            "data-testid": "popup-wrapper",
            // Indicates component is an editor pop. Required for focus handling in Message.tsx
            "data-editor-popup": true
        }, this.props.children);
    }
    render() {
        const { target: target, mountTo: mountTo } = this.props;
        const { validPosition: validPosition } = this.state;
        if (!target || !validPosition) return null;
        if (mountTo) return /*#__PURE__*/ (0, $jTxSS.createPortal)(this.renderPopup(), mountTo);
        // Without mountTo property renders popup as is,
        // which means it will be cropped by "overflow: hidden" container.
        return this.renderPopup();
    }
    constructor(...args){
        super(...args);
        this.scrollElement = void 0;
        this.unbindScroll = void 0;
        this.rafIds = new Set();
        this.state = {
            validPosition: true
        };
        this.popupRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
        this.focusTrap = void 0;
        this.placement = [
            '',
            ''
        ];
        this.handleRef = (popup)=>{
            if (!popup) return;
            this.initPopup(popup);
        };
        this.scheduledUpdatePosition = (0, $2P8Ax.default)((_props)=>{
            this.updatePosition(this.props);
        });
        this.onResize = ()=>this.scheduledUpdatePosition(this.props);
        this.resizeObserver = window?.ResizeObserver ? new ResizeObserver(()=>{
            this.scheduledUpdatePosition(this.props);
        }) : undefined;
        /**
     * Raf scheduled so that it also occurs after the initial update position
     */ this.initFocusTrap = (0, $2P8Ax.default)(()=>{
            const popup = this.popupRef.current;
            if (!popup) return;
            const defaultTrapConfig = {
                clickOutsideDeactivates: true,
                escapeDeactivates: true,
                initialFocus: popup,
                fallbackFocus: popup,
                returnFocusOnDeactivate: false
            };
            const trapConfig = typeof this.props.focusTrap === 'boolean' ? defaultTrapConfig : {
                ...defaultTrapConfig,
                ...this.props.focusTrap
            };
            this.focusTrap = (0, (/*@__PURE__*/$parcel$interopDefault($iqsGx)))(popup, (0, $iu6m9.editorExperiment)('platform_editor_block_menu', true) || (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_layout_column_menu', 'isEnabled', true) ? trapConfig : defaultTrapConfig);
            this.focusTrap.activate();
        });
    }
}
$c7500ff5662ba7c5$export$2e2bcd8739ae039.defaultProps = {
    offset: [
        0,
        0
    ],
    allowOutOfBound: false
};
module.exports["default"] = $c7500ff5662ba7c5$export$2e2bcd8739ae039;

});

parcelRegister("9Z3I5", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $40aJG = parcelRequire("40aJG");




const $2c7aa7ec975dfc3b$export$e17115e9cf808589 = ({ children: children, selectedRowIndex: selectedRowIndex, selectedColumnIndex: selectedColumnIndex, isOpenedByKeyboard: isOpenedByKeyboard, isPopupPositioned: isPopupPositioned, handleClose: handleClose, closeOnTab: closeOnTab, editorRef: editorRef, ignoreEscapeKey: ignoreEscapeKey, popupsMountPoint: popupsMountPoint })=>{
    const wrapperRef = (0, $42omo.useRef)(null);
    const currentSelectedColumnIndex = (0, $42omo.useRef)(selectedColumnIndex === -1 ? 0 : selectedColumnIndex);
    const currentSelectedRowIndex = (0, $42omo.useRef)(selectedRowIndex === -1 ? 0 : selectedRowIndex);
    const element = popupsMountPoint ? popupsMountPoint : editorRef.current;
    const [listenerTargetElement] = (0, $42omo.useState)(element);
    const incrementRowIndex = (rowElements, columnElements)=>{
        if (currentSelectedRowIndex.current === rowElements.length - 1) currentSelectedRowIndex.current = 0;
        else currentSelectedRowIndex.current = currentSelectedRowIndex.current + 1;
    };
    const decrementRowIndex = (rowElements, columnElements)=>{
        if (currentSelectedRowIndex.current === 0) currentSelectedRowIndex.current = rowElements.length - 1;
        else currentSelectedRowIndex.current = currentSelectedRowIndex.current - 1;
    };
    (0, $42omo.useLayoutEffect)(()=>{
        const incrementColumnIndex = (rowElements, columnElements)=>{
            if (currentSelectedColumnIndex.current === columnElements.length - 1) {
                incrementRowIndex(rowElements, columnElements);
                currentSelectedColumnIndex.current = 0;
            } else currentSelectedColumnIndex.current = currentSelectedColumnIndex.current + 1;
        };
        const decrementColumnIndex = (rowElements, columnElements)=>{
            if (currentSelectedColumnIndex.current === 0) {
                decrementRowIndex(rowElements, columnElements);
                currentSelectedColumnIndex.current = columnElements.length - 1;
            } else currentSelectedColumnIndex.current = currentSelectedColumnIndex.current - 1;
        };
        const focusColorSwatch = ()=>{
            const colorSwatchesRowElements = $2c7aa7ec975dfc3b$var$getColorSwatchesRows(wrapperRef?.current);
            const currentSelectedColorSwatchRowElement = colorSwatchesRowElements[currentSelectedRowIndex.current];
            const focusableElements = $2c7aa7ec975dfc3b$var$getFocusableElements(currentSelectedColorSwatchRowElement);
            if (!focusableElements || focusableElements?.length === 0) return;
            focusableElements[currentSelectedColumnIndex.current]?.focus();
        };
        /**
     * To handle the key events on the list
     * @param event
     */ const handleKeyDown = (event)=>{
            if (event.key === 'Tab' && closeOnTab) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                handleClose(event);
                return;
            }
            const colorSwatchesRowElements = $2c7aa7ec975dfc3b$var$getColorSwatchesRows(wrapperRef?.current);
            const currentSelectedColorSwatchRowElement = colorSwatchesRowElements[currentSelectedRowIndex.current];
            const focusableElements = $2c7aa7ec975dfc3b$var$getFocusableElements(currentSelectedColorSwatchRowElement);
            switch(event.key){
                case 'ArrowDown':
                    incrementRowIndex(colorSwatchesRowElements, focusableElements);
                    focusColorSwatch();
                    event.preventDefault();
                    break;
                case 'ArrowUp':
                    decrementRowIndex(colorSwatchesRowElements, focusableElements);
                    focusColorSwatch();
                    event.preventDefault();
                    break;
                case 'ArrowLeft':
                    decrementColumnIndex(colorSwatchesRowElements, focusableElements);
                    focusColorSwatch();
                    event.preventDefault();
                    break;
                case 'ArrowRight':
                    incrementColumnIndex(colorSwatchesRowElements, focusableElements);
                    focusColorSwatch();
                    event.preventDefault();
                    break;
                case 'Escape':
                    if (!ignoreEscapeKey) // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    handleClose(event);
                    break;
                default:
                    return;
            }
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        listenerTargetElement && listenerTargetElement.addEventListener('keydown', handleKeyDown);
        // set focus to current selected color swatch if only opened by keyboard
        if (isOpenedByKeyboard && isPopupPositioned) // Using timeout because, we need to wait till color palette is rendered
        //  and visible on screen, then only focus color swatch, otherwise focus will be
        //  moved to body
        setTimeout(()=>{
            focusColorSwatch();
        });
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            listenerTargetElement && listenerTargetElement.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        currentSelectedColumnIndex,
        isOpenedByKeyboard,
        isPopupPositioned,
        wrapperRef,
        handleClose,
        closeOnTab,
        ignoreEscapeKey,
        listenerTargetElement
    ]);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: "custom-key-handler-wrapper",
        ref: wrapperRef,
        "data-vc": "MC5NMerP"
    }, children));
};
function $2c7aa7ec975dfc3b$var$getColorSwatchesRows(rootNode) {
    if (!rootNode) return [];
    const colorSwatchesRowElements = rootNode.querySelectorAll('div[role=radiogroup]') || [];
    return Array.from(colorSwatchesRowElements);
}
function $2c7aa7ec975dfc3b$var$getFocusableElements(rootNode) {
    if (!rootNode) return [];
    const focusableModalElements = rootNode.querySelectorAll('button[role=radio]:not([disabled])') || [];
    return Array.from(focusableModalElements);
}






var $hTKp4 = parcelRequire("hTKp4");


var $dZ8uq = parcelRequire("dZ8uq");

const $b6cbdc7f2aa54c26$var$hasEnabledItems = (list)=>list.some((item)=>item.getAttribute('aria-disabled') !== 'true');
const $b6cbdc7f2aa54c26$export$e12b037790bf03e3 = ({ children: children, handleClose: handleClose, disableArrowKeyNavigation: disableArrowKeyNavigation, keyDownHandlerContext: keyDownHandlerContext, closeOnTab: closeOnTab, onSelection: onSelection, editorRef: editorRef, popupsMountPoint: popupsMountPoint, disableCloseOnArrowClick: disableCloseOnArrowClick })=>{
    const wrapperRef = (0, $42omo.useRef)(null);
    const [currentSelectedItemIndex, setCurrentSelectedItemIndex] = (0, $42omo.useState)(-1);
    const element = popupsMountPoint ? [
        popupsMountPoint,
        editorRef.current
    ] : [
        editorRef.current
    ];
    const [listenerTargetElement] = (0, $42omo.useState)(element);
    const getCurrentIndex = (0, $42omo.useCallback)((list)=>{
        if (!(0, $dZ8uq.expValEqualsNoExposure)('platform_editor_layout_column_menu', 'isEnabled', true)) return currentSelectedItemIndex;
        const activeElement = (0, $hTKp4.getDocument)()?.activeElement;
        if (!(activeElement instanceof HTMLElement)) return currentSelectedItemIndex;
        const activeElementIndex = list.indexOf(activeElement);
        return activeElementIndex >= 0 ? activeElementIndex : currentSelectedItemIndex;
    }, [
        currentSelectedItemIndex
    ]);
    const incrementIndex = (0, $42omo.useCallback)((list)=>{
        const currentIndex = getCurrentIndex(list);
        let nextIndex = (currentIndex + 1) % list.length;
        // Skips disabled items. Previously this function relied on a list of enabled elements which caused a
        // difference between currentIndex and the item index in the menu.
        while(nextIndex !== currentIndex && list[nextIndex].getAttribute('aria-disabled') === 'true')nextIndex = (nextIndex + 1) % list.length;
        setCurrentSelectedItemIndex(nextIndex);
        return nextIndex;
    }, [
        getCurrentIndex
    ]);
    const decrementIndex = (0, $42omo.useCallback)((list)=>{
        const currentIndex = getCurrentIndex(list);
        let nextIndex = (list.length + currentIndex - 1) % list.length;
        while(nextIndex !== currentIndex && list[nextIndex].getAttribute('aria-disabled') === 'true')nextIndex = (list.length + nextIndex - 1) % list.length;
        setCurrentSelectedItemIndex(nextIndex);
        return nextIndex;
    }, [
        getCurrentIndex
    ]);
    // this useEffect uses onSelection in it's dependency list which gets
    // changed as a result of the dropdown menu getting re-rendered in it's
    // parent component. Note that if onSelection gets updated to useMemo
    // this will no longer work.
    (0, $42omo.useEffect)(()=>{
        const currentIndex = currentSelectedItemIndex;
        const list = $b6cbdc7f2aa54c26$var$getFocusableElements(wrapperRef?.current);
        const currentElement = list[currentIndex];
        // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- Ignored via go/ees017 (to be fixed)
        if (currentElement && currentElement.getAttribute('aria-disabled') === 'true') {
            // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- Ignored via go/ees017 (to be fixed)
            const focusIndex = incrementIndex(list);
            // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- Ignored via go/ees017 (to be fixed)
            list[focusIndex]?.focus();
        }
    }, [
        currentSelectedItemIndex,
        onSelection,
        incrementIndex,
        decrementIndex
    ]);
    (0, $42omo.useLayoutEffect)(()=>{
        // Backwards compatible behaviour:
        // - `true` disables all key handling (no listeners attached)
        // - a function is evaluated per event inside the handler
        if (disableArrowKeyNavigation === true) return;
        /**
     * To handle the key events on the list
     * @param event
     */ const handleKeyDown = (event)=>{
            if (typeof disableArrowKeyNavigation === 'function' && disableArrowKeyNavigation(event)) return;
            const targetElement = event.target;
            // Tab key on menu items can be handled in the parent components of dropdown menus with KeydownHandlerContext
            if (event.key === 'Tab' && closeOnTab) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                handleClose(event);
                keyDownHandlerContext?.handleTab();
                return;
            }
            // To trap the focus inside the toolbar using left and right arrow keys
            const focusableElements = $b6cbdc7f2aa54c26$var$getFocusableElements(wrapperRef?.current);
            if (!focusableElements || focusableElements?.length === 0) return;
            if (targetElement instanceof HTMLElement && !wrapperRef.current?.contains(targetElement)) setCurrentSelectedItemIndex(-1);
            switch(event.key){
                case 'ArrowDown':
                    if ($b6cbdc7f2aa54c26$var$hasEnabledItems(focusableElements)) {
                        const focusIndex = incrementIndex(focusableElements);
                        focusableElements[focusIndex]?.focus();
                        event.preventDefault();
                    }
                    break;
                case 'ArrowUp':
                    if ($b6cbdc7f2aa54c26$var$hasEnabledItems(focusableElements)) {
                        const focusIndex = decrementIndex(focusableElements);
                        focusableElements[focusIndex]?.focus();
                        event.preventDefault();
                    }
                    break;
                // ArrowLeft/Right on the menu should close the menus
                // then logic to retain the focus can be handled in the parent components with KeydownHandlerContext
                case 'ArrowLeft':
                    if (targetElement instanceof HTMLElement && !targetElement.closest('.custom-key-handler-wrapper')) return;
                    if (!disableCloseOnArrowClick) // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    handleClose(event);
                    if (targetElement instanceof HTMLElement && !targetElement.closest('[data-testid="editor-floating-toolbar"]')) keyDownHandlerContext?.handleArrowLeft();
                    break;
                case 'ArrowRight':
                    if (targetElement instanceof HTMLElement && !targetElement.closest('.custom-key-handler-wrapper')) return;
                    if (!disableCloseOnArrowClick) // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    handleClose(event);
                    if (targetElement instanceof HTMLElement && !targetElement.closest('[data-testid="editor-floating-toolbar"]')) keyDownHandlerContext?.handleArrowRight();
                    break;
                case 'Escape':
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    handleClose(event);
                    break;
                case 'Enter':
                    if (typeof onSelection === 'function') onSelection(currentSelectedItemIndex);
                    break;
                default:
                    return;
            }
        };
        listenerTargetElement && listenerTargetElement.forEach(function(elem) {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            elem && elem.addEventListener('keydown', handleKeyDown);
        });
        return ()=>{
            listenerTargetElement && listenerTargetElement.forEach(function(elem) {
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                elem && elem.removeEventListener('keydown', handleKeyDown);
            });
        };
    }, [
        currentSelectedItemIndex,
        wrapperRef,
        handleClose,
        disableArrowKeyNavigation,
        keyDownHandlerContext,
        closeOnTab,
        onSelection,
        incrementIndex,
        decrementIndex,
        listenerTargetElement,
        disableCloseOnArrowClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "menu-key-handler-wrapper custom-key-handler-wrapper",
        ref: wrapperRef,
        "data-vc": "eao6wfFH"
    }, children);
};
function $b6cbdc7f2aa54c26$var$getFocusableElements(rootNode) {
    if (!rootNode) return [];
    const focusableModalElements = rootNode.querySelectorAll('a[href], button:not([disabled]), textarea, input, select, div[tabindex="-1"]') || [];
    return Array.from(focusableModalElements);
}



var $5v8Ta = parcelRequire("5v8Ta");

const $2192c2d733a2713a$export$ee87cc4950b6d6fe = (props)=>{
    const { children: children, type: type, ...restProps } = props;
    if (type === (0, $5v8Ta.ArrowKeyNavigationType).COLOR) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $40aJG.default).Consumer, null, ({ popupsMountPoint: popupsMountPoint, editorView: editorView, editorRef: editorRef })=>editorRef && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2c7aa7ec975dfc3b$export$e17115e9cf808589), {
            selectedRowIndex: props.selectedRowIndex,
            selectedColumnIndex: props.selectedColumnIndex,
            isOpenedByKeyboard: props.isOpenedByKeyboard,
            isPopupPositioned: props.isPopupPositioned,
            editorRef: editorRef,
            popupsMountPoint: popupsMountPoint,
            ...restProps
        }, children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $40aJG.default).Consumer, null, ({ popupsMountPoint: popupsMountPoint, editorView: editorView, editorRef: editorRef })=>editorRef && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b6cbdc7f2aa54c26$export$e12b037790bf03e3), {
            editorRef: editorRef,
            popupsMountPoint: popupsMountPoint,
            ...restProps
        }, children));
};
module.exports["ArrowKeyNavigationProvider"] = $2192c2d733a2713a$export$ee87cc4950b6d6fe;

});

parcelRegister("5v8Ta", function(module, exports) {
var $7e180e553d18717f$export$26c2c5e2f61f437a = /*#__PURE__*/ function(ArrowKeyNavigationType) {
    ArrowKeyNavigationType["COLOR"] = "color";
    ArrowKeyNavigationType["MENU"] = "menu";
    return ArrowKeyNavigationType;
}({});
module.exports["ArrowKeyNavigationType"] = $7e180e553d18717f$export$26c2c5e2f61f437a;

});

parcelRegister("wJ8xb", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $30f53b91e6ac364e$export$798d66d2e25c3c95 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(()=>Object);
module.exports["OutsideClickTargetRefContext"] = $30f53b91e6ac364e$export$798d66d2e25c3c95;

});

parcelRegister("efG2U", function(module, exports) {
$parcel$export(module.exports, "default", () => $a2a8fd6bbe2eef9a$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $iu6m9 = parcelRequire("iu6m9");


var $wJ8xb = parcelRequire("wJ8xb");


var $40aJG = parcelRequire("40aJG");

// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $a2a8fd6bbe2eef9a$var$WithOutsideClick extends (0, $42omo.PureComponent) {
    componentDidMount() {
        if (this.props.handleClickOutside) {
            const options = this.props.captureClick && (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? {
                capture: true
            } : false;
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('click', this.handleClick, options);
        }
        if (this.props.handleEscapeKeydown || this.props.handleBackspaceDeleteKeydown || this.props.handleKeyDown && (0, $iu6m9.editorExperiment)('platform_editor_block_menu', true, {
            exposure: true
        })) // Attached event to the menu so that 'ESC' events from the opened menu also will be handled.
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        (this.props.popupsMountPoint ? this.props.popupsMountPoint : // @ts-ignore - TS2873 TypeScript 5.9.2 upgrade
        this.props.editorRef?.current || this.props.targetRef || document).addEventListener('keydown', this.handleKeyDown, false);
    }
    componentWillUnmount() {
        if (this.props.handleClickOutside) {
            const options = this.props.captureClick && (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? {
                capture: true
            } : false;
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('click', this.handleClick, options);
        }
        if (this.props.handleEscapeKeydown || this.props.handleBackspaceDeleteKeydown || this.props.handleKeyDown && (0, $iu6m9.editorExperiment)('platform_editor_block_menu', true, {
            exposure: true
        })) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        (this.props.popupsMountPoint ? this.props.popupsMountPoint : // @ts-ignore - TS2873 TypeScript 5.9.2 upgrade
        this.props.editorRef?.current || this.props.targetRef || document).removeEventListener('keydown', this.handleKeyDown, false);
    }
    render() {
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.handleClick = (evt)=>{
            if (!this.props.isActiveComponent || !this.props.handleClickOutside) return;
            const domNode = this.props.outsideClickTargetRef.current?.deref();
            if (!domNode || evt.target instanceof Node && !domNode.contains(evt.target)) {
                this.props.handleClickOutside(evt);
                // When the menus are closed by clicking outside the focus is set on editor.
                if (!this.props.editorView?.hasFocus()) this.props.editorView?.focus();
            }
        };
        this.handleKeyDown = (evt)=>{
            if (!this.props.isActiveComponent) return;
            if (evt.code === 'Escape' && this.props.handleEscapeKeydown) {
                evt.preventDefault();
                evt.stopPropagation();
                this.props.handleEscapeKeydown(evt);
                // on 'Esc', Focus is handled in 'handleEscapeKeydown'.
                return false;
            } else if (evt.code === 'Enter' && this.props.handleEnterKeydown) this.props.handleEnterKeydown(evt);
            else if (evt.code === 'Tab' && this.props.handleEscapeKeydown && this.props.closeOnTab) // The menus should be closed when the tab is pressed as it takes the focus out of the menu
            this.props.handleEscapeKeydown(evt);
            else if ((evt.code === 'Delete' || evt.code === 'Backspace') && this.props.handleBackspaceDeleteKeydown) this.props.handleBackspaceDeleteKeydown(evt);
            if ((0, $iu6m9.editorExperiment)('platform_editor_block_menu', true, {
                exposure: true
            })) this.props.handleKeyDown?.(evt);
        };
    }
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $a2a8fd6bbe2eef9a$var$hasIsOpen(props) {
    return 'isOpen' in props;
}
function $a2a8fd6bbe2eef9a$export$2e2bcd8739ae039(Component) {
    return ({ captureClick: captureClick, closeOnTab: closeOnTab, handleBackspaceDeleteKeydown: handleBackspaceDeleteKeydown, handleClickOutside: handleClickOutside, handleEnterKeydown: handleEnterKeydown, handleEscapeKeydown: handleEscapeKeydown, handleKeyDown: handleKeyDown, ...props })=>{
        const isActiveProp = $a2a8fd6bbe2eef9a$var$hasIsOpen(props) ? props.isOpen : true;
        const [isActiveComponent, setActiveComponent] = (0, $42omo.useState)(false);
        const outsideClickTargetRef = (0, $42omo.useRef)(null);
        const setOutsideClickTargetRef = (0, $42omo.useCallback)((el)=>{
            outsideClickTargetRef.current = el && new WeakRef(el);
        }, [
            outsideClickTargetRef
        ]);
        (0, $42omo.useEffect)(()=>{
            requestAnimationFrame(()=>{
                setActiveComponent(isActiveProp);
            });
        }, [
            isActiveProp
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $40aJG.default).Consumer, null, ({ editorView: editorView, popupsMountPoint: popupsMountPoint, editorRef: editorRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $wJ8xb.OutsideClickTargetRefContext).Provider, {
                value: setOutsideClickTargetRef
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a2a8fd6bbe2eef9a$var$WithOutsideClick, {
                editorView: editorView,
                editorRef: editorRef,
                targetRef: props.targetRef,
                outsideClickTargetRef: outsideClickTargetRef,
                popupsMountPoint: popupsMountPoint,
                isActiveComponent: isActiveComponent,
                handleClickOutside: handleClickOutside,
                handleEnterKeydown: handleEnterKeydown,
                handleEscapeKeydown: handleEscapeKeydown,
                handleBackspaceDeleteKeydown: handleBackspaceDeleteKeydown,
                handleKeyDown: handleKeyDown,
                closeOnTab: closeOnTab,
                captureClick: captureClick
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, props))));
    };
}

});

parcelRegister("jbmmV", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $c4sKh = parcelRequire("c4sKh");


var $iXCQx = parcelRequire("iXCQx");

const $38aec38c42f74e34$export$f433dac65060f723 = ({ shortcut: shortcut, isDisabled: isDisabled })=>{
    if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c4sKh.default), {
        appearance: "primaryInverted"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.text.disabled"
    }, shortcut));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c4sKh.default), null, shortcut);
};
module.exports["ToolbarKeyboardShortcutHint"] = $38aec38c42f74e34$export$f433dac65060f723;

});

parcelRegister("khxQ7", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $iIGXo = parcelRequire("iIGXo");

var $i8M34 = parcelRequire("i8M34");

var $aFNbc = parcelRequire("aFNbc");

var $j0UBv = parcelRequire("j0UBv");


var $d925B = parcelRequire("d925B");


var $60bKU = parcelRequire("60bKU");

var $hgeg8 = parcelRequire("hgeg8");


var $2UWDO = parcelRequire("2UWDO");


var $3pLGZ = parcelRequire("3pLGZ");


var $frHf7 = parcelRequire("frHf7");


var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");


var $iu6m9 = parcelRequire("iu6m9");





var $dhoHU = parcelRequire("dhoHU");


var $dAtrv = parcelRequire("dAtrv");


var $bGUOY = parcelRequire("bGUOY");

var $8vgNB = parcelRequire("8vgNB");


var $aXG5V = parcelRequire("aXG5V");


var $7XFGZ = parcelRequire("7XFGZ");





var $boahT = parcelRequire("boahT");


var $8DwGl = parcelRequire("8DwGl");


var $7LzxJ = parcelRequire("7LzxJ");


var $4VXMf = parcelRequire("4VXMf");

var $l03WE = parcelRequire("l03WE");


var $8m4tT = parcelRequire("8m4tT");










const $b4774db4d7677b9c$export$3a2c03e35bc6c7a8 = (node)=>{
    if (!node) return false;
    return (0, $boahT.WRAPPER_BLOCK_TYPES).some((blockNode)=>blockNode.name === node.type.name);
};
const $b4774db4d7677b9c$export$1fe8b64ae159a0fa = (match, nodeType)=>{
    return (0, $l03WE.createWrappingJoinRule)({
        nodeType: nodeType,
        match: match,
        getAttrs: {},
        joinPredicate: (_, node)=>node.type === nodeType
    });
};
const $b4774db4d7677b9c$export$644b98fd2fd87b8b = ({ match: match, nodeType: nodeType, getAttrs: getAttrs })=>{
    const handler = (state, match, start, end)=>{
        const fixedStart = Math.max(start, 1);
        const $start = state.doc.resolve(fixedStart);
        const attrs = getAttrs instanceof Function ? getAttrs(match) : getAttrs;
        const nodeBefore = $start.node(-1);
        if (nodeBefore && !nodeBefore.canReplaceWith($start.index(-1), $start.indexAfter(-1), nodeType)) return null;
        return state.tr.delete(fixedStart, end).setBlockType(fixedStart, fixedStart, nodeType, attrs);
    };
    return (0, $4VXMf.createRule)(match, handler);
};
/**
 * Function will create a list of wrapper blocks present in a selection.
 */ function $b4774db4d7677b9c$var$getSelectedWrapperNodes(state) {
    const nodes = [];
    if (state.selection) {
        const { $from: $from, $to: $to, empty: empty } = state.selection;
        const { blockquote: blockquote, panel: panel, orderedList: orderedList, bulletList: bulletList, listItem: listItem, caption: caption, codeBlock: codeBlock, decisionItem: decisionItem, decisionList: decisionList, taskItem: taskItem, taskList: taskList } = state.schema.nodes;
        const wrapperNodes = [
            blockquote,
            panel,
            orderedList,
            bulletList,
            listItem,
            codeBlock,
            decisionItem,
            decisionList,
            taskItem,
            taskList
        ];
        wrapperNodes.push(caption);
        if (empty && (0, $1oCLl.expValEquals)('platform_editor_small_font_size', 'isEnabled', true)) {
            for(let depth = 0; depth <= $from.depth; depth++){
                const node = $from.node(depth);
                if (node.isBlock && wrapperNodes.indexOf(node.type) >= 0) nodes.push(node.type);
            }
            return nodes;
        }
        state.doc.nodesBetween($from.pos, $to.pos, (node)=>{
            if (node.isBlock && wrapperNodes.indexOf(node.type) >= 0) nodes.push(node.type);
        });
    }
    return nodes;
}
function $b4774db4d7677b9c$export$52adb8d9a3386cb8(state, allowFontSize = false) {
    const nodesTypes = $b4774db4d7677b9c$var$getSelectedWrapperNodes(state);
    const { panel: panel, blockquote: blockquote, bulletList: bulletList, orderedList: orderedList, listItem: listItem, taskList: taskList, taskItem: taskItem } = state.schema.nodes;
    const isSmallFontSizeEnabled = allowFontSize && (0, $1oCLl.expValEquals)('platform_editor_small_font_size', 'isEnabled', true);
    const excludedTypes = isSmallFontSizeEnabled ? [
        panel,
        bulletList,
        orderedList,
        listItem,
        taskList,
        taskItem
    ] : [
        panel
    ];
    const disallowedWrapperTypes = nodesTypes.filter((type)=>!excludedTypes.includes(type));
    if (isSmallFontSizeEnabled) {
        const selectionInsideList = $b4774db4d7677b9c$export$fbe592d31a93b004(state);
        const selectionInsideQuote = $b4774db4d7677b9c$export$a7e992c753426072(state);
        // Inside a blockquote (but not a list nested within one): the blockquote itself isn't a
        // disallowing wrapper, but anything else is.
        if (selectionInsideQuote && !selectionInsideList) return disallowedWrapperTypes.some((type)=>type !== blockquote);
        return disallowedWrapperTypes.length > 0;
    }
    if ((0, $iu6m9.editorExperiment)('platform_editor_blockquote_in_text_formatting_menu', true)) {
        let hasQuote = false;
        let hasNestedListInQuote = false;
        const { $from: $from, $to: $to } = state.selection;
        state.doc.nodesBetween($from.pos, $to.pos, (node)=>{
            if (node.type === blockquote) {
                hasQuote = true;
                node.descendants((child)=>{
                    if (child.type === bulletList || child.type === orderedList) {
                        hasNestedListInQuote = true;
                        return false;
                    }
                    return true;
                });
            }
            return !hasNestedListInQuote;
        });
        return disallowedWrapperTypes.length > 0 && (!hasQuote || hasNestedListInQuote);
    }
    return disallowedWrapperTypes.length > 0;
}
function $b4774db4d7677b9c$export$fbe592d31a93b004(state) {
    if (!state.selection) return false;
    const { $from: $from, $to: $to } = state.selection;
    const { bulletList: bulletList, orderedList: orderedList, taskList: taskList } = state.schema.nodes;
    const listNodeTypes = [
        bulletList,
        orderedList,
        taskList
    ];
    let insideList = false;
    state.doc.nodesBetween($from.pos, $to.pos, (node)=>{
        if (node.isBlock && listNodeTypes.indexOf(node.type) >= 0) {
            insideList = true;
            return false;
        }
        return true;
    });
    return insideList || listNodeTypes.some((nodeType)=>(0, $8m4tT.hasParentNodeOfType)(nodeType)(state.selection));
}
function $b4774db4d7677b9c$export$a7e992c753426072(state) {
    if (!state.selection) return false;
    const { $from: $from, $to: $to } = state.selection;
    const { blockquote: blockquote } = state.schema.nodes;
    // For collapsed selections, check if the cursor is inside a blockquote
    if ($from.pos === $to.pos) return (0, $8m4tT.hasParentNodeOfType)(blockquote)(state.selection);
    // For range selections, check if any node in the range is a blockquote,
    // or if the selection starts/ends inside a blockquote
    let insideQuote = false;
    state.doc.nodesBetween($from.pos, $to.pos, (node)=>{
        if (node.type === blockquote) {
            insideQuote = true;
            return false;
        }
        return true;
    });
    return insideQuote || (0, $8m4tT.hasParentNodeOfType)(blockquote)(state.selection);
}
const $b4774db4d7677b9c$var$blockStylingIsPresent = (state)=>{
    const { from: from, to: to } = state.selection;
    let isBlockStyling = false;
    state.doc.nodesBetween(from, to, (node)=>{
        if ((0, $boahT.FORMATTING_NODE_TYPES).indexOf(node.type.name) !== -1) {
            isBlockStyling = true;
            return false;
        }
        return true;
    });
    return isBlockStyling;
};
const $b4774db4d7677b9c$var$marksArePresent = (state)=>{
    const activeMarkTypes = (0, $boahT.FORMATTING_MARK_TYPES).filter((mark)=>{
        if (!!state.schema.marks[mark]) {
            const { $from: $from, empty: empty } = state.selection;
            const { marks: marks } = state.schema;
            if (empty) return !!marks[mark].isInSet(state.storedMarks || $from.marks());
            return (0, $8DwGl.anyMarkActive)(state, marks[mark]);
        }
        return false;
    });
    return activeMarkTypes.length > 0;
};
const $b4774db4d7677b9c$export$4b48a1fc423972ea = (state)=>{
    return $b4774db4d7677b9c$var$marksArePresent(state) || $b4774db4d7677b9c$var$blockStylingIsPresent(state);
};
const $b4774db4d7677b9c$export$bce51f4ee2032263 = (dropdownOptions)=>{
    return !!dropdownOptions.find((blockType)=>blockType.name === 'blockquote');
};
function $b4774db4d7677b9c$export$77bd22d0a1033d4(tr) {
    const { selection: selection } = tr;
    const { bulletList: bulletList, orderedList: orderedList, taskList: taskList } = tr.doc.type.schema.nodes;
    const listNodeTypes = [
        bulletList,
        orderedList,
        taskList
    ];
    let from = selection.from;
    let to = selection.to;
    // Walk up from the selection start to find the outermost list node.
    // We do NOT break at the first list found because task lists nest differently
    // from bullet/ordered lists:
    //   - bullet/ordered: bulletList > listItem > bulletList (nested inside listItem)
    //   - task: taskList > taskList (nested as direct children)
    // For task lists, breaking at the first list would only capture the innermost
    // taskList, missing sibling task items in parent lists. By continuing to walk
    // up, we find the outermost list and include all nested content.
    for(let depth = selection.$from.depth; depth > 0; depth--){
        const node = selection.$from.node(depth);
        if (listNodeTypes.indexOf(node.type) >= 0) from = selection.$from.before(depth);
    }
    for(let depth = selection.$to.depth; depth > 0; depth--){
        const node = selection.$to.node(depth);
        if (listNodeTypes.indexOf(node.type) >= 0) to = selection.$to.after(depth);
    }
    return {
        from: from,
        to: to
    };
}
function $b4774db4d7677b9c$export$9fb148c84c583d2a(tr, from, to) {
    const { nodes: { taskItem: taskItem, blockTaskItem: blockTaskItem } } = tr.doc.type.schema;
    if (!blockTaskItem || !taskItem) return;
    // Collect taskItem positions from the current (unmutated) document
    const taskItemsToConvert = [];
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        if (node.type === taskItem) taskItemsToConvert.push({
            pos: pos,
            node: node
        });
    });
    // Replace in reverse document order so earlier positions remain valid
    for(let i = taskItemsToConvert.length - 1; i >= 0; i--){
        const { pos: pos, node: node } = taskItemsToConvert[i];
        const blockTaskNode = (0, $7LzxJ.createBlockTaskItem)({
            attrs: node.attrs,
            content: node.content,
            schema: tr.doc.type.schema
        });
        tr.replaceWith(pos, pos + node.nodeSize, blockTaskNode);
    }
}








const $39ecbfa01b1d975b$export$a5cb0c20bd02ce0c = [
    'heading',
    'blockquote'
];
const $39ecbfa01b1d975b$export$73b50f8f13648c71 = [
    'em',
    'code',
    'strike',
    'strong',
    'underline',
    'textColor',
    'subsup',
    'backgroundColor'
];
const $39ecbfa01b1d975b$export$ce157a3b6664c924 = {
    em: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_ITALIC,
    code: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_CODE,
    strike: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_STRIKE,
    strong: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_STRONG,
    underline: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_UNDERLINE,
    textColor: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_COLOR,
    subsup: 'subsup',
    backgroundColor: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_BACKGROUND_COLOR
};
const $39ecbfa01b1d975b$export$bd443c1dba3019b8 = (selection, doc, f, startPos)=>{
    selection.forEachCell((cell, cellPos)=>{
        doc.nodesBetween(cellPos, cellPos + cell.nodeSize, f, startPos);
    });
};
function $39ecbfa01b1d975b$export$10ed2145ce1a03b1(schema, tr, formattedNodeType, nodeName, formattingCleared) {
    return function(node, pos) {
        if (node.type === formattedNodeType) {
            if (formattedNodeType.isTextblock) {
                tr.setNodeMarkup(pos, schema.nodes.paragraph);
                formattingCleared.push(nodeName);
                return false;
            } else {
                // In case of panel or blockquote
                const fromPos = tr.doc.resolve(pos + 1);
                const toPos = tr.doc.resolve(pos + node.nodeSize - 1);
                const nodeRange = fromPos.blockRange(toPos);
                if (nodeRange) {
                    const targetLiftDepth = (0, $aXG5V.liftTarget)(nodeRange);
                    if (targetLiftDepth || targetLiftDepth === 0) {
                        formattingCleared.push(nodeName);
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        tr.lift(nodeRange, targetLiftDepth);
                    }
                }
            }
        }
        return true;
    };
}



var $5SAOw = parcelRequire("5SAOw");







function $e186639b697f69c2$export$bb05c9a6c853122f(_nodeType) {
    return ({ tr: tr })=>{
        const { nodes: nodes } = tr.doc.type.schema;
        const { alignment: alignment, indentation: indentation, fontSize: fontSize } = tr.doc.type.schema.marks;
        if (nodes.paragraph && nodes.blockquote) {
            /** Remove alignment, indentation, and unsupported blockquote marks from the selection */ const marksToRemove = (0, $1oCLl.expValEquals)('platform_editor_small_font_size', 'isEnabled', true) ? [
                alignment,
                indentation,
                fontSize
            ] : [
                alignment,
                indentation
            ];
            const hasMark = (mark)=>marksToRemove.indexOf(mark.type) > -1;
            const not = (fn)=>(arg)=>!fn(arg);
            /**
			 * When you need to toggle the selection
			 * when another type which does not allow alignment is applied
			 */ tr.doc.nodesBetween(tr.selection.from, tr.selection.to, (node, pos)=>{
                if (node.type === nodes.paragraph && node.marks.some(hasMark)) {
                    const resolvedPos = tr.doc.resolve(pos);
                    const withoutBlockMarks = node.marks.filter(not(hasMark));
                    tr = tr.setNodeMarkup(resolvedPos.pos, undefined, node.attrs, withoutBlockMarks);
                }
            });
            /** Get range and wrapping needed for the selection */ const { $from: $from, $to: $to } = tr.selection;
            const range = $from.blockRange($to);
            const wrapping = range && (0, $aXG5V.findWrapping)(range, nodes.blockquote);
            if (wrapping) /** Wrap the selection */ tr.wrap(range, wrapping).scrollIntoView();
            else {
                /** If wrapping is not possible, replace with a blockquote */ const start = $from.start();
                const end = $to.end();
                const content = $from.node().content;
                const blockquote = nodes.blockquote.create({}, nodes.paragraph.create({}, content));
                const slice = new (0, $5SAOw.Slice)((0, $5SAOw.Fragment).from(blockquote), 0, 0);
                tr.replaceRange(start, end, slice).scrollIntoView();
            }
        }
        return tr;
    };
}


function $597e6e1491fda64d$export$36987f561c736aad(name) {
    return ({ tr: tr })=>{
        const { nodes: nodes } = tr.doc.type.schema;
        if (name === (0, $boahT.NORMAL_TEXT).name && nodes.paragraph) return $597e6e1491fda64d$export$63c4f0859cc75dc6()({
            tr: tr
        });
        if (name === 'smallText' && (0, $1oCLl.expValEquals)('platform_editor_small_font_size', 'isEnabled', true)) return $597e6e1491fda64d$export$7343796298b2524f()({
            tr: tr
        });
        const headingBlockType = (0, $boahT.HEADINGS_BY_NAME)[name];
        if (headingBlockType && nodes.heading && headingBlockType.level) return $597e6e1491fda64d$export$c6a04dca1ed03a3c(headingBlockType.level)({
            tr: tr
        });
        return null;
    };
}
function $597e6e1491fda64d$export$c6a04dca1ed03a3c(level, fromBlockQuote) {
    return function({ tr: tr }) {
        const { selection: selection, doc: { type: { schema: schema } } } = tr;
        const ranges = selection instanceof (0, $7XFGZ.CellSelection) ? selection.ranges : [
            selection
        ];
        ranges.forEach(({ $from: $from, $to: $to })=>{
            if (fromBlockQuote) {
                const range = $from.blockRange($to);
                if (!range) return;
                // First, lift the content out of the blockquote
                const targetLiftDepth = (0, $aXG5V.liftTarget)(range);
                if (targetLiftDepth || targetLiftDepth === 0) tr.lift(range, targetLiftDepth);
                // Then apply the heading block type to the lifted content
                // We need to recalculate positions after the lift operation
                const newFrom = tr.mapping.map($from.pos);
                const newTo = tr.mapping.map($to.pos);
                tr.setBlockType(newFrom, newTo, schema.nodes.heading, {
                    level: level
                });
            } else tr.setBlockType($from.pos, $to.pos, schema.nodes.heading, {
                level: level
            });
        });
        // Remove fontSize mark from transformed content in range
        // List content stays as paragraphs (headings aren't allowed in list items),
        // but non-list content has been converted to headings by setBlockType above.
        const { fontSize: fontSize } = schema.marks;
        if (fontSize && (0, $1oCLl.expValEquals)('platform_editor_small_font_size', 'isEnabled', true)) {
            const allowedBlocks = [
                schema.nodes.paragraph,
                schema.nodes.heading
            ];
            if (selection instanceof (0, $7XFGZ.CellSelection)) selection.forEachCell((cell, pos)=>{
                (0, $dhoHU.createToggleBlockMarkOnRangeNext)(fontSize, ()=>false, allowedBlocks)(pos, pos + cell.nodeSize, tr);
            });
            else {
                const expandedRange = (0, $b4774db4d7677b9c$export$77bd22d0a1033d4)(tr);
                (0, $dhoHU.createToggleBlockMarkOnRangeNext)(fontSize, ()=>false, allowedBlocks)(expandedRange.from, expandedRange.to, tr);
            }
        }
        return tr;
    };
}
function $597e6e1491fda64d$export$3f9af78ebb95cc20(name, inputMethod, editorAnalyticsApi, fromBlockQuote) {
    return ({ tr: tr })=>{
        const { nodes: nodes, marks: marks } = tr.doc.type.schema;
        if (name === 'normal' && nodes.paragraph) return $597e6e1491fda64d$export$283e32d0388e302a(inputMethod, editorAnalyticsApi, fromBlockQuote)({
            tr: tr
        });
        if (name === 'smallText' && marks.fontSize && (0, $1oCLl.expValEquals)('platform_editor_small_font_size', 'isEnabled', true)) return $597e6e1491fda64d$export$2c10a6ea48e28b89(inputMethod, editorAnalyticsApi, fromBlockQuote)({
            tr: tr
        });
        const headingBlockType = (0, $boahT.HEADINGS_BY_NAME)[name];
        if (headingBlockType && nodes.heading && headingBlockType.level) return $597e6e1491fda64d$export$52d74b15bd103d7f(headingBlockType.level, inputMethod, editorAnalyticsApi, fromBlockQuote)({
            tr: tr
        });
        return null;
    };
}
function $597e6e1491fda64d$export$7343796298b2524f(fromBlockQuote) {
    return function({ tr: tr }) {
        const { marks: { fontSize: fontSize }, nodes: { paragraph: paragraph } } = tr.doc.type.schema;
        if (!fontSize) return null;
        const { selection: selection } = tr;
        const applySmallFontSize = (0, $dhoHU.createToggleBlockMarkOnRangeNext)(fontSize, ()=>({
                fontSize: 'small'
            }), [
            paragraph
        ]);
        if (fromBlockQuote) {
            const { $from: $from, $to: $to } = selection;
            const range = $from.blockRange($to);
            if (!range) return tr;
            const targetLiftDepth = (0, $aXG5V.liftTarget)(range);
            if (targetLiftDepth || targetLiftDepth === 0) tr.lift(range, targetLiftDepth);
            const from = tr.mapping.map($from.pos);
            const to = tr.mapping.map($to.pos);
            tr.setBlockType(from, to, paragraph);
            applySmallFontSize(from, to, tr);
        } else if (selection instanceof (0, $7XFGZ.CellSelection)) {
            const mapFrom = tr.steps.length;
            selection.forEachCell((cell, pos)=>{
                const from = tr.mapping.slice(mapFrom).map(pos);
                const to = from + cell.nodeSize;
                tr.setBlockType(from, to, paragraph);
                (0, $b4774db4d7677b9c$export$9fb148c84c583d2a)(tr, from, to);
                applySmallFontSize(from, to, tr);
            });
        } else {
            tr.setBlockType(selection.from, selection.to, paragraph);
            const expandedRange = (0, $b4774db4d7677b9c$export$77bd22d0a1033d4)(tr);
            (0, $b4774db4d7677b9c$export$9fb148c84c583d2a)(tr, expandedRange.from, expandedRange.to);
            applySmallFontSize(tr.mapping.map(expandedRange.from, -1), tr.mapping.map(expandedRange.to, 1), tr);
        }
        return tr;
    };
}
function $597e6e1491fda64d$export$2c10a6ea48e28b89(inputMethod, editorAnalyticsApi, fromBlockQuote) {
    return $597e6e1491fda64d$var$withCurrentHeadingLevel((previousHeadingLevel)=>({ tr: tr })=>{
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $d925B.ACTION).FORMATTED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_SMALL_TEXT,
                attributes: {
                    inputMethod: inputMethod,
                    previousBlockType: previousHeadingLevel !== undefined ? String(previousHeadingLevel) : undefined
                }
            })(tr);
            return $597e6e1491fda64d$export$7343796298b2524f(fromBlockQuote)({
                tr: tr
            });
        });
}
function $597e6e1491fda64d$export$63c4f0859cc75dc6(fromBlockQuote) {
    return function({ tr: tr }) {
        const { selection: selection, doc: { type: { schema: schema } } } = tr;
        // Apply normal text to the selection range (handles non-list content)
        const ranges = selection instanceof (0, $7XFGZ.CellSelection) ? selection.ranges : [
            selection
        ];
        ranges.forEach(({ $from: $from, $to: $to })=>{
            if (fromBlockQuote) {
                const range = $from.blockRange($to);
                if (!range) return;
                // First, lift the content out of the blockquote
                const targetLiftDepth = (0, $aXG5V.liftTarget)(range);
                if (targetLiftDepth || targetLiftDepth === 0) tr.lift(range, targetLiftDepth);
                const newFrom = tr.mapping.map($from.pos);
                const newTo = tr.mapping.map($to.pos);
                tr.setBlockType(newFrom, newTo, schema.nodes.paragraph, {});
            } else tr.setBlockType($from.pos, $to.pos, schema.nodes.paragraph);
        });
        // Remove fontSize mark from any lists the selection touches
        const { fontSize: fontSize } = schema.marks;
        if (fontSize && (0, $1oCLl.expValEquals)('platform_editor_small_font_size', 'isEnabled', true)) {
            if (selection instanceof (0, $7XFGZ.CellSelection)) selection.forEachCell((cell, pos)=>{
                (0, $dhoHU.createToggleBlockMarkOnRangeNext)(fontSize, ()=>false, [
                    schema.nodes.paragraph
                ])(pos, pos + cell.nodeSize, tr);
            });
            else {
                const expandedRange = (0, $b4774db4d7677b9c$export$77bd22d0a1033d4)(tr);
                (0, $dhoHU.createToggleBlockMarkOnRangeNext)(fontSize, ()=>false, [
                    schema.nodes.paragraph
                ])(expandedRange.from, expandedRange.to, tr);
            }
        }
        return tr;
    };
}
function $597e6e1491fda64d$export$195de5d8e201efd7(inputMethod, editorAnalyticsApi) {
    return function({ tr: tr }) {
        const formattingCleared = [];
        const schema = tr.doc.type.schema;
        (0, $39ecbfa01b1d975b$export$73b50f8f13648c71).forEach((mark)=>{
            const { from: from, to: to } = tr.selection;
            const markType = schema.marks[mark];
            if (!markType) return;
            if (tr.selection instanceof (0, $7XFGZ.CellSelection)) (0, $39ecbfa01b1d975b$export$bd443c1dba3019b8)(tr.selection, tr.doc, (node, pos)=>{
                const isTableCell = node.type === schema.nodes.tableCell || node.type === schema.nodes.tableHeader;
                if (!isTableCell) return true;
                if (tr.doc.rangeHasMark(pos, pos + node.nodeSize, markType)) {
                    formattingCleared.push((0, $39ecbfa01b1d975b$export$ce157a3b6664c924)[mark]);
                    tr.removeMark(pos, pos + node.nodeSize, markType);
                }
                return false;
            });
            else if (tr.doc.rangeHasMark(from, to, markType)) {
                formattingCleared.push((0, $39ecbfa01b1d975b$export$ce157a3b6664c924)[mark]);
                tr.removeMark(from, to, markType);
            }
        });
        (0, $39ecbfa01b1d975b$export$a5cb0c20bd02ce0c).forEach((nodeName)=>{
            const formattedNodeType = schema.nodes[nodeName];
            const { $from: $from, $to: $to } = tr.selection;
            if (tr.selection instanceof (0, $7XFGZ.CellSelection)) (0, $39ecbfa01b1d975b$export$bd443c1dba3019b8)(tr.selection, tr.doc, (0, $39ecbfa01b1d975b$export$10ed2145ce1a03b1)(schema, tr, formattedNodeType, nodeName, formattingCleared));
            else tr.doc.nodesBetween($from.pos, $to.pos, (0, $39ecbfa01b1d975b$export$10ed2145ce1a03b1)(schema, tr, formattedNodeType, nodeName, formattingCleared));
        });
        tr.setStoredMarks([]);
        if (formattingCleared.length) editorAnalyticsApi?.attachAnalyticsEvent({
            action: (0, $d925B.ACTION).FORMATTED,
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_CLEAR,
            attributes: {
                inputMethod: inputMethod,
                formattingCleared: formattingCleared,
                dropdownMenu: 'textStyle'
            }
        })(tr);
        return tr;
    };
}
function $597e6e1491fda64d$var$withCurrentHeadingLevel(fn) {
    return ({ tr: tr })=>{
        // Find all headings and paragraphs of text
        const { heading: heading, paragraph: paragraph } = tr.doc.type.schema.nodes;
        const nodes = (0, $bGUOY.filterChildrenBetween)(tr.doc, tr.selection.from, tr.selection.to, (node)=>{
            return node.type === heading || node.type === paragraph;
        });
        // Check each paragraph and/or heading and check for consistent level
        let level;
        for (const node of nodes){
            const nodeLevel = node.node.type === heading ? node.node.attrs.level : 0;
            if (!level) level = nodeLevel;
            else if (nodeLevel !== level) {
                // Conflict in level, therefore inconsistent and undefined
                level = undefined;
                break;
            }
        }
        return fn(level)({
            tr: tr
        });
    };
}
function $597e6e1491fda64d$export$283e32d0388e302a(inputMethod, editorAnalyticsApi, fromBlockQuote) {
    return $597e6e1491fda64d$var$withCurrentHeadingLevel((previousHeadingLevel)=>({ tr: tr })=>{
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $d925B.ACTION).FORMATTED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_HEADING,
                attributes: {
                    inputMethod: inputMethod,
                    newHeadingLevel: 0,
                    previousHeadingLevel: previousHeadingLevel
                }
            })(tr);
            return $597e6e1491fda64d$export$63c4f0859cc75dc6(fromBlockQuote)({
                tr: tr
            });
        });
}
const $597e6e1491fda64d$export$52d74b15bd103d7f = (newHeadingLevel, inputMethod, editorAnalyticsApi, fromBlockQuote)=>{
    return $597e6e1491fda64d$var$withCurrentHeadingLevel((previousHeadingLevel)=>({ tr: tr })=>{
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $d925B.ACTION).FORMATTED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_HEADING,
                attributes: {
                    inputMethod: inputMethod,
                    newHeadingLevel: newHeadingLevel,
                    previousHeadingLevel: previousHeadingLevel
                }
            })(tr);
            return $597e6e1491fda64d$export$c6a04dca1ed03a3c(newHeadingLevel, fromBlockQuote)({
                tr: tr
            });
        });
};
function $597e6e1491fda64d$var$insertBlockQuote() {
    return function(state, dispatch) {
        const { nodes: nodes } = state.schema;
        if (nodes.paragraph && nodes.blockquote) return (0, $8vgNB.wrapSelectionIn)(nodes.blockquote)(state, dispatch);
        return false;
    };
}
const $597e6e1491fda64d$export$50b4331f407b3ab6 = (inputMethod, editorAnalyticsApi)=>{
    return (0, $dAtrv.withAnalytics)(editorAnalyticsApi, {
        action: (0, $d925B.ACTION).FORMATTED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
        eventType: (0, $d925B.EVENT_TYPE).TRACK,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_BLOCK_QUOTE,
        attributes: {
            inputMethod: inputMethod
        }
    })($597e6e1491fda64d$var$insertBlockQuote());
};
function $597e6e1491fda64d$export$f5e16b3b6b62d83(inputMethod, editorAnalyticsApi) {
    return $597e6e1491fda64d$var$withCurrentHeadingLevel(()=>({ tr: tr })=>{
            const { nodes: nodes } = tr.doc.type.schema;
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $d925B.ACTION).FORMATTED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_BLOCK_QUOTE,
                attributes: {
                    inputMethod: inputMethod
                }
            })(tr);
            return (0, $e186639b697f69c2$export$bb05c9a6c853122f)(nodes.blockquote)({
                tr: tr
            });
        });
}
const $597e6e1491fda64d$export$9c6026f8ac831f44 = (state, dispatch)=>{
    const { $cursor: $cursor } = state.selection;
    if ($cursor && !$cursor.nodeBefore && !$cursor.nodeAfter && $cursor.pos === 1) {
        const { tr: tr, schema: schema } = state;
        const { paragraph: paragraph } = schema.nodes;
        const { parent: parent } = $cursor;
        /**
		 * Use cases:
		 * 1. Change `heading` to `paragraph`
		 * 2. Remove block marks
		 *
		 * NOTE: We already know it's an empty doc so it's safe to use 0
		 */ tr.setNodeMarkup(0, paragraph, parent.attrs, []);
        if (dispatch) dispatch(tr);
        return true;
    }
    return false;
};






var $afcIe = parcelRequire("afcIe");


var $1S4f7 = parcelRequire("1S4f7");







var $aIMBk = parcelRequire("aIMBk");

var $14sLv = parcelRequire("14sLv");


const $df7153fd4a0164a3$var$MAX_HEADING_LEVEL = 6;
function $df7153fd4a0164a3$var$getHeadingLevel(match) {
    return {
        level: match[1].length
    };
}
function $df7153fd4a0164a3$var$headingRule(nodeType, maxLevel) {
    return (0, $b4774db4d7677b9c$export$644b98fd2fd87b8b)({
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        match: new RegExp('^(#{1,' + maxLevel + '})\\s$'),
        nodeType: nodeType,
        getAttrs: $df7153fd4a0164a3$var$getHeadingLevel
    });
}
function $df7153fd4a0164a3$var$blockQuoteRule(nodeType) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return (0, $b4774db4d7677b9c$export$1fe8b64ae159a0fa)(/^\s*>\s$/, nodeType);
}
/**
 * Get heading rules
 *
 * @param {Schema} schema
 * @returns {InputRuleWithHandler[]}
 */ function $df7153fd4a0164a3$var$getHeadingRules(editorAnalyticsAPI, schema) {
    // '# ' for h1, '## ' for h2 and etc
    const hashRule = $df7153fd4a0164a3$var$headingRule(schema.nodes.heading, $df7153fd4a0164a3$var$MAX_HEADING_LEVEL);
    const leftNodeReplacementHashRule = (0, $4VXMf.createRule)(// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    new RegExp(`${(0, $14sLv.leafNodeReplacementCharacter)}(#{1,6})\\s$`), (state, match, start, end)=>{
        const level = match[1].length;
        return (0, $afcIe.insertBlock)(state, schema.nodes.heading, start, end, {
            level: level
        });
    });
    // New analytics handler
    const ruleWithHeadingAnalytics = (0, $l03WE.inputRuleWithAnalytics)((_state, matchResult)=>({
            action: (0, $d925B.ACTION).FORMATTED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_HEADING,
            attributes: {
                inputMethod: (0, $d925B.INPUT_METHOD).FORMATTING,
                newHeadingLevel: $df7153fd4a0164a3$var$getHeadingLevel(matchResult).level
            }
        }), editorAnalyticsAPI);
    return [
        ruleWithHeadingAnalytics(hashRule),
        ruleWithHeadingAnalytics(leftNodeReplacementHashRule)
    ];
}
/**
 * Get all block quote input rules
 *
 * @param {Schema} schema
 * @returns {InputRuleWithHandler[]}
 */ function $df7153fd4a0164a3$var$getBlockQuoteRules(editorAnalyticsAPI, schema) {
    // '> ' for blockquote
    const greatherThanRule = $df7153fd4a0164a3$var$blockQuoteRule(schema.nodes.blockquote);
    const leftNodeReplacementGreatherRule = (0, $4VXMf.createRule)(// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    new RegExp(`${(0, $14sLv.leafNodeReplacementCharacter)}\\s*>\\s$`), (state, _match, start, end)=>{
        return (0, $afcIe.insertBlock)(state, schema.nodes.blockquote, start, end);
    });
    // Analytics V3 handler
    const ruleWithBlockQuoteAnalytics = (0, $l03WE.inputRuleWithAnalytics)({
        action: (0, $d925B.ACTION).FORMATTED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
        eventType: (0, $d925B.EVENT_TYPE).TRACK,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_BLOCK_QUOTE,
        attributes: {
            inputMethod: (0, $d925B.INPUT_METHOD).FORMATTING
        }
    }, editorAnalyticsAPI);
    return [
        ruleWithBlockQuoteAnalytics(greatherThanRule),
        ruleWithBlockQuoteAnalytics(leftNodeReplacementGreatherRule)
    ];
}
function $df7153fd4a0164a3$var$inputRulePlugin(editorAnalyticsAPI, schema, featureFlags) {
    const rules = [];
    if (schema.nodes.heading) rules.push(...$df7153fd4a0164a3$var$getHeadingRules(editorAnalyticsAPI, schema));
    if (schema.nodes.blockquote) rules.push(...$df7153fd4a0164a3$var$getBlockQuoteRules(editorAnalyticsAPI, schema));
    if (rules.length !== 0) return new (0, $1S4f7.SafePlugin)((0, $aIMBk.createPlugin)('block-type', rules, {
        isBlockNodeRule: true
    }));
    return;
}
var $df7153fd4a0164a3$export$2e2bcd8739ae039 = $df7153fd4a0164a3$var$inputRulePlugin;











var $e7tBw = parcelRequire("e7tBw");


var $astHL = parcelRequire("astHL");


var $ke2AI = parcelRequire("ke2AI");






var $ks2lK = parcelRequire("ks2lK");

// We should override default behaviour when selection spans node depths or
// ends at a node junction
const $bc9224a82e115b83$var$shouldMoveCursorAfterDelete = (state)=>{
    const { selection: { $from: $from, $to: $to } } = state;
    const nodeRange = $from.blockRange($to);
    if (!nodeRange) return false;
    const hasSameAncestor = $from.depth === $to.depth && $from.depth - 1 === nodeRange.depth;
    const toPositionHasNodeAfter = !!$to.nodeAfter;
    if (hasSameAncestor || toPositionHasNodeAfter) return false;
    return true;
};
const $bc9224a82e115b83$export$6c408f720f6b44a7 = (state, dispatch)=>{
    if (state.selection.empty || !(state.selection instanceof (0, $ks2lK.TextSelection))) return false;
    if (!$bc9224a82e115b83$var$shouldMoveCursorAfterDelete(state)) return false;
    const { tr: tr } = state;
    tr.deleteSelection();
    // Make sure the next position is not out of boundaries
    const previousPosition = Math.min(Math.max(state.selection.$from.pos, 0), tr.doc.content.size);
    // Override default delete behaviour that moves the cursor to first suitable position after selection (postive bias).
    // See. selectionToInsertionEnd. We will override behavior with negative bias (search for suitable cursor position backwards).
    tr.setSelection((0, $ks2lK.Selection).near(tr.doc.resolve(previousPosition), -1));
    if (dispatch) dispatch(tr.scrollIntoView());
    return true;
};








// function to check whether the selected node is the sole decision item in the decision list
const $7d61936d23892cf2$var$isSelectedNodeSoleDecisionItem = (state)=>{
    const isDecisionItemNodeSelected = state.selection instanceof (0, $ks2lK.NodeSelection) && state.selection.node.type.name === 'decisionItem';
    if (!isDecisionItemNodeSelected) return false;
    const decisionList = (0, $8m4tT.findParentNodeOfType)([
        state.schema.nodes.decisionList
    ])(state.selection)?.node;
    return decisionList?.childCount === 1;
};
const $7d61936d23892cf2$var$isSelectedNodeMediaGroup = (state)=>{
    return Boolean(state.selection instanceof (0, $ks2lK.NodeSelection) && state.selection.node.type.name === 'media' && state.selection.$head.parent.type.name === 'mediaGroup');
};
function $7d61936d23892cf2$export$9c1a524875bfb8ec(isNodeAWrappingBlockNode) {
    return (state, dispatch)=>{
        const { tr: tr, selection: { $from: $from, $to: $to }, doc: doc } = state;
        if ($from.pos === $to.pos) return false;
        let selectionCrossesWrappingBlockNode = false;
        doc.nodesBetween($from.pos, $to.pos, (node, pos)=>{
            // Optimisation. If selection crosses wrapping block node
            // short circuit the loop by returning false
            if (isNodeAWrappingBlockNode(node)) {
                selectionCrossesWrappingBlockNode = true;
                return false;
            }
        });
        if (!selectionCrossesWrappingBlockNode) return false;
        const isParentNodeOfTypePanel = (0, $8m4tT.hasParentNodeOfType)([
            state.schema.nodes.panel
        ])(state.selection);
        const isParentNodeOfTypeBlockQuote = (0, $8m4tT.hasParentNodeOfType)([
            state.schema.nodes.blockquote
        ])(state.selection);
        if ((isParentNodeOfTypePanel || isParentNodeOfTypeBlockQuote) && $7d61936d23892cf2$var$isSelectedNodeMediaGroup(state) || isParentNodeOfTypePanel && $7d61936d23892cf2$var$isSelectedNodeSoleDecisionItem(state)) {
            tr.setSelection(new (0, $ks2lK.TextSelection)(tr.doc.resolve($from.before())));
            tr.delete($from.before(), $from.after());
        } else tr.delete($from.pos, $to.pos);
        if (dispatch) dispatch(tr);
        return true;
    };
}



const $74a370d48c364617$var$backspaceCommand = (0, $astHL.chainCommands)((0, $597e6e1491fda64d$export$9c6026f8ac831f44), (0, $7d61936d23892cf2$export$9c1a524875bfb8ec)((0, $b4774db4d7677b9c$export$3a2c03e35bc6c7a8)), (0, $bc9224a82e115b83$export$6c408f720f6b44a7));
const $74a370d48c364617$var$del = (0, $astHL.chainCommands)((0, $e7tBw.deleteEmptyParagraphAndMoveBlockUp)((0, $b4774db4d7677b9c$export$3a2c03e35bc6c7a8)), (0, $7d61936d23892cf2$export$9c1a524875bfb8ec)((0, $b4774db4d7677b9c$export$3a2c03e35bc6c7a8)), (0, $bc9224a82e115b83$export$6c408f720f6b44a7));
function $74a370d48c364617$export$2e2bcd8739ae039(editorAnalyticsApi, schema, _featureFlags) {
    const list = {};
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.insertNewLine).common, (0, $e7tBw.insertNewLineWithAnalytics)(editorAnalyticsApi), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.bindKeymapWithCommand)((0, $hgeg8.moveUp).common, (0, $e7tBw.createNewParagraphAbove), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.bindKeymapWithCommand)((0, $hgeg8.moveDown).common, (0, $e7tBw.createNewParagraphBelow), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.bindKeymapWithCommand)((0, $hgeg8.findKeyMapForBrowser)((0, $hgeg8.redo)), (0, $ke2AI.redo), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.bindKeymapWithCommand)((0, $hgeg8.undo).common, (0, $ke2AI.undo), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.bindKeymapWithCommand)((0, $hgeg8.backspace).common, $74a370d48c364617$var$backspaceCommand, list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.bindKeymapWithCommand)((0, $hgeg8.deleteKey).common, $74a370d48c364617$var$del, list);
    (0, $hgeg8.bindKeymapWithCommand)((0, $hgeg8.forwardDelete).mac, $74a370d48c364617$var$del, list);
    if (schema.nodes[$boahT.BLOCK_QUOTE.nodeName]) (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.findShortcutByKeymap)((0, $hgeg8.toggleBlockQuote)), (0, $597e6e1491fda64d$export$50b4331f407b3ab6)((0, $d925B.INPUT_METHOD).KEYBOARD, editorAnalyticsApi), list);
    return (0, $60bKU.keymap)(list);
}






var $8Bqaf = parcelRequire("8Bqaf");


var $d7ZU3 = parcelRequire("d7ZU3");

















const $97a0b8dc5b45c93b$var$KEY_0 = 48;
const $97a0b8dc5b45c93b$var$KEY_1 = 49;
const $97a0b8dc5b45c93b$var$KEY_2 = 50;
const $97a0b8dc5b45c93b$var$KEY_3 = 51;
const $97a0b8dc5b45c93b$var$KEY_4 = 52;
const $97a0b8dc5b45c93b$var$KEY_5 = 53;
const $97a0b8dc5b45c93b$var$KEY_6 = 54;
const $97a0b8dc5b45c93b$export$495808184472a100 = 55;
const $97a0b8dc5b45c93b$export$442e847723cf0569 = [
    $97a0b8dc5b45c93b$var$KEY_0,
    $97a0b8dc5b45c93b$var$KEY_1,
    $97a0b8dc5b45c93b$var$KEY_2,
    $97a0b8dc5b45c93b$var$KEY_3,
    $97a0b8dc5b45c93b$var$KEY_4,
    $97a0b8dc5b45c93b$var$KEY_5,
    $97a0b8dc5b45c93b$var$KEY_6
];
const $97a0b8dc5b45c93b$var$NUMPAD_KEY_0 = 96;
const $97a0b8dc5b45c93b$var$NUMPAD_KEY_1 = 97;
const $97a0b8dc5b45c93b$var$NUMPAD_KEY_2 = 98;
const $97a0b8dc5b45c93b$var$NUMPAD_KEY_3 = 99;
const $97a0b8dc5b45c93b$var$NUMPAD_KEY_4 = 100;
const $97a0b8dc5b45c93b$var$NUMPAD_KEY_5 = 101;
const $97a0b8dc5b45c93b$var$NUMPAD_KEY_6 = 102;
const $97a0b8dc5b45c93b$export$fcc4b4cb2de35e6 = [
    $97a0b8dc5b45c93b$var$NUMPAD_KEY_0,
    $97a0b8dc5b45c93b$var$NUMPAD_KEY_1,
    $97a0b8dc5b45c93b$var$NUMPAD_KEY_2,
    $97a0b8dc5b45c93b$var$NUMPAD_KEY_3,
    $97a0b8dc5b45c93b$var$NUMPAD_KEY_4,
    $97a0b8dc5b45c93b$var$NUMPAD_KEY_5,
    $97a0b8dc5b45c93b$var$NUMPAD_KEY_6
];



const $897f6ae76c9017ad$var$blockTypeForNode = (node, schema)=>{
    if (node.type === schema.nodes.heading) {
        const maybeNode = (0, $boahT.HEADINGS_BY_LEVEL)[node.attrs['level']];
        if (maybeNode) return maybeNode;
    } else if (node.marks.some((m)=>m.type.name === 'fontSize' && m.attrs.fontSize === 'small') && (0, $1oCLl.expValEquals)('platform_editor_small_font_size', 'isEnabled', true)) return 0, $boahT.SMALL_TEXT;
    else if (node.type === schema.nodes.paragraph) return 0, $boahT.NORMAL_TEXT;
    else if (node.type === schema.nodes.blockquote) return 0, $boahT.BLOCK_QUOTE;
    return 0, $boahT.OTHER;
};
const $897f6ae76c9017ad$var$isBlockTypeSchemaSupported = (blockType, state)=>{
    switch(blockType){
        case 0, $boahT.NORMAL_TEXT:
            return !!state.schema.nodes.paragraph;
        case 0, $boahT.HEADING_1:
        case 0, $boahT.HEADING_2:
        case 0, $boahT.HEADING_3:
        case 0, $boahT.HEADING_4:
        case 0, $boahT.HEADING_5:
        case 0, $boahT.HEADING_6:
            return !!state.schema.nodes.heading;
        case 0, $boahT.SMALL_TEXT:
            return !!state.schema.marks.fontSize && (0, $1oCLl.expValEquals)('platform_editor_small_font_size', 'isEnabled', true);
        case 0, $boahT.BLOCK_QUOTE:
            return !!state.schema.nodes.blockquote;
        case 0, $boahT.CODE_BLOCK:
            return !!state.schema.nodes.codeBlock;
        case 0, $boahT.PANEL:
            return !!state.schema.nodes.panel;
    }
    return;
};
const $897f6ae76c9017ad$var$detectBlockType = (availableBlockTypes, state)=>{
    // Before a document is loaded, there is no selection.
    if (!state.selection) return 0, $boahT.NORMAL_TEXT;
    let blockType;
    const { $from: $from, $to: $to } = state.selection;
    state.doc.nodesBetween($from.pos, $to.pos, (node)=>{
        const nodeBlockType = availableBlockTypes.filter((blockType)=>blockType === $897f6ae76c9017ad$var$blockTypeForNode(node, state.schema));
        if (nodeBlockType.length > 0) {
            if (!blockType) blockType = nodeBlockType[0];
            else if (blockType !== (0, $boahT.OTHER) && blockType !== nodeBlockType[0]) blockType = (0, $boahT.OTHER);
            return false;
        }
    });
    return blockType || (0, $boahT.OTHER);
};
const $897f6ae76c9017ad$var$autoformatHeading = (headingLevel, editorAnalyticsApi)=>{
    if (headingLevel === 0) return (0, $597e6e1491fda64d$export$283e32d0388e302a)((0, $d925B.INPUT_METHOD).FORMATTING, editorAnalyticsApi);
    return (0, $597e6e1491fda64d$export$52d74b15bd103d7f)(headingLevel, (0, $d925B.INPUT_METHOD).FORMATTING, editorAnalyticsApi);
};
const $897f6ae76c9017ad$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('blockTypePlugin');
const $897f6ae76c9017ad$export$ae829ec7b2625219 = (editorAPI, // eslint-disable-next-line @typescript-eslint/no-explicit-any
dispatch, lastNodeMustBeParagraph, includeBlockQuoteAsTextstyleOption, allowFontSize)=>{
    const editorAnalyticsApi = editorAPI?.analytics?.actions;
    let altKeyLocation = 0;
    return new (0, $1S4f7.SafePlugin)({
        appendTransaction (_transactions, _oldState, newState) {
            if (lastNodeMustBeParagraph) {
                const pos = newState.doc.resolve(newState.doc.content.size - 1);
                const lastNode = pos.node(1);
                const { paragraph: paragraph } = newState.schema.nodes;
                if (lastNode && lastNode.isBlock && lastNode.type !== paragraph) {
                    const tr = newState.tr.insert(newState.doc.content.size, newState.schema.nodes.paragraph.create());
                    return (0, $dh538.fg)('platform_editor_block_menu_jira_patch_2') ? tr.setMeta((0, $8Bqaf.INSERTED_TRAILING_PARAGRAPH_TO_LAST_NODE_META), true) : tr;
                }
            }
        },
        state: {
            init (_config, state) {
                const availableBlockTypes = (0, $boahT.TEXT_BLOCK_TYPES).filter((blockType)=>$897f6ae76c9017ad$var$isBlockTypeSchemaSupported(blockType, state));
                const availableWrapperBlockTypes = (0, $boahT.WRAPPER_BLOCK_TYPES).filter((blockType)=>$897f6ae76c9017ad$var$isBlockTypeSchemaSupported(blockType, state));
                const BLOCK_TYPES_IN_DROPDOWN = (0, $boahT.getBlockTypesInDropdown)(includeBlockQuoteAsTextstyleOption);
                const availableBlockTypesInDropdown = BLOCK_TYPES_IN_DROPDOWN.filter((blockType)=>$897f6ae76c9017ad$var$isBlockTypeSchemaSupported(blockType, state));
                const formattingIsPresent = (0, $b4774db4d7677b9c$export$bce51f4ee2032263)(availableBlockTypesInDropdown) ? (0, $b4774db4d7677b9c$export$4b48a1fc423972ea)(state) : undefined;
                return {
                    currentBlockType: $897f6ae76c9017ad$var$detectBlockType(availableBlockTypesInDropdown, state),
                    blockTypesDisabled: (0, $b4774db4d7677b9c$export$52adb8d9a3386cb8)(state, allowFontSize),
                    availableBlockTypes: availableBlockTypes,
                    availableWrapperBlockTypes: availableWrapperBlockTypes,
                    availableBlockTypesInDropdown: availableBlockTypesInDropdown,
                    formattingIsPresent: formattingIsPresent
                };
            },
            apply (_tr, oldPluginState, _oldState, newState) {
                const newPluginState = {
                    ...oldPluginState,
                    currentBlockType: $897f6ae76c9017ad$var$detectBlockType(oldPluginState.availableBlockTypesInDropdown, newState),
                    blockTypesDisabled: (0, $b4774db4d7677b9c$export$52adb8d9a3386cb8)(newState, allowFontSize),
                    formattingIsPresent: (0, $b4774db4d7677b9c$export$bce51f4ee2032263)(oldPluginState.availableBlockTypesInDropdown) ? (0, $b4774db4d7677b9c$export$4b48a1fc423972ea)(newState) : undefined
                };
                if (newPluginState.currentBlockType !== oldPluginState.currentBlockType || newPluginState.blockTypesDisabled !== oldPluginState.blockTypesDisabled || newPluginState.formattingIsPresent !== oldPluginState.formattingIsPresent) dispatch($897f6ae76c9017ad$export$18d4026d1ea86bb1, newPluginState);
                return newPluginState;
            }
        },
        key: $897f6ae76c9017ad$export$18d4026d1ea86bb1,
        props: {
            /**
			 * As we only want the left alt key to work for headings shortcuts on Windows
			 * we can't use prosemirror-keymap and need to handle these shortcuts specially
			 * Shortcut on Mac: Cmd-Opt-{heading level}
			 * Shortcut on Windows: Ctrl-LeftAlt-{heading level}
			 */ handleKeyDown: (view, event)=>{
                let headingLevel = (0, $97a0b8dc5b45c93b$export$442e847723cf0569).indexOf(event.keyCode);
                if (headingLevel === -1) // Check for numpad keys if not found in digits row
                headingLevel = (0, $97a0b8dc5b45c93b$export$fcc4b4cb2de35e6).indexOf(event.keyCode);
                const browser = (0, $d7ZU3.getBrowserInfo)();
                if (headingLevel > -1 && event.altKey) {
                    if (browser.mac && event.metaKey) return editorAPI?.core?.actions.execute($897f6ae76c9017ad$var$autoformatHeading(headingLevel, editorAnalyticsApi)) ?? false;
                    else if (!browser.mac && event.ctrlKey && altKeyLocation !== event.DOM_KEY_LOCATION_RIGHT) return editorAPI?.core?.actions.execute($897f6ae76c9017ad$var$autoformatHeading(headingLevel, editorAnalyticsApi)) ?? false;
                } else if (event.keyCode === (0, $97a0b8dc5b45c93b$export$495808184472a100) && event.altKey && (0, $1oCLl.expValEquals)('platform_editor_small_font_size', 'isEnabled', true)) {
                    if (browser.mac && event.metaKey) return editorAPI?.core?.actions.execute((0, $597e6e1491fda64d$export$2c10a6ea48e28b89)((0, $d925B.INPUT_METHOD).SHORTCUT, editorAnalyticsApi)) ?? false;
                    else if (!browser.mac && event.ctrlKey && altKeyLocation !== event.DOM_KEY_LOCATION_RIGHT) return editorAPI?.core?.actions.execute((0, $597e6e1491fda64d$export$2c10a6ea48e28b89)((0, $d925B.INPUT_METHOD).SHORTCUT, editorAnalyticsApi)) ?? false;
                } else if (event.key === 'Alt') // event.location is for the current key only; when a user hits Ctrl-Alt-1 the
                // location refers to the location of the '1' key
                // We store the location of the Alt key when it is hit to check against later
                altKeyLocation = event.location;
                else if (!event.altKey) altKeyLocation = 0;
                return false;
            }
        }
    });
};









var $eiA8Z = parcelRequire("eiA8Z");




/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $9K4OG = parcelRequire("9K4OG");


var $aXWIB = parcelRequire("aXWIB");





var $2zaaI = parcelRequire("2zaaI");


var $cORDs = parcelRequire("cORDs");


var $h4TOP = parcelRequire("h4TOP");


var $aFUXX = parcelRequire("aFUXX");


var $f8c3d = parcelRequire("f8c3d");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");





var $60yhz = parcelRequire("60yhz");




/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 












var $iMS6j = parcelRequire("iMS6j");




var $a4eZN = parcelRequire("a4eZN");


var $ghftu = parcelRequire("ghftu");










var $dZ8uq = parcelRequire("dZ8uq");




/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766



/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766






const $c7d9f9b88472f185$export$1b5f3b43e6c4a8ee = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& blockquote': {
        boxSizing: 'border-box',
        color: 'inherit',
        width: '100%',
        display: 'inline-block',
        paddingLeft: "var(--ds-space-200, 16px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        borderLeft: `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border, #0B120E24)"}`,
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: `${(0, $aFUXX.blockNodesVerticalMargin)} 0 0 0`,
        marginRight: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "[dir='rtl'] &": {
            paddingLeft: 0,
            paddingRight: "var(--ds-space-200, 16px)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:first-child': {
            marginTop: 0
        },
        '&::before': {
            content: "''"
        },
        '&::after': {
            content: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& p': {
            display: 'block'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '& table, & table:last-child': {
            display: 'inline-table'
        },
        // Workaround for overriding the inline-block display on last child of a blockquote set in CSS reset.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> .code-block:last-child, >.mediaSingleView-content-wrap:last-child, >.mediaGroupView-content-wrap:last-child': {
            display: 'block'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '> .extensionView-content-wrap:last-child': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            display: 'block'
        }
    }
});

/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /* eslint-disable @atlaskit/design-system/use-tokens-space */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766







var $ilPbq = parcelRequire("ilPbq");

const $040b8d996f78bca8$var$headingWithAlignmentStyles = ()=>// Override marginTop: 0 with default margin found in headingsSharedStyles for first heading in alignment block that is not the first child
    ({
        '.fabric-editor-block-mark.fabric-editor-alignment:not(:first-child)': {
            '> h1:first-child': {
                marginTop: '1.667em'
            },
            ' > h2:first-child': {
                marginTop: '1.8em'
            },
            '> h3:first-child': {
                marginTop: '2em'
            },
            '> h4:first-child': {
                marginTop: '1.357em'
            },
            '> h5:first-child': {
                marginTop: '1.667em'
            },
            '> h6:first-child': {
                marginTop: '1.455em'
            }
        },
        // Set marginTop: 0 if alignment block is next to a gap cursor or widget that is first child
        '.ProseMirror-gapcursor:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .ProseMirror-widget:nth-child(2) + .fabric-editor-block-mark.fabric-editor-alignment': {
            '> :is(h1, h2, h3, h4, h5, h6):first-child': {
                marginTop: '0'
            }
        }
    });
const $040b8d996f78bca8$export$9272613b68afed4b = (_typographyTheme)=>{
    if ((0, $dh538.fg)('platform_editor_typography_ugc')) return /*#__PURE__*/ (0, $9K4OG.css)({
        '& h1': {
            font: (0, $ilPbq.default)('editor.font.heading.h1'),
            marginBottom: 0,
            marginTop: '1.45833em',
            '& strong': {
                fontWeight: (0, $ilPbq.default)('editor.font.weight.heading.h1.bold')
            },
            '&::before': {}
        },
        '& h2': {
            font: (0, $ilPbq.default)('editor.font.heading.h2'),
            marginTop: '1.4em',
            marginBottom: 0,
            '& strong': {
                fontWeight: (0, $ilPbq.default)('editor.font.weight.heading.h1.bold')
            }
        },
        '& h3': {
            font: (0, $ilPbq.default)('editor.font.heading.h3'),
            marginTop: '1.31249em',
            marginBottom: 0,
            '& strong': {
                fontWeight: (0, $ilPbq.default)('editor.font.weight.heading.h1.bold')
            }
        },
        '& h4': {
            font: (0, $ilPbq.default)('editor.font.heading.h4'),
            marginTop: '1.25em',
            '& strong': {
                fontWeight: (0, $ilPbq.default)('editor.font.weight.heading.h1.bold')
            }
        },
        '& h5': {
            font: (0, $ilPbq.default)('editor.font.heading.h5'),
            marginTop: '1.45833em',
            textTransform: 'none',
            '& strong': {
                fontWeight: (0, $ilPbq.default)('editor.font.weight.heading.h1.bold')
            }
        },
        '& h6': {
            font: (0, $ilPbq.default)('editor.font.heading.h6'),
            marginTop: '1.59091em',
            textTransform: 'none',
            '& strong': {
                fontWeight: (0, $ilPbq.default)('editor.font.weight.heading.h1.bold')
            }
        },
        ...$040b8d996f78bca8$var$headingWithAlignmentStyles()
    });
    else return /*#__PURE__*/ (0, $9K4OG.css)({
        '& h1': {
            fontSize: `${24 / 14}em`,
            fontStyle: 'inherit',
            lineHeight: 28 / 24,
            color: "var(--ds-text, #292A2E)",
            fontWeight: "var(--ds-font-weight-medium, 500)",
            letterSpacing: `-0.01em`,
            marginBottom: 0,
            marginTop: '1.667em'
        },
        '& h2': {
            fontSize: `${20 / 14}em`,
            fontStyle: 'inherit',
            lineHeight: 1.2,
            color: "var(--ds-text, #292A2E)",
            fontWeight: "var(--ds-font-weight-medium, 500)",
            letterSpacing: `-0.008em`,
            marginTop: '1.8em',
            marginBottom: 0
        },
        '& h3': {
            fontSize: `${16 / 14}em`,
            fontStyle: 'inherit',
            lineHeight: 1.25,
            color: "var(--ds-text, #292A2E)",
            fontWeight: "var(--ds-font-weight-semibold, 600)",
            letterSpacing: `-0.006em`,
            marginTop: '2em',
            marginBottom: 0
        },
        '& h4': {
            fontSize: `${1}em`,
            fontStyle: 'inherit',
            lineHeight: 16 / 14,
            color: "var(--ds-text, #292A2E)",
            fontWeight: "var(--ds-font-weight-semibold, 600)",
            letterSpacing: `-0.003em`,
            marginTop: '1.357em'
        },
        '& h5': {
            fontSize: `${12 / 14}em`,
            fontStyle: 'inherit',
            lineHeight: 16 / 12,
            color: "var(--ds-text, #292A2E)",
            fontWeight: "var(--ds-font-weight-semibold, 600)",
            marginTop: '1.667em',
            textTransform: 'none'
        },
        '& h6': {
            fontSize: `${11 / 14}em`,
            fontStyle: 'inherit',
            lineHeight: 16 / 11,
            color: "var(--ds-text-subtlest, #6B6E76)",
            fontWeight: "var(--ds-font-weight-bold, 653)",
            marginTop: '1.455em',
            textTransform: 'none'
        },
        ...$040b8d996f78bca8$var$headingWithAlignmentStyles()
    });
};



var $6f5RK = parcelRequire("6f5RK");

function $c306d1266b64b283$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c306d1266b64b283$export$2e548ca9c55ac73f = (tagName, selected, typographyTheme)=>{
    // TEMP FIX: See https://product-fabric.atlassian.net/browse/ED-13878
    const selectedStyle = selected ? `${tagName} { color: ${"var(--ds-text, #292A2E)"} !important; }` : '';
    return ()=>/*#__PURE__*/ (0, $9K4OG.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        tagName === 'blockquote' ? (0, $c7d9f9b88472f185$export$1b5f3b43e6c4a8ee) : (0, $040b8d996f78bca8$export$9272613b68afed4b)(typographyTheme), ">{h1, h2, h3, h4, h5, h6{margin-top:0;}blockquote{padding-top:0;padding-bottom:0;margin-top:0;}}", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        selectedStyle);
};
const $c306d1266b64b283$export$54ea58af6cf8bf3a = /*#__PURE__*/ (0, $9K4OG.css)((0, $6f5RK.shortcutStyle), "margin-left:var(--ds-space-200, 16px);color:var(--ds-icon, #292A2E);");
const $c306d1266b64b283$export$b09cf4fbc27c2bae = {
    name: "1cmggog",
    styles: "color:var(--ds-icon, #292A2E)"
};
const $c306d1266b64b283$export$4f9ef2b7bddb4c3a = {
    name: "1eh91m4",
    styles: "margin-left:var(--ds-space-050, 4px);min-width:40px"
};
const $c306d1266b64b283$export$e1f541b6d8e35681 = {
    name: "1igsh0u",
    styles: "margin-left:var(--ds-space-negative-100, -8px)"
};
const $c306d1266b64b283$export$a61e5f64ad28e14a = {
    name: "1t1gmw4",
    styles: "[data-role='droplistContent']{max-height:90vh;}"
};


const $138b0d72a35f90b5$var$buttonContentStyle = (0, $ecnYn.xcss)({
    minWidth: `calc(80px + 2*${"var(--ds-space-075, 6px)"})`,
    overflow: 'hidden',
    padding: 'space.075'
});
const $138b0d72a35f90b5$var$buttonContentReducedSpacingStyle = (0, $ecnYn.xcss)({
    padding: 'space.100',
    minWidth: `calc(80px + 2*${"var(--ds-space-100, 8px)"})`
});
const $138b0d72a35f90b5$export$60665cf15e769742 = (props)=>{
    const blockTypeName = props.blockTypeName || '';
    const labelTextStyles = props.formatMessage((0, $2zaaI.toolbarMessages).textStyles, {
        blockTypeName: blockTypeName
    });
    const toolipTextStyles = props.formatMessage((0, $2zaaI.toolbarMessages).textStylesTooltip);
    const icon = (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_controls', 'cohort', 'variant1') && props.blockTypeIcon ? props.blockTypeIcon : /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f8c3d))), {
        label: labelTextStyles,
        spacing: "spacious",
        color: "currentColor"
    });
    const chevronIconSpacing = (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_controls', 'cohort', 'variant1') ? 'spacious' : 'none';
    const shouldUseIconAsButton = props.isSmall || (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_controls', 'cohort', 'variant1');
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $a4eZN.default), {
        spacing: props.isReducedSpacing ? 'none' : 'default',
        selected: props.selected,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "block-type-btn",
        disabled: props.disabled,
        onClick: props.onClick,
        onKeyDown: props.onKeyDown,
        title: toolipTextStyles,
        "aria-label": labelTextStyles,
        "aria-haspopup": true,
        "aria-expanded": props['aria-expanded'],
        iconAfter: /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            css: [
                (0, $cORDs.wrapperStyle),
                props.isSmall && (0, $c306d1266b64b283$export$4f9ef2b7bddb4c3a)
            ],
            "data-testid": "toolbar-block-type-text-styles-icon"
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, shouldUseIconAsButton && icon, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            css: (0, $iMS6j.expandIconContainerStyle),
            "data-vc": "6YET7k3j"
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
            spacing: chevronIconSpacing,
            label: "",
            color: "currentColor",
            size: "small"
        }))))
    }, !shouldUseIconAsButton && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        xcss: [
            $138b0d72a35f90b5$var$buttonContentStyle,
            props.isReducedSpacing && $138b0d72a35f90b5$var$buttonContentReducedSpacingStyle
        ]
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $aXWIB.FormattedMessage), props.title || (0, $boahT.NORMAL_TEXT).title)));
};



const $888be5378c126dde$var$buttonWrapperStyles = (0, $ecnYn.xcss)({
    flexShrink: 0
});
// eslint-disable-next-line @repo/internal/react/no-class-components
class $888be5378c126dde$var$ToolbarBlockType extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    componentDidMount() {
        const observer = new (0, $60yhz.default)(({ typography: typography })=>{
            if (typography !== this.state.typographyTheme) this.setState({
                typographyTheme: typography
            });
        });
        this.setState({
            observer: observer
        });
        observer.observe();
    }
    componentWillUnmount() {
        this.state.observer?.disconnect();
    }
    render() {
        const { active: active, isOpenedByKeyboard: isOpenedByKeyboard } = this.state;
        const { popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isSmall: isSmall, isReducedSpacing: isReducedSpacing, currentBlockType: currentBlockType, blockTypesDisabled: blockTypesDisabled, availableBlockTypes: availableBlockTypes = [], availableBlockTypesInDropdown: availableBlockTypesInDropdown = [], shouldUseDefaultRole: shouldUseDefaultRole, intl: { formatMessage: formatMessage }, api: api } = this.props;
        const isHeadingDisabled = !availableBlockTypes.some((blockType)=>blockType.nodeName === 'heading');
        if (isHeadingDisabled) return null;
        const blockTypeTitles = availableBlockTypesInDropdown.filter((blockType)=>blockType.name === currentBlockType?.name).map((blockType)=>blockType.title);
        const defaultIcon = /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f8c3d))), {
            label: ""
        });
        const currentIcon = currentBlockType?.icon;
        if (!this.props.isDisabled && !blockTypesDisabled) {
            const items = this.createItems();
            const button = /*#__PURE__*/ (0, $9K4OG.jsx)((0, $138b0d72a35f90b5$export$60665cf15e769742), {
                isSmall: isSmall,
                isReducedSpacing: isReducedSpacing,
                selected: active,
                disabled: false,
                title: blockTypeTitles[0],
                onClick: this.handleTriggerClick,
                onKeyDown: this.handleTriggerByKeyboard,
                formatMessage: formatMessage,
                "aria-expanded": active,
                blockTypeName: currentBlockType?.name,
                blockTypeIcon: currentIcon || defaultIcon
            });
            return /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
                css: (0, $iu6m9.editorExperiment)('platform_editor_blockquote_in_text_formatting_menu', true) ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                [
                    (0, $cORDs.wrapperStyle),
                    (0, $c306d1266b64b283$export$a61e5f64ad28e14a)
                ] : // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $cORDs.wrapperStyle),
                "data-vc": "rBTi-LOL"
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $h4TOP.DropdownMenuWithKeyboardNavigation), {
                items: items,
                onOpenChange: this.onOpenChange,
                onItemActivated: this.handleSelectBlockType,
                isOpen: active,
                mountTo: popupsMountPoint,
                boundariesElement: popupsBoundariesElement,
                scrollableElement: popupsScrollableElement,
                zIndex: (0, $aFUXX.akEditorMenuZIndex),
                fitHeight: 360,
                fitWidth: 106,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                section: {
                    hasSeparator: true
                },
                shouldUseDefaultRole: shouldUseDefaultRole,
                // hasSeparator={true}
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                shouldFocusFirstItem: ()=>{
                    if (isOpenedByKeyboard) // eslint-disable-next-line @repo/internal/react/no-set-state-inside-render
                    this.setState({
                        ...this.state,
                        isOpenedByKeyboard: false
                    });
                    return isOpenedByKeyboard;
                }
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                xcss: $888be5378c126dde$var$buttonWrapperStyles
            }, button)), !api?.primaryToolbar && /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                css: (0, $cORDs.separatorStyles)
            }));
        }
        return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            css: (0, $cORDs.wrapperStyle)
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $138b0d72a35f90b5$export$60665cf15e769742), {
            isSmall: isSmall,
            isReducedSpacing: isReducedSpacing,
            selected: active,
            disabled: true,
            title: blockTypeTitles[0],
            onClick: this.handleTriggerClick,
            onKeyDown: this.handleTriggerByKeyboard,
            formatMessage: formatMessage,
            "aria-expanded": active,
            blockTypeName: currentBlockType?.name,
            blockTypeIcon: currentIcon || defaultIcon
        }), !api?.primaryToolbar && /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            css: (0, $cORDs.separatorStyles)
        })));
    }
    constructor(...args){
        super(...args);
        this.state = {
            active: false,
            isOpenedByKeyboard: false,
            typographyTheme: undefined,
            observer: null
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onOpenChange = (attrs)=>{
            this.setState({
                ...this.state,
                active: attrs.isOpen,
                isOpenedByKeyboard: attrs.isOpenedByKeyboard
            });
        };
        this.handleTriggerClick = ()=>{
            this.onOpenChange({
                isOpen: !this.state.active,
                isOpenedByKeyboard: false
            });
        };
        this.handleTriggerByKeyboard = (event)=>{
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                this.onOpenChange({
                    isOpen: !this.state.active,
                    isOpenedByKeyboard: true
                });
            }
        };
        this.createItems = ()=>{
            const { intl: { formatMessage: formatMessage }, currentBlockType: currentBlockType, availableBlockTypesInDropdown: availableBlockTypesInDropdown, formattingIsPresent: formattingIsPresent } = this.props;
            const items = (availableBlockTypesInDropdown ?? []).map((blockType, index)=>{
                const isActive = currentBlockType === blockType;
                const tagName = blockType.tagName || 'p';
                const Tag = tagName;
                const defaultMessage = Array.isArray(blockType.title.defaultMessage) ? blockType.title.defaultMessage.find((message)=>'value' in message) : blockType.title.defaultMessage;
                const description = typeof defaultMessage === 'string' ? defaultMessage : defaultMessage && 'value' in defaultMessage ? defaultMessage.value : '';
                const keyMap = (0, $hgeg8.findKeymapByDescription)(description);
                const icon = blockType?.icon;
                const item = {
                    content: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
                        css: (0, $c306d1266b64b283$export$2e548ca9c55ac73f)(tagName, isActive, this.state.typographyTheme)
                    }, /*#__PURE__*/ (0, $9K4OG.jsx)(Tag, null, formatMessage(blockType.title))),
                    value: blockType,
                    'aria-label': (0, $hgeg8.tooltip)(keyMap, formatMessage(blockType.title)),
                    key: `${blockType.name}-${index}`,
                    elemBefore: (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? icon : undefined,
                    elemAfter: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
                        css: [
                            (0, $c306d1266b64b283$export$54ea58af6cf8bf3a),
                            isActive && (0, $c306d1266b64b283$export$b09cf4fbc27c2bae)
                        ]
                    }, (0, $hgeg8.tooltip)(keyMap)),
                    isActive: isActive
                };
                return item;
            });
            if ((availableBlockTypesInDropdown ?? []).map((blockType)=>blockType.name).includes('blockquote') && (0, $iu6m9.editorExperiment)('platform_editor_controls', 'control')) {
                const clearFormattingItem = {
                    content: /*#__PURE__*/ (0, $9K4OG.jsx)("div", null, /*#__PURE__*/ (0, $9K4OG.jsx)("p", null, (0, $2zaaI.toolbarMessages).clearFormatting.defaultMessage)),
                    value: {
                        name: 'clearFormatting'
                    },
                    'aria-label': (0, $hgeg8.tooltip)((0, $hgeg8.clearFormatting), (0, $2zaaI.toolbarMessages).clearFormatting.defaultMessage),
                    key: 'clear-formatting',
                    elemAfter: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
                        css: [
                            (0, $c306d1266b64b283$export$54ea58af6cf8bf3a)
                        ]
                    }, (0, $hgeg8.tooltip)((0, $hgeg8.clearFormatting))),
                    isActive: false,
                    isDisabled: currentBlockType === (0, $boahT.NORMAL_TEXT) && !formattingIsPresent
                };
                return [
                    {
                        items: items
                    },
                    {
                        items: [
                            clearFormattingItem
                        ]
                    }
                ];
            }
            return [
                {
                    items: items
                }
            ];
        };
        this.handleSelectBlockType = ({ item: item, shouldCloseMenu: shouldCloseMenu = true })=>{
            const blockType = item.value;
            if (blockType.name === 'blockquote') this.props.wrapBlockQuote(blockType.name);
            else if (blockType.name === 'clearFormatting') this.props.clearFormatting();
            else {
                const fromBlockQuote = this.props.currentBlockType?.name === 'blockquote';
                this.props.setTextLevel(blockType.name, fromBlockQuote);
            }
            if (shouldCloseMenu) this.setState({
                ...this.state,
                active: false
            });
        };
    }
}
// eslint-disable-next-line @typescript-eslint/ban-types
const $888be5378c126dde$var$_default_1 = (0, $aXWIB.injectIntl)($888be5378c126dde$var$ToolbarBlockType);
var $888be5378c126dde$export$2e2bcd8739ae039 = $888be5378c126dde$var$_default_1;


const $b11582050f3067d1$var$FloatingToolbarSettings = {
    isSmall: true,
    disabled: false,
    isToolbarReducedSpacing: true,
    shouldUseDefaultRole: false
};
function $b11582050f3067d1$export$b15abb95157a91c7({ api: api }) {
    const { currentBlockType: currentBlockType, blockTypesDisabled: blockTypesDisabled, availableBlockTypes: availableBlockTypes, availableBlockTypesInDropdown: availableBlockTypesInDropdown, formattingIsPresent: formattingIsPresent } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'blockType'
    ], (states)=>({
            currentBlockType: states.blockTypeState?.currentBlockType,
            blockTypesDisabled: states.blockTypeState?.blockTypesDisabled,
            availableBlockTypes: states.blockTypeState?.availableBlockTypes,
            availableBlockTypesInDropdown: states.blockTypeState?.availableBlockTypesInDropdown,
            formattingIsPresent: states.blockTypeState?.formattingIsPresent
        }));
    const boundSetBlockType = (0, $42omo.useCallback)((name, fromBlockQuote)=>api?.core?.actions.execute(api?.blockType?.commands?.setTextLevel(name, (0, $d925B.INPUT_METHOD).FLOATING_TB, fromBlockQuote)), [
        api
    ]);
    const wrapBlockQuote = (0, $42omo.useCallback)(()=>api?.core?.actions.execute(api?.blockType?.commands?.insertBlockQuote((0, $d925B.INPUT_METHOD).FLOATING_TB)), [
        api
    ]);
    const clearFormatting = (0, $42omo.useCallback)(()=>api?.core?.actions.execute(api?.blockType?.commands?.clearFormatting((0, $d925B.INPUT_METHOD).FLOATING_TB)), [
        api
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $888be5378c126dde$export$2e2bcd8739ae039), {
        isSmall: $b11582050f3067d1$var$FloatingToolbarSettings.isSmall,
        isDisabled: $b11582050f3067d1$var$FloatingToolbarSettings.disabled,
        isReducedSpacing: (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? false : $b11582050f3067d1$var$FloatingToolbarSettings.isToolbarReducedSpacing,
        setTextLevel: boundSetBlockType,
        currentBlockType: currentBlockType,
        blockTypesDisabled: blockTypesDisabled,
        availableBlockTypes: availableBlockTypes,
        availableBlockTypesInDropdown: availableBlockTypesInDropdown,
        formattingIsPresent: formattingIsPresent,
        wrapBlockQuote: wrapBlockQuote,
        clearFormatting: clearFormatting,
        shouldUseDefaultRole: $b11582050f3067d1$var$FloatingToolbarSettings.shouldUseDefaultRole,
        api: api
    });
}












function $5da5a70ff335dff6$export$94516d5cccf573e3({ api: api, isSmall: isSmall, disabled: disabled, isToolbarReducedSpacing: isToolbarReducedSpacing, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, shouldUseDefaultRole: shouldUseDefaultRole }) {
    const { currentBlockType: currentBlockType, blockTypesDisabled: blockTypesDisabled, availableBlockTypes: availableBlockTypes, availableBlockTypesInDropdown: availableBlockTypesInDropdown, formattingIsPresent: formattingIsPresent } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'blockType'
    ], (states)=>({
            currentBlockType: states.blockTypeState?.currentBlockType,
            blockTypesDisabled: states.blockTypeState?.blockTypesDisabled,
            availableBlockTypes: states.blockTypeState?.availableBlockTypes,
            availableBlockTypesInDropdown: states.blockTypeState?.availableBlockTypesInDropdown,
            formattingIsPresent: states.blockTypeState?.formattingIsPresent
        }));
    const boundSetBlockType = (name, fromBlockQuote)=>api?.core?.actions.execute(api?.blockType?.commands?.setTextLevel(name, (0, $d925B.INPUT_METHOD).TOOLBAR, fromBlockQuote));
    const wrapBlockQuote = ()=>api?.core?.actions.execute(api?.blockType?.commands?.insertBlockQuote((0, $d925B.INPUT_METHOD).TOOLBAR));
    const clearFormatting = ()=>api?.core?.actions.execute(api?.blockType?.commands?.clearFormatting((0, $d925B.INPUT_METHOD).TOOLBAR));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $888be5378c126dde$export$2e2bcd8739ae039), {
        isSmall: isSmall,
        isDisabled: disabled,
        isReducedSpacing: isToolbarReducedSpacing,
        setTextLevel: boundSetBlockType,
        wrapBlockQuote: wrapBlockQuote,
        clearFormatting: clearFormatting,
        currentBlockType: currentBlockType,
        blockTypesDisabled: blockTypesDisabled,
        availableBlockTypes: availableBlockTypes,
        availableBlockTypesInDropdown: availableBlockTypesInDropdown,
        formattingIsPresent: formattingIsPresent,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        shouldUseDefaultRole: shouldUseDefaultRole,
        api: api
    });
}






var $cPCP8 = parcelRequire("cPCP8");

var $4Chin = parcelRequire("4Chin");




/* HeadingButton.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 



var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");














var $gzUv9 = parcelRequire("gzUv9");





var $b3YrF = parcelRequire("b3YrF");


var $2GVu1 = parcelRequire("2GVu1");

var $jbmmV = parcelRequire("jbmmV");











const $66b0691447c60f60$var$smallTextStyle = null;
const $66b0691447c60f60$var$normalStyle = null;
const $66b0691447c60f60$var$heading1Style = null;
const $66b0691447c60f60$var$heading2Style = null;
const $66b0691447c60f60$var$heading3Style = null;
const $66b0691447c60f60$var$heading4Style = null;
const $66b0691447c60f60$var$heading5Style = null;
const $66b0691447c60f60$var$heading6Style = null;
const $66b0691447c60f60$var$HeadingText = ({ children: children, headingType: headingType })=>{
    switch(headingType){
        case 'heading1':
            return /*#__PURE__*/ $42omo.createElement("div", {
                className: (0, $gMc0m.default)([
                    "_11c812rg"
                ]),
                style: {
                    "--_1h4o6ch": (0, $7sObp.default)((0, $ilPbq.default)('editor.font.heading.h1'))
                },
                "data-vc": "9ZEIL-tp"
            }, children);
        case 'heading2':
            return /*#__PURE__*/ $42omo.createElement("div", {
                className: (0, $gMc0m.default)([
                    "_11c81td5"
                ]),
                style: {
                    "--_1kn1hjn": (0, $7sObp.default)((0, $ilPbq.default)('editor.font.heading.h2'))
                }
            }, children);
        case 'heading3':
            return /*#__PURE__*/ $42omo.createElement("div", {
                className: (0, $gMc0m.default)([
                    "_11c81og0"
                ]),
                style: {
                    "--_13pg0ac": (0, $7sObp.default)((0, $ilPbq.default)('editor.font.heading.h3'))
                }
            }, children);
        case 'heading4':
            return /*#__PURE__*/ $42omo.createElement("div", {
                className: (0, $gMc0m.default)([
                    "_11c846ty"
                ]),
                style: {
                    "--_j67hki": (0, $7sObp.default)((0, $ilPbq.default)('editor.font.heading.h4'))
                }
            }, children);
        case 'heading5':
            return /*#__PURE__*/ $42omo.createElement("div", {
                className: (0, $gMc0m.default)([
                    "_11c81fq3"
                ]),
                style: {
                    "--_1d0ko3v": (0, $7sObp.default)((0, $ilPbq.default)('editor.font.heading.h5'))
                }
            }, children);
        case 'heading6':
            return /*#__PURE__*/ $42omo.createElement("div", {
                className: (0, $gMc0m.default)([
                    "_11c81vog"
                ]),
                style: {
                    "--_1c98jvx": (0, $7sObp.default)((0, $ilPbq.default)('editor.font.heading.h6'))
                }
            }, children);
        case 'smallText':
            return /*#__PURE__*/ $42omo.createElement("div", {
                className: (0, $gMc0m.default)([
                    "_11c8130a"
                ]),
                style: {
                    "--_1b6nbh6": (0, $7sObp.default)((0, $ilPbq.default)('editor.font.body.small'))
                }
            }, children);
        case 'normal':
        default:
            return /*#__PURE__*/ $42omo.createElement("div", {
                className: (0, $gMc0m.default)([
                    "_11c81u7j"
                ]),
                style: {
                    "--_goypne": (0, $7sObp.default)((0, $ilPbq.default)('editor.font.body'))
                }
            }, children);
    }
};
const $66b0691447c60f60$var$shortcuts = {
    normal: (0, $hgeg8.setNormalText),
    smallText: (0, $hgeg8.toggleSmallText),
    heading1: (0, $hgeg8.toggleHeading1),
    heading2: (0, $hgeg8.toggleHeading2),
    heading3: (0, $hgeg8.toggleHeading3),
    heading4: (0, $hgeg8.toggleHeading4),
    heading5: (0, $hgeg8.toggleHeading5),
    heading6: (0, $hgeg8.toggleHeading6)
};
const $66b0691447c60f60$var$shouldDisableHeadingButton = (state, blockType)=>{
    if (!state) return false;
    return (0, $b4774db4d7677b9c$export$fbe592d31a93b004)(state) && blockType.name !== 'normal' && blockType.name !== 'smallText';
};
const $66b0691447c60f60$export$a24781eb35f914a5 = ({ blockType: blockType, api: api })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const currentBlockType = (0, $b3YrF.useSharedPluginStateSelector)(api, 'blockType.currentBlockType');
    const availableBlockTypesInDropdown = (0, $b3YrF.useSharedPluginStateSelector)(api, 'blockType.availableBlockTypesInDropdown');
    const isMarkdownBridgeEnabled = (0, $dZ8uq.expValEqualsNoExposure)('cc-markdown-mode', 'isEnabled', true) && (0, $dh538.fg)('platform_editor_markdown_compatible_toolbar');
    const { markdownView: markdownView, sourceFormatState: sourceFormatState } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'markdownMode'
    ], (states)=>({
            markdownView: isMarkdownBridgeEnabled ? states.markdownModeState?.view : undefined,
            sourceFormatState: isMarkdownBridgeEnabled ? states.markdownModeState?.sourceBlockFormatState : null
        }));
    const { editorView: editorView } = (0, $gzUv9.useEditorToolbar)();
    if (!availableBlockTypesInDropdown?.some((availableBlockType)=>availableBlockType.name === blockType.name)) return null;
     // When in source view and the bridge is enabled, read heading level from
    // the CM6 Lezer-tree-derived format state rather than the PM block type state.
    // markdownView is authoritative for "in source view" — it flips synchronously
    // on setView. sourceFormatState is null between the view switch and the
    // first CM6 update listener fire, so we can't rely on it as the sentinel.
    const isMarkdownBridgeActive = markdownView === 'syntax'; // Extract the numeric level from the block type name (e.g. 'heading1' → 1).
    const headingLevel = blockType.name.startsWith('heading') ? parseInt(blockType.name.replace('heading', ''), 10) : null;
    const isDisabled = isMarkdownBridgeActive ? Boolean(sourceFormatState?.inCodeBlock) : (0, $1oCLl.expValEquals)('platform_editor_small_font_size', 'isEnabled', true) ? $66b0691447c60f60$var$shouldDisableHeadingButton(editorView?.state, blockType) : false;
    const fromBlockQuote = currentBlockType?.name === 'blockquote';
    const onClick = ()=>{
        if (isDisabled) return;
         // Route to CM6 when in source view.
        //
        // - heading1..6: apply/replace via toggleSourceHeading(targetLevel).
        // - normal (paragraph): if the cursor is currently on a heading line,
        //   call toggleSourceHeading with the *current* level — toggleHeading
        //   removes the prefix when invoked with the matching level, so this
        //   downgrades the heading back to a plain paragraph. No-op when not
        //   on a heading (already normal) or when smallText is selected (no
        //   markdown equivalent).
        if (isMarkdownBridgeActive) {
            const targetLevel = blockType.name === 'normal' ? sourceFormatState?.headingLevel ?? null : headingLevel;
            if (targetLevel !== null && targetLevel >= 1 && targetLevel <= 6) api?.markdownMode?.actions.toggleSourceHeading(targetLevel);
            return;
        }
        api?.core?.actions.execute(api?.blockType?.commands?.setTextLevel(blockType.name, (0, $d925B.INPUT_METHOD).TOOLBAR, fromBlockQuote));
    };
    const shortcut = (0, $hgeg8.formatShortcut)($66b0691447c60f60$var$shortcuts[blockType.name]); // In source view, derive isSelected from the Lezer heading level.
    // In WYSIWYG, use the existing PM block type comparison.
    //
    // Branches in source view:
    // - heading1..6: select when the source heading level matches.
    // - normal (paragraph): select when the source has no heading and is not
    //   inside a blockquote — i.e. cursor is on a plain markdown paragraph.
    // - smallText: no markdown equivalent, so never selected in source view.
    //
    // Guard on `sourceFormatState != null` up-front so the body can read the
    // fields directly — clearer than nested optional chains and not fragile to
    // future reordering of the conditions.
    const isSelected = isMarkdownBridgeActive ? sourceFormatState != null ? headingLevel !== null ? sourceFormatState.headingLevel === headingLevel : blockType.name === 'normal' ? sourceFormatState.headingLevel === null && !sourceFormatState.inBlockquote : false : false : currentBlockType?.name === blockType.name;
    return /*#__PURE__*/ $42omo.createElement((0, $2GVu1.ToolbarDropdownItem), {
        elemBefore: blockType.icon,
        elemAfter: shortcut ? /*#__PURE__*/ $42omo.createElement((0, $jbmmV.ToolbarKeyboardShortcutHint), {
            shortcut: shortcut
        }) : undefined,
        onClick: onClick,
        isSelected: isSelected,
        isDisabled: isDisabled,
        ariaKeyshortcuts: shortcut
    }, /*#__PURE__*/ $42omo.createElement($66b0691447c60f60$var$HeadingText, {
        headingType: blockType.name
    }, formatMessage(blockType.title)));
};






































const $80f7a4a34c923546$var$shouldDisableQuoteButton = (state)=>{
    if (!state) return false;
    return (0, $b4774db4d7677b9c$export$fbe592d31a93b004)(state);
};
const $80f7a4a34c923546$export$94ec63f36c20dec6 = ({ blockType: blockType, api: api })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const availableBlockTypesInDropdown = (0, $b3YrF.useSharedPluginStateSelector)(api, 'blockType.availableBlockTypesInDropdown');
    const currentBlockType = (0, $b3YrF.useSharedPluginStateSelector)(api, 'blockType.currentBlockType');
    const { editorView: editorView } = (0, $gzUv9.useEditorToolbar)();
    const isMarkdownBridgeEnabled = (0, $dZ8uq.expValEqualsNoExposure)('cc-markdown-mode', 'isEnabled', true) && (0, $dh538.fg)('platform_editor_markdown_compatible_toolbar');
    const { markdownView: markdownView, sourceBlockFormatState: sourceBlockFormatState } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'markdownMode'
    ], (states)=>({
            markdownView: isMarkdownBridgeEnabled ? states.markdownModeState?.view : undefined,
            sourceBlockFormatState: isMarkdownBridgeEnabled ? states.markdownModeState?.sourceBlockFormatState : null
        }));
    if (!availableBlockTypesInDropdown?.some((availableBlockType)=>availableBlockType.name === blockType.name)) return null;
    // markdownView is authoritative for "in source view" — it flips synchronously
    // on setView. sourceBlockFormatState is null between the view switch and the
    // first CM6 update listener fire, so we can't rely on it as the sentinel.
    const isMarkdownBridgeActive = markdownView === 'syntax';
    const isDisabled = isMarkdownBridgeActive ? Boolean(sourceBlockFormatState?.inCodeBlock) : (0, $1oCLl.expValEquals)('platform_editor_small_font_size', 'isEnabled', true) ? $80f7a4a34c923546$var$shouldDisableQuoteButton(editorView?.state) : false;
    const onClick = ()=>{
        if (isDisabled) return;
        if (isMarkdownBridgeActive) {
            api?.markdownMode?.actions.toggleSourceBlockquote();
            return;
        }
        api?.core?.actions.execute(api?.blockType?.commands?.insertBlockQuote((0, $d925B.INPUT_METHOD).TOOLBAR));
    };
    const shortcut = (0, $hgeg8.formatShortcut)((0, $hgeg8.toggleBlockQuote));
    const isSelected = isMarkdownBridgeActive ? Boolean(sourceBlockFormatState?.inBlockquote) : currentBlockType === blockType;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2GVu1.ToolbarDropdownItem), {
        elemBefore: blockType.icon,
        elemAfter: shortcut ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jbmmV.ToolbarKeyboardShortcutHint), {
            shortcut: shortcut
        }) : undefined,
        onClick: onClick,
        isSelected: isSelected,
        isDisabled: isDisabled,
        ariaKeyshortcuts: shortcut
    }, formatMessage(blockType.title));
};




















var $bTiiT = parcelRequire("bTiiT");

var $iIVVb = parcelRequire("iIVVb");













const $8cd62dcecd50af6f$var$usePluginState = (api)=>{
    // Memoized inside the hook (rather than at module scope) so the gate read
    // inside `toolbarBlockTypesWithRank` doesn't run at module import time —
    // that breaks downstream tests that import preset-default without
    // initializing the FeatureGates client.
    const sourceViewBlockTypeValues = (0, $42omo.useMemo)(()=>Object.values((0, $boahT.toolbarBlockTypesWithRank)({})), []);
    const selectPluginState = (0, $42omo.useCallback)((state)=>{
        const pmCurrentBlockType = state.interactionState?.interactionState === 'hasNotHadInteraction' && (0, $1oCLl.expValEquals)('platform_editor_default_toolbar_state', 'isEnabled', true) ? undefined : state.blockTypeState?.currentBlockType;
        // When the markdown bridge is active and the source view is mounted,
        // derive currentBlockType from the CM6 Lezer heading level rather than
        // PM block type state (which reflects the last WYSIWYG cursor position).
        const isMarkdownBridgeEnabled = (0, $dZ8uq.expValEqualsNoExposure)('cc-markdown-mode', 'isEnabled', true) && (0, $dh538.fg)('platform_editor_markdown_compatible_toolbar');
        const sourceFormatState = isMarkdownBridgeEnabled ? state.markdownModeState?.sourceBlockFormatState : null;
        // markdownView is authoritative for "in source view" — it flips synchronously
        // on setView. sourceFormatState is null between the view switch and the first
        // CM6 update listener fire, so we can't rely on it as the sentinel.
        const isSourceViewActive = isMarkdownBridgeEnabled && state.markdownModeState?.view === 'syntax';
        // When in source view, derive currentBlockType from CM6 Lezer state
        // (heading level or blockquote) rather than PM block type state.
        // Guard on sourceFormatState being available — during the race window
        // after switching to source view but before CM6 fires its first update,
        // sourceFormatState is null even though isSourceViewActive is true.
        const currentBlockType = isSourceViewActive && sourceFormatState ? sourceFormatState.headingLevel !== null ? // In a heading, look up the full BlockType by name.
        sourceViewBlockTypeValues.find((bt)=>bt.name === `heading${sourceFormatState.headingLevel}`) ?? null : sourceFormatState.inBlockquote ? // In a blockquote, look up the blockquote BlockType.
        sourceViewBlockTypeValues.find((bt)=>bt.name === 'blockquote') ?? null : // Plain paragraph — look up the 'normal' BlockType so the trigger
        // shows "Normal text" (matches WYSIWYG and HeadingButton's
        // Normal-in-source-view selection logic).
        sourceViewBlockTypeValues.find((bt)=>bt.name === 'normal') ?? null : isSourceViewActive ? null : pmCurrentBlockType;
        return {
            blockTypesDisabled: isSourceViewActive && sourceFormatState ? Boolean(sourceFormatState.inCodeBlock) : isSourceViewActive ? false : state.blockTypeState?.blockTypesDisabled,
            currentBlockType: currentBlockType
        };
    }, [
        sourceViewBlockTypeValues
    ]);
    return (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'blockType',
        'interaction',
        'markdownMode'
    ], selectPluginState);
};
const $8cd62dcecd50af6f$export$e34ebed463fa4947 = ({ allowFontSize: allowFontSize, api: api, children: children })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { blockTypesDisabled: blockTypesDisabled, currentBlockType: currentBlockType } = $8cd62dcecd50af6f$var$usePluginState(api);
    const blockTypes = (0, $boahT.toolbarBlockTypesWithRank)({
        allowFontSize: allowFontSize
    });
    const { editorAppearance: editorAppearance } = (0, $gzUv9.useEditorToolbar)();
    const CurrentIcon = Object.values(blockTypes).find((blockType)=>blockType.name === currentBlockType?.name)?.icon?.type;
    const normalText = blockTypes.normal;
    const TriggerIcon = (0, $42omo.useMemo)(()=>{
        if (editorAppearance === 'full-page') {
            const hasCurrentBlockType = currentBlockType && CurrentIcon;
            const Icon = hasCurrentBlockType ? CurrentIcon : (0, (/*@__PURE__*/$parcel$interopDefault($f8c3d)));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
                label: "",
                size: "small"
            }), hasCurrentBlockType ? formatMessage(currentBlockType.title) : formatMessage(normalText.title));
        }
        return CurrentIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(CurrentIcon, {
            label: `${currentBlockType?.name} ${formatMessage((0, $2zaaI.toolbarMessages).textStylesTooltip)}`,
            size: "small"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f8c3d))), {
            label: formatMessage((0, $2zaaI.toolbarMessages).textStylesTooltip),
            size: "small"
        });
    }, [
        editorAppearance,
        currentBlockType,
        CurrentIcon,
        normalText,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bTiiT.ToolbarDropdownMenu), {
        isDisabled: blockTypesDisabled,
        iconBefore: TriggerIcon,
        tooltipComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iIVVb.ToolbarTooltip), {
            content: formatMessage((0, $2zaaI.toolbarMessages).textStylesTooltip)
        }),
        label: formatMessage((0, $2zaaI.toolbarMessages).textStyles, {
            blockTypeName: currentBlockType?.name
        })
    }, children);
};


const $3e8de3af716ded26$export$a758406ca53b86a5 = (api, allowFontSize)=>{
    const toolbarComponents = [
        {
            type: (0, $cPCP8.TEXT_STYLES_GROUP).type,
            key: (0, $cPCP8.TEXT_STYLES_GROUP).key,
            parents: [
                {
                    type: (0, $cPCP8.TEXT_SECTION).type,
                    key: (0, $cPCP8.TEXT_SECTION).key,
                    rank: (0, $4Chin.TEXT_SECTION_RANK)[(0, $cPCP8.TEXT_STYLES_GROUP).key]
                },
                {
                    type: (0, $cPCP8.TEXT_SECTION_PRIMARY_TOOLBAR).type,
                    key: (0, $cPCP8.TEXT_SECTION_PRIMARY_TOOLBAR).key,
                    rank: (0, $4Chin.TEXT_SECTION_PRIMARY_TOOLBAR_RANK)[(0, $cPCP8.TEXT_STYLES_GROUP).key]
                }
            ]
        },
        {
            type: (0, $cPCP8.TEXT_STYLES_MENU).type,
            key: (0, $cPCP8.TEXT_STYLES_MENU).key,
            parents: [
                {
                    type: (0, $cPCP8.TEXT_STYLES_GROUP).type,
                    key: (0, $cPCP8.TEXT_STYLES_GROUP).key,
                    rank: (0, $4Chin.TEXT_STYLES_GROUP_RANK)[(0, $cPCP8.TEXT_STYLES_MENU).key]
                }
            ],
            component: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8cd62dcecd50af6f$export$e34ebed463fa4947), {
                    api: api,
                    allowFontSize: allowFontSize
                }, children)
        },
        {
            type: (0, $cPCP8.TEXT_STYLES_MENU_SECTION).type,
            key: (0, $cPCP8.TEXT_STYLES_MENU_SECTION).key,
            parents: [
                {
                    type: (0, $cPCP8.TEXT_STYLES_MENU).type,
                    key: (0, $cPCP8.TEXT_STYLES_MENU).key,
                    rank: (0, $4Chin.TEXT_STYLES_MENU_RANK)[(0, $cPCP8.TEXT_STYLES_MENU_SECTION).key]
                },
                {
                    type: (0, $cPCP8.TEXT_COLLAPSED_MENU).type,
                    key: (0, $cPCP8.TEXT_COLLAPSED_MENU).key,
                    rank: (0, $4Chin.TEXT_COLLAPSED_MENU_RANK)[(0, $cPCP8.TEXT_STYLES_MENU_SECTION).key]
                }
            ]
        }
    ];
    Object.values((0, $boahT.toolbarBlockTypesWithRank)({
        allowFontSize: allowFontSize
    })).forEach((blockType)=>{
        if (blockType.toolbarKey) {
            const menuItem = {
                type: 'menu-item',
                key: blockType.toolbarKey,
                parents: [
                    {
                        type: (0, $cPCP8.TEXT_STYLES_MENU_SECTION).type,
                        key: (0, $cPCP8.TEXT_STYLES_MENU_SECTION).key,
                        rank: blockType.toolbarRank
                    }
                ],
                component: blockType.name === 'blockquote' ? ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $80f7a4a34c923546$export$94ec63f36c20dec6), {
                        blockType: blockType,
                        api: api
                    }) : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $66b0691447c60f60$export$a24781eb35f914a5), {
                        blockType: blockType,
                        api: api
                    })
            };
            toolbarComponents.push(menuItem);
        }
    });
    return toolbarComponents;
};



var $btNLq = parcelRequire("btNLq");

var $gEb6G = parcelRequire("gEb6G");

















var $3yaUF = parcelRequire("3yaUF");


var $aYGvQ = parcelRequire("aYGvQ");


var $5wdIn = parcelRequire("5wdIn");


var $l1461 = parcelRequire("l1461");


var $7a8uv = parcelRequire("7a8uv");


var $45HPa = parcelRequire("45HPa");

const $1d22aa5186accf64$var$headingIcons = [
    (0, (/*@__PURE__*/$parcel$interopDefault($5wdIn))),
    (0, (/*@__PURE__*/$parcel$interopDefault($45HPa))),
    (0, (/*@__PURE__*/$parcel$interopDefault($7a8uv))),
    (0, (/*@__PURE__*/$parcel$interopDefault($aYGvQ))),
    (0, (/*@__PURE__*/$parcel$interopDefault($3yaUF))),
    (0, (/*@__PURE__*/$parcel$interopDefault($l1461)))
];
const $1d22aa5186accf64$var$headingMessages = [
    (0, $2UWDO.messages).heading1,
    (0, $2UWDO.messages).heading2,
    (0, $2UWDO.messages).heading3,
    (0, $2UWDO.messages).heading4,
    (0, $2UWDO.messages).heading5,
    (0, $2UWDO.messages).heading6
];
const $1d22aa5186accf64$var$NODE_NAME = 'heading';
const $1d22aa5186accf64$var$HeadingBlockMenuItem = ({ level: level, api: api })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const Icon = $1d22aa5186accf64$var$headingIcons[level - 1];
    const message = $1d22aa5186accf64$var$headingMessages[level - 1];
    const handleClick = (event)=>{
        const triggeredFrom = event.nativeEvent instanceof KeyboardEvent || event.nativeEvent.detail === 0 ? (0, $d925B.INPUT_METHOD).KEYBOARD : (0, $d925B.INPUT_METHOD).MOUSE;
        const inputMethod = (0, $d925B.INPUT_METHOD).BLOCK_MENU;
        api?.core.actions.execute(({ tr: tr })=>{
            const command = api?.blockMenu?.commands.transformNode(tr.doc.type.schema.nodes.heading, {
                inputMethod: inputMethod,
                triggeredFrom: triggeredFrom,
                targetTypeName: `${$1d22aa5186accf64$var$NODE_NAME}${level}`,
                targetAttrs: {
                    level: level
                }
            });
            return command ? command({
                tr: tr
            }) : null;
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2GVu1.ToolbarDropdownItem), {
        onClick: handleClick,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
            label: "",
            size: "small"
        })
    }, formatMessage(message));
};
const $1d22aa5186accf64$export$93c991c81dd77070 = ({ level: level, api: api })=>{
    return ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1d22aa5186accf64$var$HeadingBlockMenuItem, {
            level: level,
            api: api
        });
};












var $eKkkY = parcelRequire("eKkkY");





var $eg9hW = parcelRequire("eg9hW");

const $4a52f3d58d5e7d8e$var$NODE_NAME = 'paragraph';
const $4a52f3d58d5e7d8e$var$ParagraphBlockMenuItem = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const handleClick = (event)=>{
        const triggeredFrom = event.nativeEvent instanceof KeyboardEvent || event.nativeEvent.detail === 0 ? (0, $d925B.INPUT_METHOD).KEYBOARD : (0, $d925B.INPUT_METHOD).MOUSE;
        const inputMethod = (0, $d925B.INPUT_METHOD).BLOCK_MENU;
        api?.core.actions.execute(({ tr: tr })=>{
            const command = api?.blockMenu?.commands.transformNode(tr.doc.type.schema.nodes.paragraph, {
                inputMethod: inputMethod,
                triggeredFrom: triggeredFrom,
                targetTypeName: $4a52f3d58d5e7d8e$var$NODE_NAME
            });
            return command ? command({
                tr: tr
            }) : null;
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2GVu1.ToolbarDropdownItem), {
        onClick: handleClick,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eg9hW))), {
            label: "",
            size: "small"
        })
    }, formatMessage((0, $eKkkY.messages).paragraph));
};
const $4a52f3d58d5e7d8e$export$469651dcc0916a77 = ({ api: api })=>{
    return ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4a52f3d58d5e7d8e$var$ParagraphBlockMenuItem, {
            api: api
        });
};


/* QuoteBlockMenuItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 


















var $9RVmI = parcelRequire("9RVmI");

const $0eb6fb1002fb4e33$var$styles = {
    svgOverflow: "_1wrmewfl _172sewfl"
};
const $0eb6fb1002fb4e33$var$NODE_NAME = 'blockquote';
const $0eb6fb1002fb4e33$var$QuoteBlockMenuItem = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const handleClick = (event)=>{
        const triggeredFrom = event.nativeEvent instanceof KeyboardEvent || event.nativeEvent.detail === 0 ? (0, $d925B.INPUT_METHOD).KEYBOARD : (0, $d925B.INPUT_METHOD).MOUSE;
        const inputMethod = (0, $d925B.INPUT_METHOD).BLOCK_MENU;
        api?.core.actions.execute(({ tr: tr })=>{
            const command = api?.blockMenu?.commands.transformNode(tr.doc.type.schema.nodes.blockquote, {
                inputMethod: inputMethod,
                triggeredFrom: triggeredFrom,
                targetTypeName: $0eb6fb1002fb4e33$var$NODE_NAME
            });
            return command ? command({
                tr: tr
            }) : null;
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2GVu1.ToolbarDropdownItem), {
        onClick: handleClick,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            className: (0, $gMc0m.default)([
                $0eb6fb1002fb4e33$var$styles.svgOverflow
            ]),
            "data-vc": "WQnpC1Nk"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))), {
            label: "",
            size: "small"
        }))
    }, formatMessage((0, $2UWDO.messages).blockquote));
};
const $0eb6fb1002fb4e33$export$e07c899cb2d719c9 = ({ api: api })=>{
    return ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0eb6fb1002fb4e33$var$QuoteBlockMenuItem, {
            api: api
        });
};


const $8dd914327677bec9$var$HEADING_NODE_NAME = 'heading';
const $8dd914327677bec9$var$QUOTE_NODE_NAME = 'blockquote';
const $8dd914327677bec9$var$PARAGRAPH_NODE_NAME = 'paragraph';
const $8dd914327677bec9$export$325b6b890260a604 = (api)=>{
    const isTransformHeadingDisabled = (level)=>Boolean(api?.blockMenu?.actions.isTransformOptionDisabled($8dd914327677bec9$var$HEADING_NODE_NAME, {
            level: level
        }));
    return [
        {
            type: 'block-menu-item',
            key: (0, $btNLq.TRANSFORM_HEADINGS_H1_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $btNLq.TRANSFORM_HEADINGS_MENU_SECTION).key,
                rank: (0, $gEb6G.TRANSFORM_HEADINGS_MENU_SECTION_RANK)[(0, $btNLq.TRANSFORM_HEADINGS_H1_MENU_ITEM).key]
            },
            component: (0, $1d22aa5186accf64$export$93c991c81dd77070)({
                level: 1,
                api: api
            }),
            isHidden: ()=>isTransformHeadingDisabled(1)
        },
        {
            type: 'block-menu-item',
            key: (0, $btNLq.TRANSFORM_HEADINGS_H2_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $btNLq.TRANSFORM_HEADINGS_MENU_SECTION).key,
                rank: (0, $gEb6G.TRANSFORM_HEADINGS_MENU_SECTION_RANK)[(0, $btNLq.TRANSFORM_HEADINGS_H2_MENU_ITEM).key]
            },
            component: (0, $1d22aa5186accf64$export$93c991c81dd77070)({
                level: 2,
                api: api
            }),
            isHidden: ()=>isTransformHeadingDisabled(2)
        },
        {
            type: 'block-menu-item',
            key: (0, $btNLq.TRANSFORM_HEADINGS_H3_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $btNLq.TRANSFORM_HEADINGS_MENU_SECTION).key,
                rank: (0, $gEb6G.TRANSFORM_HEADINGS_MENU_SECTION_RANK)[(0, $btNLq.TRANSFORM_HEADINGS_H3_MENU_ITEM).key]
            },
            component: (0, $1d22aa5186accf64$export$93c991c81dd77070)({
                level: 3,
                api: api
            }),
            isHidden: ()=>isTransformHeadingDisabled(3)
        },
        {
            type: 'block-menu-item',
            key: (0, $btNLq.TRANSFORM_HEADINGS_H4_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $btNLq.TRANSFORM_HEADINGS_MENU_SECTION).key,
                rank: (0, $gEb6G.TRANSFORM_HEADINGS_MENU_SECTION_RANK)[(0, $btNLq.TRANSFORM_HEADINGS_H4_MENU_ITEM).key]
            },
            component: (0, $1d22aa5186accf64$export$93c991c81dd77070)({
                level: 4,
                api: api
            }),
            isHidden: ()=>isTransformHeadingDisabled(4)
        },
        {
            type: 'block-menu-item',
            key: (0, $btNLq.TRANSFORM_HEADINGS_H5_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $btNLq.TRANSFORM_HEADINGS_MENU_SECTION).key,
                rank: (0, $gEb6G.TRANSFORM_HEADINGS_MENU_SECTION_RANK)[(0, $btNLq.TRANSFORM_HEADINGS_H5_MENU_ITEM).key]
            },
            component: (0, $1d22aa5186accf64$export$93c991c81dd77070)({
                level: 5,
                api: api
            }),
            isHidden: ()=>isTransformHeadingDisabled(5)
        },
        {
            type: 'block-menu-item',
            key: (0, $btNLq.TRANSFORM_HEADINGS_H6_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $btNLq.TRANSFORM_HEADINGS_MENU_SECTION).key,
                rank: (0, $gEb6G.TRANSFORM_HEADINGS_MENU_SECTION_RANK)[(0, $btNLq.TRANSFORM_HEADINGS_H6_MENU_ITEM).key]
            },
            component: (0, $1d22aa5186accf64$export$93c991c81dd77070)({
                level: 6,
                api: api
            }),
            isHidden: ()=>isTransformHeadingDisabled(6)
        },
        {
            type: 'block-menu-item',
            key: (0, $btNLq.TRANSFORM_STRUCTURE_QUOTE_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $btNLq.TRANSFORM_STRUCTURE_MENU_SECTION).key,
                rank: (0, $gEb6G.TRANSFORM_STRUCTURE_MENU_SECTION_RANK)[(0, $btNLq.TRANSFORM_STRUCTURE_QUOTE_MENU_ITEM).key]
            },
            component: (0, $0eb6fb1002fb4e33$export$e07c899cb2d719c9)({
                api: api
            }),
            isHidden: ()=>Boolean(api?.blockMenu?.actions.isTransformOptionDisabled($8dd914327677bec9$var$QUOTE_NODE_NAME))
        },
        {
            type: 'block-menu-item',
            key: (0, $btNLq.TRANSFORM_STRUCTURE_PARAGRAPH_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $btNLq.TRANSFORM_STRUCTURE_MENU_SECTION).key,
                rank: (0, $gEb6G.TRANSFORM_STRUCTURE_MENU_SECTION_RANK)[(0, $btNLq.TRANSFORM_STRUCTURE_PARAGRAPH_MENU_ITEM).key]
            },
            component: (0, $4a52f3d58d5e7d8e$export$469651dcc0916a77)({
                api: api
            }),
            isHidden: ()=>Boolean(api?.blockMenu?.actions.isTransformOptionDisabled($8dd914327677bec9$var$PARAGRAPH_NODE_NAME))
        }
    ];
};


const $d0936dbedfef8763$var$headingPluginOptions = ({ formatMessage: formatMessage }, isAllowed, editorAnalyticsApi)=>{
    if (!isAllowed) return [];
    return Array.from({
        length: 6
    }, (_v, idx)=>{
        const level = idx + 1;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const descriptionDescriptor = (0, $2UWDO.messages)[`heading${level}Description`];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const keyshortcut = (0, $hgeg8.tooltip)((0, $60bKU.keymap)[`toggleHeading${level}`]);
        const id = `heading${level}`;
        return {
            id: id,
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            title: formatMessage((0, $2UWDO.messages)[id]),
            description: formatMessage(descriptionDescriptor),
            priority: 1300,
            keywords: [
                `h${level}`
            ],
            keyshortcut: keyshortcut,
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3pLGZ.IconHeading), {
                    level: level
                }),
            action (insert, state) {
                const tr = insert(state.schema.nodes.heading.createChecked({
                    level: level
                }));
                editorAnalyticsApi?.attachAnalyticsEvent({
                    action: (0, $d925B.ACTION).FORMATTED,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
                    eventType: (0, $d925B.EVENT_TYPE).TRACK,
                    actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_HEADING,
                    attributes: {
                        inputMethod: (0, $d925B.INPUT_METHOD).QUICK_INSERT,
                        newHeadingLevel: level
                    }
                })(tr);
                return tr;
            }
        };
    });
};
const $d0936dbedfef8763$var$blockquotePluginOptions = ({ formatMessage: formatMessage }, isAllowed, editorAnalyticsApi)=>{
    if (!isAllowed) return [];
    return [
        {
            id: 'blockquote',
            title: formatMessage((0, $2UWDO.messages).blockquote),
            description: formatMessage((0, $2UWDO.messages).blockquoteDescription),
            priority: 1300,
            keyshortcut: '>',
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3pLGZ.IconQuote), null),
            action (insert, state) {
                const tr = insert(state.schema.nodes.blockquote.createChecked({}, state.schema.nodes.paragraph.createChecked()));
                editorAnalyticsApi?.attachAnalyticsEvent({
                    action: (0, $d925B.ACTION).FORMATTED,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
                    eventType: (0, $d925B.EVENT_TYPE).TRACK,
                    actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_BLOCK_QUOTE,
                    attributes: {
                        inputMethod: (0, $d925B.INPUT_METHOD).QUICK_INSERT
                    }
                })(tr);
                return tr;
            }
        }
    ];
};
const $d0936dbedfef8763$export$896c3d927d705025 = ({ config: options, api: api })=>{
    const isToolbarAIFCEnabled = Boolean(api?.toolbar);
    const primaryToolbarComponent = ({ popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, toolbarSize: toolbarSize, disabled: disabled, isToolbarReducedSpacing: isToolbarReducedSpacing })=>{
        let isSmall = options && options.isUndoRedoButtonsEnabled ? toolbarSize < (0, $frHf7.ToolbarSize).XXL : toolbarSize < (0, $frHf7.ToolbarSize).XL;
        if ((0, $dh538.fg)('platform_editor_toolbar_responsive_fixes')) isSmall = toolbarSize < (0, $frHf7.ToolbarSize).XXL;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5da5a70ff335dff6$export$94516d5cccf573e3), {
            isSmall: isSmall,
            disabled: disabled,
            isToolbarReducedSpacing: isToolbarReducedSpacing,
            api: api,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            shouldUseDefaultRole: false
        });
    };
    if (isToolbarAIFCEnabled) api?.toolbar?.actions.registerComponents((0, $3e8de3af716ded26$export$a758406ca53b86a5)(api, options?.allowFontSize));
    else api?.primaryToolbar?.actions.registerComponent({
        name: 'blockType',
        component: primaryToolbarComponent
    });
    if ((0, $iu6m9.editorExperiment)('platform_editor_block_menu', true)) api?.blockMenu?.actions.registerBlockMenuComponents((0, $8dd914327677bec9$export$325b6b890260a604)(api));
    return {
        name: 'blockType',
        nodes () {
            const nodes = [
                {
                    name: 'heading',
                    node: (0, $j0UBv.heading)
                },
                {
                    name: 'blockquote',
                    node: (0, $dh538.fg)('platform_editor_adf_with_localid') ? (0, $iIGXo.extendedBlockquoteWithLocalId) : (0, $iIGXo.extendedBlockquote)
                },
                {
                    name: 'hardBreak',
                    node: (0, $aFNbc.hardBreak)
                }
            ];
            if (options && options.allowBlockType) {
                const exclude = options.allowBlockType.exclude ? options.allowBlockType.exclude : [];
                return nodes.filter((node)=>exclude.indexOf(node.name) === -1);
            }
            return nodes;
        },
        marks () {
            if (options?.allowFontSize && (0, $1oCLl.expValEquals)('platform_editor_small_font_size', 'isEnabled', true)) return [
                {
                    name: 'fontSize',
                    mark: (0, $i8M34.fontSize)
                }
            ];
            return [];
        },
        pmPlugins () {
            return [
                {
                    name: 'blockType',
                    plugin: ({ dispatch: dispatch })=>(0, $897f6ae76c9017ad$export$ae829ec7b2625219)(api, dispatch, options && options.lastNodeMustBeParagraph, options?.includeBlockQuoteAsTextstyleOption, options?.allowFontSize)
                },
                {
                    name: 'blockTypeInputRule',
                    plugin: ({ schema: schema, featureFlags: featureFlags })=>(0, $df7153fd4a0164a3$export$2e2bcd8739ae039)(api?.analytics?.actions, schema, featureFlags)
                },
                // Needs to be lower priority than editor-tables.tableEditing
                // plugin as it is currently swallowing right/down arrow events inside tables
                {
                    name: 'blockTypeKeyMap',
                    plugin: ({ schema: schema, featureFlags: featureFlags })=>(0, $74a370d48c364617$export$2e2bcd8739ae039)(api?.analytics?.actions, schema, featureFlags)
                }
            ];
        },
        actions: {
            insertBlockQuote (inputMethod) {
                return (0, $597e6e1491fda64d$export$50b4331f407b3ab6)(inputMethod, api?.analytics?.actions);
            }
        },
        commands: {
            setTextLevel (level, inputMethod, fromBlockQuote = false) {
                return (0, $597e6e1491fda64d$export$3f9af78ebb95cc20)(level, inputMethod, api?.analytics?.actions, fromBlockQuote);
            },
            insertBlockQuote (inputMethod) {
                return (0, $597e6e1491fda64d$export$f5e16b3b6b62d83)(inputMethod, api?.analytics?.actions);
            },
            clearFormatting (inputMethod) {
                return (0, $597e6e1491fda64d$export$195de5d8e201efd7)(inputMethod, api?.analytics?.actions);
            }
        },
        getSharedState (editorState) {
            if (!editorState) return;
            return (0, $897f6ae76c9017ad$export$18d4026d1ea86bb1).getState(editorState);
        },
        primaryToolbarComponent: !api?.primaryToolbar ? primaryToolbarComponent : undefined,
        pluginsOptions: {
            ...!isToolbarAIFCEnabled && {
                selectionToolbar: ()=>{
                    const toolbarDocking = (0, $dh538.fg)('platform_editor_use_preferences_plugin') ? api?.userPreferences?.sharedState.currentState()?.preferences?.toolbarDockingPosition : api?.selectionToolbar?.sharedState?.currentState()?.toolbarDocking;
                    if (toolbarDocking === 'none' && (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1', {
                        exposure: true
                    })) {
                        const toolbarCustom = {
                            type: 'custom',
                            render: (view, _idx, _dispatchAnalyticsEvent)=>{
                                if (!view) return;
                                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b11582050f3067d1$export$b15abb95157a91c7), {
                                    api: api
                                });
                            },
                            fallback: []
                        };
                        return {
                            isToolbarAbove: true,
                            items: [
                                toolbarCustom
                            ],
                            rank: 8
                        };
                    } else return undefined;
                }
            },
            quickInsert: (intl)=>{
                const exclude = options && options.allowBlockType && options.allowBlockType.exclude ? options.allowBlockType.exclude : [];
                return [
                    ...$d0936dbedfef8763$var$blockquotePluginOptions(intl, exclude.indexOf('blockquote') === -1, api?.analytics?.actions),
                    ...$d0936dbedfef8763$var$headingPluginOptions(intl, exclude.indexOf('heading') === -1, api?.analytics?.actions)
                ];
            }
        }
    };
};
module.exports["blockTypePlugin"] = $d0936dbedfef8763$export$896c3d927d705025;

});

parcelRegister("3pLGZ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4wH3g = parcelRequire("4wH3g");


const $d6e9a0cb47163615$export$e40fe94b4cff8ec5 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "5IpRi",
    name: "IconAction",
    loader: ()=>(parcelRequire("5yhmU")).then((module)=>module.default),
    loading: ()=>null
});

const $d6e9a0cb47163615$export$e332a83b9159d69d = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "Ru1gk",
    name: "IconCode",
    loader: ()=>(parcelRequire("6uNKj")).then((module)=>module.default),
    loading: ()=>null
});

const $d6e9a0cb47163615$export$39617668a6028b06 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "v8J9P",
    name: "IconDate",
    loader: ()=>(parcelRequire("5YPWf")).then((module)=>module.default),
    loading: ()=>null
});

const $d6e9a0cb47163615$export$6eb71591d1461541 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "hRamb",
    name: "IconDecision",
    loader: ()=>(parcelRequire("kAAUV")).then((module)=>module.default),
    loading: ()=>null
});

const $d6e9a0cb47163615$export$f2ab17920c9d243 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "tltrl",
    name: "IconDivider",
    loader: ()=>(parcelRequire("7we1w")).then((module)=>module.default),
    loading: ()=>null
});

const $d6e9a0cb47163615$export$8bd591d4b34dcafa = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "Erkg9",
    name: "IconEmoji",
    loader: ()=>(parcelRequire("jBGRu")).then((module)=>module.default),
    loading: ()=>null
});

const $d6e9a0cb47163615$export$c17cf1164355efc2 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "XfrX5",
    name: "IconImages",
    loader: ()=>(parcelRequire("iyJhb")).then((module)=>module.default),
    loading: ()=>null
});

const $d6e9a0cb47163615$export$fba0c846789a9d87 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "WFuTK",
    name: "IconLayout",
    loader: ()=>(parcelRequire("5o7UN")).then((module)=>module.default),
    loading: ()=>null
});

const $d6e9a0cb47163615$export$23da1e9f164f7ea1 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "gbpgO",
    name: "IconLink",
    loader: ()=>(parcelRequire("5Lmiw")).then((module)=>module.default),
    loading: ()=>null
});

const $d6e9a0cb47163615$export$32f6affcc5f19c17 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "YMJ_i",
    name: "IconListNumber",
    loader: ()=>(parcelRequire("4hslg")).then((module)=>module.default),
    loading: ()=>null
});

const $d6e9a0cb47163615$export$527d32aa1785fdd4 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "fOk38",
    name: "IconList",
    loader: ()=>(parcelRequire("bq7Rk")).then((module)=>module.default),
    loading: ()=>null
});

const $d6e9a0cb47163615$export$de1d1a07ff53cf53 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "7uj_h",
    name: "IconMention",
    loader: ()=>(parcelRequire("iww0k")).then((module)=>module.default),
    loading: ()=>null
});

const $d6e9a0cb47163615$export$a1c6b14f5f0a0c20 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "Cs6_K",
    name: "IconPanelError",
    loader: ()=>(parcelRequire("947V2")).then((module)=>module.default),
    loading: ()=>null
});

const $d6e9a0cb47163615$export$4d90d09f9e3039e = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "hzniQ",
    name: "IconPanelNote",
    loader: ()=>(parcelRequire("hfB5c")).then((module)=>module.default),
    loading: ()=>null
});

const $d6e9a0cb47163615$export$cc5c1cc765c068a0 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "miuZY",
    name: "IconPanelSuccess",
    loader: ()=>(parcelRequire("eKHyH")).then((module)=>module.default),
    loading: ()=>null
});

const $d6e9a0cb47163615$export$e728578e48814100 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "QZPBB",
    name: "IconPanelWarning",
    loader: ()=>(parcelRequire("iSjEQ")).then((module)=>module.default),
    loading: ()=>null
});

const $d6e9a0cb47163615$export$18978208c8652af3 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "F1uzJ",
    name: "IconPanel",
    loader: ()=>(parcelRequire("ksyXb")).then((module)=>module.default),
    loading: ()=>null
});

const $d6e9a0cb47163615$export$2478ed0e296e2752 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "f_9Lp",
    name: "IconQuote",
    loader: ()=>(parcelRequire("j60A9")).then((module)=>module.default),
    loading: ()=>null
});

const $d6e9a0cb47163615$export$4635bc8225f90ec6 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "dMybO",
    name: "IconStatus",
    loader: ()=>(parcelRequire("amSpc")).then((module)=>module.default),
    loading: ()=>null
});

const $d6e9a0cb47163615$export$8f1e9e900568bfce = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "1onub",
    name: "IconOneColumnLayout",
    loader: ()=>(parcelRequire("lLGqC")).then((module)=>module.default),
    loading: ()=>null
});

const $d6e9a0cb47163615$export$732a7fc4975ab5a4 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "6-NfL",
    name: "IconTwoColumnLayout",
    loader: ()=>(parcelRequire("fVB3P")).then((module)=>module.default),
    loading: ()=>null
});

const $d6e9a0cb47163615$export$fdfaf73f45072edb = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "O0AJE",
    name: "IconThreeColumnLayout",
    loader: ()=>(parcelRequire("jIV2s")).then((module)=>module.default),
    loading: ()=>null
});

const $d6e9a0cb47163615$export$a1588f873a973762 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "VvfLh",
    name: "IconFourColumnLayout",
    loader: ()=>(parcelRequire("hz9pa")).then((module)=>module.default),
    loading: ()=>null
});

const $d6e9a0cb47163615$export$ff1f32987b4c27d9 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "pum24",
    name: "IconFiveColumnLayout",
    loader: ()=>(parcelRequire("iJmaZ")).then((module)=>module.default),
    loading: ()=>null
});






function $d6e9a0cb47163615$var$importHeading(level) {
    switch(level){
        case 1:
            return (parcelRequire("5kAVx"));
        case 2:
            return (parcelRequire("c1e8q"));
        case 3:
            return (parcelRequire("a4ten"));
        case 4:
            return (parcelRequire("1fA4V"));
        case 5:
            return (parcelRequire("9iDsT"));
        case 6:
        default:
            return (parcelRequire("134VK"));
    }
}
const $d6e9a0cb47163615$export$1a33a10ac24d7971 = ({ level: level, label: label })=>{
    const Icon = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
        __loadable_id__: "DCCGQ",
        name: "Icon",
        loader: ()=>$d6e9a0cb47163615$var$importHeading(level).then((module)=>module.default),
        loading: ()=>null
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
        label: label
    });
};

const $d6e9a0cb47163615$export$e25449dcffb445e = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "fnF2w",
    name: "IconFeedback",
    loader: ()=>(parcelRequire("iIxQ6")).then((module)=>module.default),
    loading: ()=>null
});

const $d6e9a0cb47163615$export$209d03a445a7dc8e = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "sGpBl",
    name: "IconExpand",
    loader: ()=>(parcelRequire("imsHR")).then((module)=>module.default),
    loading: ()=>null
});

const $d6e9a0cb47163615$export$c9b1dcefa7c9a7aa = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "RIvxZ",
    name: "IconDatasourceJiraIssue",
    loader: ()=>(parcelRequire("4qJPu")).then((module)=>module.default),
    loading: ()=>null
});

const $d6e9a0cb47163615$export$7d6f860161da0fa6 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "mJ_ZJ",
    name: "IconDatasourceAssetsObjects",
    loader: ()=>(parcelRequire("3U4LN")).then((module)=>module.default),
    loading: ()=>null
});

const $d6e9a0cb47163615$export$29a810fd0b8c3f03 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "Ib_id",
    name: "IconDatasourceConfluenceSearch",
    loader: ()=>(parcelRequire("649WQ")).then((module)=>module.default),
    loading: ()=>null
});

const $d6e9a0cb47163615$export$ccbb24eed51aea20 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "QB-q-",
    name: "IconLoom",
    loader: ()=>(parcelRequire("cgfCd")).then((module)=>module.default),
    loading: ()=>null
});

const $d6e9a0cb47163615$export$4dc65faf2ef9e446 = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "XCScQ",
    name: "IconSyncBlock",
    loader: ()=>(parcelRequire("iPyjx")).then((module)=>module.default),
    loading: ()=>null
});
module.exports["IconAction"] = $d6e9a0cb47163615$export$e40fe94b4cff8ec5;
module.exports["IconCode"] = $d6e9a0cb47163615$export$e332a83b9159d69d;
module.exports["IconDate"] = $d6e9a0cb47163615$export$39617668a6028b06;
module.exports["IconDecision"] = $d6e9a0cb47163615$export$6eb71591d1461541;
module.exports["IconDivider"] = $d6e9a0cb47163615$export$f2ab17920c9d243;
module.exports["IconEmoji"] = $d6e9a0cb47163615$export$8bd591d4b34dcafa;
module.exports["IconImages"] = $d6e9a0cb47163615$export$c17cf1164355efc2;
module.exports["IconLayout"] = $d6e9a0cb47163615$export$fba0c846789a9d87;
module.exports["IconLink"] = $d6e9a0cb47163615$export$23da1e9f164f7ea1;
module.exports["IconListNumber"] = $d6e9a0cb47163615$export$32f6affcc5f19c17;
module.exports["IconList"] = $d6e9a0cb47163615$export$527d32aa1785fdd4;
module.exports["IconMention"] = $d6e9a0cb47163615$export$de1d1a07ff53cf53;
module.exports["IconPanelError"] = $d6e9a0cb47163615$export$a1c6b14f5f0a0c20;
module.exports["IconPanelNote"] = $d6e9a0cb47163615$export$4d90d09f9e3039e;
module.exports["IconPanelSuccess"] = $d6e9a0cb47163615$export$cc5c1cc765c068a0;
module.exports["IconPanelWarning"] = $d6e9a0cb47163615$export$e728578e48814100;
module.exports["IconPanel"] = $d6e9a0cb47163615$export$18978208c8652af3;
module.exports["IconQuote"] = $d6e9a0cb47163615$export$2478ed0e296e2752;
module.exports["IconStatus"] = $d6e9a0cb47163615$export$4635bc8225f90ec6;
module.exports["IconOneColumnLayout"] = $d6e9a0cb47163615$export$8f1e9e900568bfce;
module.exports["IconTwoColumnLayout"] = $d6e9a0cb47163615$export$732a7fc4975ab5a4;
module.exports["IconThreeColumnLayout"] = $d6e9a0cb47163615$export$fdfaf73f45072edb;
module.exports["IconFourColumnLayout"] = $d6e9a0cb47163615$export$a1588f873a973762;
module.exports["IconFiveColumnLayout"] = $d6e9a0cb47163615$export$ff1f32987b4c27d9;
module.exports["IconHeading"] = $d6e9a0cb47163615$export$1a33a10ac24d7971;
module.exports["IconFeedback"] = $d6e9a0cb47163615$export$e25449dcffb445e;
module.exports["IconExpand"] = $d6e9a0cb47163615$export$209d03a445a7dc8e;
module.exports["IconDatasourceJiraIssue"] = $d6e9a0cb47163615$export$c9b1dcefa7c9a7aa;
module.exports["IconDatasourceAssetsObjects"] = $d6e9a0cb47163615$export$7d6f860161da0fa6;
module.exports["IconDatasourceConfluenceSearch"] = $d6e9a0cb47163615$export$29a810fd0b8c3f03;
module.exports["IconSyncBlock"] = $d6e9a0cb47163615$export$4dc65faf2ef9e446;

});

parcelRegister("5yhmU", function(module, exports) {

let $40ad99bc69a45ff5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $40ad99bc69a45ff5$var$load("jcdL6").then(()=>parcelRequire('jZQow'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("6uNKj", function(module, exports) {

let $4bac21f10fdd7554$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4bac21f10fdd7554$var$load("8SMhH").then(()=>parcelRequire('d8nfK'));

});

parcelRegister("5YPWf", function(module, exports) {

let $45aad83cb5e3baf8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $45aad83cb5e3baf8$var$load("bxYOE").then(()=>parcelRequire('f6K6R'));

});

parcelRegister("kAAUV", function(module, exports) {

let $efd3ce675c591cc1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $efd3ce675c591cc1$var$load("f0zmS").then(()=>parcelRequire('3ZJ4A'));

});

parcelRegister("7we1w", function(module, exports) {

let $57966655a99d8c8e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $57966655a99d8c8e$var$load("ggLwo").then(()=>parcelRequire('8pw0K'));

});

parcelRegister("jBGRu", function(module, exports) {

let $e462b87e8808c777$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e462b87e8808c777$var$load("1p2DU").then(()=>parcelRequire('h7BLL'));

});

parcelRegister("iyJhb", function(module, exports) {

let $d82e85dbc7213dcd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d82e85dbc7213dcd$var$load("1RKLZ").then(()=>parcelRequire('dl1AA'));

});

parcelRegister("5o7UN", function(module, exports) {

let $3ec5556de2606435$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3ec5556de2606435$var$load("7i9aD").then(()=>parcelRequire('hdtwr'));

});

parcelRegister("5Lmiw", function(module, exports) {

let $4322a36187a0d8b7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4322a36187a0d8b7$var$load("4VRIj").then(()=>parcelRequire('13fHE'));

});

parcelRegister("4hslg", function(module, exports) {

let $31debc11bc9056d6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $31debc11bc9056d6$var$load("djSOz").then(()=>parcelRequire('3vm3R'));

});

parcelRegister("bq7Rk", function(module, exports) {

let $8508381827bc2203$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8508381827bc2203$var$load("irpaz").then(()=>parcelRequire('4OBP7'));

});

parcelRegister("iww0k", function(module, exports) {

let $d7c40a8b654378ad$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d7c40a8b654378ad$var$load("3SeOO").then(()=>parcelRequire('8VXJy'));

});

parcelRegister("947V2", function(module, exports) {

let $699aa14dea36be05$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $699aa14dea36be05$var$load("5se79").then(()=>parcelRequire('hp0db'));

});

parcelRegister("hfB5c", function(module, exports) {

let $c8f09a41673296f6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c8f09a41673296f6$var$load("9bXCA").then(()=>parcelRequire('4zQBS'));

});

parcelRegister("eKHyH", function(module, exports) {

let $abd72666e13ea61e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $abd72666e13ea61e$var$load("1WrE2").then(()=>parcelRequire('aB2Pi'));

});

parcelRegister("iSjEQ", function(module, exports) {

let $dbdc84c0d7154279$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dbdc84c0d7154279$var$load("fnpAC").then(()=>parcelRequire('6HuPb'));

});

parcelRegister("ksyXb", function(module, exports) {

let $ee518934381c0e47$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ee518934381c0e47$var$load("gMSS1").then(()=>parcelRequire('cXyPv'));

});

parcelRegister("j60A9", function(module, exports) {

let $de6f076d4092ff41$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $de6f076d4092ff41$var$load("e1MXN").then(()=>parcelRequire('bpr27'));

});

parcelRegister("amSpc", function(module, exports) {

let $78c62938ded61f98$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $78c62938ded61f98$var$load("4dn8m").then(()=>parcelRequire('khkEv'));

});

parcelRegister("lLGqC", function(module, exports) {

let $fd8ee625a01354e5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fd8ee625a01354e5$var$load("9E19j").then(()=>parcelRequire('f85Xb'));

});

parcelRegister("fVB3P", function(module, exports) {

let $b988ed5ca07ad4e9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b988ed5ca07ad4e9$var$load("bDOK7").then(()=>parcelRequire('bQhfP'));

});

parcelRegister("jIV2s", function(module, exports) {

let $e5be5f0ef6e5af46$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e5be5f0ef6e5af46$var$load("jhuLr").then(()=>parcelRequire('b395l'));

});

parcelRegister("hz9pa", function(module, exports) {

let $cc9d00278d802d19$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cc9d00278d802d19$var$load("gMvtj").then(()=>parcelRequire('k5Wqo'));

});

parcelRegister("iJmaZ", function(module, exports) {

let $da2da1b6e8de4f9c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $da2da1b6e8de4f9c$var$load("7unhY").then(()=>parcelRequire('iN9qS'));

});

parcelRegister("5kAVx", function(module, exports) {

let $3e1b76f09969c44b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3e1b76f09969c44b$var$load("aKgoC").then(()=>parcelRequire('wwOu8'));

});

parcelRegister("c1e8q", function(module, exports) {

let $8c008aed485f6b76$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8c008aed485f6b76$var$load("9ygQy").then(()=>parcelRequire('il5Of'));

});

parcelRegister("a4ten", function(module, exports) {

let $7550f3c3fb534bb8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7550f3c3fb534bb8$var$load("kTaDo").then(()=>parcelRequire('kXpRb'));

});

parcelRegister("1fA4V", function(module, exports) {

let $0e932d97c7257958$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0e932d97c7257958$var$load("d2kuO").then(()=>parcelRequire('dSkkf'));

});

parcelRegister("9iDsT", function(module, exports) {

let $6c54686f2a62a61e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6c54686f2a62a61e$var$load("6wLYX").then(()=>parcelRequire('jNfYo'));

});

parcelRegister("134VK", function(module, exports) {

let $0c39e553a9325c82$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0c39e553a9325c82$var$load("eVKfF").then(()=>parcelRequire('kX158'));

});

parcelRegister("iIxQ6", function(module, exports) {

let $da0695d723b14963$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $da0695d723b14963$var$load("b4NwV").then(()=>parcelRequire('8cB3R'));

});

parcelRegister("imsHR", function(module, exports) {

let $d5e08c91eed01062$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d5e08c91eed01062$var$load("h9aqE").then(()=>parcelRequire('gsXh4'));

});

parcelRegister("4qJPu", function(module, exports) {

let $339d23e63188bc18$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $339d23e63188bc18$var$load("jXrdN").then(()=>parcelRequire('25bHO'));

});

parcelRegister("3U4LN", function(module, exports) {

let $2d7a4d407462a451$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2d7a4d407462a451$var$load("9Bneg").then(()=>parcelRequire('7u3NV'));

});

parcelRegister("649WQ", function(module, exports) {

let $46aad54ece5c9785$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $46aad54ece5c9785$var$load("1lXr0").then(()=>parcelRequire('1brNQ'));

});

parcelRegister("cgfCd", function(module, exports) {

let $8ed3178647a03bf0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8ed3178647a03bf0$var$load("bHGMG").then(()=>parcelRequire('3pTCH'));

});

parcelRegister("iPyjx", function(module, exports) {

let $db579b785d2a1b4a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $db579b785d2a1b4a$var$load("4glJk").then(()=>parcelRequire('4gZJG'));

});

parcelRegister("boahT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $2UWDO = parcelRequire("2UWDO");


var $cPCP8 = parcelRequire("cPCP8");

var $4Chin = parcelRequire("4Chin");


var $3yaUF = parcelRequire("3yaUF");

var $aYGvQ = parcelRequire("aYGvQ");

var $5wdIn = parcelRequire("5wdIn");

var $l1461 = parcelRequire("l1461");

var $7a8uv = parcelRequire("7a8uv");

var $45HPa = parcelRequire("45HPa");

var $9RVmI = parcelRequire("9RVmI");

var $f8c3d = parcelRequire("f8c3d");

var $2aKPB = parcelRequire("2aKPB");

var $50a25 = parcelRequire("50a25");























var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");

/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 


const $dc8c5bf5be03067a$var$SVGContainer = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        style: {
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)",
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center'
        },
        "data-vc": "qNugyay1"
    }, children);
const $dc8c5bf5be03067a$export$5f1af8db9871e1d6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($dc8c5bf5be03067a$var$SVGContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M2 1H14V5H12.5V2.5H8.8125V13.5H10.5V15H5.5V13.5H7.3125V2.5H3.5V5H2V1Z",
        fill: "currentColor"
    })));
const $dc8c5bf5be03067a$export$5523b16adee8048 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($dc8c5bf5be03067a$var$SVGContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M0 0H1.5V6.25H6V0H7.5V6.25V7.75V14H6V7.75H1.5V14H0V7.75V6.25V0ZM9.85801 12.6959V14H13.9999V12.6959H12.8161V7.83108H11.3138L9.8418 8.86406V10.4342L11.3499 9.31528V12.6959H9.85801Z",
        fill: "currentColor"
    })));
const $dc8c5bf5be03067a$export$cb94397127ac9363 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($dc8c5bf5be03067a$var$SVGContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        "clip-rule": "evenodd",
        d: "M1.5 0H0V6.25V7.75V14H1.5V7.75H6V14H7.5V7.75V6.25V0H6V6.25H1.5V0ZM9.2395 12.8296V14H14V12.6553H11.5637V12.573L12.4146 11.875C12.7826 11.5734 13.0772 11.2981 13.2986 11.0491C13.5199 10.8 13.679 10.5635 13.7759 10.3394C13.8755 10.1152 13.9253 9.89111 13.9253 9.66699V9.64624C13.9253 9.28101 13.8285 8.96419 13.6348 8.6958C13.4411 8.42464 13.1685 8.21574 12.8171 8.06909C12.4685 7.91968 12.0562 7.84497 11.5803 7.84497C11.0906 7.84497 10.6617 7.93075 10.2937 8.10229C9.92847 8.27108 9.64347 8.50903 9.43872 8.81616C9.23674 9.12052 9.13574 9.47884 9.13574 9.89111V9.92432H10.7378V9.88696C10.7378 9.74308 10.771 9.6158 10.8374 9.50513C10.9038 9.39445 10.9951 9.30729 11.1113 9.24365C11.2303 9.18001 11.3659 9.14819 11.5181 9.14819C11.6647 9.14819 11.7906 9.1731 11.8958 9.2229C12.0037 9.27271 12.0853 9.34465 12.1406 9.43872C12.1987 9.5328 12.2278 9.64486 12.2278 9.7749V9.79565C12.2278 9.9008 12.1946 10.0115 12.1282 10.1277C12.0645 10.2439 11.9497 10.3878 11.7837 10.5593C11.6177 10.7281 11.3811 10.9467 11.074 11.2151L9.2395 12.8296Z",
        fill: "currentColor"
    })));
const $dc8c5bf5be03067a$export$746be9e3a3dfff1f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($dc8c5bf5be03067a$var$SVGContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M1.5 0H0V6.25V7.75V14H1.5V7.75H6V14H7.5V7.75V6.25V0H6V6.25H1.5V0ZM10.219 13.7649C10.5811 13.9216 11.0012 14 11.4794 14C12.0009 14 12.4494 13.9257 12.825 13.7771C13.2005 13.6258 13.4896 13.411 13.6922 13.1327C13.8976 12.8544 14.0002 12.5248 14.0002 12.1438V12.1357C14.0002 11.7575 13.8706 11.4535 13.6112 11.2239C13.3518 10.9942 13.0006 10.8564 12.5575 10.8105V10.7781C12.7709 10.7348 12.9681 10.6565 13.1492 10.543C13.3329 10.4295 13.4801 10.2823 13.5909 10.1013C13.7017 9.91755 13.7571 9.70275 13.7571 9.45688V9.44878C13.7571 9.12186 13.6639 8.83817 13.4774 8.5977C13.291 8.35454 13.0262 8.16541 12.6831 8.03032C12.34 7.89523 11.9347 7.82769 11.4673 7.82769C11.0134 7.82769 10.6162 7.90469 10.2758 8.05869C9.93805 8.20999 9.67057 8.42479 9.47334 8.70308C9.27611 8.98136 9.16533 9.31099 9.14102 9.69194L9.13696 9.75273H10.6851L10.6892 9.71626C10.7027 9.58927 10.7418 9.4785 10.8067 9.38394C10.8715 9.28667 10.9593 9.21237 11.0701 9.16104C11.1836 9.107 11.316 9.07998 11.4673 9.07998C11.6132 9.07998 11.7388 9.10565 11.8442 9.15698C11.9523 9.20562 12.0347 9.27586 12.0914 9.36772C12.1481 9.45959 12.1765 9.56631 12.1765 9.68789V9.696C12.1765 9.81488 12.1427 9.9189 12.0752 10.0081C12.0104 10.0945 11.9158 10.1607 11.7915 10.2066C11.6672 10.2526 11.5159 10.2755 11.3376 10.2755H10.7337V11.4062H11.3376C11.6348 11.4062 11.8618 11.4589 12.0185 11.5643C12.1752 11.667 12.2535 11.8183 12.2535 12.0182V12.0263C12.2535 12.1506 12.2224 12.2614 12.1603 12.3586C12.0982 12.4532 12.009 12.5289 11.8928 12.5856C11.7766 12.6396 11.6375 12.6667 11.4754 12.6667C11.3133 12.6667 11.1728 12.641 11.0539 12.5896C10.935 12.5383 10.8405 12.4681 10.7702 12.3789C10.7 12.2897 10.6567 12.1911 10.6405 12.0831L10.6324 12.0344H8.99512L8.99917 12.0871C9.02889 12.4762 9.14912 12.8139 9.35986 13.1003C9.57061 13.3867 9.857 13.6082 10.219 13.7649Z",
        fill: "currentColor"
    })));
const $dc8c5bf5be03067a$export$cc5e069d64fda823 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($dc8c5bf5be03067a$var$SVGContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M1.5 0H0V6.25V7.75V14H1.5V7.75H6V14H7.5V7.75V6.25V0H6V6.25H1.5V0ZM11.542 13.0117V14H13.2607V13.0117H13.9998V11.6195H13.2607V7.79961H10.7428C10.5852 8.05169 10.4291 8.30378 10.2744 8.55586C10.1226 8.80508 9.97077 9.05573 9.81894 9.30781C9.66999 9.5599 9.52103 9.81628 9.37207 10.077C9.22311 10.3348 9.07559 10.5969 8.92949 10.8633C8.7834 11.1268 8.6373 11.3975 8.49121 11.6754V13.0117H11.542ZM11.5936 11.6883H10.0338V11.6023C10.1226 11.4276 10.2143 11.2543 10.3088 11.0824C10.4033 10.9077 10.4993 10.7344 10.5967 10.5625C10.6969 10.3906 10.7972 10.2202 10.8975 10.0512C10.9977 9.8793 11.098 9.71029 11.1982 9.54414C11.3014 9.37799 11.4045 9.21328 11.5076 9.05H11.5936V11.6883Z",
        fill: "currentColor"
    })));
const $dc8c5bf5be03067a$export$88ef9fdaf11f7a1f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($dc8c5bf5be03067a$var$SVGContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M1.5 0H0V6.25V7.75V14H1.5V7.75H6V14H7.5V7.75V6.25V0H6V6.25H1.5V0ZM10.2808 13.7551C10.6349 13.9184 11.0527 14 11.5342 14C12.0239 14 12.4542 13.9101 12.825 13.7302C13.1957 13.5476 13.4835 13.2917 13.6882 12.9624C13.8958 12.6331 13.9995 12.2499 13.9995 11.8127V11.8044C13.9995 11.4281 13.9165 11.0961 13.7505 10.8083C13.5872 10.5178 13.3617 10.2896 13.074 10.1235C12.7862 9.95752 12.457 9.87451 12.0862 9.87451C11.887 9.87451 11.703 9.90356 11.5342 9.96167C11.3682 10.0198 11.2243 10.1 11.1025 10.2024C10.9808 10.3048 10.884 10.4237 10.812 10.5593H10.729L10.8203 9.1731H13.6177V7.84497H9.45898L9.22241 11.4973H10.7207C10.7511 11.4392 10.7913 11.3839 10.8411 11.3313C10.8909 11.276 10.9462 11.2275 11.0071 11.186C11.079 11.139 11.1579 11.103 11.2437 11.0781C11.3322 11.0505 11.4277 11.0366 11.53 11.0366C11.6933 11.0366 11.8385 11.0712 11.9658 11.1404C12.0931 11.2068 12.1927 11.2995 12.2646 11.4185C12.3366 11.5374 12.3726 11.6772 12.3726 11.8376V11.8459C12.3726 12.0037 12.3366 12.1448 12.2646 12.2693C12.1927 12.391 12.0931 12.4865 11.9658 12.5557C11.8413 12.6248 11.6974 12.6594 11.5342 12.6594C11.3903 12.6594 11.2616 12.6345 11.1482 12.5847C11.0347 12.5349 10.9393 12.4685 10.8618 12.3855C10.7871 12.2997 10.7318 12.2056 10.6958 12.1033L10.6875 12.0784H9.12695L9.1311 12.1531C9.15047 12.4989 9.25838 12.8116 9.45483 13.0911C9.65405 13.3705 9.92936 13.5919 10.2808 13.7551Z",
        fill: "currentColor"
    })));
const $dc8c5bf5be03067a$export$a559fb8039b06400 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($dc8c5bf5be03067a$var$SVGContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M1.5 0H0V6.25V7.75V14H1.5V7.75H6V14H7.5V7.75V6.25V0H6V6.25H1.5V0ZM10.4615 13.7893C10.7857 13.9298 11.1531 14 11.5638 14C12.0501 14 12.4757 13.9068 12.8404 13.7204C13.2052 13.5339 13.4889 13.28 13.6915 12.9584C13.8968 12.6342 13.9995 12.2681 13.9995 11.8602V11.8521C13.9995 11.4873 13.9225 11.1644 13.7685 10.8834C13.6172 10.5998 13.3997 10.3782 13.116 10.2188C12.835 10.0567 12.4973 9.97563 12.1028 9.97563C11.8272 9.97563 11.5935 10.0135 11.4017 10.0891C11.2099 10.1648 11.0532 10.2634 10.9316 10.385C10.81 10.5065 10.7141 10.6389 10.6438 10.7821H10.5547C10.5548 10.7402 10.5561 10.6984 10.5587 10.6565C10.575 10.3539 10.6195 10.0878 10.6925 9.8581C10.7681 9.62845 10.8762 9.44878 11.0167 9.31909C11.1572 9.1894 11.3328 9.12456 11.5436 9.12456C11.6624 9.12456 11.7678 9.14347 11.8597 9.1813C11.9542 9.21912 12.0353 9.27046 12.1028 9.3353C12.1704 9.40015 12.2204 9.47309 12.2528 9.55415L12.2649 9.58252H13.9266L13.9225 9.5582C13.8685 9.23398 13.7334 8.94219 13.5172 8.68281C13.3011 8.42074 13.0215 8.21269 12.6783 8.05869C12.3379 7.90469 11.9542 7.82768 11.5273 7.82768C11.0032 7.82768 10.5466 7.95062 10.1575 8.19648C9.76846 8.44235 9.4672 8.79629 9.25376 9.2583C9.04032 9.71761 8.93359 10.2674 8.93359 10.9078V10.9159C8.93359 11.3941 8.99303 11.8237 9.11191 12.2046C9.23079 12.5856 9.40371 12.9098 9.63066 13.1773C9.86032 13.4421 10.1373 13.6461 10.4615 13.7893ZM10.7492 11.9047C10.7492 12.056 10.7843 12.1925 10.8546 12.3141C10.9275 12.4356 11.0248 12.5316 11.1464 12.6018C11.2707 12.6694 11.4071 12.7031 11.5557 12.7031C11.707 12.7031 11.8435 12.6694 11.965 12.6018C12.0866 12.5316 12.1839 12.4383 12.2568 12.3222C12.3298 12.206 12.3663 12.075 12.3663 11.9291V11.9209C12.3663 11.7696 12.3311 11.6359 12.2609 11.5197C12.1906 11.4035 12.0947 11.3117 11.9731 11.2441C11.8543 11.1766 11.7165 11.1428 11.5598 11.1428C11.4112 11.1428 11.2747 11.1752 11.1504 11.2401C11.0289 11.3022 10.9316 11.39 10.8586 11.5035C10.7857 11.617 10.7492 11.748 10.7492 11.8966V11.9047Z",
        fill: "currentColor"
    })));


const $33ae6aa27da00e18$export$58d6de174a4025df = {
    name: 'normal',
    title: (0, $2UWDO.messages).normal,
    nodeName: 'paragraph',
    tagName: 'p',
    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f8c3d))), {
        label: ""
    }),
    LEGACY_icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dc8c5bf5be03067a$export$5f1af8db9871e1d6), null)
};
const $33ae6aa27da00e18$export$1c89d6b8fe002592 = {
    name: 'smallText',
    title: (0, $2UWDO.messages).smallText,
    nodeName: 'paragraph',
    markName: 'fontSize',
    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($50a25))), {
        label: ""
    }),
    LEGACY_icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dc8c5bf5be03067a$export$5f1af8db9871e1d6), null)
};
const $33ae6aa27da00e18$export$aca53469ff012f69 = {
    name: 'heading1',
    title: (0, $2UWDO.messages).heading1,
    nodeName: 'heading',
    tagName: 'h1',
    level: 1,
    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5wdIn))), {
        label: ""
    }),
    LEGACY_icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dc8c5bf5be03067a$export$5523b16adee8048), null)
};
const $33ae6aa27da00e18$export$8af5e2d4f952c9f0 = {
    name: 'heading2',
    title: (0, $2UWDO.messages).heading2,
    nodeName: 'heading',
    tagName: 'h2',
    level: 2,
    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($45HPa))), {
        label: ""
    }),
    LEGACY_icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dc8c5bf5be03067a$export$cb94397127ac9363), null)
};
const $33ae6aa27da00e18$export$4b4c4ef3a93a84d8 = {
    name: 'heading3',
    title: (0, $2UWDO.messages).heading3,
    nodeName: 'heading',
    tagName: 'h3',
    level: 3,
    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7a8uv))), {
        label: ""
    }),
    LEGACY_icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dc8c5bf5be03067a$export$746be9e3a3dfff1f), null)
};
const $33ae6aa27da00e18$export$67379271b4d26982 = {
    name: 'heading4',
    title: (0, $2UWDO.messages).heading4,
    nodeName: 'heading',
    tagName: 'h4',
    level: 4,
    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aYGvQ))), {
        label: ""
    }),
    LEGACY_icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dc8c5bf5be03067a$export$cc5e069d64fda823), null)
};
const $33ae6aa27da00e18$export$230d7efa1736763e = {
    name: 'heading5',
    title: (0, $2UWDO.messages).heading5,
    nodeName: 'heading',
    tagName: 'h5',
    level: 5,
    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3yaUF))), {
        label: ""
    }),
    LEGACY_icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dc8c5bf5be03067a$export$88ef9fdaf11f7a1f), null)
};
const $33ae6aa27da00e18$export$329adfa5d98f30d5 = {
    name: 'heading6',
    title: (0, $2UWDO.messages).heading6,
    nodeName: 'heading',
    tagName: 'h6',
    level: 6,
    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l1461))), {
        label: ""
    }),
    LEGACY_icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dc8c5bf5be03067a$export$a559fb8039b06400), null)
};
const $33ae6aa27da00e18$export$175cdd8bc7e4b125 = {
    name: 'blockquote',
    title: (0, $2UWDO.messages).blockquote,
    nodeName: 'blockquote',
    tagName: 'blockquote'
};
const $33ae6aa27da00e18$export$cf55d1bff75690da = {
    name: 'codeblock',
    title: (0, $2UWDO.messages).codeblock,
    nodeName: 'codeBlock'
};
const $33ae6aa27da00e18$export$867b449446b85962 = {
    name: 'panel',
    title: (0, $2UWDO.messages).infoPanel,
    nodeName: 'panel'
};
const $33ae6aa27da00e18$export$d46a05f8561f868a = {
    name: 'other',
    title: (0, $2UWDO.messages).other,
    nodeName: ''
};
const $33ae6aa27da00e18$export$2ec1d6c4f06d927 = [
    $33ae6aa27da00e18$export$58d6de174a4025df,
    $33ae6aa27da00e18$export$1c89d6b8fe002592,
    $33ae6aa27da00e18$export$aca53469ff012f69,
    $33ae6aa27da00e18$export$8af5e2d4f952c9f0,
    $33ae6aa27da00e18$export$4b4c4ef3a93a84d8,
    $33ae6aa27da00e18$export$67379271b4d26982,
    $33ae6aa27da00e18$export$230d7efa1736763e,
    $33ae6aa27da00e18$export$329adfa5d98f30d5
];
var $33ae6aa27da00e18$var$ToolbarBlockTypes = /*#__PURE__*/ function(ToolbarBlockTypes) {
    ToolbarBlockTypes["normal"] = "normal";
    ToolbarBlockTypes["heading1"] = "heading1";
    ToolbarBlockTypes["heading2"] = "heading2";
    ToolbarBlockTypes["heading3"] = "heading3";
    ToolbarBlockTypes["heading4"] = "heading4";
    ToolbarBlockTypes["heading5"] = "heading5";
    ToolbarBlockTypes["heading6"] = "heading6";
    ToolbarBlockTypes["blockquote"] = "blockquote";
    return ToolbarBlockTypes;
}($33ae6aa27da00e18$var$ToolbarBlockTypes || {});
const $33ae6aa27da00e18$export$eb0a3dded5e1d29b = ({ allowFontSize: allowFontSize })=>({
        normal: {
            ...$33ae6aa27da00e18$export$58d6de174a4025df,
            icon: // eslint-disable-next-line @atlaskit/platform/no-preconditioning
            (0, $1oCLl.expValEquals)('platform_editor_small_font_size', 'isEnabled', true) && (0, $dh538.fg)('platform_editor_change_normal_text_icon') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2aKPB))), {
                size: "small",
                label: ""
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f8c3d))), {
                size: "small",
                label: ""
            }),
            toolbarRank: (0, $4Chin.TEXT_STYLES_MENU_SECTION_RANK)[(0, $cPCP8.NORMAL_TEXT_MENU_ITEM).key],
            toolbarKey: (0, $cPCP8.NORMAL_TEXT_MENU_ITEM).key
        },
        ...allowFontSize && (0, $1oCLl.expValEquals)('platform_editor_small_font_size', 'isEnabled', true) && {
            smallText: {
                ...$33ae6aa27da00e18$export$1c89d6b8fe002592,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($50a25))), {
                    size: "small",
                    label: ""
                }),
                toolbarRank: (0, $4Chin.TEXT_STYLES_MENU_SECTION_RANK)[(0, $cPCP8.SMALL_TEXT_MENU_ITEM).key],
                toolbarKey: (0, $cPCP8.SMALL_TEXT_MENU_ITEM).key
            }
        },
        heading1: {
            ...$33ae6aa27da00e18$export$aca53469ff012f69,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5wdIn))), {
                size: "small",
                label: ""
            }),
            toolbarRank: (0, $4Chin.TEXT_STYLES_MENU_SECTION_RANK)[(0, $cPCP8.HEADING_1_MENU_ITEM).key],
            toolbarKey: (0, $cPCP8.HEADING_1_MENU_ITEM).key
        },
        heading2: {
            ...$33ae6aa27da00e18$export$8af5e2d4f952c9f0,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($45HPa))), {
                size: "small",
                label: ""
            }),
            toolbarRank: (0, $4Chin.TEXT_STYLES_MENU_SECTION_RANK)[(0, $cPCP8.HEADING_2_MENU_ITEM).key],
            toolbarKey: (0, $cPCP8.HEADING_2_MENU_ITEM).key
        },
        heading3: {
            ...$33ae6aa27da00e18$export$4b4c4ef3a93a84d8,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7a8uv))), {
                size: "small",
                label: ""
            }),
            toolbarRank: (0, $4Chin.TEXT_STYLES_MENU_SECTION_RANK)[(0, $cPCP8.HEADING_3_MENU_ITEM).key],
            toolbarKey: (0, $cPCP8.HEADING_3_MENU_ITEM).key
        },
        heading4: {
            ...$33ae6aa27da00e18$export$67379271b4d26982,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aYGvQ))), {
                size: "small",
                label: ""
            }),
            toolbarRank: (0, $4Chin.TEXT_STYLES_MENU_SECTION_RANK)[(0, $cPCP8.HEADING_4_MENU_ITEM).key],
            toolbarKey: (0, $cPCP8.HEADING_4_MENU_ITEM).key
        },
        heading5: {
            ...$33ae6aa27da00e18$export$230d7efa1736763e,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3yaUF))), {
                size: "small",
                label: ""
            }),
            toolbarRank: (0, $4Chin.TEXT_STYLES_MENU_SECTION_RANK)[(0, $cPCP8.HEADING_5_MENU_ITEM).key],
            toolbarKey: (0, $cPCP8.HEADING_5_MENU_ITEM).key
        },
        heading6: {
            ...$33ae6aa27da00e18$export$329adfa5d98f30d5,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l1461))), {
                size: "small",
                label: ""
            }),
            toolbarRank: (0, $4Chin.TEXT_STYLES_MENU_SECTION_RANK)[(0, $cPCP8.HEADING_6_MENU_ITEM).key],
            toolbarKey: (0, $cPCP8.HEADING_6_MENU_ITEM).key
        },
        blockquote: {
            ...$33ae6aa27da00e18$export$175cdd8bc7e4b125,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))), {
                size: "small",
                label: ""
            }),
            toolbarRank: (0, $4Chin.TEXT_STYLES_MENU_SECTION_RANK)[(0, $cPCP8.BLOCK_QUOTE_MENU_ITEM).key],
            toolbarKey: (0, $cPCP8.BLOCK_QUOTE_MENU_ITEM).key
        }
    });
const $33ae6aa27da00e18$export$a5cb0c20bd02ce0c = [
    'heading',
    'blockquote'
];
const $33ae6aa27da00e18$export$73b50f8f13648c71 = [
    'em',
    'code',
    'strike',
    'strong',
    'underline',
    'textColor',
    'subsup',
    'backgroundColor'
];
const $33ae6aa27da00e18$export$c6516682f7569488 = [
    $33ae6aa27da00e18$export$175cdd8bc7e4b125,
    $33ae6aa27da00e18$export$cf55d1bff75690da,
    $33ae6aa27da00e18$export$867b449446b85962
];
const $33ae6aa27da00e18$export$237f26fa8dbc0d9a = $33ae6aa27da00e18$export$2ec1d6c4f06d927.concat($33ae6aa27da00e18$export$c6516682f7569488);
const $33ae6aa27da00e18$export$a1bb601016dd2309 = (includeBlockQuoteAsTextstyleOption)=>{
    return includeBlockQuoteAsTextstyleOption ? [
        ...$33ae6aa27da00e18$export$2ec1d6c4f06d927,
        $33ae6aa27da00e18$export$175cdd8bc7e4b125
    ] : $33ae6aa27da00e18$export$2ec1d6c4f06d927;
};
const $33ae6aa27da00e18$export$110c9c3e05131569 = $33ae6aa27da00e18$export$2ec1d6c4f06d927.reduce((acc, blockType)=>{
    if (blockType.level && blockType.nodeName === 'heading') acc[blockType.level] = blockType;
    return acc;
}, {});
const $33ae6aa27da00e18$export$33dfdcd30c23ea87 = $33ae6aa27da00e18$export$2ec1d6c4f06d927.reduce((acc, blockType)=>{
    if (blockType.level && blockType.nodeName === 'heading') acc[blockType.name] = blockType;
    return acc;
}, {});
module.exports["NORMAL_TEXT"] = $33ae6aa27da00e18$export$58d6de174a4025df;
module.exports["SMALL_TEXT"] = $33ae6aa27da00e18$export$1c89d6b8fe002592;
module.exports["HEADING_1"] = $33ae6aa27da00e18$export$aca53469ff012f69;
module.exports["HEADING_2"] = $33ae6aa27da00e18$export$8af5e2d4f952c9f0;
module.exports["HEADING_3"] = $33ae6aa27da00e18$export$4b4c4ef3a93a84d8;
module.exports["HEADING_4"] = $33ae6aa27da00e18$export$67379271b4d26982;
module.exports["HEADING_5"] = $33ae6aa27da00e18$export$230d7efa1736763e;
module.exports["HEADING_6"] = $33ae6aa27da00e18$export$329adfa5d98f30d5;
module.exports["BLOCK_QUOTE"] = $33ae6aa27da00e18$export$175cdd8bc7e4b125;
module.exports["CODE_BLOCK"] = $33ae6aa27da00e18$export$cf55d1bff75690da;
module.exports["PANEL"] = $33ae6aa27da00e18$export$867b449446b85962;
module.exports["OTHER"] = $33ae6aa27da00e18$export$d46a05f8561f868a;
module.exports["TEXT_BLOCK_TYPES"] = $33ae6aa27da00e18$export$2ec1d6c4f06d927;
module.exports["toolbarBlockTypesWithRank"] = $33ae6aa27da00e18$export$eb0a3dded5e1d29b;
module.exports["FORMATTING_NODE_TYPES"] = $33ae6aa27da00e18$export$a5cb0c20bd02ce0c;
module.exports["FORMATTING_MARK_TYPES"] = $33ae6aa27da00e18$export$73b50f8f13648c71;
module.exports["WRAPPER_BLOCK_TYPES"] = $33ae6aa27da00e18$export$c6516682f7569488;
module.exports["getBlockTypesInDropdown"] = $33ae6aa27da00e18$export$a1bb601016dd2309;
module.exports["HEADINGS_BY_LEVEL"] = $33ae6aa27da00e18$export$110c9c3e05131569;
module.exports["HEADINGS_BY_NAME"] = $33ae6aa27da00e18$export$33dfdcd30c23ea87;

});

parcelRegister("4Chin", function(module, exports) {

var $cPCP8 = parcelRequire("cPCP8");

const $3644de2080d00fe8$export$bc7b81cc80d86c30 = {
    [(0, $cPCP8.AI_SECTION).key]: 100,
    [(0, $cPCP8.AI_VIEW_SECTION).key]: 100,
    [(0, $cPCP8.TEXT_SECTION).key]: 200,
    /* Same rank as TEXT_SECTION as only one is ever shown at a time */ [(0, $cPCP8.TEXT_SECTION_COLLAPSED).key]: 200,
    [(0, $cPCP8.INSERT_BLOCK_SECTION).key]: 300,
    [(0, $cPCP8.LINKING_SECTION).key]: 400,
    [(0, $cPCP8.COLLAB_SECTION).key]: 500,
    [(0, $cPCP8.APPS_SECTION).key]: 600,
    [(0, $cPCP8.TRACK_CHANGES_SECTION).key]: 700,
    [(0, $cPCP8.OVERFLOW_SECTION).key]: 800,
    [(0, $cPCP8.PIN_SECTION).key]: 900,
    /* Sits between PIN (900) and OVERFLOW_SECTION_PRIMARY_TOOLBAR (1000)
	 * so the markdown view-mode toggle renders to the right of all formatting
	 * controls but still to the left of the overflow `…` menu. */ [(0, $cPCP8.VIEW_MODE_TOGGLE_SECTION).key]: 950,
    [(0, $cPCP8.OVERFLOW_SECTION_PRIMARY_TOOLBAR).key]: 1000
};
const $3644de2080d00fe8$export$466bb91cec477703 = {
    [(0, $cPCP8.ROVO_GROUP).key]: 100,
    [(0, $cPCP8.ROVO_GROUP_DISPLAY_SMALL).key]: 100,
    [(0, $cPCP8.ROVO_GROUP_PRIMARY_TOOLBAR).key]: 100,
    [(0, $cPCP8.DEFINE_GROUP).key]: 200,
    [(0, $cPCP8.IMPROVE_WRITING_GROUP).key]: 300,
    [(0, $cPCP8.AI_SUGGESTIONS_GROUP).key]: 400,
    [(0, $cPCP8.HERO_PROMPT_BUTTON_GROUP).key]: 500
};
const $3644de2080d00fe8$export$7f767b9830d79831 = {
    [(0, $cPCP8.AI_SUGGESTIONS_BUTTON).key]: 100
};
const $3644de2080d00fe8$export$ff4863cfaec82192 = {
    [(0, $cPCP8.ROVO_HERO_BUTTON).key]: 100,
    [(0, $cPCP8.ROVO_WRITE_BUTTON_PRIMARY_TOOLBAR).key]: 100,
    [(0, $cPCP8.ROVO_MENU).key]: 200
};
const $3644de2080d00fe8$export$bc7ded9825806f2 = {
    [(0, $cPCP8.ROVO_HERO_BUTTON).key]: 100,
    [(0, $cPCP8.ROVO_MENU_DISPLAY_SMALL).key]: 200,
    [(0, $cPCP8.HERO_PROMPT_BUTTON).key]: 300,
    [(0, $cPCP8.AI_SUGGESTIONS_BUTTON).key]: 400
};
const $3644de2080d00fe8$export$322be3308b7fba35 = {
    [(0, $cPCP8.DEFINE_BUTTON).key]: 100
};
const $3644de2080d00fe8$export$6f336126efb2136d = {
    [(0, $cPCP8.IMPROVE_WRITING_BUTTON).key]: 100
};
const $3644de2080d00fe8$export$5eed3dfe1bf849e5 = {
    [(0, $cPCP8.HERO_PROMPT_BUTTON).key]: 100
};
const $3644de2080d00fe8$export$dd95f65f4139e5c7 = {
    [(0, $cPCP8.ROVO_PROMPT_MENU_SECTION_DISPLAY_SMALL).key]: 100,
    [(0, $cPCP8.ROVO_PROMPT_MENU_SECTION).key]: 100
};
const $3644de2080d00fe8$export$bfac571871e409b2 = {
    [(0, $cPCP8.IMPROVE_WRITING_MENU_ITEM).key]: 100,
    [(0, $cPCP8.HERO_PROMPT_MENU_ITEM).key]: 100,
    [(0, $cPCP8.ADD_POLISH_MENU_ITEM).key]: 100,
    [(0, $cPCP8.SPELLING_AND_GRAMMAR_MENU_ITEM).key]: 300,
    [(0, $cPCP8.CHANGE_TONE_NESTED_MENU).key]: 400,
    [(0, $cPCP8.MAKE_SHORTER_MENU_ITEM).key]: 500,
    [(0, $cPCP8.MAKE_LONGER_MENU_ITEM).key]: 600,
    [(0, $cPCP8.TRANSLATE_NESTED_MENU).key]: 700,
    [(0, $cPCP8.DEFINE_MENU_ITEM).key]: 800
};
const $3644de2080d00fe8$export$e63f50c00e536f07 = {
    [(0, $cPCP8.CHANGE_TONE_MENU_SECTION).key]: 100
};
const $3644de2080d00fe8$export$b55028e61899c679 = {
    [(0, $cPCP8.MORE_PROFESSIONAL_MENU_ITEM).key]: 100,
    [(0, $cPCP8.MORE_CASUAL_MENU_ITEM).key]: 200,
    [(0, $cPCP8.MORE_EMPATHETIC_MENU_ITEM).key]: 300
};
const $3644de2080d00fe8$export$6f11aef2061f527c = {
    [(0, $cPCP8.TRANSLATE_MENU_SECTION).key]: 100
};
const $3644de2080d00fe8$export$6784d5340d4a1b21 = {
    [(0, $cPCP8.TEXT_STYLES_GROUP).key]: 100,
    [(0, $cPCP8.TEXT_FORMATTING_GROUP).key]: 200,
    [(0, $cPCP8.LISTS_INDENTATION_GROUP).key]: 300,
    [(0, $cPCP8.ALIGNMENT_GROUP).key]: 400,
    [(0, $cPCP8.TEXT_COLOR_HIGHLIGHT_GROUP).key]: 500
};
const $3644de2080d00fe8$export$a3445a42840bc6d9 = {
    [(0, $cPCP8.TEXT_STYLES_GROUP).key]: 100,
    [(0, $cPCP8.BOLD_BUTTON_GROUP).key]: 200,
    [(0, $cPCP8.UNDERLINE_BUTTON_GROUP).key]: 300,
    [(0, $cPCP8.TEXT_FORMATTING_GROUP).key]: 400,
    [(0, $cPCP8.BULLETED_LIST_BUTTON_GROUP).key]: 500,
    [(0, $cPCP8.LISTS_INDENTATION_GROUP).key]: 600,
    [(0, $cPCP8.ALIGNMENT_GROUP).key]: 700,
    [(0, $cPCP8.TEXT_COLOR_HIGHLIGHT_GROUP).key]: 800
};
const $3644de2080d00fe8$export$b3332537c956e2f5 = {
    [(0, $cPCP8.TEXT_COLLAPSED_GROUP).key]: 100
};
const $3644de2080d00fe8$export$d0c8ffa085b6d177 = {
    [(0, $cPCP8.TEXT_COLLAPSED_MENU).key]: 100
};
const $3644de2080d00fe8$export$d5a685ed621e9024 = {
    [(0, $cPCP8.TEXT_STYLES_MENU_SECTION).key]: 100,
    [(0, $cPCP8.TEXT_FORMATTING_MENU_SECTION).key]: 200,
    [(0, $cPCP8.CLEAR_FORMARTTING_MENU_SECTION).key]: 300,
    [(0, $cPCP8.LISTS_INDENTATION_MENU_SECTION).key]: 400,
    [(0, $cPCP8.ALIGNMENT_MENU_SECTION).key]: 500,
    [(0, $cPCP8.TEXT_COLOR_HIGHLIGHT_MENU_SECTION).key]: 600
};
const $3644de2080d00fe8$export$26a9865aa120e992 = {
    [(0, $cPCP8.TEXT_STYLES_MENU).key]: 100
};
const $3644de2080d00fe8$export$51921362eebd85ab = {
    [(0, $cPCP8.TEXT_STYLES_MENU_SECTION).key]: 100
};
const $3644de2080d00fe8$export$6449a65588a19d38 = {
    [(0, $cPCP8.NORMAL_TEXT_MENU_ITEM).key]: 100,
    [(0, $cPCP8.SMALL_TEXT_MENU_ITEM).key]: 150,
    [(0, $cPCP8.HEADING_1_MENU_ITEM).key]: 200,
    [(0, $cPCP8.HEADING_2_MENU_ITEM).key]: 300,
    [(0, $cPCP8.HEADING_3_MENU_ITEM).key]: 400,
    [(0, $cPCP8.HEADING_4_MENU_ITEM).key]: 500,
    [(0, $cPCP8.HEADING_5_MENU_ITEM).key]: 600,
    [(0, $cPCP8.HEADING_6_MENU_ITEM).key]: 700,
    [(0, $cPCP8.BLOCK_QUOTE_MENU_ITEM).key]: 800
};
const $3644de2080d00fe8$export$9cdaceac32c6b4d8 = {
    [(0, $cPCP8.TEXT_FORMATTING_HERO_BUTTON).key]: 100,
    [(0, $cPCP8.TEXT_FORMATTING_MENU).key]: 200
};
const $3644de2080d00fe8$export$6d00774ee584bc52 = {
    [(0, $cPCP8.TEXT_FORMATTING_HERO_BUTTON_COLLAPSED).key]: 100,
    [(0, $cPCP8.TEXT_FORMATTING_MENU).key]: 200
};
const $3644de2080d00fe8$export$669a394c241c9256 = {
    [(0, $cPCP8.TEXT_FORMATTING_MENU_SECTION).key]: 100,
    [(0, $cPCP8.CLEAR_FORMARTTING_MENU_SECTION).key]: 200
};
const $3644de2080d00fe8$export$20900530b02fcff9 = {
    [(0, $cPCP8.BOLD_MENU_ITEM).key]: 100,
    [(0, $cPCP8.ITALIC_MENU_ITEM).key]: 200,
    [(0, $cPCP8.UNDERLINE_MENU_ITEM).key]: 300,
    [(0, $cPCP8.STRIKE_MENU_ITEM).key]: 400,
    [(0, $cPCP8.CODE_MENU_ITEM).key]: 500,
    [(0, $cPCP8.SUBSCRIPT_MENU_ITEM).key]: 600,
    [(0, $cPCP8.SUPERSCRIPT_MENU_ITEM).key]: 700
};
const $3644de2080d00fe8$export$b62a699881de3ad5 = {
    [(0, $cPCP8.CLEAR_FORMATTING_MENU_ITEM).key]: 100
};
const $3644de2080d00fe8$export$f2dba222dee1738d = {
    [(0, $cPCP8.SYNCED_BLOCK_BUTTON).key]: 100
};
const $3644de2080d00fe8$export$bbc17a51edaecf5e = {
    [(0, $cPCP8.BULLETED_LIST_BUTTON).key]: 100,
    [(0, $cPCP8.LISTS_INDENTATION_HERO_BUTTON).key]: 200,
    [(0, $cPCP8.LISTS_INDENTATION_MENU).key]: 300
};
const $3644de2080d00fe8$export$c57e1bc67b28ed16 = {
    [(0, $cPCP8.LISTS_INDENTATION_HERO_BUTTON_COLLAPSED).key]: 100,
    [(0, $cPCP8.LISTS_INDENTATION_MENU).key]: 200
};
const $3644de2080d00fe8$export$29d19572f6bf97d3 = {
    [(0, $cPCP8.LISTS_INDENTATION_MENU_SECTION).key]: 100
};
const $3644de2080d00fe8$export$70af84b45a4dbc54 = {
    [(0, $cPCP8.BULLETED_LIST_MENU_ITEM).key]: 100,
    [(0, $cPCP8.NUMBERED_LIST_MENU_ITEM).key]: 200,
    [(0, $cPCP8.TASK_LIST_MENU_ITEM).key]: 300,
    [(0, $cPCP8.OUTDENT_MENU_ITEM).key]: 400,
    [(0, $cPCP8.INDENT_MENU_ITEM).key]: 500
};
const $3644de2080d00fe8$export$f2b3800989381ab8 = {
    [(0, $cPCP8.ALIGNMENT_MENU).key]: 100
};
const $3644de2080d00fe8$export$50e3ab1607836660 = {
    [(0, $cPCP8.ALIGNMENT_MENU_SECTION).key]: 100
};
const $3644de2080d00fe8$export$fe18fd9800ea0b78 = {
    [(0, $cPCP8.ALIGN_LEFT_MENU_ITEM).key]: 100,
    [(0, $cPCP8.ALIGN_CENTER_MENU_ITEM).key]: 200,
    [(0, $cPCP8.ALIGN_RIGHT_MENU_ITEM).key]: 300
};
const $3644de2080d00fe8$export$ae4377fbd160eba4 = {
    [(0, $cPCP8.TEXT_COLOR_HIGHLIGHT_MENU).key]: 100
};
const $3644de2080d00fe8$export$7aebf1f83f92aec4 = {
    [(0, $cPCP8.TEXT_COLOR_HIGHLIGHT_MENU_SECTION).key]: 100
};
const $3644de2080d00fe8$export$6d61bddc04226fae = {
    [(0, $cPCP8.TEXT_COLOR_MENU_ITEM).key]: 100,
    [(0, $cPCP8.HIGHLIGHT_MENU_ITEM).key]: 200,
    [(0, $cPCP8.CLEAR_COLOR_MENU_ITEM).key]: 300
};
const $3644de2080d00fe8$export$d501e2da4fccd3d9 = {
    [(0, $cPCP8.TASK_LIST_GROUP).key]: 100,
    [(0, $cPCP8.MEDIA_GROUP).key]: 200,
    [(0, $cPCP8.CODE_BLOCK_GROUP).key]: 300,
    [(0, $cPCP8.MENTION_GROUP).key]: 400,
    [(0, $cPCP8.EMOJI_GROUP).key]: 500,
    [(0, $cPCP8.LAYOUT_GROUP).key]: 600,
    [(0, $cPCP8.SYNCED_BLOCK_GROUP).key]: 700,
    [(0, $cPCP8.TABLE_GROUP).key]: 800,
    [(0, $cPCP8.INSERT_GROUP).key]: 900
};
const $3644de2080d00fe8$export$ca5c9182c556b0ba = {
    [(0, $cPCP8.TASK_LIST_BUTTON).key]: 100
};
const $3644de2080d00fe8$export$41b6a2bde3ffc16c = {
    [(0, $cPCP8.MEDIA_BUTTON).key]: 100
};
const $3644de2080d00fe8$export$2e369b4fbf595d64 = {
    [(0, $cPCP8.CODE_BLOCK_BUTTON).key]: 100
};
const $3644de2080d00fe8$export$9834991fe1fe77a = {
    [(0, $cPCP8.MENTION_BUTTON).key]: 100
};
const $3644de2080d00fe8$export$5e431f0b402bc573 = {
    [(0, $cPCP8.EMOJI_BUTTON).key]: 100
};
const $3644de2080d00fe8$export$18725f40b7ed45c9 = {
    [(0, $cPCP8.LAYOUT_BUTTON).key]: 100
};
const $3644de2080d00fe8$export$3b68d352d79ba4dc = {
    [(0, $cPCP8.TABLE_BUTTON).key]: 100,
    [(0, $cPCP8.TABLE_SIZE_PICKER).key]: 200
};
const $3644de2080d00fe8$export$6b93bebdb0c4f64b = {
    [(0, $cPCP8.INSERT_BUTTON).key]: 100
};
const $3644de2080d00fe8$export$c7c28a2a4f553552 = {
    [(0, $cPCP8.LINKING_GROUP).key]: 100
};
const $3644de2080d00fe8$export$400d2c257bc9421e = {
    [(0, $cPCP8.LINKING_BUTTON).key]: 100
};
const $3644de2080d00fe8$export$efde8251fb2b89d5 = {
    [(0, $cPCP8.COMMENT_GROUP).key]: 100
};
const $3644de2080d00fe8$export$4f59ebca6ea8293b = {
    [(0, $cPCP8.COMMENT_HERO_BUTTON).key]: 100
};
const $3644de2080d00fe8$export$6795fbb63d664162 = {
    [(0, $cPCP8.UNDO_CHANGES_GROUP).key]: 100,
    [(0, $cPCP8.REDO_CHANGES_GROUP).key]: 200,
    [(0, $cPCP8.TRACK_CHANGES_GROUP).key]: 300
};
const $3644de2080d00fe8$export$8b9f9ebddc5f6d72 = {
    [(0, $cPCP8.UNDO_BUTTON).key]: 100
};
const $3644de2080d00fe8$export$faf3ae5c01b97598 = {
    [(0, $cPCP8.REDO_BUTTON).key]: 100
};
const $3644de2080d00fe8$export$e9551bb6af82297a = {
    [(0, $cPCP8.TRACK_CHANGES_BUTTON).key]: 100
};
const $3644de2080d00fe8$export$d63a7078a6c0dc57 = {
    [(0, $cPCP8.OVERFLOW_GROUP).key]: 100
};
const $3644de2080d00fe8$export$7aecad5ed6bcab55 = {
    [(0, $cPCP8.OVERFLOW_MENU).key]: 100
};
const $3644de2080d00fe8$export$ea9c3eff8619984 = {
    [(0, $cPCP8.PIN_MENU_SECTION).key]: 100,
    [(0, $cPCP8.LOOM_MENU_SECTION).key]: 200,
    [(0, $cPCP8.OVERFLOW_EXTENSIONS_MENU_SECTION).key]: 300,
    [(0, $cPCP8.SELECTION_EXTENSION_MENU_SECTION).key]: 300,
    [(0, $cPCP8.SYNCED_BLOCK_SECTION).key]: 400
};
const $3644de2080d00fe8$export$510811eb0f5e0b21 = {
    [(0, $cPCP8.PIN_MENU_ITEM).key]: 100
};
const $3644de2080d00fe8$export$6184a38ba6130c9c = {
    [(0, $cPCP8.LOOM_MENU_ITEM).key]: 100,
    [(0, $cPCP8.FIRST_PARTY_EXTENSIONS_MENU_ITEM).key]: 200,
    [(0, $cPCP8.EXTERNAL_EXTENSIONS_MENU_ITEM).key]: 300
};
const $3644de2080d00fe8$export$3bdd20aa1e9eee2 = {
    [(0, $cPCP8.OVERFLOW_GROUP_PRIMARY_TOOLBAR).key]: 100
};
const $3644de2080d00fe8$export$dc811b512e84a8a4 = {
    [(0, $cPCP8.OVERFLOW_MENU_PRIMARY_TOOLBAR).key]: 100
};
const $3644de2080d00fe8$export$9cc8eee968218e62 = {
    [(0, $cPCP8.LOOM_MENU_SECTION).key]: 100
};
const $3644de2080d00fe8$export$58a4b339bb5abbc1 = {
    [(0, $cPCP8.PIN_GROUP).key]: 100
};
const $3644de2080d00fe8$export$cb4d99d2936acb14 = {
    [(0, $cPCP8.PIN_BUTTON).key]: 100
};
const $3644de2080d00fe8$export$d27db3643df90b4d = {
    [(0, $cPCP8.LOOM_MENU_ITEM).key]: 100
};
const $3644de2080d00fe8$export$a766c0ef72fbd3e1 = {
    [(0, $cPCP8.AI_PASTE_MENU_SECTION).key]: 50,
    [(0, $cPCP8.PASTE_MENU_SECTION).key]: 100
};
const $3644de2080d00fe8$export$1e88c7dcdd9c7430 = {
    [(0, $cPCP8.PASTE_NESTED_MENU).key]: 100
};
const $3644de2080d00fe8$export$c200baaef3fcc623 = {
    [(0, $cPCP8.PASTE_MENU_NESTED_SECTION).key]: 100
};
const $3644de2080d00fe8$export$8afb46bea363e001 = {
    [(0, $cPCP8.PASTE_RICH_TEXT_MENU_ITEM).key]: 100,
    [(0, $cPCP8.PASTE_MARKDOWN_MENU_ITEM).key]: 200,
    [(0, $cPCP8.PASTE_PLAIN_TEXT_MENU_ITEM).key]: 300
};
module.exports["TOOLBAR_RANK"] = $3644de2080d00fe8$export$bc7b81cc80d86c30;
module.exports["AI_SECTION_RANK"] = $3644de2080d00fe8$export$466bb91cec477703;
module.exports["AI_SUGGESTIONS_GROUP_RANK"] = $3644de2080d00fe8$export$7f767b9830d79831;
module.exports["ROVO_GROUP_RANK"] = $3644de2080d00fe8$export$ff4863cfaec82192;
module.exports["ROVO_GROUP_DISPLAY_SMALL_RANK"] = $3644de2080d00fe8$export$bc7ded9825806f2;
module.exports["DEFINE_GROUP_RANK"] = $3644de2080d00fe8$export$322be3308b7fba35;
module.exports["IMPROVE_WRITING_GROUP_RANK"] = $3644de2080d00fe8$export$6f336126efb2136d;
module.exports["HERO_PROMPT_BUTTON_GROUP_RANK"] = $3644de2080d00fe8$export$5eed3dfe1bf849e5;
module.exports["ROVO_MENU_RANK"] = $3644de2080d00fe8$export$dd95f65f4139e5c7;
module.exports["ROVO_PROMPT_MENU_SECTION_RANK"] = $3644de2080d00fe8$export$bfac571871e409b2;
module.exports["CHANGE_TONE_MENU_RANK"] = $3644de2080d00fe8$export$e63f50c00e536f07;
module.exports["CHANGE_TONE_MENU_SECTION_RANK"] = $3644de2080d00fe8$export$b55028e61899c679;
module.exports["TRANSLATE_MENU_RANK"] = $3644de2080d00fe8$export$6f11aef2061f527c;
module.exports["TEXT_SECTION_RANK"] = $3644de2080d00fe8$export$6784d5340d4a1b21;
module.exports["TEXT_SECTION_PRIMARY_TOOLBAR_RANK"] = $3644de2080d00fe8$export$a3445a42840bc6d9;
module.exports["TEXT_COLLAPSED_MENU_RANK"] = $3644de2080d00fe8$export$d5a685ed621e9024;
module.exports["TEXT_STYLES_GROUP_RANK"] = $3644de2080d00fe8$export$26a9865aa120e992;
module.exports["TEXT_STYLES_MENU_RANK"] = $3644de2080d00fe8$export$51921362eebd85ab;
module.exports["TEXT_STYLES_MENU_SECTION_RANK"] = $3644de2080d00fe8$export$6449a65588a19d38;
module.exports["TEXT_FORMAT_GROUP_RANK"] = $3644de2080d00fe8$export$9cdaceac32c6b4d8;
module.exports["TEXT_FORMAT_GROUP_COLLAPSED_RANK"] = $3644de2080d00fe8$export$6d00774ee584bc52;
module.exports["TEXT_FORMAT_MENU_RANK"] = $3644de2080d00fe8$export$669a394c241c9256;
module.exports["TEXT_FORMATTING_MENU_SECTION_RANK"] = $3644de2080d00fe8$export$20900530b02fcff9;
module.exports["CLEAR_FORMARTTING_MENU_SECTION_RANK"] = $3644de2080d00fe8$export$b62a699881de3ad5;
module.exports["SYNCED_BLOCK_SECTION_RANK"] = $3644de2080d00fe8$export$f2dba222dee1738d;
module.exports["LISTS_INDENTATION_GROUP_RANK"] = $3644de2080d00fe8$export$bbc17a51edaecf5e;
module.exports["LISTS_INDENTATION_GROUP_COLLAPSED_RANK"] = $3644de2080d00fe8$export$c57e1bc67b28ed16;
module.exports["LISTS_INDENTATION_MENU_RANK"] = $3644de2080d00fe8$export$29d19572f6bf97d3;
module.exports["LISTS_INDENTATION_MENU_SECTION_RANK"] = $3644de2080d00fe8$export$70af84b45a4dbc54;
module.exports["ALIGNMENT_GROUP_RANK"] = $3644de2080d00fe8$export$f2b3800989381ab8;
module.exports["ALIGNMENT_MENU_RANK"] = $3644de2080d00fe8$export$50e3ab1607836660;
module.exports["ALIGNMENT_MENU_SECTION_RANK"] = $3644de2080d00fe8$export$fe18fd9800ea0b78;
module.exports["TEXT_COLOR_HIGHLIGHT_GROUP_RANK"] = $3644de2080d00fe8$export$ae4377fbd160eba4;
module.exports["TEXT_COLOR_HIGHLIGHT_MENU_RANK"] = $3644de2080d00fe8$export$7aebf1f83f92aec4;
module.exports["TEXT_COLOR_HIGHLIGHT_MENU_SECTION_RANK"] = $3644de2080d00fe8$export$6d61bddc04226fae;
module.exports["INSERT_BLOCK_SECTION_RANK"] = $3644de2080d00fe8$export$d501e2da4fccd3d9;
module.exports["TASK_LIST_GROUP_RANK"] = $3644de2080d00fe8$export$ca5c9182c556b0ba;
module.exports["MEDIA_GROUP_RANK"] = $3644de2080d00fe8$export$41b6a2bde3ffc16c;
module.exports["CODE_BLOCK_GROUP_RANK"] = $3644de2080d00fe8$export$2e369b4fbf595d64;
module.exports["MENTION_GROUP_RANK"] = $3644de2080d00fe8$export$9834991fe1fe77a;
module.exports["EMOJI_GROUP_RANK"] = $3644de2080d00fe8$export$5e431f0b402bc573;
module.exports["LAYOUT_GROUP_RANK"] = $3644de2080d00fe8$export$18725f40b7ed45c9;
module.exports["TABLE_GROUP_RANK"] = $3644de2080d00fe8$export$3b68d352d79ba4dc;
module.exports["INSERT_GROUP_RANK"] = $3644de2080d00fe8$export$6b93bebdb0c4f64b;
module.exports["LINKING_SECTION_RANK"] = $3644de2080d00fe8$export$c7c28a2a4f553552;
module.exports["LINKING_GROUP_RANK"] = $3644de2080d00fe8$export$400d2c257bc9421e;
module.exports["COLLAB_SECTION_RANK"] = $3644de2080d00fe8$export$efde8251fb2b89d5;
module.exports["TRACK_CHANGES_SECTION_RANK"] = $3644de2080d00fe8$export$6795fbb63d664162;
module.exports["UNDO_CHANGES_GROUP_RANK"] = $3644de2080d00fe8$export$8b9f9ebddc5f6d72;
module.exports["REDO_CHANGES_GROUP_RANK"] = $3644de2080d00fe8$export$faf3ae5c01b97598;
module.exports["TRACK_CHANGES_GROUP_RANK"] = $3644de2080d00fe8$export$e9551bb6af82297a;
module.exports["OVERFLOW_SECTION_RANK"] = $3644de2080d00fe8$export$d63a7078a6c0dc57;
module.exports["OVERFLOW_GROUP_RANK"] = $3644de2080d00fe8$export$7aecad5ed6bcab55;
module.exports["OVERFLOW_MENU_RANK"] = $3644de2080d00fe8$export$ea9c3eff8619984;
module.exports["PIN_MENU_SECTION_RANK"] = $3644de2080d00fe8$export$510811eb0f5e0b21;
module.exports["OVERFLOW_EXTENSIONS_MENU_SECTION_RANK"] = $3644de2080d00fe8$export$6184a38ba6130c9c;
module.exports["OVERFLOW_SECTION_PRIMARY_TOOLBAR_RANK"] = $3644de2080d00fe8$export$3bdd20aa1e9eee2;
module.exports["OVERFLOW_GROUP_PRIMARY_TOOLBAR_RANK"] = $3644de2080d00fe8$export$dc811b512e84a8a4;
module.exports["OVERFLOW_MENU_PRIMARY_TOOLBAR_RANK"] = $3644de2080d00fe8$export$9cc8eee968218e62;
module.exports["PIN_SECTION_RANK"] = $3644de2080d00fe8$export$58a4b339bb5abbc1;
module.exports["PIN_GROUP_RANK"] = $3644de2080d00fe8$export$cb4d99d2936acb14;
module.exports["LOOM_MENU_SECTION_RANK"] = $3644de2080d00fe8$export$d27db3643df90b4d;
module.exports["PASTE_MENU_RANK"] = $3644de2080d00fe8$export$a766c0ef72fbd3e1;
module.exports["PASTE_MENU_SECTION_RANK"] = $3644de2080d00fe8$export$1e88c7dcdd9c7430;
module.exports["PASTE_NESTED_MENU_RANK"] = $3644de2080d00fe8$export$c200baaef3fcc623;
module.exports["PASTE_MENU_NESTED_SECTION_RANK"] = $3644de2080d00fe8$export$8afb46bea363e001;

});

parcelRegister("2aKPB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5a6d0daa86571e434771830ab21d189b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1950d7acc61f9487$var$_react = $1950d7acc61f9487$var$_interopRequireDefault((parcelRequire("42omo")));

var $1950d7acc61f9487$var$_baseNew = $1950d7acc61f9487$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $1950d7acc61f9487$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextNormal".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing Paragraph text style / Normal text style.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1950d7acc61f9487$var$TextNormalIcon = (props)=>/*#__PURE__*/ $1950d7acc61f9487$var$_react.default.createElement($1950d7acc61f9487$var$_baseNew.default, Object.assign({
        name: "TextNormalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 1v1.5H8.751V15h-1.5V2.5H2.5V1z"/>`
    }, props));
$1950d7acc61f9487$var$TextNormalIcon.displayName = 'TextNormalIcon';
var $1950d7acc61f9487$var$_default = module.exports.default = $1950d7acc61f9487$var$TextNormalIcon;

});

parcelRegister("aIMBk", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");


var $ke2AI = parcelRequire("ke2AI");

/**
 * This file is to duplicate types that exist in editor-common
 * so that input-rules does not depend on it.
 *
 * This simplifies our dependencies and makes adoption much easier.
 */ const $853f2fbd9cc723ad$export$b0e17cd4423f50ca = (selection)=>{
    // @ts-expect-error
    return Boolean(selection.jsonID === 'gapcursor');
};






var $1oCLl = parcelRequire("1oCLl");


var $14sLv = parcelRequire("14sLv");








const $c28f09d51288f77c$export$9bcba4b183c6bb83 = ({ rules: rules, pluginKey: pluginKey, allowInsertTextOnDocument: allowInsertTextOnDocument, onInputEvent: onInputEvent, onBeforeRegexMatch: onBeforeRegexMatch })=>({ view: view, from: from, to: to, text: text })=>{
        if (view.composing) return false;
        const state = view.state;
        const $from = state.doc.resolve(from);
        if ($from.parent.type.spec.code) return false;
        if (onInputEvent && !onInputEvent({
            state: state,
            from: from,
            to: to
        })) return false;
        const textBefore = $from.parent.textBetween(Math.max(0, $from.parentOffset - (0, $14sLv.MAX_REGEX_MATCH)), $from.parentOffset, undefined, (0, $14sLv.leafNodeReplacementCharacter)) + text;
        let result = $c28f09d51288f77c$var$findMatchOnRules({
            rules: rules,
            textToMatch: textBefore,
            from: from,
            to: to,
            state: state
        });
        let isBackwardMatch;
        if (!result && (0, $1oCLl.expValEquals)('platform_editor_lovability_inline_code', 'isEnabled', true)) {
            if ((0, $14sLv.TYPEAHEAD_TRIGGERS).includes(text)) return false;
            const textAfter = text + $from.parent.textBetween($from.parentOffset, Math.min($from.parent.content.size, $from.parentOffset + (0, $14sLv.MAX_REGEX_MATCH)), undefined, (0, $14sLv.leafNodeReplacementCharacter));
            isBackwardMatch = true;
            const backwardMatchRules = rules.filter((rule)=>rule.allowsBackwardMatch);
            result = $c28f09d51288f77c$var$findMatchOnRules({
                rules: backwardMatchRules,
                textToMatch: textAfter,
                from: from,
                to: to,
                state: state,
                isBackwardMatch: isBackwardMatch
            });
            if (!result) return false;
        }
        if (!result) return false;
        const tr = allowInsertTextOnDocument ? state.tr.insertText(text, from, to) : state.tr;
        tr.setMeta((0, $14sLv.TEXT_INPUT_RULE_TRANSACTION_KEY), true);
        tr.setMeta(pluginKey, {
            textInserted: text,
            from: result.from,
            to: result.to,
            matchedRule: result.matchedRule,
            isBackwardMatch: isBackwardMatch
        });
        if (onBeforeRegexMatch) onBeforeRegexMatch(tr);
        view.dispatch(tr);
        return true;
    };
function $c28f09d51288f77c$var$findMatchOnRules({ rules: rules, textToMatch: textToMatch, from: from, to: to, state: state, isBackwardMatch: isBackwardMatch }) {
    for(let i = 0; i < rules.length; i++){
        const rule = rules[i];
        // Some plugins like Typeahead require a whitespace before a trigger character.
        // We want them to fire inside a gap cursor. Yet, a gap cursor is not considered a whitespace,
        // and `textToMatch` contains the text in the previous block before the gap cursor.
        // Here is a workaround: if we inside a gap cursor, match the input rule only against the last typed character
        // (which may be a typeahead trigger) and ignore the rest.
        const matchString = (0, $853f2fbd9cc723ad$export$b0e17cd4423f50ca)(state.selection) ? textToMatch.at(-1) ?? '' : textToMatch;
        // if the user is formatting text to inline code from R to L i.e. backwards
        if (rule.allowsBackwardMatch && isBackwardMatch && (0, $1oCLl.expValEquals)('platform_editor_lovability_inline_code', 'isEnabled', true)) {
            // if the match has a parenthesis before it, but no whitespace or empty space before that, exit
            const charBefore = state.doc.textBetween(from - 1, from);
            if (charBefore === '(') {
                const charBeforeParenthesis = state.doc.textBetween(from - 2, from - 1);
                if (charBeforeParenthesis !== ' ' && charBeforeParenthesis !== '') continue;
            } else if (charBefore !== ' ' && charBefore !== '') continue;
            const match = rule.match.exec(matchString);
            if (!match) continue;
            const matchEndPos = from + match[0].length - 1;
            const transform = rule.handler(state, match, from, matchEndPos);
            if (transform) return {
                from: from,
                to: matchEndPos,
                matchedRule: {
                    ...rule,
                    result: match
                }
            };
            return null;
        }
        const match = rule.match.exec(matchString);
        if (!match) continue;
        const parentNodeStartAt = state.selection.$from.start();
        const offset = Math.max(0, state.selection.$from.parentOffset - (0, $14sLv.MAX_REGEX_MATCH));
        const fromFixed = Math.max(parentNodeStartAt + match.index + offset, 1);
        const transform = rule.handler(state, match, fromFixed, to);
        if (transform) return {
            from: fromFixed,
            to: to,
            matchedRule: {
                ...rule,
                result: match
            }
        };
    }
    return null;
}


function $43f8c56d9c032612$export$dc83f374e2af640d(pluginName, rules, options = {}) {
    const onInputEvent = options?.onInputEvent;
    const onBeforeRegexMatch = options?.onBeforeRegexMatch;
    const allowInsertTextOnDocument = Boolean(options?.allowInsertTextOnDocument);
    const pluginKey = new (0, $ks2lK.PluginKey)(`inputRulePlugin__${pluginName}`);
    const inputEvent = (0, $c28f09d51288f77c$export$9bcba4b183c6bb83)({
        allowInsertTextOnDocument: allowInsertTextOnDocument,
        pluginKey: pluginKey,
        rules: rules,
        onInputEvent: onInputEvent,
        onBeforeRegexMatch: onBeforeRegexMatch
    });
    return {
        key: pluginKey,
        state: {
            init () {
                return null;
            },
            apply (tr, prev) {
                const stored = tr.getMeta(pluginKey);
                if (stored) return stored;
                return tr.selectionSet || tr.docChanged ? null : prev;
            }
        },
        appendTransaction: (transactions, oldState, newState)=>{
            const transactionWithInputRuleMeta = transactions.find((tr)=>tr.getMeta(pluginKey));
            const pluginState = transactionWithInputRuleMeta?.getMeta(pluginKey);
            if (!pluginState || !transactionWithInputRuleMeta) return null;
            const { matchedRule: matchedRule, from: from, to: to, isBackwardMatch: isBackwardMatch } = pluginState;
            const { result: result } = matchedRule;
            const mappedTo = transactionWithInputRuleMeta.mapping.map(to);
            const tr = matchedRule.handler(newState, result, from, mappedTo);
            if (!tr) return null;
            tr.setMeta((0, $14sLv.TEXT_INPUT_RULE_TRANSACTION_KEY), true);
            if (matchedRule.onHandlerApply) matchedRule.onHandlerApply(newState, tr, matchedRule.result);
            // after inserting inline code, we need to reset the selection back
            // else, we set the selection at the end of the inline code which doesn't make sense if we are closing the inline code from R to L
            if (isBackwardMatch && (0, $1oCLl.expValEquals)('platform_editor_lovability_inline_code', 'isEnabled', true)) {
                const prevSelection = oldState.selection.map(tr.doc, tr.mapping);
                tr.setSelection(new (0, $ks2lK.TextSelection)(prevSelection.$from));
            }
            return tr;
        },
        props: {
            handleTextInput (view, from, to, text) {
                return inputEvent({
                    view: view,
                    from: from,
                    to: to,
                    text: text
                });
            },
            handleDOMEvents: {
                blur: (view)=>{
                    if (!options?.checkOnBlur) return false;
                    const selection = view.state.selection;
                    if (!(selection instanceof (0, $ks2lK.TextSelection))) return;
                    const { $cursor: $cursor } = selection;
                    if ($cursor) inputEvent({
                        view: view,
                        from: $cursor.pos,
                        to: $cursor.pos,
                        text: options.appendTextOnBlur ?? ''
                    });
                    return false;
                },
                compositionend: (view)=>{
                    setTimeout(()=>{
                        const selection = view.state.selection;
                        if (!(selection instanceof (0, $ks2lK.TextSelection))) return;
                        const { $cursor: $cursor } = selection;
                        if ($cursor) inputEvent({
                            view: view,
                            from: $cursor.pos,
                            to: $cursor.pos,
                            text: ''
                        });
                    });
                    return false;
                }
            }
        },
        // @ts-ignore This is used by prosemirror-view to apply input rules on text input event.
        // However, there is no typing ffor this, yet.
        isInputRules: true
    };
}


const $1276f980a5aec3c8$var$hasUnsupportedMarks = (state, start, end, marksNameUnsupported)=>{
    const isUnsupportedMark = (node)=>(marksNameUnsupported || []).includes(node.type.name);
    const $from = state.doc.resolve(start);
    const $to = state.doc.resolve(end);
    const marksInSelection = start === end ? $from.marks() : $from.marksAcross($to);
    return (marksInSelection || []).some(isUnsupportedMark);
};
const $1276f980a5aec3c8$var$isCursorInsideUnsupportedMarks = (state, marksNameUnsupported)=>{
    const { selection: selection } = state;
    if (!(selection instanceof (0, $ks2lK.TextSelection))) return false;
    const { $cursor: $cursor } = selection;
    const isUnsupportedMark = (node)=>marksNameUnsupported.includes(node.type.name);
    return Boolean($cursor?.nodeBefore?.marks?.some(isUnsupportedMark));
};
const $1276f980a5aec3c8$export$ae829ec7b2625219 = (pluginName, rules, options = {})=>{
    const { isBlockNodeRule: isBlockNodeRule = false, allowInsertTextOnDocument: allowInsertTextOnDocument = true, checkOnBlur: checkOnBlur, appendTextOnBlur: appendTextOnBlur } = options;
    const onInputEvent = ({ state: state, from: from, to: to })=>{
        const unsupportedMarks = isBlockNodeRule ? [
            'code',
            'link',
            'typeAheadQuery'
        ] : [
            'code'
        ];
        const $from = state.selection.$from;
        const isInline = state.selection instanceof (0, $ks2lK.NodeSelection) && state.selection.node.type.isInline;
        if ($from.parent.type.spec.code || !(state.selection instanceof (0, $ks2lK.TextSelection)) && !(0, $853f2fbd9cc723ad$export$b0e17cd4423f50ca)(state.selection) && !isInline || $1276f980a5aec3c8$var$hasUnsupportedMarks(state, from, to, unsupportedMarks) || isBlockNodeRule && $1276f980a5aec3c8$var$isCursorInsideUnsupportedMarks(state, unsupportedMarks)) return false;
        return true;
    };
    return (0, $43f8c56d9c032612$export$dc83f374e2af640d)(pluginName, rules, {
        allowInsertTextOnDocument: allowInsertTextOnDocument,
        onInputEvent: onInputEvent,
        onBeforeRegexMatch: (tr)=>{
            (0, $ke2AI.closeHistory)(tr);
        },
        checkOnBlur: checkOnBlur,
        appendTextOnBlur: appendTextOnBlur
    });
};
module.exports["createPlugin"] = $1276f980a5aec3c8$export$ae829ec7b2625219;

});

parcelRegister("14sLv", function(module, exports) {
// ProseMirror uses the Unicode Character 'OBJECT REPLACEMENT CHARACTER' (U+FFFC) as text representation for
// leaf nodes, i.e. nodes that don't have any content or text property (e.g. hardBreak, emoji, mention, rule)
// It was introduced because of https://github.com/ProseMirror/prosemirror/issues/262
// This can be used in an input rule regex to be able to include or exclude such nodes.
const $a38d783b9682af5c$export$a96b909f1510512b = '\ufffc';
const $a38d783b9682af5c$export$e56dc8305776db1f = 'input_rule_plugin_transaction';
const $a38d783b9682af5c$export$af78bb669dec9658 = 500;
const $a38d783b9682af5c$export$3082ca29ad268435 = [
    ':',
    '/',
    '@'
];
module.exports["leafNodeReplacementCharacter"] = $a38d783b9682af5c$export$a96b909f1510512b;
module.exports["TEXT_INPUT_RULE_TRANSACTION_KEY"] = $a38d783b9682af5c$export$e56dc8305776db1f;
module.exports["MAX_REGEX_MATCH"] = $a38d783b9682af5c$export$af78bb669dec9658;
module.exports["TYPEAHEAD_TRIGGERS"] = $a38d783b9682af5c$export$3082ca29ad268435;

});

parcelRegister("8Bqaf", function(module, exports) {
const $4bc43b2819cd81af$export$fee081d0fba011ce = 'insertedTrailingParagraphToLastNode';
module.exports["INSERTED_TRAILING_PARAGRAPH_TO_LAST_NODE_META"] = $4bc43b2819cd81af$export$fee081d0fba011ce;

});

parcelRegister("cORDs", function(module, exports) {
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");

function $e4782e632d14db94$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e4782e632d14db94$export$7638a34f4ed2b514 = {
    name: "ewpfso",
    styles: "display:inline-flex;align-items:center;& > div{display:flex;}button:not(#local-media-upload-button){&:not([disabled])::after{border:none;}}"
};
const $e4782e632d14db94$export$5897f954e99cc6c0 = {
    name: "ioewc",
    styles: "display:inline-flex;align-items:center;& > div{display:flex;}button:not(#local-media-upload-button){&:not([disabled])::after{border:none;}}gap:var(--ds-space-050, 4px);div[role=group]{gap:var(--ds-space-050, 4px);}"
};
const $e4782e632d14db94$export$39b9f83b35c7456d = /*#__PURE__*/ (0, $9K4OG.css)({
    background: "var(--ds-border, #0B120E24)",
    width: '1px',
    height: '24px',
    display: 'inline-block',
    margin: `0 ${"var(--ds-space-100, 8px)"}`,
    userSelect: 'none'
});
const $e4782e632d14db94$export$c4d4f06a25de97f = {
    name: "1ty89h5",
    styles: "display:flex;align-items:center;> div, > span{display:flex;}> div > div{display:flex;}margin-left:0;min-width:auto;button{&:not([disabled])::after{border:none;}}"
};
const $e4782e632d14db94$export$147e2cce6f264c9b = {
    name: "wb8qky",
    styles: "display:flex;button{&:not([disabled])::after{border:none;}}"
};
const $e4782e632d14db94$export$f2c6a721c78d3c4a = {
    name: "4sd07o",
    styles: "display:flex;padding-right:var(--ds-space-025, 2px);button{&:not([disabled])::after{border:none;}}"
};
const $e4782e632d14db94$export$cd86615b96818354 = {
    name: "ox0lz7",
    styles: "&:not([disabled])::after{border:none;}"
};
module.exports["buttonGroupStyle"] = $e4782e632d14db94$export$5897f954e99cc6c0;
module.exports["separatorStyles"] = $e4782e632d14db94$export$39b9f83b35c7456d;
module.exports["wrapperStyle"] = $e4782e632d14db94$export$c4d4f06a25de97f;
module.exports["triggerWrapperStylesWithPadding"] = $e4782e632d14db94$export$f2c6a721c78d3c4a;
module.exports["disableBlueBorderStyles"] = $e4782e632d14db94$export$cd86615b96818354;

});

parcelRegister("h4TOP", function(module, exports) {
/* eslint-disable @repo/internal/react/no-class-components */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $aFUXX = parcelRequire("aFUXX");


var $d77M1 = parcelRequire("d77M1");

var $2SlZp = parcelRequire("2SlZp");

var $7rvPL = parcelRequire("7rvPL");


var $1oCLl = parcelRequire("1oCLl");


var $iu6m9 = parcelRequire("iu6m9");


var $3gadb = parcelRequire("3gadb");


var $lwMQJ = parcelRequire("lwMQJ");


var $5Gwdo = parcelRequire("5Gwdo");


var $wJ8xb = parcelRequire("wJ8xb");

var $efG2U = parcelRequire("efG2U");


var $9CaSN = parcelRequire("9CaSN");


var $jwWgu = parcelRequire("jwWgu");


var $9Z3I5 = parcelRequire("9Z3I5");


var $5v8Ta = parcelRequire("5v8Ta");

function $ffa3fbf7d54ca98d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ffa3fbf7d54ca98d$var$wrapper = {
    name: "ul2689",
    styles: "& > div > div{display:flex;}"
};
const $ffa3fbf7d54ca98d$var$focusedMenuItemStyle = /*#__PURE__*/ (0, $9K4OG.css)({
    boxShadow: `inset 0px 0px 0px 2px ${"var(--ds-border-focused, #4688EC)"}`,
    outline: 'none'
});
const $ffa3fbf7d54ca98d$var$buttonStyles = (isActive, submenuActive)=>{
    if (isActive) {
        if ((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) /**
       * Hack for item to imitate old dropdown-menu selected styles
       */ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
        return /*#__PURE__*/ (0, $9K4OG.css)("position:relative;&::before{display:block;height:100%;width:2px;position:absolute;left:0;top:0;background:var(--ds-border-selected, #1868DB);content:'';}>span,>span:hover,>span:active{background:var(--ds-background-selected, #E9F2FE);color:var(--ds-text-selected, #1868DB);}:focus>span[aria-disabled='false']{", $ffa3fbf7d54ca98d$var$focusedMenuItemStyle, ";}:focus-visible,:focus-visible>span[aria-disabled='false']{outline:none;}");
        /**
     * Hack for item to imitate old dropdown-menu selected styles
     */ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
        return /*#__PURE__*/ (0, $9K4OG.css)(">span,>span:hover,>span:active{background:var(--ds-background-selected, #E9F2FE);color:var(--ds-text-selected, #1868DB);}:focus>span[aria-disabled='false']{", $ffa3fbf7d54ca98d$var$focusedMenuItemStyle, ";}:focus-visible,:focus-visible>span[aria-disabled='false']{outline:none;}");
    } else // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return /*#__PURE__*/ (0, $9K4OG.css)(">span:hover[aria-disabled='false']{color:var(--ds-text, #292A2E);background-color:var(--ds-background-neutral-subtle-hovered, #0515240F);}", !submenuActive && `
					> span:active[aria-disabled='false'] {
						background-color: ${"var(--ds-background-neutral-subtle-pressed, #0B120E24)"};
					}`, ">span[aria-disabled='true']{color:var(--ds-text-disabled, #080F214A);}:focus>span[aria-disabled='false']{", $ffa3fbf7d54ca98d$var$focusedMenuItemStyle, ";}:focus-visible,:focus-visible>span[aria-disabled='false']{outline:none;}"); // The default focus-visible style is removed to ensure consistency across browsers
};
const $ffa3fbf7d54ca98d$var$DropListWithOutsideClickTargetRef = (props)=>{
    const setOutsideClickTargetRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext((0, $wJ8xb.OutsideClickTargetRefContext));
    // eslint-disable-next-line react/jsx-props-no-spreading -- Spreading props to pass through dynamic component props
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $9CaSN.default), {
        onDroplistRef: setOutsideClickTargetRef,
        ...props
    });
};
const $ffa3fbf7d54ca98d$var$DropListWithOutsideListeners = (0, $efG2U.default)($ffa3fbf7d54ca98d$var$DropListWithOutsideClickTargetRef);
class $ffa3fbf7d54ca98d$export$2e2bcd8739ae039 extends (0, $42omo.PureComponent) {
    renderDropdownMenu() {
        const { target: target, popupPlacement: popupPlacement } = this.state;
        const { items: items, mountTo: mountTo, boundariesElement: boundariesElement, scrollableElement: scrollableElement, offset: offset, fitHeight: fitHeight, fitWidth: fitWidth, isOpen: isOpen, zIndex: zIndex, shouldUseDefaultRole: shouldUseDefaultRole, onItemActivated: onItemActivated, arrowKeyNavigationProviderOptions: arrowKeyNavigationProviderOptions, section: section, handleEscapeKeydown: handleEscapeKeydown } = this.props;
        // Note that this onSelection function can't be refactored to useMemo for
        // performance gains as it is being used as a dependency in a useEffect in
        // MenuArrowKeyNavigationProvider in order to check for re-renders to adjust
        // focus for accessibility. If this needs to be refactored in future refer
        // back to ED-16740 for context.
        const navigationProviderProps = arrowKeyNavigationProviderOptions.type === (0, $5v8Ta.ArrowKeyNavigationType).COLOR ? arrowKeyNavigationProviderOptions : {
            ...arrowKeyNavigationProviderOptions,
            onSelection: (index)=>{
                let result = [];
                if (typeof onItemActivated === 'function') {
                    result = items.reduce((result, group)=>{
                        return result.concat(group.items);
                    }, result);
                    onItemActivated({
                        item: result[index],
                        shouldCloseMenu: false
                    });
                }
            }
        };
        return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $jwWgu.default), {
            target: isOpen ? target : undefined,
            mountTo: mountTo,
            boundariesElement: boundariesElement,
            scrollableElement: scrollableElement,
            onPlacementChanged: this.updatePopupPlacement,
            fitHeight: fitHeight,
            fitWidth: fitWidth,
            zIndex: zIndex || (0, $aFUXX.akEditorFloatingPanelZIndex),
            offset: offset
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $9Z3I5.ArrowKeyNavigationProvider), {
            ...navigationProviderProps,
            handleClose: this.handleCloseAndFocus,
            closeOnTab: true
        }, /*#__PURE__*/ (0, $9K4OG.jsx)($ffa3fbf7d54ca98d$var$DropListWithOutsideListeners, {
            isOpen: true,
            position: popupPlacement.join(' '),
            shouldFitContainer: true,
            handleClickOutside: this.handleClose,
            handleEscapeKeydown: handleEscapeKeydown || this.handleCloseAndFocus,
            handleEnterKeydown: this.handleEnterKeydown,
            targetRef: this.state.target
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            style: {
                height: 0,
                minWidth: fitWidth || 0
            },
            "data-vc": "J9rO7kh2"
        }), /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            ref: this.popupRef
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $2SlZp.default), {
            role: shouldUseDefaultRole ? 'group' : 'menu'
        }, items.map((group, index)=>/*#__PURE__*/ (0, $9K4OG.jsx)((0, $7rvPL.default), {
                hasSeparator: section?.hasSeparator && index > 0,
                title: section?.title,
                // Ignored via go/ees005
                // eslint-disable-next-line react/no-array-index-key
                key: index
            }, group.items.map((item)=>/*#__PURE__*/ (0, $9K4OG.jsx)($ffa3fbf7d54ca98d$export$ed97964d1871885d, {
                    key: item.key ?? String(item.content),
                    item: item,
                    onItemActivated: this.props.onItemActivated,
                    shouldUseDefaultRole: this.props.shouldUseDefaultRole,
                    onMouseEnter: this.props.onMouseEnter,
                    onMouseLeave: this.props.onMouseLeave
                })))))))));
    }
    render() {
        const { children: children, isOpen: isOpen } = this.props;
        return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: $ffa3fbf7d54ca98d$var$wrapper
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            ref: this.handleRef
        }, children), isOpen ? this.renderDropdownMenu() : null);
    }
    componentDidUpdate(previousProps) {
        const { mountTo: mountTo, isOpen: isOpen } = this.props;
        const isOpenToggled = isOpen !== previousProps.isOpen;
        if (isOpen && isOpenToggled) {
            if (typeof this.props.shouldFocusFirstItem === 'function' && this.props.shouldFocusFirstItem()) {
                const keyboardEvent = new KeyboardEvent('keydown', {
                    key: 'ArrowDown',
                    bubbles: true
                });
                if (mountTo) {
                    mountTo.dispatchEvent(keyboardEvent);
                    return;
                }
                this.state.target?.dispatchEvent(keyboardEvent);
            }
        }
    }
    constructor(...args){
        super(...args);
        this.state = {
            popupPlacement: [
                'bottom',
                'left'
            ],
            selectionIndex: -1
        };
        this.popupRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
        this.handleRef = (target)=>{
            this.setState({
                target: target || undefined
            });
        };
        this.updatePopupPlacement = (placement)=>{
            const { popupPlacement: previousPlacement } = this.state;
            if (placement[0] !== previousPlacement[0] || placement[1] !== previousPlacement[1]) this.setState({
                popupPlacement: placement
            });
        };
        this.handleCloseAndFocus = (event)=>{
            this.state.target?.querySelector('button')?.focus();
            this.handleClose(event);
        };
        this.handleClose = (event)=>{
            const { onOpenChange: onOpenChange } = this.props;
            if (onOpenChange) onOpenChange({
                isOpen: false,
                event: event
            });
        };
        this.handleEnterKeydown = (e)=>{
            if (!this.props.allowEnterDefaultBehavior) e.preventDefault();
            e.stopPropagation();
        };
    }
}
const $ffa3fbf7d54ca98d$var$DropdownMenuItemCustomComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef((props, ref)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        ref: ref,
        ...rest,
        style: {
            // This forces the item container back to be `position: static`, the default value.
            // This ensures the custom nested menu for table color picker still works as now
            // menu items from @atlaskit/menu all have `position: relative` set for the selected borders.
            // The current implementation unfortunately is very brittle. Design System Team will
            // be prioritizing official support for accessible nested menus that we want you to move
            // to in the future.
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'static'
        }
    }, children);
});
function $ffa3fbf7d54ca98d$export$ed97964d1871885d({ item: item, onItemActivated: onItemActivated, shouldUseDefaultRole: shouldUseDefaultRole, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave }) {
    const [submenuActive, setSubmenuActive] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(false);
    const memoizedOnClick = (0, $42omo.useCallback)(()=>onItemActivated && onItemActivated({
            item: item
        }), [
        onItemActivated,
        item
    ]);
    const onClick = (0, $1oCLl.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? memoizedOnClick : ()=>onItemActivated && onItemActivated({
            item: item
        });
    const memoizedOnMouseDown = (0, $42omo.useCallback)((e)=>{
        e.preventDefault();
    }, []);
    const onMouseDown = (0, $1oCLl.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? memoizedOnMouseDown : (e)=>{
        e.preventDefault();
    };
    const memoizedOnMouseEnter = (0, $42omo.useCallback)(()=>onMouseEnter && onMouseEnter({
            item: item
        }), [
        onMouseEnter,
        item
    ]);
    const onMouseEnterHandler = (0, $1oCLl.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? memoizedOnMouseEnter : ()=>onMouseEnter && onMouseEnter({
            item: item
        });
    const memoizedOnMouseLeave = (0, $42omo.useCallback)(()=>onMouseLeave && onMouseLeave({
            item: item
        }), [
        onMouseLeave,
        item
    ]);
    const onMouseLeaveHandler = (0, $1oCLl.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? memoizedOnMouseLeave : ()=>onMouseLeave && onMouseLeave({
            item: item
        });
    // onClick and value.name are the action indicators in the handlers
    // If neither are present, don't wrap in an Item.
    if (!item.onClick && !(item.value && item.value.name)) return /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        key: String(item.content)
    }, item.content);
    const _handleSubmenuActive = (event)=>{
        setSubmenuActive(Boolean(event.target instanceof HTMLElement && event.target.closest(`.${(0, $lwMQJ.DropdownMenuSharedCssClassName).SUBMENU}`)));
    };
    const ariaLabel = item['aria-label'] === '' ? undefined : item['aria-label'] || String(item.content);
    const testId = item['data-testid'] || `dropdown-item__${item.content}`;
    // From time to time we don't want to have any tabIndex on item wrapper
    // especially when we pass any interactive element as a item.content
    const tabIndex = item.wrapperTabIndex === null ? undefined : item.wrapperTabIndex || -1;
    const dropListItem = /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: ()=>$ffa3fbf7d54ca98d$var$buttonStyles(item.isActive, submenuActive),
        role: (0, $1oCLl.expValEquals)('platform_editor_august_a11y', 'isEnabled', true) ? shouldUseDefaultRole ? undefined : 'menuitem' : undefined,
        tabIndex: tabIndex,
        "aria-disabled": item.isDisabled ? 'true' : 'false',
        "aria-expanded": (0, $1oCLl.expValEquals)('platform_editor_august_a11y', 'isEnabled', true) ? item['aria-expanded'] : undefined,
        onMouseDown: _handleSubmenuActive
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $d77M1.default), {
        item: item,
        key: item.key ?? String(item.content),
        testId: testId,
        role: shouldUseDefaultRole ? 'button' : (0, $1oCLl.expValEquals)('platform_editor_august_a11y', 'isEnabled', true) ? undefined : 'menuitem',
        iconBefore: item.elemBefore,
        iconAfter: item.elemAfter,
        isDisabled: item.isDisabled,
        onClick: onClick,
        "aria-label": ariaLabel,
        "aria-pressed": shouldUseDefaultRole ? item.isActive : undefined,
        "aria-keyshortcuts": item['aria-keyshortcuts'],
        onMouseDown: onMouseDown,
        component: $ffa3fbf7d54ca98d$var$DropdownMenuItemCustomComponent,
        onMouseEnter: onMouseEnterHandler,
        onMouseLeave: onMouseLeaveHandler,
        "aria-expanded": (0, $1oCLl.expValEquals)('platform_editor_august_a11y', 'isEnabled', true) ? undefined : item['aria-expanded']
    }, item.content));
    if (item.tooltipDescription) return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3gadb.default), {
        key: item.key ?? String(item.content),
        content: item.tooltipDescription,
        position: item.tooltipPosition
    }, dropListItem);
    return dropListItem;
}
const $ffa3fbf7d54ca98d$export$9e0cd5a62a7d99cf = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
({ ...props })=>{
    const keyDownHandlerContext = (0, $42omo.useContext)((0, $5Gwdo.KeyDownHandlerContext));
    // This context is to handle the tab, Arrow Right/Left key events for dropdown.
    // Default context has the void callbacks for above key events
    const memoizedArrowKeyNavOptions = (0, $42omo.useMemo)(()=>({
            ...props.arrowKeyNavigationProviderOptions,
            keyDownHandlerContext: keyDownHandlerContext
        }), [
        props.arrowKeyNavigationProviderOptions,
        keyDownHandlerContext
    ]);
    const arrowKeyNavOptions = (0, $1oCLl.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? memoizedArrowKeyNavOptions : {
        ...props.arrowKeyNavigationProviderOptions,
        keyDownHandlerContext: keyDownHandlerContext
    };
    return /*#__PURE__*/ (0, $9K4OG.jsx)($ffa3fbf7d54ca98d$export$2e2bcd8739ae039, {
        arrowKeyNavigationProviderOptions: arrowKeyNavOptions,
        ...props
    });
});
module.exports["default"] = $ffa3fbf7d54ca98d$export$2e2bcd8739ae039;
module.exports["DropdownMenuItem"] = $ffa3fbf7d54ca98d$export$ed97964d1871885d;
module.exports["DropdownMenuWithKeyboardNavigation"] = $ffa3fbf7d54ca98d$export$9e0cd5a62a7d99cf;

});

parcelRegister("lwMQJ", function(module, exports) {
const $074bb39de2f9d970$export$15eb942addb87cf6 = 'pm-dropdown';
const $074bb39de2f9d970$export$94c0f60c32e7bd13 = {
    SUBMENU: `${$074bb39de2f9d970$export$15eb942addb87cf6}-submenu`
};
module.exports["DropdownMenuSharedCssClassName"] = $074bb39de2f9d970$export$94c0f60c32e7bd13;

});

parcelRegister("9CaSN", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $eWRwJ = parcelRequire("eWRwJ");


var $ggbZE = parcelRequire("ggbZE");


var $1DWH0 = parcelRequire("1DWH0");


var $dh538 = parcelRequire("dh538");




/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ var $eaedee612a754baf$var$isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';
var $eaedee612a754baf$var$timeoutDuration = function() {
    var longerTimeoutBrowsers = [
        'Edge',
        'Trident',
        'Firefox'
    ];
    for(var i = 0; i < longerTimeoutBrowsers.length; i += 1){
        if ($eaedee612a754baf$var$isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) return 1;
    }
    return 0;
}();
function $eaedee612a754baf$var$microtaskDebounce(fn) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        window.Promise.resolve().then(function() {
            called = false;
            fn();
        });
    };
}
function $eaedee612a754baf$var$taskDebounce(fn) {
    var scheduled = false;
    return function() {
        if (!scheduled) {
            scheduled = true;
            setTimeout(function() {
                scheduled = false;
                fn();
            }, $eaedee612a754baf$var$timeoutDuration);
        }
    };
}
var $eaedee612a754baf$var$supportsMicroTasks = $eaedee612a754baf$var$isBrowser && window.Promise;
/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/ var $eaedee612a754baf$var$debounce = $eaedee612a754baf$var$supportsMicroTasks ? $eaedee612a754baf$var$microtaskDebounce : $eaedee612a754baf$var$taskDebounce;
/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */ function $eaedee612a754baf$var$isFunction(functionToCheck) {
    var getType = {};
    return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}
/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */ function $eaedee612a754baf$var$getStyleComputedProperty(element, property) {
    if (element.nodeType !== 1) return [];
    // NOTE: 1 DOM access here
    var window1 = element.ownerDocument.defaultView;
    var css = window1.getComputedStyle(element, null);
    return property ? css[property] : css;
}
/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */ function $eaedee612a754baf$var$getParentNode(element) {
    if (element.nodeName === 'HTML') return element;
    return element.parentNode || element.host;
}
/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */ function $eaedee612a754baf$var$getScrollParent(element) {
    // Return body, `getScroll` will take care to get the correct `scrollTop` from it
    if (!element) return document.body;
    switch(element.nodeName){
        case 'HTML':
        case 'BODY':
            return element.ownerDocument.body;
        case '#document':
            return element.body;
    }
    // Firefox want us to check `-x` and `-y` variations as well
    var _getStyleComputedProp = $eaedee612a754baf$var$getStyleComputedProperty(element), overflow = _getStyleComputedProp.overflow, overflowX = _getStyleComputedProp.overflowX, overflowY = _getStyleComputedProp.overflowY;
    if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) return element;
    return $eaedee612a754baf$var$getScrollParent($eaedee612a754baf$var$getParentNode(element));
}
/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */ function $eaedee612a754baf$var$getReferenceNode(reference) {
    return reference && reference.referenceNode ? reference.referenceNode : reference;
}
var $eaedee612a754baf$var$isIE11 = $eaedee612a754baf$var$isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var $eaedee612a754baf$var$isIE10 = $eaedee612a754baf$var$isBrowser && /MSIE 10/.test(navigator.userAgent);
/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */ function $eaedee612a754baf$var$isIE(version) {
    if (version === 11) return $eaedee612a754baf$var$isIE11;
    if (version === 10) return $eaedee612a754baf$var$isIE10;
    return $eaedee612a754baf$var$isIE11 || $eaedee612a754baf$var$isIE10;
}
/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */ function $eaedee612a754baf$var$getOffsetParent(element) {
    if (!element) return document.documentElement;
    var noOffsetParent = $eaedee612a754baf$var$isIE(10) ? document.body : null;
    // NOTE: 1 DOM access here
    var offsetParent = element.offsetParent || null;
    // Skip hidden elements which don't have an offsetParent
    while(offsetParent === noOffsetParent && element.nextElementSibling)offsetParent = (element = element.nextElementSibling).offsetParent;
    var nodeName = offsetParent && offsetParent.nodeName;
    if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') return element ? element.ownerDocument.documentElement : document.documentElement;
    // .offsetParent will return the closest TH, TD or TABLE in case
    // no offsetParent is present, I hate this job...
    if ([
        'TH',
        'TD',
        'TABLE'
    ].indexOf(offsetParent.nodeName) !== -1 && $eaedee612a754baf$var$getStyleComputedProperty(offsetParent, 'position') === 'static') return $eaedee612a754baf$var$getOffsetParent(offsetParent);
    return offsetParent;
}
function $eaedee612a754baf$var$isOffsetContainer(element) {
    var nodeName = element.nodeName;
    if (nodeName === 'BODY') return false;
    return nodeName === 'HTML' || $eaedee612a754baf$var$getOffsetParent(element.firstElementChild) === element;
}
/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */ function $eaedee612a754baf$var$getRoot(node) {
    if (node.parentNode !== null) return $eaedee612a754baf$var$getRoot(node.parentNode);
    return node;
}
/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */ function $eaedee612a754baf$var$findCommonOffsetParent(element1, element2) {
    // This check is needed to avoid errors in case one of the elements isn't defined for any reason
    if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) return document.documentElement;
    // Here we make sure to give as "start" the element that comes first in the DOM
    var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
    var start = order ? element1 : element2;
    var end = order ? element2 : element1;
    // Get common ancestor container
    var range = document.createRange();
    range.setStart(start, 0);
    range.setEnd(end, 0);
    var commonAncestorContainer = range.commonAncestorContainer;
    // Both nodes are inside #document
    if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
        if ($eaedee612a754baf$var$isOffsetContainer(commonAncestorContainer)) return commonAncestorContainer;
        return $eaedee612a754baf$var$getOffsetParent(commonAncestorContainer);
    }
    // one of the nodes is inside shadowDOM, find which one
    var element1root = $eaedee612a754baf$var$getRoot(element1);
    if (element1root.host) return $eaedee612a754baf$var$findCommonOffsetParent(element1root.host, element2);
    else return $eaedee612a754baf$var$findCommonOffsetParent(element1, $eaedee612a754baf$var$getRoot(element2).host);
}
/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */ function $eaedee612a754baf$var$getScroll(element) {
    var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
    var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
    var nodeName = element.nodeName;
    if (nodeName === 'BODY' || nodeName === 'HTML') {
        var html = element.ownerDocument.documentElement;
        var scrollingElement = element.ownerDocument.scrollingElement || html;
        return scrollingElement[upperSide];
    }
    return element[upperSide];
}
/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */ function $eaedee612a754baf$var$includeScroll(rect, element) {
    var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var scrollTop = $eaedee612a754baf$var$getScroll(element, 'top');
    var scrollLeft = $eaedee612a754baf$var$getScroll(element, 'left');
    var modifier = subtract ? -1 : 1;
    rect.top += scrollTop * modifier;
    rect.bottom += scrollTop * modifier;
    rect.left += scrollLeft * modifier;
    rect.right += scrollLeft * modifier;
    return rect;
}
/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */ function $eaedee612a754baf$var$getBordersSize(styles, axis) {
    var sideA = axis === 'x' ? 'Left' : 'Top';
    var sideB = sideA === 'Left' ? 'Right' : 'Bottom';
    return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
}
function $eaedee612a754baf$var$getSize(axis, body, html, computedStyle) {
    return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], $eaedee612a754baf$var$isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}
function $eaedee612a754baf$var$getWindowSizes(document1) {
    var body = document1.body;
    var html = document1.documentElement;
    var computedStyle = $eaedee612a754baf$var$isIE(10) && getComputedStyle(html);
    return {
        height: $eaedee612a754baf$var$getSize('Height', body, html, computedStyle),
        width: $eaedee612a754baf$var$getSize('Width', body, html, computedStyle)
    };
}
var $eaedee612a754baf$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $eaedee612a754baf$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $eaedee612a754baf$var$defineProperty = function(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
};
var $eaedee612a754baf$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */ function $eaedee612a754baf$var$getClientRect(offsets) {
    return $eaedee612a754baf$var$_extends({}, offsets, {
        right: offsets.left + offsets.width,
        bottom: offsets.top + offsets.height
    });
}
/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */ function $eaedee612a754baf$var$getBoundingClientRect(element) {
    var rect = {};
    // IE10 10 FIX: Please, don't ask, the element isn't
    // considered in DOM in some circumstances...
    // This isn't reproducible in IE10 compatibility mode of IE11
    try {
        if ($eaedee612a754baf$var$isIE(10)) {
            rect = element.getBoundingClientRect();
            var scrollTop = $eaedee612a754baf$var$getScroll(element, 'top');
            var scrollLeft = $eaedee612a754baf$var$getScroll(element, 'left');
            rect.top += scrollTop;
            rect.left += scrollLeft;
            rect.bottom += scrollTop;
            rect.right += scrollLeft;
        } else rect = element.getBoundingClientRect();
    } catch (e) {}
    var result = {
        left: rect.left,
        top: rect.top,
        width: rect.right - rect.left,
        height: rect.bottom - rect.top
    };
    // subtract scrollbar size from sizes
    var sizes = element.nodeName === 'HTML' ? $eaedee612a754baf$var$getWindowSizes(element.ownerDocument) : {};
    var width = sizes.width || element.clientWidth || result.width;
    var height = sizes.height || element.clientHeight || result.height;
    var horizScrollbar = element.offsetWidth - width;
    var vertScrollbar = element.offsetHeight - height;
    // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
    // we make this check conditional for performance reasons
    if (horizScrollbar || vertScrollbar) {
        var styles = $eaedee612a754baf$var$getStyleComputedProperty(element);
        horizScrollbar -= $eaedee612a754baf$var$getBordersSize(styles, 'x');
        vertScrollbar -= $eaedee612a754baf$var$getBordersSize(styles, 'y');
        result.width -= horizScrollbar;
        result.height -= vertScrollbar;
    }
    return $eaedee612a754baf$var$getClientRect(result);
}
function $eaedee612a754baf$var$getOffsetRectRelativeToArbitraryNode(children, parent) {
    var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isIE10 = $eaedee612a754baf$var$isIE(10);
    var isHTML = parent.nodeName === 'HTML';
    var childrenRect = $eaedee612a754baf$var$getBoundingClientRect(children);
    var parentRect = $eaedee612a754baf$var$getBoundingClientRect(parent);
    var scrollParent = $eaedee612a754baf$var$getScrollParent(children);
    var styles = $eaedee612a754baf$var$getStyleComputedProperty(parent);
    var borderTopWidth = parseFloat(styles.borderTopWidth);
    var borderLeftWidth = parseFloat(styles.borderLeftWidth);
    // In cases where the parent is fixed, we must ignore negative scroll in offset calc
    if (fixedPosition && isHTML) {
        parentRect.top = Math.max(parentRect.top, 0);
        parentRect.left = Math.max(parentRect.left, 0);
    }
    var offsets = $eaedee612a754baf$var$getClientRect({
        top: childrenRect.top - parentRect.top - borderTopWidth,
        left: childrenRect.left - parentRect.left - borderLeftWidth,
        width: childrenRect.width,
        height: childrenRect.height
    });
    offsets.marginTop = 0;
    offsets.marginLeft = 0;
    // Subtract margins of documentElement in case it's being used as parent
    // we do this only on HTML because it's the only element that behaves
    // differently when margins are applied to it. The margins are included in
    // the box of the documentElement, in the other cases not.
    if (!isIE10 && isHTML) {
        var marginTop = parseFloat(styles.marginTop);
        var marginLeft = parseFloat(styles.marginLeft);
        offsets.top -= borderTopWidth - marginTop;
        offsets.bottom -= borderTopWidth - marginTop;
        offsets.left -= borderLeftWidth - marginLeft;
        offsets.right -= borderLeftWidth - marginLeft;
        // Attach marginTop and marginLeft because in some circumstances we may need them
        offsets.marginTop = marginTop;
        offsets.marginLeft = marginLeft;
    }
    if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') offsets = $eaedee612a754baf$var$includeScroll(offsets, parent);
    return offsets;
}
function $eaedee612a754baf$var$getViewportOffsetRectRelativeToArtbitraryNode(element) {
    var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var html = element.ownerDocument.documentElement;
    var relativeOffset = $eaedee612a754baf$var$getOffsetRectRelativeToArbitraryNode(element, html);
    var width = Math.max(html.clientWidth, window.innerWidth || 0);
    var height = Math.max(html.clientHeight, window.innerHeight || 0);
    var scrollTop = !excludeScroll ? $eaedee612a754baf$var$getScroll(html) : 0;
    var scrollLeft = !excludeScroll ? $eaedee612a754baf$var$getScroll(html, 'left') : 0;
    var offset = {
        top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
        left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
        width: width,
        height: height
    };
    return $eaedee612a754baf$var$getClientRect(offset);
}
/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */ function $eaedee612a754baf$var$isFixed(element) {
    var nodeName = element.nodeName;
    if (nodeName === 'BODY' || nodeName === 'HTML') return false;
    if ($eaedee612a754baf$var$getStyleComputedProperty(element, 'position') === 'fixed') return true;
    var parentNode = $eaedee612a754baf$var$getParentNode(element);
    if (!parentNode) return false;
    return $eaedee612a754baf$var$isFixed(parentNode);
}
/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */ function $eaedee612a754baf$var$getFixedPositionOffsetParent(element) {
    // This check is needed to avoid errors in case one of the elements isn't defined for any reason
    if (!element || !element.parentElement || $eaedee612a754baf$var$isIE()) return document.documentElement;
    var el = element.parentElement;
    while(el && $eaedee612a754baf$var$getStyleComputedProperty(el, 'transform') === 'none')el = el.parentElement;
    return el || document.documentElement;
}
/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */ function $eaedee612a754baf$var$getBoundaries(popper, reference, padding, boundariesElement) {
    var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    // NOTE: 1 DOM access here
    var boundaries = {
        top: 0,
        left: 0
    };
    var offsetParent = fixedPosition ? $eaedee612a754baf$var$getFixedPositionOffsetParent(popper) : $eaedee612a754baf$var$findCommonOffsetParent(popper, $eaedee612a754baf$var$getReferenceNode(reference));
    // Handle viewport case
    if (boundariesElement === 'viewport') boundaries = $eaedee612a754baf$var$getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
    else {
        // Handle other cases based on DOM element used as boundaries
        var boundariesNode = void 0;
        if (boundariesElement === 'scrollParent') {
            boundariesNode = $eaedee612a754baf$var$getScrollParent($eaedee612a754baf$var$getParentNode(reference));
            if (boundariesNode.nodeName === 'BODY') boundariesNode = popper.ownerDocument.documentElement;
        } else if (boundariesElement === 'window') boundariesNode = popper.ownerDocument.documentElement;
        else boundariesNode = boundariesElement;
        var offsets = $eaedee612a754baf$var$getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);
        // In case of HTML, we need a different computation
        if (boundariesNode.nodeName === 'HTML' && !$eaedee612a754baf$var$isFixed(offsetParent)) {
            var _getWindowSizes = $eaedee612a754baf$var$getWindowSizes(popper.ownerDocument), height = _getWindowSizes.height, width = _getWindowSizes.width;
            boundaries.top += offsets.top - offsets.marginTop;
            boundaries.bottom = height + offsets.top;
            boundaries.left += offsets.left - offsets.marginLeft;
            boundaries.right = width + offsets.left;
        } else // for all the other DOM elements, this one is good
        boundaries = offsets;
    }
    // Add paddings
    padding = padding || 0;
    var isPaddingNumber = typeof padding === 'number';
    boundaries.left += isPaddingNumber ? padding : padding.left || 0;
    boundaries.top += isPaddingNumber ? padding : padding.top || 0;
    boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
    boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
    return boundaries;
}
function $eaedee612a754baf$var$getArea(_ref) {
    var width = _ref.width, height = _ref.height;
    return width * height;
}
/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $eaedee612a754baf$var$computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
    var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
    if (placement.indexOf('auto') === -1) return placement;
    var boundaries = $eaedee612a754baf$var$getBoundaries(popper, reference, padding, boundariesElement);
    var rects = {
        top: {
            width: boundaries.width,
            height: refRect.top - boundaries.top
        },
        right: {
            width: boundaries.right - refRect.right,
            height: boundaries.height
        },
        bottom: {
            width: boundaries.width,
            height: boundaries.bottom - refRect.bottom
        },
        left: {
            width: refRect.left - boundaries.left,
            height: boundaries.height
        }
    };
    var sortedAreas = Object.keys(rects).map(function(key) {
        return $eaedee612a754baf$var$_extends({
            key: key
        }, rects[key], {
            area: $eaedee612a754baf$var$getArea(rects[key])
        });
    }).sort(function(a, b) {
        return b.area - a.area;
    });
    var filteredAreas = sortedAreas.filter(function(_ref2) {
        var width = _ref2.width, height = _ref2.height;
        return width >= popper.clientWidth && height >= popper.clientHeight;
    });
    var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
    var variation = placement.split('-')[1];
    return computedPlacement + (variation ? '-' + variation : '');
}
/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */ function $eaedee612a754baf$var$getReferenceOffsets(state, popper, reference) {
    var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var commonOffsetParent = fixedPosition ? $eaedee612a754baf$var$getFixedPositionOffsetParent(popper) : $eaedee612a754baf$var$findCommonOffsetParent(popper, $eaedee612a754baf$var$getReferenceNode(reference));
    return $eaedee612a754baf$var$getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}
/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */ function $eaedee612a754baf$var$getOuterSizes(element) {
    var window1 = element.ownerDocument.defaultView;
    var styles = window1.getComputedStyle(element);
    var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
    var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
    var result = {
        width: element.offsetWidth + y,
        height: element.offsetHeight + x
    };
    return result;
}
/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */ function $eaedee612a754baf$var$getOppositePlacement(placement) {
    var hash = {
        left: 'right',
        right: 'left',
        bottom: 'top',
        top: 'bottom'
    };
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return hash[matched];
    });
}
/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */ function $eaedee612a754baf$var$getPopperOffsets(popper, referenceOffsets, placement) {
    placement = placement.split('-')[0];
    // Get popper node sizes
    var popperRect = $eaedee612a754baf$var$getOuterSizes(popper);
    // Add position, width and height to our offsets object
    var popperOffsets = {
        width: popperRect.width,
        height: popperRect.height
    };
    // depending by the popper placement we have to compute its offsets slightly differently
    var isHoriz = [
        'right',
        'left'
    ].indexOf(placement) !== -1;
    var mainSide = isHoriz ? 'top' : 'left';
    var secondarySide = isHoriz ? 'left' : 'top';
    var measurement = isHoriz ? 'height' : 'width';
    var secondaryMeasurement = !isHoriz ? 'height' : 'width';
    popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
    if (placement === secondarySide) popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
    else popperOffsets[secondarySide] = referenceOffsets[$eaedee612a754baf$var$getOppositePlacement(secondarySide)];
    return popperOffsets;
}
/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */ function $eaedee612a754baf$var$find(arr, check) {
    // use native find if supported
    if (Array.prototype.find) return arr.find(check);
    // use `filter` to obtain the same behavior of `find`
    return arr.filter(check)[0];
}
/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */ function $eaedee612a754baf$var$findIndex(arr, prop, value) {
    // use native findIndex if supported
    if (Array.prototype.findIndex) return arr.findIndex(function(cur) {
        return cur[prop] === value;
    });
    // use `find` + `indexOf` if `findIndex` isn't supported
    var match = $eaedee612a754baf$var$find(arr, function(obj) {
        return obj[prop] === value;
    });
    return arr.indexOf(match);
}
/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */ function $eaedee612a754baf$var$runModifiers(modifiers, data, ends) {
    var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, $eaedee612a754baf$var$findIndex(modifiers, 'name', ends));
    modifiersToRun.forEach(function(modifier) {
        if (modifier['function']) // eslint-disable-line dot-notation
        console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
        var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
        if (modifier.enabled && $eaedee612a754baf$var$isFunction(fn)) {
            // Add properties to offsets to make them a complete clientRect object
            // we do this before each modifier to make sure the previous one doesn't
            // mess with these values
            data.offsets.popper = $eaedee612a754baf$var$getClientRect(data.offsets.popper);
            data.offsets.reference = $eaedee612a754baf$var$getClientRect(data.offsets.reference);
            data = fn(data, modifier);
        }
    });
    return data;
}
/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */ function $eaedee612a754baf$var$update() {
    // if popper is destroyed, don't perform any further update
    if (this.state.isDestroyed) return;
    var data = {
        instance: this,
        styles: {},
        arrowStyles: {},
        attributes: {},
        flipped: false,
        offsets: {}
    };
    // compute reference element offsets
    data.offsets.reference = $eaedee612a754baf$var$getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);
    // compute auto placement, store placement inside the data object,
    // modifiers will be able to edit `placement` if needed
    // and refer to originalPlacement to know the original value
    data.placement = $eaedee612a754baf$var$computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
    // store the computed placement inside `originalPlacement`
    data.originalPlacement = data.placement;
    data.positionFixed = this.options.positionFixed;
    // compute the popper offsets
    data.offsets.popper = $eaedee612a754baf$var$getPopperOffsets(this.popper, data.offsets.reference, data.placement);
    data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';
    // run the modifiers
    data = $eaedee612a754baf$var$runModifiers(this.modifiers, data);
    // the first `update` will call `onCreate` callback
    // the other ones will call `onUpdate` callback
    if (!this.state.isCreated) {
        this.state.isCreated = true;
        this.options.onCreate(data);
    } else this.options.onUpdate(data);
}
/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */ function $eaedee612a754baf$var$isModifierEnabled(modifiers, modifierName) {
    return modifiers.some(function(_ref) {
        var name = _ref.name, enabled = _ref.enabled;
        return enabled && name === modifierName;
    });
}
/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */ function $eaedee612a754baf$var$getSupportedPropertyName(property) {
    var prefixes = [
        false,
        'ms',
        'Webkit',
        'Moz',
        'O'
    ];
    var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
    for(var i = 0; i < prefixes.length; i++){
        var prefix = prefixes[i];
        var toCheck = prefix ? '' + prefix + upperProp : property;
        if (typeof document.body.style[toCheck] !== 'undefined') return toCheck;
    }
    return null;
}
/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */ function $eaedee612a754baf$var$destroy() {
    this.state.isDestroyed = true;
    // touch DOM only if `applyStyle` modifier is enabled
    if ($eaedee612a754baf$var$isModifierEnabled(this.modifiers, 'applyStyle')) {
        this.popper.removeAttribute('x-placement');
        this.popper.style.position = '';
        this.popper.style.top = '';
        this.popper.style.left = '';
        this.popper.style.right = '';
        this.popper.style.bottom = '';
        this.popper.style.willChange = '';
        this.popper.style[$eaedee612a754baf$var$getSupportedPropertyName('transform')] = '';
    }
    this.disableEventListeners();
    // remove the popper if user explicitly asked for the deletion on destroy
    // do not use `remove` because IE11 doesn't support it
    if (this.options.removeOnDestroy) this.popper.parentNode.removeChild(this.popper);
    return this;
}
/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */ function $eaedee612a754baf$var$getWindow(element) {
    var ownerDocument = element.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView : window;
}
function $eaedee612a754baf$var$attachToScrollParents(scrollParent, event, callback, scrollParents) {
    var isBody = scrollParent.nodeName === 'BODY';
    var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
    target.addEventListener(event, callback, {
        passive: true
    });
    if (!isBody) $eaedee612a754baf$var$attachToScrollParents($eaedee612a754baf$var$getScrollParent(target.parentNode), event, callback, scrollParents);
    scrollParents.push(target);
}
/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */ function $eaedee612a754baf$var$setupEventListeners(reference, options, state, updateBound) {
    // Resize event listener on window
    state.updateBound = updateBound;
    $eaedee612a754baf$var$getWindow(reference).addEventListener('resize', state.updateBound, {
        passive: true
    });
    // Scroll event listener on scroll parents
    var scrollElement = $eaedee612a754baf$var$getScrollParent(reference);
    $eaedee612a754baf$var$attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
    state.scrollElement = scrollElement;
    state.eventsEnabled = true;
    return state;
}
/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */ function $eaedee612a754baf$var$enableEventListeners() {
    if (!this.state.eventsEnabled) this.state = $eaedee612a754baf$var$setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
}
/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */ function $eaedee612a754baf$var$removeEventListeners(reference, state) {
    // Remove resize event listener on window
    $eaedee612a754baf$var$getWindow(reference).removeEventListener('resize', state.updateBound);
    // Remove scroll event listener on scroll parents
    state.scrollParents.forEach(function(target) {
        target.removeEventListener('scroll', state.updateBound);
    });
    // Reset state
    state.updateBound = null;
    state.scrollParents = [];
    state.scrollElement = null;
    state.eventsEnabled = false;
    return state;
}
/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */ function $eaedee612a754baf$var$disableEventListeners() {
    if (this.state.eventsEnabled) {
        cancelAnimationFrame(this.scheduleUpdate);
        this.state = $eaedee612a754baf$var$removeEventListeners(this.reference, this.state);
    }
}
/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */ function $eaedee612a754baf$var$isNumeric(n) {
    return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}
/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */ function $eaedee612a754baf$var$setStyles(element, styles) {
    Object.keys(styles).forEach(function(prop) {
        var unit = '';
        // add unit if the value is numeric and is one of the following
        if ([
            'width',
            'height',
            'top',
            'right',
            'bottom',
            'left'
        ].indexOf(prop) !== -1 && $eaedee612a754baf$var$isNumeric(styles[prop])) unit = 'px';
        element.style[prop] = styles[prop] + unit;
    });
}
/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */ function $eaedee612a754baf$var$setAttributes(element, attributes) {
    Object.keys(attributes).forEach(function(prop) {
        var value = attributes[prop];
        if (value !== false) element.setAttribute(prop, attributes[prop]);
        else element.removeAttribute(prop);
    });
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */ function $eaedee612a754baf$var$applyStyle(data) {
    // any property present in `data.styles` will be applied to the popper,
    // in this way we can make the 3rd party modifiers add custom styles to it
    // Be aware, modifiers could override the properties defined in the previous
    // lines of this modifier!
    $eaedee612a754baf$var$setStyles(data.instance.popper, data.styles);
    // any property present in `data.attributes` will be applied to the popper,
    // they will be set as HTML attributes of the element
    $eaedee612a754baf$var$setAttributes(data.instance.popper, data.attributes);
    // if arrowElement is defined and arrowStyles has some properties
    if (data.arrowElement && Object.keys(data.arrowStyles).length) $eaedee612a754baf$var$setStyles(data.arrowElement, data.arrowStyles);
    return data;
}
/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */ function $eaedee612a754baf$var$applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
    // compute reference element offsets
    var referenceOffsets = $eaedee612a754baf$var$getReferenceOffsets(state, popper, reference, options.positionFixed);
    // compute auto placement, store placement inside the data object,
    // modifiers will be able to edit `placement` if needed
    // and refer to originalPlacement to know the original value
    var placement = $eaedee612a754baf$var$computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
    popper.setAttribute('x-placement', placement);
    // Apply `position` to popper before anything else because
    // without the position applied we can't guarantee correct computations
    $eaedee612a754baf$var$setStyles(popper, {
        position: options.positionFixed ? 'fixed' : 'absolute'
    });
    return options;
}
/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */ function $eaedee612a754baf$var$getRoundedOffsets(data, shouldRound) {
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var round = Math.round, floor = Math.floor;
    var noRound = function noRound(v) {
        return v;
    };
    var referenceWidth = round(reference.width);
    var popperWidth = round(popper.width);
    var isVertical = [
        'left',
        'right'
    ].indexOf(data.placement) !== -1;
    var isVariation = data.placement.indexOf('-') !== -1;
    var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
    var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;
    var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
    var verticalToInteger = !shouldRound ? noRound : round;
    return {
        left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
        top: verticalToInteger(popper.top),
        bottom: verticalToInteger(popper.bottom),
        right: horizontalToInteger(popper.right)
    };
}
var $eaedee612a754baf$var$isFirefox = $eaedee612a754baf$var$isBrowser && /Firefox/i.test(navigator.userAgent);
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $eaedee612a754baf$var$computeStyle(data, options) {
    var x = options.x, y = options.y;
    var popper = data.offsets.popper;
    // Remove this legacy support in Popper.js v2
    var legacyGpuAccelerationOption = $eaedee612a754baf$var$find(data.instance.modifiers, function(modifier) {
        return modifier.name === 'applyStyle';
    }).gpuAcceleration;
    if (legacyGpuAccelerationOption !== undefined) console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
    var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
    var offsetParent = $eaedee612a754baf$var$getOffsetParent(data.instance.popper);
    var offsetParentRect = $eaedee612a754baf$var$getBoundingClientRect(offsetParent);
    // Styles
    var styles = {
        position: popper.position
    };
    var offsets = $eaedee612a754baf$var$getRoundedOffsets(data, window.devicePixelRatio < 2 || !$eaedee612a754baf$var$isFirefox);
    var sideA = x === 'bottom' ? 'top' : 'bottom';
    var sideB = y === 'right' ? 'left' : 'right';
    // if gpuAcceleration is set to `true` and transform is supported,
    //  we use `translate3d` to apply the position to the popper we
    // automatically use the supported prefixed version if needed
    var prefixedProperty = $eaedee612a754baf$var$getSupportedPropertyName('transform');
    // now, let's make a step back and look at this code closely (wtf?)
    // If the content of the popper grows once it's been positioned, it
    // may happen that the popper gets misplaced because of the new content
    // overflowing its reference element
    // To avoid this problem, we provide two options (x and y), which allow
    // the consumer to define the offset origin.
    // If we position a popper on top of a reference element, we can set
    // `x` to `top` to make the popper grow towards its top instead of
    // its bottom.
    var left = void 0, top = void 0;
    if (sideA === 'bottom') {
        // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
        // and not the bottom of the html element
        if (offsetParent.nodeName === 'HTML') top = -offsetParent.clientHeight + offsets.bottom;
        else top = -offsetParentRect.height + offsets.bottom;
    } else top = offsets.top;
    if (sideB === 'right') {
        if (offsetParent.nodeName === 'HTML') left = -offsetParent.clientWidth + offsets.right;
        else left = -offsetParentRect.width + offsets.right;
    } else left = offsets.left;
    if (gpuAcceleration && prefixedProperty) {
        styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
        styles[sideA] = 0;
        styles[sideB] = 0;
        styles.willChange = 'transform';
    } else {
        // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
        var invertTop = sideA === 'bottom' ? -1 : 1;
        var invertLeft = sideB === 'right' ? -1 : 1;
        styles[sideA] = top * invertTop;
        styles[sideB] = left * invertLeft;
        styles.willChange = sideA + ', ' + sideB;
    }
    // Attributes
    var attributes = {
        'x-placement': data.placement
    };
    // Update `data` attributes, styles and arrowStyles
    data.attributes = $eaedee612a754baf$var$_extends({}, attributes, data.attributes);
    data.styles = $eaedee612a754baf$var$_extends({}, styles, data.styles);
    data.arrowStyles = $eaedee612a754baf$var$_extends({}, data.offsets.arrow, data.arrowStyles);
    return data;
}
/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */ function $eaedee612a754baf$var$isModifierRequired(modifiers, requestingName, requestedName) {
    var requesting = $eaedee612a754baf$var$find(modifiers, function(_ref) {
        var name = _ref.name;
        return name === requestingName;
    });
    var isRequired = !!requesting && modifiers.some(function(modifier) {
        return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
    });
    if (!isRequired) {
        var _requesting = '`' + requestingName + '`';
        var requested = '`' + requestedName + '`';
        console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
    }
    return isRequired;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $eaedee612a754baf$var$arrow(data, options) {
    var _data$offsets$arrow;
    // arrow depends on keepTogether in order to work
    if (!$eaedee612a754baf$var$isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) return data;
    var arrowElement = options.element;
    // if arrowElement is a string, suppose it's a CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = data.instance.popper.querySelector(arrowElement);
        // if arrowElement is not found, don't run the modifier
        if (!arrowElement) return data;
    } else // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
        console.warn('WARNING: `arrow.element` must be child of its popper element!');
        return data;
    }
    var placement = data.placement.split('-')[0];
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var isVertical = [
        'left',
        'right'
    ].indexOf(placement) !== -1;
    var len = isVertical ? 'height' : 'width';
    var sideCapitalized = isVertical ? 'Top' : 'Left';
    var side = sideCapitalized.toLowerCase();
    var altSide = isVertical ? 'left' : 'top';
    var opSide = isVertical ? 'bottom' : 'right';
    var arrowElementSize = $eaedee612a754baf$var$getOuterSizes(arrowElement)[len];
    //
    // extends keepTogether behavior making sure the popper and its
    // reference have enough pixels in conjunction
    //
    // top/left side
    if (reference[opSide] - arrowElementSize < popper[side]) data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
    // bottom/right side
    if (reference[side] + arrowElementSize > popper[opSide]) data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
    data.offsets.popper = $eaedee612a754baf$var$getClientRect(data.offsets.popper);
    // compute center of the popper
    var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
    // Compute the sideValue using the updated popper offsets
    // take popper margin in account because we don't have this info available
    var css = $eaedee612a754baf$var$getStyleComputedProperty(data.instance.popper);
    var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
    var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
    var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;
    // prevent arrowElement from being placed not contiguously to its popper
    sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
    data.arrowElement = arrowElement;
    data.offsets.arrow = (_data$offsets$arrow = {}, $eaedee612a754baf$var$defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), $eaedee612a754baf$var$defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);
    return data;
}
/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */ function $eaedee612a754baf$var$getOppositeVariation(variation) {
    if (variation === 'end') return 'start';
    else if (variation === 'start') return 'end';
    return variation;
}
/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */ var $eaedee612a754baf$var$placements = [
    'auto-start',
    'auto',
    'auto-end',
    'top-start',
    'top',
    'top-end',
    'right-start',
    'right',
    'right-end',
    'bottom-end',
    'bottom',
    'bottom-start',
    'left-end',
    'left',
    'left-start'
];
// Get rid of `auto` `auto-start` and `auto-end`
var $eaedee612a754baf$var$validPlacements = $eaedee612a754baf$var$placements.slice(3);
/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */ function $eaedee612a754baf$var$clockwise(placement) {
    var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var index = $eaedee612a754baf$var$validPlacements.indexOf(placement);
    var arr = $eaedee612a754baf$var$validPlacements.slice(index + 1).concat($eaedee612a754baf$var$validPlacements.slice(0, index));
    return counter ? arr.reverse() : arr;
}
var $eaedee612a754baf$var$BEHAVIORS = {
    FLIP: 'flip',
    CLOCKWISE: 'clockwise',
    COUNTERCLOCKWISE: 'counterclockwise'
};
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $eaedee612a754baf$var$flip(data, options) {
    // if `inner` modifier is enabled, we can't use the `flip` modifier
    if ($eaedee612a754baf$var$isModifierEnabled(data.instance.modifiers, 'inner')) return data;
    if (data.flipped && data.placement === data.originalPlacement) // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
    var boundaries = $eaedee612a754baf$var$getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
    var placement = data.placement.split('-')[0];
    var placementOpposite = $eaedee612a754baf$var$getOppositePlacement(placement);
    var variation = data.placement.split('-')[1] || '';
    var flipOrder = [];
    switch(options.behavior){
        case $eaedee612a754baf$var$BEHAVIORS.FLIP:
            flipOrder = [
                placement,
                placementOpposite
            ];
            break;
        case $eaedee612a754baf$var$BEHAVIORS.CLOCKWISE:
            flipOrder = $eaedee612a754baf$var$clockwise(placement);
            break;
        case $eaedee612a754baf$var$BEHAVIORS.COUNTERCLOCKWISE:
            flipOrder = $eaedee612a754baf$var$clockwise(placement, true);
            break;
        default:
            flipOrder = options.behavior;
    }
    flipOrder.forEach(function(step, index) {
        if (placement !== step || flipOrder.length === index + 1) return data;
        placement = data.placement.split('-')[0];
        placementOpposite = $eaedee612a754baf$var$getOppositePlacement(placement);
        var popperOffsets = data.offsets.popper;
        var refOffsets = data.offsets.reference;
        // using floor because the reference offsets may contain decimals we are not going to consider here
        var floor = Math.floor;
        var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);
        var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
        var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
        var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
        var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
        var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;
        // flip the variation if required
        var isVertical = [
            'top',
            'bottom'
        ].indexOf(placement) !== -1;
        // flips variation if reference element overflows boundaries
        var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);
        // flips variation if popper content overflows boundaries
        var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);
        var flippedVariation = flippedVariationByRef || flippedVariationByContent;
        if (overlapsRef || overflowsBoundaries || flippedVariation) {
            // this boolean to detect any flip loop
            data.flipped = true;
            if (overlapsRef || overflowsBoundaries) placement = flipOrder[index + 1];
            if (flippedVariation) variation = $eaedee612a754baf$var$getOppositeVariation(variation);
            data.placement = placement + (variation ? '-' + variation : '');
            // this object contains `position`, we want to preserve it along with
            // any additional property we may add in the future
            data.offsets.popper = $eaedee612a754baf$var$_extends({}, data.offsets.popper, $eaedee612a754baf$var$getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
            data = $eaedee612a754baf$var$runModifiers(data.instance.modifiers, data, 'flip');
        }
    });
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $eaedee612a754baf$var$keepTogether(data) {
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var placement = data.placement.split('-')[0];
    var floor = Math.floor;
    var isVertical = [
        'top',
        'bottom'
    ].indexOf(placement) !== -1;
    var side = isVertical ? 'right' : 'bottom';
    var opSide = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';
    if (popper[side] < floor(reference[opSide])) data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
    if (popper[opSide] > floor(reference[side])) data.offsets.popper[opSide] = floor(reference[side]);
    return data;
}
/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */ function $eaedee612a754baf$var$toValue(str, measurement, popperOffsets, referenceOffsets) {
    // separate value from unit
    var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
    var value = +split[1];
    var unit = split[2];
    // If it's not a number it's an operator, I guess
    if (!value) return str;
    if (unit.indexOf('%') === 0) {
        var element = void 0;
        switch(unit){
            case '%p':
                element = popperOffsets;
                break;
            case '%':
            case '%r':
            default:
                element = referenceOffsets;
        }
        var rect = $eaedee612a754baf$var$getClientRect(element);
        return rect[measurement] / 100 * value;
    } else if (unit === 'vh' || unit === 'vw') {
        // if is a vh or vw, we calculate the size based on the viewport
        var size = void 0;
        if (unit === 'vh') size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        else size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        return size / 100 * value;
    } else // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
}
/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */ function $eaedee612a754baf$var$parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
    var offsets = [
        0,
        0
    ];
    // Use height if placement is left or right and index is 0 otherwise use width
    // in this way the first offset will use an axis and the second one
    // will use the other one
    var useHeight = [
        'right',
        'left'
    ].indexOf(basePlacement) !== -1;
    // Split the offset string to obtain a list of values and operands
    // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
    var fragments = offset.split(/(\+|\-)/).map(function(frag) {
        return frag.trim();
    });
    // Detect if the offset string contains a pair of values or a single one
    // they could be separated by comma or space
    var divider = fragments.indexOf($eaedee612a754baf$var$find(fragments, function(frag) {
        return frag.search(/,|\s/) !== -1;
    }));
    if (fragments[divider] && fragments[divider].indexOf(',') === -1) console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
    // If divider is found, we divide the list of values and operands to divide
    // them by ofset X and Y.
    var splitRegex = /\s*,\s*|\s+/;
    var ops = divider !== -1 ? [
        fragments.slice(0, divider).concat([
            fragments[divider].split(splitRegex)[0]
        ]),
        [
            fragments[divider].split(splitRegex)[1]
        ].concat(fragments.slice(divider + 1))
    ] : [
        fragments
    ];
    // Convert the values with units to absolute pixels to allow our computations
    ops = ops.map(function(op, index) {
        // Most of the units rely on the orientation of the popper
        var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
        var mergeWithPrevious = false;
        return op// This aggregates any `+` or `-` sign that aren't considered operators
        // e.g.: 10 + +5 => [10, +, +5]
        .reduce(function(a, b) {
            if (a[a.length - 1] === '' && [
                '+',
                '-'
            ].indexOf(b) !== -1) {
                a[a.length - 1] = b;
                mergeWithPrevious = true;
                return a;
            } else if (mergeWithPrevious) {
                a[a.length - 1] += b;
                mergeWithPrevious = false;
                return a;
            } else return a.concat(b);
        }, [])// Here we convert the string values into number values (in px)
        .map(function(str) {
            return $eaedee612a754baf$var$toValue(str, measurement, popperOffsets, referenceOffsets);
        });
    });
    // Loop trough the offsets arrays and execute the operations
    ops.forEach(function(op, index) {
        op.forEach(function(frag, index2) {
            if ($eaedee612a754baf$var$isNumeric(frag)) offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
        });
    });
    return offsets;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */ function $eaedee612a754baf$var$offset(data, _ref) {
    var offset = _ref.offset;
    var placement = data.placement, _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var basePlacement = placement.split('-')[0];
    var offsets = void 0;
    if ($eaedee612a754baf$var$isNumeric(+offset)) offsets = [
        +offset,
        0
    ];
    else offsets = $eaedee612a754baf$var$parseOffset(offset, popper, reference, basePlacement);
    if (basePlacement === 'left') {
        popper.top += offsets[0];
        popper.left -= offsets[1];
    } else if (basePlacement === 'right') {
        popper.top += offsets[0];
        popper.left += offsets[1];
    } else if (basePlacement === 'top') {
        popper.left += offsets[0];
        popper.top -= offsets[1];
    } else if (basePlacement === 'bottom') {
        popper.left += offsets[0];
        popper.top += offsets[1];
    }
    data.popper = popper;
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $eaedee612a754baf$var$preventOverflow(data, options) {
    var boundariesElement = options.boundariesElement || $eaedee612a754baf$var$getOffsetParent(data.instance.popper);
    // If offsetParent is the reference element, we really want to
    // go one step up and use the next offsetParent as reference to
    // avoid to make this modifier completely useless and look like broken
    if (data.instance.reference === boundariesElement) boundariesElement = $eaedee612a754baf$var$getOffsetParent(boundariesElement);
    // NOTE: DOM access here
    // resets the popper's position so that the document size can be calculated excluding
    // the size of the popper element itself
    var transformProp = $eaedee612a754baf$var$getSupportedPropertyName('transform');
    var popperStyles = data.instance.popper.style; // assignment to help minification
    var top = popperStyles.top, left = popperStyles.left, transform = popperStyles[transformProp];
    popperStyles.top = '';
    popperStyles.left = '';
    popperStyles[transformProp] = '';
    var boundaries = $eaedee612a754baf$var$getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);
    // NOTE: DOM access here
    // restores the original style properties after the offsets have been computed
    popperStyles.top = top;
    popperStyles.left = left;
    popperStyles[transformProp] = transform;
    options.boundaries = boundaries;
    var order = options.priority;
    var popper = data.offsets.popper;
    var check = {
        primary: function primary(placement) {
            var value = popper[placement];
            if (popper[placement] < boundaries[placement] && !options.escapeWithReference) value = Math.max(popper[placement], boundaries[placement]);
            return $eaedee612a754baf$var$defineProperty({}, placement, value);
        },
        secondary: function secondary(placement) {
            var mainSide = placement === 'right' ? 'left' : 'top';
            var value = popper[mainSide];
            if (popper[placement] > boundaries[placement] && !options.escapeWithReference) value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
            return $eaedee612a754baf$var$defineProperty({}, mainSide, value);
        }
    };
    order.forEach(function(placement) {
        var side = [
            'left',
            'top'
        ].indexOf(placement) !== -1 ? 'primary' : 'secondary';
        popper = $eaedee612a754baf$var$_extends({}, popper, check[side](placement));
    });
    data.offsets.popper = popper;
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $eaedee612a754baf$var$shift(data) {
    var placement = data.placement;
    var basePlacement = placement.split('-')[0];
    var shiftvariation = placement.split('-')[1];
    // if shift shiftvariation is specified, run the modifier
    if (shiftvariation) {
        var _data$offsets = data.offsets, reference = _data$offsets.reference, popper = _data$offsets.popper;
        var isVertical = [
            'bottom',
            'top'
        ].indexOf(basePlacement) !== -1;
        var side = isVertical ? 'left' : 'top';
        var measurement = isVertical ? 'width' : 'height';
        var shiftOffsets = {
            start: $eaedee612a754baf$var$defineProperty({}, side, reference[side]),
            end: $eaedee612a754baf$var$defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
        };
        data.offsets.popper = $eaedee612a754baf$var$_extends({}, popper, shiftOffsets[shiftvariation]);
    }
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $eaedee612a754baf$var$hide(data) {
    if (!$eaedee612a754baf$var$isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) return data;
    var refRect = data.offsets.reference;
    var bound = $eaedee612a754baf$var$find(data.instance.modifiers, function(modifier) {
        return modifier.name === 'preventOverflow';
    }).boundaries;
    if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
        // Avoid unnecessary DOM access if visibility hasn't changed
        if (data.hide === true) return data;
        data.hide = true;
        data.attributes['x-out-of-boundaries'] = '';
    } else {
        // Avoid unnecessary DOM access if visibility hasn't changed
        if (data.hide === false) return data;
        data.hide = false;
        data.attributes['x-out-of-boundaries'] = false;
    }
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $eaedee612a754baf$var$inner(data) {
    var placement = data.placement;
    var basePlacement = placement.split('-')[0];
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var isHoriz = [
        'left',
        'right'
    ].indexOf(basePlacement) !== -1;
    var subtractLength = [
        'top',
        'left'
    ].indexOf(basePlacement) === -1;
    popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);
    data.placement = $eaedee612a754baf$var$getOppositePlacement(placement);
    data.offsets.popper = $eaedee612a754baf$var$getClientRect(popper);
    return data;
}
/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */ /**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */ var $eaedee612a754baf$var$modifiers = {
    /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */ shift: {
        /** @prop {number} order=100 - Index used to define the order of execution */ order: 100,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $eaedee612a754baf$var$shift
    },
    /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */ offset: {
        /** @prop {number} order=200 - Index used to define the order of execution */ order: 200,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $eaedee612a754baf$var$offset,
        /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */ offset: 0
    },
    /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */ preventOverflow: {
        /** @prop {number} order=300 - Index used to define the order of execution */ order: 300,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $eaedee612a754baf$var$preventOverflow,
        /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */ priority: [
            'left',
            'right',
            'top',
            'bottom'
        ],
        /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */ padding: 5,
        /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */ boundariesElement: 'scrollParent'
    },
    /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */ keepTogether: {
        /** @prop {number} order=400 - Index used to define the order of execution */ order: 400,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $eaedee612a754baf$var$keepTogether
    },
    /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */ arrow: {
        /** @prop {number} order=500 - Index used to define the order of execution */ order: 500,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $eaedee612a754baf$var$arrow,
        /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */ element: '[x-arrow]'
    },
    /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */ flip: {
        /** @prop {number} order=600 - Index used to define the order of execution */ order: 600,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $eaedee612a754baf$var$flip,
        /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */ behavior: 'flip',
        /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */ padding: 5,
        /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */ boundariesElement: 'viewport',
        /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */ flipVariations: false,
        /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */ flipVariationsByContent: false
    },
    /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */ inner: {
        /** @prop {number} order=700 - Index used to define the order of execution */ order: 700,
        /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */ enabled: false,
        /** @prop {ModifierFn} */ fn: $eaedee612a754baf$var$inner
    },
    /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */ hide: {
        /** @prop {number} order=800 - Index used to define the order of execution */ order: 800,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $eaedee612a754baf$var$hide
    },
    /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */ computeStyle: {
        /** @prop {number} order=850 - Index used to define the order of execution */ order: 850,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $eaedee612a754baf$var$computeStyle,
        /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */ gpuAcceleration: true,
        /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */ x: 'bottom',
        /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */ y: 'right'
    },
    /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */ applyStyle: {
        /** @prop {number} order=900 - Index used to define the order of execution */ order: 900,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $eaedee612a754baf$var$applyStyle,
        /** @prop {Function} */ onLoad: $eaedee612a754baf$var$applyStyleOnLoad,
        /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */ gpuAcceleration: undefined
    }
};
/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */ /**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */ var $eaedee612a754baf$var$Defaults = {
    /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */ placement: 'bottom',
    /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */ positionFixed: false,
    /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */ eventsEnabled: true,
    /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */ removeOnDestroy: false,
    /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */ onCreate: function onCreate() {},
    /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */ onUpdate: function onUpdate() {},
    /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */ modifiers: $eaedee612a754baf$var$modifiers
};
/**
 * @callback onCreate
 * @param {dataObject} data
 */ /**
 * @callback onUpdate
 * @param {dataObject} data
 */ // Utils
// Methods
var $eaedee612a754baf$var$Popper = function() {
    /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */ function Popper(reference, popper) {
        var _this = this;
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        $eaedee612a754baf$var$classCallCheck(this, Popper);
        this.scheduleUpdate = function() {
            return requestAnimationFrame(_this.update);
        };
        // make update() debounced, so that it only runs at most once-per-tick
        this.update = $eaedee612a754baf$var$debounce(this.update.bind(this));
        // with {} we create a new object with the options inside it
        this.options = $eaedee612a754baf$var$_extends({}, Popper.Defaults, options);
        // init state
        this.state = {
            isDestroyed: false,
            isCreated: false,
            scrollParents: []
        };
        // get reference and popper elements (allow jQuery wrappers)
        this.reference = reference && reference.jquery ? reference[0] : reference;
        this.popper = popper && popper.jquery ? popper[0] : popper;
        // Deep merge modifiers options
        this.options.modifiers = {};
        Object.keys($eaedee612a754baf$var$_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function(name) {
            _this.options.modifiers[name] = $eaedee612a754baf$var$_extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
        });
        // Refactoring modifiers' list (Object => Array)
        this.modifiers = Object.keys(this.options.modifiers).map(function(name) {
            return $eaedee612a754baf$var$_extends({
                name: name
            }, _this.options.modifiers[name]);
        })// sort the modifiers by order
        .sort(function(a, b) {
            return a.order - b.order;
        });
        // modifiers have the ability to execute arbitrary code when Popper.js get inited
        // such code is executed in the same order of its modifier
        // they could add new properties to their options configuration
        // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
        this.modifiers.forEach(function(modifierOptions) {
            if (modifierOptions.enabled && $eaedee612a754baf$var$isFunction(modifierOptions.onLoad)) modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
        });
        // fire the first update to position the popper in the right place
        this.update();
        var eventsEnabled = this.options.eventsEnabled;
        if (eventsEnabled) // setup event listeners, they will take care of update the position in specific situations
        this.enableEventListeners();
        this.state.eventsEnabled = eventsEnabled;
    }
    // We can't use class properties because they don't get listed in the
    // class prototype and break stuff like Sinon stubs
    $eaedee612a754baf$var$createClass(Popper, [
        {
            key: 'update',
            value: function update$$1() {
                return $eaedee612a754baf$var$update.call(this);
            }
        },
        {
            key: 'destroy',
            value: function destroy$$1() {
                return $eaedee612a754baf$var$destroy.call(this);
            }
        },
        {
            key: 'enableEventListeners',
            value: function enableEventListeners$$1() {
                return $eaedee612a754baf$var$enableEventListeners.call(this);
            }
        },
        {
            key: 'disableEventListeners',
            value: function disableEventListeners$$1() {
                return $eaedee612a754baf$var$disableEventListeners.call(this);
            }
        }
    ]);
    return Popper;
}();
/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */ $eaedee612a754baf$var$Popper.Utils = (typeof window !== 'undefined' ? window : $parcel$global).PopperUtils;
$eaedee612a754baf$var$Popper.placements = $eaedee612a754baf$var$placements;
$eaedee612a754baf$var$Popper.Defaults = $eaedee612a754baf$var$Defaults;
var $eaedee612a754baf$export$2e2bcd8739ae039 = $eaedee612a754baf$var$Popper;



var $2P8Ax = parcelRequire("2P8Ax");

const $6cee9a0dd9b96167$export$f6c90e9517ee2ce0 = {
    values: [
        'top left',
        'top center',
        'top right',
        'right top',
        'right middle',
        'right bottom',
        'bottom left',
        'bottom center',
        'bottom right',
        'left top',
        'left middle',
        'left bottom'
    ],
    default: 'right middle'
};


const $a7f0f3117eb1eaf9$var$positionMap = {
    'top left': {
        position: 'top-start',
        animation: 'top'
    },
    'top center': {
        position: 'top',
        animation: 'top'
    },
    'top right': {
        position: 'top-end',
        animation: 'top'
    },
    'right top': {
        position: 'right-start',
        animation: 'right'
    },
    'right middle': {
        position: 'right',
        animation: 'right'
    },
    'right bottom': {
        position: 'right-end',
        animation: 'right'
    },
    'bottom left': {
        position: 'bottom-start',
        animation: 'bottom'
    },
    'bottom center': {
        position: 'bottom',
        animation: 'bottom'
    },
    'bottom right': {
        position: 'bottom-end',
        animation: 'bottom'
    },
    'left top': {
        position: 'left-start',
        animation: 'left'
    },
    'left middle': {
        position: 'left',
        animation: 'left'
    },
    'left bottom': {
        position: 'left-end',
        animation: 'left'
    }
};
function $a7f0f3117eb1eaf9$var$positionToPopper(position) {
    return position && $a7f0f3117eb1eaf9$var$positionMap[position] ? $a7f0f3117eb1eaf9$var$positionMap[position].position : null;
}
function $a7f0f3117eb1eaf9$export$9e6a7c92c66a7cdd(position) {
    return $a7f0f3117eb1eaf9$var$positionToPopper(position) || $a7f0f3117eb1eaf9$var$positionMap[(0, $6cee9a0dd9b96167$export$f6c90e9517ee2ce0).default].position;
} // eslint-disable-next-line @atlaskit/editor/no-re-export


const $a18e186cf79a4970$var$defaultState = {
    hasExtractedStyles: false,
    // We set these default offsets to prevent a flash of popper content in the wrong position
    // which can cause incorrect height calculations. Popper will calculate these values
    offsets: {
        popper: {
            left: -9999,
            top: -9999,
            position: null
        }
    },
    cssPosition: 'absolute',
    originalHeight: null,
    maxHeight: null
};
class $a18e186cf79a4970$export$2e2bcd8739ae039 extends (0, $42omo.Component) {
    componentDidMount() {
        this.applyPopper(this.props);
    }
    componentDidUpdate(prevProps, prevState) {
        const { onPositioned: onPositioned } = this.props;
        const { hasExtractedStyles: hasExtractedStyles } = this.state;
        if (this.props !== prevProps) this.applyPopper(this.props);
        // This flag is set the first time the position is calculated from Popper and applied to the content
        if (!prevState.hasExtractedStyles && hasExtractedStyles && onPositioned) onPositioned();
    }
    componentWillUnmount() {
        // this.extractStyles.cancel();
        if (this.popper) this.popper.destroy();
    }
    /* Calculate the max height of the popper if it's height is greater than the viewport to prevent
   * the bottom of the popper not being viewable.
   * Only works if the popper uses viewport as the boundary and has a fixed position ancestor.
   */ calculateMaxHeight(originalHeight, currentHeight, positionTop, cssPosition) {
        let DocumentElementClientHeight = 0;
        if (document.documentElement) DocumentElementClientHeight = document.documentElement.clientHeight;
        if (cssPosition !== 'fixed') return null;
        const viewportHeight = Math.max(DocumentElementClientHeight, window.innerHeight || 0);
        return viewportHeight < originalHeight && currentHeight + positionTop >= viewportHeight - 50 ? // allow some spacing either side of viewport height
        viewportHeight - 12 : null;
    }
    applyPopper(props) {
        if (!this.targetRef.current || !this.contentRef.current) return;
        if (this.popper) this.popper.destroy();
        // "new Popper(...)" operation is very expensive when called on virtual DOM.
        // This condition reduces the number of calls so we can run our tests faster
        // (time was reduced from 100s to 13s).
        if (!props.content) return;
        // we wrap our target in a div so that we can safely get a reference to it, but we pass the
        // actual target to popper
        const isAlwaysFixed = false;
        const actualTarget = this.targetRef.current.children[0];
        const popperOpts = {
            placement: (0, $a7f0f3117eb1eaf9$export$9e6a7c92c66a7cdd)(props.position),
            onCreate: this.extractStyles,
            onUpdate: this.extractStyles,
            modifiers: {
                applyStyle: {
                    enabled: false
                },
                hide: {
                    enabled: false
                },
                offset: {
                    enabled: true,
                    offset: this.props.offset
                },
                flip: {
                    enabled: false,
                    flipVariations: true,
                    boundariesElement: 'viewport',
                    padding: 0 // leave 0 pixels between popper and the boundariesElement
                },
                preventOverflow: {
                    enabled: false,
                    escapeWithReference: true
                }
            },
            positionFixed: isAlwaysFixed
        };
        if (actualTarget) this.popper = new (0, $eaedee612a754baf$export$2e2bcd8739ae039)(actualTarget, this.contentRef.current, popperOpts);
    }
    render() {
        const { transform: transform, hasExtractedStyles: hasExtractedStyles, maxHeight: maxHeight } = this.state;
        const opacity = hasExtractedStyles ? {} : {
            opacity: 0
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-vc": "MFkS-Q2E"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            ref: this.targetRef
        }, this.props.children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            ref: this.contentRef,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                top: 0,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                left: 0,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                position: 'absolute',
                transform: // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                transform,
                maxHeight: maxHeight ? maxHeight : 'auto',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                ...opacity
            }
        }, this.props.content));
    }
    constructor(props){
        super(props);
        this.popper = void 0;
        this.targetRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
        this.contentRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
        this.extractStyles = (state)=>{
            if (state) {
                const popperHeight = state.offsets.popper.height;
                const left = Math.round(state.offsets.popper.left);
                const top = Math.round(state.offsets.popper.top);
                const cssPosition = 'absolute';
                const originalHeight = this.state.originalHeight || popperHeight;
                const maxHeight = this.calculateMaxHeight(originalHeight, popperHeight, top, cssPosition);
                this.setState({
                    cssPosition: // position: fixed or absolute
                    cssPosition,
                    hasExtractedStyles: true,
                    transform: `translate3d(${left}px, ${top}px, 0px)`,
                    originalHeight: originalHeight,
                    maxHeight: maxHeight
                });
            }
        };
        this.state = $a18e186cf79a4970$var$defaultState;
        this.extractStyles = (0, $2P8Ax.default)(this.extractStyles.bind(this));
    }
}
// working with extract-react-types
$a18e186cf79a4970$export$2e2bcd8739ae039.defaultProps = {
    boundariesElement: 'viewport',
    children: null,
    content: null,
    offset: '0, 0',
    position: 'right middle',
    zIndex: 400,
    lockScroll: false,
    isAlwaysFixed: false,
    onPositioned: ()=>{}
};


const $62f832e6cddceac5$var$packageName = "platform-pkg";
const $62f832e6cddceac5$var$packageVersion = "0.0.0-use.local";
const $62f832e6cddceac5$var$halfFocusRing = 1;
const $62f832e6cddceac5$var$dropOffset = '0, 8';
const $62f832e6cddceac5$var$fadeIn = (0, $9K4OG.keyframes)({
    '0%': {
        opacity: 0
    },
    '100%': {
        opacity: 1
    }
});
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $62f832e6cddceac5$var$DropList extends (0, $42omo.Component) {
    render() {
        const { children: children, isOpen: isOpen, position: position, trigger: trigger, onPositioned: onPositioned, testId: testId, id: id } = this.props;
        const layerContent = isOpen ? /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: this.menuWrapper,
            "data-role": "droplistContent",
            "data-testid": testId && `${testId}--content`,
            ref: this.handleContentRef,
            id: id,
            role: "presentation"
        }, children) : null;
        return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: [
                this.wrapperStyles,
                (0, $dh538.fg)('p2m-drop-down-motion') && this.motionStyles
            ],
            ref: this.handleDroplistRef,
            "data-vc": "LiS2-0O4"
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $a18e186cf79a4970$export$2e2bcd8739ae039), {
            content: layerContent,
            offset: $62f832e6cddceac5$var$dropOffset,
            position: position,
            onPositioned: onPositioned
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: [
                this.triggerStyles,
                (0, $dh538.fg)('p2m-drop-down-motion') && this.motionStyles
            ],
            ref: this.handleTriggerRef
        }, trigger)));
    }
    constructor(...args){
        super(...args);
        this.dropContentRef = void 0;
        this.triggerRef = void 0;
        this.wrapperStyles = /*#__PURE__*/ (0, $9K4OG.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            display: this.props.shouldFitContainer ? 'block' : 'inline-flex',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            flex: this.props.shouldFitContainer ? '1 1 auto' : undefined,
            transitionDuration: '0.2s',
            transition: 'box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)'
        });
        this.triggerStyles = /*#__PURE__*/ (0, $9K4OG.css)({
            transitionDuration: '0.2s',
            transition: 'box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            display: this.props.shouldFitContainer ? 'block' : 'inline-flex',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            boxSizing: this.props.shouldFitContainer ? 'border-box' : undefined
        });
        this.motionStyles = /*#__PURE__*/ (0, $9K4OG.css)({
            animationName: `${$62f832e6cddceac5$var$fadeIn}`,
            animationDuration: '360ms',
            animationTimingFunction: 'cubic-bezier(0.8, 0, 0, 1)'
        });
        /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ this.menuWrapper = ()=>{
            return /*#__PURE__*/ (0, $9K4OG.css)({
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-surface-overlay, #FFFFFF)",
                borderRadius: "var(--ds-radius-small, 3px)",
                boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)",
                boxSizing: 'border-box',
                overflow: 'auto',
                padding: `${"var(--ds-space-050, 4px)"} 0`,
                maxHeight: '90vh'
            });
        };
        /* eslint-enable @atlaskit/design-system/ensure-design-token-usage */ this.componentDidMount = ()=>{
            this.setContentWidth();
            // We use a captured event here to avoid a radio or checkbox dropdown item firing its
            // click event first, which would cause a re-render of the element and prevent DropList
            // from detecting the actual source of this original click event.
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('click', this.handleClickOutside, true);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('keydown', this.handleEsc);
        };
        this.componentDidUpdate = ()=>{
            if (this.props.isOpen) this.setContentWidth();
        };
        this.componentWillUnmount = ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('click', this.handleClickOutside, true);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('keydown', this.handleEsc);
        };
        this.setContentWidth = ()=>{
            const { dropContentRef: dropContentRef, triggerRef: triggerRef } = this;
            const { shouldFitContainer: shouldFitContainer } = this.props;
            // We need to manually set the content width to match the trigger width
            if (shouldFitContainer && dropContentRef && triggerRef) dropContentRef.style.width = `${triggerRef.offsetWidth - $62f832e6cddceac5$var$halfFocusRing * 2}px`;
        };
        this.handleEsc = (event)=>{
            if ((event.key === 'Escape' || event.key === 'Esc') && this.props.isOpen) this.close(event);
        };
        this.handleClickOutside = (event)=>{
            if (this.props.isOpen) {
                if (event.target instanceof Node) {
                    // Rather than check for the target within the entire DropList, we specify the trigger/content.
                    // This aids with future effort in scroll-locking DropList when isMenuFixed is enabled; the scroll
                    // blanket which stretches to the viewport should not stop 'close' from being triggered.
                    const withinTrigger = this.triggerRef && this.triggerRef.contains(event.target);
                    const withinContent = this.dropContentRef && this.dropContentRef.contains(event.target);
                    if (!withinTrigger && !withinContent) this.close(event);
                }
            }
        };
        this.close = (event)=>{
            if (this.props.onOpenChange) this.props.onOpenChange({
                isOpen: false,
                event: event
            });
        };
        this.handleContentRef = (ref)=>{
            this.dropContentRef = ref;
            // If the dropdown has just been opened, we focus on the containing element so the
            // user can tab to the first dropdown item. We will only receive this ref if isOpen
            // is true or null, so no need to check for truthiness here.
            if (ref) ref.focus();
        };
        this.handleDroplistRef = (ref)=>{
            this.props.onDroplistRef?.(ref);
        };
        this.handleTriggerRef = (ref)=>{
            this.triggerRef = ref;
        };
    }
}
const $62f832e6cddceac5$var$createAndFireEventOnAtlaskit = (0, $eWRwJ.default)('atlaskit');
const $62f832e6cddceac5$var$_default_1 = (0, $ggbZE.default)({
    componentName: 'droplist',
    packageName: $62f832e6cddceac5$var$packageName,
    packageVersion: $62f832e6cddceac5$var$packageVersion
})((0, $1DWH0.default)({
    onOpenChange: $62f832e6cddceac5$var$createAndFireEventOnAtlaskit({
        action: 'toggled',
        actionSubject: 'droplist',
        attributes: {
            componentName: 'droplist',
            packageName: $62f832e6cddceac5$var$packageName,
            packageVersion: $62f832e6cddceac5$var$packageVersion
        }
    })
})($62f832e6cddceac5$var$DropList));
var $62f832e6cddceac5$export$2e2bcd8739ae039 = $62f832e6cddceac5$var$_default_1;
module.exports["default"] = $62f832e6cddceac5$export$2e2bcd8739ae039;

});

parcelRegister("a4eZN", function(module, exports) {
// If you make any change here, copy it to above file as well
// and notify about the change in #team-fc-editor-ai-dev channel.
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $k7eoe = parcelRequire("k7eoe");


var $3gadb = parcelRequire("3gadb");


var $d925B = parcelRequire("d925B");


var $hgeg8 = parcelRequire("hgeg8");

// If you make any change here, copy it to above file as well
//  and notify about the change in #team-fc-editor-ai-dev channel.




var $eEA8O = parcelRequire("eEA8O");


var $1oCLl = parcelRequire("1oCLl");

const $689b30c0c5181ae3$var$toolbarButtonStyle = {
    alignItems: 'center'
};
const $689b30c0c5181ae3$var$_default_1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef((props, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        ref: ref,
        ...props,
        // Ignored via go/ees007
        // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
        // TODO: (from codemod) Buttons with "component", "css" or "style" prop can't be automatically migrated with codemods. Please migrate it manually.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: (0, $1oCLl.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? $689b30c0c5181ae3$var$toolbarButtonStyle : {
            alignItems: 'center'
        }
    });
});
var $689b30c0c5181ae3$export$2e2bcd8739ae039 = $689b30c0c5181ae3$var$_default_1;


function $898f5a6e67cc11a0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $898f5a6e67cc11a0$var$buttonWrapper = {
    name: "15currb",
    styles: "display:flex;height:100%"
};
const $898f5a6e67cc11a0$var$ToolbarButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef((props, ref)=>{
    const { buttonId: buttonId, testId: testId, className: className = '', href: href, iconAfter: iconAfter, iconBefore: iconBefore, disabled: disabled, selected: selected, spacing: spacing, target: target, children: children, hideTooltip: hideTooltip, title: title, keymap: keymap, titlePosition: titlePosition = 'top', item: item, rel: rel, 'aria-label': ariaLabel, 'aria-haspopup': ariaHasPopup, 'aria-expanded': ariaExpanded, 'aria-pressed': ariaPressed, 'aria-keyshortcuts': ariaKeyShortcuts, 'aria-controls': ariaControls, 'data-ds--level': dataDsLevel, onClick: onClick, onKeyDown: onKeyDown, onItemClick: onItemClick, onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave } = props;
    const handleClick = (0, $42omo.useCallback)((event, analyticsEvent)=>{
        if (disabled) return;
        if (buttonId) analyticsEvent.update((payload)=>({
                ...payload,
                action: (0, $d925B.ACTION).CLICKED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TOOLBAR_BUTTON,
                actionSubjectId: buttonId,
                eventType: (0, $d925B.EVENT_TYPE).UI
            })).fire((0, $k7eoe.FabricChannel).editor);
        if (onClick) onClick(event);
        if (item && onItemClick) onItemClick(item);
    }, [
        disabled,
        onClick,
        onItemClick,
        item,
        buttonId
    ]);
    const button = /*#__PURE__*/ (0, $9K4OG.jsx)((0, $689b30c0c5181ae3$export$2e2bcd8739ae039), {
        ref: ref,
        appearance: "subtle",
        testId: testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        href: href,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isDisabled: disabled,
        isSelected: selected,
        onClick: handleClick,
        spacing: spacing || 'default',
        target: target,
        shouldFitContainer: true,
        "aria-expanded": ariaExpanded,
        "aria-controls": ariaControls,
        "aria-haspopup": ariaHasPopup,
        "aria-label": ariaLabel,
        "aria-pressed": ariaPressed,
        "aria-keyshortcuts": ariaKeyShortcuts,
        onKeyDown: onKeyDown,
        onFocus: onFocus,
        onBlur: onBlur,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        "data-ds--level": dataDsLevel,
        rel: rel
    }, children);
    if (!title) return button;
    const tooltipContent = hideTooltip ? null : /*#__PURE__*/ (0, $9K4OG.jsx)((0, $hgeg8.ToolTipContent), {
        description: title,
        keymap: keymap
    });
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3gadb.default), {
        content: tooltipContent,
        hideTooltipOnClick: true,
        position: titlePosition
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $898f5a6e67cc11a0$var$buttonWrapper,
        "data-vc": "fEl1ytBB"
    }, button));
});
var $898f5a6e67cc11a0$export$2e2bcd8739ae039 = $898f5a6e67cc11a0$var$ToolbarButton;
module.exports["default"] = $898f5a6e67cc11a0$export$2e2bcd8739ae039;

});

parcelRegister("6f5RK", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $aFUXX = parcelRequire("aFUXX");

const $b18eedfe6bddbc21$export$297e5814a2c821bb = /*#__PURE__*/ (0, $9K4OG.css)("background-color:var(--ds-background-neutral, #0515240F);color:var(--ds-text-subtle, #505258);border-radius:var(--ds-radius-small, 3px);padding:var(--ds-space-050, 4px);line-height:12px;font-size:", (0, $aFUXX.relativeFontSizeToBase16)(11.67), ";align-self:flex-end;@media (max-width: ", (0, $aFUXX.akEditorMobileMaxWidth), "px){display:none;}");
module.exports["shortcutStyle"] = $b18eedfe6bddbc21$export$297e5814a2c821bb;

});

parcelRegister("7rj2U", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4HD7y = parcelRequire("4HD7y");


var $d925B = parcelRequire("d925B");


var $btNLq = parcelRequire("btNLq");

var $gEb6G = parcelRequire("gEb6G");


var $2UWDO = parcelRequire("2UWDO");


var $3pLGZ = parcelRequire("3pLGZ");


var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");


var $dZ8uq = parcelRequire("dZ8uq");


var $iu6m9 = parcelRequire("iu6m9");




var $e2wMq = parcelRequire("e2wMq");


var $cMZNY = parcelRequire("cMZNY");


var $dNXVc = parcelRequire("dNXVc");


var $dAtrv = parcelRequire("dAtrv");


var $zT4ZO = parcelRequire("zT4ZO");


var $gmyMu = parcelRequire("gmyMu");


var $enBNf = parcelRequire("enBNf");


var $ks2lK = parcelRequire("ks2lK");


var $8m4tT = parcelRequire("8m4tT");







const $88b7294e6fc1bbcd$export$92a1a3b7554e9387 = {
    CLEAR_FORMAT_CODE_ERROR: 'CLEAR_FORMAT_CODE_ERROR',
    REMOVE_AUTO_DETECT_ENTRY: 'REMOVE_AUTO_DETECT_ENTRY',
    RESOLVE_FORMAT_CODE: 'RESOLVE_FORMAT_CODE',
    SET_AUTO_DETECT_ENTRY: 'SET_AUTO_DETECT_ENTRY',
    SET_COPIED_TO_CLIPBOARD: 'SET_COPIED_TO_CLIPBOARD',
    SET_IS_WRAPPED: 'SET_IS_WRAPPED',
    SET_SHOULD_IGNORE_FOLLOWING_MUTATIONS: 'SET_SHOULD_IGNORE_FOLLOWING_MUTATIONS',
    START_FORMAT_CODE: 'START_FORMAT_CODE'
};





const $0f30d43ffc94b135$export$264979d19e499e37 = new (0, $ks2lK.PluginKey)('codeBlockAutoDetectPlugin');
const $0f30d43ffc94b135$export$62e9b65dae1e4e8f = (state)=>$0f30d43ffc94b135$export$264979d19e499e37.getState(state);



var $kgnzE = parcelRequire("kgnzE");


var $1S4f7 = parcelRequire("1S4f7");





var $ftzrq = parcelRequire("ftzrq");

const $81cbafd47e9e3d55$export$97324d26e7dfa2c5 = new (0, $ks2lK.PluginKey)('codeBlockCopySelectionPlugin');
function $81cbafd47e9e3d55$var$getSelectionDecorationStartAndEnd({ state: state, transaction: transaction }) {
    const codeBlockNode = (0, $kgnzE.getSelectedNodeOrNodeParentByNodeType)({
        nodeType: state.schema.nodes.codeBlock,
        selection: transaction.selection
    });
    if (!codeBlockNode) return {
        decorationStartAndEnd: undefined,
        codeBlockNode: undefined
    };
    const decorationStartAndEnd = [
        codeBlockNode.start,
        codeBlockNode.start + codeBlockNode.node.nodeSize
    ];
    return {
        decorationStartAndEnd: decorationStartAndEnd,
        codeBlockNode: codeBlockNode.node
    };
}
function $81cbafd47e9e3d55$export$bf11b3ffc9027f6b() {
    return new (0, $1S4f7.SafePlugin)({
        key: $81cbafd47e9e3d55$export$97324d26e7dfa2c5,
        state: {
            init () {
                return {
                    decorationStartAndEnd: undefined
                };
            },
            apply (transaction, currentCodeBlockCopySelectionPluginState, _oldState, newState) {
                switch(transaction.getMeta($81cbafd47e9e3d55$export$97324d26e7dfa2c5)){
                    case 'show-selection':
                        return $81cbafd47e9e3d55$var$getSelectionDecorationStartAndEnd({
                            state: newState,
                            transaction: transaction
                        });
                    case 'remove-selection':
                        return {
                            decorationStartAndEnd: undefined
                        };
                    default:
                        // The contents of the code block can change while the selection is being shown
                        // (either from collab edits -- or from the user continuing to type while hovering
                        // the mouse over the copy button).
                        // This ensures the selection is updated in these cases.
                        if (currentCodeBlockCopySelectionPluginState.decorationStartAndEnd !== undefined) return $81cbafd47e9e3d55$var$getSelectionDecorationStartAndEnd({
                            state: newState,
                            transaction: transaction
                        });
                        return currentCodeBlockCopySelectionPluginState;
                }
            }
        },
        props: {
            decorations (state) {
                if ($81cbafd47e9e3d55$export$97324d26e7dfa2c5.getState(state).decorationStartAndEnd) {
                    const [start, end] = $81cbafd47e9e3d55$export$97324d26e7dfa2c5.getState(state).decorationStartAndEnd;
                    return (0, $ftzrq.DecorationSet).create(state.doc, [
                        (0, $ftzrq.Decoration).inline(start, end, {
                            class: 'ProseMirror-fake-text-selection'
                        })
                    ]);
                }
                return (0, $ftzrq.DecorationSet).empty;
            }
        }
    });
}
function $81cbafd47e9e3d55$export$73dae478fefb96e(state, dispatch) {
    const tr = state.tr;
    tr.setMeta($81cbafd47e9e3d55$export$97324d26e7dfa2c5, 'show-selection');
    // note: dispatch should always be defined when called from the
    // floating toolbar. Howver the Command type which the floating toolbar
    // uses suggests it's optional.
    // Using the type here to protect against future refactors of the
    // floating toolbar
    if (dispatch) dispatch(tr);
    return true;
}
function $81cbafd47e9e3d55$export$1ec425a919cc0ea(state, dispatch) {
    const tr = state.tr;
    tr.setMeta($81cbafd47e9e3d55$export$97324d26e7dfa2c5, 'remove-selection');
    // note: dispatch should always be defined when called from the
    // floating toolbar. Howver the Command type which the floating toolbar
    // uses suggests it's optional.
    // Using the type here to protect against future refactors of the
    // floating toolbar
    if (dispatch) dispatch(tr);
    return true;
}





const $3848854553e34219$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('codeBlockPlugin');



var $adhil = parcelRequire("adhil");


var $3Ter7 = parcelRequire("3Ter7");

var $dIxHZ = parcelRequire("dIxHZ");


var $5SAOw = parcelRequire("5SAOw");




function $53e4a41e0689db18$export$92adcb8baa0906a6(state, start, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
attrs) {
    const startOfCodeBlockText = state.selection.$from;
    const endPosition = state.selection.empty && !(state.selection instanceof (0, $adhil.GapCursorSelection)) ? startOfCodeBlockText.end() : state.selection.$to.pos;
    const startLinePosition = startOfCodeBlockText.start();
    //when cmd+A is used to select the content. start position should be 0.
    const parentStartPosition = startOfCodeBlockText.depth === 0 ? 0 : startOfCodeBlockText.before();
    const contentSlice = state.doc.slice(startOfCodeBlockText.pos, endPosition);
    const codeBlockSlice = (0, $3Ter7.mapSlice)(contentSlice, (node, parent, index)=>{
        if (node.type === state.schema.nodes.hardBreak) return state.schema.text('\n');
        if (node.isText) return node.mark([]);
        if (node.isInline) {
            // Convert dates
            if (node.attrs.timestamp) return state.schema.text((0, $dIxHZ.timestampToString)(node.attrs.timestamp, null));
            // Convert links
            if (node.attrs.url) return state.schema.text(node.attrs.url);
            return node.attrs.text ? state.schema.text(node.attrs.text) : null;
        }
        // if the current node is the last child of the Slice exit early to prevent
        // adding additional line breaks
        if (contentSlice.content.childCount - 1 === index) return node.content;
        //useful to decide whether to append line breaks when the content has list items.
        const isParentLastChild = parent && contentSlice.content.childCount - 1 === index;
        // add line breaks at the end of each paragraph to mimic layout of selected content
        // do not add line breaks when the 'paragraph' parent is last child.
        if (node.content.childCount && node.type === state.schema.nodes.paragraph && !isParentLastChild) return node.content.append((0, $5SAOw.Fragment).from(state.schema.text('\n\n')));
        return node.content.childCount ? node.content : null;
    });
    const tr = state.tr;
    // Replace current block node
    const startMapped = startLinePosition === start ? parentStartPosition : start;
    const codeBlock = state.schema.nodes.codeBlock;
    const codeBlockNode = codeBlock.createChecked(attrs, codeBlockSlice.content);
    tr.replaceWith(startMapped, Math.min(endPosition, tr.doc.content.size), codeBlockNode);
    // Reposition cursor when inserting into layouts or table headers
    const mapped = tr.doc.resolve(tr.mapping.map(startMapped) + 1);
    const selection = (0, $ks2lK.TextSelection).findFrom(mapped, state.selection instanceof (0, $adhil.GapCursorSelection) ? -1 : 1, true);
    if (selection) return tr.setSelection(selection);
    return tr.setSelection((0, $ks2lK.TextSelection).create(tr.doc, Math.min(start + startOfCodeBlockText.node().nodeSize - 1, tr.doc.content.size)));
}
function $53e4a41e0689db18$export$4b5d5858845bfcf6(state) {
    // Before a document is loaded, there is no selection.
    if (!state.selection) return false;
    const { $from: $from } = state.selection;
    const node = $from.parent;
    if (!node.isTextblock || node.type === state.schema.nodes.codeBlock) return false;
    const parentDepth = $from.depth - 1;
    const parentNode = $from.node(parentDepth);
    const index = $from.index(parentDepth);
    return parentNode.canReplaceWith(index, index + 1, state.schema.nodes.codeBlock);
}





function $60a45f8e35213e68$export$da3f040fb23d21f(selection) {
    return selection.$cursor || undefined;
}
function $60a45f8e35213e68$export$f43d710a87ced169(state) {
    const codeBlockNodes = [];
    state.doc.descendants((node, pos)=>{
        if (node.type === state.schema.nodes.codeBlock) {
            codeBlockNodes.push({
                node: node,
                pos: pos
            });
            return false;
        }
        return true;
    });
    return codeBlockNodes;
}
function $60a45f8e35213e68$export$3fa3c149b89781e7(tr) {
    const changedCodeBlocks = [];
    const nodePositions = new Set();
    tr.steps.forEach((step)=>{
        const mapResult = step.getMap();
        mapResult.forEach((oldStart, oldEnd, newStart, newEnd)=>{
            tr.doc.nodesBetween(newStart, Math.min(newEnd, tr.doc.content.size), (node, pos)=>{
                if (node.type.name === 'codeBlock') {
                    if (!nodePositions.has(pos)) {
                        nodePositions.add(pos);
                        changedCodeBlocks.push({
                            node: node,
                            pos: pos
                        });
                    }
                }
            });
        });
    });
    return changedCodeBlocks;
}


const $80dcb8cbac119154$var$MIN_AUTO_DETECT_TEXT_LENGTH = 20;
const $80dcb8cbac119154$export$75fa5ee64c376b5c = (lastObservedText, text)=>{
    if (!lastObservedText) return text.length > 0;
    return Math.abs(text.length - lastObservedText.length) > lastObservedText.length / 2;
};
const $80dcb8cbac119154$export$1c51de8940db13e0 = (text)=>text.split('\n')[0] ?? '';
const $80dcb8cbac119154$export$a5224da7b01ec0b7 = (text)=>text.trim().length >= $80dcb8cbac119154$var$MIN_AUTO_DETECT_TEXT_LENGTH;
const $80dcb8cbac119154$export$957229695d10ea4a = (node)=>typeof node.attrs.localId === 'string' ? node.attrs.localId : null;
const $80dcb8cbac119154$export$ebf3c95b2e36b335 = (node, pos, isPending, previous)=>({
        lastObservedText: node.textContent,
        lastObservedFirstLine: $80dcb8cbac119154$export$1c51de8940db13e0(node.textContent),
        isPending: isPending,
        detectionResult: previous?.detectionResult,
        autoDetectedLanguage: previous?.autoDetectedLanguage,
        pos: pos
    });
const $80dcb8cbac119154$export$82bdb85239e6f0b5 = (languageDetectionMap, node, pos, isPending)=>{
    const localId = $80dcb8cbac119154$export$957229695d10ea4a(node);
    if (!localId) return languageDetectionMap;
    return {
        ...languageDetectionMap,
        [localId]: $80dcb8cbac119154$export$ebf3c95b2e36b335(node, pos, isPending, languageDetectionMap[localId])
    };
};
const $80dcb8cbac119154$export$8e484f7dcf239a78 = (languageDetectionMap, localId)=>{
    if (!languageDetectionMap[localId]) return languageDetectionMap;
    const nextLanguageDetectionMap = {
        ...languageDetectionMap
    };
    delete nextLanguageDetectionMap[localId];
    return nextLanguageDetectionMap;
};
const $80dcb8cbac119154$var$getCodeBlockLocalIdsRemovedFromChangedRanges = (tr, codeBlockType)=>{
    const localIds = new Set();
    tr.steps.forEach((step, stepIndex)=>{
        const docAtStep = tr.docs[stepIndex];
        step.getMap().forEach((oldStart, oldEnd)=>{
            if (oldStart === oldEnd) return;
            const clampedOldEnd = Math.min(oldEnd, docAtStep.content.size);
            docAtStep.nodesBetween(oldStart, clampedOldEnd, (node, pos)=>{
                if (node.type !== codeBlockType) return true;
                const isWholeCodeBlockRemoved = pos >= oldStart && pos + node.nodeSize <= clampedOldEnd;
                if (!isWholeCodeBlockRemoved) return false;
                const localId = $80dcb8cbac119154$export$957229695d10ea4a(node);
                if (localId) localIds.add(localId);
                return false;
            });
        });
    });
    return localIds;
};
const $80dcb8cbac119154$var$getCodeBlockTransactionChanges = (tr, codeBlockType)=>{
    const insertedNodesWithPos = (0, $dNXVc.getInsertedCodeBlocksInTransaction)(tr, codeBlockType);
    const removedFromChangedRangesLocalIds = $80dcb8cbac119154$var$getCodeBlockLocalIdsRemovedFromChangedRanges(tr, codeBlockType);
    const insertedLocalIds = new Set();
    const insertedCodeBlocks = [];
    insertedNodesWithPos.forEach(({ node: node, pos: pos })=>{
        const localId = $80dcb8cbac119154$export$957229695d10ea4a(node);
        if (!localId) return;
        insertedLocalIds.add(localId);
        if (!removedFromChangedRangesLocalIds.has(localId)) insertedCodeBlocks.push({
            localId: localId,
            node: node,
            pos: pos
        });
    });
    const deletedLocalIds = new Set();
    removedFromChangedRangesLocalIds.forEach((localId)=>{
        if (!insertedLocalIds.has(localId)) deletedLocalIds.add(localId);
    });
    return {
        deletedLocalIds: deletedLocalIds,
        insertedCodeBlocks: insertedCodeBlocks
    };
};
const $80dcb8cbac119154$export$e9e91d763bd6702f = (tr, pluginState)=>{
    const { codeBlock: codeBlock } = tr.doc.type.schema.nodes;
    const isPaste = tr.getMeta('paste') === true || tr.getMeta('uiEvent') === 'paste';
    const isExternalContentChange = tr.getMeta('replaceDocument') === true || tr.getMeta('isRemote') === true;
    const hasTrackedEntries = Object.keys(pluginState.languageDetectionMap).length > 0;
    // Page loads and remote edits should not start auto-detection for code blocks.
    if (!hasTrackedEntries && isExternalContentChange) return pluginState.languageDetectionMap;
    // Existing entries still need mapping/deletion cleanup, but external edits should not refresh text.
    const changedCodeBlockNodes = isExternalContentChange ? [] : (0, $60a45f8e35213e68$export$3fa3c149b89781e7)(tr);
    if (!hasTrackedEntries && !changedCodeBlockNodes.length) return pluginState.languageDetectionMap;
    const { deletedLocalIds: deletedLocalIds, insertedCodeBlocks: insertedCodeBlocks } = $80dcb8cbac119154$var$getCodeBlockTransactionChanges(tr, codeBlock);
    let languageDetectionMap = hasTrackedEntries ? Object.fromEntries(Object.entries(pluginState.languageDetectionMap).map(([localId, entry])=>[
            localId,
            {
                ...entry,
                pos: tr.mapping.map(entry.pos)
            }
        ])) : pluginState.languageDetectionMap;
    if (!isExternalContentChange) {
        insertedCodeBlocks.forEach(({ localId: localId, node: node, pos: pos })=>{
            if (node.attrs.language) {
                languageDetectionMap = $80dcb8cbac119154$export$8e484f7dcf239a78(languageDetectionMap, localId);
                return;
            }
            languageDetectionMap = $80dcb8cbac119154$export$82bdb85239e6f0b5(languageDetectionMap, node, pos, $80dcb8cbac119154$export$a5224da7b01ec0b7(node.textContent));
        });
        changedCodeBlockNodes.forEach(({ node: node, pos: pos })=>{
            const localId = $80dcb8cbac119154$export$957229695d10ea4a(node);
            if (!localId || !languageDetectionMap[localId]) return;
            const currentLanguage = node.attrs.language;
            const previousEntry = languageDetectionMap[localId];
            if (currentLanguage && currentLanguage !== previousEntry.autoDetectedLanguage) {
                languageDetectionMap = $80dcb8cbac119154$export$8e484f7dcf239a78(languageDetectionMap, localId);
                return;
            }
            const text = node.textContent;
            const firstLine = $80dcb8cbac119154$export$1c51de8940db13e0(text);
            const shouldTriggerDetection = previousEntry.isPending || isPaste || firstLine !== previousEntry.lastObservedFirstLine || $80dcb8cbac119154$export$75fa5ee64c376b5c(previousEntry.lastObservedText, text);
            const isPending = $80dcb8cbac119154$export$a5224da7b01ec0b7(text) && shouldTriggerDetection;
            // Only pending detection refreshes the text snapshot; otherwise gradual typing
            // should continue comparing against the last attempted detection.
            languageDetectionMap = isPending ? $80dcb8cbac119154$export$82bdb85239e6f0b5(languageDetectionMap, node, pos, true) : {
                ...languageDetectionMap,
                [localId]: {
                    ...previousEntry,
                    isPending: false,
                    pos: pos
                }
            };
        });
    }
    deletedLocalIds.forEach((localId)=>{
        if (languageDetectionMap[localId]) languageDetectionMap = $80dcb8cbac119154$export$8e484f7dcf239a78(languageDetectionMap, localId);
    });
    return languageDetectionMap;
};


const $ad155092bbb7cd73$var$supportedFormatLanguages = [
    'json',
    'javascript',
    'jsx',
    'typescript',
    'tsx',
    'sql'
];
const $ad155092bbb7cd73$export$e8fc22189a2297aa = (language)=>$ad155092bbb7cd73$var$supportedFormatLanguages.includes(language);
let $ad155092bbb7cd73$var$formatterModulePromise;

const $ad155092bbb7cd73$export$e1d1126efd666697 = ()=>{
    if (!$ad155092bbb7cd73$var$formatterModulePromise) $ad155092bbb7cd73$var$formatterModulePromise = (parcelRequire("7YsdE")).catch((error)=>{
        $ad155092bbb7cd73$var$formatterModulePromise = undefined;
        throw error;
    });
    return $ad155092bbb7cd73$var$formatterModulePromise;
};
const $ad155092bbb7cd73$export$bbd1d07b83fc9327 = ()=>(_state, dispatch)=>{
        if (!dispatch) // Hover/focus handlers are command-shaped; keep dry-runs side-effect free.
        return false;
        $ad155092bbb7cd73$export$e1d1126efd666697();
        return false;
    };
const $ad155092bbb7cd73$export$91933935116a6ce2 = async ({ content: content, language: language })=>{
    let formatterModule;
    try {
        formatterModule = await $ad155092bbb7cd73$export$e1d1126efd666697();
    } catch  {
        return {
            errorType: 'formatter-load-failed',
            language: language,
            status: 'failed'
        };
    }
    try {
        return await formatterModule.formatCode({
            content: content,
            language: language
        });
    } catch  {
        return {
            errorType: 'formatter-execution-failed',
            language: language,
            status: 'failed'
        };
    }
};


const $842bd612836073a1$export$44b4779780b25933 = (editorAnalyticsAPI)=>{
    return (0, $dAtrv.withAnalytics)(editorAnalyticsAPI, {
        action: (0, $d925B.ACTION).DELETED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).CODE_BLOCK,
        attributes: {
            inputMethod: (0, $d925B.INPUT_METHOD).FLOATING_TB
        },
        eventType: (0, $d925B.EVENT_TYPE).TRACK
    })($842bd612836073a1$export$e635d7f974817375);
};
const $842bd612836073a1$export$e635d7f974817375 = (state, dispatch)=>{
    const { schema: { nodes: nodes }, tr: tr } = state;
    if (dispatch) {
        let removeTr = tr;
        if ((0, $8m4tT.findSelectedNodeOfType)(nodes.codeBlock)(tr.selection)) removeTr = (0, $8m4tT.removeSelectedNode)(tr);
        else removeTr = (0, $8m4tT.removeParentNodeOfType)(nodes.codeBlock)(tr);
        dispatch(removeTr);
    }
    return true;
};
const $842bd612836073a1$export$61465194746e7fd2 = (editorAnalyticsAPI)=>(language, selectionSource)=>(state, dispatch)=>{
            const { codeBlock: codeBlock } = state.schema.nodes;
            const pos = (0, $3848854553e34219$export$18d4026d1ea86bb1).getState(state)?.pos;
            if (typeof pos !== 'number') return false;
            const node = state.doc.nodeAt(pos);
            const localId = node?.attrs.localId;
            const previousAutoDetectEntry = (0, $1oCLl.expValEquals)('platform_editor_code_block_q4_lovability', 'isEnabled', true) && (0, $dh538.fg)('platform_editor_code_block_language_detection_flow') ? (0, $0f30d43ffc94b135$export$264979d19e499e37).getState(state)?.languageDetectionMap[localId] : undefined;
            const tr = state.tr.setNodeMarkup(pos, codeBlock, {
                ...node?.attrs,
                language: language
            }).setMeta('scrollIntoView', false);
            if ((0, $1oCLl.expValEquals)('platform_editor_code_block_q4_lovability', 'isEnabled', true) && (0, $dh538.fg)('platform_editor_code_block_language_detection_flow')) tr.setMeta((0, $0f30d43ffc94b135$export$264979d19e499e37), {
                type: (0, $88b7294e6fc1bbcd$export$92a1a3b7554e9387).REMOVE_AUTO_DETECT_ENTRY,
                data: {
                    localId: localId
                }
            });
            const selection = (0, $8m4tT.isNodeSelection)(state.selection) ? (0, $ks2lK.NodeSelection).create(tr.doc, pos) : tr.selection;
            const result = tr.setSelection(selection);
            if (dispatch) {
                editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: (0, $d925B.ACTION).LANGUAGE_SELECTED,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).CODE_BLOCK,
                    attributes: {
                        language: language ?? 'none',
                        ...selectionSource ? {
                            selectionSource: selectionSource
                        } : {},
                        autoDetectionResult: previousAutoDetectEntry?.detectionResult,
                        autoDetectedLanguage: previousAutoDetectEntry?.autoDetectedLanguage
                    },
                    eventType: (0, $d925B.EVENT_TYPE).TRACK
                })(result);
                dispatch(result);
            }
            return true;
        };
const $842bd612836073a1$export$ae9ea24a1b29b07c = ()=>(state, dispatch)=>{
        const pos = (0, $3848854553e34219$export$18d4026d1ea86bb1).getState(state)?.pos;
        if (typeof pos !== 'number') return false;
        const node = state.doc.nodeAt(pos);
        if (!node) return false;
        const localId = (0, $80dcb8cbac119154$export$957229695d10ea4a)(node);
        if (!localId) return false;
        const autoDetectState = (0, $0f30d43ffc94b135$export$264979d19e499e37).getState(state);
        const previousEntry = autoDetectState?.languageDetectionMap[localId];
        const entry = (0, $80dcb8cbac119154$export$ebf3c95b2e36b335)(node, pos, (0, $80dcb8cbac119154$export$a5224da7b01ec0b7)(node.textContent), previousEntry);
        const tr = state.tr.setNodeMarkup(pos, state.schema.nodes.codeBlock, {
            ...node.attrs,
            language: null
        }).setMeta((0, $0f30d43ffc94b135$export$264979d19e499e37), {
            type: (0, $88b7294e6fc1bbcd$export$92a1a3b7554e9387).SET_AUTO_DETECT_ENTRY,
            data: {
                localId: localId,
                entry: entry
            }
        }).setMeta('scrollIntoView', false);
        const selection = (0, $8m4tT.isNodeSelection)(state.selection) ? (0, $ks2lK.NodeSelection).create(tr.doc, pos) : tr.selection;
        const result = tr.setSelection(selection);
        if (dispatch) dispatch(result);
        return true;
    };
const $842bd612836073a1$var$setResolveFormatCodeMeta = (tr, { languageSource: languageSource, localId: localId, outcome: outcome, requestId: requestId, errorType: errorType })=>tr.setMeta((0, $3848854553e34219$export$18d4026d1ea86bb1), {
        type: (0, $88b7294e6fc1bbcd$export$92a1a3b7554e9387).RESOLVE_FORMAT_CODE,
        data: {
            languageSource: languageSource,
            localId: localId,
            outcome: outcome,
            requestId: requestId,
            ...errorType ? {
                errorType: errorType
            } : {}
        }
    });
const $842bd612836073a1$var$replaceCodeBlockText = ({ codeBlockNode: codeBlockNode, content: content, pos: pos, tr: tr })=>{
    const from = pos + 1;
    const to = pos + codeBlockNode.nodeSize - 1;
    tr.delete(from, to);
    if (content) tr.insertText(content, from);
    // The editor scroll plugin scrolls doc-changing transactions by default.
    return tr.setMeta('scrollIntoView', false);
};
const $842bd612836073a1$var$attachFormatCodeAnalytics = ({ editorAnalyticsAPI: editorAnalyticsAPI, languageSource: languageSource, result: result, tr: tr })=>{
    if (result.status === 'failed') {
        editorAnalyticsAPI?.attachAnalyticsEvent({
            action: (0, $d925B.ACTION).ERRORED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).CODE_BLOCK,
            attributes: {
                errorType: result.errorType,
                language: result.language,
                languageSource: languageSource
            },
            eventType: (0, $d925B.EVENT_TYPE).TRACK
        })(tr);
        return;
    }
    editorAnalyticsAPI?.attachAnalyticsEvent({
        action: (0, $d925B.ACTION).FORMATTED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).CODE_BLOCK,
        attributes: {
            language: result.language,
            languageSource: languageSource,
            outcome: result.status
        },
        eventType: (0, $d925B.EVENT_TYPE).TRACK
    })(tr);
};
const $842bd612836073a1$var$createResolveFormatCodeTransaction = ({ editorAnalyticsAPI: editorAnalyticsAPI, localId: localId, pendingFormat: pendingFormat, result: result, tr: tr })=>{
    const { languageSource: languageSource, requestId: requestId } = pendingFormat;
    const codeBlockNode = tr.doc.nodeAt(pendingFormat.pos);
    const hasMatchingCodeBlock = codeBlockNode?.type === tr.doc.type.schema.nodes.codeBlock && codeBlockNode?.attrs.localId === localId;
    if (!hasMatchingCodeBlock) {
        // Keep failure telemetry even when the target block is no longer available.
        if (result.status === 'failed') $842bd612836073a1$var$attachFormatCodeAnalytics({
            editorAnalyticsAPI: editorAnalyticsAPI,
            languageSource: languageSource,
            result: result,
            tr: tr
        });
        return $842bd612836073a1$var$setResolveFormatCodeMeta(tr, {
            languageSource: languageSource,
            localId: localId,
            outcome: 'unchanged',
            requestId: requestId
        });
    }
    let resultTransaction = tr;
    if (result.status === 'formatted') resultTransaction = $842bd612836073a1$var$replaceCodeBlockText({
        codeBlockNode: codeBlockNode,
        content: result.content,
        pos: pendingFormat.pos,
        tr: tr
    });
    $842bd612836073a1$var$attachFormatCodeAnalytics({
        editorAnalyticsAPI: editorAnalyticsAPI,
        languageSource: languageSource,
        result: result,
        tr: resultTransaction
    });
    return $842bd612836073a1$var$setResolveFormatCodeMeta(resultTransaction, {
        errorType: result.status === 'failed' ? result.errorType : undefined,
        languageSource: languageSource,
        localId: localId,
        outcome: result.status,
        requestId: requestId
    });
};
const $842bd612836073a1$export$7f5d8563b7e51b88 = ({ api: api, editorAnalyticsAPI: editorAnalyticsAPI })=>(state, dispatch)=>{
        const currentCodeBlockState = (0, $3848854553e34219$export$18d4026d1ea86bb1).getState(state);
        const currentPos = currentCodeBlockState?.pos;
        if (!currentCodeBlockState || typeof currentPos !== 'number') return false;
        const currentNode = state.doc.nodeAt(currentPos);
        if (!currentNode || currentNode.type !== state.schema.nodes.codeBlock) return false;
        const currentLanguage = currentNode.attrs.language;
        if (!(0, $ad155092bbb7cd73$export$e8fc22189a2297aa)(currentLanguage)) return true;
        const currentLocalId = currentNode.attrs.localId;
        if (currentCodeBlockState.pendingFormats[currentLocalId]) return true;
        const autoDetectEntry = (0, $0f30d43ffc94b135$export$264979d19e499e37).getState(state)?.languageDetectionMap[currentLocalId];
        const languageSource = autoDetectEntry?.autoDetectedLanguage === currentLanguage ? 'auto-detected' : 'selected';
        const content = currentNode.textContent;
        const requestId = crypto.randomUUID();
        api?.core?.actions.execute(({ tr: tr })=>tr.setMeta((0, $3848854553e34219$export$18d4026d1ea86bb1), {
                type: (0, $88b7294e6fc1bbcd$export$92a1a3b7554e9387).START_FORMAT_CODE,
                data: {
                    languageSource: languageSource,
                    localId: currentLocalId,
                    pos: currentPos,
                    requestId: requestId
                }
            }));
        (0, $ad155092bbb7cd73$export$91933935116a6ce2)({
            content: content,
            language: currentLanguage
        }).then((result)=>{
            const pendingFormat = api?.codeBlock?.sharedState.currentState()?.pendingFormats[currentLocalId];
            if (!pendingFormat || pendingFormat.requestId !== requestId) return;
            api?.core?.actions.execute(({ tr: tr })=>$842bd612836073a1$var$createResolveFormatCodeTransaction({
                    editorAnalyticsAPI: editorAnalyticsAPI,
                    localId: currentLocalId,
                    pendingFormat: pendingFormat,
                    result: result,
                    tr: tr
                }));
        });
        return true;
    };
const $842bd612836073a1$export$50ffc017f5e54c0 = (editorAnalyticsAPI)=>(state, dispatch)=>{
        const { schema: { nodes: nodes }, tr: tr } = state;
        const codeBlock = (0, $8m4tT.findParentNodeOfType)(nodes.codeBlock)(tr.selection);
        const textContent = codeBlock && codeBlock.node.textContent;
        if (textContent) {
            (0, $cMZNY.copyToClipboard)(textContent);
            const copyToClipboardTr = tr;
            copyToClipboardTr.setMeta((0, $3848854553e34219$export$18d4026d1ea86bb1), {
                type: (0, $88b7294e6fc1bbcd$export$92a1a3b7554e9387).SET_COPIED_TO_CLIPBOARD,
                data: true
            });
            copyToClipboardTr.setMeta((0, $81cbafd47e9e3d55$export$97324d26e7dfa2c5), 'remove-selection');
            if (editorAnalyticsAPI) {
                const analyticsPayload = (0, $cMZNY.getAnalyticsPayload)(state, (0, $d925B.ACTION).COPIED);
                if (analyticsPayload) {
                    analyticsPayload.attributes.inputMethod = (0, $d925B.INPUT_METHOD).FLOATING_TB;
                    analyticsPayload.attributes.nodeType = codeBlock?.node.type.name;
                    editorAnalyticsAPI.attachAnalyticsEvent(analyticsPayload)(copyToClipboardTr);
                }
            }
            if (dispatch) dispatch(copyToClipboardTr);
        }
        return true;
    };
const $842bd612836073a1$export$859674cc23da4522 = (state, dispatch)=>{
    const { schema: { nodes: nodes }, tr: tr } = state;
    const codeBlock = (0, $8m4tT.findParentNodeOfType)(nodes.codeBlock)(tr.selection);
    const textContent = codeBlock && codeBlock.node.textContent;
    if (textContent) {
        (0, $cMZNY.copyToClipboard)(textContent);
        const copyToClipboardTr = tr;
        copyToClipboardTr.setMeta((0, $3848854553e34219$export$18d4026d1ea86bb1), {
            type: (0, $88b7294e6fc1bbcd$export$92a1a3b7554e9387).SET_COPIED_TO_CLIPBOARD,
            data: true
        });
        copyToClipboardTr.setMeta((0, $81cbafd47e9e3d55$export$97324d26e7dfa2c5), 'remove-selection');
        if (dispatch) dispatch(copyToClipboardTr);
    }
    return true;
};
const $842bd612836073a1$export$3e0b07341e7576a = (state, dispatch)=>{
    const { tr: tr } = state;
    const codeBlockState = (0, $3848854553e34219$export$18d4026d1ea86bb1).getState(state);
    const resetCopiedStateTr = tr;
    if (codeBlockState && codeBlockState.contentCopied) {
        resetCopiedStateTr.setMeta((0, $3848854553e34219$export$18d4026d1ea86bb1), {
            type: (0, $88b7294e6fc1bbcd$export$92a1a3b7554e9387).SET_COPIED_TO_CLIPBOARD,
            data: false
        });
        resetCopiedStateTr.setMeta((0, $81cbafd47e9e3d55$export$97324d26e7dfa2c5), 'remove-selection');
        if (dispatch) dispatch(resetCopiedStateTr);
    } else {
        const clearSelectionStateTransaction = state.tr;
        clearSelectionStateTransaction.setMeta((0, $81cbafd47e9e3d55$export$97324d26e7dfa2c5), 'remove-selection');
        // note: dispatch should always be defined when called from the
        // floating toolbar. Howver the Command type which floating toolbar uses
        // (and resetCopiedState) uses suggests it's optional.
        if (dispatch) dispatch(clearSelectionStateTransaction);
    }
    return true;
};
const $842bd612836073a1$export$e6e93d61d1873d0c = (state, dispatch)=>{
    const { tr: tr } = state;
    const ignoreFollowingMutationsTr = tr;
    ignoreFollowingMutationsTr.setMeta((0, $3848854553e34219$export$18d4026d1ea86bb1), {
        type: (0, $88b7294e6fc1bbcd$export$92a1a3b7554e9387).SET_SHOULD_IGNORE_FOLLOWING_MUTATIONS,
        data: true
    });
    if (dispatch) dispatch(ignoreFollowingMutationsTr);
    return true;
};
const $842bd612836073a1$export$60364cd5f5fed191 = (state, dispatch)=>{
    const { tr: tr } = state;
    const ignoreFollowingMutationsTr = tr;
    ignoreFollowingMutationsTr.setMeta((0, $3848854553e34219$export$18d4026d1ea86bb1), {
        type: (0, $88b7294e6fc1bbcd$export$92a1a3b7554e9387).SET_SHOULD_IGNORE_FOLLOWING_MUTATIONS,
        data: false
    });
    if (dispatch) dispatch(ignoreFollowingMutationsTr);
    return true;
};
function $842bd612836073a1$export$c875ffe428b4a5f({ state: state }) {
    let { tr: tr } = state;
    const { from: from } = state.selection;
    const { codeBlock: codeBlock } = state.schema.nodes;
    const codeBlockAttrs = (0, $dNXVc.getDefaultCodeBlockAttrs)();
    const grandParentNode = state.selection.$from.node(-1);
    const grandParentNodeType = grandParentNode?.type;
    const parentNodeType = state.selection.$from.parent.type;
    /** We always want to append a codeBlock unless we're inserting into a paragraph
   * AND it's a valid child of the grandparent node.
   * Insert the current selection as codeBlock content unless it contains nodes other
   * than paragraphs and inline.
   */ const canInsertCodeBlock = (0, $zT4ZO.shouldSplitSelectedNodeOnNodeInsertion)({
        parentNodeType: parentNodeType,
        grandParentNodeType: grandParentNodeType,
        content: codeBlock.createAndFill()
    }) && (0, $zT4ZO.contentAllowedInCodeBlock)(state);
    if (canInsertCodeBlock) tr = (0, $53e4a41e0689db18$export$92adcb8baa0906a6)(state, from, codeBlockAttrs);
    else (0, $8m4tT.safeInsert)(codeBlock.createAndFill(codeBlockAttrs))(tr).scrollIntoView();
    return tr;
}
function $842bd612836073a1$export$a8d9c0f039b6fb43(inputMethod, analyticsAPI) {
    return (0, $dAtrv.withAnalytics)(analyticsAPI, {
        action: (0, $d925B.ACTION).INSERTED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).CODE_BLOCK,
        attributes: {
            inputMethod: inputMethod
        },
        eventType: (0, $d925B.EVENT_TYPE).TRACK
    })(function(state, dispatch) {
        const tr = $842bd612836073a1$export$c875ffe428b4a5f({
            state: state
        });
        if (dispatch) dispatch(tr);
        return true;
    });
}
const $842bd612836073a1$export$160d674382436f98 = (editorAnalyticsAPI)=>(state, dispatch)=>{
        const codeBlock = (0, $enBNf.findCodeBlock)(state);
        const codeBlockNode = codeBlock?.node;
        const { tr: tr } = state;
        if (!(0, $dNXVc.codeBlockWrappedStates) || !codeBlockNode) return false;
        const updatedToggleState = !(0, $dNXVc.isCodeBlockWordWrapEnabled)(codeBlockNode);
        if ((0, $1oCLl.expValEquals)('platform_editor_code_block_q4_lovability', 'isEnabled', true)) tr.setNodeMarkup(codeBlock.pos, undefined, {
            ...codeBlockNode.attrs,
            wrap: updatedToggleState
        });
        else (0, $dNXVc.codeBlockWrappedStates).set(codeBlockNode, updatedToggleState);
        tr.setMeta((0, $3848854553e34219$export$18d4026d1ea86bb1), {
            type: (0, $88b7294e6fc1bbcd$export$92a1a3b7554e9387).SET_IS_WRAPPED,
            data: updatedToggleState
        });
        if (dispatch) {
            editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $d925B.ACTION).TOGGLE_CODE_BLOCK_WRAP,
                actionSubject: (0, $d925B.ACTION_SUBJECT).CODE_BLOCK,
                attributes: {
                    platform: (0, $e2wMq.PLATFORMS).WEB,
                    mode: (0, $e2wMq.MODE).EDITOR,
                    wordWrapEnabled: updatedToggleState,
                    codeBlockNodeSize: codeBlockNode.nodeSize
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            })(tr);
            dispatch(tr);
        }
        return true;
    };
const $842bd612836073a1$export$86e84eec7e5dd9ff = (editorAnalyticsAPI)=>({ tr: tr })=>{
        const { codeBlock: codeBlockType } = tr.doc.type.schema.nodes;
        const codeBlock = (0, $8m4tT.findSelectedNodeOfType)(codeBlockType)(tr.selection) || (0, $8m4tT.findParentNodeOfType)(codeBlockType)(tr.selection);
        if (!codeBlock) return null;
        const codeBlockNode = codeBlock.node;
        const lineNumbersHidden = !Boolean(codeBlockNode.attrs.hideLineNumbers);
        tr.setNodeMarkup(codeBlock.pos, undefined, {
            ...codeBlockNode.attrs,
            hideLineNumbers: lineNumbersHidden
        });
        editorAnalyticsAPI?.attachAnalyticsEvent({
            action: (0, $d925B.ACTION).TOGGLE_CODE_BLOCK_LINE_NUMBERS,
            actionSubject: (0, $d925B.ACTION_SUBJECT).CODE_BLOCK,
            attributes: {
                platform: (0, $e2wMq.PLATFORMS).WEB,
                lineNumbersHidden: lineNumbersHidden,
                codeBlockNodeSize: codeBlockNode.nodeSize
            },
            eventType: (0, $d925B.EVENT_TYPE).TRACK
        })(tr);
        return tr;
    };
const $842bd612836073a1$export$5d4256781e1f4071 = (editorAnalyticsAPI)=>(0, $gmyMu.editorCommandToPMCommand)($842bd612836073a1$export$86e84eec7e5dd9ff(editorAnalyticsAPI));












/* eslint-disable require-unicode-regexp */ // Conservative weighted-regex heuristic for common high-confidence snippets, not a full classifier.
// Ambiguous snippets intentionally return null so users can select the language manually.
const $adae1e1a27b3f1e0$var$MAX_DETECTION_CHARS = 10000;
const $adae1e1a27b3f1e0$var$MIN_DETECTION_SCORE = 3; // Require at least one medium-confidence signal before auto-selecting.
const $adae1e1a27b3f1e0$var$MIN_SCORE_GAP = 2; // Avoid auto-selecting when top two languages are too close to distinguish.
const $adae1e1a27b3f1e0$var$hasPattern = (code, pattern)=>{
    // Reset stateful regexes so repeated tests always start at the beginning.
    pattern.lastIndex = 0;
    return pattern.test(code);
};
const $adae1e1a27b3f1e0$var$scorePatterns = (code, patterns)=>patterns.reduce((score, [pattern, value])=>score + ($adae1e1a27b3f1e0$var$hasPattern(code, pattern) ? value : 0), 0);
const $adae1e1a27b3f1e0$var$looksLikeHtmlTagPair = (code)=>{
    const openTags = new Set();
    const tagPattern = /<\/?([a-z][a-z0-9-]*)\b[^<>]{0,500}>/gi;
    let match;
    while((match = tagPattern.exec(code)) !== null){
        const [tag, tagName] = match;
        if (tag.endsWith('/>')) continue;
        if (tag.startsWith('</')) {
            if (openTags.has(tagName.toLowerCase())) return true;
        } else openTags.add(tagName.toLowerCase());
    }
    return false;
};
const $adae1e1a27b3f1e0$var$looksLikeJson = (code)=>{
    const trimmed = code.trim();
    if (!/^[{[]/.test(trimmed) || !/[}\]]$/.test(trimmed)) return false;
    try {
        const parsed = JSON.parse(trimmed);
        return parsed !== null && typeof parsed === 'object';
    } catch  {
        return false;
    }
};
const $adae1e1a27b3f1e0$var$getLanguageScores = (code)=>[
        {
            language: 'json',
            score: $adae1e1a27b3f1e0$var$looksLikeJson(code) ? 8 : 0
        },
        {
            language: 'html',
            score: $adae1e1a27b3f1e0$var$scorePatterns(code, [
                [
                    /<!doctype\s+html/i,
                    5
                ],
                [
                    /<\/?(?:html|head|body|div|span|script|style|section|template)\b/i,
                    2
                ]
            ]) + ($adae1e1a27b3f1e0$var$looksLikeHtmlTagPair(code) ? 3 : 0)
        },
        {
            language: 'css',
            score: $adae1e1a27b3f1e0$var$scorePatterns(code, [
                [
                    /@[\w-]+\s+[^{]+\{/,
                    3
                ],
                [
                    /[.#]?[-_a-zA-Z][-_a-zA-Z0-9\s,.:#>+~*\[\]='"]+\{[^}]*\b(?:color|display|margin|padding|font|background|border|width|height|grid|flex)\s*:/,
                    5
                ],
                [
                    /\b(?:color|display|margin|padding|font-size|background|border|width|height)\s*:\s*[^;{}]+;/,
                    3
                ]
            ])
        },
        {
            language: 'sql',
            score: $adae1e1a27b3f1e0$var$scorePatterns(code, [
                [
                    /\bSELECT\b[\s\S]+\bFROM\b/i,
                    5
                ],
                [
                    /\b(?:INSERT\s+INTO|UPDATE\b[\s\S]+\bSET\b|DELETE\s+FROM|CREATE\s+TABLE|ALTER\s+TABLE)\b/i,
                    5
                ],
                [
                    /\b(?:JOIN|WHERE|GROUP\s+BY|ORDER\s+BY|LIMIT)\b/i,
                    2
                ]
            ])
        },
        {
            language: 'typescript',
            score: $adae1e1a27b3f1e0$var$scorePatterns(code, [
                [
                    /\b(?:interface|type)\s+[A-Z_$][\w$]*(?:\s*[=<{])/,
                    5
                ],
                [
                    /\bimport\s+type\b|\bexport\s+type\b/,
                    4
                ],
                [
                    /\b(?:const|let|var)\s+[\w$]+\s*:\s*[A-Za-z_$][\w$<>|\[\],\s]*/,
                    4
                ],
                [
                    /\)\s*:\s*(?:Promise<)?[A-Za-z_$][\w$<>|\[\],\s]*(?:>|\s)?\s*=>?\s*[{;]/,
                    3
                ],
                [
                    /\b(?:as\s+const|implements\s+[A-Z_$]|enum\s+[A-Z_$])/,
                    3
                ]
            ])
        },
        {
            language: 'javascript',
            score: $adae1e1a27b3f1e0$var$scorePatterns(code, [
                [
                    /\b(?:const|let|var)\s+[\w$]+\s*=/,
                    3
                ],
                [
                    /\bfunction\s*[\w$]*\s*\([^)]*\)\s*\{/,
                    3
                ],
                [
                    /=>\s*(?:\{|[\w$'"`(])/,
                    3
                ],
                [
                    /\b(?:import|export)\s+(?:[\w${}*,\s]+\s+from\s+)?['"][^'"]+['"]/,
                    3
                ],
                [
                    /\b(?:console\.log|document\.|window\.|require\()|\bmodule\.exports\b/,
                    3
                ]
            ])
        },
        {
            language: 'python',
            score: $adae1e1a27b3f1e0$var$scorePatterns(code, [
                [
                    /^\s*def\s+[a-zA-Z_]\w*\([^)]*\)\s*:/m,
                    5
                ],
                [
                    /^\s*class\s+[A-Z_]\w*(?:\([^)]*\))?\s*:/m,
                    4
                ],
                [
                    /^\s*(?:from\s+[\w.]+\s+import\s+\w+|import\s+[\w.]+)/m,
                    3
                ],
                [
                    /^\s*(?:if|elif|else|for|while|try|except)\b[^\n]*:\s*$/m,
                    2
                ],
                [
                    /\bprint\([^)]*\)/,
                    2
                ]
            ])
        },
        {
            language: 'java',
            score: $adae1e1a27b3f1e0$var$scorePatterns(code, [
                [
                    /\bpublic\s+(?:final\s+)?class\s+[A-Z]\w*/,
                    5
                ],
                [
                    /\bpublic\s+static\s+void\s+main\s*\(\s*String\[\]/,
                    5
                ],
                [
                    /\bSystem\.out\.println\s*\(/,
                    4
                ],
                [
                    /\b(?:private|protected|public)\s+(?:static\s+)?(?:final\s+)?[A-Z]\w*(?:<[^>]+>)?\s+\w+\s*[;(=]/,
                    3
                ]
            ])
        },
        {
            language: 'go',
            score: $adae1e1a27b3f1e0$var$scorePatterns(code, [
                [
                    /^\s*package\s+\w+/m,
                    5
                ],
                [
                    /\bfunc\s+(?:\([^)]*\)\s*)?[A-Za-z_]\w*\s*\([^)]*\)\s*(?:[A-Za-z_*\[\]]+\s*)?\{/,
                    5
                ],
                [
                    /\bfmt\.(?:Println|Printf)\s*\(/,
                    3
                ],
                [
                    /\bimport\s+\(\s*[\s\S]*?\)/,
                    2
                ]
            ])
        },
        {
            language: 'ruby',
            score: $adae1e1a27b3f1e0$var$scorePatterns(code, [
                [
                    /^\s*def\s+[a-z_]\w*[!?=]?/m,
                    4
                ],
                [
                    /^\s*class\s+[A-Z]\w*(?:\s*<\s*[A-Z]\w*)?/m,
                    3
                ],
                [
                    /^\s*end\s*$/m,
                    3
                ],
                [
                    /\b(?:puts|require|attr_reader|attr_accessor)\b/,
                    3
                ],
                [
                    /\bdo\s*\|[^|]+\|/,
                    2
                ]
            ])
        },
        {
            language: 'rust',
            score: $adae1e1a27b3f1e0$var$scorePatterns(code, [
                [
                    /\bfn\s+[a-z_]\w*\s*\([^)]*\)\s*(?:->\s*[A-Za-z_:<>]+\s*)?\{/,
                    5
                ],
                [
                    /\blet\s+mut\s+\w+/,
                    3
                ],
                [
                    /\bprintln!\s*\(/,
                    4
                ],
                [
                    /\buse\s+(?:std|crate|super)::/,
                    3
                ],
                [
                    /\b(?:impl|pub\s+struct|enum)\s+[A-Z]\w*/,
                    3
                ]
            ])
        },
        {
            language: 'shell',
            score: $adae1e1a27b3f1e0$var$scorePatterns(code, [
                [
                    /^#!\/usr\/bin\/(?:env\s+)?(?:ba|z|k)?sh\b/m,
                    6
                ],
                [
                    /^\s*(?:if|for|while)\b[\s\S]+\b(?:then|do)\b/m,
                    4
                ],
                [
                    /^\s*(?:fi|done)\s*$/m,
                    3
                ],
                [
                    /\b(?:echo|export|cd|grep|sed|awk|curl)\b[\s\S]*(?:\$\w+|&&|\|)/,
                    3
                ],
                [
                    /\$\{?[A-Z_][A-Z0-9_]*\}?/,
                    2
                ]
            ])
        }
    ];
const $adae1e1a27b3f1e0$export$ae9ea24a1b29b07c = (code)=>{
    const trimmedCode = code.trim();
    if (trimmedCode.length < 8) return null;
    const codeForDetection = trimmedCode.slice(0, $adae1e1a27b3f1e0$var$MAX_DETECTION_CHARS);
    const [best, secondBest] = $adae1e1a27b3f1e0$var$getLanguageScores(codeForDetection).filter(({ score: score })=>score > 0).sort((a, b)=>b.score - a.score);
    if (!best || best.score < $adae1e1a27b3f1e0$var$MIN_DETECTION_SCORE) return null;
    if (secondBest && best.score - secondBest.score < $adae1e1a27b3f1e0$var$MIN_SCORE_GAP) return null;
    return best.language;
};


const $38f6b79740b99690$var$AUTO_DETECT_DEBOUNCE_MS = 500;
// Stored positions are mapped through transactions; verify the localId before using them.
const $38f6b79740b99690$var$getCodeBlockFromEntry = (view, localId, entry)=>{
    const node = view.state.doc.nodeAt(entry.pos);
    const codeBlockType = view.state.schema.nodes.codeBlock;
    if (node?.type === codeBlockType && node.attrs.localId === localId) return {
        node: node,
        pos: entry.pos
    };
    return null;
};
// Runs after debounce, so it must re-read current editor state before applying language changes.
const $38f6b79740b99690$var$runPendingDetection = (view, localId, api)=>{
    const pluginState = (0, $0f30d43ffc94b135$export$264979d19e499e37).getState(view.state);
    const entry = pluginState?.languageDetectionMap[localId];
    if (!entry?.isPending) return;
    const found = $38f6b79740b99690$var$getCodeBlockFromEntry(view, localId, entry);
    if (!found) return;
    const detectedLanguage = (0, $adae1e1a27b3f1e0$export$ae9ea24a1b29b07c)(found.node.textContent);
    const detectionResult = detectedLanguage ? 'detected' : 'noneDetected';
    // Keep a previous auto-detected language when the latest snippet is too weak to classify.
    const shouldPreserveAutoDetectedLanguage = !detectedLanguage && Boolean(entry.autoDetectedLanguage) && found.node.attrs.language === entry.autoDetectedLanguage;
    const nextEntry = {
        ...(0, $80dcb8cbac119154$export$ebf3c95b2e36b335)(found.node, found.pos, false, entry),
        detectionResult: detectionResult,
        autoDetectedLanguage: detectedLanguage ?? entry.autoDetectedLanguage
    };
    // If there is no confident detection, record the result without clearing user-visible language.
    const shouldOnlyUpdateDetectionState = !detectedLanguage && (!found.node.attrs.language || shouldPreserveAutoDetectedLanguage);
    api?.core?.actions.execute(({ tr: tr })=>{
        if (!shouldOnlyUpdateDetectionState) tr.setNodeMarkup(found.pos, undefined, {
            ...found.node.attrs,
            language: detectedLanguage
        }, found.node.marks);
        tr.setMeta((0, $0f30d43ffc94b135$export$264979d19e499e37), {
            type: (0, $88b7294e6fc1bbcd$export$92a1a3b7554e9387).SET_AUTO_DETECT_ENTRY,
            data: {
                localId: localId,
                entry: nextEntry
            }
        });
        api?.analytics?.actions.attachAnalyticsEvent({
            action: (0, $d925B.ACTION).LANGUAGE_AUTO_DETECTED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).CODE_BLOCK,
            attributes: {
                language: detectedLanguage ?? 'none',
                detectionResult: detectionResult
            },
            eventType: (0, $d925B.EVENT_TYPE).TRACK
        })(tr);
        return tr;
    });
};
const $38f6b79740b99690$var$clearTimer = (timers, localId)=>{
    const scheduledDetection = timers.get(localId);
    if (scheduledDetection) {
        clearTimeout(scheduledDetection.timer);
        timers.delete(localId);
    }
};
const $38f6b79740b99690$export$294a2b069616ba23 = (view, timers, api)=>{
    const pluginState = (0, $0f30d43ffc94b135$export$264979d19e499e37).getState(view.state);
    const pendingEntries = Object.entries(pluginState?.languageDetectionMap ?? {}).filter(([, entry])=>entry.isPending);
    const pendingLocalIds = new Set(pendingEntries.map(([localId])=>localId));
    pendingEntries.forEach(([localId, entry])=>{
        const scheduledDetection = timers.get(localId);
        if (scheduledDetection?.lastObservedText === entry.lastObservedText) return;
        $38f6b79740b99690$var$clearTimer(timers, localId);
        const timer = setTimeout(()=>{
            timers.delete(localId);
            $38f6b79740b99690$var$runPendingDetection(view, localId, api);
        }, $38f6b79740b99690$var$AUTO_DETECT_DEBOUNCE_MS);
        timers.set(localId, {
            lastObservedText: entry.lastObservedText,
            timer: timer
        });
    });
    timers.forEach((_, localId)=>{
        if (!pendingLocalIds.has(localId)) $38f6b79740b99690$var$clearTimer(timers, localId);
    });
};




const $1ba006743c4cb8b1$export$d5142f5b34a5c85b = (api)=>new (0, $1S4f7.SafePlugin)({
        key: (0, $0f30d43ffc94b135$export$264979d19e499e37),
        state: {
            init () {
                return {
                    languageDetectionMap: {}
                };
            },
            apply (tr, pluginState) {
                const meta = tr.getMeta((0, $0f30d43ffc94b135$export$264979d19e499e37));
                let languageDetectionMap = tr.docChanged ? (0, $80dcb8cbac119154$export$e9e91d763bd6702f)(tr, pluginState) : pluginState.languageDetectionMap;
                if (meta?.type === (0, $88b7294e6fc1bbcd$export$92a1a3b7554e9387).SET_AUTO_DETECT_ENTRY) languageDetectionMap = {
                    ...languageDetectionMap,
                    [meta.data.localId]: meta.data.entry
                };
                else if (meta?.type === (0, $88b7294e6fc1bbcd$export$92a1a3b7554e9387).REMOVE_AUTO_DETECT_ENTRY) languageDetectionMap = (0, $80dcb8cbac119154$export$8e484f7dcf239a78)(languageDetectionMap, meta.data.localId);
                if (languageDetectionMap === pluginState.languageDetectionMap) return pluginState;
                return {
                    languageDetectionMap: languageDetectionMap
                };
            }
        },
        view (view) {
            const timers = new Map();
            return {
                update () {
                    (0, $38f6b79740b99690$export$294a2b069616ba23)(view, timers, api);
                },
                destroy () {
                    timers.forEach(({ timer: timer })=>clearTimeout(timer));
                    timers.clear();
                }
            };
        }
    });



var $d7ZU3 = parcelRequire("d7ZU3");













const $4d9c5a8d8eb96c97$export$6114c8149cd0d98e = new (0, $ks2lK.PluginKey)('codeBlockAutoFullStopTransformPluginKey');
function $4d9c5a8d8eb96c97$export$67e82b3aa944d041() {
    return new (0, $1S4f7.SafePlugin)({
        key: $4d9c5a8d8eb96c97$export$6114c8149cd0d98e,
        appendTransaction (_transactions, oldState, newState) {
            if (!(0, $dh538.fg)('code_block_auto_insertion_bug_fix')) return undefined;
            // We need to compare the old and new state to isloate auto insertion of fullstop on mac
            const { tr: trNew } = newState;
            const { tr: trOld } = oldState;
            const { from: fromOld } = trOld.selection;
            const { from: fromNew, to: toNew } = trNew.selection;
            const isCodeBlock = !!(0, $enBNf.findCodeBlock)(oldState, trOld.selection) && !!(0, $enBNf.findCodeBlock)(newState, trNew.selection);
            const browser = (0, $d7ZU3.getBrowserInfo)();
            /**
			 * Mac will auto insert a fullstop when the user double taps the space key after some content.
			 * Line number decorators are assumed content so on new lines the fullstop is inserted.
			 *
			 * - When a fulltop is auto inserted the new states selection is the same, the old state selection is one position less
			 * - The text returned for the old state returns as a space with the selection from - 1
			 * - The text returned for the new state returns as a fullstop with the selection from - 2 to from -1
			 *
			 * This is enough conditional logic to isoloate the auto insertion of the fullstop on mac
			 *
			 * There are some solutions to this problem in codemirror which can be read further here
			 * https://discuss.codemirror.net/t/dot-being-added-when-pressing-space-repeatedly/3899
			 */ // both selections must be of code block early exit
            if (browser.mac && fromNew === toNew && fromNew === fromOld + 1 && isCodeBlock) // detect when '.' is inserted when the previous state was a space ' '
            try {
                const textBetweenBefore = trOld.doc.textBetween(fromOld - 1, fromOld); // ' '
                const textBetweenAfter = trNew.doc.textBetween(fromNew - 2, fromNew - 1); // '.'
                if (textBetweenBefore === ' ' && textBetweenAfter === '.') {
                    trNew.delete(fromNew - 2, fromNew); // remove the fullstop
                    trNew.insertText('  ', fromNew - 2); // insert double space
                    return trNew;
                }
            } catch (error) {
                // if for some reason textBetween fails, just return the new transaction as is by defaut.
                return undefined;
            }
            return undefined;
        }
    });
}







var $WGctw = parcelRequire("WGctw");


var $dus6D = parcelRequire("dus6D");







const $143f6bd614b701e1$export$94d363c96bda1dd9 = {
    '{': '}',
    '[': ']',
    '(': ')'
};
const $143f6bd614b701e1$export$29c04e6b1b08e223 = (before, after)=>{
    // when directly before a closing bracket
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    if (/^[}\])]/.test(after)) return true;
    // exclusion: when directly before a non-whitespace character
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    if (/^[^\s]/.test(after)) return false;
    return true;
};
const $143f6bd614b701e1$export$a40becce5a71614c = (before, after)=>{
    const left = Object.keys($143f6bd614b701e1$export$94d363c96bda1dd9).find((item)=>before.endsWith(item));
    const right = left ? $143f6bd614b701e1$export$94d363c96bda1dd9[left] : undefined;
    const hasTrailingMatchingBracket = right ? after.startsWith(right) : false;
    return {
        left: left,
        right: right,
        hasTrailingMatchingBracket: hasTrailingMatchingBracket
    };
};





var $aU3dp = parcelRequire("aU3dp");





const $4900dac1f59b7610$export$b54b55a89e362241 = (state)=>state.selection.$from.sameParent(state.selection.$to) && state.selection.$from.parent.type === state.schema.nodes.codeBlock;
const $4900dac1f59b7610$export$cecd33f3def3e129 = (state)=>!!(0, $60a45f8e35213e68$export$da3f040fb23d21f)(state.selection) && $4900dac1f59b7610$export$b54b55a89e362241(state);
const $4900dac1f59b7610$export$13a3ef35664ba7de = (state)=>{
    const { $from: $from } = state.selection;
    if ($from.nodeBefore && $from.nodeBefore.isText) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const prevNewLineIndex = $from.nodeBefore.text.lastIndexOf('\n');
        return {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            text: $from.nodeBefore.text.substring(prevNewLineIndex + 1),
            pos: $from.start() + prevNewLineIndex + 1
        };
    }
    return {
        text: '',
        pos: $from.pos
    };
};
const $4900dac1f59b7610$export$8291149050336443 = (state)=>{
    const { $to: $to } = state.selection;
    if ($to.nodeAfter && $to.nodeAfter.isText) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const nextNewLineIndex = $to.nodeAfter.text.indexOf('\n');
        return {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            text: $to.nodeAfter.text.substring(0, nextNewLineIndex >= 0 ? nextNewLineIndex : undefined),
            pos: nextNewLineIndex >= 0 ? $to.pos + nextNewLineIndex : $to.end()
        };
    }
    return {
        text: '',
        pos: $to.pos
    };
};
function $4900dac1f59b7610$export$64ccdebd7526708f(state) {
    const { pos: start } = $4900dac1f59b7610$export$13a3ef35664ba7de(state);
    const { pos: end } = $4900dac1f59b7610$export$8291149050336443(state);
    const text = state.doc.textBetween(start, end);
    return {
        text: text,
        start: start,
        end: end
    };
}
const $4900dac1f59b7610$export$7f5b487b51da88d0 = (text, callback)=>{
    let offset = 0;
    text.split('\n').forEach((line)=>{
        callback(line, offset);
        offset += line.length + 1;
    });
};
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $4900dac1f59b7610$var$SPACE = {
    token: ' ',
    size: 2,
    regex: /[^ ]/
};
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $4900dac1f59b7610$var$TAB = {
    token: '\t',
    size: 1,
    regex: /[^\t]/
};
const $4900dac1f59b7610$export$7af82191547c5ff7 = (line)=>{
    const indentToken = line.startsWith('\t') ? $4900dac1f59b7610$var$TAB : $4900dac1f59b7610$var$SPACE;
    const indentLength = line.search(indentToken.regex);
    const indentText = line.substring(0, indentLength >= 0 ? indentLength : line.length);
    return {
        indentToken: indentToken,
        indentText: indentText
    };
};


/**
 * Return the current indentation level
 * @param indentText - Text in the code block that represent an indentation
 * @param indentSize - Size of the indentation token in a string
 */ function $b2b7f2278bd11bdf$var$getIndentLevel(indentText, indentSize) {
    if (indentSize === 0 || indentText.length === 0) return 0;
    return indentText.length / indentSize;
}
const $b2b7f2278bd11bdf$export$79ebfa808dffa5c6 = (editorAnalyticsAPI)=>(state, dispatch)=>{
        const { text: text, start: start } = (0, $4900dac1f59b7610$export$64ccdebd7526708f)(state);
        const { tr: tr, selection: selection } = state;
        (0, $4900dac1f59b7610$export$7f5b487b51da88d0)(text, (line, offset)=>{
            const { indentText: indentText, indentToken: indentToken } = (0, $4900dac1f59b7610$export$7af82191547c5ff7)(line);
            const indentLevel = $b2b7f2278bd11bdf$var$getIndentLevel(indentText, indentToken.size);
            const indentToAdd = indentToken.token.repeat(indentToken.size - indentText.length % indentToken.size || indentToken.size);
            tr.insertText(indentToAdd, tr.mapping.map(start + offset, -1));
            editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $d925B.ACTION).FORMATTED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_INDENT,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: {
                    inputMethod: (0, $d925B.INPUT_METHOD).KEYBOARD,
                    previousIndentationLevel: indentLevel,
                    newIndentLevel: indentLevel + 1,
                    direction: (0, $aU3dp.INDENT_DIRECTION).INDENT,
                    indentType: (0, $aU3dp.INDENT_TYPE).CODE_BLOCK
                }
            })(tr);
            if (!selection.empty) tr.setSelection((0, $ks2lK.TextSelection).create(tr.doc, tr.mapping.map(selection.from, -1), tr.selection.to));
        });
        if (dispatch) dispatch(tr);
        return true;
    };
const $b2b7f2278bd11bdf$export$25755c0352544598 = (editorAnalyticsAPI)=>(state, dispatch)=>{
        const { text: text, start: start } = (0, $4900dac1f59b7610$export$64ccdebd7526708f)(state);
        const { tr: tr } = state;
        (0, $4900dac1f59b7610$export$7f5b487b51da88d0)(text, (line, offset)=>{
            const { indentText: indentText, indentToken: indentToken } = (0, $4900dac1f59b7610$export$7af82191547c5ff7)(line);
            if (indentText) {
                const indentLevel = $b2b7f2278bd11bdf$var$getIndentLevel(indentText, indentToken.size);
                const unindentLength = indentText.length % indentToken.size || indentToken.size;
                tr.delete(tr.mapping.map(start + offset), tr.mapping.map(start + offset + unindentLength));
                editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: (0, $d925B.ACTION).FORMATTED,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
                    actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_INDENT,
                    eventType: (0, $d925B.EVENT_TYPE).TRACK,
                    attributes: {
                        inputMethod: (0, $d925B.INPUT_METHOD).KEYBOARD,
                        previousIndentationLevel: indentLevel,
                        newIndentLevel: indentLevel - 1,
                        direction: (0, $aU3dp.INDENT_DIRECTION).OUTDENT,
                        indentType: (0, $aU3dp.INDENT_TYPE).CODE_BLOCK
                    }
                })(tr);
            }
        });
        if (dispatch) dispatch(tr);
        return true;
    };
function $b2b7f2278bd11bdf$export$ba3935b326bda6a5(state, dispatch) {
    const { text: textAtStartOfLine } = (0, $4900dac1f59b7610$export$13a3ef35664ba7de)(state);
    const { indentToken: indentToken } = (0, $4900dac1f59b7610$export$7af82191547c5ff7)(textAtStartOfLine);
    const indentToAdd = indentToken.token.repeat(indentToken.size - textAtStartOfLine.length % indentToken.size || indentToken.size);
    dispatch(state.tr.insertText(indentToAdd));
    return true;
}
function $b2b7f2278bd11bdf$export$1b9cc0cafa2b529c(state, dispatch) {
    const { text: textAtStartOfLine } = (0, $4900dac1f59b7610$export$13a3ef35664ba7de)(state);
    const { indentText: indentText } = (0, $4900dac1f59b7610$export$7af82191547c5ff7)(textAtStartOfLine);
    if (indentText && dispatch) {
        dispatch(state.tr.insertText('\n' + indentText));
        return true;
    }
    return false;
}




const $461b093d316f19c1$export$bb64b01afeb72d0a = {
    "'": "'",
    '"': '"',
    '`': '`'
};
const $461b093d316f19c1$export$42f0a0996a9a464d = (before, after)=>{
    // when directly before a closing bracket
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    if (/^[}\])]/.test(after)) return true;
    // exclusion: when directly before a non-whitespace character
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    if (/^[^\s]/.test(after)) return false;
    // exclusion: when directly after a letter or quote
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    if (/[A-Za-z0-9]$/.test(before) || /[\'\"\`]$/.test(before)) return false;
    return true;
};
const $461b093d316f19c1$export$6af564d7e42f37e8 = (before, after)=>{
    const left = Object.keys($461b093d316f19c1$export$bb64b01afeb72d0a).find((item)=>before.endsWith(item));
    const right = left ? $461b093d316f19c1$export$bb64b01afeb72d0a[left] : undefined;
    const hasTrailingMatchingQuote = right ? after.startsWith(right) : false;
    return {
        left: left,
        right: right,
        hasTrailingMatchingQuote: hasTrailingMatchingQuote
    };
};


const $8901f3edac79418e$var$PAIRED_CHARACTER_MAP = {
    ...(0, $143f6bd614b701e1$export$94d363c96bda1dd9),
    ...(0, $461b093d316f19c1$export$bb64b01afeb72d0a)
};
const $8901f3edac79418e$export$1d6d73d16dcadbdd = (after)=>{
    return Object.keys($8901f3edac79418e$var$PAIRED_CHARACTER_MAP).some((leftCharacter)=>after.startsWith($8901f3edac79418e$var$PAIRED_CHARACTER_MAP[leftCharacter]));
};
const $8901f3edac79418e$export$ea0560eb552fb0a7 = (text)=>{
    return Object.keys($8901f3edac79418e$var$PAIRED_CHARACTER_MAP).some((leftCharacter)=>text === $8901f3edac79418e$var$PAIRED_CHARACTER_MAP[leftCharacter]);
};




const $043a9bf6cfe9cc6a$var$ideUX = (pluginInjectionApi)=>{
    const editorAnalyticsAPI = pluginInjectionApi?.analytics?.actions;
    return new (0, $1S4f7.SafePlugin)({
        props: {
            handleTextInput (view, from, to, text) {
                const { state: state, dispatch: dispatch } = view;
                const compositionPluginState = pluginInjectionApi?.composition?.sharedState.currentState();
                if ((0, $4900dac1f59b7610$export$cecd33f3def3e129)(state) && !compositionPluginState?.isComposing) {
                    const beforeText = (0, $4900dac1f59b7610$export$13a3ef35664ba7de)(state).text;
                    const afterText = (0, $4900dac1f59b7610$export$8291149050336443)(state).text;
                    // If text is a closing bracket/quote and we've already inserted it, move the selection after
                    if ((0, $8901f3edac79418e$export$1d6d73d16dcadbdd)(afterText) && (0, $8901f3edac79418e$export$ea0560eb552fb0a7)(text) && afterText.startsWith(text)) {
                        dispatch((0, $8m4tT.setTextSelection)(to + text.length)(state.tr));
                        return true;
                    }
                    // Automatically add right-hand side bracket when user types the left bracket
                    if ((0, $143f6bd614b701e1$export$29c04e6b1b08e223)(beforeText, afterText)) {
                        const { left: left, right: right } = (0, $143f6bd614b701e1$export$a40becce5a71614c)(beforeText + text, afterText);
                        if (left && right) {
                            const bracketPair = state.schema.text(text + right);
                            const tr = state.tr.replaceWith(from, to, bracketPair);
                            dispatch((0, $8m4tT.setTextSelection)(from + text.length)(tr));
                            return true;
                        }
                    }
                    // Automatically add closing quote when user types a starting quote
                    if ((0, $461b093d316f19c1$export$42f0a0996a9a464d)(beforeText, afterText)) {
                        const { left: leftQuote, right: rightQuote } = (0, $461b093d316f19c1$export$6af564d7e42f37e8)(beforeText + text, afterText);
                        if (leftQuote && rightQuote) {
                            const quotePair = state.schema.text(text + rightQuote);
                            const tr = state.tr.replaceWith(from, to, quotePair);
                            dispatch((0, $8m4tT.setTextSelection)(from + text.length)(tr));
                            return true;
                        }
                    }
                }
                return false;
            },
            handleKeyDown: (0, $dus6D.keydownHandler)({
                Backspace: (state, dispatch)=>{
                    if ((0, $4900dac1f59b7610$export$cecd33f3def3e129)(state)) {
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        const $cursor = (0, $60a45f8e35213e68$export$da3f040fb23d21f)(state.selection);
                        const beforeText = (0, $4900dac1f59b7610$export$13a3ef35664ba7de)(state).text;
                        const afterText = (0, $4900dac1f59b7610$export$8291149050336443)(state).text;
                        const { left: leftBracket, right: rightBracket, hasTrailingMatchingBracket: hasTrailingMatchingBracket } = (0, $143f6bd614b701e1$export$a40becce5a71614c)(beforeText, afterText);
                        if (leftBracket && rightBracket && hasTrailingMatchingBracket && dispatch) {
                            dispatch(state.tr.delete($cursor.pos - leftBracket.length, $cursor.pos + rightBracket.length));
                            return true;
                        }
                        const { left: leftQuote, right: rightQuote, hasTrailingMatchingQuote: hasTrailingMatchingQuote } = (0, $461b093d316f19c1$export$6af564d7e42f37e8)(beforeText, afterText);
                        if (leftQuote && rightQuote && hasTrailingMatchingQuote && dispatch) {
                            dispatch(state.tr.delete($cursor.pos - leftQuote.length, $cursor.pos + rightQuote.length));
                            return true;
                        }
                        const { indentToken: { size: size, token: token }, indentText: indentText } = (0, $4900dac1f59b7610$export$7af82191547c5ff7)(beforeText);
                        if (beforeText === indentText) {
                            if (indentText.endsWith(token.repeat(size)) && dispatch) {
                                dispatch(state.tr.delete($cursor.pos - (size - indentText.length % size || size), $cursor.pos));
                                return true;
                            }
                        }
                    }
                    return false;
                },
                Enter: (0, $WGctw.filter)((0, $4900dac1f59b7610$export$b54b55a89e362241), (0, $b2b7f2278bd11bdf$export$1b9cc0cafa2b529c)),
                'Mod-]': (0, $WGctw.filter)((0, $4900dac1f59b7610$export$b54b55a89e362241), (0, $b2b7f2278bd11bdf$export$79ebfa808dffa5c6)(editorAnalyticsAPI)),
                'Mod-[': (0, $WGctw.filter)((0, $4900dac1f59b7610$export$b54b55a89e362241), (0, $b2b7f2278bd11bdf$export$25755c0352544598)(editorAnalyticsAPI)),
                Tab: (0, $WGctw.filter)((0, $4900dac1f59b7610$export$b54b55a89e362241), (state, dispatch)=>{
                    if (!dispatch) return false;
                    if ((0, $4900dac1f59b7610$export$cecd33f3def3e129)(state)) return (0, $b2b7f2278bd11bdf$export$ba3935b326bda6a5)(state, dispatch);
                    return (0, $b2b7f2278bd11bdf$export$79ebfa808dffa5c6)(editorAnalyticsAPI)(state, dispatch);
                }),
                'Shift-Tab': (0, $WGctw.filter)((0, $4900dac1f59b7610$export$b54b55a89e362241), (0, $b2b7f2278bd11bdf$export$25755c0352544598)(editorAnalyticsAPI)),
                'Mod-a': (state, dispatch)=>{
                    if ((0, $4900dac1f59b7610$export$b54b55a89e362241)(state)) {
                        const { $from: $from, $to: $to } = state.selection;
                        const isFullCodeBlockSelection = $from.parentOffset === 0 && $to.parentOffset === $to.parent.nodeSize - 2;
                        if (!isFullCodeBlockSelection && dispatch) {
                            dispatch(state.tr.setSelection((0, $ks2lK.TextSelection).create(state.doc, $from.start(), $to.end())));
                            return true;
                        }
                    }
                    return false;
                }
            })
        }
    });
};
var $043a9bf6cfe9cc6a$export$2e2bcd8739ae039 = $043a9bf6cfe9cc6a$var$ideUX;









var $afcIe = parcelRequire("afcIe");





var $4VXMf = parcelRequire("4VXMf");

var $l03WE = parcelRequire("l03WE");





var $aIMBk = parcelRequire("aIMBk");

var $14sLv = parcelRequire("14sLv");


function $afbf4a74e817e11e$export$bdcd7d8080bcac7f(schema, editorAnalyticsAPI) {
    const rules = $afbf4a74e817e11e$var$getCodeBlockRules(editorAnalyticsAPI, schema);
    return new (0, $1S4f7.SafePlugin)((0, $aIMBk.createPlugin)('code-block-input-rule', rules, {
        isBlockNodeRule: true
    }));
}
/**
 * Get all code block input rules
 *
 * @param {Schema} schema
 * @returns {InputRuleWithHandler[]}
 */ function $afbf4a74e817e11e$var$getCodeBlockRules(editorAnalyticsAPI, schema) {
    const ruleAnalytics = (0, $l03WE.inputRuleWithAnalytics)({
        action: (0, $d925B.ACTION).INSERTED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).CODE_BLOCK,
        attributes: {
            inputMethod: (0, $d925B.INPUT_METHOD).FORMATTING
        },
        eventType: (0, $d925B.EVENT_TYPE).TRACK
    }, editorAnalyticsAPI);
    const validMatchLength = (match)=>match.length > 0 && match[0].length === 3;
    // eslint-disable-next-line require-unicode-regexp
    const threeTildeRule = (0, $4VXMf.createRule)(/(?!\s)(`{3,})$/, (state, match, start, end)=>{
        if (!validMatchLength(match)) return null;
        const attributes = (0, $dNXVc.getDefaultCodeBlockAttrs)(match[4] ? {
            language: match[4]
        } : {});
        if ((0, $53e4a41e0689db18$export$4b5d5858845bfcf6)(state)) return (0, $53e4a41e0689db18$export$92adcb8baa0906a6)(state, start, attributes);
        const tr = state.tr;
        tr.delete(start, end);
        const codeBlock = tr.doc.type.schema.nodes.codeBlock.createChecked(attributes);
        (0, $8m4tT.safeInsert)(codeBlock)(tr);
        return tr;
    });
    const leftNodeReplacementThreeTildeRule = (0, $4VXMf.createRule)(// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    new RegExp(`((${(0, $14sLv.leafNodeReplacementCharacter)}\`{3,})|^\\s(\`{3,}))(\\S*)$`), (state, match, start, end)=>{
        if (!validMatchLength(match)) return null;
        const attributes = (0, $dNXVc.getDefaultCodeBlockAttrs)(match[4] ? {
            language: match[4]
        } : {});
        const inlineStart = Math.max(match.index + state.selection.$from.start(), 1);
        return (0, $afcIe.insertBlock)(state, schema.nodes.codeBlock, inlineStart, end, attributes);
    });
    return [
        ruleAnalytics(threeTildeRule),
        ruleAnalytics(leftNodeReplacementThreeTildeRule)
    ];
}



var $l9G9n = parcelRequire("l9G9n");











const $376c98df80c817ca$var$deleteCurrentItem = ($from)=>(tr)=>{
        return tr.delete($from.before($from.depth), $from.after($from.depth));
    };
const $376c98df80c817ca$var$setTextSelection = (pos)=>(tr)=>{
        const newSelection = (0, $ks2lK.Selection).findFrom(tr.doc.resolve(pos), -1, true);
        if (newSelection) tr.setSelection(newSelection);
        return tr;
    };
function $376c98df80c817ca$export$e832373cff8dec22(schema) {
    return (0, $dus6D.keymap)({
        Backspace: (state, dispatch)=>{
            const $cursor = (0, $60a45f8e35213e68$export$da3f040fb23d21f)(state.selection);
            const { codeBlock: codeBlock, listItem: listItem, table: table, layoutColumn: layoutColumn, paragraph: paragraph } = state.schema.nodes;
            if (!$cursor || $cursor.parent.type !== codeBlock || !dispatch) return false;
            if ($cursor.pos === 1 || (0, $8m4tT.hasParentNodeOfType)(listItem)(state.selection) && $cursor.parentOffset === 0) {
                const node = (0, $8m4tT.findParentNodeOfTypeClosestToPos)($cursor, codeBlock);
                if (!node) return false;
                dispatch(state.tr.setNodeMarkup(node.pos, node.node.type, node.node.attrs, []).setBlockType($cursor.pos, $cursor.pos, paragraph));
                return true;
            }
            if ($cursor.node && (0, $l9G9n.isEmptyNode)(schema)($cursor.node()) && ((0, $8m4tT.hasParentNodeOfType)(layoutColumn)(state.selection) || (0, $8m4tT.hasParentNodeOfType)(table)(state.selection))) {
                const { tr: tr } = state;
                const insertPos = $cursor.pos;
                $376c98df80c817ca$var$deleteCurrentItem($cursor)(tr);
                $376c98df80c817ca$var$setTextSelection(insertPos)(tr);
                dispatch(tr.scrollIntoView());
                return true;
            }
            // Handle not nested empty code block
            if ((0, $l9G9n.isEmptyNode)(schema)($cursor.node())) {
                dispatch($376c98df80c817ca$var$deleteCurrentItem($cursor)(state?.tr));
                return true;
            }
            return false;
        }
    });
}
var $376c98df80c817ca$export$2e2bcd8739ae039 = $376c98df80c817ca$export$e832373cff8dec22;















var $3tffm = parcelRequire("3tffm");




























const $0e9812aff98b7f6f$export$f05434c51e3762e = (state)=>(0, $3848854553e34219$export$18d4026d1ea86bb1).getState(state);



var $5MaNT = parcelRequire("5MaNT");

const $7096d1f41ed4202c$export$4ffea7f3ae91d083 = {
    container: (0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER,
    start: (0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_START,
    end: (0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_END,
    contentWrapper: (0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER,
    contentWrapped: (0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPED,
    gutter: (0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER,
    content: (0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT,
    lineNumberWidget: (0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER_LINE_NUMBER_WIDGET
};


// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $1ed120fb9dd45e9c$var$MATCH_NEWLINES = new RegExp('\n', 'g');
const $1ed120fb9dd45e9c$var$toDOM = (node, contentEditable, formattedAriaLabel)=>[
        'div',
        {
            class: (0, $7096d1f41ed4202c$export$4ffea7f3ae91d083).container
        },
        [
            'div',
            {
                class: (0, $7096d1f41ed4202c$export$4ffea7f3ae91d083).start,
                contenteditable: 'false'
            }
        ],
        [
            'div',
            {
                class: (0, $7096d1f41ed4202c$export$4ffea7f3ae91d083).contentWrapper
            },
            [
                'div',
                {
                    class: (0, $7096d1f41ed4202c$export$4ffea7f3ae91d083).gutter,
                    contenteditable: 'false'
                }
            ],
            [
                'div',
                {
                    class: (0, $7096d1f41ed4202c$export$4ffea7f3ae91d083).content
                },
                [
                    'code',
                    {
                        'data-language': node.attrs.language || '',
                        spellcheck: 'false',
                        contenteditable: contentEditable ? 'true' : 'false',
                        'data-testid': 'code-block--code',
                        'aria-label': formattedAriaLabel,
                        ...(0, $dh538.fg)('platform_editor_adf_with_localid') && {
                            'data-local-id': node.attrs.localId
                        }
                    },
                    0
                ]
            ]
        ],
        [
            'div',
            {
                class: (0, $7096d1f41ed4202c$export$4ffea7f3ae91d083).end,
                contenteditable: 'false'
            }
        ]
    ];
class $1ed120fb9dd45e9c$export$84ecc4258da6ad44 {
    handleEditorDisabledChanged() {
        if (this.api?.editorDisabled) this.cleanupEditorDisabledListener = this.api.editorDisabled.sharedState.onChange((sharedState)=>{
            if (this.contentDOM) this.contentDOM.setAttribute('contenteditable', sharedState.nextSharedState.editorDisabled ? 'false' : 'true');
        });
    }
    updateDOMAndSelection(savedInnerHTML, newCursorPosition) {
        if (this.dom?.childNodes && this.dom.childNodes.length > 1) {
            const contentWrapper = this.dom.childNodes[1];
            const contentView = contentWrapper?.childNodes[1];
            if (contentView?.childNodes?.length > 0) {
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const codeElement = contentView.firstChild;
                codeElement.innerHTML = savedInnerHTML;
                // We need to set cursor for the DOM update
                const textElement = Array.from(codeElement.childNodes).find((child)=>child.nodeName === '#text');
                const sel = window.getSelection();
                const range = document.createRange();
                range.setStart(textElement, newCursorPosition);
                range.collapse(true);
                sel?.removeAllRanges();
                sel?.addRange(range);
            }
        }
    }
    coalesceDOMElements() {
        if (this.dom?.childNodes && this.dom.childNodes.length > 1) {
            const contentWrapper = this.dom.childNodes[1];
            const contentView = contentWrapper?.childNodes[1];
            if (contentView?.childNodes && contentView.childNodes.length > 1) {
                let savedInnerHTML = '';
                while(contentView.childNodes.length > 1){
                    // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    const lastChild = contentView.lastChild;
                    savedInnerHTML = lastChild.innerHTML + savedInnerHTML;
                    contentView.removeChild(lastChild);
                }
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const firstChild = contentView.firstChild;
                savedInnerHTML = firstChild.innerHTML + '\n' + savedInnerHTML;
                const newCursorPosition = firstChild.innerHTML.length + 1;
                setTimeout(this.updateDOMAndSelection.bind(this, savedInnerHTML, newCursorPosition), 20);
            }
        }
    }
    update(node) {
        if (node.type !== this.node.type) return false;
        if (node !== this.node) {
            if (node.attrs.language !== this.node.attrs.language) this.contentDOM.setAttribute('data-language', node.attrs.language || '');
            this.node = node;
            this.maintainDynamicGutterSize();
            const browser = (0, $d7ZU3.getBrowserInfo)();
            if (browser.android) {
                this.coalesceDOMElements();
                (0, $842bd612836073a1$export$60364cd5f5fed191)(this.view.state, this.view.dispatch);
            }
        }
        return true;
    }
    ignoreMutation(record) {
        const pluginState = (0, $0e9812aff98b7f6f$export$f05434c51e3762e)(this.view.state);
        if (pluginState?.shouldIgnoreFollowingMutations) return true;
        // Ensure updating the line-number gutter doesn't trigger reparsing the codeblock
        return record.target === this.lineNumberGutter || record.target.parentNode === this.lineNumberGutter;
    }
    destroy() {
        if (this.cleanupEditorDisabledListener) this.cleanupEditorDisabledListener();
        this.cleanupEditorDisabledListener = undefined;
    }
    constructor(_node, view, getPos, formattedAriaLabel, api, cleanupEditorDisabledListener){
        this.cleanupEditorDisabledListener = cleanupEditorDisabledListener;
        this.node = void 0;
        this.dom = void 0;
        this.contentDOM = void 0;
        this.lineNumberGutter = void 0;
        this.getPos = void 0;
        this.view = void 0;
        this.formattedAriaLabel = '';
        this.api = void 0;
        /**
     * As the code block updates we get the maximum amount of digits in a line number and expand the number gutter to reflect this.
     */ this.maintainDynamicGutterSize = ()=>{
            let totalLineCount = 1;
            this.node.forEach((node)=>{
                const text = node.text;
                if (text) // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                totalLineCount += (node.text.match($1ed120fb9dd45e9c$var$MATCH_NEWLINES) || []).length;
            });
            const maxDigits = totalLineCount.toString().length;
            this.dom.style.setProperty('--lineNumberGutterWidth', `${maxDigits}ch`);
        };
        const { dom: dom, contentDOM: contentDOM } = (0, $5SAOw.DOMSerializer).renderSpec(document, $1ed120fb9dd45e9c$var$toDOM(_node, !api?.editorDisabled?.sharedState.currentState()?.editorDisabled, formattedAriaLabel));
        this.getPos = getPos;
        this.view = view;
        this.node = _node;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.dom = dom;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.contentDOM = contentDOM;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.lineNumberGutter = this.dom.querySelector(`.${(0, $7096d1f41ed4202c$export$4ffea7f3ae91d083).gutter}`);
        this.api = api;
        this.maintainDynamicGutterSize();
        // Ensure the code block node has a wrapped state.
        // Wrapped state may already exist from breakout's recreating the node.
        if (!(0, $dNXVc.codeBlockWrappedStates).has(_node)) (0, $dNXVc.codeBlockWrappedStates).set(_node, (0, $dNXVc.defaultWordWrapState));
        this.handleEditorDisabledChanged();
    }
}
const $1ed120fb9dd45e9c$export$9ea0022afafc61b7 = (node, view, getPos, formattedAriaLabel, api)=>new $1ed120fb9dd45e9c$export$84ecc4258da6ad44(node, view, getPos, formattedAriaLabel, api);




const $7e5c46d6468f6272$export$bd3710c0a5fb6dad = (pendingFormats, tr, newState)=>{
    const entries = Object.entries(pendingFormats);
    if (entries.length === 0) return pendingFormats;
    let nextPendingFormats = pendingFormats;
    entries.forEach(([localId, pendingFormat])=>{
        const { deleted: deleted, pos: pos } = tr.mapping.mapResult(pendingFormat.pos, 1);
        const codeBlockNode = newState.doc.nodeAt(pos);
        const shouldRemovePendingFormat = deleted || codeBlockNode?.type !== newState.schema.nodes.codeBlock || codeBlockNode?.attrs.localId !== localId;
        const shouldUpdatePendingFormat = pos !== pendingFormat.pos;
        if (shouldRemovePendingFormat || shouldUpdatePendingFormat) {
            if (nextPendingFormats === pendingFormats) nextPendingFormats = {
                ...pendingFormats
            };
        }
        if (shouldRemovePendingFormat) {
            delete nextPendingFormats[localId];
            return;
        }
        if (shouldUpdatePendingFormat) nextPendingFormats[localId] = {
            ...pendingFormat,
            pos: pos
        };
    });
    return nextPendingFormats;
};
function $7e5c46d6468f6272$var$removeRecordEntry(record, key) {
    const nextRecord = {
        ...record
    };
    delete nextRecord[key];
    return nextRecord;
}
const $7e5c46d6468f6272$export$6d52e1741d2cdede = (pluginState, meta)=>{
    switch(meta?.type){
        case (0, $88b7294e6fc1bbcd$export$92a1a3b7554e9387).START_FORMAT_CODE:
            return {
                ...pluginState,
                pendingFormats: {
                    ...pluginState.pendingFormats,
                    [meta.data.localId]: {
                        languageSource: meta.data.languageSource,
                        pos: meta.data.pos,
                        requestId: meta.data.requestId
                    }
                }
            };
        case (0, $88b7294e6fc1bbcd$export$92a1a3b7554e9387).RESOLVE_FORMAT_CODE:
            {
                const pendingFormats = $7e5c46d6468f6272$var$removeRecordEntry(pluginState.pendingFormats, meta.data.localId);
                const formatCodeErrors = $7e5c46d6468f6272$var$removeRecordEntry(pluginState.formatCodeErrors, meta.data.localId);
                return {
                    ...pluginState,
                    formatCodeErrors: meta.data.outcome === 'failed' ? {
                        ...formatCodeErrors,
                        [meta.data.localId]: {
                            errorType: meta.data.errorType,
                            localId: meta.data.localId,
                            languageSource: meta.data.languageSource
                        }
                    } : formatCodeErrors,
                    pendingFormats: pendingFormats
                };
            }
        case (0, $88b7294e6fc1bbcd$export$92a1a3b7554e9387).CLEAR_FORMAT_CODE_ERROR:
            return {
                ...pluginState,
                formatCodeErrors: $7e5c46d6468f6272$var$removeRecordEntry(pluginState.formatCodeErrors, meta.data.localId)
            };
        default:
            return pluginState;
    }
};











const $3c246a92a96b72bd$export$feb1744c3f7a1a44 = 'decorationWidgetType';
const $3c246a92a96b72bd$export$7d62a9abd4358350 = 'decorationNodeType';
const $3c246a92a96b72bd$export$e39f4b987bac6a89 = (state)=>{
    const codeBlockNodes = (0, $60a45f8e35213e68$export$f43d710a87ced169)(state);
    return codeBlockNodes.flatMap((node)=>$3c246a92a96b72bd$export$9955827033f49bf6($3c246a92a96b72bd$export$e2f66570e25f0fa7(node)));
};
const $3c246a92a96b72bd$export$af0ed0ae85f93cba = (tr, codeBlockNodes, decorationSet)=>{
    let updatedDecorationSet = decorationSet;
    // Update line number decorators for changed code block nodes if new line added or line removed.
    updatedDecorationSet = $3c246a92a96b72bd$export$b7832269a6c1c9aa(tr, codeBlockNodes, updatedDecorationSet);
    // Check to make sure the word wrap decorators are still valid.
    updatedDecorationSet = $3c246a92a96b72bd$export$7384f52a5ea552e1(tr, codeBlockNodes, updatedDecorationSet);
    return updatedDecorationSet;
};
const $3c246a92a96b72bd$export$b7832269a6c1c9aa = (tr, codeBlockNodes, decorationSet)=>{
    let updatedDecorationSet = decorationSet;
    const lineNumberDecorators = [];
    codeBlockNodes.forEach((node)=>{
        const existingWidgetsOnNode = updatedDecorationSet.find(node.pos, node.pos + node.node.nodeSize, (spec)=>spec.type === $3c246a92a96b72bd$export$feb1744c3f7a1a44);
        const newLineAttributes = $3c246a92a96b72bd$export$e2f66570e25f0fa7(node);
        // There will be no widgets on initialisation. If the number of existing widgets does not equal the amount of lines, regenerate the widgets.
        // There may be a case where the number of existing widgets and the number of lines are the same, that's why we track totalLineCount. This allows
        // us to know how many lines there were when the widget was created. It avoids a break in line numbers, e.g. "1, 2, 3, 5, 6". Happens on line removal.
        if (existingWidgetsOnNode.length === 0 || existingWidgetsOnNode.length !== newLineAttributes.length || existingWidgetsOnNode[0].spec.totalLineCount !== newLineAttributes.length) {
            updatedDecorationSet = updatedDecorationSet.remove(existingWidgetsOnNode);
            lineNumberDecorators.push(...$3c246a92a96b72bd$export$9955827033f49bf6(newLineAttributes));
        }
    });
    return updatedDecorationSet.add(tr.doc, [
        ...lineNumberDecorators
    ]);
};
const $3c246a92a96b72bd$export$e2f66570e25f0fa7 = (node)=>{
    const { node: innerNode, pos: pos } = node;
    // Get content node
    const contentNode = innerNode.content;
    // Get node text content
    let lineAttributes = [];
    // Early exit if content size is 0
    if (contentNode.size === 0) return [
        {
            lineStart: pos + 1,
            lineNumber: 1
        }
    ];
    contentNode.forEach((child)=>{
        const nodeTextContent = child.textContent;
        const nodeStartPos = pos;
        let lineStartIndex = nodeStartPos;
        // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
        const newLineAttributes = nodeTextContent.split('\n').map((line, index)=>{
            const lineLength = line.length;
            const lineStart = lineStartIndex + 1;
            const lineNumber = index + 1;
            // Include the newline character and increment to keep tabs on line position
            lineStartIndex += lineLength + 1;
            return {
                lineStart: lineStart,
                lineNumber: lineNumber
            };
        });
        lineAttributes = [
            ...lineAttributes,
            ...newLineAttributes
        ];
    });
    return lineAttributes;
};
const $3c246a92a96b72bd$export$9955827033f49bf6 = (lineAttributes)=>{
    const widgetDecorations = lineAttributes.map((lineAttribute)=>{
        const { lineStart: lineStart, lineNumber: lineNumber } = lineAttribute;
        // Passing a function to create the widget rather than directly passing a widget, as per ProseMirror docs.
        const createLineNumberWidget = ()=>{
            const widget = document.createElement('span');
            widget.textContent = `${lineNumber}`;
            widget.classList.add((0, $7096d1f41ed4202c$export$4ffea7f3ae91d083).lineNumberWidget);
            return widget;
        };
        // side -1 is used so the line numbers are the first thing to the left of the lines of code.
        // totalLineCount is used to know whether or not to update the line numbers when a new line is added or removed.
        return (0, $ftzrq.Decoration).widget(lineStart, createLineNumberWidget, {
            type: $3c246a92a96b72bd$export$feb1744c3f7a1a44,
            side: -1,
            totalLineCount: lineAttributes.length
        });
    });
    return widgetDecorations;
};
const $3c246a92a96b72bd$export$7384f52a5ea552e1 = (tr, codeBlockNodes, decorationSet)=>{
    let updatedDecorationSet = decorationSet;
    codeBlockNodes.forEach((node)=>{
        const isCodeBlockWrappedInState = (0, $dNXVc.isCodeBlockWordWrapEnabled)(node.node);
        const isCodeBlockWrappedByDecorator = $3c246a92a96b72bd$export$343dbf55d0e24df2(node.pos, decorationSet).length !== 0;
        if (isCodeBlockWrappedInState !== isCodeBlockWrappedByDecorator) updatedDecorationSet = $3c246a92a96b72bd$export$655c2c2993b251d2(decorationSet, tr, node);
    });
    return updatedDecorationSet;
};
const $3c246a92a96b72bd$export$655c2c2993b251d2 = (decorationSet, tr, node)=>{
    if (!node || node.pos === undefined) return decorationSet;
    let updatedDecorationSet = decorationSet;
    const { pos: pos, node: innerNode } = node;
    const isNodeWrapped = (0, $dNXVc.isCodeBlockWordWrapEnabled)(innerNode);
    if (!isNodeWrapped) {
        const currentWrappedBlockDecorationSet = $3c246a92a96b72bd$export$343dbf55d0e24df2(pos, updatedDecorationSet);
        updatedDecorationSet = updatedDecorationSet.remove(currentWrappedBlockDecorationSet);
        // In code block advanced we don't use the node decoration - however a change in decorations
        // is how we detect updates to the word wrap. If we have no decorations attached we've
        // likely changed the breakout width with the toggle ON - we add an empty decoration to force
        // prosemirror to recognise the change so we can update in our node view. This gets filtered
        // out on the next toggle.
        if (currentWrappedBlockDecorationSet.length === 0 && pos + innerNode.nodeSize <= tr.doc.content.size) {
            const wrappedBlock = (0, $ftzrq.Decoration).node(pos, pos + innerNode.nodeSize, {}, {
                type: $3c246a92a96b72bd$export$7d62a9abd4358350
            } // Allows for quick filtering of decorations while using `find`
            );
            updatedDecorationSet = updatedDecorationSet.add(tr.doc, [
                wrappedBlock
            ]);
        }
    } else {
        const wrappedBlock = (0, $ftzrq.Decoration).node(pos, pos + innerNode.nodeSize, {
            class: (0, $7096d1f41ed4202c$export$4ffea7f3ae91d083).contentWrapped
        }, {
            type: $3c246a92a96b72bd$export$7d62a9abd4358350
        } // Allows for quick filtering of decorations while using `find`
        );
        updatedDecorationSet = updatedDecorationSet.add(tr.doc, [
            wrappedBlock
        ]);
    }
    return updatedDecorationSet;
};
const $3c246a92a96b72bd$export$343dbf55d0e24df2 = (pos, decorationSet)=>{
    const codeBlockNodePosition = pos + 1; // We need to add 1 to the position to get the start of the node.
    const currentWrappedBlockDecorationSet = decorationSet.find(codeBlockNodePosition, codeBlockNodePosition, (spec)=>spec.type === $3c246a92a96b72bd$export$7d62a9abd4358350);
    return currentWrappedBlockDecorationSet;
};




const $4f7d056bbf670d70$export$ae829ec7b2625219 = ({ useLongPressSelection: useLongPressSelection = false, getIntl: getIntl, allowCompositionInputOverride: allowCompositionInputOverride = false, api: api })=>{
    const handleDOMEvents = {
        click: ()=>{
            // Set hasHadInteraction to true on any click of code blocks, as clicks
            // on code blocks to not propagate to editor-level click handlers
            api?.core?.actions.execute(api?.interaction?.commands.handleInteraction);
        }
    };
    // ME-1599: Composition on mobile was causing the DOM observer to mutate the code block
    // incorrecly and lose content when pressing enter in the middle of a code block line.
    if (allowCompositionInputOverride) handleDOMEvents.beforeinput = (view, event)=>{
        const keyEvent = event;
        const eventInputType = keyEvent.inputType;
        const eventText = keyEvent.data;
        const browser = (0, $d7ZU3.getBrowserInfo)();
        if (browser.ios && event.composed && // insertParagraph will be the input type when the enter key is pressed.
        eventInputType === 'insertParagraph' && (0, $enBNf.findCodeBlock)(view.state, view.state.selection)) {
            event.preventDefault();
            return true;
        } else if (browser.android && event.composed && eventInputType === 'insertCompositionText' && eventText[eventText?.length - 1] === '\n' && (0, $enBNf.findCodeBlock)(view.state, view.state.selection)) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const resultingText = event.target.outerText + '\n';
            if (resultingText.endsWith(eventText)) // End of paragraph
            setTimeout(()=>{
                view.someProp('handleKeyDown', (f)=>f(view, new KeyboardEvent('keydown', {
                        bubbles: true,
                        cancelable: true,
                        key: 'Enter',
                        code: 'Enter'
                    })));
            }, 0);
            else // Middle of paragraph, end of line
            (0, $842bd612836073a1$export$e6e93d61d1873d0c)(view.state, view.dispatch);
            return true;
        }
        if (browser.android) (0, $842bd612836073a1$export$60364cd5f5fed191)(view.state, view.dispatch);
        return false;
    };
    return new (0, $1S4f7.SafePlugin)({
        state: {
            init (_, state) {
                const node = (0, $enBNf.findCodeBlock)(state, state.selection);
                const initialDecorations = // Disabled when using advanced code block advanced since it interfers with styling
                // Long term we will deprecate the code block plugin and move all the related logic to
                // the advanced plugin
                // @ts-expect-error Code block advanced cannot depend on code block
                api?.codeBlockAdvanced !== undefined && (0, $1oCLl.expValEquals)('platform_editor_code_block_fold_gutter', 'isEnabled', true) ? [] : (0, $3c246a92a96b72bd$export$e39f4b987bac6a89)(state);
                return {
                    pos: node ? node.pos : null,
                    contentCopied: false,
                    formatCodeErrors: {},
                    isNodeSelected: false,
                    pendingFormats: {},
                    shouldIgnoreFollowingMutations: false,
                    decorations: (0, $ftzrq.DecorationSet).create(state.doc, initialDecorations)
                };
            },
            apply (tr, pluginState, _oldState, newState) {
                const meta = tr.getMeta((0, $3848854553e34219$export$18d4026d1ea86bb1));
                if (meta?.type === (0, $88b7294e6fc1bbcd$export$92a1a3b7554e9387).SET_IS_WRAPPED) {
                    const node = (0, $enBNf.findCodeBlock)(newState, tr.selection);
                    return {
                        ...pluginState,
                        decorations: (0, $3c246a92a96b72bd$export$655c2c2993b251d2)(pluginState.decorations, tr, node)
                    };
                }
                if (tr.docChanged) {
                    const node = (0, $enBNf.findCodeBlock)(newState, tr.selection);
                    const codeBlockNodes = (0, $60a45f8e35213e68$export$3fa3c149b89781e7)(tr);
                    // Updates mapping position of all existing decorations to new positions
                    // specifically used for updating word wrap node decorators (does not cover drag & drop, validateWordWrappedDecorators does).
                    let updatedDecorationSet = pluginState.decorations.map(tr.mapping, tr.doc);
                    if (codeBlockNodes) {
                        (0, $dNXVc.updateCodeBlockWrappedStateNodeKeys)(codeBlockNodes, _oldState);
                        // Disabled when using advanced code block for performance reasons
                        // @ts-expect-error Code block advanced cannot depend on code block
                        if (api?.codeBlockAdvanced === undefined) updatedDecorationSet = (0, $3c246a92a96b72bd$export$af0ed0ae85f93cba)(tr, codeBlockNodes, updatedDecorationSet);
                    }
                    const newPluginState = {
                        ...pluginState,
                        pos: node ? node.pos : null,
                        isNodeSelected: tr.selection instanceof (0, $ks2lK.NodeSelection),
                        decorations: updatedDecorationSet
                    };
                    if (!(0, $1oCLl.expValEquals)('platform_editor_code_block_q4_lovability', 'isEnabled', true)) return newPluginState;
                    // Successful format results change the doc and carry format meta.
                    const formatCodePluginState = (0, $7e5c46d6468f6272$export$6d52e1741d2cdede)(newPluginState, meta);
                    return {
                        ...formatCodePluginState,
                        // Pending format requests can outlive unrelated document edits.
                        pendingFormats: (0, $7e5c46d6468f6272$export$bd3710c0a5fb6dad)(formatCodePluginState.pendingFormats, tr, newState)
                    };
                }
                if (tr.selectionSet) {
                    const node = (0, $enBNf.findCodeBlock)(newState, tr.selection);
                    const newPluginState = {
                        ...pluginState,
                        pos: node ? node.pos : null,
                        isNodeSelected: tr.selection instanceof (0, $ks2lK.NodeSelection)
                    };
                    return newPluginState;
                }
                if (meta?.type === (0, $88b7294e6fc1bbcd$export$92a1a3b7554e9387).SET_COPIED_TO_CLIPBOARD) return {
                    ...pluginState,
                    contentCopied: meta.data
                };
                else if (meta?.type === (0, $88b7294e6fc1bbcd$export$92a1a3b7554e9387).SET_SHOULD_IGNORE_FOLLOWING_MUTATIONS) return {
                    ...pluginState,
                    shouldIgnoreFollowingMutations: meta.data
                };
                if ((0, $1oCLl.expValEquals)('platform_editor_code_block_q4_lovability', 'isEnabled', true)) // Failed/unchanged format results and dismissals are meta-only.
                return (0, $7e5c46d6468f6272$export$6d52e1741d2cdede)(pluginState, meta);
                return pluginState;
            }
        },
        key: (0, $3848854553e34219$export$18d4026d1ea86bb1),
        props: {
            decorations (state) {
                return (0, $3848854553e34219$export$18d4026d1ea86bb1).getState(state).decorations || (0, $ftzrq.DecorationSet).empty;
            },
            nodeViews: {
                codeBlock: (node, view, getPos)=>{
                    const { formatMessage: formatMessage } = getIntl();
                    const formattedAriaLabel = formatMessage((0, $2UWDO.messages).codeblock);
                    return (0, $1ed120fb9dd45e9c$export$9ea0022afafc61b7)(node, view, getPos, formattedAriaLabel, api);
                }
            },
            handleClickOn: (0, $3tffm.createSelectionClickHandler)([
                'codeBlock'
            ], (target)=>!!(target.classList.contains((0, $7096d1f41ed4202c$export$4ffea7f3ae91d083).lineNumberWidget) || target.classList.contains((0, $7096d1f41ed4202c$export$4ffea7f3ae91d083).gutter)), {
                useLongPressSelection: useLongPressSelection
            }),
            handleDOMEvents: handleDOMEvents
        }
    });
};







// Workaround for a firefox issue where dom selection is off sync
// https://product-fabric.atlassian.net/browse/ED-12442
const $ab31c96704dede3d$export$b3bd6df96c05d596 = ()=>{
    const domSelection = window.getSelection();
    if (domSelection) {
        const domRange = domSelection && domSelection.rangeCount === 1 && domSelection.getRangeAt(0).cloneRange();
        if (domRange) {
            domSelection.removeAllRanges();
            domSelection.addRange(domRange);
        }
    }
};
const $ab31c96704dede3d$var$refreshBrowserSelectionOnChange = (transaction, editorState)=>{
    const browser = (0, $d7ZU3.getBrowserInfo)();
    if (browser.gecko && transaction.docChanged && // codeblockState.pos should be set if current selection is in a codeblock.
    typeof (0, $3848854553e34219$export$18d4026d1ea86bb1).getState(editorState)?.pos === 'number') $ab31c96704dede3d$export$b3bd6df96c05d596();
};
var $ab31c96704dede3d$export$2e2bcd8739ae039 = $ab31c96704dede3d$var$refreshBrowserSelectionOnChange;









var $f8J4a = parcelRequire("f8J4a");

var $61p3e = parcelRequire("61p3e");


var $iHzeA = parcelRequire("iHzeA");





var $eIlE7 = parcelRequire("eIlE7");


var $2MuFw = parcelRequire("2MuFw");


var $gKvd9 = parcelRequire("gKvd9");


var $2y4tz = parcelRequire("2y4tz");


var $aK2ZC = parcelRequire("aK2ZC");





















const $3e48f5ff7e79aab7$export$1ce1cbcc4f60583f = 'none';
const $3e48f5ff7e79aab7$export$81fe902fcf56eb7c = 'autodetect';
const $3e48f5ff7e79aab7$export$5ebaabde4fc8cb67 = 'text';
const $3e48f5ff7e79aab7$export$997b95251f1f16f7 = (formatMessage)=>({
        alias: [
            $3e48f5ff7e79aab7$export$81fe902fcf56eb7c
        ],
        label: formatMessage((0, $f8J4a.codeBlockButtonMessages).detectLanguage),
        selectionSource: 'pinned',
        value: $3e48f5ff7e79aab7$export$81fe902fcf56eb7c
    });
const $3e48f5ff7e79aab7$export$1bc7cbac729eb361 = ({ formatMessage: formatMessage, languages: languages, recentlyUsedLanguages: recentlyUsedLanguages = [] })=>{
    const recentlyUsedLanguageValues = new Set(recentlyUsedLanguages.map((language)=>language.value));
    const allLanguages = languages.filter((language)=>language.value !== $3e48f5ff7e79aab7$export$1ce1cbcc4f60583f && language.value !== $3e48f5ff7e79aab7$export$5ebaabde4fc8cb67 && !recentlyUsedLanguageValues.has(language.value));
    const plainTextOption = languages.find((language)=>language.value === $3e48f5ff7e79aab7$export$5ebaabde4fc8cb67);
    const pinnedOptions = (0, $dh538.fg)('platform_editor_code_block_language_detection_flow') ? [
        $3e48f5ff7e79aab7$export$997b95251f1f16f7(formatMessage)
    ] : [];
    if (plainTextOption) pinnedOptions.push({
        ...plainTextOption,
        selectionSource: 'pinned'
    });
    return [
        {
            label: '',
            options: pinnedOptions
        },
        ...recentlyUsedLanguages.length > 0 ? [
            {
                label: formatMessage((0, $f8J4a.codeBlockButtonMessages).recentlyUsed),
                options: recentlyUsedLanguages.map((language)=>({
                        ...language,
                        selectionSource: 'recentlyUsed'
                    }))
            }
        ] : [],
        {
            label: formatMessage((0, $f8J4a.codeBlockButtonMessages).all),
            options: allLanguages.map((language)=>({
                    ...language,
                    selectionSource: 'all'
                }))
        }
    ];
};


/* LanguagePicker.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");





var $ccHMk = parcelRequire("ccHMk");





var $ghftu = parcelRequire("ghftu");


var $gdv5Z = parcelRequire("gdv5Z");


var $3hOY6 = parcelRequire("3hOY6");

var $6Ipjn = parcelRequire("6Ipjn");


const $91aaf3054348c025$var$pickerOptionStyles = null;
const $91aaf3054348c025$var$styles = {
    divider: "_h7alglyw _179rglyw _mqm2ia51 _1bsb1osq",
    trigger: "_1reo15vq _18m915vq _1bsbuuw1 _1bto1l2s _o5721q9c _ficf1e5h _1xw9glyw"
};
const $91aaf3054348c025$var$CustomGroup = (props)=>{
    const allGroups = props.selectProps.options;
    const isFirstGroup = allGroups.length > 0 && allGroups[0] === props.data;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, !isFirstGroup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        as: "hr",
        xcss: $91aaf3054348c025$var$styles.divider,
        role: "presentation"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3hOY6.components).Group, props));
};
const $91aaf3054348c025$var$CustomOption = (props)=>{
    return(// eslint-disable-next-line react/jsx-props-no-spreading -- react-select custom components must forward all props to the default Option.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3hOY6.components).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        className: (0, $gMc0m.default)([
            "_vwz478tn"
        ]),
        "data-vc": "-rUqtfdl"
    }, props.children)));
};
const $91aaf3054348c025$var$popupSelectComponents = {
    Group: $91aaf3054348c025$var$CustomGroup,
    Option: $91aaf3054348c025$var$CustomOption
};
const $91aaf3054348c025$var$menuPopperProps = {
    modifiers: [
        {
            name: 'offset',
            options: {
                offset: [
                    0,
                    8
                ]
            }
        },
        {
            name: 'preventOverflow',
            enabled: false
        }
    ]
};
const $91aaf3054348c025$var$getRecentlyUsedLanguages = (recentLanguageValues, optionsByValue)=>{
    const recentlyUsedLanguages = [];
    for (const recentLanguageValue of recentLanguageValues){
        const option = optionsByValue.get(recentLanguageValue);
        if (option) recentlyUsedLanguages.push(option);
    }
    return recentlyUsedLanguages;
};
const $91aaf3054348c025$export$409dffa5e19bc01a = ({ defaultValue: defaultValue, filterOption: filterOption, formatMessage: formatMessage, languagePickerOptions: languagePickerOptions, recentLanguageValues: recentLanguageValues = [], onMenuOpen: onMenuOpen, onSelection: onSelection })=>{
    const label = defaultValue?.label ?? formatMessage((0, $f8J4a.codeBlockButtonMessages).selectLanguage);
    const selectLanguageLabel = formatMessage((0, $f8J4a.codeBlockButtonMessages).selectLanguage);
    const [hasSearchQuery, setHasSearchQuery] = (0, $42omo.useState)(false);
    const inputValueRef = (0, $42omo.useRef)('');
    const optionsByValue = (0, $42omo.useMemo)(()=>new Map(languagePickerOptions.map((option)=>[
                option.value,
                option
            ])), [
        languagePickerOptions
    ]);
    const recentlyUsedLanguages = (0, $42omo.useMemo)(()=>$91aaf3054348c025$var$getRecentlyUsedLanguages(recentLanguageValues, optionsByValue), [
        recentLanguageValues,
        optionsByValue
    ]);
    const options = (0, $42omo.useMemo)(()=>(0, $3e48f5ff7e79aab7$export$1bc7cbac729eb361)({
            formatMessage: formatMessage,
            languages: languagePickerOptions,
            recentlyUsedLanguages: recentlyUsedLanguages
        }), [
        formatMessage,
        languagePickerOptions,
        recentlyUsedLanguages
    ]);
    const searchOptions = (0, $42omo.useMemo)(()=>options.flatMap((group)=>group.options), [
        options
    ]);
    const handleChange = (0, $42omo.useCallback)((option)=>{
        if (!option) return;
        const isSearchSelection = inputValueRef.current.trim().length > 0;
        const selectionSource = isSearchSelection ? 'search' : option.selectionSource ?? 'all';
        onSelection(option, selectionSource);
    }, [
        onSelection
    ]);
    const handleInputChange = (0, $42omo.useCallback)((newInputValue, actionMeta)=>{
        // React-select clears the input as part of selecting a value before onChange fires.
        // Keep the last user-typed query so handleChange can report search selections correctly.
        if (!actionMeta || actionMeta.action === 'input-change') inputValueRef.current = newInputValue;
        setHasSearchQuery(newInputValue.trim().length > 0);
        return newInputValue;
    }, []);
    const renderTarget = (0, $42omo.useCallback)(({ isOpen: isOpen, ref: ref, onKeyDown: onKeyDown, 'aria-controls': ariaControls })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                $91aaf3054348c025$var$styles.trigger
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            shouldFitContainer: true,
            onKeyDown: onKeyDown,
            ref: ref,
            iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($ghftu))),
            appearance: "subtle",
            isSelected: isOpen,
            "aria-controls": ariaControls,
            testId: "code-block-language-picker-trigger"
        }, label)), [
        label
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6Ipjn.default), {
        components: $91aaf3054348c025$var$popupSelectComponents,
        filterOption: filterOption,
        label: selectLanguageLabel,
        maxMenuHeight: 300,
        minMenuWidth: 200,
        menuPlacement: "auto",
        onChange: handleChange,
        onInputChange: handleInputChange,
        onMenuOpen: onMenuOpen,
        options: hasSearchQuery ? searchOptions : options,
        popperProps: $91aaf3054348c025$var$menuPopperProps,
        searchThreshold: -1,
        target: renderTarget,
        testId: "code-block-language-picker",
        defaultValue: defaultValue
    });
};



var $kt8c2 = parcelRequire("kt8c2");


var $cTQmR = parcelRequire("cTQmR");

const $00229b4e8191af1d$export$5a175c817b3d7154 = [
    {
        name: '(None)',
        alias: [
            'none'
        ],
        value: 'none'
    },
    ...(0, $cTQmR.SUPPORTED_LANGUAGES)
];
function $00229b4e8191af1d$export$c11db3aa0f1c6401(supportedLanguages, language) {
    if (!language) return undefined;
    const matches = supportedLanguages.filter((supportedLanguage)=>{
        return supportedLanguage.alias.indexOf(language.toLowerCase()) !== -1;
    });
    if (matches.length > 0) return matches[0];
    return undefined;
}
function $00229b4e8191af1d$export$b76ace6a02d76481(supportedLanguages) {
    if (!supportedLanguages || !supportedLanguages.length) return $00229b4e8191af1d$export$5a175c817b3d7154;
    return $00229b4e8191af1d$export$5a175c817b3d7154.filter((language)=>{
        let i = language.alias.length;
        while(i--){
            if (supportedLanguages.indexOf(language.alias[i]) > -1) return true;
        }
        return false;
    });
}
function $00229b4e8191af1d$export$8ef04e71795bc8a6(language) {
    return language.alias[0];
}
function $00229b4e8191af1d$export$e2dc9c8f242e4ee2(supportedLanguages) {
    return supportedLanguages.sort((left, right)=>{
        if (left.alias[0] === 'none') return -1;
        if (left.name.toLowerCase() > right.name.toLowerCase()) return 1;
        if (left.name.toLowerCase() < right.name.toLowerCase()) return -1;
        return 0;
    });
}



const $950c34f92b5ee5d9$export$377b756c63ac664b = 'recently-used-languages';
const $950c34f92b5ee5d9$var$RECENT_LANGUAGES_STORAGE_CLIENT_KEY = '@atlaskit/editor-plugin-code-block';
const $950c34f92b5ee5d9$var$MAX_RECENT_LANGUAGES = 3;
const $950c34f92b5ee5d9$var$RECENT_LANGUAGE_BLOCKLIST = new Set([
    (0, $3e48f5ff7e79aab7$export$81fe902fcf56eb7c),
    (0, $3e48f5ff7e79aab7$export$1ce1cbcc4f60583f),
    (0, $3e48f5ff7e79aab7$export$5ebaabde4fc8cb67)
]);
const $950c34f92b5ee5d9$var$KNOWN_LANGUAGE_VALUES = new Set((0, $00229b4e8191af1d$export$5a175c817b3d7154).map((language)=>(0, $00229b4e8191af1d$export$8ef04e71795bc8a6)(language)));
const $950c34f92b5ee5d9$var$recentLanguagesStorageClient = new (0, $kt8c2.default)($950c34f92b5ee5d9$var$RECENT_LANGUAGES_STORAGE_CLIENT_KEY);
const $950c34f92b5ee5d9$var$isValidRecentLanguage = (language)=>$950c34f92b5ee5d9$var$KNOWN_LANGUAGE_VALUES.has(language) && !$950c34f92b5ee5d9$var$RECENT_LANGUAGE_BLOCKLIST.has(language);
const $950c34f92b5ee5d9$var$readRecentLanguages = ()=>{
    const storedValue = $950c34f92b5ee5d9$var$recentLanguagesStorageClient.getItem($950c34f92b5ee5d9$export$377b756c63ac664b);
    return Array.isArray(storedValue) ? storedValue : [];
};
const $950c34f92b5ee5d9$export$f474067f7cfd10a = ()=>{
    try {
        return $950c34f92b5ee5d9$var$readRecentLanguages();
    } catch  {
        return [];
    }
};
const $950c34f92b5ee5d9$export$40a7fab637911506 = (language)=>{
    if (!$950c34f92b5ee5d9$var$isValidRecentLanguage(language)) return;
    try {
        const recentLanguages = $950c34f92b5ee5d9$var$readRecentLanguages();
        const nextRecentLanguages = Array.from(new Set([
            language,
            ...recentLanguages
        ])).slice(0, $950c34f92b5ee5d9$var$MAX_RECENT_LANGUAGES);
        // StorageClient only exposes setItemWithExpiry; omitting the duration stores without expiry.
        $950c34f92b5ee5d9$var$recentLanguagesStorageClient.setItemWithExpiry($950c34f92b5ee5d9$export$377b756c63ac664b, nextRecentLanguages);
    } catch  {
        return;
    }
};
const $950c34f92b5ee5d9$export$36acc0e2c8b8397d = ()=>{
    $950c34f92b5ee5d9$var$recentLanguagesStorageClient.removeItem($950c34f92b5ee5d9$export$377b756c63ac664b);
};


const $52d7b957a6e9470f$export$5393582178e4c2a = ({ api: api, defaultValue: defaultValue, editorView: editorView, filterOption: filterOption, formatMessage: formatMessage, languagePickerOptions: languagePickerOptions })=>{
    const [recentLanguageValues, setRecentLanguageValues] = (0, $42omo.useState)(()=>(0, $950c34f92b5ee5d9$export$f474067f7cfd10a)());
    const refreshRecentLanguages = (0, $42omo.useCallback)(()=>{
        setRecentLanguageValues((0, $950c34f92b5ee5d9$export$f474067f7cfd10a)());
    }, []);
    const handleSelection = (0, $42omo.useCallback)((option, selectionSource)=>{
        const command = option.value === (0, $3e48f5ff7e79aab7$export$81fe902fcf56eb7c) && (0, $dh538.fg)('platform_editor_code_block_language_detection_flow') ? (0, $842bd612836073a1$export$ae9ea24a1b29b07c)() : (0, $842bd612836073a1$export$61465194746e7fd2)(api?.analytics?.actions)(option.value, selectionSource);
        const commandSucceeded = command(editorView.state, editorView.dispatch);
        if (commandSucceeded && option.value !== (0, $3e48f5ff7e79aab7$export$81fe902fcf56eb7c)) {
            (0, $950c34f92b5ee5d9$export$40a7fab637911506)(option.value);
            setRecentLanguageValues((0, $950c34f92b5ee5d9$export$f474067f7cfd10a)());
        }
    }, [
        api?.analytics?.actions,
        editorView
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $91aaf3054348c025$export$409dffa5e19bc01a), {
        defaultValue: defaultValue,
        filterOption: filterOption,
        formatMessage: formatMessage,
        languagePickerOptions: languagePickerOptions,
        recentLanguageValues: recentLanguageValues,
        onMenuOpen: refreshRecentLanguages,
        onSelection: handleSelection
    });
};






var $aXWIB = parcelRequire("aXWIB");


var $eKkkY = parcelRequire("eKkkY");

const $71aa4bb0727e6d14$var$CustomGlyph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "24",
        height: "24",
        fill: "none",
        viewBox: "0 0 24 24",
        "data-vc": "VoqIxche"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        fill: "currentColor",
        clipPath: "url(#clip0_654_431)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M20 4h-1v16h1V4ZM3 8a1 1 0 0 1 1-1h9.5a4.5 4.5 0 1 1 0 9h-2.086l.293.293a1 1 0 0 1-1.414 1.414l-2-2a1 1 0 0 1 0-1.414l2-2a1 1 0 0 1 1.414 1.414l-.293.293H13.5a2.5 2.5 0 0 0 0-5H4a1 1 0 0 1-1-1Z",
        clipRule: "evenodd",
        fillRule: "evenodd"
    })));
const $71aa4bb0727e6d14$export$93a804c703d50d67 = ()=>{
    const intl = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($71aa4bb0727e6d14$var$CustomGlyph, {
        "aria-label": intl.formatMessage((0, $eKkkY.messages).wrapIcon)
    });
};








const $112d13ab730976d5$var$getAutoDetectPickerValue = ({ autoDetectEntry: autoDetectEntry, formatMessage: formatMessage, language: language, languagePickerOptions: languagePickerOptions })=>{
    const defaultPickerValue = language ? languagePickerOptions.find((option)=>language === (0, $3e48f5ff7e79aab7$export$1ce1cbcc4f60583f) ? option.value === (0, $3e48f5ff7e79aab7$export$5ebaabde4fc8cb67) : option.value === language || option.alias.includes(language)) : undefined;
    // A weak re-detection records noneDetected but can leave a previously auto-detected
    // language on the node. Keep showing "(detected)" only while that preserved language
    // still matches the node language, so manual language changes do not inherit the label.
    if (defaultPickerValue && (autoDetectEntry?.detectionResult === 'detected' || autoDetectEntry?.detectionResult === 'noneDetected' && autoDetectEntry.autoDetectedLanguage === language)) return {
        ...defaultPickerValue,
        label: formatMessage((0, $f8J4a.codeBlockButtonMessages).detectedLanguage, {
            language: defaultPickerValue.label
        })
    };
    if (autoDetectEntry?.detectionResult === 'noneDetected' && !language) return {
        alias: [],
        label: formatMessage((0, $f8J4a.codeBlockButtonMessages).noneDetected),
        value: (0, $3e48f5ff7e79aab7$export$1ce1cbcc4f60583f)
    };
    return defaultPickerValue;
};
const $112d13ab730976d5$export$86ce8f8241c20a3 = (allowCopyToClipboard = false, api, overrideLanguageName)=>{
    const languageList = (0, $00229b4e8191af1d$export$e2dc9c8f242e4ee2)(overrideLanguageName ? (0, $00229b4e8191af1d$export$5a175c817b3d7154).map((languageOption)=>({
            ...languageOption,
            name: overrideLanguageName(languageOption.name)
        })) : (0, $00229b4e8191af1d$export$5a175c817b3d7154));
    const languagePickerOptions = languageList.map((lang)=>({
            label: lang.name,
            value: (0, $00229b4e8191af1d$export$8ef04e71795bc8a6)(lang),
            alias: lang.alias
        }));
    return (state, { formatMessage: formatMessage })=>{
        const isViewMode = api?.editorViewMode?.sharedState.currentState()?.mode === 'view';
        const { hoverDecoration: hoverDecoration } = api?.decorations?.actions ?? {};
        const editorAnalyticsAPI = api?.analytics?.actions;
        const codeBlockState = (0, $3848854553e34219$export$18d4026d1ea86bb1).getState(state);
        const pos = codeBlockState?.pos ?? null;
        if (!codeBlockState || pos === null) return;
        const node = state.doc.nodeAt(pos);
        const nodeType = state.schema.nodes.codeBlock;
        if (node?.type !== nodeType) return;
        const isWrapped = (0, $dNXVc.isCodeBlockWordWrapEnabled)(node);
        const areLineNumbersVisible = (0, $dNXVc.areCodeBlockLineNumbersVisible)(node);
        const language = node?.attrs?.language;
        const localId = node?.attrs?.localId;
        const autoDetectState = (0, $0f30d43ffc94b135$export$264979d19e499e37).getState(state);
        const isFormatCodePending = typeof localId === 'string' && Boolean(codeBlockState.pendingFormats[localId]);
        // Keep fresh option objects for the legacy toolbar select so reopening it
        // continues to start from the top rather than preserving the previously
        // focused option by reference.
        const languageSelectOptions = languagePickerOptions.map((option)=>({
                ...option
            }));
        const defaultValue = language ? languageSelectOptions.find((option)=>option.value === language) || languageSelectOptions.find((option)=>option.alias.includes(language)) : null;
        const languageSelect = {
            id: 'editor.codeBlock.languageOptions',
            type: 'select',
            selectType: 'list',
            onChange: (option)=>(0, $842bd612836073a1$export$61465194746e7fd2)(editorAnalyticsAPI)(option.value),
            defaultValue: defaultValue,
            placeholder: formatMessage((0, $f8J4a.codeBlockButtonMessages).selectLanguage),
            options: languageSelectOptions,
            filterOption: $112d13ab730976d5$export$fffed505cd33273c
        };
        let languagePicker;
        if ((0, $1oCLl.expValEquals)('platform_editor_code_block_q4_lovability', 'isEnabled', true) && (0, $dh538.fg)('platform_editor_code_block_add_line_number_button')) {
            const autoDetectEntry = typeof localId === 'string' && (0, $dh538.fg)('platform_editor_code_block_language_detection_flow') ? autoDetectState?.languageDetectionMap[localId] : undefined;
            const autoDetectPickerValue = $112d13ab730976d5$var$getAutoDetectPickerValue({
                autoDetectEntry: autoDetectEntry,
                formatMessage: formatMessage,
                language: language,
                languagePickerOptions: languagePickerOptions
            });
            languagePicker = {
                type: 'custom',
                fallback: [],
                render: (view)=>{
                    if (!view) return null;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52d7b957a6e9470f$export$5393582178e4c2a), {
                        api: api,
                        defaultValue: autoDetectPickerValue,
                        editorView: view,
                        filterOption: $112d13ab730976d5$export$fffed505cd33273c,
                        formatMessage: formatMessage,
                        languagePickerOptions: languagePickerOptions
                    });
                }
            };
        }
        const separator = {
            type: 'separator'
        };
        const areAnyNewToolbarFlagsEnabled = (0, $iHzeA.areToolbarFlagsEnabled)(Boolean(api?.toolbar));
        const copyToClipboardItems = !allowCopyToClipboard ? [] : [
            {
                id: 'editor.codeBlock.copy',
                type: 'button',
                supportsViewMode: true,
                appearance: 'subtle',
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($2MuFw))),
                // note: copyContentToClipboardWithAnalytics contains logic that also removes the
                // visual feedback for the copy button
                onClick: (0, $842bd612836073a1$export$50ffc017f5e54c0)(editorAnalyticsAPI),
                title: formatMessage(codeBlockState.contentCopied ? (0, $f8J4a.codeBlockButtonMessages).copiedCodeToClipboard : (0, $f8J4a.codeBlockButtonMessages).copyCodeToClipboard),
                onMouseEnter: (0, $81cbafd47e9e3d55$export$73dae478fefb96e),
                // note: resetCopiedState contains logic that also removes the
                // visual feedback for the copy button
                onMouseLeave: (0, $842bd612836073a1$export$3e0b07341e7576a),
                onFocus: (0, $81cbafd47e9e3d55$export$73dae478fefb96e),
                onBlur: (0, $81cbafd47e9e3d55$export$1ec425a919cc0ea),
                hideTooltipOnClick: false,
                disabled: codeBlockState.isNodeSelected,
                tabIndex: null
            },
            separator
        ];
        let copyAndDeleteButtonMenuItems = [];
        if (areAnyNewToolbarFlagsEnabled) {
            const overflowMenuOptions = [
                {
                    title: formatMessage((0, $61p3e.default).delete),
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($gKvd9)))({
                        label: ''
                    }),
                    onMouseEnter: hoverDecoration?.(nodeType, true),
                    onMouseLeave: hoverDecoration?.(nodeType, false),
                    onFocus: hoverDecoration?.(nodeType, true),
                    onBlur: hoverDecoration?.(nodeType, false),
                    onClick: (0, $842bd612836073a1$export$44b4779780b25933)(editorAnalyticsAPI)
                }
            ];
            if (allowCopyToClipboard) overflowMenuOptions.unshift({
                title: formatMessage((0, $61p3e.default).copyToClipboard),
                onClick: (0, $842bd612836073a1$export$50ffc017f5e54c0)(editorAnalyticsAPI),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($2MuFw)))({
                    label: ''
                }),
                onMouseEnter: (0, $81cbafd47e9e3d55$export$73dae478fefb96e),
                onMouseLeave: (0, $842bd612836073a1$export$3e0b07341e7576a),
                onFocus: (0, $81cbafd47e9e3d55$export$73dae478fefb96e),
                onBlur: (0, $81cbafd47e9e3d55$export$1ec425a919cc0ea),
                disabled: codeBlockState.isNodeSelected
            });
            copyAndDeleteButtonMenuItems = isViewMode ? [
                ...copyToClipboardItems
            ] : [
                {
                    type: 'separator',
                    fullHeight: true
                },
                {
                    type: 'overflow-dropdown',
                    testId: 'code-block-overflow-dropdown-trigger',
                    options: overflowMenuOptions
                }
            ];
        } else {
            const deleteButton = {
                id: 'editor.codeBlock.delete',
                type: 'button',
                appearance: 'danger',
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))),
                iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))),
                onMouseEnter: hoverDecoration?.(nodeType, true),
                onMouseLeave: hoverDecoration?.(nodeType, false),
                onFocus: hoverDecoration?.(nodeType, true),
                onBlur: hoverDecoration?.(nodeType, false),
                onClick: (0, $842bd612836073a1$export$44b4779780b25933)(editorAnalyticsAPI),
                title: formatMessage((0, $61p3e.default).remove),
                tabIndex: null
            };
            copyAndDeleteButtonMenuItems = [
                separator,
                ...copyToClipboardItems,
                deleteButton
            ];
        }
        const codeBlockWrapButtonTitle = (0, $1oCLl.expValEquals)('platform_editor_code_block_q4_lovability', 'isEnabled', true) ? formatMessage(isWrapped ? (0, $f8J4a.codeBlockButtonMessages).unwrapCodeLabel : (0, $f8J4a.codeBlockButtonMessages).wrapCodeLabel) : formatMessage((0, $f8J4a.codeBlockButtonMessages).wrapCode);
        const codeBlockWrapButton = {
            id: 'editor.codeBlock.wrap',
            type: 'button',
            // Toggling button now writes to ADF, hence it should be available in view mode
            supportsViewMode: !(0, $1oCLl.expValEquals)('platform_editor_code_block_q4_lovability', 'isEnabled', true),
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($aK2ZC))),
            iconFallback: (0, $71aa4bb0727e6d14$export$93a804c703d50d67),
            onClick: (0, $842bd612836073a1$export$160d674382436f98)(editorAnalyticsAPI),
            title: codeBlockWrapButtonTitle,
            tabIndex: null,
            selected: isWrapped
        };
        const codeBlockLineNumbersButton = {
            id: 'editor.codeBlock.lineNumbers',
            type: 'button',
            supportsViewMode: false,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($2y4tz))),
            onClick: (0, $842bd612836073a1$export$5d4256781e1f4071)(editorAnalyticsAPI),
            title: formatMessage(areLineNumbersVisible ? (0, $f8J4a.codeBlockButtonMessages).hideLineNumbersLabel : (0, $f8J4a.codeBlockButtonMessages).showLineNumbersLabel),
            tabIndex: null,
            selected: areLineNumbersVisible
        };
        const canFormatCode = node.textContent.length > 0 && (0, $ad155092bbb7cd73$export$e8fc22189a2297aa)(language);
        const formatCodeButton = {
            id: 'editor.codeBlock.formatCode',
            type: 'button',
            supportsViewMode: false,
            disabled: !canFormatCode || isFormatCodePending,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($eIlE7))),
            onClick: (0, $842bd612836073a1$export$7f5d8563b7e51b88)({
                api: api,
                editorAnalyticsAPI: editorAnalyticsAPI
            }),
            onFocus: (0, $ad155092bbb7cd73$export$bbd1d07b83fc9327)(),
            onMouseEnter: (0, $ad155092bbb7cd73$export$bbd1d07b83fc9327)(),
            title: formatMessage(canFormatCode ? (0, $f8J4a.codeBlockButtonMessages).formatCode : (0, $f8J4a.codeBlockButtonMessages).formatCodeUnavailable)
        };
        return {
            title: 'CodeBlock floating controls',
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            getDomRef: (view)=>(0, $8m4tT.findDomRefAtPos)(pos, view.domAtPos.bind(view)),
            nodeType: nodeType,
            items: [
                languagePicker ?? languageSelect,
                ...areAnyNewToolbarFlagsEnabled ? [] : [
                    separator
                ],
                codeBlockWrapButton,
                ...(0, $1oCLl.expValEquals)('platform_editor_code_block_q4_lovability', 'isEnabled', true) && (0, $dh538.fg)('platform_editor_code_block_add_line_number_button') ? [
                    codeBlockLineNumbersButton
                ] : [],
                // eslint-disable-next-line @atlaskit/platform/no-preconditioning
                ...(0, $1oCLl.expValEquals)('platform_editor_code_block_q4_lovability', 'isEnabled', true) && (0, $dh538.fg)('platform_editor_code_block_add_line_number_button') && (0, $dh538.fg)('platform_editor_code_block_formatting') ? [
                    formatCodeButton
                ] : [],
                ...copyAndDeleteButtonMenuItems
            ],
            scrollable: true
        };
    };
};
const $112d13ab730976d5$export$fffed505cd33273c = (option, rawInput)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const { data: data } = option;
    const searchString = rawInput.toLowerCase();
    return data.label.toLowerCase().includes(searchString) || data.alias.some((alias)=>alias.toLowerCase() === searchString);
};















var $2GVu1 = parcelRequire("2GVu1");




const $736d48fafc03a0b8$var$NODE_NAME = 'codeBlock';
const $736d48fafc03a0b8$var$CodeBlockMenuItem = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const handleClick = (event)=>{
        const triggeredFrom = event.nativeEvent instanceof KeyboardEvent || event.nativeEvent.detail === 0 ? (0, $d925B.INPUT_METHOD).KEYBOARD : (0, $d925B.INPUT_METHOD).MOUSE;
        const inputMethod = (0, $d925B.INPUT_METHOD).BLOCK_MENU;
        api?.core.actions.execute(({ tr: tr })=>{
            const command = api?.blockMenu?.commands.transformNode(tr.doc.type.schema.nodes.codeBlock, {
                inputMethod: inputMethod,
                triggeredFrom: triggeredFrom,
                targetTypeName: $736d48fafc03a0b8$var$NODE_NAME
            });
            return command ? command({
                tr: tr
            }) : null;
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2GVu1.ToolbarDropdownItem), {
        onClick: handleClick,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eIlE7))), {
            label: "",
            size: "small"
        })
    }, formatMessage((0, $eKkkY.messages).codeBlock));
};
const $736d48fafc03a0b8$export$76cec325b897d60 = (api)=>{
    return ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($736d48fafc03a0b8$var$CodeBlockMenuItem, {
            api: api
        });
};









var $eiA8Z = parcelRequire("eiA8Z");





var $eCEXz = parcelRequire("eCEXz");

var $6uGcC = parcelRequire("6uGcC");


var $a3fRD = parcelRequire("a3fRD");



const $4db72052410599a0$var$FormatCodeErrorFlagItem = ({ formatCodeError: formatCodeError })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eCEXz.default), {
        description: formatMessage(formatCodeError.languageSource === 'auto-detected' ? (0, $f8J4a.codeBlockButtonMessages).formatCodeFailedAutoDetectedDescription : (0, $f8J4a.codeBlockButtonMessages).formatCodeFailedDescription),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
            color: "var(--ds-icon-danger, #C9372C)",
            label: ""
        }),
        id: formatCodeError.localId,
        title: formatMessage((0, $f8J4a.codeBlockButtonMessages).formatCodeFailed)
    });
};
const $4db72052410599a0$export$4481d6fe3f264c4b = ({ api: api })=>{
    const { formatCodeErrors: formatCodeErrors } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'codeBlock'
    ], (states)=>({
            formatCodeErrors: states.codeBlockState?.formatCodeErrors ?? {}
        }));
    const onDismissed = (0, $42omo.useCallback)((localId)=>{
        api?.core?.actions.execute(({ tr: tr })=>{
            tr.setMeta((0, $3848854553e34219$export$18d4026d1ea86bb1), {
                type: (0, $88b7294e6fc1bbcd$export$92a1a3b7554e9387).CLEAR_FORMAT_CODE_ERROR,
                data: {
                    localId: localId
                }
            });
            return tr;
        });
        api?.core?.actions.focus();
    }, [
        api
    ]);
    const onFlagGroupDismissed = (0, $42omo.useCallback)((localId)=>onDismissed(String(localId)), [
        onDismissed
    ]);
    const activeFormatCodeErrors = Object.values(formatCodeErrors);
    if (activeFormatCodeErrors.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6uGcC.default), {
        onDismissed: onFlagGroupDismissed
    }, activeFormatCodeErrors.map((formatCodeError)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4db72052410599a0$var$FormatCodeErrorFlagItem, {
            formatCodeError: formatCodeError,
            key: formatCodeError.localId
        })));
};


const $5f6806eaea85daa8$var$CODE_BLOCK_NODE_NAME = 'codeBlock';
const $5f6806eaea85daa8$var$codeBlockPlugin = ({ config: options, api: api })=>{
    if ((0, $iu6m9.editorExperiment)('platform_editor_block_menu', true)) api?.blockMenu?.actions.registerBlockMenuComponents([
        {
            type: 'block-menu-item',
            key: (0, $btNLq.TRANSFORM_STRUCTURE_CODE_BLOCK_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $btNLq.TRANSFORM_STRUCTURE_MENU_SECTION).key,
                rank: (0, $gEb6G.TRANSFORM_STRUCTURE_MENU_SECTION_RANK)[(0, $btNLq.TRANSFORM_STRUCTURE_CODE_BLOCK_MENU_ITEM).key]
            },
            component: (0, $736d48fafc03a0b8$export$76cec325b897d60)(api),
            isHidden: ()=>Boolean(api?.blockMenu?.actions.isTransformOptionDisabled($5f6806eaea85daa8$var$CODE_BLOCK_NODE_NAME))
        }
    ]);
    return {
        name: 'codeBlock',
        nodes () {
            return [
                {
                    name: 'codeBlock',
                    node: (0, $1oCLl.expValEquals)('platform_editor_code_block_q4_lovability', 'isEnabled', true) ? (0, $4HD7y.codeBlockWithExtendedAttributes) : (0, $dh538.fg)('platform_editor_adf_with_localid') ? (0, $4HD7y.codeBlockWithLocalId) : (0, $4HD7y.codeBlock)
                }
            ];
        },
        getSharedState (state) {
            if (!state) return undefined;
            const codeBlockState = (0, $3848854553e34219$export$18d4026d1ea86bb1).getState(state);
            return {
                copyButtonHoverNode: (0, $81cbafd47e9e3d55$export$97324d26e7dfa2c5).getState(state).codeBlockNode,
                formatCodeErrors: codeBlockState?.formatCodeErrors ?? {},
                pendingFormats: codeBlockState?.pendingFormats ?? {}
            };
        },
        pmPlugins () {
            return [
                {
                    name: 'codeBlock',
                    plugin: ({ getIntl: getIntl })=>(0, $4f7d056bbf670d70$export$ae829ec7b2625219)({
                            ...options,
                            getIntl: getIntl,
                            api: api
                        })
                },
                {
                    name: 'codeBlockInputRule',
                    plugin: ({ schema: schema })=>{
                        return (0, $afbf4a74e817e11e$export$bdcd7d8080bcac7f)(schema, api?.analytics?.actions);
                    }
                },
                ...(0, $1oCLl.expValEquals)('platform_editor_code_block_q4_lovability', 'isEnabled', true) && (0, $dh538.fg)('platform_editor_code_block_language_detection_flow') ? [
                    {
                        name: 'codeBlockAutoDetect',
                        plugin: ()=>(0, $1ba006743c4cb8b1$export$d5142f5b34a5c85b)(api)
                    }
                ] : [],
                {
                    name: 'codeBlockIDEKeyBindings',
                    plugin: ()=>(0, $043a9bf6cfe9cc6a$export$2e2bcd8739ae039)(api)
                },
                {
                    name: 'codeBlockKeyMap',
                    plugin: ({ schema: schema })=>(0, $376c98df80c817ca$export$2e2bcd8739ae039)(schema)
                },
                {
                    name: 'codeBlockCopySelection',
                    plugin: ()=>(0, $81cbafd47e9e3d55$export$bf11b3ffc9027f6b)()
                },
                {
                    name: 'codeBlockAutoFullStopTransform',
                    plugin: ()=>(0, $4d9c5a8d8eb96c97$export$67e82b3aa944d041)()
                }
            ];
        },
        // Workaround for a firefox issue where dom selection is off sync
        // https://product-fabric.atlassian.net/browse/ED-12442
        onEditorViewStateUpdated (props) {
            (0, $ab31c96704dede3d$export$2e2bcd8739ae039)(props.originalTransaction, props.newEditorState);
        },
        actions: {
            /*
       * Function will insert code block at current selection if block is empty or below current selection and set focus on it.
       */ insertCodeBlock: (inputMethod)=>(0, $842bd612836073a1$export$a8d9c0f039b6fb43)(inputMethod, api?.analytics?.actions)
        },
        pluginsOptions: {
            quickInsert: ({ formatMessage: formatMessage })=>[
                    {
                        id: 'codeblock',
                        title: formatMessage((0, $2UWDO.messages).codeblock),
                        description: formatMessage((0, $2UWDO.messages).codeblockDescription),
                        keywords: [
                            'code block'
                        ],
                        priority: 700,
                        keyshortcut: '```',
                        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3pLGZ.IconCode), null),
                        action (_insert, state, source) {
                            const tr = (0, $842bd612836073a1$export$c875ffe428b4a5f)({
                                state: state
                            });
                            api?.analytics?.actions.attachAnalyticsEvent({
                                action: (0, $d925B.ACTION).INSERTED,
                                actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
                                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).CODE_BLOCK,
                                attributes: {
                                    inputMethod: source || (0, $d925B.INPUT_METHOD).QUICK_INSERT
                                },
                                eventType: (0, $d925B.EVENT_TYPE).TRACK
                            })(tr);
                            return tr;
                        }
                    }
                ],
            floatingToolbar: (0, $112d13ab730976d5$export$86ce8f8241c20a3)(options?.allowCopyToClipboard, api, options?.overrideLanguageName)
        },
        contentComponent: ()=>(0, $dZ8uq.expValEqualsNoExposure)('platform_editor_code_block_q4_lovability', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4db72052410599a0$export$4481d6fe3f264c4b), {
                api: api
            }) : null
    };
};
var $5f6806eaea85daa8$export$2e2bcd8739ae039 = $5f6806eaea85daa8$var$codeBlockPlugin;
module.exports["default"] = $5f6806eaea85daa8$export$2e2bcd8739ae039;

});

parcelRegister("kgnzE", function(module, exports) {

var $5SAOw = parcelRequire("5SAOw");


var $ks2lK = parcelRequire("ks2lK");


var $8m4tT = parcelRequire("8m4tT");


var $cMZNY = parcelRequire("cMZNY");


var $d7ZU3 = parcelRequire("d7ZU3");

function $913317dd85d1f25a$export$64477bc469482fd0({ nodeType: nodeType, selection: selection }) {
    let node = (0, $8m4tT.findSelectedNodeOfType)(nodeType)(selection);
    if (!node) node = (0, $8m4tT.findParentNodeOfType)(nodeType)(selection);
    return node;
}
const $913317dd85d1f25a$export$289411c5a7970646 = (node, schema)=>{
    return (0, $5SAOw.DOMSerializer).fromSchema(schema).serializeNode(node);
};
const $913317dd85d1f25a$export$ccb445b3e5426309 = (domNode, nodeType, selection)=>{
    if (domNode) {
        const div = document.createElement('div');
        div.appendChild(domNode);
        const schema = selection.$from.doc.type.schema;
        const browser = (0, $d7ZU3.getBrowserInfo)();
        // if copying inline content
        if (nodeType.inlineContent) // The "1 1" refers to the start and end depth of the slice
        // since we're copying the text inside a paragraph, it will always be 1 1
        // https://github.com/ProseMirror/prosemirror-view/blob/master/src/clipboard.ts#L32
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        div.firstChild.setAttribute('data-pm-slice', '1 1 []');
        else // The "0 0" refers to the start and end depth of the slice
        // since we're copying the block node only, it will always be 0 0
        // https://github.com/ProseMirror/prosemirror-view/blob/master/src/clipboard.ts#L32
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        div.firstChild.setAttribute('data-pm-slice', '0 0 []');
        // ED-17083 safari seems have bugs for extension copy because exntension do not have a child text(innerText) and it will not recognized as html in clipboard, this could be merge into one if this extension fixed children issue or safari fix the copy bug
        // MEX-2528 safari has a bug related to the mediaSingle node with border or link. The image tag within the clipboard is not recognized as HTML when using the ClipboardItem API. To address this, we have to switch to ClipboardPolyfill
        if (browser.safari && selection instanceof (0, $ks2lK.NodeSelection) && (selection.node.type === schema.nodes.extension || selection.node.type === schema.nodes.mediaSingle)) (0, $cMZNY.copyHTMLToClipboardPolyfill)(div);
        else (0, $cMZNY.copyHTMLToClipboard)(div);
    }
};
module.exports["getSelectedNodeOrNodeParentByNodeType"] = $913317dd85d1f25a$export$64477bc469482fd0;
module.exports["toDOM"] = $913317dd85d1f25a$export$289411c5a7970646;
module.exports["copyDomNode"] = $913317dd85d1f25a$export$ccb445b3e5426309;

});

parcelRegister("7YsdE", function(module, exports) {

let $5ce406bdea3ea5db$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5ce406bdea3ea5db$var$load("iWTur").then(()=>parcelRequire('dCSrF'));

});

parcelRegister("aU3dp", function(module, exports) {
var $2a5fc71cca41ec20$export$c8090e81b8640d69 = /*#__PURE__*/ function(INDENT_DIRECTION) {
    INDENT_DIRECTION["INDENT"] = "indent";
    INDENT_DIRECTION["OUTDENT"] = "outdent";
    return INDENT_DIRECTION;
}({});
var $2a5fc71cca41ec20$export$303836d45647271d = /*#__PURE__*/ function(INDENT_TYPE) {
    INDENT_TYPE["PARAGRAPH"] = "paragraph";
    INDENT_TYPE["LIST"] = "list";
    INDENT_TYPE["HEADING"] = "heading";
    INDENT_TYPE["CODE_BLOCK"] = "codeBlock";
    INDENT_TYPE["TASK_LIST"] = "taskList";
    return INDENT_TYPE;
}({});
module.exports["INDENT_DIRECTION"] = $2a5fc71cca41ec20$export$c8090e81b8640d69;
module.exports["INDENT_TYPE"] = $2a5fc71cca41ec20$export$303836d45647271d;

});

parcelRegister("iHzeA", function(module, exports) {

var $dZ8uq = parcelRequire("dZ8uq");

const $a968435ac8f8a68a$export$c6d9af905adcabd8 = (isNewToolbarEnabled)=>Boolean((0, $dZ8uq.expValEqualsNoExposure)('platform_editor_controls', 'cohort', 'variant1') || isNewToolbarEnabled);
module.exports["areToolbarFlagsEnabled"] = $a968435ac8f8a68a$export$c6d9af905adcabd8;

});

parcelRegister("gyXPd", function(module, exports) {

var $1S4f7 = parcelRequire("1S4f7");


var $TfRUG = parcelRequire("TfRUG");


var $ks2lK = parcelRequire("ks2lK");

const $ddda974bd0c22043$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('compositionPlugin');


const $69206131402df254$var$isLinux = ()=>navigator.userAgent.indexOf('Linux') >= 0;
var $69206131402df254$export$2e2bcd8739ae039 = ()=>new (0, $1S4f7.SafePlugin)({
        key: (0, $ddda974bd0c22043$export$18d4026d1ea86bb1),
        state: {
            init: ()=>({
                    isComposing: false,
                    zeroWidthSpacePos: undefined
                }),
            apply: (tr, value)=>{
                const isComposing = tr.getMeta((0, $ddda974bd0c22043$export$18d4026d1ea86bb1));
                const zeroWidthSpacePos = tr.getMeta('zeroWidthSpacePos');
                if (typeof isComposing === 'undefined') return value;
                return {
                    isComposing: isComposing,
                    zeroWidthSpacePos: zeroWidthSpacePos
                };
            }
        },
        props: {
            handleDOMEvents: {
                compositionstart: (view, event)=>{
                    const { tr: tr } = view.state;
                    tr.setMeta((0, $ddda974bd0c22043$export$18d4026d1ea86bb1), true);
                    // only apply for linux and cursor is at start of line
                    if ($69206131402df254$var$isLinux() && view.state.selection.$from.parentOffset === 0) {
                        tr.insertText((0, $TfRUG.ZERO_WIDTH_SPACE));
                        // remember the position of inserted zero width space
                        tr.setMeta('zeroWidthSpacePos', view.state.selection.$from.pos);
                    }
                    view.dispatch(tr);
                    return false;
                },
                compositionend: (view, event)=>{
                    const { tr: tr } = view.state;
                    tr.setMeta((0, $ddda974bd0c22043$export$18d4026d1ea86bb1), false);
                    if ($69206131402df254$var$isLinux()) {
                        const zeroWidthSpacePos = (0, $ddda974bd0c22043$export$18d4026d1ea86bb1).getState(view.state)?.zeroWidthSpacePos;
                        if (typeof zeroWidthSpacePos !== 'undefined') tr.deleteRange(zeroWidthSpacePos, zeroWidthSpacePos + 1);
                        tr.setMeta('zeroWidthSpacePos', undefined);
                    }
                    view.dispatch(tr);
                    return false;
                }
            }
        }
    });



const $f7871b6fa4413f27$export$afd1652ef5208b = ()=>{
    return {
        name: 'composition',
        getSharedState (editorState) {
            if (!editorState) return {
                isComposing: false
            };
            return {
                isComposing: !!(0, $ddda974bd0c22043$export$18d4026d1ea86bb1).getState(editorState)?.isComposing
            };
        },
        pmPlugins () {
            return [
                {
                    name: 'composition',
                    plugin: ()=>(0, $69206131402df254$export$2e2bcd8739ae039)()
                }
            ];
        }
    };
};
module.exports["compositionPlugin"] = $f7871b6fa4413f27$export$afd1652ef5208b;

});

parcelRegister("kIhx9", function(module, exports) {

var $1S4f7 = parcelRequire("1S4f7");


var $ftzrq = parcelRequire("ftzrq");


var $ks2lK = parcelRequire("ks2lK");

const $2ea8e661d7a4fd20$export$e41a18c2cdafffa9 = new (0, $ks2lK.PluginKey)('copyButtonPlugin');


function $3b196656753db3e1$export$6867b9cd7a8c8a75({ $pos: $pos, markType: markType }) {
    const hasMark = $pos.doc.rangeHasMark($pos.pos, Math.min($pos.pos + 1, $pos.doc.nodeSize), markType);
    if (!hasMark) return false;
    if ($pos.parent.childCount === 1) {
        const nodePosition = $pos.pos;
        const maybeNode = $pos.doc.nodeAt(nodePosition);
        if (!maybeNode || !maybeNode.isText) return false;
        const start = $pos.pos - $pos.parentOffset;
        const end = start + maybeNode.nodeSize;
        return {
            start: start,
            end: end
        };
    }
    if ($pos.parent.childCount > 1) {
        const start = $pos.pos - $pos.textOffset;
        const maybeTextNode = $pos.doc.nodeAt(start);
        if (!maybeTextNode || !maybeTextNode.isText) return false;
        const end = start + maybeTextNode.nodeSize;
        return {
            start: start,
            end: end
        };
    }
    return false;
}
function $3b196656753db3e1$var$getMarkSelectionDecorationStartAndEnd({ markType: markType, transaction: transaction }) {
    const anchorPositions = $3b196656753db3e1$export$6867b9cd7a8c8a75({
        $pos: transaction.selection.$anchor,
        markType: markType
    });
    if (anchorPositions) return {
        ...anchorPositions,
        markType: markType
    };
    const headPositions = $3b196656753db3e1$export$6867b9cd7a8c8a75({
        $pos: transaction.selection.$head,
        markType: markType
    });
    if (headPositions) return {
        ...headPositions,
        markType: markType
    };
    return undefined;
}
function $3b196656753db3e1$export$ea22bdb37423f02c() {
    return new (0, $1S4f7.SafePlugin)({
        key: (0, $2ea8e661d7a4fd20$export$e41a18c2cdafffa9),
        state: {
            init () {
                return {
                    copied: false,
                    markSelection: undefined
                };
            },
            apply (tr, currentPluginState) {
                const meta = tr.getMeta((0, $2ea8e661d7a4fd20$export$e41a18c2cdafffa9));
                if (meta?.copied !== undefined) return {
                    copied: meta.copied,
                    markSelection: undefined
                };
                if (meta?.showSelection) return {
                    copied: currentPluginState.copied,
                    markSelection: $3b196656753db3e1$var$getMarkSelectionDecorationStartAndEnd({
                        markType: meta.markType,
                        transaction: tr
                    })
                };
                if (meta?.removeSelection) return {
                    copied: currentPluginState.copied,
                    markSelection: undefined
                };
                if (currentPluginState.markSelection) return {
                    copied: currentPluginState.copied,
                    markSelection: $3b196656753db3e1$var$getMarkSelectionDecorationStartAndEnd({
                        markType: currentPluginState.markSelection.markType,
                        transaction: tr
                    })
                };
                return currentPluginState;
            }
        },
        props: {
            decorations (_state) {
                // Showing visual hints for the hyperlink copy button has been disabled
                // due to an issue where invalid hyperlink marks cause the floating toolbar
                // to jump around when the copy button is hovered.
                // See the following bug for details -- once that is resolved -- the visual
                // hints can be re enabled.
                // https://product-fabric.atlassian.net/browse/DTR-722
                // const copyButtonPluginState = copyButtonPluginKey.getState(
                //   state,
                // ) as CopyButtonPluginState;
                // if (copyButtonPluginState.markSelection) {
                //   const { start, end } = copyButtonPluginState.markSelection;
                //   return DecorationSet.create(state.doc, [
                //     Decoration.inline(start, end, {
                //       class: 'ProseMirror-fake-text-selection',
                //     }),
                //   ]);
                // }
                return (0, $ftzrq.DecorationSet).empty;
            }
        }
    });
}
var $3b196656753db3e1$export$2e2bcd8739ae039 = $3b196656753db3e1$export$ea22bdb37423f02c;



var $61p3e = parcelRequire("61p3e");


var $2MuFw = parcelRequire("2MuFw");


var $d925B = parcelRequire("d925B");


var $d7ZU3 = parcelRequire("d7ZU3");


var $cMZNY = parcelRequire("cMZNY");


var $kgnzE = parcelRequire("kgnzE");





var $iu6m9 = parcelRequire("iu6m9");


function $3c1f734c059ab471$export$61f33363e77ed28(markType, editorAnalyticsApi) {
    function command(state, dispatch) {
        const textNode = state.tr.selection.$head.parent.maybeChild(state.tr.selection.$head.index());
        if (!textNode) return false;
        if (dispatch) {
            // As calling copyHTMLToClipboard causes side effects -- we only run this when
            // dispatch is provided -- as otherwise the consumer is only testing to see if
            // the action is availble.
            const domNode = (0, $kgnzE.toDOM)(textNode, state.schema);
            if (domNode) {
                const div = document.createElement('div');
                const p = document.createElement('p');
                div.appendChild(p);
                p.appendChild(domNode);
                // The "1 1" refers to the start and end depth of the slice
                // since we're copying the text inside a paragraph, it will always be 1 1
                // https://github.com/ProseMirror/prosemirror-view/blob/master/src/clipboard.ts#L32
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                div.firstChild.setAttribute('data-pm-slice', '1 1 []');
                // If we're copying a hyperlink, we'd copy the url as the fallback plain text
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const linkUrl = domNode.getAttribute('href');
                (0, $cMZNY.copyHTMLToClipboard)(div, markType.name === 'link' && linkUrl ? linkUrl : undefined);
            }
            const copyToClipboardTr = state.tr;
            copyToClipboardTr.setMeta((0, $2ea8e661d7a4fd20$export$e41a18c2cdafffa9), {
                copied: true
            });
            const analyticsPayload = (0, $cMZNY.getAnalyticsPayload)(state, (0, $d925B.ACTION).COPIED);
            if (analyticsPayload && editorAnalyticsApi) {
                analyticsPayload.attributes.inputMethod = (0, $d925B.INPUT_METHOD).FLOATING_TB;
                analyticsPayload.attributes.markType = markType.name;
                editorAnalyticsApi?.attachAnalyticsEvent?.(analyticsPayload)(copyToClipboardTr);
            }
            dispatch(copyToClipboardTr);
        }
        return true;
    }
    return command;
}
function $3c1f734c059ab471$export$5887c7b152626490(markType) {
    function provideMarkVisualFeedbackForCopyButtonCommand(state, dispatch) {
        const tr = state.tr;
        tr.setMeta((0, $2ea8e661d7a4fd20$export$e41a18c2cdafffa9), {
            showSelection: true,
            markType: markType
        });
        if (dispatch) dispatch(tr);
        return true;
    }
    return provideMarkVisualFeedbackForCopyButtonCommand;
}
function $3c1f734c059ab471$export$e52b1d5c60d367b8(state, dispatch) {
    const tr = state.tr;
    tr.setMeta((0, $2ea8e661d7a4fd20$export$e41a18c2cdafffa9), {
        removeSelection: true
    });
    const copyButtonState = (0, $2ea8e661d7a4fd20$export$e41a18c2cdafffa9).getState(state);
    if (copyButtonState?.copied) tr.setMeta((0, $2ea8e661d7a4fd20$export$e41a18c2cdafffa9), {
        copied: false
    });
    if (dispatch) dispatch(tr);
    return true;
}
const $3c1f734c059ab471$export$be806b3b778a7682 = (nodeType, editorAnalyticsApi, api, onClickMessage)=>(state, dispatch)=>{
        const { tr: tr, schema: schema } = state;
        // This command should only be triggered by the Copy button in the floating toolbar
        // which is only visible when selection is inside the target node
        const contentNodeWithPos = (0, $kgnzE.getSelectedNodeOrNodeParentByNodeType)({
            nodeType: nodeType,
            selection: tr.selection
        });
        if (!contentNodeWithPos) return false;
        const copyToClipboardTr = tr;
        copyToClipboardTr.setMeta((0, $2ea8e661d7a4fd20$export$e41a18c2cdafffa9), {
            copied: true
        });
        const analyticsPayload = (0, $cMZNY.getAnalyticsPayload)(state, (0, $d925B.ACTION).COPIED);
        if (analyticsPayload && editorAnalyticsApi) {
            analyticsPayload.attributes.inputMethod = (0, $d925B.INPUT_METHOD).FLOATING_TB;
            analyticsPayload.attributes.nodeType = contentNodeWithPos.node.type.name;
            editorAnalyticsApi?.attachAnalyticsEvent?.(analyticsPayload)(copyToClipboardTr);
        }
        if (dispatch) {
            // As calling copyHTMLToClipboard causes side effects -- we only run this when
            // dispatch is provided -- as otherwise the consumer is only testing to see if
            // the action is availble.
            const domNode = (0, $kgnzE.toDOM)(contentNodeWithPos.node, schema);
            if ((0, $iu6m9.editorExperiment)('platform_editor_block_menu', true)) (0, $kgnzE.copyDomNode)(domNode, contentNodeWithPos.node.type, tr.selection);
            else if (domNode) {
                const div = document.createElement('div');
                const browser = (0, $d7ZU3.getBrowserInfo)();
                div.appendChild(domNode);
                // if copying inline content
                if (contentNodeWithPos.node.type.inlineContent) // The "1 1" refers to the start and end depth of the slice
                // since we're copying the text inside a paragraph, it will always be 1 1
                // https://github.com/ProseMirror/prosemirror-view/blob/master/src/clipboard.ts#L32
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                div.firstChild.setAttribute('data-pm-slice', '1 1 []');
                else // The "0 0" refers to the start and end depth of the slice
                // since we're copying the block node only, it will always be 0 0
                // https://github.com/ProseMirror/prosemirror-view/blob/master/src/clipboard.ts#L32
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                div.firstChild.setAttribute('data-pm-slice', '0 0 []');
                // ED-17083 safari seems have bugs for extension copy because exntension do not have a child text(innerText) and it will not recognized as html in clipboard, this could be merge into one if this extension fixed children issue or safari fix the copy bug
                // MEX-2528 safari has a bug related to the mediaSingle node with border or link. The image tag within the clipboard is not recognized as HTML when using the ClipboardItem API. To address this, we have to switch to ClipboardPolyfill
                if (browser.safari && state.selection instanceof (0, $ks2lK.NodeSelection) && (state.selection.node.type === state.schema.nodes.extension || state.selection.node.type === state.schema.nodes.mediaSingle)) (0, $cMZNY.copyHTMLToClipboardPolyfill)(div);
                else (0, $cMZNY.copyHTMLToClipboard)(div);
            }
            copyToClipboardTr.setMeta('scrollIntoView', false);
            dispatch(copyToClipboardTr);
        }
        /**
		 * A11y-10275 This prop api drilled from the plugin all the way down to the usage
		 * because it's the safest way to ensure accessibilityUtils is available and not
		 * undefined.
		 *
		 * see thread https://atlassian.slack.com/archives/C02CDUS3SUS/p1744256326459569
		 */ if (onClickMessage) api?.accessibilityUtils?.actions.ariaNotify(onClickMessage, {
            priority: 'important'
        });
        return true;
    };
const $3c1f734c059ab471$export$3e0b07341e7576a = (nodeType, hoverDecoration, onMouseLeave)=>(state, dispatch)=>{
        let customTr = state.tr;
        // Avoid multipe dispatch
        // https://product-fabric.atlassian.net/wiki/spaces/E/pages/2241659456/All+about+dispatch+and+why+there+shouldn+t+be+multiple#How-do-I-avoid-them%3F
        const customDispatch = (tr)=>{
            customTr = tr;
        };
        onMouseLeave ? onMouseLeave(state, customDispatch) : hoverDecoration?.(nodeType, false)(state, customDispatch);
        const copyButtonState = (0, $2ea8e661d7a4fd20$export$e41a18c2cdafffa9).getState(state);
        if (copyButtonState?.copied) customTr.setMeta((0, $2ea8e661d7a4fd20$export$e41a18c2cdafffa9), {
            copied: false
        });
        if (dispatch) dispatch(customTr);
        return true;
    };



// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $af6710bc2de99569$var$isSeparator(item) {
    return item?.type === 'separator';
}
function $af6710bc2de99569$var$isNodeOptions(options) {
    return 'nodeType' in options && options.nodeType !== undefined;
}
const $af6710bc2de99569$export$b372d635c5d31afc = (api)=>(message)=>{
        api?.core.actions.execute(({ tr: tr })=>{
            return tr.setMeta((0, $2ea8e661d7a4fd20$export$e41a18c2cdafffa9), {
                copied: true
            }).setMeta('scrollIntoView', false);
        });
        api?.accessibilityUtils?.actions.ariaNotify(message, {
            priority: 'important'
        });
    };
function $af6710bc2de99569$export$518afae27d2d4b23(options, hoverDecoration, editorAnalyticsApi, api) {
    const { state: state, formatMessage: formatMessage, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onFocus: onFocus, onBlur: onBlur } = options;
    const copyButtonState = (0, $2ea8e661d7a4fd20$export$e41a18c2cdafffa9).getState(state);
    let buttonActionHandlers;
    if ($af6710bc2de99569$var$isNodeOptions(options)) {
        const { onClick: onClick } = options;
        buttonActionHandlers = {
            onClick: (0, $3c1f734c059ab471$export$be806b3b778a7682)(options.nodeType, editorAnalyticsApi, api, formatMessage((0, $61p3e.default).copiedToClipboard)),
            // Note for future changes: these two handlers should perform
            // the same action.
            onMouseEnter: onMouseEnter || hoverDecoration?.(options.nodeType, true, 'ak-editor-selected-node'),
            onFocus: onFocus || hoverDecoration?.(options.nodeType, true, 'ak-editor-selected-node'),
            // Note for future changes: these two handlers should perform
            // the same action.
            onMouseLeave: (0, $3c1f734c059ab471$export$3e0b07341e7576a)(options.nodeType, hoverDecoration, onMouseLeave),
            onBlur: (0, $3c1f734c059ab471$export$3e0b07341e7576a)(options.nodeType, hoverDecoration, onBlur)
        };
        if (onClick) buttonActionHandlers.onClick = (editorState, dispatch, editorView)=>{
            if (onClick(editorState, dispatch, editorView)) {
                $af6710bc2de99569$export$b372d635c5d31afc(api)(formatMessage((0, $61p3e.default).copiedToClipboard));
                return true;
            }
            return false;
        };
    } else buttonActionHandlers = {
        onClick: (0, $3c1f734c059ab471$export$61f33363e77ed28)(options.markType, editorAnalyticsApi),
        onMouseEnter: (0, $3c1f734c059ab471$export$5887c7b152626490)(options.markType),
        onFocus: (0, $3c1f734c059ab471$export$5887c7b152626490)(options.markType),
        onMouseLeave: (0, $3c1f734c059ab471$export$e52b1d5c60d367b8),
        onBlur: (0, $3c1f734c059ab471$export$e52b1d5c60d367b8)
    };
    return {
        id: 'editor.floatingToolbar.copy',
        type: 'button',
        appearance: 'subtle',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2MuFw))),
        title: formatMessage(copyButtonState?.copied ? (0, $61p3e.default).copiedToClipboard : (0, $61p3e.default).copyToClipboard),
        ...buttonActionHandlers,
        hideTooltipOnClick: false,
        tabIndex: null
    };
}
const $af6710bc2de99569$export$f61ed03c42ac876f = (editorAnalyticsApi, api)=>(_state)=>{
        return (items, hoverDecoration)=>items.flatMap((item)=>{
                switch(item.type){
                    case 'copy-button':
                        if (item?.hidden) return [];
                        return item?.items.map((copyButtonItem)=>$af6710bc2de99569$var$isSeparator(copyButtonItem) ? copyButtonItem : $af6710bc2de99569$export$518afae27d2d4b23(copyButtonItem, hoverDecoration, editorAnalyticsApi, api));
                    default:
                        return [
                            item
                        ];
                }
            });
    };


const $e12541e52433e3ab$export$ea22bdb37423f02c = ({ api: api })=>({
        name: 'copyButton',
        pmPlugins () {
            return [
                {
                    name: 'copyButton',
                    plugin: ()=>(0, $3b196656753db3e1$export$2e2bcd8739ae039)()
                }
            ];
        },
        actions: {
            processCopyButtonItems: (0, $af6710bc2de99569$export$f61ed03c42ac876f)(api?.analytics?.actions, api),
            afterCopy: (message)=>(0, $af6710bc2de99569$export$b372d635c5d31afc)(api)(message)
        }
    });
module.exports["copyButtonPlugin"] = $e12541e52433e3ab$export$ea22bdb37423f02c;

});

parcelRegister("4KTOl", function(module, exports) {

var $iu6m9 = parcelRequire("iu6m9");


var $l6okE = parcelRequire("l6okE");


var $ks2lK = parcelRequire("ks2lK");


var $ftzrq = parcelRequire("ftzrq");


var $7XFGZ = parcelRequire("7XFGZ");

var $LmqWp = parcelRequire("LmqWp");


var $id9O1 = parcelRequire("id9O1");


var $dh538 = parcelRequire("dh538");





var $1S4f7 = parcelRequire("1S4f7");





var $8m4tT = parcelRequire("8m4tT");





var $dZ8uq = parcelRequire("dZ8uq");




const $1138185b97e29b7a$export$385f768f10dabdd5 = new (0, $ks2lK.PluginKey)('decorationPlugin');
var $1138185b97e29b7a$export$92a1a3b7554e9387 = /*#__PURE__*/ function(ACTIONS) {
    ACTIONS[ACTIONS["DECORATION_ADD"] = 0] = "DECORATION_ADD";
    ACTIONS[ACTIONS["DECORATION_REMOVE"] = 1] = "DECORATION_REMOVE";
    return ACTIONS;
}({});
const $1138185b97e29b7a$export$ea377ae2b4b58797 = (state, dispatch)=>{
    const { tr: tr } = state;
    const { decoration: decoration } = $1138185b97e29b7a$export$385f768f10dabdd5.getState(state);
    if (decoration && dispatch) {
        dispatch(tr.setMeta($1138185b97e29b7a$export$385f768f10dabdd5, {
            action: 1
        }));
        return true;
    }
    return false;
};
const $1138185b97e29b7a$export$fbf24964a8aac61c = (nodeType, add, className = 'danger')=>(state, dispatch)=>{
        let from;
        let parentNode;
        if (state.selection instanceof (0, $ks2lK.NodeSelection)) {
            const selectedNode = state.selection.node;
            const nodeTypes = Array.isArray(nodeType) ? nodeType : [
                nodeType
            ];
            const isNodeTypeMatching = nodeTypes.indexOf(selectedNode.type) > -1;
            // This adds danger styling if the selected node is the one that requires
            // the decoration to be added, e.g. if a layout is selected and the user
            // hovers over the layout's delete button.
            if (isNodeTypeMatching) {
                from = state.selection.from;
                parentNode = selectedNode;
            }
        }
        // This adds danger styling if the selection is not a node selection, OR if
        // the selected node is a child of the one that requires the decoration to
        // be added, e.g. if a decision item is selected inside a layout and the
        // user hovers over the layout's delete button.
        const foundParentNode = (0, $8m4tT.findParentNodeOfType)(nodeType)(state.selection);
        if (from === undefined && foundParentNode) {
            from = foundParentNode.pos;
            parentNode = foundParentNode.node;
        }
        // Note: can't use !from as from could be 0, which is falsy but valid
        if (from === undefined || parentNode === undefined) return false;
        if (dispatch) dispatch(state.tr.setMeta($1138185b97e29b7a$export$385f768f10dabdd5, {
            action: add ? 0 : 1,
            data: (0, $ftzrq.Decoration).node(from, from + parentNode.nodeSize, {
                class: className
            }, {
                key: 'decorationNode'
            })
        }).setMeta('addToHistory', false));
        return true;
    };
var $1138185b97e29b7a$export$2e2bcd8739ae039 = ()=>{
    return new (0, $1S4f7.SafePlugin)({
        key: $1138185b97e29b7a$export$385f768f10dabdd5,
        state: {
            init: ()=>({
                    decoration: undefined
                }),
            apply (tr, pluginState) {
                if (pluginState.decoration && pluginState.decoration instanceof (0, $ftzrq.Decoration)) {
                    const mapResult = tr.mapping.mapResult(pluginState.decoration.from);
                    if (mapResult.deleted) pluginState = {
                        decoration: undefined
                    };
                }
                if (pluginState.decoration && pluginState.decoration instanceof (0, $ftzrq.DecorationSet) && (0, $iu6m9.editorExperiment)('platform_editor_block_menu', true)) pluginState.decoration = pluginState.decoration.map(tr.mapping, tr.doc);
                const meta = tr.getMeta($1138185b97e29b7a$export$385f768f10dabdd5);
                if (!meta) return pluginState;
                switch(meta.action){
                    case 0:
                        return {
                            decoration: meta.data,
                            hasDangerDecorations: (0, $dZ8uq.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true) ? meta.hasDangerDecorations : undefined
                        };
                    case 1:
                        return {
                            decoration: undefined,
                            hasDangerDecorations: undefined
                        };
                    default:
                        return pluginState;
                }
            }
        },
        props: {
            decorations (state) {
                const { doc: doc } = state;
                const { decoration: decoration } = $1138185b97e29b7a$export$385f768f10dabdd5.getState(state);
                if (decoration instanceof (0, $ftzrq.Decoration)) return (0, $ftzrq.DecorationSet).create(doc, [
                    decoration
                ]);
                if (decoration instanceof (0, $ftzrq.DecorationSet) && (0, $iu6m9.editorExperiment)('platform_editor_block_menu', true)) return decoration;
                return null;
            }
        }
    });
};


const $8a41e4d6add08fa7$export$84d8b6d3cf5f2fb4 = ({ add: add, className: className = 'danger selected', selection: providedSelection })=>({ tr: tr })=>{
        // [FEATURE FLAG: platform_editor_block_menu_jira_patch_1]
        // Use the provided selection (e.g., preservedSelection) or fall back to tr.selection.
        // To clean up: always use providedSelection || tr.selection, remove the feature flag check.
        const selection = ((0, $dh538.fg)('platform_editor_block_menu_jira_patch_1') ? providedSelection : undefined) || tr.selection;
        const decorations = [];
        const handleTableSelection = (pos = selection.$from)=>{
            const table = (0, $id9O1.findTableClosestToPos)(pos);
            if (!table) return tr;
            const tableNode = table.node;
            const tablePos = table.pos;
            decorations.push((0, $ftzrq.Decoration).node(tablePos, tablePos + tableNode.nodeSize, {
                class: className
            }, {
                key: `decorationNode-table-${tablePos}`
            }));
            const map = (0, $LmqWp.TableMap).get(tableNode);
            const cellPositions = new Set(map.map);
            cellPositions.forEach((cellPos)=>{
                const docPos = tablePos + cellPos + 1;
                const cell = tableNode.nodeAt(cellPos);
                if (cell) decorations.push((0, $ftzrq.Decoration).node(docPos, docPos + cell.nodeSize, {
                    class: className
                }, {
                    key: `decorationNode-cell-${docPos}`
                }));
            });
        };
        const handleNodeSelection = (node, pos)=>{
            const from = pos;
            const to = from + node.nodeSize;
            decorations.push((0, $ftzrq.Decoration).node(from, to, {
                class: className
            }, {
                key: 'decorationNode'
            }));
            if (node.type.name === 'layoutSection' || node.type.name === 'layoutColumn') {
                const startOfInsideOfContainer = tr.doc.resolve(from + 1);
                const endOfInsideOfContainer = tr.doc.resolve(to - 1);
                handleNodesSelection(startOfInsideOfContainer, endOfInsideOfContainer);
            }
        };
        const handleNodesSelection = ($from, $to)=>{
            let currentPos = $from.pos;
            const sourceNodes = (0, $l6okE.getSourceNodesFromSelectionRange)(tr, (0, $ks2lK.TextSelection).create(tr.doc, currentPos, $to.pos));
            sourceNodes.forEach((sourceNode)=>{
                if (sourceNode.type.name === 'table') {
                    const startPosOfTable = tr.doc.resolve(currentPos + 3);
                    handleTableSelection(startPosOfTable);
                } else handleNodeSelection(sourceNode, currentPos);
                currentPos += sourceNode.nodeSize;
            });
        };
        // Selecting a table directly: CellSelection
        if (selection instanceof (0, $7XFGZ.CellSelection)) handleTableSelection();
        // multiselect: TextSelection
        if (selection instanceof (0, $ks2lK.TextSelection)) handleNodesSelection(selection.$from, selection.$to);
        if (selection instanceof (0, $ks2lK.NodeSelection)) handleNodeSelection(selection.node, selection.from);
        // If no decorations were created, return early
        if (decorations.length === 0) return tr;
        const hasDangerDecorations = className.split(' ').includes('danger');
        tr.setMeta((0, $1138185b97e29b7a$export$385f768f10dabdd5), {
            action: add ? (0, $1138185b97e29b7a$export$92a1a3b7554e9387).DECORATION_ADD : (0, $1138185b97e29b7a$export$92a1a3b7554e9387).DECORATION_REMOVE,
            data: (0, $ftzrq.DecorationSet).create(tr.doc, decorations),
            hasDangerDecorations: (0, $iu6m9.editorExperiment)('platform_editor_block_menu', true) && hasDangerDecorations
        }).setMeta('addToHistory', false);
        return tr;
    };
const $8a41e4d6add08fa7$export$14b7848c5cb6944c = ()=>({ tr: tr })=>{
        return tr.setMeta((0, $1138185b97e29b7a$export$385f768f10dabdd5), {
            action: (0, $1138185b97e29b7a$export$92a1a3b7554e9387).DECORATION_REMOVE
        });
    };



const $d6da42aec9f7758a$export$1c07ef1814918eb5 = ()=>({
        name: 'decorations',
        pmPlugins () {
            return [
                {
                    name: 'decorationPlugin',
                    plugin: ()=>(0, $1138185b97e29b7a$export$2e2bcd8739ae039)()
                }
            ];
        },
        actions: {
            hoverDecoration: $1138185b97e29b7a$export$fbf24964a8aac61c,
            removeDecoration: $1138185b97e29b7a$export$ea377ae2b4b58797
        },
        getSharedState (editorState) {
            if (!editorState) return {
                decoration: undefined
            };
            return (0, $1138185b97e29b7a$export$385f768f10dabdd5).getState(editorState);
        },
        commands: {
            hoverDecoration: (0, $iu6m9.editorExperiment)('platform_editor_block_menu', true) ? ({ add: add, className: className })=>(0, $8a41e4d6add08fa7$export$84d8b6d3cf5f2fb4)({
                    add: add,
                    className: className
                }) : undefined,
            removeDecoration: (0, $iu6m9.editorExperiment)('platform_editor_block_menu', true) ? ()=>(0, $8a41e4d6add08fa7$export$14b7848c5cb6944c)() : undefined
        }
    });
module.exports["decorationsPlugin"] = $d6da42aec9f7758a$export$1c07ef1814918eb5;

});

parcelRegister("lgjGE", function(module, exports) {

var $2P8Ax = parcelRequire("2P8Ax");


var $1S4f7 = parcelRequire("1S4f7");


var $lkJUe = parcelRequire("lkJUe");


var $ks2lK = parcelRequire("ks2lK");

var $8b1beeb096942e63$export$9523889e0a5da4ba = /*#__PURE__*/ function(ACTION) {
    ACTION["TOGGLE_DISABLED"] = "TOGGLE_DISABLED";
    return ACTION;
}({});
function $8b1beeb096942e63$export$1650419e431d3ba3(pluginState, meta) {
    if (meta && 'action' in meta) switch(meta.action){
        case "TOGGLE_DISABLED":
            if (meta.disabled === pluginState.disabledByPlugin) return pluginState;
            return {
                ...pluginState,
                disabledByPlugin: Boolean(meta.disabled)
            };
        default:
            return pluginState;
    }
    return pluginState;
}


const $68176bed9676b94c$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('editorDisabledPlugin');
const { getPluginState: $68176bed9676b94c$var$getPluginState } = (0, $lkJUe.pluginFactory)($68176bed9676b94c$export$18d4026d1ea86bb1, (0, $8b1beeb096942e63$export$1650419e431d3ba3));
/*
Stores the state of the editor enabled/disabled for panel and floating
toolbar to subscribe to through useSharedPluginState. Otherwise the NodeViews
won't re-render when it changes.
*/ function $68176bed9676b94c$var$createPlugin(dispatch, options) {
    const scheduleEditorDisabledUpdate = (0, $2P8Ax.default)((view)=>{
        if ($68176bed9676b94c$var$getPluginState(view.state).editorDisabled !== !view.editable) {
            const disabledMeta = {
                editorDisabled: !view.editable,
                disabledByPlugin: $68176bed9676b94c$var$getPluginState(view.state).disabledByPlugin
            };
            const tr = view.state.tr.setMeta($68176bed9676b94c$export$18d4026d1ea86bb1, disabledMeta).setMeta('editorDisabledPlugin', disabledMeta);
            tr.setMeta('isLocal', true);
            view.dispatch(tr);
        }
    });
    return new (0, $1S4f7.SafePlugin)({
        key: $68176bed9676b94c$export$18d4026d1ea86bb1,
        state: {
            init: ()=>{
                return {
                    editorDisabled: options?.initialDisabledState ?? false,
                    disabledByPlugin: false
                };
            },
            apply: (tr, pluginState)=>{
                const meta = tr.getMeta($68176bed9676b94c$export$18d4026d1ea86bb1);
                if (meta) {
                    if ('action' in meta) return (0, $8b1beeb096942e63$export$1650419e431d3ba3)(pluginState, meta);
                    return pluginState.editorDisabled !== meta.editorDisabled ? {
                        ...pluginState,
                        ...meta
                    } : pluginState;
                }
                return pluginState;
            }
        },
        props: {
            // If we set to undefined it respects the previous value.
            // Prosemirror doesn't have this typed correctly for this type of behaviour
            // @ts-expect-error
            editable: (state)=>{
                const { disabledByPlugin: disabledByPlugin } = $68176bed9676b94c$export$18d4026d1ea86bb1.getState(state) ?? {
                    disabledByPlugin: false
                };
                return disabledByPlugin ? false : undefined;
            }
        },
        view: (view)=>{
            // schedule on mount
            scheduleEditorDisabledUpdate(view);
            return {
                update (view) {
                    scheduleEditorDisabledUpdate(view);
                },
                destroy () {
                    scheduleEditorDisabledUpdate.cancel();
                }
            };
        }
    });
}
const $68176bed9676b94c$export$db5fb3a4c4390f03 = ({ config: options = {} })=>({
        name: 'editorDisabled',
        getSharedState (editorState) {
            if (!editorState) return {
                editorDisabled: false
            };
            const pluginState = $68176bed9676b94c$export$18d4026d1ea86bb1.getState(editorState);
            if (!pluginState) return {
                editorDisabled: false
            };
            return {
                editorDisabled: pluginState.disabledByPlugin || pluginState.editorDisabled
            };
        },
        pmPlugins: ()=>[
                {
                    name: 'editorDisabled',
                    plugin: ({ dispatch: dispatch })=>$68176bed9676b94c$var$createPlugin(dispatch, options)
                }
            ],
        commands: {
            toggleDisabled: (disabled)=>({ tr: tr })=>{
                    return tr.setMeta($68176bed9676b94c$export$18d4026d1ea86bb1, {
                        action: (0, $8b1beeb096942e63$export$9523889e0a5da4ba).TOGGLE_DISABLED,
                        disabled: disabled
                    });
                }
        }
    });
module.exports["editorDisabledPlugin"] = $68176bed9676b94c$export$db5fb3a4c4390f03;

});

parcelRegister("7sK9h", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5nZsM = parcelRequire("5nZsM");


var $d925B = parcelRequire("d925B");


var $eTj7Y = parcelRequire("eTj7Y");


var $7fmpI = parcelRequire("7fmpI");


var $1Oo9w = parcelRequire("1Oo9w");


var $dYBVS = parcelRequire("dYBVS");


var $1S4f7 = parcelRequire("1S4f7");


var $iHzeA = parcelRequire("iHzeA");


var $jwWgu = parcelRequire("jwWgu");


var $ks2lK = parcelRequire("ks2lK");


var $8m4tT = parcelRequire("8m4tT");


var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");


var $d7ZU3 = parcelRequire("d7ZU3");


var $cMZNY = parcelRequire("cMZNY");


var $kgnzE = parcelRequire("kgnzE");





var $iu6m9 = parcelRequire("iu6m9");

const $2f991cc39c54e634$export$978ef9948557240e = (nodeType, editorAnalyticsApi, inputMethod)=>({ tr: tr })=>{
        // const { tr, schema } = state;
        // This command should only be triggered by the Copy button in the floating toolbar
        // which is only visible when selection is inside the target node
        const contentNodeWithPos = (0, $kgnzE.getSelectedNodeOrNodeParentByNodeType)({
            nodeType: nodeType,
            selection: tr.selection
        });
        if (!contentNodeWithPos) return tr;
        const schema = tr.doc.type.schema;
        const copyToClipboardTr = tr;
        const domNode = (0, $kgnzE.toDOM)(contentNodeWithPos.node, schema);
        if ((0, $iu6m9.editorExperiment)('platform_editor_block_menu', true)) (0, $kgnzE.copyDomNode)(domNode, contentNodeWithPos.node.type, tr.selection);
        else if (domNode) {
            const div = document.createElement('div');
            const browser = (0, $d7ZU3.getBrowserInfo)();
            div.appendChild(domNode);
            // if copying inline content
            if (contentNodeWithPos.node.type.inlineContent) // The "1 1" refers to the start and end depth of the slice
            // since we're copying the text inside a paragraph, it will always be 1 1
            // https://github.com/ProseMirror/prosemirror-view/blob/master/src/clipboard.ts#L32
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            div.firstChild.setAttribute('data-pm-slice', '1 1 []');
            else // The "0 0" refers to the start and end depth of the slice
            // since we're copying the block node only, it will always be 0 0
            // https://github.com/ProseMirror/prosemirror-view/blob/master/src/clipboard.ts#L32
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            div.firstChild.setAttribute('data-pm-slice', '0 0 []');
            // ED-17083 safari seems have bugs for extension copy because exntension do not have a child text(innerText) and it will not recognized as html in clipboard, this could be merge into one if this extension fixed children issue or safari fix the copy bug
            // MEX-2528 safari has a bug related to the mediaSingle node with border or link. The image tag within the clipboard is not recognized as HTML when using the ClipboardItem API. To address this, we have to switch to ClipboardPolyfill
            if (browser.safari && tr.selection instanceof (0, $ks2lK.NodeSelection) && (tr.selection.node.type === schema.nodes.extension || tr.selection.node.type === schema.nodes.mediaSingle)) (0, $cMZNY.copyHTMLToClipboardPolyfill)(div);
            else (0, $cMZNY.copyHTMLToClipboard)(div);
        }
        if (editorAnalyticsApi) {
            const analyticsPayload = (0, $cMZNY.getNodeCopiedAnalyticsPayload)(contentNodeWithPos.node, inputMethod);
            editorAnalyticsApi.attachAnalyticsEvent(analyticsPayload)(copyToClipboardTr);
        }
        copyToClipboardTr.setMeta('scrollIntoView', false);
        return copyToClipboardTr;
    };








const $2bbb1f5d06db1dd0$export$ded15a80767f6af7 = new (0, $ks2lK.PluginKey)('forceFocusStatePlugin');
var /**
 * Used in cases where a floating toolbar button opens a submenu which destroys
 * the button, but the user has pressed ESC to close the submenu and focus needs
 * to move back to the button. */ $2bbb1f5d06db1dd0$export$2e2bcd8739ae039 = ()=>new (0, $1S4f7.SafePlugin)({
        key: $2bbb1f5d06db1dd0$export$ded15a80767f6af7,
        state: {
            init: ()=>({
                    selector: null
                }),
            apply: (tr, prevState)=>{
                const meta = tr.getMeta($2bbb1f5d06db1dd0$export$ded15a80767f6af7);
                if (meta && 'selector' in meta) return {
                    selector: meta.selector
                };
                return prevState;
            }
        }
    });
const $2bbb1f5d06db1dd0$export$1470545de94762f5 = (selector)=>(tr)=>{
        return tr.setMeta($2bbb1f5d06db1dd0$export$ded15a80767f6af7, {
            selector: selector
        });
    };
function $2bbb1f5d06db1dd0$export$a2ced8424a9be595(view) {
    const state = view?.state;
    if (state) {
        const { selector: selector } = $2bbb1f5d06db1dd0$export$ded15a80767f6af7.getState(state);
        if (selector) {
            const focusableElement = document.querySelector(selector);
            if (focusableElement) {
                focusableElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                    inline: 'nearest'
                });
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                focusableElement.focus();
                const { state: { tr: tr }, dispatch: dispatch } = view;
                dispatch($2bbb1f5d06db1dd0$export$1470545de94762f5(null)(tr));
            }
        }
    }
}



var $lkJUe = parcelRequire("lkJUe");




const $05bdec134809a907$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('floatingToolbarData');


const $30339f2e245a04a7$export$1650419e431d3ba3 = (pluginState, action)=>{
    switch(action.type){
        case 'SHOW_CONFIRM_DIALOG':
            return {
                ...pluginState,
                confirmDialogForItem: action.data.buttonIndex,
                confirmDialogForItemOption: action.data.optionIndex
            };
        case 'HIDE_CONFIRM_DIALOG':
            return {
                ...pluginState,
                confirmDialogForItem: undefined
            };
        default:
            return pluginState;
    }
};


const $c5d475331e1317d1$var$dest = (0, $lkJUe.pluginFactory)((0, $05bdec134809a907$export$18d4026d1ea86bb1), (0, $30339f2e245a04a7$export$1650419e431d3ba3));
const $c5d475331e1317d1$export$656c7661095efe2e = $c5d475331e1317d1$var$dest.createPluginState;
const $c5d475331e1317d1$export$8d4021544bdece00 = $c5d475331e1317d1$var$dest.createCommand;
const $c5d475331e1317d1$export$f05434c51e3762e = $c5d475331e1317d1$var$dest.getPluginState;


const $fcd54976fe532dea$export$c0076bd4afc29e7a = (buttonIndex, optionIndex)=>(0, $c5d475331e1317d1$export$8d4021544bdece00)({
        type: 'SHOW_CONFIRM_DIALOG',
        data: {
            buttonIndex: buttonIndex,
            optionIndex: optionIndex
        }
    }, (tr)=>tr.setMeta('addToHistory', false));
const $fcd54976fe532dea$export$5a3c1357cfd1045c = ()=>(0, $c5d475331e1317d1$export$8d4021544bdece00)({
        type: 'HIDE_CONFIRM_DIALOG'
    }, (tr)=>tr.setMeta('addToHistory', false));







const $5b9b106e178d33bc$export$ae829ec7b2625219 = (dispatch)=>{
    return new (0, $1S4f7.SafePlugin)({
        state: (0, $c5d475331e1317d1$export$656c7661095efe2e)(dispatch, {}),
        key: (0, $05bdec134809a907$export$18d4026d1ea86bb1)
    });
};



function $6ac0eea64e149e3b$export$5b92d7a8b5d33ee2(parent, predicate) {
    let matchedNode;
    parent.descendants((node)=>{
        // dont run predicate if node already found
        if (matchedNode) return false;
        if (predicate(node)) {
            matchedNode = node;
            return false;
        }
        return true;
    });
    return matchedNode;
}






var $aXWIB = parcelRequire("aXWIB");


var $6xdDU = parcelRequire("6xdDU");





var $ccHMk = parcelRequire("ccHMk");


var $7gpC4 = parcelRequire("7gpC4");


var $k4fPq = parcelRequire("k4fPq");


var $8CZUH = parcelRequire("8CZUH");

var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");


var $iXCQx = parcelRequire("iXCQx");

const $cbcc7c7fd72ea79c$export$9c828de50258a892 = (props)=>{
    const [isChecked, setCheckbox] = (0, $42omo.useState)(false);
    const { onConfirm: onConfirm, onClose: onClose, options: options, intl: { formatMessage: formatMessage }, testId: testId } = props;
    const heading = options?.title || formatMessage((0, $k4fPq.default).confirmModalDefaultHeading);
    const okButtonLabel = options?.okButtonLabel || formatMessage((0, $k4fPq.default).confirmModalOK);
    const cancelButtonLabel = options?.cancelButtonLabel || formatMessage((0, $k4fPq.default).confirmModalCancel);
    const checkboxlabel = options?.checkboxLabel;
    const childrenInfo = options?.getChildrenInfo?.();
    const ListComponent = ({ nodes: nodes })=>{
        if (nodes.length === 0) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ul", {
            "data-vc": "hLxAVwWk"
        }, nodes.map((node)=>// Ignored via go/ees005
            // eslint-disable-next-line react/jsx-props-no-spreading
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ListItem, {
                ...node,
                key: node.id
            })));
    };
    const ListItem = (props)=>{
        const { id: id, name: name, amount: amount } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("li", {
            id: id
        }, formatMessage((0, $k4fPq.default).confirmModalListUnit, {
            name: name,
            amount: amount
        }));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8CZUH.default), {
        onClose: onClose,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8eRd.default), {
        appearance: "warning"
    }, heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        as: "p"
    }, options?.message), !!childrenInfo?.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ListComponent, {
        nodes: childrenInfo
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        as: "p"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7gpC4.default), {
        isChecked: isChecked,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onChange: ()=>setCheckbox(!isChecked),
        label: checkboxlabel,
        testId: testId ? `${testId}-checkbox` : undefined
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8o1lj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "default",
        onClick: onClose,
        testId: testId ? `${testId}-cancel-button` : undefined
    }, cancelButtonLabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "warning",
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onClick: ()=>{
            onConfirm(isChecked);
            onClose();
        },
        testId: testId ? `${testId}-confirm-button` : undefined
    }, okButtonLabel)));
};

























const $e89fa378510b1874$export$f96c193e316d2274 = (props)=>{
    const { onConfirm: onConfirm, onClose: onClose, options: options, intl: { formatMessage: formatMessage }, testId: testId } = props;
    const heading = options?.title || formatMessage((0, $k4fPq.default).confirmModalDefaultHeading);
    const okButtonLabel = options?.okButtonLabel || formatMessage((0, $k4fPq.default).confirmModalOK);
    const cancelButtonLabel = options?.cancelButtonLabel || formatMessage((0, $k4fPq.default).confirmModalCancel);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8CZUH.default), {
        onClose: onClose,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8eRd.default), {
        appearance: "warning"
    }, heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        as: "p"
    }, options?.message)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8o1lj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "default",
        onClick: onClose,
        testId: testId ? `${testId}-cancel-button` : undefined
    }, cancelButtonLabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "warning",
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onClick: ()=>{
            onConfirm();
            onClose();
        },
        testId: testId ? `${testId}-confirm-button` : undefined
    }, okButtonLabel)));
};


const $df15872dca729d4f$var$ConfirmationModalImpl = (props)=>{
    const { options: options } = props;
    const renderModel = (isReferentialityDialog = false)=>// Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        isReferentialityDialog ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cbcc7c7fd72ea79c$export$9c828de50258a892), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e89fa378510b1874$export$f96c193e316d2274), props);
    return options ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, renderModel(options?.isReferentialityDialog)) : null;
};
const $df15872dca729d4f$export$1f33f980da756c46 = (0, $aXWIB.injectIntl)($df15872dca729d4f$var$ConfirmationModalImpl);


/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $9K4OG = parcelRequire("9K4OG");





var $hArLp = parcelRequire("hArLp");


var $aaI8u = parcelRequire("aaI8u");


var $1QXSD = parcelRequire("1QXSD");





var $4BNmH = parcelRequire("4BNmH");

// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $a7c1514010b8535c$var$makeSameType(_a, _b) {
    return true;
}
const $a7c1514010b8535c$export$d36bdfa510afb180 = (objA, objB)=>{
    if (objA === objB) return true;
    if (objA == null || objB == null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    const bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    for(let idx = 0; idx < keysA.length; idx++){
        const key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (objA[key] !== objB[key]) return false;
    }
    return true;
};
const $a7c1514010b8535c$export$fc16749c794bf6ff = (left, right, compareFn = $a7c1514010b8535c$export$d36bdfa510afb180)=>{
    if (left.length !== right.length) return false;
    for(let idx = 0; idx < left.length; idx++){
        if (!compareFn(left[idx], right[idx])) return false;
    }
    return true;
};
const $a7c1514010b8535c$var$compareItemWithKeys = (leftItem, rightItem, excludedKeys = [])=>Object.keys(leftItem).filter((key)=>excludedKeys.indexOf(key) === -1).every((key)=>leftItem[key] instanceof Object ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $a7c1514010b8535c$export$d36bdfa510afb180(leftItem[key], rightItem[key]) : leftItem[key] === rightItem[key]);
const $a7c1514010b8535c$export$b6007c51cfc2eaf0 = (leftItem, rightItem)=>{
    if (leftItem.type !== rightItem.type) return false;
    switch(leftItem.type){
        case 'button':
            // Need to typecast `rightItem as typeof leftItem` otherwise we will
            // have to put the `type !==` inside each case.
            return $a7c1514010b8535c$var$compareItemWithKeys(leftItem, rightItem, [
                'type',
                'onClick',
                'onMouseEnter',
                'onMouseLeave'
            ]);
        case 'copy-button':
            return $a7c1514010b8535c$var$compareItemWithKeys(leftItem, rightItem, [
                'type',
                'items'
            ]);
        case 'input':
            return $a7c1514010b8535c$var$compareItemWithKeys(leftItem, rightItem, [
                'type',
                'onSubmit',
                'onBlur'
            ]);
        case 'select':
            if ($a7c1514010b8535c$var$makeSameType(leftItem, rightItem) && Array.isArray(leftItem.options) && Array.isArray(rightItem.options) && // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            !$a7c1514010b8535c$export$fc16749c794bf6ff(leftItem.options, rightItem.options, (left, right)=>$a7c1514010b8535c$var$compareItemWithKeys(left, right))) return false;
            return $a7c1514010b8535c$var$compareItemWithKeys(leftItem, rightItem, [
                'type',
                'onChange',
                'options'
            ]);
        case 'overflow-dropdown':
        case 'dropdown':
            if ($a7c1514010b8535c$var$makeSameType(leftItem, rightItem) && Array.isArray(leftItem.options) && Array.isArray(rightItem.options) && // @ts-expect-error TS2345: Argument of type 'DropdownOptionT<Function>[]' is not assignable to parameter of type 'any[][]'
            !$a7c1514010b8535c$export$fc16749c794bf6ff(leftItem.options, rightItem.options, (left, right)=>// @ts-expect-error  TS2322: Type '"onClick"' is not assignable to type 'keyof any[]'
                $a7c1514010b8535c$var$compareItemWithKeys(left, right, [
                    'onClick'
                ]))) return false;
            return $a7c1514010b8535c$var$compareItemWithKeys(leftItem, rightItem, [
                'type',
                'options'
            ]);
        case 'custom':
            return false;
        case 'separator':
            return $a7c1514010b8535c$var$compareItemWithKeys(leftItem, rightItem);
        case 'extensions-placeholder':
            return $a7c1514010b8535c$var$compareItemWithKeys(leftItem, rightItem);
    }
};
const $a7c1514010b8535c$export$1d04baad505b720e = (leftArr, rightArr)=>{
    if (leftArr === undefined && rightArr === undefined) return true;
    if (leftArr === undefined || rightArr === undefined) return false;
    if (leftArr.length !== rightArr.length) return false;
    return leftArr.every((item, index)=>$a7c1514010b8535c$export$b6007c51cfc2eaf0(rightArr[index], item));
};





var $61p3e = parcelRequire("61p3e");





var $cftLn = parcelRequire("cftLn");

var $3P0Cg = parcelRequire("3P0Cg");

var $faH35 = parcelRequire("faH35");


var $8LFdJ = parcelRequire("8LFdJ");


var $lAt6Q = parcelRequire("lAt6Q");

var $5Gwdo = parcelRequire("5Gwdo");


var $6icEc = parcelRequire("6icEc");


var $9VJDA = parcelRequire("9VJDA");






/**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag
 */ 









var $5v8Ta = parcelRequire("5v8Ta");

var $2dkHo = parcelRequire("2dkHo");


var $ghftu = parcelRequire("ghftu");





var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");

const $9fa432e80da87a20$var$styles = (0, $ecnYn.xcss)({
    width: '100%',
    borderBlockEnd: 'none',
    borderBlockStart: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    borderInline: 'none'
});
const $9fa432e80da87a20$export$2e0a83ec2e27ecbb = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        as: "hr",
        xcss: $9fa432e80da87a20$var$styles,
        role: "presentation"
    });


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 














var $gBbsI = parcelRequire("gBbsI");

const $2b7bb400945d309b$export$1a7f12094b137d20 = {
    width: 175,
    height: 32
};
const $2b7bb400945d309b$var$headingStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    padding: `${"var(--ds-space-200, 16px)"} 0 ${"var(--ds-space-100, 8px)"}`
});
// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
const $2b7bb400945d309b$var$menuContainerStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minWidth: `${$2b7bb400945d309b$export$1a7f12094b137d20.width}px`,
    // temporary solution to retain spacing defined by @atlaskit/Item
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& button': {
        minHeight: "var(--ds-space-400, 32px)",
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"} 7px`,
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > [data-item-elem-before]': {
            marginRight: "var(--ds-space-050, 4px)"
        }
    }
});
const $2b7bb400945d309b$export$e14354b446b68c1f = 4;
const $2b7bb400945d309b$var$Dropdown = /*#__PURE__*/ (0, $42omo.memo)((props)=>{
    const { hide: hide, dispatchCommand: dispatchCommand, items: items, intl: intl, editorView: editorView, showSelected: showSelected = true, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled } = props;
    if (areAnyNewToolbarFlagsEnabled) return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $2b7bb400945d309b$var$menuContainerStyles,
        role: "menu",
        "data-vc": "vlLbyZdB"
    }, items// @ts-ignore
    .filter((item)=>item && (!('hidden' in item) || !item.hidden)).map((item, idx)=>{
        if (!('type' in item)) return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $1QXSD.DropdownMenuItem), {
            // Ignored via go/ees005
            // eslint-disable-next-line react/no-array-index-key
            key: idx,
            item: item,
            hide: hide,
            dispatchCommand: dispatchCommand,
            editorView: editorView,
            showSelected: showSelected,
            intl: intl
        });
        if (item.type === 'separator') // eslint-disable-next-line react/no-array-index-key
        return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $4BNmH.DropdownSeparator), {
            key: idx
        });
        if (item.type === 'overflow-dropdown-heading') return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            key: item.title,
            css: $2b7bb400945d309b$var$headingStyles
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $gBbsI.default), null, item.title));
        if (item.type === 'custom') {
            const dropdownMenuOptions = {
                hide: hide,
                dispatchCommand: dispatchCommand,
                editorView: editorView,
                showSelected: showSelected,
                intl: intl
            };
            return item.render(editorView, dropdownMenuOptions);
        }
    }));
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $2b7bb400945d309b$var$menuContainerStyles,
        role: "menu"
    }, items.filter((item)=>!item.hidden).map((item, idx)=>/*#__PURE__*/ (0, $9K4OG.jsx)((0, $1QXSD.DropdownMenuItem), {
            // Ignored via go/ees005
            // eslint-disable-next-line react/no-array-index-key
            key: idx,
            item: item,
            hide: hide,
            dispatchCommand: dispatchCommand,
            editorView: editorView,
            showSelected: showSelected,
            intl: intl
        })));
});
const $2b7bb400945d309b$var$_default_1 = (0, $aXWIB.injectIntl)($2b7bb400945d309b$var$Dropdown);
var $2b7bb400945d309b$export$2e2bcd8739ae039 = $2b7bb400945d309b$var$_default_1;


function $861ad37f8a0900c3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $861ad37f8a0900c3$var$dropdownExpandContainer = /*#__PURE__*/ (0, $9K4OG.css)({
    margin: `0px ${"var(--ds-space-negative-050, -4px)"}`
});
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $861ad37f8a0900c3$var$iconGroup = {
    name: "zjik7",
    styles: "display:flex"
};
const $861ad37f8a0900c3$var$CompositeIcon = ({ icon: icon })=>/*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $861ad37f8a0900c3$var$iconGroup,
        "data-vc": "azj_mCUo"
    }, icon, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        css: $861ad37f8a0900c3$var$dropdownExpandContainer
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
        color: "currentColor",
        spacing: "spacious",
        label: "Expand dropdown menu",
        size: "small"
    })));
class $861ad37f8a0900c3$export$2e2bcd8739ae039 extends (0, $42omo.Component) {
    render() {
        const { isOpen: isOpen } = this.state;
        const { title: title, icon: icon, iconBefore: iconBefore, options: options, dispatchCommand: dispatchCommand, mountPoint: mountPoint, boundariesElement: boundariesElement, scrollableElement: scrollableElement, hideExpandIcon: hideExpandIcon, disabled: disabled, tooltip: tooltip, buttonTestId: buttonTestId, dropdownWidth: dropdownWidth, dropdownListId: dropdownListId, alignDropdownWithToolbar: alignDropdownWithToolbar, footer: footer, onMount: onMount, pulse: pulse, shouldFitContainer: shouldFitContainer, alignX: alignX, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled } = this.props;
        let trigger;
        if (icon) {
            const TriggerIcon = hideExpandIcon ? icon : /*#__PURE__*/ (0, $9K4OG.jsx)($861ad37f8a0900c3$var$CompositeIcon, {
                icon: icon
            });
            trigger = /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3P0Cg.default), {
                testId: buttonTestId,
                title: title,
                icon: TriggerIcon,
                onClick: this.toggleOpen,
                onKeyDown: this.toggleOpenByKeyboard,
                selected: isOpen,
                disabled: disabled,
                tooltipContent: tooltip,
                ariaHasPopup: areAnyNewToolbarFlagsEnabled ? true : undefined,
                onMount: onMount,
                pulse: pulse,
                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
            });
        } else trigger = /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3P0Cg.default), {
            testId: buttonTestId,
            iconAfter: /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
                css: $861ad37f8a0900c3$var$dropdownExpandContainer
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                color: "currentColor",
                spacing: "spacious",
                label: "Expand dropdown menu",
                size: "small"
            })),
            icon: iconBefore,
            onClick: this.toggleOpen,
            onKeyDown: this.toggleOpenByKeyboard,
            selected: isOpen,
            disabled: disabled,
            tooltipContent: tooltip,
            ariaHasPopup: true,
            areaControls: dropdownListId,
            onMount: onMount,
            pulse: pulse,
            areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
        }, title);
        /**
     * We want to change direction of our dropdowns a bit early,
     * not exactly when it hits the boundary.
     */ const fitTolerance = 10;
        const fitWidth = Array.isArray(options) || typeof options === 'function' ? dropdownWidth || (0, $2b7bb400945d309b$export$1a7f12094b137d20).width : options.width;
        const fitHeight = Array.isArray(options) ? options.length * (0, $2b7bb400945d309b$export$1a7f12094b137d20).height + (0, $2b7bb400945d309b$export$e14354b446b68c1f) * 2 : typeof options === 'function' ? this.makeArrayOptionsFromCallback(options).length : options.height;
        return(/**
       * At the moment footer diver is rendered along with footer, if it's provided
       * This is to provide some level of consistency
       * Refer to the PR for more details:
       * https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/137394/overview?commentId=8130003
       */ /*#__PURE__*/ (0, $9K4OG.jsx)((0, $2dkHo.DropdownContainer), {
            alignX: alignX,
            mountTo: mountPoint,
            boundariesElement: boundariesElement,
            scrollableElement: scrollableElement,
            isOpen: isOpen,
            handleClickOutside: this.hide,
            handleEscapeKeydown: this.hideOnEsc,
            onOpenChange: this.onOpenChanged,
            fitWidth: fitWidth + fitTolerance,
            fitHeight: fitHeight + fitTolerance,
            trigger: trigger,
            dropdownListId: dropdownListId,
            alignDropdownWithParentElement: alignDropdownWithToolbar,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            arrowKeyNavigationProviderOptions: {
                type: (0, $5v8Ta.ArrowKeyNavigationType).MENU
            },
            shouldFitContainer: shouldFitContainer
        }, Array.isArray(options) ? this.renderArrayOptions(options) : typeof options === 'function' ? this.renderArrayOptions(this.makeArrayOptionsFromCallback(options)) : options.render({
            hide: this.hide,
            dispatchCommand: dispatchCommand
        }), footer && /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $9fa432e80da87a20$export$2e0a83ec2e27ecbb), null), footer)));
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.isOpen !== this.state.isOpen) {
            if (this.props.setDisableParentScroll) this.props.setDisableParentScroll(this.state.isOpen);
            // ECA11Y-235: no sense in sending keyboard event since the menu popup mounted to the custom element,
            // we will ensure first element focused asap as 'MenuArrowKeyNavigationProvider' is mounted
            if (this.props.mountPoint) return;
            if (this.state.isOpen && this.state.isOpenedByKeyboard) {
                const dropList = document.querySelector('[data-role="droplistContent"]');
                if (dropList) // Add setTimeout so that if a dropdown item has tooltip,
                // the tooltip won't be rendered until next render cycle
                // when the droplist is correctly positioned.
                // This makes tooltip appears at the correct position for the first dropdown item.
                setTimeout(()=>{
                    const keyboardEvent = new KeyboardEvent('keydown', {
                        bubbles: true,
                        key: 'ArrowDown'
                    });
                    dropList.dispatchEvent(keyboardEvent);
                }, 0);
            }
        }
    }
    constructor(...args){
        super(...args);
        this.state = {
            isOpen: false,
            isOpenedByKeyboard: false
        };
        this.triggerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
        this.makeArrayOptionsFromCallback = (makeOptions)=>{
            const options = makeOptions();
            return options;
        };
        this.renderArrayOptions = (options)=>{
            const { showSelected: showSelected, dispatchCommand: dispatchCommand, editorView: editorView, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled } = this.props;
            return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $2b7bb400945d309b$export$2e2bcd8739ae039), {
                hide: this.hide,
                dispatchCommand: dispatchCommand,
                items: options,
                showSelected: showSelected,
                editorView: editorView,
                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
            });
        };
        this.toggleOpen = ()=>{
            const onClick = this.props.onClick;
            if (onClick) onClick();
            this.setState({
                isOpen: !this.state.isOpen,
                isOpenedByKeyboard: false
            });
            const onToggle = this.props.onToggle;
            if (!onToggle) return;
            requestAnimationFrame(()=>{
                this.props.dispatchCommand(onToggle);
            });
        };
        this.toggleOpenByKeyboard = (event)=>{
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                this.setState({
                    isOpen: !this.state.isOpen,
                    isOpenedByKeyboard: true
                });
            }
        };
        this.hide = ()=>{
            this.setState({
                ...this.state,
                isOpen: false
            });
        };
        this.hideOnEsc = ()=>{
            // Focus the trigger button only on Escape
            // Focus is done before hiding to ensure onBlur is called
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            document.querySelector(`[data-testid=${this.props.buttonTestId}]`)?.focus();
            this.hide();
        };
        this.onOpenChanged = (openChangedEvent)=>{
            if (!openChangedEvent.isOpen && openChangedEvent.event instanceof KeyboardEvent) openChangedEvent.event?.key === 'Escape' ? this.hideOnEsc() : this.hide();
        };
    }
}


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 






var $1qfLF = parcelRequire("1qfLF");


var $eiA8Z = parcelRequire("eiA8Z");





var $wJ8xb = parcelRequire("wJ8xb");

var $efG2U = parcelRequire("efG2U");


var $fnia6 = parcelRequire("fnia6");


var $4FHTF = parcelRequire("4FHTF");


var $3gadb = parcelRequire("3gadb");

function $6cc4590ebdb944ca$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $6cc4590ebdb944ca$var$emojiPickerButtonWrapperVisualRefresh = {
    name: "1spoyok",
    styles: "position:relative;button{&:not([disabled])::after{border:none;}}"
};
const $6cc4590ebdb944ca$var$selector = (states)=>{
    return states.emojiState?.emojiProvider;
};
const $6cc4590ebdb944ca$var$EmojiPickerWithProvider = (props)=>{
    const emojiProvider = (0, $eiA8Z.useSharedPluginStateWithSelector)(props.pluginInjectionApi, [
        'emoji'
    ], $6cc4590ebdb944ca$var$selector);
    const setOutsideClickTargetRef = (0, $42omo.useContext)((0, $wJ8xb.OutsideClickTargetRefContext));
    if (!emojiProvider) return null;
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $fnia6.EmojiPicker), {
        emojiProvider: Promise.resolve(emojiProvider),
        onSelection: props.updateEmoji,
        onPickerRef: setOutsideClickTargetRef
    });
};
// Note: These are based on the height and width of the emoji picker at the time
// of writing (2025-05-05). It is 100% prone to change but at least it's vaguely
// written down.
const $6cc4590ebdb944ca$var$EMOJI_PICKER_MAX_HEIGHT = 431;
const $6cc4590ebdb944ca$var$EMOJI_PICKER_MAX_WIDTH = 352;
const $6cc4590ebdb944ca$var$EmojiPickerWithListener = (0, $efG2U.default)($6cc4590ebdb944ca$var$EmojiPickerWithProvider);
const $6cc4590ebdb944ca$export$428fcc6fc228bd52 = (props)=>{
    const buttonRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(null);
    const [isPopupOpen, setIsPopupOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        if (props.setDisableParentScroll) props.setDisableParentScroll(isPopupOpen);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isPopupOpen
    ]);
    const togglePopup = (0, $42omo.useCallback)(()=>{
        setIsPopupOpen(!isPopupOpen);
    }, [
        setIsPopupOpen,
        isPopupOpen
    ]);
    const updateEmoji = (emoji)=>{
        setIsPopupOpen(false);
        props.onChange && props.onChange(emoji);
        requestAnimationFrame(()=>{
            props.editorView?.focus();
        });
    };
    const isDetachedElement = (0, $42omo.useCallback)((el)=>!document.body.contains(el), []);
    const handleEmojiClickOutside = (0, $42omo.useCallback)((e)=>{
        // Ignore click events for detached elements.
        // Workaround for CETI-240 - where two onClicks fire - one when the upload button is
        // still in the document, and one once it's detached. Does not always occur, and
        // may be a side effect of a react render optimisation
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        if (e && e.target && !isDetachedElement(e.target)) togglePopup();
    }, [
        isDetachedElement,
        togglePopup
    ]);
    const handleEmojiPressEscape = (0, $42omo.useCallback)(()=>{
        setIsPopupOpen(false);
        buttonRef.current?.focus();
    }, [
        setIsPopupOpen,
        buttonRef
    ]);
    const renderPopup = ()=>{
        if (!buttonRef.current || !isPopupOpen) return;
        return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $jwWgu.default), {
            target: buttonRef.current,
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            mountTo: props.setDisableParentScroll ? props.mountPoint : buttonRef.current.parentElement,
            fitHeight: $6cc4590ebdb944ca$var$EMOJI_PICKER_MAX_HEIGHT,
            fitWidth: $6cc4590ebdb944ca$var$EMOJI_PICKER_MAX_WIDTH,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            offset: [
                0,
                10
            ],
            // Confluence inline comment editor has z-index: 500
            // if the toolbar is scrollable, this will be mounted in the root editor
            // we need an index of > 500 to display over it
            zIndex: props.setDisableParentScroll ? 600 : undefined,
            focusTrap: true,
            preventOverflow: true,
            boundariesElement: props.popupsBoundariesElement
        }, /*#__PURE__*/ (0, $9K4OG.jsx)($6cc4590ebdb944ca$var$EmojiPickerWithListener, {
            handleEscapeKeydown: handleEmojiPressEscape,
            handleClickOutside: handleEmojiClickOutside,
            pluginInjectionApi: props.pluginInjectionApi,
            updateEmoji: updateEmoji
        }));
    };
    const title = props.title || '';
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $6cc4590ebdb944ca$var$emojiPickerButtonWrapperVisualRefresh,
        "data-vc": "x7YDweXy"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3gadb.default), {
        content: title,
        position: "top"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $1qfLF.default), {
        appearance: "subtle",
        key: props.idx,
        onClick: togglePopup,
        ref: buttonRef,
        isSelected: props.isSelected,
        label: title,
        spacing: "compact",
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        icon: ()=>/*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4FHTF))), {
                color: "currentColor",
                label: "emoji-picker-button",
                spacing: "spacious"
            })
    })), renderPopup());
};






var $4wH3g = parcelRequire("4wH3g");





var $2cmfr = parcelRequire("2cmfr");


var $8EYIj = parcelRequire("8EYIj");

var $jSp3D = parcelRequire("jSp3D");







var $7iE7T = parcelRequire("7iE7T");


const $a227bbdaf854705b$var$noop = ()=>null;
const $a227bbdaf854705b$var$isDefaultExport = (mod)=>{
    return mod.hasOwnProperty('default');
};
const $a227bbdaf854705b$var$resolveExtensionIcon = async (getIcon)=>{
    if (!getIcon) return $a227bbdaf854705b$var$noop;
    const maybeIcon = await getIcon();
    return $a227bbdaf854705b$var$isDefaultExport(maybeIcon) ? maybeIcon.default : maybeIcon;
};
const $a227bbdaf854705b$var$ExtensionButton = (props)=>{
    const { item: item, node: node, extensionApi: extensionApi, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled } = props;
    const ButtonIcon = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>item.icon ? (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
            __loadable_id__: "aISYW",
            name: "platform.packages.editor.editor-plugin-floating-toolbar.src.ui.ExtensionsPlaceholder",
            // Ignored via go/ees005
            // eslint-disable-next-line require-await
            loader: async ()=>$a227bbdaf854705b$var$resolveExtensionIcon(item.icon),
            loading: $a227bbdaf854705b$var$noop
        }) : undefined, [
        item.icon
    ]);
    const onClick = ()=>{
        if (typeof item.action !== 'function') throw new Error(`'action' of context toolbar item '${item.key}' is not a function`);
        const targetNodeAdf = (0, $7iE7T.nodeToJSON)(node);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        item.action(targetNodeAdf, extensionApi);
    };
    const getAriaLabel = ()=>{
        if (item.ariaLabel) return item.ariaLabel;
        if (typeof item.tooltip === 'string') return item.tooltip;
        if (item.label) return item.label;
        return '';
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3P0Cg.default), {
        title: item.label,
        ariaLabel: getAriaLabel(),
        icon: ButtonIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ButtonIcon, {
            label: item.label || ''
        }) : undefined,
        onClick: onClick,
        tooltipContent: item.tooltip,
        tooltipStyle: item.tooltipStyle,
        disabled: item.disabled,
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    }, item.label);
};
const $a227bbdaf854705b$export$8bacfc8aacebb3c1 = (props)=>{
    const { node: node, editorView: editorView, extensionProvider: extensionProvider, separator: separator, applyChangeToContextPanel: applyChangeToContextPanel, extensionApi: extensionApi, scrollable: scrollable, setDisableScroll: setDisableScroll, dispatchCommand: dispatchCommand, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, alignDropdownWithToolbar: alignDropdownWithToolbar, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled } = props;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const [extensions, setExtensions] = (0, $42omo.useState)([]);
    (0, $42omo.useEffect)(()=>{
        getExtensions();
        async function getExtensions() {
            const provider = await extensionProvider;
            if (provider) setExtensions(await provider.getExtensions());
        }
    // leaving dependencies array empty so that this effect runs just once on component mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const nodeAdf = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>(0, $7iE7T.nodeToJSON)(node), [
        node
    ]);
    const extensionItems = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return (0, $2cmfr.getContextualToolbarItemsFromModule)(extensions, nodeAdf, extensionApi);
    }, [
        extensions,
        nodeAdf,
        extensionApi
    ]);
    if (!extensionItems.length) return null;
    // ButtonGroup wraps each child with another layer
    // but count fragment as 1 child, so here we create the children manually.
    const children = [];
    if (separator && [
        'start',
        'both'
    ].includes(separator)) children.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $faH35.default), {
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    }));
    const isNestedTable = (0, $8EYIj.isNestedTablesSupported)(editorView.state.schema) && (0, $jSp3D.isSelectionTableNestedInTable)(editorView.state);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    extensionItems.forEach((item, index)=>{
        // disable the referentiality and charts extensions for nested tables
        if (isNestedTable && [
            'referentiality:connections',
            'chart:insert-chart'
        ].includes(item.key)) item.disabled = true;
        if ('type' in item && item.type === 'dropdown') children.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $861ad37f8a0900c3$export$2e2bcd8739ae039), {
            key: item.id,
            title: item.title,
            icon: item.icon,
            dispatchCommand: dispatchCommand || (()=>{}),
            options: item.options,
            disabled: item.disabled,
            tooltip: item.tooltip,
            hideExpandIcon: item.hideExpandIcon,
            mountPoint: popupsMountPoint,
            boundariesElement: popupsBoundariesElement,
            scrollableElement: popupsScrollableElement,
            dropdownWidth: item.dropdownWidth,
            showSelected: item.showSelected,
            buttonTestId: item.testId,
            editorView: editorView,
            setDisableParentScroll: scrollable ? setDisableScroll : undefined,
            dropdownListId: item?.id && `${item.id}-dropdownList`,
            alignDropdownWithToolbar: alignDropdownWithToolbar,
            onToggle: item.onToggle,
            footer: item.footer,
            onMount: item.onMount,
            onClick: item.onClick,
            pulse: item.pulse,
            areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
        }));
        else children.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a227bbdaf854705b$var$ExtensionButton, {
            node: node,
            item: item,
            editorView: editorView,
            applyChangeToContextPanel: applyChangeToContextPanel,
            extensionApi: extensionApi,
            areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
        }));
        if (index < extensionItems.length - 1) children.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $faH35.default), {
            areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
        }));
    });
    if (separator && [
        'end',
        'both'
    ].includes(separator)) children.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $faH35.default), {
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    }));
    // eslint-disable-next-line react/no-children-prop
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hArLp.default), {
        children: children
    });
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 






var $1DCSy = parcelRequire("1DCSy");

const $7cc83105d314583f$export$f5b8910cec6cf069 = (props)=>{
    const { defaultValue: defaultValue, onBlur: onBlur, onSubmit: onSubmit, placeholder: placeholder } = props;
    const [text, setText] = (0, $42omo.useState)(defaultValue || '');
    const handleChange = (e)=>{
        setText(e.target.value);
    };
    const handleSubmit = (e)=>{
        e.preventDefault();
        onSubmit && onSubmit(text);
    };
    const handleBlur = (e)=>{
        e.preventDefault();
        onBlur && onBlur(text);
    };
    return /*#__PURE__*/ (0, $9K4OG.jsx)("form", {
        onSubmit: handleSubmit,
        "data-vc": "W105mLSv"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("input", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $1DCSy.panelTextInput),
        value: text,
        onChange: handleChange,
        placeholder: placeholder,
        onBlur: handleBlur
    }));
};






var $fFa3V = parcelRequire("fFa3V");


var $2P8Ax = parcelRequire("2P8Ax");








var $laHi9 = parcelRequire("laHi9");


var $6R5uz = parcelRequire("6R5uz");






const $eac6816e95a745b0$var$rightSideStyles = (0, $ecnYn.xcss)({
    borderLeft: `solid ${"var(--ds-border, #0B120E24)"} 1px`,
    right: 'space.0',
    borderTopRightRadius: 'radius.small',
    borderBottomRightRadius: 'radius.small'
});
const $eac6816e95a745b0$var$leftSideStyles = (0, $ecnYn.xcss)({
    borderRight: `solid ${"var(--ds-border, #0B120E24)"} 1px`,
    left: 'space.0',
    borderTopLeftRadius: 'radius.small',
    borderBottomLeftRadius: 'radius.small'
});
const $eac6816e95a745b0$var$buttonCommonStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'elevation.surface.overlay',
    zIndex: '1',
    position: 'absolute'
});
const $eac6816e95a745b0$export$93d01adc5582c83e = ({ intl: intl, scrollContainerRef: scrollContainerRef, node: node, disabled: disabled, side: side })=>{
    const [needScroll, setNeedScroll] = (0, $42omo.useState)(false);
    const [canScrollToSide, setCanScrollToSide] = (0, $42omo.useState)(true);
    const setCanScrollDebounced = (0, $2P8Ax.default)(()=>{
        // Refs are null before mounting and after unmount
        if (!scrollContainerRef.current) return;
        const { scrollLeft: scrollLeft, scrollWidth: scrollWidth, offsetWidth: offsetWidth } = scrollContainerRef.current;
        setCanScrollToSide(// -1 to account for pixel rounding error
        side === 'left' ? scrollLeft > 0 : scrollLeft < scrollWidth - offsetWidth - 1);
    });
    const onScroll = ()=>{
        setCanScrollDebounced();
    };
    const onClick = ()=>{
        const { width: scrollContainerWidth = 0 } = scrollContainerRef.current?.getBoundingClientRect() || {};
        const scrollLeft = scrollContainerRef.current?.scrollLeft || 0;
        const scrollTo = side === 'left' ? scrollLeft - scrollContainerWidth : scrollLeft + scrollContainerWidth;
        scrollContainerRef.current?.scrollTo({
            top: 0,
            left: scrollTo,
            behavior: 'smooth'
        });
    };
    const resizeObserver = new ResizeObserver((_t)=>{
        const widthNeededToShowAllItems = scrollContainerRef.current?.scrollWidth || 0;
        const parentNode = scrollContainerRef.current?.parentNode;
        let availableSpace = -1;
        if (parentNode instanceof HTMLElement) availableSpace = parentNode.offsetWidth;
        if (availableSpace === -1) return;
        if (availableSpace >= widthNeededToShowAllItems) setNeedScroll(false);
        else {
            setNeedScroll(true);
            onScroll();
        }
    });
    (0, $42omo.useEffect)(()=>{
        onScroll();
        const scrollContainerRefCurrent = scrollContainerRef.current;
        let unbind;
        if (scrollContainerRefCurrent) {
            // Adding/removing scroll button depending on scroll position
            unbind = (0, $fFa3V.bind)(scrollContainerRefCurrent, {
                type: 'scroll',
                listener: onScroll
            });
            // watch for toolbar resize and show/hide scroll buttons if needed
            resizeObserver.observe(scrollContainerRefCurrent);
        }
        return ()=>{
            if (scrollContainerRefCurrent) {
                unbind?.();
                resizeObserver.unobserve(scrollContainerRefCurrent);
            }
            setCanScrollDebounced.cancel();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $42omo.useEffect)(()=>{
        const scrollContainerRefCurrent = scrollContainerRef.current;
        if (scrollContainerRefCurrent) // reset scroll position when switching from one node with toolbar to another
        // scroll to made optional as it may not be rendered in testing env
        scrollContainerRefCurrent.scrollTo?.({
            left: 0
        });
    }, [
        node.type,
        scrollContainerRef
    ]);
    const Icon = side === 'left' ? (0, (/*@__PURE__*/$parcel$interopDefault($laHi9))) : (0, (/*@__PURE__*/$parcel$interopDefault($6R5uz)));
    return needScroll && (side === 'left' && canScrollToSide || side === 'right' && canScrollToSide) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        padding: "space.050",
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        xcss: [
            side === 'left' ? $eac6816e95a745b0$var$leftSideStyles : $eac6816e95a745b0$var$rightSideStyles,
            $eac6816e95a745b0$var$buttonCommonStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        appearance: "subtle",
        label: intl.formatMessage(side === 'left' ? (0, $k4fPq.default).floatingToolbarScrollLeft : (0, $k4fPq.default).floatingToolbarScrollRight),
        onClick: onClick,
        isDisabled: disabled,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
                label: iconProps.label,
                size: "small"
            }),
        isTooltipDisabled: false,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        tooltip: {
            position: 'top'
        }
    }));
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 




















// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $15aecf9d817a3f98$var$toolbarScrollButtons = /*#__PURE__*/ (0, $9K4OG.css)({
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridGap: "var(--ds-space-050, 4px)",
    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-100, 8px)"}`,
    borderLeft: `solid ${"var(--ds-border, #0B120E24)"} ${"var(--ds-border-width, 1px)"}`,
    flexShrink: 0,
    alignItems: 'center'
});
const $15aecf9d817a3f98$var$LeftIcon = (0, (/*@__PURE__*/$parcel$interopDefault($laHi9)));
const $15aecf9d817a3f98$var$RightIcon = (0, (/*@__PURE__*/$parcel$interopDefault($6R5uz)));
const $15aecf9d817a3f98$export$154bc6e95efc5a0d = ({ intl: intl, scrollContainerRef: scrollContainerRef, node: node, disabled: disabled, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled })=>{
    const buttonsContainerRef = (0, $42omo.useRef)(null);
    const [needScroll, setNeedScroll] = (0, $42omo.useState)(false);
    const [canScrollLeft, setCanScrollLeft] = (0, $42omo.useState)(true);
    const [canScrollRight, setCanScrollRight] = (0, $42omo.useState)(true);
    const setCanScrollDebounced = (0, $2P8Ax.default)(()=>{
        // Refs are null before mounting and after unmount
        if (!scrollContainerRef.current) return;
        const { scrollLeft: scrollLeft, scrollWidth: scrollWidth, offsetWidth: offsetWidth } = scrollContainerRef.current;
        setCanScrollLeft(scrollLeft > 0);
        setCanScrollRight(scrollLeft + offsetWidth < scrollWidth - 1); // -1 to account for half pixel
    });
    const onScroll = ()=>setCanScrollDebounced();
    const scrollLeft = ()=>{
        const { width: scrollContainerWidth = 0 } = scrollContainerRef.current?.getBoundingClientRect() || {};
        const scrollLeft = scrollContainerRef.current?.scrollLeft || 0;
        // scroll to current position - scroll container width
        const scrollTo = scrollLeft - scrollContainerWidth;
        scrollContainerRef.current?.scrollTo({
            top: 0,
            left: scrollTo,
            behavior: 'smooth'
        });
    };
    const scrollRight = ()=>{
        const { width: scrollContainerWidth = 0 } = scrollContainerRef.current?.getBoundingClientRect() || {};
        const scrollLeft = scrollContainerRef.current?.scrollLeft || 0;
        // scroll to current position + scroll container width
        const scrollTo = scrollLeft + scrollContainerWidth;
        scrollContainerRef.current?.scrollTo({
            top: 0,
            left: scrollTo,
            behavior: 'smooth'
        });
    };
    const resizeObserver = new ResizeObserver((t)=>{
        const widthNeededToShowAllItems = scrollContainerRef.current?.scrollWidth || 0;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        const availableSpace = scrollContainerRef.current?.parentNode?.offsetWidth;
        if (availableSpace >= widthNeededToShowAllItems) setNeedScroll(false);
        else {
            setNeedScroll(true);
            onScroll();
        }
    });
    (0, $42omo.useEffect)(()=>{
        onScroll();
        const scrollContainerRefCurrent = scrollContainerRef.current;
        if (scrollContainerRefCurrent) {
            // enable/disable scroll buttons depending on scroll position
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            scrollContainerRefCurrent.addEventListener('scroll', onScroll);
            // watch for toolbar resize and show/hide scroll buttons if needed
            resizeObserver.observe(scrollContainerRefCurrent);
        }
        return ()=>{
            if (scrollContainerRefCurrent) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                scrollContainerRefCurrent.removeEventListener('scroll', onScroll);
                resizeObserver.unobserve(scrollContainerRefCurrent);
            }
            setCanScrollDebounced.cancel();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $42omo.useEffect)(()=>{
        const scrollContainerRefCurrent = scrollContainerRef.current;
        if (scrollContainerRefCurrent) // reset scroll position when switching from one node with toolbar to another
        // scroll to made optional as it may not be rendered in testing env
        scrollContainerRefCurrent.scrollTo?.({
            left: 0
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        node.type
    ]);
    return needScroll ? /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        ref: buttonsContainerRef,
        css: $15aecf9d817a3f98$var$toolbarScrollButtons,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "scroll-buttons",
        "data-vc": "2c7vw7-T"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3P0Cg.default), {
        title: intl.formatMessage((0, $k4fPq.default).floatingToolbarScrollLeft),
        icon: /*#__PURE__*/ (0, $9K4OG.jsx)($15aecf9d817a3f98$var$LeftIcon, {
            label: intl.formatMessage((0, $k4fPq.default).floatingToolbarScrollLeft),
            size: "small"
        }),
        onClick: scrollLeft,
        disabled: !canScrollLeft || disabled,
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    }), /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3P0Cg.default), {
        title: intl.formatMessage((0, $k4fPq.default).floatingToolbarScrollRight),
        icon: /*#__PURE__*/ (0, $9K4OG.jsx)($15aecf9d817a3f98$var$RightIcon, {
            label: intl.formatMessage((0, $k4fPq.default).floatingToolbarScrollRight),
            size: "small"
        }),
        onClick: scrollRight,
        disabled: !canScrollRight || disabled,
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    })) : null;
};






var $6T8v4 = parcelRequire("6T8v4");

function $2029e03d391ceae6$export$2e2bcd8739ae039(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const selectRef = (0, $42omo.useRef)(null);
    const { width: width = 200 } = props;
    const style = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>({
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            container: (base)=>({
                    ...base,
                    width: width
                }),
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            menuPortal: (base)=>{
                // ED:16095: We add two possible getter paths for safely reaching into the underlying
                // react-select element. We first try a getter that conforms with react-select v5 APIs,
                // Failing that, we try a getter consistent with react-select v4 APIs. (We
                // handle both as consumers may control the time of the actual dependency version
                // cutover).
                const controlWrapper = selectRef?.current?.select?.controlRef?.parentNode || selectRef?.current?.select?.select?.controlRef?.parentNode;
                const menuPortalStyles = controlWrapper && props.setDisableParentScroll ? {
                    // since the portal is now outside, we need to position it as before
                    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                    top: controlWrapper.offsetTop,
                    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                    left: controlWrapper.offsetLeft,
                    height: controlWrapper.offsetHeight,
                    width: width
                } : {};
                return {
                    ...base,
                    ...menuPortalStyles
                };
            }
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        width
    ]);
    const onMenuOpen = ()=>{
        if (props.setDisableParentScroll) props.setDisableParentScroll(true);
    };
    const onMenuClose = ()=>{
        if (props.setDisableParentScroll) props.setDisableParentScroll(false);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6T8v4.default), {
        ref: selectRef,
        options: props.options,
        value: props.defaultValue,
        onChange: props.onChange,
        placeholder: props.placeholder,
        spacing: "compact",
        menuPlacement: "auto",
        filterOption: props.filterOption,
        styles: style,
        menuPortalTarget: props.mountPoint,
        onMenuOpen: onMenuOpen,
        onMenuClose: onMenuClose,
        label: props.ariaLabel,
        classNamePrefix: props.classNamePrefix
    });
}


function $913d5151b8b04b1e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
function $913d5151b8b04b1e$export$7abc8284d66f79b1(items, areAnyNewToolbarFlagsEnabled) {
    const groupItems = items.reduce((accumulator, item, i)=>{
        const { finalOutput: finalOutput, buttonGroup: buttonGroup } = accumulator;
        if (item.type === 'button') {
            const notLastItem = i < items.length - 1;
            const nextItemIsButton = items[i + 1] && items[i + 1].type === 'button';
            const wasPreviousButton = items[i - 1] && items[i - 1].type === 'button';
            const shouldBeRadioButton = notLastItem && nextItemIsButton || wasPreviousButton;
            // Only group as radio button if not explicitly set to false
            const isRadioButton = !(0, $1oCLl.expValEquals)('platform_editor_august_a11y', 'isEnabled', true) ? shouldBeRadioButton : shouldBeRadioButton && item.isRadioButton !== false;
            if (isRadioButton) {
                item.isRadioButton = true;
                buttonGroup.push(item);
                if (!nextItemIsButton && wasPreviousButton) {
                    finalOutput.push(buttonGroup);
                    accumulator.buttonGroup = [];
                }
            } else finalOutput.push(item);
        } else if (item.type === 'separator' && areAnyNewToolbarFlagsEnabled) {
            const isLeadingSeparator = i === 0;
            const isTrailingSeparator = i === items.length - 1;
            const isDuplicateSeparator = items[i - 1]?.type === 'separator';
            !isLeadingSeparator && !isTrailingSeparator && !isDuplicateSeparator && finalOutput.push(item);
        } else finalOutput.push(item);
        return accumulator;
    }, {
        buttonGroup: [],
        finalOutput: []
    });
    return groupItems.finalOutput;
}
const $913d5151b8b04b1e$var$ToolbarItems = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ items: items, groupLabel: groupLabel, dispatchCommand: dispatchCommand, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, editorView: editorView, dispatchAnalyticsEvent: dispatchAnalyticsEvent, popupsScrollableElement: popupsScrollableElement, scrollable: scrollable, providerFactory: providerFactory, extensionsProvider: extensionsProvider, node: node, setDisableScroll: setDisableScroll, mountRef: mountRef, api: api, intl: intl })=>{
    const emojiAndColourPickerMountPoint = scrollable ? popupsMountPoint || editorView?.dom.closest('.fabric-editor-popup-scroll-parent') || editorView?.dom.closest('.ak-editor-content-area') || undefined : popupsMountPoint;
    const areAnyNewToolbarFlagsEnabled = (0, $iHzeA.areToolbarFlagsEnabled)(Boolean(api?.toolbar));
    const renderItem = (item, idx)=>{
        switch(item.type){
            case 'button':
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const ButtonIcon = item.icon;
                const onClickHandler = ()=>{
                    if (item.confirmDialog) dispatchCommand((0, $fcd54976fe532dea$export$c0076bd4afc29e7a)(idx));
                    else {
                        dispatchCommand(item.onClick);
                        if (item.focusEditoronEnter && !editorView?.hasFocus()) editorView?.focus();
                    }
                };
                const getIconColor = (disabled, selected)=>{
                    if (disabled) return "var(--ds-icon-disabled, #080F214A)";
                    if (selected) return "var(--ds-icon-selected, #1868DB)";
                    return 'currentColor';
                };
                return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3P0Cg.default), {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides -- Ignored via go/DSP-18766
                    className: item.className,
                    key: idx,
                    title: item.title,
                    href: item.href,
                    icon: item.icon ? /*#__PURE__*/ (0, $9K4OG.jsx)(ButtonIcon, {
                        color: getIconColor(item.disabled, item.selected),
                        spacing: "spacious",
                        label: undefined,
                        "aria-hidden": true
                    }) : undefined,
                    iconAfter: item.iconAfter ? /*#__PURE__*/ (0, $9K4OG.jsx)(item.iconAfter, {
                        label: ""
                    }) : undefined,
                    appearance: item.appearance,
                    target: item.target,
                    onClick: onClickHandler,
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    onMouseEnter: ()=>dispatchCommand(item.onMouseEnter),
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    onMouseLeave: ()=>dispatchCommand(item.onMouseLeave),
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    onFocus: ()=>dispatchCommand(item.onFocus),
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    onBlur: ()=>dispatchCommand(item.onBlur),
                    onMount: item.onMount,
                    onUnmount: item.onUnmount,
                    selected: item.selected,
                    disabled: item.disabled,
                    tooltipContent: item.tooltipContent,
                    testId: item.testId,
                    hideTooltipOnClick: item.hideTooltipOnClick,
                    ariaHasPopup: item.ariaHasPopup,
                    tabIndex: item.tabIndex,
                    isRadioButton: item.isRadioButton,
                    ariaLabel: item?.ariaLabel,
                    pulse: item.pulse,
                    interactionName: item.interactionName,
                    areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
                }, item.showTitle && item.title);
            case 'input':
                return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $7cc83105d314583f$export$f5b8910cec6cf069), {
                    key: idx,
                    mountPoint: popupsMountPoint,
                    boundariesElement: popupsBoundariesElement,
                    defaultValue: item.defaultValue,
                    placeholder: item.placeholder,
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    onSubmit: (value)=>dispatchCommand(item.onSubmit(value)),
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    onBlur: (value)=>dispatchCommand(item.onBlur(value))
                });
            case 'custom':
                return item.render(editorView, idx, dispatchAnalyticsEvent, {
                    popupsBoundariesElement: popupsBoundariesElement,
                    popupsMountPoint: popupsMountPoint,
                    popupsScrollableElement: popupsScrollableElement,
                    scrollable: scrollable,
                    setDisableParentScroll: scrollable ? setDisableScroll : undefined
                });
            case 'overflow-dropdown':
                // if an option has a confirmDialog, we need to replace its onClick handler
                // to set the state to show the confirm dialog
                // crudely done here to avoid greater coupling with DropdownMenuItem from `floating-toolbar`
                // which would need knowledge of indexes, showConfirmDialog etc.
                const options = item.options.map((option, optionIndex)=>{
                    if (!('type' in option) && option.confirmDialog) {
                        const onClick = option.confirmDialog ? (0, $fcd54976fe532dea$export$c0076bd4afc29e7a)(idx, optionIndex) : option.onClick;
                        return {
                            ...option,
                            onClick: onClick
                        };
                    }
                    return option;
                });
                return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $861ad37f8a0900c3$export$2e2bcd8739ae039), {
                    alignX: areAnyNewToolbarFlagsEnabled ? 'right' : undefined,
                    key: idx,
                    title: intl.formatMessage((0, $61p3e.default).viewMore),
                    icon: /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
                        label: "",
                        spacing: "spacious"
                    }),
                    dispatchCommand: dispatchCommand,
                    options: options,
                    disabled: item.disabled,
                    tooltip: item.tooltip,
                    hideExpandIcon: true,
                    mountPoint: popupsMountPoint,
                    boundariesElement: popupsBoundariesElement,
                    scrollableElement: popupsScrollableElement,
                    dropdownWidth: item.dropdownWidth,
                    showSelected: item.showSelected,
                    buttonTestId: item.testId,
                    editorView: editorView,
                    setDisableParentScroll: scrollable ? setDisableScroll : undefined,
                    dropdownListId: item?.id && `${item.id}-dropdownList`,
                    alignDropdownWithToolbar: items.length === 1,
                    onClick: item.onClick,
                    areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
                });
            case 'dropdown':
                const DropdownIcon = item.icon;
                const BeforeIcon = item.iconBefore;
                return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $861ad37f8a0900c3$export$2e2bcd8739ae039), {
                    key: idx,
                    title: item.title,
                    icon: DropdownIcon && /*#__PURE__*/ (0, $9K4OG.jsx)(DropdownIcon, {
                        label: item.title
                    }),
                    iconBefore: BeforeIcon && /*#__PURE__*/ (0, $9K4OG.jsx)(BeforeIcon, {
                        label: ""
                    }),
                    dispatchCommand: dispatchCommand,
                    options: item.options,
                    disabled: item.disabled,
                    tooltip: item.tooltip,
                    hideExpandIcon: item.hideExpandIcon,
                    mountPoint: popupsMountPoint,
                    boundariesElement: popupsBoundariesElement,
                    scrollableElement: popupsScrollableElement,
                    dropdownWidth: item.dropdownWidth,
                    showSelected: item.showSelected,
                    buttonTestId: item.testId,
                    editorView: editorView,
                    setDisableParentScroll: scrollable ? setDisableScroll : undefined,
                    dropdownListId: item?.id && `${item.id}-dropdownList`,
                    alignDropdownWithToolbar: items.length === 1,
                    onToggle: item.onToggle,
                    footer: item.footer,
                    onMount: item.onMount,
                    onClick: item.onClick,
                    pulse: item.pulse,
                    shouldFitContainer: item.shouldFitContainer,
                    areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
                });
            case 'select':
                if (item.selectType === 'list') {
                    const ariaLabel = item.title || item.placeholder;
                    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $2029e03d391ceae6$export$2e2bcd8739ae039), {
                        key: idx,
                        dispatchCommand: dispatchCommand,
                        options: item.options,
                        hideExpandIcon: item.hideExpandIcon,
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        mountPoint: scrollable ? mountRef.current : undefined,
                        boundariesElement: popupsBoundariesElement,
                        scrollableElement: popupsScrollableElement,
                        defaultValue: item.defaultValue,
                        placeholder: item.placeholder,
                        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                        onChange: (selected)=>dispatchCommand(item.onChange(selected)),
                        ariaLabel: ariaLabel,
                        filterOption: item.filterOption,
                        setDisableParentScroll: scrollable ? setDisableScroll : undefined,
                        classNamePrefix: 'floating-toolbar-select'
                    });
                }
                if (item.selectType === 'color') return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $lAt6Q.default), {
                    skipFocusButtonAfterPick: true,
                    key: idx,
                    isAriaExpanded: item.isAriaExpanded,
                    title: item.title,
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    onChange: (selected)=>{
                        dispatchCommand(item.onChange(selected));
                    },
                    colorPalette: item.options,
                    currentColor: item.defaultValue ? item.defaultValue.value : undefined,
                    placement: "Panels",
                    mountPoint: emojiAndColourPickerMountPoint,
                    setDisableParentScroll: scrollable ? setDisableScroll : undefined,
                    // Currently in floating toolbar, color picker is only
                    //  used in panel and table cell background color.
                    // Both uses same color palette.
                    // That's why hard-coding hexToEditorBackgroundPaletteColor
                    //  and paletteColorTooltipMessages.
                    // When we need to support different color palette
                    //  in floating toolbar, we need to set hexToPaletteColor
                    //  and paletteColorTooltipMessages in item options.
                    hexToPaletteColor: (0, $6icEc.hexToEditorBackgroundPaletteColor),
                    paletteColorTooltipMessages: (0, $8LFdJ.backgroundPaletteTooltipMessages),
                    returnEscToButton: item.returnEscToButton
                });
                if (item.selectType === 'emoji') return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6cc4590ebdb944ca$export$428fcc6fc228bd52), {
                    key: idx,
                    editorView: editorView,
                    title: item.title,
                    providerFactory: providerFactory,
                    isSelected: item.selected,
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    onChange: (selected)=>dispatchCommand(item.onChange(selected)),
                    mountPoint: emojiAndColourPickerMountPoint,
                    popupsBoundariesElement: popupsBoundariesElement,
                    setDisableParentScroll: scrollable ? setDisableScroll : undefined,
                    pluginInjectionApi: api
                });
                return null;
            case 'extensions-placeholder':
                if (!editorView || !extensionsProvider) return null;
                return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $a227bbdaf854705b$export$8bacfc8aacebb3c1), {
                    key: idx,
                    node: node,
                    editorView: editorView,
                    extensionProvider: extensionsProvider,
                    separator: item.separator,
                    applyChangeToContextPanel: api?.contextPanel?.actions.applyChange,
                    extensionApi: api?.extension?.actions.api(),
                    dispatchCommand: dispatchCommand,
                    popupsMountPoint: popupsMountPoint,
                    popupsBoundariesElement: popupsBoundariesElement,
                    popupsScrollableElement: popupsScrollableElement,
                    alignDropdownWithToolbar: items.length === 1,
                    scrollable: scrollable,
                    areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
                });
            case 'separator':
                if (areAnyNewToolbarFlagsEnabled) return item.fullHeight ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, $faH35.default), {
                    key: idx,
                    fullHeight: true,
                    areAnyNewToolbarFlagsEnabled: true
                }) : null;
                return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $faH35.default), {
                    key: idx,
                    fullHeight: item.fullHeight,
                    areAnyNewToolbarFlagsEnabled: false
                });
        }
    };
    const groupedItems = $913d5151b8b04b1e$export$7abc8284d66f79b1(// eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
    items.filter((item)=>!item.hidden), areAnyNewToolbarFlagsEnabled);
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $hArLp.default), {
        testId: "editor-floating-toolbar-items"
    }, groupedItems.map((element, index)=>{
        const isGroup = Array.isArray(element);
        if (isGroup) return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            // Ignored via go/ees005
            // eslint-disable-next-line react/no-array-index-key
            key: index,
            css: areAnyNewToolbarFlagsEnabled ? $913d5151b8b04b1e$var$buttonGroupStylesNew : $913d5151b8b04b1e$var$buttonGroupStyles,
            role: "radiogroup",
            "aria-label": groupLabel ?? undefined,
            "data-testid": "editor-floating-toolbar-grouped-buttons"
        }, element.map((element)=>{
            const indexInAllItems = items.findIndex((item)=>item === element);
            return renderItem(element, indexInAllItems);
        }));
        else {
            const indexInAllItems = items.findIndex((item)=>item === element);
            return renderItem(element, indexInAllItems);
        }
    }));
}, (prevProps, nextProps)=>{
    if (!nextProps.node) return false;
    // only rerender toolbar items if the node is different
    // otherwise it causes an issue where multiple popups stays open
    return !(prevProps.node.type !== nextProps.node.type || prevProps.node.attrs.localId !== nextProps.node.attrs.localId || prevProps.popupsBoundariesElement !== nextProps.popupsBoundariesElement || prevProps.popupsMountPoint !== nextProps.popupsMountPoint || prevProps.popupsScrollableElement !== nextProps.popupsScrollableElement || prevProps.scrollable !== nextProps.scrollable || prevProps.setDisableScroll !== nextProps.setDisableScroll || !(0, $a7c1514010b8535c$export$1d04baad505b720e)(prevProps.items, nextProps.items) || !prevProps.mounted !== !nextProps.mounted);
});
const $913d5151b8b04b1e$var$buttonGroupStyles = {
    name: "h1up05",
    styles: "display:flex;gap:var(--ds-space-050, 4px)"
};
const $913d5151b8b04b1e$var$buttonGroupStylesNew = {
    name: "gcdzb",
    styles: "display:flex;gap:var(--ds-space-075, 6px)"
};
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var $913d5151b8b04b1e$var$_ref6 = {
    name: "q568uz",
    styles: "min-height:var(--ds-space-500, 40px)"
};
var $913d5151b8b04b1e$var$_ref7 = {
    name: "oxur4o",
    styles: "padding-left:var(--ds-space-050, 4px)"
};
var $913d5151b8b04b1e$var$_ref8 = {
    name: "oxur4o",
    styles: "padding-left:var(--ds-space-050, 4px)"
};
var $913d5151b8b04b1e$var$_ref9 = {
    name: "s0vnfv",
    styles: "height:32px"
};
var $913d5151b8b04b1e$var$_ref0 = {
    name: "1k18kha",
    styles: "height:40px"
};
const $913d5151b8b04b1e$var$toolbarContainer = (areAnyNewToolbarFlagsEnabled, scrollable, hasSelect, firstElementIsSelect)=>/*#__PURE__*/ (0, $9K4OG.css)("background-color:var(--ds-surface-overlay, #FFFFFF);border-radius:var(--ds-radius-small, 3px);box-shadow:var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f);display:flex;line-height:1;box-sizing:border-box;& > div > div{align-items:center;}", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    scrollable ? /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    (0, $9K4OG.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    hasSelect ? $913d5151b8b04b1e$var$_ref0 : $913d5151b8b04b1e$var$_ref9, "overflow:hidden;") : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    areAnyNewToolbarFlagsEnabled ? /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    (0, $9K4OG.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        padding: `${"var(--ds-space-0, 0px)"} 4px ${"var(--ds-space-0, 0px)"} 4px`
    }, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    firstElementIsSelect && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    $913d5151b8b04b1e$var$_ref8) : /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    (0, $9K4OG.css)({
        padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-100, 8px)"}`
    }, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    firstElementIsSelect && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    $913d5151b8b04b1e$var$_ref7), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    areAnyNewToolbarFlagsEnabled ? $913d5151b8b04b1e$var$_ref6 : undefined);
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var $913d5151b8b04b1e$var$_ref = {
    name: "zjik7",
    styles: "display:flex"
};
var $913d5151b8b04b1e$var$_ref2 = {
    name: "9kivhj",
    styles: "margin-left:var(--ds-space-100, 8px)"
};
var $913d5151b8b04b1e$var$_ref3 = {
    name: "8gsxsd",
    styles: "margin-left:var(--ds-space-050, 4px)"
};
var $913d5151b8b04b1e$var$_ref4 = {
    name: "upho8i",
    styles: "overflow-x:auto;overflow-y:hidden;scrollbar-width:none"
};
var $913d5151b8b04b1e$var$_ref5 = {
    name: "d3v9zr",
    styles: "overflow:hidden"
};
const $913d5151b8b04b1e$var$toolbarOverflow = ({ scrollable: scrollable, scrollDisabled: scrollDisabled, firstElementIsSelect: firstElementIsSelect, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled })=>/*#__PURE__*/ (0, $9K4OG.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    scrollable ? /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    (0, $9K4OG.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    scrollDisabled ? $913d5151b8b04b1e$var$_ref5 : $913d5151b8b04b1e$var$_ref4, {
        WebkitOverflowScrolling: 'touch',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        padding: `${"var(--ds-space-050, 4px)"} 0 ${"var(--ds-space-050, 4px)"}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> div': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            '> div:first-child': firstElementIsSelect ? $913d5151b8b04b1e$var$_ref3 : $913d5151b8b04b1e$var$_ref2,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '> div:last-child': {
                marginRight: "var(--ds-space-100, 8px)"
            }
        }
    }, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    areAnyNewToolbarFlagsEnabled ? /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    (0, $9K4OG.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        padding: `${"var(--ds-space-0, 0px)"} 4px ${"var(--ds-space-600, 48px)"} 4px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '> div': {
            minHeight: "var(--ds-space-500, 40px)",
            gap: "var(--ds-space-075, 6px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '> div:first-child': {
                marginLeft: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '> div:last-child': {
                marginRight: 0
            }
        }
    }) : undefined) : $913d5151b8b04b1e$var$_ref);
// eslint-disable-next-line @repo/internal/react/no-class-components
class $913d5151b8b04b1e$var$Toolbar extends (0, $42omo.Component) {
    // remove any decorations added by toolbar buttons i.e danger and selected styling
    // this prevents https://product-fabric.atlassian.net/browse/ED-10207
    resetStyling() {
        if (this.props.editorView) {
            const { state: state, dispatch: dispatch } = this.props.editorView;
            this.props.api?.decorations?.actions.removeDecoration(state, dispatch);
        }
    }
    componentDidMount() {
        this.setState({
            mounted: true
        });
    }
    componentDidUpdate(prevProps) {
        (0, $2bbb1f5d06db1dd0$export$a2ced8424a9be595)(this.props?.editorView);
        if (this.props.node !== prevProps.node) this.resetStyling();
    }
    componentWillUnmount() {
        const { editorView: editorView } = this.props;
        if (editorView) {
            const { state: { tr: tr }, dispatch: dispatch } = editorView;
            dispatch((0, $2bbb1f5d06db1dd0$export$1470545de94762f5)(null)(tr));
        }
        this.resetStyling();
    }
    render() {
        const { items: items, className: className, node: node, intl: intl, scrollable: scrollable, mediaAssistiveMessage: mediaAssistiveMessage } = this.props;
        const areAnyNewToolbarFlagsEnabled = (0, $iHzeA.areToolbarFlagsEnabled)(Boolean(this.props.api?.toolbar));
        if (!items || !items.length) return null;
        // Select has left padding of 4px to the border, everything else 8px
        const firstElementIsSelect = items[0].type === 'select';
        const hasSelect = items.find((item)=>item.type === 'select' && item.selectType === 'list');
        const shouldRenderAssistiveAnnouncer = (0, $1oCLl.expValEquals)('editor_a11y_role_textbox', 'isEnabled', true) ? this.doesNodeRequireAssitiveMessage(node) : true;
        return /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $5Gwdo.ToolbarArrowKeyNavigationProvider), {
            editorView: this.props.editorView,
            handleEscape: this.handleEscape,
            disableArrowKeyNavigation: !this.shouldHandleArrowKeys(),
            childComponentSelector: "[data-testid='editor-floating-toolbar']",
            isShortcutToFocusToolbar: this.isShortcutToFocusToolbar,
            intl: intl
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            ref: this.toolbarContainerRef,
            css: ()=>[
                    $913d5151b8b04b1e$var$toolbarContainer(areAnyNewToolbarFlagsEnabled, scrollable, hasSelect !== undefined, firstElementIsSelect)
                ],
            "aria-label": intl.formatMessage((0, $k4fPq.default).floatingToolbarAriaLabel),
            role: "toolbar",
            "data-testid": "editor-floating-toolbar",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            onMouseDown: areAnyNewToolbarFlagsEnabled ? this.captureMouseEvent : undefined
        }, shouldRenderAssistiveAnnouncer && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $cftLn.default), {
            text: mediaAssistiveMessage ? `${mediaAssistiveMessage}, ${intl.formatMessage((0, $k4fPq.default).floatingToolbarAnnouncer)}` : intl.formatMessage((0, $k4fPq.default).floatingToolbarAnnouncer),
            delay: 250
        }), scrollable && areAnyNewToolbarFlagsEnabled && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $eac6816e95a745b0$export$93d01adc5582c83e), {
            intl: intl,
            scrollContainerRef: this.scrollContainerRef,
            node: node,
            disabled: this.state.scrollDisabled,
            side: "left"
        }), /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            "data-testid": "floating-toolbar-items",
            ref: this.scrollContainerRef,
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            css: $913d5151b8b04b1e$var$toolbarOverflow({
                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled,
                scrollable: scrollable,
                scrollDisabled: this.state.scrollDisabled,
                firstElementIsSelect: firstElementIsSelect
            })
        }, /*#__PURE__*/ (0, $9K4OG.jsx)($913d5151b8b04b1e$var$ToolbarItems, {
            ...this.props,
            setDisableScroll: this.setDisableScroll,
            mountRef: this.mountRef,
            mounted: this.state.mounted
        })), scrollable && (areAnyNewToolbarFlagsEnabled ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, $eac6816e95a745b0$export$93d01adc5582c83e), {
            intl: intl,
            scrollContainerRef: this.scrollContainerRef,
            node: node,
            disabled: this.state.scrollDisabled,
            side: "right"
        }) : /*#__PURE__*/ (0, $9K4OG.jsx)((0, $15aecf9d817a3f98$export$154bc6e95efc5a0d), {
            intl: intl,
            scrollContainerRef: this.scrollContainerRef,
            node: node,
            disabled: this.state.scrollDisabled,
            areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
        }))), /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            ref: this.mountRef,
            "data-vc": "yl9KjPED"
        })));
    }
    constructor(props){
        super(props);
        this.scrollContainerRef = void 0;
        this.mountRef = void 0;
        this.toolbarContainerRef = void 0;
        this.setDisableScroll = (disabled)=>{
            // wait before setting disabled state incase users jumping from one popup to another
            if (disabled) requestAnimationFrame(()=>{
                this.setState({
                    scrollDisabled: disabled
                });
            });
            else this.setState({
                scrollDisabled: disabled
            });
        };
        this.shouldHandleArrowKeys = ()=>{
            //To prevent the keydown handling of arrow keys for custom toolbar items with 'disableArrowNavigation' prop enabled,
            //Usually the button which has menus or popups
            return !this.props.items?.find((item)=>item.type === 'custom' && item.disableArrowNavigation);
        };
        this.handleEscape = (event)=>{
            // If any menu is open inside the floating toolbar 'Esc' key should not
            // focus the editorview.
            // Event can't be stopped as they are not childnodes of floating toolbar
            // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
            const isDropdownOpen = !!document.querySelector('[data-role="droplistContent"]');
            // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
            const isSelectMenuOpen = !!document.querySelector('.floating-toolbar-select__menu');
            if (isDropdownOpen || isSelectMenuOpen) return;
            this.props.editorView?.focus();
            event.preventDefault();
            event.stopPropagation();
        };
        this.captureMouseEvent = (event)=>{
            // Don't capture mouse event for custom toolbars e.g. insert hyperlink
            if (this.props.items?.length === 1 && this.props.items[0].type === 'custom') return;
            // Prevents toolbar from closing when clicking on the toolbar itself and not on the buttons
            event.stopPropagation();
            event.preventDefault();
        };
        this.isShortcutToFocusToolbar = (event)=>{
            //Alt + F10 to reach first element in this floating toolbar
            return event.altKey && (event.key === 'F10' || event.keyCode === 121);
        };
        this.doesNodeRequireAssitiveMessage = (node)=>{
            // Code blocks have an assistive message to announce the content of the code block to screen readers, so we don't need to announce the floating toolbar for those nodes
            const nodesWithAlternativeRoles = [
                'codeBlock'
            ];
            if (nodesWithAlternativeRoles.includes(node.type.name)) return false;
            return true;
        };
        this.scrollContainerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
        this.mountRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
        this.toolbarContainerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
        this.state = {
            scrollDisabled: false,
            mounted: false
        };
    }
}
// eslint-disable-next-line @typescript-eslint/ban-types
const $913d5151b8b04b1e$var$_default_1 = (0, $aXWIB.injectIntl)($913d5151b8b04b1e$var$Toolbar);
var $913d5151b8b04b1e$export$2e2bcd8739ae039 = $913d5151b8b04b1e$var$_default_1;


const $b46300531fc1dc0e$export$2f5751d7b477f660 = (overflowDropdowns)=>{
    if (overflowDropdowns.length <= 1) return overflowDropdowns[0];
    const combinedItems = overflowDropdowns.reduce((acc, item)=>{
        if (item.options) acc.push(...item.options);
        return acc;
    }, []);
    // To filter out items that have a rank property, sort them by rank in descending order (highest rank first)
    const rankedItems = combinedItems.filter((item)=>'rank' in item && typeof item.rank === 'number').sort((a, b)=>(b.rank || 0) - (a.rank || 0));
    const unrankedItems = combinedItems.filter((item)=>!('rank' in item && typeof item.rank === 'number'));
    const sortedItems = [
        ...rankedItems,
        ...unrankedItems
    ];
    const largestDropdownWidth = overflowDropdowns.reduce((acc, item)=>{
        if (item.dropdownWidth && item.dropdownWidth > acc) return item.dropdownWidth;
        return acc;
    }, 0);
    return {
        type: 'overflow-dropdown',
        dropdownWidth: largestDropdownWidth,
        options: sortedItems
    };
};


const $f50c723278285e6d$var$SUPPRESS_TOOLBAR_USER_INTENTS = [
    'dragging',
    'tableContextualMenuPopupOpen',
    'tableDragMenuPopupOpen',
    'commenting',
    'resizing',
    'blockMenuOpen',
    'statusPickerOpen',
    // Suppress when a modal/overlay is open over the editor (e.g. the Jira remix ephemeral preview),
    // so the floating toolbar does not bleed through on top of the overlay.
    'overlayOpen'
];
const $f50c723278285e6d$export$c5f0b4d19f5b8d4b = (selection, configs)=>{
    // node selections always take precedence, see if
    let configPair;
    configs.find((config)=>{
        const node = (0, $8m4tT.findSelectedNodeOfType)(config.nodeType)(selection);
        if (node) configPair = {
            node: node.node,
            pos: node.pos,
            config: config
        };
        return !!node;
    });
    if (configPair) return configPair;
    // create mapping of node type name to configs
    const configByNodeType = {};
    configs.forEach((config)=>{
        if (Array.isArray(config.nodeType)) config.nodeType.forEach((nodeType)=>{
            configByNodeType[nodeType.name] = config;
        });
        else configByNodeType[config.nodeType.name] = config;
    });
    // search up the tree from selection
    const { $from: $from } = selection;
    for(let i = $from.depth; i > 0; i--){
        const node = $from.node(i);
        const matchedConfig = configByNodeType[node.type.name];
        if (matchedConfig) return {
            config: matchedConfig,
            node: node,
            pos: $from.pos
        };
    }
    // if it is AllSelection (can be result of Cmd+A) - use first node
    if (selection instanceof (0, $ks2lK.AllSelection)) {
        const docNode = $from.node(0);
        let matchedConfig = null;
        const firstChild = (0, $6ac0eea64e149e3b$export$5b92d7a8b5d33ee2)(docNode, (node)=>{
            matchedConfig = configByNodeType[node.type.name];
            return !!matchedConfig;
        });
        if (firstChild && matchedConfig) return {
            config: matchedConfig,
            node: firstChild,
            pos: $from.pos
        };
    }
    return;
};
const $f50c723278285e6d$var$getDomRefFromSelection = (view, dispatchAnalyticsEvent)=>{
    try {
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        return (0, $8m4tT.findDomRefAtPos)(view.state.selection.from, view.domAtPos.bind(view));
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn(error);
        if (dispatchAnalyticsEvent) {
            const payload = {
                action: (0, $d925B.ACTION).ERRORED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).CONTENT_COMPONENT,
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    component: (0, $d925B.CONTENT_COMPONENT).FLOATING_TOOLBAR,
                    selection: view.state.selection.toJSON(),
                    position: view.state.selection.from,
                    docSize: view.state.doc.nodeSize,
                    error: error.toString(),
                    // @ts-expect-error - Object literal may only specify known properties, 'errorStack' does not exist in type
                    // This error was introduced after upgrading to TypeScript 5
                    errorStack: error.stack || undefined
                }
            };
            dispatchAnalyticsEvent(payload);
        }
    }
};
function $f50c723278285e6d$var$filterUndefined(x) {
    return !!x;
}
const $f50c723278285e6d$export$baed971c987bc0e = ({ api: api })=>{
    return {
        name: 'floatingToolbar',
        pmPlugins (floatingToolbarHandlers = []) {
            const plugins = [
                {
                    // Should be after all toolbar plugins
                    name: 'floatingToolbar',
                    plugin: ({ providerFactory: providerFactory, getIntl: getIntl })=>$f50c723278285e6d$export$5c1ec0ef773ca0cc({
                            api: api,
                            floatingToolbarHandlers: floatingToolbarHandlers,
                            providerFactory: providerFactory,
                            getIntl: getIntl
                        })
                },
                {
                    name: 'floatingToolbarData',
                    plugin: ({ dispatch: dispatch })=>(0, $5b9b106e178d33bc$export$ae829ec7b2625219)(dispatch)
                },
                {
                    name: 'forceFocus',
                    plugin: ()=>(0, $2bbb1f5d06db1dd0$export$2e2bcd8739ae039)()
                }
            ];
            return plugins;
        },
        actions: {
            forceFocusSelector: $2bbb1f5d06db1dd0$export$1470545de94762f5
        },
        commands: {
            copyNode: (nodeType, inputMethod)=>(0, $2f991cc39c54e634$export$978ef9948557240e)(nodeType, api?.analytics?.actions, inputMethod)
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const interactionState = api?.interaction?.sharedState.currentState()?.interactionState;
            const configWithNodeInfo = interactionState !== 'hasNotHadInteraction' ? $f50c723278285e6d$export$18d4026d1ea86bb1.getState(editorState)?.getConfigWithNodeInfo?.(editorState) ?? undefined : undefined;
            return {
                configWithNodeInfo: configWithNodeInfo,
                floatingToolbarData: (0, $05bdec134809a907$export$18d4026d1ea86bb1).getState(editorState)
            };
        },
        contentComponent ({ popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, editorView: editorView, providerFactory: providerFactory, dispatchAnalyticsEvent: dispatchAnalyticsEvent }) {
            if (!editorView) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f50c723278285e6d$export$2dda1e4a1d1f6a81, {
                editorView: editorView,
                pluginInjectionApi: api,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement,
                providerFactory: providerFactory,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent
            });
        }
    };
};
function $f50c723278285e6d$export$2dda1e4a1d1f6a81({ pluginInjectionApi: pluginInjectionApi, editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, providerFactory: providerFactory, dispatchAnalyticsEvent: dispatchAnalyticsEvent }) {
    const { floatingToolbarState: floatingToolbarState, editorDisabledState: editorDisabledState, editorViewModeState: editorViewModeState, userIntentState: userIntentState } = (0, $1Oo9w.useSharedPluginState)(pluginInjectionApi, [
        'floatingToolbar',
        'editorDisabled',
        'editorViewMode',
        'userIntent'
    ]);
    const { configWithNodeInfo: configWithNodeInfoFromHook, floatingToolbarData: floatingToolbarData } = floatingToolbarState ?? {};
    let configWithNodeInfo = configWithNodeInfoFromHook;
    if ((0, $dh538.fg)('platform_editor_ai_remix_toolbar')) // Read configWithNodeInfo live because the hook snapshot can lag behind the
    // current editor selection and keep the floating toolbar rendered stale.
    // for example, trigger remix on panel will not hide the floating toolbar
    configWithNodeInfo = pluginInjectionApi?.floatingToolbar?.sharedState.currentState()?.configWithNodeInfo;
    if ((0, $eTj7Y.isSSR)()) return null;
    if (!configWithNodeInfo || !configWithNodeInfo.config || typeof configWithNodeInfo.config?.visible !== 'undefined' && !configWithNodeInfo.config?.visible) return null;
    if (userIntentState?.currentUserIntent && $f50c723278285e6d$var$SUPPRESS_TOOLBAR_USER_INTENTS.includes(userIntentState?.currentUserIntent)) return null;
    const { config: config, node: node } = configWithNodeInfo;
    // When the new inline editor-toolbar is enabled, suppress floating toolbar for text selections.
    if (Boolean(pluginInjectionApi?.toolbar)) {
        const selection = editorView.state.selection;
        const isCellSelection = '$anchorCell' in selection && !selection.empty;
        const isTextSelected = selection instanceof (0, $ks2lK.TextSelection) && !selection.empty;
        // don't dismiss table toolbar when a cell selection is caused by clicking the drag handle (which has it's own userIntent)
        if (isTextSelected && config.className !== 'hyperlink-floating-toolbar' || isCellSelection && userIntentState?.currentUserIntent === 'default') return null;
    }
    let { items: items } = config;
    const { groupLabel: groupLabel } = config;
    const { title: title, getDomRef: getDomRef = $f50c723278285e6d$var$getDomRefFromSelection, align: align = 'center', className: className = '', height: height, width: width, zIndex: zIndex, offset: offset = [
        0,
        12
    ], forcePlacement: forcePlacement, preventPopupOverflow: preventPopupOverflow, onPositionCalculated: onPositionCalculated, absoluteOffset: absoluteOffset = {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0
    }, focusTrap: focusTrap, mediaAssistiveMessage: mediaAssistiveMessage = '', stick: stick = true } = config;
    const targetRef = getDomRef(editorView, dispatchAnalyticsEvent);
    const isEditorDisabled = editorDisabledState && editorDisabledState.editorDisabled;
    const isInViewMode = editorViewModeState?.mode === 'view';
    if (!targetRef || isEditorDisabled && !isInViewMode) return null;
    // TODO: MODES-3950 - Update this view mode specific logic once we refactor view mode.
    //       We should inverse the responsibility here: A blacklist for toolbar items in view mode, rather than this white list.
    //       Also consider moving this logic to the more specific toolbar plugins (media and selection).
    const iterableItems = Array.isArray(items) ? items : items?.(node);
    if (isInViewMode) {
        // Typescript note: Not all toolbar item types have the `supportsViewMode` prop.
        const toolbarItemViewModeProp = 'supportsViewMode';
        // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
        items = iterableItems.filter((item)=>toolbarItemViewModeProp in item && !!item[toolbarItemViewModeProp]);
    }
    if ((0, $iHzeA.areToolbarFlagsEnabled)(Boolean(pluginInjectionApi?.toolbar))) {
        // Consolidate floating toolbar items
        const toolbarItemsArray = Array.isArray(items) ? items : items?.(node);
        // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
        const overflowDropdownItems = toolbarItemsArray.filter((item)=>item.type === 'overflow-dropdown');
        if (overflowDropdownItems.length > 1) {
            const consolidatedOverflowDropdown = (0, $b46300531fc1dc0e$export$2f5751d7b477f660)(overflowDropdownItems);
            // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
            const otherItems = toolbarItemsArray.filter((item)=>item.type !== 'overflow-dropdown');
            if (otherItems.length > 0) // remove the last separators
            while(otherItems.at(-1)?.type === 'separator')otherItems.pop();
            items = [
                ...otherItems,
                {
                    type: 'separator',
                    fullHeight: true,
                    supportsViewMode: true
                },
                consolidatedOverflowDropdown
            ];
        }
        // Apply analytics to dropdown
        if (overflowDropdownItems.length > 0 && dispatchAnalyticsEvent) {
            const currentItems = Array.isArray(items) ? items : items?.(node);
            const updatedItems = currentItems.map((item)=>{
                if (item.type !== 'overflow-dropdown') return item;
                const originalOnClick = item.onClick;
                return {
                    ...item,
                    onClick: ()=>{
                        const editorContentMode = pluginInjectionApi?.editorViewMode?.sharedState.currentState()?.mode;
                        dispatchAnalyticsEvent({
                            action: (0, $d925B.ACTION).CLICKED,
                            actionSubject: (0, $d925B.ACTION_SUBJECT).BUTTON,
                            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).FLOATING_TOOLBAR_OVERFLOW,
                            eventType: (0, $d925B.EVENT_TYPE).UI,
                            attributes: {
                                editorContentMode: editorContentMode
                            }
                        });
                        // Call original onClick if it exists
                        originalOnClick?.();
                    }
                };
            });
            items = updatedItems;
        }
    }
    let customPositionCalculation;
    const toolbarItems = pluginInjectionApi?.copyButton?.actions.processCopyButtonItems(editorView.state)(Array.isArray(items) ? items : items(node), pluginInjectionApi?.decorations?.actions.hoverDecoration);
    if (onPositionCalculated) customPositionCalculation = (nextPos)=>{
        return onPositionCalculated(editorView, nextPos);
    };
    const dispatchCommand = (fn)=>fn && fn(editorView.state, editorView.dispatch, editorView);
    // Confirm dialog
    let confirmButtonItem;
    const { confirmDialogForItem: confirmDialogForItem, confirmDialogForItemOption: confirmDialogForItemOption } = floatingToolbarData || {};
    const matchingItem = confirmDialogForItem ? toolbarItems?.[confirmDialogForItem] : undefined;
    if (matchingItem?.type === 'button') confirmButtonItem = matchingItem;
    if (matchingItem?.type === 'overflow-dropdown' && confirmDialogForItemOption !== undefined) {
        const matchingItemOption = matchingItem.options[confirmDialogForItemOption];
        // OverflowDropdownOption is the only member of the union that does not have a 'type' property
        if (!('type' in matchingItemOption)) confirmButtonItem = matchingItemOption;
    }
    const scrollable = config.scrollable;
    const confirmDialogOptions = typeof confirmButtonItem?.confirmDialog === 'function' ? confirmButtonItem?.confirmDialog() : confirmButtonItem?.confirmDialog;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7fmpI.ErrorBoundary), {
        component: (0, $d925B.ACTION_SUBJECT).FLOATING_TOOLBAR_PLUGIN,
        componentId: (0, (/*@__PURE__*/$parcel$interopDefault($5nZsM)))(title),
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        fallbackComponent: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jwWgu.default), {
        ariaLabel: title,
        role: 'toolbar',
        offset: offset,
        target: targetRef,
        alignY: "bottom",
        forcePlacement: forcePlacement,
        fitHeight: height,
        fitWidth: width,
        absoluteOffset: absoluteOffset,
        alignX: align,
        stick: stick,
        zIndex: zIndex,
        mountTo: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        onPositionCalculated: customPositionCalculation,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: scrollable ? {
            maxWidth: '100%'
        } : {},
        focusTrap: focusTrap,
        preventOverflow: preventPopupOverflow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dYBVS.WithProviders), {
        providerFactory: providerFactory,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        providers: [
            'extensionProvider'
        ],
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        renderNode: (providers)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $913d5151b8b04b1e$export$2e2bcd8739ae039), {
                target: targetRef,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                items: toolbarItems,
                groupLabel: groupLabel,
                node: node,
                dispatchCommand: dispatchCommand,
                editorView: editorView,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: className,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                focusEditor: ()=>editorView.focus(),
                providerFactory: providerFactory,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                extensionsProvider: providers.extensionProvider,
                scrollable: scrollable,
                api: pluginInjectionApi,
                mediaAssistiveMessage: mediaAssistiveMessage
            });
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $df15872dca729d4f$export$1f33f980da756c46), {
        testId: "ak-floating-toolbar-confirmation-modal",
        options: confirmDialogOptions,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onConfirm: (isChecked = false)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            if (!!confirmDialogOptions.onConfirm) // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            dispatchCommand(confirmDialogOptions.onConfirm(isChecked));
            else // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            dispatchCommand(confirmButtonItem.onClick);
        },
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onClose: ()=>{
            dispatchCommand((0, $fcd54976fe532dea$export$5a3c1357cfd1045c)());
            // Need to set focus to Editor here,
            // As when the Confirmation dialog pop up, and user interacts with the dialog, Editor loses focus.
            // So when Confirmation dialog is closed, Editor does not have the focus, then cursor goes to the position 1 of the doc,
            // instead of the cursor position before the dialog pop up.
            if (!editorView.hasFocus()) editorView.focus();
        }
    }));
}
const $f50c723278285e6d$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('floatingToolbarPluginKey');
/**
 * Clean up floating toolbar configs from undesired properties.
 */ function $f50c723278285e6d$var$sanitizeFloatingToolbarConfig(config) {
    // Cleanup from non existing node types
    if (Array.isArray(config.nodeType)) return {
        ...config,
        nodeType: config.nodeType.filter($f50c723278285e6d$var$filterUndefined)
    };
    return config;
}
function $f50c723278285e6d$export$5c1ec0ef773ca0cc(options) {
    const { floatingToolbarHandlers: floatingToolbarHandlers, providerFactory: providerFactory, getIntl: getIntl, api: api } = options;
    const intl = getIntl();
    const getConfigWithNodeInfo = (editorState)=>{
        let activeConfigs = [];
        for(let index = 0; index < floatingToolbarHandlers.length; index++){
            const handler = floatingToolbarHandlers[index];
            const config = handler(editorState, intl, providerFactory, activeConfigs);
            if (config) {
                if ($f50c723278285e6d$var$SUPPRESS_TOOLBAR_USER_INTENTS.includes(api?.userIntent?.sharedState.currentState()?.currentUserIntent || '')) {
                    activeConfigs = undefined;
                    break;
                }
                activeConfigs.push($f50c723278285e6d$var$sanitizeFloatingToolbarConfig(config));
            }
        }
        const relevantConfig = activeConfigs && $f50c723278285e6d$export$c5f0b4d19f5b8d4b(editorState.selection, activeConfigs);
        return relevantConfig;
    };
    const getIsToolbarSuppressed = ()=>{
        return false;
    };
    const apply = ()=>{
        const newPluginState = {
            getConfigWithNodeInfo: getConfigWithNodeInfo
        };
        return newPluginState;
    };
    return new (0, $1S4f7.SafePlugin)({
        key: $f50c723278285e6d$export$18d4026d1ea86bb1,
        state: {
            init: ()=>{
                return {
                    getConfigWithNodeInfo: getConfigWithNodeInfo
                };
            },
            apply: (0, $1oCLl.expValEquals)('platform_editor_lovability_suppress_toolbar_event', 'isEnabled', true) ? (_tr, _pluginState, __oldEditorState)=>{
                const suppressedToolbar = getIsToolbarSuppressed();
                const newPluginState = {
                    getConfigWithNodeInfo: getConfigWithNodeInfo,
                    suppressedToolbar: suppressedToolbar
                };
                return newPluginState;
            } : apply
        },
        view: (0, $1oCLl.expValEquals)('platform_editor_lovability_suppress_toolbar_event', 'isEnabled', true) ? ()=>{
            return {
                update: (view, prevState)=>{
                    const pluginState = $f50c723278285e6d$export$18d4026d1ea86bb1.getState(view.state);
                    const prevPluginState = $f50c723278285e6d$export$18d4026d1ea86bb1.getState(prevState);
                    if (pluginState?.suppressedToolbar && !prevPluginState?.suppressedToolbar) api?.analytics?.actions?.fireAnalyticsEvent({
                        action: (0, $d925B.ACTION).SUPPRESSED,
                        actionSubject: (0, $d925B.ACTION_SUBJECT).FLOATING_TOOLBAR_PLUGIN,
                        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).FLOATING_TOOLBAR,
                        eventType: (0, $d925B.EVENT_TYPE).TRACK
                    });
                }
            };
        } : undefined
    });
}
module.exports["floatingToolbarPlugin"] = $f50c723278285e6d$export$baed971c987bc0e;

});

parcelRegister("k4fPq", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $9cd835599ac82068$var$message = (0, $aXWIB.defineMessages)({
    confirmModalDefaultHeading: {
        id: "fabric.editor.floatingToolbar.confirmModalHeading",
        defaultMessage: "Are you sure?"
    },
    confirmModalOK: {
        id: "fabric.editor.floatingToolbar.confirmModalOK",
        defaultMessage: "OK"
    },
    confirmModalCancel: {
        id: "fabric.editor.floatingToolbar.confirmModalCancel",
        defaultMessage: "Cancel"
    },
    confirmModalListUnit: {
        id: "fabric.editor.floatingToolbar.confirmModalConnectedUnit",
        defaultMessage: "{name}{amount, plural, =0 {} one { (+1 connected element)} other { (+# connected elements)}}"
    },
    confirmDeleteLinkedModalMessage: {
        id: "fabric.editor.extension.confirmDeleteLinkedModalMessage",
        defaultMessage: "Deleting {nodeName} will break anything connected to it."
    },
    floatingToolbarAriaLabel: {
        id: "fabric.editor.floatingToolbar.floatingToolbarAriaLabel",
        defaultMessage: "Floating Toolbar"
    },
    floatingToolbarAnnouncer: {
        id: "fabric.editor.floatingToolbar.floatingToolbarAnnouncer",
        defaultMessage: "Floating toolbar controls have been opened"
    },
    floatingToolbarScrollLeft: {
        id: "fabric.editor.floatingToolbar.scrollLeft",
        defaultMessage: "Scroll left"
    },
    floatingToolbarScrollRight: {
        id: "fabric.editor.floatingToolbar.scrollRight",
        defaultMessage: "Scroll right"
    }
});
var $9cd835599ac82068$export$2e2bcd8739ae039 = $9cd835599ac82068$var$message;
module.exports["default"] = $9cd835599ac82068$export$2e2bcd8739ae039;

});

parcelRegister("aaI8u", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4wH3g = parcelRequire("4wH3g");


var $2cmfr = parcelRequire("2cmfr");


var $7iE7T = parcelRequire("7iE7T");


var $1QXSD = parcelRequire("1QXSD");


var $4BNmH = parcelRequire("4BNmH");

const $f02b9f89b6a430f6$var$noop = ()=>null;
const $f02b9f89b6a430f6$var$isDefaultExport = (mod)=>{
    return mod.hasOwnProperty('default');
};
const $f02b9f89b6a430f6$var$resolveExtensionIcon = async (getIcon)=>{
    if (!getIcon) return $f02b9f89b6a430f6$var$noop;
    const maybeIcon = await getIcon();
    return $f02b9f89b6a430f6$var$isDefaultExport(maybeIcon) ? maybeIcon.default : maybeIcon;
};
const $f02b9f89b6a430f6$var$convertExtensionToDropdownMenuItem = ({ item: item, disabled: disabled, node: node, extension: extension, IconComponent: IconComponent })=>{
    let title = '';
    if (item.label) title = item.label;
    else if (typeof item.tooltip === 'string') title = item.tooltip;
    else if (item.ariaLabel) title = item.ariaLabel;
    item.disabled = disabled?.(item.key) || false;
    const getIcon = ()=>{
        const label = item.label || '';
        return IconComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(IconComponent, {
            label: label
        }) : undefined;
    };
    return {
        title: title,
        icon: getIcon(),
        disabled: item.disabled,
        onClick: ()=>{
            if (typeof item.action !== 'function') throw new Error(`'action' of context toolbar item '${item.key}' is not a function`);
            const targetNodeAdf = (0, $7iE7T.nodeToJSON)(node);
            extension.extensionApi && item.action(targetNodeAdf, extension.extensionApi);
            return true;
        }
    };
};
const $f02b9f89b6a430f6$var$DropdownMenuExtensionItem = ({ item: item, editorView: editorView, disabled: disabled, node: node, extension: extension, dropdownOptions: dropdownOptions })=>{
    // Use ref to keep icon component stable across renders
    const iconRef = (0, $42omo.useRef)(null);
    if (!iconRef.current && item.icon) iconRef.current = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
        __loadable_id__: "fR-gN",
        name: "platform.packages.editor.editor-common.src.floating-toolbar.DropdownMenuExtensionItems",
        loader: ()=>$f02b9f89b6a430f6$var$resolveExtensionIcon(item.icon),
        loading: $f02b9f89b6a430f6$var$noop
    });
    const dropdownItem = $f02b9f89b6a430f6$var$convertExtensionToDropdownMenuItem({
        item: item,
        disabled: disabled,
        node: node,
        extension: extension,
        IconComponent: iconRef.current
    });
    if (!dropdownItem) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1QXSD.DropdownMenuItem), {
        key: item.key,
        item: dropdownItem,
        editorView: editorView,
        hide: dropdownOptions.hide,
        dispatchCommand: dropdownOptions.dispatchCommand,
        showSelected: dropdownOptions.showSelected,
        intl: dropdownOptions.intl
    });
};
const $f02b9f89b6a430f6$export$24b801b186044441 = (props)=>{
    const { node: node, editorView: editorView, extension: extension, disabled: disabled, dropdownOptions: dropdownOptions, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled } = props;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const [extensions, setExtensions] = (0, $42omo.useState)([]);
    (0, $42omo.useEffect)(()=>{
        getExtensions();
        async function getExtensions() {
            const provider = await extension.extensionProvider;
            if (provider) setExtensions(await provider.getExtensions());
        }
    }, [
        extension.extensionProvider
    ]);
    const nodeAdf = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>(0, $7iE7T.nodeToJSON)(node), [
        node
    ]);
    const extensionItems = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        if (!extension.extensionApi) return [];
        return (0, $2cmfr.getContextualToolbarItemsFromModule)(extensions, nodeAdf, extension.extensionApi);
    }, [
        extensions,
        nodeAdf,
        extension.extensionApi
    ]);
    if (!extensionItems.length || !dropdownOptions) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, extensionItems.map((item, _idx)=>{
        if (!('key' in item)) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f02b9f89b6a430f6$var$DropdownMenuExtensionItem, {
            key: item.key,
            item: item,
            editorView: editorView,
            disabled: disabled,
            node: node,
            extension: extension,
            dropdownOptions: dropdownOptions
        });
    }), areAnyNewToolbarFlagsEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4BNmH.DropdownSeparator), null));
};
module.exports["DropdownMenuExtensionItems"] = $f02b9f89b6a430f6$export$24b801b186044441;

});

parcelRegister("3P0Cg", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4KS7f = parcelRequire("4KS7f");


var $9JpPs = parcelRequire("9JpPs");


var $1oCLl = parcelRequire("1oCLl");


var $iu6m9 = parcelRequire("iu6m9");


var $3gadb = parcelRequire("3gadb");





var $1lhEF = parcelRequire("1lhEF");

function $47c5872541e5161f$export$927d63e2511364c0({ pulse: pulse, radius: radius = 3, children: children }) {
    if (pulse) return(// SpotlightPulse shows pulse effect if `pulse` is `undefined`.
    // That's why we need to cast `pulse` to `false` if it's `undefined`.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1lhEF.Pulse), {
        radius: radius,
        pulse: pulse ?? false
    }, children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
}


const $64e8307e1e8e4beb$export$7d8cec9727d4e603 = {
    '&&': {
        padding: '0px'
    },
    '& > span': {
        margin: '0px'
    }
};


const $047184325f5a1d90$var$getStyles = (property, { appearance: appearance = 'default', state: state = 'default', mode: mode = 'light' })=>{
    if (!property[appearance] || !property[appearance][state]) return 'initial';
    return property[appearance][state][mode];
};
const $047184325f5a1d90$var$backgroundVisualRefresh = {
    danger: {
        default: {
            light: 'inherit',
            dark: 'inherit'
        },
        hover: {
            light: "var(--ds-background-danger-hovered, #FFD5D2)",
            dark: "var(--ds-background-danger-hovered, #FFD5D2)"
        },
        active: {
            light: "var(--ds-background-danger-pressed, #FFB8B2)",
            dark: "var(--ds-background-danger-pressed, #FFB8B2)"
        }
    }
};
const $047184325f5a1d90$var$colorVisualRefresh = {
    danger: {
        default: {
            light: "var(--ds-icon-subtle, #505258)",
            dark: "var(--ds-icon-subtle, #505258)"
        },
        hover: {
            light: "var(--ds-icon-danger, #C9372C)",
            dark: "var(--ds-icon-danger, #C9372C)"
        },
        active: {
            light: "var(--ds-icon-danger, #C9372C)",
            dark: "var(--ds-icon-danger, #C9372C)"
        }
    }
};
const $047184325f5a1d90$export$f98ea88a275be66c = (props)=>({
        background: $047184325f5a1d90$var$getStyles($047184325f5a1d90$var$backgroundVisualRefresh, props),
        color: $047184325f5a1d90$var$getStyles($047184325f5a1d90$var$colorVisualRefresh, props)
    }); // eslint-disable-next-line @atlaskit/editor/no-re-export


const $3d0f783a8260f48b$var$customSizeAndPadding = {
    minWidth: "var(--ds-space-400, 32px)",
    padding: `0px ${"var(--ds-space-050, 4px)"}`
};
const $3d0f783a8260f48b$var$FloatingToolbarButton = ({ title: title, icon: icon, iconAfter: iconAfter, onClick: onClick, onKeyDown: onKeyDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onFocus: onFocus, onBlur: onBlur, onMount: onMount, onUnmount: onUnmount, selected: selected, disabled: disabled, href: href, target: target, appearance: appearance = 'subtle', children: children, className: className, tooltipContent: tooltipContent, tooltipStyle: tooltipStyle, testId: testId, interactionName: interactionName, hideTooltipOnClick: hideTooltipOnClick = true, ariaHasPopup: ariaHasPopup, tabIndex: tabIndex, areaControls: areaControls, ariaLabel: ariaLabel, isRadioButton: isRadioButton, pulse: pulse, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled }, forwardedRef)=>{
    // Check if there's only an icon and add additional styles
    const iconOnly = (icon || iconAfter) && !children;
    const customSpacing = iconOnly ? (0, $64e8307e1e8e4beb$export$7d8cec9727d4e603) : {};
    const isButtonPressed = ariaHasPopup ? undefined : selected;
    /**
   * If it's a radio button, we need to reflect false values too, hence
   * we cast it as a Boolean
   */ const ariaChecked = isRadioButton ? Boolean(isButtonPressed) : undefined;
    const ariaPressed = isRadioButton ? undefined : isButtonPressed;
    (0, $42omo.useEffect)(()=>{
        onMount?.();
        return ()=>onUnmount?.();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleOnClick = (0, $42omo.useCallback)((event)=>{
        onClick?.(event);
    }, [
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        // Only fallback to title for tooltip if title is not shown
        content: tooltipContent || (iconOnly ? title : undefined),
        component: tooltipStyle,
        hideTooltipOnClick: hideTooltipOnClick,
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        onMouseEnter: (0, $1oCLl.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? undefined : onMouseEnter,
        onMouseLeave: (0, $1oCLl.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? undefined : onMouseLeave,
        "data-vc": "tZdhXZq3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $47c5872541e5161f$export$927d63e2511364c0), {
        pulse: !(0, $1oCLl.expValEquals)('platform_editor_spotlight_migration', 'isEnabled', true) && pulse
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KS7f.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides -- Ignored via go/DSP-18766
        className: className,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        ref: (buttonElement)=>{
            if (forwardedRef && (0, $iu6m9.editorExperiment)('platform_synced_block', true)) {
                if (typeof forwardedRef === 'function') forwardedRef(buttonElement);
                else if (typeof forwardedRef === 'object') forwardedRef.current = buttonElement;
            }
        },
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        theme: (adgTheme, themeProps)=>{
            const { buttonStyles: buttonStyles, ...rest } = adgTheme(themeProps);
            return {
                buttonStyles: {
                    ...buttonStyles,
                    ...customSpacing,
                    ...appearance === 'danger' && (0, $047184325f5a1d90$export$f98ea88a275be66c)({
                        appearance: appearance,
                        state: themeProps.state,
                        mode: themeProps.mode
                    }),
                    ...areAnyNewToolbarFlagsEnabled ? $3d0f783a8260f48b$var$customSizeAndPadding : {}
                },
                ...rest
            };
        },
        "aria-label": ariaLabel || title,
        "aria-pressed": ariaPressed,
        "aria-checked": ariaChecked,
        role: isRadioButton ? 'radio' : undefined,
        "aria-expanded": ariaHasPopup ? selected : undefined,
        "aria-controls": ariaHasPopup ? areaControls : undefined,
        spacing: areAnyNewToolbarFlagsEnabled ? 'default' : 'compact',
        href: href,
        target: target,
        appearance: appearance,
        "aria-haspopup": ariaHasPopup,
        iconBefore: icon || undefined,
        iconAfter: iconAfter,
        onClick: handleOnClick,
        onKeyDown: onKeyDown,
        isSelected: selected,
        isDisabled: disabled,
        testId: testId,
        interactionName: interactionName,
        onMouseEnter: (0, $1oCLl.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? onMouseEnter : undefined,
        onMouseLeave: (0, $1oCLl.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? onMouseLeave : undefined,
        onFocus: onFocus,
        onBlur: onBlur,
        // @ts-ignore
        // tabIndex set as 0 by default in the design system  ButtonBase component
        // this is not expected for all buttons, we have to use tabIndex={null} for some cases
        // should be fixed here https://a11y-internal.atlassian.net/browse/DST-287
        tabIndex: tabIndex
    }, children)))));
};
// eslint-disable-next-line @typescript-eslint/ban-types
const $3d0f783a8260f48b$var$_default_1 = (0, $9JpPs.componentWithCondition)(()=>(0, $iu6m9.editorExperiment)('platform_synced_block', true), /*#__PURE__*/ (0, $42omo.forwardRef)($3d0f783a8260f48b$var$FloatingToolbarButton), $3d0f783a8260f48b$var$FloatingToolbarButton);
var $3d0f783a8260f48b$export$2e2bcd8739ae039 = $3d0f783a8260f48b$var$_default_1;
module.exports["default"] = $3d0f783a8260f48b$export$2e2bcd8739ae039;

});

parcelRegister("faH35", function(module, exports) {
$parcel$export(module.exports, "default", () => $32bcc88a95097d8e$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports -- Ignored via go/DSP-18766; jsx required at runtime for @jsxRuntime classic

var $9K4OG = parcelRequire("9K4OG");

function $32bcc88a95097d8e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $32bcc88a95097d8e$var$separator = /*#__PURE__*/ (0, $9K4OG.css)({
    background: "var(--ds-border, #0B120E24)",
    width: '1px',
    height: '20px',
    margin: `0 ${"var(--ds-space-050, 4px)"}`,
    alignSelf: 'center'
});
const $32bcc88a95097d8e$var$separatorNew = {
    name: "pange0",
    styles: "background:var(--ds-border, #0B120E24);width:1px;height:20px;align-self:center"
};
const $32bcc88a95097d8e$var$separatorFullHeight = {
    name: "1k18kha",
    styles: "height:40px"
};
var $32bcc88a95097d8e$export$2e2bcd8739ae039 = ({ fullHeight: fullHeight, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled })=>/*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: [
            areAnyNewToolbarFlagsEnabled ? $32bcc88a95097d8e$var$separatorNew : $32bcc88a95097d8e$var$separator,
            fullHeight && $32bcc88a95097d8e$var$separatorFullHeight
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "separator",
        "data-vc": "BZ7nO-OC"
    });

});

parcelRegister("8LFdJ", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");


var $glYgz = parcelRequire("glYgz");


var $3Cheb = parcelRequire("3Cheb");


var $ktVJr = parcelRequire("ktVJr");

const $5a949e7e68309254$var$darkModeTextPaletteOverrides = (0, $aXWIB.defineMessages)({
    '#FFFFFF': {
        id: "fabric.theme.dark-gray",
        defaultMessage: "Dark gray"
    }
});
const $5a949e7e68309254$export$cca9f3b863b77c82 = {
    ...(0, $ktVJr.lightTextPaletteTooltipMessages),
    ...$5a949e7e68309254$var$darkModeTextPaletteOverrides
};
const $5a949e7e68309254$export$d8fe76863446580e = {
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    light: (0, $ktVJr.lightTextPaletteTooltipMessages),
    dark: $5a949e7e68309254$export$cca9f3b863b77c82
};
const $5a949e7e68309254$var$darkModeBackgroundPaletteOverrides = (0, $aXWIB.defineMessages)({
    '#FFFFFF': {
        id: "fabric.theme.subtle-gray",
        defaultMessage: "Subtle gray"
    },
    '#B3BAC5': {
        id: "fabric.theme.bold-gray",
        defaultMessage: "Bold gray"
    }
});
const $5a949e7e68309254$export$d1327856929fda16 = {
    ...(0, $glYgz.lightBackgroundPaletteTooltipMessages),
    ...$5a949e7e68309254$var$darkModeBackgroundPaletteOverrides
};
const $5a949e7e68309254$export$c671ecebb9c48677 = {
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    light: (0, $glYgz.lightBackgroundPaletteTooltipMessages),
    dark: $5a949e7e68309254$export$d1327856929fda16
};
const $5a949e7e68309254$var$darkChartsColorPaletteTooltipMessages = {
    ...(0, $3Cheb.lightChartsColorPaletteTooltipMessages)
};
const $5a949e7e68309254$export$f8b88c9f6c817aff = {
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    light: (0, $3Cheb.lightChartsColorPaletteTooltipMessages),
    dark: $5a949e7e68309254$var$darkChartsColorPaletteTooltipMessages
};
const $5a949e7e68309254$var$lightBorderPaletteTooltipMessages = (0, $aXWIB.defineMessages)({
    '#091E4224': {
        id: "fabric.theme.subtle-gray",
        defaultMessage: "Subtle gray"
    },
    '#758195': {
        id: "fabric.theme.gray",
        defaultMessage: "Gray"
    },
    '#172B4D': {
        id: "fabric.theme.bold-gray",
        defaultMessage: "Bold gray"
    }
});
const $5a949e7e68309254$var$darkBorderPaletteTooltipMessages = {
    ...$5a949e7e68309254$var$lightBorderPaletteTooltipMessages
};
const $5a949e7e68309254$export$515e8edd15e08de7 = {
    light: $5a949e7e68309254$var$lightBorderPaletteTooltipMessages,
    dark: $5a949e7e68309254$var$darkBorderPaletteTooltipMessages
};
module.exports["textPaletteTooltipMessages"] = $5a949e7e68309254$export$d8fe76863446580e;
module.exports["backgroundPaletteTooltipMessages"] = $5a949e7e68309254$export$c671ecebb9c48677;
module.exports["chartsColorPaletteTooltipMessages"] = $5a949e7e68309254$export$f8b88c9f6c817aff;
module.exports["borderPaletteTooltipMessages"] = $5a949e7e68309254$export$515e8edd15e08de7;

});

parcelRegister("lAt6Q", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $aXWIB = parcelRequire("aXWIB");


var $ggbZE = parcelRequire("ggbZE");


var $1DWH0 = parcelRequire("1DWH0");


var $ccHMk = parcelRequire("ccHMk");


var $ghftu = parcelRequire("ghftu");


var $dh538 = parcelRequire("dh538");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $ecnYn = parcelRequire("ecnYn");


var $1oCLl = parcelRequire("1oCLl");


var $iu6m9 = parcelRequire("iu6m9");


var $3gadb = parcelRequire("3gadb");


var $d925B = parcelRequire("d925B");

var $3BfTH = parcelRequire("3BfTH");


var $b2CWF = parcelRequire("b2CWF");


var $hxEux = parcelRequire("hxEux");

var $lhtyR = parcelRequire("lhtyR");

var $ahQKW = parcelRequire("ahQKW");


var $efG2U = parcelRequire("efG2U");


var $jwWgu = parcelRequire("jwWgu");


var $9Z3I5 = parcelRequire("9Z3I5");


var $5v8Ta = parcelRequire("5v8Ta");

function $3f0a914cf2d5c40f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// helps adjusts position of popup
const $3f0a914cf2d5c40f$var$colorPickerButtonWrapper = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $3f0a914cf2d5c40f$var$colorPickerExpandContainerVisualRefresh = (0, $ecnYn.xcss)({
    marginTop: 'space.negative.025',
    marginRight: 'space.negative.050'
});
const $3f0a914cf2d5c40f$var$colorPickerButtonStyle = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    button: {
        '&::after': {
            border: 'none'
        },
        '&:hover': {
            backgroundColor: `${"var(--ds-background-selected, #E9F2FE)"}`
        }
    }
});
// Control the size of color picker buttons and preview
// TODO: DSP-4134 - Color picking UI
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $3f0a914cf2d5c40f$var$colorPickerWrapper = ()=>/*#__PURE__*/ (0, $9K4OG.css)({
        borderRadius: "var(--ds-radius-small, 3px)",
        backgroundColor: "var(--ds-surface-overlay, #FFFFFF)",
        boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)",
        padding: `${"var(--ds-space-100, 8px)"} 0px`
    });
const $3f0a914cf2d5c40f$var$ColorPaletteWithReactViewListeners = (0, $efG2U.default)((0, $hxEux.default));
const $3f0a914cf2d5c40f$var$COLOR_PICKER_POPUP_OFFSET = [
    0,
    10
];
const $3f0a914cf2d5c40f$var$ColorPickerButton = (props)=>{
    const buttonRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(null);
    const [isPopupOpen, setIsPopupOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(false);
    const [isPopupPositioned, setIsPopupPositioned] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(false);
    const [isOpenedByKeyboard, setIsOpenedByKeyboard] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(false);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const memoizedHandleClose = (0, $42omo.useCallback)(()=>setIsPopupOpen(false), [
        setIsPopupOpen
    ]);
    const handleClose = (0, $1oCLl.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? memoizedHandleClose : ()=>setIsPopupOpen(false);
    const memoizedTogglePopup = (0, $42omo.useCallback)(()=>{
        setIsPopupOpen((prevIsOpen)=>{
            if (!prevIsOpen) {
                setIsOpenedByKeyboard(false);
                setIsPopupPositioned(false);
            }
            return !prevIsOpen;
        });
    }, []);
    const togglePopup = (0, $1oCLl.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? memoizedTogglePopup : ()=>{
        setIsPopupOpen(!isPopupOpen);
        if (!isPopupOpen) {
            setIsOpenedByKeyboard(false);
            setIsPopupPositioned(false);
        }
    };
    const memoizedOnKeyDown = (0, $42omo.useCallback)((event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            memoizedTogglePopup();
            setIsOpenedByKeyboard(true);
        }
    }, [
        memoizedTogglePopup
    ]);
    const onKeyDown = (0, $1oCLl.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? memoizedOnKeyDown : (event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            togglePopup();
            setIsOpenedByKeyboard(true);
        }
    };
    const memoizedPaletteOptions = (0, $42omo.useMemo)(()=>({
            palette: props.colorPalette,
            hexToPaletteColor: props.hexToPaletteColor,
            paletteColorTooltipMessages: props.paletteColorTooltipMessages
        }), [
        props.colorPalette,
        props.hexToPaletteColor,
        props.paletteColorTooltipMessages
    ]);
    const paletteOptions = (0, $1oCLl.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? memoizedPaletteOptions : {
        palette: props.colorPalette,
        hexToPaletteColor: props.hexToPaletteColor,
        paletteColorTooltipMessages: props.paletteColorTooltipMessages
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        if (props.setDisableParentScroll) props.setDisableParentScroll(isPopupOpen);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isPopupOpen
    ]);
    const focusButton = ()=>{
        buttonRef.current?.focus();
    };
    const handleEsc = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback(()=>{
        setIsOpenedByKeyboard(false);
        setIsPopupPositioned(false);
        setIsPopupOpen(false);
        focusButton();
    }, []);
    const onPositionCalculated = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((position)=>{
        setIsPopupPositioned(true);
        return position;
    }, []);
    const { onChange: onChange, createAnalyticsEvent: createAnalyticsEvent, colorPalette: colorPalette, placement: placement, skipFocusButtonAfterPick: skipFocusButtonAfterPick } = props;
    const onColorSelected = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((color, label)=>{
        setIsOpenedByKeyboard(false);
        setIsPopupOpen(false);
        setIsPopupPositioned(false);
        if (onChange) {
            if (createAnalyticsEvent) {
                // fire analytics
                const payload = {
                    action: (0, $d925B.ACTION).UPDATED,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).PICKER,
                    actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).PICKER_COLOR,
                    attributes: {
                        color: color,
                        label: label,
                        placement: placement
                    },
                    eventType: (0, $d925B.EVENT_TYPE).TRACK
                };
                createAnalyticsEvent(payload).fire((0, $3BfTH.editorAnalyticsChannel));
            }
            const newPalette = colorPalette.find((colorPalette)=>colorPalette.value === color);
            newPalette && onChange(newPalette);
        }
        if (!skipFocusButtonAfterPick) focusButton();
    }, [
        colorPalette,
        onChange,
        createAnalyticsEvent,
        placement,
        skipFocusButtonAfterPick
    ]);
    const renderPopup = ()=>{
        if (!isPopupOpen || !buttonRef.current) return;
        const selectedColor = props.currentColor || null;
        const { selectedRowIndex: selectedRowIndex, selectedColumnIndex: selectedColumnIndex } = (0, $ahQKW.getSelectedRowAndColumnFromPalette)(props.colorPalette, selectedColor, props.cols);
        return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $jwWgu.default), {
            target: buttonRef.current,
            fitHeight: 350,
            fitWidth: 350,
            offset: (0, $1oCLl.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? $3f0a914cf2d5c40f$var$COLOR_PICKER_POPUP_OFFSET : [
                0,
                10
            ],
            alignX: props.alignX,
            mountTo: props.setDisableParentScroll ? props.mountPoint : undefined,
            absoluteOffset: props.absoluteOffset,
            // Confluence inline comment editor has z-index: 500
            // if the toolbar is scrollable, this will be mounted in the root editor
            // we need an index of > 500 to display over it
            zIndex: props.setDisableParentScroll ? 600 : undefined,
            ariaLabel: (0, $dh538.fg)('_editor_a11y_aria_label_removal_popup') ? formatMessage((0, $b2CWF.colorPickerButtonMessages).colorPickerMenuLabel) : 'Color picker popup',
            onPositionCalculated: onPositionCalculated
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: $3f0a914cf2d5c40f$var$colorPickerWrapper,
            "data-test-id": "color-picker-menu"
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $9Z3I5.ArrowKeyNavigationProvider), {
            type: (0, $5v8Ta.ArrowKeyNavigationType).COLOR,
            selectedRowIndex: selectedRowIndex,
            selectedColumnIndex: selectedColumnIndex,
            closeOnTab: true,
            handleClose: handleClose,
            isOpenedByKeyboard: isOpenedByKeyboard,
            isPopupPositioned: isPopupPositioned,
            ignoreEscapeKey: props.returnEscToButton
        }, /*#__PURE__*/ (0, $9K4OG.jsx)($3f0a914cf2d5c40f$var$ColorPaletteWithReactViewListeners, {
            cols: props.cols,
            selectedColor: selectedColor,
            onClick: onColorSelected,
            handleClickOutside: togglePopup,
            handleEscapeKeydown: handleEsc,
            paletteOptions: paletteOptions
        }))));
    };
    const title = props.title || '';
    const currentColor = props.currentColor && props.hexToPaletteColor ? props.hexToPaletteColor(props.currentColor) : props.currentColor;
    const buttonStyleVisualRefresh = ()=>/*#__PURE__*/ (0, $9K4OG.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: `${!!props.size?.height ? 'inherit' : ''}`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '&:before': {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                alignSelf: 'center',
                content: "''",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                border: `${"var(--ds-border-width, 1px)"} solid ${(0, $lhtyR.DEFAULT_BORDER_COLOR)}`,
                borderRadius: "var(--ds-radius-small, 3px)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                backgroundColor: currentColor || 'transparent',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: props.size?.width || '14px',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                height: props.size?.height || '14px',
                marginTop: `${"var(--ds-space-025, 2px)"}`
            }
        });
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $3f0a914cf2d5c40f$var$colorPickerButtonWrapper,
        "data-vc": "6wfHIb1s"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3gadb.default), {
        content: title,
        position: "top"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $3f0a914cf2d5c40f$var$colorPickerButtonStyle
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $ccHMk.default), {
        appearance: 'subtle',
        ref: buttonRef,
        "aria-label": title,
        "aria-expanded": props.isAriaExpanded ? isPopupOpen : undefined,
        spacing: (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? 'default' : 'compact',
        onClick: togglePopup,
        onKeyDown: onKeyDown,
        "data-selected-color": props.currentColor,
        isSelected: isPopupOpen
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $dcJ7R.default), {
        alignBlock: "start"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: buttonStyleVisualRefresh
    }), /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
        xcss: $3f0a914cf2d5c40f$var$colorPickerExpandContainerVisualRefresh
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
        color: "currentColor",
        spacing: "spacious",
        label: "color-picker-chevron-down",
        size: "small"
    })))))), renderPopup());
};
const $3f0a914cf2d5c40f$var$_default_1 = (0, $ggbZE.default)({
    source: 'ConfigPanel'
})((0, $1DWH0.default)()($3f0a914cf2d5c40f$var$ColorPickerButton));
var $3f0a914cf2d5c40f$export$2e2bcd8739ae039 = $3f0a914cf2d5c40f$var$_default_1;
module.exports["default"] = $3f0a914cf2d5c40f$export$2e2bcd8739ae039;

});

parcelRegister("b2CWF", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $7a38eb603f0d495d$export$46fbf624c87d759a = (0, $aXWIB.defineMessages)({
    colorPickerMenuLabel: {
        id: "fabric.editor.colorPicker.menuLabel",
        defaultMessage: "Color picker menu"
    }
});
module.exports["colorPickerButtonMessages"] = $7a38eb603f0d495d$export$46fbf624c87d759a;

});

parcelRegister("hxEux", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $lcPXp = parcelRequire("lcPXp");


var $aXWIB = parcelRequire("aXWIB");


var $cOrQJ = parcelRequire("cOrQJ");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("42omo");





var $cvXh8 = parcelRequire("cvXh8");


var $3gadb = parcelRequire("3gadb");

/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766



const $74d2d00e98fa8316$export$fd4d27a26b4854f3 = /*#__PURE__*/ (0, $9K4OG.css)({
    height: '26px',
    width: '26px',
    background: "var(--ds-background-neutral, #0515240F)",
    padding: 0,
    borderRadius: "var(--ds-radius-small, 4px)",
    border: `1px solid ${"var(--ds-border-inverse, #FFFFFF)"}`,
    cursor: 'pointer',
    display: 'block'
});
const $74d2d00e98fa8316$export$7afe8f4b3442c19d = /*#__PURE__*/ (0, $9K4OG.css)({
    border: '1px solid transparent',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: 0,
    display: 'flex',
    alignItems: 'center',
    padding: "var(--ds-space-025, 2px)",
    borderRadius: "var(--ds-radius-medium, 6px)",
    '&:focus-within, &:focus, &:hover': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        borderColor: `${"var(--ds-border, #0B120E24)"} !important`
    }
}); /* eslint-enable @atlaskit/design-system/ensure-design-token-usage */ 


const $100779ae2f6b4479$var$Color = (props)=>{
    const { autoFocus: autoFocus, tabIndex: tabIndex, value: value, label: label, isSelected: isSelected, borderColor: borderColor, hexToPaletteColor: /**
     * When hexToPaletteColor prop is set,
     * it will be used to get background color style based on
     * value (which will be hexcode) prop
     */ hexToPaletteColor, decorator: decorator } = props;
    const colorStyle = hexToPaletteColor ? hexToPaletteColor(value) : value;
    const onMouseDown = (e)=>{
        e.preventDefault();
    };
    const onClick = (e)=>{
        const { onClick: onClick, value: value, label: label } = props;
        e.preventDefault();
        onClick(value, label);
    };
    const onKeyDown = (e)=>{
        const { onKeyDown: onKeyDown, value: value, label: label } = props;
        if (!onKeyDown) return undefined;
        e.preventDefault();
        onKeyDown(value, label, e);
    };
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3gadb.default), {
        content: label
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        css: (0, $74d2d00e98fa8316$export$7afe8f4b3442c19d),
        "data-vc": "dbrFHVGg"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("button", {
        type: "button",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: (0, $74d2d00e98fa8316$export$fd4d27a26b4854f3),
        "aria-label": label,
        role: "radio",
        "aria-checked": isSelected,
        onClick: onClick,
        onKeyDown: onKeyDown,
        onMouseDown: onMouseDown,
        tabIndex: tabIndex,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${isSelected ? 'selected' : ''}`,
        style: {
            backgroundColor: colorStyle || "var(--ds-background-input, #FFFFFF)",
            border: `${"var(--ds-border-width, 1px)"} solid ${borderColor}`
        },
        autoFocus: autoFocus
    }, !decorator && isSelected && /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))), {
        label: ""
    }), decorator)));
};
var $100779ae2f6b4479$export$2e2bcd8739ae039 = $100779ae2f6b4479$var$Color;



var $hMewq = parcelRequire("hMewq");

/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766



const $5229d5597eda2d54$export$506342f5c0767858 = /*#__PURE__*/ (0, $9K4OG.css)({
    padding: `0 ${"var(--ds-space-100, 8px)"}`,
    /* Firefox bug fix: https://product-fabric.atlassian.net/browse/ED-1789 */ display: 'flex'
});



var $ahQKW = parcelRequire("ahQKW");

/**
 * For a given color pick the color from a list of colors with
 * the highest contrast
 *
 * @param color color string, supports HEX, RGB, RGBA etc.
 * @param useIconToken boolean, describes if a token should be used for the icon color
 * @return Highest contrast color in pool
 */ function $25d1bc2e907471de$var$getCheckMarkColor(color, useIconToken) {
    const tokenVal = (0, $ahQKW.getTokenCSSVariableValue)(color);
    const colorValue = !!tokenVal ? tokenVal : color;
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    const contrastColor = [
        '#FFFFFF',
        '#42526E'
    ].sort((a, b)=>(0, $lcPXp.default).difference(b, colorValue) - (0, $lcPXp.default).difference(a, colorValue))[0];
    if (!useIconToken) return contrastColor;
    // Use of these token comes from guidance from designers in the Design System team
    // they are only intended for use with text colors (and there are different tokens
    // planned to be used when this extended to be used with other palettes).
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    return contrastColor === '#FFFFFF' ? "var(--ds-icon-inverse, #FFFFFF)" : "var(--ds-icon, #292A2E)";
}
const $25d1bc2e907471de$var$ColorPalette = (props)=>{
    const { cols: cols = (0, $ahQKW.DEFAULT_COLOR_PICKER_COLUMNS), onClick: onClick, onKeyDown: onKeyDown, selectedColor: selectedColor, className: className, intl: { formatMessage: formatMessage }, paletteOptions: paletteOptions } = props;
    const { palette: palette, hexToPaletteColor: hexToPaletteColor, paletteColorTooltipMessages: paletteColorTooltipMessages } = paletteOptions;
    const { colorMode: tokenTheme } = (0, $cOrQJ.default)();
    const useIconToken = !!hexToPaletteColor;
    const colorsPerRow = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        return (0, $ahQKW.getColorsPerRowFromPalette)(palette, cols);
    }, [
        palette,
        cols
    ]);
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, colorsPerRow.map((row)=>/*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            css: (0, $5229d5597eda2d54$export$506342f5c0767858),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            key: `row-first-color-${row[0].value}`,
            role: "radiogroup",
            "data-vc": "ECW_rnjM"
        }, row.map(({ value: value, label: label, border: border, message: message, decorator: decorator })=>{
            if (paletteColorTooltipMessages) {
                if (tokenTheme === 'dark') message = (0, $hMewq.default)(paletteColorTooltipMessages.dark, value.toUpperCase());
                if (tokenTheme === 'light') message = (0, $hMewq.default)(paletteColorTooltipMessages.light, value.toUpperCase());
            }
            return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $100779ae2f6b4479$export$2e2bcd8739ae039), {
                key: value,
                value: value,
                borderColor: border,
                label: message ? formatMessage(message) : label,
                onClick: onClick,
                onKeyDown: onKeyDown,
                isSelected: value === selectedColor,
                checkMarkColor: $25d1bc2e907471de$var$getCheckMarkColor(value, useIconToken),
                hexToPaletteColor: hexToPaletteColor,
                decorator: decorator
            });
        }))));
};
// eslint-disable-next-line @typescript-eslint/ban-types
const $25d1bc2e907471de$var$_default_1 = (0, $aXWIB.injectIntl)($25d1bc2e907471de$var$ColorPalette);
var $25d1bc2e907471de$export$2e2bcd8739ae039 = $25d1bc2e907471de$var$_default_1;
module.exports["default"] = $25d1bc2e907471de$export$2e2bcd8739ae039;

});

parcelRegister("hMewq", function(module, exports) {
$parcel$export(module.exports, "default", () => $999fa455a4d20bef$export$2e2bcd8739ae039);
function $999fa455a4d20bef$export$2e2bcd8739ae039(messages, color) {
    const message = messages[color];
    if (!message) // eslint-disable-next-line no-console
    console.warn(`Text color palette does not have an internationalization message for color ${color.toUpperCase()}.
You must add a message description to properly translate this color.
Using current label as default message.
This could have happen when someone changed the 'colorPalette' from 'adf-schema' without updating this file.
`);
    return message;
}

});

parcelRegister("ahQKW", function(module, exports) {

var $MnuXJ = parcelRequire("MnuXJ");

const $3ad7a62bf945488a$export$dc37d14f75a32acb = 7;
function $3ad7a62bf945488a$export$d97d52770ca27b6f(palette, cols = $3ad7a62bf945488a$export$dc37d14f75a32acb) {
    return palette.reduce((resultArray, item, index)=>{
        const chunkIndex = Math.floor(index / cols);
        resultArray[chunkIndex] = resultArray[chunkIndex] || []; // start a new chunk
        resultArray[chunkIndex].push(item);
        return resultArray;
    }, []);
}
function $3ad7a62bf945488a$export$c16ae5b27ec0c8f6(palette, selectedColor, cols = $3ad7a62bf945488a$export$dc37d14f75a32acb) {
    const colorsPerRow = $3ad7a62bf945488a$export$d97d52770ca27b6f(palette, cols);
    return (0, $MnuXJ.getSelectedRowAndColumn)(colorsPerRow, selectedColor);
}
const $3ad7a62bf945488a$export$426cbff16166281c = (variableExpression)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const matcher = variableExpression.match(/var\(([^,\)]+)(,.*)?\)/);
    if (matcher) {
        const variable = matcher[1].trim();
        const fallback = matcher[2] ? matcher[2].replace(',', '').trim() : '';
        if (typeof document === 'undefined') return fallback;
        const value = window.getComputedStyle(document.documentElement).getPropertyValue(variable).trim();
        return value || fallback;
    }
    return '';
};
module.exports["DEFAULT_COLOR_PICKER_COLUMNS"] = $3ad7a62bf945488a$export$dc37d14f75a32acb;
module.exports["getColorsPerRowFromPalette"] = $3ad7a62bf945488a$export$d97d52770ca27b6f;
module.exports["getSelectedRowAndColumnFromPalette"] = $3ad7a62bf945488a$export$c16ae5b27ec0c8f6;
module.exports["getTokenCSSVariableValue"] = $3ad7a62bf945488a$export$426cbff16166281c;

});

parcelRegister("lhtyR", function(module, exports) {

var $lcPXp = parcelRequire("lcPXp");

/**
 * For a given color set the alpha channel to alpha
 *
 * @param color color string, suppports HEX, RGB, RGBA etc.
 * @param alpha Alpha channel value as fraction of 1
 * @return CSS RGBA string with applied alpha channel
 */ function $bbf128563beada6a$var$setAlpha(color, alpha) {
    const { r: r, g: g, b: b } = (0, $lcPXp.default).convert(color).rgb;
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
const $bbf128563beada6a$export$f54f5cacf382b9f2 = $bbf128563beada6a$var$setAlpha('#172B4D', 0.12); /* eslint-enable @atlaskit/design-system/ensure-design-token-usage */ 
module.exports["DEFAULT_BORDER_COLOR"] = $bbf128563beada6a$export$f54f5cacf382b9f2;

});

parcelRegister("2dkHo", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $5v8Ta = parcelRequire("5v8Ta");


var $6qITU = parcelRequire("6qITU");


var $5Gwdo = parcelRequire("5Gwdo");

const $500e07b537f1f600$export$49166591ec160d97 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(function DropdownContainer(props) {
    const keyDownHandlerContext = (0, $42omo.useContext)((0, $5Gwdo.KeyDownHandlerContext));
    let newArrowKeyNavigationProviderOptions = props.arrowKeyNavigationProviderOptions;
    // if the dropdown is of type menu, use this keyDownHandlerContext
    if (props.arrowKeyNavigationProviderOptions.type === (0, $5v8Ta.ArrowKeyNavigationType).MENU) newArrowKeyNavigationProviderOptions = {
        ...props.arrowKeyNavigationProviderOptions,
        keyDownHandlerContext: keyDownHandlerContext
    };
    return(//This context is to handle the tab, Arrow Right/Left key events for dropdown.
    //Default context has the void callbacks for above key events
    /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6qITU.default), {
        ...props,
        arrowKeyNavigationProviderOptions: newArrowKeyNavigationProviderOptions
    }));
});
module.exports["DropdownContainer"] = $500e07b537f1f600$export$49166591ec160d97;

});

parcelRegister("6qITU", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $wJ8xb = parcelRequire("wJ8xb");

var $efG2U = parcelRequire("efG2U");


var $9CaSN = parcelRequire("9CaSN");


var $jwWgu = parcelRequire("jwWgu");


var $7YjFd = parcelRequire("7YjFd");


var $9Z3I5 = parcelRequire("9Z3I5");

class $2ad1109a6d85ec73$export$931cbfb6bfb85fc extends (0, $42omo.PureComponent) {
    componentDidUpdate(prevProps) {
        if (!prevProps.isOpen && this.props.isOpen && this.state.target) {
            // Dropdown flickers when opens as placement is calculated in Popup component and updated after the first render.
            // popupPlacement is set to ['bottom', 'left'] by default, but it may not be the correct placement and is required in DropdownList.
            // To avoid flicker we calculate placement here and set it to state when the dropdown opens.
            const initialPlacement = (0, $7YjFd.calculatePlacement)(this.state.target, this.props.boundariesElement || document.body, this.props.fitWidth, this.props.fitHeight, this.props.alignX, this.props.alignY, this.props.forcePlacement);
            this.setState({
                popupPlacement: initialPlacement
            });
        }
    }
    renderDropdown() {
        const { target: target, popupPlacement: popupPlacement } = this.state;
        const { children: children, mountTo: mountTo, boundariesElement: boundariesElement, scrollableElement: scrollableElement, onOpenChange: onOpenChange, fitHeight: fitHeight, fitWidth: fitWidth, zIndex: zIndex, arrowKeyNavigationProviderOptions: arrowKeyNavigationProviderOptions, dropdownListId: dropdownListId, alignDropdownWithParentElement: alignDropdownWithParentElement, target: targetProp, forcePlacement: forcePlacement, alignX: alignX, alignY: alignY, offset: offset, shouldFitContainer: shouldFitContainer = true, testId: testId } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jwWgu.default), {
            target: targetProp ?? (alignDropdownWithParentElement ? // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            target?.closest("[data-testid='editor-floating-toolbar']") : target),
            mountTo: mountTo,
            boundariesElement: boundariesElement,
            scrollableElement: scrollableElement,
            onPlacementChanged: forcePlacement ? undefined : this.updatePopupPlacement,
            fitHeight: fitHeight,
            fitWidth: fitWidth,
            zIndex: zIndex,
            allowOutOfBounds: alignDropdownWithParentElement,
            alignX: alignX,
            alignY: alignY,
            forcePlacement: forcePlacement,
            offset: offset
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9Z3I5.ArrowKeyNavigationProvider), {
            ...arrowKeyNavigationProviderOptions,
            closeOnTab: true,
            handleClose: this.handleCloseAndFocus
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            style: {
                height: 0,
                minWidth: fitWidth || 0
            },
            "data-vc": "9LZo01kB"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9CaSN.default), {
            isOpen: true,
            onOpenChange: onOpenChange,
            position: popupPlacement.join(' '),
            shouldFitContainer: shouldFitContainer,
            id: dropdownListId,
            testId: testId
        }, children))));
    }
    render() {
        const { trigger: trigger, isOpen: isOpen } = this.props;
        return trigger ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $wJ8xb.OutsideClickTargetRefContext).Consumer, null, (setOutsideClickTargetRef)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
                ref: this.handleRef(setOutsideClickTargetRef)
            }, trigger), isOpen ? this.renderDropdown() : null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, isOpen ? this.renderDropdown() : null);
    }
    constructor(props){
        super(props);
        this.handleRef = (setOutsideClickTargetRef)=>(target)=>{
                setOutsideClickTargetRef(target);
                this.setState({
                    target: target || undefined
                });
            };
        this.updatePopupPlacement = (placement)=>{
            this.setState({
                popupPlacement: placement
            });
        };
        this.handleCloseAndFocus = (event)=>{
            this.state.target?.querySelector('button')?.focus();
            this.handleClose(event);
        };
        this.handleClose = (event)=>{
            if (this.props.onOpenChange) this.props.onOpenChange({
                isOpen: false,
                event: event
            });
        };
        this.state = {
            popupPlacement: [
                'bottom',
                'left'
            ]
        };
    }
}
const $2ad1109a6d85ec73$var$DropdownWithOuterListeners = (0, $efG2U.default)($2ad1109a6d85ec73$export$931cbfb6bfb85fc);
var $2ad1109a6d85ec73$export$2e2bcd8739ae039 = $2ad1109a6d85ec73$var$DropdownWithOuterListeners;
module.exports["default"] = $2ad1109a6d85ec73$export$2e2bcd8739ae039;

});

parcelRegister("jSp3D", function(module, exports) {

var $id9O1 = parcelRequire("id9O1");

const $9a071a6d499026fc$export$3dd46fa6c35aa514 = (state)=>{
    const table = (0, $id9O1.findTable)(state.selection);
    if (!table) return false;
    const parent = state.doc.resolve(table.pos).parent;
    const nodeTypes = state.schema.nodes;
    return [
        nodeTypes.tableHeader,
        nodeTypes.tableCell
    ].includes(parent.type);
};
module.exports["isSelectionTableNestedInTable"] = $9a071a6d499026fc$export$3dd46fa6c35aa514;

});

parcelRegister("gATpw", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gQUY7 = parcelRequire("gQUY7");


var $d925B = parcelRequire("d925B");


var $hgeg8 = parcelRequire("hgeg8");


var $86XId = parcelRequire("86XId");


var $4HWgE = parcelRequire("4HWgE");


var $gmyMu = parcelRequire("gmyMu");


var $3pLGZ = parcelRequire("3pLGZ");


var $j9WGh = parcelRequire("j9WGh");


var $1bY7o = parcelRequire("1bY7o");


var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");


var $iu6m9 = parcelRequire("iu6m9");


var $22tcT = parcelRequire("22tcT");


var $jSDb4 = parcelRequire("jSDb4");


var $1S4f7 = parcelRequire("1S4f7");


var $ftzrq = parcelRequire("ftzrq");


var $ks2lK = parcelRequire("ks2lK");

const $1ab805d201d6f6fe$export$38c00ed3b117ab26 = new (0, $ks2lK.PluginKey)('fakeCursorToolbarPlugin');



var $6VwLP = parcelRequire("6VwLP");

const $2db3fe02ec916f4c$var$createTextCursor = (pos)=>{
    const node = document.createElement('div');
    node.className = 'ProseMirror-fake-text-cursor';
    return (0, $ftzrq.Decoration).widget(pos, node, {
        key: 'hyperlink-text-cursor'
    });
};
const $2db3fe02ec916f4c$var$createTextSelection = (from, to)=>(0, $ftzrq.Decoration).inline(from, to, {
        class: 'ProseMirror-fake-text-selection'
    });
const $2db3fe02ec916f4c$var$getInsertLinkToolbarState = (editorState)=>{
    const state = (0, $6VwLP.stateKey).getState(editorState);
    if (state && state.activeLinkMark) {
        if (state.activeLinkMark.type === (0, $jSDb4.InsertStatus).INSERT_LINK_TOOLBAR) return state.activeLinkMark;
    }
    return undefined;
};
const $2db3fe02ec916f4c$var$fakeCursorToolbarPlugin = new (0, $1S4f7.SafePlugin)({
    key: (0, $1ab805d201d6f6fe$export$38c00ed3b117ab26),
    state: {
        init () {
            return (0, $ftzrq.DecorationSet).empty;
        },
        apply (tr, pluginState, oldState, newState) {
            const oldInsertToolbarState = $2db3fe02ec916f4c$var$getInsertLinkToolbarState(oldState);
            const insertToolbarState = $2db3fe02ec916f4c$var$getInsertLinkToolbarState(newState);
            // Map DecorationSet if it still refers to the same position in the document
            if (oldInsertToolbarState && insertToolbarState) {
                const { from: from, to: to } = insertToolbarState;
                const oldFrom = tr.mapping.map(oldInsertToolbarState.from);
                const oldTo = tr.mapping.map(oldInsertToolbarState.to);
                if (oldFrom === from && oldTo === to) return pluginState.map(tr.mapping, tr.doc);
            }
            // Update DecorationSet if new insert toolbar, or if we have moved to a different position in the doc
            if (insertToolbarState) {
                const { from: from, to: to } = insertToolbarState;
                return (0, $ftzrq.DecorationSet).create(tr.doc, [
                    from === to ? $2db3fe02ec916f4c$var$createTextCursor(from) : $2db3fe02ec916f4c$var$createTextSelection(from, to)
                ]);
            }
            return (0, $ftzrq.DecorationSet).empty;
        }
    },
    props: {
        decorations (state) {
            return (0, $1ab805d201d6f6fe$export$38c00ed3b117ab26).getState(state);
        }
    }
});
var $2db3fe02ec916f4c$export$2e2bcd8739ae039 = $2db3fe02ec916f4c$var$fakeCursorToolbarPlugin;






var $19Q6F = parcelRequire("19Q6F");





var $4VXMf = parcelRequire("4VXMf");

var $b0F8r = parcelRequire("b0F8r");

var $hoQ9u = parcelRequire("hoQ9u");

var $lSdQB = parcelRequire("lSdQB");

var $azNN5 = parcelRequire("azNN5");


var $aIMBk = parcelRequire("aIMBk");







const $03379beda430460c$export$6cbac557ea601778 = new (0, $ks2lK.PluginKey)('hyperlinkToolbarItems');
const $03379beda430460c$export$faf11097578346af = (initialState)=>{
    return new (0, $1S4f7.SafePlugin)({
        key: $03379beda430460c$export$6cbac557ea601778,
        state: {
            init: (_, __)=>{
                return initialState;
            },
            apply: (tr, pluginState)=>{
                const metaState = tr.getMeta($03379beda430460c$export$6cbac557ea601778);
                if (metaState) return metaState;
                return pluginState;
            }
        }
    });
};


function $9bb794acdd7e372a$export$8d0400fab1d2ed11(regexp, editorAnalyticsApi) {
    // Plain typed text (eg, typing 'www.google.com') should convert to a hyperlink
    return (0, $4VXMf.createRule)(regexp, (state, match, start, end)=>{
        const { schema: schema } = state;
        if (state.doc.rangeHasMark(start, end, schema.marks.link)) return null;
        const link = match;
        // Property 'url' does not exist on type 'RegExpExecArray', the type of `match`.
        // This check is in case the match is not a Linkify match, which has a url property.
        if (link.url === undefined) return null;
        if (!(0, $azNN5.shouldAutoLinkifyMatch)(link)) return null;
        const url = (0, $lSdQB.normalizeUrl)(link.url);
        // Not previously handled; don't create a link if the URL is empty.
        // This will only happen if the `regexp` matches more links than the normalizeUrl validation;
        // if they both use the same linkify instance this shouldn't happen.
        if (url === '') return null;
        const markType = schema.mark('link', {
            href: url
        });
        // Need access to complete text to check if last URL is part of a filepath before linkifying
        const nodeBefore = state.selection.$from.nodeBefore;
        if (!nodeBefore || !nodeBefore.isText || !nodeBefore.text) return null;
        const filepaths = (0, $b0F8r.findFilepaths)(nodeBefore.text, // The position referenced by 'start' is relative to the start of the document, findFilepaths deals with index in a node only.
        start - (nodeBefore.text.length - link.text.length));
        if ((0, $b0F8r.isLinkInMatches)(start, filepaths)) {
            const tr = state.tr;
            return tr;
        }
        const from = start;
        const to = Math.min(start + link.text.length, state.doc.content.size);
        const tr = state.tr.addMark(from, to, markType);
        // Keep old behavior that will delete the space after the link
        if (to === end) tr.insertText(' ');
        (0, $19Q6F.addLinkMetadata)(state.selection, tr, {
            inputMethod: (0, $d925B.INPUT_METHOD).AUTO_DETECT
        });
        const skipAnalytics = (0, $03379beda430460c$export$6cbac557ea601778).getState(state)?.skipAnalytics ?? false;
        if (skipAnalytics) return tr;
        editorAnalyticsApi?.attachAnalyticsEvent((0, $b0F8r.getLinkCreationAnalyticsEvent)((0, $d925B.INPUT_METHOD).AUTO_DETECT, url))(tr);
        return tr;
    });
}
function $9bb794acdd7e372a$export$dc83f374e2af640d(schema, editorAnalyticsApi, autoLinkOnBlur = false) {
    if (!schema.marks.link) return;
    const urlWithASpaceRule = $9bb794acdd7e372a$export$8d0400fab1d2ed11((0, $hoQ9u.LinkMatcher).create(), editorAnalyticsApi);
    // [something](link) should convert to a hyperlink
    // eslint-disable-next-line require-unicode-regexp
    const markdownLinkRule = (0, $4VXMf.createRule)(/(^|[^!])\[(.*?)\]\((\S+)\)$/, (state, match, start, end)=>{
        const { schema: schema } = state;
        const [, prefix, linkText, linkUrl] = match;
        // We don't filter this match here by shouldAutoLinkifyMatch
        // because the intent of creating a link is clear
        const url = (0, $lSdQB.normalizeUrl)(linkUrl).trim();
        const markType = schema.mark('link', {
            href: url
        });
        const tr = state.tr.replaceWith(start + prefix.length, end, schema.text((linkText || '').trim(), [
            markType
        ]));
        (0, $19Q6F.addLinkMetadata)(state.selection, tr, {
            inputMethod: (0, $d925B.INPUT_METHOD).FORMATTING
        });
        const skipAnalytics = (0, $03379beda430460c$export$6cbac557ea601778).getState(state)?.skipAnalytics ?? false;
        if (skipAnalytics) return tr;
        editorAnalyticsApi?.attachAnalyticsEvent((0, $b0F8r.getLinkCreationAnalyticsEvent)((0, $d925B.INPUT_METHOD).FORMATTING, url))(tr);
        return tr;
    });
    return new (0, $1S4f7.SafePlugin)((0, $aIMBk.createPlugin)('hyperlink', [
        urlWithASpaceRule,
        markdownLinkRule
    ], autoLinkOnBlur ? {
        checkOnBlur: true,
        appendTextOnBlur: ' '
    } : undefined));
}
var $9bb794acdd7e372a$export$2e2bcd8739ae039 = $9bb794acdd7e372a$export$dc83f374e2af640d;



var $81OAa = parcelRequire("81OAa");
















var $dus6D = parcelRequire("dus6D");








function $cc6b937a2abc69f3$export$1d7b13ce0747fbd(editorAnalyticsApi) {
    const list = {};
    (0, $hgeg8.bindKeymapWithEditorCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.addLink).common, (0, $22tcT.showLinkToolbar)((0, $d925B.INPUT_METHOD).SHORTCUT, editorAnalyticsApi), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.bindKeymapWithCommand)((0, $hgeg8.enter).common, $cc6b937a2abc69f3$var$mayConvertLastWordToHyperlink(editorAnalyticsApi), list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.insertNewLine).common, $cc6b937a2abc69f3$var$mayConvertLastWordToHyperlink(editorAnalyticsApi), list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.escape).common, (state, dispatch, view)=>{
        const hyperlinkPlugin = (0, $6VwLP.stateKey).getState(state);
        if (hyperlinkPlugin.activeLinkMark) {
            (0, $22tcT.hideLinkToolbar)()(state, dispatch);
            if (view) view.focus();
            return false;
        }
        return false;
    }, list);
    return (0, $dus6D.keymap)(list);
}
/**
 * Convert the last word before the selection to a hyperlink if it's a valid URL with a tld we want to linkify
 */ const $cc6b937a2abc69f3$var$mayConvertLastWordToHyperlink = (editorAnalyticsApi)=>{
    return function(state, dispatch) {
        const skipAnalytics = (0, $03379beda430460c$export$6cbac557ea601778).getState(state)?.skipAnalytics ?? false;
        const nodeBefore = state.selection.$from.nodeBefore;
        if (!nodeBefore || !nodeBefore.isText || !nodeBefore.text) return false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const words = nodeBefore.text.split(' ');
        const lastWord = words[words.length - 1];
        const match = (0, $81OAa.getLinkMatch)(lastWord);
        if (match) {
            if (!(0, $azNN5.shouldAutoLinkifyMatch)(match)) return false;
            const hyperlinkedText = match.raw;
            const start = state.selection.$from.pos - hyperlinkedText.length;
            const end = state.selection.$from.pos;
            if (state.doc.rangeHasMark(start, end, state.schema.marks.link)) return false;
            const url = match.url;
            const markType = state.schema.mark('link', {
                href: url
            });
            const filepaths = (0, $b0F8r.findFilepaths)(nodeBefore.text, start - (nodeBefore.text.length - hyperlinkedText.length));
            if ((0, $b0F8r.isLinkInMatches)(start, filepaths)) return false;
            const tr = state.tr.addMark(start, end, markType);
            if (dispatch) {
                (0, $19Q6F.addLinkMetadata)(state.selection, tr, {
                    inputMethod: (0, $d925B.INPUT_METHOD).AUTO_DETECT
                });
                if (skipAnalytics) dispatch(tr);
                else {
                    editorAnalyticsApi?.attachAnalyticsEvent((0, $b0F8r.getLinkCreationAnalyticsEvent)((0, $d925B.INPUT_METHOD).AUTO_DETECT, url))(tr);
                    dispatch(tr);
                }
            }
        }
        return false;
    };
};
var $cc6b937a2abc69f3$export$2e2bcd8739ae039 = $cc6b937a2abc69f3$export$1d7b13ce0747fbd;










var $cPCP8 = parcelRequire("cPCP8");

var $4Chin = parcelRequire("4Chin");





var $aXWIB = parcelRequire("aXWIB");





var $eiA8Z = parcelRequire("eiA8Z");










var $7ERUE = parcelRequire("7ERUE");

var $iIVVb = parcelRequire("iIVVb");

const $f6266ee5b64ef0a4$export$29d11c0fe2fc51d8 = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const canInsertLink = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'hyperlink'
    ], (state)=>state?.hyperlinkState?.canInsertLink ?? true);
    const onClick = ()=>{
        api?.core.actions.execute(api?.hyperlink.commands.showLinkToolbar((0, $d925B.INPUT_METHOD).FLOATING_TB));
    };
    const isEnabled = canInsertLink;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iIVVb.ToolbarTooltip), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hgeg8.ToolTipContent), {
            description: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).link),
            keymap: (0, $hgeg8.addLink)
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7ERUE.ToolbarButton), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
            label: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).link),
            size: "small"
        }),
        onClick: onClick,
        testId: 'editor-toolbar__link-button',
        isDisabled: !isEnabled
    }));
};


const $006b700c91db9ea8$export$a758406ca53b86a5 = (api)=>{
    const toolbarComponents = [
        {
            type: (0, $cPCP8.LINKING_GROUP).type,
            key: (0, $cPCP8.LINKING_GROUP).key,
            parents: [
                {
                    type: (0, $cPCP8.LINKING_SECTION).type,
                    key: (0, $cPCP8.LINKING_SECTION).key,
                    rank: (0, $4Chin.LINKING_SECTION_RANK)[(0, $cPCP8.LINKING_GROUP).key]
                }
            ]
        },
        {
            type: (0, $cPCP8.LINKING_BUTTON).type,
            key: (0, $cPCP8.LINKING_BUTTON).key,
            parents: [
                {
                    type: (0, $cPCP8.LINKING_GROUP).type,
                    key: (0, $cPCP8.LINKING_GROUP).key,
                    rank: (0, $4Chin.LINKING_GROUP_RANK)[(0, $cPCP8.LINKING_BUTTON).key]
                }
            ],
            component: ()=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f6266ee5b64ef0a4$export$29d11c0fe2fc51d8), {
                    api: api
                });
            }
        }
    ];
    return toolbarComponents;
};











var $iGbqR = parcelRequire("iGbqR");


var $doRn8 = parcelRequire("doRn8");





var $6YpFi = parcelRequire("6YpFi");


var $fpEzC = parcelRequire("fpEzC");

var $ckqYV = parcelRequire("ckqYV");


var $iHzeA = parcelRequire("iHzeA");


var $9fPrY = parcelRequire("9fPrY");


var $1eLzC = parcelRequire("1eLzC");





var $91bcx = parcelRequire("91bcx");





var $8m4tT = parcelRequire("8m4tT");


var $1Zr9M = parcelRequire("1Zr9M");


var $dZMVn = parcelRequire("dZMVn");


var $8tdj3 = parcelRequire("8tdj3");











/* type guard for edit links */ function $417e19eda6a34f02$var$isEditLink(linkMark) {
    return linkMark.pos !== undefined;
}
const $417e19eda6a34f02$var$dispatchAnalytics = (dispatch, state, analyticsBuilder, editorAnalyticsApi)=>{
    if (dispatch) {
        const { tr: tr } = state;
        editorAnalyticsApi?.attachAnalyticsEvent(analyticsBuilder((0, $d925B.ACTION_SUBJECT_ID).HYPERLINK))(tr);
        dispatch(tr);
    }
};
const $417e19eda6a34f02$var$visitHyperlink = (editorAnalyticsApi)=>(state, dispatch)=>{
        $417e19eda6a34f02$var$dispatchAnalytics(dispatch, state, (0, $iGbqR.buildVisitedLinkPayload), editorAnalyticsApi);
        return true;
    };
function $417e19eda6a34f02$var$getLinkText(activeLinkMark, state) {
    if (!activeLinkMark.node) return undefined;
    const textToUrl = (0, $lSdQB.normalizeUrl)(activeLinkMark.node.text);
    const linkMark = activeLinkMark.node.marks.find((mark)=>mark.type === state.schema.marks.link);
    const linkHref = linkMark && linkMark.attrs.href;
    if (textToUrl === linkHref) return undefined;
    return activeLinkMark.node.text;
}
const $417e19eda6a34f02$var$selector = (states)=>{
    return {
        timesViewed: states.hyperlinkState?.timesViewed,
        inputMethod: states.hyperlinkState?.inputMethod,
        searchSessionId: states.hyperlinkState?.searchSessionId
    };
};
function $417e19eda6a34f02$export$a46cebff622c3cae({ linkPickerOptions: linkPickerOptions = {}, onSubmit: onSubmit, displayText: displayText, displayUrl: displayUrl, providerFactory: providerFactory, view: view, onCancel: onCancel, invokeMethod: invokeMethod, lpLinkPicker: lpLinkPicker, onClose: onClose, onEscapeCallback: onEscapeCallback, onClickAwayCallback: onClickAwayCallback, pluginInjectionApi: pluginInjectionApi }) {
    const { timesViewed: timesViewed, inputMethod: inputMethod, searchSessionId: searchSessionId } = (0, $eiA8Z.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'hyperlink'
    ], $417e19eda6a34f02$var$selector);
    // This is constant rather than dynamic - because if someone's already got a hyperlink toolbar open,
    // we don't want to dynamically change it on them as this would cause data loss if they've already
    // started typing in the fields.
    const isOffline = (0, $42omo.useRef)((0, $91bcx.isOfflineMode)(pluginInjectionApi?.connectivity?.sharedState.currentState()?.mode));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6YpFi.HyperlinkAddToolbar), {
        linkPickerOptions: linkPickerOptions,
        onSubmit: onSubmit,
        displayText: displayText,
        displayUrl: displayUrl,
        providerFactory: providerFactory,
        view: view,
        onCancel: onCancel,
        invokeMethod: invokeMethod,
        lpLinkPicker: lpLinkPicker,
        onClose: onClose,
        onEscapeCallback: onEscapeCallback,
        onClickAwayCallback: onClickAwayCallback,
        timesViewed: timesViewed,
        inputMethod: inputMethod,
        searchSessionId: searchSessionId,
        isOffline: isOffline.current
    });
}
const $417e19eda6a34f02$export$86ce8f8241c20a3 = (options, pluginInjectionApi)=>(state, intl, providerFactory)=>{
        if (options.disableFloatingToolbar) return;
        const isToolbarAIFCEnabled = Boolean(pluginInjectionApi?.toolbar);
        const linkState = (0, $6VwLP.stateKey).getState(state);
        const activeLinkMark = linkState?.activeLinkMark;
        // If range selection, we don't show hyperlink floating toolbar.
        // Text Formattting toolbar is shown instaed.
        if (state.selection instanceof (0, $ks2lK.TextSelection) && state.selection.to !== state.selection.from && activeLinkMark?.type === 'EDIT' && (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) return;
        const { formatMessage: formatMessage } = intl;
        const editorCardActions = pluginInjectionApi?.card?.actions;
        const editorAnalyticsApi = pluginInjectionApi?.analytics?.actions;
        const lpLinkPicker = options.lpLinkPicker ?? true;
        if (activeLinkMark) {
            const hyperLinkToolbar = {
                title: 'Hyperlink floating controls',
                nodeType: [
                    state.schema.nodes.text,
                    state.schema.nodes.paragraph,
                    state.schema.nodes.heading,
                    state.schema.nodes.taskItem,
                    state.schema.nodes.decisionItem,
                    state.schema.nodes.caption
                ].filter((nodeType)=>!!nodeType),
                // Use only the node types existing in the schema ED-6745
                align: 'left',
                className: activeLinkMark.type.match('INSERT|EDIT_INSERTED') ? 'hyperlink-floating-toolbar' : '',
                // getDomRef by default uses view.state.selection.from to position the toolbar.
                // However, when the user clicks in right after the link the view.state.selection.from references to the dom after the selection.
                // So instead we want to use the activeLinkMark.pos which has been calculated as the position before the click so that would be the link node
                getDomRef: activeLinkMark && (activeLinkMark.type === 'EDIT_INSERTED' || activeLinkMark.type === 'EDIT') && (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? (view)=>{
                    const domRef = (0, $8m4tT.findDomRefAtPos)(activeLinkMark.pos, view.domAtPos.bind(view));
                    return domRef instanceof HTMLElement ? domRef : undefined;
                } : undefined
            };
            switch(activeLinkMark.type){
                case 'EDIT':
                    {
                        const { pos: pos, node: node } = activeLinkMark;
                        const linkMark = node.marks.filter((mark)=>mark.type === state.schema.marks.link);
                        const link = linkMark[0] && linkMark[0].attrs.href;
                        const isValidUrl = (0, $81OAa.isSafeUrl)(link);
                        const labelOpenLink = formatMessage(isValidUrl ? (0, $fpEzC.linkMessages).openLink : (0, $ckqYV.linkToolbarMessages).unableToOpenLink);
                        // TODO: ED-14403 - investigate why these are not translating?
                        const labelUnlink = formatMessage((0, $ckqYV.linkToolbarMessages).unlink);
                        const editLink = formatMessage((0, $ckqYV.linkToolbarMessages).editLink);
                        const metadata = {
                            url: link,
                            title: ''
                        };
                        if (activeLinkMark.node.text) metadata.title = activeLinkMark.node.text;
                        const areAnyNewToolbarFlagsEnabled = (0, $iHzeA.areToolbarFlagsEnabled)(Boolean(pluginInjectionApi?.toolbar));
                        const cardActions = pluginInjectionApi?.card?.actions;
                        const startingToolbarItems = cardActions?.getStartingToolbarItems(intl, link, (0, $22tcT.editInsertedLink)(editorAnalyticsApi), metadata, areAnyNewToolbarFlagsEnabled ? state : undefined) ?? [
                            {
                                id: 'editor.link.edit',
                                testId: 'editor.link.edit',
                                type: 'button',
                                onClick: (0, $22tcT.editInsertedLink)(editorAnalyticsApi),
                                title: editLink,
                                showTitle: areAnyNewToolbarFlagsEnabled ? false : true,
                                metadata: metadata,
                                icon: areAnyNewToolbarFlagsEnabled ? (0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))) : undefined
                            },
                            {
                                type: 'separator'
                            }
                        ];
                        const openLinkButton = {
                            id: 'editor.link.openLink',
                            testId: 'editor.link.openLink',
                            type: 'button',
                            disabled: !isValidUrl,
                            target: '_blank',
                            href: isValidUrl ? link : undefined,
                            onClick: $417e19eda6a34f02$var$visitHyperlink(editorAnalyticsApi),
                            title: labelOpenLink,
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))),
                            className: 'hyperlink-open-link',
                            metadata: metadata,
                            tabIndex: null
                        };
                        const unlinkButton = {
                            id: 'editor.link.unlink',
                            testId: 'editor.link.unlink',
                            type: 'button',
                            onClick: (0, $doRn8.commandWithMetadata)((0, $22tcT.removeLink)(pos, editorAnalyticsApi), {
                                inputMethod: (0, $d925B.INPUT_METHOD).FLOATING_TB
                            }),
                            title: labelUnlink,
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($dZMVn))),
                            tabIndex: null
                        };
                        const items = [
                            ...startingToolbarItems,
                            ...areAnyNewToolbarFlagsEnabled ? [
                                unlinkButton,
                                {
                                    type: 'separator',
                                    fullHeight: true
                                },
                                openLinkButton,
                                {
                                    type: 'separator',
                                    fullHeight: true
                                }
                            ] : [
                                openLinkButton,
                                {
                                    type: 'separator'
                                },
                                unlinkButton,
                                {
                                    type: 'separator'
                                }
                            ],
                            {
                                type: 'copy-button',
                                items: [
                                    {
                                        state: state,
                                        formatMessage: formatMessage,
                                        markType: state.schema.marks.link
                                    }
                                ]
                            },
                            ...cardActions?.getEndingToolbarItems(intl, link) ?? []
                        ];
                        return {
                            ...hyperLinkToolbar,
                            height: 32,
                            width: 250,
                            items: items,
                            scrollable: true
                        };
                    }
                case 'EDIT_INSERTED':
                case 'INSERT':
                    {
                        let link;
                        if ($417e19eda6a34f02$var$isEditLink(activeLinkMark) && activeLinkMark.node) {
                            const linkMark = activeLinkMark.node.marks.filter((mark)=>mark.type === state.schema.marks.link);
                            link = linkMark[0] && linkMark[0].attrs.href;
                        }
                        const displayText = $417e19eda6a34f02$var$isEditLink(activeLinkMark) ? $417e19eda6a34f02$var$getLinkText(activeLinkMark, state) : linkState.activeText;
                        const popupHeight = options?.linkPicker?.popupHeight ?? (lpLinkPicker ? (0, $9fPrY.LINKPICKER_HEIGHT_IN_PX) : (0, $9fPrY.RECENT_SEARCH_HEIGHT_IN_PX));
                        const popupWidth = options?.linkPicker?.popupWidth ?? (!lpLinkPicker ? undefined : (0, $9fPrY.RECENT_SEARCH_WIDTH_IN_PX));
                        return {
                            ...hyperLinkToolbar,
                            preventPopupOverflow: true,
                            height: popupHeight,
                            width: popupWidth,
                            items: [
                                {
                                    type: 'custom',
                                    fallback: [],
                                    disableArrowNavigation: true,
                                    render: (view, idx)=>{
                                        if (!view) return null;
                                        const Toolbar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($417e19eda6a34f02$export$a46cebff622c3cae, {
                                            pluginInjectionApi: pluginInjectionApi,
                                            view: view,
                                            key: idx,
                                            linkPickerOptions: options?.linkPicker,
                                            lpLinkPicker: lpLinkPicker,
                                            displayUrl: link,
                                            displayText: displayText || '',
                                            providerFactory: providerFactory,
                                            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                                            onCancel: ()=>view.focus(),
                                            onEscapeCallback: (0, $22tcT.onEscapeCallback)(editorCardActions),
                                            onClickAwayCallback: (0, $22tcT.onClickAwayCallback),
                                            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                                            onSubmit: (href, title = '', displayText, inputMethod, analytic)=>{
                                                const isEdit = $417e19eda6a34f02$var$isEditLink(activeLinkMark);
                                                const action = isEdit ? (0, $d925B.ACTION).UPDATED : (0, $d925B.ACTION).INSERTED;
                                                const skipAnalytics = (0, $03379beda430460c$export$6cbac557ea601778).getState(state)?.skipAnalytics ?? false;
                                                const command = isEdit ? (0, $doRn8.commandWithMetadata)((0, $22tcT.updateLink)(href, displayText || title, activeLinkMark.pos), {
                                                    action: action,
                                                    inputMethod: inputMethod,
                                                    sourceEvent: analytic
                                                }) : (0, $22tcT.insertLinkWithAnalytics)(inputMethod, activeLinkMark.from, activeLinkMark.to, href, editorCardActions, editorAnalyticsApi, title, displayText, skipAnalytics, analytic);
                                                command(view.state, view.dispatch, view);
                                                view.focus();
                                            }
                                        });
                                        return isToolbarAIFCEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eLzC.UserIntentPopupWrapper), {
                                            api: pluginInjectionApi
                                        }, Toolbar) : Toolbar;
                                    }
                                }
                            ]
                        };
                    }
            }
        }
        return;
    };


const $19e770218fcc89ff$var$getPosFromActiveLinkMark = (state)=>{
    if (state === undefined) return undefined;
    switch(state.type){
        case 'EDIT':
        case 'EDIT_INSERTED':
            return state.pos;
        case 'INSERT':
            return undefined;
    }
};
const $19e770218fcc89ff$var$selectionToolbarLinkButtonTestId = 'ak-editor-selection-toolbar-link-button';
const $19e770218fcc89ff$export$8143923e8601d272 = ({ config: options = {}, api: api })=>{
    let primaryToolbarComponent;
    const isToolbarAIFCEnabled = Boolean(api?.toolbar);
    if (isToolbarAIFCEnabled) api?.toolbar?.actions.registerComponents((0, $006b700c91db9ea8$export$a758406ca53b86a5)(api));
    return {
        name: 'hyperlink',
        marks () {
            return [
                {
                    name: 'link',
                    mark: (0, $gQUY7.link)
                }
            ];
        },
        commands: {
            showLinkToolbar: (inputMethod = (0, $d925B.INPUT_METHOD).TOOLBAR)=>(0, $22tcT.showLinkToolbar)(inputMethod, api?.analytics?.actions),
            updateLink: (href, text)=>{
                const linkMark = api?.hyperlink?.sharedState.currentState()?.activeLinkMark;
                const pos = $19e770218fcc89ff$var$getPosFromActiveLinkMark(linkMark);
                if (pos === undefined) return ()=>null;
                return (0, $22tcT.updateLinkEditorCommand)(href, text, pos);
            },
            removeLink: ()=>{
                const linkMark = api?.hyperlink?.sharedState.currentState()?.activeLinkMark;
                const pos = $19e770218fcc89ff$var$getPosFromActiveLinkMark(linkMark);
                if (pos === undefined) return ()=>null;
                return (0, $22tcT.removeLinkEditorCommand)(pos, api?.analytics?.actions);
            }
        },
        actions: {
            hideLinkToolbar: (0, $22tcT.hideLinkToolbarSetMeta),
            insertLink: (inputMethod, from, to, href, title, displayText, cardsAvailable = false, sourceEvent, appearance)=>(0, $22tcT.insertLinkWithAnalytics)(inputMethod, from, to, href, api?.card?.actions, api?.analytics?.actions, title, displayText, cardsAvailable, sourceEvent, appearance),
            updateLink: (0, $22tcT.updateLink)
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            return (0, $6VwLP.stateKey).getState(editorState);
        },
        pmPlugins () {
            return [
                {
                    name: 'hyperlink',
                    plugin: ({ dispatch: dispatch, getIntl: getIntl })=>(0, $6VwLP.plugin)(dispatch, getIntl(), options?.editorAppearance, api, options?.onClickCallback, // @ts-ignore Temporary solution to check for Live Page editor.
                        options.__livePage)
                },
                {
                    name: 'fakeCursorToolbarPlugin',
                    plugin: ()=>(0, $2db3fe02ec916f4c$export$2e2bcd8739ae039)
                },
                {
                    name: 'hyperlinkInputRule',
                    plugin: ({ schema: schema })=>(0, $9bb794acdd7e372a$export$dc83f374e2af640d)(schema, api?.analytics?.actions, options.autoLinkOnBlur)
                },
                {
                    name: 'hyperlinkKeymap',
                    plugin: ()=>(0, $cc6b937a2abc69f3$export$1d7b13ce0747fbd)(api?.analytics?.actions)
                },
                {
                    name: 'hyperlinkToolbarButtons',
                    plugin: ()=>{
                        const hasCard = !!api?.card?.actions;
                        return (0, $03379beda430460c$export$faf11097578346af)(hasCard ? {
                            skipAnalytics: true
                        } : undefined);
                    }
                }
            ];
        },
        pluginsOptions: {
            quickInsert: ({ formatMessage: formatMessage })=>[
                    {
                        id: 'hyperlink',
                        title: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).link),
                        description: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).linkDescription),
                        keywords: [
                            'hyperlink',
                            'url'
                        ],
                        priority: (0, $1oCLl.expValEquals)('confluence_quick_insert_embeds', 'cohort', 'prioritizeLinkInQIM', 'control') ? -300 : 1200,
                        keyshortcut: (0, $hgeg8.tooltip)((0, $hgeg8.addLink)),
                        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3pLGZ.IconLink), null),
                        action (insert, state) {
                            const tr = insert(undefined);
                            tr.setMeta((0, $6VwLP.stateKey), {
                                type: (0, $86XId.LinkAction).SHOW_INSERT_TOOLBAR,
                                inputMethod: (0, $d925B.INPUT_METHOD).QUICK_INSERT
                            });
                            const analyticsAttached = api?.analytics?.actions?.attachAnalyticsEvent?.({
                                action: (0, $d925B.ACTION).INVOKED,
                                actionSubject: (0, $d925B.ACTION_SUBJECT).TYPEAHEAD,
                                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).TYPEAHEAD_LINK,
                                attributes: {
                                    inputMethod: (0, $d925B.INPUT_METHOD).QUICK_INSERT
                                },
                                eventType: (0, $d925B.EVENT_TYPE).UI
                            })(tr);
                            return analyticsAttached !== false ? tr : false;
                        }
                    }
                ],
            floatingToolbar: (0, $417e19eda6a34f02$export$86ce8f8241c20a3)(options, api),
            ...!isToolbarAIFCEnabled && {
                selectionToolbar: (state, { formatMessage: formatMessage })=>{
                    const toolbarDocking = (0, $dh538.fg)('platform_editor_use_preferences_plugin') ? api?.userPreferences?.sharedState.currentState()?.preferences.toolbarDockingPosition : api?.selectionToolbar?.sharedState?.currentState()?.toolbarDocking;
                    if (toolbarDocking === 'none' && (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1', {
                        exposure: true
                    })) {
                        const toolbarButton = ()=>{
                            const { from: from, to: to } = state.selection;
                            const isEnabled = (0, $j9WGh.canLinkBeCreatedInRange)(from, to)(state);
                            const title = formatMessage((0, $4HWgE.toolbarInsertBlockMessages).link);
                            return {
                                type: 'button',
                                disabled: !isEnabled,
                                testId: `${$19e770218fcc89ff$var$selectionToolbarLinkButtonTestId}`,
                                icon: (0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))),
                                title: title,
                                tooltipContent: (0, $hgeg8.tooltip)((0, $hgeg8.addLink), title),
                                showTitle: false,
                                onClick: (state, dispatch)=>{
                                    return (0, $gmyMu.editorCommandToPMCommand)((0, $22tcT.showLinkToolbar)((0, $d925B.INPUT_METHOD).FLOATING_TB, api?.analytics?.actions))(state, dispatch);
                                }
                            };
                        };
                        return {
                            isToolbarAbove: true,
                            items: [
                                toolbarButton()
                            ],
                            rank: 2
                        };
                    } else return undefined;
                }
            },
            ...!isToolbarAIFCEnabled && {
                primaryToolbarComponent: !api?.primaryToolbar && (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1', {
                    exposure: true
                }) ? primaryToolbarComponent : undefined
            }
        }
    };
};
module.exports["hyperlinkPlugin"] = $19e770218fcc89ff$export$8143923e8601d272;

});

parcelRegister("22tcT", function(module, exports) {

var $d925B = parcelRequire("d925B");

var $iGbqR = parcelRequire("iGbqR");


var $19Q6F = parcelRequire("19Q6F");

var $doRn8 = parcelRequire("doRn8");


var $dAtrv = parcelRequire("dAtrv");


var $9rqFK = parcelRequire("9rqFK");

var $86XId = parcelRequire("86XId");


var $gmyMu = parcelRequire("gmyMu");


var $b0F8r = parcelRequire("b0F8r");

var $lSdQB = parcelRequire("lSdQB");


var $ks2lK = parcelRequire("ks2lK");


var $6VwLP = parcelRequire("6VwLP");

function $2c1efd8bbbdacd9a$var$setLinkHrefEditorCommand(href, pos, editorAnalyticsApi, to, isTabPressed) {
    return ({ tr: tr })=>{
        if (!(0, $9rqFK.isTextAtPos)(pos)({
            tr: tr
        })) return null;
        const $pos = tr.doc.resolve(pos);
        const node = tr.doc.nodeAt(pos);
        const linkMark = tr.doc.type.schema.marks.link;
        const mark = linkMark.isInSet(node.marks);
        const url = (0, $lSdQB.normalizeUrl)(href);
        if (mark && mark.attrs.href === url) return null;
        const rightBound = to && pos !== to ? to : pos - $pos.textOffset + node.nodeSize;
        tr.removeMark(pos, rightBound, linkMark);
        if (href.trim()) tr.addMark(pos, rightBound, linkMark.create({
            ...mark && mark.attrs || {},
            href: url
        }));
        else editorAnalyticsApi?.attachAnalyticsEvent((0, $iGbqR.unlinkPayload)((0, $d925B.ACTION_SUBJECT_ID).HYPERLINK))(tr);
        if (!isTabPressed) tr.setMeta((0, $6VwLP.stateKey), {
            type: (0, $86XId.LinkAction).HIDE_TOOLBAR
        });
        return tr;
    };
}
function $2c1efd8bbbdacd9a$export$911a683cdd8a2ccf(href, pos, editorAnalyticsApi, to, isTabPressed) {
    return (0, $gmyMu.editorCommandToPMCommand)($2c1efd8bbbdacd9a$var$setLinkHrefEditorCommand(href, pos, editorAnalyticsApi, to, isTabPressed));
}
function $2c1efd8bbbdacd9a$export$1f68f6e2d4509ef7(href, text, pos, to) {
    return ({ tr: tr })=>{
        const $pos = tr.doc.resolve(pos);
        const node = tr.doc.nodeAt(pos);
        if (!node) return null;
        const url = (0, $lSdQB.normalizeUrl)(href);
        const mark = tr.doc.type.schema.marks.link.isInSet(node.marks);
        const linkMark = tr.doc.type.schema.marks.link;
        const rightBound = to && pos !== to ? to : pos - $pos.textOffset + node.nodeSize;
        if (!url && text) {
            tr.removeMark(pos, rightBound, linkMark);
            tr.insertText(text, pos, rightBound);
        } else if (!url) return null;
        else {
            tr.insertText(text, pos, rightBound);
            // Casting to LinkAttributes to prevent wrong attributes been passed (Example ED-7951)
            const linkAttrs = {
                ...mark && mark.attrs || {},
                href: url
            };
            tr.addMark(pos, pos + text.length, linkMark.create(linkAttrs));
            tr.setMeta((0, $6VwLP.stateKey), {
                type: (0, $86XId.LinkAction).HIDE_TOOLBAR
            });
        }
        return tr;
    };
}
function $2c1efd8bbbdacd9a$export$468bc07728835ac4(href, text, pos, to) {
    return (0, $gmyMu.editorCommandToPMCommand)($2c1efd8bbbdacd9a$export$1f68f6e2d4509ef7(href, text, pos, to));
}
function $2c1efd8bbbdacd9a$export$c13c4fbf8f656592(from, to, incomingHref, incomingTitle, displayText, source, sourceEvent, appearance = 'inline', cardApiActions) {
    return (state, dispatch)=>{
        const link = state.schema.marks.link;
        const { tr: tr } = state;
        if (incomingHref.trim()) {
            const normalizedUrl = (0, $lSdQB.normalizeUrl)(incomingHref);
            // NB: in this context, `currentText` represents text which has been
            // highlighted in the Editor, upon which a link is is being added.
            const currentText = (0, $6VwLP.stateKey).getState(state)?.activeText;
            let markEnd = to;
            const text = displayText || incomingTitle || incomingHref;
            if (!displayText || displayText !== currentText) {
                tr.insertText(text, from, to);
                // new block created to wrap the link
                if (tr.mapping.map(from) === from + text.length + 2) // +1 is for the block's opening tag
                markEnd = from + text.length + 1;
                else markEnd = from + text.length;
            }
            tr.addMark(from, markEnd, link.create({
                href: normalizedUrl
            }));
            tr.setSelection((0, $ks2lK.Selection).near(tr.doc.resolve(markEnd)));
            if (!displayText || displayText === incomingHref) {
                const queueCardsFromChangedTr = cardApiActions?.queueCardsFromChangedTr;
                if (queueCardsFromChangedTr) queueCardsFromChangedTr?.(state, tr, // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                source, (0, $d925B.ACTION).INSERTED, false, sourceEvent, appearance);
                else (0, $19Q6F.addLinkMetadata)(state.selection, tr, {
                    action: (0, $d925B.ACTION).INSERTED,
                    inputMethod: source,
                    sourceEvent: sourceEvent
                });
            } else /**
				 * Add link metadata because queue cards would have otherwise handled this for us
				 */ (0, $19Q6F.addLinkMetadata)(state.selection, tr, {
                action: (0, $d925B.ACTION).INSERTED,
                inputMethod: source,
                sourceEvent: sourceEvent
            });
            tr.setMeta((0, $6VwLP.stateKey), {
                type: (0, $86XId.LinkAction).HIDE_TOOLBAR
            });
            if (dispatch) dispatch(tr);
            return true;
        }
        tr.setMeta((0, $6VwLP.stateKey), {
            type: (0, $86XId.LinkAction).HIDE_TOOLBAR
        });
        if (dispatch) dispatch(tr);
        return false;
    };
}
const $2c1efd8bbbdacd9a$export$61f4de3ecc2b935b = (inputMethod, from, to, href, cardActions, editorAnalyticsApi, title, displayText, cardsAvailable = false, sourceEvent, appearance)=>{
    // If smart cards are available, we send analytics for hyperlinks when a smart link is rejected.
    if (cardsAvailable && !title && !displayText) return $2c1efd8bbbdacd9a$export$c13c4fbf8f656592(from, to, href, title, displayText, inputMethod, sourceEvent, appearance, cardActions);
    return (0, $dAtrv.withAnalytics)(editorAnalyticsApi, (0, $b0F8r.getLinkCreationAnalyticsEvent)(inputMethod, href))($2c1efd8bbbdacd9a$export$c13c4fbf8f656592(from, to, href, title, displayText, inputMethod, sourceEvent, appearance, cardActions));
};
function $2c1efd8bbbdacd9a$export$91d8072017908bea(pos, editorAnalyticsApi) {
    return (0, $doRn8.commandWithMetadata)($2c1efd8bbbdacd9a$export$911a683cdd8a2ccf('', pos, editorAnalyticsApi), {
        action: (0, $d925B.ACTION).UNLINK
    });
}
function $2c1efd8bbbdacd9a$export$32e967ed59808fd(pos, editorAnalyticsApi) {
    return ({ tr: tr })=>{
        $2c1efd8bbbdacd9a$var$setLinkHrefEditorCommand('', pos, editorAnalyticsApi)({
            tr: tr
        });
        (0, $19Q6F.addLinkMetadata)(tr.selection, tr, {
            action: (0, $d925B.ACTION).UNLINK
        });
        return tr;
    };
}
function $2c1efd8bbbdacd9a$export$8eb8ea8f98f386b5(editorAnalyticsApi) {
    return (state, dispatch)=>{
        if (dispatch) {
            const { tr: tr } = state;
            tr.setMeta((0, $6VwLP.stateKey), {
                type: (0, $86XId.LinkAction).EDIT_INSERTED_TOOLBAR,
                inputMethod: (0, $d925B.INPUT_METHOD).FLOATING_TB
            });
            editorAnalyticsApi?.attachAnalyticsEvent((0, $iGbqR.buildEditLinkPayload)((0, $d925B.ACTION_SUBJECT_ID).HYPERLINK))(tr);
            dispatch(tr);
        }
        return true;
    };
}
function $2c1efd8bbbdacd9a$export$83c364d103479f90(inputMethod, editorAnalyticsApi) {
    return ({ tr: tr })=>{
        const newTr = tr.setMeta((0, $6VwLP.stateKey), {
            type: (0, $86XId.LinkAction).SHOW_INSERT_TOOLBAR,
            inputMethod: inputMethod
        });
        editorAnalyticsApi?.attachAnalyticsEvent({
            action: (0, $d925B.ACTION).INVOKED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).TYPEAHEAD,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).TYPEAHEAD_LINK,
            attributes: {
                inputMethod: inputMethod
            },
            eventType: (0, $d925B.EVENT_TYPE).UI
        })(newTr);
        return newTr;
    };
}
function $2c1efd8bbbdacd9a$export$bd1cd60a9b31da5e() {
    return function(state, dispatch) {
        if (dispatch) dispatch($2c1efd8bbbdacd9a$export$534add8453a7a184(state.tr));
        return true;
    };
}
const $2c1efd8bbbdacd9a$export$534add8453a7a184 = (tr)=>{
    return tr.setMeta((0, $6VwLP.stateKey), {
        type: (0, $86XId.LinkAction).HIDE_TOOLBAR
    });
};
const $2c1efd8bbbdacd9a$export$34daa751a305794c = (cardActions)=>(state, dispatch)=>{
        const { tr: tr } = state;
        $2c1efd8bbbdacd9a$export$534add8453a7a184(tr);
        cardActions?.hideLinkToolbar?.(tr);
        if (dispatch) {
            dispatch(tr);
            return true;
        }
        return false;
    };
const $2c1efd8bbbdacd9a$export$e72685a867c8a4f2 = (state, dispatch)=>{
    if (dispatch) {
        $2c1efd8bbbdacd9a$export$bd1cd60a9b31da5e()(state, dispatch);
        return true;
    }
    return false;
};
module.exports["updateLinkEditorCommand"] = $2c1efd8bbbdacd9a$export$1f68f6e2d4509ef7;
module.exports["updateLink"] = $2c1efd8bbbdacd9a$export$468bc07728835ac4;
module.exports["insertLinkWithAnalytics"] = $2c1efd8bbbdacd9a$export$61f4de3ecc2b935b;
module.exports["removeLink"] = $2c1efd8bbbdacd9a$export$91d8072017908bea;
module.exports["removeLinkEditorCommand"] = $2c1efd8bbbdacd9a$export$32e967ed59808fd;
module.exports["editInsertedLink"] = $2c1efd8bbbdacd9a$export$8eb8ea8f98f386b5;
module.exports["showLinkToolbar"] = $2c1efd8bbbdacd9a$export$83c364d103479f90;
module.exports["hideLinkToolbar"] = $2c1efd8bbbdacd9a$export$bd1cd60a9b31da5e;
module.exports["hideLinkToolbarSetMeta"] = $2c1efd8bbbdacd9a$export$534add8453a7a184;
module.exports["onEscapeCallback"] = $2c1efd8bbbdacd9a$export$34daa751a305794c;
module.exports["onClickAwayCallback"] = $2c1efd8bbbdacd9a$export$e72685a867c8a4f2;

});

parcelRegister("19Q6F", function(module, exports) {

var $8EkET = parcelRequire("8EkET");

function $c9fb00f95255b8e2$export$e2d4855dca88ecc1(initialSelection, tr, metadata) {
    const { storedMarks: storedMarks } = tr;
    const pos = tr.mapping.map(initialSelection.$from.pos);
    tr.step(new (0, $8EkET.LinkMetaStep)(pos, metadata));
    // When you add a new step all the storedMarks are removed it
    if (storedMarks) tr.setStoredMarks(storedMarks);
    return tr;
}
module.exports["addLinkMetadata"] = $c9fb00f95255b8e2$export$e2d4855dca88ecc1;

});

parcelRegister("8EkET", function(module, exports) {

var $5SAOw = parcelRequire("5SAOw");


var $aXG5V = parcelRequire("aXG5V");

var $cO9ey = parcelRequire("cO9ey");

const $1260724267f46a71$export$954e3f6aa93d9ba3 = 'editor-linking-meta';
const $1260724267f46a71$export$2774298c489a128f = 'editor-linking-meta-invert';
class $1260724267f46a71$export$40e33c9d27895078 extends (0, $cO9ey.Step) {
    getMetadata() {
        return this.metadata;
    }
    /**
   * Generate new undo/redo analytics event when step is inverted
   */ invert() {
        /**
     * Omit sourceEvent in history
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { sourceEvent: sourceEvent, ...metadata } = this.metadata;
        return new $1260724267f46a71$export$40e33c9d27895078(this.pos, metadata, true);
    }
    // Should make no modifications to the doc
    apply(doc) {
        return (0, $aXG5V.StepResult).ok(doc);
    }
    map(mapping) {
        let newPos = this.pos;
        if (typeof newPos === 'number') newPos = mapping.map(newPos);
        // Return the same events, this step will never be removed
        return new $1260724267f46a71$export$40e33c9d27895078(newPos, this.metadata, this.isInverted);
    }
    getMap() {
        return new (0, $aXG5V.StepMap)([
            this.pos || 0,
            0,
            0
        ]);
    }
    // Return null to avoid merging events
    merge() {
        return null;
    }
    toJSON() {
        // When serialized we should create a noop Replace step
        return {
            stepType: 'replace',
            from: 0,
            to: 0
        };
    }
    static fromJSON() {
        // This is a "local custom step" once serialized
        // we need to transform it in a no-operation action
        return new (0, $aXG5V.ReplaceStep)(0, 0, (0, $5SAOw.Slice).empty);
    }
    constructor(pos, metadata, isInverted = false){
        super(), this.pos = pos, this.metadata = metadata, this.isInverted = isInverted;
    }
}
/** Register this step with Prosemirror */ (0, $cO9ey.Step).jsonID($1260724267f46a71$export$954e3f6aa93d9ba3, $1260724267f46a71$export$40e33c9d27895078);
module.exports["LinkMetaStep"] = $1260724267f46a71$export$40e33c9d27895078;

});

parcelRegister("doRn8", function(module, exports) {

var $19Q6F = parcelRequire("19Q6F");


const $459e427a0f132e6d$export$76125a95b70625ac = (command, metadata)=>{
    return (state, dispatch, view)=>{
        if (!dispatch) return command(state, dispatch, view);
        return command(state, (tr)=>{
            (0, $19Q6F.addLinkMetadata)(state.selection, tr, metadata);
            dispatch(tr);
        }, view);
    };
};
module.exports["commandWithMetadata"] = $459e427a0f132e6d$export$76125a95b70625ac;

});

parcelRegister("i9vfM", function(module, exports) {

var $kfZYI = parcelRequire("kfZYI");


var $iu6m9 = parcelRequire("iu6m9");

const $94b174dea6a56edc$export$f0972e90f14682b1 = '/manage-profile/link-preferences';




const $04323d2467b48d43$var$STAGING = 'staging';
const $04323d2467b48d43$var$PRODUCTION = 'prod';
const $04323d2467b48d43$var$DEV = 'dev';
const $04323d2467b48d43$export$e5404273592f5dbd = ()=>{
    const envType = $04323d2467b48d43$var$PRODUCTION;
    return (0, $kfZYI.getUrlForDomainInContext)('id', envType) + (0, $94b174dea6a56edc$export$f0972e90f14682b1);
};
const $04323d2467b48d43$var$isSelectionInsideLink = (state)=>!!state.doc.type.schema.marks.link.isInSet(state.selection.$from.marks());
const $04323d2467b48d43$var$isEmptySelectionBeforeLink = (state)=>{
    const { $from: $from, $to: $to } = state.selection;
    return $from === $to && !!state.doc.type.schema.marks.link.isInSet($from.nodeAfter?.marks || []);
};
const $04323d2467b48d43$var$isEmptySelectionAfterLink = (state)=>{
    const { $from: $from, $to: $to } = state.selection;
    return $from === $to && !!state.doc.type.schema.marks.link.isInSet($from.nodeBefore?.marks || []);
};
const $04323d2467b48d43$var$isSelectionAroundLink = (state)=>{
    const { $from: $from, $to: $to } = state.selection;
    const node = $from.nodeAfter;
    return !!node && $from.textOffset === 0 && $to.pos - $from.pos === node.nodeSize && !!state.doc.type.schema.marks.link.isInSet(node.marks);
};
const $04323d2467b48d43$export$819e108a65d33088 = (state)=>{
    const { selection: { $from: $from } } = state;
    if ($04323d2467b48d43$var$isSelectionInsideLink(state) || $04323d2467b48d43$var$isSelectionAroundLink(state)) {
        const pos = $from.pos - $from.textOffset;
        const node = state.doc.nodeAt(pos);
        return node && node.isText ? {
            node: node,
            pos: pos
        } : undefined;
    }
    if ($04323d2467b48d43$var$isEmptySelectionBeforeLink(state) && (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) {
        // if user clicks right before the link, we want to show the toolbar for the link
        // but only if the link is a single character
        const node = state.doc.nodeAt($from.pos);
        return node && node.isText && node.nodeSize === 1 ? {
            node: node,
            pos: $from.pos
        } : undefined;
    }
    if ($04323d2467b48d43$var$isEmptySelectionAfterLink(state) && (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) {
        // if user clicks right after the link, we want to show the toolbar for the link
        // but only if the link is a single character
        // and we return the position of the link
        const node = state.doc.nodeAt($from.pos - 1);
        return node && node.isText && node.nodeSize === 1 ? {
            node: node,
            pos: $from.pos - 1
        } : undefined;
    }
    return undefined;
};
module.exports["getLinkPreferencesURLFromENV"] = $04323d2467b48d43$export$e5404273592f5dbd;
module.exports["getActiveLinkMark"] = $04323d2467b48d43$export$819e108a65d33088;

});

parcelRegister("6YpFi", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1oCLl = parcelRequire("1oCLl");


var $d925B = parcelRequire("d925B");


var $dYBVS = parcelRequire("dYBVS");





var $5zdke = parcelRequire("5zdke");


var $bYRk6 = parcelRequire("bYRk6");


var $4iPjq = parcelRequire("4iPjq");





var $lWghV = parcelRequire("lWghV");




const $dbb1025808306c40$export$886f2fdec3f419af = (onEscape, onClickAway)=>{
    const ref = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        const handleClickAway = (event)=>{
            const el = ref.current;
            if (event.target instanceof Element && el && !el.contains(event.target)) onClickAway();
        };
        const handleKeydown = (event)=>{
            if (event.key === 'Escape') {
                event.preventDefault();
                onEscape();
            }
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.addEventListener('mousedown', handleClickAway);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.addEventListener('keydown', handleKeydown);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('mousedown', handleClickAway);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('keydown', handleKeydown);
        };
    }, [
        onClickAway,
        onEscape
    ]);
    return ref;
};


const $5d1db7e2a1c0eca0$var$PREVENT_SCROLL = {
    preventScroll: true
};
const $5d1db7e2a1c0eca0$export$da2f76555f5c8d0a = ({ view: view, onCancel: onCancel, invokeMethod: invokeMethod = '_unknown', editorAppearance: editorAppearance, onClose: onClose, onEscapeCallback: onEscapeCallback, onClickAwayCallback: onClickAwayCallback, ...restProps })=>{
    /**
   * Track onClose handler in a
   * ref so that we void needing it in the dependency array
   * below
   */ const onCloseRef = (0, $42omo.useRef)(onClose);
    (0, $42omo.useEffect)(()=>{
        onCloseRef.current = onClose;
    });
    /**
   * Call onClose on mount, usefull to provide
   * a handler for performing an action after the component has been
   * unmounted (e.g. return focus to the editors)
   */ (0, $42omo.useEffect)(()=>()=>onCloseRef.current?.(), []);
    const onEscape = (0, $42omo.useCallback)(()=>{
        const { state: state, dispatch: dispatch } = view;
        onEscapeCallback?.(state, dispatch);
        onCancel?.();
    }, [
        view,
        onCancel,
        onEscapeCallback
    ]);
    const onClickAway = (0, $42omo.useCallback)(()=>{
        const { state: state, dispatch: dispatch } = view;
        onClickAwayCallback?.(state, dispatch);
        onCancel?.();
    }, [
        view,
        onCancel,
        onClickAwayCallback
    ]);
    const ref = (0, $dbb1025808306c40$export$886f2fdec3f419af)(onEscape, onClickAway);
    const analyticsEditorAppearance = (0, $lWghV.getAnalyticsEditorAppearance)(editorAppearance);
    const analyticsData = (0, $42omo.useMemo)(()=>({
            attributes: {
                invokeMethod: invokeMethod,
                location: analyticsEditorAppearance
            },
            // Below is added for the future implementation of Linking Platform namespaced analytic context
            location: analyticsEditorAppearance
        }), [
        invokeMethod,
        analyticsEditorAppearance
    ]);
    const returnFocus = (0, $1oCLl.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? $5d1db7e2a1c0eca0$var$PREVENT_SCROLL : // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- intentional fallback for experiment off path
    {
        preventScroll: true
    };
    const focusOptions = (0, $1oCLl.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? $5d1db7e2a1c0eca0$var$PREVENT_SCROLL : // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- intentional fallback for experiment off path
    {
        preventScroll: true
    };
    if ((0, $1oCLl.expValEquals)('platform_editor_a11y_escape_link_dialog', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: ref,
        "data-vc": "JJZfPGvP"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bYRk6.default), {
        data: analyticsData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5zdke.default), {
        returnFocus: returnFocus,
        focusOptions: focusOptions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4iPjq.default), {
        ...restProps,
        onCancel: onEscape
    }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bYRk6.default), {
        data: analyticsData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4iPjq.default), {
        ...restProps,
        onCancel: onEscape
    })));
};


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $9K4OG = parcelRequire("9K4OG");


var $jSnXV = parcelRequire("jSnXV");


var $jTxSS = parcelRequire("jTxSS");





var $aXWIB = parcelRequire("aXWIB");


var $81OAa = parcelRequire("81OAa");


var $1DWH0 = parcelRequire("1DWH0");


var $7yDmn = parcelRequire("7yDmn");


var $8hhCV = parcelRequire("8hhCV");


var $2W0qg = parcelRequire("2W0qg");

var $ecnYn = parcelRequire("ecnYn");





var $3gadb = parcelRequire("3gadb");




var $ajtqX = parcelRequire("ajtqX");


var $cftLn = parcelRequire("cftLn");

var $8i5w2 = parcelRequire("8i5w2");


var $lSdQB = parcelRequire("lSdQB");


var $d7ZU3 = parcelRequire("d7ZU3");


var $48vaT = parcelRequire("48vaT");


var $3a8Ut = parcelRequire("3a8Ut");


var $1j5Rt = parcelRequire("1j5Rt");

function $ee4435520cbe783a$export$8437fc55448c6e05(arr, comparator) {
    return arr.filter((firstItem, index, self)=>{
        return self.findIndex((secondItem)=>comparator ? comparator(firstItem, secondItem) : firstItem === secondItem) === index;
    });
}



var $liOw1 = parcelRequire("liOw1");


var $k8ulM = parcelRequire("k8ulM");

const $8611e6cce9b571e1$export$5091bdda49ba90f5 = (input)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($k8ulM))).createHash().update(input).digest('hex');
};









var $6iY4P = parcelRequire("6iY4P");


var $l5jcq = parcelRequire("l5jcq");





var $9J3bP = parcelRequire("9J3bP");


var $7G33r = parcelRequire("7G33r");


var $8d3zB = parcelRequire("8d3zB");


var $dh538 = parcelRequire("dh538");




const $70670bfa292abd08$export$ecd9e62648c1046a = (0, $aXWIB.defineMessages)({
    hyperlinkIconIssueLabel: {
        id: "fabric.editor.headingLink.hyperlinkIconIssueLabel",
        defaultMessage: "Issue"
    },
    hyperlinkIconBugLabel: {
        id: "fabric.editor.headingLink.hyperlinkIconBugLabel",
        defaultMessage: "Bug"
    },
    hyperlinkIconStoryLabel: {
        id: "fabric.editor.headingLink.hyperlinkIconStoryLabel",
        defaultMessage: "Story"
    },
    hyperlinkIconTaskLabel: {
        id: "fabric.editor.headingLink.hyperlinkIconTaskLabel",
        defaultMessage: "Task"
    },
    hyperlinkIconPageLabel: {
        id: "fabric.editor.headingLink.hyperlinkIconPageLabel",
        defaultMessage: "Page"
    },
    hyperlinkIconBlogLabel: {
        id: "fabric.editor.headingLink.hyperlinkIconBlogLabel",
        defaultMessage: "Blog"
    },
    hyperlinkIconIssueLabelIssueTermRefresh: {
        id: "fabric.editor.headingLink.hyperlinkIconIssueLabel.issue-term-refresh",
        defaultMessage: "Work Item"
    }
});





const $7b715f0c422234c4$var$Issue16 = (props)=>{
    const { intl: intl } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8d3zB.default), {
        label: intl.formatMessage((0, $dh538.fg)('confluence-issue-terminology-refresh') ? (0, $70670bfa292abd08$export$ecd9e62648c1046a).hyperlinkIconIssueLabelIssueTermRefresh : (0, $70670bfa292abd08$export$ecd9e62648c1046a).hyperlinkIconIssueLabel)
    });
};
const $7b715f0c422234c4$var$Bug16 = (props)=>{
    const { intl: intl } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $l5jcq.default), {
        label: intl.formatMessage((0, $70670bfa292abd08$export$ecd9e62648c1046a).hyperlinkIconBugLabel)
    });
};
const $7b715f0c422234c4$var$Story16 = (props)=>{
    const { intl: intl } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9J3bP.default), {
        label: intl.formatMessage((0, $70670bfa292abd08$export$ecd9e62648c1046a).hyperlinkIconStoryLabel)
    });
};
const $7b715f0c422234c4$var$Task16 = (props)=>{
    const { intl: intl } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7G33r.default), {
        label: intl.formatMessage((0, $70670bfa292abd08$export$ecd9e62648c1046a).hyperlinkIconTaskLabel)
    });
};
const $7b715f0c422234c4$var$Page16 = (props)=>{
    const { intl: intl } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8hhCV.default), {
        label: intl.formatMessage((0, $70670bfa292abd08$export$ecd9e62648c1046a).hyperlinkIconPageLabel)
    });
};
const $7b715f0c422234c4$var$Blog16 = (props)=>{
    const { intl: intl } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6iY4P.default), {
        label: intl.formatMessage((0, $70670bfa292abd08$export$ecd9e62648c1046a).hyperlinkIconBlogLabel)
    });
};
const $7b715f0c422234c4$var$IntlIssue16Icon = (0, $aXWIB.injectIntl)($7b715f0c422234c4$var$Issue16);
const $7b715f0c422234c4$var$IntlBug16Icon = (0, $aXWIB.injectIntl)($7b715f0c422234c4$var$Bug16);
const $7b715f0c422234c4$var$IntlStory16Icon = (0, $aXWIB.injectIntl)($7b715f0c422234c4$var$Story16);
const $7b715f0c422234c4$var$IntlTask16Icon = (0, $aXWIB.injectIntl)($7b715f0c422234c4$var$Task16);
const $7b715f0c422234c4$var$IntlPage16Icon = (0, $aXWIB.injectIntl)($7b715f0c422234c4$var$Page16);
const $7b715f0c422234c4$var$IntlBlog16Icon = (0, $aXWIB.injectIntl)($7b715f0c422234c4$var$Blog16);
const $7b715f0c422234c4$export$80e948449ec854a9 = {
    'jira.issue': /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7b715f0c422234c4$var$IntlIssue16Icon, null),
    'jira.issue.bug': /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7b715f0c422234c4$var$IntlBug16Icon, null),
    'jira.issue.story': /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7b715f0c422234c4$var$IntlStory16Icon, null),
    'jira.issue.task': /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7b715f0c422234c4$var$IntlTask16Icon, null),
    'confluence.page': /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7b715f0c422234c4$var$IntlPage16Icon, null),
    'confluence.blogpost': /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7b715f0c422234c4$var$IntlBlog16Icon, null)
};


const $96e7c6113f32482e$export$24d5ff955141c347 = (input)=>{
    return input.split(' ').length;
};


function $7d851d84bd595a70$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7d851d84bd595a70$export$8dd524ceb40e3d16 = {
    name: "19nbz8q",
    styles: "clip:rect(1px, 1px, 1px, 1px);clip-path:inset(50%);height:1px;width:1px;margin:var(--ds-space-negative-025, -2px);overflow:hidden;padding:0;position:absolute"
};
const $7d851d84bd595a70$export$452f1062ecf44be7 = 5;
const $7d851d84bd595a70$var$clearTextButtonStyles = (0, $ecnYn.xcss)({
    padding: 'space.0',
    marginRight: 'space.100',
    backgroundColor: 'color.background.neutral.subtle',
    border: 'none'
});
const $7d851d84bd595a70$var$clearTextWrapper = {
    name: "154v9b4",
    styles: "position:absolute;right:0"
};
const $7d851d84bd595a70$var$containerPadding = /*#__PURE__*/ (0, $9K4OG.css)({
    padding: `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-100, 8px)"}`
});
const $7d851d84bd595a70$var$textLabelMargin = {
    name: "1s21os8",
    styles: "margin-top:var(--ds-space-150, 12px)"
};
const $7d851d84bd595a70$var$inputLabel = {
    name: "oad2n7",
    styles: "color:var(--ds-text-subtlest, #6B6E76);padding-bottom:var(--ds-space-050, 4px);font:var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);font-weight:var(--ds-font-weight-medium, 500)"
};
const $7d851d84bd595a70$var$inputWrapperPosition = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $7d851d84bd595a70$var$defaultIcon = /*#__PURE__*/ (0, $9K4OG.jsx)((0, $8hhCV.default), {
    label: "page"
});
const $7d851d84bd595a70$var$mapActivityProviderResultToLinkSearchItemData = ({ name: name, container: container, iconUrl: iconUrl, objectId: objectId, url: url, viewedTimestamp: viewedTimestamp })=>({
        objectId: objectId,
        name: name,
        container: container,
        iconUrl: iconUrl,
        url: url,
        lastViewedDate: viewedTimestamp ? new Date(viewedTimestamp) : undefined,
        prefetch: true
    });
const $7d851d84bd595a70$var$mapSearchProviderResultToLinkSearchItemData = ({ objectId: objectId, container: container, title: title, contentType: contentType, url: url, updatedTimestamp: updatedTimestamp })=>({
        objectId: objectId,
        container: container,
        name: title,
        url: url,
        lastUpdatedDate: updatedTimestamp ? new Date(updatedTimestamp) : undefined,
        icon: contentType && (0, $7b715f0c422234c4$export$80e948449ec854a9)[contentType] || $7d851d84bd595a70$var$defaultIcon,
        prefetch: false
    });
class $7d851d84bd595a70$export$7acbf008e0847b89 extends (0, $42omo.PureComponent) {
    async componentDidMount() {
        const { timesViewed: timesViewed, inputMethod: inputMethod, searchSessionId: searchSessionId } = this.props;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners, @atlaskit/platform/no-direct-document-usage
        document.addEventListener('mousedown', this.handleClickOutside);
        this.fireAnalytics({
            action: (0, $d925B.ACTION).VIEWED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).CREATE_LINK_INLINE_DIALOG,
            attributes: {
                timesViewed: timesViewed ?? 0,
                searchSessionId: searchSessionId ?? '',
                trigger: inputMethod ?? ''
            },
            eventType: (0, $d925B.EVENT_TYPE).SCREEN
        });
        const [activityProvider, searchProvider] = await Promise.all([
            this.props.activityProvider,
            this.props.searchProvider
        ]);
        // loadInitialLinkSearchResult and updateInput rely on activityProvider being set in state
        (0, $jTxSS.flushSync)(()=>this.setState({
                activityProvider: activityProvider,
                searchProvider: searchProvider
            }));
        await this.loadInitialLinkSearchResult();
    }
    componentWillUnmount() {
        const { searchSessionId: searchSessionId } = this.props;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners, @atlaskit/platform/no-direct-document-usage
        document.removeEventListener('mousedown', this.handleClickOutside);
        if (!this.submitted) this.fireAnalytics({
            action: (0, $d925B.ACTION).DISMISSED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).CREATE_LINK_INLINE_DIALOG,
            attributes: {
                source: this.analyticSource,
                searchSessionId: searchSessionId ?? '',
                trigger: 'blur'
            },
            eventType: (0, $d925B.EVENT_TYPE).UI
        });
    }
    async getRecentItems(activityProvider, query) {
        const { searchSessionId: searchSessionId } = this.props;
        const perfStart = performance.now();
        try {
            const activityRecentItems = $7d851d84bd595a70$var$limit(query ? await activityProvider.searchRecent(query) : await activityProvider.getRecentItems());
            const items = activityRecentItems.map($7d851d84bd595a70$var$mapActivityProviderResultToLinkSearchItemData);
            const perfStop = performance.now();
            const duration = perfStop - perfStart;
            this.fireAnalytics({
                action: (0, $d925B.ACTION).INVOKED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).SEARCH_RESULT,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).RECENT_ACTIVITIES,
                attributes: {
                    duration: duration,
                    count: items.length
                },
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
            });
            this.fireAnalytics({
                action: (0, $d925B.ACTION).SHOWN,
                actionSubject: (0, $d925B.ACTION_SUBJECT).SEARCH_RESULT,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).PRE_QUERY_SEARCH_RESULTS,
                attributes: {
                    source: this.analyticSource,
                    preQueryRequestDurationMs: duration,
                    searchSessionId: searchSessionId ?? '',
                    resultCount: items.length,
                    results: activityRecentItems.map((item)=>({
                            resultContentId: item.objectId,
                            resultType: item.type ?? ''
                        }))
                },
                eventType: (0, $d925B.EVENT_TYPE).UI
            });
            return items;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            const perfStop = performance.now();
            const duration = perfStop - perfStart;
            this.fireAnalytics({
                action: (0, $d925B.ACTION).INVOKED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).SEARCH_RESULT,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).RECENT_ACTIVITIES,
                attributes: {
                    duration: duration,
                    count: -1,
                    errorCode: err.status
                },
                eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
            });
            return [];
        }
    }
    fireAnalytics(payload) {
        if (this.props.createAnalyticsEvent && this.fireCustomAnalytics) this.fireCustomAnalytics({
            payload: payload
        });
    }
    async loadInitialLinkSearchResult() {
        const { displayUrl: displayUrl, activityProvider: activityProvider } = this.state;
        try {
            if (!displayUrl && activityProvider) {
                this.setState({
                    isLoading: true
                });
                const items = await this.getRecentItems(activityProvider);
                this.setState({
                    items: items
                });
            }
        } finally{
            this.setState({
                isLoading: false
            });
        }
    }
    render() {
        const { items: items, isLoading: isLoading, selectedIndex: selectedIndex, displayUrl: displayUrl, displayText: displayText } = this.state;
        const { intl: { formatMessage: formatMessage } } = this.props;
        const formatClearLinkText = formatMessage((0, $liOw1.messages).clearLink);
        const screenReaderDescriptionId = 'search-recent-links-field-description';
        const linkSearchListId = 'hyperlink-search-list';
        const ariaActiveDescendant = selectedIndex > -1 ? `link-search-list-item-${selectedIndex}` : '';
        const linkSearchInputId = 'search-recent-links-field-id';
        const displayTextInputId = 'display-text-filed-id';
        const browser = (0, $d7ZU3.getBrowserInfo)();
        // Added workaround with a screen reader Announcer specifically for VoiceOver + Safari
        // as the Aria design pattern for combobox does not work in this case
        // for details: https://a11y-internal.atlassian.net/browse/AK-740
        const screenReaderText = browser.safari && this.getScreenReaderText();
        const hyperlinkElement = /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            "aria-label": formatMessage((0, $liOw1.messages).hyperlinkAriaLabel),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "recent-list",
            "data-testid": "hyperlink-add-toolbar"
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            css: [
                (0, $3a8Ut.container),
                (0, $3a8Ut.narrowContainerWidth),
                $7d851d84bd595a70$var$containerPadding
            ],
            ref: this.wrapperRef,
            "data-vc": "GDY_eqAQ"
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("label", {
            htmlFor: linkSearchInputId,
            css: $7d851d84bd595a70$var$inputLabel
        }, formatMessage((0, $liOw1.messages).linkVisibleLabel)), /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: [
                (0, $3a8Ut.inputWrapper),
                $7d851d84bd595a70$var$inputWrapperPosition
            ]
        }, screenReaderText && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $cftLn.default), {
            ariaLive: "assertive",
            text: screenReaderText,
            ariaRelevant: "additions",
            delay: 250
        }), /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: $7d851d84bd595a70$export$8dd524ceb40e3d16,
            "aria-hidden": "true",
            id: screenReaderDescriptionId
        }, formatMessage((0, $liOw1.messages).searchLinkAriaDescription)), /*#__PURE__*/ (0, $9K4OG.jsx)((0, $8i5w2.default), {
            role: "combobox",
            ariaExpanded: items && items.length > 0 && !isLoading,
            ariaActiveDescendant: ariaActiveDescendant,
            ariaControls: linkSearchListId,
            ariaAutoComplete: true,
            describedById: screenReaderDescriptionId,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            ref: (ele)=>this.urlInputContainer = ele,
            testId: 'link-url',
            onSubmit: this.handleSubmit,
            onChange: this.updateInput,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            autoFocus: {
                preventScroll: true
            },
            onCancel: this.handleCancel,
            defaultValue: displayUrl,
            onKeyDown: this.handleKeyDown,
            inputId: linkSearchInputId
        }), displayUrl && /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: $7d851d84bd595a70$var$clearTextWrapper
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3gadb.default), {
            content: formatClearLinkText
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $2W0qg.default), {
            xcss: $7d851d84bd595a70$var$clearTextButtonStyles,
            onClick: this.handleClearText
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7yDmn))), {
            label: formatClearLinkText,
            color: "var(--ds-icon-subtle, #505258)"
        }))))), /*#__PURE__*/ (0, $9K4OG.jsx)("label", {
            htmlFor: displayTextInputId,
            css: [
                $7d851d84bd595a70$var$inputLabel,
                $7d851d84bd595a70$var$textLabelMargin
            ]
        }, formatMessage((0, $liOw1.messages).textVisibleLabel)), /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: [
                (0, $3a8Ut.inputWrapper),
                $7d851d84bd595a70$var$inputWrapperPosition
            ]
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $8i5w2.default), {
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            ref: (ele)=>this.displayTextInputContainer = ele,
            testId: 'link-text',
            onChange: this.updateTextInput,
            onCancel: this.handleCancel,
            defaultValue: displayText,
            onSubmit: this.handleSubmit,
            onKeyDown: this.handleKeyDown,
            inputId: displayTextInputId
        }), displayText && /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: $7d851d84bd595a70$var$clearTextWrapper
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3gadb.default), {
            content: formatMessage((0, $liOw1.messages).clearText)
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $2W0qg.default), {
            xcss: $7d851d84bd595a70$var$clearTextButtonStyles,
            onClick: this.handleClearDisplayText,
            onKeyDown: this.handleClearTextKeyDown
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7yDmn))), {
            label: formatMessage((0, $liOw1.messages).clearText),
            color: "var(--ds-icon-subtle, #505258)"
        }))))), /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: $7d851d84bd595a70$export$8dd524ceb40e3d16,
            "aria-live": "polite",
            "aria-atomic": "true",
            id: "fabric.editor.hyperlink.suggested.results"
        }, displayUrl && formatMessage((0, $liOw1.messages).searchLinkResults, {
            count: items.length
        })), /*#__PURE__*/ (0, $9K4OG.jsx)((0, $48vaT.default), {
            ariaControls: "fabric.editor.hyperlink.suggested.results",
            id: linkSearchListId,
            role: "listbox",
            items: items,
            isLoading: isLoading,
            selectedIndex: selectedIndex,
            listItemRefCallback: this.listItemRefCallback,
            onFocus: this.handleListItemFocus,
            onBlur: this.handleListItemBlur,
            onKeyDown: this.handleKeyDown,
            onSelect: this.handleSelected,
            onMouseEnter: this.handleMouseEnterResultItem,
            onMouseLeave: this.handleMouseLeaveResultItem
        })));
        if ((0, $1oCLl.expValEquals)('platform_editor_a11y_escape_link_dialog', 'isEnabled', true)) return(// eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        /*#__PURE__*/ (0, $9K4OG.jsx)((0, $5zdke.default), {
            returnFocus: {
                preventScroll: true
            },
            focusOptions: {
                preventScroll: true
            }
        }, hyperlinkElement));
        return hyperlinkElement;
    }
    constructor(props){
        super(props);
        /* To prevent double submit */ this.submitted = false;
        this.urlInputContainer = null;
        this.displayTextInputContainer = null;
        this.wrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
        this.listItemRefs = {
            current: {}
        };
        this.handleClearText = void 0;
        this.handleClearDisplayText = void 0;
        this.debouncedQuickSearch = void 0;
        this.fireCustomAnalytics = void 0;
        this.quickSearchQueryVersion = 0;
        this.analyticSource = 'createLinkInlineDialog';
        this.quickSearch = async (input, items, quickSearchLimit)=>{
            const { searchProvider: searchProvider, displayUrl: displayUrl } = this.state;
            const { searchSessionId: searchSessionId } = this.props;
            if (!searchProvider) return;
            const queryVersion = ++this.quickSearchQueryVersion;
            this.fireAnalytics({
                action: (0, $d925B.ACTION).ENTERED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).LINK_SEARCH_INPUT,
                attributes: {
                    queryLength: input.length,
                    queryVersion: queryVersion,
                    queryHash: (0, $8611e6cce9b571e1$export$5091bdda49ba90f5)(input),
                    searchSessionId: searchSessionId ?? '',
                    wordCount: (0, $96e7c6113f32482e$export$24d5ff955141c347)(input),
                    source: this.analyticSource
                },
                nonPrivacySafeAttributes: {
                    query: input
                },
                eventType: (0, $d925B.EVENT_TYPE).UI
            });
            const perfStart = performance.now();
            try {
                const searchProviderResultItems = await searchProvider.quickSearch(input, quickSearchLimit);
                const searchItems = $7d851d84bd595a70$var$limit((0, $ee4435520cbe783a$export$8437fc55448c6e05)([
                    ...items,
                    ...searchProviderResultItems.map($7d851d84bd595a70$var$mapSearchProviderResultToLinkSearchItemData)
                ], (firstItem, secondItem)=>firstItem.objectId === secondItem.objectId));
                if (displayUrl === input && queryVersion === this.quickSearchQueryVersion) this.setState({
                    items: searchItems,
                    isLoading: false
                });
                const perfStop = performance.now();
                const duration = perfStop - perfStart;
                this.fireAnalytics({
                    action: (0, $d925B.ACTION).INVOKED,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).SEARCH_RESULT,
                    actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).QUICK_SEARCH,
                    attributes: {
                        duration: duration,
                        count: searchProviderResultItems.length
                    },
                    eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
                });
                this.fireAnalytics({
                    action: (0, $d925B.ACTION).SHOWN,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).SEARCH_RESULT,
                    actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).POST_QUERY_SEARCH_RESULTS,
                    attributes: {
                        source: this.analyticSource,
                        postQueryRequestDurationMs: duration,
                        searchSessionId: searchSessionId ?? '',
                        resultCount: searchProviderResultItems.length,
                        results: searchProviderResultItems.map((item)=>({
                                resultContentId: item.objectId,
                                resultType: item.contentType
                            }))
                    },
                    eventType: (0, $d925B.EVENT_TYPE).UI
                });
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (err) {
                const perfStop = performance.now();
                const duration = perfStop - perfStart;
                this.fireAnalytics({
                    action: (0, $d925B.ACTION).INVOKED,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).SEARCH_RESULT,
                    actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).QUICK_SEARCH,
                    attributes: {
                        duration: duration,
                        count: -1,
                        errorCode: err.status
                    },
                    eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
                });
            }
        };
        this.updateInput = async (input)=>{
            const { activityProvider: activityProvider, searchProvider: searchProvider } = this.state;
            this.setState({
                displayUrl: input
            });
            if (activityProvider) {
                if (input.length === 0) this.setState({
                    items: await this.getRecentItems(activityProvider),
                    selectedIndex: -1
                });
                else if ((0, $81OAa.isSafeUrl)(input)) this.setState({
                    items: [],
                    selectedIndex: -1,
                    isLoading: false
                });
                else {
                    const items = await this.getRecentItems(activityProvider, input);
                    const shouldQuerySearchProvider = items.length < $7d851d84bd595a70$export$452f1062ecf44be7 && !!searchProvider;
                    this.setState({
                        items: items,
                        isLoading: shouldQuerySearchProvider
                    });
                    if (shouldQuerySearchProvider) this.debouncedQuickSearch(input, items, $7d851d84bd595a70$export$452f1062ecf44be7);
                }
            }
        };
        this.createClearHandler = (field)=>{
            return async ()=>{
                const { activityProvider: activityProvider } = this.state;
                switch(field){
                    case 'displayUrl':
                        this.setState({
                            [field]: '',
                            items: !!activityProvider ? $7d851d84bd595a70$var$limit(await activityProvider.getRecentItems()) : []
                        });
                        if (this.urlInputContainer) this.urlInputContainer.focus();
                        break;
                    case 'displayText':
                        this.setState({
                            [field]: ''
                        });
                        if (this.displayTextInputContainer) this.displayTextInputContainer.focus();
                }
            };
        };
        this.handleClickOutside = (event)=>{
            if (event.target instanceof Element && this.wrapperRef.current && !this.wrapperRef.current.contains(event.target)) {
                const { view: { state: state, dispatch: dispatch }, onClickAwayCallback: onClickAwayCallback } = this.props;
                onClickAwayCallback?.(state, dispatch);
            }
        };
        this.getScreenReaderText = ()=>{
            const { intl: intl } = this.props;
            const { items: items, selectedIndex: selectedIndex } = this.state;
            if (items.length && selectedIndex > -1) {
                const { name: name, container: container, lastUpdatedDate: lastUpdatedDate, lastViewedDate: lastViewedDate } = items[selectedIndex];
                const date = (0, $1j5Rt.transformTimeStamp)(intl, lastViewedDate, lastUpdatedDate);
                return `${name}, ${container}, ${date?.pageAction} ${date?.dateString} ${date?.timeSince || ''}`;
            }
        };
        this.listItemRefCallback = (el, id)=>{
            if (!this.listItemRefs.current) return;
            if (el === null) delete this.listItemRefs.current[id];
            else this.listItemRefs.current[id] = el;
        };
        this.isUrlPopulatedWithSelectedItem = ()=>{
            /**
       * When we use ArrowKey to navigate through result items,
       * the URL field will be populated with the content of
       * selected item.
       * This function will check if the URL field is populated
       * with selected item.
       * It can be useful to detect whether we want to insert a
       * smartlink or a hyperlink with customized title
       */ const { items: items, selectedIndex: selectedIndex, displayUrl: displayUrl } = this.state;
            const selectedItem = items[selectedIndex];
            if (selectedItem && selectedItem.url === displayUrl) return true;
            return false;
        };
        this.handleSelected = (href, text)=>{
            this.handleInsert(href, text, (0, $d925B.INPUT_METHOD).TYPEAHEAD, 'click');
        };
        this.handleInsert = (href, title, inputType, interaction)=>{
            const { searchSessionId: searchSessionId, onSubmit: onSubmit } = this.props;
            const { items: items, selectedIndex: selectedIndex, displayText: displayText } = this.state;
            if (onSubmit) {
                this.submitted = true;
                onSubmit(href, title, displayText, inputType);
            }
            if (interaction === 'click' || this.isUrlPopulatedWithSelectedItem()) {
                /**
         * When it's a mouse click even or the selectedItem.url matches displayUrl, we think
         * it's selected from the result list and fire the
         * analytic
         */ const selectedItem = items[selectedIndex];
                this.fireAnalytics({
                    action: (0, $d925B.ACTION).SELECTED,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).SEARCH_RESULT,
                    attributes: {
                        source: this.analyticSource,
                        searchSessionId: searchSessionId ?? '',
                        trigger: interaction,
                        resultCount: items.length,
                        selectedResultId: selectedItem.objectId,
                        selectedRelativePosition: selectedIndex,
                        prefetch: selectedItem.prefetch ?? false
                    },
                    eventType: (0, $d925B.EVENT_TYPE).UI
                });
            }
        };
        this.handleMouseEnterResultItem = (objectId)=>{
            const { items: items } = this.state;
            const index = $7d851d84bd595a70$var$findIndex(items, (item)=>item.objectId === objectId);
            this.setState({
                selectedIndex: index
            });
        };
        this.handleMouseLeaveResultItem = (objectId)=>{
            const { items: items, selectedIndex: selectedIndex } = this.state;
            const index = $7d851d84bd595a70$var$findIndex(items, (item)=>item.objectId === objectId);
            // This is to avoid updating index that was set by other mouseenter event
            if (selectedIndex === index) this.setState({
                selectedIndex: -1
            });
        };
        this.handleSubmit = ()=>{
            const { displayUrl: displayUrl, selectedIndex: selectedIndex, items: items } = this.state;
            const selectedItem = items[selectedIndex];
            if (this.isUrlPopulatedWithSelectedItem()) this.handleInsert((0, $lSdQB.normalizeUrl)(selectedItem.url), selectedItem.name, (0, $d925B.INPUT_METHOD).TYPEAHEAD, 'keyboard');
            else if (displayUrl && displayUrl.length > 0) {
                const url = (0, $lSdQB.normalizeUrl)(displayUrl);
                if (url) this.handleInsert(url, displayUrl, (0, $d925B.INPUT_METHOD).MANUAL, 'notselected');
            }
        };
        this.handleClearTextKeyDown = (event)=>{
            const KEY_CODE_TAB = 9;
            const { keyCode: keyCode } = event;
            if (keyCode === KEY_CODE_TAB) {
                /** If there are items in the list, allow normal tabbing so focus moves to the next interactive element (in this case, a search result item).
         */ if (this.state.items.length > 0) return;
                if (!this.submitted) {
                    const { displayUrl: displayUrl, displayText: displayText } = this.state;
                    const url = (0, $lSdQB.normalizeUrl)(displayUrl);
                    this.handleInsert(url, displayText || displayUrl, (0, $d925B.INPUT_METHOD).MANUAL, 'notselected');
                }
                event.preventDefault();
                return;
            }
        };
        this.handleListItemFocus = (index)=>{
            this.setState({
                selectedIndex: index
            });
        };
        this.handleListItemBlur = ()=>{
            this.setState({
                selectedIndex: -1
            });
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.handleKeyDown = (event)=>{
            const { items: items, selectedIndex: selectedIndex } = this.state;
            const { view: view, onEscapeCallback: onEscapeCallback, searchSessionId: searchSessionId } = this.props;
            const { keyCode: keyCode } = event;
            const KEY_CODE_ESCAPE = 27;
            const KEY_CODE_ARROW_DOWN = 40;
            const KEY_CODE_ARROW_UP = 38;
            if (keyCode === KEY_CODE_ESCAPE) {
                // escape
                event.preventDefault();
                const { state: state, dispatch: dispatch } = view;
                onEscapeCallback?.(state, dispatch);
                return;
            }
            if (!items || !items.length) return;
            let updatedIndex = selectedIndex;
            if (keyCode === KEY_CODE_ARROW_DOWN) {
                // down
                event.preventDefault();
                updatedIndex = (selectedIndex + 1) % items.length;
            } else if (keyCode === KEY_CODE_ARROW_UP) {
                // up
                event.preventDefault();
                updatedIndex = selectedIndex > 0 ? selectedIndex - 1 : items.length - 1;
            }
            if ([
                KEY_CODE_ARROW_DOWN,
                KEY_CODE_ARROW_UP
            ].includes(keyCode) && items[updatedIndex]) {
                if (this.listItemRefs.current) this.listItemRefs.current[items[updatedIndex].objectId]?.focus();
                this.setState({
                    selectedIndex: updatedIndex,
                    displayUrl: items[updatedIndex].url
                });
                this.fireAnalytics({
                    action: (0, $d925B.ACTION).HIGHLIGHTED,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).SEARCH_RESULT,
                    attributes: {
                        source: this.analyticSource,
                        searchSessionId: searchSessionId ?? '',
                        selectedResultId: items[updatedIndex].objectId,
                        selectedRelativePosition: updatedIndex
                    },
                    eventType: (0, $d925B.EVENT_TYPE).UI
                });
            }
        };
        this.updateTextInput = (displayText)=>{
            this.setState({
                displayText: displayText
            });
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.handleCancel = (e)=>{
            const { view: { state: state, dispatch: dispatch }, onClickAwayCallback: onClickAwayCallback } = this.props;
            e.preventDefault();
            onClickAwayCallback?.(state, dispatch);
        };
        this.state = {
            selectedIndex: -1,
            isLoading: false,
            displayUrl: (0, $lSdQB.normalizeUrl)(props.displayUrl),
            displayText: props.displayText,
            items: []
        };
        /* Cache functions */ this.handleClearText = this.createClearHandler('displayUrl');
        this.handleClearDisplayText = this.createClearHandler('displayText');
        this.debouncedQuickSearch = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(this.quickSearch, 400);
        this.fireCustomAnalytics = (0, $ajtqX.fireAnalyticsEvent)(props.createAnalyticsEvent);
    }
}
function $7d851d84bd595a70$var$findIndex(array, predicate) {
    let index = -1;
    array.some((item, i)=>{
        if (predicate(item)) {
            index = i;
            return true;
        }
        return false;
    });
    return index;
}
function $7d851d84bd595a70$var$limit(items) {
    return items.slice(0, $7d851d84bd595a70$export$452f1062ecf44be7);
}
const $7d851d84bd595a70$export$527bb787d3e8324e = (0, $aXWIB.injectIntl)($7d851d84bd595a70$export$7acbf008e0847b89);
const $7d851d84bd595a70$var$_default_1 = (0, $1DWH0.default)()($7d851d84bd595a70$export$527bb787d3e8324e);
var $7d851d84bd595a70$export$2e2bcd8739ae039 = $7d851d84bd595a70$var$_default_1;


const $17127c1fe51c9e88$var$HYPERLINK_PROVIDERS = [
    'activityProvider',
    'searchProvider'
];
/**
 * Wraps around the editor's onSubmit handler so that the plugin can interface with the link picker
 */ const $17127c1fe51c9e88$var$onSubmitInterface = (onSubmit)=>({ url: url, title: title, displayText: displayText, rawUrl: rawUrl, meta: meta }, analytic)=>{
        onSubmit(url, title ?? rawUrl, displayText || undefined, meta.inputMethod === 'manual' ? (0, $d925B.INPUT_METHOD).MANUAL : (0, $d925B.INPUT_METHOD).TYPEAHEAD, analytic);
    };
function $17127c1fe51c9e88$export$8be6a38cd66ace65({ linkPickerOptions: { popupWidth: _popupWidth, popupHeight: _popupHeight, ...linkPickerOptions } = {}, onSubmit: onSubmit, displayText: displayText, displayUrl: displayUrl, providerFactory: providerFactory, view: view, onCancel: onCancel, invokeMethod: invokeMethod, lpLinkPicker: lpLinkPicker, onClose: onClose, onEscapeCallback: onEscapeCallback, onClickAwayCallback: onClickAwayCallback, editorAppearance: editorAppearance, inputMethod: inputMethod, searchSessionId: searchSessionId, timesViewed: timesViewed, isOffline: isOffline }) {
    const memoizedOnSubmitWithInterface = (0, $42omo.useMemo)(()=>$17127c1fe51c9e88$var$onSubmitInterface(onSubmit), [
        onSubmit
    ]);
    const memoizedRenderNode = (0, $42omo.useCallback)(({ activityProvider: activityProvider, searchProvider: searchProvider })=>{
        // If we're offline fallback to HyperlinkAddToolbarComp as we may not have loaded
        // EditorLinkPicker into the bundle
        if (lpLinkPicker && !Boolean(isOffline)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5d1db7e2a1c0eca0$export$da2f76555f5c8d0a), {
            view: view,
            invokeMethod: // Provide `invokeMethod` prop as preferred value (card plugin passes as prop) otherwise assume this
            // is being used from inside the hyperlink plugin and use inputMethod from plugin state
            invokeMethod ?? inputMethod,
            editorAppearance: editorAppearance,
            ...linkPickerOptions,
            url: displayUrl,
            displayText: displayText,
            onSubmit: memoizedOnSubmitWithInterface,
            onCancel: onCancel,
            onClose: onClose,
            onEscapeCallback: onEscapeCallback,
            onClickAwayCallback: onClickAwayCallback
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7d851d84bd595a70$export$2e2bcd8739ae039), {
            activityProvider: activityProvider,
            searchProvider: searchProvider,
            onSubmit: onSubmit,
            displayText: displayText,
            displayUrl: displayUrl,
            view: view,
            onEscapeCallback: onEscapeCallback,
            onClickAwayCallback: onClickAwayCallback,
            inputMethod: inputMethod,
            searchSessionId: searchSessionId,
            timesViewed: timesViewed
        });
    }, [
        lpLinkPicker,
        isOffline,
        view,
        invokeMethod,
        inputMethod,
        editorAppearance,
        linkPickerOptions,
        displayUrl,
        displayText,
        onSubmit,
        memoizedOnSubmitWithInterface,
        onCancel,
        onClose,
        onEscapeCallback,
        onClickAwayCallback,
        searchSessionId,
        timesViewed
    ]);
    const providers = (0, $1oCLl.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? $17127c1fe51c9e88$var$HYPERLINK_PROVIDERS : // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- intentional fallback for experiment off path
    [
        'activityProvider',
        'searchProvider'
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dYBVS.WithProviders), {
        providers: providers,
        providerFactory: providerFactory,
        renderNode: (0, $1oCLl.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? memoizedRenderNode : // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- intentional fallback for experiment off path
        ({ activityProvider: activityProvider, searchProvider: searchProvider })=>{
            // If we're offline fallback to HyperlinkAddToolbarComp as we may not have loaded
            // EditorLinkPicker into the bundle
            if (lpLinkPicker && !Boolean(isOffline)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5d1db7e2a1c0eca0$export$da2f76555f5c8d0a), {
                view: view,
                invokeMethod: // Provide `invokeMethod` prop as preferred value (card plugin passes as prop) otherwise assume this
                // is being used from inside the hyperlink plugin and use inputMethod from plugin state
                invokeMethod ?? inputMethod,
                editorAppearance: editorAppearance,
                ...linkPickerOptions,
                url: displayUrl,
                displayText: displayText,
                onSubmit: $17127c1fe51c9e88$var$onSubmitInterface(onSubmit),
                onCancel: onCancel,
                onClose: onClose,
                onEscapeCallback: onEscapeCallback,
                onClickAwayCallback: onClickAwayCallback
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7d851d84bd595a70$export$2e2bcd8739ae039), {
                activityProvider: activityProvider,
                searchProvider: searchProvider,
                onSubmit: onSubmit,
                displayText: displayText,
                displayUrl: displayUrl,
                view: view,
                onEscapeCallback: onEscapeCallback,
                onClickAwayCallback: onClickAwayCallback,
                inputMethod: inputMethod,
                searchSessionId: searchSessionId,
                timesViewed: timesViewed
            });
        }
    });
}
module.exports["HyperlinkAddToolbar"] = $17127c1fe51c9e88$export$8be6a38cd66ace65;

});

parcelRegister("8i5w2", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $d7ZU3 = parcelRequire("d7ZU3");


var $1DCSy = parcelRequire("1DCSy");

const $ab1eca00d3b17c53$var$KeyZCode = 90;
const $ab1eca00d3b17c53$var$KeyYCode = 89;
class $ab1eca00d3b17c53$export$2e2bcd8739ae039 extends (0, $42omo.PureComponent) {
    componentDidUpdate(prevProps) {
        if (prevProps.defaultValue !== this.props.defaultValue) this.setState({
            value: this.props.defaultValue
        });
    }
    componentWillUnmount() {
        window.clearTimeout(this.focusTimeoutId);
    }
    render() {
        const { placeholder: placeholder, width: width, maxLength: maxLength, testId: testId, ariaLabel: ariaLabel, describedById: describedById, ariaActiveDescendant: ariaActiveDescendant, ariaControls: ariaControls, ariaExpanded: ariaExpanded, ariaAutoComplete: ariaAutoComplete, role: role, inputId: inputId } = this.props;
        const { value: value } = this.state;
        return /*#__PURE__*/ (0, $9K4OG.jsx)("input", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            css: [
                (0, $1DCSy.panelTextInput),
                width !== undefined && (0, $1DCSy.panelTextInputWithCustomWidth)(width)
            ],
            role: role,
            "aria-autocomplete": ariaAutoComplete ? 'list' : undefined,
            "aria-expanded": ariaExpanded,
            "aria-controls": ariaControls,
            "aria-activedescendant": ariaActiveDescendant,
            "aria-describedby": describedById,
            "data-testid": testId || '',
            type: "text",
            placeholder: placeholder,
            value: value,
            onChange: this.handleChange,
            onKeyDown: this.handleKeydown,
            onMouseDown: this.onMouseDown,
            onBlur: this.onBlur,
            ref: this.handleRef,
            maxLength: maxLength,
            "aria-label": ariaLabel,
            "aria-required": this.props?.ariaRequired,
            "aria-invalid": this.props?.ariaInvalid,
            id: inputId
        });
    }
    focus() {
        const { input: input } = this;
        if (input) {
            const focusOpts = typeof this.props.autoFocus === 'object' ? this.props.autoFocus : {};
            input.focus(focusOpts);
        }
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    isUndoEvent(event) {
        const browser = (0, $d7ZU3.getBrowserInfo)();
        return event.keyCode === $ab1eca00d3b17c53$var$KeyZCode && // cmd + z for mac
        (browser.mac && event.metaKey && !event.shiftKey || // ctrl + z for non-mac
        !browser.mac && event.ctrlKey);
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    isRedoEvent(event) {
        const browser = (0, $d7ZU3.getBrowserInfo)();
        return(// ctrl + y for non-mac
        !browser.mac && event.ctrlKey && event.keyCode === $ab1eca00d3b17c53$var$KeyYCode || browser.mac && event.metaKey && event.shiftKey && event.keyCode === $ab1eca00d3b17c53$var$KeyZCode || event.ctrlKey && event.shiftKey && event.keyCode === $ab1eca00d3b17c53$var$KeyZCode);
    }
    constructor(props){
        super(props);
        this.input = void 0;
        this.focusTimeoutId = void 0;
        this.onMouseDown = ()=>{
            const { onMouseDown: onMouseDown } = this.props;
            if (onMouseDown) onMouseDown();
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onBlur = (e)=>{
            const { onBlur: onBlur } = this.props;
            if (onBlur) onBlur(e);
        };
        this.handleChange = ()=>{
            const { onChange: onChange } = this.props;
            if (this.input) this.setState({
                value: this.input.value
            });
            if (onChange && this.input) onChange(this.input.value);
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.handleKeydown = (e)=>{
            const { onUndo: onUndo, onRedo: onRedo, onSubmit: onSubmit, onCancel: onCancel } = this.props;
            if (e.keyCode === 13 && onSubmit) {
                e.preventDefault(); // Prevent from submitting if an editor is inside a form.
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                onSubmit(this.input.value);
            } else if (e.keyCode === 27 && onCancel) onCancel(e);
            else if (typeof onUndo === 'function' && this.isUndoEvent(e)) {
                e.preventDefault();
                onUndo();
            } else if (typeof onRedo === 'function' && this.isRedoEvent(e)) {
                e.preventDefault();
                onRedo();
            }
            if (this.props.onKeyDown) this.props.onKeyDown(e);
        };
        this.handleRef = (input)=>{
            if (input instanceof HTMLInputElement) {
                this.input = input;
                if (this.props.autoFocus) // Need this to prevent jumping when we render TextInput inside Portal @see ED-2992
                this.focusTimeoutId = window.setTimeout(()=>this.focus());
            } else this.input = undefined;
        };
        this.state = {
            value: props.defaultValue || ''
        };
    }
}
module.exports["default"] = $ab1eca00d3b17c53$export$2e2bcd8739ae039;

});

parcelRegister("48vaT", function(module, exports) {
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $9K4OG = parcelRequire("9K4OG");


var $9hlns = parcelRequire("9hlns");

/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");





var $aXWIB = parcelRequire("aXWIB");


var $aFUXX = parcelRequire("aFUXX");


var $1oCLl = parcelRequire("1oCLl");




const $af43d2af7b544f70$var$messages = (0, $aXWIB.defineMessages)({
    story: {
        id: "fabric.editor.story",
        defaultMessage: "Story"
    },
    epic: {
        id: "fabric.editor.epic",
        defaultMessage: "Epic"
    },
    task: {
        id: "fabric.editor.task",
        defaultMessage: "Task"
    },
    bug: {
        id: "fabric.editor.bug",
        defaultMessage: "Bug"
    },
    subTask: {
        id: "fabric.editor.subTask",
        defaultMessage: "Sub-task"
    },
    improvement: {
        id: "fabric.editor.improvement",
        defaultMessage: "Improvement"
    },
    defaultAltText: {
        id: "fabric.editor.defaultAltText",
        defaultMessage: "Document"
    }
});
const $af43d2af7b544f70$export$ac1fda7301622804 = (iconUrl, intl)=>{
    let alt = intl.formatMessage($af43d2af7b544f70$var$messages.defaultAltText);
    if (iconUrl.includes('story.svg')) alt = intl.formatMessage($af43d2af7b544f70$var$messages.story);
    if (iconUrl.includes('epic.svg')) alt = intl.formatMessage($af43d2af7b544f70$var$messages.epic);
    if (iconUrl.includes('avatarId=10318')) alt = intl.formatMessage($af43d2af7b544f70$var$messages.task);
    if (iconUrl.includes('avatarId=10303')) alt = intl.formatMessage($af43d2af7b544f70$var$messages.bug);
    if (iconUrl.includes('avatarId=10518')) alt = intl.formatMessage($af43d2af7b544f70$var$messages.subTask);
    if (iconUrl.includes('avatarId=10310')) alt = intl.formatMessage($af43d2af7b544f70$var$messages.improvement);
    return alt;
};



var $1j5Rt = parcelRequire("1j5Rt");

function $1203f148809411eb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1203f148809411eb$export$34e0f9847d4c02dd = /*#__PURE__*/ (0, $9K4OG.css)({
    backgroundColor: 'transparent',
    padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-150, 12px)"}`,
    cursor: 'pointer',
    display: 'flex',
    marginTop: 0
});
const $1203f148809411eb$export$624ac72e8eeb8e3d = {
    name: "172qvh2",
    styles: "background-color:var(--ds-background-neutral-subtle-hovered, #0515240F)"
};
const $1203f148809411eb$var$nameWrapper = {
    name: "d3v9zr",
    styles: "overflow:hidden"
};
const $1203f148809411eb$export$d6a1b4d10134b7d7 = {
    name: "15va48x",
    styles: "color:var(--ds-text, #292A2E);overflow:hidden;text-overflow:ellipsis;white-space:nowrap;line-height:20px"
};
const $1203f148809411eb$export$ff1446d682f75fb9 = /*#__PURE__*/ (0, $9K4OG.css)({
    color: "var(--ds-text-subtlest, #6B6E76)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '14px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: (0, $aFUXX.relativeFontSizeToBase16)(11)
});
const $1203f148809411eb$var$iconStyle = {
    name: "r2c2s1",
    styles: "min-width:16px;margin-top:var(--ds-space-050, 4px);margin-right:var(--ds-space-150, 12px);img{max-width:16px;}"
};
const $1203f148809411eb$var$LinkSearchListItem = (props, ref)=>{
    const { id: id, item: item, onBlur: onBlur, onFocus: onFocus, onKeyDown: onKeyDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseMove: onMouseMove, onSelect: onSelect, selected: selected, intl: intl } = props;
    const handleSelect = (0, $42omo.useCallback)((e)=>{
        e.preventDefault(); // don't let editor lose focus
        onSelect(item.url, item.name);
    }, [
        onSelect,
        item.url,
        item.name
    ]);
    const handleKeyDown = (0, $42omo.useCallback)((event)=>{
        if (event.key === 'Enter') onSelect(item.url, item.name);
        onKeyDown?.(event);
    }, [
        onSelect,
        onKeyDown,
        item.url,
        item.name
    ]);
    const handleMouseMove = (0, $42omo.useCallback)(()=>{
        onMouseMove?.(item.objectId);
    }, [
        onMouseMove,
        item.objectId
    ]);
    const handleMouseEnter = (0, $42omo.useCallback)(()=>{
        onMouseEnter?.(item.objectId);
    }, [
        onMouseEnter,
        item.objectId
    ]);
    const handleMouseLeave = (0, $42omo.useCallback)(()=>{
        onMouseLeave?.(item.objectId);
    }, [
        onMouseLeave,
        item.objectId
    ]);
    const renderIcon = ()=>{
        if (item.icon) return /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            css: $1203f148809411eb$var$iconStyle,
            "data-vc": "mNTxAq5I"
        }, item.icon);
        if (item.iconUrl) return /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            css: $1203f148809411eb$var$iconStyle
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("img", {
            src: item.iconUrl,
            alt: (0, $af43d2af7b544f70$export$ac1fda7301622804)(item.iconUrl, intl)
        }));
        return null;
    };
    const renderTimeStamp = ()=>{
        const date = (0, $1j5Rt.transformTimeStamp)(intl, item.lastViewedDate, item.lastUpdatedDate);
        return date && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, "\xa0 \u2022", /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "link-search-timestamp",
            "data-testid": "link-search-timestamp"
        }, "\xa0 ", date.pageAction, " ", date.dateString, " ", date.timeSince || ''));
    };
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        ref: ref,
        css: [
            $1203f148809411eb$export$34e0f9847d4c02dd,
            selected && $1203f148809411eb$export$624ac72e8eeb8e3d
        ],
        role: 'option',
        tabIndex: 0,
        id: id,
        "aria-selected": selected,
        "data-testid": "link-search-list-item",
        onBlur: (0, $1oCLl.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? onBlur : undefined,
        onFocus: onFocus,
        onKeyDown: handleKeyDown,
        onMouseMove: handleMouseMove,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onClick: handleSelect
    }, renderIcon(), /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        css: $1203f148809411eb$var$nameWrapper
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $1203f148809411eb$export$d6a1b4d10134b7d7
    }, item.name), /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        "data-testid": "link-search-list-item-container",
        css: $1203f148809411eb$export$ff1446d682f75fb9
    }, item.container, renderTimeStamp())));
};
const $1203f148809411eb$var$ForwardedLinkSearchListItem = /*#__PURE__*/ (0, $42omo.forwardRef)($1203f148809411eb$var$LinkSearchListItem);
const $1203f148809411eb$export$1896ba66c9a2c53b = (0, $aXWIB.injectIntl)($1203f148809411eb$var$ForwardedLinkSearchListItem, {
    forwardRef: true
});
var $1203f148809411eb$export$2e2bcd8739ae039 = $1203f148809411eb$export$1896ba66c9a2c53b;


function $ce717dcd0d3f2053$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ce717dcd0d3f2053$var$listContainer = /*#__PURE__*/ (0, $9K4OG.css)({
    paddingTop: 0,
    marginTop: "var(--ds-space-150, 12px)",
    borderTop: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`
});
const $ce717dcd0d3f2053$var$spinnerContainer = {
    name: "q64ud4",
    styles: "text-align:center;min-height:80px;margin-top:var(--ds-space-400, 32px)"
};
const $ce717dcd0d3f2053$export$ca0620a9deb4a3fe = {
    name: "n1lsvi",
    styles: "padding:0;list-style:none"
};
const $ce717dcd0d3f2053$var$LinkSearchList = ({ listItemRefCallback: listItemRefCallback, onBlur: onBlur, onFocus: onFocus, onKeyDown: onKeyDown, onSelect: onSelect, onMouseMove: onMouseMove, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, items: items, selectedIndex: selectedIndex, isLoading: isLoading, ariaControls: ariaControls, role: role, id: id })=>{
    let itemsContent;
    let loadingContent;
    if (items && items.length > 0) itemsContent = /*#__PURE__*/ (0, $9K4OG.jsx)("ul", {
        css: $ce717dcd0d3f2053$export$ca0620a9deb4a3fe,
        id: id,
        role: role,
        "aria-controls": ariaControls,
        "data-testid": `${id}--items`
    }, items.map((item, index)=>/*#__PURE__*/ (0, $9K4OG.jsx)((0, $1203f148809411eb$export$2e2bcd8739ae039), {
            id: `link-search-list-item-${index}`,
            item: item,
            selected: selectedIndex === index,
            onBlur: onBlur,
            // eslint-disable-next-line @atlassian/perf-linting/detect-unnecessary-rerenders, @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onFocus: ()=>onFocus?.(index),
            onKeyDown: onKeyDown,
            onMouseMove: onMouseMove,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onSelect: onSelect,
            key: item.objectId,
            // eslint-disable-next-line @atlassian/perf-linting/detect-unnecessary-rerenders, @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            ref: (el)=>listItemRefCallback?.(el, item.objectId)
        })));
    if (isLoading) loadingContent = /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        id: id,
        "data-testid": `${id}--loading`,
        css: $ce717dcd0d3f2053$var$spinnerContainer
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $9hlns.default), {
        size: "medium",
        interactionName: "link-search-spinner"
    }));
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $ce717dcd0d3f2053$var$listContainer,
        "data-vc": "FJw9lpV3"
    }, itemsContent, loadingContent);
};
var $ce717dcd0d3f2053$export$2e2bcd8739ae039 = $ce717dcd0d3f2053$var$LinkSearchList;
module.exports["default"] = $ce717dcd0d3f2053$export$2e2bcd8739ae039;

});

parcelRegister("3a8Ut", function(module, exports) {
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $9fPrY = parcelRequire("9fPrY");

function $5556ba5e176666fe$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $5556ba5e176666fe$export$248a47518f3a0001 = /*#__PURE__*/ (0, $9K4OG.css)({
    display: 'flex',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 0,
    padding: `${"var(--ds-space-075, 6px)"} 0`,
    alignItems: 'center'
});
const $5556ba5e176666fe$export$34e0f9847d4c02dd = /*#__PURE__*/ (0, $9K4OG.css)({
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    padding: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $9fPrY.RECENT_SEARCH_WIDTH_WITHOUT_ITEMS_IN_PX)}px`,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 'initial'
});
const $5556ba5e176666fe$export$8fb2d297355596b4 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $9fPrY.RECENT_SEARCH_WIDTH_IN_PX)}px`
});
const $5556ba5e176666fe$export$b45558f4e00a3f09 = {
    name: "1raezz8",
    styles: "width:292px"
};
module.exports["inputWrapper"] = $5556ba5e176666fe$export$248a47518f3a0001;
module.exports["container"] = $5556ba5e176666fe$export$34e0f9847d4c02dd;
module.exports["containerWithProvider"] = $5556ba5e176666fe$export$8fb2d297355596b4;
module.exports["narrowContainerWidth"] = $5556ba5e176666fe$export$b45558f4e00a3f09;

});

parcelRegister("9fPrY", function(module, exports) {
const $01c5305caa51ddd3$export$a62aa932daf22ffe = 420;
const $01c5305caa51ddd3$export$92a2501826f554f6 = 360;
const $01c5305caa51ddd3$export$c04a5ad015d45447 = 360;
const $01c5305caa51ddd3$export$c635b83728f81640 = 570;
const $01c5305caa51ddd3$export$6174bb2f16361f4e = 464;
const $01c5305caa51ddd3$export$6d1047548150003f = 512;
module.exports["RECENT_SEARCH_WIDTH_IN_PX"] = $01c5305caa51ddd3$export$a62aa932daf22ffe;
module.exports["RECENT_SEARCH_WIDTH_WITHOUT_ITEMS_IN_PX"] = $01c5305caa51ddd3$export$92a2501826f554f6;
module.exports["RECENT_SEARCH_HEIGHT_IN_PX"] = $01c5305caa51ddd3$export$c04a5ad015d45447;
module.exports["LINKPICKER_HEIGHT_IN_PX"] = $01c5305caa51ddd3$export$c635b83728f81640;

});

parcelRegister("1eLzC", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $0aac8fed4af68d91$export$99ff0262540b54dc = ({ userIntent: userIntent = 'popupOpen', children: children, api: api })=>{
    (0, $42omo.useEffect)(()=>{
        api?.core.actions.execute(api?.userIntent?.commands.setCurrentUserIntent(userIntent));
        return ()=>{
            if (userIntent === api?.userIntent?.sharedState.currentState()?.currentUserIntent) // Defer the reset to avoid interfering with ongoing ProseMirror transactions
            // This fixes a race condition where cleanup happens during a transaction
            // (e.g., during drag handle mouse over -> unmountDecorations -> flushSync)
            setTimeout(()=>{
                api?.core.actions.execute(api?.userIntent?.commands.setCurrentUserIntent('default'));
            }, 0);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return children;
};
module.exports["UserIntentPopupWrapper"] = $0aac8fed4af68d91$export$99ff0262540b54dc;

});

parcelRegister("36iDo", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $iu6m9 = parcelRequire("iu6m9");


var $dQl1W = parcelRequire("dQl1W");


var $d925B = parcelRequire("d925B");

var $aSgIe = parcelRequire("aSgIe");


var $19Q6F = parcelRequire("19Q6F");


var $4KOFJ = parcelRequire("4KOFJ");


var $2cmfr = parcelRequire("2cmfr");


var $8EYIj = parcelRequire("8EYIj");


var $8gdgt = parcelRequire("8gdgt");

var $jvA0K = parcelRequire("jvA0K");


var $jz9wK = parcelRequire("jz9wK");


var $1S4f7 = parcelRequire("1S4f7");


var $e6n00 = parcelRequire("e6n00");


var $ly3wu = parcelRequire("ly3wu");




const $bfe611567370ae9a$export$2dccb54a894dbcd3 = (html)=>{
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    doc.querySelectorAll(`div.${(0, $ly3wu.BreakoutCssClassName).BREAKOUT_MARK}`).forEach((breakoutDiv)=>{
        // Check if this breakout div directly contains a renderer sync block
        const rendererDiv = breakoutDiv.querySelector(`:scope > div[${(0, $e6n00.SyncBlockRendererDataAttributeName)}]`);
        if (rendererDiv) breakoutDiv.replaceWith(rendererDiv);
    });
    return doc.body.innerHTML;
};


var $5FXvM = parcelRequire("5FXvM");

var $5SAOw = parcelRequire("5SAOw");

const $cf580436a7489192$export$d1dc8019f50dded8 = (slice, schema)=>{
    if (slice.content.childCount === 1 && (slice.openStart || slice.openEnd)) {
        const maybeCodeBlock = slice.content.firstChild;
        if (maybeCodeBlock && maybeCodeBlock.type === schema.nodes.codeBlock) {
            if (maybeCodeBlock.textContent && maybeCodeBlock.textContent.indexOf('\n') === -1) return new (0, $5SAOw.Slice)((0, $5SAOw.Fragment).from(schema.text(maybeCodeBlock.textContent, [
                schema.marks.code.create()
            ])), 0, 0);
        }
    }
    return slice;
};


var $iqEyW = parcelRequire("iqEyW");

var $4Dk64 = parcelRequire("4Dk64");



const $8eab6696b4592b34$export$65d21b4bef5d424b = (slice, schema)=>{
    const node = slice.content.firstChild;
    if (slice.content.childCount === 1 && node && node.type.name === 'decisionItem') {
        const decisionListWrapperNode = schema.nodes.decisionList.create({}, node);
        return new (0, $5SAOw.Slice)((0, $5SAOw.Fragment).from(decisionListWrapperNode), slice.openStart, slice.openEnd);
    }
    return slice;
};





var $3Ter7 = parcelRequire("3Ter7");



function $92458d2ff9cd5d89$var$joinCodeBlocks(left, right) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const textContext = `${left.textContent}\n${right.textContent}`;
    return left.type.create(left.attrs, left.type.schema.text(textContext));
}
function $92458d2ff9cd5d89$var$mergeAdjacentCodeBlocks(fragment) {
    const children = [];
    fragment.forEach((maybeCodeBlock)=>{
        if (maybeCodeBlock.type === maybeCodeBlock.type.schema.nodes.codeBlock) {
            const peekAtPrevious = children[children.length - 1];
            if (peekAtPrevious && peekAtPrevious.type === maybeCodeBlock.type) // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return children.push($92458d2ff9cd5d89$var$joinCodeBlocks(children.pop(), maybeCodeBlock));
        }
        return children.push(maybeCodeBlock);
    });
    return (0, $5SAOw.Fragment).from(children);
}
function $92458d2ff9cd5d89$export$5a682e48ed34e262(slice) {
    slice = (0, $3Ter7.mapSlice)(slice, (node)=>{
        return node.isBlock && !node.isTextblock ? node.copy($92458d2ff9cd5d89$var$mergeAdjacentCodeBlocks(node.content)) : node;
    });
    // mapSlice won't be able to merge adjacent top-level code-blocks
    return new (0, $5SAOw.Slice)($92458d2ff9cd5d89$var$mergeAdjacentCodeBlocks(slice.content), slice.openStart, slice.openEnd);
}


var $igNsz = parcelRequire("igNsz");

var $kqmjz = parcelRequire("kqmjz");


var $bYZ53 = parcelRequire("bYZ53");

var $jI93b = parcelRequire("jI93b");

var $b0F8r = parcelRequire("b0F8r");




var $aRZzN = parcelRequire("aRZzN");





var $8m4tT = parcelRequire("8m4tT");


var $dmcsV = parcelRequire("dmcsV");


var $2v1PW = parcelRequire("2v1PW");


var $6taGi = parcelRequire("6taGi");





var $1oCLl = parcelRequire("1oCLl");


var $dZ8uq = parcelRequire("dZ8uq");




var $d67f3be44268e218$export$ad3c0356f902fd97 = /*#__PURE__*/ function(PastePluginActionTypes) {
    PastePluginActionTypes["START_TRACKING_PASTED_MACRO_POSITIONS"] = "START_TRACKING_PASTED_MACRO_POSITIONS";
    PastePluginActionTypes["STOP_TRACKING_PASTED_MACRO_POSITIONS"] = "STOP_TRACKING_PASTED_MACRO_POSITIONS";
    PastePluginActionTypes["ON_PASTE"] = "ON_PASTE";
    PastePluginActionTypes["SET_ACTIVE_FLAG"] = "SET_ACTIVE_FLAG";
    return PastePluginActionTypes;
}({});



var $jshjN = parcelRequire("jshjN");




var $astHL = parcelRequire("astHL");





var $ks2lK = parcelRequire("ks2lK");



var $lkJUe = parcelRequire("lkJUe");











const $76c531f16a3b9d92$export$1650419e431d3ba3 = (state, action)=>{
    switch(action.type){
        case (0, $d67f3be44268e218$export$ad3c0356f902fd97).START_TRACKING_PASTED_MACRO_POSITIONS:
            return {
                ...state,
                pastedMacroPositions: {
                    ...state.pastedMacroPositions,
                    ...action.pastedMacroPositions
                }
            };
        case (0, $d67f3be44268e218$export$ad3c0356f902fd97).STOP_TRACKING_PASTED_MACRO_POSITIONS:
            {
                const filteredMacroPositions = Object.fromEntries(Object.entries(state.pastedMacroPositions).filter(([key])=>!action.pastedMacroPositionKeys.includes(key)));
                return {
                    ...state,
                    pastedMacroPositions: filteredMacroPositions
                };
            }
        case (0, $d67f3be44268e218$export$ad3c0356f902fd97).ON_PASTE:
            return {
                ...state,
                lastContentPasted: action.contentPasted
            };
        case (0, $d67f3be44268e218$export$ad3c0356f902fd97).SET_ACTIVE_FLAG:
            if (!(0, $iu6m9.editorExperiment)('platform_synced_block', true) && !(0, $dh538.fg)('platform_synced_block_unsupported_products')) return state;
            return {
                ...state,
                activeFlag: action.activeFlag
            };
        default:
            return state;
    }
};


const $6b91a48544104490$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('pastePlugin');
const $6b91a48544104490$var$dest = (0, $lkJUe.pluginFactory)($6b91a48544104490$export$18d4026d1ea86bb1, (0, $76c531f16a3b9d92$export$1650419e431d3ba3), {
    mapping: (tr, pluginState)=>{
        if (tr.docChanged) {
            let atLeastOnePositionChanged = false;
            const positionsMappedThroughChanges = Object.entries(pluginState.pastedMacroPositions).reduce((acc, [key, position])=>{
                const mappedPosition = tr.mapping.map(position);
                if (position !== mappedPosition) atLeastOnePositionChanged = true;
                acc[key] = tr.mapping.map(position);
                return acc;
            }, {});
            if (atLeastOnePositionChanged) return {
                ...pluginState,
                pastedMacroPositions: positionsMappedThroughChanges
            };
        }
        return pluginState;
    }
});
const $6b91a48544104490$export$656c7661095efe2e = $6b91a48544104490$var$dest.createPluginState;
const $6b91a48544104490$export$8d4021544bdece00 = $6b91a48544104490$var$dest.createCommand;
const $6b91a48544104490$export$f05434c51e3762e = $6b91a48544104490$var$dest.getPluginState;


const $2e4406ece4085ab9$export$4a47d257a3fdbe1c = (pastedMacroPositions)=>(0, $6b91a48544104490$export$8d4021544bdece00)(()=>{
        return {
            type: (0, $d67f3be44268e218$export$ad3c0356f902fd97).START_TRACKING_PASTED_MACRO_POSITIONS,
            pastedMacroPositions: pastedMacroPositions
        };
    });
const $2e4406ece4085ab9$export$68f98dcea8e59d59 = (pastedMacroPositionKeys)=>(0, $6b91a48544104490$export$8d4021544bdece00)(()=>{
        return {
            type: (0, $d67f3be44268e218$export$ad3c0356f902fd97).STOP_TRACKING_PASTED_MACRO_POSITIONS,
            pastedMacroPositionKeys: pastedMacroPositionKeys
        };
    });
// matchers for text lists
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $2e4406ece4085ab9$var$bullets = /^\s*[\*\-\u2022](\s+|\s+$)/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $2e4406ece4085ab9$var$numbers = /^\s*\d[\.\)](\s+|$)/;
const $2e4406ece4085ab9$var$isListItem = (node, schema)=>{
    return Boolean(node && node.type === schema.nodes.listItem);
};
const $2e4406ece4085ab9$var$getListType = (node, schema)=>{
    if (!node || !node.text) return null;
    const { bulletList: bulletList, orderedList: orderedList } = schema.nodes;
    return [
        {
            node: bulletList,
            matcher: $2e4406ece4085ab9$var$bullets
        },
        {
            node: orderedList,
            matcher: $2e4406ece4085ab9$var$numbers
        }
    ].reduce((lastMatch, listType)=>{
        if (lastMatch) return lastMatch;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const match = node.text.match(listType.matcher);
        return match ? [
            listType.node,
            match[0].length
        ] : lastMatch;
    }, null);
};
const $2e4406ece4085ab9$export$252a79c29aea3669 = (content, schema)=>{
    const wrapperContent = [];
    let nextContent = [];
    content.forEach((node)=>{
        if (node.type === schema.nodes.hardBreak) {
            if (nextContent.length !== 0) wrapperContent.push(nextContent);
            nextContent = [
                node
            ];
        } else nextContent.push(node);
    });
    wrapperContent.push(nextContent);
    return wrapperContent;
};
const $2e4406ece4085ab9$export$5bfe14e0df30e39c = (node, parent, schema)=>{
    const content = (0, $3Ter7.mapChildren)(node.content, (node)=>node);
    const linesSplitByHardbreaks = $2e4406ece4085ab9$export$252a79c29aea3669(content, schema);
    const { paragraph: paragraph, hardBreak: hardBreak, listItem: listItem, orderedList: orderedList } = schema.nodes;
    const splitListsAndParagraphs = [];
    let paragraphParts = [];
    // Ignored via go/ees005
    // eslint-disable-next-line no-var
    for(var index = 0; index < linesSplitByHardbreaks.length; index = index + 1){
        const line = linesSplitByHardbreaks[index];
        let listMatch;
        if (index === 0) {
            if (line[0]?.type === hardBreak) {
                paragraphParts.push(line);
                continue;
            } else // the first line the potential list item is at postion 0
            listMatch = $2e4406ece4085ab9$var$getListType(line[0], schema);
        } else {
            // lines after the first the potential list item is at postion 1
            if (line.length === 1) {
                // if the line only has a line break return as is
                paragraphParts.push(line);
                continue;
            }
            listMatch = $2e4406ece4085ab9$var$getListType(line[1], schema);
        }
        if (!listMatch || // CONFCLOUD-79708: If we are inside a list - let's not try to upgrade list as it resolves
        // to invalid content
        $2e4406ece4085ab9$var$isListItem(parent, schema)) {
            // if there is not list match return as is
            paragraphParts.push(line);
            continue;
        }
        const [nodeType, length] = listMatch;
        const firstNonHardBreakNode = line.find((node)=>node.type !== hardBreak);
        const chunksWithoutLeadingHardBreaks = line.slice(line.findIndex((node)=>node.type !== hardBreak));
        // retain text after bullet or number-dot e.g. 1. Hello
        const startingText = firstNonHardBreakNode?.text?.substr(length);
        const restOfChunk = startingText ? [
            schema.text(startingText, firstNonHardBreakNode?.marks),
            ...chunksWithoutLeadingHardBreaks.slice(1)
        ] : chunksWithoutLeadingHardBreaks.slice(1);
        // convert to list
        const listItemNode = listItem?.createAndFill(undefined, paragraph.createChecked(undefined, restOfChunk));
        if (!listItemNode) {
            paragraphParts.push(line);
            continue;
        }
        const attrs = nodeType === orderedList ? {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
            order: parseInt(firstNonHardBreakNode.text.split('.')[0])
        } : undefined;
        const newList = nodeType.createChecked(attrs, [
            listItemNode
        ]);
        if (paragraphParts.length !== 0 && paragraph.validContent((0, $5SAOw.Fragment).from(paragraphParts.flat()))) {
            splitListsAndParagraphs.push(paragraph.createAndFill(node.attrs, paragraphParts.flat(), node.marks));
            paragraphParts = [];
        }
        splitListsAndParagraphs.push(newList);
    }
    if (paragraphParts.length !== 0 && paragraph.validContent((0, $5SAOw.Fragment).from(paragraphParts.flat()))) splitListsAndParagraphs.push(schema.nodes.paragraph.createAndFill(node.attrs, paragraphParts.flat(), node.marks));
    const result = splitListsAndParagraphs.flat();
    // try to join
    const mockState = (0, $ks2lK.EditorState).create({
        schema: schema
    });
    let joinedListsTr;
    const mockDispatch = (tr)=>{
        joinedListsTr = tr;
    };
    // Return false to prevent replaceWith from wrapping the text node in a paragraph
    // paragraph since that will be done later. If it's done here, it will fail
    // the paragraph.validContent check.
    // Dont return false if there are lists, as they arent validContent for paragraphs
    // and will result in hanging textNodes
    (0, $astHL.autoJoin)((state, dispatch)=>{
        if (!dispatch) return false;
        const containsList = result.some((node)=>node.type === schema.nodes.bulletList || node.type === schema.nodes.orderedList);
        if (result.some((node)=>node.isText) && !containsList) return false;
        dispatch(state.tr.replaceWith(0, 2, result));
        return true;
    }, (before, after)=>(0, $jshjN.isListNode)(before) && (0, $jshjN.isListNode)(after))(mockState, mockDispatch);
    const fragment = joinedListsTr ? joinedListsTr.doc.content : (0, $5SAOw.Fragment).from(result);
    return fragment;
};
const $2e4406ece4085ab9$export$df231bdf1595dd19 = (slice, schema)=>{
    return (0, $3Ter7.mapSlice)(slice, (node, parent)=>{
        if (node.type === schema.nodes.paragraph) return $2e4406ece4085ab9$export$5bfe14e0df30e39c(node, parent, schema);
        return node;
    });
};
const $2e4406ece4085ab9$export$f2dc3112f5c2bd10 = (slice, schema)=>{
    // exclude Text nodes with a code mark, since we transform those later
    // into a codeblock
    let hasCodeMark = false;
    slice.content.forEach((child)=>{
        hasCodeMark = hasCodeMark || child.marks.some((mark)=>mark.type === schema.marks.code);
    });
    // slice might just be a raw text string
    if (schema.nodes.paragraph.validContent(slice.content) && !hasCodeMark) {
        const replSlice = $2e4406ece4085ab9$export$b2e3d6bb71a327f1({
            fragment: slice.content,
            schema: schema
        });
        return new (0, $5SAOw.Slice)(replSlice, slice.openStart + 1, slice.openEnd + 1);
    }
    return (0, $3Ter7.mapSlice)(slice, (node)=>{
        if (node.type === schema.nodes.paragraph) return $2e4406ece4085ab9$export$b2e3d6bb71a327f1({
            fragment: node.content,
            blockMarks: node.marks,
            schema: schema
        });
        return node;
    });
};
const $2e4406ece4085ab9$export$b2e3d6bb71a327f1 = ({ fragment: fragment, blockMarks: blockMarks = [], schema: schema })=>{
    const paragraphs = [];
    let curChildren = [];
    let lastNode = null;
    const { hardBreak: hardBreak, paragraph: paragraph } = schema.nodes;
    fragment.forEach((node, i)=>{
        const isNodeValidContentForParagraph = schema.nodes.paragraph.validContent((0, $5SAOw.Fragment).from(node));
        if (!isNodeValidContentForParagraph) {
            paragraphs.push(node);
            return;
        }
        // ED-14725 Fixed the issue that it make duplicated line
        // when pasting <br /> from google docs.
        if (i === 0 && node.type === hardBreak) {
            paragraphs.push(paragraph.createChecked(undefined, curChildren, [
                ...blockMarks
            ]));
            lastNode = node;
            return;
        } else if (lastNode && lastNode.type === hardBreak && node.type === hardBreak) {
            // double hardbreak
            // backtrack a little; remove the trailing hardbreak we added last loop
            curChildren.pop();
            // create a new paragraph
            paragraphs.push(paragraph.createChecked(undefined, curChildren, [
                ...blockMarks
            ]));
            curChildren = [];
            return;
        }
        // add to this paragraph
        curChildren.push(node);
        lastNode = node;
    });
    if (curChildren.length) paragraphs.push(paragraph.createChecked(undefined, curChildren, [
        ...blockMarks
    ]));
    return (0, $5SAOw.Fragment).from(paragraphs.length ? paragraphs : // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    [
        paragraph.createAndFill(undefined, undefined, [
            ...blockMarks
        ])
    ]);
};



var $gAARK = parcelRequire("gAARK");




var $gK9Ck = parcelRequire("gK9Ck");

var $f14He = parcelRequire("f14He");

var $i1Isf = parcelRequire("i1Isf");





var $fCrf0 = parcelRequire("fCrf0");




function $8ed707feaf00ea4f$export$5ed9534d355a0a0f(slice, schema, api) {
    const { mediaSingle: mediaSingle, layoutSection: layoutSection, table: table, bulletList: bulletList, orderedList: orderedList, expand: expand, nestedExpand: nestedExpand } = schema.nodes;
    return (selection)=>{
        let newSlice = slice;
        if ((0, $8m4tT.hasParentNodeOfType)([
            layoutSection,
            table,
            bulletList,
            orderedList,
            expand,
            nestedExpand
        ])(selection)) newSlice = (0, $3Ter7.mapSlice)(newSlice, (node)=>{
            const mediaState = api?.media?.sharedState.currentState();
            const extendedOrLegacyAttrs = mediaState?.mediaOptions?.allowPixelResizing ? {
                layout: node.attrs.layout,
                widthType: node.attrs.widthType,
                width: node.attrs.width
            } : {
                layout: node.attrs.layout
            };
            let attrs = {};
            if ((0, $8m4tT.hasParentNodeOfType)([
                layoutSection,
                table
            ])(selection)) // Supports layouts
            attrs = {
                ...extendedOrLegacyAttrs
            };
            else if ((0, $8m4tT.hasParentNodeOfType)([
                bulletList,
                orderedList,
                expand,
                nestedExpand
            ])(selection)) // does not support other layouts
            attrs = {
                ...extendedOrLegacyAttrs,
                layout: 'center'
            };
            return node.type.name === 'mediaSingle' ? mediaSingle.createChecked(attrs, node.content, node.marks) : node;
        });
        return newSlice;
    };
}
const $8ed707feaf00ea4f$export$fb85bc5d6d9ef19b = (fileType)=>{
    return !!fileType && (fileType.indexOf('image/') > -1 || fileType.indexOf('video/') > -1);
};
const $8ed707feaf00ea4f$export$bd95a8dd607682c8 = (slice, schema)=>{
    const { mediaGroup: mediaGroup, mediaSingle: mediaSingle, media: media } = schema.nodes;
    return (0, $3Ter7.mapSlice)(slice, (node, parent)=>{
        if (!parent && node.type === media) {
            if (mediaSingle && ($8ed707feaf00ea4f$export$fb85bc5d6d9ef19b(node.attrs.__fileMimeType) || node.attrs.type === 'external')) return mediaSingle.createChecked({}, node);
            else return mediaGroup.createChecked({}, [
                node
            ]);
        }
        return node;
    });
};
const $8ed707feaf00ea4f$export$77944619eaa3fcd3 = (slice, schema, api)=>{
    const { mediaInline: mediaInline, mediaSingle: mediaSingle, media: media } = schema.nodes;
    const newSlice = (0, $3Ter7.mapSlice)(slice, (node)=>{
        // This logic is duplicated in editor-plugin-ai where external images can be inserted
        // from external sources through the use of AI.  The editor-plugin-ai package is avoiding
        // sharing dependencies with editor-core to support products using it with various versions
        // of editor packages.
        // The duplication is in the following file:
        // packages/editor/editor-plugin-ai/src/prebuilt/content-transformers/markdown-to-pm/markdown-transformer.ts
        if (node.type === mediaSingle) {
            const mediaState = api?.media?.sharedState.currentState();
            return mediaState?.mediaOptions?.allowPixelResizing ? mediaSingle.createChecked({
                width: node.attrs.width || (0, $gAARK.DEFAULT_IMAGE_WIDTH),
                widthType: node.attrs.widthType || 'pixel',
                layout: node.attrs.layout
            }, node.content, node.marks) : node;
        }
        return node;
    });
    return (0, $3Ter7.mapSlice)(newSlice, (node)=>{
        const __mediaTraceId = (0, $fCrf0.getRandomHex)(8);
        if (node.type === media) {
            api?.core.actions.execute(api?.media?.commands.trackMediaPaste(node.attrs));
            return media.createChecked({
                ...node.attrs,
                __external: node.attrs.type === 'external',
                __mediaTraceId: node.attrs.type === 'external' ? null : __mediaTraceId
            }, node.content, node.marks);
        }
        if (node.type.name === 'mediaInline') {
            api?.core.actions.execute(api?.media?.commands.trackMediaPaste(node.attrs));
            return mediaInline.createChecked({
                ...node.attrs,
                __mediaTraceId: __mediaTraceId
            }, node.content, node.marks);
        }
        return node;
    });
};
/**
 * Check base styles to see if an element will be invisible when rendered in a document.
 * @param element
 */ const $8ed707feaf00ea4f$var$isElementInvisible = (element)=>{
    return element.style.opacity === '0' || element.style.display === 'none' || element.style.visibility === 'hidden';
};
const $8ed707feaf00ea4f$var$VALID_TAGS_CONTAINER = [
    'DIV',
    'TD',
    'BLOCKQUOTE'
];
function $8ed707feaf00ea4f$var$canContainImage(element) {
    if (!element) return false;
    return $8ed707feaf00ea4f$var$VALID_TAGS_CONTAINER.indexOf(element.tagName) !== -1;
}
/**
 * Determines whether an `<img>` inside a mediaSingle wrapper should be hoisted
 * out of the wrapper and treated as a standalone external image.
 *
 * This should only happen when:
 * - The image source is external (data-source="external"), and
 * - The media wrapper has no valid file reference (no data-id), meaning
 *   ProseMirror cannot reconstruct a proper internal media node from the wrapper.
 *
 * When the wrapper has a valid file reference (e.g. internal media from Jira),
 * we leave the wrapper intact so ProseMirror can reconstruct a proper internal media node with the file reference and fetch fresh auth tokens.
 */ function $8ed707feaf00ea4f$var$shouldHoistFromMediaSingle(imageTag) {
    const isExternalSource = imageTag.getAttribute('data-source') === 'external';
    if (!isExternalSource) return false;
    const mediaNode = imageTag.closest('[data-node-type="media"]');
    const hasFileReference = mediaNode?.hasAttribute('data-id') ?? false;
    return !hasFileReference;
}
const $8ed707feaf00ea4f$export$3b69af3aaae9ee54 = (html)=>{
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const wrapper = doc.body;
    // Remove Google Doc's wrapper <b> el
    const docsWrapper = wrapper.querySelector('b[id^="docs-internal-guid-"]');
    if (docsWrapper) (0, $f14He.unwrap)(wrapper, docsWrapper);
    const imageTags = wrapper.querySelectorAll('img');
    if (!imageTags.length) return html;
    imageTags.forEach((imageTag)=>{
        // Capture the immediate parent, we may remove the media from here later.
        const mediaParent = imageTag.parentElement;
        if (!mediaParent) return;
        // Bypass emoji
        if (imageTag.className.includes('emoji-common-emoji-image')) return;
        // Bypass mediaInline images - don't hoist images that are inside a mediaInline wrapper
        // as this would break parseDOM matching for mediaInline nodes
        // We remove the img from the DOM since mediaInline is a leaf node with no content
        if (imageTag.closest('[data-node-type="mediaInline"]') && (0, $1oCLl.expValEquals)('platform_editor_inline_media_copy_paste_fix', 'isEnabled', true)) {
            // Remove the img element so ProseMirror doesn't try to parse it
            // mediaInline nodes are leaf nodes and cannot have children
            imageTag.remove();
            return;
        }
        // when copying a jira comment that contains external image (data-source="external"),
        // the 'media' div is like this:
        // <div data-node-type="media"> has no data-id,
        // But when copying a jira comment that contains image that was uploaded to Jira, the div is like this:
        // <div data-node-type="media" data-type="file" data-id="dce9c14b-b857-41fd-9452-5f4ba3a4f679" data-collection="" data-file-name="Screenshot 2026-05-26 at 4.41.05 pm.png" data-file-size="1354355" data-file-mime-type="image/png">
        // ProseMirror fails to parse the media node because it has no data-id,
        // so we hoist the <img> to replace the entire mediaSingle wrapper
        // so the editor can treat it as a plain external image and render/re-upload it correctly.
        const mediaSingleWrapper = imageTag.closest('[data-node-type="mediaSingle"]');
        if (mediaSingleWrapper && $8ed707feaf00ea4f$var$shouldHoistFromMediaSingle(imageTag) && (0, $1oCLl.expValEquals)('fix_copy_paste_external_media_renderer_to_editor', 'isEnabled', true)) // Hoist the <img> to replace the entire mediaSingle wrapper
        {
            if (mediaSingleWrapper.parentElement) {
                mediaSingleWrapper.parentElement.insertBefore(imageTag, mediaSingleWrapper);
                mediaSingleWrapper.remove();
                return;
            }
        }
        // If either the parent or the image itself contains styles that would make
        // them invisible on copy, dont paste them.
        if ($8ed707feaf00ea4f$var$isElementInvisible(mediaParent) || $8ed707feaf00ea4f$var$isElementInvisible(imageTag)) {
            mediaParent.removeChild(imageTag);
            return;
        }
        // If its wrapped by a valid container we assume its safe to bypass.
        // ProseMirror should handle these cases properly.
        if ($8ed707feaf00ea4f$var$canContainImage(mediaParent) || mediaParent instanceof HTMLSpanElement && mediaParent.closest('[class*="emoji-common"]')) return;
        // Find the top most element that the parent has a valid container for the image.
        // Stop just before found the wrapper
        const insertBeforeElement = (0, $i1Isf.walkUpTreeUntil)(mediaParent, (element)=>{
            // If is at the top just use this element as reference
            if (element.parentElement === wrapper) return true;
            return $8ed707feaf00ea4f$var$canContainImage(element.parentElement);
        });
        // Here we try to insert the media right after its top most valid parent element
        // Unless its the last element in our structure then we will insert above it.
        if (insertBeforeElement && insertBeforeElement.parentElement) {
            // Insert as close as possible to the most closest valid element index in the tree.
            insertBeforeElement.parentElement.insertBefore(imageTag, insertBeforeElement.nextElementSibling || insertBeforeElement);
            // Attempt to clean up lines left behind by the image
            mediaParent.innerText = mediaParent.innerText.trim();
            // Walk up and delete empty elements left over after removing the image tag
            (0, $gK9Ck.removeNestedEmptyEls)(mediaParent);
        }
    });
    // If last child is a hardbreak we don't want it
    if (wrapper.lastElementChild && wrapper.lastElementChild.tagName === 'BR') wrapper.removeChild(wrapper.lastElementChild);
    return wrapper.innerHTML;
};








var $d2M6W = parcelRequire("d2M6W");












var $3824I = parcelRequire("3824I");


var $2oGxU = parcelRequire("2oGxU");


var $d3YeI = parcelRequire("d3YeI");













var $9KolL = parcelRequire("9KolL");

var $iYC9s = parcelRequire("iYC9s");


var $Girkv = parcelRequire("Girkv");




function $2ded4de594877764$export$6ba9f527e53e4ac1(html) {
    return !!html && html.indexOf('urn:schemas-microsoft-com:office:word') >= 0;
}
function $2ded4de594877764$export$8d0b7622c89b176c(html) {
    return !!html && html.indexOf('urn:schemas-microsoft-com:office:excel') >= 0;
}
function $2ded4de594877764$var$isPastedFromDropboxPaper(html) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return !!html && !!html.match(/class=\"\s?author-d-.+"/gim);
}
function $2ded4de594877764$var$isPastedFromGoogleDocs(html) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return !!html && !!html.match(/id=\"docs-internal-guid-.+"/gim);
}
function $2ded4de594877764$var$isPastedFromGoogleSpreadSheets(html) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return !!html && !!html.match(/data-sheets-.+=/gim);
}
function $2ded4de594877764$var$isPastedFromPages(html) {
    return !!html && html.indexOf('content="Cocoa HTML Writer"') >= 0;
}
function $2ded4de594877764$var$isPastedFromFabricEditor(html) {
    return !!html && html.indexOf('data-pm-slice="') >= 0;
}
function $2ded4de594877764$var$isPastedFromFabricRenderer(html) {
    return !!html && html.indexOf('data-renderer-start-pos="') >= 0 && (0, $dh538.fg)('platform_editor_paste_renderer_analytics');
}
const $2ded4de594877764$export$6186a6a0af6a6a9d = (text)=>{
    return !!text && text.trim().split('\n').length === 1;
};
function $2ded4de594877764$export$41d193509f55b76e(html) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return !!html.match(/<img .*>/) && !(0, $Girkv.isMediaBlobUrl)(html);
}
function $2ded4de594877764$export$e45b5b7458bacd81(event) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const html = event.clipboardData.getData('text/html');
    if ($2ded4de594877764$var$isPastedFromDropboxPaper(html)) return 'dropbox-paper';
    else if ($2ded4de594877764$export$6ba9f527e53e4ac1(html)) return 'microsoft-word';
    else if ($2ded4de594877764$export$8d0b7622c89b176c(html)) return 'microsoft-excel';
    else if ($2ded4de594877764$var$isPastedFromGoogleDocs(html)) return 'google-docs';
    else if ($2ded4de594877764$var$isPastedFromGoogleSpreadSheets(html)) return 'google-spreadsheets';
    else if ($2ded4de594877764$var$isPastedFromPages(html)) return 'apple-pages';
    else if ($2ded4de594877764$var$isPastedFromFabricEditor(html)) return 'fabric-editor';
    else if ($2ded4de594877764$var$isPastedFromFabricRenderer(html)) return 'fabric-renderer';
    return 'uncategorized';
}
function $2ded4de594877764$export$8acd10161c5f8b07(text) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return text.replace(/(\[([^\]]+)\]\()?((https?|ftp|jamfselfservice):\/\/[^\s>"]+)/g, (str)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        return str.match(/^(https?|ftp|jamfselfservice):\/\/[^\s>"]+$/) ? `<${str}>` : str;
    });
}
function $2ded4de594877764$export$3e81f5aaf68cd698(textInput) {
    // ref: https://spec.commonmark.org/0.31.2/#fenced-code-blocks
    // Allows up to 3 leading spaces before ``` and optional trailing characters
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const openingCodeFenceRegex = /^( {0,3})```.*$/;
    // Allows up to 3 leading spaces before ``` and optional trailing spaces or tabs
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const closingCodeFenceRegex = /^( {0,3})```[ \t]*$/;
    let isInsideCodeBlock = false;
    const lines = textInput.split('\n');
    // In the splitted array, we traverse through every line and check if it will be parsed as a codeblock.
    return lines.map((line)=>{
        if (!isInsideCodeBlock && openingCodeFenceRegex.test(line)) {
            isInsideCodeBlock = true;
            return line;
        }
        if (isInsideCodeBlock && closingCodeFenceRegex.test(line)) {
            isInsideCodeBlock = false;
            return line;
        }
        // not code fence, don't escape anything inside code block
        if (isInsideCodeBlock) return line;
        else {
            // Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp, @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
            let escaped = line.replace(/\\/g, '\\\\');
            escaped = $2ded4de594877764$export$8acd10161c5f8b07(escaped);
            return escaped;
        }
    }).join('\n');
}
function $2ded4de594877764$export$a4568554bf9b43cd(...nodeTypes) {
    return (slice)=>{
        let hasOnlyNodesOfType = true;
        slice.content.descendants((node)=>{
            hasOnlyNodesOfType = hasOnlyNodesOfType && nodeTypes.indexOf(node.type) > -1;
            return hasOnlyNodesOfType;
        });
        return hasOnlyNodesOfType;
    };
}
function $2ded4de594877764$export$3bf611fd421c1669(schema, marks) {
    return (slice)=>{
        const { marks: { code: codeMark, link: linkMark, annotation: annotationMark } } = schema;
        if (!Array.isArray(marks) || marks.length === 0) return slice;
        const sliceCopy = (0, $5SAOw.Slice).fromJSON(schema, slice.toJSON() || {});
        // allow links and annotations to be pasted
        const allowedMarksToPaste = [
            linkMark,
            annotationMark
        ];
        sliceCopy.content.descendants((node, _pos, parent)=>{
            if (node.isText && parent && parent.isBlock) {
                // @ts-ignore - [unblock prosemirror bump] assigning to readonly prop
                node.marks = [
                    // remove all marks from pasted slice when applying code mark
                    // and exclude all marks that are not allowed to be pasted
                    ...node.marks && !codeMark.isInSet(marks) && node.marks.filter((mark)=>allowedMarksToPaste.includes(mark.type)) || [],
                    // add marks to a slice if they're allowed in parent node
                    // and exclude link marks
                    ...parent.type.allowedMarks(marks).filter((mark)=>mark.type !== linkMark)
                ].sort((0, $2oGxU.sortByOrderWithTypeName)('marks'));
                return false;
            }
            if (node.isInline && [
                'inlineCard',
                'emoji',
                'status',
                'date',
                'mention'
            ].includes(node.type.name) && parent && parent.isBlock) // @ts-ignore - [unblock prosemirror bump] assigning to readonly prop
            node.marks = [
                ...node.marks,
                ...parent.type.allowedMarks(marks).filter((mark)=>mark.type === schema.marks.annotation)
            ];
            return true;
        });
        return sliceCopy;
    };
}
function $2ded4de594877764$export$641fdf56f693bfbc(node) {
    if (!node) return false;
    const { type: nodeType } = node;
    const emptyNode = nodeType.createAndFill();
    return emptyNode && emptyNode.nodeSize === node.nodeSize && emptyNode.content.eq(node.content) && (0, $5SAOw.Mark).sameSet(emptyNode.marks, node.marks);
}
function $2ded4de594877764$export$ee1d3ec5b3695690(selection) {
    return selection instanceof (0, $ks2lK.TextSelection) && selection.empty && selection.$cursor && (!selection.$cursor.nodeBefore || !selection.$cursor.nodeAfter);
}
function $2ded4de594877764$export$c7c9ca5cba02ff5a(node) {
    return Boolean(node && node.type.name === 'panel');
}
function $2ded4de594877764$export$3befc640b7d49184(selection) {
    if (selection instanceof (0, $ks2lK.NodeSelection) && $2ded4de594877764$export$c7c9ca5cba02ff5a(selection.node)) return selection.node;
    const { doc: { type: { schema: { nodes: { panel: panel } } } } } = selection.$from;
    const panelPosition = (0, $8m4tT.findParentNodeOfType)(panel)(selection);
    if (panelPosition) return panelPosition.node;
    return null;
}
const $2ded4de594877764$export$3c3a613abe5bb97d = (html)=>{
    return !!html && (html.includes('</a></a>') || html.includes('"></a><a'));
};
const $2ded4de594877764$export$35ca1bb0581efaf3 = (html)=>{
    if ($2ded4de594877764$export$3c3a613abe5bb97d(html)) {
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        const htmlArray = html.split(/(?=<a)/);
        const htmlArrayWithoutInvalidLinks = htmlArray.filter((item)=>{
            return !(item.includes('<a') && item.includes('"></a>')) && !(item.includes('<a') && !item.includes('</a>'));
        });
        const fixedHtml = htmlArrayWithoutInvalidLinks.join('')// Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        .replace(/<\/a><\/a>/gi, '</a>')// Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        .replace(/<a>/gi, '<a');
        return fixedHtml;
    }
    return html;
};
const $2ded4de594877764$export$4f704994f6a89bd1 = (state, tr, editorAnalyticsAPI)=>{
    if ((0, $iYC9s.isTableSelected)(state.selection)) {
        const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $9KolL.getSelectedTableInfo)(state.selection);
        editorAnalyticsAPI?.attachAnalyticsEvent({
            action: (0, $3824I.TABLE_ACTION).REPLACED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
            attributes: {
                totalColumnCount: totalColumnCount,
                totalRowCount: totalRowCount,
                inputMethod: (0, $d925B.INPUT_METHOD).CLIPBOARD
            },
            eventType: (0, $d925B.EVENT_TYPE).TRACK
        })(tr);
        return tr;
    }
    return state.tr;
};
const $2ded4de594877764$export$9ffea5586131a948 = (slice, state, cardOptions)=>{
    const { blockCard: blockCard, inlineCard: inlineCard } = state.schema.nodes;
    const children = [];
    (0, $3Ter7.mapChildren)(slice.content, (node, i, frag)=>{
        if (node.type === blockCard && !$2ded4de594877764$var$isBlockCardSupported(state, frag, cardOptions?.allowBlockCards ?? false)) children.push(inlineCard.createChecked(node.attrs, node.content, node.marks));
        else children.push(node);
    });
    return new (0, $5SAOw.Slice)((0, $5SAOw.Fragment).fromArray(children), slice.openStart, slice.openEnd);
};
/**
 * Function to determine if a block card is supported by the editor
 * @param state
 * @param frag
 * @param allowBlockCards
 * @returns
 */ const $2ded4de594877764$var$isBlockCardSupported = (state, frag, allowBlockCards)=>{
    return allowBlockCards && (0, $d3YeI.isSupportedInParent)(state, frag);
};


// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $cUcZ5 = parcelRequire("cUcZ5");


var $1OR0A = parcelRequire("1OR0A");











var $hBm38 = parcelRequire("hBm38");


var $8DwGl = parcelRequire("8DwGl");


var $kAKYF = parcelRequire("kAKYF");

var $20bG5 = parcelRequire("20bG5");


var $adhil = parcelRequire("adhil");

var $9GYNY = parcelRequire("9GYNY");


var $j9WGh = parcelRequire("j9WGh");

var $l9G9n = parcelRequire("l9G9n");

var $7iE7T = parcelRequire("7iE7T");

var $4DdJm = parcelRequire("4DdJm");























var $id9O1 = parcelRequire("id9O1");




const $a61730028ef020bd$export$ea73b328547c6ad5 = (state, content)=>{
    if ((0, $iYC9s.isTableSelected)(state.selection)) {
        const table = (0, $id9O1.findTable)(state.selection);
        if (table) {
            const slice = typeof content === 'string' ? new (0, $5SAOw.Slice)((0, $5SAOw.Fragment).from(state.schema.text(content)), 0, 0) : content;
            const tr = state.tr.replace(table.pos, table.pos + table.node.nodeSize, slice);
            tr.setSelection((0, $ks2lK.TextSelection).create(tr.doc, table.pos + slice.size + 1));
            return tr;
        }
    }
    return state.tr;
};






var $ke2AI = parcelRequire("ke2AI");







var $dhoHU = parcelRequire("dhoHU");











var $aXG5V = parcelRequire("aXG5V");








parcelRequire("l9G9n");
var $jMZUD = parcelRequire("jMZUD");













function $62c6c6b359b84fb6$export$d69afd888d46c7c({ tr: tr, slice: slice }) {
    tr.replaceSelection(slice);
}
function $62c6c6b359b84fb6$export$7b48cb097052829({ tr: tr, slice: slice }) {
    const { selection: selection } = tr;
    const { $cursor: $cursor } = selection;
    if (!$cursor) return;
    const position = !$cursor.nodeBefore ? $cursor.before() : $cursor.after();
    tr.replaceRange(position, position, slice);
    const startSlicePosition = tr.doc.resolve(Math.min(position + slice.content.size - slice.openEnd, tr.doc.content.size));
    const direction = -1;
    tr.setSelection((0, $ks2lK.TextSelection).near(startSlicePosition, direction));
}
function $62c6c6b359b84fb6$export$eee44e0848f600ea({ tr: tr, slice: slice }) {
    const { selection: { $to: $to, $from: $from, to: to, from: from } } = tr;
    // when the selection is inside of the same list item
    // we can use a normal replace
    if ($from.sameParent($to) || $from.depth === $to.depth) return tr.replaceSelection(slice);
    // if pasting a list inside another list, ensure no empty list items get added
    const newRange = $from.blockRange($to);
    if (!newRange) return;
    const startPos = from;
    const endPos = $to.nodeAfter ? to : to + 2;
    const newSlice = tr.doc.slice(endPos, newRange.end);
    tr.deleteRange(startPos, newRange.end);
    const mapped = tr.mapping.map(startPos);
    tr.replaceRange(mapped, mapped, slice);
    if (newSlice.size <= 0) return;
    const newSelection = (0, $ks2lK.TextSelection).near(tr.doc.resolve(tr.mapping.map(mapped)), -1);
    // @ts-ignore - [unblock prosemirror bump] assigning to readonly prop
    newSlice.openEnd = newSlice.openStart;
    tr.replaceRange(newSelection.from, newSelection.from, newSlice);
    tr.setSelection((0, $ks2lK.TextSelection).near(tr.doc.resolve(newSelection.from), -1));
}
function $62c6c6b359b84fb6$export$778b6ddd10a6aad3(panelNode) {
    return ({ tr: tr, slice: slice, schema: schema })=>{
        const { selection: selection, selection: { $to: $to, $from: $from } } = tr;
        const { from: panelPosition } = selection;
        // if content of slice isn't valid for a panel node, insert the invalid node and following content after
        if (panelNode && !panelNode.type.validContent((0, $5SAOw.Fragment).from(slice.content))) {
            let insertPosition = $to.pos + 1;
            /* Adapting above logic to handle MBE, as it currently assumes that slice can be safely inserted after the panel node, which is not the case for MBE
         If insertPosition is in MBE and current slice contains invalid content for MBE, we need to insert the slice after the MBE node
      */ if (schema) {
                const mbeParentOfPanel = (0, $8m4tT.findParentNodeOfType)(schema.nodes.multiBodiedExtension)(selection);
                if (mbeParentOfPanel && !mbeParentOfPanel.node.type.validContent((0, $5SAOw.Fragment).from(slice.content))) insertPosition = mbeParentOfPanel.start + mbeParentOfPanel.node.nodeSize - 1;
            }
            tr.replaceRange(insertPosition, insertPosition, slice);
            // need to delete the empty paragraph at the top of the panel
            const parentNode = tr.doc.resolve($from.before()).node();
            if (parentNode && parentNode.childCount > 1 && parentNode.firstChild?.type.name === 'paragraph' && (0, $jMZUD.isEmptyParagraph)(parentNode.firstChild)) {
                const startPosDelete = tr.doc.resolve($from.before()).posAtIndex(0);
                const endPosDelete = tr.doc.resolve($from.before()).posAtIndex(1);
                const SIZE_OF_EMPTY_PARAGRAPH = 2; // {startPos}<p>{startPos + 1}</p>{endPos}
                if (endPosDelete - startPosDelete === SIZE_OF_EMPTY_PARAGRAPH) tr.delete(startPosDelete, endPosDelete);
            }
            tr.setSelection((0, $ks2lK.TextSelection).near(tr.doc.resolve(insertPosition + slice.content.size - slice.openStart - slice.openEnd + 1)));
            return;
        }
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const temporaryDoc = new (0, $aXG5V.Transform)(tr.doc.type.createAndFill());
        temporaryDoc.replaceRange(0, temporaryDoc.doc.content.size, slice);
        const sliceWithoutInvalidListSurrounding = temporaryDoc.doc.slice(0);
        const newPanel = panelNode.copy(sliceWithoutInvalidListSurrounding.content);
        const panelNodeSelected = selection instanceof (0, $ks2lK.NodeSelection) ? selection.node : null;
        const replaceFrom = panelNodeSelected ? panelPosition : tr.doc.resolve(panelPosition).start();
        const replaceTo = panelNodeSelected ? panelPosition + panelNodeSelected.nodeSize : replaceFrom;
        tr.replaceRangeWith(replaceFrom, replaceTo, newPanel);
        tr.setSelection((0, $ks2lK.TextSelection).near(tr.doc.resolve($from.pos + newPanel.content.size), -1));
    };
}


function $cfa8bd4c8427b032$export$9beec16307c108ac({ tr: tr, slice: slice, schema: schema }) {
    const { selection: selection, selection: { $to: $to, $from: $from } } = tr;
    const { $cursor: $cursor } = selection;
    const panelNode = (0, $2ded4de594877764$export$3befc640b7d49184)(selection);
    const selectionIsInsideList = $from.blockRange($to, (0, $jshjN.isListNode));
    if (!$cursor && selectionIsInsideList) return (0, $62c6c6b359b84fb6$export$eee44e0848f600ea)({
        tr: tr,
        slice: slice
    });
    // if inside an empty panel, try and insert content inside it rather than replace it
    if (panelNode && (0, $2ded4de594877764$export$641fdf56f693bfbc)(panelNode) && $from.node() === $to.node()) return (0, $62c6c6b359b84fb6$export$778b6ddd10a6aad3)(panelNode)({
        tr: tr,
        slice: slice,
        schema: schema
    });
    if (!$cursor || selectionIsInsideList) return tr.replaceSelection(slice);
    if ((0, $2ded4de594877764$export$641fdf56f693bfbc)(tr.doc.resolve($cursor.pos).node())) return (0, $62c6c6b359b84fb6$export$d69afd888d46c7c)({
        tr: tr,
        slice: slice
    });
    // When pasting a single list item into an action or decision, we skip the special "insert at node edge"
    // logic so that prosemirror pastes the list's content into the action/decision, rather than
    // pasting a whole list node directly after the action/decision item. (But we still preserve the
    // existing "insert at" node edge" behaviour if dealing with a list with more than one item, so that
    // it still inserts whole list node after the action/decision item).
    const pastingIntoActionOrDecision = Boolean((0, $8m4tT.findParentNodeOfType)([
        schema.nodes.taskList,
        schema.nodes.decisionList
    ])(selection));
    const oneListItem = slice.content.childCount === 1 && (0, $jshjN.isListNode)(slice.content.firstChild) && slice.content.firstChild?.childCount === 1;
    if (!(pastingIntoActionOrDecision && oneListItem) && (0, $2ded4de594877764$export$ee1d3ec5b3695690)(selection)) return (0, $62c6c6b359b84fb6$export$7b48cb097052829)({
        tr: tr,
        slice: slice
    });
    tr.replaceSelection(slice);
}
const $cfa8bd4c8427b032$var$stripFontSizeInsideBlockquoteLists = (tr, blockquotePos)=>{
    const { marks: { fontSize: fontSize }, nodes: { paragraph: paragraph, listItem: listItem, taskItem: taskItem, blockTaskItem: blockTaskItem } } = tr.doc.type.schema;
    const listItemParentNodeTypes = [
        listItem,
        taskItem,
        blockTaskItem
    ];
    if (!fontSize || !(0, $1oCLl.expValEquals)('platform_editor_small_font_size', 'isEnabled', true)) return;
    const containingBlockquote = tr.doc.nodeAt(blockquotePos);
    if (!containingBlockquote) return;
    const from = blockquotePos + 1;
    const to = blockquotePos + containingBlockquote.nodeSize - 1;
    (0, $dhoHU.createToggleBlockMarkOnRangeNext)(fontSize, ()=>false, (_schema, node, parent)=>node.type === paragraph && !!parent && listItemParentNodeTypes.some((nodeType)=>nodeType === parent.type))(from, to, tr);
};
function $cfa8bd4c8427b032$export$2dee216d0a70c94e({ tr: tr, slice: slice }) {
    //insert blockquote explicitly and set the selection in blockquote since replaceSelection will only insert the list
    const { schema: schema } = tr.doc.type;
    tr.replaceSelection(new (0, $5SAOw.Slice)((0, $5SAOw.Fragment).from(schema.nodes.blockquote.createAndFill()), 0, 0));
    $cfa8bd4c8427b032$export$e57c13697a8b8195({
        tr: tr
    });
    tr.replaceSelection(slice);
    if ((0, $1oCLl.expValEquals)('platform_editor_small_font_size', 'isEnabled', true)) {
        const insertedBlockquotePos = (0, $8m4tT.findParentNodeOfType)(schema.nodes.blockquote)(tr.selection);
        if (!insertedBlockquotePos) return;
        $cfa8bd4c8427b032$var$stripFontSizeInsideBlockquoteLists(tr, insertedBlockquotePos.pos);
    }
}
function $cfa8bd4c8427b032$export$e57c13697a8b8195({ tr: tr }) {
    // ProseMirror doesn't give a proper way to tell us where something was inserted.
    // However, we can know "how" it inserted something.
    //
    // So, instead of weird depth calculations, we can use the step produced by the transform.
    // For instance:
    //    The `replaceStep.to and replaceStep.from`, tell us the real position
    //    where the content will be insert.
    //    Then, we can use the `tr.mapping.map` to the updated position after the replace operation
    const replaceStep = tr.steps[0];
    if (!(replaceStep instanceof (0, $aXG5V.ReplaceStep))) return tr;
    const nextPosition = tr.mapping.map(replaceStep.to);
    // The findFrom will make search for both: TextSelection and NodeSelections.
    const nextSelection = (0, $ks2lK.Selection).findFrom(tr.doc.resolve(Math.min(nextPosition, tr.doc.content.size)), -1);
    if (nextSelection) tr.setSelection(nextSelection);
}
function $cfa8bd4c8427b032$export$2982aac953f7c8b6({ tr: tr, slice: slice }) {
    const { schema: schema } = tr.doc.type;
    //To avoid the list being replaced with the tasklist, enclose the slice within a taskItem.
    const selectionBeforeReplace = tr.selection.from;
    tr.replaceSelection(new (0, $5SAOw.Slice)((0, $5SAOw.Fragment).from(schema.nodes.taskItem.createAndFill()), 0, 0));
    const nextSelection = (0, $ks2lK.Selection).near(tr.doc.resolve(selectionBeforeReplace + 1));
    tr.setSelection(nextSelection);
    tr.replaceSelection(slice);
}




const $ed7aabc7e8e09621$var$insideExpand = (state)=>{
    const { expand: expand, nestedExpand: nestedExpand } = state.schema.nodes;
    return (0, $8m4tT.hasParentNodeOfType)([
        expand,
        nestedExpand
    ])(state.selection);
};
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Compose 1 to n functions.
 * @param func first function
 * @param funcs additional functions
 */ function $ed7aabc7e8e09621$var$compose(func, ...funcs) {
    const allFuncs = [
        func,
        ...funcs
    ];
    return function composed(raw) {
        return allFuncs.reduceRight((memo, func)=>func(memo), raw);
    };
}
function $ed7aabc7e8e09621$export$7097a0398467de9c(slice, schema) {
    return (0, $3Ter7.mapSlice)(slice, (node)=>{
        // We should move this to the mention plugin when we refactor how paste works in the future
        // For now we can just null check mention exists in the schema to ensure we don't crash if it doesn't
        // exist.
        if (node.type.name === schema.nodes.mention?.name) {
            const mention = node.attrs;
            const newMention = {
                ...mention,
                text: ''
            };
            return schema.nodes.mention.create(newMention, node.content, node.marks);
        }
        return node;
    });
}
function $ed7aabc7e8e09621$export$af959912bf89ae42(slice, queueCardsFromChangedTr) {
    return (state, dispatch)=>{
        const { schema: schema, tr: { selection: selection } } = state;
        const { marks: { code: codeMark }, nodes: { decisionItem: decisionItem, emoji: emoji, hardBreak: hardBreak, mention: mention, paragraph: paragraph, taskItem: taskItem, text: text, panel: panel, bulletList: bulletList, orderedList: orderedList, taskList: taskList, listItem: listItem, expand: expand, heading: heading, codeBlock: codeBlock } } = schema;
        const selectionIsValidNode = state.selection instanceof (0, $ks2lK.NodeSelection) && [
            'decisionList',
            'decisionItem',
            'taskList',
            'taskItem'
        ].includes(state.selection.node.type.name);
        const selectionHasValidParentNode = (0, $8m4tT.hasParentNodeOfType)([
            decisionItem,
            taskItem,
            panel
        ])(state.selection);
        const selectionIsCodeBlock = (0, $8m4tT.hasParentNodeOfType)([
            codeBlock
        ])(state.selection);
        const selectionIsListItem = (0, $8m4tT.hasParentNodeOfType)([
            listItem
        ])(state.selection);
        const panelNode = (0, $2ded4de594877764$export$3befc640b7d49184)(selection);
        const selectionIsPanel = Boolean(panelNode);
        const isSliceWholePanel = slice.content.firstChild?.type === panel && slice.openStart === 0 && slice.openEnd === 0;
        // we avoid handling codeBlock-in-panel use case in this function
        // returning false will allow code to flow into `handleCodeBlock` function
        // Partial content copied from panels will have panel in the slice
        // Return false to avoid handling this situation when pasted into list in panel and let `handlePastePanelOrDecisionContentIntoList` handle it
        if (selectionIsPanel && (selectionIsCodeBlock || selectionIsListItem && !isSliceWholePanel && (0, $1oCLl.expValEquals)('platform_editor_pasting_text_in_panel', 'isEnabled', true))) return false;
        // Some types of content should be handled by the default handler, not this function.
        // Check through slice content to see if it contains an invalid node.
        let sliceIsInvalid = false;
        let sliceHasTask = false;
        slice.content.nodesBetween(0, slice.content.size, (node)=>{
            if (node.type === bulletList || node.type === orderedList || node.type === expand || node.type === heading || node.type === listItem) sliceIsInvalid = true;
            if (selectionIsPanel && node.type === taskList) sliceHasTask = true;
        });
        // If the selection is a panel,
        // and the slice's first node is a paragraph
        // and it is not from a depth that would indicate it being from inside from another node (e.g. text from a decision)
        // then we can rely on the default behaviour.
        const selectionIsTaskOrDecision = (0, $8m4tT.hasParentNode)((node)=>node.type === taskItem || node.type === decisionItem)(selection);
        const sliceIsAPanelReceivingLowDepthText = selectionIsPanel && !selectionIsTaskOrDecision && slice.content.firstChild?.type === paragraph && slice.openEnd < 2;
        if (sliceIsInvalid || sliceIsAPanelReceivingLowDepthText || !selectionIsValidNode && !selectionHasValidParentNode) return false;
        const filters = [
            (0, $b0F8r.linkifyContent)(schema)
        ];
        const selectionMarks = selection.$head.marks();
        if (selection instanceof (0, $ks2lK.TextSelection) && Array.isArray(selectionMarks) && selectionMarks.length > 0 && (0, $2ded4de594877764$export$a4568554bf9b43cd)(paragraph, text, emoji, mention, hardBreak)(slice) && (!codeMark.isInSet(selectionMarks) || (0, $8DwGl.anyMarkActive)(state, codeMark) // check if there is a code mark anywhere in the selection
        )) filters.push((0, $2ded4de594877764$export$3bf611fd421c1669)(schema, selection.$head.marks()));
        const transformedSlice = $ed7aabc7e8e09621$var$compose.apply(null, filters)(slice);
        const isFirstChildTaskNode = transformedSlice.content.firstChild.type === taskList || transformedSlice.content.firstChild.type === taskItem;
        const tr = (0, $ke2AI.closeHistory)(state.tr);
        if (panelNode && sliceHasTask && slice.content.firstChild?.type === panel && (0, $2ded4de594877764$export$641fdf56f693bfbc)(panelNode) && selection.$from.node() === selection.$to.node()) return Boolean((0, $62c6c6b359b84fb6$export$778b6ddd10a6aad3)(panelNode)({
            tr: tr,
            slice: slice
        }));
        const transformedSliceIsValidNode = (transformedSlice.content.firstChild.type.inlineContent || [
            'decisionList',
            'decisionItem',
            'taskItem',
            'taskList',
            'panel'
        ].includes(transformedSlice.content.firstChild.type.name)) && (!(0, $l9G9n.isInListItem)(state) || (0, $l9G9n.isInListItem)(state) && isFirstChildTaskNode);
        // If the slice or the selection are valid nodes to handle,
        // and the slice is not a whole node (i.e. openStart is 1 and openEnd is 0)
        // or the slice's first node is a paragraph,
        // then we can replace the selection with our slice.
        const pastingIntoExtendedPanel = selectionIsPanel && panel.validContent(transformedSlice.content);
        if ((transformedSliceIsValidNode || selectionIsValidNode) && !pastingIntoExtendedPanel && !(transformedSlice.openStart === 1 && transformedSlice.openEnd === 0 || // Whole codeblock node has reverse slice depths.
        transformedSlice.openStart === 0 && transformedSlice.openEnd === 1) || transformedSlice.content.firstChild?.type === paragraph) tr.replaceSelection(transformedSlice).scrollIntoView();
        else {
            const isWholeContentSelected = selection.$from.pos === selection.$from.start() && selection.$to.end() === selection.$to.pos;
            if (pastingIntoExtendedPanel && selection.$from.pos !== selection.$to.pos && !isWholeContentSelected) // Do a replaceSelection if the entire panel content isn't selected
            //tr.replaceSelection(transformedSlice).scrollIntoView();
            tr.replaceSelection(new (0, $5SAOw.Slice)(transformedSlice.content, 0, transformedSlice.openEnd)).scrollIntoView();
            else if ([
                'mediaSingle'
            ].includes(transformedSlice.content.firstChild.type.name) && selectionIsPanel) {
                const parentNode = (0, $8m4tT.findParentNodeOfType)(panel)(selection);
                if (selectionIsPanel && parentNode && (0, $l9G9n.isNodeEmpty)(parentNode.node)) {
                    tr.insert(selection.$from.pos, transformedSlice.content).scrollIntoView();
                    // Place the cursor at the the end of the insersertion
                    const endPos = tr.selection.from + transformedSlice.size;
                    tr.setSelection(new (0, $ks2lK.TextSelection)(tr.doc.resolve(endPos)));
                } else tr.replaceSelection(transformedSlice).scrollIntoView();
            } else {
                if (pastingIntoExtendedPanel && isWholeContentSelected) // if the entire panel content is selected, doing a replaceSelection removes the panel as well. Hence we do delete followed by safeInsert
                tr.delete(selection.$from.pos, selection.$to.pos);
                // This maintains both the selection (destination) and the slice (paste content).
                (0, $8m4tT.safeInsert)(transformedSlice.content)(tr).scrollIntoView();
                if (transformedSlice.content.lastChild?.type?.name === 'rule') tr.setSelection((0, $ks2lK.TextSelection).near(tr.doc.resolve(tr.selection.$from.pos + transformedSlice.content.size)));
                else {
                    // safeInsert doesn't set correct cursor position
                    // it moves the cursor to beginning of the node
                    // we manually shift the cursor to end of the node
                    const nextPos = tr.doc.resolve(tr.selection.$from.end());
                    tr.setSelection(new (0, $ks2lK.TextSelection)(nextPos));
                }
            }
        }
        queueCardsFromChangedTr?.(state, tr, (0, $d925B.INPUT_METHOD).CLIPBOARD);
        if (dispatch) dispatch(tr);
        return true;
    };
}
function $ed7aabc7e8e09621$export$b8a52be876d0b84f(slice) {
    return (state, dispatch)=>{
        const { tr: tr } = state;
        const { selection: selection } = tr;
        const { $from: $from, $to: $to, from: from, to: to } = selection;
        const { orderedList: orderedList, bulletList: bulletList, listItem: listItem } = state.schema.nodes;
        // Selected nodes
        const selectionParentListItemNode = (0, $8m4tT.findParentNodeOfType)(listItem)(selection);
        const selectionParentListNodeWithPos = (0, $8m4tT.findParentNodeOfType)([
            bulletList,
            orderedList
        ])(selection);
        const selectionParentListNode = selectionParentListNodeWithPos?.node;
        // Slice info
        const sliceContent = slice.content;
        const sliceIsListItems = (0, $jshjN.isListNode)(sliceContent.firstChild) && (0, $jshjN.isListNode)(sliceContent.lastChild);
        // Find case of slices that can be inserted into a list item
        // (eg. paragraphs, list items, code blocks, media single)
        // These scenarios already get handled elsewhere and don't need to split the list
        let sliceContainsBlockNodesOtherThanThoseAllowedInListItem = false;
        slice.content.forEach((child)=>{
            if (!listItem || child.isBlock && !listItem.spec.content?.includes(child.type.name)) sliceContainsBlockNodesOtherThanThoseAllowedInListItem = true;
        });
        if (!selectionParentListItemNode || !sliceContent || (0, $8m4tT.canInsert)($from, sliceContent) || // eg. inline nodes that can be inserted in a list item
        !sliceContainsBlockNodesOtherThanThoseAllowedInListItem || sliceIsListItems || !selectionParentListNodeWithPos) return false;
        // Offsets
        const listWrappingOffset = $to.depth - selectionParentListNodeWithPos.depth + 1; // difference in depth between to position and list node
        const listItemWrappingOffset = $to.depth - selectionParentListNodeWithPos.depth; // difference in depth between to position and list item node
        // Anything to do with nested lists should safeInsert and not be handled here
        if ($ed7aabc7e8e09621$export$67c0f4368bb304c3(state)) return false;
        // Node after the insert position
        const nodeAfterInsertPositionIsListItem = tr.doc.nodeAt(to + listItemWrappingOffset)?.type.name === 'listItem';
        // Get the next list items position (used later to find the split out ordered list)
        const indexOfNextListItem = $to.indexAfter($to.depth - listItemWrappingOffset);
        const positionOfNextListItem = tr.doc.resolve(selectionParentListNodeWithPos.pos + 1).posAtIndex(indexOfNextListItem);
        // These nodes paste as plain text by default so need to be handled differently
        const sliceContainsNodeThatPastesAsPlainText = sliceContent.firstChild && [
            'taskItem',
            'taskList',
            'heading',
            'blockquote'
        ].includes(sliceContent.firstChild.type.name);
        // Work out position to replace up to
        let replaceTo;
        if (sliceContainsNodeThatPastesAsPlainText && nodeAfterInsertPositionIsListItem) replaceTo = to + listItemWrappingOffset;
        else if (sliceContainsNodeThatPastesAsPlainText || !nodeAfterInsertPositionIsListItem) replaceTo = to;
        else replaceTo = to + listWrappingOffset;
        // handle the insertion of the slice
        if (slice.content.firstChild?.type.name === 'blockquote' && (0, $8m4tT.contains)(slice.content.firstChild, state.schema.nodes.listItem)) (0, $cfa8bd4c8427b032$export$2dee216d0a70c94e)({
            tr: tr,
            slice: slice
        });
        else if (sliceContainsNodeThatPastesAsPlainText || nodeAfterInsertPositionIsListItem || sliceContent.childCount > 1 && sliceContent.firstChild?.type.name !== 'paragraph') tr.replaceWith(from, replaceTo, sliceContent).scrollIntoView();
        else // When the selection is not at the end of a list item
        // eg. middle of list item, start of list item
        tr.replaceSelection(slice).scrollIntoView();
        // Find the ordered list node after the pasted content so we can set it's order
        const mappedPositionOfNextListItem = tr.mapping.map(positionOfNextListItem);
        if (mappedPositionOfNextListItem > tr.doc.nodeSize) return false;
        const nodeAfterPastedContentResolvedPos = (0, $8m4tT.findParentNodeOfTypeClosestToPos)(tr.doc.resolve(mappedPositionOfNextListItem), [
            orderedList
        ]);
        // Work out the new split out lists 'order' (the number it starts from)
        const originalParentOrderedListNodeOrder = selectionParentListNode?.attrs.order;
        const numOfListItemsInOriginalList = (0, $8m4tT.findParentNodeOfTypeClosestToPos)(tr.doc.resolve(from - 1), [
            orderedList
        ])?.node.childCount;
        // Set the new split out lists order attribute
        if (typeof originalParentOrderedListNodeOrder === 'number' && numOfListItemsInOriginalList && nodeAfterPastedContentResolvedPos) tr.setNodeMarkup(nodeAfterPastedContentResolvedPos.pos, orderedList, {
            ...nodeAfterPastedContentResolvedPos.node.attrs,
            order: originalParentOrderedListNodeOrder + numOfListItemsInOriginalList
        });
        // dispatch transaction
        if (tr.docChanged) {
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };
}
const $ed7aabc7e8e09621$export$c2473d50cf33051b = (selection, findRootParentListNode)=>{
    const { $from: $from, $to: $to, from: from, to: to } = selection;
    const selectionParentListItemNodeResolvedPos = findRootParentListNode ? findRootParentListNode($from) || findRootParentListNode($to) : null;
    const selectionParentListNode = selectionParentListItemNodeResolvedPos?.parent;
    if (!selectionParentListItemNodeResolvedPos || !selectionParentListNode) return false;
    const startOfEntireList = $from.pos < $to.pos ? selectionParentListItemNodeResolvedPos.pos + $from.depth - 1 : selectionParentListItemNodeResolvedPos.pos + $to.depth - 1;
    const endOfEntireList = $from.pos < $to.pos ? selectionParentListItemNodeResolvedPos.pos + selectionParentListNode.nodeSize - $to.depth - 1 : selectionParentListItemNodeResolvedPos.pos + selectionParentListNode.nodeSize - $from.depth - 1;
    if (!startOfEntireList || !endOfEntireList) return false;
    if (from < to) return startOfEntireList >= $from.pos && endOfEntireList <= $to.pos;
    else if (from > to) return startOfEntireList >= $to.pos && endOfEntireList <= $from.pos;
    else return false;
};
function $ed7aabc7e8e09621$export$3fd7f6d89a9d2cac(slice, findRootParentListNode) {
    return (state, dispatch)=>{
        const { schema: schema, tr: tr } = state;
        const { selection: selection } = tr;
        // Check this pasting action is related to copy content from panel node into a selected the list node
        const blockNode = slice.content.firstChild;
        const isSliceWholeNode = slice.openStart === 0 && slice.openEnd === 0;
        const selectionParentListItemNode = selection.$to.node(selection.$to.depth - 1);
        const sliceIsWholeNodeButShouldNotReplaceSelection = isSliceWholeNode && !$ed7aabc7e8e09621$export$c2473d50cf33051b(selection, findRootParentListNode);
        if (!selectionParentListItemNode || selectionParentListItemNode?.type !== schema.nodes.listItem || !blockNode || ![
            'panel',
            'decisionList'
        ].includes(blockNode?.type.name) || slice.content.childCount > 1 || blockNode?.content.firstChild === undefined || sliceIsWholeNodeButShouldNotReplaceSelection) return false;
        // Paste the panel node contents extracted instead of pasting the entire panel node
        tr.replaceSelection(slice).scrollIntoView();
        if (dispatch) dispatch(tr);
        return true;
    };
}
const $ed7aabc7e8e09621$var$innerTextRangeOfTextblock = (doc, posOfBlock)=>{
    const block = doc.nodeAt(posOfBlock);
    if (!block || !block.isTextblock) return null;
    // raw content bounds
    const contentStart = posOfBlock + 1; // +1 to move from node's start token to content start
    const contentEnd = contentStart + block.content.size;
    // clamp to doc coord space
    const start = Math.max(0, Math.min(contentStart, doc.content.size));
    const end = Math.max(0, Math.min(contentEnd, doc.content.size));
    if (end <= start) return null;
    // snap to nearest valid text positions
    const startSel = (0, $ks2lK.TextSelection).findFrom(doc.resolve(start), 1, true);
    const endSel = (0, $ks2lK.TextSelection).findFrom(doc.resolve(end), -1, true);
    if (!startSel || !endSel) return null;
    const from = startSel.$from.pos;
    const to = endSel.$to.pos;
    return to > from ? {
        from: from,
        to: to
    } : null;
};
function $ed7aabc7e8e09621$var$resolveSingleTextblockRangeIfAllSelected(state) {
    const sel = state.selection;
    if (!(sel instanceof (0, $ks2lK.AllSelection))) return null;
    let count = 0;
    let posOfBlock = -1;
    state.doc.nodesBetween(sel.from, sel.to, (node, pos)=>{
        if (!node.isTextblock) return true;
        count++;
        if (count > 1) return false;
        posOfBlock = pos;
        return true;
    });
    if (count !== 1) return null;
    return $ed7aabc7e8e09621$var$innerTextRangeOfTextblock(state.doc, posOfBlock);
}
function $ed7aabc7e8e09621$export$5e27b285bdcc71bf(slice) {
    return (state, dispatch)=>{
        const { schema: schema, selection: selection, selection: { from: from, to: to }, tr: tr } = state;
        let linkMark;
        // check if we have a link on the clipboard
        if (slice.content.childCount === 1 && (0, $7iE7T.isParagraph)(slice.content.child(0), schema)) {
            const paragraph = slice.content.child(0);
            if (paragraph.content.childCount === 1 && (0, $7iE7T.isText)(paragraph.content.child(0), schema)) {
                const text = paragraph.content.child(0);
                // If pasteType is plain text, then
                //  @atlaskit/editor-markdown-transformer in getMarkdownSlice decode
                //  url before setting text property of text node.
                //  However href of marks will be without decoding.
                //  So, if there is character (e.g space) in url eligible escaping then
                //  mark.attrs.href will not be equal to text.text.
                //  That's why decoding mark.attrs.href before comparing.
                // However, if pasteType is richText, that means url in text.text
                //  and href in marks, both won't be decoded.
                linkMark = text.marks.find((mark)=>(0, $7iE7T.isLinkMark)(mark, schema) && (mark.attrs.href === text.text || decodeURI(mark.attrs.href) === text.text));
            }
        }
        // derive a linkable range if possible for Select‑All over a single textblock
        const selectAllRange = (0, $dh538.fg)('platform_editor_link_paste_select_all') ? $ed7aabc7e8e09621$var$resolveSingleTextblockRangeIfAllSelected(state) : null;
        const rangeFrom = selectAllRange?.from ?? from;
        const rangeTo = selectAllRange?.to ?? to;
        // if we have a link, apply it to the selected text if we have any and it's allowed
        if (linkMark && (selection instanceof (0, $ks2lK.TextSelection) || Boolean(selectAllRange)) && !selection.empty && (0, $j9WGh.canLinkBeCreatedInRange)(rangeFrom, rangeTo)(state)) {
            tr.addMark(rangeFrom, rangeTo, linkMark);
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };
}
function $ed7aabc7e8e09621$export$efe55f809fabb910(slice, _event, editorAnalyticsAPI) {
    return (state, dispatch, view)=>{
        if (!view) return false;
        // prosemirror-bump-fix
        // Yes, this is wrong by default. But, we need to keep the private PAI usage to unblock the prosemirror bump
        // So, this code will make sure we are checking for both version (current and the newest prosemirror-view version
        const isShiftKeyPressed = // eslint-disable-next-line @typescript-eslint/no-explicit-any
        view.shiftKey || view.input?.shiftKey;
        // In case of SHIFT+CMD+V ("Paste and Match Style") we don't want to run the usual
        // fuzzy matching of content. ProseMirror already handles this scenario and will
        // provide us with slice containing paragraphs with plain text, which we decorate
        // with "stored marks".
        // @see prosemirror-view/src/clipboard.js:parseFromClipboard()).
        // @see prosemirror-view/src/input.js:doPaste().
        if (isShiftKeyPressed) {
            let tr = (0, $ke2AI.closeHistory)(state.tr);
            const { selection: selection } = tr;
            // <- using the same internal flag that prosemirror-view is using
            // if user has selected table we need custom logic to replace the table
            tr = (0, $a61730028ef020bd$export$ea73b328547c6ad5)(state, slice);
            // add analytics after replacing selected table
            tr = (0, $2ded4de594877764$export$4f704994f6a89bd1)(state, tr, editorAnalyticsAPI);
            // otherwise just replace the selection
            if (!tr.docChanged) tr.replaceSelection(slice);
            (state.storedMarks || []).forEach((mark)=>{
                tr.addMark(selection.from, selection.from + slice.size, mark);
            });
            tr.scrollIntoView();
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };
}
function $ed7aabc7e8e09621$export$de618421675f910e(slice, queueCardsFromChangedTr) {
    return (state, dispatch)=>{
        const { schema: schema, tr: { selection: selection } } = state;
        const { marks: { code: codeMark, annotation: annotationMark }, nodes: { bulletList: bulletList, emoji: emoji, hardBreak: hardBreak, heading: heading, listItem: listItem, mention: mention, orderedList: orderedList, text: text } } = schema;
        if (!(selection instanceof (0, $ks2lK.TextSelection))) return false;
        const selectionMarks = selection.$head.marks();
        if (selectionMarks.length === 0) return false;
        // special case for codeMark: will preserve mark only if codeMark is currently active
        // won't preserve mark if cursor is on the edge on the mark (namely inactive)
        const hasActiveCodeMark = codeMark && codeMark.isInSet(selectionMarks) && (0, $8DwGl.anyMarkActive)(state, codeMark);
        const hasAnnotationMark = annotationMark && annotationMark.isInSet(selectionMarks);
        const selectionIsHeading = (0, $8m4tT.hasParentNodeOfType)([
            heading
        ])(state.selection);
        // if the pasted data is one of the node types below
        // we apply current selection marks to the pasted slice
        if ((0, $2ded4de594877764$export$a4568554bf9b43cd)(bulletList, hardBreak, heading, listItem, text, emoji, mention, orderedList)(slice) || selectionIsHeading || hasActiveCodeMark || hasAnnotationMark) {
            const transformedSlice = (0, $2ded4de594877764$export$3bf611fd421c1669)(schema, selectionMarks)(slice);
            const tr = (0, $ke2AI.closeHistory)(state.tr).replaceSelection(transformedSlice).setStoredMarks(selectionMarks).scrollIntoView();
            queueCardsFromChangedTr?.(state, tr, (0, $d925B.INPUT_METHOD).CLIPBOARD);
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };
}
async function $ed7aabc7e8e09621$var$getSmartLinkAdf(text, type, cardOptions) {
    if (!cardOptions.provider) throw Error('No card provider found');
    const provider = await cardOptions.provider;
    return await provider.resolve(text, type);
}
function $ed7aabc7e8e09621$var$insertAutoMacro(slice, macro, view, from, to) {
    if (view) {
        // insert the text or linkified/md-converted clipboard data
        const selection = view.state.tr.selection;
        let tr;
        let before;
        if (typeof from === 'number' && typeof to === 'number') {
            tr = view.state.tr.replaceRange(from, to, slice);
            before = tr.mapping.map(from, -1);
        } else {
            tr = view.state.tr.replaceSelection(slice);
            before = tr.mapping.map(selection.from, -1);
        }
        view.dispatch(tr);
        // replace the text with the macro as a separate transaction
        // so the autoconversion generates 2 undo steps
        const macroTr = (0, $ke2AI.closeHistory)(view.state.tr).replaceRangeWith(before, before + slice.size, macro).scrollIntoView();
        (0, $19Q6F.addLinkMetadata)(view.state.selection, macroTr, {
            inputMethod: (0, $d925B.INPUT_METHOD).CLIPBOARD,
            cardAction: 'AUTO_CONVERT'
        });
        view.dispatch(macroTr);
        return true;
    }
    return false;
}
function $ed7aabc7e8e09621$export$d23738992a74c3a9(text, slice, queueCardsFromChangedTr, runMacroAutoConvert, cardsOptions, extensionAutoConverter) {
    return (state, dispatch, view)=>{
        let macro = null;
        // try to use auto convert from extension provider first
        if (extensionAutoConverter) {
            const extension = extensionAutoConverter(text);
            if (extension) macro = (0, $5SAOw.Node).fromJSON(state.schema, extension);
        }
        // then try from macro provider (which will be removed some time in the future)
        if (!macro) macro = runMacroAutoConvert?.(state, text) ?? null;
        if (macro) {
            /**
			 * if FF enabled, run through smart links and check for result
			 */ if (cardsOptions && cardsOptions.resolveBeforeMacros && cardsOptions.resolveBeforeMacros.length) {
                if (cardsOptions.resolveBeforeMacros.indexOf(macro.attrs.extensionKey) < 0) return $ed7aabc7e8e09621$var$insertAutoMacro(slice, macro, view);
                if (!view) throw new Error('View is missing');
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                const trackingId = (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))();
                const trackingFrom = `handleMacroAutoConvert-from-${trackingId}`;
                const trackingTo = `handleMacroAutoConvert-to-${trackingId}`;
                (0, $2e4406ece4085ab9$export$4a47d257a3fdbe1c)({
                    [trackingFrom]: state.selection.from,
                    [trackingTo]: state.selection.to
                })(state, dispatch);
                $ed7aabc7e8e09621$var$getSmartLinkAdf(text, 'inline', cardsOptions).then(()=>{
                    // we use view.state rather than state because state becomes a stale
                    // state reference after getSmartLinkAdf's async work
                    const { pastedMacroPositions: pastedMacroPositions } = (0, $6b91a48544104490$export$f05434c51e3762e)(view.state);
                    if (dispatch) $ed7aabc7e8e09621$export$4b83e18c607f848f(slice, queueCardsFromChangedTr, pastedMacroPositions[trackingFrom], pastedMacroPositions[trackingTo])(view.state, dispatch);
                }).catch(()=>{
                    const { pastedMacroPositions: pastedMacroPositions } = (0, $6b91a48544104490$export$f05434c51e3762e)(view.state);
                    $ed7aabc7e8e09621$var$insertAutoMacro(slice, macro, view, pastedMacroPositions[trackingFrom], pastedMacroPositions[trackingTo]);
                }).finally(()=>{
                    (0, $2e4406ece4085ab9$export$68f98dcea8e59d59)([
                        trackingFrom,
                        trackingTo
                    ])(view.state, dispatch);
                });
                return true;
            }
            return $ed7aabc7e8e09621$var$insertAutoMacro(slice, macro, view);
        }
        return !!macro;
    };
}
function $ed7aabc7e8e09621$export$98135102f7ccdef2(text) {
    return (state, dispatch)=>{
        const { codeBlock: codeBlock } = state.schema.nodes;
        if (text && (0, $8m4tT.hasParentNodeOfType)(codeBlock)(state.selection)) {
            const tr = (0, $ke2AI.closeHistory)(state.tr);
            tr.scrollIntoView();
            if (dispatch) dispatch(tr.insertText(text));
            return true;
        }
        return false;
    };
}
function $ed7aabc7e8e09621$var$isOnlyMedia(state, slice) {
    const { media: media } = state.schema.nodes;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return slice.content.childCount === 1 && slice.content.firstChild.type === media;
}
function $ed7aabc7e8e09621$var$isOnlyMediaSingle(state, slice) {
    const { mediaSingle: mediaSingle } = state.schema.nodes;
    return(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    mediaSingle && slice.content.childCount === 1 && slice.content.firstChild.type === mediaSingle);
}
function $ed7aabc7e8e09621$export$5fb647c5a57bac64(inputMethod, insertMediaAsMediaSingle) {
    return function(slice) {
        return (state, dispatch, view)=>{
            if (view) {
                if ($ed7aabc7e8e09621$var$isOnlyMedia(state, slice)) // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                return insertMediaAsMediaSingle?.(view, slice.content.firstChild, inputMethod) ?? false;
                if ((0, $4KOFJ.insideTable)(state) && $ed7aabc7e8e09621$var$isOnlyMediaSingle(state, slice)) {
                    const tr = state.tr.replaceSelection(slice);
                    const nextPos = tr.doc.resolve(tr.mapping.map(state.selection.$from.pos));
                    if (dispatch) dispatch(tr.setSelection(new (0, $adhil.GapCursorSelection)(nextPos, (0, $9GYNY.Side).RIGHT)));
                    return true;
                }
            }
            return false;
        };
    };
}
const $ed7aabc7e8e09621$var$hasTopLevelExpand = (slice)=>{
    let hasExpand = false;
    slice.content.forEach((node)=>{
        if (node.type.name === 'expand' || node.type.name === 'nestedExpand') hasExpand = true;
    });
    return hasExpand;
};
function $ed7aabc7e8e09621$export$36e0fe2cadced224(slice) {
    return (state, dispatch)=>{
        const isInsideBodyExtension = (0, $8m4tT.hasParentNodeOfType)(state.schema.nodes.bodiedExtension)(state.selection);
        if (!(0, $4KOFJ.insideTable)(state) || !isInsideBodyExtension) return false;
        const { bodiedExtension: bodiedExtension } = state.schema.nodes;
        const newSlice = (0, $3Ter7.mapSlice)(slice, (maybeNode)=>{
            if (maybeNode.type === bodiedExtension) return bodiedExtension.createChecked(maybeNode.attrs, maybeNode.content, maybeNode.marks);
            return maybeNode;
        });
        if (dispatch) {
            dispatch(state.tr.replaceSelection(newSlice));
            return true;
        }
        return false;
    };
}
function $ed7aabc7e8e09621$export$113227139658cc8d(slice, isNestingTablesSupported) {
    return (state, dispatch)=>{
        if (!isNestingTablesSupported || !(0, $4KOFJ.insideTable)(state)) return false;
        const { schema: schema, selection: selection } = state;
        let sliceHasTable = false;
        slice.content.forEach((node)=>{
            if (node.type === state.schema.nodes.table) sliceHasTable = true;
        });
        if (sliceHasTable) // if slice has table - if pasting to deeply nested location place paste after top table
        {
            if ((0, $kAKYF.getParentOfTypeCount)(schema.nodes.table)(selection.$from) > 1) {
                const positionAfterTopTable = (0, $20bG5.getPositionAfterTopParentNodeOfType)(schema.nodes.table)(selection.$from);
                let { tr: tr } = state;
                tr = (0, $8m4tT.safeInsert)(slice.content, positionAfterTopTable)(tr);
                tr.scrollIntoView();
                if (dispatch) {
                    dispatch(tr);
                    return true;
                }
            }
        }
        return false;
    };
}
function $ed7aabc7e8e09621$export$a497757c6eac4530(slice) {
    return (state, dispatch)=>{
        const isInsideNestableExpand = !!$ed7aabc7e8e09621$var$insideExpand(state);
        // Do not handle expand if it's not being pasted into a table or expand
        // OR if it's nested within another node when being pasted into a table/expand
        if (!(0, $4KOFJ.insideTable)(state) && !isInsideNestableExpand || !$ed7aabc7e8e09621$var$hasTopLevelExpand(slice)) return false;
        const { expand: expand, nestedExpand: nestedExpand } = state.schema.nodes;
        let { tr: tr } = state;
        let hasExpand = false;
        const newSlice = (0, $3Ter7.mapSlice)(slice, (maybeNode)=>{
            if (maybeNode.type === expand || maybeNode.type === nestedExpand) {
                hasExpand = true;
                try {
                    return nestedExpand.createChecked(maybeNode.attrs, maybeNode.content, maybeNode.marks);
                } catch  {
                    tr = (0, $8m4tT.safeInsert)(maybeNode, tr.selection.$to.pos)(tr);
                    return (0, $5SAOw.Fragment).empty;
                }
            }
            return maybeNode;
        });
        if (hasExpand && dispatch) {
            // If the slice is a subset, we can let PM replace the selection
            // it will insert as text where it can't place the node.
            // Otherwise we use safeInsert to insert below instead of
            // replacing/splitting the current node.
            if (slice.openStart > 1 && slice.openEnd > 1) dispatch(tr.replaceSelection(newSlice));
            else dispatch((0, $8m4tT.safeInsert)(newSlice.content)(tr));
            return true;
        }
        return false;
    };
}
function $ed7aabc7e8e09621$export$4b83e18c607f848f(markdownSlice, queueCardsFromChangedTr, from, to) {
    return (state, dispatch)=>{
        const tr = (0, $ke2AI.closeHistory)(state.tr);
        const pastesFrom = typeof from === 'number' ? from : tr.selection.from;
        if (typeof from === 'number' && typeof to === 'number') tr.replaceRange(from, to, markdownSlice);
        else tr.replaceSelection(markdownSlice);
        const textPosition = tr.doc.resolve(Math.min(pastesFrom + markdownSlice.size, tr.doc.content.size));
        tr.setSelection((0, $ks2lK.TextSelection).near(textPosition, -1));
        queueCardsFromChangedTr?.(state, tr, (0, $d925B.INPUT_METHOD).CLIPBOARD);
        if (dispatch) dispatch(tr.scrollIntoView());
        return true;
    };
}
function $ed7aabc7e8e09621$var$removePrecedingBackTick(tr) {
    const { $from: { nodeBefore: nodeBefore }, from: from } = tr.selection;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    if (nodeBefore && nodeBefore.isText && nodeBefore.text.endsWith('`')) tr.delete(from - 1, from);
}
function $ed7aabc7e8e09621$var$hasInlineCode(state, slice) {
    return slice.content.firstChild && slice.content.firstChild.marks.some((m)=>m.type === state.schema.marks.code);
}
function $ed7aabc7e8e09621$var$rollupLeafListItems(list, leafListItems) {
    list.content.forEach((child)=>{
        if ((0, $jshjN.isListNode)(child) || (0, $4DdJm.isListItemNode)(child) && (0, $jshjN.isListNode)(child.firstChild)) $ed7aabc7e8e09621$var$rollupLeafListItems(child, leafListItems);
        else leafListItems.push(child);
    });
}
function $ed7aabc7e8e09621$var$shouldFlattenList(state, slice) {
    const node = slice.content.firstChild;
    return node && (0, $4KOFJ.insideTable)(state) && (0, $jshjN.isListNode)(node) && slice.openStart > slice.openEnd;
}
function $ed7aabc7e8e09621$var$sliceHasTopLevelMarks(slice) {
    let hasTopLevelMarks = false;
    slice.content.descendants((node)=>{
        if (node.marks.length > 0) hasTopLevelMarks = true;
        return false;
    });
    return hasTopLevelMarks;
}
function $ed7aabc7e8e09621$var$getTopLevelMarkTypesInSlice(slice) {
    const markTypes = new Set();
    slice.content.descendants((node)=>{
        node.marks.map((mark)=>mark.type).forEach((markType)=>markTypes.add(markType));
        return false;
    });
    return markTypes;
}
/**
 * Peels container wrapper nodes (e.g. panel, expand) added by ProseMirror's addContext()
 * so that fontSize-marked paragraphs become top-level, preserving the mark on paste.
 */ function $ed7aabc7e8e09621$var$unwrapContainerNodesWithBlockMarks(slice, schema, fontSize) {
    let content = slice.content;
    let levelsUnwrapped = 0;
    while(content.childCount === 1 && content.firstChild && !content.firstChild.isTextblock && slice.openStart - levelsUnwrapped > 1){
        let hasBlockMarkedParagraph = false;
        for(let i = 0; i < content.firstChild.childCount; i++){
            const child = content.firstChild.child(i);
            if (child.type === schema.nodes.paragraph && child.marks.some((m)=>m.type === fontSize)) {
                hasBlockMarkedParagraph = true;
                break;
            }
        }
        if (!hasBlockMarkedParagraph) break;
        content = content.firstChild.content;
        levelsUnwrapped++;
    }
    if (levelsUnwrapped === 0) return slice;
    return new (0, $5SAOw.Slice)(content, slice.openStart - levelsUnwrapped, Math.max(0, slice.openEnd - levelsUnwrapped));
}
/**
 * Returns the fontSize attrs to apply at the paste destination, or false if none.
 * Checks list and task destinations in priority order.
 */ function $ed7aabc7e8e09621$var$getDestinationFontSizeAttrs(destinationListNode, isInSmallTaskContext, $from, currentNode, fontSize) {
    if (destinationListNode) return (0, $hBm38.getFirstParagraphBlockMarkAttrs)(destinationListNode, fontSize);
    if (isInSmallTaskContext) return (0, $hBm38.getBlockMarkAttrs)($from.parent, fontSize) || (0, $hBm38.getFirstParagraphBlockMarkAttrs)(currentNode, fontSize);
    return false;
}
/**
 * Resolves which marks to apply to a paragraph node after filtering forbidden marks.
 * When a destination block mark is provided, replaces any existing fontSize mark with it.
 * When normalizing for the target context, removes the fontSize mark entirely.
 * Otherwise returns the filtered marks unchanged.
 */ function $ed7aabc7e8e09621$var$resolveParagraphMarks(marks, destinationBlockMarkAttrs, shouldNormalize, fontSize) {
    if (destinationBlockMarkAttrs) return marks.filter((m)=>m.type !== fontSize).concat(fontSize.create(destinationBlockMarkAttrs));
    if (shouldNormalize) return marks.filter((m)=>m.type !== fontSize);
    return marks;
}
function $ed7aabc7e8e09621$export$feb0d61bf65d9267(state, slice) {
    if (slice.content.size === 0) return slice;
    const { schema: schema, selection: selection, selection: { $from: $from } } = state;
    const { bulletList: bulletList, orderedList: orderedList, blockTaskItem: blockTaskItem, taskItem: taskItem, paragraph: paragraph, heading: heading } = schema.nodes;
    const { fontSize: fontSize } = schema.marks;
    const isSmallFontSizeEnabled = !!fontSize && (0, $1oCLl.expValEquals)('platform_editor_small_font_size', 'isEnabled', true);
    // When copying from inside a container (e.g. panel, expand), ProseMirror wraps the
    // content back in the container via addContext(), increasing openStart/openEnd. Unwrap
    // so the paragraph (with its fontSize mark) becomes top-level.
    if (isSmallFontSizeEnabled) slice = $ed7aabc7e8e09621$var$unwrapContainerNodesWithBlockMarks(slice, schema, fontSize);
    const destinationListNode = (0, $8m4tT.findParentNodeOfType)([
        bulletList,
        orderedList
    ])(selection)?.node;
    const currentNode = typeof $from.node === 'function' ? $from.node() : undefined;
    const isInNormalTaskContext = currentNode?.type === taskItem || $from.parent.type === taskItem;
    const isInSmallTaskContext = !!blockTaskItem && (currentNode?.type === blockTaskItem || $from.parent.type === blockTaskItem || $from.parent.type === paragraph && $from.depth > 0 && $from.node($from.depth - 1).type === blockTaskItem);
    const destinationBlockMarkAttrs = isSmallFontSizeEnabled ? $ed7aabc7e8e09621$var$getDestinationFontSizeAttrs(destinationListNode, isInSmallTaskContext, $from, currentNode, fontSize) : false;
    const isInHeadingContext = $from.parent.type === heading;
    // If no paragraph in the slice contains marks, there's no need for special handling
    // unless we're pasting into a small-text list and need to add the destination block mark.
    // Note: this doesn't check for marks applied to lower level nodes such as text
    if (!$ed7aabc7e8e09621$var$sliceHasTopLevelMarks(slice) && !destinationBlockMarkAttrs) return slice;
    const shouldNormalizeFontSizeForTarget = isSmallFontSizeEnabled && (!!destinationListNode || isInNormalTaskContext || isInSmallTaskContext || isInHeadingContext);
    // If pasting a single paragraph into pre-existing content, match destination formatting.
    // For bullet/ordered lists under small-text, we still need to normalize the paragraph block mark
    // so pasted content adopts the destination list state.
    const destinationHasContent = $from.parent.textContent.length > 0;
    if (slice.content.childCount === 1 && destinationHasContent && !shouldNormalizeFontSizeForTarget) return slice;
    // Check the parent of (paragraph -> text) because block marks are assigned to a wrapper
    // element around the paragraph node
    const grandparent = $from.node(Math.max(0, $from.depth - 1));
    const markTypesInSlice = $ed7aabc7e8e09621$var$getTopLevelMarkTypesInSlice(slice);
    const forbiddenMarkTypes = [];
    for (const markType of markTypesInSlice)if (!grandparent.type.allowsMarkType(markType)) forbiddenMarkTypes.push(markType);
    const normalizedContent = (0, $3Ter7.mapSlice)(slice, (node)=>{
        if (node.type === paragraph) {
            const paragraphMarks = node.marks.filter((mark)=>!forbiddenMarkTypes.includes(mark.type));
            return paragraph.createChecked(undefined, node.content, $ed7aabc7e8e09621$var$resolveParagraphMarks(paragraphMarks, destinationBlockMarkAttrs, shouldNormalizeFontSizeForTarget, fontSize));
        } else if (node.type === heading) // Preserve heading attributes to keep formatting
        return heading.createChecked(node.attrs, node.content, node.marks.filter((mark)=>!forbiddenMarkTypes.includes(mark.type)));
        return node;
    });
    if (forbiddenMarkTypes.length === 0 && !shouldNormalizeFontSizeForTarget) {
        // In a slice containing one or more paragraphs at the document level (not wrapped in
        // another node), the first paragraph will only have its text content captured and pasted
        // since openStart is 1. We decrement the open depth of the slice so it retains any block
        // marks applied to it. We only care about the depth at the start of the selection so
        // there's no need to change openEnd - the rest of the slice gets pasted correctly.
        const openStart = Math.max(0, slice.openStart - 1);
        return new (0, $5SAOw.Slice)(slice.content, openStart, slice.openEnd);
    }
    if (forbiddenMarkTypes.length === 0 && shouldNormalizeFontSizeForTarget) {
        // When pasting into a heading, keep the original openStart so ProseMirror merges inline
        // content into the heading node rather than replacing it with a paragraph.
        const openStart = isInHeadingContext ? slice.openStart : Math.max(0, slice.openStart - 1);
        return new (0, $5SAOw.Slice)(normalizedContent.content, openStart, slice.openEnd);
    }
    // If the paragraph or heading contains marks forbidden by the parent node
    // (e.g. alignment/indentation), drop those marks from the slice. For lists under the small
    // text experiment, also normalize fontSize to the destination list state.
    return new (0, $5SAOw.Slice)(normalizedContent.content, slice.openStart, slice.openEnd);
}
function $ed7aabc7e8e09621$export$79d83373d2946ba6(slice) {
    if (!slice.content.firstChild) return slice;
    const listToFlatten = slice.content.firstChild;
    const leafListItems = [];
    $ed7aabc7e8e09621$var$rollupLeafListItems(listToFlatten, leafListItems);
    const contentWithFlattenedList = slice.content.replaceChild(0, listToFlatten.type.createChecked(listToFlatten.attrs, leafListItems));
    return new (0, $5SAOw.Slice)(contentWithFlattenedList, slice.openEnd, slice.openEnd);
}
const $ed7aabc7e8e09621$var$doesSliceContainBlockquoteListNodes = (slice, listContainerNodeTypes)=>{
    const firstChildOfSlice = slice.content.firstChild;
    const lastChildOfSlice = slice.content.lastChild;
    const isFirstChildBlockquoteListNode = firstChildOfSlice?.type?.name === 'blockquote' && listContainerNodeTypes.some((nodeType)=>nodeType === firstChildOfSlice?.content.firstChild?.type);
    const isLastChildBlockquoteListNode = lastChildOfSlice?.type?.name === 'blockquote' && listContainerNodeTypes.some((nodeType)=>nodeType === lastChildOfSlice?.content.firstChild?.type);
    return isFirstChildBlockquoteListNode || isLastChildBlockquoteListNode;
};
function $ed7aabc7e8e09621$export$f9c7e15c780a77d0(slice, queueCardsFromChangedTr) {
    return (state, dispatch)=>{
        const { codeBlock: codeBlock, heading: heading, paragraph: paragraph, panel: panel, bulletList: bulletList, orderedList: orderedList } = state.schema.nodes;
        const { fontSize: fontSize } = state.schema.marks;
        const { selection: selection, schema: schema } = state;
        const firstChildOfSlice = slice.content?.firstChild;
        const lastChildOfSlice = slice.content?.lastChild;
        const listContainerNodeTypes = [
            bulletList,
            orderedList
        ];
        const isSmallFontSizeEnabled = !!fontSize && (0, $1oCLl.expValEquals)('platform_editor_small_font_size', 'isEnabled', true);
        const destinationListNode = isSmallFontSizeEnabled ? (0, $8m4tT.findParentNodeOfType)(listContainerNodeTypes)(selection)?.node : undefined;
        const destinationListFontSizeAttrs = isSmallFontSizeEnabled ? (0, $hBm38.getFirstParagraphBlockMarkAttrs)(destinationListNode, fontSize) : false;
        // In case user is pasting inline code,
        // any backtick ` immediately preceding it should be removed.
        let tr = state.tr;
        if ($ed7aabc7e8e09621$var$hasInlineCode(state, slice)) $ed7aabc7e8e09621$var$removePrecedingBackTick(tr);
        if ($ed7aabc7e8e09621$var$shouldFlattenList(state, slice)) slice = $ed7aabc7e8e09621$export$79d83373d2946ba6(slice);
        (0, $ke2AI.closeHistory)(tr);
        const isFirstChildListNode = (0, $jshjN.isListNode)(firstChildOfSlice);
        const isLastChildListNode = (0, $jshjN.isListNode)(lastChildOfSlice);
        const isSliceContentListNodes = isFirstChildListNode || isLastChildListNode;
        const isFirstChildTaskListNode = firstChildOfSlice?.type?.name === 'taskList';
        const isLastChildTaskListNode = lastChildOfSlice?.type?.name === 'taskList';
        const isSliceContentTaskListNodes = isFirstChildTaskListNode || isLastChildTaskListNode;
        const sliceContentBlockquoteListNodes = $ed7aabc7e8e09621$var$doesSliceContainBlockquoteListNodes(slice, listContainerNodeTypes);
        // Compute once and reuse below to avoid traversing the slice twice.
        const sliceMarkTypes = isSmallFontSizeEnabled ? $ed7aabc7e8e09621$var$getTopLevelMarkTypesInSlice(slice) : new Set();
        const destinationIsEmpty = isSmallFontSizeEnabled && selection.$from.parent.type === paragraph && selection.$from.parent.textContent.length === 0;
        // Capture the destination paragraph's non-fontSize block marks (e.g. alignment, indentation)
        // before the paste so they can be restored if the paste replaces the paragraph entirely
        // (which happens when small text is pasted with openStart=0).
        const destinationNonFontSizeBlockMarks = isSmallFontSizeEnabled && selection.$from.parent.type === paragraph && sliceMarkTypes.has(fontSize) ? selection.$from.parent.marks.filter((m)=>m.type !== fontSize) : [];
        // We want to use safeInsert to insert invalid content, as it inserts at the closest non schema violating position
        // rather than spliting the selection parent node in half (which is what replaceSelection does)
        // Exception is paragraph and heading nodes, these should be split, provided their parent supports the pasted content
        const textNodes = [
            heading,
            paragraph
        ];
        const selectionParent = selection.$to.node(selection.$to.depth - 1);
        const noNeedForSafeInsert = selection.$to.node().type.validContent(slice.content) || textNodes.includes(selection.$to.node().type) && selectionParent.type.validContent(slice.content);
        const panelParentOverCurrentSelection = (0, $8m4tT.findParentNodeOfType)(panel)(tr.selection);
        const isTargetPanelEmpty = panelParentOverCurrentSelection && panelParentOverCurrentSelection.node?.content.size === 2;
        if (!isSliceContentTaskListNodes && (isSliceContentListNodes || isTargetPanelEmpty)) (0, $cfa8bd4c8427b032$export$9beec16307c108ac)({
            tr: tr,
            slice: slice,
            schema: schema
        });
        else if (noNeedForSafeInsert && !((0, $1oCLl.expValEquals)('platform_editor_flexible_list_indentation', 'isEnabled', true) && $ed7aabc7e8e09621$export$f0f8559835c0f076(state, slice))) {
            if (firstChildOfSlice?.type?.name === 'blockquote' && firstChildOfSlice?.content.firstChild?.type.name && [
                'bulletList',
                'orderedList',
                'mediaSingle'
            ].includes(firstChildOfSlice?.content.firstChild?.type.name)) // checks if parent node is a blockquote and child node is either a bulletlist or orderedlist or mediaSingle
            (0, $cfa8bd4c8427b032$export$2dee216d0a70c94e)({
                tr: tr,
                slice: slice
            });
            else {
                tr.replaceSelection(slice);
                // when cursor is inside a table cell, and slice.content.lastChild is a panel, expand, or decisionList
                // need to make sure the cursor position is is right after the panel, expand, or decisionList
                // still in the same table cell, see issue: https://product-fabric.atlassian.net/browse/ED-17862
                const shouldUpdateCursorPosAfterPaste = [
                    'panel',
                    'nestedExpand',
                    'decisionList',
                    'codeBlock'
                ].includes(slice.content.lastChild?.type?.name || '');
                const lastChild = slice.content.lastChild;
                const $nextPos = tr.doc.resolve(tr.mapping.map(selection.from));
                const nextSelection = lastChild?.type.isTextblock ? (0, $ks2lK.TextSelection).findFrom($nextPos, -1, true) : new (0, $adhil.GapCursorSelection)($nextPos, (0, $9GYNY.Side).RIGHT);
                if (nextSelection) tr.setSelection(nextSelection);
                else if ((0, $l9G9n.insideTableCell)(state) && shouldUpdateCursorPosAfterPaste) {
                    const nextPos = tr.doc.resolve(tr.mapping.map(selection.$from.pos));
                    tr.setSelection(new (0, $adhil.GapCursorSelection)(nextPos, (0, $9GYNY.Side).RIGHT));
                }
            }
        } else {
            // need to scan the slice if there's a block node or list items inside it
            let sliceHasList = false;
            slice.content.nodesBetween(0, slice.content.size, (node)=>{
                if (node.type === state.schema.nodes.listItem) {
                    sliceHasList = true;
                    return false;
                }
            });
            if ((0, $l9G9n.insideTableCell)(state) && (0, $l9G9n.isInListItem)(state) && (0, $8m4tT.canInsert)(selection.$from, slice.content) && (0, $8m4tT.canInsert)(selection.$to, slice.content) || sliceHasList) tr.replaceSelection(slice);
            else if ($ed7aabc7e8e09621$export$f0f8559835c0f076(state, slice) && !$ed7aabc7e8e09621$export$67c0f4368bb304c3(state)) (0, $cfa8bd4c8427b032$export$2982aac953f7c8b6)({
                tr: tr,
                slice: slice
            });
            else {
                // need safeInsert rather than replaceSelection, so that nodes aren't split in half
                // e.g. when pasting a layout into a table, replaceSelection splits the table in half and adds the layout in the middle
                tr = (0, $8m4tT.safeInsert)(slice.content, tr.selection.$to.pos)(tr);
                if ($ed7aabc7e8e09621$export$f0f8559835c0f076(state, slice)) (0, $cfa8bd4c8427b032$export$e57c13697a8b8195)({
                    tr: tr
                });
            }
        }
        // font size handling for pasting into lists or blockquotes
        if (isSmallFontSizeEnabled && (isSliceContentListNodes || sliceContentBlockquoteListNodes)) {
            const containingList = (0, $8m4tT.findParentNodeOfTypeClosestToPos)(tr.selection.$from, listContainerNodeTypes);
            if (containingList) (0, $hBm38.reconcileBlockMarkForContainerAtPos)(tr, containingList.pos, fontSize, isSliceContentListNodes ? destinationListFontSizeAttrs : false);
        }
        // font size handling for pasting into paragraphs (normal text) - preserve source style
        if (isSmallFontSizeEnabled && destinationIsEmpty && !sliceMarkTypes.has(fontSize) && !destinationListNode && selection.$from.parent.type === paragraph && (0, $hBm38.getBlockMarkAttrs)(selection.$from.parent, fontSize)) (0, $hBm38.reconcileBlockMarkForParagraphAtPos)(tr, tr.mapping.map(selection.$from.pos), fontSize, false);
        // Restore destination block marks (e.g. alignment) that were lost when pasting small text
        // replaced the paragraph entirely (openStart=0 from container unwrap).
        if (isSmallFontSizeEnabled && destinationNonFontSizeBlockMarks.length > 0) {
            const pastedFrom = tr.mapping.map(selection.from, -1);
            const pastedTo = tr.mapping.map(selection.to, 1);
            for (const mark of destinationNonFontSizeBlockMarks)(0, $hBm38.reconcileBlockMarkInRange)(tr, pastedFrom, pastedTo, mark.type, mark.attrs);
        }
        tr.setStoredMarks([]);
        if (tr.selection.empty && tr.selection.$from.parent.type === codeBlock) tr.setSelection((0, $ks2lK.TextSelection).near(tr.selection.$from, 1));
        tr.scrollIntoView();
        // queue link cards, ignoring any errors
        queueCardsFromChangedTr?.(state, tr, (0, $d925B.INPUT_METHOD).CLIPBOARD);
        if (dispatch) dispatch(tr);
        return true;
    };
}
function $ed7aabc7e8e09621$var$isUrlString(text) {
    try {
        new URL(text);
        return true;
    } catch  {
        return false;
    }
}
function $ed7aabc7e8e09621$var$isLinkOrUrlString(slice, schema) {
    if (slice.content.childCount !== 1 || !(0, $7iE7T.isParagraph)(slice.content.child(0), schema)) return false;
    const paragraph = slice.content.child(0);
    if (paragraph.content.childCount !== 1 || !(0, $7iE7T.isText)(paragraph.content.child(0), schema)) return false;
    const { marks: marks, text: text = '' } = paragraph.content.child(0);
    const hasLinkMark = marks.some((mark)=>(0, $7iE7T.isLinkMark)(mark, schema));
    return hasLinkMark || $ed7aabc7e8e09621$var$isUrlString(text);
}
function $ed7aabc7e8e09621$export$d399a86cc775ad7e(slice) {
    return (state, dispatch)=>{
        if ($ed7aabc7e8e09621$var$isLinkOrUrlString(slice, state.schema)) return false;
        const { caption: caption } = state.schema.nodes;
        const tr = state.tr;
        if ((0, $8m4tT.hasParentNodeOfType)(caption)(state.selection)) {
            // We let PM replace the selection and it will insert as text where it can't place the node
            // This is totally fine as caption is just a simple block that only contains inline contents
            // And it is more in line with WYSIWYG expectations
            tr.replaceSelection(slice).scrollIntoView();
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };
}
const $ed7aabc7e8e09621$export$4ce587bb5876886d = (editorAnalyticsAPI)=>(slice)=>(state, dispatch)=>{
            let tr = (0, $a61730028ef020bd$export$ea73b328547c6ad5)(state, slice);
            // add analytics after replacing selected table
            tr = (0, $2ded4de594877764$export$4f704994f6a89bd1)(state, tr, editorAnalyticsAPI);
            if (tr.docChanged) {
                if (dispatch) dispatch(tr);
                return true;
            }
            return false;
        };
function $ed7aabc7e8e09621$export$f0f8559835c0f076(state, slice) {
    return Boolean((0, $l9G9n.isInListItem)(state) && [
        'taskList',
        'taskItem'
    ].includes(slice.content.firstChild?.type?.name || ''));
}
function $ed7aabc7e8e09621$export$67c0f4368bb304c3(state) {
    const { selection: selection, tr: tr } = state;
    const { orderedList: orderedList, bulletList: bulletList, listItem: listItem } = state.schema.nodes;
    const selectionParentListItemNode = (0, $8m4tT.findParentNodeOfType)(listItem)(selection);
    const selectionParentListNodeWithPos = (0, $8m4tT.findParentNodeOfType)([
        bulletList,
        orderedList
    ])(selection);
    if (!selectionParentListItemNode || !selectionParentListNodeWithPos) return false;
    const grandParentListNode = (0, $8m4tT.findParentNodeOfTypeClosestToPos)(tr.doc.resolve(selectionParentListNodeWithPos.pos), [
        bulletList,
        orderedList
    ]);
    const selectionIsInNestedList = !!grandParentListNode;
    let selectedListItemHasNestedList = false;
    selectionParentListItemNode.node.content.forEach((child)=>{
        if ((0, $jshjN.isListNode)(child)) selectedListItemHasNestedList = true;
    });
    return selectedListItemHasNestedList || selectionIsInNestedList;
}
function $ed7aabc7e8e09621$export$ce28e8ccb2f7a3dd(slice) {
    return (0, $3Ter7.mapSlice)(slice, (node)=>{
        if (node.type.name === 'expand' || node.type.name === 'nestedExpand') {
            const children = [];
            if (node.attrs.title) children.push(node.type.schema.nodes.paragraph.createChecked(undefined, (0, $5SAOw.Fragment).from(node.type.schema.text(node.attrs.title))));
            node.content.forEach((inner)=>children.push(inner));
            return children;
        }
        return node;
    });
}
function $ed7aabc7e8e09621$export$ce2b3491c532dd9d(slice, schema, destinationParentType) {
    const sliceJson = slice.toJSON();
    if (!sliceJson) return slice;
    const wrappedAdf = {
        type: destinationParentType,
        content: sliceJson.content ?? []
    };
    try {
        const { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $1OR0A.transformContainerNodes)(wrappedAdf, schema);
        return isTransformed && transformedAdf && transformedAdf.content && transformedAdf.content.length > 0 ? (0, $5SAOw.Slice).fromJSON(schema, {
            ...sliceJson,
            content: transformedAdf.content
        }) : slice;
    } catch  {
        return slice;
    }
}
function $ed7aabc7e8e09621$export$f596ff5b0d9c556a(html) {
    if (!html.includes('data-panel-type')) return html;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const panelDivs = Array.from(doc.querySelectorAll('div[data-panel-type]'));
    let changed = false;
    for (const panelDiv of panelDivs){
        const tableWrappers = Array.from(panelDiv.querySelectorAll('[data-prosemirror-node-name="table"]'));
        if (tableWrappers.length === 0) continue;
        changed = true;
        let anchor = panelDiv;
        for (const tableWrapper of tableWrappers){
            tableWrapper.parentNode?.removeChild(tableWrapper);
            anchor.parentNode?.insertBefore(tableWrapper, anchor.nextSibling);
            anchor = tableWrapper;
        }
    }
    return changed ? doc.body.innerHTML : html;
}


const $077e6b5ad97baf3f$var$contentToPasteContent = {
    url: (0, $aSgIe.PasteContents).url,
    paragraph: (0, $aSgIe.PasteContents).text,
    bulletList: (0, $aSgIe.PasteContents).bulletList,
    orderedList: (0, $aSgIe.PasteContents).orderedList,
    heading: (0, $aSgIe.PasteContents).heading,
    blockquote: (0, $aSgIe.PasteContents).blockquote,
    codeBlock: (0, $aSgIe.PasteContents).codeBlock,
    panel: (0, $aSgIe.PasteContents).panel,
    rule: (0, $aSgIe.PasteContents).rule,
    mediaSingle: (0, $aSgIe.PasteContents).mediaSingle,
    mediaCard: (0, $aSgIe.PasteContents).mediaCard,
    mediaGroup: (0, $aSgIe.PasteContents).mediaGroup,
    table: (0, $aSgIe.PasteContents).table,
    tableCells: (0, $aSgIe.PasteContents).tableCells,
    tableHeader: (0, $aSgIe.PasteContents).tableHeader,
    tableRow: (0, $aSgIe.PasteContents).tableRow,
    decisionList: (0, $aSgIe.PasteContents).decisionList,
    decisionItem: (0, $aSgIe.PasteContents).decisionItem,
    taskList: (0, $aSgIe.PasteContents).taskItem,
    extension: (0, $aSgIe.PasteContents).extension,
    bodiedExtension: (0, $aSgIe.PasteContents).bodiedExtension,
    blockCard: (0, $aSgIe.PasteContents).blockCard,
    layoutSection: (0, $aSgIe.PasteContents).layoutSection
};
const $077e6b5ad97baf3f$var$nodeToActionSubjectId = {
    blockquote: (0, $d925B.ACTION_SUBJECT_ID).PASTE_BLOCKQUOTE,
    blockCard: (0, $d925B.ACTION_SUBJECT_ID).PASTE_BLOCK_CARD,
    bodiedExtension: (0, $d925B.ACTION_SUBJECT_ID).PASTE_BODIED_EXTENSION,
    bulletList: (0, $d925B.ACTION_SUBJECT_ID).PASTE_BULLET_LIST,
    codeBlock: (0, $d925B.ACTION_SUBJECT_ID).PASTE_CODE_BLOCK,
    decisionList: (0, $d925B.ACTION_SUBJECT_ID).PASTE_DECISION_LIST,
    extension: (0, $d925B.ACTION_SUBJECT_ID).PASTE_EXTENSION,
    heading: (0, $d925B.ACTION_SUBJECT_ID).PASTE_HEADING,
    mediaGroup: (0, $d925B.ACTION_SUBJECT_ID).PASTE_MEDIA_GROUP,
    mediaSingle: (0, $d925B.ACTION_SUBJECT_ID).PASTE_MEDIA_SINGLE,
    orderedList: (0, $d925B.ACTION_SUBJECT_ID).PASTE_ORDERED_LIST,
    panel: (0, $d925B.ACTION_SUBJECT_ID).PASTE_PANEL,
    rule: (0, $d925B.ACTION_SUBJECT_ID).PASTE_RULE,
    table: (0, $d925B.ACTION_SUBJECT_ID).PASTE_TABLE,
    tableCell: (0, $d925B.ACTION_SUBJECT_ID).PASTE_TABLE_CELL,
    tableHeader: (0, $d925B.ACTION_SUBJECT_ID).PASTE_TABLE_HEADER,
    tableRow: (0, $d925B.ACTION_SUBJECT_ID).PASTE_TABLE_ROW,
    taskList: (0, $d925B.ACTION_SUBJECT_ID).PASTE_TASK_LIST
};
function $077e6b5ad97baf3f$export$234c310f1a4fffd6({ schema: schema, slice: slice }) {
    const { nodes: { paragraph: paragraph }, marks: { link: link } } = schema;
    const nodeOrMarkName = new Set();
    slice.content.forEach((node)=>{
        if (node.type === paragraph && node.content.size === 0) // Skip empty paragraph
        return;
        if (node.type.name === 'text' && link.isInSet(node.marks)) {
            nodeOrMarkName.add('url');
            return;
        }
        // Check node contain link
        if (node.type === paragraph && node.rangeHasMark(0, node.nodeSize - 2, link)) {
            nodeOrMarkName.add('url');
            return;
        }
        nodeOrMarkName.add(node.type.name);
    });
    if (nodeOrMarkName.size > 1) return (0, $aSgIe.PasteContents).mixed;
    if (nodeOrMarkName.size === 0) return (0, $aSgIe.PasteContents).uncategorized;
    const type = nodeOrMarkName.values().next().value;
    // @ts-ignore - TS2538 TypeScript 5.9.2 upgrade
    const pasteContent = $077e6b5ad97baf3f$var$contentToPasteContent[type];
    return pasteContent ? pasteContent : (0, $aSgIe.PasteContents).uncategorized;
}
function $077e6b5ad97baf3f$export$d26f991ad03d8827(slice) {
    let traceId;
    (0, $3Ter7.mapSlice)(slice, (node)=>{
        if (node.type.name === 'media' || node.type.name === 'mediaInline') traceId = node.attrs.__mediaTraceId;
        return node;
    });
    return traceId;
}
function $077e6b5ad97baf3f$var$getActionSubjectId({ selection: selection, schema: schema }) {
    const { nodes: { paragraph: paragraph, listItem: listItem, taskItem: taskItem, decisionItem: decisionItem } } = schema;
    const parent = (0, $8m4tT.findParentNode)((node)=>{
        if (node.type !== paragraph && node.type !== listItem && node.type !== taskItem && node.type !== decisionItem) return true;
        return false;
    })(selection);
    if (!parent) return (0, $d925B.ACTION_SUBJECT_ID).PASTE_PARAGRAPH;
    const parentType = parent.node.type;
    const actionSubjectId = $077e6b5ad97baf3f$var$nodeToActionSubjectId[parentType.name];
    return actionSubjectId ? actionSubjectId : (0, $d925B.ACTION_SUBJECT_ID).PASTE_PARAGRAPH;
}
function $077e6b5ad97baf3f$var$createPasteAsPlainPayload(actionSubjectId, text, linksInPasteCount) {
    return {
        action: (0, $d925B.ACTION).PASTED_AS_PLAIN,
        actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: actionSubjectId,
        eventType: (0, $d925B.EVENT_TYPE).TRACK,
        attributes: {
            inputMethod: (0, $d925B.INPUT_METHOD).KEYBOARD,
            pasteSize: text.length,
            linksInPasteCount: linksInPasteCount
        }
    };
}
function $077e6b5ad97baf3f$var$createPastePayload(actionSubjectId, attributes, linkDomain) {
    return {
        action: (0, $d925B.ACTION).PASTED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: actionSubjectId,
        eventType: (0, $d925B.EVENT_TYPE).TRACK,
        attributes: {
            inputMethod: (0, $d925B.INPUT_METHOD).KEYBOARD,
            ...attributes
        },
        ...linkDomain && linkDomain.length > 0 ? {
            nonPrivacySafeAttributes: {
                linkDomain: linkDomain
            }
        } : {}
    };
}
function $077e6b5ad97baf3f$var$createPasteAnalyticsPayloadBySelection(event, slice, pasteContext, pluginInjectionApi) {
    return (selection)=>{
        const text = event.clipboardData ? event.clipboardData.getData('text/plain') || event.clipboardData.getData('text/uri-list') : '';
        const actionSubjectId = $077e6b5ad97baf3f$var$getActionSubjectId({
            selection: selection,
            schema: selection.$from.doc.type.schema
        });
        const pasteSize = slice.size;
        const content = $077e6b5ad97baf3f$export$234c310f1a4fffd6({
            schema: selection.$from.doc.type.schema,
            slice: slice
        });
        const linkUrls = [];
        const mediaTraceId = $077e6b5ad97baf3f$export$d26f991ad03d8827(slice);
        // If we have a link among the pasted content, grab the
        // domain and send it up with the analytics event
        if (content === (0, $aSgIe.PasteContents).url || content === (0, $aSgIe.PasteContents).mixed) (0, $3Ter7.mapSlice)(slice, (node)=>{
            const linkMark = node.marks.find((mark)=>mark.type.name === 'link');
            if (linkMark) linkUrls.push(linkMark.attrs.href);
            return node;
        });
        if (pasteContext.asPlain) return $077e6b5ad97baf3f$var$createPasteAsPlainPayload(actionSubjectId, text, linkUrls.length);
        const source = (0, $2ded4de594877764$export$e45b5b7458bacd81)(event);
        const mentionIds = [];
        const mentionLocalIds = [];
        slice.content.descendants((node)=>{
            if (node.type.name === 'mention') {
                mentionIds.push(node.attrs.id);
                mentionLocalIds.push(node.attrs.localId);
            }
        });
        if (pluginInjectionApi?.mention?.actions?.announceMentionsInsertion) {
            const mentionsInserted = [];
            slice.content.descendants((node)=>{
                if (node.type.name === 'mention') mentionsInserted.push({
                    type: 'added',
                    id: node.attrs.id,
                    localId: node.attrs.localId,
                    method: 'pasted'
                });
                if (node.type.name === 'taskItem') {
                    node.content.forEach((nodeContent)=>{
                        if (nodeContent.type.name === 'mention') mentionsInserted.push({
                            type: 'added',
                            localId: nodeContent.attrs.localId,
                            id: nodeContent.attrs.id,
                            taskLocalId: node.attrs.localId,
                            method: 'pasted'
                        });
                    });
                    return false;
                }
            });
            pluginInjectionApi?.mention?.actions?.announceMentionsInsertion(mentionsInserted);
        }
        const pastedNodeTypes = (0, $dh538.fg)('platform_editor_paste_renderer_analytics') ? [
            ...$077e6b5ad97baf3f$export$629ff5588e070c83(slice.content)
        ].sort().join(',') : undefined;
        if (pasteContext.type === (0, $aSgIe.PasteTypes).plain) return $077e6b5ad97baf3f$var$createPastePayload(actionSubjectId, {
            pasteSize: text.length,
            type: pasteContext.type,
            content: (0, $aSgIe.PasteContents).text,
            source: source,
            hyperlinkPasteOnText: false,
            linksInPasteCount: linkUrls.length,
            mentionIds: mentionIds,
            mentionLocalIds: mentionLocalIds,
            pasteSplitList: pasteContext.pasteSplitList,
            pastedNodeTypes: pastedNodeTypes
        });
        const linkDomains = linkUrls.map((0, $d2M6W.getLinkDomain));
        return $077e6b5ad97baf3f$var$createPastePayload(actionSubjectId, {
            type: pasteContext.type,
            pasteSize: pasteSize,
            content: content,
            source: source,
            hyperlinkPasteOnText: !!pasteContext.hyperlinkPasteOnText,
            linksInPasteCount: linkUrls.length,
            mediaTraceId: mediaTraceId,
            mentionIds: mentionIds,
            mentionLocalIds: mentionLocalIds,
            pasteSplitList: pasteContext.pasteSplitList,
            pastedNodeTypes: pastedNodeTypes
        }, linkDomains);
    };
}
function $077e6b5ad97baf3f$export$a30e064bd28e927f(view, event, slice, pasteContext) {
    return $077e6b5ad97baf3f$var$createPasteAnalyticsPayloadBySelection(event, slice, pasteContext)(view.state.selection);
}
const $077e6b5ad97baf3f$export$5ee87eef0a304a1b = (editorAnalyticsAPI)=>(view, event, slice, pasteContext)=>{
        const tr = view.state.tr;
        const payload = $077e6b5ad97baf3f$export$a30e064bd28e927f(view, event, slice, pasteContext);
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
        view.dispatch(tr);
    };
const $077e6b5ad97baf3f$export$69d6e3902009956e = (editorAnalyticsAPI)=>(view, event, slice)=>$077e6b5ad97baf3f$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($077e6b5ad97baf3f$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: (0, $aSgIe.PasteTypes).plain,
            asPlain: true
        }))((0, $ed7aabc7e8e09621$export$efe55f809fabb910)(slice, event, editorAnalyticsAPI));
const $077e6b5ad97baf3f$export$e3873690443e0966 = (view, event, slice, type, pluginInjectionApi)=>$077e6b5ad97baf3f$var$injectAnalyticsPayloadBeforeCommand(pluginInjectionApi?.analytics?.actions)($077e6b5ad97baf3f$var$createPasteAnalyticsPayloadBySelection(event, slice, {
        type: type
    }))((0, $ed7aabc7e8e09621$export$af959912bf89ae42)(slice, pluginInjectionApi?.card?.actions?.queueCardsFromChangedTr));
const $077e6b5ad97baf3f$export$e1d2fb186881c383 = (editorAnalyticsAPI)=>(view, event, slice, type)=>$077e6b5ad97baf3f$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($077e6b5ad97baf3f$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: type
        }))((0, $ed7aabc7e8e09621$export$d399a86cc775ad7e)(slice));
const $077e6b5ad97baf3f$export$9fea421173ba6d7d = (editorAnalyticsAPI)=>(view, event, slice, text)=>$077e6b5ad97baf3f$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($077e6b5ad97baf3f$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: (0, $aSgIe.PasteTypes).plain
        }))((0, $ed7aabc7e8e09621$export$98135102f7ccdef2)(text));
const $077e6b5ad97baf3f$export$b49fd82cf59cd44e = (editorAnalyticsAPI)=>(view, event, slice, type, insertMediaAsMediaSingle)=>$077e6b5ad97baf3f$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($077e6b5ad97baf3f$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: type
        }))((0, $ed7aabc7e8e09621$export$5fb647c5a57bac64)((0, $d925B.INPUT_METHOD).CLIPBOARD, insertMediaAsMediaSingle)(slice));
const $077e6b5ad97baf3f$export$ef36b80b79d1d973 = (view, event, slice, type, pluginInjectionApi)=>$077e6b5ad97baf3f$var$injectAnalyticsPayloadBeforeCommand(pluginInjectionApi?.analytics?.actions)($077e6b5ad97baf3f$var$createPasteAnalyticsPayloadBySelection(event, slice, {
        type: type
    }))((0, $ed7aabc7e8e09621$export$de618421675f910e)(slice, pluginInjectionApi?.card?.actions?.queueCardsFromChangedTr));
const $077e6b5ad97baf3f$export$d7489d309972091e = (view, event, slice, pluginInjectionApi)=>$077e6b5ad97baf3f$var$injectAnalyticsPayloadBeforeCommand(pluginInjectionApi?.analytics?.actions)($077e6b5ad97baf3f$var$createPasteAnalyticsPayloadBySelection(event, slice, {
        type: (0, $aSgIe.PasteTypes).markdown
    }))((0, $ed7aabc7e8e09621$export$4b83e18c607f848f)(slice, pluginInjectionApi?.card?.actions?.queueCardsFromChangedTr));
const $077e6b5ad97baf3f$export$3ef868f9e7157717 = (view, event, slice, pluginInjectionApi)=>$077e6b5ad97baf3f$var$injectAnalyticsPayloadBeforeCommand(pluginInjectionApi?.analytics?.actions)($077e6b5ad97baf3f$var$createPasteAnalyticsPayloadBySelection(event, slice, {
        type: (0, $aSgIe.PasteTypes).richText
    }, pluginInjectionApi))((0, $ed7aabc7e8e09621$export$f9c7e15c780a77d0)(slice, pluginInjectionApi?.card?.actions?.queueCardsFromChangedTr));
const $077e6b5ad97baf3f$var$injectAnalyticsPayloadBeforeCommand = (editorAnalyticsAPI)=>(createPayloadByTransaction)=>{
        return (mainCommand)=>{
            return (state, dispatch, view)=>{
                let originalTransaction = state.tr;
                const fakeDispatch = (tr)=>{
                    originalTransaction = tr;
                };
                const result = mainCommand(state, fakeDispatch, view);
                if (!result) return false;
                if (dispatch && originalTransaction.docChanged) {
                    // it needs to know the selection before the changes
                    const payload = createPayloadByTransaction(state.selection);
                    editorAnalyticsAPI?.attachAnalyticsEvent(payload)(originalTransaction);
                    dispatch(originalTransaction);
                }
                return true;
            };
        };
    };
const $077e6b5ad97baf3f$export$2d195c5439ce2ebc = (editorAnalyticsAPI)=>(view, event, slice, findRootParentListNode)=>$077e6b5ad97baf3f$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($077e6b5ad97baf3f$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: (0, $aSgIe.PasteTypes).richText
        }))((0, $ed7aabc7e8e09621$export$3fd7f6d89a9d2cac)(slice, findRootParentListNode));
const $077e6b5ad97baf3f$export$bbc9709b7b4a2f6 = (editorAnalyticsAPI)=>(view, event, slice)=>$077e6b5ad97baf3f$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($077e6b5ad97baf3f$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: (0, $aSgIe.PasteTypes).richText,
            pasteSplitList: true
        }))((0, $ed7aabc7e8e09621$export$b8a52be876d0b84f)(slice));
const $077e6b5ad97baf3f$export$6681e5bfb9c8b704 = (editorAnalyticsAPI)=>(view, event, slice)=>$077e6b5ad97baf3f$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($077e6b5ad97baf3f$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: (0, $aSgIe.PasteTypes).richText,
            pasteSplitList: true
        }))((0, $ed7aabc7e8e09621$export$a497757c6eac4530)(slice));
const $077e6b5ad97baf3f$export$7dc8d4c52517a2f7 = (editorAnalyticsAPI, isNestingTablesSupported)=>(view, event, slice)=>$077e6b5ad97baf3f$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($077e6b5ad97baf3f$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: (0, $aSgIe.PasteTypes).richText,
            pasteSplitList: true
        }))((0, $ed7aabc7e8e09621$export$113227139658cc8d)(slice, isNestingTablesSupported));
const $077e6b5ad97baf3f$export$6dbadac5ea22dd7a = (editorAnalyticsAPI)=>(view, event, slice)=>$077e6b5ad97baf3f$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($077e6b5ad97baf3f$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: (0, $aSgIe.PasteTypes).richText
        }))((0, $ed7aabc7e8e09621$export$4ce587bb5876886d)(editorAnalyticsAPI)(slice));
const $077e6b5ad97baf3f$export$b36a7c9ea20b7bbf = (editorAnalyticsAPI)=>(view, event, slice, type)=>$077e6b5ad97baf3f$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($077e6b5ad97baf3f$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: type,
            hyperlinkPasteOnText: true
        }))((0, $ed7aabc7e8e09621$export$5e27b285bdcc71bf)(slice));
const $077e6b5ad97baf3f$export$5dd5834ba1e07721 = ({ view: view, duration: duration, content: content, distortedDuration: distortedDuration })=>{
    const pasteIntoNode = $077e6b5ad97baf3f$var$getActionSubjectId({
        selection: view.state.selection,
        schema: view.state.schema
    });
    return {
        action: (0, $d925B.ACTION).PASTED_TIMED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
        attributes: {
            pasteIntoNode: pasteIntoNode,
            content: content,
            time: duration,
            distortedDuration: distortedDuration
        }
    };
};
const $077e6b5ad97baf3f$export$629ff5588e070c83 = (content)=>{
    let nodeTypes = new Set();
    if (content.size) content.forEach((node)=>{
        if (node.content && node.content.size) nodeTypes = new Set([
            ...nodeTypes,
            ...$077e6b5ad97baf3f$export$629ff5588e070c83(node.content)
        ]);
        nodeTypes.add(node.type.name);
    });
    return Array.from(nodeTypes);
};








/**
 * Builds additional parseDOM rules to inject into the clipboard parser.
 *
 * Adding a rule with a higher priority than the default schema rules, allows
 * specific HTML patterns to be parsed as a different node type than the schema
 * would normally choose.
 */ function $da6eede523c6cc03$var$buildAdditionalClipboardParseRules(schema) {
    const rules = [];
    // This means that panels with tables inside always stay as panel_c1,
    // but panels without tables retain standard behaviour
    // of choosing between panel_c1 and panel depending on the context.
    // e.g. panel with table pasted in expand gets lifted out, panel with normal text gets pasted inside expand
    const { panel_c1: panel_c1, panel: panel } = schema.nodes;
    if (!panel_c1 || !panel) return rules;
    const panelGetAttrs = panel.spec.parseDOM?.[0]?.getAttrs;
    rules.push({
        tag: 'div[data-panel-type]',
        priority: 60,
        node: panel_c1.name,
        getAttrs: (dom)=>{
            const hasTable = dom.querySelector('[data-prosemirror-node-name="table"]') !== null;
            if (!hasTable) return false; // fall through to standard panel rule
            return panelGetAttrs ? panelGetAttrs(dom) : null;
        }
    });
    return rules;
}
function $da6eede523c6cc03$export$973a4e50710cf49d(schema) {
    if (!(0, $1oCLl.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true)) return undefined;
    const additionalRules = $da6eede523c6cc03$var$buildAdditionalClipboardParseRules(schema);
    const baseParser = (0, $5SAOw.DOMParser).fromSchema(schema);
    const customParser = new (0, $5SAOw.DOMParser)(schema, [
        ...additionalRules,
        ...baseParser.rules
    ]);
    return customParser;
}



var $dIxHZ = parcelRequire("dIxHZ");

function $c6932566e2ec5327$export$98b67e7d9513bbaf(intl) {
    return (slice)=>{
        const blockSeparator = '\n\n';
        return slice.content.textBetween(0, slice.content.size, blockSeparator, (leafNode)=>{
            switch(leafNode.type.name){
                case 'hardBreak':
                    return '\n';
                case 'text':
                    return leafNode.text;
                case 'inlineCard':
                    return leafNode.attrs.url;
                case 'blockCard':
                    return leafNode.attrs.url;
                // Note: Due to relying on an async fetch of the Mention name by the Node's React component,
                // pasting a mention does not actually work for the in-product Mention implementation.
                // However, this is also true of the previous implementation.
                // Bug ticket: https://product-fabric.atlassian.net/browse/ED-23076
                case 'mention':
                    return leafNode.attrs.text;
                case 'date':
                    return (0, $dIxHZ.timestampToString)(leafNode.attrs.timestamp, intl);
                default:
                    // Unsupported node
                    return leafNode.text ?? '';
            }
        });
    };
}





var $cTQmR = parcelRequire("cTQmR");




function $7bdd8b3011622662$var$safelyGetVSCodeLanguage(editorData) {
    try {
        const vscodeData = editorData ? JSON.parse(editorData) : undefined;
        return vscodeData?.mode;
    } catch  {}
}
function $7bdd8b3011622662$export$d920fedcc56c4475({ state: state, slice: slice, text: text, event: event }) {
    const vscodeData = event?.clipboardData?.getData('vscode-editor-data');
    const language = $7bdd8b3011622662$var$safelyGetVSCodeLanguage(vscodeData);
    if (text && language && (0, $cTQmR.SUPPORTED_LANGUAGES).some((l)=>l.alias[0] === language)) {
        const { schema: schema } = state;
        slice = (0, $3Ter7.mapSlice)(slice, (node)=>{
            if (node.type.name === schema.nodes.codeBlock?.name) return schema.nodes.codeBlock.createChecked({
                language: language
            }, schema.text(text));
            return node;
        });
    }
    return slice;
}




var $dNXVc = parcelRequire("dNXVc");

const $30ae5b8a41b08016$var$isCodeBlockWithUnsetWrap = (node)=>node.attrs.wrap === null;
const $30ae5b8a41b08016$var$patchInsertedCodeBlocks = (tr, insertedCodeBlocks)=>{
    insertedCodeBlocks.forEach(({ node: node, pos: pos })=>{
        tr.setNodeMarkup(pos, undefined, (0, $dNXVc.getDefaultCodeBlockAttrs)(node.attrs), node.marks);
    });
};
const $30ae5b8a41b08016$export$85bff74b6f63f849 = (tr, codeBlockType)=>{
    if (!codeBlockType) return tr;
    const insertedCodeBlocks = (0, $dNXVc.getInsertedCodeBlocksInTransaction)(tr, codeBlockType, {
        filter: $30ae5b8a41b08016$var$isCodeBlockWithUnsetWrap
    });
    if (insertedCodeBlocks.length) $30ae5b8a41b08016$var$patchInsertedCodeBlocks(tr, insertedCodeBlocks);
    return tr;
};



var $fO7hX = parcelRequire("fO7hX");





var $01f2ba065c56b221$export$5e592dcf077082fd = /*#__PURE__*/ function(FLAG_TYPE) {
    FLAG_TYPE["WARNING"] = "warning";
    FLAG_TYPE["ERROR"] = "error";
    FLAG_TYPE["INFO"] = "info";
    FLAG_TYPE["SUCCESS"] = "success";
    return FLAG_TYPE;
}({});



var $009f23fcd155fb15$var$FLAG_ID = /*#__PURE__*/ function(FLAG_ID) {
    FLAG_ID["CANNOT_PASTE_CONTENT"] = "cannot-paste-content";
    return FLAG_ID;
}($009f23fcd155fb15$var$FLAG_ID || {});
const $009f23fcd155fb15$var$transformSyncBlockNode = (node, schema, isFromEditor)=>{
    // if copying from renderer, flatten out the content and remove the sync block
    if (!isFromEditor) return node.content;
    // sync blocks need a unique localId to function correctly
    const newAttrs = {
        ...node.attrs,
        localId: (0, $fO7hX.uuid).generate()
    };
    return schema.nodes.syncBlock.create(newAttrs, null, [
        ...node.marks
    ]);
};
const $009f23fcd155fb15$var$transformBodiedSyncBlockNode = (node, isFromEditor)=>{
    // if copying from renderer, flatten out the content and remove the bodied sync block
    if (!isFromEditor) return node.content;
    // this is not possible as all bodiedSyncBlocks have already been converted into a syncBlock by now.
    return node;
};
const $009f23fcd155fb15$var$showWarningFlag = ({ api: api, title: title, description: description, urlText: urlText, urlHref: urlHref })=>{
    // Use setTimeout to dispatch transaction in next tick and avoid re-entrant dispatch
    setTimeout(()=>{
        api?.core.actions.execute(({ tr: tr })=>{
            const flag = {
                id: "cannot-paste-content",
                description: description,
                title: title,
                urlText: urlText,
                urlHref: urlHref,
                type: (0, $01f2ba065c56b221$export$5e592dcf077082fd).WARNING
            };
            return tr.setMeta((0, $6b91a48544104490$export$18d4026d1ea86bb1), {
                type: (0, $d67f3be44268e218$export$ad3c0356f902fd97).SET_ACTIVE_FLAG,
                activeFlag: flag
            });
        });
    }, 0);
};
// Check if rawHtml contains a synced block
// example: "<meta charset='utf-8'><html><head></head><body><div data-sync-block=\"\" data-local-id=\"\" data-resource-id=\"d64883c8-1270-431d-a1d3-51d36a1ed5f4\" data-prosemirror-content-type=\"node\" data-prosemirror-node-name=\"syncBlock\" data-prosemirror-node-block=\"true\" data-pm-slice=\"0 0 []\"></div></body></html>"
const $009f23fcd155fb15$var$hasSyncedBlockInRawHtml = (rawHtml)=>{
    return rawHtml.includes('data-sync-block="');
};
const $009f23fcd155fb15$export$27da60ebda8ac583 = (slice, schema, pasteSource, rawHtml, pasteWarningOptions, api)=>{
    const isFromEditor = pasteSource === 'fabric-editor';
    const isSyncedBlockInRawHtml = $009f23fcd155fb15$var$hasSyncedBlockInRawHtml(rawHtml);
    let hasSyncedBlockInSlice = false;
    slice = (0, $3Ter7.mapSlice)(slice, (node)=>{
        if (node.type === schema.nodes.syncBlock) {
            hasSyncedBlockInSlice = true;
            return $009f23fcd155fb15$var$transformSyncBlockNode(node, schema, isFromEditor);
        } else if (node.type === schema.nodes.bodiedSyncBlock) {
            hasSyncedBlockInSlice = true;
            return $009f23fcd155fb15$var$transformBodiedSyncBlockNode(node, isFromEditor);
        }
        return node;
    });
    if (pasteWarningOptions?.cannotPasteSyncedBlock && !hasSyncedBlockInSlice && isSyncedBlockInRawHtml) $009f23fcd155fb15$var$showWarningFlag({
        api: api,
        title: pasteWarningOptions?.cannotPasteSyncedBlock?.title,
        description: pasteWarningOptions?.cannotPasteSyncedBlock?.description,
        urlText: pasteWarningOptions?.cannotPasteSyncedBlock?.urlText,
        urlHref: pasteWarningOptions?.cannotPasteSyncedBlock?.urlHref
    });
    return slice;
};



var $c4jUA = parcelRequire("c4jUA");

const $2ef111395dc72fc1$var$isPastedFromTinyMCE = (pasteEvent)=>{
    return pasteEvent?.clipboardData?.types?.some((mimeType)=>mimeType === 'x-tinymce/html') ?? false;
};
const $2ef111395dc72fc1$export$4a3cccc9bf9da386 = (pasteEvent, html)=>{
    return $2ef111395dc72fc1$var$isPastedFromTinyMCE(pasteEvent) && !!html && // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    !!html.match(/class=\"\s?(confluenceTd|confluenceTh|confluenceTable).+"/gim);
};
const $2ef111395dc72fc1$export$4552e3fc797fc52a = (html)=>{
    const parser = new DOMParser();
    const nonTableWrappedDoc = parser.parseFromString(html, 'text/html');
    const tableWrappedDoc = parser.parseFromString(`<table>${html}</table>`, 'text/html');
    tableWrappedDoc.body.querySelectorAll('meta').forEach((meta)=>{
        tableWrappedDoc.head.prepend(meta);
    });
    return {
        tableWrappedDoc: tableWrappedDoc,
        nonTableWrappedDoc: nonTableWrappedDoc
    };
};
const $2ef111395dc72fc1$var$exactlyDivisible = (larger, smaller)=>larger % smaller === 0;
const $2ef111395dc72fc1$var$getTableElementsInfo = (doc)=>{
    const cellCount = doc.querySelectorAll('td').length;
    const thCount = doc.querySelectorAll('th').length;
    const mergedCellCount = doc.querySelectorAll('td[colspan]:not([colspan="1"])').length;
    let hasThAfterTd = false;
    const thsAndCells = doc.querySelectorAll('th,td');
    for(let i = 0, cellFound = false; i < thsAndCells.length; i++){
        if (cellFound && thsAndCells[i].nodeName === 'TH') {
            hasThAfterTd = true;
            break;
        }
        if (thsAndCells[i].nodeName === 'TD') cellFound = true;
    }
    const onlyTh = thCount > 0 && cellCount === 0;
    const onlyCells = cellCount > 0 && thCount === 0;
    const hasCompleteRow = // we take header-only and cell-only tables to be
    // row-complete
    onlyTh || onlyCells || // if headers and cells can "fit" against each other,
    // then we assume a complete row exists
    ($2ef111395dc72fc1$var$exactlyDivisible(thCount, cellCount) || $2ef111395dc72fc1$var$exactlyDivisible(cellCount, thCount)) && // all numbers are divisible by 1, so we carve out a specific
    // check for when there is only 1 table cell, and more than 1
    // table header.
    !(thCount > 1 && cellCount === 1);
    return {
        cellCount: cellCount,
        thCount: thCount,
        mergedCellCount: mergedCellCount,
        hasThAfterTd: hasThAfterTd,
        hasIncompleteRow: !hasCompleteRow
    };
};
const $2ef111395dc72fc1$var$configureTableRows = (doc, colsInRow)=>{
    const tableHeadersAndCells = Array.from(doc.body.querySelectorAll('th,td'));
    const evenlySplitChunks = (0, (/*@__PURE__*/$parcel$interopDefault($c4jUA)))(tableHeadersAndCells, colsInRow);
    const tableBody = doc.body.querySelector('tbody');
    evenlySplitChunks.forEach((chunk)=>{
        const tr = doc.createElement('tr');
        tableBody?.append(tr);
        tr.append(...chunk);
    });
    // We remove any leftover empty rows which may cause fabric editor
    // to no-op when parsing the table
    const emptyRows = Array.from(tableBody.querySelectorAll('tr'))?.filter((row)=>row.innerHTML.trim().length === 0);
    emptyRows.forEach((row)=>row.remove());
    return doc.body.innerHTML;
};
const $2ef111395dc72fc1$var$fillIncompleteRowWithEmptyCells = (doc, thCount, cellCount)=>{
    let extraCellsCount = 0;
    while(!$2ef111395dc72fc1$var$exactlyDivisible(cellCount + extraCellsCount, thCount))extraCellsCount++;
    const extraEmptyCells = Array.from(Array(extraCellsCount)).map(()=>doc.createElement('td'));
    const lastCell = doc.body.querySelector('td:last-of-type');
    lastCell?.parentElement?.append(...extraEmptyCells);
    return {
        updatedCellCount: cellCount + extraCellsCount
    };
};
const $2ef111395dc72fc1$export$d749bb0e238929f2 = (doc)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line prefer-const
    let { cellCount: cellCount, thCount: thCount, mergedCellCount: mergedCellCount, hasThAfterTd: hasThAfterTd, hasIncompleteRow: hasIncompleteRow } = $2ef111395dc72fc1$var$getTableElementsInfo(doc);
    if (mergedCellCount || hasThAfterTd) // bail out to avoid handling more complex table structures
    return doc.body.innerHTML;
    if (!thCount) // if no table headers exist for reference, fallback to a single column table structure
    return $2ef111395dc72fc1$var$configureTableRows(doc, 1);
    if (hasIncompleteRow) {
        // if shift-click selection copies a partial table row to the clipboard,
        // and we do have table headers for reference, then we add empty table cells
        // to fill out the partial row
        const { updatedCellCount: updatedCellCount } = $2ef111395dc72fc1$var$fillIncompleteRowWithEmptyCells(doc, thCount, cellCount);
        cellCount = updatedCellCount;
    }
    for(let possibleColsInRow = thCount; possibleColsInRow > 0; possibleColsInRow--){
        if ($2ef111395dc72fc1$var$exactlyDivisible(thCount, possibleColsInRow) && $2ef111395dc72fc1$var$exactlyDivisible(cellCount, possibleColsInRow)) return $2ef111395dc72fc1$var$configureTableRows(doc, possibleColsInRow);
    }
    return doc.body.innerHTML;
};
const $2ef111395dc72fc1$export$120b137b77798e76 = (html)=>{
    return !html.includes('<table ') && (html.includes('<td ') || html.includes('<th '));
};
const $2ef111395dc72fc1$export$253f7bda9f1e0696 = (incompleteTableHtml)=>{
    // first we try wrapping the table elements with <table> and let DOMParser try to rebuild
    // a valid DOM tree. we also keep the non-wrapped table for comparison purposes.
    const { nonTableWrappedDoc: nonTableWrappedDoc, tableWrappedDoc: tableWrappedDoc } = $2ef111395dc72fc1$export$4552e3fc797fc52a(incompleteTableHtml);
    const didPreserveTableElements = Boolean(!nonTableWrappedDoc.body.querySelector('th, td') && tableWrappedDoc.body.querySelector('th, td'));
    const isExpectedStructure = tableWrappedDoc.querySelectorAll('body > table:only-child') && !tableWrappedDoc.querySelector(`body > table > tbody > tr > :not(th,td)`);
    // if DOMParser saves table elements that we would otherwise lose, and
    // if the table html is what we'd expect (a single table, with no extraneous
    // elements in table rows other than th, td), then we can now also try to
    // rebuild table rows/columns.
    if (didPreserveTableElements && isExpectedStructure) {
        const completeTableHtml = $2ef111395dc72fc1$export$d749bb0e238929f2(tableWrappedDoc);
        return completeTableHtml;
    }
    return null;
};


const $4b9ed3b686e9ecfc$export$eedfdbc6a6bc1442 = (state)=>{
    const { blockquote: blockquote } = state.schema.nodes;
    return (0, $8m4tT.hasParentNodeOfType)(blockquote)(state.selection);
};
const $4b9ed3b686e9ecfc$var$enableNewDomainCheckToImproveSmartLinkResolveRate = (hostname)=>{
    return (0, $1oCLl.expValEquals)('improve_3p_smart_link_resolve_rate', 'isEnabled', true) && // OneDrive Shortlinks
    (hostname.endsWith('1drv.ms') || // MS Teams links
    hostname.endsWith('teams.live.com') || hostname.endsWith('teams.cloud.microsoft') || hostname.endsWith('teams.microsoft.com') || // MS Power BI
    hostname.endsWith('powerbi.com') || // MS Azure devops
    hostname.endsWith('dev.azure.com') || hostname.endsWith('visualstudio.com'));
};
const $4b9ed3b686e9ecfc$var$PASTE = 'Editor Paste Plugin Paste Duration';
function $4b9ed3b686e9ecfc$export$c503e2315ac846a7(url) {
    if (!url) return false;
    try {
        const urlObj = new URL(url);
        const hostname = urlObj.hostname.toLowerCase();
        const protocol = urlObj.protocol.toLowerCase();
        // Only accept HTTPS URLs for security
        if (protocol !== 'https:') return false;
        // Check if hostname ends with the trusted domains (not just contains them)
        return hostname.endsWith('sharepoint.com') || hostname.endsWith('onedrive.com') || hostname.endsWith('onedrive.live.com') || $4b9ed3b686e9ecfc$var$enableNewDomainCheckToImproveSmartLinkResolveRate(hostname);
    } catch  {
        // If URL parsing fails, return false for safety
        return false;
    }
}
function $4b9ed3b686e9ecfc$export$ae829ec7b2625219(schema, dispatchAnalyticsEvent, dispatch, featureFlags, pluginInjectionApi, getIntl, cardOptions, sanitizePrivateContent, providerFactory, pasteWarningOptions) {
    const editorAnalyticsAPI = pluginInjectionApi?.analytics?.actions;
    const atlassianMarkDownParser = new (0, $aRZzN.MarkdownTransformer)(schema, (0, $jvA0K.md));
    function getMarkdownSlice(text, openStart, openEnd) {
        const escapedTextInput = (0, $2ded4de594877764$export$3e81f5aaf68cd698)(text);
        const doc = atlassianMarkDownParser.parse(escapedTextInput);
        if (doc && doc.content) return new (0, $5SAOw.Slice)(doc.content, openStart, openEnd);
        return;
    }
    let extensionAutoConverter;
    async function setExtensionAutoConverter(name, extensionProviderPromise) {
        if (name !== 'extensionProvider' || !extensionProviderPromise) return;
        try {
            extensionAutoConverter = await (0, $2cmfr.getExtensionAutoConvertersFromProvider)(extensionProviderPromise);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    }
    if (providerFactory) providerFactory.subscribe('extensionProvider', setExtensionAutoConverter);
    let mostRecentPasteEvent;
    let pastedFromBitBucket = false;
    return new (0, $1S4f7.SafePlugin)({
        key: (0, $6b91a48544104490$export$18d4026d1ea86bb1),
        state: (0, $6b91a48544104490$export$656c7661095efe2e)(dispatch, {
            activeFlag: null,
            pastedMacroPositions: {},
            lastContentPasted: null
        }),
        props: {
            // For serialising to plain text
            clipboardTextSerializer: (0, $c6932566e2ec5327$export$98b67e7d9513bbaf)(getIntl()),
            clipboardParser: (0, $da6eede523c6cc03$export$973a4e50710cf49d)(schema),
            handleDOMEvents: {
                // note
                paste: (view, event)=>{
                    mostRecentPasteEvent = event;
                    if ((0, $1oCLl.expValEquals)('cc_editor_interactivity_monitoring', 'isEnabled', true) && event.clipboardData) (0, $2v1PW.insm).startHeavyTask('paste');
                    return false;
                }
            },
            // note
            handlePaste (view, rawEvent, slice) {
                const event = rawEvent;
                if (!event.clipboardData) return false;
                let text = event.clipboardData.getData('text/plain');
                const html = event.clipboardData.getData('text/html');
                const uriList = event.clipboardData.getData('text/uri-list');
                // Extract clientId values from pasted HTML for media cross-product copy/paste
                // This must be done before ProseMirror parses the HTML, as clientId is not stored in ADF
                if ((0, $dh538.fg)('platform_media_cross_client_copy_with_auth')) (0, $6taGi.extractClientIdsFromHtml)(html);
                // Links copied from iOS Safari share button only have the text/uri-list data type
                // ProseMirror don't do anything with this type so we want to make our own open slice
                // with url as text content so link is pasted inline
                if (uriList && !text && !html) {
                    text = uriList;
                    slice = new (0, $5SAOw.Slice)((0, $5SAOw.Fragment).from(schema.text(text)), 1, 1);
                }
                if (text?.includes('\r')) // Ignored via go/ees005
                // eslint-disable-next-line require-unicode-regexp
                text = text.replace(/\r/g, '');
                // Strip Legacy Content Macro (LCM) extensions on paste
                if (!(0, $dh538.fg)('platform_editor_legacy_content_macro_insert')) slice = (0, $igNsz.transformSliceToRemoveLegacyContentMacro)(slice, schema);
                const isPastedFile = (0, $8gdgt.isPastedFile)(event);
                const isPlainText = text && !html;
                const isRichText = !!html;
                // Bail if copied content has files
                if (isPastedFile) {
                    if (!html) {
                        if ((0, $1oCLl.expValEquals)('cc_editor_interactivity_monitoring', 'isEnabled', true)) (0, $2v1PW.insm).endHeavyTask('paste');
                        /**
             * Microsoft Office, Number, Pages, etc. adds an image to clipboard
             * with other mime-types so we don't let the event reach media.
             * The detection ration here is that if the payload has both `html` and
             * `files`, then it could be one of above or an image copied from web.
             * Here, we don't have html, so we return true to allow default event behaviour
             */ return true;
                    }
                    /**
           * We want to return false for external copied image to allow
           * it to be uploaded by the client.
           *
           * Scenario where we are pasting an external image inside a block quote
           * is skipped and handled in handleRichText
           */ if ((0, $2ded4de594877764$export$41d193509f55b76e)(html) && !$4b9ed3b686e9ecfc$export$eedfdbc6a6bc1442(view.state)) {
                        if ((0, $1oCLl.expValEquals)('cc_editor_interactivity_monitoring', 'isEnabled', true)) (0, $2v1PW.insm).endHeavyTask('paste');
                        return true;
                    }
                    /**
           * https://product-fabric.atlassian.net/browse/ED-21993
           * stopImmediatePropagation will run the first event attached to the same element
           * Which chould have race condition issue
           */ event.stopPropagation();
                }
                const { state: state } = view;
                const content = (0, $077e6b5ad97baf3f$export$629ff5588e070c83)(slice.content);
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                const pasteId = (0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))();
                const measureName = `${$4b9ed3b686e9ecfc$var$PASTE}_${pasteId}`;
                (0, $jz9wK.measureRender)(measureName, ({ duration: duration, distortedDuration: distortedDuration })=>{
                    const payload = (0, $077e6b5ad97baf3f$export$5dd5834ba1e07721)({
                        view: view,
                        duration: duration,
                        content: content,
                        distortedDuration: distortedDuration
                    });
                    if (payload) dispatchAnalyticsEvent(payload);
                    if ((0, $1oCLl.expValEquals)('cc_editor_interactivity_monitoring', 'isEnabled', true)) (0, $2v1PW.insm).endHeavyTask('paste');
                });
                const getLastPastedSlice = (tr)=>{
                    let slice;
                    for (const step of tr.steps){
                        const stepSlice = (0, $jI93b.extractSliceFromStep)(step);
                        if (stepSlice) slice = stepSlice;
                    }
                    return slice;
                };
                // creating a custom dispatch because we want to add a meta whenever we do a paste.
                const dispatch = (tr)=>{
                    // https://product-fabric.atlassian.net/browse/ED-12633
                    // don't add closeHistory call if we're pasting a text inside placeholder text as we want the whole action
                    // to be atomic
                    const { placeholder: placeholder } = state.schema.nodes;
                    const isPastingTextInsidePlaceholderText = state.doc.resolve(state.selection.$anchor.pos).nodeAfter?.type === placeholder;
                    // Don't add closeHistory if we're pasting over layout columns, as we will appendTransaction
                    // to cleanup the layout's structure and we want to keep the paste and re-structuring as
                    // one event.
                    const isPastingOverLayoutColumns = (0, $8m4tT.hasParentNodeOfType)(state.schema.nodes.layoutColumn)(state.selection);
                    // don't add closeHistory call if we're pasting a table, as some tables may involve additional
                    // appendedTransactions to repair them (if they're partial or incomplete) and we don't want
                    // to split those repairing transactions in prosemirror-history when they're being added to the
                    // "done" stack
                    const isPastingTable = tr.steps.some((step)=>{
                        const slice = (0, $jI93b.extractSliceFromStep)(step);
                        let tableExists = false;
                        slice?.content?.forEach((node)=>{
                            if (node.type === state.schema.nodes.table) tableExists = true;
                        });
                        return tableExists;
                    });
                    // Don't flag as a paste event (add closeHistory) when the paste affects a list and
                    // the list plugin's appendTransaction will normalise the structure, and we want the
                    // paste + normalisation to be a single undo step.
                    // Pasting into an existing list — selection is inside a list node.
                    let isPastingIntoList = false;
                    // Pasting list content from an external source — slice top-level contains a list node.
                    let isPastingListContent = false;
                    if ((0, $dZ8uq.expValEqualsNoExposure)('platform_editor_flexible_list_schema', 'isEnabled', true)) {
                        const listNodeTypes = [
                            state.schema.nodes.bulletList,
                            state.schema.nodes.orderedList,
                            state.schema.nodes.taskList
                        ].filter((n)=>Boolean(n));
                        isPastingIntoList = (0, $8m4tT.hasParentNodeOfType)(listNodeTypes)(state.selection);
                        for(let i = 0; i < slice.content.childCount; i++)if (listNodeTypes.includes(slice.content.child(i).type)) {
                            isPastingListContent = true;
                            break;
                        }
                    }
                    if (!isPastingTextInsidePlaceholderText && !isPastingTable && !isPastingOverLayoutColumns && !isPastingIntoList && !isPastingListContent && pluginInjectionApi?.betterTypeHistory) tr = pluginInjectionApi?.betterTypeHistory?.actions.flagPasteEvent(tr);
                    if ((0, $1oCLl.expValEquals)('platform_editor_code_block_q4_lovability', 'isEnabled', true)) tr = (0, $30ae5b8a41b08016$export$85bff74b6f63f849)(tr, schema.nodes.codeBlock);
                    const isDocChanged = tr.docChanged;
                    (0, $19Q6F.addLinkMetadata)(view.state.selection, tr, {
                        action: isPlainText ? (0, $d925B.ACTION).PASTED_AS_PLAIN : (0, $d925B.ACTION).PASTED,
                        inputMethod: (0, $d925B.INPUT_METHOD).CLIPBOARD
                    });
                    // handleMacroAutoConvert dispatches twice
                    // we make sure to call paste options toolbar
                    // only for a valid paste action
                    if (isDocChanged) {
                        const pastedSlice = getLastPastedSlice(tr);
                        if (pastedSlice) {
                            const pasteStartPos = state.selection.from;
                            const pasteEndPos = tr.selection.to;
                            const contentPasted = {
                                pasteStartPos: pasteStartPos,
                                pasteEndPos: pasteEndPos,
                                text: text,
                                isShiftPressed: Boolean(// eslint-disable-next-line @typescript-eslint/no-explicit-any
                                view.shiftKey || view.input?.shiftKey),
                                isPlainText: Boolean(isPlainText),
                                pastedSlice: pastedSlice,
                                pastedAt: Date.now(),
                                pasteSource: (0, $2ded4de594877764$export$e45b5b7458bacd81)(event)
                            };
                            tr.setMeta((0, $6b91a48544104490$export$18d4026d1ea86bb1), {
                                type: (0, $d67f3be44268e218$export$ad3c0356f902fd97).ON_PASTE,
                                contentPasted: contentPasted
                            });
                        }
                    }
                    // the handlePaste definition overrides the generic prosemirror behaviour which would previously
                    // include a uiEvent meta of paste. To align with the docs (https://prosemirror.net/docs/ref/#state.Transaction)
                    // This will re-add the uiEvent meta.
                    view.dispatch(tr.setMeta('uiEvent', 'paste'));
                };
                slice = (0, $ed7aabc7e8e09621$export$feb0d61bf65d9267)(state, slice);
                if ((0, $1oCLl.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true)) {
                    const destinationParentType = view.state.selection.$from.node(-1)?.type.name ?? view.state.doc.type.name;
                    slice = (0, $ed7aabc7e8e09621$export$ce2b3491c532dd9d)(slice, schema, destinationParentType);
                }
                slice = (0, $7bdd8b3011622662$export$d920fedcc56c4475)({
                    state: state,
                    slice: slice,
                    event: event,
                    text: text
                });
                if ((0, $iu6m9.editorExperiment)('platform_synced_block', true) || (0, $dh538.fg)('platform_synced_block_unsupported_products')) slice = (0, $009f23fcd155fb15$export$27da60ebda8ac583)(slice, schema, (0, $2ded4de594877764$export$e45b5b7458bacd81)(event), html, pasteWarningOptions, pluginInjectionApi);
                const plainTextPasteSlice = (0, $b0F8r.linkifyContent)(state.schema)(slice);
                if ((0, $077e6b5ad97baf3f$export$69d6e3902009956e)(editorAnalyticsAPI)(view, event, plainTextPasteSlice)(state, dispatch, view)) return true;
                if ((0, $077e6b5ad97baf3f$export$e1d2fb186881c383)(editorAnalyticsAPI)(view, event, slice, (0, $aSgIe.PasteTypes).richText)(state, dispatch)) // Create a custom handler to avoid handling with handleRichText method
                // As SafeInsert is used inside handleRichText which caused some bad UX like this:
                // https://product-fabric.atlassian.net/browse/MEX-1520
                // Converting caption to plain text needs to be handled before transformSliceForMedia
                // as createChecked will fail when trying to create a mediaSingle node with a caption
                // that is not plain text.
                return true;
                // transform slices based on destination
                slice = (0, $8ed707feaf00ea4f$export$5ed9534d355a0a0f)(slice, schema, pluginInjectionApi)(state.selection);
                let markdownSlice;
                if (isPlainText) {
                    markdownSlice = getMarkdownSlice(text, slice.openStart, slice.openEnd);
                    // https://product-fabric.atlassian.net/browse/ED-15134
                    // Lists are not allowed within Blockquotes at this time. Attempting to
                    // paste a markdown list ie. ">- foo" will yeild a markdownSlice of size 0.
                    // Rather then blocking the paste action with no UI feedback, this will instead
                    // force a "paste as plain text" action by clearing the markdownSlice.
                    markdownSlice = !markdownSlice?.size ? undefined : markdownSlice;
                    if (markdownSlice) {
                        // linkify text prior to converting to macro
                        if ((0, $077e6b5ad97baf3f$export$b36a7c9ea20b7bbf)(editorAnalyticsAPI)(view, event, markdownSlice, (0, $aSgIe.PasteTypes).markdown)(state, dispatch)) return true;
                        // run macro autoconvert prior to other conversions
                        if ((0, $ed7aabc7e8e09621$export$d23738992a74c3a9)(text, markdownSlice, pluginInjectionApi?.card?.actions?.queueCardsFromChangedTr, pluginInjectionApi?.extension?.actions?.runMacroAutoConvert, cardOptions, extensionAutoConverter)(state, dispatch, view)) {
                            // TODO: ED-26959 - handleMacroAutoConvert dispatch twice, so we can't use the helper
                            (0, $077e6b5ad97baf3f$export$5ee87eef0a304a1b)(editorAnalyticsAPI)(view, event, markdownSlice, {
                                type: (0, $aSgIe.PasteTypes).markdown
                            });
                            return true;
                        }
                    }
                }
                slice = (0, $2ded4de594877764$export$9ffea5586131a948)(slice, state, cardOptions);
                // Handles edge case so that when copying text from the top level of the document
                // it can be pasted into nodes like panels/actions/decisions without removing them.
                // Overriding openStart to be 1 when only pasting a paragraph makes the preferred
                // depth favour the text, rather than the paragraph node.
                // https://github.com/ProseMirror/prosemirror-transform/blob/master/src/replace.js#:~:text=Transform.prototype.-,replaceRange,-%3D%20function(from%2C%20to
                const selectionDepth = state.selection.$head.depth;
                const selectionParentNode = state.selection.$head.node(selectionDepth - 1);
                const selectionParentType = selectionParentNode?.type;
                const edgeCaseNodeTypes = [
                    schema.nodes?.panel,
                    schema.nodes?.taskList,
                    schema.nodes?.decisionList
                ];
                if (slice.openStart === 0 && slice.openEnd !== 1 && selectionParentNode && edgeCaseNodeTypes.includes(selectionParentType)) // @ts-ignore - [unblock prosemirror bump] assigning to readonly prop
                slice.openStart = 1;
                // If we're in a code block, append the text contents of clipboard inside it
                if ((0, $077e6b5ad97baf3f$export$9fea421173ba6d7d)(editorAnalyticsAPI)(view, event, slice, text)(state, dispatch)) return true;
                if ((0, $077e6b5ad97baf3f$export$b49fd82cf59cd44e)(editorAnalyticsAPI)(view, event, slice, isPastedFile ? (0, $aSgIe.PasteTypes).binary : (0, $aSgIe.PasteTypes).richText, pluginInjectionApi?.media?.actions.insertMediaAsMediaSingle)(state, dispatch, view)) return true;
                if ((0, $077e6b5ad97baf3f$export$6dbadac5ea22dd7a)(editorAnalyticsAPI)(view, event, slice)(state, dispatch)) return true;
                let isNestedMarkdownTable = false;
                // if paste a markdown table inside a table cell, we should treat it as a table slice
                const isParentNodeTdOrTh = selectionParentType === schema.nodes.tableCell || selectionParentType === schema.nodes.tableHeader;
                isNestedMarkdownTable = !!(markdownSlice && isPlainText && isParentNodeTdOrTh && (0, $077e6b5ad97baf3f$export$629ff5588e070c83)(markdownSlice.content).includes(schema.nodes.table?.name));
                slice = isNestedMarkdownTable ? markdownSlice : slice;
                // get editor-tables to handle pasting tables if it can
                // otherwise, just the replace the selection with the content
                if ((0, $dmcsV.handlePaste)(view, event, slice, {
                    pasteSource: (0, $2ded4de594877764$export$e45b5b7458bacd81)(event)
                })) {
                    (0, $077e6b5ad97baf3f$export$5ee87eef0a304a1b)(editorAnalyticsAPI)(view, event, slice, {
                        type: (0, $aSgIe.PasteTypes).richText
                    });
                    return true;
                }
                // handle paste of nested tables to ensure nesting limits are respected
                if ((0, $077e6b5ad97baf3f$export$7dc8d4c52517a2f7)(editorAnalyticsAPI, (0, $8EYIj.isNestedTablesSupported)(state.schema))(view, event, slice)(state, dispatch)) return true;
                if ((0, $077e6b5ad97baf3f$export$e3873690443e0966)(view, event, slice, isPlainText ? (0, $aSgIe.PasteTypes).plain : (0, $aSgIe.PasteTypes).richText, pluginInjectionApi)(state, dispatch)) return true;
                // If the clipboard only contains plain text, attempt to parse it as Markdown
                if (isPlainText && markdownSlice && !isNestedMarkdownTable) {
                    if ((0, $077e6b5ad97baf3f$export$ef36b80b79d1d973)(view, event, markdownSlice, (0, $aSgIe.PasteTypes).markdown, pluginInjectionApi)(state, dispatch)) return true;
                    return (0, $077e6b5ad97baf3f$export$d7489d309972091e)(view, event, markdownSlice, pluginInjectionApi)(state, dispatch);
                }
                if (isRichText && $4b9ed3b686e9ecfc$export$eedfdbc6a6bc1442(state)) {
                    //If pasting inside blockquote
                    //Skip the blockquote node and keep remaining nodes as they are
                    //prevent doing this if there is list inside blockquote as the list is pasted incorrectly inside blockquote due to wrong openStart and openEnd
                    const { blockquote: blockquote } = schema.nodes;
                    const children = [];
                    (0, $3Ter7.mapChildren)(slice.content, (node)=>{
                        if (node.type === blockquote && !(0, $8m4tT.contains)(node, state.schema.nodes.listItem)) for(let i = 0; i < node.childCount; i++)children.push(node.child(i));
                        else children.push(node);
                    });
                    slice = new (0, $5SAOw.Slice)((0, $5SAOw.Fragment).fromArray(children), slice.openStart, slice.openEnd);
                }
                // finally, handle rich-text copy-paste
                if (isRichText || isNestedMarkdownTable) {
                    // linkify the text where possible
                    slice = (0, $b0F8r.linkifyContent)(state.schema)(slice);
                    if ((0, $077e6b5ad97baf3f$export$b36a7c9ea20b7bbf)(editorAnalyticsAPI)(view, event, slice, (0, $aSgIe.PasteTypes).richText)(state, dispatch)) return true;
                    // run macro autoconvert prior to other conversions
                    if ((0, $ed7aabc7e8e09621$export$d23738992a74c3a9)(text, slice, pluginInjectionApi?.card?.actions?.queueCardsFromChangedTr, pluginInjectionApi?.extension?.actions?.runMacroAutoConvert, cardOptions, extensionAutoConverter)(state, dispatch, view)) {
                        // TODO: ED-26959 - handleMacroAutoConvert dispatch twice, so we can't use the helper
                        (0, $077e6b5ad97baf3f$export$5ee87eef0a304a1b)(editorAnalyticsAPI)(view, event, slice, {
                            type: (0, $aSgIe.PasteTypes).richText
                        });
                        return true;
                    }
                    // Special handling for SharePoint URLs generated from Share button
                    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
                    if ($4b9ed3b686e9ecfc$export$c503e2315ac846a7(text) && ((0, $dh538.fg)('platform_editor_sharepoint_url_smart_card_fallback') || (0, $dh538.fg)('platform_editor_sharepoint_url_smart_card_jira'))) {
                        // Create an inline card directly for SharePoint URLs to show the "Connect" button
                        const inlineCardNode = schema.nodes.inlineCard.create({
                            url: text
                        });
                        const cardSlice = new (0, $5SAOw.Slice)((0, $5SAOw.Fragment).from(inlineCardNode), 0, 0);
                        if (dispatch) dispatch(state.tr.replaceSelection(cardSlice));
                        return true;
                    }
                    // handle the case when copy content from a table cell inside bodied extension
                    if ((0, $ed7aabc7e8e09621$export$36e0fe2cadced224)(slice)(state, dispatch)) return true;
                    // remove annotation marks from the pasted data if they are not present in the document
                    // for the cases when they are pasted from external pages
                    if (slice.content.size && (0, $bYZ53.containsAnyAnnotations)(slice, state)) pluginInjectionApi?.annotation?.actions.stripNonExistingAnnotations(slice, state);
                    if ((0, $077e6b5ad97baf3f$export$ef36b80b79d1d973)(view, event, slice, (0, $aSgIe.PasteTypes).richText, pluginInjectionApi)(state, dispatch)) return true;
                    // Check that we are pasting in a location that does not accept
                    // breakout marks, if so we strip the mark and paste. Note that
                    // breakout marks are only valid in the root document.
                    if (selectionParentType !== state.schema.nodes.doc) {
                        const sliceCopy = (0, $5SAOw.Slice).fromJSON(state.schema, slice.toJSON() || {});
                        sliceCopy.content.descendants((node)=>{
                            // @ts-ignore - [unblock prosemirror bump] assigning to readonly prop
                            node.marks = node.marks.filter((mark)=>mark.type.name !== 'breakout');
                            // as breakout marks should only be on top level nodes,
                            // we don't traverse the entire document
                            return false;
                        });
                        slice = sliceCopy;
                    }
                    if ((0, $077e6b5ad97baf3f$export$6681e5bfb9c8b704)(editorAnalyticsAPI)(view, event, slice)(state, dispatch)) return true;
                    if (!(0, $4KOFJ.insideTable)(state)) slice = (0, $4Dk64.transformSliceNestedExpandToExpand)(slice, state.schema);
                    if ((0, $077e6b5ad97baf3f$export$2d195c5439ce2ebc)(editorAnalyticsAPI)(view, event, slice, pluginInjectionApi?.list?.actions.findRootParentListNode)(state, dispatch)) return true;
                    if ((0, $077e6b5ad97baf3f$export$bbc9709b7b4a2f6)(editorAnalyticsAPI)(view, event, slice)(state, dispatch)) return true;
                    return (0, $077e6b5ad97baf3f$export$3ef868f9e7157717)(view, event, slice, pluginInjectionApi)(state, dispatch);
                }
                return false;
            },
            transformPasted (slice) {
                if (sanitizePrivateContent) slice = (0, $ed7aabc7e8e09621$export$7097a0398467de9c)(slice, schema);
                /* Bitbucket copies diffs as multiple adjacent code blocks
         * so we merge ALL adjacent code blocks to support paste here */ if (pastedFromBitBucket) slice = (0, $92458d2ff9cd5d89$export$5a682e48ed34e262)(slice);
                // Filter out expand nodes if allowExpand is false
                if (!pluginInjectionApi?.expand?.sharedState?.currentState()?.allowInsertion && (0, $1oCLl.expValEquals)('platform_editor_expand_paste_in_comment_editor', 'isEnabled', true)) slice = (0, $ed7aabc7e8e09621$export$ce28e8ccb2f7a3dd)(slice);
                slice = (0, $cf580436a7489192$export$d1dc8019f50dded8)(slice, schema);
                slice = (0, $8ed707feaf00ea4f$export$bd95a8dd607682c8)(slice, schema);
                slice = (0, $8ed707feaf00ea4f$export$77944619eaa3fcd3)(slice, schema, pluginInjectionApi);
                slice = (0, $8eab6696b4592b34$export$65d21b4bef5d424b)(slice, schema);
                // splitting linebreaks into paragraphs must happen before upgrading text to lists
                slice = (0, $2e4406ece4085ab9$export$f2dc3112f5c2bd10)(slice, schema);
                slice = (0, $2e4406ece4085ab9$export$df231bdf1595dd19)(slice, schema);
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                if (slice.content.childCount && slice.content.lastChild.type === schema.nodes.codeBlock) slice = new (0, $5SAOw.Slice)(slice.content, 0, 0);
                if (!(0, $iu6m9.editorExperiment)('single_column_layouts', true)) slice = (0, $5FXvM.transformSingleColumnLayout)(slice, schema);
                slice = (0, $kqmjz.transformSliceToRemoveMacroId)(slice, schema);
                if ((0, $1oCLl.expValEquals)('platform_editor_flexible_list_schema', 'isEnabled', true) && !(0, $1oCLl.expValEquals)('platform_editor_flexible_list_indentation', 'isEnabled', true)) // Prevent pasted externally-authored flexible list HTML from producing flexible list structures
                // Only when schema support is enabled but indentation behaviour is not, meaning editor gracefully
                // handles the structure, but ideally does not produce it
                slice = (0, $iqEyW.transformSliceEnsureListItemParagraphFirst)(slice, schema);
                return slice;
            },
            transformPastedHTML (html) {
                // Fix for issue ED-4438
                // text from google docs should not be pasted as inline code
                if (html.indexOf('id="docs-internal-guid-') >= 0) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line require-unicode-regexp
                    html = html.replace(/white-space:pre/g, '');
                    // Ignored via go/ees005
                    // eslint-disable-next-line require-unicode-regexp
                    html = html.replace(/white-space:pre-wrap/g, '');
                }
                // Partial fix for ED-7331: During a copy/paste from the legacy tinyMCE
                // confluence editor, if we encounter an incomplete table (e.g. table elements
                // not wrapped in <table>), we try to rebuild a complete, valid table if possible.
                if (mostRecentPasteEvent && (0, $2ef111395dc72fc1$export$4a3cccc9bf9da386)(mostRecentPasteEvent, html) && (0, $2ef111395dc72fc1$export$120b137b77798e76)(html)) {
                    const completeTableHtml = (0, $2ef111395dc72fc1$export$253f7bda9f1e0696)(html);
                    if (completeTableHtml) html = completeTableHtml;
                }
                if (!(0, $2ded4de594877764$export$6ba9f527e53e4ac1)(html) && !(0, $2ded4de594877764$export$8d0b7622c89b176c)(html) && html.indexOf('<img ') >= 0) html = (0, $8ed707feaf00ea4f$export$3b69af3aaae9ee54)(html);
                // https://product-fabric.atlassian.net/browse/ED-11714
                // Checking for edge case when copying a list item containing links from Notion
                // The html from this case is invalid with duplicate nested links
                if ((0, $2ded4de594877764$export$3c3a613abe5bb97d)(html)) html = (0, $2ded4de594877764$export$35ca1bb0581efaf3)(html);
                // Fix for ED-13568: Code blocks being copied/pasted when next to each other get merged
                pastedFromBitBucket = html.indexOf('data-qa="code-line"') >= 0;
                // Remove breakout marks HTML around sync block renderer nodes
                // so the breakout mark doesn't get applied to the wrong nodes
                if (html.indexOf((0, $e6n00.SyncBlockRendererDataAttributeName)) >= 0 && (0, $iu6m9.editorExperiment)('platform_synced_block', true)) html = (0, $bfe611567370ae9a$export$2dccb54a894dbcd3)(html);
                // When platform_editor_nest_table_in_panel is OFF,
                // move tables out of panel divs in the HTML before ProseMirror
                // parses it — otherwise the panel schema drops the table content.
                if ((0, $1oCLl.expValEquals)('platform_editor_table_in_panel_paste_fallback', 'isEnabled', true) && !(0, $1oCLl.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true)) html = (0, $ed7aabc7e8e09621$export$f596ff5b0d9c556a)(html);
                mostRecentPasteEvent = null;
                return html;
            }
        }
    });
}











var $851fa09db89d6087$export$a5fa3822909c7e0 = /*#__PURE__*/ function(MoveAnalyticPluginTypes) {
    MoveAnalyticPluginTypes[MoveAnalyticPluginTypes["UpdateMovedAction"] = 0] = "UpdateMovedAction";
    MoveAnalyticPluginTypes[MoveAnalyticPluginTypes["RemoveMovedAction"] = 1] = "RemoveMovedAction";
    return MoveAnalyticPluginTypes;
}({});








const $3c17f3081d2a5df2$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('moveAnalyticsPlugin');



// For an event to be considered a move content event we want to ensure that
// cut had happened and was followed by paste. So our currentActions array should
// look like this ['contentCut', 'contentPasted'];
// After removing appendTransaction we don't update currentActions with 'contentPasted'
// but leaving it as array in case we decide to change it back or add 'contentCopied'.
const $a119ccceeb227772$export$49d5fc8cba920a0 = {
    contentMoved: {
        size: undefined,
        nodeDepth: undefined,
        currentActions: [],
        nodeTypes: undefined,
        hasSelectedMultipleNodes: undefined
    }
};


const $79a289149ab6d3b4$export$1650419e431d3ba3 = (state, action)=>{
    switch(action.type){
        case (0, $851fa09db89d6087$export$a5fa3822909c7e0).UpdateMovedAction:
            return {
                ...state,
                contentMoved: {
                    ...state.contentMoved,
                    ...action.data
                }
            };
        case (0, $851fa09db89d6087$export$a5fa3822909c7e0).RemoveMovedAction:
            return {
                ...state,
                contentMoved: (0, $a119ccceeb227772$export$49d5fc8cba920a0).contentMoved
            };
        default:
            return state;
    }
};


const $d821d7b8fbce6be3$var$dest = (0, $lkJUe.pluginFactory)((0, $3c17f3081d2a5df2$export$18d4026d1ea86bb1), (0, $79a289149ab6d3b4$export$1650419e431d3ba3));
const $d821d7b8fbce6be3$export$656c7661095efe2e = $d821d7b8fbce6be3$var$dest.createPluginState;
const $d821d7b8fbce6be3$export$8d4021544bdece00 = $d821d7b8fbce6be3$var$dest.createCommand;
const $d821d7b8fbce6be3$export$f05434c51e3762e = $d821d7b8fbce6be3$var$dest.getPluginState;



const $42b72b61ab9090c5$export$7c2867f48317a29d = (nextState, nextAction)=>(0, $d821d7b8fbce6be3$export$8d4021544bdece00)((state)=>{
        const { contentMoved: contentMoved } = (0, $d821d7b8fbce6be3$export$f05434c51e3762e)(state);
        const data = {
            currentActions: [
                ...contentMoved.currentActions,
                nextAction
            ],
            size: nextState?.size || contentMoved.size,
            nodeDepth: nextState?.nodeDepth,
            nodeTypes: nextState?.nodeTypes,
            hasSelectedMultipleNodes: nextState?.hasSelectedMultipleNodes
        };
        return {
            type: (0, $851fa09db89d6087$export$a5fa3822909c7e0).UpdateMovedAction,
            data: data
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $42b72b61ab9090c5$export$56834735aa39d3eb = ()=>(0, $d821d7b8fbce6be3$export$8d4021544bdece00)(()=>{
        return {
            type: (0, $851fa09db89d6087$export$a5fa3822909c7e0).RemoveMovedAction
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $42b72b61ab9090c5$export$47c45651eb91dff0 = ()=>(tr)=>{
        const payload = {
            type: (0, $851fa09db89d6087$export$a5fa3822909c7e0).RemoveMovedAction
        };
        return tr.setMeta((0, $3c17f3081d2a5df2$export$18d4026d1ea86bb1), payload);
    };









var $7XFGZ = parcelRequire("7XFGZ");




const $37420eab570e151a$var$excludedNodes = [
    'caption',
    'layoutColumn',
    'listItem',
    'tableHeader',
    'tableCell',
    'tableRow',
    'text',
    'placeholder',
    'unsupportedBlock',
    'unsupportedInline',
    'hardBreak',
    'confluenceUnsupportedBlock',
    'confluenceUnsupportedInline',
    'taskItem',
    'decisionItem'
];
const $37420eab570e151a$export$75248da1527ddfc1 = (nodeName)=>$37420eab570e151a$var$excludedNodes.includes(nodeName);
const $37420eab570e151a$export$14f96cade94e47c = (selection)=>{
    const { from: from, to: to, $from: $from } = selection;
    if (from !== to) return false;
    return $from.parentOffset === 0;
};
const $37420eab570e151a$var$inlineNodes = [
    'emoji',
    'date',
    'status',
    'mention',
    'mediaInline',
    'inlineCard',
    'inlineExtension'
];
const $37420eab570e151a$export$82ae59a0847ee78b = (nodeName)=>{
    return $37420eab570e151a$var$inlineNodes.includes(nodeName);
};
const $37420eab570e151a$export$8cd6af93b47990b9 = (selection)=>{
    if (selection.$from.depth !== 1) return true;
    // check if the node is a part of a larger paragraph or heading
    const parentSize = selection.$from.parent.content.size;
    const contentSize = selection.content().size;
    const parentChildCount = selection.$from.parent.childCount;
    // when the node was copied and pasted, it won't have extra space the parent has only one child
    if (parentChildCount === 1) return false;
    // some inline nodes (like date and emoji) when inserted have extra space that is stores as a child
    if (parentChildCount === 2 && parentSize - contentSize === 1) return false;
    return true;
};
const $37420eab570e151a$export$78b714f3f17d88b0 = (state)=>{
    const { schema: schema, selection: selection } = state;
    if (selection instanceof (0, $7XFGZ.CellSelection)) return false;
    const { table: table } = schema.nodes;
    const tableNode = (0, $8m4tT.findParentNodeOfTypeClosestToPos)(selection.$from, table);
    if (!tableNode) return false;
    return true;
};
const $37420eab570e151a$export$568289ef11d607ce = (selection)=>{
    const parentNode = (0, $8m4tT.findParentNodeClosestToPos)(selection.$from, ()=>true);
    if (!parentNode) return 0;
    return parentNode.node.type.name === 'heading' || parentNode.node.type.name === 'paragraph' ? parentNode.depth - 1 : parentNode.depth;
};
const $37420eab570e151a$export$b6cb43348b690a2d = (selection)=>{
    const { $from: $from, $to: $to } = selection;
    return $from.textOffset === 0 && $to.textOffset === 0;
};
const $37420eab570e151a$export$c4a09517c4982d7c = (content)=>{
    for(let i = 0; i < content.childCount; i++){
        const nodeName = content.maybeChild(i)?.type.name || '';
        if ($37420eab570e151a$export$75248da1527ddfc1(nodeName)) return true;
    }
    return false;
};
const $37420eab570e151a$export$f3a535d61fe1eda3 = (content)=>{
    const nodeTypes = [];
    if (content.size) content.forEach((node)=>{
        nodeTypes.push(node.type.name);
    });
    return {
        nodeTypes: (0, $dh538.fg)('platform_editor_track_node_types') ? [
            ...new Set(nodeTypes)
        ].sort().join(',') : undefined,
        hasSelectedMultipleNodes: nodeTypes.length > 1
    };
};


const $2456d0d62042635b$export$ae829ec7b2625219 = (dispatch, editorAnalyticsAPI)=>{
    // This variable is used to distinguish between copy and cut events in transformCopied.
    let isCutEvent = false;
    return new (0, $1S4f7.SafePlugin)({
        key: (0, $3c17f3081d2a5df2$export$18d4026d1ea86bb1),
        state: (0, $d821d7b8fbce6be3$export$656c7661095efe2e)(dispatch, (0, $a119ccceeb227772$export$49d5fc8cba920a0)),
        props: {
            handleDOMEvents: {
                cut: ()=>{
                    isCutEvent = true;
                }
            },
            handlePaste: ({ state: state, dispatch: dispatch }, _event, slice)=>{
                // The state was cleaned after previous paste. We don't need to update plugin state
                // with 'contentPasted' if currentActions array doesn't have 'copiedOrCut'.
                const { contentMoved: contentMoved } = (0, $d821d7b8fbce6be3$export$f05434c51e3762e)(state);
                const hasCutAction = contentMoved.currentActions.includes('contentCut');
                if (!hasCutAction) return;
                const { content: content } = slice;
                const nodeName = content.firstChild?.type.name;
                if (!nodeName || !contentMoved?.nodeTypes || !(0, $37420eab570e151a$export$14f96cade94e47c)(state.selection)) return;
                const { tr: tr } = state;
                editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: (0, $d925B.ACTION).MOVED,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
                    actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).NODE,
                    eventType: (0, $d925B.EVENT_TYPE).TRACK,
                    attributes: {
                        nodeDepth: contentMoved?.nodeDepth,
                        destinationNodeDepth: (0, $37420eab570e151a$export$568289ef11d607ce)(state.selection),
                        nodeTypes: contentMoved?.nodeTypes,
                        hasSelectedMultipleNodes: contentMoved?.hasSelectedMultipleNodes
                    }
                })(tr);
                // reset to default state
                const updatedTr = (0, $42b72b61ab9090c5$export$47c45651eb91dff0)()(tr);
                dispatch(updatedTr);
            },
            transformCopied: (slice, { state: state, dispatch: dispatch })=>{
                // We want to listen only to 'cut' events
                if (!isCutEvent) return slice;
                let resetState = false;
                const { content: content, size: size } = slice;
                const { selection: selection } = state;
                const isMultiSelectTrackingEnabled = (0, $dh538.fg)('platform_editor_track_node_types');
                const nodeName = content.firstChild?.type.name || '';
                let nodeTypes, hasSelectedMultipleNodes = false;
                if (content.childCount > 1) {
                    if (isMultiSelectTrackingEnabled) {
                        if ((0, $37420eab570e151a$export$c4a09517c4982d7c)(content)) resetState = true;
                        else {
                            const attributes = (0, $37420eab570e151a$export$f3a535d61fe1eda3)(content);
                            nodeTypes = attributes.nodeTypes;
                            hasSelectedMultipleNodes = attributes.hasSelectedMultipleNodes;
                        }
                    } else resetState = true;
                } else if (content.childCount === 1) {
                    // Some nodes are not relevant as they are parts of nodes, not whole nodes (like tableCell, tableHeader instead of table node)
                    // Some nodes like lists, taskList(item), decisionList(item) requires tricky checks that we want to avoid doing.
                    // These nodes were added to excludedNodes array.
                    if (!resetState && (0, $37420eab570e151a$export$75248da1527ddfc1)(nodeName)) resetState = true;
                    if (!resetState && !(0, $37420eab570e151a$export$b6cb43348b690a2d)(selection)) resetState = true;
                    if (!resetState && (0, $37420eab570e151a$export$82ae59a0847ee78b)(nodeName) && (0, $37420eab570e151a$export$8cd6af93b47990b9)(selection)) resetState = true;
                    if (!resetState && (0, $37420eab570e151a$export$78b714f3f17d88b0)(state)) resetState = true;
                } else resetState = true;
                if (resetState) (0, $42b72b61ab9090c5$export$56834735aa39d3eb)()(state, dispatch);
                else {
                    let newState = {
                        size: size,
                        nodeTypes: nodeTypes,
                        nodeDepth: (0, $37420eab570e151a$export$568289ef11d607ce)(selection)
                    };
                    if (isMultiSelectTrackingEnabled) newState = {
                        ...newState,
                        nodeTypes: nodeTypes ?? nodeName,
                        hasSelectedMultipleNodes: hasSelectedMultipleNodes
                    };
                    (0, $42b72b61ab9090c5$export$7c2867f48317a29d)(newState, 'contentCut')(state, dispatch);
                }
                isCutEvent = false;
                return slice;
            }
        }
    });
};







var $aXWIB = parcelRequire("aXWIB");


var $eiA8Z = parcelRequire("eiA8Z");


var $aD1SW = parcelRequire("aD1SW");

var $eCEXz = parcelRequire("eCEXz");

var $6uGcC = parcelRequire("6uGcC");


var $a3fRD = parcelRequire("a3fRD");


var $3sFtD = parcelRequire("3sFtD");


var $ebrpi = parcelRequire("ebrpi");




const $a8cd931d148ce0ed$export$48ea269755562084 = ({ api: api })=>{
    const { activeFlag: activeFlag } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'paste'
    ], (states)=>({
            activeFlag: states.pasteState?.activeFlag
        }));
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    if (!activeFlag) return;
    const { type: type, onDismissed: onDismissedCallback, description: flagDescription, title: flagTitle, urlText: flagUrlText, urlHref: flagUrlHref } = activeFlag;
    const description = flagDescription ? formatMessage(flagDescription) : undefined;
    const title = flagTitle ? formatMessage(flagTitle) : undefined;
    const urlText = flagUrlText ? formatMessage(flagUrlText) : undefined;
    const onDismissed = ()=>{
        api?.core.actions.execute(({ tr: tr })=>{
            onDismissedCallback?.(tr);
            const oldMeta = tr.getMeta((0, $6b91a48544104490$export$18d4026d1ea86bb1));
            tr.setMeta((0, $6b91a48544104490$export$18d4026d1ea86bb1), {
                ...oldMeta,
                type: (0, $d67f3be44268e218$export$ad3c0356f902fd97).SET_ACTIVE_FLAG,
                activeFlag: false
            });
            return tr;
        });
        api?.core.actions.focus();
    };
    const getActions = ()=>{
        const action = urlText && flagUrlHref ? {
            content: urlText,
            href: flagUrlHref
        } : undefined;
        if (action) return [
            {
                content: action.content,
                href: action.href,
                target: '_blank'
            }
        ];
        return undefined;
    };
    const getFlagComponent = ()=>{
        if (type === (0, $01f2ba065c56b221$export$5e592dcf077082fd).INFO || type === (0, $01f2ba065c56b221$export$5e592dcf077082fd).SUCCESS) return 0, $aD1SW.default;
        return 0, $eCEXz.default;
    };
    const FlagComponent = getFlagComponent();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6uGcC.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(FlagComponent, {
        onDismissed: onDismissed,
        title: title,
        description: description,
        id: activeFlag.id,
        testId: activeFlag.id,
        icon: $a8cd931d148ce0ed$var$typeToIcon(type),
        actions: getActions()
    }));
};
const $a8cd931d148ce0ed$var$typeToIcon = (type)=>{
    if (type === 'error') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
        label: "",
        color: "var(--ds-icon-danger, #C9372C)"
    });
    if (type === 'warning') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ebrpi))), {
        label: "",
        color: "var(--ds-icon-warning, #E06C00)"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
        label: "",
        color: "var(--ds-icon-success, #6A9A23)"
    });
};


const $68551712a2fbdc6a$export$2d7f4bd9c1268cd7 = ({ config: config, api: api })=>{
    const { cardOptions: cardOptions, sanitizePrivateContent: sanitizePrivateContent, isFullPage: isFullPage, pasteWarningOptions: pasteWarningOptions } = config ?? {};
    const featureFlags = api?.featureFlags?.sharedState.currentState() || {};
    const editorAnalyticsAPI = api?.analytics?.actions;
    return {
        name: 'paste',
        pmPlugins () {
            return [
                {
                    name: 'paste',
                    plugin: ({ schema: schema, providerFactory: providerFactory, dispatchAnalyticsEvent: dispatchAnalyticsEvent, dispatch: dispatch, getIntl: getIntl })=>(0, $4b9ed3b686e9ecfc$export$ae829ec7b2625219)(schema, dispatchAnalyticsEvent, dispatch, featureFlags, api, getIntl, cardOptions, sanitizePrivateContent, providerFactory, pasteWarningOptions)
                },
                {
                    name: 'moveAnalyticsPlugin',
                    plugin: ({ dispatch: dispatch })=>{
                        return isFullPage ? (0, $2456d0d62042635b$export$ae829ec7b2625219)(dispatch, editorAnalyticsAPI) : undefined;
                    }
                }
            ];
        },
        contentComponent: !(0, $iu6m9.editorExperiment)('platform_synced_block', true) && !(0, $dh538.fg)('platform_synced_block_unsupported_products') ? undefined : ()=>{
            if (!pasteWarningOptions) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a8cd931d148ce0ed$export$48ea269755562084), {
                api: api
            });
        },
        getSharedState: (editorState)=>{
            if (!editorState) return {
                activeFlag: null,
                lastContentPasted: null
            };
            const pluginState = (0, $6b91a48544104490$export$18d4026d1ea86bb1).getState(editorState);
            return {
                activeFlag: pluginState.activeFlag,
                lastContentPasted: pluginState.lastContentPasted
            };
        }
    };
};
module.exports["pastePlugin"] = $68551712a2fbdc6a$export$2d7f4bd9c1268cd7;

});

parcelRegister("aSgIe", function(module, exports) {
const $ab6f2be4f9d1d9f9$export$2ba12a8680458b1e = {
    richText: 'richText',
    plain: 'plain',
    markdown: 'markdown',
    binary: 'binary'
};
const $ab6f2be4f9d1d9f9$export$602c33ed77663fbf = {
    fabricEditor: 'fabric-editor',
    applePages: 'apple-pages',
    googleSpreadsheets: 'google-spreadsheets',
    googleDocs: 'google-docs',
    microsoftExcel: 'microsoft-excel',
    microsoftWord: 'microsoft-word',
    dropboxPaper: 'dropbox-paper',
    uncategorized: 'uncategorized'
};
const $ab6f2be4f9d1d9f9$export$a82556f999b47168 = {
    text: 'text',
    url: 'url',
    code: 'code',
    mediaSingle: 'mediaSingle',
    mediaCard: 'mediaCard',
    mediaGroup: 'mediaGroup',
    tableCells: 'tableCells',
    table: 'table',
    expand: 'expand',
    nestedExpand: 'nestedExpand',
    mixed: 'mixed',
    blockquote: 'blockquote',
    blockCard: 'blockCard',
    bodiedExtension: 'bodiedExtension',
    multiBodiedExtension: 'multiBodiedExtension',
    bulletList: 'bulletList',
    codeBlock: 'codeBlock',
    decisionList: 'decisionList',
    decisionItem: 'decisionItem',
    extension: 'extension',
    heading: 'heading',
    layoutSection: 'layoutSection',
    orderedList: 'orderedList',
    panel: 'panel',
    rule: 'rule',
    tableHeader: 'tableHeader',
    tableRow: 'tableRow',
    taskItem: 'taskItem',
    uncategorized: 'uncategorized'
};
module.exports["PasteTypes"] = $ab6f2be4f9d1d9f9$export$2ba12a8680458b1e;
module.exports["PasteContents"] = $ab6f2be4f9d1d9f9$export$a82556f999b47168;

});

parcelRegister("4KOFJ", function(module, exports) {

var $8m4tT = parcelRequire("8m4tT");

const $ef4320de738b4ace$export$244bf4b32387ef62 = (state)=>{
    const { table: table, tableCell: tableCell } = state.schema.nodes;
    return (0, $8m4tT.hasParentNodeOfType)([
        table,
        tableCell
    ])(state.selection);
};
module.exports["insideTable"] = $ef4320de738b4ace$export$244bf4b32387ef62;

});

parcelRegister("8gdgt", function(module, exports) {

var $9cWZh = parcelRequire("9cWZh");

function $09ec4a237b874471$export$30c8e5e50a78a591(rawEvent) {
    const { clipboardData: clipboardData } = rawEvent;
    if (!clipboardData) return false;
    return (0, $9cWZh.checkClipboardTypes)(clipboardData.types, 'Files');
}
module.exports["isPastedFile"] = $09ec4a237b874471$export$30c8e5e50a78a591;

});

parcelRegister("jvA0K", function(module, exports) {
// File has been copied to packages/editor/editor-plugin-ai/src/provider/markdown-transformer/md/index.ts
// If changes are made to this file, please make the same update in the linked file.

var $2Yzoe = parcelRequire("2Yzoe");

/*
 * ED-15646
 * Headings in list items are not supported in our schema.
 * As the markdown transformer is used by the paste plugin,
 * certain pastes will strip invalid lines as
 * prosemirror-markdown cannot conform to the schema
 */ function $100d092373d62a5b$var$handleHeadingOpen(state, token, acc, index) {
    const isInListItem = state.tokens[index - 1]?.type === 'list_item_open';
    if (isInListItem) acc.push(new state.Token('paragraph_open', 'p', 1));
    else acc.push(token);
}
function $100d092373d62a5b$var$handleHeadingClose(state, token, acc, index) {
    const isInListItem = state.tokens[index + 1]?.type === 'list_item_close';
    if (isInListItem) acc.push(new state.Token('paragraph_close', 'p', -1));
    else acc.push(token);
}
function $100d092373d62a5b$export$2e2bcd8739ae039(md) {
    md.core.ruler.after('inline', 'ignore-list-heading-md-plugin', function(state) {
        state.tokens = state.tokens.reduce((acc, token, index)=>{
            const { type: type } = token;
            if (type === 'heading_open') $100d092373d62a5b$var$handleHeadingOpen(state, token, acc, index);
            else if (type === 'heading_close') $100d092373d62a5b$var$handleHeadingClose(state, token, acc, index);
            else acc.push(token);
            return acc;
        }, []);
    });
}


// File has been copied to packages/editor/editor-plugin-ai/src/provider/markdown-transformer/md/linkify-md-plugin.ts
// If changes are made to this file, please make the same update in the linked file.
// See https://product-fabric.atlassian.net/browse/ED-3097 for why this file exists.

var $2Gb84 = parcelRequire("2Gb84");


var $81OAa = parcelRequire("81OAa");


var $b0F8r = parcelRequire("b0F8r");

var $azNN5 = parcelRequire("azNN5");

// modified version of the original markdown-it Linkify plugin
// https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/linkify.js
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $90ed793ac8ade1ce$var$arrayReplaceAt = (src, pos, newElements)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return [].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
};
const $90ed793ac8ade1ce$var$isLinkOpen = (str)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return /^<a[>\s]/i.test(str);
};
const $90ed793ac8ade1ce$var$isLinkClose = (str)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return /^<\/a\s*>/i.test(str);
};
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $90ed793ac8ade1ce$var$linkify = (state)=>{
    const blockTokens = state.tokens;
    const linkify = new (0, (/*@__PURE__*/$parcel$interopDefault($2Gb84)))();
    for(let j = 0, l = blockTokens.length; j < l; j++){
        if (blockTokens[j].type !== 'inline' || !linkify.pretest(blockTokens[j].content)) continue;
        let tokens = blockTokens[j].children;
        let htmlLinkLevel = 0;
        // We scan from the end, to keep position when new tags added.
        // Use reversed logic in links start/end match
        for(let i = tokens.length - 1; i >= 0; i--){
            const currentToken = tokens[i];
            // Skip content of markdown links
            if (currentToken.type === 'link_close') {
                i--;
                while(tokens[i].level !== currentToken.level && tokens[i].type !== 'link_open')i--;
                continue;
            }
            // Skip content of html tag links
            if (currentToken.type === 'html_inline') {
                if ($90ed793ac8ade1ce$var$isLinkOpen(currentToken.content) && htmlLinkLevel > 0) htmlLinkLevel--;
                if ($90ed793ac8ade1ce$var$isLinkClose(currentToken.content)) htmlLinkLevel++;
            }
            if (htmlLinkLevel > 0) continue;
            if (currentToken.type === 'text' && linkify.test(currentToken.content)) {
                const text = currentToken.content;
                let links = (0, $81OAa.linkifyMatch)(text);
                if (!links.length) links = linkify.match(text) || [];
                links = links.filter((link)=>(0, $azNN5.shouldAutoLinkifyMatch)(link));
                // Now split string to nodes
                const nodes = [];
                let level = currentToken.level;
                let lastPos = 0;
                const filepaths = (0, $b0F8r.findFilepaths)(text);
                for(let ln = 0; ln < links.length; ln++){
                    if ((0, $b0F8r.isLinkInMatches)(links[ln].index, filepaths)) continue;
                    const { url: url } = links[ln];
                    const fullUrl = state.md.normalizeLink(url);
                    if (!state.md.validateLink(fullUrl)) continue;
                    let urlText = links[ln].text;
                    // Linkifier might send raw hostnames like "example.com", where url
                    // starts with domain name. So we prepend http:// in those cases,
                    // and remove it afterwards.
                    //
                    if (!links[ln].schema) // Ignored via go/ees005
                    // eslint-disable-next-line require-unicode-regexp, @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
                    urlText = state.md.normalizeLinkText('http://' + urlText).replace(/^http:\/\//, '');
                    else if (links[ln].schema === 'mailto:' && !/^mailto:/i.test(urlText)) // Ignored via go/ees005
                    // eslint-disable-next-line require-unicode-regexp, @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
                    urlText = state.md.normalizeLinkText('mailto:' + urlText).replace(/^mailto:/, '');
                    else urlText = state.md.normalizeLinkText(urlText);
                    const pos = links[ln].index;
                    if (pos > lastPos) {
                        const token = new state.Token('text', '', 0);
                        token.content = text.slice(lastPos, pos);
                        token.level = level;
                        nodes.push(token);
                    }
                    let token = new state.Token('link_open', 'a', 1);
                    token.attrs = [
                        [
                            'href',
                            fullUrl
                        ]
                    ];
                    token.level = level++;
                    token.markup = 'linkify';
                    token.info = 'auto';
                    nodes.push(token);
                    token = new state.Token('text', '', 0);
                    token.content = urlText;
                    token.level = level;
                    nodes.push(token);
                    token = new state.Token('link_close', 'a', -1);
                    token.level = --level;
                    token.markup = 'linkify';
                    token.info = 'auto';
                    nodes.push(token);
                    lastPos = links[ln].lastIndex;
                }
                if (lastPos < text.length) {
                    const token = new state.Token('text', '', 0);
                    token.content = text.slice(lastPos);
                    token.level = level;
                    nodes.push(token);
                }
                // replace current node
                blockTokens[j].children = tokens = $90ed793ac8ade1ce$var$arrayReplaceAt(tokens, i, nodes);
            }
        }
    }
};
var // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$90ed793ac8ade1ce$export$2e2bcd8739ae039 = (md)=>md.core.ruler.push('custom-linkify', $90ed793ac8ade1ce$var$linkify);


// File has been copied to packages/editor/editor-plugin-ai/src/provider/markdown-transformer/md/newline-md-plugin.ts
// If changes are made to this file, please make the same update in the linked file.
// ED-15363: modified version of the original newline plugin
// https://github.com/markdown-it/markdown-it/blob/master/lib/rules_inline/newline.js
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $067f1cd35c6763e5$var$newline = (state, silent)=>{
    let pos = state.pos;
    // ED-15363: unread variables
    // max,
    // ws,
    if (state.src.charCodeAt(pos) !== 0x0a /* \n */ ) return false;
    const pmax = state.pending.length - 1;
    // ED-15363: unread variable
    // max = state.posMax;
    // '  \n' -> hardbreak
    // Lookup in pending chars is bad practice! Don't copy to other rules!
    // Pending string is stored in concat mode, indexed lookups will cause
    // convertion to flat mode.
    if (!silent) {
        if (pmax >= 0 && state.pending.charCodeAt(pmax) === 0x20) {
            if (pmax >= 1 && state.pending.charCodeAt(pmax - 1) === 0x20) // ED-15363: We commented out this logic to preserve trailing whitespaces
            // for each line of text when pasting plain text
            // // Find whitespaces tail of pending chars.
            // ws = pmax - 1;
            // while (ws >= 1 && state.pending.charCodeAt(ws - 1) === 0x20) {
            //   ws--;
            // }
            // state.pending = state.pending.slice(0, ws);
            state.push('hardbreak', 'br', 0);
            else {
                state.pending = state.pending.slice(0, -1);
                state.push('softbreak', 'br', 0);
            }
        } else state.push('softbreak', 'br', 0);
    }
    pos++;
    // ED-15363: We commented out this logic from the original library to
    // preserve leading whitespaces for each line of text when pasting plain
    // text (to preserve whitespace-based indentation).
    // // skip heading spaces for next line
    // while (pos < max && isSpace(state.src.charCodeAt(pos))) {
    //   pos++;
    // }
    state.pos = pos;
    return true;
};
var // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$067f1cd35c6763e5$export$2e2bcd8739ae039 = (md)=>md.inline.ruler.at('newline', $067f1cd35c6763e5$var$newline);


// File has been copied to packages/editor/editor-plugin-ai/src/provider/markdown-transformer/md/paragraph-md-plugin.ts
// If changes are made to this file, please make the same update in the linked file.
// ED-15363: modified version of the original paragraph plugin
// https://github.com/markdown-it/markdown-it/blob/master/lib/rules_block/paragraph.js
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $0bf22cd21976f1c0$var$paragraph = (state, startLine /*, endLine*/ )=>{
    let terminate, i, l, token, nextLine = startLine + 1;
    const terminatorRules = state.md.block.ruler.getRules('paragraph');
    const endLine = state.lineMax;
    const oldParentType = state.parentType;
    state.parentType = 'paragraph';
    // jump line-by-line until empty one or EOF
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    // ED-15363: We removed .trim() from this logic from the original library to
    // preserve leading whitespaces at the beginning and end of paragraph blocks
    // when pasting plain text (to preserve whitespace-based indentation, at the
    // beginning and end of paragraphs).
    // content = state.getLines(startLine, nextLine, state.blkIndent, false) .trim()
    const content = state.getLines(startLine, nextLine, state.blkIndent, false);
    state.line = nextLine;
    token = state.push('paragraph_open', 'p', 1);
    token.map = [
        startLine,
        state.line
    ];
    token = state.push('inline', '', 0);
    token.content = content;
    token.map = [
        startLine,
        state.line
    ];
    token.children = [];
    token = state.push('paragraph_close', 'p', -1);
    state.parentType = oldParentType;
    return true;
};
var // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$0bf22cd21976f1c0$export$2e2bcd8739ae039 = (md)=>md.block.ruler.at('paragraph', $0bf22cd21976f1c0$var$paragraph);


const $4613d073487a1d72$export$f4de1c043ce6927 = (0, (/*@__PURE__*/$parcel$interopDefault($2Yzoe)))('zero', {
    html: false
});
$4613d073487a1d72$export$f4de1c043ce6927.enable([
    // Process html entity - &#123;, &#xAF;, &quot;, ...
    'entity',
    // Process escaped chars and hardbreaks
    'escape',
    'newline'
]);
$4613d073487a1d72$export$f4de1c043ce6927.use((0, $0bf22cd21976f1c0$export$2e2bcd8739ae039));
// enable modified version of linkify plugin
// @see https://product-fabric.atlassian.net/browse/ED-3097
$4613d073487a1d72$export$f4de1c043ce6927.use((0, $90ed793ac8ade1ce$export$2e2bcd8739ae039));
$4613d073487a1d72$export$f4de1c043ce6927.use((0, $067f1cd35c6763e5$export$2e2bcd8739ae039));
$4613d073487a1d72$export$f4de1c043ce6927.use((0, $100d092373d62a5b$export$2e2bcd8739ae039));
module.exports["md"] = $4613d073487a1d72$export$f4de1c043ce6927;

});

parcelRegister("ly3wu", function(module, exports) {
const $fe361930a2595c94$export$c21a3b023fccd534 = {
    BREAKOUT_MARK: 'fabric-editor-breakout-mark',
    BREAKOUT_MARK_DOM: 'fabric-editor-breakout-mark-dom'
};
module.exports["BreakoutCssClassName"] = $fe361930a2595c94$export$c21a3b023fccd534;

});

parcelRegister("5FXvM", function(module, exports) {

var $5SAOw = parcelRequire("5SAOw");

const $f98390851e6c385f$export$ca45027befc3fad2 = (slice, schema)=>{
    if (slice.content.childCount === 1 && slice.openStart === 0 && slice.openEnd === 0) {
        if (slice.content.firstChild?.type === schema.nodes.layoutColumn) {
            const newSlice = new (0, $5SAOw.Slice)(slice.content.firstChild.content, 0, 0);
            return newSlice;
        } else if (slice.content.firstChild?.type === schema.nodes.layoutSection && slice.content.firstChild.childCount === 1 && slice.content.firstChild.firstChild?.type === schema.nodes.layoutColumn) {
            const newSlice = new (0, $5SAOw.Slice)(slice.content.firstChild.firstChild.content, 0, 0);
            return newSlice;
        }
    }
    return slice;
};
module.exports["transformSingleColumnLayout"] = $f98390851e6c385f$export$ca45027befc3fad2;

});

parcelRegister("iqEyW", function(module, exports) {

var $5SAOw = parcelRequire("5SAOw");


var $3Ter7 = parcelRequire("3Ter7");

const $7d2cb35b22132d9f$export$f19e2607443a4dd2 = (slice, schema)=>{
    const { listItem: listItem, paragraph: paragraph } = schema.nodes;
    if (!listItem || !paragraph) return slice;
    return (0, $3Ter7.mapSlice)(slice, (node)=>{
        if (node.type === listItem) {
            const firstChild = node.firstChild;
            if (firstChild && firstChild.type !== paragraph) {
                const emptyParagraph = paragraph.createAndFill();
                if (emptyParagraph) {
                    const children = [
                        emptyParagraph
                    ];
                    for(let i = 0; i < node.childCount; i++)children.push(node.child(i));
                    return node.copy((0, $5SAOw.Fragment).from(children));
                }
            }
        }
        return node;
    });
};
module.exports["transformSliceEnsureListItemParagraphFirst"] = $7d2cb35b22132d9f$export$f19e2607443a4dd2;

});

parcelRegister("4Dk64", function(module, exports) {

var $5SAOw = parcelRequire("5SAOw");


var $3Ter7 = parcelRequire("3Ter7");

const $e0589ed9603c4051$export$fd33fafbf6b5abc7 = (slice, schema)=>{
    const { expand: expand, nestedExpand: nestedExpand } = schema.nodes;
    const children = [];
    (0, $3Ter7.mapChildren)(slice.content, (node)=>{
        if (node.type === nestedExpand) children.push(expand.createChecked(node.attrs, node.content, node.marks));
        else children.push(node);
    });
    return new (0, $5SAOw.Slice)((0, $5SAOw.Fragment).fromArray(children), slice.openStart, slice.openEnd);
};
module.exports["transformSliceNestedExpandToExpand"] = $e0589ed9603c4051$export$fd33fafbf6b5abc7;

});

parcelRegister("igNsz", function(module, exports) {

var $fO7hX = parcelRequire("fO7hX");


var $5SAOw = parcelRequire("5SAOw");


var $3Ter7 = parcelRequire("3Ter7");


const $3f0e740e896fc264$export$c50f82e6f2cff97d = (slice, schema)=>{
    const { bodiedExtension: bodiedExtension } = schema.nodes;
    const fragment = (0, $3Ter7.mapFragment)(slice.content, (node, parent, index)=>{
        if (node.type === bodiedExtension && !parent) {
            const currentNodeIsAtStartAndIsOpen = slice.openStart && index === 0;
            const currentNodeIsAtEndAndIsOpen = slice.openEnd && index + 1 === slice.content.childCount;
            if (currentNodeIsAtStartAndIsOpen || currentNodeIsAtEndAndIsOpen) return node.content;
        }
        return node;
    });
    // If the first/last child has changed - then we know we've removed a bodied extension & to decrement the open depth
    return new (0, $5SAOw.Slice)(fragment, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    fragment.firstChild && fragment.firstChild.type !== slice.content.firstChild.type ? slice.openStart - 1 : slice.openStart, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    fragment.lastChild && fragment.lastChild.type !== slice.content.lastChild.type ? slice.openEnd - 1 : slice.openEnd);
};
const $3f0e740e896fc264$export$d2a1206296dcfa47 = (slice, schema)=>{
    const { multiBodiedExtension: multiBodiedExtension, extensionFrame: extensionFrame } = schema.nodes;
    let depthToReduce = 2; // Removing MBE and extensionFrame
    // Edge case where the slice does not contain extensionFrames under MBE, happens when multiple block nodes get copied from a frame
    if (slice.content.firstChild?.type === multiBodiedExtension && slice.content.firstChild?.firstChild?.type !== extensionFrame) depthToReduce = 1;
    const fragment = (0, $3Ter7.mapFragment)(slice.content, (node, parent, index)=>{
        if (node.type === multiBodiedExtension && !parent || node.type === extensionFrame) {
            const currentNodeIsAtStartAndIsOpen = slice.openStart >= depthToReduce && index === 0;
            const currentNodeIsAtEndAndIsOpen = slice.openEnd >= depthToReduce && index + 1 === slice.content.childCount;
            if (currentNodeIsAtStartAndIsOpen || currentNodeIsAtEndAndIsOpen) return node.content;
        }
        if (node.type === multiBodiedExtension) /* While pasting on the same page, macroId does not change until the page is published and causes collision with the existing macroId
			 *  where switching tabs of one node changes the tabs for the other node, so we put a random macroId at paste to avoid collision
			 */ {
            if (node.attrs.parameters?.macroMetadata?.macroId?.value) node.attrs.parameters.macroMetadata.macroId.value = (0, $fO7hX.uuid).generate();
        }
        return node;
    });
    // If the first/last child has changed - then we know we've removed MBE and extensionFrame and need to decrement the open depth
    return new (0, $5SAOw.Slice)(fragment, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    fragment.firstChild && fragment.firstChild.type !== slice.content.firstChild.type ? slice.openStart - depthToReduce : slice.openStart, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    fragment.lastChild && fragment.lastChild.type !== slice.content.lastChild.type ? slice.openEnd - depthToReduce : slice.openEnd);
};
const $3f0e740e896fc264$var$LEGACY_CONTENT_MACRO_EXTENSION_TYPE = 'com.atlassian.confluence.migration', $3f0e740e896fc264$var$LEGACY_CONTENT_MACRO_EXTENSION_KEY = 'legacy-content';
const $3f0e740e896fc264$var$isLegacyContentMacroExtension = (extensionNode)=>extensionNode.attrs?.extensionType === $3f0e740e896fc264$var$LEGACY_CONTENT_MACRO_EXTENSION_TYPE && extensionNode.attrs?.extensionKey === $3f0e740e896fc264$var$LEGACY_CONTENT_MACRO_EXTENSION_KEY;
const $3f0e740e896fc264$export$23ce34395aea8526 = (slice, schema)=>{
    const { extension: extension } = schema.nodes;
    return (0, $3Ter7.mapSlice)(slice, (node)=>{
        if (node.type === extension && $3f0e740e896fc264$var$isLegacyContentMacroExtension(node)) // Strip the node
        return null;
        return node;
    });
};
module.exports["transformSliceToRemoveOpenBodiedExtension"] = $3f0e740e896fc264$export$c50f82e6f2cff97d;
module.exports["transformSliceToRemoveOpenMultiBodiedExtension"] = $3f0e740e896fc264$export$d2a1206296dcfa47;
module.exports["transformSliceToRemoveLegacyContentMacro"] = $3f0e740e896fc264$export$23ce34395aea8526;

});

parcelRegister("dmcsV", function(module, exports) {

var $5SAOw = parcelRequire("5SAOw");


var $8m4tT = parcelRequire("8m4tT");


var $dh538 = parcelRequire("dh538");


var $7XFGZ = parcelRequire("7XFGZ");


var $LmqWp = parcelRequire("LmqWp");


var $bzgWU = parcelRequire("bzgWU");


var $d1kIV = parcelRequire("d1kIV");


var $bMyNT = parcelRequire("bMyNT");

// Utilities used for copy/paste handling.
//
// This module handles pasting cell content into tables, or pasting
// anything into a cell selection, as replacing a block of cells with
// the content of the selection. When pasting cells into a cell, that
// involves placing the block of pasted content so that its top left
// aligns with the selection cell, optionally extending the table to
// the right or bottom to make sure it is large enough. Pasting into a
// cell selection is different, here the cells in the selection are
// clipped to the selection's rectangle, optionally repeating the
// pasted cells when they are smaller than the selection.




var $aXG5V = parcelRequire("aXG5V");








var $jl382 = parcelRequire("jl382");


var $2QyFu = parcelRequire("2QyFu");





var $2vynv = parcelRequire("2vynv");

// Utilities to help with copying and pasting table cells
/**
 * Replace any header cells with table cells.
 *
 * @param schema
 * @param cells
 * @returns Fragment with header cells converted to table cells
 */ function $89abb14886e23b87$var$stripHeaderType(schema, cells) {
    const newCells = [];
    cells.forEach((cell)=>{
        // Convert to cell type if not already
        const cellNodeType = (0, $d1kIV.tableNodeTypes)(schema).cell;
        const tableCell = cell.type === cellNodeType ? cell : cellNodeType.createAndFill(cell.attrs, cell.content, cell.marks) ?? cell;
        newCells.push(tableCell);
    });
    return (0, $5SAOw.Fragment).from(newCells);
}
function $89abb14886e23b87$export$f6d8f52489457fc4(slice) {
    if (!slice.size) return null;
    let { content: content, openStart: openStart, openEnd: openEnd } = slice;
    if (!content.firstChild) throw new Error('pastedCells: no firstChild defined for content');
    while(content.childCount === 1 && (openStart > 0 && openEnd > 0 || content.firstChild.type.spec.tableRole === 'table')){
        openStart--;
        openEnd--;
        content = content.firstChild.content;
        if (!content.firstChild) throw new Error('pastedCells: no firstChild defined for content');
    }
    const first = content.firstChild;
    const role = first.type.spec.tableRole;
    const { schema: schema } = first.type;
    const rows = [];
    if (role === 'row') for(let i = 0; i < content.childCount; i++){
        let cells = content.child(i).content;
        const left = i ? 0 : Math.max(0, openStart - 1);
        const right = i < content.childCount - 1 ? 0 : Math.max(0, openEnd - 1);
        if (left || right) cells = $89abb14886e23b87$export$f09c6b3b06d884fb((0, $d1kIV.tableNodeTypes)(schema).row, new (0, $5SAOw.Slice)(cells, left, right)).content;
        rows.push(cells);
    }
    else if (role === 'cell' || role === 'header_cell') rows.push(openStart || openEnd ? $89abb14886e23b87$export$f09c6b3b06d884fb((0, $d1kIV.tableNodeTypes)(schema).row, new (0, $5SAOw.Slice)(content, openStart, openEnd)).content : content);
    else return null;
    const rowsWithoutHeaders = rows.map((row)=>$89abb14886e23b87$var$stripHeaderType(schema, row));
    return $89abb14886e23b87$var$ensureRectangular(schema, rowsWithoutHeaders);
}
// : (Schema, [Fragment]) → {width: number, height: number, rows: [Fragment]}
// Compute the width and height of a set of cells, and make sure each
// row has the same number of cells.
function $89abb14886e23b87$var$ensureRectangular(schema, rowsFragment) {
    const rows = rowsFragment;
    const widths = [];
    for(let i = 0; i < rows.length; i++){
        const row = rows[i];
        for(let j = row.childCount - 1; j >= 0; j--){
            const { rowspan: rowspan, colspan: colspan } = row.child(j).attrs;
            for(let r = i; r < i + rowspan; r++)widths[r] = (widths[r] || 0) + colspan;
        }
    }
    let width = 0;
    for(let r = 0; r < widths.length; r++)width = Math.max(width, widths[r]);
    for(let r = 0; r < widths.length; r++){
        if (r >= rows.length) rows.push((0, $5SAOw.Fragment).empty);
        if (widths[r] < width) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const empty = (0, $d1kIV.tableNodeTypes)(schema).cell.createAndFill();
            const cells = [];
            for(let i = widths[r]; i < width; i++)cells.push(empty);
            rows[r] = rows[r].append((0, $5SAOw.Fragment).from(cells));
        }
    }
    return {
        height: rows.length,
        width: width,
        rows: rows
    };
}
function $89abb14886e23b87$export$f09c6b3b06d884fb(nodeType, slice) {
    const node = nodeType.createAndFill();
    if (!node) throw new Error(`fitSlice: unable to create node`);
    const tr = new (0, $aXG5V.Transform)(node).replace(0, node.content.size, slice);
    return tr.doc;
}
function $89abb14886e23b87$export$cdcebd68073bc3f({ width: currentWidth, height: currentHeight, rows: currentRows }, newWidth, newHeight) {
    let rows = currentRows;
    let width = currentWidth;
    let height = currentHeight;
    if (width !== newWidth) {
        const added = [];
        const newRows = [];
        for(let row = 0; row < rows.length; row++){
            const frag = rows[row];
            const cells = [];
            for(let col = added[row] || 0, i = 0; col < newWidth; i++){
                let cell = frag.child(i % frag.childCount);
                if (col + cell.attrs.colspan > newWidth) cell = cell.type.create((0, $jl382.removeColSpan)(cell.attrs, cell.attrs.colspan, col + cell.attrs.colspan - newWidth), cell.content);
                cells.push(cell);
                col += cell.attrs.colspan;
                for(let j = 1; j < cell.attrs.rowspan; j++)added[row + j] = (added[row + j] || 0) + cell.attrs.colspan;
            }
            newRows.push((0, $5SAOw.Fragment).from(cells));
        }
        rows = newRows;
        width = newWidth;
    }
    if (height !== newHeight) {
        const newRows = [];
        for(let row = 0, i = 0; row < newHeight; row++, i++){
            const cells = [];
            const source = rows[i % height];
            for(let j = 0; j < source.childCount; j++){
                let cell = source.child(j);
                if (row + cell.attrs.rowspan > newHeight) cell = cell.type.create({
                    ...cell.attrs,
                    rowspan: Math.max(1, newHeight - cell.attrs.rowspan)
                }, cell.content);
                cells.push(cell);
            }
            newRows.push((0, $5SAOw.Fragment).from(cells));
        }
        rows = newRows;
        height = newHeight;
    }
    return {
        width: width,
        height: height,
        rows: rows
    };
}
// Make sure a table has at least the given width and height. Return
// true if something was changed.
function $89abb14886e23b87$var$growTable(tr, map, table, start, width, height, mapFrom) {
    const { schema: schema } = tr.doc.type;
    const types = (0, $d1kIV.tableNodeTypes)(schema);
    let empty;
    let emptyHead;
    if (width > map.width) for(let row = 0, rowEnd = 0; row < map.height; row++){
        const rowNode = table.child(row);
        rowEnd += rowNode.nodeSize;
        const cells = [];
        let add;
        if (rowNode.lastChild == null || rowNode.lastChild.type === types.cell) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        add = empty || (empty = types.cell.createAndFill());
        else // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        add = emptyHead || (emptyHead = types.header_cell.createAndFill());
        for(let i = map.width; i < width; i++)cells.push(add);
        tr.insert(tr.mapping.slice(mapFrom).map(rowEnd - 1 + start), cells);
    }
    if (height > map.height) {
        const cells = [];
        for(let i = 0, k = (map.height - 1) * map.width; i < Math.max(map.width, width); i++){
            let header;
            if (i >= map.width) header = false;
            else {
                const mappedPos = map.map[k + i];
                const node = table.nodeAt(mappedPos);
                if (!node) throw new Error(`growTable: no node found at pos ${mappedPos}`);
                header = node.type === types.header_cell;
            }
            cells.push(header ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            emptyHead || (emptyHead = types.header_cell.createAndFill()) : // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            empty || (empty = types.cell.createAndFill()));
        }
        const emptyRow = types.row.create(null, (0, $5SAOw.Fragment).from(cells));
        const rows = [];
        for(let i = map.height; i < height; i++)rows.push(emptyRow);
        tr.insert(tr.mapping.slice(mapFrom).map(start + table.nodeSize - 2), rows);
    }
    return !!(empty || emptyHead);
}
// Make sure the given line (left, top) to (right, top) doesn't cross
// any rowspan cells by splitting cells that cross it. Return true if
// something changed.
function $89abb14886e23b87$var$isolateHorizontal(tr, map, table, start, left, right, top, mapFrom) {
    if (top === 0 || top === map.height) return false;
    let found = false;
    for(let col = left; col < right; col++){
        const index = top * map.width + col;
        const pos = map.map[index];
        if (map.map[index - map.width] === pos) {
            found = true;
            const cell = table.nodeAt(pos);
            if (!cell) throw new Error(`isolateHorizontal: no cell found at pos ${pos}`);
            const { top: cellTop, left: cellLeft } = map.findCell(pos);
            tr.setNodeMarkup(tr.mapping.slice(mapFrom).map(pos + start), undefined, {
                ...cell.attrs,
                rowspan: top - cellTop
            });
            const newCell = cell.type.createAndFill({
                ...cell.attrs,
                rowspan: cellTop + cell.attrs.rowspan - top
            });
            if (!newCell) throw new Error('isolateHorizontal: failed to create cell');
            tr.insert(tr.mapping.slice(mapFrom).map(map.positionAt(top, cellLeft, table)), newCell);
            col += cell.attrs.colspan - 1;
        }
    }
    return found;
}
// Make sure the given line (left, top) to (left, bottom) doesn't
// cross any colspan cells by splitting cells that cross it. Return
// true if something changed.
function $89abb14886e23b87$var$isolateVertical(tr, map, table, start, top, bottom, left, mapFrom) {
    if (left === 0 || left === map.width) return false;
    let found = false;
    for(let row = top; row < bottom; row++){
        const index = row * map.width + left;
        const pos = map.map[index];
        if (map.map[index - 1] === pos) {
            found = true;
            const cell = table.nodeAt(pos);
            if (!cell) throw new Error(`isolateVertical: could not find cell at pos ${pos}`);
            const cellLeft = map.colCount(pos);
            const updatePos = tr.mapping.slice(mapFrom).map(pos + start);
            tr.setNodeMarkup(updatePos, undefined, (0, $jl382.removeColSpan)(cell.attrs, left - cellLeft, cell.attrs.colspan - (left - cellLeft)));
            const newCell = cell.type.createAndFill((0, $jl382.removeColSpan)(cell.attrs, 0, left - cellLeft));
            if (!newCell) throw new Error('isolateVertical: failed to create cell');
            tr.insert(updatePos + cell.nodeSize, newCell);
            row += cell.attrs.rowspan - 1;
        }
    }
    return found;
}
function $89abb14886e23b87$var$applyHeaderCells(tr, tableMap, state, tableStart, table, headerRowEnabled, headerColumnEnabled) {
    const { schema: schema } = state;
    const setMarkup = (tr, row, col, headerEnabled)=>{
        const cellPos = tableStart + tableMap.positionAt(row, col, table);
        const cell = tr.doc.nodeAt(cellPos);
        const newType = headerEnabled ? schema.nodes.tableHeader : schema.nodes.tableCell;
        const isCellTypeChanged = newType !== cell?.type;
        const isCellTypeValid = !!cell && [
            schema.nodes.tableCell,
            schema.nodes.tableHeader
        ].includes(cell.type);
        if (isCellTypeChanged && isCellTypeValid) tr.setNodeMarkup(cellPos, newType, cell?.attrs, cell?.marks);
    };
    // For row === 0 && col === 0 it is enabled if either are enabled
    setMarkup(tr, 0, 0, headerColumnEnabled || headerRowEnabled);
    // Header Column
    for(let col = 1; col < tableMap.width; col++)setMarkup(tr, 0, col, headerRowEnabled);
    // Header Row
    for(let row = 1; row < tableMap.height; row++)setMarkup(tr, row, 0, headerColumnEnabled);
}
function $89abb14886e23b87$export$e0b94385c1fdc132(state, dispatch, tableStart, rect, cells) {
    let table = state.doc;
    const newRect = (0, $2QyFu.selectedRect)(state);
    const types = (0, $d1kIV.tableNodeTypes)(state.schema);
    // Get if the header row and column are enabled on the original table
    const headerRowEnabled = (0, $2vynv.isHeaderEnabledByType)('row', newRect, types);
    const headerColumnEnabled = (0, $2vynv.isHeaderEnabledByType)('column', newRect, types);
    if (tableStart) {
        table = state.doc.nodeAt(tableStart - 1);
        if (!table) throw new Error(`insertCells: could not find table at pos ${tableStart - 1}`);
    }
    let map = (0, $LmqWp.TableMap).get(table);
    const { top: top, left: left } = rect;
    const right = left + cells.width;
    const bottom = top + cells.height;
    const { tr: tr } = state;
    let mapFrom = 0;
    function recomp() {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        table = tableStart ? tr.doc.nodeAt(tableStart - 1) : tr.doc;
        map = (0, $LmqWp.TableMap).get(table);
        mapFrom = tr.mapping.maps.length;
    }
    // Prepare the table to be large enough and not have any cells
    // crossing the boundaries of the rectangle that we want to
    // insert into. If anything about it changes, recompute the table
    // map so that subsequent operations can see the current shape.
    if ($89abb14886e23b87$var$growTable(tr, map, table, tableStart, right, bottom, mapFrom)) recomp();
    if ($89abb14886e23b87$var$isolateHorizontal(tr, map, table, tableStart, left, right, top, mapFrom)) recomp();
    if ($89abb14886e23b87$var$isolateHorizontal(tr, map, table, tableStart, left, right, bottom, mapFrom)) recomp();
    if ($89abb14886e23b87$var$isolateVertical(tr, map, table, tableStart, top, bottom, left, mapFrom)) recomp();
    if ($89abb14886e23b87$var$isolateVertical(tr, map, table, tableStart, top, bottom, right, mapFrom)) recomp();
    for(let row = top; row < bottom; row++){
        const from = map.positionAt(row, left, table);
        const to = map.positionAt(row, right, table);
        // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
        tr.replace(tr.mapping.slice(mapFrom).map(from + tableStart), tr.mapping.slice(mapFrom).map(to + tableStart), new (0, $5SAOw.Slice)(cells.rows[row - top], 0, 0));
    }
    recomp();
    $89abb14886e23b87$var$applyHeaderCells(tr, map, state, tableStart, table, headerRowEnabled, headerColumnEnabled);
    tr.setSelection(new (0, $7XFGZ.CellSelection)(tr.doc.resolve(tableStart + map.map[top * map.width + left]), tr.doc.resolve(tableStart + map.map[(bottom - 1) * map.width + right - 1])));
    dispatch(tr);
}


const $fd0430a36e3c4d63$var$SKIP_NESTED_TABLE_PASTE_SOURCES = [
    'microsoft-excel',
    'google-spreadsheets'
];
function $fd0430a36e3c4d63$export$5dbcc300324fed87(view, _event, slice, options) {
    if (!(0, $bMyNT.isInTable)(view.state)) return false;
    const { schema: schema } = view.state;
    const isPasteFullTableInsideEmptyCellEnabled = (0, $dh538.fg)('platform_editor_paste_full_table_inside_empty_cell');
    const isPartialTablePaste = slice.content.childCount === 1 && slice.content.firstChild?.type === schema.nodes.table && slice.openStart !== 0 && slice.openEnd !== 0;
    const sel = view.state.selection;
    const isCellSelection = sel instanceof (0, $7XFGZ.CellSelection);
    if (isPasteFullTableInsideEmptyCellEnabled && !isPartialTablePaste && // If the selection is not a cell selection, and the selection is empty then we can insert a nested table
    !isCellSelection && sel.empty && !(options && $fd0430a36e3c4d63$var$SKIP_NESTED_TABLE_PASTE_SOURCES.includes(options.pasteSource))) {
        const cellRes = (0, $8m4tT.findParentNode)((node)=>node.type === schema.nodes.tableCell || node.type === schema.nodes.tableHeader)(sel);
        if (cellRes) {
            const canInsertNestedTable = cellRes.node.contentMatchAt(0).matchType(schema.nodes.table)?.validEnd;
            if (canInsertNestedTable) return false;
        }
    }
    let cells = (0, $89abb14886e23b87$export$f6d8f52489457fc4)(slice);
    if (isCellSelection) {
        if (!cells) cells = {
            width: 1,
            height: 1,
            rows: [
                (0, $5SAOw.Fragment).from((0, $89abb14886e23b87$export$f09c6b3b06d884fb)((0, $d1kIV.tableNodeTypes)(view.state.schema).cell, slice))
            ]
        };
        const table = sel.$anchorCell.node(-1);
        const start = sel.$anchorCell.start(-1);
        const tableMap = (0, $LmqWp.TableMap).get(table);
        const rect = tableMap.rectBetween(sel.$anchorCell.pos - start, sel.$headCell.pos - start);
        cells = (0, $89abb14886e23b87$export$cdcebd68073bc3f)(cells, rect.right - rect.left, rect.bottom - rect.top);
        (0, $89abb14886e23b87$export$e0b94385c1fdc132)(view.state, view.dispatch, start, rect, $fd0430a36e3c4d63$var$clearColumnWidthOfCells(cells, rect, tableMap));
        return true;
    }
    if (cells) {
        const $cell = (0, $bzgWU.selectionCell)(sel);
        if (!$cell) throw new Error(`handlePaste: no cell found`);
        const start = $cell.start(-1);
        const rect = (0, $LmqWp.TableMap).get($cell.node(-1)).findCell($cell.pos - start);
        const tableMap = (0, $LmqWp.TableMap).get($cell.node(-1));
        (0, $89abb14886e23b87$export$e0b94385c1fdc132)(view.state, view.dispatch, start, rect, $fd0430a36e3c4d63$var$clearColumnWidthOfCells(cells, rect, tableMap));
        return true;
    }
    return false;
}
// Clear the pasted cells column widths so that it maintains
// the column widths of the destination table only if the pasted
// cells overlap with existing cells in the destination table.
// If the table grows on paste, keep the column widhts of the
// original table.
const $fd0430a36e3c4d63$var$clearColumnWidthOfCells = (cells, rect, table)=>{
    const overlappingCells = [];
    for (const row of cells.rows){
        let colNum = rect.left;
        for(let index = 0; index < row.childCount; index++){
            const cell = row.child(index);
            if (colNum + cell.attrs.colspan <= table.width) {
                overlappingCells.push(cell);
                colNum += cell.attrs.colspan;
            } else break;
        }
    }
    for (const cell of overlappingCells)// TODO: ED-13910 - unblock Prosemirror bump
    // @ts-ignore
    cell.attrs.colwidth = null;
    return cells;
};
module.exports["handlePaste"] = $fd0430a36e3c4d63$export$5dbcc300324fed87;

});

parcelRegister("d1kIV", function(module, exports) {
function $24faf46e0f03a5c7$export$c7782132717464bc(schema) {
    let result = schema.cached.tableNodeTypes;
    if (!result) {
        result = {};
        // eslint-disable-next-line no-param-reassign
        schema.cached.tableNodeTypes = result;
        // eslint-disable-next-line guard-for-in
        for(const name in schema.nodes){
            const type = schema.nodes[name];
            const role = type.spec.tableRole;
            if (role) result[role] = type;
        }
    }
    return result;
}
module.exports["tableNodeTypes"] = $24faf46e0f03a5c7$export$c7782132717464bc;

});

parcelRegister("2vynv", function(module, exports) {

var $LmqWp = parcelRequire("LmqWp");


var $2QyFu = parcelRequire("2QyFu");


var $d1kIV = parcelRequire("d1kIV");


var $bMyNT = parcelRequire("bMyNT");

function $afb09f49f7d4ea1c$export$96946e3333d0ccc6(type, rect, types) {
    // Get cell positions for first row or first column
    const cellPositions = rect.map.cellsInRect({
        left: 0,
        top: 0,
        right: type === 'row' ? rect.map.width : 1,
        bottom: type === 'column' ? rect.map.height : 1
    });
    for(let i = 0; i < cellPositions.length; i++){
        const cell = rect.table.nodeAt(cellPositions[i]);
        if (cell && cell.type !== types.header_cell) return false;
    }
    return true;
}
function $afb09f49f7d4ea1c$export$dee0ccd8d8f5a56e(type) {
    return function(state, dispatch) {
        if (!(0, $bMyNT.isInTable)(state)) return false;
        if (dispatch) {
            const types = (0, $d1kIV.tableNodeTypes)(state.schema);
            const rect = (0, $2QyFu.selectedRect)(state), tr = state.tr;
            const isHeaderRowEnabled = $afb09f49f7d4ea1c$export$96946e3333d0ccc6('row', rect, types);
            const isHeaderColumnEnabled = $afb09f49f7d4ea1c$export$96946e3333d0ccc6('column', rect, types);
            const isHeaderEnabled = type === 'column' ? isHeaderRowEnabled : type === 'row' ? isHeaderColumnEnabled : false;
            const selectionStartsAt = isHeaderEnabled ? 1 : 0;
            const cellsRect = type === 'column' ? new (0, $LmqWp.Rect)(0, selectionStartsAt, 1, rect.map.height) : type === 'row' ? new (0, $LmqWp.Rect)(selectionStartsAt, 0, rect.map.width, 1) : rect;
            let newType;
            if (type === 'column') newType = isHeaderColumnEnabled ? types.cell : types.header_cell;
            else if (type === 'row') newType = isHeaderRowEnabled ? types.cell : types.header_cell;
            else newType = types.cell;
            rect.map.cellsInRect(cellsRect).forEach((relativeCellPos)=>{
                const cellPos = relativeCellPos + rect.tableStart;
                const cell = tr.doc.nodeAt(cellPos);
                if (cell) tr.setNodeMarkup(cellPos, newType, cell.attrs);
            });
            dispatch(tr);
        }
        return true;
    };
}
module.exports["isHeaderEnabledByType"] = $afb09f49f7d4ea1c$export$96946e3333d0ccc6;
module.exports["toggleHeader"] = $afb09f49f7d4ea1c$export$dee0ccd8d8f5a56e;

});

parcelRegister("6taGi", function(module, exports) {
/**
 * Cache for storing fileId to clientId mapping during paste operations.
 * This avoids the need to store clientId in ADF schema attributes.
 *
 * Used for cross-client copy/paste scenarios
 *
 * Entries persist across reads to support multiple pastes of the same content.
 * An LRU-style max size limit guards against unbounded growth — the oldest entry
 * is evicted whenever the cache exceeds CLIENT_ID_CACHE_MAX_SIZE.
 */ const $0087194f6f60fb6d$var$CLIENT_ID_CACHE_MAX_SIZE = 20;
const $0087194f6f60fb6d$var$clientIdCache = new Map();
const $0087194f6f60fb6d$export$e03a2c36a6c44657 = (fileId, clientId)=>{
    $0087194f6f60fb6d$var$clientIdCache.set(fileId, clientId);
    // Evict oldest entries if cache exceeds max size
    if ($0087194f6f60fb6d$var$clientIdCache.size > $0087194f6f60fb6d$var$CLIENT_ID_CACHE_MAX_SIZE) {
        const oldestKey = $0087194f6f60fb6d$var$clientIdCache.keys().next().value;
        if (oldestKey !== undefined) $0087194f6f60fb6d$var$clientIdCache.delete(oldestKey);
    }
};
const $0087194f6f60fb6d$export$3cac71a2bd99f367 = (fileId)=>{
    return $0087194f6f60fb6d$var$clientIdCache.get(fileId);
};
const $0087194f6f60fb6d$export$227522d8fd74bd7e = ()=>{
    $0087194f6f60fb6d$var$clientIdCache.clear();
};
/**
 * Used to store fileId to clientId mappings on paste of Editor PM Node
 *
 * Handles two sources of pasted HTML:
 *
 * 1. Editor-to-editor copy: the clientId is stored as a `data-client-id` attribute
 *    directly on the `<div data-node-type="media">` element, written by the editor's
 *    clipboard serialiser.
 *
 * 2. Renderer-to-editor copy (e.g. pasting from a published Confluence page): the
 *    renderer does not write `data-client-id` on the media div. Instead, the clientId
 *    is embedded inside the blob URL on the `<img>` child element, in the hash params:
 *    `src="blob:https://...#media-blob-url=true&id=FILE_ID&...&clientId=CLIENT_ID"`
 *
 * All media nodes in a single pasted HTML fragment always share the same clientId,
 * so we extract it once and apply it to all file IDs found in the HTML.
 */ /**
 * Extract the clientId from a blob URL hash fragment (renderer-to-editor path).
 * Returns undefined if not found.
 */ const $0087194f6f60fb6d$var$extractClientIdFromBlobUrl = (html)=>{
    // Matches both:
    //   - blob: URLs (client-rendered renderer)
    //   - HTTPS URLs with #media-blob-url=true in the hash (SSR-rendered renderer)
    const imgSrcRegex = /src="([^"]*#media-blob-url=true[^"]*)"/g;
    let match;
    while((match = imgSrcRegex.exec(html)) !== null){
        const src = match[1];
        // clientId is encoded in the hash fragment as a URL param
        // e.g. blob:https://hello.atlassian.net/uuid#media-blob-url=true&id=FILE_ID&clientId=CLIENT_ID
        const hash = src.includes('#') ? src.slice(src.indexOf('#') + 1) : '';
        // Unescape HTML-encoded ampersands that appear in raw clipboard HTML attribute values
        const decodedHash = hash.replace(/&amp;/g, '&');
        const clientId = new URLSearchParams(decodedHash).get('clientId');
        if (clientId) return clientId;
    }
    return undefined;
};
const $0087194f6f60fb6d$export$a60ab7931e673c86 = (html)=>{
    if (!html) return;
    // All media nodes in a single paste share the same clientId.
    // Extract it once from either source:
    //   - Editor-to-editor: present as data-client-id="..." attribute
    //   - Renderer-to-editor: embedded in the blob URL hash as clientId=...
    const clientId = /data-client-id="([^"]*)"/.exec(html)?.[1] ?? $0087194f6f60fb6d$var$extractClientIdFromBlobUrl(html);
    if (!clientId) return;
    // Map every file ID in the HTML to the single clientId
    const fileIdRegex = /data-id="([^"]*)"/g;
    let match;
    while((match = fileIdRegex.exec(html)) !== null)$0087194f6f60fb6d$export$e03a2c36a6c44657(match[1], clientId);
};
module.exports["getClientIdForFile"] = $0087194f6f60fb6d$export$3cac71a2bd99f367;
module.exports["extractClientIdsFromHtml"] = $0087194f6f60fb6d$export$a60ab7931e673c86;

});

parcelRegister("9KolL", function(module, exports) {

var $LmqWp = parcelRequire("LmqWp");


var $id9O1 = parcelRequire("id9O1");


var $iP1et = parcelRequire("iP1et");

function $4c983097368b5624$export$d2cf64960b17e12e(selection) {
    let map;
    let totalRowCount = 0;
    let totalColumnCount = 0;
    const table = (0, $id9O1.findTable)(selection);
    if (table) {
        map = (0, $LmqWp.TableMap).get(table.node);
        totalRowCount = map.height;
        totalColumnCount = map.width;
    }
    return {
        table: table,
        map: map,
        totalRowCount: totalRowCount,
        totalColumnCount: totalColumnCount
    };
}
function $4c983097368b5624$export$277d5394a2608229(selection) {
    let horizontalCells = 1;
    let verticalCells = 1;
    let totalCells = 1;
    const { table: table, map: map, totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = $4c983097368b5624$export$d2cf64960b17e12e(selection);
    if (table && map) {
        const rect = (0, $iP1et.getSelectionRect)(selection);
        if (rect) {
            totalCells = map.cellsInRect(rect).length;
            horizontalCells = rect.right - rect.left;
            verticalCells = rect.bottom - rect.top;
        }
    }
    return {
        totalRowCount: totalRowCount,
        totalColumnCount: totalColumnCount,
        horizontalCells: horizontalCells,
        verticalCells: verticalCells,
        totalCells: totalCells
    };
}
module.exports["getSelectedTableInfo"] = $4c983097368b5624$export$d2cf64960b17e12e;
module.exports["getSelectedCellInfo"] = $4c983097368b5624$export$277d5394a2608229;

});

parcelRegister("iP1et", function(module, exports) {

var $LmqWp = parcelRequire("LmqWp");


var $BW42l = parcelRequire("BW42l");

const $f789b7130425e047$export$aa946c0ed562e2ed = (selection)=>{
    if (!(0, $BW42l.isSelectionType)(selection, 'cell')) return;
    const start = selection.$anchorCell.start(-1);
    const map = (0, $LmqWp.TableMap).get(selection.$anchorCell.node(-1));
    return map.rectBetween(selection.$anchorCell.pos - start, selection.$headCell.pos - start);
};
module.exports["getSelectionRect"] = $f789b7130425e047$export$aa946c0ed562e2ed;

});

parcelRegister("hBm38", function(module, exports) {

var $dhoHU = parcelRequire("dhoHU");

const $2dba0b6a28b30551$var$getDefaultBlockNodeTypes = (tr)=>{
    const { paragraph: paragraph } = tr.doc.type.schema.nodes;
    return paragraph ? [
        paragraph
    ] : [];
};
const $2dba0b6a28b30551$export$9e2e0ba9b4a3aaa9 = (node, markType)=>{
    if (!node || !markType) return false;
    const blockMark = node.marks.find((mark)=>mark.type === markType);
    return blockMark ? blockMark.attrs : false;
};
const $2dba0b6a28b30551$export$1b9361dde62c5ad5 = (node, markType)=>{
    if (!node || !markType) return false;
    const { paragraph: paragraph } = node.type.schema.nodes;
    if (!paragraph) return false;
    const findFirstParagraphBlockMarkAttrs = (currentNode)=>{
        if (currentNode.type === paragraph) return $2dba0b6a28b30551$export$9e2e0ba9b4a3aaa9(currentNode, markType);
        for(let index = 0; index < currentNode.childCount; index++){
            const childResult = findFirstParagraphBlockMarkAttrs(currentNode.child(index));
            if (childResult !== false) return childResult;
        }
        return false;
    };
    return findFirstParagraphBlockMarkAttrs(node);
};
const $2dba0b6a28b30551$export$d2e4d08c8ba1d788 = (tr, from, to, markType, markAttrs, blockNodeTypes = $2dba0b6a28b30551$var$getDefaultBlockNodeTypes(tr))=>{
    if (!markType || blockNodeTypes.length === 0) return false;
    return (0, $dhoHU.createToggleBlockMarkOnRangeNext)(markType, ()=>markAttrs, blockNodeTypes)(from, to, tr);
};
const $2dba0b6a28b30551$export$6ea2388618f50d4a = (tr, containerPos, markType, markAttrs, blockNodeTypes = $2dba0b6a28b30551$var$getDefaultBlockNodeTypes(tr))=>{
    const containerNode = tr.doc.nodeAt(containerPos);
    if (!containerNode) return false;
    return $2dba0b6a28b30551$export$d2e4d08c8ba1d788(tr, containerPos, containerPos + containerNode.nodeSize, markType, markAttrs, blockNodeTypes);
};
const $2dba0b6a28b30551$export$eb81f7a0535d3440 = (tr, pos, markType, markAttrs)=>{
    const { paragraph: paragraph } = tr.doc.type.schema.nodes;
    if (!paragraph) return false;
    const resolvedPos = tr.doc.resolve(Math.max(0, Math.min(pos, tr.doc.content.size)));
    for(let depth = resolvedPos.depth; depth > 0; depth--){
        const node = resolvedPos.node(depth);
        if (node.type === paragraph) return $2dba0b6a28b30551$export$d2e4d08c8ba1d788(tr, resolvedPos.before(depth), resolvedPos.before(depth) + node.nodeSize, markType, markAttrs, [
            paragraph
        ]);
    }
    return false;
};
module.exports["getBlockMarkAttrs"] = $2dba0b6a28b30551$export$9e2e0ba9b4a3aaa9;
module.exports["getFirstParagraphBlockMarkAttrs"] = $2dba0b6a28b30551$export$1b9361dde62c5ad5;
module.exports["reconcileBlockMarkInRange"] = $2dba0b6a28b30551$export$d2e4d08c8ba1d788;
module.exports["reconcileBlockMarkForContainerAtPos"] = $2dba0b6a28b30551$export$6ea2388618f50d4a;
module.exports["reconcileBlockMarkForParagraphAtPos"] = $2dba0b6a28b30551$export$eb81f7a0535d3440;

});

parcelRegister("e6sdP", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $eTj7Y = parcelRequire("eTj7Y");


var $4HWgE = parcelRequire("4HWgE");


var $3KVX0 = parcelRequire("3KVX0");


var $2XqLN = parcelRequire("2XqLN");


var $dh538 = parcelRequire("dh538");

const $41f58be4b65e6d82$var$processQuickInsertItems = (items, intl)=>{
    return items.reduce((acc, item)=>{
        if (typeof item === 'function' && // we preserve handler items with disableMemo so that we
        // can process them in a later step outside of memoizations
        !item.disableMemo) {
            const quickInsertItems = item(intl);
            return acc.concat(quickInsertItems);
        }
        return acc.concat(item);
    }, []);
};
const $41f58be4b65e6d82$var$memoizedProcessQuickInsertItems = (0, $2XqLN.default)($41f58be4b65e6d82$var$processQuickInsertItems);
const $41f58be4b65e6d82$export$4fca091f4ee92b6d = (items, intl)=>{
    const memoizedResults = $41f58be4b65e6d82$var$memoizedProcessQuickInsertItems(items, intl);
    const hasDisabledMemos = items.some((item)=>typeof item === 'function' && item.disableMemo);
    if (!hasDisabledMemos) return memoizedResults;
    return memoizedResults.flatMap((item)=>typeof item === 'function' && item.disableMemo ? item(intl) : item);
};
const $41f58be4b65e6d82$var$options = {
    threshold: 0.3,
    includeScore: true,
    keys: [
        {
            name: 'title',
            weight: 0.57
        },
        {
            name: 'keywords',
            weight: 0.08
        },
        {
            name: 'description',
            weight: 0.04
        },
        {
            name: 'keyshortcut',
            weight: 0.01
        }
    ]
};
function $41f58be4b65e6d82$export$71aa6c912b956294(query, items, prioritySortingFn) {
    if (query === '') // Copy and sort list by priority
    return items.slice(0).sort((a, b)=>(a.priority || Number.POSITIVE_INFINITY) - (b.priority || Number.POSITIVE_INFINITY));
    const fuseOptions = {
        ...$41f58be4b65e6d82$var$options
    };
    if (prioritySortingFn) {
        const sortFn = prioritySortingFn(items);
        // prioritySortingFn will trigger the experiment exposure, but sortFn
        // will be undefined for the control group.
        if (sortFn) fuseOptions.sortFn = sortFn;
    }
    const fuse = new (0, $3KVX0.default)(items, fuseOptions);
    const results = fuse.search(query);
    if ((0, $dh538.fg)('jim-lower-ranking-in-jira-macro-search')) {
        // searching for jira work items macro first
        const datasourceIndex = results.findIndex((r)=>r.item.id === 'datasource' && r.item.keywords?.includes('jira'));
        //  then searching for the legacy jira macro
        const legacyIndex = results.findIndex((r)=>typeof r.item.key === 'string' && r.item.key.endsWith(':jira'));
        // the jira legcy macro is found before the jira work items macro then swap the two
        if (datasourceIndex > 0 && legacyIndex >= 0 && legacyIndex < datasourceIndex && Math.abs((results[datasourceIndex].score ?? 0) - (results[legacyIndex].score ?? 0)) < 0.2) {
            const [datasource] = results.splice(datasourceIndex, 1);
            results.splice(legacyIndex, 0, datasource);
        }
    }
    return results.map((result)=>result.item);
}



var $1S4f7 = parcelRequire("1S4f7");


var $lOELb = parcelRequire("lOELb");


var $9VJDA = parcelRequire("9VJDA");





var $1oCLl = parcelRequire("1oCLl");


var $zT4ZO = parcelRequire("zT4ZO");


var $ks2lK = parcelRequire("ks2lK");

const $47acf0b419f9d7aa$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('quickInsertPluginKey');


const $5805149c74b21c1a$export$a37159c5d6f821f5 = ({ tr: tr })=>tr.setMeta((0, $47acf0b419f9d7aa$export$18d4026d1ea86bb1), {
        isElementBrowserModalOpen: true
    });
const $5805149c74b21c1a$export$d7c09ddb7ec80ba9 = ()=>(state, dispatch)=>{
        if (dispatch) dispatch(state.tr.setMeta((0, $47acf0b419f9d7aa$export$18d4026d1ea86bb1), {
            isElementBrowserModalOpen: false
        }));
        return true;
    };
const $5805149c74b21c1a$export$40b105cb73ed6b94 = (onInsert)=>$5805149c74b21c1a$var$insertItem(onInsert);
// this method was adapted from the typeahead plugin so we respect the API for quick insert items
const $5805149c74b21c1a$var$insertItem = (onInsert)=>(item, source)=>(state, dispatch)=>{
            const insert = (maybeNode, opts = {})=>{
                return (0, $zT4ZO.insertSelectedItem)(maybeNode, opts)(state, state.tr, state.selection.head);
            };
            const tr = item.action(insert, state, source);
            /** @note There is no transaction when called without a search currently (different insert) */ if (tr && dispatch) dispatch(tr);
            onInsert?.(item);
            return true;
        };



var $d925B = parcelRequire("d925B");


var $j85vL = parcelRequire("j85vL");

var $grmt9 = parcelRequire("grmt9");

var $8kPu1 = parcelRequire("8kPu1");

var $SI3ya = parcelRequire("SI3ya");

var $fo9p3 = parcelRequire("fo9p3");

var $6pIOC = parcelRequire("6pIOC");







const $641d33b11dd1e4d7$var$pluginKey = new (0, $ks2lK.PluginKey)('quickInsertOpenExperience');
const $641d33b11dd1e4d7$var$TIMEOUT_DURATION = 1000;
const $641d33b11dd1e4d7$var$START_METHOD = {
    QUICK_INSERT_BUTTON: 'quickInsertButton',
    TYPEAHEAD: 'typeahead'
};
const $641d33b11dd1e4d7$var$ABORT_REASON = {
    USER_CANCELED: 'userCanceled',
    EDITOR_DESTROYED: 'editorDestroyed'
};
const $641d33b11dd1e4d7$export$399cc8247eb1f3b5 = ({ refs: refs, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
    let targetEl;
    let editorViewEl;
    let mouseDownPos;
    const getTarget = ()=>{
        if (!targetEl) targetEl = refs.popupsMountPoint || refs.wrapperElement || (0, $6pIOC.getPopupContainerFromEditorView)(editorViewEl);
        return targetEl;
    };
    const experience = new (0, $grmt9.Experience)((0, $8kPu1.EXPERIENCE_ID).MENU_OPEN, {
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).QUICK_INSERT,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        checks: [
            new (0, $fo9p3.ExperienceCheckTimeout)({
                durationMs: $641d33b11dd1e4d7$var$TIMEOUT_DURATION
            }),
            new (0, $SI3ya.ExperienceCheckDomMutation)({
                onDomMutation: ({ mutations: mutations })=>{
                    if (mutations.some($641d33b11dd1e4d7$var$isQuickInsertMenuAddedInMutation)) return {
                        status: 'success'
                    };
                },
                observeConfig: ()=>({
                        target: getTarget(),
                        options: {
                            childList: true
                        }
                    })
            })
        ]
    });
    return new (0, $1S4f7.SafePlugin)({
        key: $641d33b11dd1e4d7$var$pluginKey,
        props: {
            handleDOMEvents: {
                mousedown: (_view, event)=>{
                    if ($641d33b11dd1e4d7$var$isTargetQuickInsertButton(event.target)) mouseDownPos = {
                        x: event.clientX,
                        y: event.clientY
                    };
                },
                mouseup: (_view, event)=>{
                    if (mouseDownPos && $641d33b11dd1e4d7$var$isTargetQuickInsertButton(event.target) && event.clientX === mouseDownPos.x && event.clientY === mouseDownPos.y) experience.start({
                        method: $641d33b11dd1e4d7$var$START_METHOD.QUICK_INSERT_BUTTON
                    });
                    mouseDownPos = undefined;
                },
                beforeinput: (view, event)=>{
                    if ($641d33b11dd1e4d7$var$isQuickInsertTrigger(event) && $641d33b11dd1e4d7$var$isSelectionWhichSupportsTypeahead(view) && !$641d33b11dd1e4d7$var$isQuickInsertMenuWithinNode(getTarget())) experience.start({
                        method: $641d33b11dd1e4d7$var$START_METHOD.TYPEAHEAD,
                        forceRestart: true
                    });
                },
                keydown: (_view, event)=>{
                    if ($641d33b11dd1e4d7$var$isCancelKey(event.key) && !$641d33b11dd1e4d7$var$isQuickInsertMenuWithinNode(getTarget())) experience.abort({
                        reason: $641d33b11dd1e4d7$var$ABORT_REASON.USER_CANCELED
                    });
                }
            }
        },
        view: (editorView)=>{
            editorViewEl = editorView.dom;
            return {
                destroy: ()=>{
                    experience.abort({
                        reason: $641d33b11dd1e4d7$var$ABORT_REASON.EDITOR_DESTROYED
                    });
                }
            };
        }
    });
};
const $641d33b11dd1e4d7$var$isQuickInsertTrigger = ({ inputType: inputType, data: data })=>{
    return inputType === 'insertText' && data === '/';
};
const $641d33b11dd1e4d7$var$isSelectionWhichSupportsTypeahead = ({ state: state })=>{
    const { from: from, $from: $from } = state.selection;
    if ($from.parent.type.name === 'codeBlock') return false;
    if ($from.marks().some((mark)=>mark.type.name === 'code')) return false;
    if (from === 0) return true;
    const nodeBefore = state.doc.resolve(from).nodeBefore;
    if (!nodeBefore) return true;
    const charBefore = nodeBefore.textContent?.slice(-1) || '';
    return charBefore.trim().length === 0;
};
const $641d33b11dd1e4d7$var$isCancelKey = (key)=>{
    return key === 'Escape' || key === 'Backspace';
};
const $641d33b11dd1e4d7$var$isTargetQuickInsertButton = (target)=>{
    return target instanceof HTMLElement && (target.dataset.testid === 'editor-quick-insert-button' || !!target.closest('[data-testid="editor-quick-insert-button"]'));
};
const $641d33b11dd1e4d7$var$isQuickInsertMenuAddedInMutation = ({ type: type, addedNodes: addedNodes })=>{
    return type === 'childList' && [
        ...addedNodes
    ].some($641d33b11dd1e4d7$var$isQuickInsertMenuWithinNode);
};
const $641d33b11dd1e4d7$var$isQuickInsertMenuWithinNode = (node)=>{
    return (0, $j85vL.containsPopupWithNestedElement)(node, '.fabric-editor-typeahead');
};










var $eiA8Z = parcelRequire("eiA8Z");


var $91bcx = parcelRequire("91bcx");





/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $9K4OG = parcelRequire("9K4OG");





var $eEA8O = parcelRequire("eEA8O");


var $ism5g = parcelRequire("ism5g");


var $auDHv = parcelRequire("auDHv");


var $ci7Ox = parcelRequire("ci7Ox");


var $8TTLA = parcelRequire("8TTLA");

var $8CZUH = parcelRequire("8CZUH");

var $6xdDU = parcelRequire("6xdDU");

var $804cB = parcelRequire("804cB");




function $2f66e44cc352b6ef$export$7a0f33e8df10bd94(intl) {
    return [
        {
            title: intl.formatMessage((0, $auDHv.messages).all),
            name: 'all'
        },
        {
            title: intl.formatMessage((0, $auDHv.messages).AI),
            name: 'AI'
        },
        {
            title: intl.formatMessage((0, $auDHv.messages).formatting),
            name: 'formatting'
        },
        {
            title: intl.formatMessage((0, $auDHv.messages)['confluence-content']),
            name: 'confluence-content'
        },
        {
            title: intl.formatMessage((0, $auDHv.messages).media),
            name: 'media'
        },
        {
            title: intl.formatMessage((0, $auDHv.messages).visuals),
            name: 'visuals'
        },
        {
            title: intl.formatMessage((0, $auDHv.messages).navigation),
            name: 'navigation'
        },
        {
            title: intl.formatMessage((0, $auDHv.messages)['external-content']),
            name: 'external-content'
        },
        {
            title: intl.formatMessage((0, $auDHv.messages).communication),
            name: 'communication'
        },
        {
            title: intl.formatMessage((0, $auDHv.messages).reporting),
            name: 'reporting'
        },
        {
            title: intl.formatMessage((0, $auDHv.messages).admin),
            name: 'admin'
        },
        {
            title: intl.formatMessage((0, $auDHv.messages).development),
            name: 'development'
        }
    ];
}


function $05c3994250e25697$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $05c3994250e25697$export$77ff514ac660f8f8 = 16;
const $05c3994250e25697$var$actionsStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    display: 'inline-flex',
    margin: `0 ${"var(--ds-space-negative-050, -4px)"}`
});
const $05c3994250e25697$var$actionItemStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    flex: '1 0 auto',
    margin: `0 ${"var(--ds-space-050, 4px)"}`
});
const $05c3994250e25697$var$wrapperStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    display: 'flex',
    flex: '1 1 auto',
    boxSizing: 'border-box',
    padding: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-200, 16px)"} 0 10px`,
    overflow: 'hidden',
    backgroundColor: "var(--ds-surface-overlay, #FFFFFF)",
    borderRadius: "var(--ds-radius-small, 3px)"
});
const $05c3994250e25697$var$modalFooterStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    display: 'flex',
    padding: `${"var(--ds-space-200, 16px)"}`,
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'space-between'
});
const $05c3994250e25697$var$modalCloseButtonStyles = {
    name: "1446vv2",
    styles: "display:flex;justify-content:flex-end;padding-block-start:var(--ds-space-200, 16px);padding-inline:var(--ds-space-200, 16px)"
};
const $05c3994250e25697$var$ModalElementBrowser = (props)=>{
    const [selectedItem, setSelectedItem] = (0, $42omo.useState)();
    const { helpUrl: helpUrl, intl: intl, onInsertItem: onInsertItemFn } = props;
    const onSelectItem = (0, $42omo.useCallback)((item)=>{
        setSelectedItem(item);
    }, [
        setSelectedItem
    ]);
    const onInsertItem = (0, $42omo.useCallback)((item)=>{
        onInsertItemFn(item);
    }, [
        onInsertItemFn
    ]);
    const RenderFooter = (0, $42omo.useCallback)(()=>/*#__PURE__*/ (0, $9K4OG.jsx)($05c3994250e25697$var$Footer, {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onInsert: ()=>onInsertItem(selectedItem),
            beforeElement: helpUrl ? $05c3994250e25697$var$HelpLink(helpUrl, intl.formatMessage((0, $auDHv.messages).help)) : undefined
        }), [
        onInsertItem,
        selectedItem,
        helpUrl,
        intl
    ]);
    const RenderBody = (0, $42omo.useCallback)(()=>/*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: $05c3994250e25697$var$wrapperStyles,
            "data-vc": "oy1K3lFD"
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $ism5g.default), {
            categories: (0, $2f66e44cc352b6ef$export$7a0f33e8df10bd94)(props.intl),
            getItems: props.getItems,
            showSearch: true,
            showCategories: true,
            mode: "full",
            onSelectItem: onSelectItem,
            onInsertItem: onInsertItem,
            emptyStateHandler: props.emptyStateHandler,
            autoFocusSearch: false
        })), [
        props.intl,
        props.getItems,
        onSelectItem,
        onInsertItem,
        props.emptyStateHandler
    ]);
    const label = intl.formatMessage((0, $auDHv.messages).browse);
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        "data-editor-popup": true
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6xdDU.default), null, props.isOpen && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $8CZUH.default), {
        label: label,
        testId: "element-browser-modal-dialog",
        stackIndex: 0,
        key: "element-browser-modal",
        onClose: props.onClose,
        onCloseComplete: props.onCloseComplete,
        height: "664px",
        width: "x-large",
        shouldReturnFocus: props.shouldReturnFocus
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $05c3994250e25697$var$modalCloseButtonStyles
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $8TTLA.CloseButton), {
        onClick: props.onClose
    })), /*#__PURE__*/ (0, $9K4OG.jsx)(RenderBody, null), /*#__PURE__*/ (0, $9K4OG.jsx)(RenderFooter, null))));
};
$05c3994250e25697$var$ModalElementBrowser.displayName = 'ModalElementBrowser';
const $05c3994250e25697$var$Footer = ({ onInsert: onInsert, beforeElement: beforeElement })=>{
    const intl = (0, $aXWIB.useIntl)();
    const { onClose: onClose } = (0, $804cB.useModal)();
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $05c3994250e25697$var$modalFooterStyles
    }, beforeElement ? beforeElement : /*#__PURE__*/ (0, $9K4OG.jsx)("span", null), /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $05c3994250e25697$var$actionsStyles
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $05c3994250e25697$var$actionItemStyles
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $eEA8O.default), {
        appearance: "primary",
        onClick: onInsert,
        testId: "ModalElementBrowser__insert-button"
    }, intl.formatMessage((0, $auDHv.messages).insert))), /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $05c3994250e25697$var$actionItemStyles
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $eEA8O.default), {
        appearance: "subtle",
        onClick: onClose,
        testId: "ModalElementBrowser__close-button"
    }, intl.formatMessage((0, $auDHv.messages).close)))));
};
const $05c3994250e25697$var$HelpLink = (url, helpText)=>/*#__PURE__*/ (0, $9K4OG.jsx)((0, $eEA8O.default), {
        iconBefore: /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ci7Ox))), {
            label: ""
        }),
        appearance: "subtle-link",
        href: url,
        target: "_blank",
        testId: "ModalElementBrowser__help-button"
    }, helpText);
const $05c3994250e25697$var$_default_1 = (0, $aXWIB.injectIntl)($05c3994250e25697$var$ModalElementBrowser);
var $05c3994250e25697$export$2e2bcd8739ae039 = $05c3994250e25697$var$_default_1;


const $4d563301f3da277a$var$Modal = ({ quickInsertState: quickInsertState, isOffline: isOffline, editorView: editorView, helpUrl: helpUrl, insertItem: insertItem, getSuggestions: getSuggestions, api: api })=>{
    const getItems = (0, $42omo.useCallback)((query, category)=>getSuggestions?.({
            query: query,
            category: category
        })?.map((item)=>{
            return isOffline && item.isDisabledOffline ? {
                ...item,
                isDisabled: true
            } : item;
        }) ?? [], // See: https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/157796/overview?commentId=8559952
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        getSuggestions,
        quickInsertState.lazyDefaultItems,
        quickInsertState.providedItems,
        isOffline
    ]);
    const focusInEditor = (0, $42omo.useCallback)(()=>{
        if (!editorView.hasFocus()) editorView.focus();
    }, [
        editorView
    ]);
    // ED-19408 We not store the item ref in the state
    // Instead of adding the item immediately on insert item
    // We wait until modal close is complete, refocus the editor and then add the item
    const insertableItem = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(null);
    const onInsertItem = (0, $42omo.useCallback)((item)=>{
        (0, $5805149c74b21c1a$export$d7c09ddb7ec80ba9)()(editorView.state, editorView.dispatch);
        if ((0, $dh538.fg)('platform_editor_ease_of_use_metrics')) api?.core.actions.execute(api?.metrics?.commands.startActiveSessionTimer());
        insertableItem.current = item;
    }, [
        editorView,
        api
    ]);
    const onClose = (0, $42omo.useCallback)(()=>{
        (0, $5805149c74b21c1a$export$d7c09ddb7ec80ba9)()(editorView.state, editorView.dispatch);
        if ((0, $dh538.fg)('platform_editor_ease_of_use_metrics')) api?.core.actions.execute(api?.metrics?.commands.startActiveSessionTimer());
        focusInEditor();
    }, [
        editorView,
        focusInEditor,
        api
    ]);
    const onCloseComplete = (0, $42omo.useCallback)(()=>{
        if (!insertableItem.current) {
            focusInEditor();
            return;
        }
        const item = insertableItem.current;
        insertableItem.current = null;
        focusInEditor();
        insertItem?.(item, (0, $d925B.INPUT_METHOD).ELEMENT_BROWSER)(editorView.state, editorView.dispatch);
    }, [
        editorView,
        focusInEditor,
        insertItem
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $05c3994250e25697$export$2e2bcd8739ae039), {
        getItems: getItems,
        onInsertItem: onInsertItem,
        helpUrl: helpUrl,
        isOpen: quickInsertState.isElementBrowserModalOpen || false,
        emptyStateHandler: quickInsertState.emptyStateHandler,
        onClose: onClose,
        onCloseComplete: onCloseComplete,
        shouldReturnFocus: false
    });
};
var $4d563301f3da277a$export$2e2bcd8739ae039 = ({ editorView: editorView, helpUrl: helpUrl, pluginInjectionAPI: pluginInjectionAPI })=>{
    const { lazyDefaultItems: lazyDefaultItems, providedItems: providedItems, isElementBrowserModalOpen: isElementBrowserModalOpen, emptyStateHandler: emptyStateHandler, mode: mode } = (0, $eiA8Z.useSharedPluginStateWithSelector)(pluginInjectionAPI, [
        'quickInsert',
        'connectivity'
    ], (state)=>({
            lazyDefaultItems: state.quickInsertState?.lazyDefaultItems,
            providedItems: state.quickInsertState?.providedItems,
            isElementBrowserModalOpen: state.quickInsertState?.isElementBrowserModalOpen,
            emptyStateHandler: state.quickInsertState?.emptyStateHandler,
            mode: state.connectivityState?.mode
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4d563301f3da277a$var$Modal, {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        quickInsertState: {
            lazyDefaultItems: lazyDefaultItems,
            providedItems: providedItems,
            isElementBrowserModalOpen: isElementBrowserModalOpen,
            emptyStateHandler: emptyStateHandler
        },
        editorView: editorView,
        helpUrl: helpUrl,
        isOffline: (0, $91bcx.isOfflineMode)(mode),
        insertItem: pluginInjectionAPI?.quickInsert?.actions?.insertItem,
        getSuggestions: pluginInjectionAPI?.quickInsert?.actions?.getSuggestions,
        api: pluginInjectionAPI
    });
};




var $i4oLV = parcelRequire("i4oLV");




const $04a55eb0152aaca0$var$isRegisteredLayoutQuickInsertItem = (item)=>Boolean(item.id && item.id !== 'layout' && item.keywords?.includes('layout') && item.keywords?.includes('column'));
const $04a55eb0152aaca0$var$getLayoutQuickInsertItemIdRank = (items)=>new Map(items.filter($04a55eb0152aaca0$var$isRegisteredLayoutQuickInsertItem).map((item, index)=>[
            item.id,
            index
        ]));
const $04a55eb0152aaca0$var$getQuickInsertItemId = (items, result)=>items[result.idx]?.id;
const $04a55eb0152aaca0$export$e8643d2543db7695 = (prioritySortingFn)=>(items)=>{
        const consumerSortFn = prioritySortingFn?.(items);
        const layoutItemIdRank = $04a55eb0152aaca0$var$getLayoutQuickInsertItemIdRank(items);
        if (layoutItemIdRank.size < 2) return consumerSortFn;
        return (firstItem, secondItem)=>{
            const firstLayoutItemRank = layoutItemIdRank.get($04a55eb0152aaca0$var$getQuickInsertItemId(items, firstItem));
            const secondLayoutItemRank = layoutItemIdRank.get($04a55eb0152aaca0$var$getQuickInsertItemId(items, secondItem));
            if (firstLayoutItemRank !== undefined && secondLayoutItemRank !== undefined) return firstLayoutItemRank - secondLayoutItemRank;
            if (consumerSortFn) return consumerSortFn(firstItem, secondItem);
            return firstItem.score === secondItem.score ? firstItem.idx < secondItem.idx ? -1 : 1 : firstItem.score < secondItem.score ? -1 : 1;
        };
    };
const $04a55eb0152aaca0$export$f7a129a7d10810d3 = (searchOptions, lazyDefaultItems = ()=>[], providedItems)=>{
    // @ts-ignore
    const { query: query, category: category, disableDefaultItems: disableDefaultItems, featuredItems: featuredItems, itemFilter: itemFilter, prioritySortingFn: prioritySortingFn } = searchOptions;
    const defaultItems = disableDefaultItems ? [] : lazyDefaultItems();
    const dedupeFn = (item)=>`${item.title}-${item.description ?? ''}`;
    let items = providedItems ? (0, $i4oLV.dedupe)([
        ...defaultItems,
        ...providedItems
    ], dedupeFn) : defaultItems;
    // EDITOR-6558: apply consumer-supplied filter (e.g. Markdown Mode allowlist).
    if (itemFilter) items = items.filter(itemFilter);
    if (featuredItems) return items.filter((item)=>item.featured);
    return (0, $41f58be4b65e6d82$export$71aa6c912b956294)(((0, $dh538.fg)('platform_editor_fix_space_triggering_ai') ? query?.trimEnd() : query) || '', category === 'all' || !category ? items : items.filter((item)=>item.categories && item.categories.includes(category)), prioritySortingFn);
};


const $dc39a25d0b9ea653$export$2ff93c7de46a9aaa = ({ config: options, api: api })=>{
    const refs = {};
    const onInsert = (item)=>{
        options?.onInsert?.(item);
    };
    const typeAheadPrioritySortingFn = (0, $1oCLl.expValEquals)('platform_editor_layout_typeahead_reorder', 'isEnabled', true) ? (0, $04a55eb0152aaca0$export$e8643d2543db7695)(options?.prioritySortingFn) : options?.prioritySortingFn;
    const typeAhead = {
        id: (0, $lOELb.TypeAheadAvailableNodes).QUICK_INSERT,
        trigger: '/',
        // Support fullwidth slash (U+FF0F) used by Japanese/CJK keyboards (e.g. typing / on a Japanese keyboard layout)
        customRegex: (0, $1oCLl.expValEquals)('platform_editor_wide_slash_trigger', 'isEnabled', true) ? "[/\uFF0F]" : undefined,
        headless: options?.headless,
        getItems ({ query: query, editorState: editorState }) {
            const quickInsertState = (0, $47acf0b419f9d7aa$export$18d4026d1ea86bb1).getState(editorState);
            const items = (0, $04a55eb0152aaca0$export$f7a129a7d10810d3)({
                query: query,
                disableDefaultItems: options?.disableDefaultItems,
                prioritySortingFn: typeAheadPrioritySortingFn,
                // EDITOR-6558: pass through consumer-supplied filter (e.g. Markdown Mode allowlist)
                itemFilter: options?.itemFilter
            }, quickInsertState?.lazyDefaultItems, quickInsertState?.providedItems);
            return Promise.resolve(items);
        },
        getEmptyItem ({ editorState: editorState }) {
            if (!(0, $1oCLl.expValEquals)('platform_editor_insert_menu_ai', 'isEnabled', true)) return undefined;
            const quickInsertState = (0, $47acf0b419f9d7aa$export$18d4026d1ea86bb1).getState(editorState);
            const matches = (0, $04a55eb0152aaca0$export$f7a129a7d10810d3)({
                query: '',
                disableDefaultItems: options?.disableDefaultItems,
                prioritySortingFn: options?.prioritySortingFn,
                itemFilter: (item)=>item.categories?.includes('AI') ?? false
            }, quickInsertState?.lazyDefaultItems, quickInsertState?.providedItems);
            return matches[0];
        },
        selectItem: (state, item, insert)=>{
            const quickInsertItem = item;
            const result = quickInsertItem.action(insert, state);
            if (result) onInsert(quickInsertItem);
            return result;
        },
        getMoreOptionsButtonConfig: options?.enableElementBrowser ? ({ formatMessage: formatMessage })=>{
            return {
                title: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).viewMore),
                ariaLabel: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).viewMoreAriaLabel),
                onClick: (0, $5805149c74b21c1a$export$a37159c5d6f821f5),
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
                    label: ""
                })
            };
        } : undefined
    };
    let intl;
    return {
        name: 'quickInsert',
        pmPlugins (defaultItems) {
            return [
                {
                    name: 'quickInsert',
                    // It's important that this plugin is above TypeAheadPlugin
                    plugin: ({ providerFactory: providerFactory, getIntl: getIntl, dispatch: dispatch })=>$dc39a25d0b9ea653$var$quickInsertPluginFactory(defaultItems, providerFactory, getIntl, dispatch, options?.emptyStateHandler)
                },
                {
                    name: 'quickInsertOpenExperience',
                    plugin: ()=>(0, $641d33b11dd1e4d7$export$399cc8247eb1f3b5)({
                            refs: refs,
                            dispatchAnalyticsEvent: (payload)=>api?.analytics?.actions?.fireAnalyticsEvent(payload)
                        })
                }
            ];
        },
        pluginsOptions: {
            typeAhead: typeAhead
        },
        contentComponent ({ editorView: editorView, popupsMountPoint: popupsMountPoint, wrapperElement: wrapperElement }) {
            refs.popupsMountPoint = popupsMountPoint || undefined;
            refs.wrapperElement = wrapperElement || undefined;
            if (!editorView || (0, $eTj7Y.isSSR)()) return null;
            if (options?.enableElementBrowser) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4d563301f3da277a$export$2e2bcd8739ae039), {
                editorView: editorView,
                helpUrl: options?.elementBrowserHelpUrl,
                pluginInjectionAPI: api
            });
            return null;
        },
        getSharedState (editorState) {
            if (!editorState) return null;
            const quickInsertState = (0, $47acf0b419f9d7aa$export$18d4026d1ea86bb1).getState(editorState);
            if (!quickInsertState) return null;
            return {
                typeAheadHandler: typeAhead,
                lazyDefaultItems: quickInsertState.lazyDefaultItems,
                emptyStateHandler: quickInsertState.emptyStateHandler,
                providedItems: quickInsertState.providedItems,
                isElementBrowserModalOpen: quickInsertState.isElementBrowserModalOpen
            };
        },
        actions: {
            insertItem: (0, $5805149c74b21c1a$export$40b105cb73ed6b94)(onInsert),
            openTypeAhead (inputMethod, removePrefixTriggerOnCancel) {
                return Boolean(api?.typeAhead?.actions.open({
                    triggerHandler: typeAhead,
                    inputMethod: inputMethod,
                    removePrefixTriggerOnCancel: removePrefixTriggerOnCancel
                }));
            },
            getSuggestions: (searchOptions)=>{
                const { lazyDefaultItems: lazyDefaultItems, providedItems: providedItems } = api?.quickInsert?.sharedState.currentState() ?? {};
                if ((0, $1oCLl.expValEquals)('platform_editor_layout_typeahead_reorder', 'isEnabled', true)) searchOptions = {
                    ...searchOptions,
                    prioritySortingFn: (0, $04a55eb0152aaca0$export$e8643d2543db7695)(options?.prioritySortingFn ?? searchOptions.prioritySortingFn)
                };
                else if (options?.prioritySortingFn) searchOptions = {
                    ...searchOptions,
                    prioritySortingFn: options.prioritySortingFn
                };
                // EDITOR-6558: layer the consumer-supplied filter (e.g. Markdown Mode allowlist)
                // over any caller-supplied filter so both apply.
                if (options?.itemFilter) {
                    const consumerFilter = options.itemFilter;
                    const callerFilter = searchOptions.itemFilter;
                    searchOptions = {
                        ...searchOptions,
                        itemFilter: callerFilter ? (item)=>consumerFilter(item) && callerFilter(item) : consumerFilter
                    };
                }
                return (0, $04a55eb0152aaca0$export$f7a129a7d10810d3)(searchOptions, lazyDefaultItems, providedItems);
            }
        },
        commands: {
            openElementBrowserModal: ({ tr: tr })=>{
                if ((0, $dh538.fg)('platform_editor_ease_of_use_metrics')) api?.metrics?.commands.handleIntentToStartEdit({
                    shouldStartTimer: false,
                    shouldPersistActiveSession: true
                })({
                    tr: tr
                });
                return (0, $5805149c74b21c1a$export$a37159c5d6f821f5)({
                    tr: tr
                });
            },
            addQuickInsertItem: (item)=>({ tr: tr })=>{
                    const { lazyDefaultItems: lazyDefaultItems } = api?.quickInsert?.sharedState.currentState() ?? {};
                    const defaultItems = lazyDefaultItems ? lazyDefaultItems() : [];
                    const memoisedNewItems = (0, $41f58be4b65e6d82$export$4fca091f4ee92b6d)([
                        item
                    ], intl);
                    return tr.setMeta((0, $47acf0b419f9d7aa$export$18d4026d1ea86bb1), {
                        lazyDefaultItems: ()=>[
                                ...defaultItems,
                                ...memoisedNewItems
                            ]
                    });
                },
            updateQuickInsertItem: (key, item)=>({ tr: tr })=>{
                    const { providedItems: providedItems, lazyDefaultItems: lazyDefaultItems } = api?.quickInsert?.sharedState.currentState() ?? {};
                    const defaultItems = lazyDefaultItems ? lazyDefaultItems() : [];
                    const newItem = (0, $41f58be4b65e6d82$export$4fca091f4ee92b6d)([
                        item
                    ], intl);
                    const replaceByKey = (items)=>items.flatMap((i)=>i.key === key ? newItem : i);
                    const meta = {};
                    if (defaultItems.some((i)=>i.key === key)) meta.lazyDefaultItems = ()=>replaceByKey(defaultItems);
                    if (providedItems?.some((i)=>i.key === key)) meta.providedItems = replaceByKey(providedItems);
                    return Object.keys(meta).length > 0 ? tr.setMeta((0, $47acf0b419f9d7aa$export$18d4026d1ea86bb1), meta) : tr;
                },
            removeQuickInsertItem: (key)=>({ tr: tr })=>{
                    const { providedItems: providedItems, lazyDefaultItems: lazyDefaultItems } = api?.quickInsert?.sharedState.currentState() ?? {};
                    const defaultItems = lazyDefaultItems ? lazyDefaultItems() : [];
                    return tr.setMeta((0, $47acf0b419f9d7aa$export$18d4026d1ea86bb1), {
                        providedItems: providedItems?.filter((item)=>item.key !== key) ?? [],
                        lazyDefaultItems: ()=>defaultItems.filter((item)=>item.key !== key)
                    });
                }
        },
        usePluginHook: ()=>{
            intl = (0, $aXWIB.useIntl)();
        }
    };
};
const $dc39a25d0b9ea653$var$setProviderState = (providerState)=>(state, dispatch)=>{
        if (dispatch) dispatch(state.tr.setMeta((0, $47acf0b419f9d7aa$export$18d4026d1ea86bb1), providerState));
        return true;
    };
function $dc39a25d0b9ea653$var$quickInsertPluginFactory(defaultItems, providerFactory, getIntl, dispatch, emptyStateHandler) {
    return new (0, $1S4f7.SafePlugin)({
        key: (0, $47acf0b419f9d7aa$export$18d4026d1ea86bb1),
        state: {
            init () {
                return {
                    isElementBrowserModalOpen: false,
                    emptyStateHandler: emptyStateHandler,
                    // lazy so it doesn't run on editor initialization
                    // memo here to avoid using a singleton cache, avoids editor
                    // getting confused when two editors exist within the same page.
                    lazyDefaultItems: ()=>(0, $41f58be4b65e6d82$export$4fca091f4ee92b6d)(defaultItems || [], getIntl())
                };
            },
            apply (tr, pluginState) {
                const meta = tr.getMeta((0, $47acf0b419f9d7aa$export$18d4026d1ea86bb1));
                if (meta) {
                    const keys = Object.keys(meta);
                    const changed = keys.some((key)=>{
                        return pluginState[key] !== meta[key];
                    });
                    if (changed) {
                        const newState = {
                            ...pluginState,
                            ...meta
                        };
                        dispatch((0, $47acf0b419f9d7aa$export$18d4026d1ea86bb1), newState);
                        return newState;
                    }
                }
                return pluginState;
            }
        },
        view (editorView) {
            const providerHandler = async (_name, providerPromise)=>{
                if (providerPromise) try {
                    const provider = await providerPromise;
                    const providedItems = await provider.getItems();
                    $dc39a25d0b9ea653$var$setProviderState({
                        provider: provider,
                        providedItems: providedItems
                    })(editorView.state, editorView.dispatch);
                } catch (e) {
                    // eslint-disable-next-line no-console
                    console.error('Error getting items from quick insert provider', e);
                }
            };
            providerFactory.subscribe('quickInsertProvider', providerHandler);
            return {
                destroy () {
                    providerFactory.unsubscribe('quickInsertProvider', providerHandler);
                }
            };
        }
    });
}
module.exports["quickInsertPlugin"] = $dc39a25d0b9ea653$export$2ff93c7de46a9aaa;

});

parcelRegister("lOELb", function(module, exports) {
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $6h7hA = parcelRequire("6h7hA");

var $1af9d72fee78e0de$export$8c4c885c87e5cc07 = /*#__PURE__*/ function(TypeAheadAvailableNodes) {
    TypeAheadAvailableNodes["EMOJI"] = "emojiTypeAhead";
    TypeAheadAvailableNodes["MENTION"] = "mentionTypeAhead";
    TypeAheadAvailableNodes["QUICK_INSERT"] = "quickInsertTypeAhead";
    return TypeAheadAvailableNodes;
}({});
var $1af9d72fee78e0de$export$4d7d0343c6d95a0e = /*#__PURE__*/ function(SelectItemMode) {
    SelectItemMode["SHIFT_ENTER"] = "shift-enter";
    SelectItemMode["ENTER"] = "enter";
    SelectItemMode["SPACE"] = "space";
    SelectItemMode["SELECTED"] = "selected";
    return SelectItemMode;
}({});
module.exports["TypeAheadAvailableNodes"] = $1af9d72fee78e0de$export$8c4c885c87e5cc07;
module.exports["SelectItemMode"] = $1af9d72fee78e0de$export$4d7d0343c6d95a0e;

});

parcelRegister("j85vL", function(module, exports) {
/**
 * Checks if a given node contains a popup with a nested element identified by a specific test ID.
 *
 * @param node - The node to check.
 * @param nestedElementQuery - The query to look for the nested element.
 * @returns True if the node contains the popup, false otherwise.
 */ const $bb95c0419e99684e$export$34b917212c8a3de1 = (node, nestedElementQuery)=>{
    if (!(node instanceof HTMLElement)) return false;
    // Check if node itself has the popup attribute and contains the element matching the nestedElementQuery
    if (node.matches('[data-editor-popup="true"]')) return !!node.querySelector(nestedElementQuery);
    // Check if any direct child with popup attribute contains the element matching the nestedElementQuery
    return !!node.querySelector(`:scope > [data-editor-popup="true"] ${nestedElementQuery}`);
};
module.exports["containsPopupWithNestedElement"] = $bb95c0419e99684e$export$34b917212c8a3de1;

});

parcelRegister("ism5g", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $4wH3g = parcelRequire("4wH3g");


var $9hlns = parcelRequire("9hlns");

function $27e11d4c6749c332$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $27e11d4c6749c332$var$spinnerContainer = {
    name: "c1gsw5",
    styles: "display:flex;align-items:center;justify-content:center;height:100%;width:100%"
};

const $27e11d4c6749c332$var$ElementBrowserLoader = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "RQhdv",
    name: "ElementBrowserLoader",
    loader: ()=>(parcelRequire("4ajiR")).then((module)=>module.default),
    loading: ()=>/*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: $27e11d4c6749c332$var$spinnerContainer,
            "data-vc": "tbptUptF"
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $9hlns.default), {
            size: "medium",
            interactionName: "element-browser-spinner"
        }))
});
var $27e11d4c6749c332$export$2e2bcd8739ae039 = $27e11d4c6749c332$var$ElementBrowserLoader;
module.exports["default"] = $27e11d4c6749c332$export$2e2bcd8739ae039;

});

parcelRegister("4ajiR", function(module, exports) {

let $308711cdffe9e100$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $308711cdffe9e100$var$load("lkOIY"),
    $308711cdffe9e100$var$load("Wowvf"),
    $308711cdffe9e100$var$load("hhss7"),
    $308711cdffe9e100$var$load("5WLpx")
]).then(()=>parcelRequire('lEolr'));

});

parcelRegister("auDHv", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $30742814a9e05ed7$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    help: {
        id: "fabric.editor.elementBrowser.help",
        defaultMessage: "Help"
    },
    insert: {
        id: "fabric.editor.elementbrowser.modal.insert",
        defaultMessage: "Insert"
    },
    close: {
        id: "fabric.editor.elementbrowser.modal.close",
        defaultMessage: "Close"
    },
    all: {
        id: "fabric.editor.elementbrowser.categorylist.category-all",
        defaultMessage: "All"
    },
    formatting: {
        id: "fabric.editor.elementbrowser.categorylist.category-formatting",
        defaultMessage: "Formatting"
    },
    'confluence-content': {
        id: "fabric.editor.elementbrowser.categorylist.category-confluence-content",
        defaultMessage: "Confluence content"
    },
    media: {
        id: "fabric.editor.elementbrowser.categorylist.category-media",
        defaultMessage: "Media"
    },
    visuals: {
        id: "fabric.editor.elementbrowser.categorylist.category-visuals",
        defaultMessage: "Visuals & images"
    },
    navigation: {
        id: "fabric.editor.elementbrowser.categorylist.category-navigation",
        defaultMessage: "Navigation"
    },
    'external-content': {
        id: "fabric.editor.elementbrowser.categorylist.category-external-content",
        defaultMessage: "External content"
    },
    communication: {
        id: "fabric.editor.elementbrowser.categorylist.category-communication",
        defaultMessage: "Communication"
    },
    reporting: {
        id: "fabric.editor.elementbrowser.categorylist.category-reporting",
        defaultMessage: "Reporting"
    },
    admin: {
        id: "fabric.editor.elementbrowser.categorylist.category-admin",
        defaultMessage: "Administration"
    },
    development: {
        id: "fabric.editor.elementbrowser.categorylist.category-development",
        defaultMessage: "Development"
    },
    AI: {
        id: "fabric.editor.elementbrowser.categorylist.category-ai",
        defaultMessage: "Rovo"
    },
    featuredWhiteboardDescription: {
        id: "fabric.editor.elementbrowser.featured.whiteboard.description",
        defaultMessage: "Use a whiteboard to add visuals to your page"
    },
    browse: {
        id: "fabric.editor.elementbrowser.sidebar.heading",
        defaultMessage: "Browse"
    }
});
module.exports["messages"] = $30742814a9e05ed7$export$defe85febe8b728c;

});

parcelRegister("8EdHV", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $64bcb12b0adeaf8d$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $64bcb12b0adeaf8d$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $64bcb12b0adeaf8d$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$64bcb12b0adeaf8d$var$componentWillMount.__suppressDeprecationWarning = true;
$64bcb12b0adeaf8d$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$64bcb12b0adeaf8d$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $64bcb12b0adeaf8d$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error('Can only polyfill class components');
    if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === 'function') foundWillMountName = 'componentWillMount';
    else if (typeof prototype.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
    if (typeof prototype.componentWillReceiveProps === 'function') foundWillReceivePropsName = 'componentWillReceiveProps';
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
    if (typeof prototype.componentWillUpdate === 'function') foundWillUpdateName = 'componentWillUpdate';
    else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
        throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === 'function') {
        prototype.componentWillMount = $64bcb12b0adeaf8d$var$componentWillMount;
        prototype.componentWillReceiveProps = $64bcb12b0adeaf8d$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
        if (typeof prototype.componentDidUpdate !== 'function') throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
        prototype.componentWillUpdate = $64bcb12b0adeaf8d$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}
module.exports["polyfill"] = $64bcb12b0adeaf8d$export$cea1c58a6db52bca;

});

parcelRegister("iYupH", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $dd056c15be8f4b66$export$2e2bcd8739ae039);
var $472fa34b2539589d$export$2e2bcd8739ae039 = !!(typeof window !== 'undefined' && window.document && window.document.createElement);


var $dd056c15be8f4b66$var$size;
function $dd056c15be8f4b66$export$2e2bcd8739ae039(recalc) {
    if (!$dd056c15be8f4b66$var$size && $dd056c15be8f4b66$var$size !== 0 || recalc) {
        if (0, $472fa34b2539589d$export$2e2bcd8739ae039) {
            var scrollDiv = document.createElement('div');
            scrollDiv.style.position = 'absolute';
            scrollDiv.style.top = '-9999px';
            scrollDiv.style.width = '50px';
            scrollDiv.style.height = '50px';
            scrollDiv.style.overflow = 'scroll';
            document.body.appendChild(scrollDiv);
            $dd056c15be8f4b66$var$size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);
        }
    }
    return $dd056c15be8f4b66$var$size;
}

});

parcelRegister("c2Q7G", function(module, exports) {
function $8c4e1a757a4b8f03$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $8c4e1a757a4b8f03$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("iyK4o", function(module, exports) {

var $atzas = parcelRequire("atzas");

function $d82f23769c011c4d$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $atzas(o.key), o);
    }
}
function $d82f23769c011c4d$var$_createClass(e, r, t) {
    return r && $d82f23769c011c4d$var$_defineProperties(e.prototype, r), t && $d82f23769c011c4d$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports = $d82f23769c011c4d$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("4CXrK", function(module, exports) {

var $crVe8 = parcelRequire("crVe8");

var $35e8d2e58136fe36$var$_typeof = $crVe8.default;

var $gurtx = parcelRequire("gurtx");

function $35e8d2e58136fe36$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $35e8d2e58136fe36$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $gurtx(t);
}
module.exports = $35e8d2e58136fe36$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("18f43", function(module, exports) {
function $0d32394a09e156ce$var$_getPrototypeOf(t) {
    return module.exports = $0d32394a09e156ce$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $0d32394a09e156ce$var$_getPrototypeOf(t);
}
module.exports = $0d32394a09e156ce$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("JL40l", function(module, exports) {

var $gHZmH = parcelRequire("gHZmH");

function $0898b5eece7376ee$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $gHZmH(t, e);
}
module.exports = $0898b5eece7376ee$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("cLwe6", function(module, exports) {
"use strict";

var $eGvGZ = parcelRequire("eGvGZ");

Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "CellMeasurer", {
    enumerable: true,
    get: function get() {
        return $94b2df55097d83d9$var$_CellMeasurer["default"];
    }
});
Object.defineProperty(module.exports, "CellMeasurerCache", {
    enumerable: true,
    get: function get() {
        return $94b2df55097d83d9$var$_CellMeasurerCache["default"];
    }
});
module.exports["default"] = void 0;

var $94b2df55097d83d9$var$_CellMeasurer = $eGvGZ((parcelRequire("4Gybo")));

var $94b2df55097d83d9$var$_CellMeasurerCache = $eGvGZ((parcelRequire("g0BUc")));
var $94b2df55097d83d9$var$_default = module.exports["default"] = $94b2df55097d83d9$var$_CellMeasurer["default"];

});

parcelRegister("4Gybo", function(module, exports) {
"use strict";

var $eGvGZ = parcelRequire("eGvGZ");


var $crVe8 = parcelRequire("crVe8");

Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $369599a346f49d8d$var$_classCallCheck2 = $eGvGZ((parcelRequire("c2Q7G")));

var $369599a346f49d8d$var$_createClass2 = $eGvGZ((parcelRequire("iyK4o")));

var $369599a346f49d8d$var$_possibleConstructorReturn2 = $eGvGZ((parcelRequire("4CXrK")));

var $369599a346f49d8d$var$_getPrototypeOf2 = $eGvGZ((parcelRequire("18f43")));

var $369599a346f49d8d$var$_inherits2 = $eGvGZ((parcelRequire("JL40l")));

var $369599a346f49d8d$var$_defineProperty2 = $eGvGZ((parcelRequire("l2SD1")));

var $369599a346f49d8d$var$_react = $369599a346f49d8d$var$_interopRequireWildcard((parcelRequire("42omo")));
var $369599a346f49d8d$var$React = $369599a346f49d8d$var$_react;
function $369599a346f49d8d$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($369599a346f49d8d$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $369599a346f49d8d$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $crVe8(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $369599a346f49d8d$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $369599a346f49d8d$var$_callSuper(t, o, e) {
    return o = (0, $369599a346f49d8d$var$_getPrototypeOf2["default"])(o), (0, $369599a346f49d8d$var$_possibleConstructorReturn2["default"])(t, $369599a346f49d8d$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $369599a346f49d8d$var$_getPrototypeOf2["default"])(t).constructor) : o.apply(t, e));
}
function $369599a346f49d8d$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($369599a346f49d8d$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
} /*:: import type {CellMeasureCache} from './types';*/ 
/*:: type Children = (params: {measure: () => void}) => React.Element<*>;*/ /*:: type Cell = {
  columnIndex: number,
  rowIndex: number,
};*/ /*:: type Props = {
  cache: CellMeasureCache,
  children: Children | React.Element<*>,
  columnIndex?: number,
  index?: number,
  parent: {
    invalidateCellSizeAfterRender?: (cell: Cell) => void,
    recomputeGridSize?: (cell: Cell) => void,
  },
  rowIndex?: number,
};*/ /**
 * Wraps a cell and measures its rendered content.
 * Measurements are stored in a per-cell cache.
 * Cached-content is not be re-measured.
 */ var $369599a346f49d8d$var$CellMeasurer = module.exports["default"] = /*#__PURE__*/ function(_React$PureComponent) {
    function CellMeasurer() {
        var _this;
        (0, $369599a346f49d8d$var$_classCallCheck2["default"])(this, CellMeasurer);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $369599a346f49d8d$var$_callSuper(this, CellMeasurer, [].concat(args));
        (0, $369599a346f49d8d$var$_defineProperty2["default"])(_this, "_child", /*#__PURE__*/ $369599a346f49d8d$var$React.createRef());
        (0, $369599a346f49d8d$var$_defineProperty2["default"])(_this, "_measure", function() {
            var _this$props = _this.props, cache = _this$props.cache, _this$props$columnInd = _this$props.columnIndex, columnIndex = _this$props$columnInd === void 0 ? 0 : _this$props$columnInd, parent = _this$props.parent, _this$props$rowIndex = _this$props.rowIndex, rowIndex = _this$props$rowIndex === void 0 ? _this.props.index || 0 : _this$props$rowIndex;
            var _this$_getCellMeasure = _this._getCellMeasurements(), height = _this$_getCellMeasure.height, width = _this$_getCellMeasure.width;
            if (height !== cache.getHeight(rowIndex, columnIndex) || width !== cache.getWidth(rowIndex, columnIndex)) {
                cache.set(rowIndex, columnIndex, width, height);
                if (parent && typeof parent.recomputeGridSize === 'function') parent.recomputeGridSize({
                    columnIndex: columnIndex,
                    rowIndex: rowIndex
                });
            }
        });
        (0, $369599a346f49d8d$var$_defineProperty2["default"])(_this, "_registerChild", function(element) {
            if (element && !(element instanceof Element)) console.warn('CellMeasurer registerChild expects to be passed Element or null');
            _this._child.current = element;
            if (element) _this._maybeMeasureCell();
        });
        return _this;
    }
    (0, $369599a346f49d8d$var$_inherits2["default"])(CellMeasurer, _React$PureComponent);
    return (0, $369599a346f49d8d$var$_createClass2["default"])(CellMeasurer, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this._maybeMeasureCell();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this._maybeMeasureCell();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var children = this.props.children;
                var resolvedChildren = typeof children === 'function' ? children({
                    measure: this._measure,
                    registerChild: this._registerChild
                }) : children;
                if (resolvedChildren === null) return resolvedChildren;
                return /*#__PURE__*/ (0, $369599a346f49d8d$var$_react.cloneElement)(resolvedChildren, {
                    ref: function ref(node) {
                        if (typeof resolvedChildren.ref === 'function') resolvedChildren.ref(node);
                        else if (resolvedChildren.ref) resolvedChildren.ref.current = node;
                        _this2._child.current = node;
                    }
                });
            }
        },
        {
            key: "_getCellMeasurements",
            value: function _getCellMeasurements() {
                var cache = this.props.cache;
                var node = this._child.current;
                // TODO Check for a bad combination of fixedWidth and missing numeric width or vice versa with height
                if (node && node.ownerDocument && node.ownerDocument.defaultView && node instanceof node.ownerDocument.defaultView.HTMLElement) {
                    var styleWidth = node.style.width;
                    var styleHeight = node.style.height;
                    // If we are re-measuring a cell that has already been measured,
                    // It will have a hard-coded width/height from the previous measurement.
                    // The fact that we are measuring indicates this measurement is probably stale,
                    // So explicitly clear it out (eg set to "auto") so we can recalculate.
                    // See issue #593 for more info.
                    // Even if we are measuring initially- if we're inside of a MultiGrid component,
                    // Explicitly clear width/height before measuring to avoid being tainted by another Grid.
                    // eg top/left Grid renders before bottom/right Grid
                    // Since the CellMeasurerCache is shared between them this taints derived cell size values.
                    if (!cache.hasFixedWidth()) node.style.width = 'auto';
                    if (!cache.hasFixedHeight()) node.style.height = 'auto';
                    var height = Math.ceil(node.offsetHeight);
                    var width = Math.ceil(node.offsetWidth);
                    // Reset after measuring to avoid breaking styles; see #660
                    if (styleWidth) node.style.width = styleWidth;
                    if (styleHeight) node.style.height = styleHeight;
                    return {
                        height: height,
                        width: width
                    };
                } else return {
                    height: 0,
                    width: 0
                };
            }
        },
        {
            key: "_maybeMeasureCell",
            value: function _maybeMeasureCell() {
                var _this$props2 = this.props, cache = _this$props2.cache, _this$props2$columnIn = _this$props2.columnIndex, columnIndex = _this$props2$columnIn === void 0 ? 0 : _this$props2$columnIn, parent = _this$props2.parent, _this$props2$rowIndex = _this$props2.rowIndex, rowIndex = _this$props2$rowIndex === void 0 ? this.props.index || 0 : _this$props2$rowIndex;
                if (!cache.has(rowIndex, columnIndex)) {
                    var _this$_getCellMeasure2 = this._getCellMeasurements(), height = _this$_getCellMeasure2.height, width = _this$_getCellMeasure2.width;
                    cache.set(rowIndex, columnIndex, width, height);
                    // If size has changed, let Grid know to re-render.
                    if (parent && typeof parent.invalidateCellSizeAfterRender === 'function') parent.invalidateCellSizeAfterRender({
                        columnIndex: columnIndex,
                        rowIndex: rowIndex
                    });
                }
            }
        }
    ]);
}($369599a346f49d8d$var$React.PureComponent); // Used for DEV mode warning check
(0, $369599a346f49d8d$var$_defineProperty2["default"])($369599a346f49d8d$var$CellMeasurer, "__internalCellMeasurerFlag", false);

});

parcelRegister("g0BUc", function(module, exports) {
"use strict";

var $eGvGZ = parcelRequire("eGvGZ");

Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = module.exports.DEFAULT_WIDTH = module.exports.DEFAULT_HEIGHT = void 0;

var $ba7a0cacf1ccba14$var$_classCallCheck2 = $eGvGZ((parcelRequire("c2Q7G")));

var $ba7a0cacf1ccba14$var$_createClass2 = $eGvGZ((parcelRequire("iyK4o")));

var $ba7a0cacf1ccba14$var$_defineProperty2 = $eGvGZ((parcelRequire("l2SD1")));
/*:: import type {CellMeasureCache} from './types';*/ var $ba7a0cacf1ccba14$var$DEFAULT_HEIGHT = module.exports.DEFAULT_HEIGHT = 30;
var $ba7a0cacf1ccba14$var$DEFAULT_WIDTH = module.exports.DEFAULT_WIDTH = 100;
// Enables more intelligent mapping of a given column and row index to an item ID.
// This prevents a cell cache from being invalidated when its parent collection is modified.
/*:: type KeyMapper = (rowIndex: number, columnIndex: number) => any;*/ /*:: type CellMeasurerCacheParams = {
  defaultHeight?: number,
  defaultWidth?: number,
  fixedHeight?: boolean,
  fixedWidth?: boolean,
  minHeight?: number,
  minWidth?: number,
  keyMapper?: KeyMapper,
};*/ /*:: type Cache = {
  [key: any]: number,
};*/ /*:: type IndexParam = {
  index: number,
};*/ /**
 * Caches measurements for a given cell.
 */ var $ba7a0cacf1ccba14$var$CellMeasurerCache = module.exports["default"] = /*#__PURE__*/ function() {
    function CellMeasurerCache() {
        var _this = this;
        var params /*: CellMeasurerCacheParams*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $ba7a0cacf1ccba14$var$_classCallCheck2["default"])(this, CellMeasurerCache);
        (0, $ba7a0cacf1ccba14$var$_defineProperty2["default"])(this, "_cellHeightCache", {});
        (0, $ba7a0cacf1ccba14$var$_defineProperty2["default"])(this, "_cellWidthCache", {});
        (0, $ba7a0cacf1ccba14$var$_defineProperty2["default"])(this, "_columnWidthCache", {});
        (0, $ba7a0cacf1ccba14$var$_defineProperty2["default"])(this, "_rowHeightCache", {});
        (0, $ba7a0cacf1ccba14$var$_defineProperty2["default"])(this, "_defaultHeight", void 0);
        (0, $ba7a0cacf1ccba14$var$_defineProperty2["default"])(this, "_defaultWidth", void 0);
        (0, $ba7a0cacf1ccba14$var$_defineProperty2["default"])(this, "_minHeight", void 0);
        (0, $ba7a0cacf1ccba14$var$_defineProperty2["default"])(this, "_minWidth", void 0);
        (0, $ba7a0cacf1ccba14$var$_defineProperty2["default"])(this, "_keyMapper", void 0);
        (0, $ba7a0cacf1ccba14$var$_defineProperty2["default"])(this, "_hasFixedHeight", void 0);
        (0, $ba7a0cacf1ccba14$var$_defineProperty2["default"])(this, "_hasFixedWidth", void 0);
        (0, $ba7a0cacf1ccba14$var$_defineProperty2["default"])(this, "_columnCount", 0);
        (0, $ba7a0cacf1ccba14$var$_defineProperty2["default"])(this, "_rowCount", 0);
        (0, $ba7a0cacf1ccba14$var$_defineProperty2["default"])(this, "columnWidth", function(_ref /*:: */ ) {
            var index = _ref /*:: */ .index;
            var key = _this._keyMapper(0, index);
            return _this._columnWidthCache[key] !== undefined ? _this._columnWidthCache[key] : _this._defaultWidth;
        });
        (0, $ba7a0cacf1ccba14$var$_defineProperty2["default"])(this, "rowHeight", function(_ref2 /*:: */ ) {
            var index = _ref2 /*:: */ .index;
            var key = _this._keyMapper(index, 0);
            return _this._rowHeightCache[key] !== undefined ? _this._rowHeightCache[key] : _this._defaultHeight;
        });
        var defaultHeight = params.defaultHeight, defaultWidth = params.defaultWidth, fixedHeight = params.fixedHeight, fixedWidth = params.fixedWidth, keyMapper = params.keyMapper, minHeight = params.minHeight, minWidth = params.minWidth;
        this._hasFixedHeight = fixedHeight === true;
        this._hasFixedWidth = fixedWidth === true;
        this._minHeight = minHeight || 0;
        this._minWidth = minWidth || 0;
        this._keyMapper = keyMapper || $ba7a0cacf1ccba14$var$defaultKeyMapper;
        this._defaultHeight = Math.max(this._minHeight, typeof defaultHeight === 'number' ? defaultHeight : $ba7a0cacf1ccba14$var$DEFAULT_HEIGHT);
        this._defaultWidth = Math.max(this._minWidth, typeof defaultWidth === 'number' ? defaultWidth : $ba7a0cacf1ccba14$var$DEFAULT_WIDTH);
    }
    return (0, $ba7a0cacf1ccba14$var$_createClass2["default"])(CellMeasurerCache, [
        {
            key: "clear",
            value: function clear(rowIndex /*: number*/ ) {
                var columnIndex /*: number*/  = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                var key = this._keyMapper(rowIndex, columnIndex);
                delete this._cellHeightCache[key];
                delete this._cellWidthCache[key];
                this._updateCachedColumnAndRowSizes(rowIndex, columnIndex);
            }
        },
        {
            key: "clearAll",
            value: function clearAll() {
                this._cellHeightCache = {};
                this._cellWidthCache = {};
                this._columnWidthCache = {};
                this._rowHeightCache = {};
                this._rowCount = 0;
                this._columnCount = 0;
            }
        },
        {
            key: "defaultHeight",
            get: function get() /*: number*/ {
                return this._defaultHeight;
            }
        },
        {
            key: "defaultWidth",
            get: function get() /*: number*/ {
                return this._defaultWidth;
            }
        },
        {
            key: "hasFixedHeight",
            value: function hasFixedHeight() /*: boolean*/ {
                return this._hasFixedHeight;
            }
        },
        {
            key: "hasFixedWidth",
            value: function hasFixedWidth() /*: boolean*/ {
                return this._hasFixedWidth;
            }
        },
        {
            key: "getHeight",
            value: function getHeight(rowIndex /*: number*/ ) /*: number*/ {
                var columnIndex /*: number*/  = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                if (this._hasFixedHeight) return this._defaultHeight;
                else {
                    var _key = this._keyMapper(rowIndex, columnIndex);
                    return this._cellHeightCache[_key] !== undefined ? Math.max(this._minHeight, this._cellHeightCache[_key]) : this._defaultHeight;
                }
            }
        },
        {
            key: "getWidth",
            value: function getWidth(rowIndex /*: number*/ ) /*: number*/ {
                var columnIndex /*: number*/  = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                if (this._hasFixedWidth) return this._defaultWidth;
                else {
                    var _key2 = this._keyMapper(rowIndex, columnIndex);
                    return this._cellWidthCache[_key2] !== undefined ? Math.max(this._minWidth, this._cellWidthCache[_key2]) : this._defaultWidth;
                }
            }
        },
        {
            key: "has",
            value: function has(rowIndex /*: number*/ ) /*: boolean*/ {
                var columnIndex /*: number*/  = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                var key = this._keyMapper(rowIndex, columnIndex);
                return this._cellHeightCache[key] !== undefined;
            }
        },
        {
            key: "set",
            value: function set(rowIndex /*: number*/ , columnIndex /*: number*/ , width /*: number*/ , height /*: number*/ ) /*: void*/ {
                var key = this._keyMapper(rowIndex, columnIndex);
                if (columnIndex >= this._columnCount) this._columnCount = columnIndex + 1;
                if (rowIndex >= this._rowCount) this._rowCount = rowIndex + 1;
                // Size is cached per cell so we don't have to re-measure if cells are re-ordered.
                this._cellHeightCache[key] = height;
                this._cellWidthCache[key] = width;
                this._updateCachedColumnAndRowSizes(rowIndex, columnIndex);
            }
        },
        {
            key: "_updateCachedColumnAndRowSizes",
            value: function _updateCachedColumnAndRowSizes(rowIndex /*: number*/ , columnIndex /*: number*/ ) {
                // :columnWidth and :rowHeight are derived based on all cells in a column/row.
                // Pre-cache these derived values for faster lookup later.
                // Reads are expected to occur more frequently than writes in this case.
                // Only update non-fixed dimensions though to avoid doing unnecessary work.
                if (!this._hasFixedWidth) {
                    var columnWidth = 0;
                    for(var i = 0; i < this._rowCount; i++)columnWidth = Math.max(columnWidth, this.getWidth(i, columnIndex));
                    var columnKey = this._keyMapper(0, columnIndex);
                    this._columnWidthCache[columnKey] = columnWidth;
                }
                if (!this._hasFixedHeight) {
                    var rowHeight = 0;
                    for(var _i = 0; _i < this._columnCount; _i++)rowHeight = Math.max(rowHeight, this.getHeight(rowIndex, _i));
                    var rowKey = this._keyMapper(rowIndex, 0);
                    this._rowHeightCache[rowKey] = rowHeight;
                }
            }
        }
    ]);
}();
function $ba7a0cacf1ccba14$var$defaultKeyMapper(rowIndex /*: number*/ , columnIndex /*: number*/ ) {
    return "".concat(rowIndex, "-").concat(columnIndex);
}

});

parcelRegister("158AJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $8cb544b5ac994e0a$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $42omo = parcelRequire("42omo");


var $1R4Hk = parcelRequire("1R4Hk");

function $8cb544b5ac994e0a$export$2e2bcd8739ae039() {
    const { iconThemed: iconThemed } = (0, $1R4Hk.useIconThemed)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        focusable: "false",
        "aria-hidden": true,
        width: 40,
        height: 40,
        viewBox: "0 0 40 40",
        "data-vc": "TQCxVXwG"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("linearGradient", {
        x1: "-26.046%",
        y1: "100%",
        x2: "62.626%",
        y2: "0%",
        id: "fallback-a"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        stopColor: "#B3BAC5",
        offset: "0%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        stopColor: "#A5ADBA",
        offset: "100%"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("linearGradient", {
        x1: "-12.24%",
        y1: "100%",
        x2: "82.44%",
        y2: "0%",
        id: "fallback-b"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        stopColor: "#5A6977",
        offset: "0%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("stop", {
        stopColor: "#454F59",
        offset: "100%"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: iconThemed({
            light: '#FFF',
            dark: '#161A1D'
        }),
        d: "M0 0h40v40H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: iconThemed({
            light: '#DFE1E6',
            dark: '#738496'
        }),
        d: "M20 16h12v12H20z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: iconThemed({
            light: 'url(#fallback-a)',
            dark: 'url(#fallback-b)'
        }),
        d: "M8 16h12v12H8z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        d: "M20 16c-4 .5-6.029 2.5-6.086 6-.057 3.5-2.028 5.5-5.914 6h12V16z",
        fill: iconThemed({
            light: '#A5ADBA',
            dark: '#454F59'
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: iconThemed({
            light: '#B3BAC5',
            dark: '#454F59'
        }),
        d: "M17.5 13h5v3h-5z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: iconThemed({
            light: '#A5ADBA',
            dark: '#454F59'
        }),
        d: "M10 13h5v3h-5z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        fill: iconThemed({
            light: '#DFE1E6',
            dark: '#738496'
        }),
        d: "M25 13h5v3h-5z"
    })));
}

});

parcelRegister("5mDFx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $lu7Ub = parcelRequire("lu7Ub");

var $a2CNw = parcelRequire("a2CNw");

var $dd67x = parcelRequire("dd67x");

var $bJD2s = parcelRequire("bJD2s");

var $ip8b2 = parcelRequire("ip8b2");

var $gKyPs = parcelRequire("gKyPs");


var $dh538 = parcelRequire("dh538");


var $iu6m9 = parcelRequire("iu6m9");


var $d925B = parcelRequire("d925B");


var $b167b = parcelRequire("b167b");


var $b6bhi = parcelRequire("b6bhi");


var $ks2lK = parcelRequire("ks2lK");


var $7XFGZ = parcelRequire("7XFGZ");




const $fd66d12c7d1bd84a$export$21e1076136e25038 = (markType, api, // eslint-disable-next-line @typescript-eslint/no-explicit-any
attrs)=>({ tr: tr })=>{
        const mark = markType.create(attrs);
        // For cursor selections we can use the default behaviour.
        if (tr.selection instanceof (0, $ks2lK.TextSelection) && tr.selection.$cursor) {
            if (mark.isInSet(tr.storedMarks || tr.selection.$cursor.marks())) tr.removeStoredMark(mark);
            else tr.addStoredMark(mark);
            return tr;
        }
        return $fd66d12c7d1bd84a$var$nextToggleMarkInRange(mark, api)({
            tr: tr
        });
    };
const $fd66d12c7d1bd84a$var$nextToggleMarkInRange = (mark, api)=>({ tr: tr })=>{
        if (tr.selection instanceof (0, $7XFGZ.CellSelection)) {
            let removeMark = true;
            const cells = [];
            tr.selection.forEachCell((cell, cellPos)=>{
                cells.push({
                    node: cell,
                    pos: cellPos
                });
                const from = cellPos;
                const to = cellPos + cell.nodeSize;
                removeMark && (removeMark = (0, $b6bhi.entireSelectionContainsMark)(mark, tr.doc, from, to));
            });
            for(let i = cells.length - 1; i >= 0; i--){
                const cell = cells[i];
                const from = cell.pos;
                const to = from + cell.node.nodeSize;
                $fd66d12c7d1bd84a$export$2b94ea0e39917015(from, to, removeMark, mark, tr, api);
            }
        } else {
            const { $from: $from, $to: $to } = tr.selection;
            // We decide to remove the mark only if the entire selection contains the mark
            // Examples with *bold* text
            // Scenario 1: Selection contains both bold and non-bold text -> bold entire selection
            // Scenario 2: Selection contains only bold text -> un-bold entire selection
            // Scenario 3: Selection contains no bold text -> bold entire selection
            const removeMark = (0, $b6bhi.entireSelectionContainsMark)(mark, tr.doc, $from.pos, $to.pos);
            $fd66d12c7d1bd84a$export$2b94ea0e39917015($from.pos, $to.pos, removeMark, mark, tr, api);
        }
        if (tr.docChanged) return tr;
        return null;
    };
const $fd66d12c7d1bd84a$export$2b94ea0e39917015 = (from, to, removeMark, mark, tr, api)=>{
    const { schema: schema } = tr.doc.type;
    const { code: code } = schema.marks;
    if (mark.type === code) api?.base?.actions?.resolveMarks(from, to, tr);
    /**
	 * We should refactor this so text formatting doesn't reference plugins it doesn't know about.
	 */ tr.doc.nodesBetween(tr.mapping.map(from), tr.mapping.map(to), (node, pos)=>{
        if ((0, $dh538.fg)('editor_inline_comments_on_inline_nodes')) {
            if (!node.isText) {
                const isAllowedInlineNode = [
                    'emoji',
                    'status',
                    'date',
                    'mention',
                    'inlineCard'
                ].includes(node.type.name);
                if (!isAllowedInlineNode) return true;
            }
        } else {
            if (!node.isText) return true;
        }
        // This is an issue when the user selects some text.
        // We need to check if the current node position is less than the range selection from.
        // If it’s true, that means we should apply the mark using the range selection,
        // not the current node position.
        const nodeBetweenFrom = Math.max(pos, tr.mapping.map(from));
        const nodeBetweenTo = Math.min(pos + node.nodeSize, tr.mapping.map(to));
        if (removeMark) tr.removeMark(nodeBetweenFrom, nodeBetweenTo, mark);
        else tr.addMark(nodeBetweenFrom, nodeBetweenTo, mark);
        return true;
    });
    return tr;
};


const $bb3f69b8f70e233b$export$3032060d929f850a = ({ tr: tr })=>{
    const { em: em } = tr.doc.type.schema.marks;
    if (!em) // No transaction to apply
    return null;
    return (0, $b167b.toggleMark)(em)({
        tr: tr
    });
};
const $bb3f69b8f70e233b$export$fe8278eb0d365433 = (editorAnalyticsApi)=>(inputMethod)=>({ tr: tr })=>{
            const newTr = $bb3f69b8f70e233b$export$3032060d929f850a({
                tr: tr
            });
            if (!newTr) // No transaction to apply
            return null;
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $d925B.ACTION).FORMATTED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_ITALIC,
                attributes: {
                    inputMethod: inputMethod
                }
            })(newTr);
            return newTr;
        };
const $bb3f69b8f70e233b$export$2670450dfa0f0caf = ({ tr: tr })=>{
    const { strike: strike } = tr.doc.type.schema.marks;
    if (!strike) // No transaction to apply
    return null;
    return (0, $b167b.toggleMark)(strike)({
        tr: tr
    });
};
const $bb3f69b8f70e233b$export$f08ef336cb688397 = (editorAnalyticsApi)=>(inputMethod)=>({ tr: tr })=>{
            const newTr = $bb3f69b8f70e233b$export$2670450dfa0f0caf({
                tr: tr
            });
            if (!newTr) // No transaction to apply
            return null;
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $d925B.ACTION).FORMATTED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_STRIKE,
                attributes: {
                    inputMethod: inputMethod
                }
            })(newTr);
            return newTr;
        };
const $bb3f69b8f70e233b$export$52f111485e4791e7 = ({ tr: tr })=>{
    const { strong: strong } = tr.doc.type.schema.marks;
    if (!strong) // No transaction to apply
    return null;
    return (0, $b167b.toggleMark)(strong)({
        tr: tr
    });
};
const $bb3f69b8f70e233b$export$686bc7c29753e27 = (editorAnalyticsApi)=>(inputMethod)=>({ tr: tr })=>{
            const newTr = $bb3f69b8f70e233b$export$52f111485e4791e7({
                tr: tr
            });
            if (!newTr) // No transaction to apply
            return null;
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $d925B.ACTION).FORMATTED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_STRONG,
                attributes: {
                    inputMethod: inputMethod
                }
            })(newTr);
            return newTr;
        };
const $bb3f69b8f70e233b$export$6bcc93697958b66d = ({ tr: tr })=>{
    const { underline: underline } = tr.doc.type.schema.marks;
    if (!underline) // No transaction to apply
    return null;
    return (0, $b167b.toggleMark)(underline)({
        tr: tr
    });
};
const $bb3f69b8f70e233b$export$bf3c86b5abdb857d = (editorAnalyticsApi)=>(inputMethod)=>({ tr: tr })=>{
            const newTr = $bb3f69b8f70e233b$export$6bcc93697958b66d({
                tr: tr
            });
            if (!newTr) // No transaction to apply
            return null;
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $d925B.ACTION).FORMATTED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_UNDERLINE,
                attributes: {
                    inputMethod: inputMethod
                }
            })(newTr);
            return newTr;
        };
const $bb3f69b8f70e233b$export$4af6b58e12324fd = ({ tr: tr })=>{
    const { subsup: subsup } = tr.doc.type.schema.marks;
    if (!subsup) // No transaction to apply
    return null;
    return (0, $b167b.toggleMark)(subsup, {
        type: 'sup'
    })({
        tr: tr
    });
};
const $bb3f69b8f70e233b$export$ca1c98793b67ba6b = (editorAnalyticsApi)=>(inputMethod)=>({ tr: tr })=>{
            const newTr = $bb3f69b8f70e233b$export$4af6b58e12324fd({
                tr: tr
            });
            if (!newTr) // No transaction to apply
            return null;
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $d925B.ACTION).FORMATTED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_SUPER,
                attributes: {
                    inputMethod: inputMethod
                }
            })(newTr);
            return newTr;
        };
const $bb3f69b8f70e233b$export$d26ab98fee0c804 = ({ tr: tr })=>{
    const { subsup: subsup } = tr.doc.type.schema.marks;
    if (!subsup) // No transaction to apply
    return null;
    return (0, $b167b.toggleMark)(subsup, {
        type: 'sub'
    })({
        tr: tr
    });
};
const $bb3f69b8f70e233b$export$8d0c92ae27a193 = (editorAnalyticsApi)=>(inputMethod)=>({ tr: tr })=>{
            const newTr = $bb3f69b8f70e233b$export$d26ab98fee0c804({
                tr: tr
            });
            if (!newTr) // No transaction to apply
            return null;
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $d925B.ACTION).FORMATTED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_SUB,
                attributes: {
                    inputMethod: inputMethod
                }
            })(newTr);
            return newTr;
        };
const $bb3f69b8f70e233b$export$70686c6e7e15ed46 = ({ api: api })=>({ tr: tr })=>{
        const { code: code } = tr.doc.type.schema.marks;
        if (!code) // No transaction to apply
        return null;
        return (0, $fd66d12c7d1bd84a$export$21e1076136e25038)(code, api)({
            tr: tr
        });
    };
const $bb3f69b8f70e233b$export$2d4f5a54f840ba91 = (editorAnalyticsApi, api)=>(inputMethod)=>({ tr: tr })=>{
            const newTr = $bb3f69b8f70e233b$export$70686c6e7e15ed46({
                api: api
            })({
                tr: tr
            });
            if (!newTr) // No transaction to apply
            return null;
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $d925B.ACTION).FORMATTED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_CODE,
                attributes: {
                    inputMethod: inputMethod
                }
            })(newTr);
            return newTr;
        };



var $1S4f7 = parcelRequire("1S4f7");





var $8DwGl = parcelRequire("8DwGl");





var $aXG5V = parcelRequire("aXG5V");




const $467b749fb75a6d67$export$bd443c1dba3019b8 = (selection, doc, f, startPos)=>{
    selection.forEachCell((cell, cellPos)=>{
        doc.nodesBetween(cellPos, cellPos + cell.nodeSize, f, startPos);
    });
};


const $259f2a142ea36336$export$a5cb0c20bd02ce0c = [
    'heading',
    'blockquote'
];
const $259f2a142ea36336$export$73b50f8f13648c71 = [
    'em',
    'code',
    'strike',
    'strong',
    'underline',
    'textColor',
    'subsup',
    'backgroundColor'
];
const $259f2a142ea36336$var$formatTypes = {
    em: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_ITALIC,
    code: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_CODE,
    strike: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_STRIKE,
    strong: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_STRONG,
    underline: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_UNDERLINE,
    textColor: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_COLOR,
    subsup: 'subsup',
    backgroundColor: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_BACKGROUND_COLOR
};
function $259f2a142ea36336$export$332a1f720fc2ba0(inputMethod, editorAnalyticsAPI) {
    return $259f2a142ea36336$export$195de5d8e201efd7(inputMethod, editorAnalyticsAPI);
}
const $259f2a142ea36336$var$clearNodeFormattingOnSelectionNext = (schema, tr, formattedNodeType, nodeName, formattingCleared)=>{
    return function(node, pos) {
        if (node.type === formattedNodeType) {
            if (formattedNodeType.isTextblock) {
                tr.setNodeMarkup(pos, schema.nodes.paragraph);
                formattingCleared.push(nodeName);
                return false;
            } else {
                // In case of panel or blockquote
                const fromPos = tr.doc.resolve(pos + 1);
                const toPos = tr.doc.resolve(pos + node.nodeSize - 1);
                const nodeRange = fromPos.blockRange(toPos);
                if (nodeRange) {
                    const targetLiftDepth = (0, $aXG5V.liftTarget)(nodeRange);
                    if (targetLiftDepth || targetLiftDepth === 0) {
                        formattingCleared.push(nodeName);
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        tr.lift(nodeRange, targetLiftDepth);
                    }
                }
            }
        }
        return true;
    };
};
function $259f2a142ea36336$var$clearNodeFormattingOnSelection(state, tr, formattedNodeType, nodeName, formattingCleared) {
    return function(node, pos) {
        if (node.type === formattedNodeType) {
            if (formattedNodeType.isTextblock) {
                tr.setNodeMarkup(pos, state.schema.nodes.paragraph);
                formattingCleared.push(nodeName);
                return false;
            } else {
                // In case of panel or blockquote
                const fromPos = tr.doc.resolve(pos + 1);
                const toPos = tr.doc.resolve(pos + node.nodeSize - 1);
                const nodeRange = fromPos.blockRange(toPos);
                if (nodeRange) {
                    const targetLiftDepth = (0, $aXG5V.liftTarget)(nodeRange);
                    if (targetLiftDepth || targetLiftDepth === 0) {
                        formattingCleared.push(nodeName);
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        tr.lift(nodeRange, targetLiftDepth);
                    }
                }
            }
        }
        return true;
    };
}
function $259f2a142ea36336$export$195de5d8e201efd7(inputMethod, editorAnalyticsAPI) {
    return function(state, dispatch) {
        const { tr: tr } = state;
        const formattingCleared = [];
        $259f2a142ea36336$export$73b50f8f13648c71.forEach((mark)=>{
            const { from: from, to: to } = tr.selection;
            const markType = state.schema.marks[mark];
            if (!markType) return;
            if (tr.selection instanceof (0, $7XFGZ.CellSelection)) (0, $467b749fb75a6d67$export$bd443c1dba3019b8)(tr.selection, tr.doc, (node, pos)=>{
                const isTableCell = node.type === state.schema.nodes.tableCell || node.type === state.schema.nodes.tableHeader;
                if (!isTableCell) return true;
                if (tr.doc.rangeHasMark(pos, pos + node.nodeSize, markType)) {
                    formattingCleared.push($259f2a142ea36336$var$formatTypes[mark]);
                    tr.removeMark(pos, pos + node.nodeSize, markType);
                }
                return false;
            });
            else if (tr.doc.rangeHasMark(from, to, markType)) {
                formattingCleared.push($259f2a142ea36336$var$formatTypes[mark]);
                tr.removeMark(from, to, markType);
            }
        });
        $259f2a142ea36336$export$a5cb0c20bd02ce0c.forEach((nodeName)=>{
            const formattedNodeType = state.schema.nodes[nodeName];
            const { $from: $from, $to: $to } = tr.selection;
            if (tr.selection instanceof (0, $7XFGZ.CellSelection)) (0, $467b749fb75a6d67$export$bd443c1dba3019b8)(tr.selection, tr.doc, $259f2a142ea36336$var$clearNodeFormattingOnSelection(state, tr, formattedNodeType, nodeName, formattingCleared));
            else tr.doc.nodesBetween($from.pos, $to.pos, $259f2a142ea36336$var$clearNodeFormattingOnSelection(state, tr, formattedNodeType, nodeName, formattingCleared));
        });
        tr.setStoredMarks([]);
        if (formattingCleared.length && inputMethod) editorAnalyticsAPI?.attachAnalyticsEvent({
            action: (0, $d925B.ACTION).FORMATTED,
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_CLEAR,
            attributes: {
                inputMethod: inputMethod,
                formattingCleared: formattingCleared,
                dropdownMenu: inputMethod === (0, $d925B.INPUT_METHOD).TOOLBAR || inputMethod === (0, $d925B.INPUT_METHOD).FLOATING_TB ? 'textFormatting' : undefined
            }
        })(tr);
        if (dispatch) dispatch(tr);
        return true;
    };
}
const $259f2a142ea36336$export$38c6848f9e966bd5 = (editorAnalyticsApi)=>(inputMethod)=>({ tr: tr })=>{
            const formattingCleared = [];
            const { schema: schema } = tr.doc.type;
            $259f2a142ea36336$export$73b50f8f13648c71.forEach((mark)=>{
                const { from: from, to: to } = tr.selection;
                const markType = schema.marks[mark];
                if (!markType) return;
                if (tr.selection instanceof (0, $7XFGZ.CellSelection)) (0, $467b749fb75a6d67$export$bd443c1dba3019b8)(tr.selection, tr.doc, (node, pos)=>{
                    const isTableCell = node.type === tr.doc.type.schema.nodes.tableCell || node.type === schema.nodes.tableHeader;
                    if (!isTableCell) return true;
                    if (tr.doc.rangeHasMark(pos, pos + node.nodeSize, markType)) {
                        formattingCleared.push($259f2a142ea36336$var$formatTypes[mark]);
                        tr.removeMark(pos, pos + node.nodeSize, markType);
                    }
                    return false;
                });
                else if (tr.doc.rangeHasMark(from, to, markType)) {
                    formattingCleared.push($259f2a142ea36336$var$formatTypes[mark]);
                    tr.removeMark(from, to, markType);
                }
            });
            $259f2a142ea36336$export$a5cb0c20bd02ce0c.forEach((nodeName)=>{
                const formattedNodeType = schema.nodes[nodeName];
                const { $from: $from, $to: $to } = tr.selection;
                if (tr.selection instanceof (0, $7XFGZ.CellSelection)) (0, $467b749fb75a6d67$export$bd443c1dba3019b8)(tr.selection, tr.doc, $259f2a142ea36336$var$clearNodeFormattingOnSelectionNext(schema, tr, formattedNodeType, nodeName, formattingCleared));
                else tr.doc.nodesBetween($from.pos, $to.pos, $259f2a142ea36336$var$clearNodeFormattingOnSelectionNext(schema, tr, formattedNodeType, nodeName, formattingCleared));
            });
            tr.setStoredMarks([]);
            if (formattingCleared.length && inputMethod) editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $d925B.ACTION).FORMATTED,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_CLEAR,
                attributes: {
                    inputMethod: inputMethod,
                    formattingCleared: formattingCleared,
                    dropdownMenu: inputMethod === (0, $d925B.INPUT_METHOD).TOOLBAR || inputMethod === (0, $d925B.INPUT_METHOD).FLOATING_TB ? 'textFormatting' : undefined
                }
            })(tr);
            return tr;
        };


const $b6372db181ff20ac$export$435b7561880b778c = (state, pos)=>{
    const { code: code } = state.schema.marks;
    const node = pos >= 0 && state.doc.nodeAt(pos);
    if (node) return !!node.marks.filter((mark)=>mark.type === code).length;
    return false;
};
const $b6372db181ff20ac$export$c91f8b3cbd625635 = (state, mark)=>{
    const { from: from, to: to, empty: empty } = state.selection;
    // When the selection is empty, only the active marks apply.
    if (empty) return !!mark.isInSet(state.tr.storedMarks || state.selection.$from.marks());
    // For a non-collapsed selection, the marks on the nodes matter.
    let found = false;
    state.doc.nodesBetween(from, to, (node)=>{
        found = found || mark.isInSet(node.marks);
    });
    return found;
};
const $b6372db181ff20ac$var$blockStylingIsPresent = (state)=>{
    const { from: from, to: to } = state.selection;
    let isBlockStyling = false;
    state.doc.nodesBetween(from, to, (node)=>{
        if ((0, $259f2a142ea36336$export$a5cb0c20bd02ce0c).indexOf(node.type.name) !== -1) {
            isBlockStyling = true;
            return false;
        }
        return true;
    });
    return isBlockStyling;
};
const $b6372db181ff20ac$var$marksArePresent = (state)=>{
    const activeMarkTypes = (0, $259f2a142ea36336$export$73b50f8f13648c71).filter((mark)=>{
        if (!!state.schema.marks[mark]) {
            const { $from: $from, empty: empty } = state.selection;
            const { marks: marks } = state.schema;
            if (empty) return !!marks[mark].isInSet(state.storedMarks || $from.marks());
            return (0, $8DwGl.anyMarkActive)(state, marks[mark]);
        }
        return false;
    });
    return activeMarkTypes.length > 0;
};
const $b6372db181ff20ac$export$4b48a1fc423972ea = (state)=>{
    return $b6372db181ff20ac$var$marksArePresent(state) || $b6372db181ff20ac$var$blockStylingIsPresent(state);
};
const $b6372db181ff20ac$export$53d327693050b221 = (items, prevItems)=>{
    return items && items.filter((item)=>!prevItems.includes(item));
};
const $b6372db181ff20ac$export$f8f79f933a3fce55 = (items, content)=>items.filter((item)=>item.content === content).length > 0;


const $c4b62bb81a4e5eb6$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('clearFormattingPlugin');
const $c4b62bb81a4e5eb6$export$ca524d3785e2543 = (dispatch)=>new (0, $1S4f7.SafePlugin)({
        state: {
            init (_config, state) {
                return {
                    formattingIsPresent: (0, $b6372db181ff20ac$export$4b48a1fc423972ea)(state)
                };
            },
            apply (_tr, pluginState, _oldState, newState) {
                const formattingIsPresent = (0, $b6372db181ff20ac$export$4b48a1fc423972ea)(newState);
                if (formattingIsPresent !== pluginState.formattingIsPresent) {
                    dispatch($c4b62bb81a4e5eb6$export$18d4026d1ea86bb1, {
                        formattingIsPresent: formattingIsPresent
                    });
                    return {
                        formattingIsPresent: formattingIsPresent
                    };
                }
                return pluginState;
            }
        },
        key: $c4b62bb81a4e5eb6$export$18d4026d1ea86bb1
    });






var $hgeg8 = parcelRequire("hgeg8");


var $dus6D = parcelRequire("dus6D");


function $251906526182976c$export$e832373cff8dec22(editorAnalyticsAPI) {
    const list = {};
    (0, $hgeg8.bindKeymapWithEditorCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.findShortcutByKeymap)((0, $hgeg8.clearFormatting)), (0, $259f2a142ea36336$export$38c6848f9e966bd5)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).SHORTCUT), list);
    return (0, $dus6D.keymap)(list);
}
var $251906526182976c$export$2e2bcd8739ae039 = $251906526182976c$export$e832373cff8dec22;








// eslint-disable-next-line import/no-anonymous-default-export
const $42c3ebae9833cf7e$var$_default_1 = new (0, $1S4f7.SafePlugin)({
    props: {
        handleClick (view, clickPos, event) {
            // Don't apply in Edge as per ED-4546
            // Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            if (navigator && /Edge\/\d/.test(navigator.userAgent)) return false;
            // @see ED-6231
            if (clickPos > view.state.doc.content.size) return false;
            const { code: code } = view.state.schema.marks;
            const { paragraph: paragraph } = view.state.schema.nodes;
            const $click = view.state.doc.resolve(clickPos);
            const clickWasAtEdgeOfATextNode = ($click.nodeBefore ? $click.nodeBefore.isInline : $click.nodeAfter) && ($click.nodeAfter ? $click.nodeAfter.isInline : $click.nodeBefore) && $click.textOffset === 0;
            const clickWasNearACodeMark = code && ($click.nodeBefore && code.isInSet($click.nodeBefore.marks) || $click.nodeAfter && code.isInSet($click.nodeAfter.marks));
            // Find the starting position of the clicked dom-element
            // TODO: ED-26962 - Remove calls to private API
            const clickedDOMElementPosition = event.target && event.target instanceof Node && view.posAtDOM(event.target);
            const clickNode = view.state.doc.nodeAt(clickPos);
            const clickWasAtTextNode = !!(clickNode && clickNode.isText);
            const clickWasAtEndOfAParagraphNode = $click.parent.type === paragraph && $click.textOffset === 0 && $click.nodeAfter === null;
            if (clickWasAtEdgeOfATextNode && clickWasNearACodeMark && clickedDOMElementPosition && // if click did not occur at a text node or end of paragraph, then
            // it was at a directly adjacent non-text node, so we skip this manual
            // text selection logic to preserve that non-text node's selection
            (clickWasAtTextNode || clickWasAtEndOfAParagraphNode)) {
                const clickWasInsideNodeDOM = event.target.parentNode === view.domAtPos(clickedDOMElementPosition).node && // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                code.isInSet(view.state.doc.resolve(clickedDOMElementPosition).nodeAfter.marks);
                const nodeNextToClick = $click.nodeBefore && code.isInSet($click.nodeBefore.marks) ? $click.nodeAfter : $click.nodeBefore;
                // Need to set the selection here to allow clicking between [code('text'),{<>},emoji()]
                const tr = view.state.tr.setSelection((0, $ks2lK.TextSelection).near($click));
                if (clickWasInsideNodeDOM) tr.setStoredMarks([
                    code.create()
                ]);
                else tr.setStoredMarks(nodeNextToClick ? nodeNextToClick.marks : []);
                view.dispatch(tr);
                return true;
            }
            return false;
        }
    }
});
var $42c3ebae9833cf7e$export$2e2bcd8739ae039 = $42c3ebae9833cf7e$var$_default_1;









var $4VXMf = parcelRequire("4VXMf");

var $l03WE = parcelRequire("l03WE");


var $aIMBk = parcelRequire("aIMBk");

var $14sLv = parcelRequire("14sLv");


var $1oCLl = parcelRequire("1oCLl");

var $272af2f525a6adbd$var$ValidAutoformatChars = /*#__PURE__*/ function(ValidAutoformatChars) {
    ValidAutoformatChars["STRONG"] = "__";
    ValidAutoformatChars["STRIKE"] = "~~";
    ValidAutoformatChars["STRONG_MARKDOWN"] = "**";
    ValidAutoformatChars["ITALIC_MARKDOWN"] = "*";
    ValidAutoformatChars["ITALIC"] = "_";
    ValidAutoformatChars["CODE"] = "`";
    return ValidAutoformatChars;
}($272af2f525a6adbd$var$ValidAutoformatChars || {});
const $272af2f525a6adbd$export$ab511c819612d3bc = {
    ["~~"]: [
        "_",
        "__",
        "**",
        "*"
    ],
    ["__"]: [
        "~~",
        "*"
    ],
    ["**"]: [
        "_",
        "~~"
    ],
    ["*"]: [
        "~~",
        "__"
    ],
    ["_"]: [
        "~~",
        "**"
    ],
    ["`"]: [
        // e.g: loko (`some code`
        '( '
    ]
};
function $272af2f525a6adbd$var$addMark(markType, _schema, char, api) {
    return (state, _match, start, end)=>{
        const { doc: doc, schema: schema, tr: tr } = state;
        const textPrefix = state.doc.textBetween(start, start + char.length);
        // fixes the following case: my `*name` is *
        // expected result: should ignore special characters inside "code"
        if (textPrefix !== char || schema?.marks?.code?.isInSet(doc.resolve(start + 1).marks())) {
            if (!(0, $1oCLl.expValEquals)('platform_editor_lovability_inline_code', 'isEnabled', true)) return null;
            // if the prefix is not a character but the suffix is, continue
            const suffix = state.doc.textBetween(end - char.length, end);
            if (suffix !== char) return null;
        }
        // Prevent autoformatting across hardbreaks
        let containsHardBreak;
        doc.nodesBetween(start, end, (node)=>{
            if (node.type === schema.nodes.hardBreak) {
                containsHardBreak = true;
                return false;
            }
            return !containsHardBreak;
        });
        if (containsHardBreak) return null;
        // fixes autoformatting in heading nodes: # Heading *bold*
        // expected result: should not autoformat *bold*; <h1>Heading *bold*</h1>
        const startPosResolved = doc.resolve(start);
        const endPosResolved = doc.resolve(end);
        if (startPosResolved.sameParent(endPosResolved) && !startPosResolved.parent.type.allowsMarkType(markType)) return null;
        if (markType.name === 'code') api?.base?.actions?.resolveMarks(tr.mapping.map(start), tr.mapping.map(end), tr);
        const mappedStart = tr.mapping.map(start);
        const mappedEnd = tr.mapping.map(end);
        tr.addMark(mappedStart, mappedEnd, markType.create());
        const textSuffix = tr.doc.textBetween(mappedEnd - char.length, mappedEnd);
        if (textSuffix === char) tr.delete(mappedEnd - char.length, mappedEnd);
        if (textPrefix === char) tr.delete(mappedStart, mappedStart + char.length);
        return tr.removeStoredMark(markType);
    };
}
class $272af2f525a6adbd$var$ReverseRegexExp extends RegExp {
    exec(str) {
        if (!str) return null;
        const reverseStr = [
            ...str
        ].reverse().join('');
        const result = super.exec(reverseStr);
        if (!result) return null;
        for(let i = 0; i < result.length; i++)if (result[i] && typeof result[i] === 'string') result[i] = [
            ...result[i]
        ].reverse().join('');
        if (result.input && typeof result.input === 'string') result.input = [
            ...result.input
        ].reverse().join('');
        if (result.input && result[0]) result.index = result.input.length - result[0].length;
        return result;
    }
}
const $272af2f525a6adbd$var$buildRegex = (char)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const escapedChar = char.replace(/(\W)/g, '\\$1');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp, @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
    const combinations = $272af2f525a6adbd$export$ab511c819612d3bc[char].map((c)=>c.replace(/(\W)/g, '\\$1')).join('|');
    // Single X - https://regex101.com/r/McT3yq/14/
    // Double X - https://regex101.com/r/pQUgjx/1/
    const baseRegex = '^X(?=[^X\\s]).*?[^\\sX]X(?=[\\sOBJECT_REPLACEMENT_CHARACTER]COMBINATIONS|$)'.replace('OBJECT_REPLACEMENT_CHARACTER', (0, $14sLv.leafNodeReplacementCharacter)).replace('COMBINATIONS', combinations ? `|${combinations}` : '');
    const replacedRegex = String.prototype.hasOwnProperty('replaceAll') ? // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    baseRegex.replaceAll('X', escapedChar) : // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    baseRegex.replace(/X/g, escapedChar);
    return new $272af2f525a6adbd$var$ReverseRegexExp(replacedRegex);
};
const $272af2f525a6adbd$var$buildRegexNew = (char, allowsBackwardMatch = false)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const escapedChar = char.replace(/(\W)/g, '\\$1');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp, @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
    const combinations = $272af2f525a6adbd$export$ab511c819612d3bc[char].map((c)=>c.replace(/(\W)/g, '\\$1')).join('|');
    // Single X - https://regex101.com/r/McT3yq/14/
    // Double X - https://regex101.com/r/pQUgjx/1/
    // if backwards matches are allowed, do not prefix the regex with an anchor (^)
    const maybeAnchor = allowsBackwardMatch ? '' : '^';
    const orCombinations = combinations ? `|${combinations}` : '';
    const baseRegex = `${maybeAnchor}X(?=[^X\\s]).*?[^\\sX]X(?=[\\s${(0, $14sLv.leafNodeReplacementCharacter)}]${orCombinations}|$)`;
    const replacedRegex = String.prototype.hasOwnProperty('replaceAll') ? // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    baseRegex.replaceAll('X', escapedChar) : // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    baseRegex.replace(/X/g, escapedChar);
    return new $272af2f525a6adbd$var$ReverseRegexExp(replacedRegex);
};
const $272af2f525a6adbd$export$3312a15c47701971 = $272af2f525a6adbd$var$buildRegex("__");
const $272af2f525a6adbd$export$b2c5e5dc4b85ebff = $272af2f525a6adbd$var$buildRegex("**");
const $272af2f525a6adbd$export$5293ac529581c0f9 = $272af2f525a6adbd$var$buildRegex("_");
const $272af2f525a6adbd$export$bef0fedfe2c8027e = $272af2f525a6adbd$var$buildRegex("*");
const $272af2f525a6adbd$export$6dd2d2a62884fadf = $272af2f525a6adbd$var$buildRegex("~~");
const $272af2f525a6adbd$export$b311ac3b6caef479 = $272af2f525a6adbd$var$buildRegex("`");
const $272af2f525a6adbd$export$6e92f28cddbb8b0c = $272af2f525a6adbd$var$buildRegexNew("`", true);
/**
 * Create input rules for strong mark
 *
 * @param {Schema} schema
 * @returns {InputRuleWrapper[]}
 */ function $272af2f525a6adbd$var$getStrongInputRules(schema, editorAnalyticsAPI) {
    const ruleWithStrongAnalytics = (0, $l03WE.inputRuleWithAnalytics)({
        action: (0, $d925B.ACTION).FORMATTED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_STRONG,
        eventType: (0, $d925B.EVENT_TYPE).TRACK,
        attributes: {
            inputMethod: (0, $d925B.INPUT_METHOD).FORMATTING
        }
    }, editorAnalyticsAPI);
    // **string** or __strong__ should bold the text
    const doubleUnderscoreRule = (0, $4VXMf.createRule)($272af2f525a6adbd$export$3312a15c47701971, $272af2f525a6adbd$var$addMark(schema.marks.strong, schema, "__"));
    const doubleAsterixRule = (0, $4VXMf.createRule)($272af2f525a6adbd$export$b2c5e5dc4b85ebff, $272af2f525a6adbd$var$addMark(schema.marks.strong, schema, "**"));
    return [
        ruleWithStrongAnalytics(doubleUnderscoreRule),
        ruleWithStrongAnalytics(doubleAsterixRule)
    ];
}
/**
 * Create input rules for em mark
 *
 * @param {Schema} schema
 * @returns {InputRuleWrapper[]}
 */ function $272af2f525a6adbd$var$getItalicInputRules(schema, editorAnalyticsAPI) {
    const ruleWithItalicAnalytics = (0, $l03WE.inputRuleWithAnalytics)({
        action: (0, $d925B.ACTION).FORMATTED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_ITALIC,
        eventType: (0, $d925B.EVENT_TYPE).TRACK,
        attributes: {
            inputMethod: (0, $d925B.INPUT_METHOD).FORMATTING
        }
    }, editorAnalyticsAPI);
    const underscoreRule = (0, $4VXMf.createRule)($272af2f525a6adbd$export$5293ac529581c0f9, $272af2f525a6adbd$var$addMark(schema.marks.em, schema, "_"));
    const asterixRule = (0, $4VXMf.createRule)($272af2f525a6adbd$export$bef0fedfe2c8027e, $272af2f525a6adbd$var$addMark(schema.marks.em, schema, "*"));
    return [
        ruleWithItalicAnalytics(underscoreRule),
        ruleWithItalicAnalytics(asterixRule)
    ];
}
/**
 * Create input rules for strike mark
 *
 * @param {Schema} schema
 * @returns {InputRuleWrapper[]}
 */ function $272af2f525a6adbd$var$getStrikeInputRules(schema, editorAnalyticsAPI) {
    const ruleWithStrikeAnalytics = (0, $l03WE.inputRuleWithAnalytics)({
        action: (0, $d925B.ACTION).FORMATTED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_STRIKE,
        eventType: (0, $d925B.EVENT_TYPE).TRACK,
        attributes: {
            inputMethod: (0, $d925B.INPUT_METHOD).FORMATTING
        }
    }, editorAnalyticsAPI);
    const doubleTildeRule = (0, $4VXMf.createRule)($272af2f525a6adbd$export$6dd2d2a62884fadf, $272af2f525a6adbd$var$addMark(schema.marks.strike, schema, "~~"));
    return [
        ruleWithStrikeAnalytics(doubleTildeRule)
    ];
}
/**
 * Create input rules for code mark
 *
 * @param {Schema} schema
 * @returns {InputRuleWrapper[]}
 */ function $272af2f525a6adbd$var$getCodeInputRules(schema, editorAnalyticsAPI, api) {
    const ruleWithCodeAnalytics = (0, $l03WE.inputRuleWithAnalytics)({
        action: (0, $d925B.ACTION).FORMATTED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_CODE,
        eventType: (0, $d925B.EVENT_TYPE).TRACK,
        attributes: {
            inputMethod: (0, $d925B.INPUT_METHOD).FORMATTING
        }
    }, editorAnalyticsAPI);
    const allowsBackwardMatch = (0, $1oCLl.expValEquals)('platform_editor_lovability_inline_code', 'isEnabled', true);
    const backTickRule = (0, $4VXMf.createRule)(allowsBackwardMatch ? $272af2f525a6adbd$export$6e92f28cddbb8b0c : $272af2f525a6adbd$export$b311ac3b6caef479, $272af2f525a6adbd$var$addMark(schema.marks.code, schema, "`", api), allowsBackwardMatch);
    return [
        ruleWithCodeAnalytics(backTickRule)
    ];
}
function $272af2f525a6adbd$export$568a7ed6897c4817(schema, editorAnalyticsAPI, api) {
    const rules = [];
    if (schema.marks.strong) rules.push(...$272af2f525a6adbd$var$getStrongInputRules(schema, editorAnalyticsAPI));
    if (schema.marks.em) rules.push(...$272af2f525a6adbd$var$getItalicInputRules(schema, editorAnalyticsAPI));
    if (schema.marks.strike) rules.push(...$272af2f525a6adbd$var$getStrikeInputRules(schema, editorAnalyticsAPI));
    if (schema.marks.code) rules.push(...$272af2f525a6adbd$var$getCodeInputRules(schema, editorAnalyticsAPI, api));
    if (rules.length !== 0) return new (0, $1S4f7.SafePlugin)((0, $aIMBk.createPlugin)('text-formatting', rules));
    return;
}
var $272af2f525a6adbd$export$2e2bcd8739ae039 = $272af2f525a6adbd$export$568a7ed6897c4817;





















const $09fa888fe84c9f23$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('textFormatting');


function $eb356cb5191041bc$export$2e2bcd8739ae039(schema, editorAnalyticsAPI) {
    const list = {};
    if (schema.marks.strong) (0, $hgeg8.bindKeymapWithEditorCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.findShortcutByKeymap)((0, $hgeg8.toggleBold)), (0, $bb3f69b8f70e233b$export$686bc7c29753e27)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).SHORTCUT), list);
    if (schema.marks.em) (0, $hgeg8.bindKeymapWithEditorCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.findShortcutByKeymap)((0, $hgeg8.toggleItalic)), (0, $bb3f69b8f70e233b$export$fe8278eb0d365433)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).SHORTCUT), list);
    if (schema.marks.code) (0, $hgeg8.bindKeymapWithEditorCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.findShortcutByKeymap)((0, $hgeg8.toggleCode)), (0, $bb3f69b8f70e233b$export$2d4f5a54f840ba91)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).SHORTCUT), list);
    if (schema.marks.strike) (0, $hgeg8.bindKeymapWithEditorCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.findShortcutByKeymap)((0, $hgeg8.toggleStrikethrough)), (0, $bb3f69b8f70e233b$export$f08ef336cb688397)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).SHORTCUT), list);
    if (schema.marks.subsup) (0, $hgeg8.bindKeymapWithEditorCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.findShortcutByKeymap)((0, $hgeg8.toggleSubscript)), (0, $bb3f69b8f70e233b$export$8d0c92ae27a193)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).SHORTCUT), list);
    if (schema.marks.subsup) (0, $hgeg8.bindKeymapWithEditorCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.findShortcutByKeymap)((0, $hgeg8.toggleSuperscript)), (0, $bb3f69b8f70e233b$export$ca1c98793b67ba6b)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).SHORTCUT), list);
    if (schema.marks.underline) (0, $hgeg8.bindKeymapWithEditorCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.findShortcutByKeymap)((0, $hgeg8.toggleUnderline)), (0, $bb3f69b8f70e233b$export$bf3c86b5abdb857d)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).SHORTCUT), list);
    const getEnabledKeylist = (view)=>{
        const textFormattingState = (0, $09fa888fe84c9f23$export$18d4026d1ea86bb1).getState(view.state);
        const list = {};
        if (schema.marks.strong && !textFormattingState?.strongDisabled) (0, $hgeg8.bindKeymapWithEditorCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $hgeg8.findShortcutByKeymap)((0, $hgeg8.toggleBold)), (0, $bb3f69b8f70e233b$export$686bc7c29753e27)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).SHORTCUT), list);
        if (schema.marks.em && !textFormattingState?.emDisabled) (0, $hgeg8.bindKeymapWithEditorCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $hgeg8.findShortcutByKeymap)((0, $hgeg8.toggleItalic)), (0, $bb3f69b8f70e233b$export$fe8278eb0d365433)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).SHORTCUT), list);
        if (schema.marks.code && !textFormattingState?.codeDisabled) (0, $hgeg8.bindKeymapWithEditorCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $hgeg8.findShortcutByKeymap)((0, $hgeg8.toggleCode)), (0, $bb3f69b8f70e233b$export$2d4f5a54f840ba91)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).SHORTCUT), list);
        if (schema.marks.strike && !textFormattingState?.strikeDisabled) (0, $hgeg8.bindKeymapWithEditorCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $hgeg8.findShortcutByKeymap)((0, $hgeg8.toggleStrikethrough)), (0, $bb3f69b8f70e233b$export$f08ef336cb688397)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).SHORTCUT), list);
        if (schema.marks.subsup && !textFormattingState?.subscriptDisabled) (0, $hgeg8.bindKeymapWithEditorCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $hgeg8.findShortcutByKeymap)((0, $hgeg8.toggleSubscript)), (0, $bb3f69b8f70e233b$export$8d0c92ae27a193)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).SHORTCUT), list);
        if (schema.marks.subsup && !textFormattingState?.superscriptDisabled) (0, $hgeg8.bindKeymapWithEditorCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $hgeg8.findShortcutByKeymap)((0, $hgeg8.toggleSuperscript)), (0, $bb3f69b8f70e233b$export$ca1c98793b67ba6b)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).SHORTCUT), list);
        if (schema.marks.underline && !textFormattingState?.underlineDisabled) (0, $hgeg8.bindKeymapWithEditorCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $hgeg8.findShortcutByKeymap)((0, $hgeg8.toggleUnderline)), (0, $bb3f69b8f70e233b$export$bf3c86b5abdb857d)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).SHORTCUT), list);
        return list;
    };
    return new (0, $1S4f7.SafePlugin)({
        props: {
            handleKeyDown (view, event) {
                const keyboardEvent = (0, $hgeg8.isCapsLockOnAndModifyKeyboardEvent)(event);
                const keymapList = (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? getEnabledKeylist(view) : list;
                return (0, $dus6D.keydownHandler)(keymapList)(view, keyboardEvent);
            }
        }
    });
}


// TODO: ED-26962 - Ideally this should use the custom toggleMark function from @atlaskit/editor-common so we also disable the options when selecting inline nodes but it disables the marks when the selection is empty at this point in time which is undesirable
// import { toggleMark } from '@atlaskit/editor-common/mark';






var $5SAOw = parcelRequire("5SAOw");







const $f7ca8ce531570316$var$allMarksAreRuledOut = (marks)=>Array.from(marks.values()).every((mark)=>!mark);
const $f7ca8ce531570316$export$a4048c78ac7b54c8 = (state, markTypes)=>{
    const { $from: $from, from: from, to: to, empty: empty } = state.selection;
    if (empty) return new Map(markTypes.map((markType)=>[
            markType,
            !!markType.isInSet(state.storedMarks || $from.marks())
        ]));
    if (state.selection instanceof (0, $7XFGZ.CellSelection)) return $f7ca8ce531570316$var$cellSelectionHasMarks(state.doc, state.selection, markTypes);
    return $f7ca8ce531570316$var$wholeRangeHasMarks(from, to, state.doc, markTypes);
};
const $f7ca8ce531570316$var$cellSelectionHasMarks = (doc, selection, markTypes)=>{
    // Warning: This is micro-optimized and is a total pain to actually read.
    // Will attempt to explain in comments.
    // Start with map of booleans for each mark
    let cellsHaveMarks = new Map(markTypes.map((markType)=>[
            markType,
            true
        ]));
    selection.forEachCell((cell, cellPos)=>{
        // Early exit if all marks are already ruled out
        if ($f7ca8ce531570316$var$allMarksAreRuledOut(cellsHaveMarks)) return;
        const from = cellPos;
        const to = cellPos + cell.nodeSize;
        // On first cell just do a regular check
        if (!cellsHaveMarks) cellsHaveMarks = $f7ca8ce531570316$var$wholeRangeHasMarks(from, to, doc, markTypes);
        else {
            // Find the marks that are still true ie the ones that haven't been ruled out in
            // previous cells. The idea here is to whittle down the list of marks so that we check
            // less and less as we go, giving `wholeRangeHasMarks` more opportunities to exit early
            const marksToCheck = [];
            for (const [markType, hasMark] of cellsHaveMarks)if (hasMark) marksToCheck.push(markType);
            // Look specifically for the marks that are not yet ruled out.
            const cellHasMarks = $f7ca8ce531570316$var$wholeRangeHasMarks(from, to, doc, marksToCheck);
            // Map these results back into the original array of results and repeat!
            for (const [markType, hasMark] of cellHasMarks)cellsHaveMarks.set(markType, hasMark);
        }
    });
    return cellsHaveMarks;
};
const $f7ca8ce531570316$var$wholeRangeHasMarks = (from, to, doc, markTypes)=>{
    const hasMarks = new Map(markTypes.map((markType)=>[
            markType,
            true
        ]));
    const hasNoMarks = new Map(markTypes.map((markType)=>[
            markType,
            false
        ]));
    let isTextContent = false;
    doc.nodesBetween(from, to, (node)=>{
        if ($f7ca8ce531570316$var$allMarksAreRuledOut(hasMarks)) // This won't be a true early exit, but will prevent diving into nodes and
        // any checks further down the function.
        return false;
        if (!node.type.isText) return true; // continue traversing
        isTextContent = true;
        for (const [markType, hasMark] of hasMarks){
            if (!hasMark) continue; // already ruled out the mark, skip further checks
            const value = markType instanceof (0, $5SAOw.Mark) ? markType.isInSet(node.marks) : node.marks.some((mark)=>mark.type === markType);
            hasMarks.set(markType, value);
        }
    });
    return isTextContent ? hasMarks : hasNoMarks;
};






var $l9G9n = parcelRequire("l9G9n");


var $astHL = parcelRequire("astHL");

















var $dAtrv = parcelRequire("dAtrv");








const $571ed8f5e3913329$export$e2c874fbfec7201 = ()=>{
    return (state, dispatch)=>{
        const { code: code } = state.schema.marks;
        const { empty: empty, $cursor: $cursor } = state.selection;
        if (!empty || !$cursor) return false;
        const { storedMarks: storedMarks } = state.tr;
        if (code) {
            const insideCode = (0, $b6372db181ff20ac$export$c91f8b3cbd625635)(state, code.create());
            const currentPosHasCode = state.doc.rangeHasMark($cursor.pos, $cursor.pos, code);
            const nextPosHasCode = state.doc.rangeHasMark($cursor.pos, $cursor.pos + 1, code);
            const exitingCode = !currentPosHasCode && !nextPosHasCode && (!storedMarks || !!storedMarks.length);
            const enteringCode = !currentPosHasCode && nextPosHasCode && (!storedMarks || !storedMarks.length);
            // entering code mark (from the left edge): don't move the cursor, just add the mark
            if (!insideCode && enteringCode) {
                if (dispatch) dispatch(state.tr.addStoredMark(code.create()));
                return true;
            }
            // exiting code mark: don't move the cursor, just remove the mark
            if (insideCode && exitingCode) {
                if (dispatch) dispatch(state.tr.removeStoredMark(code));
                return true;
            }
        }
        return false;
    };
};
const $571ed8f5e3913329$export$108f27160c89e515 = ()=>{
    return (state, dispatch)=>{
        const { code: code } = state.schema.marks;
        const { empty: empty, $cursor: $cursor } = state.selection;
        if (!empty || !$cursor) return false;
        const { storedMarks: storedMarks } = state.tr;
        if (code) {
            const insideCode = code && (0, $b6372db181ff20ac$export$c91f8b3cbd625635)(state, code.create());
            const currentPosHasCode = (0, $b6372db181ff20ac$export$435b7561880b778c)(state, $cursor.pos);
            const nextPosHasCode = (0, $b6372db181ff20ac$export$435b7561880b778c)(state, $cursor.pos - 1);
            const nextNextPosHasCode = (0, $b6372db181ff20ac$export$435b7561880b778c)(state, $cursor.pos - 2);
            const exitingCode = currentPosHasCode && !nextPosHasCode && Array.isArray(storedMarks);
            const atLeftEdge = nextPosHasCode && !nextNextPosHasCode && (storedMarks === null || Array.isArray(storedMarks) && !!storedMarks.length);
            const atRightEdge = (exitingCode && Array.isArray(storedMarks) && !storedMarks.length || !exitingCode && storedMarks === null) && !nextPosHasCode && nextNextPosHasCode;
            const enteringCode = !currentPosHasCode && nextPosHasCode && Array.isArray(storedMarks) && !storedMarks.length;
            // at the right edge: remove code mark and move the cursor to the left
            if (!insideCode && atRightEdge) {
                const tr = state.tr.setSelection((0, $ks2lK.Selection).near(state.doc.resolve($cursor.pos - 1)));
                if (dispatch) dispatch(tr.removeStoredMark(code));
                return true;
            }
            // entering code mark (from right edge): don't move the cursor, just add the mark
            if (!insideCode && enteringCode) {
                if (dispatch) dispatch(state.tr.addStoredMark(code.create()));
                return true;
            }
            // at the left edge: add code mark and move the cursor to the left
            if (insideCode && atLeftEdge) {
                const tr = state.tr.setSelection((0, $ks2lK.Selection).near(state.doc.resolve($cursor.pos - 1)));
                if (dispatch) dispatch(tr.addStoredMark(code.create()));
                return true;
            }
            // exiting code mark (or at the beginning of the line): don't move the cursor, just remove the mark
            const isFirstChild = $cursor.index($cursor.depth - 1) === 0;
            if (insideCode && (exitingCode || !$cursor.nodeBefore && isFirstChild)) {
                if (dispatch) dispatch(state.tr.removeStoredMark(code));
                return true;
            }
        }
        return false;
    };
};
const $571ed8f5e3913329$var$createInlineCodeFromTextInput = (from, to, text)=>{
    return (state, dispatch)=>{
        if (state.selection.empty) {
            const { nodeBefore: before } = state.doc.resolve(from);
            const { nodeAfter: after } = state.doc.resolve(to);
            const hasTickBefore = before && before.text && before.text.endsWith('`');
            const hasTickAfter = after && after.text && after.text.startsWith('`');
            if (hasTickBefore && hasTickAfter) {
                let tr = state.tr.replaceRangeWith(from - 1, to + 1, state.schema.text(text));
                if (dispatch) {
                    const codeMark = state.schema.marks.code.create();
                    tr = (0, $b167b.applyMarkOnRange)(tr.mapping.map(from - 1), tr.mapping.map(to + 1), false, codeMark, tr).setStoredMarks([
                        codeMark
                    ]);
                    dispatch(tr);
                }
                return true;
            }
        }
        return false;
    };
};
const $571ed8f5e3913329$export$7a99a2b030134bb0 = (editorAnalyticsAPI)=>(from, to, text)=>{
        return (0, $dAtrv.withAnalytics)(editorAnalyticsAPI, {
            action: (0, $d925B.ACTION).FORMATTED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_CODE,
            attributes: {
                inputMethod: (0, $d925B.INPUT_METHOD).FORMATTING
            }
        })($571ed8f5e3913329$var$createInlineCodeFromTextInput(from, to, text));
    };



const $87facb9c332c53bc$var$isSelectionInlineCursor = (selection)=>{
    if (selection instanceof (0, $ks2lK.NodeSelection)) return true;
    return false;
};
const $87facb9c332c53bc$var$checkNodeSelection = (mark, editorState, type)=>{
    const selection = editorState.selection;
    if ($87facb9c332c53bc$var$isSelectionInlineCursor(selection)) return false;
    return (0, $astHL.toggleMark)(mark, {
        type: type
    })(editorState);
};
const $87facb9c332c53bc$var$getTextFormattingState = (editorState, _editorAnalyticsAPI)=>{
    const { em: em, code: code, strike: strike, strong: strong, subsup: subsup, underline: underline } = editorState.schema.marks;
    const state = {
        isInitialised: true
    };
    const showOnlyCommonMarks = (0, $1oCLl.expValEquals)('platform_editor_controls', 'cohort', 'variant1');
    if (showOnlyCommonMarks) {
        // Code marks will disable all other formatting options when they are included in a
        // selection but (for now) we do not want to make it behave differently in regards to which
        // toolbar items are highlighted on selection. We need to track code in selection seperately
        // to ensure all other formatting options are disabled appropriately.
        if (code) state.codeInSelection = (0, $8DwGl.anyMarkActive)(editorState, code.create());
        const marks = [
            [
                code,
                'code'
            ],
            [
                em,
                'em'
            ],
            [
                strike,
                'strike'
            ],
            [
                strong,
                'strong'
            ],
            [
                underline,
                'underline'
            ],
            [
                subsup?.create({
                    type: 'sub'
                }),
                'subscript'
            ],
            [
                subsup?.create({
                    type: 'sup'
                }),
                'superscript'
            ]
        ].filter(([mark])=>mark);
        const marksToName = new Map(marks);
        const activeMarks = (0, $f7ca8ce531570316$export$a4048c78ac7b54c8)(editorState, Array.from(marksToName.keys()));
        for (const [mark, markName] of marks){
            const active = activeMarks.get(mark);
            if (active !== undefined) state[`${markName}Active`] = active;
            state[`${markName}Disabled`] = // Disable when code is active, except for code itself which should not be disabled
            // when code is in selection 😅
            state.codeInSelection && markName !== 'code' ? true : !$87facb9c332c53bc$var$checkNodeSelection(mark instanceof (0, $5SAOw.MarkType) ? mark : mark.type, editorState);
        }
        return state;
    }
    if (code) {
        state.codeActive = (0, $8DwGl.anyMarkActive)(editorState, code.create());
        state.codeDisabled = !$87facb9c332c53bc$var$checkNodeSelection(code, editorState);
    }
    if (em) {
        state.emActive = (0, $8DwGl.anyMarkActive)(editorState, em);
        state.emDisabled = state.codeActive ? true : !$87facb9c332c53bc$var$checkNodeSelection(em, editorState);
    }
    if (strike) {
        state.strikeActive = (0, $8DwGl.anyMarkActive)(editorState, strike);
        state.strikeDisabled = state.codeActive ? true : !$87facb9c332c53bc$var$checkNodeSelection(strike, editorState);
    }
    if (strong) {
        state.strongActive = (0, $8DwGl.anyMarkActive)(editorState, strong);
        state.strongDisabled = state.codeActive ? true : !$87facb9c332c53bc$var$checkNodeSelection(strong, editorState);
    }
    if (subsup) {
        const subMark = subsup.create({
            type: 'sub'
        });
        const supMark = subsup.create({
            type: 'sup'
        });
        state.subscriptActive = (0, $8DwGl.anyMarkActive)(editorState, subMark);
        state.superscriptActive = (0, $8DwGl.anyMarkActive)(editorState, supMark);
        state.subscriptDisabled = state.codeActive ? true : !$87facb9c332c53bc$var$checkNodeSelection(subsup, editorState, 'sub');
        state.superscriptDisabled = state.codeActive ? true : !$87facb9c332c53bc$var$checkNodeSelection(subsup, editorState, 'sup');
    }
    if (underline) {
        state.underlineActive = (0, $8DwGl.anyMarkActive)(editorState, underline);
        state.underlineDisabled = state.codeActive ? true : !$87facb9c332c53bc$var$checkNodeSelection(underline, editorState);
    }
    return state;
};
const $87facb9c332c53bc$export$ca524d3785e2543 = (dispatch, editorAnalyticsAPI)=>new (0, $1S4f7.SafePlugin)({
        state: {
            init (_config, state) {
                return $87facb9c332c53bc$var$getTextFormattingState(state, editorAnalyticsAPI);
            },
            apply (_tr, pluginState, _oldState, newState) {
                const state = $87facb9c332c53bc$var$getTextFormattingState(newState, editorAnalyticsAPI);
                if (!(0, $l9G9n.shallowEqual)(pluginState, state)) {
                    dispatch((0, $09fa888fe84c9f23$export$18d4026d1ea86bb1), state);
                    return state;
                }
                return pluginState;
            }
        },
        key: (0, $09fa888fe84c9f23$export$18d4026d1ea86bb1),
        props: {
            handleKeyDown (view, event) {
                const { state: state, dispatch: dispatch } = view;
                if (event.key === (0, $hgeg8.moveRight).common && !event.metaKey) return $571ed8f5e3913329$export$e2c874fbfec7201()(state, dispatch);
                else if (event.key === (0, $hgeg8.moveLeft).common && !event.metaKey) return $571ed8f5e3913329$export$108f27160c89e515()(state, dispatch);
                else if (event.key === 'u' && event.metaKey && (0, $09fa888fe84c9f23$export$18d4026d1ea86bb1).getState(state)?.underlineDisabled && (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) // This is a workaround for browser behaviour with cmd+u (in Chrome only) where the underline mark being applied around the selection
                event.preventDefault();
                return false;
            },
            handleTextInput (view, from, to, text) {
                const { state: state, dispatch: dispatch } = view;
                const { schema: schema, selection: { $from: { parent: { type: parentNodeType } } } } = state;
                if (parentNodeType.allowsMarkType(schema.marks.code)) return (0, $571ed8f5e3913329$export$7a99a2b030134bb0)(editorAnalyticsAPI)(from, to, text)(state, dispatch);
                return false;
            }
        }
    });





var $53bd1a8ae33ee9a5$export$27c95a7104c1f7aa = /*#__PURE__*/ function(SYMBOL) {
    SYMBOL["ARROW_RIGHT"] = "rightArrow";
    SYMBOL["ARROW_LEFT"] = "leftArrow";
    SYMBOL["ARROW_DOUBLE"] = "doubleArrow";
    return SYMBOL;
}({});
var $53bd1a8ae33ee9a5$export$3530f2dd0e78fdc2 = /*#__PURE__*/ function(PUNC) {
    PUNC["DASH"] = "emDash";
    PUNC["ELLIPSIS"] = "ellipsis";
    PUNC["QUOTE_SINGLE"] = "singleQuote";
    PUNC["QUOTE_DOUBLE"] = "doubleQuote";
    return PUNC;
}({});
















/**
 * Creates an InputRuleHandler that will match on a regular expression of the
 * form `(prefix, content, suffix?)`, and replace it with some given text,
 * maintaining prefix and suffix around the replacement.
 *
 * @param text text to replace with
 */ function $7fedcc10a2237f27$var$replaceTextUsingCaptureGroup(text) {
    return (state, match, start, end)=>{
        const [, prefix, , suffix] = match;
        const replacement = text + (suffix || '');
        const { tr: tr, selection: { $to: $to } } = state;
        const startPos = start + (prefix || '').length;
        const safePos = Math.min(// I know it is almost impossible to have a negative value at this point.
        // But, this is JS #trustnoone
        Math.max(startPos, 0), end);
        tr.replaceWith(safePos, end, state.schema.text(replacement, $to.marks()));
        tr.setSelection((0, $ks2lK.Selection).near(tr.doc.resolve(tr.selection.to)));
        return tr;
    };
}
function $7fedcc10a2237f27$var$createReplacementRule(to, from) {
    return (0, $4VXMf.createRule)(from, $7fedcc10a2237f27$var$replaceTextUsingCaptureGroup(to));
}
/**
 * Create replacement rules fiven a replacement map
 * @param replMap - Replacement map
 * @param trackingEventName - Analytics V2 tracking event name
 * @param replacementRuleWithAnalytics - Analytics GAS V3 middleware for replacement and rules.
 */ function $7fedcc10a2237f27$var$createReplacementRules(replMap, replacementRuleWithAnalytics) {
    return Object.keys(replMap).map((replacement)=>{
        const regex = replMap[replacement];
        const rule = $7fedcc10a2237f27$var$createReplacementRule(replacement, regex);
        if (replacementRuleWithAnalytics) return replacementRuleWithAnalytics(replacement)(rule);
        return rule;
    });
}
// We don't agressively upgrade single quotes to smart quotes because
// they may clash with an emoji. Only do that when we have a matching
// single quote, or a contraction.
function $7fedcc10a2237f27$var$createSingleQuotesRules() {
    return [
        // wrapped text
        // eslint-disable-next-line require-unicode-regexp
        (0, $4VXMf.createRule)(/(\s|^)'(\S+.*\S+)'$/, (state, match, start, end)=>{
            const OPEN_SMART_QUOTE_CHAR = "\u2018";
            const CLOSED_SMART_QUOTE_CHAR = "\u2019";
            const [, spacing, innerContent] = match;
            // Edge case where match begins with some spacing. We need to add
            // it back to the document
            const openQuoteReplacement = spacing + OPEN_SMART_QUOTE_CHAR;
            // End is not always where the closed quote is, edge case exists
            // when there is spacing after the closed quote. We need to
            // determine position of closed quote from the start position.
            const positionOfClosedQuote = start + openQuoteReplacement.length + innerContent.length;
            return state.tr.insertText(CLOSED_SMART_QUOTE_CHAR, positionOfClosedQuote, end).insertText(openQuoteReplacement, start, start + openQuoteReplacement.length);
        }),
        // apostrophe
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        $7fedcc10a2237f27$var$createReplacementRule("\u2019", /(\w+)(')(\w+)$/)
    ];
}
/**
 * Get replacement rules related to product
 */ function $7fedcc10a2237f27$var$getProductRules(editorAnalyticsAPI) {
    const productRuleWithAnalytics = (product)=>(0, $l03WE.inputRuleWithAnalytics)((_, match)=>({
                action: (0, $d925B.ACTION).SUBSTITUTED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).PRODUCT_NAME,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: {
                    product: product,
                    originalSpelling: match[2]
                }
            }), editorAnalyticsAPI);
    return $7fedcc10a2237f27$var$createReplacementRules({
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        Atlassian: /(\s+|^)(atlassian)(\s)$/,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        Jira: /(\s+|^)(jira|JIRA)(\s)$/,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        Bitbucket: /(\s+|^)(bitbucket|BitBucket)(\s)$/,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        Hipchat: /(\s+|^)(hipchat|HipChat)(\s)$/,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        Trello: /(\s+|^)(trello)(\s)$/
    }, productRuleWithAnalytics);
}
/**
 * Get replacement rules related to symbol
 */ function $7fedcc10a2237f27$var$getSymbolRules(editorAnalyticsAPI) {
    const symbolToString = {
        "\u2192": (0, $53bd1a8ae33ee9a5$export$27c95a7104c1f7aa).ARROW_RIGHT,
        "\u2190": (0, $53bd1a8ae33ee9a5$export$27c95a7104c1f7aa).ARROW_LEFT,
        "\u2194\uFE0E": (0, $53bd1a8ae33ee9a5$export$27c95a7104c1f7aa).ARROW_DOUBLE
    };
    const symbolRuleWithAnalytics = (symbol)=>(0, $l03WE.inputRuleWithAnalytics)({
            action: (0, $d925B.ACTION).SUBSTITUTED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).SYMBOL,
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            attributes: {
                symbol: symbolToString[symbol]
            }
        }, editorAnalyticsAPI);
    return $7fedcc10a2237f27$var$createReplacementRules({
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        "\u2192": /(\s+|^)(--?>)(\s)$/,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        "\u2190": /(\s+|^)(<--?)(\s)$/,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        "\u2194\uFE0E": /(\s+|^)(<->?)(\s)$/
    }, symbolRuleWithAnalytics);
}
/**
 * Get replacement rules related to punctuation
 */ function $7fedcc10a2237f27$var$getPunctuationRules(editorAnalyticsAPI) {
    const punctuationToString = {
        "\u2013": (0, $53bd1a8ae33ee9a5$export$3530f2dd0e78fdc2).DASH,
        "\u2026": (0, $53bd1a8ae33ee9a5$export$3530f2dd0e78fdc2).ELLIPSIS,
        "\u201D": (0, $53bd1a8ae33ee9a5$export$3530f2dd0e78fdc2).QUOTE_DOUBLE,
        [(0, $53bd1a8ae33ee9a5$export$3530f2dd0e78fdc2).QUOTE_SINGLE]: (0, $53bd1a8ae33ee9a5$export$3530f2dd0e78fdc2).QUOTE_SINGLE
    };
    const punctuationRuleWithAnalytics = (punctuation)=>(0, $l03WE.inputRuleWithAnalytics)({
            action: (0, $d925B.ACTION).SUBSTITUTED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).PUNC,
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            attributes: {
                punctuation: punctuationToString[punctuation]
            }
        }, editorAnalyticsAPI);
    const dashEllipsisRules = $7fedcc10a2237f27$var$createReplacementRules({
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        "\u2013": /(\s+|^)(--)(\s)$/,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        "\u2026": /()(\.\.\.)$/
    }, punctuationRuleWithAnalytics);
    const doubleQuoteRules = $7fedcc10a2237f27$var$createReplacementRules({
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        "\u201C": /((?:^|[\s\{\[\(\<'"\u2018\u201C]))(")$/,
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        "\u201D": /"$/
    }, punctuationRuleWithAnalytics);
    const singleQuoteRules = $7fedcc10a2237f27$var$createSingleQuotesRules();
    return [
        ...dashEllipsisRules,
        ...doubleQuoteRules,
        ...singleQuoteRules.map((rule)=>punctuationRuleWithAnalytics((0, $53bd1a8ae33ee9a5$export$3530f2dd0e78fdc2).QUOTE_SINGLE)(rule))
    ];
}
var $7fedcc10a2237f27$export$2e2bcd8739ae039 = (editorAnalyticsAPI)=>new (0, $1S4f7.SafePlugin)((0, $aIMBk.createPlugin)('text-formatting:smart-input', [
        ...$7fedcc10a2237f27$var$getProductRules(editorAnalyticsAPI),
        ...$7fedcc10a2237f27$var$getSymbolRules(editorAnalyticsAPI),
        ...$7fedcc10a2237f27$var$getPunctuationRules(editorAnalyticsAPI)
    ]));


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $9K4OG = parcelRequire("9K4OG");


var $aXWIB = parcelRequire("aXWIB");


var $eiA8Z = parcelRequire("eiA8Z");


var $frHf7 = parcelRequire("frHf7");







var $2cca58939a01b863$export$f84ca76848e3ed34 = /*#__PURE__*/ function(IconTypes) {
    IconTypes["strong"] = "strong";
    IconTypes["em"] = "em";
    IconTypes["underline"] = "underline";
    IconTypes["strike"] = "strike";
    IconTypes["code"] = "code";
    IconTypes["subscript"] = "subscript";
    IconTypes["superscript"] = "superscript";
    return IconTypes;
}({});
var $2cca58939a01b863$export$c1fb0eb1ea3f6fb6 = /*#__PURE__*/ function(FormatOptions) {
    FormatOptions["strong"] = "strong";
    FormatOptions["em"] = "em";
    FormatOptions["underline"] = "underline";
    FormatOptions["strike"] = "strike";
    FormatOptions["code"] = "code";
    FormatOptions["subscript"] = "subscript";
    FormatOptions["superscript"] = "superscript";
    return FormatOptions;
}({});
var $2cca58939a01b863$export$a5d11b3163e4b1a5 = /*#__PURE__*/ function(ToolbarType) {
    ToolbarType["PRIMARY"] = "primaryToolbar";
    ToolbarType["FLOATING"] = "floatingToolbar";
    return ToolbarType;
}({});


const $387041f5cfaa6663$export$37a675a4731536c = [
    (0, $2cca58939a01b863$export$f84ca76848e3ed34).strong,
    (0, $2cca58939a01b863$export$f84ca76848e3ed34).em
];
const $387041f5cfaa6663$export$9930ae1c7f6b53f3 = [
    (0, $2cca58939a01b863$export$f84ca76848e3ed34).strong
];
const $387041f5cfaa6663$export$def34bf0ee813055 = [
    (0, $2cca58939a01b863$export$f84ca76848e3ed34).strong,
    (0, $2cca58939a01b863$export$f84ca76848e3ed34).em,
    (0, $2cca58939a01b863$export$f84ca76848e3ed34).underline
];
const $387041f5cfaa6663$export$5789feaf6941ee12 = [
    (0, $2cca58939a01b863$export$f84ca76848e3ed34).em,
    (0, $2cca58939a01b863$export$f84ca76848e3ed34).underline,
    (0, $2cca58939a01b863$export$f84ca76848e3ed34).strike,
    (0, $2cca58939a01b863$export$f84ca76848e3ed34).code,
    (0, $2cca58939a01b863$export$f84ca76848e3ed34).subscript,
    (0, $2cca58939a01b863$export$f84ca76848e3ed34).superscript
];
const $387041f5cfaa6663$export$f40ebaa61bfc4d53 = [
    (0, $2cca58939a01b863$export$f84ca76848e3ed34).underline,
    (0, $2cca58939a01b863$export$f84ca76848e3ed34).strike,
    (0, $2cca58939a01b863$export$f84ca76848e3ed34).code,
    (0, $2cca58939a01b863$export$f84ca76848e3ed34).subscript,
    (0, $2cca58939a01b863$export$f84ca76848e3ed34).superscript
];
const $387041f5cfaa6663$export$b1ac64c82cac61ce = [
    (0, $2cca58939a01b863$export$f84ca76848e3ed34).strike,
    (0, $2cca58939a01b863$export$f84ca76848e3ed34).code,
    (0, $2cca58939a01b863$export$f84ca76848e3ed34).subscript,
    (0, $2cca58939a01b863$export$f84ca76848e3ed34).superscript
];
const $387041f5cfaa6663$export$13589e95a4a6fb40 = {
    [(0, $frHf7.ToolbarSize).XXL]: $387041f5cfaa6663$export$9930ae1c7f6b53f3,
    [(0, $frHf7.ToolbarSize).XL]: $387041f5cfaa6663$export$9930ae1c7f6b53f3,
    [(0, $frHf7.ToolbarSize).L]: $387041f5cfaa6663$export$9930ae1c7f6b53f3,
    [(0, $frHf7.ToolbarSize).M]: $387041f5cfaa6663$export$9930ae1c7f6b53f3,
    [(0, $frHf7.ToolbarSize).S]: $387041f5cfaa6663$export$9930ae1c7f6b53f3,
    [(0, $frHf7.ToolbarSize).XXXS]: []
};
const $387041f5cfaa6663$export$fdd1bbcb63018330 = {
    [(0, $frHf7.ToolbarSize).XXL]: $387041f5cfaa6663$export$37a675a4731536c,
    [(0, $frHf7.ToolbarSize).XL]: $387041f5cfaa6663$export$37a675a4731536c,
    [(0, $frHf7.ToolbarSize).L]: $387041f5cfaa6663$export$37a675a4731536c,
    [(0, $frHf7.ToolbarSize).M]: $387041f5cfaa6663$export$37a675a4731536c,
    [(0, $frHf7.ToolbarSize).S]: $387041f5cfaa6663$export$37a675a4731536c,
    [(0, $frHf7.ToolbarSize).XXXS]: []
};
const $387041f5cfaa6663$export$861ad8d05e95bc1e = {
    [(0, $frHf7.ToolbarSize).XXL]: $387041f5cfaa6663$export$def34bf0ee813055,
    [(0, $frHf7.ToolbarSize).XL]: $387041f5cfaa6663$export$def34bf0ee813055,
    [(0, $frHf7.ToolbarSize).L]: $387041f5cfaa6663$export$def34bf0ee813055,
    [(0, $frHf7.ToolbarSize).M]: $387041f5cfaa6663$export$37a675a4731536c,
    [(0, $frHf7.ToolbarSize).S]: $387041f5cfaa6663$export$37a675a4731536c,
    [(0, $frHf7.ToolbarSize).XXXS]: $387041f5cfaa6663$export$9930ae1c7f6b53f3
};
const $387041f5cfaa6663$export$1b53a931a2dd9e07 = {
    [(0, $frHf7.ToolbarSize).XXL]: $387041f5cfaa6663$export$5789feaf6941ee12,
    [(0, $frHf7.ToolbarSize).XL]: $387041f5cfaa6663$export$5789feaf6941ee12,
    [(0, $frHf7.ToolbarSize).L]: $387041f5cfaa6663$export$5789feaf6941ee12,
    [(0, $frHf7.ToolbarSize).M]: $387041f5cfaa6663$export$5789feaf6941ee12,
    [(0, $frHf7.ToolbarSize).S]: $387041f5cfaa6663$export$5789feaf6941ee12,
    [(0, $frHf7.ToolbarSize).XXXS]: [
        (0, $2cca58939a01b863$export$f84ca76848e3ed34).strong,
        (0, $2cca58939a01b863$export$f84ca76848e3ed34).em,
        ...$387041f5cfaa6663$export$5789feaf6941ee12
    ]
};
const $387041f5cfaa6663$export$53d57ab9be604153 = {
    [(0, $frHf7.ToolbarSize).XXL]: $387041f5cfaa6663$export$f40ebaa61bfc4d53,
    [(0, $frHf7.ToolbarSize).XL]: $387041f5cfaa6663$export$f40ebaa61bfc4d53,
    [(0, $frHf7.ToolbarSize).L]: $387041f5cfaa6663$export$f40ebaa61bfc4d53,
    [(0, $frHf7.ToolbarSize).M]: $387041f5cfaa6663$export$f40ebaa61bfc4d53,
    [(0, $frHf7.ToolbarSize).S]: $387041f5cfaa6663$export$f40ebaa61bfc4d53,
    [(0, $frHf7.ToolbarSize).XXXS]: [
        (0, $2cca58939a01b863$export$f84ca76848e3ed34).strong,
        (0, $2cca58939a01b863$export$f84ca76848e3ed34).em,
        ...$387041f5cfaa6663$export$f40ebaa61bfc4d53
    ]
};
const $387041f5cfaa6663$export$77ad87491c5fbf88 = {
    [(0, $frHf7.ToolbarSize).XXL]: $387041f5cfaa6663$export$b1ac64c82cac61ce,
    [(0, $frHf7.ToolbarSize).XL]: $387041f5cfaa6663$export$b1ac64c82cac61ce,
    [(0, $frHf7.ToolbarSize).L]: $387041f5cfaa6663$export$b1ac64c82cac61ce,
    [(0, $frHf7.ToolbarSize).M]: [
        (0, $2cca58939a01b863$export$f84ca76848e3ed34).underline,
        ...$387041f5cfaa6663$export$b1ac64c82cac61ce
    ],
    [(0, $frHf7.ToolbarSize).S]: [
        (0, $2cca58939a01b863$export$f84ca76848e3ed34).underline,
        ...$387041f5cfaa6663$export$b1ac64c82cac61ce
    ],
    [(0, $frHf7.ToolbarSize).XXXS]: [
        (0, $2cca58939a01b863$export$f84ca76848e3ed34).em,
        (0, $2cca58939a01b863$export$f84ca76848e3ed34).underline,
        ...$387041f5cfaa6663$export$b1ac64c82cac61ce
    ]
};






var $2zaaI = parcelRequire("2zaaI");


var $h4TOP = parcelRequire("h4TOP");


var $aFUXX = parcelRequire("aFUXX");




/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("42omo");





var $cORDs = parcelRequire("cORDs");

var $iMS6j = parcelRequire("iMS6j");


var $a4eZN = parcelRequire("a4eZN");


var $ghftu = parcelRequire("ghftu");


var $2gUVF = parcelRequire("2gUVF");


const $847dc66460b82017$export$7c43b97d70f40057 = ({ label: label, isReducedSpacing: isReducedSpacing, isDisabled: isDisabled, isSelected: isSelected, 'aria-expanded': ariaExpanded, onClick: onClick, onKeyDown: onKeyDown, toolbarType: toolbarType, iconBefore: iconBefore, activeIconName: activeIconName })=>{
    const reducedSpacing = toolbarType === (0, $2cca58939a01b863$export$a5d11b3163e4b1a5).FLOATING ? 'compact' : 'none';
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $a4eZN.default), {
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-imported-style-values
        css: (0, $cORDs.disableBlueBorderStyles),
        testId: 'ak-editor-selection-toolbar-format-text-button',
        spacing: isReducedSpacing ? reducedSpacing : 'default',
        disabled: isDisabled,
        selected: isSelected,
        "aria-label": label,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": true,
        title: label,
        onClick: onClick,
        onKeyDown: onKeyDown,
        iconBefore: /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $cORDs.triggerWrapperStylesWithPadding),
            "data-testid": activeIconName ? `editor-toolbar__${activeIconName}` : undefined
        }, iconBefore ? iconBefore : /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2gUVF))), {
            color: "currentColor",
            spacing: "spacious",
            label: ""
        }), /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            css: (0, $iMS6j.expandIconContainerStyle),
            "data-vc": "2LmmT7mc"
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
            label: "",
            color: "currentColor",
            size: "small"
        })))
    });
};





const $13c41b8af588762d$export$8091e3849c182a6 = ()=>{
    const [isMenuOpen, setIsMenuOpened] = (0, $42omo.useState)(false);
    const toggleMenu = (0, $42omo.useCallback)(()=>{
        setIsMenuOpened(!isMenuOpen);
    }, [
        isMenuOpen
    ]);
    const closeMenu = (0, $42omo.useCallback)(()=>{
        setIsMenuOpened(false);
    }, []);
    return [
        isMenuOpen,
        toggleMenu,
        closeMenu
    ];
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 









var $9VJDA = parcelRequire("9VJDA");

function $140891e9e23b787e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $140891e9e23b787e$var$MoreIconStyle = {
    name: "1m17jn9",
    styles: "display:flex;align-items:center;height:var(--ds-space-300, 24px)"
};
const $140891e9e23b787e$export$7f94856880993f27 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ label: label, 'aria-expanded': ariaExpanded, isReducedSpacing: isReducedSpacing, isSelected: isSelected, isDisabled: isDisabled, onClick: onClick, onKeyDown: onKeyDown })=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $a4eZN.default), {
        disabled: isDisabled,
        selected: isSelected,
        onClick: onClick,
        onKeyDown: onKeyDown,
        spacing: isReducedSpacing ? 'none' : 'default',
        title: label,
        iconBefore: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: $140891e9e23b787e$var$MoreIconStyle,
            "data-vc": "OaMvqgk0"
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
            label: "",
            color: "currentColor",
            spacing: "spacious",
            size: "small"
        })),
        "aria-expanded": ariaExpanded,
        "aria-label": label,
        "aria-haspopup": true
    });
});


const $e664dcb48a74cd94$export$52e9a2bbe5d185e8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ editorView: editorView, moreButtonLabel: moreButtonLabel, isReducedSpacing: isReducedSpacing, items: items, hasFormattingActive: hasFormattingActive, popupsBoundariesElement: popupsBoundariesElement, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement, hasMoreButton: hasMoreButton, intl: intl, toolbarType: toolbarType, isDisabled: isDisabled })=>{
    const [isMenuOpen, toggleMenu, closeMenu] = (0, $13c41b8af588762d$export$8091e3849c182a6)();
    const [isOpenedByKeyboard, setIsOpenedByKeyboard] = (0, $42omo.useState)(false);
    const onItemActivated = (0, $42omo.useCallback)(({ item: item, shouldCloseMenu: shouldCloseMenu = true })=>{
        if (item) {
            item.command(editorView.state, editorView.dispatch);
            if (shouldCloseMenu) closeMenu();
        }
    }, [
        editorView.state,
        editorView.dispatch,
        closeMenu
    ]);
    const activeItem = items[0].items.find((item)=>item.isActive);
    const defaultIcon = (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? items[0].items[0]?.elemBefore : undefined;
    const defaultIconName = items[0].items[0]?.value.name;
    const iconBefore = activeItem ? activeItem?.elemBefore : defaultIcon;
    const activeIconName = activeItem?.value.name || defaultIconName;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $h4TOP.DropdownMenuWithKeyboardNavigation), {
        mountTo: popupsMountPoint,
        onOpenChange: closeMenu,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        onItemActivated: onItemActivated,
        isOpen: isMenuOpen,
        items: items,
        zIndex: (0, $aFUXX.akEditorMenuZIndex),
        fitHeight: 188,
        fitWidth: (0, $iu6m9.editorExperiment)('platform_editor_controls', 'control') ? 136 : 230,
        shouldUseDefaultRole: true,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        section: {
            hasSeparator: true
        },
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        shouldFocusFirstItem: ()=>{
            if (isOpenedByKeyboard) setIsOpenedByKeyboard(false);
            return isOpenedByKeyboard;
        }
    }, hasMoreButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $140891e9e23b787e$export$7f94856880993f27), {
        isSelected: isMenuOpen || hasFormattingActive,
        label: moreButtonLabel,
        isReducedSpacing: isReducedSpacing,
        isDisabled: false,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onClick: ()=>{
            toggleMenu();
            setIsOpenedByKeyboard(false);
        },
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onKeyDown: (event)=>{
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                toggleMenu();
                setIsOpenedByKeyboard(true);
            }
        },
        "aria-expanded": isMenuOpen
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $847dc66460b82017$export$7c43b97d70f40057), {
        isReducedSpacing: isReducedSpacing,
        isDisabled: Boolean(isDisabled),
        isSelected: isMenuOpen,
        label: intl.formatMessage((0, $2zaaI.toolbarMessages).textFormat),
        "aria-expanded": isMenuOpen,
        "aria-haspopup": true,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onClick: ()=>{
            toggleMenu();
            setIsOpenedByKeyboard(false);
        },
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onKeyDown: (event)=>{
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                toggleMenu();
                setIsOpenedByKeyboard(true);
            }
        },
        toolbarType: toolbarType,
        iconBefore: iconBefore,
        activeIconName: activeIconName
    }));
});


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 












var $6f5RK = parcelRequire("6f5RK");


var $iV7dk = parcelRequire("iV7dk");









const $a5628beebd6ca577$export$ec2f5afcaf7ee094 = {
    [(0, $2cca58939a01b863$export$a5d11b3163e4b1a5).PRIMARY]: (0, $d925B.INPUT_METHOD).TOOLBAR,
    [(0, $2cca58939a01b863$export$a5d11b3163e4b1a5).FLOATING]: (0, $d925B.INPUT_METHOD).FLOATING_TB
};
const $a5628beebd6ca577$export$8213a6fbfa466e73 = (toolbarType)=>$a5628beebd6ca577$export$ec2f5afcaf7ee094[toolbarType];


const $1996c9b6f6bd9ee0$export$4ff17fae4b9914b = ({ intl: intl, formattingPluginInitialised: formattingPluginInitialised, formattingIsPresent: formattingPresent, editorAnalyticsAPI: editorAnalyticsAPI, toolbarType: toolbarType })=>{
    const isPluginAvailable = Boolean(formattingPluginInitialised);
    const formattingIsPresent = Boolean(formattingPresent);
    const clearFormattingLabel = intl.formatMessage((0, $2zaaI.toolbarMessages).clearFormatting);
    const clearFormattingToolbar = (0, $42omo.useCallback)((state, dispatch)=>(0, $259f2a142ea36336$export$332a1f720fc2ba0)((0, $a5628beebd6ca577$export$8213a6fbfa466e73)(toolbarType), editorAnalyticsAPI)(state, dispatch), [
        editorAnalyticsAPI,
        toolbarType
    ]);
    return (0, $42omo.useMemo)(()=>{
        if (!isPluginAvailable) return null;
        return {
            key: 'clearFormatting',
            command: clearFormattingToolbar,
            content: clearFormattingLabel,
            elemBefore: (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iV7dk))), {
                label: ""
            }) : undefined,
            elemAfter: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
                css: (0, $6f5RK.shortcutStyle),
                "data-vc": "d0FgC2gj"
            }, (0, $hgeg8.tooltip)((0, $hgeg8.clearFormatting))),
            value: {
                name: 'clearFormatting'
            },
            isActive: false,
            isDisabled: !formattingIsPresent,
            'aria-label': (0, $hgeg8.clearFormatting) ? (0, $hgeg8.tooltip)((0, $hgeg8.clearFormatting), String(clearFormattingLabel)) : String(clearFormattingLabel)
        };
    }, [
        isPluginAvailable,
        clearFormattingToolbar,
        clearFormattingLabel,
        formattingIsPresent
    ]);
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 






var $8TW6I = parcelRequire("8TW6I");








var $gmyMu = parcelRequire("gmyMu");





var $eIlE7 = parcelRequire("eIlE7");


var $7gIXe = parcelRequire("7gIXe");





var $jHpAD = parcelRequire("jHpAD");


var $4E5My = parcelRequire("4E5My");





/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 


const $c2effb35c1d6195c$var$SVGContainer = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        style: {
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)",
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        },
        "data-vc": "ZyQMOVxS"
    }, children);
const $c2effb35c1d6195c$export$54eb3b8088f84d2b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c2effb35c1d6195c$var$SVGContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M5.10609 6.54799L7.88895 2.09448L9.16102 2.88936L5.99047 7.9633L9.21219 13.1191L7.94012 13.914L5.10609 9.37861L2.27207 13.914L1 13.1191L4.2217 7.9633L1.05117 2.88939L2.32324 2.09451L5.10609 6.54799ZM10.858 15.0001V13.696H12.3499V10.3153L10.8418 11.4343V9.86413L12.3138 8.83114H13.8161V13.696H14.9999V15.0001H10.858Z",
        fill: "currentColor"
    })));
const $c2effb35c1d6195c$export$a4eac561e2e9d419 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c2effb35c1d6195c$var$SVGContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M10.858 7.16892V5.86487H12.3499V2.4842L10.8418 3.60312V2.03298L12.3138 1H13.8161V5.86487H14.9999V7.16892H10.858ZM5.10609 6.5479L7.88895 2.09439L9.16102 2.88927L5.99047 7.96321L9.21219 13.119L7.94012 13.9139L5.10609 9.37852L2.27207 13.9139L1 13.119L4.2217 7.96321L1.05117 2.8893L2.32324 2.09442L5.10609 6.5479Z",
        fill: "currentColor"
    })));




const $74f32cf3e14ca459$var$withInputMethod = (toolbarType, func)=>(0, $gmyMu.editorCommandToPMCommand)(func((0, $a5628beebd6ca577$export$8213a6fbfa466e73)(toolbarType)));
const $74f32cf3e14ca459$var$IconButtons = (editorAnalyticsAPI, toolbarType)=>({
        strong: {
            buttonId: (0, $8TW6I.TOOLBAR_ACTION_SUBJECT_ID).TEXT_FORMATTING_STRONG,
            command: $74f32cf3e14ca459$var$withInputMethod(toolbarType, (0, $bb3f69b8f70e233b$export$686bc7c29753e27)(editorAnalyticsAPI)),
            message: (0, $2zaaI.toolbarMessages).bold,
            tooltipKeymap: (0, $hgeg8.toggleBold),
            component: ()=>/*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7gIXe))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: ""
                })
        },
        em: {
            buttonId: (0, $8TW6I.TOOLBAR_ACTION_SUBJECT_ID).TEXT_FORMATTING_ITALIC,
            command: $74f32cf3e14ca459$var$withInputMethod(toolbarType, (0, $bb3f69b8f70e233b$export$fe8278eb0d365433)(editorAnalyticsAPI)),
            message: (0, $2zaaI.toolbarMessages).italic,
            tooltipKeymap: (0, $hgeg8.toggleItalic),
            component: ()=>/*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2gUVF))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: ""
                })
        },
        underline: {
            buttonId: (0, $8TW6I.TOOLBAR_ACTION_SUBJECT_ID).TEXT_FORMATTING_UNDERLINE,
            command: $74f32cf3e14ca459$var$withInputMethod(toolbarType, (0, $bb3f69b8f70e233b$export$bf3c86b5abdb857d)(editorAnalyticsAPI)),
            message: (0, $2zaaI.toolbarMessages).underline,
            tooltipKeymap: (0, $hgeg8.toggleUnderline),
            component: ()=>/*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4E5My))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: ""
                })
        },
        strike: {
            command: $74f32cf3e14ca459$var$withInputMethod(toolbarType, (0, $bb3f69b8f70e233b$export$f08ef336cb688397)(editorAnalyticsAPI)),
            message: (0, $2zaaI.toolbarMessages).strike,
            tooltipKeymap: (0, $hgeg8.toggleStrikethrough)
        },
        code: {
            command: $74f32cf3e14ca459$var$withInputMethod(toolbarType, (0, $bb3f69b8f70e233b$export$2d4f5a54f840ba91)(editorAnalyticsAPI)),
            message: (0, $2zaaI.toolbarMessages).code,
            tooltipKeymap: (0, $hgeg8.toggleCode)
        },
        subscript: {
            command: $74f32cf3e14ca459$var$withInputMethod(toolbarType, (0, $bb3f69b8f70e233b$export$8d0c92ae27a193)(editorAnalyticsAPI)),
            message: (0, $2zaaI.toolbarMessages).subscript,
            tooltipKeymap: (0, $hgeg8.toggleSubscript)
        },
        superscript: {
            command: $74f32cf3e14ca459$var$withInputMethod(toolbarType, (0, $bb3f69b8f70e233b$export$ca1c98793b67ba6b)(editorAnalyticsAPI)),
            message: (0, $2zaaI.toolbarMessages).superscript,
            tooltipKeymap: (0, $hgeg8.toggleSuperscript)
        }
    });
const $74f32cf3e14ca459$var$IconBefore = {
    strong: {
        icon: /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7gIXe))), {
            color: "currentColor",
            spacing: "spacious",
            label: ""
        })
    },
    em: {
        icon: /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2gUVF))), {
            color: "currentColor",
            spacing: "spacious",
            label: ""
        })
    },
    underline: {
        icon: /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4E5My))), {
            color: "currentColor",
            spacing: "spacious",
            label: ""
        })
    },
    strike: {
        icon: /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jHpAD))), {
            label: ""
        })
    },
    code: {
        icon: /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eIlE7))), {
            color: "currentColor",
            spacing: "spacious",
            label: ""
        })
    },
    subscript: {
        icon: /*#__PURE__*/ (0, $9K4OG.jsx)((0, $c2effb35c1d6195c$export$54eb3b8088f84d2b), null)
    },
    superscript: {
        icon: /*#__PURE__*/ (0, $9K4OG.jsx)((0, $c2effb35c1d6195c$export$a4eac561e2e9d419), null)
    }
};
const $74f32cf3e14ca459$var$getIcon = ({ iconType: iconType, isDisabled: isDisabled, isActive: isActive, intl: intl, editorAnalyticsAPI: editorAnalyticsAPI, toolbarType: toolbarType })=>{
    const icon = $74f32cf3e14ca459$var$IconButtons(editorAnalyticsAPI, toolbarType)[iconType];
    const iconBefore = $74f32cf3e14ca459$var$IconBefore[iconType].icon;
    const content = intl.formatMessage(icon.message);
    const { tooltipKeymap: tooltipKeymap } = icon;
    return {
        content: content,
        buttonId: icon.buttonId,
        iconMark: iconType,
        key: iconType,
        command: icon.command,
        iconElement: icon.component ? icon.component() : undefined,
        tooltipElement: tooltipKeymap ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, $hgeg8.ToolTipContent), {
            description: content,
            keymap: tooltipKeymap
        }) : undefined,
        elemBefore: (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? iconBefore : undefined,
        elemAfter: tooltipKeymap ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: (0, $6f5RK.shortcutStyle),
            "data-vc": "JHQ_l3x5"
        }, (0, $hgeg8.tooltip)(tooltipKeymap)) : undefined,
        value: {
            name: iconType
        },
        isActive: isActive,
        isDisabled: isDisabled,
        'aria-label': tooltipKeymap ? (0, $hgeg8.tooltip)(tooltipKeymap, String(content)) : String(content),
        'aria-keyshortcuts': (0, $hgeg8.getAriaKeyshortcuts)(tooltipKeymap)
    };
};
const $74f32cf3e14ca459$var$IconsMarkSchema = {
    [(0, $2cca58939a01b863$export$f84ca76848e3ed34).strong]: 'strong',
    [(0, $2cca58939a01b863$export$f84ca76848e3ed34).em]: 'em',
    [(0, $2cca58939a01b863$export$f84ca76848e3ed34).strike]: 'strike',
    [(0, $2cca58939a01b863$export$f84ca76848e3ed34).code]: 'code',
    [(0, $2cca58939a01b863$export$f84ca76848e3ed34).underline]: 'underline',
    [(0, $2cca58939a01b863$export$f84ca76848e3ed34).superscript]: 'subsup',
    [(0, $2cca58939a01b863$export$f84ca76848e3ed34).subscript]: 'subsup'
};
const $74f32cf3e14ca459$var$buildMenuIconState = (iconMark)=>({ schema: schema, textFormattingState: textFormattingState })=>{
        const hasPluginState = Boolean(textFormattingState?.isInitialised);
        const markSchema = $74f32cf3e14ca459$var$IconsMarkSchema[iconMark];
        const hasSchemaMark = Boolean(schema.marks[markSchema]);
        if (!hasPluginState) return {
            isActive: false,
            isDisabled: true,
            isHidden: false,
            hasSchemaMark: hasSchemaMark
        };
        const isActive = textFormattingState?.[`${iconMark}Active`];
        const isDisabled = textFormattingState?.[`${iconMark}Disabled`];
        const isHidden = textFormattingState?.[`${iconMark}Hidden`];
        return {
            isActive: Boolean(isActive),
            isDisabled: Boolean(isDisabled),
            isHidden: Boolean(isHidden),
            hasSchemaMark: hasSchemaMark
        };
    };
const $74f32cf3e14ca459$var$buildIcon = (iconMark, editorAnalyticsAPI, toolbarType)=>{
    const getState = $74f32cf3e14ca459$var$buildMenuIconState(iconMark);
    return ({ schema: schema, textFormattingState: textFormattingState, intl: intl, isToolbarDisabled: isToolbarDisabled })=>{
        const iconState = getState({
            schema: schema,
            textFormattingState: textFormattingState
        });
        const { isActive: isActive, isDisabled: isDisabled, isHidden: isHidden, hasSchemaMark: hasSchemaMark } = iconState;
        const iconComponent = (0, $42omo.useMemo)(()=>$74f32cf3e14ca459$var$getIcon({
                iconType: (0, $2cca58939a01b863$export$f84ca76848e3ed34)[iconMark],
                isDisabled: isToolbarDisabled || isDisabled,
                isActive: isActive,
                intl: intl,
                editorAnalyticsAPI: editorAnalyticsAPI,
                toolbarType: toolbarType
            }), [
            isToolbarDisabled,
            isDisabled,
            isActive,
            intl
        ]);
        const shouldRenderIcon = hasSchemaMark && !isHidden;
        return (0, $42omo.useMemo)(()=>shouldRenderIcon ? iconComponent : null, [
            shouldRenderIcon,
            iconComponent
        ]);
    };
};
const $74f32cf3e14ca459$export$6f298ec13df828 = ({ isToolbarDisabled: isToolbarDisabled, textFormattingState: textFormattingState, schema: schema, intl: intl, editorAnalyticsAPI: editorAnalyticsAPI, toolbarType: toolbarType })=>{
    const props = {
        schema: schema,
        textFormattingState: textFormattingState,
        intl: intl,
        isToolbarDisabled: Boolean(isToolbarDisabled),
        toolbarType: toolbarType
    };
    const buildStrongIcon = $74f32cf3e14ca459$var$buildIcon((0, $2cca58939a01b863$export$f84ca76848e3ed34).strong, editorAnalyticsAPI, toolbarType);
    const buildEmIcon = $74f32cf3e14ca459$var$buildIcon((0, $2cca58939a01b863$export$f84ca76848e3ed34).em, editorAnalyticsAPI, toolbarType);
    const buildUnderlineIcon = $74f32cf3e14ca459$var$buildIcon((0, $2cca58939a01b863$export$f84ca76848e3ed34).underline, editorAnalyticsAPI, toolbarType);
    const buildStrikeIcon = $74f32cf3e14ca459$var$buildIcon((0, $2cca58939a01b863$export$f84ca76848e3ed34).strike, editorAnalyticsAPI, toolbarType);
    const buildCodeIcon = $74f32cf3e14ca459$var$buildIcon((0, $2cca58939a01b863$export$f84ca76848e3ed34).code, editorAnalyticsAPI, toolbarType);
    const buildSubscriptIcon = $74f32cf3e14ca459$var$buildIcon((0, $2cca58939a01b863$export$f84ca76848e3ed34).subscript, editorAnalyticsAPI, toolbarType);
    const buildSuperscriptIcon = $74f32cf3e14ca459$var$buildIcon((0, $2cca58939a01b863$export$f84ca76848e3ed34).superscript, editorAnalyticsAPI, toolbarType);
    const strongIcon = buildStrongIcon(props);
    const emIcon = buildEmIcon(props);
    const underlineIcon = buildUnderlineIcon(props);
    const strikeIcon = buildStrikeIcon(props);
    const codeIcon = buildCodeIcon(props);
    const subscriptIcon = buildSubscriptIcon(props);
    const superscriptIcon = buildSuperscriptIcon(props);
    const result = (0, $42omo.useMemo)(()=>[
            strongIcon,
            emIcon,
            underlineIcon,
            strikeIcon,
            codeIcon,
            subscriptIcon,
            superscriptIcon
        ], [
        strongIcon,
        emIcon,
        underlineIcon,
        strikeIcon,
        codeIcon,
        subscriptIcon,
        superscriptIcon
    ]);
    return result;
};
const $74f32cf3e14ca459$export$cb0a2ed6e982a08f = ({ iconTypeList: iconTypeList, textFormattingState: textFormattingState })=>{
    const hasActiveFormatting = (0, $42omo.useMemo)(()=>{
        if (!textFormattingState?.isInitialised) return false;
        return iconTypeList.some((iconType)=>textFormattingState[`${iconType}Active`]);
    }, [
        textFormattingState,
        iconTypeList
    ]);
    return hasActiveFormatting;
};





const $79aeb6914e29e11a$export$894adbec036a07c6 = ({ icons: icons, iconTypeList: iconTypeList })=>{
    return (0, $42omo.useMemo)(()=>{
        return icons.reduce((acc, icon)=>{
            if (!icon || !icon.iconMark) return acc;
            const isIconSingleButton = iconTypeList.includes(icon.iconMark);
            if (isIconSingleButton) return {
                dropdownItems: acc.dropdownItems,
                singleItems: [
                    ...acc.singleItems,
                    icon
                ]
            };
            return {
                dropdownItems: [
                    ...acc.dropdownItems,
                    icon
                ],
                singleItems: acc.singleItems
            };
        }, {
            dropdownItems: [],
            singleItems: []
        });
    }, [
        icons,
        iconTypeList
    ]);
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 











const $bd700498505ff390$export$e3e9702c9c21585 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ items: items, isReducedSpacing: isReducedSpacing, editorView: editorView })=>{
    const onClick = (0, $42omo.useCallback)((command)=>{
        return ()=>{
            command(editorView.state, editorView.dispatch);
            return false;
        };
    }, [
        editorView.state,
        editorView.dispatch
    ]);
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        css: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
        (0, $cORDs.buttonGroupStyle),
        "data-vc": "vYX8JQ8Q"
    }, items.map((item)=>/*#__PURE__*/ (0, $9K4OG.jsx)((0, $a4eZN.default), {
            key: item.key,
            testId: `editor-toolbar__${String(item.content)}`,
            buttonId: item.buttonId,
            spacing: isReducedSpacing ? 'none' : 'default',
            onClick: onClick(item.command),
            selected: item.isActive,
            disabled: item.isDisabled,
            title: item.tooltipElement,
            iconBefore: item.iconElement,
            "aria-pressed": item.isActive,
            "aria-label": item['aria-label'] ?? String(item.content),
            "aria-keyshortcuts": item['aria-keyshortcuts']
        }))));
});



const $f5dbb937cfa2eba4$var$FloatingToolbarSettings = {
    disabled: false,
    isReducedSpacing: true,
    shouldUseResponsiveToolbar: false,
    toolbarSize: (0, $frHf7.ToolbarSize).S,
    hasMoreButton: false,
    moreButtonLabel: '',
    toolbarType: (0, $2cca58939a01b863$export$a5d11b3163e4b1a5).FLOATING
};
const $f5dbb937cfa2eba4$var$selector = (states)=>{
    return {
        isInitialised: Boolean(states.textFormattingState?.isInitialised),
        formattingIsPresent: states.textFormattingState?.formattingIsPresent,
        emActive: states.textFormattingState?.emActive,
        emDisabled: states.textFormattingState?.emDisabled,
        emHidden: states.textFormattingState?.emHidden,
        codeActive: states.textFormattingState?.codeActive,
        codeDisabled: states.textFormattingState?.codeDisabled,
        codeHidden: states.textFormattingState?.codeHidden,
        underlineActive: states.textFormattingState?.underlineActive,
        underlineDisabled: states.textFormattingState?.underlineDisabled,
        underlineHidden: states.textFormattingState?.underlineHidden,
        strikeActive: states.textFormattingState?.strikeActive,
        strikeDisabled: states.textFormattingState?.strikeDisabled,
        strikeHidden: states.textFormattingState?.strikeHidden,
        strongActive: states.textFormattingState?.strongActive,
        strongDisabled: states.textFormattingState?.strongDisabled,
        strongHidden: states.textFormattingState?.strongHidden,
        superscriptActive: states.textFormattingState?.superscriptActive,
        superscriptDisabled: states.textFormattingState?.superscriptDisabled,
        superscriptHidden: states.textFormattingState?.superscriptHidden,
        subscriptActive: states.textFormattingState?.subscriptActive,
        subscriptDisabled: states.textFormattingState?.subscriptDisabled,
        subscriptHidden: states.textFormattingState?.subscriptHidden
    };
};
const $f5dbb937cfa2eba4$var$FloatingToolbarTextFormat = ({ api: api, editorAnalyticsAPI: editorAnalyticsAPI, editorView: editorView, intl: intl })=>{
    const textFormattingState = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'textFormatting'
    ], $f5dbb937cfa2eba4$var$selector);
    const { formattingIsPresent: formattingIsPresent, ...formattingIconState } = textFormattingState;
    const defaultIcons = (0, $74f32cf3e14ca459$export$6f298ec13df828)({
        schema: editorView.state.schema,
        intl: intl,
        isToolbarDisabled: $f5dbb937cfa2eba4$var$FloatingToolbarSettings.disabled,
        editorAnalyticsAPI: editorAnalyticsAPI,
        textFormattingState: formattingIconState,
        toolbarType: $f5dbb937cfa2eba4$var$FloatingToolbarSettings.toolbarType
    });
    const { dropdownItems: dropdownItems, singleItems: singleItems } = (0, $79aeb6914e29e11a$export$894adbec036a07c6)({
        icons: defaultIcons,
        iconTypeList: (0, $387041f5cfaa6663$export$9930ae1c7f6b53f3)
    });
    const clearIcon = (0, $1996c9b6f6bd9ee0$export$4ff17fae4b9914b)({
        formattingPluginInitialised: textFormattingState.isInitialised,
        formattingIsPresent: formattingIsPresent,
        intl: intl,
        editorAnalyticsAPI: editorAnalyticsAPI,
        toolbarType: $f5dbb937cfa2eba4$var$FloatingToolbarSettings.toolbarType
    });
    const items = (0, $42omo.useMemo)(()=>{
        if (!clearIcon) return [
            {
                items: dropdownItems
            }
        ];
        return [
            {
                items: dropdownItems
            },
            {
                items: [
                    clearIcon
                ]
            }
        ];
    }, [
        clearIcon,
        dropdownItems
    ]);
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $bd700498505ff390$export$e3e9702c9c21585), {
        items: singleItems,
        editorView: editorView,
        isReducedSpacing: false
    }), /*#__PURE__*/ (0, $9K4OG.jsx)((0, $e664dcb48a74cd94$export$52e9a2bbe5d185e8), {
        editorView: editorView,
        items: items,
        isReducedSpacing: (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? false : $f5dbb937cfa2eba4$var$FloatingToolbarSettings.isReducedSpacing,
        moreButtonLabel: $f5dbb937cfa2eba4$var$FloatingToolbarSettings.moreButtonLabel,
        hasFormattingActive: $f5dbb937cfa2eba4$var$FloatingToolbarSettings.hasMoreButton,
        hasMoreButton: $f5dbb937cfa2eba4$var$FloatingToolbarSettings.hasMoreButton,
        intl: intl,
        toolbarType: $f5dbb937cfa2eba4$var$FloatingToolbarSettings.toolbarType
    }));
};
const $f5dbb937cfa2eba4$export$d728f1bdde37938b = (0, $aXWIB.injectIntl)($f5dbb937cfa2eba4$var$FloatingToolbarTextFormat);








/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 









var $7541v = parcelRequire("7541v");








var $cftLn = parcelRequire("cftLn");












var $dZ8uq = parcelRequire("dZ8uq");



const $0ebb7f33b77e48eb$export$29ca18d8ace26dd8 = ({ toolbarSize: toolbarSize, responsivenessEnabled: responsivenessEnabled })=>{
    let ResponsiveCustomButtonToolbar = (0, $387041f5cfaa6663$export$fdd1bbcb63018330);
    if ((0, $dZ8uq.expValEqualsNoExposure)('platform_editor_controls', 'cohort', 'variant1')) ResponsiveCustomButtonToolbar = (0, $387041f5cfaa6663$export$13589e95a4a6fb40);
    const iconTypeList = (0, $42omo.useMemo)(()=>ResponsiveCustomButtonToolbar[toolbarSize], [
        toolbarSize,
        ResponsiveCustomButtonToolbar
    ]);
    if (responsivenessEnabled) return iconTypeList;
    if ((0, $dZ8uq.expValEqualsNoExposure)('platform_editor_controls', 'cohort', 'variant1')) return 0, $387041f5cfaa6663$export$9930ae1c7f6b53f3;
    else return 0, $387041f5cfaa6663$export$37a675a4731536c;
};
const $0ebb7f33b77e48eb$export$110e6c3d6580196f = ({ toolbarSize: toolbarSize, responsivenessEnabled: responsivenessEnabled })=>{
    let ResponsiveCustomMenu = (0, $387041f5cfaa6663$export$53d57ab9be604153);
    if ((0, $dZ8uq.expValEqualsNoExposure)('platform_editor_controls', 'cohort', 'variant1')) ResponsiveCustomMenu = (0, $387041f5cfaa6663$export$1b53a931a2dd9e07);
    const iconTypeList = (0, $42omo.useMemo)(()=>ResponsiveCustomMenu[toolbarSize], [
        toolbarSize,
        ResponsiveCustomMenu
    ]);
    if (responsivenessEnabled) return iconTypeList;
    if ((0, $dZ8uq.expValEqualsNoExposure)('platform_editor_controls', 'cohort', 'variant1')) return 0, $387041f5cfaa6663$export$5789feaf6941ee12;
    else return 0, $387041f5cfaa6663$export$37a675a4731536c;
};
const $0ebb7f33b77e48eb$export$efa5449fdb315092 = ({ icons: icons, toolbarSize: toolbarSize, responsivenessEnabled: responsivenessEnabled })=>{
    const iconTypeList = $0ebb7f33b77e48eb$export$29ca18d8ace26dd8({
        toolbarSize: toolbarSize,
        responsivenessEnabled: responsivenessEnabled
    });
    const iconsPosition = (0, $79aeb6914e29e11a$export$894adbec036a07c6)({
        icons: icons,
        iconTypeList: iconTypeList
    });
    return iconsPosition;
};




const $c9359b424429db47$var$ToolbarFormatting = ({ shouldUseResponsiveToolbar: shouldUseResponsiveToolbar, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, editorView: editorView, toolbarSize: toolbarSize, isReducedSpacing: isReducedSpacing, isToolbarDisabled: isToolbarDisabled, intl: intl, editorAnalyticsAPI: editorAnalyticsAPI, textFormattingState: textFormattingState, api: api, toolbarType: toolbarType })=>{
    const [message, setMessage] = (0, $42omo.useState)('');
    const { formattingIsPresent: formattingIsPresent, ...formattingIconState } = textFormattingState;
    const defaultIcons = (0, $74f32cf3e14ca459$export$6f298ec13df828)({
        schema: editorView.state.schema,
        intl: intl,
        isToolbarDisabled: isToolbarDisabled,
        editorAnalyticsAPI: editorAnalyticsAPI,
        textFormattingState: formattingIconState,
        toolbarType: toolbarType
    });
    const clearIcon = (0, $1996c9b6f6bd9ee0$export$4ff17fae4b9914b)({
        formattingPluginInitialised: textFormattingState.isInitialised,
        formattingIsPresent: formattingIsPresent,
        intl: intl,
        editorAnalyticsAPI: editorAnalyticsAPI,
        toolbarType: toolbarType
    });
    const menuIconTypeList = (0, $0ebb7f33b77e48eb$export$110e6c3d6580196f)({
        toolbarSize: toolbarSize,
        responsivenessEnabled: shouldUseResponsiveToolbar
    });
    const hasFormattingActive = (0, $74f32cf3e14ca459$export$cb0a2ed6e982a08f)({
        iconTypeList: menuIconTypeList,
        textFormattingState: textFormattingState
    });
    const { dropdownItems: dropdownItems, singleItems: singleItems } = (0, $0ebb7f33b77e48eb$export$efa5449fdb315092)({
        icons: defaultIcons,
        toolbarSize: toolbarSize,
        responsivenessEnabled: shouldUseResponsiveToolbar
    });
    const clearFormattingStatus = intl.formatMessage((0, $2zaaI.toolbarMessages).textFormattingOff);
    const superscriptOffSubscriptOnStatus = intl.formatMessage((0, $2zaaI.toolbarMessages).superscriptOffSubscriptOn);
    const subscriptOffSuperscriptOnStatus = intl.formatMessage((0, $2zaaI.toolbarMessages).subscriptOffSuperscriptOn);
    // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
    const activeItems = [
        ...dropdownItems,
        ...singleItems
    ].filter((item)=>item.isActive);
    const prevActiveItems = (0, $7541v.default)(activeItems) ?? [];
    const fromSuperscriptToSubscript = (0, $b6372db181ff20ac$export$f8f79f933a3fce55)(activeItems, 'Subscript') && (0, $b6372db181ff20ac$export$f8f79f933a3fce55)(prevActiveItems, 'Superscript');
    const fromSubscriptToSuperscript = (0, $b6372db181ff20ac$export$f8f79f933a3fce55)(activeItems, 'Superscript') && (0, $b6372db181ff20ac$export$f8f79f933a3fce55)(prevActiveItems, 'Subscript');
    let comparedItems;
    let screenReaderMessage = '';
    if (prevActiveItems && activeItems.length > prevActiveItems.length) {
        comparedItems = (0, $b6372db181ff20ac$export$53d327693050b221)(activeItems, prevActiveItems);
        screenReaderMessage = intl.formatMessage((0, $2zaaI.toolbarMessages).on, {
            formattingType: comparedItems[0].content
        });
    } else {
        comparedItems = (0, $b6372db181ff20ac$export$53d327693050b221)(prevActiveItems, activeItems);
        if (comparedItems && comparedItems.length) {
            screenReaderMessage = intl.formatMessage((0, $2zaaI.toolbarMessages).off, {
                formattingType: comparedItems[0].content
            });
            if (activeItems[0]?.content === 'Code') screenReaderMessage = intl.formatMessage((0, $2zaaI.toolbarMessages).codeOn, {
                textFormattingOff: prevActiveItems?.length > 1 ? clearFormattingStatus : screenReaderMessage
            });
            if (fromSuperscriptToSubscript) screenReaderMessage = superscriptOffSubscriptOnStatus;
            if (fromSubscriptToSuperscript) screenReaderMessage = subscriptOffSuperscriptOnStatus;
        }
    }
    // handle 'Clear formatting' status for screen readers
    if (!activeItems?.length && prevActiveItems?.length > 1) screenReaderMessage = clearFormattingStatus;
    const items = (0, $42omo.useMemo)(()=>{
        if (!clearIcon) return [
            {
                items: dropdownItems
            }
        ];
        return [
            {
                items: dropdownItems
            },
            {
                items: [
                    clearIcon
                ]
            }
        ];
    }, [
        clearIcon,
        dropdownItems
    ]);
    const moreFormattingButtonLabel = intl.formatMessage((0, $2zaaI.toolbarMessages).moreFormatting);
    const labelTextFormat = intl.formatMessage((0, $2zaaI.toolbarMessages).textFormatting);
    (0, $42omo.useEffect)(()=>{
        if (screenReaderMessage) setMessage(screenReaderMessage);
    }, [
        screenReaderMessage
    ]);
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        css: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
        (0, $cORDs.buttonGroupStyle),
        "data-vc": "YUK2Z_kv"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        role: "group",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: 'js-text-format-wrap',
        "aria-label": labelTextFormat
    }, message && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $cftLn.default), {
        ariaLive: "assertive",
        text: message,
        ariaRelevant: "additions",
        delay: 250
    }), /*#__PURE__*/ (0, $9K4OG.jsx)((0, $bd700498505ff390$export$e3e9702c9c21585), {
        items: singleItems,
        editorView: editorView,
        isReducedSpacing: isReducedSpacing
    }), /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage
        css: (0, $cORDs.wrapperStyle)
    }, isToolbarDisabled && !(0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? /*#__PURE__*/ (0, $9K4OG.jsx)("div", null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $140891e9e23b787e$export$7f94856880993f27), {
        label: moreFormattingButtonLabel,
        isReducedSpacing: isReducedSpacing,
        isDisabled: true,
        isSelected: false,
        "aria-expanded": undefined,
        "aria-pressed": undefined
    })) : /*#__PURE__*/ (0, $9K4OG.jsx)((0, $e664dcb48a74cd94$export$52e9a2bbe5d185e8), {
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        editorView: editorView,
        isReducedSpacing: isReducedSpacing,
        moreButtonLabel: moreFormattingButtonLabel,
        hasFormattingActive: hasFormattingActive,
        hasMoreButton: !(0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1'),
        items: items,
        intl: intl,
        toolbarType: toolbarType,
        isDisabled: (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? isToolbarDisabled : false
    }))), !api?.primaryToolbar && /* eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        css: (0, $cORDs.separatorStyles)
    })));
};
const $c9359b424429db47$var$Toolbar = ({ popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement, toolbarSize: toolbarSize, isReducedSpacing: isReducedSpacing, editorView: editorView, isToolbarDisabled: isToolbarDisabled, shouldUseResponsiveToolbar: shouldUseResponsiveToolbar, intl: intl, editorAnalyticsAPI: editorAnalyticsAPI, textFormattingState: textFormattingState, api: api, toolbarType: toolbarType })=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)($c9359b424429db47$var$ToolbarFormatting, {
        textFormattingState: textFormattingState,
        popupsMountPoint: popupsMountPoint,
        popupsScrollableElement: popupsScrollableElement,
        toolbarSize: toolbarSize,
        isReducedSpacing: isReducedSpacing,
        editorView: editorView,
        isToolbarDisabled: isToolbarDisabled,
        shouldUseResponsiveToolbar: shouldUseResponsiveToolbar,
        intl: intl,
        editorAnalyticsAPI: editorAnalyticsAPI,
        api: api,
        toolbarType: toolbarType
    });
};
const $c9359b424429db47$var$_default_1 = (0, $aXWIB.injectIntl)($c9359b424429db47$var$Toolbar);
var $c9359b424429db47$export$2e2bcd8739ae039 = $c9359b424429db47$var$_default_1;



const $b0a680815b4ae49f$var$selector = (states)=>{
    return {
        isInitialised: Boolean(states.textFormattingState?.isInitialised),
        formattingIsPresent: states.textFormattingState?.formattingIsPresent,
        emActive: states.textFormattingState?.emActive,
        emDisabled: states.textFormattingState?.emDisabled,
        emHidden: states.textFormattingState?.emHidden,
        codeActive: states.textFormattingState?.codeActive,
        codeDisabled: states.textFormattingState?.codeDisabled,
        codeHidden: states.textFormattingState?.codeHidden,
        underlineActive: states.textFormattingState?.underlineActive,
        underlineDisabled: states.textFormattingState?.underlineDisabled,
        underlineHidden: states.textFormattingState?.underlineHidden,
        strikeActive: states.textFormattingState?.strikeActive,
        strikeDisabled: states.textFormattingState?.strikeDisabled,
        strikeHidden: states.textFormattingState?.strikeHidden,
        strongActive: states.textFormattingState?.strongActive,
        strongDisabled: states.textFormattingState?.strongDisabled,
        strongHidden: states.textFormattingState?.strongHidden,
        superscriptActive: states.textFormattingState?.superscriptActive,
        superscriptDisabled: states.textFormattingState?.superscriptDisabled,
        superscriptHidden: states.textFormattingState?.superscriptHidden,
        subscriptActive: states.textFormattingState?.subscriptActive,
        subscriptDisabled: states.textFormattingState?.subscriptDisabled,
        subscriptHidden: states.textFormattingState?.subscriptHidden
    };
};
const $b0a680815b4ae49f$export$94516d5cccf573e3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ api: api, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement, toolbarSize: toolbarSize, editorView: editorView, disabled: disabled, isReducedSpacing: isReducedSpacing, shouldUseResponsiveToolbar: shouldUseResponsiveToolbar })=>{
    const textFormattingState = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'textFormatting'
    ], $b0a680815b4ae49f$var$selector);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c9359b424429db47$export$2e2bcd8739ae039), {
        textFormattingState: textFormattingState,
        popupsMountPoint: popupsMountPoint,
        popupsScrollableElement: popupsScrollableElement,
        toolbarSize: toolbarSize,
        isReducedSpacing: isReducedSpacing,
        editorView: editorView,
        isToolbarDisabled: disabled,
        shouldUseResponsiveToolbar: shouldUseResponsiveToolbar,
        editorAnalyticsAPI: api?.analytics?.actions,
        api: api,
        toolbarType: (0, $2cca58939a01b863$export$a5d11b3163e4b1a5).PRIMARY
    });
});






var $cPCP8 = parcelRequire("cPCP8");

var $4Chin = parcelRequire("4Chin");

var $gzUv9 = parcelRequire("gzUv9");


var $aro2m = parcelRequire("aro2m");

var $kDB94 = parcelRequire("kDB94");


















var $fIFhP = parcelRequire("fIFhP");






var $EJKmu = parcelRequire("EJKmu");

var $7ERUE = parcelRequire("7ERUE");

var $2GVu1 = parcelRequire("2GVu1");

var $6UWPx = parcelRequire("6UWPx");

var $bTiiT = parcelRequire("bTiiT");

var $jbmmV = parcelRequire("jbmmV");

var $iIVVb = parcelRequire("iIVVb");

































var $33Muq = parcelRequire("33Muq");

var $6MAS3 = parcelRequire("6MAS3");










/**
 * Maps the text-formatting plugin's `FormatOptions` keys to their
 * `SourceViewInlineFormat` equivalents for the CM6 source view.
 * Only formats that have a markdown syntax equivalent are included —
 * underline, subscript, and superscript have no GFM equivalent and
 * are left as undefined (they remain PM-only).
 */ const $ca44e89d0be02d9b$var$FORMAT_OPTION_TO_SOURCE_VIEW = {
    strong: 'bold',
    em: 'italic',
    code: 'inlineCode',
    strike: 'strikethrough'
};
const $ca44e89d0be02d9b$var$SOURCE_VIEW_ANALYTICS_ACTION_SUBJECT_ID = {
    bold: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_STRONG,
    italic: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_ITALIC,
    inlineCode: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_CODE,
    strikethrough: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_STRIKE
};
const $ca44e89d0be02d9b$var$TEXT_FORMATTING_PLUGIN_STATE_KEYS = [
    'textFormatting'
];
const $ca44e89d0be02d9b$var$TEXT_FORMATTING_MARKDOWN_PLUGIN_STATE_KEYS = [
    'textFormatting',
    'markdownMode'
];
const $ca44e89d0be02d9b$var$FormatMarkSchema = {
    strong: 'strong',
    em: 'em',
    underline: 'underline',
    strike: 'strike',
    code: 'code',
    subscript: 'subsup',
    superscript: 'subsup'
};
const $ca44e89d0be02d9b$export$fd1f6c37ffd41092 = ({ api: api, optionType: optionType, title: title, shortcut: shortcut, toggleMarkWithAnalyticsCallback: toggleMarkWithAnalyticsCallback, parents: parents })=>{
    const isMarkdownBridgeEnabled = (0, $dZ8uq.expValEqualsNoExposure)('cc-markdown-mode', 'isEnabled', true) && (0, $dh538.fg)('platform_editor_markdown_compatible_toolbar');
    const pluginStateKeys = isMarkdownBridgeEnabled ? $ca44e89d0be02d9b$var$TEXT_FORMATTING_MARKDOWN_PLUGIN_STATE_KEYS : $ca44e89d0be02d9b$var$TEXT_FORMATTING_PLUGIN_STATE_KEYS;
    const { isActive: isActive, isDisabled: isDisabled, isHidden: isHidden, isPluginInitialised: isPluginInitialised, markdownModeView: markdownModeView, sourceFormatState: sourceFormatState } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, pluginStateKeys, (states)=>({
            isActive: states.textFormattingState?.[`${optionType}Active`],
            isDisabled: states.textFormattingState?.[`${optionType}Disabled`],
            isHidden: states.textFormattingState?.[`${optionType}Hidden`],
            isPluginInitialised: states.textFormattingState?.isInitialised,
            markdownModeView: isMarkdownBridgeEnabled ? states.markdownModeState?.view : undefined,
            sourceFormatState: isMarkdownBridgeEnabled ? states.markdownModeState?.sourceInlineFormatState : null
        }));
    const hasMarkSchema = api?.core?.sharedState.currentState()?.schema?.marks[$ca44e89d0be02d9b$var$FormatMarkSchema[optionType]];
    let formatOptionState;
    if (!isPluginInitialised) formatOptionState = {
        isActive: false,
        isDisabled: true,
        isHidden: false
    };
    else formatOptionState = {
        isActive: Boolean(isActive),
        isDisabled: Boolean(isDisabled),
        isHidden: Boolean(!hasMarkSchema || isHidden)
    };
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const formatTitle = formatMessage(title);
    const shortcutContent = (0, $hgeg8.tooltip)(shortcut);
    const ariaLabel = (0, $hgeg8.tooltip)(shortcut, formatTitle);
    // The SourceViewInlineFormat key for this format option, if it has one.
    // undefined for underline, subscript, superscript (no GFM equivalent).
    const sourceViewFormat = $ca44e89d0be02d9b$var$FORMAT_OPTION_TO_SOURCE_VIEW[optionType];
    // The CM6 source view is authoritative when the user has switched to it.
    // We rely on `markdownModeState.view === 'syntax'` (synchronous, set on
    // `setView`) rather than the presence of `sourceFormatState` — the latter
    // is `null` until the CM6 update listener fires for the first time, so
    // using it as the sentinel would let the first toolbar click after entering
    // source view fall through to the PM path and mutate the hidden PM doc.
    const isInSourceView = markdownModeView === 'syntax';
    if (isInSourceView && !sourceViewFormat) // Underline, subscript, superscript have no GFM equivalent. Disable
    // them immediately on entering source view — independent of whether
    // the CM6 update listener has fired yet — so the buttons don't briefly
    // appear active/enabled during that race window.
    formatOptionState = {
        isActive: false,
        isDisabled: true,
        isHidden: false
    };
    else if (isInSourceView && sourceFormatState && sourceViewFormat) {
        // Map each SourceViewInlineFormat to its isActive field on the snapshot.
        const activeByFormat = {
            bold: sourceFormatState.boldActive,
            italic: sourceFormatState.italicActive,
            inlineCode: sourceFormatState.codeActive,
            strikethrough: sourceFormatState.strikeActive
        };
        formatOptionState = {
            isActive: activeByFormat[sourceViewFormat],
            isDisabled: !sourceFormatState.inlineFormattingAvailable,
            isHidden: false
        };
    } else if (isInSourceView) // Race window: the user has switched to source view but the CM6 update
    // listener hasn't pushed its first format state snapshot yet
    // (`sourceFormatState` is still `null`). Without this branch the
    // button would render stale PM-cursor state (e.g. "Bold active" based
    // on where the PM selection was) until CM6 catches up. Render a
    // neutral, non-disabled state instead.
    formatOptionState = {
        isActive: false,
        isDisabled: false,
        isHidden: false
    };
    const onClick = ()=>{
        // Route to CM6 when in source view and the format has a CM6 equivalent.
        if (isInSourceView) {
            if (sourceViewFormat) {
                api?.analytics?.actions.fireAnalyticsEvent({
                    action: (0, $d925B.ACTION).FORMATTED,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
                    eventType: (0, $d925B.EVENT_TYPE).TRACK,
                    actionSubjectId: $ca44e89d0be02d9b$var$SOURCE_VIEW_ANALYTICS_ACTION_SUBJECT_ID[sourceViewFormat],
                    attributes: {
                        inputMethod: (0, $fIFhP.getInputMethodFromParentKeys)(parents)
                    }
                });
                switch(sourceViewFormat){
                    case 'bold':
                        api?.markdownMode?.actions.toggleSourceBold();
                        break;
                    case 'italic':
                        api?.markdownMode?.actions.toggleSourceItalic();
                        break;
                    case 'inlineCode':
                        api?.markdownMode?.actions.toggleSourceInlineCode();
                        break;
                    case 'strikethrough':
                        api?.markdownMode?.actions.toggleSourceStrike();
                        break;
                }
            }
            return;
        }
        // Default PM path.
        api?.core.actions.execute(toggleMarkWithAnalyticsCallback(api?.analytics?.actions)((0, $fIFhP.getInputMethodFromParentKeys)(parents)));
    };
    return {
        ...formatOptionState,
        formatTitle: formatTitle,
        shortcutContent: shortcutContent,
        ariaLabel: ariaLabel || formatTitle,
        onClick: onClick
    };
};
const $ca44e89d0be02d9b$export$fb6751f88f91d177 = ()=>({
        strong: {
            rank: (0, $4Chin.TEXT_FORMATTING_MENU_SECTION_RANK)[(0, $cPCP8.BOLD_MENU_ITEM).key],
            key: (0, $cPCP8.BOLD_MENU_ITEM).key,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($7gIXe))),
            title: (0, $2zaaI.toolbarMessages).bold,
            command: (0, $bb3f69b8f70e233b$export$686bc7c29753e27),
            shortcut: (0, $hgeg8.toggleBold)
        },
        em: {
            rank: (0, $4Chin.TEXT_FORMATTING_MENU_SECTION_RANK)[(0, $cPCP8.ITALIC_MENU_ITEM).key],
            key: (0, $cPCP8.ITALIC_MENU_ITEM).key,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($2gUVF))),
            title: (0, $2zaaI.toolbarMessages).italic,
            command: (0, $bb3f69b8f70e233b$export$fe8278eb0d365433),
            shortcut: (0, $hgeg8.toggleItalic)
        },
        underline: {
            rank: (0, $4Chin.TEXT_FORMATTING_MENU_SECTION_RANK)[(0, $cPCP8.UNDERLINE_MENU_ITEM).key],
            key: (0, $cPCP8.UNDERLINE_MENU_ITEM).key,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($4E5My))),
            title: (0, $2zaaI.toolbarMessages).underline,
            command: (0, $bb3f69b8f70e233b$export$bf3c86b5abdb857d),
            shortcut: (0, $hgeg8.toggleUnderline)
        },
        strike: {
            rank: (0, $4Chin.TEXT_FORMATTING_MENU_SECTION_RANK)[(0, $cPCP8.STRIKE_MENU_ITEM).key],
            key: (0, $cPCP8.STRIKE_MENU_ITEM).key,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($jHpAD))),
            title: (0, $2zaaI.toolbarMessages).strike,
            command: (0, $bb3f69b8f70e233b$export$f08ef336cb688397),
            shortcut: (0, $hgeg8.toggleStrikethrough)
        },
        code: {
            rank: (0, $4Chin.TEXT_FORMATTING_MENU_SECTION_RANK)[(0, $cPCP8.CODE_MENU_ITEM).key],
            key: (0, $cPCP8.CODE_MENU_ITEM).key,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($eIlE7))),
            title: (0, $2zaaI.toolbarMessages).code,
            command: (0, $bb3f69b8f70e233b$export$2d4f5a54f840ba91),
            shortcut: (0, $hgeg8.toggleCode)
        },
        subscript: {
            rank: (0, $4Chin.TEXT_FORMATTING_MENU_SECTION_RANK)[(0, $cPCP8.SUBSCRIPT_MENU_ITEM).key],
            key: (0, $cPCP8.SUBSCRIPT_MENU_ITEM).key,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($33Muq))),
            title: (0, $2zaaI.toolbarMessages).subscript,
            command: (0, $bb3f69b8f70e233b$export$8d0c92ae27a193),
            shortcut: (0, $hgeg8.toggleSubscript)
        },
        superscript: {
            rank: (0, $4Chin.TEXT_FORMATTING_MENU_SECTION_RANK)[(0, $cPCP8.SUPERSCRIPT_MENU_ITEM).key],
            key: (0, $cPCP8.SUPERSCRIPT_MENU_ITEM).key,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($6MAS3))),
            title: (0, $2zaaI.toolbarMessages).superscript,
            command: (0, $bb3f69b8f70e233b$export$ca1c98793b67ba6b),
            shortcut: (0, $hgeg8.toggleSuperscript)
        }
    });


const $fd71712e2bc23935$export$ddf8e5968f0fbf06 = ({ parents: parents, api: api, optionType: optionType, toggleMarkWithAnalyticsCallback: toggleMarkWithAnalyticsCallback, icon: icon, shortcut: shortcut, title: title })=>{
    const { isActive: isActive, isDisabled: isDisabled, isHidden: isHidden, shortcutContent: shortcutContent, onClick: onClick, ariaLabel: ariaLabel, formatTitle: formatTitle } = (0, $ca44e89d0be02d9b$export$fd1f6c37ffd41092)({
        api: api,
        optionType: optionType,
        title: title,
        shortcut: shortcut,
        toggleMarkWithAnalyticsCallback: toggleMarkWithAnalyticsCallback,
        parents: parents
    });
    const Icon = icon;
    if (isHidden) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2GVu1.ToolbarDropdownItem), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
            size: "small",
            label: ""
        }),
        elemAfter: shortcutContent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jbmmV.ToolbarKeyboardShortcutHint), {
            shortcut: shortcutContent
        }),
        isDisabled: isDisabled,
        isSelected: isActive,
        onClick: onClick,
        "aria-keyshortcuts": (0, $hgeg8.getAriaKeyshortcuts)(shortcut),
        "aria-label": ariaLabel
    }, formatTitle);
};
const $fd71712e2bc23935$export$4ce756b69a643bb2 = ({ parents: parents, api: api, optionType: optionType, toggleMarkWithAnalyticsCallback: toggleMarkWithAnalyticsCallback, icon: icon, shortcut: shortcut, title: title })=>{
    const { isActive: isActive, isDisabled: isDisabled, onClick: onClick, ariaLabel: ariaLabel, formatTitle: formatTitle } = (0, $ca44e89d0be02d9b$export$fd1f6c37ffd41092)({
        api: api,
        optionType: optionType,
        title: title,
        shortcut: shortcut,
        toggleMarkWithAnalyticsCallback: toggleMarkWithAnalyticsCallback,
        parents: parents
    });
    const Icon = icon;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iIVVb.ToolbarTooltip), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hgeg8.ToolTipContent), {
            description: formatTitle,
            keymap: shortcut
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7ERUE.ToolbarButton), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
            label: ariaLabel,
            size: "small"
        }),
        onClick: onClick,
        isSelected: isActive,
        isDisabled: isDisabled,
        ariaKeyshortcuts: (0, $hgeg8.getAriaKeyshortcuts)(shortcut),
        testId: `editor-toolbar__${formatTitle}`
    }));
};
const $fd71712e2bc23935$export$2d10ff258f7812b8 = ({ api: api, parents: parents })=>{
    const { isInitialised: isInitialised, isFormattingPresent: isFormattingPresent } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'textFormatting'
    ], (states)=>({
            isInitialised: states.textFormattingState?.isInitialised,
            isFormattingPresent: states.textFormattingState?.formattingIsPresent
        }));
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    if (!isInitialised) return null;
    const formatTitle = formatMessage((0, $2zaaI.toolbarMessages).clearFormatting);
    const shortcutContent = (0, $hgeg8.tooltip)((0, $hgeg8.clearFormatting));
    const onClick = ()=>{
        api?.core.actions.execute((0, $259f2a142ea36336$export$38c6848f9e966bd5)(api?.analytics?.actions)((0, $fIFhP.getInputMethodFromParentKeys)(parents)));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2GVu1.ToolbarDropdownItem), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iV7dk))), {
            label: "",
            size: "small"
        }),
        elemAfter: shortcutContent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jbmmV.ToolbarKeyboardShortcutHint), {
            shortcut: shortcutContent
        }),
        isDisabled: !isFormattingPresent,
        onClick: onClick,
        ariaKeyshortcuts: (0, $hgeg8.getAriaKeyshortcuts)((0, $hgeg8.clearFormatting))
    }, formatTitle);
};
const $fd71712e2bc23935$export$f2e08b351bba4df = ({ children: children })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const content = formatMessage((0, $2zaaI.toolbarMessages).moreFormatting);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bTiiT.ToolbarDropdownMenu), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $EJKmu.MoreItemsIcon), {
            label: "",
            testId: "more-formatting"
        }),
        label: content,
        tooltipComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iIVVb.ToolbarTooltip), {
            content: formatMessage((0, $2zaaI.toolbarMessages).textFormat)
        })
    }, children);
};
const $fd71712e2bc23935$export$4b1545b4f2016d26 = ({ children: children, title: title, parents: parents })=>{
    const hasSeparator = parents.some((parent)=>parent.key === (0, $cPCP8.TEXT_COLLAPSED_MENU).key);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6UWPx.ToolbarDropdownItemSection), {
        hasSeparator: hasSeparator,
        title: title
    }, children);
};



const $a275def668254e8d$var$BoldButtonGroup = ({ children: children })=>{
    const { editorAppearance: editorAppearance } = (0, $gzUv9.useEditorToolbar)();
    if (editorAppearance === 'full-page') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aro2m.Show), {
        above: "xl"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDB94.ToolbarButtonGroup), null, children));
};
const $a275def668254e8d$export$838bd3df7e6d113c = (api)=>[
        {
            type: (0, $cPCP8.BOLD_BUTTON_GROUP).type,
            key: (0, $cPCP8.BOLD_BUTTON_GROUP).key,
            parents: [
                {
                    type: (0, $cPCP8.TEXT_SECTION_PRIMARY_TOOLBAR).type,
                    key: (0, $cPCP8.TEXT_SECTION_PRIMARY_TOOLBAR).key,
                    rank: (0, $4Chin.TEXT_SECTION_PRIMARY_TOOLBAR_RANK)[(0, $cPCP8.BOLD_BUTTON_GROUP).key]
                }
            ],
            component: ({ children: children })=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a275def668254e8d$var$BoldButtonGroup, null, children);
            }
        },
        {
            type: (0, $cPCP8.BOLD_BUTTON).type,
            key: (0, $cPCP8.BOLD_BUTTON).key,
            parents: [
                {
                    type: (0, $cPCP8.BOLD_BUTTON_GROUP).type,
                    key: (0, $cPCP8.BOLD_BUTTON_GROUP).key,
                    rank: 100
                }
            ],
            component: ({ parents: parents })=>{
                const { icon: icon, command: command, shortcut: shortcut, title: title } = (0, $ca44e89d0be02d9b$export$fb6751f88f91d177)().strong;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fd71712e2bc23935$export$4ce756b69a643bb2), {
                    api: api,
                    parents: parents,
                    icon: icon,
                    title: title,
                    shortcut: shortcut,
                    optionType: (0, $2cca58939a01b863$export$c1fb0eb1ea3f6fb6).strong,
                    toggleMarkWithAnalyticsCallback: command
                });
            }
        }
    ];
















const $d1b621026d50013d$export$653d8b3e035cd6f7 = (api)=>[
        {
            type: (0, $cPCP8.TEXT_FORMATTING_GROUP_INLINE).type,
            key: (0, $cPCP8.TEXT_FORMATTING_GROUP_INLINE).key,
            parents: [
                {
                    type: (0, $cPCP8.TEXT_SECTION).type,
                    key: (0, $cPCP8.TEXT_SECTION).key,
                    rank: (0, $4Chin.TEXT_SECTION_RANK)[(0, $cPCP8.TEXT_FORMATTING_GROUP).key]
                }
            ],
            component: ({ children: children })=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDB94.ToolbarButtonGroup), null, children);
            }
        },
        {
            type: (0, $cPCP8.TEXT_FORMATTING_HERO_BUTTON).type,
            key: (0, $cPCP8.TEXT_FORMATTING_HERO_BUTTON).key,
            parents: [
                {
                    type: (0, $cPCP8.TEXT_FORMATTING_GROUP_INLINE).type,
                    key: (0, $cPCP8.TEXT_FORMATTING_GROUP_INLINE).key,
                    rank: (0, $4Chin.TEXT_FORMAT_GROUP_RANK)[(0, $cPCP8.TEXT_FORMATTING_HERO_BUTTON).key]
                }
            ],
            component: ({ parents: parents })=>{
                const { icon: icon, command: command, shortcut: shortcut, title: title } = (0, $ca44e89d0be02d9b$export$fb6751f88f91d177)().strong;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fd71712e2bc23935$export$4ce756b69a643bb2), {
                    api: api,
                    parents: parents,
                    icon: icon,
                    title: title,
                    shortcut: shortcut,
                    optionType: (0, $2cca58939a01b863$export$c1fb0eb1ea3f6fb6).strong,
                    toggleMarkWithAnalyticsCallback: command
                });
            }
        }
    ];




















const $420c7c9a0f8426ae$var$TextFormattingGroup = ({ children: children })=>{
    const { editorAppearance: editorAppearance } = (0, $gzUv9.useEditorToolbar)();
    if (editorAppearance === 'full-page') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aro2m.Show), {
        above: "xl"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDB94.ToolbarButtonGroup), null, children));
};
const $420c7c9a0f8426ae$var$TextFormattingGroupCollapsed = ({ children: children })=>{
    const { editorAppearance: editorAppearance } = (0, $gzUv9.useEditorToolbar)();
    if (editorAppearance === 'full-page') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aro2m.Show), {
        below: "xl"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDB94.ToolbarButtonGroup), null, children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDB94.ToolbarButtonGroup), null, children);
};
const $420c7c9a0f8426ae$export$ed04d15827dc03ae = (api)=>[
        {
            type: (0, $cPCP8.TEXT_FORMATTING_GROUP).type,
            key: (0, $cPCP8.TEXT_FORMATTING_GROUP).key,
            parents: [
                {
                    type: (0, $cPCP8.TEXT_SECTION_PRIMARY_TOOLBAR).type,
                    key: (0, $cPCP8.TEXT_SECTION_PRIMARY_TOOLBAR).key,
                    rank: (0, $4Chin.TEXT_SECTION_PRIMARY_TOOLBAR_RANK)[(0, $cPCP8.TEXT_FORMATTING_GROUP).key]
                }
            ],
            component: ({ children: children })=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($420c7c9a0f8426ae$var$TextFormattingGroup, null, children);
            }
        },
        {
            type: (0, $cPCP8.TEXT_FORMATTING_GROUP_COLLAPSED).type,
            key: (0, $cPCP8.TEXT_FORMATTING_GROUP_COLLAPSED).key,
            parents: [
                {
                    type: (0, $cPCP8.TEXT_SECTION_PRIMARY_TOOLBAR).type,
                    key: (0, $cPCP8.TEXT_SECTION_PRIMARY_TOOLBAR).key,
                    rank: (0, $4Chin.TEXT_SECTION_PRIMARY_TOOLBAR_RANK)[(0, $cPCP8.TEXT_FORMATTING_GROUP).key]
                }
            ],
            component: ({ children: children })=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($420c7c9a0f8426ae$var$TextFormattingGroupCollapsed, null, children);
            }
        },
        {
            type: (0, $cPCP8.TEXT_FORMATTING_HERO_BUTTON).type,
            key: (0, $cPCP8.TEXT_FORMATTING_HERO_BUTTON).key,
            parents: [
                {
                    type: (0, $cPCP8.TEXT_FORMATTING_GROUP).type,
                    key: (0, $cPCP8.TEXT_FORMATTING_GROUP).key,
                    rank: (0, $4Chin.TEXT_FORMAT_GROUP_RANK)[(0, $cPCP8.TEXT_FORMATTING_HERO_BUTTON).key]
                }
            ],
            component: ({ parents: parents })=>{
                const { icon: icon, command: command, shortcut: shortcut, title: title } = (0, $ca44e89d0be02d9b$export$fb6751f88f91d177)().em;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fd71712e2bc23935$export$4ce756b69a643bb2), {
                    api: api,
                    parents: parents,
                    icon: icon,
                    title: title,
                    shortcut: shortcut,
                    optionType: (0, $2cca58939a01b863$export$c1fb0eb1ea3f6fb6).em,
                    toggleMarkWithAnalyticsCallback: command
                });
            }
        },
        {
            type: (0, $cPCP8.TEXT_FORMATTING_HERO_BUTTON_COLLAPSED).type,
            key: (0, $cPCP8.TEXT_FORMATTING_HERO_BUTTON_COLLAPSED).key,
            parents: [
                {
                    type: (0, $cPCP8.TEXT_FORMATTING_GROUP_COLLAPSED).type,
                    key: (0, $cPCP8.TEXT_FORMATTING_GROUP_COLLAPSED).key,
                    rank: (0, $4Chin.TEXT_FORMAT_GROUP_COLLAPSED_RANK)[(0, $cPCP8.TEXT_FORMATTING_HERO_BUTTON_COLLAPSED).key]
                }
            ],
            component: ({ parents: parents })=>{
                const { icon: icon, command: command, shortcut: shortcut, title: title } = (0, $ca44e89d0be02d9b$export$fb6751f88f91d177)().strong;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fd71712e2bc23935$export$4ce756b69a643bb2), {
                    api: api,
                    parents: parents,
                    icon: icon,
                    title: title,
                    shortcut: shortcut,
                    optionType: (0, $2cca58939a01b863$export$c1fb0eb1ea3f6fb6).strong,
                    toggleMarkWithAnalyticsCallback: command
                });
            }
        }
    ];















const $bbcb8ae96c008de4$export$922904c4345b3461 = (api)=>{
    return Object.entries((0, $ca44e89d0be02d9b$export$fb6751f88f91d177)()).map(([optionType, { icon: icon, shortcut: shortcut, title: title, command: command, rank: rank, key: key }])=>{
        return {
            type: 'menu-item',
            key: key,
            parents: [
                {
                    type: (0, $cPCP8.TEXT_FORMATTING_MENU_SECTION).type,
                    key: (0, $cPCP8.TEXT_FORMATTING_MENU_SECTION).key,
                    rank: rank
                }
            ],
            component: ({ parents: parents })=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fd71712e2bc23935$export$ddf8e5968f0fbf06), {
                    api: api,
                    parents: parents,
                    icon: icon,
                    shortcut: shortcut,
                    title: title,
                    optionType: optionType,
                    toggleMarkWithAnalyticsCallback: command
                });
            }
        };
    });
};
const $bbcb8ae96c008de4$export$21e1245c68e20dce = (api)=>[
        {
            type: (0, $cPCP8.TEXT_FORMATTING_MENU).type,
            key: (0, $cPCP8.TEXT_FORMATTING_MENU).key,
            parents: [
                {
                    type: (0, $cPCP8.TEXT_FORMATTING_GROUP).type,
                    key: (0, $cPCP8.TEXT_FORMATTING_GROUP).key,
                    rank: (0, $4Chin.TEXT_FORMAT_GROUP_RANK)[(0, $cPCP8.TEXT_FORMATTING_MENU).key]
                },
                {
                    type: (0, $cPCP8.TEXT_FORMATTING_GROUP_COLLAPSED).type,
                    key: (0, $cPCP8.TEXT_FORMATTING_GROUP_COLLAPSED).key,
                    rank: (0, $4Chin.TEXT_FORMAT_GROUP_RANK)[(0, $cPCP8.TEXT_FORMATTING_MENU).key]
                },
                {
                    type: (0, $cPCP8.TEXT_FORMATTING_GROUP_INLINE).type,
                    key: (0, $cPCP8.TEXT_FORMATTING_GROUP_INLINE).key,
                    rank: (0, $4Chin.TEXT_FORMAT_GROUP_RANK)[(0, $cPCP8.TEXT_FORMATTING_HERO_BUTTON).key]
                }
            ],
            component: ({ children: children })=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fd71712e2bc23935$export$f2e08b351bba4df), null, children);
            }
        },
        {
            type: (0, $cPCP8.TEXT_FORMATTING_MENU_SECTION).type,
            key: (0, $cPCP8.TEXT_FORMATTING_MENU_SECTION).key,
            parents: [
                {
                    type: (0, $cPCP8.TEXT_FORMATTING_MENU).type,
                    key: (0, $cPCP8.TEXT_FORMATTING_MENU).key,
                    rank: (0, $4Chin.TEXT_FORMAT_MENU_RANK)[(0, $cPCP8.TEXT_FORMATTING_MENU_SECTION).key]
                },
                {
                    type: (0, $cPCP8.TEXT_COLLAPSED_MENU).type,
                    key: (0, $cPCP8.TEXT_COLLAPSED_MENU).key,
                    rank: (0, $4Chin.TEXT_COLLAPSED_MENU_RANK)[(0, $cPCP8.TEXT_FORMATTING_MENU_SECTION).key]
                }
            ],
            component: (0, $fd71712e2bc23935$export$4b1545b4f2016d26)
        },
        ...$bbcb8ae96c008de4$export$922904c4345b3461(api),
        {
            type: (0, $cPCP8.CLEAR_FORMARTTING_MENU_SECTION).type,
            key: (0, $cPCP8.CLEAR_FORMARTTING_MENU_SECTION).key,
            parents: [
                {
                    type: (0, $cPCP8.TEXT_FORMATTING_MENU).type,
                    key: (0, $cPCP8.TEXT_FORMATTING_MENU).key,
                    rank: (0, $4Chin.TEXT_FORMAT_MENU_RANK)[(0, $cPCP8.CLEAR_FORMARTTING_MENU_SECTION).key]
                },
                {
                    type: (0, $cPCP8.TEXT_COLLAPSED_MENU).type,
                    key: (0, $cPCP8.TEXT_COLLAPSED_MENU).key,
                    rank: (0, $4Chin.TEXT_COLLAPSED_MENU_RANK)[(0, $cPCP8.CLEAR_FORMARTTING_MENU_SECTION).key]
                }
            ],
            component: ({ children: children })=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6UWPx.ToolbarDropdownItemSection), {
                    hasSeparator: true
                }, children);
            }
        },
        {
            type: (0, $cPCP8.CLEAR_FORMATTING_MENU_ITEM).type,
            key: (0, $cPCP8.CLEAR_FORMATTING_MENU_ITEM).key,
            parents: [
                {
                    type: (0, $cPCP8.CLEAR_FORMARTTING_MENU_SECTION).type,
                    key: (0, $cPCP8.CLEAR_FORMARTTING_MENU_SECTION).key,
                    rank: (0, $4Chin.CLEAR_FORMARTTING_MENU_SECTION_RANK)[(0, $cPCP8.CLEAR_FORMATTING_MENU_ITEM).key]
                }
            ],
            component: ({ parents: parents })=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fd71712e2bc23935$export$2d10ff258f7812b8), {
                    parents: parents,
                    api: api
                }));
            }
        }
    ];




















const $b26e6478bc42b1b0$var$UnderlineButtonGroup = ({ children: children })=>{
    const { editorAppearance: editorAppearance } = (0, $gzUv9.useEditorToolbar)();
    if (editorAppearance === 'full-page') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aro2m.Show), {
        above: "xl"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDB94.ToolbarButtonGroup), null, children));
};
const $b26e6478bc42b1b0$export$8988dc22a0ee54a7 = (api)=>[
        {
            type: (0, $cPCP8.UNDERLINE_BUTTON_GROUP).type,
            key: (0, $cPCP8.UNDERLINE_BUTTON_GROUP).key,
            parents: [
                {
                    type: (0, $cPCP8.TEXT_SECTION_PRIMARY_TOOLBAR).type,
                    key: (0, $cPCP8.TEXT_SECTION_PRIMARY_TOOLBAR).key,
                    rank: (0, $4Chin.TEXT_SECTION_PRIMARY_TOOLBAR_RANK)[(0, $cPCP8.UNDERLINE_BUTTON_GROUP).key]
                }
            ],
            component: ({ children: children })=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b26e6478bc42b1b0$var$UnderlineButtonGroup, null, children);
            }
        },
        {
            type: (0, $cPCP8.UNDERLINE_BUTTON).type,
            key: (0, $cPCP8.UNDERLINE_BUTTON).key,
            parents: [
                {
                    type: (0, $cPCP8.UNDERLINE_BUTTON_GROUP).type,
                    key: (0, $cPCP8.UNDERLINE_BUTTON_GROUP).key,
                    rank: 100
                }
            ],
            component: ({ parents: parents })=>{
                const { icon: icon, command: command, shortcut: shortcut, title: title } = (0, $ca44e89d0be02d9b$export$fb6751f88f91d177)().underline;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fd71712e2bc23935$export$4ce756b69a643bb2), {
                    api: api,
                    parents: parents,
                    icon: icon,
                    title: title,
                    shortcut: shortcut,
                    optionType: (0, $2cca58939a01b863$export$c1fb0eb1ea3f6fb6).underline,
                    toggleMarkWithAnalyticsCallback: command
                });
            }
        }
    ];


const $2672af3eb8469c94$export$a758406ca53b86a5 = (api, options)=>{
    return [
        ...(0, $420c7c9a0f8426ae$export$ed04d15827dc03ae)(api),
        ...(0, $d1b621026d50013d$export$653d8b3e035cd6f7)(api),
        ...(0, $a275def668254e8d$export$838bd3df7e6d113c)(api),
        ...options?.disableUnderline ? [] : (0, $b26e6478bc42b1b0$export$8988dc22a0ee54a7)(api),
        ...(0, $bbcb8ae96c008de4$export$21e1245c68e20dce)(api)
    ];
};


const $bc1eab28a45a6e54$export$2db686be056cb923 = ({ config: options, api: api })=>{
    const isToolbarAIFCEnabled = Boolean(api?.toolbar);
    const primaryToolbarComponent = ({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement, isToolbarReducedSpacing: isToolbarReducedSpacing, toolbarSize: toolbarSize, disabled: disabled })=>{
        if (!editorView) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b0a680815b4ae49f$export$94516d5cccf573e3), {
            api: api,
            popupsMountPoint: popupsMountPoint,
            popupsScrollableElement: popupsScrollableElement,
            toolbarSize: toolbarSize,
            isReducedSpacing: isToolbarReducedSpacing,
            editorView: editorView,
            disabled: disabled,
            shouldUseResponsiveToolbar: Boolean(options?.responsiveToolbarMenu)
        });
    };
    if (isToolbarAIFCEnabled) api?.toolbar?.actions.registerComponents((0, $2672af3eb8469c94$export$a758406ca53b86a5)(api, options));
    else api?.primaryToolbar?.actions.registerComponent({
        name: 'textFormatting',
        component: primaryToolbarComponent
    });
    return {
        name: 'textFormatting',
        marks () {
            return [
                {
                    name: 'em',
                    mark: (0, $a2CNw.em)
                },
                {
                    name: 'strong',
                    mark: (0, $bJD2s.strong)
                }
            ].concat(options?.disableStrikethrough ? [] : {
                name: 'strike',
                mark: (0, $dd67x.strike)
            }).concat(options?.disableCode ? [] : {
                name: 'code',
                mark: (0, $lu7Ub.code)
            }).concat(options?.disableSuperscriptAndSubscript ? [] : {
                name: 'subsup',
                mark: (0, $ip8b2.subsup)
            }).concat(options?.disableUnderline ? [] : {
                name: 'underline',
                mark: (0, $gKyPs.underline)
            });
        },
        pmPlugins () {
            return [
                {
                    name: 'textFormatting',
                    plugin: ({ dispatch: dispatch })=>(0, $87facb9c332c53bc$export$ca524d3785e2543)(dispatch, api?.analytics?.actions)
                },
                {
                    name: 'textFormattingCursor',
                    plugin: ()=>(0, $42c3ebae9833cf7e$export$2e2bcd8739ae039)
                },
                {
                    name: 'textFormattingInputRule',
                    plugin: ({ schema: schema })=>(0, $272af2f525a6adbd$export$2e2bcd8739ae039)(schema, api?.analytics?.actions, api)
                },
                {
                    name: 'textFormattingSmartRule',
                    plugin: ()=>!options?.disableSmartTextCompletion ? (0, $7fedcc10a2237f27$export$2e2bcd8739ae039)(api?.analytics?.actions) : undefined
                },
                {
                    name: 'textFormattingClear',
                    plugin: ({ dispatch: dispatch })=>(0, $c4b62bb81a4e5eb6$export$ca524d3785e2543)(dispatch)
                },
                {
                    name: 'textFormattingClearKeymap',
                    plugin: ()=>(0, $251906526182976c$export$2e2bcd8739ae039)(api?.analytics?.actions)
                },
                {
                    name: 'textFormattingKeymap',
                    plugin: ({ schema: schema })=>(0, $eb356cb5191041bc$export$2e2bcd8739ae039)(schema, api?.analytics?.actions)
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const textFormattingState = (0, $09fa888fe84c9f23$export$18d4026d1ea86bb1).getState(editorState);
            return {
                ...textFormattingState,
                formattingIsPresent: (0, $c4b62bb81a4e5eb6$export$18d4026d1ea86bb1).getState(editorState)?.formattingIsPresent,
                isInitialised: !!textFormattingState?.isInitialised
            };
        },
        pluginsOptions: isToolbarAIFCEnabled ? {} : {
            selectionToolbar: ()=>{
                const toolbarDocking = (0, $dh538.fg)('platform_editor_use_preferences_plugin') ? api?.userPreferences?.sharedState.currentState()?.preferences?.toolbarDockingPosition : api?.selectionToolbar?.sharedState?.currentState()?.toolbarDocking;
                if (toolbarDocking === 'none' && (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1', {
                    exposure: true
                })) {
                    const toolbarCustom = {
                        type: 'custom',
                        render: (view)=>{
                            if (!view) return;
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f5dbb937cfa2eba4$export$d728f1bdde37938b), {
                                api: api,
                                editorView: view,
                                editorAnalyticsAPI: api?.analytics?.actions
                            });
                        },
                        fallback: []
                    };
                    return {
                        isToolbarAbove: true,
                        items: [
                            toolbarCustom
                        ],
                        rank: 7,
                        pluginName: 'textFormatting'
                    };
                } else return undefined;
            }
        },
        primaryToolbarComponent: !api?.primaryToolbar && !isToolbarAIFCEnabled ? primaryToolbarComponent : undefined,
        commands: {
            toggleSuperscript: (0, $bb3f69b8f70e233b$export$ca1c98793b67ba6b)(api?.analytics?.actions),
            toggleSubscript: (0, $bb3f69b8f70e233b$export$8d0c92ae27a193)(api?.analytics?.actions),
            toggleStrike: (0, $bb3f69b8f70e233b$export$f08ef336cb688397)(api?.analytics?.actions),
            toggleCode: (0, $bb3f69b8f70e233b$export$2d4f5a54f840ba91)(api?.analytics?.actions),
            toggleUnderline: (0, $bb3f69b8f70e233b$export$bf3c86b5abdb857d)(api?.analytics?.actions),
            toggleEm: (0, $bb3f69b8f70e233b$export$fe8278eb0d365433)(api?.analytics?.actions),
            toggleStrong: (0, $bb3f69b8f70e233b$export$686bc7c29753e27)(api?.analytics?.actions)
        }
    };
};
module.exports["textFormattingPlugin"] = $bc1eab28a45a6e54$export$2db686be056cb923;

});

parcelRegister("b167b", function(module, exports) {

var $ks2lK = parcelRequire("ks2lK");


var $7XFGZ = parcelRequire("7XFGZ");


var $dh538 = parcelRequire("dh538");


var $b6bhi = parcelRequire("b6bhi");



const $e4a271b9e519cf8b$var$SMART_TO_ASCII = {
    "\u2026": '...',
    "\u2192": '->',
    "\u2190": '<-',
    "\u2013": '--',
    "\u201C": '"',
    "\u201D": '"',
    "\u2018": "'",
    "\u2019": "'"
};
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $e4a271b9e519cf8b$var$FIND_SMART_CHAR = new RegExp(`[${Object.keys($e4a271b9e519cf8b$var$SMART_TO_ASCII).join('')}]`, 'g');
function $e4a271b9e519cf8b$export$abc5e6e01568db39(from, to, tr) {
    const { doc: doc } = tr;
    const { schema: schema } = doc.type;
    const { mention: mentionNodeType, text: textNodeType, emoji: emojiNodeType, inlineCard: inlineCardNodeType } = schema.nodes;
    const nodesToChange = [];
    doc.nodesBetween(from, to, (node, pos, _parent)=>{
        if ([
            mentionNodeType,
            textNodeType,
            emojiNodeType,
            inlineCardNodeType
        ].includes(node.type)) nodesToChange.push({
            node: node,
            pos: pos
        });
    });
    nodesToChange.forEach(({ node: node, pos: pos })=>{
        if (node.type !== textNodeType) {
            const newText = node.attrs.url || // url for inlineCard
            node.attrs.text || `${node.type.name} text missing`; // fallback for missing text
            const currentPos = tr.mapping.map(pos);
            tr.replaceWith(currentPos, currentPos + node.nodeSize, schema.text(newText, node.marks));
        } else if (node.text) {
            // Find a valid start and end position because the text may be partially selected.
            const startPositionInSelection = Math.max(pos, from);
            const endPositionInSelection = Math.min(pos + node.nodeSize, to);
            const textForReplacing = doc.textBetween(startPositionInSelection, endPositionInSelection);
            // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
            const newText = textForReplacing.replace($e4a271b9e519cf8b$var$FIND_SMART_CHAR, (match)=>$e4a271b9e519cf8b$var$SMART_TO_ASCII[match] ?? match);
            const currentStartPos = tr.mapping.map(startPositionInSelection);
            const currentEndPos = tr.mapping.map(endPositionInSelection);
            tr.replaceWith(currentStartPos, currentEndPos, schema.text(newText, node.marks));
        }
    });
}
const $e4a271b9e519cf8b$export$94a1aa532f5398df = (from, to, removeMark, mark, tr)=>{
    const { schema: schema } = tr.doc.type;
    const { code: code } = schema.marks;
    if (mark.type === code) $e4a271b9e519cf8b$export$abc5e6e01568db39(from, to, tr);
    tr.doc.nodesBetween(tr.mapping.map(from), tr.mapping.map(to), (node, pos)=>{
        if ((0, $dh538.fg)('editor_inline_comments_on_inline_nodes')) {
            if (!node.isText) {
                const isAllowedInlineNode = [
                    'emoji',
                    'status',
                    'date',
                    'mention',
                    'inlineCard'
                ].includes(node.type.name);
                if (!isAllowedInlineNode) return true;
            }
        } else {
            if (!node.isText) return true;
        }
        // This is an issue when the user selects some text.
        // We need to check if the current node position is less than the range selection from.
        // If it’s true, that means we should apply the mark using the range selection,
        // not the current node position.
        const nodeBetweenFrom = Math.max(pos, tr.mapping.map(from));
        const nodeBetweenTo = Math.min(pos + node.nodeSize, tr.mapping.map(to));
        if (removeMark) tr.removeMark(nodeBetweenFrom, nodeBetweenTo, mark);
        else tr.addMark(nodeBetweenFrom, nodeBetweenTo, mark);
        return true;
    });
    return tr;
};
const $e4a271b9e519cf8b$var$toggleMarkInRange = (mark)=>({ tr: tr })=>{
        if (tr.selection instanceof (0, $7XFGZ.CellSelection)) {
            let removeMark = true;
            const cells = [];
            tr.selection.forEachCell((cell, cellPos)=>{
                cells.push({
                    node: cell,
                    pos: cellPos
                });
                const from = cellPos;
                const to = cellPos + cell.nodeSize;
                removeMark && (removeMark = (0, $b6bhi.entireSelectionContainsMark)(mark, tr.doc, from, to));
            });
            for(let i = cells.length - 1; i >= 0; i--){
                const cell = cells[i];
                const from = cell.pos;
                const to = from + cell.node.nodeSize;
                $e4a271b9e519cf8b$export$94a1aa532f5398df(from, to, removeMark, mark, tr);
            }
        } else {
            const { $from: $from, $to: $to } = tr.selection;
            // We decide to remove the mark only if the entire selection contains the mark
            // Examples with *bold* text
            // Scenario 1: Selection contains both bold and non-bold text -> bold entire selection
            // Scenario 2: Selection contains only bold text -> un-bold entire selection
            // Scenario 3: Selection contains no bold text -> bold entire selection
            const removeMark = (0, $b6bhi.entireSelectionContainsMark)(mark, tr.doc, $from.pos, $to.pos);
            $e4a271b9e519cf8b$export$94a1aa532f5398df($from.pos, $to.pos, removeMark, mark, tr);
        }
        if (tr.docChanged) return tr;
        return null;
    };
const $e4a271b9e519cf8b$export$797ad2667b8015a8 = (markType, attrs)=>({ tr: tr })=>{
        const mark = markType.create(attrs);
        // For cursor selections we can use the default behaviour.
        if (tr.selection instanceof (0, $ks2lK.TextSelection) && tr.selection.$cursor) {
            if (mark.isInSet(tr.storedMarks || tr.selection.$cursor.marks())) tr.removeStoredMark(mark);
            else tr.addStoredMark(mark);
            return tr;
        }
        return $e4a271b9e519cf8b$var$toggleMarkInRange(mark)({
            tr: tr
        });
    };
module.exports["applyMarkOnRange"] = $e4a271b9e519cf8b$export$94a1aa532f5398df;
module.exports["toggleMark"] = $e4a271b9e519cf8b$export$797ad2667b8015a8;

});

parcelRegister("b6bhi", function(module, exports) {
const $5e31ae3712eebce3$export$cc5a5f0a00f537f5 = (mark, doc, fromPos, toPos)=>{
    let onlyContainsMark = true;
    doc.nodesBetween(fromPos, toPos, (node)=>{
        // Skip recursion once we've found text which doesn't include the mark
        if (!onlyContainsMark) return false;
        if (node.isText) onlyContainsMark && (onlyContainsMark = !!mark?.isInSet(node.marks));
    });
    return onlyContainsMark;
};
module.exports["entireSelectionContainsMark"] = $5e31ae3712eebce3$export$cc5a5f0a00f537f5;

});

parcelRegister("8TW6I", function(module, exports) {
var $f45f20daab5c26a1$export$f90c25d407b3694a = /*#__PURE__*/ function(TOOLBAR_ACTION_SUBJECT_ID) {
    TOOLBAR_ACTION_SUBJECT_ID["FIND_REPLACE"] = "findReplace";
    TOOLBAR_ACTION_SUBJECT_ID["EMOJI"] = "emoji";
    TOOLBAR_ACTION_SUBJECT_ID["ORDERED_LIST"] = "orderedList";
    TOOLBAR_ACTION_SUBJECT_ID["BULLET_LIST"] = "bulletList";
    TOOLBAR_ACTION_SUBJECT_ID["MEDIA"] = "media";
    TOOLBAR_ACTION_SUBJECT_ID["MENTION"] = "mention";
    TOOLBAR_ACTION_SUBJECT_ID["DECISION_LIST"] = "decisionList";
    TOOLBAR_ACTION_SUBJECT_ID["TASK_LIST"] = "taskList";
    TOOLBAR_ACTION_SUBJECT_ID["TEXT_COLOR"] = "color";
    TOOLBAR_ACTION_SUBJECT_ID["BACKGROUND_COLOR"] = "backgroundColor";
    TOOLBAR_ACTION_SUBJECT_ID["TEXT_FORMATTING_STRONG"] = "strong";
    TOOLBAR_ACTION_SUBJECT_ID["TEXT_FORMATTING_ITALIC"] = "italic";
    TOOLBAR_ACTION_SUBJECT_ID["TEXT_FORMATTING_UNDERLINE"] = "underline";
    TOOLBAR_ACTION_SUBJECT_ID["UNDO"] = "undo";
    TOOLBAR_ACTION_SUBJECT_ID["REDO"] = "redo";
    TOOLBAR_ACTION_SUBJECT_ID["INDENT"] = "indent";
    TOOLBAR_ACTION_SUBJECT_ID["OUTDENT"] = "outdent";
    TOOLBAR_ACTION_SUBJECT_ID["RECORD_VIDEO"] = "recordVideo";
    TOOLBAR_ACTION_SUBJECT_ID["AI"] = "atlassian-intelligence";
    return TOOLBAR_ACTION_SUBJECT_ID;
}({});
module.exports["TOOLBAR_ACTION_SUBJECT_ID"] = $f45f20daab5c26a1$export$f90c25d407b3694a;

});

parcelRegister("aro2m", function(module, exports) {
/* eslint-disable @atlaskit/ui-styling-standard/no-classname-prop */ 
var $42omo = parcelRequire("42omo");

/**
 * Generate a className based on the breakpoints provided.
 *
 * **Warning** - must much classnames defined in ResponsiveContainer.tsx
 * @param above - The breakpoint to show the element above.
 * @param below - The breakpoint to show the element below.
 * @returns The className to apply to the element.
 */ const $81771525c31a3389$var$generateClassName = (above, below, only)=>{
    if (only) return `show-only-${only}`;
    const classes = [];
    if (above) classes.push(`show-above-${above}`);
    if (below) classes.push(`show-below-${below}`);
    return classes.length > 0 ? classes.join(' ') : undefined;
};
const $81771525c31a3389$export$f6a3d19be20f5819 = ({ children: children, above: above, below: below, only: only })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: $81771525c31a3389$var$generateClassName(above, below, only),
        "data-vc": "SYzzaGeC"
    }, children);
};
module.exports["Show"] = $81771525c31a3389$export$f6a3d19be20f5819;

});

parcelRegister("fIFhP", function(module, exports) {

var $d925B = parcelRequire("d925B");


var $cPCP8 = parcelRequire("cPCP8");

const $f7489d2cc91d9569$export$19f6cf3733198aff = (parents)=>parents.at(0)?.key === (0, $cPCP8.TOOLBARS).INLINE_TEXT_TOOLBAR ? (0, $d925B.INPUT_METHOD).FLOATING_TB : (0, $d925B.INPUT_METHOD).TOOLBAR;
module.exports["getInputMethodFromParentKeys"] = $f7489d2cc91d9569$export$19f6cf3733198aff;

});

parcelRegister("EJKmu", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ghftu = parcelRequire("ghftu");

const $ab884fb0347eea48$export$fab3805c25b17109 = ({ label: label, testId: testId, color: color, shouldRecommendSmallIcon: shouldRecommendSmallIcon, spacing: spacing })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
        label: label,
        testId: testId,
        color: color,
        shouldRecommendSmallIcon: shouldRecommendSmallIcon,
        spacing: spacing,
        size: "small"
    });
module.exports["MoreItemsIcon"] = $ab884fb0347eea48$export$fab3805c25b17109;

});

parcelRegister("fMaLE", function(module, exports) {
/**
 *
 * Revamped typeahead using decorations instead of the `typeAheadQuery` mark
 *
 * https://product-fabric.atlassian.net/wiki/spaces/E/pages/2992177582/Technical+TypeAhead+Data+Flow
 *
 *
 */ 
var $42omo = parcelRequire("42omo");


var $lSP4W = parcelRequire("lSP4W");


var $d925B = parcelRequire("d925B");


var $1S4f7 = parcelRequire("1S4f7");


var $lOELb = parcelRequire("lOELb");


var $ftzrq = parcelRequire("ftzrq");


var $dh538 = parcelRequire("dh538");

var $002f5348d4a49eb7$export$92a1a3b7554e9387 = /*#__PURE__*/ function(ACTIONS) {
    ACTIONS["OPEN_TYPEAHEAD_AT_CURSOR"] = "OPEN_TYPEAHEAD_AT_CURSOR";
    ACTIONS["CLOSE_TYPE_AHEAD"] = "CLOSE_TYPE_AHEAD";
    ACTIONS["CHANGE_QUERY"] = "CHANGE_QUERY";
    ACTIONS["INSERT_ITEM"] = "INSERT_ITEM";
    ACTIONS["INSERT_RAW_QUERY"] = "INSERT_RAW_QUERY";
    ACTIONS["UPDATE_LIST_ITEMS"] = "UPDATE_LIST_ITEMS";
    ACTIONS["UPDATE_LIST_ERROR"] = "UPDATE_LIST_ERROR";
    ACTIONS["CLEAR_LIST_ERROR"] = "CLEAR_LIST_ERROR";
    ACTIONS["UPDATE_SELECTED_INDEX"] = "UPDATE_SELECTED_INDEX";
    ACTIONS["UPDATE_SECTION_TITLE"] = "UPDATE_SECTION_TITLE";
    return ACTIONS;
}({});



var $ks2lK = parcelRequire("ks2lK");

const $6d2d39cb0dff555a$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('typeAheadPlugin');


const $4564a5865115acc6$export$daba40574d0568e3 = (tr)=>{
    return tr.setMeta((0, $6d2d39cb0dff555a$export$18d4026d1ea86bb1), {
        action: (0, $002f5348d4a49eb7$export$92a1a3b7554e9387).CLOSE_TYPE_AHEAD
    });
};



var $cuprm = parcelRequire("cuprm");





var $5SAOw = parcelRequire("5SAOw");


var $ke2AI = parcelRequire("ke2AI");



class $d4f0613799f34ef9$export$630efe5940bb4d41 {
    constructor(){
        this.startedAt = 0;
        this.endedAt = 0;
        this.keyCount = {
            arrowUp: 0,
            arrowDown: 0
        };
        this.increaseArrowUp = ()=>{
            this.keyCount.arrowUp += 1;
        };
        this.increaseArrowDown = ()=>{
            this.keyCount.arrowDown += 1;
        };
        this.serialize = ()=>{
            return {
                startedAt: this.startedAt,
                endedAt: performance.now(),
                keyCount: {
                    arrowUp: this.keyCount?.arrowUp || 0,
                    arrowDown: this.keyCount?.arrowDown || 0
                }
            };
        };
        this.startedAt = performance.now();
        this.keyCount = {
            arrowUp: 0,
            arrowDown: 0
        };
    }
}





var $6h7hA = parcelRequire("6h7hA");


var $iu6m9 = parcelRequire("iu6m9");



var $91bcx = parcelRequire("91bcx");

const $ea4aac0f7b007a9c$export$1ebf03cc1b973f80 = (item, api)=>{
    const isOffline = (0, $91bcx.isOfflineMode)(api?.connectivity?.sharedState.currentState()?.mode);
    return isOffline && item?.isDisabledOffline === true;
};



const $0f316b3f53d4dc77$export$9993709486a96a6b = (selectedIndex, api)=>{
    return (state, dispatch)=>{
        const pluginState = (0, $6d2d39cb0dff555a$export$18d4026d1ea86bb1).getState(state);
        if (pluginState?.selectedIndex === selectedIndex) return false;
        // If the new index is disabled ignore this call, we can use the previous index
        if ((0, $ea4aac0f7b007a9c$export$1ebf03cc1b973f80)(pluginState?.items[selectedIndex], api)) return false;
        const tr = state.tr;
        tr.setMeta((0, $6d2d39cb0dff555a$export$18d4026d1ea86bb1), {
            action: (0, $002f5348d4a49eb7$export$92a1a3b7554e9387).UPDATE_SELECTED_INDEX,
            params: {
                selectedIndex: selectedIndex
            }
        });
        if (dispatch) dispatch(tr);
        return true;
    };
};





const $1f77393088ff3949$export$be092076596418f1 = (handler)=>{
    return handler && Object.values((0, $lOELb.TypeAheadAvailableNodes)).includes(handler.id) && typeof handler.trigger === 'string' && typeof handler.selectItem === 'function' && typeof handler.getItems === 'function';
};
const $1f77393088ff3949$export$564dcc295d6ce147 = (editorState)=>{
    return !!(0, $6d2d39cb0dff555a$export$18d4026d1ea86bb1)?.getState(editorState)?.decorationSet?.find().length;
};
const $1f77393088ff3949$export$f05434c51e3762e = (editorState)=>{
    return (0, $6d2d39cb0dff555a$export$18d4026d1ea86bb1).getState(editorState);
};
const $1f77393088ff3949$export$c1eba975d6442029 = (editorState)=>{
    return (0, $6d2d39cb0dff555a$export$18d4026d1ea86bb1).getState(editorState)?.triggerHandler;
};
const $1f77393088ff3949$export$7a55deb43cd1340e = (editorState)=>{
    return (0, $6d2d39cb0dff555a$export$18d4026d1ea86bb1).getState(editorState)?.query;
};
const $1f77393088ff3949$export$74b0f581633f8412 = (state)=>{
    const isOpen = $1f77393088ff3949$export$564dcc295d6ce147(state);
    // if the TypeAhead is open
    // we should not allow it
    return !isOpen;
};
const $1f77393088ff3949$export$2bae95e359577df4 = (id, state)=>{
    const pluginState = (0, $6d2d39cb0dff555a$export$18d4026d1ea86bb1).getState(state);
    if (!pluginState || !pluginState.typeAheadHandlers || pluginState.typeAheadHandlers.length === 0) return null;
    const { typeAheadHandlers: typeAheadHandlers } = pluginState;
    return typeAheadHandlers.find((h)=>h.id === id) || null;
};
const $1f77393088ff3949$export$84a03e6192df0237 = ({ currentIndex: currentIndex, nextIndex: nextIndex, listSize: listSize, itemIsDisabled: itemIsDisabled })=>{
    // Use a loop to find the next selectable item
    for(let idx = nextIndex; idx < listSize; idx++){
        if (!itemIsDisabled(idx)) return idx;
    }
    // We got to the end of the list ^, now try from the start
    if ((0, $iu6m9.editorExperiment)('platform_editor_offline_editing_web', true)) for(let idx = 0; idx < nextIndex; idx++){
        if (!itemIsDisabled(idx)) return idx;
    }
    // If no selectable items are found, return currentIndex
    return currentIndex;
};
const $1f77393088ff3949$export$723aff40bcdce278 = ({ currentIndex: currentIndex, nextIndex: nextIndex, listSize: listSize, itemIsDisabled: itemIsDisabled })=>{
    // Use a loop to find the next non-selectable item when going backwards
    for(let idx = nextIndex; idx >= 0; idx--){
        if (!itemIsDisabled(idx)) return idx;
    }
    // We got to the start of the list ^, now try from the end
    if ((0, $iu6m9.editorExperiment)('platform_editor_offline_editing_web', true)) for(let idx = listSize; idx > nextIndex; idx--){
        if (!itemIsDisabled(idx)) return idx;
    }
    // If no non-selectable items are found, return currentIndex
    return currentIndex;
};
const $1f77393088ff3949$export$89c7a133a9db5167 = ({ trigger: trigger, editorState: editorState })=>{
    const pluginState = (0, $6d2d39cb0dff555a$export$18d4026d1ea86bb1).getState(editorState);
    if (!pluginState || !pluginState.typeAheadHandlers || pluginState.typeAheadHandlers.length === 0) return null;
    const { typeAheadHandlers: typeAheadHandlers } = pluginState;
    return typeAheadHandlers.find((h)=>h.trigger === trigger) || null;
};
const $1f77393088ff3949$export$f985e98ceae7c8f6 = ({ editorView: editorView, direction: direction, api: api })=>()=>{
        const typeAheadState = $1f77393088ff3949$export$f05434c51e3762e(editorView.state);
        if (!typeAheadState) return;
        const { selectedIndex: selectedIndex, items: items } = typeAheadState;
        const stats = typeAheadState.stats instanceof (0, $d4f0613799f34ef9$export$630efe5940bb4d41) ? typeAheadState.stats : new (0, $d4f0613799f34ef9$export$630efe5940bb4d41)();
        let nextIndex;
        const isDisabled = (idx)=>(0, $ea4aac0f7b007a9c$export$1ebf03cc1b973f80)(items[idx], api);
        if (direction === 'next') {
            stats.increaseArrowDown();
            /**
     * See: https://product-fabric.atlassian.net/browse/ED-17200
     * `selectedIndex` is forced to -1 now to not immediately focus the typeahead
     * and only do so when there is explicit logic to focus into the typeahead
     * options.
     *
     * This check for "set index to 1 when -1"
     * - is a temporary workaround to get back the previous behaviour without
     *    entirely reverting the a11y improvements
     *
     */ if (selectedIndex === -1 && items.length > 1) // If the first item is disabled we actually want to skip to the 3rd item
            // on the first arrow down
            nextIndex = isDisabled(0) && items.length > 2 ? 2 : 1;
            else nextIndex = selectedIndex >= items.length - 1 ? 0 : selectedIndex + 1;
            nextIndex = $1f77393088ff3949$export$84a03e6192df0237({
                currentIndex: selectedIndex,
                nextIndex: nextIndex,
                listSize: items.length,
                itemIsDisabled: isDisabled
            });
        } else {
            stats.increaseArrowUp();
            nextIndex = selectedIndex <= 0 ? items.length - 1 : selectedIndex - 1;
            nextIndex = $1f77393088ff3949$export$723aff40bcdce278({
                currentIndex: selectedIndex,
                nextIndex: nextIndex,
                listSize: items.length,
                itemIsDisabled: isDisabled
            });
        }
        (0, $0f316b3f53d4dc77$export$9993709486a96a6b)(nextIndex, api)(editorView.state, editorView.dispatch);
    };
const $1f77393088ff3949$export$19cacaa810ba988a = (trigger, intl, item)=>{
    switch(trigger){
        case '@':
            return {
                popupAriaLabel: intl.formatMessage((0, $6h7hA.typeAheadListMessages).mentionPopupLabel),
                listItemAriaLabel: intl.formatMessage((0, $6h7hA.typeAheadListMessages).metionListItemLabel, {
                    name: item?.mention?.name || '',
                    shortName: item?.mention?.mentionName || ''
                })
            };
        case '/':
            return {
                popupAriaLabel: intl.formatMessage((0, $6h7hA.typeAheadListMessages).quickInsertPopupLabel),
                listItemAriaLabel: intl.formatMessage((0, $6h7hA.typeAheadListMessages).emojiListItemLabel, {
                    name: item?.title || '',
                    shortcut: item?.emoji?.shortName || ''
                })
            };
        case ':':
            return {
                popupAriaLabel: intl.formatMessage((0, $6h7hA.typeAheadListMessages).emojiPopupLabel),
                listItemAriaLabel: intl.formatMessage((0, $6h7hA.typeAheadListMessages).emojiListItemLabel, {
                    name: item?.emoji?.name || '',
                    shortcut: item?.emoji?.shortName || ''
                })
            };
        default:
            return {
                popupAriaLabel: intl.formatMessage((0, $6h7hA.typeAheadListMessages).typeAheadPopupLabel)
            };
    }
};




var $zT4ZO = parcelRequire("zT4ZO");


var $eDabt = parcelRequire("eDabt");


var $cX9xt = parcelRequire("cX9xt");








var $1oCLl = parcelRequire("1oCLl");

function $afe5b94150163716$var$findInsertPoint(doc, pos, nodeToInsert) {
    const $pos = doc.resolve(pos);
    const createInsertPosition = (from, to)=>({
            from: from,
            to: to || from
        });
    // Search for a valid position for nodeToInsert in progressively higher levels
    for(let level = $pos.depth; level >= 0; level--){
        const nodeAtLevel = $pos.node(level);
        // Try to replace the empty paragraph in the level above
        // Scenario:
        //   doc(
        //     table(
        //       row(
        //         cell(
        //           p('{<>}'),
        //         ),
        //       )
        //     )
        //   )
        const levelAbove = Math.max(level - 1, 0);
        const parentNode = $pos.node(levelAbove);
        // Special case: when this is true, the 'to' position should be the end
        // of the empty paragraph
        const isNodeAtLevelEmptyParagraph = nodeAtLevel.type.name === 'paragraph' && nodeAtLevel.content.size === 0;
        const indexAtLevelAbove = $pos.index(levelAbove);
        const canReplaceNodeAtLevelAbove = parentNode.canReplaceWith(indexAtLevelAbove, indexAtLevelAbove, nodeToInsert.type);
        if (isNodeAtLevelEmptyParagraph && canReplaceNodeAtLevelAbove) {
            const from = $pos.posAtIndex(indexAtLevelAbove, levelAbove);
            return createInsertPosition(from, from + nodeAtLevel.nodeSize);
        }
        // Try to insert this node right after the node in the level above
        // Scenario:
        //   doc(
        //     panel(
        //       p('{<>}'),
        //     )
        //   )
        const indexAfterAtLevelAbove = $pos.indexAfter(levelAbove);
        const canInsertNodeAtLevelAbove = parentNode.canReplaceWith(indexAfterAtLevelAbove, indexAfterAtLevelAbove, nodeToInsert.type);
        if (canInsertNodeAtLevelAbove) return createInsertPosition($pos.posAtIndex(indexAfterAtLevelAbove, levelAbove));
    }
    return createInsertPosition(0);
}
const $afe5b94150163716$export$faec73a52dd47a2c = ({ node: node, tr: tr, position: position })=>{
    const { start: start, end: end } = position;
    if (node.isText) return tr.replaceWith(start, end, node);
    if (node.isBlock) {
        tr.delete(start, end);
        const mappedStart = tr.mapping.map(start);
        const nodeNormalized = (0, $zT4ZO.normaliseNestedLayout)(tr, node);
        const { listItem: listItem } = tr.doc.type.schema.nodes;
        // Handle edge cases if it's in a list or that it's inserting a node in the same node type
        /* e.g.
		 * panel (
		 *   1. text (insertion)
		 * )
		 * at insertion, text is parent (0), listItem is grandParent (-1), list is greatGrandparent (-2), panel is ggreatGrandParent (-3)
		 */ const grandParentNodeType = tr.selection.$from.node(-1)?.type;
        const ggreatGrandParentNodeType = tr.selection.$from.node(-3)?.type;
        const isGGreatGrandParentOfSameType = (0, $1oCLl.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? ggreatGrandParentNodeType && (0, $cX9xt.isNodeOfSameBaseType)(ggreatGrandParentNodeType, node.type) : ggreatGrandParentNodeType === node.type;
        if (grandParentNodeType === listItem && !isGGreatGrandParentOfSameType) return (0, $eDabt.transformNodeIntoListItem)(tr, nodeNormalized);
        // Handle edge cases for hr and mediaSingle
        const inserted = (0, $zT4ZO.safeInsert)(nodeNormalized, mappedStart)(tr);
        if (inserted) return tr;
        const sliceInserted = (0, $5SAOw.Slice).maxOpen((0, $5SAOw.Fragment).from(nodeNormalized));
        const { from: from, to: to } = $afe5b94150163716$var$findInsertPoint(tr.doc, mappedStart, nodeNormalized);
        tr.replaceWith(from, to, node);
        const openPosition = Math.min(from + (node.isAtom ? node.nodeSize : sliceInserted.openStart), tr.doc.content.size);
        const FORWARD_DIRECTION = 1;
        const nextSelection = (0, $ks2lK.TextSelection).findFrom(tr.doc.resolve(openPosition), FORWARD_DIRECTION, true);
        if (nextSelection) return tr.setSelection(nextSelection);
    }
    return tr;
};
const $afe5b94150163716$export$a6d430434014dc1c = ({ maybeFragment: maybeFragment, tr: tr, position: position, selectInlineNode: selectInlineNode })=>{
    const { start: start, end: end } = position;
    const fragment = maybeFragment instanceof (0, $5SAOw.Node) ? (0, $5SAOw.Fragment).from(maybeFragment) : maybeFragment;
    tr.replaceWith(start, end, fragment);
    if (selectInlineNode) return tr.setSelection((0, $ks2lK.NodeSelection).create(tr.doc, start));
    return tr.setSelection((0, $ks2lK.TextSelection).near(tr.doc.resolve(start + fragment.size)));
};


const $841a4b69009bd58d$var$validateNode = ({ schema: schema, maybeNode: maybeNode })=>{
    if (!maybeNode) return null;
    if (maybeNode instanceof (0, $5SAOw.Node) || maybeNode instanceof (0, $5SAOw.Fragment)) return maybeNode;
    if (typeof maybeNode === 'string') return schema.text(maybeNode);
    try {
        return (0, $5SAOw.Node).fromJSON(schema, maybeNode);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        return null;
    }
};
const $841a4b69009bd58d$var$createInsertCallback = ({ editorState: state, handler: handler, query: query, wasInsertedBySpace: wasInsertedBySpace, selectedIndex: selectedIndex, textStartPosition: textStartPosition, textInserted: textInserted })=>(maybeNode, opts = {})=>{
        const { tr: tr } = state;
        const position = {
            start: textStartPosition,
            end: textStartPosition + (wasInsertedBySpace ? textInserted.length : 0)
        };
        const node = $841a4b69009bd58d$var$validateNode({
            schema: state.schema,
            maybeNode: maybeNode
        });
        if (!node) {
            (0, $4564a5865115acc6$export$daba40574d0568e3)(tr);
            // In this kind of situation we need to
            // delete the raw text query
            tr.delete(position.start, position.end);
            return tr;
        }
        node instanceof (0, $5SAOw.Node) && node.isBlock ? (0, $afe5b94150163716$export$faec73a52dd47a2c)({
            node: node,
            tr: tr,
            position: position
        }) : (0, $afe5b94150163716$export$a6d430434014dc1c)({
            maybeFragment: node,
            tr: tr,
            position: position,
            selectInlineNode: Boolean(opts.selectInlineNode)
        });
        (0, $ke2AI.closeHistory)(tr);
        if (wasInsertedBySpace) return tr;
        const config = {
            stage: (0, $cuprm.InsertTypeAheadStages).INSERTING_ITEM,
            query: query,
            selectedIndex: selectedIndex,
            trigger: handler.trigger
        };
        tr.step(new (0, $cuprm.InsertTypeAheadStep)(config));
        return tr;
    };
const $841a4b69009bd58d$var$createDeleteRawTextCallback = ({ trigger: trigger, selectedIndex: selectedIndex, position: position, query: query, wasInsertedBySpace: wasInsertedBySpace, insertItem: insertItem })=>{
    return (newState)=>{
        const tr = newState.tr;
        (0, $ke2AI.closeHistory)(tr);
        if (!wasInsertedBySpace) {
            tr.delete(position.start, position.end);
            const config = {
                stage: (0, $cuprm.InsertTypeAheadStages).DELETING_RAW_QUERY,
                selectedIndex: selectedIndex,
                query: query,
                trigger: trigger
            };
            tr.step(new (0, $cuprm.InsertTypeAheadStep)(config));
        }
        tr.setMeta((0, $6d2d39cb0dff555a$export$18d4026d1ea86bb1), {
            action: (0, $002f5348d4a49eb7$export$92a1a3b7554e9387).INSERT_ITEM,
            params: insertItem
        });
        return tr;
    };
};
const $841a4b69009bd58d$export$173ade35125a6637 = (view)=>({ item: item, handler: handler, mode: mode, query: query, sourceListItem: sourceListItem })=>{
        const pluginState = (0, $1f77393088ff3949$export$f05434c51e3762e)(view.state);
        if (!pluginState) return;
        const stats = (pluginState.stats || new (0, $d4f0613799f34ef9$export$630efe5940bb4d41)()).serialize();
        const meta = {
            mode: mode,
            query: query,
            stats: stats,
            sourceListItem: sourceListItem
        };
        const { tr: tr } = view.state;
        const trigger = handler.trigger;
        let text = `${trigger}${query}`;
        if (mode === (0, $lOELb.SelectItemMode).SPACE) text = text.trim().concat(' ');
        // We want to always persist selectedIndex as -1 upon selecting an item from typeahead
        // in order to retain exist focus behaviour when undoing
        const selectedIndex = -1;
        const wasInsertedBySpace = mode === (0, $lOELb.SelectItemMode).SPACE;
        const { selection: { from: textStartPosition } } = tr;
        const insertItem = (newEditorSate)=>{
            const insertCallback = $841a4b69009bd58d$var$createInsertCallback({
                editorState: newEditorSate,
                query: query,
                mode: mode,
                handler: handler,
                wasInsertedBySpace: wasInsertedBySpace,
                selectedIndex: selectedIndex,
                textInserted: text,
                textStartPosition: textStartPosition
            });
            let wasInsertCallbackCalled = false;
            // Some wierd plugins doesn't call the insert item callback
            // For example, the link quick insert item
            // For those cases we need to make sure we are closing the typeahead
            const proxyHandler = {
                apply: function(target, _thisContext, argumentsList) {
                    wasInsertCallbackCalled = true;
                    return target(...argumentsList);
                }
            };
            const insertCallbackProxy = new Proxy(insertCallback, proxyHandler);
            const nextTr = handler.selectItem(newEditorSate, item, insertCallbackProxy, meta);
            if (!wasInsertCallbackCalled && nextTr) {
                (0, $ke2AI.closeHistory)(nextTr);
                // In some cases we need to re-open the typeahead
                // e.g.: addign mentions from the quick insert
                //
                // Today, the QuickInsert API doesn't have a tool
                // to help on this. So the code below will close the typeahead
                // only if there is no previous metadata about typeahead in the
                // next transaction
                if (!nextTr.getMeta((0, $6d2d39cb0dff555a$export$18d4026d1ea86bb1))) (0, $4564a5865115acc6$export$daba40574d0568e3)(nextTr);
            }
            return nextTr;
        };
        const position = {
            start: tr.selection.from,
            end: tr.selection.from + text.length
        };
        tr.setMeta((0, $6d2d39cb0dff555a$export$18d4026d1ea86bb1), {
            action: (0, $002f5348d4a49eb7$export$92a1a3b7554e9387).INSERT_RAW_QUERY,
            params: $841a4b69009bd58d$var$createDeleteRawTextCallback({
                wasInsertedBySpace: wasInsertedBySpace,
                selectedIndex: selectedIndex,
                insertItem: insertItem,
                position: position,
                query: query,
                trigger: trigger
            })
        });
        tr.insertText(text);
        (0, $ke2AI.closeHistory)(tr);
        view.dispatch(tr);
        view.focus();
    };



var $adhil = parcelRequire("adhil");









const $135f765001339810$export$adbec20dbbf15a6b = (props)=>(tr)=>{
        const { triggerHandler: triggerHandler, inputMethod: inputMethod, query: query, removePrefixTriggerOnCancel: removePrefixTriggerOnCancel } = props;
        tr.setMeta((0, $6d2d39cb0dff555a$export$18d4026d1ea86bb1), {
            action: (0, $002f5348d4a49eb7$export$92a1a3b7554e9387).OPEN_TYPEAHEAD_AT_CURSOR,
            params: {
                triggerHandler: triggerHandler,
                inputMethod: inputMethod,
                query: query,
                removePrefixTriggerOnCancel: removePrefixTriggerOnCancel
            }
        });
    };
const $135f765001339810$export$e7ce737179b76875 = ({ triggerHandler: triggerHandler, inputMethod: inputMethod, query: query, removePrefixTriggerOnCancel: removePrefixTriggerOnCancel })=>({ tr: tr })=>{
        $135f765001339810$export$adbec20dbbf15a6b({
            triggerHandler: triggerHandler,
            inputMethod: inputMethod,
            query: query,
            removePrefixTriggerOnCancel: removePrefixTriggerOnCancel
        })(tr);
        const { selection: selection } = tr;
        const isInline = selection instanceof (0, $ks2lK.NodeSelection) && selection.node.type.isInline;
        if (!(selection instanceof (0, $ks2lK.TextSelection) || selection instanceof (0, $adhil.GapCursorSelection) || selection instanceof (0, $ks2lK.NodeSelection))) return tr;
        if (selection instanceof (0, $adhil.GapCursorSelection)) {
            // Create space for the typeahead menu in gap cursor
            tr.insertText(' ');
            // delete 1 pos before wherever selection is now - that will delete the empty space
            tr.delete(tr.selection.from - 1, tr.selection.from);
        } else {
            if (selection instanceof (0, $ks2lK.NodeSelection)) {
                if (isInline) {
                    tr.deleteSelection();
                    return tr;
                }
                return tr;
            }
            if (!selection.$cursor) {
                tr.deleteSelection();
                return tr;
            }
            // Search & Destroy placeholder
            const cursorPos = selection.$cursor.pos;
            const nodeAtCursor = tr.doc.nodeAt(cursorPos);
            const isPlaceholderAtCursorPosition = nodeAtCursor && nodeAtCursor.type.name === 'placeholder';
            if (nodeAtCursor && isPlaceholderAtCursorPosition) tr.delete(cursorPos, cursorPos + nodeAtCursor.nodeSize);
            // ME-2375 remove the superfluous '@' inserted before decoration
            // by composition (https://github.com/ProseMirror/prosemirror/issues/903)
            //
            // Update:
            // Now also handles any use case with superfluous typeahead triggers (ie. '@', ':', '/')
            // being inserted due to composition by checking if we have the trigger
            // directly before the typeahead. This should not happen unless it has
            // been eroneously added because we require whitespace/newline for typeahead.
            // Check if the text ends with the trigger character (or any character matched
            // by customRegex, to support wide-char variants like fullwidth slash ／)
            const triggerPattern = (0, $1oCLl.expValEquals)('platform_editor_wide_slash_trigger', 'isEnabled', true) && triggerHandler.customRegex ? new RegExp(`(${triggerHandler.customRegex})$`, 'u') : null;
            const endsWithTrigger = selection.$head.parent.textContent.endsWith?.(triggerHandler.trigger) || triggerPattern && triggerPattern.test(selection.$head.parent.textContent);
            if (cursorPos >= 2 && !!selection?.$head?.parent?.textContent && endsWithTrigger) tr.delete(cursorPos - 1, cursorPos);
        }
        return tr;
    };



var $aeAfU = parcelRequire("aeAfU");



const $20f93bdfad7f6c7d$export$9edb4b0ea764e965 = ({ id: id, title: title, showTitleWhenOnlySection: showTitleWhenOnlySection })=>{
    return (state, dispatch)=>{
        if (!(0, $aeAfU.expVal)('platform_editor_agent_mentions', 'isEnabled', false) || !dispatch) return false;
        const tr = state.tr;
        const update = {
            title: title,
            ...showTitleWhenOnlySection !== undefined ? {
                showTitleWhenOnlySection: showTitleWhenOnlySection
            } : {}
        };
        tr.setMeta((0, $6d2d39cb0dff555a$export$18d4026d1ea86bb1), {
            action: (0, $002f5348d4a49eb7$export$92a1a3b7554e9387).UPDATE_SECTION_TITLE,
            params: {
                id: id,
                update: update
            }
        });
        dispatch(tr);
        return true;
    };
};









var $4VXMf = parcelRequire("4VXMf");


var $aIMBk = parcelRequire("aIMBk");

var $14sLv = parcelRequire("14sLv");


function $80a11dc406606389$export$568a7ed6897c4817(schema, typeAheads, featureFlags) {
    if (!typeAheads || typeAheads.length === 0) return;
    const rules = typeAheads.reduce((acc, typeAhead)=>{
        const trigger = typeAhead.customRegex || typeAhead.trigger;
        if (!trigger) return acc;
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        const regex = new RegExp(`(^|[.!?\\s${(0, $14sLv.leafNodeReplacementCharacter)}])(${trigger})$`);
        acc.push((0, $4VXMf.createRule)(regex, (state, match)=>{
            return (0, $135f765001339810$export$e7ce737179b76875)({
                triggerHandler: typeAhead,
                inputMethod: (0, $d925B.INPUT_METHOD).KEYBOARD
            })({
                tr: state.tr
            });
        }));
        return acc;
    }, []);
    const plugin = new (0, $1S4f7.SafePlugin)((0, $aIMBk.createPlugin)('type-ahead', rules, {
        allowInsertTextOnDocument: false
    }));
    return plugin;
}
var $80a11dc406606389$export$2e2bcd8739ae039 = $80a11dc406606389$export$568a7ed6897c4817;







const $b916e8e2b129c7fe$export$e715282b081c154e = (transactions, action)=>{
    const tr = transactions.find((tr)=>tr.getMeta((0, $6d2d39cb0dff555a$export$18d4026d1ea86bb1))?.action === action);
    if (!tr) return null;
    return tr.getMeta((0, $6d2d39cb0dff555a$export$18d4026d1ea86bb1))?.params;
};


function $2e6b2c9330b7fa69$export$ae829ec7b2625219() {
    return new (0, $1S4f7.SafePlugin)({
        appendTransaction (transactions, _oldState, newState) {
            const insertItemCallback = (0, $b916e8e2b129c7fe$export$e715282b081c154e)(transactions, (0, $002f5348d4a49eb7$export$92a1a3b7554e9387).INSERT_ITEM);
            if (insertItemCallback) {
                const tr = insertItemCallback(newState);
                if (tr) return tr;
            }
        }
    });
}













var $4vlwG = parcelRequire("4vlwG");












const $19ce93ae9f28b9e5$export$65dc1d975bd3407b = 'typeahead_decoration_key';
const $19ce93ae9f28b9e5$export$be8a8259777b339f = 'typeaheadDecoration';
const $19ce93ae9f28b9e5$export$a5cdf6890cae94d6 = 'fabric-editor-typeahead';
const $19ce93ae9f28b9e5$export$a38374e9651d6165 = 'typeahaed_decoration_element_id';
var $19ce93ae9f28b9e5$export$fc2dc87cf13c1ab1 = /*#__PURE__*/ function(CloseSelectionOptions) {
    CloseSelectionOptions["BEFORE_TEXT_INSERTED"] = "BEFORE_TEXT_INSERTED";
    CloseSelectionOptions["AFTER_TEXT_INSERTED"] = "AFTER_TEXT_INSERTED";
    return CloseSelectionOptions;
}({});






var $aXWIB = parcelRequire("aXWIB");


var $dQl1W = parcelRequire("dQl1W");


var $kbdB6 = parcelRequire("kbdB6");


































const $5f46f7bb5d602e59$export$4a6068dadc2c7771 = (api, closeAction, hasQuery, inputMethod, invocationMethod = null)=>{
    api?.analytics?.actions.fireAnalyticsEvent({
        action: (0, $d925B.ACTION).CLOSED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).TYPEAHEAD,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).TYPEAHEAD_QUICK_INSERT,
        attributes: {
            inputMethod: inputMethod,
            closeAction: closeAction,
            hasQuery: hasQuery,
            invocationMethod: invocationMethod
        },
        eventType: (0, $d925B.EVENT_TYPE).TRACK
    });
};




const $d1276177a33af925$export$4d1bf8b2f67bcb1 = (query)=>{
    return (state, dispatch)=>{
        const pluginState = (0, $6d2d39cb0dff555a$export$18d4026d1ea86bb1).getState(state);
        if (pluginState?.query === query) return false;
        const tr = state.tr;
        tr.setMeta((0, $6d2d39cb0dff555a$export$18d4026d1ea86bb1), {
            action: (0, $002f5348d4a49eb7$export$92a1a3b7554e9387).CHANGE_QUERY,
            params: {
                query: query
            }
        });
        if (dispatch) dispatch(tr);
        return true;
    };
};















const $096ea43f1319ffaf$export$5af11333ab9d7643 = (rawText)=>(tr)=>{
        const currentPosition = tr.selection.$from.pos;
        const positionBeforeRawText = Math.max(currentPosition - rawText.length, 0);
        const resolvedPositionBeforeText = tr.doc.resolve(positionBeforeRawText);
        const nextSelection = (0, $ks2lK.TextSelection).findFrom(resolvedPositionBeforeText, -1, true);
        if (nextSelection) tr.setSelection(nextSelection);
    };




const $3bcc5e104a830047$var$onlyHasViewMoreItem = (items)=>items.at(0)?.title === 'View more';
const $3bcc5e104a830047$var$insertRawQuery = ({ view: view, setSelectionAt: setSelectionAt, text: text, forceFocusOnEditor: forceFocusOnEditor })=>{
    const { tr: tr, schema: schema } = view.state;
    (0, $4564a5865115acc6$export$daba40574d0568e3)(tr);
    if (text.length > 0) {
        tr.replaceSelectionWith(schema.text(text));
        if (setSelectionAt === (0, $19ce93ae9f28b9e5$export$fc2dc87cf13c1ab1).BEFORE_TEXT_INSERTED) (0, $096ea43f1319ffaf$export$5af11333ab9d7643)(text)(tr);
    }
    view.dispatch(tr);
    if (forceFocusOnEditor) view.focus();
};
const $3bcc5e104a830047$export$3a3385069392b26f = (triggerHandler, editorView, items, api)=>{
    const editorViewRef = (0, $42omo.useRef)(editorView);
    const itemsRef = (0, $42omo.useRef)(items);
    const onTextInsert = (0, $42omo.useCallback)(({ setSelectionAt: setSelectionAt, text: text, forceFocusOnEditor: forceFocusOnEditor })=>{
        if (!triggerHandler) return;
        const { current: view } = editorViewRef;
        $3bcc5e104a830047$var$insertRawQuery({
            view: view,
            setSelectionAt: setSelectionAt,
            text: text,
            forceFocusOnEditor: forceFocusOnEditor
        });
    }, [
        triggerHandler
    ]);
    const onItemInsert = (0, $42omo.useCallback)(({ mode: mode, index: index, query: query })=>{
        const sourceListItem = itemsRef.current;
        if (sourceListItem.length === 0 || !triggerHandler || // View more item is only added for keyboard navigation and should not be considered as a valid item to be inserted
        $3bcc5e104a830047$var$onlyHasViewMoreItem(sourceListItem)) {
            const text = `${triggerHandler.trigger}${query}`;
            onTextInsert({
                forceFocusOnEditor: true,
                setSelectionAt: (0, $19ce93ae9f28b9e5$export$fc2dc87cf13c1ab1).AFTER_TEXT_INSERTED,
                text: text
            });
            return;
        }
        const itemToInsert = sourceListItem[index];
        if (!itemToInsert) return;
        const isDisabled = (0, $ea4aac0f7b007a9c$export$1ebf03cc1b973f80)(itemToInsert, api);
        if (isDisabled) return;
        const { current: view } = editorViewRef;
        (0, $841a4b69009bd58d$export$173ade35125a6637)(view)({
            item: itemToInsert,
            handler: triggerHandler,
            mode: mode,
            query: query,
            sourceListItem: sourceListItem
        });
    }, [
        triggerHandler,
        onTextInsert,
        api
    ]);
    const onItemMatch = (0, $42omo.useCallback)(({ mode: mode, query: query })=>{
        const _items = itemsRef.current;
        if (_items && _items.length > 1) return false;
        if (_items.length === 1 && // View more item is only added for keyboard navigation and should not be considered as a valid item to be inserted
        !$3bcc5e104a830047$var$onlyHasViewMoreItem(_items)) queueMicrotask(()=>{
            onItemInsert({
                mode: mode,
                query: query,
                index: 0
            });
        });
        else {
            const text = `${triggerHandler.trigger}${query}`;
            queueMicrotask(()=>{
                onTextInsert({
                    forceFocusOnEditor: true,
                    setSelectionAt: (0, $19ce93ae9f28b9e5$export$fc2dc87cf13c1ab1).AFTER_TEXT_INSERTED,
                    text: mode === (0, $lOELb.SelectItemMode).SPACE ? text.concat(' ') : text
                });
            });
        }
        return true;
    }, [
        onItemInsert,
        triggerHandler,
        onTextInsert
    ]);
    (0, $42omo.useLayoutEffect)(()=>{
        itemsRef.current = items;
    }, [
        items
    ]);
    return [
        onItemInsert,
        onTextInsert,
        onItemMatch
    ];
};













const $60a931d32dc134c6$export$265c9044700bb67 = ()=>{
    return ({ tr: tr })=>{
        tr.setMeta((0, $6d2d39cb0dff555a$export$18d4026d1ea86bb1), {
            action: (0, $002f5348d4a49eb7$export$92a1a3b7554e9387).CLEAR_LIST_ERROR,
            params: {
                errorInfo: null
            }
        });
        return tr;
    };
};




const $ecee86653111ffe7$export$4f4014ebb73e8d41 = (errorInfo)=>{
    return (state, dispatch)=>{
        const tr = state.tr;
        tr.setMeta((0, $6d2d39cb0dff555a$export$18d4026d1ea86bb1), {
            action: (0, $002f5348d4a49eb7$export$92a1a3b7554e9387).UPDATE_LIST_ERROR,
            params: {
                errorInfo: errorInfo,
                items: []
            }
        });
        if (dispatch) dispatch(tr);
        return true;
    };
};




const $e385805eda6211c5$export$e482099e4c227d2 = (items, sections = [])=>{
    return (state, dispatch)=>{
        const tr = state.tr;
        tr.setMeta((0, $6d2d39cb0dff555a$export$18d4026d1ea86bb1), {
            action: (0, $002f5348d4a49eb7$export$92a1a3b7554e9387).UPDATE_LIST_ITEMS,
            params: {
                items: items,
                sections: sections
            }
        });
        if (dispatch) dispatch(tr);
        return true;
    };
};





const $0246acc579519233$export$ba9956bced492649 = ({ items: items, triggerHandler: triggerHandler, intl: intl })=>{
    if (!(0, $iu6m9.editorExperiment)('platform_editor_agent_mentions', true) || !intl) return {
        items: items,
        sections: []
    };
    const sectionDefinitions = triggerHandler.getSections?.({
        intl: intl
    });
    if (!sectionDefinitions || sectionDefinitions.length === 0) return {
        items: items,
        sections: []
    };
    // Track which item indexes have been claimed by a section, or excluded (matched a section but
    // cut by that section's limit). Items excluded by limit should not appear anywhere in the output.
    const assignedToSection = new Set();
    const excludedByLimit = new Set();
    const groupedBySection = new Map();
    for (const section of sectionDefinitions){
        const matchingIndexes = [];
        for(let i = 0; i < items.length; i++){
            if (assignedToSection.has(i) || excludedByLimit.has(i)) continue;
            if (section.filter(items[i])) matchingIndexes.push(i);
        }
        const acceptedIndexes = section.limit !== undefined ? matchingIndexes.slice(0, section.limit) : matchingIndexes;
        const rejectedByLimit = matchingIndexes.slice(acceptedIndexes.length);
        for (const i of acceptedIndexes)assignedToSection.add(i);
        for (const i of rejectedByLimit)excludedByLimit.add(i);
        if (acceptedIndexes.length === 0) continue;
        groupedBySection.set(section.id, {
            indexes: acceptedIndexes,
            section: section
        });
    }
    const flattenedItems = [];
    const sections = [];
    for (const section of sectionDefinitions){
        const grouped = groupedBySection.get(section.id);
        if (!grouped) continue;
        const startIndex = flattenedItems.length;
        flattenedItems.push(...grouped.indexes.map((i)=>items[i]));
        const endIndex = flattenedItems.length - 1;
        sections.push({
            endIndex: endIndex,
            id: section.id,
            startIndex: startIndex,
            title: section.title
        });
    }
    // Append items not claimed by any section and not excluded by a limit
    for(let i = 0; i < items.length; i++)if (!assignedToSection.has(i) && !excludedByLimit.has(i)) flattenedItems.push(items[i]);
    return {
        items: flattenedItems,
        sections: sections
    };
};


const $d0ed9b51e4e85a1e$var$EMPTY_LIST_ITEM = [];
const $d0ed9b51e4e85a1e$export$36f5628e43bc3fcd = (triggerHandler, editorView, query, showViewMore, api, intl)=>{
    const [items, setItems] = (0, $42omo.useState)($d0ed9b51e4e85a1e$var$EMPTY_LIST_ITEM);
    const componentIsMounted = (0, $42omo.useRef)(true);
    const editorViewRef = (0, $42omo.useRef)(editorView);
    (0, $42omo.useEffect)(()=>{
        const getItems = triggerHandler?.getItems;
        if (!getItems) {
            setItems($d0ed9b51e4e85a1e$var$EMPTY_LIST_ITEM);
            return;
        }
        const options = {
            query: query || '',
            editorState: editorView.state
        };
        const { current: view } = editorViewRef;
        if ((0, $iu6m9.editorExperiment)('platform_editor_offline_editing_web', true)) // Clear any existing error state before making a new request
        queueMicrotask(()=>{
            api?.core.actions.execute((0, $60a931d32dc134c6$export$265c9044700bb67)());
        });
        getItems(options).then((result)=>{
            // Inject empty list item here so it flows through the normal list rendering and keyboard
            // navigation paths
            const emptyItem = result.length === 0 && (0, $1oCLl.expValEquals)('platform_editor_insert_menu_ai', 'isEnabled', true) ? triggerHandler.getEmptyItem?.({
                editorState: editorView.state
            }) : undefined;
            const rawList = result.length > 0 ? result : emptyItem ? [
                emptyItem
            ] : $d0ed9b51e4e85a1e$var$EMPTY_LIST_ITEM;
            const { items: list, sections: sections } = (0, $0246acc579519233$export$ba9956bced492649)({
                items: rawList,
                triggerHandler: triggerHandler,
                intl: intl ?? null
            });
            if (componentIsMounted.current) setItems(list);
            // Add a placeholder item for view more button so that it can be traversed with arrow keys
            const viewMoreItem = {
                title: 'View more'
            };
            queueMicrotask(()=>{
                (0, $e385805eda6211c5$export$e482099e4c227d2)(showViewMore ? list.concat(viewMoreItem) : list, sections)(view.state, view.dispatch);
            });
        }).catch((e)=>{
            if ((0, $iu6m9.editorExperiment)('platform_editor_offline_editing_web', true)) {
                if (e) {
                    if (componentIsMounted.current) setItems($d0ed9b51e4e85a1e$var$EMPTY_LIST_ITEM);
                    queueMicrotask(()=>{
                        (0, $ecee86653111ffe7$export$4f4014ebb73e8d41)(e)(view.state, view.dispatch);
                    });
                }
            }
        });
    // ignore because EditorView is mutable but we don't want to
    // call loadItems when it changes, only when the query changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        triggerHandler,
        query,
        intl
    ]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            componentIsMounted.current = false;
        };
    }, []);
    return items;
};









const $63d50c22b18d770d$export$4715c10ec9ca9321 = ({ triggerHandler: triggerHandler, items: items, query: query, editorView: editorView, closePopup: closePopup })=>{
    const editorViewRef = (0, $42omo.useRef)(editorView);
    (0, $42omo.useLayoutEffect)(()=>{
        if (!query || typeof triggerHandler.forceSelect !== 'function') return;
        const item = triggerHandler.forceSelect({
            items: items,
            query: query,
            editorState: editorViewRef.current.state
        });
        if (!item) return;
        const { current: view } = editorViewRef;
        closePopup();
        queueMicrotask(()=>{
            (0, $841a4b69009bd58d$export$173ade35125a6637)(view)({
                item: item,
                mode: (0, $lOELb.SelectItemMode).SPACE,
                query: query,
                handler: triggerHandler,
                sourceListItem: items
            });
        });
    }, [
        triggerHandler,
        closePopup,
        query,
        items
    ]);
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 



var $9K4OG = parcelRequire("9K4OG");








var $d7ZU3 = parcelRequire("d7ZU3");







var $5KVL8 = parcelRequire("5KVL8");


var $8m4tT = parcelRequire("8m4tT");


var $aFUXX = parcelRequire("aFUXX");









function $ea921fe6967839b1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ea921fe6967839b1$var$placeholderStyles = {
    name: "qn4qy1",
    styles: "&::after{content:attr(data-place-holder);color:var(--ds-text-subtlest, #6B6E76);position:relative;padding:var(--ds-space-025, 2px);left:var(--ds-space-negative-050, -4px);background-color:var(--ds-background-neutral, #0515240F);border-radius:var(--ds-radius-small, 3px);}"
};
const $ea921fe6967839b1$var$queryWithoutPlaceholderStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    '&::after': {
        content: `''`
    }
});
const $ea921fe6967839b1$var$querySpanStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    outline: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& input': {
        width: '5px',
        border: 'none',
        background: 'transparent',
        padding: 0,
        margin: 0,
        // TODO: ED-17022 - Fixes firefox caret position
        // Do not migrate font when em is used as unit
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '1em',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: (0, $aFUXX.blockNodesVerticalMargin),
        caretColor: "var(--ds-text-accent-blue, #1558BC)"
    }
});
const $ea921fe6967839b1$var$isNavigationKey = (event)=>{
    return [
        'Enter',
        'Tab',
        'ArrowDown',
        'ArrowUp'
    ].includes(event.key);
};
const $ea921fe6967839b1$var$isUndoRedoShortcut = (event)=>{
    const key = (0, $kbdB6.keyName)(event);
    if (event.ctrlKey && key === 'y') return 'historyRedo';
    if ((event.ctrlKey || event.metaKey) && event.shiftKey && key === 'Z') return 'historyRedo';
    if ((event.ctrlKey || event.metaKey) && key === 'z') return 'historyUndo';
    return false;
};
const $ea921fe6967839b1$var$getAriaLabel = (triggerPrefix, _intl)=>{
    switch(triggerPrefix){
        case '@':
            return (0, $6h7hA.typeAheadListMessages).mentionInputLabel;
        case '/':
            return (0, $6h7hA.typeAheadListMessages).quickInsertInputLabel;
        case ':':
            return (0, $6h7hA.typeAheadListMessages).emojiInputLabel;
        default:
            return (0, $6h7hA.typeAheadListMessages).quickInsertInputLabel;
    }
};
const $ea921fe6967839b1$export$efc9b80896822e63 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ triggerQueryPrefix: triggerQueryPrefix, cancel: cancel, onQueryChange: onQueryChange, onItemSelect: onItemSelect, selectNextItem: selectNextItem, selectPreviousItem: selectPreviousItem, forceFocus: forceFocus, reopenQuery: reopenQuery, onQueryFocus: onQueryFocus, onUndoRedo: onUndoRedo, editorView: editorView, items: items })=>{
    const ref = (0, $42omo.useRef)(document.createElement('span'));
    const inputRef = (0, $42omo.useRef)(null);
    const [query, setQuery] = (0, $42omo.useState)(null);
    const isEditorControlsEnabled = (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1');
    const isSearchPlaceholderEnabled = (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') && (0, $dh538.fg)('platform_editor_quick_insert_placeholder');
    const selection = editorView.state.selection;
    const { table: table } = editorView.state.schema.nodes;
    const [showPlaceholder, setShowPlaceholder] = (0, $42omo.useState)(isSearchPlaceholderEnabled && triggerQueryPrefix === '/' && // When triggered in very narrow table column, placeholder becomes ellipsis only
    // hence we disable it for now and revisit this scenario in ED-27480
    !(0, $8m4tT.findParentNodeOfType)(table)(selection));
    const cleanedInputContent = (0, $42omo.useCallback)(()=>{
        const raw = ref.current?.textContent || '';
        return raw;
    }, []);
    const onKeyUp = (0, $42omo.useCallback)((_event)=>{
        const text = cleanedInputContent();
        onQueryChange(text);
    }, [
        onQueryChange,
        cleanedInputContent
    ]);
    const onInput = (0, $42omo.useCallback)(()=>{
        if (cleanedInputContent()) setShowPlaceholder(false);
    }, [
        cleanedInputContent
    ]);
    const [isInFocus, setInFocus] = (0, $42omo.useState)(false);
    const checkKeyEvent = (0, $42omo.useCallback)((event)=>{
        const key = (0, $kbdB6.keyName)(event);
        const sel = document.getSelection();
        const raw = ref.current?.textContent || '';
        const text = cleanedInputContent();
        let stopDefault = false;
        const { selectedIndex: selectedIndex, removePrefixTriggerOnCancel: removePrefixTriggerOnCancel } = (0, $1f77393088ff3949$export$f05434c51e3762e)(editorView.state) || {};
        setInFocus(true);
        switch(key){
            case ' ':
                // space key
                if (text.length === 0) {
                    cancel({
                        forceFocusOnEditor: true,
                        text: ' ',
                        addPrefixTrigger: isEditorControlsEnabled ? !removePrefixTriggerOnCancel : true,
                        setSelectionAt: (0, $19ce93ae9f28b9e5$export$fc2dc87cf13c1ab1).AFTER_TEXT_INSERTED
                    });
                    stopDefault = true;
                }
                break;
            case 'Escape':
            case 'PageUp':
            case 'PageDown':
            case 'Home':
                cancel({
                    text: text,
                    forceFocusOnEditor: true,
                    addPrefixTrigger: isEditorControlsEnabled ? !removePrefixTriggerOnCancel : true,
                    setSelectionAt: (0, $19ce93ae9f28b9e5$export$fc2dc87cf13c1ab1).AFTER_TEXT_INSERTED
                });
                stopDefault = true;
                break;
            case 'Backspace':
                if (raw.length === 0 || sel?.anchorOffset === 0) {
                    event.stopPropagation();
                    event.preventDefault();
                    cancel({
                        forceFocusOnEditor: true,
                        text: text,
                        addPrefixTrigger: false,
                        setSelectionAt: (0, $19ce93ae9f28b9e5$export$fc2dc87cf13c1ab1).BEFORE_TEXT_INSERTED
                    });
                }
                break;
            case 'Enter':
                // TODO: ED-14758 - Under the W3C specification, any keycode sent under IME would return a keycode 229
                // event.isComposing can't be used alone as this also included a virtual keyboard under a keyboardless device, therefore, it seems the best practice would be intercepting the event as below.
                // Some suggested the other workaround maybe listen on`keypress` instead of `keydown`
                if (!event.isComposing && event.which !== 229 && event.keyCode !== 229) {
                    if (selectedIndex === -1) {
                        /**
             * TODO DTR-1401: (also see ED-17200) There are two options
             * here, either
             * - set the index directly to 1 in WrapperTypeAhead.tsx's
             *   `insertSelectedItem` at the cost of breaking some of the a11y
             *   focus changes,
             * - or do this jank at the cost of some small analytics noise.
             *
             * The focus behaviour still needs cleanup
             */ selectPreviousItem();
                        selectNextItem();
                    }
                    onItemSelect(event.shiftKey ? (0, $lOELb.SelectItemMode).SHIFT_ENTER : (0, $lOELb.SelectItemMode).ENTER);
                }
                break;
            case 'Tab':
                event.shiftKey ? selectPreviousItem() : selectNextItem();
                break;
            case 'ArrowDown':
                selectNextItem();
                break;
            case 'ArrowUp':
                selectPreviousItem();
                break;
        }
        const undoRedoType = $ea921fe6967839b1$var$isUndoRedoShortcut(event);
        if (onUndoRedo && undoRedoType && onUndoRedo(undoRedoType)) stopDefault = true;
        if ($ea921fe6967839b1$var$isNavigationKey(event) || stopDefault) {
            event.stopPropagation();
            event.preventDefault();
            return false;
        }
    }, [
        onUndoRedo,
        onItemSelect,
        selectNextItem,
        selectPreviousItem,
        cancel,
        cleanedInputContent,
        editorView.state,
        isEditorControlsEnabled
    ]);
    (0, $42omo.useLayoutEffect)(()=>{
        if (!ref.current) return;
        const browser = (0, $d7ZU3.getBrowserInfo)();
        const { current: element } = ref;
        const { removePrefixTriggerOnCancel: removePrefixTriggerOnCancel } = (0, $1f77393088ff3949$export$f05434c51e3762e)(editorView.state) || {};
        const onFocusIn = (_event)=>{
            onQueryFocus();
        };
        const keyDown = (event)=>{
            const key = (0, $kbdB6.keyName)(event);
            if ([
                'ArrowLeft',
                'ArrowRight'
            ].includes(key) && document.getSelection && document.getSelection()) {
                const q = ref.current?.textContent || '';
                const sel = document.getSelection();
                const isMovingRight = sel && 'ArrowRight' === key && sel.anchorOffset === q.length;
                const isMovingLeft = sel && 'ArrowLeft' === key && (sel.anchorOffset === 0 || event.metaKey);
                if (!isMovingRight && !isMovingLeft) return;
                cancel({
                    forceFocusOnEditor: true,
                    addPrefixTrigger: isEditorControlsEnabled ? !removePrefixTriggerOnCancel : true,
                    text: cleanedInputContent(),
                    setSelectionAt: isMovingRight ? (0, $19ce93ae9f28b9e5$export$fc2dc87cf13c1ab1).AFTER_TEXT_INSERTED : (0, $19ce93ae9f28b9e5$export$fc2dc87cf13c1ab1).BEFORE_TEXT_INSERTED
                });
                event.preventDefault();
                event.stopPropagation();
                return;
            }
            checkKeyEvent(event);
        };
        const onPaste = (event)=>{
            const html = event.clipboardData?.getData('text/html');
            const plainText = event.clipboardData?.getData('text/plain');
            if (html && plainText) {
                event.preventDefault();
                // insert the plain text into the type-ahead input field
                const selection = window.getSelection();
                if (selection && ref.current) {
                    if (selection.rangeCount > 0) {
                        const range = selection.getRangeAt(0);
                        range.deleteContents();
                        range.insertNode(document.createTextNode(plainText));
                        range.collapse(false);
                    }
                }
            }
        };
        const onFocusOut = (event)=>{
            const { relatedTarget: relatedTarget } = event;
            // Given the user is changing the focus
            // When the target is inside the TypeAhead Popup
            // Then the popup should stay open
            if (relatedTarget instanceof HTMLElement && relatedTarget.closest && relatedTarget.closest(`.${(0, $19ce93ae9f28b9e5$export$a5cdf6890cae94d6)}`)) return;
            // Chrome and Edge may emit focusout events without direct input.
            // This path handles dismissals that don't involve item selection, so we ignore these events.
            // In Edge this also lead to duplication in the trigger character (@, /, :) as `cancel` would be called twice
            if ((browser.ie || browser.chrome) && !(window.getSelection()?.type === 'Range') && // eslint-disable-next-line @typescript-eslint/no-explicit-any
            !event.sourceCapabilities) return;
            cancel({
                addPrefixTrigger: isEditorControlsEnabled ? !removePrefixTriggerOnCancel : true,
                text: cleanedInputContent(),
                setSelectionAt: (0, $19ce93ae9f28b9e5$export$fc2dc87cf13c1ab1).BEFORE_TEXT_INSERTED,
                forceFocusOnEditor: false
            });
        };
        const close = ()=>{
            cancel({
                addPrefixTrigger: false,
                text: '',
                forceFocusOnEditor: true,
                setSelectionAt: (0, $19ce93ae9f28b9e5$export$fc2dc87cf13c1ab1).BEFORE_TEXT_INSERTED
            });
        };
        const beforeinput = (e)=>{
            setInFocus(false);
            const { target: target } = e;
            if (e.isComposing || !(target instanceof HTMLElement)) return;
            if (e.inputType === 'historyUndo' && target.textContent?.length === 0) {
                e.preventDefault();
                e.stopPropagation();
                close();
                return;
            }
            if (e.data != null && inputRef.current === null) {
                setQuery('');
                // We need to change the content on Safari
                // and set the cursor at the right place
                if (browser.safari) {
                    e.preventDefault();
                    const dataElement = document.createTextNode(e.data);
                    element.appendChild(dataElement);
                    const sel = window.getSelection();
                    const range = document.createRange();
                    range.setStart(dataElement, dataElement.length);
                    range.collapse(true);
                    sel?.removeAllRanges();
                    sel?.addRange(range);
                }
            }
        };
        const onInput = ()=>{};
        if (browser.safari) {
            // On Safari, for reasons beyond my understanding,
            // The undo behavior is totally different from other browsers
            // That why we need to have an specific branch only for Safari.
            const onInput = (e)=>{
                const { target: target } = e;
                if (!(e instanceof InputEvent) || e.isComposing || !(target instanceof HTMLElement)) return;
                if (e.inputType === 'historyUndo' && target.textContent?.length === 1) {
                    e.preventDefault();
                    e.stopPropagation();
                    close();
                    return;
                }
            };
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element.addEventListener('input', onInput);
        }
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element.addEventListener('focusout', onFocusOut);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element.addEventListener('focusin', onFocusIn);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element.addEventListener('keydown', keyDown);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element.addEventListener('beforeinput', beforeinput);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element.addEventListener('paste', onPaste);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element.removeEventListener('focusout', onFocusOut);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element.removeEventListener('focusin', onFocusIn);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element.removeEventListener('keydown', keyDown);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element.removeEventListener('beforeinput', beforeinput);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element.removeEventListener('paste', onPaste);
            if (browser.safari) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element.removeEventListener('input', onInput);
        };
    }, [
        triggerQueryPrefix,
        cleanedInputContent,
        onQueryFocus,
        cancel,
        checkKeyEvent,
        editorView.state,
        isEditorControlsEnabled
    ]);
    (0, $42omo.useLayoutEffect)(()=>{
        const hasReopenQuery = typeof reopenQuery === 'string' && reopenQuery.trim().length > 0;
        if (ref.current && forceFocus) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            setQuery(hasReopenQuery ? reopenQuery : null);
            requestAnimationFrame(()=>{
                if (!ref?.current) return;
                const sel = window.getSelection();
                if (sel && hasReopenQuery && ref.current.lastChild instanceof Text) {
                    const lastChild = ref.current.lastChild;
                    const range = document.createRange();
                    range.setStart(ref.current.lastChild, lastChild.length);
                    range.collapse(true);
                    sel.removeAllRanges();
                    sel.addRange(range);
                }
                ref.current.focus();
                setInFocus(true);
            });
        }
    }, [
        forceFocus,
        reopenQuery
    ]);
    const classNames = (0, $42omo.useMemo)(()=>{
        const classes = [];
        if (showPlaceholder) {
            // to avoid the placeholder wrapped to next line when triggered at the end of the line
            // see placeholderWrapStyles in editor-core/src/ui/ContentStyles/index.tsx
            classes.push('placeholder-decoration-wrap');
            if (selection.$from.depth > 1) // to hide placeholder overflow as ellipsis
            // see placeholderWrapStyles in editor-core/src/ui/ContentStyles/index.tsx
            classes.push('placeholder-decoration-hide-overflow');
        }
        return classes.join(' ');
    }, [
        showPlaceholder,
        selection
    ]);
    const assistiveHintID = (0, $19ce93ae9f28b9e5$export$a38374e9651d6165) + '__assistiveHint';
    const intl = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, triggerQueryPrefix, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        css: [
            $ea921fe6967839b1$var$querySpanStyles,
            isSearchPlaceholderEnabled && $ea921fe6967839b1$var$queryWithoutPlaceholderStyles,
            showPlaceholder && $ea921fe6967839b1$var$placeholderStyles
        ],
        contentEditable: true,
        ref: ref,
        onKeyUp: onKeyUp,
        tabIndex: -1,
        onInput: isSearchPlaceholderEnabled ? onInput : undefined,
        role: "combobox",
        "aria-controls": (0, $19ce93ae9f28b9e5$export$a38374e9651d6165),
        "aria-autocomplete": "list",
        "aria-expanded": items.length !== 0,
        "aria-labelledby": assistiveHintID,
        suppressContentEditableWarning: true,
        "data-query-prefix": triggerQueryPrefix,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: classNames,
        "data-place-holder": intl.formatMessage((0, $6h7hA.typeAheadListMessages).quickInsertInputPlaceholderLabel),
        "data-vc": "LAgbHt1x"
    }, query === null ? /*#__PURE__*/ (0, $9K4OG.jsx)("input", {
        ref: inputRef,
        type: "text",
        "aria-label": intl.formatMessage($ea921fe6967839b1$var$getAriaLabel(triggerQueryPrefix, intl))
    }) : query), /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        id: assistiveHintID,
        style: {
            display: 'none'
        }
    }, intl.formatMessage((0, $6h7hA.typeAheadListMessages).inputQueryAssistiveLabel)), /*#__PURE__*/ (0, $9K4OG.jsx)((0, $5KVL8.AssistiveText), {
        assistiveText: items.length === 0 ? intl.formatMessage((0, $6h7hA.typeAheadListMessages).noSearchResultsLabel, {
            itemsLength: items.length
        }) : '',
        isInFocus: items.length === 0 || isInFocus,
        id: (0, $19ce93ae9f28b9e5$export$a38374e9651d6165)
    }));
});
$ea921fe6967839b1$export$efc9b80896822e63.displayName = 'InputQuery';


const $ce54c0bb8029b5af$export$970faf6afe0d9376 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ triggerHandler: triggerHandler, editorView: editorView, anchorElement: anchorElement, shouldFocusCursorInsideQuery: shouldFocusCursorInsideQuery, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, inputMethod: inputMethod, getDecorationPosition: getDecorationPosition, reopenQuery: reopenQuery, onUndoRedo: onUndoRedo, api: api })=>{
    // @ts-ignore
    const openElementBrowserModal = triggerHandler?.openElementBrowserModal;
    let showMoreOptionsButton = false;
    if ((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) showMoreOptionsButton = !!triggerHandler?.getMoreOptionsButtonConfig;
    const intl = (0, $aXWIB.useIntl)();
    const [closed, setClosed] = (0, $42omo.useState)(false);
    const [query, setQuery] = (0, $42omo.useState)(reopenQuery || '');
    const queryRef = (0, $42omo.useRef)(query);
    const editorViewRef = (0, $42omo.useRef)(editorView);
    const items = (0, $d0ed9b51e4e85a1e$export$36f5628e43bc3fcd)(triggerHandler, editorView, query, showMoreOptionsButton, api, intl);
    (0, $42omo.useEffect)(()=>{
        if (!closed && (0, $dh538.fg)('platform_editor_ease_of_use_metrics')) api?.core.actions.execute(api?.metrics?.commands.handleIntentToStartEdit({
            shouldStartTimer: false,
            shouldPersistActiveSession: true
        }));
    }, [
        closed,
        api
    ]);
    (0, $42omo.useLayoutEffect)(()=>{
        queryRef.current = query;
    }, [
        query
    ]);
    const [onItemInsert, onTextInsert] = (0, $3bcc5e104a830047$export$3a3385069392b26f)(triggerHandler, editorView, items, api);
    const selectNextItem = (0, $42omo.useMemo)(()=>(0, $1f77393088ff3949$export$f985e98ceae7c8f6)({
            editorView: editorView,
            direction: 'next',
            api: api
        }), [
        editorView,
        api
    ]);
    const selectPreviousItem = (0, $42omo.useMemo)(()=>(0, $1f77393088ff3949$export$f985e98ceae7c8f6)({
            editorView: editorView,
            direction: 'previous',
            api: api
        }), [
        editorView,
        api
    ]);
    const cancel = (0, $42omo.useCallback)(({ setSelectionAt: setSelectionAt, addPrefixTrigger: addPrefixTrigger, text: text, forceFocusOnEditor: forceFocusOnEditor })=>{
        if ((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) (0, $5f46f7bb5d602e59$export$4a6068dadc2c7771)(api, (0, $d925B.ACTION).CANCELLED, !!queryRef.current, (0, $d925B.INPUT_METHOD).KEYBOARD, (0, $1f77393088ff3949$export$f05434c51e3762e)(editorView.state)?.inputMethod);
        setClosed(true);
        const fullquery = addPrefixTrigger ? `${triggerHandler.trigger}${text}` : text;
        onTextInsert({
            forceFocusOnEditor: forceFocusOnEditor,
            setSelectionAt: setSelectionAt,
            text: fullquery
        });
    }, [
        triggerHandler.trigger,
        onTextInsert,
        api,
        editorView.state
    ]);
    const insertSelectedItem = (0, $42omo.useCallback)((mode = (0, $lOELb.SelectItemMode).SELECTED)=>{
        const { current: view } = editorViewRef;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const { selectedIndex: selectedIndex } = (0, $1f77393088ff3949$export$f05434c51e3762e)(view.state);
        const safeSelectedIndex = (0, $1f77393088ff3949$export$84a03e6192df0237)({
            currentIndex: selectedIndex,
            nextIndex: 1,
            listSize: items.length,
            itemIsDisabled: (idx)=>(0, $ea4aac0f7b007a9c$export$1ebf03cc1b973f80)(items[idx], api)
        });
        // If the only safe index is -1 then none are safe - do not insert item
        if (safeSelectedIndex === -1) return;
        if ((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) (0, $5f46f7bb5d602e59$export$4a6068dadc2c7771)(api, (0, $d925B.ACTION).INSERTED, !!queryRef.current, (0, $d925B.INPUT_METHOD).KEYBOARD, (0, $1f77393088ff3949$export$f05434c51e3762e)(editorView.state)?.inputMethod);
        setClosed(true);
        queueMicrotask(()=>{
            onItemInsert({
                mode: mode,
                index: selectedIndex,
                query: queryRef.current
            });
        });
    }, [
        items,
        api,
        editorView.state,
        onItemInsert
    ]);
    const showTypeAheadPopupList = (0, $42omo.useCallback)(()=>{}, []);
    const closePopup = (0, $42omo.useCallback)(()=>{
        setClosed(true);
    }, []);
    (0, $42omo.useEffect)(()=>{
        const { current: view } = editorViewRef;
        const pluginState = (0, $1f77393088ff3949$export$f05434c51e3762e)(view.state);
        if (query.length === 0 || query === pluginState?.query || !pluginState?.triggerHandler) return;
        (0, $d1276177a33af925$export$4d1bf8b2f67bcb1)(query)(view.state, view.dispatch);
    }, [
        query,
        reopenQuery
    ]);
    (0, $63d50c22b18d770d$export$4715c10ec9ca9321)({
        triggerHandler: triggerHandler,
        items: items,
        query: query,
        editorView: editorView,
        closePopup: closePopup
    });
    if (closed) return null;
    if (!triggerHandler) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ea921fe6967839b1$export$efc9b80896822e63), {
        triggerQueryPrefix: triggerHandler?.trigger,
        onQueryChange: setQuery,
        onItemSelect: insertSelectedItem,
        selectNextItem: selectNextItem,
        selectPreviousItem: selectPreviousItem,
        onQueryFocus: showTypeAheadPopupList,
        cancel: cancel,
        forceFocus: shouldFocusCursorInsideQuery,
        onUndoRedo: onUndoRedo,
        reopenQuery: reopenQuery,
        editorView: editorView,
        items: items
    });
});
$ce54c0bb8029b5af$export$970faf6afe0d9376.displayName = 'WrapperTypeAhead';






const $7760713677cf3dc2$export$116b677c5744e397 = ({ intl: intl, popupMountRef: popupMountRef, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI, api: api })=>{
    const createDecorations = (tr, { triggerHandler: triggerHandler, inputMethod: inputMethod, reopenQuery: reopenQuery })=>{
        const { selection: selection } = tr;
        if (!(selection instanceof (0, $ks2lK.TextSelection)) || !selection.$cursor) return {
            decorationSet: (0, $ftzrq.DecorationSet).empty,
            stats: null,
            decorationElement: null
        };
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const decorationId = `decoration_id_${(0, $19ce93ae9f28b9e5$export$65dc1d975bd3407b)}_${(0, $dQl1W.v4)()}`;
        const { $cursor: $cursor } = selection;
        const typeaheadComponent = document.createElement('mark');
        const stats = new (0, $d4f0613799f34ef9$export$630efe5940bb4d41)();
        let shouldFocusCursorInsideQuery = true;
        const deco = (0, $ftzrq.Decoration).widget($cursor.pos, (editorView, getDecorationPositionUnsafe)=>{
            const getDecorationPosition = ()=>{
                try {
                    return getDecorationPositionUnsafe();
                } catch (e) {
                    return undefined;
                }
            };
            typeaheadComponent.setAttribute('id', decorationId);
            typeaheadComponent.setAttribute('role', 'search');
            typeaheadComponent.dataset.typeAheadQuery = 'true';
            typeaheadComponent.dataset.trigger = triggerHandler.trigger;
            // This line below seems weird,
            // we need that cuz the clickAreaHelper
            // will try to hijack any click event coming
            // from the inside of the Editor
            // packages/editor/editor-core/src/ui/Addon/click-area-helper.ts
            typeaheadComponent.dataset.editorPopup = 'true';
            typeaheadComponent.dataset.typeAhead = (0, $19ce93ae9f28b9e5$export$be8a8259777b339f);
            typeaheadComponent.style.color = "var(--ds-text-accent-blue, #1558BC)";
            typeaheadComponent.style.backgroundColor = 'transparent';
            const onUndoRedo = (inputType)=>{
                if (![
                    'historyUndo',
                    'historyRedo'
                ].includes(inputType)) return false;
                const hasReopenQuery = typeof reopenQuery === 'string' && reopenQuery.trim().length > 0;
                const currentQuery = (0, $1f77393088ff3949$export$7a55deb43cd1340e)(editorView.state);
                if (hasReopenQuery || currentQuery?.length === 0) {
                    const command = inputType === 'historyUndo' ? (0, $ke2AI.undo) : (0, $ke2AI.redo);
                    let tr = editorView.state.tr;
                    const fakeDispatch = (customTr)=>{
                        tr = customTr;
                    };
                    const result = command(editorView.state, fakeDispatch);
                    if (result) {
                        (0, $4564a5865115acc6$export$daba40574d0568e3)(tr);
                        editorView.dispatch(tr);
                        editorView.focus();
                    }
                    return result;
                }
                return false;
            };
            nodeViewPortalProviderAPI.render(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.IntlProvider), {
                    defaultLocale: intl.defaultLocale || 'en-US',
                    locale: intl.locale || 'en-US',
                    messages: intl.messages,
                    formats: intl.formats
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ce54c0bb8029b5af$export$970faf6afe0d9376), {
                    triggerHandler: triggerHandler,
                    editorView: editorView,
                    anchorElement: typeaheadComponent,
                    inputMethod: inputMethod,
                    getDecorationPosition: getDecorationPosition,
                    shouldFocusCursorInsideQuery: shouldFocusCursorInsideQuery,
                    popupsMountPoint: popupMountRef.current?.popupsMountPoint,
                    popupsBoundariesElement: popupMountRef.current?.popupsBoundariesElement,
                    popupsScrollableElement: popupMountRef.current?.popupsScrollableElement,
                    onUndoRedo: onUndoRedo,
                    reopenQuery: reopenQuery,
                    api: api
                })), typeaheadComponent, decorationId, undefined, // @portal-render-immediately
            true);
            shouldFocusCursorInsideQuery = false;
            return typeaheadComponent;
        }, {
            isTypeAheadDecoration: true,
            key: decorationId,
            side: 0,
            stopEvent: (e)=>{
                const key = (0, $kbdB6.keyName)(e);
                const sel = document.getSelection();
                if ('ArrowLeft' === key && sel?.anchorOffset === 0) return false;
                return true;
            },
            ignoreSelection: false
        });
        return {
            decorationSet: (0, $ftzrq.DecorationSet).create(tr.doc, [
                deco
            ]),
            decorationElement: typeaheadComponent,
            stats: stats
        };
    };
    const removeDecorations = (decorationSet)=>{
        if (!decorationSet || decorationSet === (0, $ftzrq.DecorationSet).empty) return false;
        const typeAheadDecorations = decorationSet.find(undefined, undefined, (spec)=>{
            return spec.isTypeAheadDecoration;
        });
        if (!typeAheadDecorations || typeAheadDecorations.length === 0) return false;
        typeAheadDecorations.forEach(({ spec: spec })=>{
            if (!spec.key) return;
            const decoElement = document.querySelector(`#${spec.key}`);
            if (!decoElement) return;
            nodeViewPortalProviderAPI.remove(spec.key);
        });
        if ((0, $dh538.fg)('platform_editor_ease_of_use_metrics')) api?.core.actions.execute(api?.metrics?.commands.startActiveSessionTimer());
        return true;
    };
    return {
        createDecorations: createDecorations,
        removeDecorations: removeDecorations
    };
};














var $2v1PW = parcelRequire("2v1PW");










const $a4bd515e41bf20ae$var$shouldForceOpen = (step)=>{
    if (!(step instanceof (0, $cuprm.InsertTypeAheadStep))) return false;
    const isDeletionRawQueryOperation = step.isInsertionStep() && step.stage === (0, $cuprm.InsertTypeAheadStages).DELETING_RAW_QUERY;
    const isUndoingInsertionItem = step.isUndoingStep() && step.stage === (0, $cuprm.InsertTypeAheadStages).INSERTING_ITEM;
    return isDeletionRawQueryOperation || isUndoingInsertionItem;
};
const $a4bd515e41bf20ae$var$shouldForceClose = (step)=>{
    if (!(step instanceof (0, $cuprm.InsertTypeAheadStep))) return false;
    const isInsertingItem = step.isInsertionStep() && step.stage === (0, $cuprm.InsertTypeAheadStages).INSERTING_ITEM;
    const isUndoingDeletionRawQuery = step.isUndoingStep() && step.stage === (0, $cuprm.InsertTypeAheadStages).DELETING_RAW_QUERY;
    return isInsertingItem || isUndoingDeletionRawQuery;
};
const $a4bd515e41bf20ae$var$applySectionTitleUpdates = ({ sections: sections, sectionTitleUpdates: sectionTitleUpdates })=>{
    if (!(0, $aeAfU.expVal)('platform_editor_agent_mentions', 'isEnabled', false)) return sections;
    const updatedSections = sections.map((section)=>{
        const update = sectionTitleUpdates[section.id];
        if (!update) return section;
        return {
            ...section,
            ...update
        };
    });
    return updatedSections;
};
const $a4bd515e41bf20ae$var$createFindHandler = (typeAheadHandlers)=>(step)=>{
        if (!(step instanceof (0, $cuprm.InsertTypeAheadStep))) return null;
        const handler = typeAheadHandlers.find((h)=>h.trigger === step.trigger);
        return handler || null;
    };
const $a4bd515e41bf20ae$export$473eb76d322d0290 = ({ typeAheadHandlers: typeAheadHandlers, removeDecorations: removeDecorations, createDecorations: createDecorations })=>{
    const findHandler = $a4bd515e41bf20ae$var$createFindHandler(typeAheadHandlers);
    const openMenu = (currentPluginState, { tr: tr, triggerHandler: triggerHandler, inputMethod: inputMethod, reopenQuery: reopenQuery, selectedIndex: selectedIndex, removePrefixTriggerOnCancel: removePrefixTriggerOnCancel })=>{
        removeDecorations(currentPluginState.decorationSet);
        const { decorationSet: decorationSet, decorationElement: decorationElement, stats: stats } = createDecorations(tr, {
            triggerHandler: triggerHandler,
            inputMethod: inputMethod,
            reopenQuery: reopenQuery
        });
        if ((0, $1oCLl.expValEquals)('cc_editor_interactivity_monitoring', 'isEnabled', true)) (0, $2v1PW.insm).session?.startFeature('typeaheadOpen');
        return {
            ...currentPluginState,
            stats: stats,
            decorationSet: decorationSet,
            triggerHandler: triggerHandler,
            decorationElement: decorationElement,
            inputMethod: inputMethod,
            selectedIndex: typeof selectedIndex === 'number' ? selectedIndex : -1,
            items: [],
            sectionTitleUpdates: {},
            sections: [],
            query: reopenQuery || '',
            removePrefixTriggerOnCancel: removePrefixTriggerOnCancel
        };
    };
    const closeMenu = (currentPluginState)=>{
        removeDecorations(currentPluginState.decorationSet);
        if ((0, $1oCLl.expValEquals)('cc_editor_interactivity_monitoring', 'isEnabled', true)) (0, $2v1PW.insm).session?.endFeature('typeaheadOpen');
        return {
            ...currentPluginState,
            inputMethod: null,
            query: '',
            decorationElement: null,
            decorationSet: (0, $ftzrq.DecorationSet).empty,
            stats: null,
            triggerHandler: undefined,
            items: [],
            sections: [],
            sectionTitleUpdates: {},
            removePrefixTriggerOnCancel: undefined
        };
    };
    return (tr, currentPluginState, typeAheadStepOverride)=>{
        const meta = tr.getMeta((0, $6d2d39cb0dff555a$export$18d4026d1ea86bb1)) || {};
        // This code below controls when we should force
        // the menu to open or close during undo/redo operations
        const overrideHandler = findHandler(typeAheadStepOverride);
        if (typeAheadStepOverride && overrideHandler && $a4bd515e41bf20ae$var$shouldForceOpen(typeAheadStepOverride)) return openMenu(currentPluginState, {
            tr: tr,
            triggerHandler: overrideHandler,
            inputMethod: (0, $d925B.INPUT_METHOD).KEYBOARD,
            reopenQuery: typeAheadStepOverride.query,
            selectedIndex: typeAheadStepOverride.selectedIndex
        });
        else if ($a4bd515e41bf20ae$var$shouldForceClose(typeAheadStepOverride)) return closeMenu(currentPluginState);
        const { action: action, params: params } = meta || {};
        const shouldOpenMenu = action === (0, $002f5348d4a49eb7$export$92a1a3b7554e9387).OPEN_TYPEAHEAD_AT_CURSOR && (0, $1f77393088ff3949$export$be092076596418f1)(params?.triggerHandler);
        const selectionChanged = tr.selectionSet && (tr.isGeneric || Boolean(tr.getMeta('pointer')));
        const shouldCloseMenu = [
            (0, $002f5348d4a49eb7$export$92a1a3b7554e9387).CLOSE_TYPE_AHEAD,
            (0, $002f5348d4a49eb7$export$92a1a3b7554e9387).INSERT_ITEM
        ].includes(action) || selectionChanged;
        const shouldUpdateQuery = action === (0, $002f5348d4a49eb7$export$92a1a3b7554e9387).CHANGE_QUERY;
        const shouldUpdateListItems = action === (0, $002f5348d4a49eb7$export$92a1a3b7554e9387).UPDATE_LIST_ITEMS;
        const shouldUpdateListError = action === (0, $002f5348d4a49eb7$export$92a1a3b7554e9387).UPDATE_LIST_ERROR;
        const shouldUpdateSelectedIndex = action === (0, $002f5348d4a49eb7$export$92a1a3b7554e9387).UPDATE_SELECTED_INDEX;
        const shouldUpdateSectionTitleState = action === (0, $002f5348d4a49eb7$export$92a1a3b7554e9387).UPDATE_SECTION_TITLE;
        const shouldClearListError = action === (0, $002f5348d4a49eb7$export$92a1a3b7554e9387).CLEAR_LIST_ERROR;
        if (shouldOpenMenu) return openMenu(currentPluginState, {
            tr: tr,
            triggerHandler: params.triggerHandler,
            inputMethod: params.inputMethod,
            reopenQuery: params.query,
            removePrefixTriggerOnCancel: params.removePrefixTriggerOnCancel
        });
        else if (shouldCloseMenu) return closeMenu(currentPluginState);
        else if (shouldUpdateQuery) return {
            ...currentPluginState,
            query: params.query
        };
        else if (shouldUpdateListError) {
            const { errorInfo: errorInfo } = params;
            return {
                ...currentPluginState,
                errorInfo: errorInfo,
                items: [],
                sections: [],
                selectedIndex: -1
            };
        } else if (shouldUpdateListItems) {
            const { items: items, sections: sections = [] } = params;
            const { selectedIndex: selectedIndex } = currentPluginState;
            return {
                ...currentPluginState,
                items: items,
                sections: $a4bd515e41bf20ae$var$applySectionTitleUpdates({
                    sections: sections,
                    sectionTitleUpdates: currentPluginState.sectionTitleUpdates
                }),
                selectedIndex: Math.max(selectedIndex >= items.length ? items.length - 1 : selectedIndex, -1)
            };
        } else if (shouldUpdateSectionTitleState) {
            if (!(0, $aeAfU.expVal)('platform_editor_agent_mentions', 'isEnabled', false)) return currentPluginState;
            const { id: id, update: update } = params;
            const sectionTitleUpdates = {
                ...currentPluginState.sectionTitleUpdates,
                [id]: {
                    ...currentPluginState.sectionTitleUpdates[id],
                    ...update
                }
            };
            return {
                ...currentPluginState,
                sectionTitleUpdates: sectionTitleUpdates,
                sections: $a4bd515e41bf20ae$var$applySectionTitleUpdates({
                    sections: currentPluginState.sections,
                    sectionTitleUpdates: sectionTitleUpdates
                })
            };
        } else if (shouldUpdateSelectedIndex) return {
            ...currentPluginState,
            selectedIndex: params.selectedIndex
        };
        else if (shouldClearListError) return {
            ...currentPluginState,
            errorInfo: null
        };
        if (tr.docChanged) {
            const { decorationSet: decorationSet } = currentPluginState;
            const onRemove = ()=>{
                // Make sure we are unmounting the component
                // from the react tree when this decoration is removed
                removeDecorations(currentPluginState.decorationSet);
            };
            const mappedDecorationSet = decorationSet.map(tr.mapping, tr.doc, {
                onRemove: onRemove
            });
            // return same pluginState if decorationSet did not change
            if (mappedDecorationSet === currentPluginState.decorationSet) return currentPluginState;
            return {
                ...currentPluginState,
                decorationSet: mappedDecorationSet
            };
        }
        return currentPluginState;
    };
};


const $4ef775772671161d$var$hasValidTypeAheadStep = (tr)=>{
    const steps = tr.steps.filter((step)=>step instanceof (0, $cuprm.InsertTypeAheadStep));
    // There are some cases, like collab rebase, where the steps are re-applied
    // We should not re open the type-ahead for those cases
    if (steps.length === 1) return steps[0];
    return null;
};
function $4ef775772671161d$export$ae829ec7b2625219({ reactDispatch: reactDispatch, popupMountRef: popupMountRef, typeAheadHandlers: typeAheadHandlers, getIntl: getIntl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI, api: api }) {
    const intl = getIntl();
    const { createDecorations: createDecorations, removeDecorations: removeDecorations } = (0, $7760713677cf3dc2$export$116b677c5744e397)({
        intl: intl,
        nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
        popupMountRef: popupMountRef,
        api: api
    });
    const reducer = (0, $a4bd515e41bf20ae$export$473eb76d322d0290)({
        createDecorations: createDecorations,
        removeDecorations: removeDecorations,
        typeAheadHandlers: typeAheadHandlers,
        popupMountRef: popupMountRef
    });
    // Tracks a wide-char trigger handler detected during IME composition (e.g. ／).
    // Set by compositionupdate, cleared by compositionend. Used by handleKeyDown
    // to intercept Enter that confirms the composition.
    let pendingWideSlashHandler = null;
    return new (0, $1S4f7.SafePlugin)({
        key: (0, $6d2d39cb0dff555a$export$18d4026d1ea86bb1),
        state: {
            init () {
                return {
                    typeAheadHandlers: typeAheadHandlers,
                    query: '',
                    decorationSet: (0, $ftzrq.DecorationSet).empty,
                    decorationElement: null,
                    items: [],
                    sectionTitleUpdates: {},
                    sections: [],
                    errorInfo: null,
                    selectedIndex: -1,
                    stats: null,
                    inputMethod: null,
                    removePrefixTriggerOnCancel: undefined
                };
            },
            apply (tr, currentPluginState, oldEditorState, state) {
                const customStep = $4ef775772671161d$var$hasValidTypeAheadStep(tr);
                const nextPluginState = reducer(tr, currentPluginState, customStep);
                if (currentPluginState !== nextPluginState) reactDispatch((0, $6d2d39cb0dff555a$export$18d4026d1ea86bb1), nextPluginState);
                return nextPluginState;
            }
        },
        appendTransaction (transactions, _oldState, newState) {
            const insertItemCallback = (0, $b916e8e2b129c7fe$export$e715282b081c154e)(transactions, (0, $002f5348d4a49eb7$export$92a1a3b7554e9387).INSERT_RAW_QUERY);
            if (insertItemCallback) {
                const tr = insertItemCallback(newState);
                if (tr) {
                    if ((0, $dh538.fg)('platform_editor_ease_of_use_metrics')) api?.metrics?.commands.startActiveSessionTimer()({
                        tr: tr
                    });
                    return tr;
                }
            }
        },
        view () {
            return {
                update (editorView) {}
            };
        },
        props: {
            decorations: (state)=>{
                return (0, $6d2d39cb0dff555a$export$18d4026d1ea86bb1).getState(state)?.decorationSet;
            },
            handleKeyDown: (view, event)=>{
                // When composing a wide-char trigger (e.g. ／), intercept the Enter key
                // that confirms the composition so we can open the typeahead instead.
                if (pendingWideSlashHandler && event.isComposing && (event.key === 'Enter' || event.keyCode === 13)) {
                    const handler = pendingWideSlashHandler;
                    pendingWideSlashHandler = null;
                    // Defer until ProseMirror has flushed the composed text into its state.
                    setTimeout(()=>{
                        const command = (0, $135f765001339810$export$e7ce737179b76875)({
                            triggerHandler: handler,
                            inputMethod: (0, $d925B.INPUT_METHOD).KEYBOARD
                        });
                        const tr = command({
                            tr: view.state.tr
                        });
                        if (tr) view.dispatch(tr);
                    }, 0);
                    return true;
                }
                return false;
            },
            handleDOMEvents: {
                compositionupdate: (view, event)=>{
                    // When the experiment is on, track whether the current composition
                    // exactly matches a wide-char trigger (e.g. ／ from Japanese keyboard).
                    // We can't open the typeahead yet because composition is still active,
                    // but we record the matching handler so the next keydown (Enter) can use it.
                    if ((0, $1oCLl.expValEquals)('platform_editor_wide_slash_trigger', 'isEnabled', true)) {
                        const pendingData = event.data ?? '';
                        pendingWideSlashHandler = typeAheadHandlers.find((handler)=>{
                            if (!handler.customRegex) return false;
                            // Only match if the composition is a NON-ASCII trigger character.
                            // ASCII triggers (e.g. '/') are handled by the normal input rule
                            // path and must NOT be intercepted here — otherwise typing '/' on
                            // a macOS Japanese IME (which briefly fires compositionupdate with
                            // data='/') would cause the Enter-confirm to open the typeahead.
                            // Matches any single ASCII character (U+0000–U+007F).
                            // No 'u' flag needed for ASCII-only ranges.
                            // Ignored via go/ees005
                            // eslint-disable-next-line require-unicode-regexp
                            if (/^[\x00-\x7F]$/.test(pendingData)) return false;
                            const pattern = new RegExp(`^(${handler.customRegex})$`, 'u');
                            return pattern.test(pendingData);
                        }) ?? null;
                    }
                    return false;
                },
                compositionend: (view, event)=>{
                    // Clear the pending handler when composition ends (cancelled or committed
                    // via a non-Enter key like Space, which we don't want to intercept).
                    pendingWideSlashHandler = null;
                    return false;
                },
                click: (view, event)=>{
                    const { target: target } = event;
                    // ProseMirror view listen to any click event inside of it
                    // When this event is coming from the typeahead
                    // we should tell to ProseMirror to sit down and relax
                    // cuz we know what we are doing (I hope)
                    if (target instanceof HTMLElement && (0, $4vlwG.closest)(target, `[data-type-ahead=${(0, $19ce93ae9f28b9e5$export$be8a8259777b339f)}]`)) return true;
                    return false;
                }
            }
        }
    });
}








var $eiA8Z = parcelRequire("eiA8Z");















/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 






var $2P8Ax = parcelRequire("2P8Ax");











var $7YjFd = parcelRequire("7YjFd");

var $jwWgu = parcelRequire("jwWgu");





var $c6GJD = parcelRequire("c6GJD");










/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports













var $cO1el = parcelRequire("cO1el");


var $bUlM5 = parcelRequire("bUlM5");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");

const $8525a248fa37c0d8$var$containerStyles = (0, $ecnYn.xcss)({
    marginBlockStart: 'space.600',
    marginBlockEnd: 'space.600',
    textAlign: 'center'
});
const $8525a248fa37c0d8$export$fddf379e22a74b00 = ({ testId: testId, header: header, description: description, renderImage: renderImage })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        xcss: $8525a248fa37c0d8$var$containerStyles,
        testId: testId,
        direction: "column",
        alignItems: "center",
        gap: "space.300"
    }, renderImage?.(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        direction: "column",
        alignItems: "center",
        gap: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "medium",
        as: "h2"
    }, header), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        as: "p",
        color: "color.text"
    }, description)));
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports



const $75dba0b2ab42fd7c$var$HEIGHT = 90;
const $75dba0b2ab42fd7c$var$genericErrorStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    height: `${$75dba0b2ab42fd7c$var$HEIGHT}px`,
    display: 'block'
});
const $75dba0b2ab42fd7c$export$e54420a1a27457a4 = (props)=>{
    const id = 'link-picker-ui-generic-error-svg';
    return /*#__PURE__*/ (0, $9K4OG.jsx)("svg", {
        height: "90",
        viewBox: "0 0 164 212",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        css: $75dba0b2ab42fd7c$var$genericErrorStyles,
        ...props,
        "data-vc": "_IbL23ov"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("path", {
        d: "m95.43 74.16 66.44 115.08c5.84 10.12-1.46 22.76-13.14 22.76H15.85c-11.68 0-18.98-12.65-13.14-22.76L69.15 74.16c5.84-10.12 20.44-10.12 26.28 0Zm-7.56 83.55 2.88-44.35c.34-5.29-3.86-9.78-9.16-9.78-5.31 0-9.51 4.48-9.16 9.78l2.88 44.35a6.3 6.3 0 0 0 6.28 5.89c3.31 0 6.06-2.58 6.28-5.89Zm-15.84 23.54c0 5.66 4.76 10.1 10.39 9.58 4.85-.45 8.73-4.5 8.83-9.37.11-5.45-4.31-9.94-9.73-9.94-5.23-.01-9.49 4.37-9.49 9.73Z",
        fill: `url(#${id})`
    }), /*#__PURE__*/ (0, $9K4OG.jsx)("path", {
        opacity: ".6",
        d: "M93.35 27.17 85.94.45c-.17-.62-1.07-.58-1.19.05l-4.66 25.1-5.8-1.08a.612.612 0 0 0-.7.76L81 52c.17.62 1.07.58 1.19-.05l4.66-25.1 5.8 1.08c.45.08.82-.33.7-.76ZM66.77 41.81 55.9 33.26c-.22-.18-.53.07-.41.33l5.53 11.43-2.66 1.29c-.18.09-.2.33-.05.45l10.87 8.55c.22.18.53-.07.41-.33l-5.53-11.43 2.66-1.29c.17-.08.2-.33.05-.45Z",
        fill: "#C1C7D0"
    }), /*#__PURE__*/ (0, $9K4OG.jsx)("path", {
        opacity: ".6",
        d: "M102.78 56.75a.993.993 0 0 1-.92-1.38c-.24-.77-2.29-2.85-3.54-4.11-2.97-3.01-4.93-5-3.84-6.49 1.09-1.48 3.58-.22 7.35 1.7 1.32.67 3.35 1.7 4.45 2.03-.64-.95-2.24-2.58-3.28-3.63-2.97-3.01-4.93-5-3.84-6.49 1.08-1.48 3.58-.22 7.34 1.7 1.32.67 3.34 1.7 4.45 2.03-.64-.95-2.24-2.57-3.28-3.62-2.97-3.01-4.93-5-3.84-6.49 1.08-1.48 3.57-.22 7.34 1.7 1.58.8 4.18 2.13 4.98 2.13a1.005 1.005 0 0 1 1.46 1.36c-1.09 1.48-3.57.22-7.34-1.7-1.32-.67-3.34-1.7-4.44-2.03.64.95 2.24 2.57 3.28 3.62 2.97 3.01 4.93 5 3.84 6.49-1.08 1.48-3.57.22-7.34-1.7-1.32-.67-3.35-1.7-4.45-2.03.64.95 2.24 2.57 3.28 3.63 2.97 3.01 4.93 5 3.84 6.49-1.09 1.48-3.58.22-7.35-1.7-1.32-.67-3.35-1.71-4.45-2.03.64.95 2.24 2.58 3.28 3.63 2.97 3.01 4.93 5 3.84 6.49-.21.26-.51.4-.82.4Zm5.56 14.32c-.35 0-.69-.19-.88-.52-1.04-1.88-2.22-4.02-.91-5.21 1.31-1.2 3.34.18 5.49 1.63.87.59 2.26 1.53 2.93 1.71-.12-.68-.93-2.15-1.45-3.07-1.26-2.27-2.45-4.41-1.14-5.61 1.31-1.2 3.34.18 5.49 1.63.96.65 2.54 1.72 3.1 1.74a1 1 0 0 1 1.27 1.54c-1.31 1.2-3.34-.17-5.49-1.63-.87-.59-2.26-1.53-2.93-1.71.12.68.93 2.15 1.45 3.07 1.26 2.27 2.45 4.41 1.14 5.61-1.31 1.2-3.34-.18-5.49-1.63-.87-.59-2.26-1.53-2.93-1.71.12.68.93 2.14 1.22 2.67.27.48.09 1.09-.39 1.36-.15.09-.32.13-.48.13Zm-54.32-2.89c-.22 0-.44-.04-.67-.14-1.64-.69-1.24-3.11-.81-5.67.17-1.04.45-2.7.33-3.38-.57.39-1.56 1.75-2.18 2.6-1.53 2.09-2.99 4.07-4.62 3.38a.991.991 0 0 1-.53-1.31c.2-.48.73-.72 1.21-.57.52-.21 1.65-1.75 2.34-2.68 1.53-2.09 2.98-4.08 4.62-3.38 1.64.69 1.24 3.11.81 5.67-.17 1.04-.45 2.7-.33 3.38.57-.39 1.56-1.75 2.18-2.6 1.53-2.09 2.98-4.08 4.62-3.38 1.63.69 1.24 3.09.89 5.21-.09.54-.6.91-1.15.83-.54-.09-.92-.6-.83-1.15.1-.59.37-2.24.26-2.92-.57.39-1.56 1.75-2.18 2.6-1.33 1.79-2.59 3.51-3.96 3.51Z",
        fill: "#B3BAC5"
    }), /*#__PURE__*/ (0, $9K4OG.jsx)("defs", null, /*#__PURE__*/ (0, $9K4OG.jsx)("linearGradient", {
        id: id,
        x1: "26.169",
        y1: "228.621",
        x2: "138.408",
        y2: "116.382",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("stop", {
        stopColor: "#C1C7D0"
    }), /*#__PURE__*/ (0, $9K4OG.jsx)("stop", {
        offset: ".297",
        stopColor: "#C6CBD4",
        stopOpacity: ".881"
    }), /*#__PURE__*/ (0, $9K4OG.jsx)("stop", {
        offset: ".63",
        stopColor: "#D3D7DE",
        stopOpacity: ".748"
    }), /*#__PURE__*/ (0, $9K4OG.jsx)("stop", {
        offset: ".98",
        stopColor: "#E9EBEF",
        stopOpacity: ".608"
    }), /*#__PURE__*/ (0, $9K4OG.jsx)("stop", {
        offset: "1",
        stopColor: "#EBECF0",
        stopOpacity: ".6"
    }))));
};


function $ccd58d8d5c473a54$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ccd58d8d5c473a54$var$minHeightComponentStyles = {
    name: "2omrkj",
    styles: "display:flex;align-items:stretch;justify-content:center;min-height:290px"
};
const $ccd58d8d5c473a54$export$71ea07f9d4f4ab38 = ()=>{
    const intl = (0, $aXWIB.useIntl)();
    const header = intl.formatMessage((0, $6h7hA.typeAheadListMessages).typeAheadErrorFallbackHeading);
    const description = intl.formatMessage((0, $6h7hA.typeAheadListMessages).typeAheadErrorFallbackDesc);
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        "data-testid": "typeahead-error-boundary-ui",
        css: $ccd58d8d5c473a54$var$minHeightComponentStyles
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $8525a248fa37c0d8$export$fddf379e22a74b00), {
        header: header,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        renderImage: ()=>/*#__PURE__*/ (0, $9K4OG.jsx)((0, $75dba0b2ab42fd7c$export$e54420a1a27457a4), null),
        description: description
    }));
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 









var $cLwe6 = parcelRequire("cLwe6");


var $lG3Ww = parcelRequire("lG3Ww");





var $4HWgE = parcelRequire("4HWgE");










var $2SlZp = parcelRequire("2SlZp");


var $gdv5Z = parcelRequire("gdv5Z");

var $iXCQx = parcelRequire("iXCQx");














const $79039aba281e4c8c$export$c36f87108246a02a = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, measure: measure, index: index, style: style, isVisible: isVisible, isScrolling: isScrolling, onMouseMove: onMouseMove }, ref)=>{
    const childElementRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        // Do not measure if the row is not visible or is scrolling for performance reasons.
        if (!childElementRef.current || !isVisible || isScrolling) return;
        const observer = new ResizeObserver(()=>measure());
        observer.observe(childElementRef.current);
        return ()=>observer.disconnect();
    }, [
        isScrolling,
        isVisible,
        measure
    ]);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: ref,
        style: style,
        "data-index": index,
        "data-vc": "HHYW-Cy2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: childElementRef,
        "data-testid": `list-item-height-observed-${index}`,
        onMouseMove: onMouseMove
    }, children)));
});


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 









var $56M4r = parcelRequire("56M4r");

var $7rvPL = parcelRequire("7rvPL");

function $2e81f1e274001535$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2e81f1e274001535$var$buttonStyles = {
    name: "t1j6cq",
    styles: "& > button:hover{background-color:var(--ds-background-neutral-subtle-hovered, #0515240F);}& > button:focus{background-color:var(--ds-background-neutral-subtle-hovered, #0515240F);}"
};
const $2e81f1e274001535$export$76421314069e32e1 = ({ onClick: onClick, isFocused: isFocused, title: title, ariaLabel: ariaLabel, iconBefore: iconBefore, lastInputMethodRef: lastInputMethodRef })=>{
    const ref = (0, $42omo.useRef)(null);
    const isSafari = (0, $d7ZU3.getBrowserInfo)().safari;
    (0, $42omo.useEffect)(()=>{
        if (isFocused && ref.current) {
            const skipFocusOnSafariHover = isSafari && lastInputMethodRef?.current === 'mouse';
            if (!skipFocusOnSafariHover) ref.current.focus();
        }
    }, [
        isFocused,
        lastInputMethodRef,
        isSafari
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!ref.current) return;
        const { current: element } = ref;
        const handleEnter = (e)=>{
            if (e.key === 'Enter') {
                onClick();
                // Prevent keydown listener in TypeaheadList from handling Enter pressed
                e.stopPropagation();
            }
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element?.addEventListener('keydown', handleEnter);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element?.removeEventListener('keydown', handleEnter);
        };
    });
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $7rvPL.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        css: $2e81f1e274001535$var$buttonStyles,
        "data-vc": "3btFqisv"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $56M4r.default), {
        ref: ref,
        /* eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed) */ onMouseDown: (e)=>{
            if (isSafari) e.preventDefault();
        },
        onClick: onClick,
        iconBefore: iconBefore,
        "aria-label": ariaLabel,
        testId: "type-ahead-more-options-button"
    }, title)));
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 















var $158AJ = parcelRequire("158AJ");













var $6f5RK = parcelRequire("6f5RK");








var $6F6hl = parcelRequire("6F6hl");

function $c41ea6b4bf428ac0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c41ea6b4bf428ac0$export$cfa784b45fc7b21d = /*#__PURE__*/ (0, $9K4OG.css)({
    width: "var(--ds-space-500, 40px)",
    height: "var(--ds-space-500, 40px)",
    overflow: 'hidden',
    border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    borderRadius: "var(--ds-radius-small, 3px)",
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    div: {
        width: "var(--ds-space-500, 40px)",
        height: "var(--ds-space-500, 40px)"
    }
});
const $c41ea6b4bf428ac0$var$itemIconSizeUpdated = {
    name: "1pc97kj",
    styles: "width:var(--ds-space-400, 32px);height:var(--ds-space-400, 32px);div{width:var(--ds-space-400, 32px);height:var(--ds-space-400, 32px);}"
};
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $c41ea6b4bf428ac0$var$itemBody = {
    name: "dblrt7",
    styles: "display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:space-between"
};
const $c41ea6b4bf428ac0$var$itemText = /*#__PURE__*/ (0, $9K4OG.css)({
    whiteSpace: 'initial',
    color: `${"var(--ds-text, #292A2E)"}`
});
const $c41ea6b4bf428ac0$var$itemTitle = {
    name: "1v4psb4",
    styles: "line-height:1.4"
};
const $c41ea6b4bf428ac0$var$itemTitleOverride = {
    name: "1mdt16o",
    styles: "font:var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
const $c41ea6b4bf428ac0$var$itemDescription = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography
    fontSize: `${(0, $aFUXX.relativeFontSizeToBase16)(12)};`,
    color: `${"var(--ds-text-subtle, #505258)"};`,
    marginTop: `${"var(--ds-space-050, 4px)"};`
});
const $c41ea6b4bf428ac0$var$itemDescriptionOverride = {
    name: "11i1ezp",
    styles: "font:var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);margin-top:0"
};
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $c41ea6b4bf428ac0$var$itemAfter = {
    name: "ou8xsw",
    styles: "flex:0 0 auto"
};
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Ignored via go/DSP-18766
const $c41ea6b4bf428ac0$var$customRenderItemDivStyle = {
    name: "1679gcj",
    styles: "overflow:hidden;&:focus{box-shadow:inset 2px 0px 0px var(--ds-border-focused, #4688EC);background-color:var(--ds-background-neutral-subtle-hovered, #0515240F);outline:none;}"
};
/**
 * This CSS emulates the desired behaviour with :focus-visible for firefox.
 * Firefox unfortunately does not register keyboard focus if user mouseDown and drag a typeahead item
 * resulting in focus-visible style not drawn.
 */ const $c41ea6b4bf428ac0$var$selectionFrame = {
    '& > button:focus': {
        boxShadow: `inset 2px 0px 0px ${"var(--ds-border-focused, #4688EC)"};`,
        backgroundColor: `${"var(--ds-background-neutral-subtle-hovered, #0515240F)"}`,
        outline: 'none',
        '&:active': {
            boxShadow: 'none'
        }
    },
    '& > button:hover': {
        backgroundColor: 'inherit',
        outline: 'none'
    }
};
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Ignored via go/DSP-18766
const $c41ea6b4bf428ac0$var$selectedStyle = {
    name: "2atq5y",
    styles: "background-color:var(--ds-background-neutral-subtle-hovered, #0515240F);box-shadow:inset 2px 0px 0px var(--ds-border-focused, #4688EC)"
};
const $c41ea6b4bf428ac0$var$disabledStyle = {
    name: "v9x70u",
    styles: "color:var(--ds-text-disabled, #080F214A)"
};
const $c41ea6b4bf428ac0$var$titleWithLozengeStyle = /*#__PURE__*/ (0, $9K4OG.css)({
    display: 'flex',
    alignItems: 'center',
    gap: `${"var(--ds-space-050, 4px)"}`
});
const $c41ea6b4bf428ac0$var$lozengeWrapperStyle = {
    name: "ozd7xs",
    styles: "flex-shrink:0"
};
const $c41ea6b4bf428ac0$var$FallbackIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(()=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $158AJ.default), null);
});
const $c41ea6b4bf428ac0$var$noop = ()=>{};
const $c41ea6b4bf428ac0$var$CustomItemComponentWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((props)=>{
    const { customRenderItem: customRenderItem, isSelected: isSelected, itemIsDisabled: itemIsDisabled, ariaLabel: ariaLabel, itemsLength: itemsLength, customItemRef: customItemRef, insertSelectedItem: insertSelectedItem, itemIndex: itemIndex } = props;
    const Comp = customRenderItem;
    const listItemClasses = (0, $42omo.useMemo)(()=>{
        return [
            $c41ea6b4bf428ac0$var$customRenderItemDivStyle,
            isSelected && !itemIsDisabled && $c41ea6b4bf428ac0$var$selectedStyle,
            itemIsDisabled && $c41ea6b4bf428ac0$var$disabledStyle
        ];
    }, [
        isSelected,
        itemIsDisabled
    ]);
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        "aria-selected": isSelected,
        role: "option",
        "aria-label": ariaLabel,
        "aria-setsize": itemsLength,
        "aria-posinset": itemIndex + 1,
        tabIndex: 0,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: listItemClasses,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `ak-typeahead-item ${isSelected ? 'typeahead-selected-item' : ''}`,
        //CSS classes added for test cases purpose
        ref: customItemRef,
        "data-vc": "cTSwTxHo"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        "aria-hidden": true
    }, /*#__PURE__*/ (0, $9K4OG.jsx)(Comp, {
        onClick: insertSelectedItem,
        isSelected: false,
        onHover: $c41ea6b4bf428ac0$var$noop
    })));
});
const $c41ea6b4bf428ac0$export$913373331e95c13e = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ item: item, itemsLength: itemsLength, selectedIndex: selectedIndex, onItemClick: onItemClick, itemIndex: itemIndex, ariaLabel: ariaLabel, moreElementsInQuickInsertViewEnabled: moreElementsInQuickInsertViewEnabled, api: api, firstOnlineSupportedIndex: firstOnlineSupportedIndex, lastInputMethodRef: lastInputMethodRef })=>{
    const isSafari = (0, $d7ZU3.getBrowserInfo)().safari;
    const { connectivityMode: connectivityMode } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'connectivity'
    ], (states)=>{
        return {
            connectivityMode: states.connectivityState?.mode
        };
    });
    const isItemDisabled = (item)=>(0, $91bcx.isOfflineMode)(connectivityMode) && (item?.isDisabledOffline ?? false);
    const itemIsDisabled = isItemDisabled(item);
    const isFirstEnabledIndex = (0, $91bcx.isOfflineMode)(connectivityMode) && itemIndex === firstOnlineSupportedIndex && selectedIndex === -1;
    /**
   * To select and highlight the first Item when no item is selected
   * However selectedIndex remains -1, So that user does not skip the first item when down arrow key is used from typeahead query(inputQuery.tsx)
   */ let isSelected = false;
    // Feature gated - connectivity is only available on desktop and behind a feature gate on full page mode
    if (connectivityMode === undefined) isSelected = itemIndex === selectedIndex || selectedIndex === -1 && itemIndex === 0;
    else isSelected = itemIndex === selectedIndex || selectedIndex === -1 && (itemIndex === 0 || isFirstEnabledIndex) && !itemIsDisabled;
    // Assistive text
    const intl = (0, $aXWIB.useIntl)();
    const descriptionText = item.description ? `${item.description}.` : '';
    const shortcutText = item.keyshortcut ? ` ${intl.formatMessage((0, $6h7hA.typeAheadListMessages).shortcutLabel)} ${item.keyshortcut}.` : '';
    const descriptionId = `typeahead-item-description-${itemIndex}`;
    const { icon: icon, title: title, render: customRenderItem } = item;
    const elementIcon = (0, $42omo.useMemo)(()=>{
        return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: [
                $c41ea6b4bf428ac0$export$cfa784b45fc7b21d,
                moreElementsInQuickInsertViewEnabled && $c41ea6b4bf428ac0$var$itemIconSizeUpdated
            ]
        }, icon ? icon() : /*#__PURE__*/ (0, $9K4OG.jsx)($c41ea6b4bf428ac0$var$FallbackIcon, null));
    }, [
        icon,
        moreElementsInQuickInsertViewEnabled
    ]);
    const insertSelectedItem = (0, $42omo.useCallback)(()=>{
        if (itemIsDisabled) return;
        onItemClick((0, $lOELb.SelectItemMode).SELECTED, itemIndex);
    }, [
        onItemClick,
        itemIndex,
        itemIsDisabled
    ]);
    const customItemRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(null);
    const buttonItemRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(null);
    const shouldUpdateFocus = selectedIndex === itemIndex && !isFirstEnabledIndex;
    const listItemClasses = (0, $42omo.useMemo)(()=>{
        return [
            $c41ea6b4bf428ac0$var$selectionFrame,
            isSelected && !itemIsDisabled && $c41ea6b4bf428ac0$var$selectedStyle
        ];
    }, [
        isSelected,
        itemIsDisabled
    ]);
    (0, $42omo.useLayoutEffect)(()=>{
        if (shouldUpdateFocus) {
            const skipFocusOnSafariHover = isSafari && lastInputMethodRef?.current === 'mouse';
            if (!skipFocusOnSafariHover) customItemRef?.current?.focus();
        }
    }, [
        customItemRef,
        shouldUpdateFocus,
        lastInputMethodRef,
        isSafari
    ]);
    (0, $42omo.useLayoutEffect)(()=>{
        if (shouldUpdateFocus) {
            const skipFocusOnSafariHover = isSafari && lastInputMethodRef?.current === 'mouse';
            if (!skipFocusOnSafariHover) buttonItemRef?.current?.focus();
        }
    }, [
        buttonItemRef,
        shouldUpdateFocus,
        lastInputMethodRef,
        isSafari
    ]);
    if (customRenderItem) return /*#__PURE__*/ (0, $9K4OG.jsx)($c41ea6b4bf428ac0$var$CustomItemComponentWrapper, {
        itemIsDisabled: itemIsDisabled,
        customRenderItem: customRenderItem,
        isSelected: isSelected,
        ariaLabel: ariaLabel,
        itemsLength: itemsLength,
        customItemRef: customItemRef,
        insertSelectedItem: insertSelectedItem,
        itemIndex: itemIndex
    });
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        css: listItemClasses
    }, (descriptionText || shortcutText) && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6F6hl.default), {
        id: descriptionId
    }, descriptionText, " ", shortcutText), /*#__PURE__*/ (0, $9K4OG.jsx)((0, $56M4r.default), {
        onClick: insertSelectedItem,
        iconBefore: elementIcon,
        isSelected: isSelected,
        "aria-selected": isSelected,
        "aria-label": title,
        "aria-describedby": descriptionText || shortcutText ? descriptionId : undefined,
        "aria-setsize": itemsLength,
        "aria-posinset": itemIndex + 1,
        role: "option",
        ref: buttonItemRef,
        isDisabled: itemIsDisabled,
        testId: (0, $iu6m9.editorExperiment)('platform_synced_block', true) ? item.testId : undefined,
        // @ts-ignore
        css: listItemClasses
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        "aria-hidden": true
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: [
            $c41ea6b4bf428ac0$var$itemText
        ]
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $c41ea6b4bf428ac0$var$itemBody
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: [
            $c41ea6b4bf428ac0$var$itemTitle,
            moreElementsInQuickInsertViewEnabled && $c41ea6b4bf428ac0$var$itemTitleOverride,
            itemIsDisabled && $c41ea6b4bf428ac0$var$disabledStyle,
            item.lozenge && $c41ea6b4bf428ac0$var$titleWithLozengeStyle
        ]
    }, item.title, item.lozenge && /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        css: $c41ea6b4bf428ac0$var$lozengeWrapperStyle
    }, item.lozenge)), /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $c41ea6b4bf428ac0$var$itemAfter
    }, item.keyshortcut && /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: (0, $6f5RK.shortcutStyle)
    }, item.keyshortcut))), /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: [
            $c41ea6b4bf428ac0$var$itemDescription,
            moreElementsInQuickInsertViewEnabled && $c41ea6b4bf428ac0$var$itemDescriptionOverride,
            itemIsDisabled && $c41ea6b4bf428ac0$var$disabledStyle
        ]
    }, item.description))))));
});


const $f7806da2d8ba3649$var$LIST_ITEM_ESTIMATED_HEIGHT = 64;
const $f7806da2d8ba3649$var$LIST_WIDTH = 320;
const $f7806da2d8ba3649$var$list = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    button: {
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-150, 12px)"}`
    }
});
const $f7806da2d8ba3649$export$8db52dab09acd16e = ({ itemsLength: itemsLength, sections: sections })=>{
    if (sections.length === 0) return Array.from({
        length: itemsLength
    }, (_, itemIndex)=>({
            type: 'item',
            itemIndex: itemIndex
        }));
    const sortedSections = [
        ...sections
    ].sort((left, right)=>left.startIndex - right.startIndex);
    const sectionsByStartIndex = new Map(sortedSections.map((section)=>[
            section.startIndex,
            section
        ]));
    const rows = [];
    for(let itemIndex = 0; itemIndex < itemsLength; itemIndex++){
        const section = sectionsByStartIndex.get(itemIndex);
        if (section) rows.push({
            type: 'section',
            section: section
        });
        rows.push({
            type: 'item',
            itemIndex: itemIndex
        });
    }
    return rows;
};
const $f7806da2d8ba3649$var$TypeaheadAssistiveTextPureComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ numberOfResults: numberOfResults })=>{
    const intl = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $5KVL8.AssistiveText), {
        assistiveText: intl.formatMessage((0, $6h7hA.typeAheadListMessages).searchResultsLabel, {
            itemsLength: numberOfResults
        }),
        // when the popup is open its always in focus
        isInFocus: true,
        id: (0, $19ce93ae9f28b9e5$export$a38374e9651d6165) + '__popup'
    });
});
const $f7806da2d8ba3649$var$TypeAheadListComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ items: items, sections: sections, emptyItem: emptyItem, selectedIndex: selectedIndex, editorView: editorView, onItemClick: onItemClick, intl: intl, fitHeight: fitHeight, decorationElement: decorationElement, triggerHandler: triggerHandler, moreElementsInQuickInsertViewEnabled: moreElementsInQuickInsertViewEnabled, api: api, showMoreOptionsButton: showMoreOptionsButton, onMoreOptionsClicked: onMoreOptionsClicked })=>{
    const listRef = (0, $42omo.useRef)();
    const listContainerRef = (0, $42omo.useRef)(null);
    const lastInputMethodRef = (0, $42omo.useRef)('keyboard');
    const mouseMovedRef = (0, $42omo.useRef)(false);
    const lastVisibleIndexes = (0, $42omo.useRef)({
        overscanStartIndex: 0,
        overscanStopIndex: 0,
        startIndex: 0,
        stopIndex: 0
    });
    // Exclude view more item from the count
    const itemsLength = showMoreOptionsButton ? Math.max(items.length - 1, 0) : items.length;
    const isEmptyStateActive = (0, $1oCLl.expValEquals)('platform_editor_insert_menu_ai', 'isEnabled', true) && !!emptyItem && itemsLength === 1 && items[0] === emptyItem;
    const estimatedHeight = itemsLength * $f7806da2d8ba3649$var$LIST_ITEM_ESTIMATED_HEIGHT;
    const [height, setHeight] = (0, $42omo.useState)(Math.min(estimatedHeight, fitHeight));
    const [cache, setCache] = (0, $42omo.useState)(new (0, $cLwe6.CellMeasurerCache)({
        fixedWidth: true,
        defaultHeight: $f7806da2d8ba3649$var$LIST_ITEM_ESTIMATED_HEIGHT
    }));
    const listRows = (0, $42omo.useMemo)(()=>$f7806da2d8ba3649$export$8db52dab09acd16e({
            itemsLength: itemsLength,
            sections: sections || []
        }), [
        itemsLength,
        sections
    ]);
    const itemRowIndexByItemIndex = (0, $42omo.useMemo)(()=>{
        const rowIndexByItemIndex = new Map();
        listRows.forEach((row, rowIndex)=>{
            if (row.type === 'item') rowIndexByItemIndex.set(row.itemIndex, rowIndex);
        });
        return rowIndexByItemIndex;
    }, [
        listRows
    ]);
    const selectedItemRowIndex = selectedIndex >= 0 ? itemRowIndexByItemIndex.get(selectedIndex) ?? -1 : -1;
    const populatedSectionCount = (0, $42omo.useMemo)(()=>listRows.filter((row)=>row.type === 'section').length, [
        listRows
    ]);
    const onItemsRendered = (0, $42omo.useCallback)((props)=>{
        lastVisibleIndexes.current = props;
    }, []);
    const actions = (0, $42omo.useMemo)(()=>({
            onItemClick: onItemClick
        }), [
        onItemClick
    ]);
    const isNavigationKey = (event)=>{
        return [
            'ArrowDown',
            'ArrowUp',
            'Tab',
            'Enter',
            'Shift'
        ].includes(event.key);
    };
    const focusTargetElement = (0, $42omo.useCallback)(()=>{
        //To reset the selected index
        (0, $0f316b3f53d4dc77$export$9993709486a96a6b)(-1, api)(editorView.state, editorView.dispatch);
        listRef.current.scrollToRow(0);
        decorationElement?.querySelector(`[role='combobox']`)?.focus();
    }, [
        editorView,
        listRef,
        decorationElement,
        api
    ]);
    const selectNextItem = (0, $42omo.useMemo)(()=>(0, $1f77393088ff3949$export$f985e98ceae7c8f6)({
            editorView: editorView,
            direction: 'next',
            api: api
        }), [
        editorView,
        api
    ]);
    const selectPreviousItem = (0, $42omo.useMemo)(()=>(0, $1f77393088ff3949$export$f985e98ceae7c8f6)({
            editorView: editorView,
            direction: 'previous',
            api: api
        }), [
        editorView,
        api
    ]);
    const lastVisibleStartIndex = lastVisibleIndexes.current.startIndex;
    const lastVisibleStopIndex = lastVisibleIndexes.current.stopIndex;
    const onScroll = (0, $42omo.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ({ scrollUpdateWasRequested: scrollUpdateWasRequested })=>{
        if (!scrollUpdateWasRequested) return;
        // In case the user scroll to a non-visible item like press ArrowUp from the first index
        // We will force the scroll calling the scrollToItem in the useEffect hook
        // When the scroll happens and we render the elements,
        // we still need calculate the items height and re-draw the List.
        // It is possible the item selected became invisible again (because the items height changed)
        // So, we need to wait for height to be calculated. Then we need to check
        // if the selected item is visible or not. If it isn't visible we call the scrollToItem again.
        //
        // We can't do this check in the first frame because that frame is being used by the resetScreenThrottled
        // to calculate each height. THen, we can schedule a new frame when this one finishs.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                const isViewMoreSelected = showMoreOptionsButton && selectedIndex === itemsLength;
                const isSelectedItemVisible = selectedItemRowIndex >= lastVisibleStartIndex && selectedItemRowIndex <= lastVisibleStopIndex || // view more is always visible, hence no scrolling
                isViewMoreSelected;
                //Should scroll to the list item only when the selectedIndex >= 0 and item is not visible
                if (!isSelectedItemVisible && selectedIndex !== -1) listRef.current.scrollToRow(selectedItemRowIndex);
                else if (selectedIndex === -1) listRef.current.scrollToRow(0);
            });
        });
    }, [
        selectedIndex,
        lastVisibleStartIndex,
        lastVisibleStopIndex,
        itemsLength,
        showMoreOptionsButton,
        selectedItemRowIndex
    ]);
    const onMouseMove = (event, row)=>{
        if (row.type !== 'item') return;
        const itemIndex = row.itemIndex;
        event.preventDefault();
        event.stopPropagation();
        if (selectedIndex === itemIndex) return;
        mouseMovedRef.current = true;
        lastInputMethodRef.current = 'mouse';
        (0, $0f316b3f53d4dc77$export$9993709486a96a6b)(itemIndex, api)(editorView.state, editorView.dispatch);
    };
    (0, $42omo.useLayoutEffect)(()=>{
        if (mouseMovedRef.current) mouseMovedRef.current = false;
        else lastInputMethodRef.current = 'keyboard';
    }, [
        selectedIndex
    ]);
    (0, $42omo.useLayoutEffect)(()=>{
        if (!listRef.current) return;
        const isViewMoreSelected = showMoreOptionsButton && selectedIndex === itemsLength;
        const isSelectedItemVisible = selectedItemRowIndex >= lastVisibleStartIndex && selectedItemRowIndex <= lastVisibleStopIndex || // view more is always visible, hence no scrolling
        isViewMoreSelected;
        //Should scroll to the list item only when the selectedIndex >= 0 and item is not visible
        if (!isSelectedItemVisible && selectedIndex !== -1) listRef.current.scrollToRow(selectedItemRowIndex);
        else if (selectedIndex === -1) listRef.current.scrollToRow(0);
    }, [
        selectedIndex,
        lastVisibleStartIndex,
        lastVisibleStopIndex,
        itemsLength,
        showMoreOptionsButton,
        selectedItemRowIndex
    ]);
    (0, $42omo.useLayoutEffect)(()=>{
        setCache(new (0, $cLwe6.CellMeasurerCache)({
            fixedWidth: true,
            defaultHeight: $f7806da2d8ba3649$var$LIST_ITEM_ESTIMATED_HEIGHT
        }));
        // When query is updated, sometimes the scroll position of the menu is not at the top
        // Scrolling back to top for consistency
        requestAnimationFrame(()=>{
            if (listContainerRef.current?.firstChild) // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            listContainerRef.current.firstChild.scrollTo(0, 0);
        });
    }, [
        items,
        sections
    ]);
    (0, $42omo.useLayoutEffect)(()=>{
        // Exclude view more item from the count
        const itemsToRender = (0, $iu6m9.editorExperiment)('platform_editor_agent_mentions', true) ? listRows : showMoreOptionsButton ? items.slice(0, -1) : items;
        const height = Math.min(// eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
        itemsToRender.reduce((prevValue, currentValue, index)=>{
            return prevValue + cache.rowHeight({
                index: index
            });
        }, 0), fitHeight);
        setHeight(height);
    }, [
        listRows,
        items,
        cache,
        fitHeight,
        showMoreOptionsButton
    ]);
    (0, $42omo.useLayoutEffect)(()=>{
        if (!listContainerRef.current) return;
        const { current: element } = listContainerRef;
        /**
     * To handle the key events on the list
     * @param event
     * @example
     */ const handleKeyDown = (event)=>{
            if (isNavigationKey(event)) {
                lastInputMethodRef.current = 'keyboard';
                switch(event.key){
                    case 'ArrowDown':
                        selectNextItem();
                        event.preventDefault();
                        event.stopPropagation();
                        break;
                    case 'ArrowUp':
                        selectPreviousItem();
                        event.preventDefault();
                        event.stopPropagation();
                        break;
                    case 'Tab':
                        event.shiftKey ? selectPreviousItem() : selectNextItem();
                        event.preventDefault();
                        break;
                    case 'Enter':
                        //Enter key quick inserts the selected item.
                        if (!event.isComposing || event.which !== 229 && event.keyCode !== 229) {
                            onItemClick(event.shiftKey ? (0, $lOELb.SelectItemMode).SHIFT_ENTER : (0, $lOELb.SelectItemMode).ENTER, selectedIndex, (0, $d925B.INPUT_METHOD).KEYBOARD);
                            event.preventDefault();
                        }
                        break;
                    default:
                        event.preventDefault();
                }
            } else //All the remaining keys sets focus on the typeahead query(inputQuery.tsx))
            focusTargetElement();
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element?.addEventListener('keydown', handleKeyDown);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element?.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        editorView.state,
        focusTargetElement,
        selectNextItem,
        selectPreviousItem,
        selectedIndex,
        onItemClick,
        itemsLength
    ]);
    const firstOnlineSupportedRow = (0, $42omo.useMemo)(()=>{
        return items.findIndex((item)=>item.isDisabledOffline !== true);
    }, [
        items
    ]);
    const config = triggerHandler?.getMoreOptionsButtonConfig?.(intl);
    const handleClick = ()=>{
        if (onMoreOptionsClicked) onMoreOptionsClicked();
        api?.core.actions.execute(({ tr: tr })=>{
            (0, $4564a5865115acc6$export$daba40574d0568e3)(tr);
            config?.onClick({
                tr: tr
            });
            return tr;
        });
    };
    const renderRow = ({ index: index, key: key, style: style, parent: parent, isScrolling: isScrolling, isVisible: isVisible })=>{
        const currentRow = listRows[index];
        if (!currentRow) return null;
        const shouldHideSingleSectionTitle = currentRow.type === 'section' && populatedSectionCount === 1 && !currentRow.section.showTitleWhenOnlySection;
        return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $cLwe6.CellMeasurer), {
            key: key,
            cache: cache,
            parent: parent,
            columnIndex: 0,
            rowIndex: index
        }, ({ measure: measure })=>/*#__PURE__*/ (0, $9K4OG.jsx)((0, $79039aba281e4c8c$export$c36f87108246a02a), {
                measure: measure,
                index: index,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                style: style,
                isVisible: isVisible,
                isScrolling: isScrolling,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                onMouseMove: (e)=>onMouseMove(e, currentRow)
            }, currentRow.type === 'section' ? // Preserve the existing collapsed-title behaviour for single-section results unless
            // the gated section title API explicitly asks for the title to remain visible.
            shouldHideSingleSectionTitle ? null : /*#__PURE__*/ (0, $9K4OG.jsx)((0, $gdv5Z.default), {
                paddingInline: "space.150",
                paddingBlock: "space.050"
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $iXCQx.default), {
                as: "span",
                size: "small",
                color: "color.text.subtle",
                weight: "medium"
            }, currentRow.section.title)) : /*#__PURE__*/ (0, $9K4OG.jsx)((0, $c41ea6b4bf428ac0$export$913373331e95c13e), {
                key: items[currentRow.itemIndex].title,
                item: items[currentRow.itemIndex],
                firstOnlineSupportedIndex: firstOnlineSupportedRow,
                itemsLength: itemsLength,
                itemIndex: currentRow.itemIndex,
                selectedIndex: selectedIndex,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                onItemClick: (mode, itemIndex)=>{
                    actions.onItemClick(mode, itemIndex, (0, $d925B.INPUT_METHOD).MOUSE);
                },
                ariaLabel: (0, $1f77393088ff3949$export$19cacaa810ba988a)(triggerHandler?.trigger, intl, items[currentRow.itemIndex]).listItemAriaLabel,
                moreElementsInQuickInsertViewEnabled: moreElementsInQuickInsertViewEnabled,
                api: api,
                lastInputMethodRef: lastInputMethodRef
            })));
    };
    const popupAriaLabel = (0, $1f77393088ff3949$export$19cacaa810ba988a)(triggerHandler?.trigger, intl).popupAriaLabel;
    if (!Array.isArray(items)) return null;
    const menuGroupId = decorationElement.querySelector(`[role='combobox']`)?.getAttribute('aria-controls') || (0, $19ce93ae9f28b9e5$export$a38374e9651d6165);
    const EmptyResultView = /*#__PURE__*/ (0, $9K4OG.jsx)((0, $gdv5Z.default), {
        paddingBlock: "space.150",
        paddingInline: "space.250"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $iXCQx.default), {
        align: "center",
        as: "p"
    }, intl.formatMessage((0, $6h7hA.typeAheadListMessages).emptySearchResults)), /*#__PURE__*/ (0, $9K4OG.jsx)((0, $iXCQx.default), {
        align: "center",
        as: "p"
    }, intl.formatMessage((0, $1oCLl.expValEquals)('platform_editor_insert_menu_ai', 'isEnabled', true) ? showMoreOptionsButton ? (0, $6h7hA.typeAheadListMessages).emptySearchResultsSuggestionNew : (0, $6h7hA.typeAheadListMessages).emptySearchResultsSuggestionAskRovoOnly : (0, $6h7hA.typeAheadListMessages).emptySearchResultsSuggestion, {
        askRovoName: /*#__PURE__*/ (0, $9K4OG.jsx)((0, $iXCQx.default), {
            weight: "medium"
        }, intl.formatMessage((0, $4HWgE.toolbarInsertBlockMessages).askRovo)),
        buttonName: /*#__PURE__*/ (0, $9K4OG.jsx)((0, $iXCQx.default), {
            weight: "medium"
        }, intl.formatMessage((0, $4HWgE.toolbarInsertBlockMessages).viewMore))
    })));
    const ListContent = /*#__PURE__*/ (0, $9K4OG.jsx)((0, $lG3Ww.List), {
        rowRenderer: renderRow,
        ref: listRef,
        // Skip rendering the view more button in the list
        rowCount: listRows.length,
        rowHeight: cache.rowHeight,
        onRowsRendered: onItemsRendered,
        width: $f7806da2d8ba3649$var$LIST_WIDTH,
        onScroll: onScroll,
        height: height,
        overscanRowCount: 3,
        "aria-label": (0, $1f77393088ff3949$export$19cacaa810ba988a)(undefined, intl).popupAriaLabel,
        containerRole: "presentation",
        role: "listbox",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        css: [
            /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $9K4OG.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
                button: {
                    padding: `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-150, 12px)"} 11px`,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                    'span:last-child span:last-child': {
                        whiteSpace: 'normal'
                    }
                }
            }),
            moreElementsInQuickInsertViewEnabled && $f7806da2d8ba3649$var$list
        ]
    });
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $2SlZp.default), {
        "aria-label": popupAriaLabel,
        "aria-relevant": "additions removals"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        id: menuGroupId,
        ref: listContainerRef,
        "data-vc": "OLcUNcOM"
    }, isEmptyStateActive && EmptyResultView, isEmptyStateActive ? ListContent : !showMoreOptionsButton || itemsLength ? ListContent : EmptyResultView, showMoreOptionsButton && config && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $2e81f1e274001535$export$76421314069e32e1), {
        title: config.title,
        ariaLabel: config.ariaLabel,
        onClick: handleClick,
        isFocused: selectedIndex === itemsLength,
        iconBefore: config.iconBefore,
        lastInputMethodRef: lastInputMethodRef
    }), /*#__PURE__*/ (0, $9K4OG.jsx)($f7806da2d8ba3649$var$TypeaheadAssistiveTextPureComponent, {
        numberOfResults: itemsLength.toString()
    })));
});
const $f7806da2d8ba3649$export$81b66b5b19964713 = (0, $aXWIB.injectIntl)($f7806da2d8ba3649$var$TypeAheadListComponent);
$f7806da2d8ba3649$export$81b66b5b19964713.displayName = 'TypeAheadList';


function $68b14c4952aab248$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $68b14c4952aab248$var$DEFAULT_TYPEAHEAD_MENU_HEIGHT = 380;
const $68b14c4952aab248$var$VIEWMORE_BUTTON_HEIGHT = 53;
const $68b14c4952aab248$var$DEFAULT_TYPEAHEAD_MENU_HEIGHT_NEW = 480;
const $68b14c4952aab248$var$ITEM_PADDING = 12;
const $68b14c4952aab248$var$typeAheadContent = /*#__PURE__*/ (0, $9K4OG.css)({
    background: "var(--ds-surface-overlay, #FFFFFF)",
    borderRadius: "var(--ds-radius-small, 3px)",
    boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)",
    padding: `${"var(--ds-space-050, 4px)"} 0`,
    width: '320px',
    maxHeight: '380px' /* ~5.5 visibile items */ ,
    overflowY: 'auto',
    MsOverflowStyle: '-ms-autohiding-scrollbar',
    position: 'relative'
});
const $68b14c4952aab248$var$typeAheadContentOverride = /*#__PURE__*/ (0, $9K4OG.css)({
    maxHeight: `${$68b14c4952aab248$var$DEFAULT_TYPEAHEAD_MENU_HEIGHT_NEW}px`
});
const $68b14c4952aab248$var$typeAheadWrapperWithViewMoreOverride = {
    name: "1fttcpj",
    styles: "display:flex;flex-direction:column"
};
const $68b14c4952aab248$var$typeAheadContentOverrideBorder = {
    name: "1ghozw",
    styles: "border-radius:var(--ds-radius-large, 8px)"
};
const $68b14c4952aab248$var$Highlight = ({ state: state, triggerHandler: triggerHandler })=>{
    if (!triggerHandler?.getHighlight) return null;
    return triggerHandler.getHighlight(state);
};
const $68b14c4952aab248$var$OFFSET = [
    0,
    8
];
const $68b14c4952aab248$export$fbc0702507873a7d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((props)=>{
    const { editorView: editorView, triggerHandler: triggerHandler, anchorElement: anchorElement, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, items: items, sections: sections = [], emptyItem: emptyItem, errorInfo: errorInfo, selectedIndex: selectedIndex, onItemInsert: onItemInsert, isEmptyQuery: isEmptyQuery, cancel: cancel, api: api, showMoreOptionsButton: showMoreOptionsButton } = props;
    const ref = (0, $42omo.useRef)(null);
    const { moreElementsInQuickInsertView: moreElementsInQuickInsertView } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'featureFlags'
    ], (states)=>({
            moreElementsInQuickInsertView: states.featureFlagsState?.moreElementsInQuickInsertView
        }));
    const moreElementsInQuickInsertViewEnabled = moreElementsInQuickInsertView && triggerHandler.id === (0, $lOELb.TypeAheadAvailableNodes).QUICK_INSERT;
    const isEditorControlsEnabled = (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1');
    const defaultMenuHeight = (0, $42omo.useMemo)(()=>moreElementsInQuickInsertViewEnabled ? $68b14c4952aab248$var$DEFAULT_TYPEAHEAD_MENU_HEIGHT_NEW : $68b14c4952aab248$var$DEFAULT_TYPEAHEAD_MENU_HEIGHT, [
        moreElementsInQuickInsertViewEnabled
    ]);
    const activityStateRef = (0, $42omo.useRef)({
        inputMethod: null,
        closeAction: null,
        invocationMethod: (0, $1f77393088ff3949$export$f05434c51e3762e)(editorView.state)?.inputMethod
    });
    const startTime = (0, $42omo.useMemo)(()=>performance.now(), // In case those props changes
    // we need to recreate the startTime
    [
        items,
        isEmptyQuery,
        triggerHandler
    ] // eslint-disable-line react-hooks/exhaustive-deps
    );
    (0, $42omo.useEffect)(()=>{
        if (!api?.analytics?.actions?.fireAnalyticsEvent) return;
        const stopTime = performance.now();
        const time = stopTime - startTime;
        // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        (0, $c6GJD.default).getExperimentValue('cc_fd_db_quick_insert_options', 'isEnabled', false);
        api?.analytics?.actions?.fireAnalyticsEvent({
            action: (0, $d925B.ACTION).RENDERED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).TYPEAHEAD,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: {
                time: time,
                items: items.length,
                initial: isEmptyQuery
            }
        });
    }, [
        startTime,
        items,
        isEmptyQuery,
        // In case the current triggerHandler changes
        // e.g: Inserting a mention using the quick insert
        // we need to send the event again
        // eslint-disable-next-line react-hooks/exhaustive-deps
        triggerHandler,
        api
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!api?.analytics?.actions?.fireAnalyticsEvent) return;
        api?.analytics?.actions?.fireAnalyticsEvent({
            action: (0, $d925B.ACTION).VIEWED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).TYPEAHEAD_ITEM,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: {
                index: selectedIndex,
                items: items.length
            }
        });
    }, [
        items,
        api,
        selectedIndex,
        // In case the current triggerHandler changes
        // e.g: Inserting a mention using the quick insert
        // we need to send the event again
        // eslint-disable-next-line react-hooks/exhaustive-deps
        triggerHandler
    ]);
    const [fitHeight, setFitHeight] = (0, $42omo.useState)(defaultMenuHeight);
    const fitHeightWithViewMore = (0, $42omo.useMemo)(()=>{
        if (showMoreOptionsButton) return fitHeight - $68b14c4952aab248$var$VIEWMORE_BUTTON_HEIGHT;
        return fitHeight;
    }, [
        fitHeight,
        showMoreOptionsButton
    ]);
    const getFitHeight = (0, $42omo.useCallback)(()=>{
        if (!anchorElement || !popupsMountPoint) return;
        const target = anchorElement;
        const { top: targetTop, height: targetHeight } = target.getBoundingClientRect();
        const boundariesElement = popupsBoundariesElement || document.body;
        const { height: boundariesHeight, top: boundariesTop } = boundariesElement.getBoundingClientRect();
        // Calculating the space above and space below our decoration
        const spaceAbove = targetTop - (boundariesTop - boundariesElement.scrollTop);
        const spaceBelow = boundariesTop + boundariesHeight - (targetTop + targetHeight);
        // Keep default height if more than enough space
        if (spaceBelow >= defaultMenuHeight) return setFitHeight(defaultMenuHeight);
        // Determines whether typeahead will fit above or below decoration
        // and return the space available.
        const newFitHeight = spaceBelow >= spaceAbove ? spaceBelow : spaceAbove;
        // Each typeahead item has some padding
        // We want to leave some space at the top so first item
        // is not partially cropped
        const fitHeightWithSpace = newFitHeight - $68b14c4952aab248$var$ITEM_PADDING * 2;
        // Ensure typeahead height is max its default height
        const minFitHeight = Math.min(defaultMenuHeight, fitHeightWithSpace);
        return setFitHeight(minFitHeight);
    }, [
        anchorElement,
        defaultMenuHeight,
        popupsBoundariesElement,
        popupsMountPoint
    ]);
    const getFitHeightDebounced = (0, $2P8Ax.default)(getFitHeight);
    (0, $42omo.useLayoutEffect)(()=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const scrollableElement = popupsScrollableElement || (0, $7YjFd.findOverflowScrollParent)(anchorElement);
        getFitHeight();
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.addEventListener('resize', getFitHeightDebounced);
        if (scrollableElement) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        scrollableElement.addEventListener('scroll', getFitHeightDebounced);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.removeEventListener('resize', getFitHeightDebounced);
            if (scrollableElement) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            scrollableElement.removeEventListener('scroll', getFitHeightDebounced);
        };
    }, [
        anchorElement,
        popupsScrollableElement,
        getFitHeightDebounced,
        getFitHeight
    ]);
    (0, $42omo.useLayoutEffect)(()=>{
        const { removePrefixTriggerOnCancel: removePrefixTriggerOnCancel } = (0, $1f77393088ff3949$export$f05434c51e3762e)(editorView.state) || {};
        const focusOut = (event)=>{
            const { relatedTarget: relatedTarget } = event;
            // Given the user is changing the focus
            // When the target is inside the TypeAhead Popup
            // Then the popup should stay open
            if (relatedTarget instanceof HTMLElement && relatedTarget.closest && (relatedTarget.closest(`.${(0, $19ce93ae9f28b9e5$export$a5cdf6890cae94d6)}`) || relatedTarget.closest(`[data-type-ahead="${(0, $19ce93ae9f28b9e5$export$be8a8259777b339f)}"]`))) return;
            // Handles cases like emoji (:) and mention (@) typeaheads that open new typeaheads
            const isTextSelected = window.getSelection()?.type === 'Range';
            const innerEditor = anchorElement.closest('.extension-editable-area');
            if (innerEditor) {
                // When there is no related target, we default to not closing the popup
                let newFocusInsideCurrentEditor = !relatedTarget;
                if (relatedTarget instanceof HTMLElement) // check if the new focus is inside inner editor, keep popup opens
                newFocusInsideCurrentEditor = innerEditor.contains(relatedTarget);
                if (!isTextSelected && newFocusInsideCurrentEditor) return;
            } else {
                // if the current focus in outer editor, keep the existing behaviour, do not close the pop up if text is not selected
                if (!isTextSelected) return;
            }
            cancel({
                addPrefixTrigger: isEditorControlsEnabled ? !removePrefixTriggerOnCancel : true,
                setSelectionAt: (0, $19ce93ae9f28b9e5$export$fc2dc87cf13c1ab1).AFTER_TEXT_INSERTED,
                forceFocusOnEditor: false
            });
        };
        const { current: element } = ref;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element?.addEventListener('focusout', focusOut);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element?.removeEventListener('focusout', focusOut);
        };
    }, [
        ref,
        cancel,
        editorView.state,
        isEditorControlsEnabled,
        anchorElement
    ]);
    // TODO: ED-17443 - When you press escape on typeahead panel, it should remove focus and close the panel
    // This is the expected keyboard behaviour advised by the Accessibility team
    (0, $42omo.useLayoutEffect)(()=>{
        const { removePrefixTriggerOnCancel: removePrefixTriggerOnCancel } = (0, $1f77393088ff3949$export$f05434c51e3762e)(editorView.state) || {};
        const escape = (event)=>{
            if (event.key === 'Escape') {
                activityStateRef.current.inputMethod = (0, $d925B.INPUT_METHOD).KEYBOARD;
                cancel({
                    addPrefixTrigger: isEditorControlsEnabled ? !removePrefixTriggerOnCancel : true,
                    setSelectionAt: (0, $19ce93ae9f28b9e5$export$fc2dc87cf13c1ab1).AFTER_TEXT_INSERTED,
                    forceFocusOnEditor: true
                });
            }
        };
        const { current: element } = ref;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element?.addEventListener('keydown', escape);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element?.removeEventListener('keydown', escape);
        };
    }, [
        ref,
        cancel,
        editorView.state,
        isEditorControlsEnabled
    ]);
    // @ts-ignore
    const openElementBrowserModal = triggerHandler?.openElementBrowserModal;
    const onMoreOptionsClicked = (0, $42omo.useCallback)(()=>{
        if (// eslint-disable-next-line @atlaskit/platform/no-preconditioning
        openElementBrowserModal && (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') && triggerHandler.id === (0, $lOELb.TypeAheadAvailableNodes).QUICK_INSERT) activityStateRef.current = {
            inputMethod: (0, $d925B.INPUT_METHOD).MOUSE,
            closeAction: (0, $d925B.ACTION).VIEW_MORE,
            invocationMethod: activityStateRef.current.invocationMethod
        };
    }, [
        openElementBrowserModal,
        triggerHandler.id
    ]);
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $jwWgu.default), {
        zIndex: (0, $aFUXX.akEditorFloatingDialogZIndex),
        target: anchorElement,
        mountTo: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        fitHeight: fitHeight,
        fitWidth: 340,
        offset: $68b14c4952aab248$var$OFFSET,
        ariaLabel: null,
        preventOverflow: true,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onUnmount: ()=>{
            if (selectedIndex > -1 && (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) {
                // if selectedIndex is -1, it means that the user has not selected any item
                // will be handled by WrapperTypeAhead
                (0, $5f46f7bb5d602e59$export$4a6068dadc2c7771)(api, activityStateRef.current.closeAction || (0, $d925B.ACTION).CANCELLED, !isEmptyQuery, activityStateRef.current.inputMethod || (0, $d925B.INPUT_METHOD).MOUSE, activityStateRef.current.invocationMethod);
                // reset activity state
                activityStateRef.current = {
                    inputMethod: null,
                    closeAction: null,
                    invocationMethod: null
                };
            }
        }
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: [
            $68b14c4952aab248$var$typeAheadContent,
            moreElementsInQuickInsertViewEnabled && $68b14c4952aab248$var$typeAheadContentOverride,
            showMoreOptionsButton && $68b14c4952aab248$var$typeAheadWrapperWithViewMoreOverride,
            (0, $1oCLl.expValEquals)('cc-markdown-mode', 'isEnabled', true) && $68b14c4952aab248$var$typeAheadContentOverrideBorder
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $19ce93ae9f28b9e5$export$a5cdf6890cae94d6),
        ref: ref,
        "data-vc": "2h3v49pl"
    }, errorInfo ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, $ccd58d8d5c473a54$export$71ea07f9d4f4ab38), null) : /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, $9K4OG.jsx)($68b14c4952aab248$var$Highlight, {
        state: editorView.state,
        triggerHandler: triggerHandler
    }), /*#__PURE__*/ (0, $9K4OG.jsx)((0, $f7806da2d8ba3649$export$81b66b5b19964713), {
        items: items,
        sections: sections,
        emptyItem: emptyItem,
        selectedIndex: selectedIndex,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onItemClick: (mode, index, inputMethod)=>{
            if ((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) activityStateRef.current = {
                inputMethod: inputMethod || null,
                closeAction: (0, $d925B.ACTION).INSERTED,
                invocationMethod: activityStateRef.current.invocationMethod
            };
            onItemInsert(mode, index);
        },
        fitHeight: fitHeightWithViewMore,
        editorView: editorView,
        decorationElement: anchorElement,
        triggerHandler: triggerHandler,
        moreElementsInQuickInsertViewEnabled: moreElementsInQuickInsertViewEnabled,
        api: api,
        showMoreOptionsButton: showMoreOptionsButton,
        onMoreOptionsClicked: onMoreOptionsClicked
    }))));
});
$68b14c4952aab248$export$fbc0702507873a7d.displayName = 'TypeAheadPopup';


const $fa9fa9738d9c6c55$export$b11addef9209139 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ editorView: editorView, popupMountRef: popupMountRef, typeAheadState: typeAheadState, selectedIndex: selectedIndex, api: api })=>{
    const isOpen = typeAheadState.decorationSet.find().length > 0;
    const { triggerHandler: triggerHandler, items: items, sections: sections = [], errorInfo: errorInfo, decorationElement: decorationElement, decorationSet: decorationSet, query: query } = typeAheadState;
    const [onItemInsert, onTextInsert, onItemMatch] = (0, $3bcc5e104a830047$export$3a3385069392b26f)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    triggerHandler, editorView, items, api);
    const setSelectedItem = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback(({ index: nextIndex })=>{
        queueMicrotask(()=>{
            (0, $0f316b3f53d4dc77$export$9993709486a96a6b)(nextIndex, api)(editorView.state, editorView.dispatch);
        });
    }, [
        editorView,
        api
    ]);
    const insertItem = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((mode = (0, $lOELb.SelectItemMode).SELECTED, index)=>{
        queueMicrotask(()=>{
            onItemInsert({
                mode: mode,
                index: index,
                query: query
            });
        });
    }, [
        onItemInsert,
        query
    ]);
    const cancel = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback(({ setSelectionAt: setSelectionAt, addPrefixTrigger: addPrefixTrigger, forceFocusOnEditor: forceFocusOnEditor })=>{
        const fullQuery = addPrefixTrigger ? `${triggerHandler?.trigger}${query}` : query;
        onTextInsert({
            forceFocusOnEditor: forceFocusOnEditor,
            setSelectionAt: setSelectionAt,
            text: fullQuery
        });
    }, [
        triggerHandler,
        onTextInsert,
        query
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        if (!isOpen || !query) return;
        const isLastCharSpace = query[query.length - 1] === ' ';
        if (!isLastCharSpace) return;
        const result = onItemMatch({
            mode: (0, $lOELb.SelectItemMode).SPACE,
            query: query.trim()
        });
        if (!result) return;
    }, [
        isOpen,
        query,
        onItemMatch
    ]);
    // @ts-ignore
    const openElementBrowserModal = triggerHandler?.openElementBrowserModal;
    let showMoreOptionsButton = false;
    if ((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) showMoreOptionsButton = !!triggerHandler?.getMoreOptionsButtonConfig;
    const emptyItem = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>(0, $1oCLl.expValEquals)('platform_editor_insert_menu_ai', 'isEnabled', true) ? triggerHandler?.getEmptyItem?.({
            editorState: editorView.state
        }) : undefined, [
        triggerHandler,
        editorView.state
    ]);
    if (!isOpen || !triggerHandler || !(decorationElement instanceof HTMLElement) || !openElementBrowserModal && items.length === 0 && !errorInfo && !emptyItem) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $68b14c4952aab248$export$fbc0702507873a7d), {
        editorView: editorView,
        popupsMountPoint: popupMountRef.current?.popupsMountPoint,
        popupsBoundariesElement: popupMountRef.current?.popupsBoundariesElement,
        popupsScrollableElement: popupMountRef.current?.popupsScrollableElement,
        anchorElement: decorationElement,
        triggerHandler: triggerHandler,
        items: items,
        sections: sections,
        emptyItem: emptyItem,
        errorInfo: errorInfo,
        selectedIndex: selectedIndex,
        setSelectedItem: setSelectedItem,
        onItemInsert: insertItem,
        decorationSet: decorationSet,
        isEmptyQuery: !query,
        cancel: cancel,
        api: api,
        showMoreOptionsButton: showMoreOptionsButton
    });
});


function $b6855f8bea4fa761$export$2dda1e4a1d1f6a81({ api: api, editorView: editorView, popupMountRef: popupMountRef }) {
    const { triggerHandler: triggerHandler, items: items, sections: sections, errorInfo: errorInfo, decorationElement: decorationElement, decorationSet: decorationSet, query: query, selectedIndex: selectedIndex } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'typeAhead'
    ], (states)=>({
            triggerHandler: states.typeAheadState?.triggerHandler,
            items: states.typeAheadState?.items,
            sections: states.typeAheadState?.sections,
            errorInfo: states.typeAheadState?.errorInfo,
            decorationElement: states.typeAheadState?.decorationElement,
            decorationSet: states.typeAheadState?.decorationSet,
            query: states.typeAheadState?.query,
            selectedIndex: states.typeAheadState?.selectedIndex
        }));
    if (items === undefined || sections === undefined || decorationSet === undefined || errorInfo === undefined || decorationElement === undefined || query === undefined || selectedIndex === undefined) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fa9fa9738d9c6c55$export$b11addef9209139), {
        editorView: editorView,
        popupMountRef: popupMountRef,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        typeAheadState: {
            triggerHandler: triggerHandler,
            items: items,
            sections: sections,
            errorInfo: errorInfo,
            decorationElement: decorationElement,
            decorationSet: decorationSet,
            query: query
        },
        selectedIndex: selectedIndex,
        api: api
    });
}


const $48cbe3da39eebf5f$var$createOpenAtTransaction = (editorAnalyticsAPI)=>(props)=>(tr)=>{
            const { triggerHandler: triggerHandler, inputMethod: inputMethod, query: query, removePrefixTriggerOnCancel: removePrefixTriggerOnCancel } = props;
            (0, $135f765001339810$export$e7ce737179b76875)({
                triggerHandler: triggerHandler,
                inputMethod: inputMethod,
                query: query,
                removePrefixTriggerOnCancel: removePrefixTriggerOnCancel
            })({
                tr: tr
            });
            // This function is called from the editor-plugin-emoji and editor-plugin-type-ahead
            // createOpenAtTransaction <- createOpenTypeAhead <- actions.open
            // 	<- emoji-plugin (Not used)
            //  <- type-ahead-plugin (Used)
            // and this caused the analytics event to be fired twice, as other places are relying on the
            // `onEditorViewStateUpdated` method to fire the analytics event
            // We want to disable this event
            if (!(0, $dh538.fg)('platform_editor_controls_patch_analytics_3')) editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $d925B.ACTION).INVOKED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TYPEAHEAD,
                actionSubjectId: triggerHandler.id,
                attributes: {
                    inputMethod: inputMethod
                },
                eventType: (0, $d925B.EVENT_TYPE).UI
            })(tr);
            return true;
        };
const $48cbe3da39eebf5f$var$createOpenTypeAhead = (editorViewRef, editorAnalyticsAPI)=>(props)=>{
        if (!editorViewRef.current) return false;
        const { current: view } = editorViewRef;
        const { tr: tr } = view.state;
        $48cbe3da39eebf5f$var$createOpenAtTransaction(editorAnalyticsAPI)(props)(tr);
        view.dispatch(tr);
        return true;
    };
const $48cbe3da39eebf5f$var$createInsertTypeAheadItem = (editorViewRef)=>(props)=>{
        if (!editorViewRef.current) return false;
        const { current: view } = editorViewRef;
        const { triggerHandler: triggerHandler, contentItem: contentItem, query: query, sourceListItem: sourceListItem, mode: mode } = props;
        (0, $841a4b69009bd58d$export$173ade35125a6637)(view)({
            handler: triggerHandler,
            item: contentItem,
            mode: mode || (0, $lOELb.SelectItemMode).SELECTED,
            query: query,
            sourceListItem: sourceListItem
        });
        return true;
    };
const $48cbe3da39eebf5f$var$createFindHandlerByTrigger = (editorViewRef)=>(trigger)=>{
        if (!editorViewRef.current) return null;
        const { current: view } = editorViewRef;
        return (0, $1f77393088ff3949$export$2bae95e359577df4)(trigger, view.state);
    };
const $48cbe3da39eebf5f$var$createUpdateSectionTitle = (editorViewRef)=>(props)=>{
        if (!editorViewRef.current) return false;
        const { current: view } = editorViewRef;
        return (0, $20f93bdfad7f6c7d$export$9edb4b0ea764e965)(props)(view.state, view.dispatch);
    };
const $48cbe3da39eebf5f$var$createCloseTypeAhead = (editorViewRef)=>(options)=>{
        if (!editorViewRef.current) return false;
        const { current: view } = editorViewRef;
        const currentQuery = (0, $1f77393088ff3949$export$7a55deb43cd1340e)(view.state) || '';
        const { state: state } = view;
        let tr = state.tr;
        if (options.attachCommand) {
            const fakeDispatch = (customTr)=>{
                tr = customTr;
            };
            options.attachCommand(state, fakeDispatch);
        }
        (0, $4564a5865115acc6$export$daba40574d0568e3)(tr);
        if (options.insertCurrentQueryAsRawText && currentQuery && currentQuery.length > 0) {
            const handler = (0, $1f77393088ff3949$export$c1eba975d6442029)(state);
            if (!handler) return false;
            const text = handler.trigger.concat(currentQuery);
            tr.replaceSelectionWith(state.schema.text(text));
        }
        view.dispatch(tr);
        if (!view.hasFocus()) view.focus();
        return true;
    };
const $48cbe3da39eebf5f$export$a023c922ef32b883 = ({ api: api })=>{
    const popupMountRef = {
        current: null
    };
    const editorViewRef = {
        current: null
    };
    return {
        name: 'typeAhead',
        marks () {
            // We need to keep this to make sure
            // All documents with typeahead marks will be loaded normally
            return [
                {
                    name: 'typeAheadQuery',
                    mark: (0, $lSP4W.typeAheadQuery)
                }
            ];
        },
        pmPlugins (typeAhead = []) {
            return [
                {
                    name: 'typeAhead',
                    plugin: ({ dispatch: dispatch, getIntl: getIntl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>(0, $4ef775772671161d$export$ae829ec7b2625219)({
                            getIntl: getIntl,
                            popupMountRef: popupMountRef,
                            reactDispatch: dispatch,
                            typeAheadHandlers: typeAhead,
                            nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
                            api: api
                        })
                },
                {
                    name: 'typeAheadEditorViewRef',
                    plugin: ()=>{
                        return new (0, $1S4f7.SafePlugin)({
                            view (view) {
                                editorViewRef.current = view;
                                return {
                                    destroy () {
                                        editorViewRef.current = null;
                                    }
                                };
                            }
                        });
                    }
                },
                {
                    name: 'typeAheadInsertItem',
                    plugin: (0, $2e6b2c9330b7fa69$export$ae829ec7b2625219)
                },
                {
                    name: 'typeAheadInputRule',
                    plugin: ({ schema: schema, featureFlags: featureFlags })=>(0, $80a11dc406606389$export$568a7ed6897c4817)(schema, typeAhead, featureFlags)
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return {
                query: '',
                isOpen: false,
                isAllowed: false,
                currentHandler: undefined,
                decorationSet: (0, $ftzrq.DecorationSet).empty,
                decorationElement: null,
                triggerHandler: undefined,
                items: [],
                sections: [],
                errorInfo: null,
                selectedIndex: 0
            };
            const isOpen = (0, $1f77393088ff3949$export$564dcc295d6ce147)(editorState);
            const state = (0, $1f77393088ff3949$export$f05434c51e3762e)(editorState);
            return {
                query: (0, $1f77393088ff3949$export$7a55deb43cd1340e)(editorState) || '',
                currentHandler: (0, $1f77393088ff3949$export$c1eba975d6442029)(editorState),
                isOpen: isOpen,
                isAllowed: !isOpen,
                decorationSet: state?.decorationSet ?? (0, $ftzrq.DecorationSet).empty,
                decorationElement: state?.decorationElement ?? null,
                triggerHandler: state?.triggerHandler,
                items: state?.items ?? [],
                sections: state?.sections ?? [],
                errorInfo: state?.errorInfo ?? null,
                selectedIndex: state?.selectedIndex ?? 0
            };
        },
        actions: {
            isOpen: (0, $1f77393088ff3949$export$564dcc295d6ce147),
            isAllowed: (0, $1f77393088ff3949$export$74b0f581633f8412),
            open: $48cbe3da39eebf5f$var$createOpenTypeAhead(editorViewRef, api?.analytics?.actions),
            openAtTransaction: $48cbe3da39eebf5f$var$createOpenAtTransaction(api?.analytics?.actions),
            findHandlerByTrigger: $48cbe3da39eebf5f$var$createFindHandlerByTrigger(editorViewRef),
            insert: $48cbe3da39eebf5f$var$createInsertTypeAheadItem(editorViewRef),
            close: $48cbe3da39eebf5f$var$createCloseTypeAhead(editorViewRef),
            updateSectionTitle: $48cbe3da39eebf5f$var$createUpdateSectionTitle(editorViewRef)
        },
        contentComponent ({ editorView: editorView, containerElement: containerElement, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, wrapperElement: wrapperElement }) {
            popupMountRef.current = {
                popupsMountPoint: popupsMountPoint || wrapperElement || undefined,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement || containerElement || undefined
            };
            if (!editorView) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b6855f8bea4fa761$export$2dda1e4a1d1f6a81), {
                editorView: editorView,
                popupMountRef: popupMountRef,
                api: api
            });
        },
        onEditorViewStateUpdated ({ originalTransaction: originalTransaction, oldEditorState: oldEditorState, newEditorState: newEditorState }) {
            const oldPluginState = (0, $1f77393088ff3949$export$f05434c51e3762e)(oldEditorState);
            const newPluginState = (0, $1f77393088ff3949$export$f05434c51e3762e)(newEditorState);
            if (!oldPluginState || !newPluginState) return;
            const { triggerHandler: oldTriggerHandler } = oldPluginState;
            const { triggerHandler: newTriggerHandler } = newPluginState;
            const isANewHandler = oldTriggerHandler !== newTriggerHandler;
            if (oldTriggerHandler?.dismiss && isANewHandler) {
                const typeAheadMessage = originalTransaction.getMeta((0, $6d2d39cb0dff555a$export$18d4026d1ea86bb1));
                const wasItemInserted = typeAheadMessage && typeAheadMessage.action === 'INSERT_RAW_QUERY';
                oldTriggerHandler.dismiss({
                    editorState: newEditorState,
                    query: oldPluginState.query,
                    stats: (oldPluginState.stats || new (0, $d4f0613799f34ef9$export$630efe5940bb4d41)()).serialize(),
                    wasItemInserted: wasItemInserted
                });
            }
            if (newTriggerHandler?.onOpen && isANewHandler) {
                if ((0, $dh538.fg)('platform_editor_ease_of_use_metrics')) api?.metrics?.commands.handleIntentToStartEdit({
                    shouldStartTimer: false,
                    shouldPersistActiveSession: true
                });
                newTriggerHandler.onOpen(newEditorState);
            }
            const oldIsOpen = (0, $1f77393088ff3949$export$564dcc295d6ce147)(oldEditorState);
            const newIsOpen = (0, $1f77393088ff3949$export$564dcc295d6ce147)(newEditorState);
            if (newTriggerHandler && isANewHandler) {
                // if the typeahead opens another typeahead via the quickInsert we do NOT want to fire this analytic event (mentions and emojis) as it is already being fired from editor-plugin-analytics
                const isDuplicateInvokedEvent = newPluginState.inputMethod === (0, $d925B.INPUT_METHOD).QUICK_INSERT && Object.values((0, $lOELb.TypeAheadAvailableNodes)).includes(newTriggerHandler.id);
                if (!isDuplicateInvokedEvent) {
                    if ((0, $dh538.fg)('platform_editor_controls_patch_analytics_3')) api?.analytics?.actions?.fireAnalyticsEvent({
                        action: (0, $d925B.ACTION).INVOKED,
                        actionSubject: (0, $d925B.ACTION_SUBJECT).TYPEAHEAD,
                        actionSubjectId: newTriggerHandler.id || 'not_set',
                        attributes: {
                            inputMethod: newPluginState.inputMethod || (0, $d925B.INPUT_METHOD).KEYBOARD
                        },
                        eventType: (0, $d925B.EVENT_TYPE).UI
                    }, undefined, {
                        context: {
                            selection: newEditorState.selection
                        }
                    });
                    else api?.analytics?.actions?.fireAnalyticsEvent({
                        action: (0, $d925B.ACTION).INVOKED,
                        actionSubject: (0, $d925B.ACTION_SUBJECT).TYPEAHEAD,
                        actionSubjectId: newTriggerHandler.id || 'not_set',
                        attributes: {
                            inputMethod: newPluginState.inputMethod || (0, $d925B.INPUT_METHOD).KEYBOARD
                        },
                        eventType: (0, $d925B.EVENT_TYPE).UI
                    });
                }
            } else if (oldIsOpen && !newIsOpen && (0, $dh538.fg)('platform_editor_ease_of_use_metrics')) api?.core.actions.execute(api?.metrics?.commands.startActiveSessionTimer());
        }
    };
};
module.exports["typeAheadPlugin"] = $48cbe3da39eebf5f$export$a023c922ef32b883;

});

parcelRegister("cuprm", function(module, exports) {

var $5SAOw = parcelRequire("5SAOw");


var $aXG5V = parcelRequire("aXG5V");

var $cO9ey = parcelRequire("cO9ey");

const $d6300abef4344420$export$2f0b0962a5993fe0 = 'atlaskit-insert-type-ahead';
var $d6300abef4344420$export$1b2be0bed116d664 = /*#__PURE__*/ function(InsertTypeAheadStages) {
    InsertTypeAheadStages["DELETING_RAW_QUERY"] = "DELETING_RAW_QUERY";
    InsertTypeAheadStages["INSERTING_ITEM"] = "INSERTING_ITEM";
    return InsertTypeAheadStages;
}({});
class $d6300abef4344420$export$5ca6d15deb246b5d extends (0, $cO9ey.Step) {
    invert() {
        const config = {
            stage: this.stage,
            query: this.query,
            trigger: this.trigger,
            selectedIndex: this.selectedIndex
        };
        return new $d6300abef4344420$export$5ca6d15deb246b5d(config, !this.isInvertStep);
    }
    apply(doc) {
        return (0, $aXG5V.StepResult).ok(doc);
    }
    merge() {
        return null;
    }
    isInsertionStep() {
        return !this.isInvertStep;
    }
    isUndoingStep() {
        return this.isInvertStep;
    }
    map() {
        const config = {
            stage: this.stage,
            query: this.query,
            trigger: this.trigger,
            selectedIndex: this.selectedIndex
        };
        // Return the same events, this step will never be removed
        return new $d6300abef4344420$export$5ca6d15deb246b5d(config, this.isInvertStep);
    }
    getMap() {
        return new (0, $aXG5V.StepMap)([
            0,
            0,
            0
        ]);
    }
    toJSON() {
        // When serialized we should create a noop Replace step
        return {
            stepType: 'replace',
            from: 0,
            to: 0
        };
    }
    static fromJSON() {
        // This is a "local custom step" once serialized
        // we need to transform it in a no-operation action
        return new (0, $aXG5V.ReplaceStep)(0, 0, (0, $5SAOw.Slice).empty);
    }
    constructor({ stage: stage, query: query, trigger: trigger, selectedIndex: selectedIndex }, isInvertStep = false){
        super();
        this.isInvertStep = void 0;
        this.selectedIndex = void 0;
        this.stage = void 0;
        this.query = void 0;
        this.trigger = void 0;
        this.isInvertStep = isInvertStep;
        this.stage = stage;
        this.query = query;
        this.trigger = trigger;
        this.selectedIndex = selectedIndex;
    }
}
/** Register this step with Prosemirror */ (0, $cO9ey.Step).jsonID($d6300abef4344420$export$2f0b0962a5993fe0, $d6300abef4344420$export$5ca6d15deb246b5d);
module.exports["InsertTypeAheadStages"] = $d6300abef4344420$export$1b2be0bed116d664;
module.exports["InsertTypeAheadStep"] = $d6300abef4344420$export$5ca6d15deb246b5d;

});

parcelRegister("5KVL8", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $jSnXV = parcelRequire("jSnXV");

function $a173f815c2e90721$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a173f815c2e90721$var$assitiveTextStyles = {
    name: "v66mgv",
    styles: "border:0;clip:rect(0 0 0 0);height:1px;marginbottom:-1px;marginright:-1px;overflow:hidden;padding:0;position:absolute;whitespace:nowrap;width:1px"
};
const $a173f815c2e90721$export$568f929105953699 = ({ assistiveText: assistiveText = '', isInFocus: isInFocus = false, id: id = '', statusDebounceMillis: _statusDebounceMillis = 1400 })=>{
    const [bump, setBump] = (0, $42omo.useState)(false);
    const [debounced, setDebounced] = (0, $42omo.useState)(false);
    const [silenced, setSilenced] = (0, $42omo.useState)(false);
    const debounceStatusUpdate = (0, $42omo.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(()=>{
            const shouldSilence = !isInFocus;
            setBump((prevBump)=>!prevBump);
            setDebounced(true);
            setSilenced(shouldSilence);
        }), [
        isInFocus
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!debounced) {
            // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- Ignored via go/ees017 (to be fixed)
            debounceStatusUpdate();
            return ()=>{
                debounceStatusUpdate.cancel();
            };
        }
    }, [
        assistiveText,
        isInFocus,
        debounced,
        debounceStatusUpdate
    ]);
    (0, $42omo.useEffect)(()=>{
        if (debounced) {
            // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- Ignored via go/ees017 (to be fixed)
            setBump((prevBump)=>!prevBump);
            // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- Ignored via go/ees017 (to be fixed)
            setDebounced(true);
            // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- Ignored via go/ees017 (to be fixed)
            setSilenced(!isInFocus);
        }
    }, [
        assistiveText,
        isInFocus,
        debounced
    ]);
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $a173f815c2e90721$var$assitiveTextStyles,
        "data-vc": "typWfy57"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        "data-testid": id + '__status--A',
        id: id + '__status--A',
        role: "status",
        "aria-atomic": "true",
        "aria-live": "polite"
    }, !silenced && debounced && bump ? assistiveText : ''), /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        "data-testid": id + '__status--B',
        id: id + '__status--B',
        role: "status",
        "aria-atomic": "true",
        "aria-live": "polite"
    }, !silenced && debounced && !bump ? assistiveText : ''));
};
module.exports["AssistiveText"] = $a173f815c2e90721$export$568f929105953699;

});

parcelRegister("7bDv1", function(module, exports) {
"use strict";

var $eGvGZ = parcelRequire("eGvGZ");


var $crVe8 = parcelRequire("crVe8");

Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $53b8333dcefa62f1$var$_extends2 = $eGvGZ((parcelRequire("fLNXX")));

var $53b8333dcefa62f1$var$_classCallCheck2 = $eGvGZ((parcelRequire("c2Q7G")));

var $53b8333dcefa62f1$var$_createClass2 = $eGvGZ((parcelRequire("iyK4o")));

var $53b8333dcefa62f1$var$_possibleConstructorReturn2 = $eGvGZ((parcelRequire("4CXrK")));

var $53b8333dcefa62f1$var$_getPrototypeOf2 = $eGvGZ((parcelRequire("18f43")));

var $53b8333dcefa62f1$var$_inherits2 = $eGvGZ((parcelRequire("JL40l")));

var $53b8333dcefa62f1$var$_defineProperty2 = $eGvGZ((parcelRequire("l2SD1")));

var $53b8333dcefa62f1$var$_Grid = $53b8333dcefa62f1$var$_interopRequireWildcard((parcelRequire("ktbPS")));

var $53b8333dcefa62f1$var$React = $53b8333dcefa62f1$var$_interopRequireWildcard((parcelRequire("42omo")));

var $53b8333dcefa62f1$var$_clsx = $eGvGZ((parcelRequire("aCXDM")));
function $53b8333dcefa62f1$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($53b8333dcefa62f1$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $53b8333dcefa62f1$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $crVe8(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $53b8333dcefa62f1$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $53b8333dcefa62f1$var$_callSuper(t, o, e) {
    return o = (0, $53b8333dcefa62f1$var$_getPrototypeOf2["default"])(o), (0, $53b8333dcefa62f1$var$_possibleConstructorReturn2["default"])(t, $53b8333dcefa62f1$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $53b8333dcefa62f1$var$_getPrototypeOf2["default"])(t).constructor) : o.apply(t, e));
}
function $53b8333dcefa62f1$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($53b8333dcefa62f1$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
} /*:: import type {
  NoContentRenderer,
  Alignment,
  CellSize,
  CellPosition,
  OverscanIndicesGetter,
  RenderedSection,
  CellRendererParams,
  Scroll as GridScroll,
} from '../Grid';*/ 
/*:: import type {RowRenderer, RenderedRows, Scroll} from './types';*/ /**
 * It is inefficient to create and manage a large list of DOM elements within a scrolling container
 * if only a few of those elements are visible. The primary purpose of this component is to improve
 * performance by only rendering the DOM nodes that a user is able to see based on their current
 * scroll position.
 *
 * This component renders a virtualized list of elements with either fixed or dynamic heights.
 */ /*:: type Props = {
  'aria-label'?: string,

  /**
   * Removes fixed height from the scrollingContainer so that the total height
   * of rows can stretch the window. Intended for use with WindowScroller
   *-/
  autoHeight: boolean,

  /** Optional CSS class name *-/
  className?: string,

  /**
   * Used to estimate the total height of a List before all of its rows have actually been measured.
   * The estimated total height is adjusted as rows are rendered.
   *-/
  estimatedRowSize: number,

  /** Height constraint for list (determines how many actual rows are rendered) *-/
  height: number,

  /** Optional renderer to be used in place of rows when rowCount is 0 *-/
  noRowsRenderer: NoContentRenderer,

  /** Callback invoked with information about the slice of rows that were just rendered.  *-/

  onRowsRendered: (params: RenderedRows) => void,

  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   *-/
  onScroll: (params: Scroll) => void,

  /** See Grid#overscanIndicesGetter *-/
  overscanIndicesGetter: OverscanIndicesGetter,

  /**
   * Number of rows to render above/below the visible bounds of the list.
   * These rows can help for smoother scrolling on touch devices.
   *-/
  overscanRowCount: number,

  /** Either a fixed row height (number) or a function that returns the height of a row given its index.  *-/
  rowHeight: CellSize,

  /** Responsible for rendering a row given an index; ({ index: number }): node *-/
  rowRenderer: RowRenderer,

  /** Number of rows in list. *-/
  rowCount: number,

  /** See Grid#scrollToAlignment *-/
  scrollToAlignment: Alignment,

  /** Row index to ensure visible (by forcefully scrolling if necessary) *-/
  scrollToIndex: number,

  /** Vertical offset. *-/
  scrollTop?: number,

  /** Optional inline style *-/
  style: Object,

  /** Tab index for focus *-/
  tabIndex?: number,

  /** Width of list *-/
  width: number,
};*/ var $53b8333dcefa62f1$var$List = module.exports["default"] = /*#__PURE__*/ function(_React$PureComponent) {
    function List() {
        var _this;
        (0, $53b8333dcefa62f1$var$_classCallCheck2["default"])(this, List);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $53b8333dcefa62f1$var$_callSuper(this, List, [].concat(args));
        (0, $53b8333dcefa62f1$var$_defineProperty2["default"])(_this, "Grid", void 0);
        (0, $53b8333dcefa62f1$var$_defineProperty2["default"])(_this, "_cellRenderer", function(_ref /*:: */ ) {
            var parent = _ref /*:: */ .parent, rowIndex = _ref /*:: */ .rowIndex, style = _ref /*:: */ .style, isScrolling = _ref /*:: */ .isScrolling, isVisible = _ref /*:: */ .isVisible, key = _ref /*:: */ .key;
            var rowRenderer = _this.props.rowRenderer;
            // TRICKY The style object is sometimes cached by Grid.
            // This prevents new style objects from bypassing shallowCompare().
            // However as of React 16, style props are auto-frozen (at least in dev mode)
            // Check to make sure we can still modify the style before proceeding.
            // https://github.com/facebook/react/commit/977357765b44af8ff0cfea327866861073095c12#commitcomment-20648713
            var widthDescriptor = Object.getOwnPropertyDescriptor(style, 'width');
            if (widthDescriptor && widthDescriptor.writable) // By default, List cells should be 100% width.
            // This prevents them from flowing under a scrollbar (if present).
            style.width = '100%';
            return rowRenderer({
                index: rowIndex,
                style: style,
                isScrolling: isScrolling,
                isVisible: isVisible,
                key: key,
                parent: parent
            });
        });
        (0, $53b8333dcefa62f1$var$_defineProperty2["default"])(_this, "_setRef", function(ref /*: ?React.ElementRef<typeof Grid>*/ ) {
            _this.Grid = ref;
        });
        (0, $53b8333dcefa62f1$var$_defineProperty2["default"])(_this, "_onScroll", function(_ref2 /*:: */ ) {
            var clientHeight = _ref2 /*:: */ .clientHeight, scrollHeight = _ref2 /*:: */ .scrollHeight, scrollTop = _ref2 /*:: */ .scrollTop;
            var onScroll = _this.props.onScroll;
            onScroll({
                clientHeight: clientHeight,
                scrollHeight: scrollHeight,
                scrollTop: scrollTop
            });
        });
        (0, $53b8333dcefa62f1$var$_defineProperty2["default"])(_this, "_onSectionRendered", function(_ref3 /*:: */ ) {
            var rowOverscanStartIndex = _ref3 /*:: */ .rowOverscanStartIndex, rowOverscanStopIndex = _ref3 /*:: */ .rowOverscanStopIndex, rowStartIndex = _ref3 /*:: */ .rowStartIndex, rowStopIndex = _ref3 /*:: */ .rowStopIndex;
            var onRowsRendered = _this.props.onRowsRendered;
            onRowsRendered({
                overscanStartIndex: rowOverscanStartIndex,
                overscanStopIndex: rowOverscanStopIndex,
                startIndex: rowStartIndex,
                stopIndex: rowStopIndex
            });
        });
        return _this;
    }
    (0, $53b8333dcefa62f1$var$_inherits2["default"])(List, _React$PureComponent);
    return (0, $53b8333dcefa62f1$var$_createClass2["default"])(List, [
        {
            key: "forceUpdateGrid",
            value: function forceUpdateGrid() {
                if (this.Grid) this.Grid.forceUpdate();
            }
        },
        {
            key: "getOffsetForRow",
            value: function getOffsetForRow(_ref4 /*:: */ ) {
                var alignment = _ref4 /*:: */ .alignment, index = _ref4 /*:: */ .index;
                if (this.Grid) {
                    var _this$Grid$getOffsetF = this.Grid.getOffsetForCell({
                        alignment: alignment,
                        rowIndex: index,
                        columnIndex: 0
                    }), scrollTop = _this$Grid$getOffsetF.scrollTop;
                    return scrollTop;
                }
                return 0;
            }
        },
        {
            key: "invalidateCellSizeAfterRender",
            value: function invalidateCellSizeAfterRender(_ref5 /*:: */ ) {
                var columnIndex = _ref5 /*:: */ .columnIndex, rowIndex = _ref5 /*:: */ .rowIndex;
                if (this.Grid) this.Grid.invalidateCellSizeAfterRender({
                    rowIndex: rowIndex,
                    columnIndex: columnIndex
                });
            }
        },
        {
            key: "measureAllRows",
            value: function measureAllRows() {
                if (this.Grid) this.Grid.measureAllCells();
            }
        },
        {
            key: "recomputeGridSize",
            value: function recomputeGridSize() {
                var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref6$columnIndex = _ref6.columnIndex, columnIndex = _ref6$columnIndex === void 0 ? 0 : _ref6$columnIndex, _ref6$rowIndex = _ref6.rowIndex, rowIndex = _ref6$rowIndex === void 0 ? 0 : _ref6$rowIndex;
                if (this.Grid) this.Grid.recomputeGridSize({
                    rowIndex: rowIndex,
                    columnIndex: columnIndex
                });
            }
        },
        {
            key: "recomputeRowHeights",
            value: function recomputeRowHeights() {
                var index /*: number*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                if (this.Grid) this.Grid.recomputeGridSize({
                    rowIndex: index,
                    columnIndex: 0
                });
            }
        },
        {
            key: "scrollToPosition",
            value: function scrollToPosition() {
                var scrollTop /*: number*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                if (this.Grid) this.Grid.scrollToPosition({
                    scrollTop: scrollTop
                });
            }
        },
        {
            key: "scrollToRow",
            value: function scrollToRow() {
                var index /*: number*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                if (this.Grid) this.Grid.scrollToCell({
                    columnIndex: 0,
                    rowIndex: index
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, className = _this$props.className, noRowsRenderer = _this$props.noRowsRenderer, scrollToIndex = _this$props.scrollToIndex, width = _this$props.width;
                var classNames = (0, $53b8333dcefa62f1$var$_clsx["default"])('ReactVirtualized__List', className);
                return /*#__PURE__*/ $53b8333dcefa62f1$var$React.createElement($53b8333dcefa62f1$var$_Grid["default"], (0, $53b8333dcefa62f1$var$_extends2["default"])({}, this.props, {
                    autoContainerWidth: true,
                    cellRenderer: this._cellRenderer,
                    className: classNames,
                    columnWidth: width,
                    columnCount: 1,
                    noContentRenderer: noRowsRenderer,
                    onScroll: this._onScroll,
                    onSectionRendered: this._onSectionRendered,
                    ref: this._setRef,
                    scrollToRow: scrollToIndex
                }));
            }
        }
    ]);
}($53b8333dcefa62f1$var$React.PureComponent);
(0, $53b8333dcefa62f1$var$_defineProperty2["default"])($53b8333dcefa62f1$var$List, "defaultProps", {
    autoHeight: false,
    estimatedRowSize: 30,
    onScroll: function onScroll() {},
    noRowsRenderer: function noRowsRenderer() {
        return null;
    },
    onRowsRendered: function onRowsRendered() {},
    overscanIndicesGetter: $53b8333dcefa62f1$var$_Grid.accessibilityOverscanIndicesGetter,
    overscanRowCount: 10,
    scrollToAlignment: 'auto',
    scrollToIndex: -1,
    style: {}
});

});

parcelRegister("ktbPS", function(module, exports) {
"use strict";

var $eGvGZ = parcelRequire("eGvGZ");

Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "Grid", {
    enumerable: true,
    get: function get() {
        return $ee6fb265a313cd9c$var$_Grid["default"];
    }
});
Object.defineProperty(module.exports, "accessibilityOverscanIndicesGetter", {
    enumerable: true,
    get: function get() {
        return $ee6fb265a313cd9c$var$_accessibilityOverscanIndicesGetter["default"];
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function get() {
        return $ee6fb265a313cd9c$var$_Grid["default"];
    }
});
Object.defineProperty(module.exports, "defaultCellRangeRenderer", {
    enumerable: true,
    get: function get() {
        return $ee6fb265a313cd9c$var$_defaultCellRangeRenderer["default"];
    }
});
Object.defineProperty(module.exports, "defaultOverscanIndicesGetter", {
    enumerable: true,
    get: function get() {
        return $ee6fb265a313cd9c$var$_defaultOverscanIndicesGetter["default"];
    }
});

var $ee6fb265a313cd9c$var$_Grid = $eGvGZ((parcelRequire("4zfAq")));

var $ee6fb265a313cd9c$var$_accessibilityOverscanIndicesGetter = $eGvGZ((parcelRequire("4rbRt")));

var $ee6fb265a313cd9c$var$_defaultCellRangeRenderer = $eGvGZ((parcelRequire("hbetg")));

var $ee6fb265a313cd9c$var$_defaultOverscanIndicesGetter = $eGvGZ((parcelRequire("1jCVK")));

});

parcelRegister("4zfAq", function(module, exports) {
"use strict";

var $eGvGZ = parcelRequire("eGvGZ");


Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = module.exports.DEFAULT_SCROLLING_RESET_TIME_INTERVAL = void 0;

var $3536857614fccf62$var$_extends2 = $eGvGZ((parcelRequire("fLNXX")));

var $3536857614fccf62$var$_typeof2 = $eGvGZ((parcelRequire("crVe8")));

var $3536857614fccf62$var$_classCallCheck2 = $eGvGZ((parcelRequire("c2Q7G")));

var $3536857614fccf62$var$_createClass2 = $eGvGZ((parcelRequire("iyK4o")));

var $3536857614fccf62$var$_possibleConstructorReturn2 = $eGvGZ((parcelRequire("4CXrK")));

var $3536857614fccf62$var$_getPrototypeOf2 = $eGvGZ((parcelRequire("18f43")));

var $3536857614fccf62$var$_inherits2 = $eGvGZ((parcelRequire("JL40l")));

var $3536857614fccf62$var$_defineProperty2 = $eGvGZ((parcelRequire("l2SD1")));

var $3536857614fccf62$var$React = $3536857614fccf62$var$_interopRequireWildcard((parcelRequire("42omo")));

var $3536857614fccf62$var$_clsx = $eGvGZ((parcelRequire("aCXDM")));

var $3536857614fccf62$var$_calculateSizeAndPositionDataAndUpdateScrollOffset = $eGvGZ((parcelRequire("1lm4p")));

var $3536857614fccf62$var$_ScalingCellSizeAndPositionManager = $eGvGZ((parcelRequire("l3uqv")));

var $3536857614fccf62$var$_createCallbackMemoizer = $eGvGZ((parcelRequire("1qRum")));

var $3536857614fccf62$var$_defaultOverscanIndicesGetter = $3536857614fccf62$var$_interopRequireWildcard((parcelRequire("1jCVK")));

var $3536857614fccf62$var$_updateScrollIndexHelper = $eGvGZ((parcelRequire("bjahi")));

var $3536857614fccf62$var$_defaultCellRangeRenderer = $eGvGZ((parcelRequire("hbetg")));

var $3536857614fccf62$var$_scrollbarSize = $eGvGZ((parcelRequire("iYupH")));

var $8EdHV = parcelRequire("8EdHV");


var $c6sGd = parcelRequire("c6sGd");

function $3536857614fccf62$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($3536857614fccf62$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $3536857614fccf62$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != (parcelRequire("crVe8"))(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $3536857614fccf62$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $3536857614fccf62$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3536857614fccf62$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3536857614fccf62$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $3536857614fccf62$var$_defineProperty2["default"])(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3536857614fccf62$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3536857614fccf62$var$_callSuper(t, o, e) {
    return o = (0, $3536857614fccf62$var$_getPrototypeOf2["default"])(o), (0, $3536857614fccf62$var$_possibleConstructorReturn2["default"])(t, $3536857614fccf62$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $3536857614fccf62$var$_getPrototypeOf2["default"])(t).constructor) : o.apply(t, e));
}
function $3536857614fccf62$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($3536857614fccf62$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
} /*:: import type {
  CellRenderer,
  CellRangeRenderer,
  CellPosition,
  CellSize,
  CellSizeGetter,
  NoContentRenderer,
  Scroll,
  ScrollbarPresenceChange,
  RenderedSection,
  OverscanIndicesGetter,
  Alignment,
  CellCache,
  StyleCache,
} from './types';*/ 
/*:: import type {AnimationTimeoutId} from '../utils/requestAnimationTimeout';*/ /**
 * Specifies the number of milliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */ var $3536857614fccf62$var$DEFAULT_SCROLLING_RESET_TIME_INTERVAL = module.exports.DEFAULT_SCROLLING_RESET_TIME_INTERVAL = 150;
/**
 * Controls whether the Grid updates the DOM element's scrollLeft/scrollTop based on the current state or just observes it.
 * This prevents Grid from interrupting mouse-wheel animations (see issue #2).
 */ var $3536857614fccf62$var$SCROLL_POSITION_CHANGE_REASONS = {
    OBSERVED: 'observed',
    REQUESTED: 'requested'
};
var $3536857614fccf62$var$renderNull /*: NoContentRenderer*/  = function renderNull() {
    return null;
};
/*:: type ScrollPosition = {
  scrollTop?: number,
  scrollLeft?: number,
};*/ /*:: type Props = {
  'aria-label': string,
  'aria-readonly'?: boolean,

  /**
   * Set the width of the inner scrollable container to 'auto'.
   * This is useful for single-column Grids to ensure that the column doesn't extend below a vertical scrollbar.
   *-/
  autoContainerWidth: boolean,

  /**
   * Removes fixed height from the scrollingContainer so that the total height of rows can stretch the window.
   * Intended for use with WindowScroller
   *-/
  autoHeight: boolean,

  /**
   * Removes fixed width from the scrollingContainer so that the total width of rows can stretch the window.
   * Intended for use with WindowScroller
   *-/
  autoWidth: boolean,

  /** Responsible for rendering a cell given an row and column index.  *-/
  cellRenderer: CellRenderer,

  /** Responsible for rendering a group of cells given their index ranges.  *-/
  cellRangeRenderer: CellRangeRenderer,

  /** Optional custom CSS class name to attach to root Grid element.  *-/
  className?: string,

  /** Number of columns in grid.  *-/
  columnCount: number,

  /** Either a fixed column width (number) or a function that returns the width of a column given its index.  *-/
  columnWidth: CellSize,

  /** Unfiltered props for the Grid container. *-/
  containerProps?: Object,

  /** ARIA role for the cell-container.  *-/
  containerRole: string,

  /** Optional inline style applied to inner cell-container *-/
  containerStyle: Object,

  /**
   * If CellMeasurer is used to measure this Grid's children, this should be a pointer to its CellMeasurerCache.
   * A shared CellMeasurerCache reference enables Grid and CellMeasurer to share measurement data.
   *-/
  deferredMeasurementCache?: Object,

  /**
   * Used to estimate the total width of a Grid before all of its columns have actually been measured.
   * The estimated total width is adjusted as columns are rendered.
   *-/
  estimatedColumnSize: number,

  /**
   * Used to estimate the total height of a Grid before all of its rows have actually been measured.
   * The estimated total height is adjusted as rows are rendered.
   *-/
  estimatedRowSize: number,

  /** Exposed for testing purposes only.  *-/
  getScrollbarSize: () => number,

  /** Height of Grid; this property determines the number of visible (vs virtualized) rows.  *-/
  height: number,

  /** Optional custom id to attach to root Grid element.  *-/
  id?: string,

  /**
   * Override internal is-scrolling state tracking.
   * This property is primarily intended for use with the WindowScroller component.
   *-/
  isScrolling?: boolean,

  /**
   * Opt-out of isScrolling param passed to cellRangeRenderer.
   * To avoid the extra render when scroll stops.
   *-/
  isScrollingOptOut: boolean,

  /** Optional renderer to be used in place of rows when either :rowCount or :columnCount is 0.  *-/
  noContentRenderer: NoContentRenderer,

  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   *-/
  onScroll: (params: Scroll) => void,

  /**
   * Called whenever a horizontal or vertical scrollbar is added or removed.
   * This prop is not intended for end-user use;
   * It is used by MultiGrid to support fixed-row/fixed-column scroll syncing.
   *-/
  onScrollbarPresenceChange: (params: ScrollbarPresenceChange) => void,

  /** Callback invoked with information about the section of the Grid that was just rendered.  *-/
  onSectionRendered: (params: RenderedSection) => void,

  /**
   * Number of columns to render before/after the visible section of the grid.
   * These columns can help for smoother scrolling on touch devices or browsers that send scroll events infrequently.
   *-/
  overscanColumnCount: number,

  /**
   * Calculates the number of cells to overscan before and after a specified range.
   * This function ensures that overscanning doesn't exceed the available cells.
   *-/
  overscanIndicesGetter: OverscanIndicesGetter,

  /**
   * Number of rows to render above/below the visible section of the grid.
   * These rows can help for smoother scrolling on touch devices or browsers that send scroll events infrequently.
   *-/
  overscanRowCount: number,

  /** ARIA role for the grid element.  *-/
  role: string,

  /**
   * Either a fixed row height (number) or a function that returns the height of a row given its index.
   * Should implement the following interface: ({ index: number }): number
   *-/
  rowHeight: CellSize,

  /** Number of rows in grid.  *-/
  rowCount: number,

  /** Wait this amount of time after the last scroll event before resetting Grid `pointer-events`. *-/
  scrollingResetTimeInterval: number,

  /** Horizontal offset. *-/
  scrollLeft?: number,

  /**
   * Controls scroll-to-cell behavior of the Grid.
   * The default ("auto") scrolls the least amount possible to ensure that the specified cell is fully visible.
   * Use "start" to align cells to the top/left of the Grid and "end" to align bottom/right.
   *-/
  scrollToAlignment: Alignment,

  /** Column index to ensure visible (by forcefully scrolling if necessary) *-/
  scrollToColumn: number,

  /** Vertical offset. *-/
  scrollTop?: number,

  /** Row index to ensure visible (by forcefully scrolling if necessary) *-/
  scrollToRow: number,

  /** Optional inline style *-/
  style: Object,

  /** Tab index for focus *-/
  tabIndex: ?number,

  /** Width of Grid; this property determines the number of visible (vs virtualized) columns.  *-/
  width: number,

  /** Reference to DOM node *-/
  elementRef?: React.Ref<React.ElementType>,
};*/ /*:: type InstanceProps = {
  prevColumnWidth: CellSize,
  prevRowHeight: CellSize,

  prevColumnCount: number,
  prevRowCount: number,
  prevIsScrolling: boolean,
  prevScrollToColumn: number,
  prevScrollToRow: number,

  columnSizeAndPositionManager: ScalingCellSizeAndPositionManager,
  rowSizeAndPositionManager: ScalingCellSizeAndPositionManager,

  scrollbarSize: number,
  scrollbarSizeMeasured: boolean,
};*/ /*:: type State = {
  instanceProps: InstanceProps,
  isScrolling: boolean,
  scrollDirectionHorizontal: -1 | 1,
  scrollDirectionVertical: -1 | 1,
  scrollLeft: number,
  scrollTop: number,
  scrollPositionChangeReason: 'observed' | 'requested' | null,
  needToResetStyleCache: boolean,
};*/ /**
 * Renders tabular data with virtualization along the vertical and horizontal axes.
 * Row heights and column widths must be known ahead of time and specified as properties.
 */ var $3536857614fccf62$var$Grid = /*#__PURE__*/ function(_React$PureComponent) {
    function Grid(props /*: Props*/ ) {
        var _this;
        (0, $3536857614fccf62$var$_classCallCheck2["default"])(this, Grid);
        _this = $3536857614fccf62$var$_callSuper(this, Grid, [
            props
        ]);
        // Invokes onSectionRendered callback only when start/stop row or column indices change
        (0, $3536857614fccf62$var$_defineProperty2["default"])(_this, "_onGridRenderedMemoizer", (0, $3536857614fccf62$var$_createCallbackMemoizer["default"])());
        (0, $3536857614fccf62$var$_defineProperty2["default"])(_this, "_onScrollMemoizer", (0, $3536857614fccf62$var$_createCallbackMemoizer["default"])(false));
        (0, $3536857614fccf62$var$_defineProperty2["default"])(_this, "_deferredInvalidateColumnIndex", null);
        (0, $3536857614fccf62$var$_defineProperty2["default"])(_this, "_deferredInvalidateRowIndex", null);
        (0, $3536857614fccf62$var$_defineProperty2["default"])(_this, "_recomputeScrollLeftFlag", false);
        (0, $3536857614fccf62$var$_defineProperty2["default"])(_this, "_recomputeScrollTopFlag", false);
        (0, $3536857614fccf62$var$_defineProperty2["default"])(_this, "_horizontalScrollBarSize", 0);
        (0, $3536857614fccf62$var$_defineProperty2["default"])(_this, "_verticalScrollBarSize", 0);
        (0, $3536857614fccf62$var$_defineProperty2["default"])(_this, "_scrollbarPresenceChanged", false);
        (0, $3536857614fccf62$var$_defineProperty2["default"])(_this, "_scrollingContainer", void 0);
        (0, $3536857614fccf62$var$_defineProperty2["default"])(_this, "_childrenToDisplay", void 0);
        (0, $3536857614fccf62$var$_defineProperty2["default"])(_this, "_columnStartIndex", void 0);
        (0, $3536857614fccf62$var$_defineProperty2["default"])(_this, "_columnStopIndex", void 0);
        (0, $3536857614fccf62$var$_defineProperty2["default"])(_this, "_rowStartIndex", void 0);
        (0, $3536857614fccf62$var$_defineProperty2["default"])(_this, "_rowStopIndex", void 0);
        (0, $3536857614fccf62$var$_defineProperty2["default"])(_this, "_renderedColumnStartIndex", 0);
        (0, $3536857614fccf62$var$_defineProperty2["default"])(_this, "_renderedColumnStopIndex", 0);
        (0, $3536857614fccf62$var$_defineProperty2["default"])(_this, "_renderedRowStartIndex", 0);
        (0, $3536857614fccf62$var$_defineProperty2["default"])(_this, "_renderedRowStopIndex", 0);
        (0, $3536857614fccf62$var$_defineProperty2["default"])(_this, "_initialScrollTop", void 0);
        (0, $3536857614fccf62$var$_defineProperty2["default"])(_this, "_initialScrollLeft", void 0);
        (0, $3536857614fccf62$var$_defineProperty2["default"])(_this, "_disablePointerEventsTimeoutId", void 0);
        (0, $3536857614fccf62$var$_defineProperty2["default"])(_this, "_styleCache", {});
        (0, $3536857614fccf62$var$_defineProperty2["default"])(_this, "_cellCache", {});
        (0, $3536857614fccf62$var$_defineProperty2["default"])(_this, "_debounceScrollEndedCallback", function() {
            _this._disablePointerEventsTimeoutId = null;
            // isScrolling is used to determine if we reset styleCache
            _this.setState({
                isScrolling: false,
                needToResetStyleCache: false
            });
        });
        (0, $3536857614fccf62$var$_defineProperty2["default"])(_this, "_invokeOnGridRenderedHelper", function() {
            var onSectionRendered = _this.props.onSectionRendered;
            _this._onGridRenderedMemoizer({
                callback: onSectionRendered,
                indices: {
                    columnOverscanStartIndex: _this._columnStartIndex,
                    columnOverscanStopIndex: _this._columnStopIndex,
                    columnStartIndex: _this._renderedColumnStartIndex,
                    columnStopIndex: _this._renderedColumnStopIndex,
                    rowOverscanStartIndex: _this._rowStartIndex,
                    rowOverscanStopIndex: _this._rowStopIndex,
                    rowStartIndex: _this._renderedRowStartIndex,
                    rowStopIndex: _this._renderedRowStopIndex
                }
            });
        });
        (0, $3536857614fccf62$var$_defineProperty2["default"])(_this, "_setScrollingContainerRef", function(ref /*: Element*/ ) {
            _this._scrollingContainer = ref;
            if (typeof _this.props.elementRef === 'function') _this.props.elementRef(ref);
            else if ((0, $3536857614fccf62$var$_typeof2["default"])(_this.props.elementRef) === 'object') _this.props.elementRef.current = ref;
        });
        (0, $3536857614fccf62$var$_defineProperty2["default"])(_this, "_onScroll", function(event /*: Event*/ ) {
            // In certain edge-cases React dispatches an onScroll event with an invalid target.scrollLeft / target.scrollTop.
            // This invalid event can be detected by comparing event.target to this component's scrollable DOM element.
            // See issue #404 for more information.
            if (event.target === _this._scrollingContainer) _this.handleScrollEvent(event.target /*: any*/ );
        });
        var columnSizeAndPositionManager = new $3536857614fccf62$var$_ScalingCellSizeAndPositionManager["default"]({
            cellCount: props.columnCount,
            cellSizeGetter: function cellSizeGetter(params) {
                return Grid._wrapSizeGetter(props.columnWidth)(params);
            },
            estimatedCellSize: Grid._getEstimatedColumnSize(props)
        });
        var rowSizeAndPositionManager = new $3536857614fccf62$var$_ScalingCellSizeAndPositionManager["default"]({
            cellCount: props.rowCount,
            cellSizeGetter: function cellSizeGetter(params) {
                return Grid._wrapSizeGetter(props.rowHeight)(params);
            },
            estimatedCellSize: Grid._getEstimatedRowSize(props)
        });
        _this.state = {
            instanceProps: {
                columnSizeAndPositionManager: columnSizeAndPositionManager,
                rowSizeAndPositionManager: rowSizeAndPositionManager,
                prevColumnWidth: props.columnWidth,
                prevRowHeight: props.rowHeight,
                prevColumnCount: props.columnCount,
                prevRowCount: props.rowCount,
                prevIsScrolling: props.isScrolling === true,
                prevScrollToColumn: props.scrollToColumn,
                prevScrollToRow: props.scrollToRow,
                scrollbarSize: 0,
                scrollbarSizeMeasured: false
            },
            isScrolling: false,
            scrollDirectionHorizontal: $3536857614fccf62$var$_defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD,
            scrollDirectionVertical: $3536857614fccf62$var$_defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD,
            scrollLeft: 0,
            scrollTop: 0,
            scrollPositionChangeReason: null,
            needToResetStyleCache: false
        };
        if (props.scrollToRow > 0) _this._initialScrollTop = _this._getCalculatedScrollTop(props, _this.state);
        if (props.scrollToColumn > 0) _this._initialScrollLeft = _this._getCalculatedScrollLeft(props, _this.state);
        return _this;
    }
    /**
   * Gets offsets for a given cell and alignment.
   */ (0, $3536857614fccf62$var$_inherits2["default"])(Grid, _React$PureComponent);
    return (0, $3536857614fccf62$var$_createClass2["default"])(Grid, [
        {
            key: "getOffsetForCell",
            value: function getOffsetForCell() {
                var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$alignment = _ref.alignment, alignment = _ref$alignment === void 0 ? this.props.scrollToAlignment : _ref$alignment, _ref$columnIndex = _ref.columnIndex, columnIndex = _ref$columnIndex === void 0 ? this.props.scrollToColumn : _ref$columnIndex, _ref$rowIndex = _ref.rowIndex, rowIndex = _ref$rowIndex === void 0 ? this.props.scrollToRow : _ref$rowIndex;
                var offsetProps = $3536857614fccf62$var$_objectSpread($3536857614fccf62$var$_objectSpread({}, this.props), {}, {
                    scrollToAlignment: alignment,
                    scrollToColumn: columnIndex,
                    scrollToRow: rowIndex
                });
                return {
                    scrollLeft: this._getCalculatedScrollLeft(offsetProps),
                    scrollTop: this._getCalculatedScrollTop(offsetProps)
                };
            }
        },
        {
            key: "getTotalRowsHeight",
            value: function getTotalRowsHeight() {
                return this.state.instanceProps.rowSizeAndPositionManager.getTotalSize();
            }
        },
        {
            key: "getTotalColumnsWidth",
            value: function getTotalColumnsWidth() {
                return this.state.instanceProps.columnSizeAndPositionManager.getTotalSize();
            }
        },
        {
            key: "handleScrollEvent",
            value: function handleScrollEvent(_ref2 /*:: */ ) {
                var _ref2$scrollLeft = _ref2 /*:: */ .scrollLeft, scrollLeftParam = _ref2$scrollLeft === void 0 ? 0 : _ref2$scrollLeft, _ref2$scrollTop = _ref2 /*:: */ .scrollTop, scrollTopParam = _ref2$scrollTop === void 0 ? 0 : _ref2$scrollTop;
                // On iOS, we can arrive at negative offsets by swiping past the start.
                // To prevent flicker here, we make playing in the negative offset zone cause nothing to happen.
                if (scrollTopParam < 0) return;
                // Prevent pointer events from interrupting a smooth scroll
                this._debounceScrollEnded();
                var _this$props = this.props, autoHeight = _this$props.autoHeight, autoWidth = _this$props.autoWidth, height = _this$props.height, width = _this$props.width;
                var instanceProps = this.state.instanceProps;
                // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
                // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
                // This causes a series of rapid renders that is slow for long lists.
                // We can avoid that by doing some simple bounds checking to ensure that scroll offsets never exceed their bounds.
                var scrollbarSize = instanceProps.scrollbarSize;
                var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
                var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
                var scrollLeft = Math.min(Math.max(0, totalColumnsWidth - width + scrollbarSize), scrollLeftParam);
                var scrollTop = Math.min(Math.max(0, totalRowsHeight - height + scrollbarSize), scrollTopParam);
                // Certain devices (like Apple touchpad) rapid-fire duplicate events.
                // Don't force a re-render if this is the case.
                // The mouse may move faster then the animation frame does.
                // Use requestAnimationFrame to avoid over-updating.
                if (this.state.scrollLeft !== scrollLeft || this.state.scrollTop !== scrollTop) {
                    // Track scrolling direction so we can more efficiently overscan rows to reduce empty space around the edges while scrolling.
                    // Don't change direction for an axis unless scroll offset has changed.
                    var scrollDirectionHorizontal = scrollLeft !== this.state.scrollLeft ? scrollLeft > this.state.scrollLeft ? $3536857614fccf62$var$_defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD : $3536857614fccf62$var$_defaultOverscanIndicesGetter.SCROLL_DIRECTION_BACKWARD : this.state.scrollDirectionHorizontal;
                    var scrollDirectionVertical = scrollTop !== this.state.scrollTop ? scrollTop > this.state.scrollTop ? $3536857614fccf62$var$_defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD : $3536857614fccf62$var$_defaultOverscanIndicesGetter.SCROLL_DIRECTION_BACKWARD : this.state.scrollDirectionVertical;
                    var newState /*: $Shape<State>*/  = {
                        isScrolling: true,
                        scrollDirectionHorizontal: scrollDirectionHorizontal,
                        scrollDirectionVertical: scrollDirectionVertical,
                        scrollPositionChangeReason: $3536857614fccf62$var$SCROLL_POSITION_CHANGE_REASONS.OBSERVED
                    };
                    if (!autoHeight) newState.scrollTop = scrollTop;
                    if (!autoWidth) newState.scrollLeft = scrollLeft;
                    newState.needToResetStyleCache = false;
                    this.setState(newState);
                }
                this._invokeOnScrollMemoizer({
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop,
                    totalColumnsWidth: totalColumnsWidth,
                    totalRowsHeight: totalRowsHeight
                });
            }
        },
        {
            key: "invalidateCellSizeAfterRender",
            value: function invalidateCellSizeAfterRender(_ref3 /*:: */ ) {
                var columnIndex = _ref3 /*:: */ .columnIndex, rowIndex = _ref3 /*:: */ .rowIndex;
                this._deferredInvalidateColumnIndex = typeof this._deferredInvalidateColumnIndex === 'number' ? Math.min(this._deferredInvalidateColumnIndex, columnIndex) : columnIndex;
                this._deferredInvalidateRowIndex = typeof this._deferredInvalidateRowIndex === 'number' ? Math.min(this._deferredInvalidateRowIndex, rowIndex) : rowIndex;
            }
        },
        {
            key: "measureAllCells",
            value: function measureAllCells() {
                var _this$props2 = this.props, columnCount = _this$props2.columnCount, rowCount = _this$props2.rowCount;
                var instanceProps = this.state.instanceProps;
                instanceProps.columnSizeAndPositionManager.getSizeAndPositionOfCell(columnCount - 1);
                instanceProps.rowSizeAndPositionManager.getSizeAndPositionOfCell(rowCount - 1);
            }
        },
        {
            key: "recomputeGridSize",
            value: function recomputeGridSize() {
                var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref4$columnIndex = _ref4.columnIndex, columnIndex = _ref4$columnIndex === void 0 ? 0 : _ref4$columnIndex, _ref4$rowIndex = _ref4.rowIndex, rowIndex = _ref4$rowIndex === void 0 ? 0 : _ref4$rowIndex;
                var _this$props3 = this.props, scrollToColumn = _this$props3.scrollToColumn, scrollToRow = _this$props3.scrollToRow;
                var instanceProps = this.state.instanceProps;
                instanceProps.columnSizeAndPositionManager.resetCell(columnIndex);
                instanceProps.rowSizeAndPositionManager.resetCell(rowIndex);
                // Cell sizes may be determined by a function property.
                // In this case the cDU handler can't know if they changed.
                // Store this flag to let the next cDU pass know it needs to recompute the scroll offset.
                this._recomputeScrollLeftFlag = scrollToColumn >= 0 && (this.state.scrollDirectionHorizontal === $3536857614fccf62$var$_defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD ? columnIndex <= scrollToColumn : columnIndex >= scrollToColumn);
                this._recomputeScrollTopFlag = scrollToRow >= 0 && (this.state.scrollDirectionVertical === $3536857614fccf62$var$_defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD ? rowIndex <= scrollToRow : rowIndex >= scrollToRow);
                // Clear cell cache in case we are scrolling;
                // Invalid row heights likely mean invalid cached content as well.
                this._styleCache = {};
                this._cellCache = {};
                this.forceUpdate();
            }
        },
        {
            key: "scrollToCell",
            value: function scrollToCell(_ref5 /*:: */ ) {
                var columnIndex = _ref5 /*:: */ .columnIndex, rowIndex = _ref5 /*:: */ .rowIndex;
                var columnCount = this.props.columnCount;
                var props = this.props;
                // Don't adjust scroll offset for single-column grids (eg List, Table).
                // This can cause a funky scroll offset because of the vertical scrollbar width.
                if (columnCount > 1 && columnIndex !== undefined) this._updateScrollLeftForScrollToColumn($3536857614fccf62$var$_objectSpread($3536857614fccf62$var$_objectSpread({}, props), {}, {
                    scrollToColumn: columnIndex
                }));
                if (rowIndex !== undefined) this._updateScrollTopForScrollToRow($3536857614fccf62$var$_objectSpread($3536857614fccf62$var$_objectSpread({}, props), {}, {
                    scrollToRow: rowIndex
                }));
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this$props4 = this.props, getScrollbarSize = _this$props4.getScrollbarSize, height = _this$props4.height, scrollLeft = _this$props4.scrollLeft, scrollToColumn = _this$props4.scrollToColumn, scrollTop = _this$props4.scrollTop, scrollToRow = _this$props4.scrollToRow, width = _this$props4.width;
                var instanceProps = this.state.instanceProps;
                // Reset initial offsets to be ignored in browser
                this._initialScrollTop = 0;
                this._initialScrollLeft = 0;
                // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
                // We must do this at the start of the method as we may calculate and update scroll position below.
                this._handleInvalidatedGridSize();
                // If this component was first rendered server-side, scrollbar size will be undefined.
                // In that event we need to remeasure.
                if (!instanceProps.scrollbarSizeMeasured) this.setState(function(prevState) {
                    var stateUpdate = $3536857614fccf62$var$_objectSpread($3536857614fccf62$var$_objectSpread({}, prevState), {}, {
                        needToResetStyleCache: false
                    });
                    stateUpdate.instanceProps.scrollbarSize = getScrollbarSize();
                    stateUpdate.instanceProps.scrollbarSizeMeasured = true;
                    return stateUpdate;
                });
                if (typeof scrollLeft === 'number' && scrollLeft >= 0 || typeof scrollTop === 'number' && scrollTop >= 0) {
                    var stateUpdate = Grid._getScrollToPositionStateUpdate({
                        prevState: this.state,
                        scrollLeft: scrollLeft,
                        scrollTop: scrollTop
                    });
                    if (stateUpdate) {
                        stateUpdate.needToResetStyleCache = false;
                        this.setState(stateUpdate);
                    }
                }
                // refs don't work in `react-test-renderer`
                if (this._scrollingContainer) {
                    // setting the ref's scrollLeft and scrollTop.
                    // Somehow in MultiGrid the main grid doesn't trigger a update on mount.
                    if (this._scrollingContainer.scrollLeft !== this.state.scrollLeft) this._scrollingContainer.scrollLeft = this.state.scrollLeft;
                    if (this._scrollingContainer.scrollTop !== this.state.scrollTop) this._scrollingContainer.scrollTop = this.state.scrollTop;
                }
                // Don't update scroll offset if the size is 0; we don't render any cells in this case.
                // Setting a state may cause us to later thing we've updated the offce when we haven't.
                var sizeIsBiggerThanZero = height > 0 && width > 0;
                if (scrollToColumn >= 0 && sizeIsBiggerThanZero) this._updateScrollLeftForScrollToColumn();
                if (scrollToRow >= 0 && sizeIsBiggerThanZero) this._updateScrollTopForScrollToRow();
                // Update onRowsRendered callback
                this._invokeOnGridRenderedHelper();
                // Initialize onScroll callback
                this._invokeOnScrollMemoizer({
                    scrollLeft: scrollLeft || 0,
                    scrollTop: scrollTop || 0,
                    totalColumnsWidth: instanceProps.columnSizeAndPositionManager.getTotalSize(),
                    totalRowsHeight: instanceProps.rowSizeAndPositionManager.getTotalSize()
                });
                this._maybeCallOnScrollbarPresenceChange();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps /*: Props*/ , prevState /*: State*/ ) {
                var _this2 = this;
                var _this$props5 = this.props, autoHeight = _this$props5.autoHeight, autoWidth = _this$props5.autoWidth, columnCount = _this$props5.columnCount, height = _this$props5.height, rowCount = _this$props5.rowCount, scrollToAlignment = _this$props5.scrollToAlignment, scrollToColumn = _this$props5.scrollToColumn, scrollToRow = _this$props5.scrollToRow, width = _this$props5.width;
                var _this$state = this.state, scrollLeft = _this$state.scrollLeft, scrollPositionChangeReason = _this$state.scrollPositionChangeReason, scrollTop = _this$state.scrollTop, instanceProps = _this$state.instanceProps;
                // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
                // We must do this at the start of the method as we may calculate and update scroll position below.
                this._handleInvalidatedGridSize();
                // Handle edge case where column or row count has only just increased over 0.
                // In this case we may have to restore a previously-specified scroll offset.
                // For more info see bvaughn/react-virtualized/issues/218
                var columnOrRowCountJustIncreasedFromZero = columnCount > 0 && prevProps.columnCount === 0 || rowCount > 0 && prevProps.rowCount === 0;
                // Make sure requested changes to :scrollLeft or :scrollTop get applied.
                // Assigning to scrollLeft/scrollTop tells the browser to interrupt any running scroll animations,
                // And to discard any pending async changes to the scroll position that may have happened in the meantime (e.g. on a separate scrolling thread).
                // So we only set these when we require an adjustment of the scroll position.
                // See issue #2 for more information.
                if (scrollPositionChangeReason === $3536857614fccf62$var$SCROLL_POSITION_CHANGE_REASONS.REQUESTED) {
                    // @TRICKY :autoHeight and :autoWidth properties instructs Grid to leave :scrollTop and :scrollLeft management to an external HOC (eg WindowScroller).
                    // In this case we should avoid checking scrollingContainer.scrollTop and scrollingContainer.scrollLeft since it forces layout/flow.
                    if (!autoWidth && scrollLeft >= 0 && (scrollLeft !== this._scrollingContainer.scrollLeft || columnOrRowCountJustIncreasedFromZero)) this._scrollingContainer.scrollLeft = scrollLeft;
                    if (!autoHeight && scrollTop >= 0 && (scrollTop !== this._scrollingContainer.scrollTop || columnOrRowCountJustIncreasedFromZero)) this._scrollingContainer.scrollTop = scrollTop;
                }
                // Special case where the previous size was 0:
                // In this case we don't show any windowed cells at all.
                // So we should always recalculate offset afterwards.
                var sizeJustIncreasedFromZero = (prevProps.width === 0 || prevProps.height === 0) && height > 0 && width > 0;
                // Update scroll offsets if the current :scrollToColumn or :scrollToRow values requires it
                // @TODO Do we also need this check or can the one in componentWillUpdate() suffice?
                if (this._recomputeScrollLeftFlag) {
                    this._recomputeScrollLeftFlag = false;
                    this._updateScrollLeftForScrollToColumn(this.props);
                } else (0, $3536857614fccf62$var$_updateScrollIndexHelper["default"])({
                    cellSizeAndPositionManager: instanceProps.columnSizeAndPositionManager,
                    previousCellsCount: prevProps.columnCount,
                    previousCellSize: prevProps.columnWidth,
                    previousScrollToAlignment: prevProps.scrollToAlignment,
                    previousScrollToIndex: prevProps.scrollToColumn,
                    previousSize: prevProps.width,
                    scrollOffset: scrollLeft,
                    scrollToAlignment: scrollToAlignment,
                    scrollToIndex: scrollToColumn,
                    size: width,
                    sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
                    updateScrollIndexCallback: function updateScrollIndexCallback() {
                        return _this2._updateScrollLeftForScrollToColumn(_this2.props);
                    }
                });
                if (this._recomputeScrollTopFlag) {
                    this._recomputeScrollTopFlag = false;
                    this._updateScrollTopForScrollToRow(this.props);
                } else (0, $3536857614fccf62$var$_updateScrollIndexHelper["default"])({
                    cellSizeAndPositionManager: instanceProps.rowSizeAndPositionManager,
                    previousCellsCount: prevProps.rowCount,
                    previousCellSize: prevProps.rowHeight,
                    previousScrollToAlignment: prevProps.scrollToAlignment,
                    previousScrollToIndex: prevProps.scrollToRow,
                    previousSize: prevProps.height,
                    scrollOffset: scrollTop,
                    scrollToAlignment: scrollToAlignment,
                    scrollToIndex: scrollToRow,
                    size: height,
                    sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
                    updateScrollIndexCallback: function updateScrollIndexCallback() {
                        return _this2._updateScrollTopForScrollToRow(_this2.props);
                    }
                });
                // Update onRowsRendered callback if start/stop indices have changed
                this._invokeOnGridRenderedHelper();
                // Changes to :scrollLeft or :scrollTop should also notify :onScroll listeners
                if (scrollLeft !== prevState.scrollLeft || scrollTop !== prevState.scrollTop) {
                    var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
                    var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
                    this._invokeOnScrollMemoizer({
                        scrollLeft: scrollLeft,
                        scrollTop: scrollTop,
                        totalColumnsWidth: totalColumnsWidth,
                        totalRowsHeight: totalRowsHeight
                    });
                }
                this._maybeCallOnScrollbarPresenceChange();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this._disablePointerEventsTimeoutId) (0, $c6sGd.cancelAnimationTimeout)(this._disablePointerEventsTimeoutId);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props6 = this.props, autoContainerWidth = _this$props6.autoContainerWidth, autoHeight = _this$props6.autoHeight, autoWidth = _this$props6.autoWidth, className = _this$props6.className, containerProps = _this$props6.containerProps, containerRole = _this$props6.containerRole, containerStyle = _this$props6.containerStyle, height = _this$props6.height, id = _this$props6.id, noContentRenderer = _this$props6.noContentRenderer, role = _this$props6.role, style = _this$props6.style, tabIndex = _this$props6.tabIndex, width = _this$props6.width;
                var _this$state2 = this.state, instanceProps = _this$state2.instanceProps, needToResetStyleCache = _this$state2.needToResetStyleCache;
                var isScrolling = this._isScrolling();
                var gridStyle /*: Object*/  = {
                    boxSizing: 'border-box',
                    direction: 'ltr',
                    height: autoHeight ? 'auto' : height,
                    position: 'relative',
                    width: autoWidth ? 'auto' : width,
                    WebkitOverflowScrolling: 'touch',
                    willChange: 'transform'
                };
                if (needToResetStyleCache) this._styleCache = {};
                // calculate _styleCache here
                // if state.isScrolling (not from _isScrolling) then reset
                if (!this.state.isScrolling) this._resetStyleCache();
                // calculate children to render here
                this._calculateChildrenToRender(this.props, this.state);
                var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
                var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
                // Force browser to hide scrollbars when we know they aren't necessary.
                // Otherwise once scrollbars appear they may not disappear again.
                // For more info see issue #116
                var verticalScrollBarSize = totalRowsHeight > height ? instanceProps.scrollbarSize : 0;
                var horizontalScrollBarSize = totalColumnsWidth > width ? instanceProps.scrollbarSize : 0;
                if (horizontalScrollBarSize !== this._horizontalScrollBarSize || verticalScrollBarSize !== this._verticalScrollBarSize) {
                    this._horizontalScrollBarSize = horizontalScrollBarSize;
                    this._verticalScrollBarSize = verticalScrollBarSize;
                    this._scrollbarPresenceChanged = true;
                }
                // Also explicitly init styles to 'auto' if scrollbars are required.
                // This works around an obscure edge case where external CSS styles have not yet been loaded,
                // But an initial scroll index of offset is set as an external prop.
                // Without this style, Grid would render the correct range of cells but would NOT update its internal offset.
                // This was originally reported via clauderic/react-infinite-calendar/issues/23
                gridStyle.overflowX = totalColumnsWidth + verticalScrollBarSize <= width ? 'hidden' : 'auto';
                gridStyle.overflowY = totalRowsHeight + horizontalScrollBarSize <= height ? 'hidden' : 'auto';
                var childrenToDisplay = this._childrenToDisplay;
                var showNoContentRenderer = childrenToDisplay.length === 0 && height > 0 && width > 0;
                return /*#__PURE__*/ $3536857614fccf62$var$React.createElement("div", (0, $3536857614fccf62$var$_extends2["default"])({
                    ref: this._setScrollingContainerRef
                }, containerProps, {
                    "aria-label": this.props['aria-label'],
                    "aria-readonly": this.props['aria-readonly'],
                    className: (0, $3536857614fccf62$var$_clsx["default"])('ReactVirtualized__Grid', className),
                    id: id,
                    onScroll: this._onScroll,
                    role: role,
                    style: $3536857614fccf62$var$_objectSpread($3536857614fccf62$var$_objectSpread({}, gridStyle), style),
                    tabIndex: tabIndex
                }), childrenToDisplay.length > 0 && /*#__PURE__*/ $3536857614fccf62$var$React.createElement("div", {
                    className: "ReactVirtualized__Grid__innerScrollContainer",
                    role: containerRole,
                    style: $3536857614fccf62$var$_objectSpread({
                        width: autoContainerWidth ? 'auto' : totalColumnsWidth,
                        height: totalRowsHeight,
                        maxWidth: totalColumnsWidth,
                        maxHeight: totalRowsHeight,
                        overflow: 'hidden',
                        pointerEvents: isScrolling ? 'none' : '',
                        position: 'relative'
                    }, containerStyle)
                }, childrenToDisplay), showNoContentRenderer && noContentRenderer());
            }
        },
        {
            key: "_calculateChildrenToRender",
            value: function _calculateChildrenToRender() {
                var props /*: Props*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var state /*: State*/  = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                var cellRenderer = props.cellRenderer, cellRangeRenderer = props.cellRangeRenderer, columnCount = props.columnCount, deferredMeasurementCache = props.deferredMeasurementCache, height = props.height, overscanColumnCount = props.overscanColumnCount, overscanIndicesGetter = props.overscanIndicesGetter, overscanRowCount = props.overscanRowCount, rowCount = props.rowCount, width = props.width, isScrollingOptOut = props.isScrollingOptOut;
                var scrollDirectionHorizontal = state.scrollDirectionHorizontal, scrollDirectionVertical = state.scrollDirectionVertical, instanceProps = state.instanceProps;
                var scrollTop = this._initialScrollTop > 0 ? this._initialScrollTop : state.scrollTop;
                var scrollLeft = this._initialScrollLeft > 0 ? this._initialScrollLeft : state.scrollLeft;
                var isScrolling = this._isScrolling(props, state);
                this._childrenToDisplay = [];
                // Render only enough columns and rows to cover the visible area of the grid.
                if (height > 0 && width > 0) {
                    var visibleColumnIndices = instanceProps.columnSizeAndPositionManager.getVisibleCellRange({
                        containerSize: width,
                        offset: scrollLeft
                    });
                    var visibleRowIndices = instanceProps.rowSizeAndPositionManager.getVisibleCellRange({
                        containerSize: height,
                        offset: scrollTop
                    });
                    var horizontalOffsetAdjustment = instanceProps.columnSizeAndPositionManager.getOffsetAdjustment({
                        containerSize: width,
                        offset: scrollLeft
                    });
                    var verticalOffsetAdjustment = instanceProps.rowSizeAndPositionManager.getOffsetAdjustment({
                        containerSize: height,
                        offset: scrollTop
                    });
                    // Store for _invokeOnGridRenderedHelper()
                    this._renderedColumnStartIndex = visibleColumnIndices.start;
                    this._renderedColumnStopIndex = visibleColumnIndices.stop;
                    this._renderedRowStartIndex = visibleRowIndices.start;
                    this._renderedRowStopIndex = visibleRowIndices.stop;
                    var overscanColumnIndices = overscanIndicesGetter({
                        direction: 'horizontal',
                        cellCount: columnCount,
                        overscanCellsCount: overscanColumnCount,
                        scrollDirection: scrollDirectionHorizontal,
                        startIndex: typeof visibleColumnIndices.start === 'number' ? visibleColumnIndices.start : 0,
                        stopIndex: typeof visibleColumnIndices.stop === 'number' ? visibleColumnIndices.stop : -1
                    });
                    var overscanRowIndices = overscanIndicesGetter({
                        direction: 'vertical',
                        cellCount: rowCount,
                        overscanCellsCount: overscanRowCount,
                        scrollDirection: scrollDirectionVertical,
                        startIndex: typeof visibleRowIndices.start === 'number' ? visibleRowIndices.start : 0,
                        stopIndex: typeof visibleRowIndices.stop === 'number' ? visibleRowIndices.stop : -1
                    });
                    // Store for _invokeOnGridRenderedHelper()
                    var columnStartIndex = overscanColumnIndices.overscanStartIndex;
                    var columnStopIndex = overscanColumnIndices.overscanStopIndex;
                    var rowStartIndex = overscanRowIndices.overscanStartIndex;
                    var rowStopIndex = overscanRowIndices.overscanStopIndex;
                    // Advanced use-cases (eg CellMeasurer) require batched measurements to determine accurate sizes.
                    if (deferredMeasurementCache) {
                        // If rows have a dynamic height, scan the rows we are about to render.
                        // If any have not yet been measured, then we need to render all columns initially,
                        // Because the height of the row is equal to the tallest cell within that row,
                        // (And so we can't know the height without measuring all column-cells first).
                        if (!deferredMeasurementCache.hasFixedHeight()) {
                            for(var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++)if (!deferredMeasurementCache.has(rowIndex, 0)) {
                                columnStartIndex = 0;
                                columnStopIndex = columnCount - 1;
                                break;
                            }
                        }
                        // If columns have a dynamic width, scan the columns we are about to render.
                        // If any have not yet been measured, then we need to render all rows initially,
                        // Because the width of the column is equal to the widest cell within that column,
                        // (And so we can't know the width without measuring all row-cells first).
                        if (!deferredMeasurementCache.hasFixedWidth()) {
                            for(var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++)if (!deferredMeasurementCache.has(0, columnIndex)) {
                                rowStartIndex = 0;
                                rowStopIndex = rowCount - 1;
                                break;
                            }
                        }
                    }
                    this._childrenToDisplay = cellRangeRenderer({
                        cellCache: this._cellCache,
                        cellRenderer: cellRenderer,
                        columnSizeAndPositionManager: instanceProps.columnSizeAndPositionManager,
                        columnStartIndex: columnStartIndex,
                        columnStopIndex: columnStopIndex,
                        deferredMeasurementCache: deferredMeasurementCache,
                        horizontalOffsetAdjustment: horizontalOffsetAdjustment,
                        isScrolling: isScrolling,
                        isScrollingOptOut: isScrollingOptOut,
                        parent: this,
                        rowSizeAndPositionManager: instanceProps.rowSizeAndPositionManager,
                        rowStartIndex: rowStartIndex,
                        rowStopIndex: rowStopIndex,
                        scrollLeft: scrollLeft,
                        scrollTop: scrollTop,
                        styleCache: this._styleCache,
                        verticalOffsetAdjustment: verticalOffsetAdjustment,
                        visibleColumnIndices: visibleColumnIndices,
                        visibleRowIndices: visibleRowIndices
                    });
                    // update the indices
                    this._columnStartIndex = columnStartIndex;
                    this._columnStopIndex = columnStopIndex;
                    this._rowStartIndex = rowStartIndex;
                    this._rowStopIndex = rowStopIndex;
                }
            }
        },
        {
            key: "_debounceScrollEnded",
            value: function _debounceScrollEnded() {
                var scrollingResetTimeInterval = this.props.scrollingResetTimeInterval;
                if (this._disablePointerEventsTimeoutId) (0, $c6sGd.cancelAnimationTimeout)(this._disablePointerEventsTimeoutId);
                this._disablePointerEventsTimeoutId = (0, $c6sGd.requestAnimationTimeout)(this._debounceScrollEndedCallback, scrollingResetTimeInterval);
            }
        },
        {
            key: "_handleInvalidatedGridSize",
            value: /**
     * Check for batched CellMeasurer size invalidations.
     * This will occur the first time one or more previously unmeasured cells are rendered.
     */ function _handleInvalidatedGridSize() {
                if (typeof this._deferredInvalidateColumnIndex === 'number' && typeof this._deferredInvalidateRowIndex === 'number') {
                    var columnIndex = this._deferredInvalidateColumnIndex;
                    var rowIndex = this._deferredInvalidateRowIndex;
                    this._deferredInvalidateColumnIndex = null;
                    this._deferredInvalidateRowIndex = null;
                    this.recomputeGridSize({
                        columnIndex: columnIndex,
                        rowIndex: rowIndex
                    });
                }
            }
        },
        {
            key: "_invokeOnScrollMemoizer",
            value: function _invokeOnScrollMemoizer(_ref6 /*:: */ ) {
                var _this3 = this;
                var scrollLeft = _ref6 /*:: */ .scrollLeft, scrollTop = _ref6 /*:: */ .scrollTop, totalColumnsWidth = _ref6 /*:: */ .totalColumnsWidth, totalRowsHeight = _ref6 /*:: */ .totalRowsHeight;
                this._onScrollMemoizer({
                    callback: function callback(_ref7) {
                        var scrollLeft = _ref7.scrollLeft, scrollTop = _ref7.scrollTop;
                        var _this3$props = _this3.props, height = _this3$props.height, onScroll = _this3$props.onScroll, width = _this3$props.width;
                        onScroll({
                            clientHeight: height,
                            clientWidth: width,
                            scrollHeight: totalRowsHeight,
                            scrollLeft: scrollLeft,
                            scrollTop: scrollTop,
                            scrollWidth: totalColumnsWidth
                        });
                    },
                    indices: {
                        scrollLeft: scrollLeft,
                        scrollTop: scrollTop
                    }
                });
            }
        },
        {
            key: "_isScrolling",
            value: function _isScrolling() /*: boolean*/ {
                var props /*: Props*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var state /*: State*/  = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                // If isScrolling is defined in props, use it to override the value in state
                // This is a performance optimization for WindowScroller + Grid
                return Object.hasOwnProperty.call(props, 'isScrolling') ? Boolean(props.isScrolling) : Boolean(state.isScrolling);
            }
        },
        {
            key: "_maybeCallOnScrollbarPresenceChange",
            value: function _maybeCallOnScrollbarPresenceChange() {
                if (this._scrollbarPresenceChanged) {
                    var onScrollbarPresenceChange = this.props.onScrollbarPresenceChange;
                    this._scrollbarPresenceChanged = false;
                    onScrollbarPresenceChange({
                        horizontal: this._horizontalScrollBarSize > 0,
                        size: this.state.instanceProps.scrollbarSize,
                        vertical: this._verticalScrollBarSize > 0
                    });
                }
            }
        },
        {
            key: "scrollToPosition",
            value: /**
     * Scroll to the specified offset(s).
     * Useful for animating position changes.
     */ function scrollToPosition(_ref8 /*:: */ ) {
                var scrollLeft = _ref8 /*:: */ .scrollLeft, scrollTop = _ref8 /*:: */ .scrollTop;
                var stateUpdate = Grid._getScrollToPositionStateUpdate({
                    prevState: this.state,
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop
                });
                if (stateUpdate) {
                    stateUpdate.needToResetStyleCache = false;
                    this.setState(stateUpdate);
                }
            }
        },
        {
            key: "_getCalculatedScrollLeft",
            value: function _getCalculatedScrollLeft() {
                var props /*: Props*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var state /*: State*/  = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                return Grid._getCalculatedScrollLeft(props, state);
            }
        },
        {
            key: "_updateScrollLeftForScrollToColumn",
            value: function _updateScrollLeftForScrollToColumn() {
                var props /*: Props*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var state /*: State*/  = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                var stateUpdate = Grid._getScrollLeftForScrollToColumnStateUpdate(props, state);
                if (stateUpdate) {
                    stateUpdate.needToResetStyleCache = false;
                    this.setState(stateUpdate);
                }
            }
        },
        {
            key: "_getCalculatedScrollTop",
            value: function _getCalculatedScrollTop() {
                var props /*: Props*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var state /*: State*/  = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                return Grid._getCalculatedScrollTop(props, state);
            }
        },
        {
            key: "_resetStyleCache",
            value: function _resetStyleCache() {
                var styleCache = this._styleCache;
                var cellCache = this._cellCache;
                var isScrollingOptOut = this.props.isScrollingOptOut;
                // Reset cell and style caches once scrolling stops.
                // This makes Grid simpler to use (since cells commonly change).
                // And it keeps the caches from growing too large.
                // Performance is most sensitive when a user is scrolling.
                // Don't clear visible cells from cellCache if isScrollingOptOut is specified.
                // This keeps the cellCache to a resonable size.
                this._cellCache = {};
                this._styleCache = {};
                // Copy over the visible cell styles so avoid unnecessary re-render.
                for(var rowIndex = this._rowStartIndex; rowIndex <= this._rowStopIndex; rowIndex++)for(var columnIndex = this._columnStartIndex; columnIndex <= this._columnStopIndex; columnIndex++){
                    var key = "".concat(rowIndex, "-").concat(columnIndex);
                    this._styleCache[key] = styleCache[key];
                    if (isScrollingOptOut) this._cellCache[key] = cellCache[key];
                }
            }
        },
        {
            key: "_updateScrollTopForScrollToRow",
            value: function _updateScrollTopForScrollToRow() {
                var props /*: Props*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var state /*: State*/  = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                var stateUpdate = Grid._getScrollTopForScrollToRowStateUpdate(props, state);
                if (stateUpdate) {
                    stateUpdate.needToResetStyleCache = false;
                    this.setState(stateUpdate);
                }
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps /*: Props*/ , prevState /*: State*/ ) /*: $Shape<State>*/ {
                var newState = {};
                if (nextProps.columnCount === 0 && prevState.scrollLeft !== 0 || nextProps.rowCount === 0 && prevState.scrollTop !== 0) {
                    newState.scrollLeft = 0;
                    newState.scrollTop = 0;
                // only use scroll{Left,Top} from props if scrollTo{Column,Row} isn't specified
                // scrollTo{Column,Row} should override scroll{Left,Top}
                } else if (nextProps.scrollLeft !== prevState.scrollLeft && nextProps.scrollToColumn < 0 || nextProps.scrollTop !== prevState.scrollTop && nextProps.scrollToRow < 0) Object.assign(newState, Grid._getScrollToPositionStateUpdate({
                    prevState: prevState,
                    scrollLeft: nextProps.scrollLeft,
                    scrollTop: nextProps.scrollTop
                }));
                var instanceProps = prevState.instanceProps;
                // Initially we should not clearStyleCache
                newState.needToResetStyleCache = false;
                if (nextProps.columnWidth !== instanceProps.prevColumnWidth || nextProps.rowHeight !== instanceProps.prevRowHeight) // Reset cache. set it to {} in render
                newState.needToResetStyleCache = true;
                instanceProps.columnSizeAndPositionManager.configure({
                    cellCount: nextProps.columnCount,
                    estimatedCellSize: Grid._getEstimatedColumnSize(nextProps),
                    cellSizeGetter: Grid._wrapSizeGetter(nextProps.columnWidth)
                });
                instanceProps.rowSizeAndPositionManager.configure({
                    cellCount: nextProps.rowCount,
                    estimatedCellSize: Grid._getEstimatedRowSize(nextProps),
                    cellSizeGetter: Grid._wrapSizeGetter(nextProps.rowHeight)
                });
                if (instanceProps.prevColumnCount === 0 || instanceProps.prevRowCount === 0) {
                    instanceProps.prevColumnCount = 0;
                    instanceProps.prevRowCount = 0;
                }
                // If scrolling is controlled outside this component, clear cache when scrolling stops
                if (nextProps.autoHeight && nextProps.isScrolling === false && instanceProps.prevIsScrolling === true) Object.assign(newState, {
                    isScrolling: false
                });
                var maybeStateA;
                var maybeStateB;
                (0, $3536857614fccf62$var$_calculateSizeAndPositionDataAndUpdateScrollOffset["default"])({
                    cellCount: instanceProps.prevColumnCount,
                    cellSize: typeof instanceProps.prevColumnWidth === 'number' ? instanceProps.prevColumnWidth : null,
                    computeMetadataCallback: function computeMetadataCallback() {
                        return instanceProps.columnSizeAndPositionManager.resetCell(0);
                    },
                    computeMetadataCallbackProps: nextProps,
                    nextCellsCount: nextProps.columnCount,
                    nextCellSize: typeof nextProps.columnWidth === 'number' ? nextProps.columnWidth : null,
                    nextScrollToIndex: nextProps.scrollToColumn,
                    scrollToIndex: instanceProps.prevScrollToColumn,
                    updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
                        maybeStateA = Grid._getScrollLeftForScrollToColumnStateUpdate(nextProps, prevState);
                    }
                });
                (0, $3536857614fccf62$var$_calculateSizeAndPositionDataAndUpdateScrollOffset["default"])({
                    cellCount: instanceProps.prevRowCount,
                    cellSize: typeof instanceProps.prevRowHeight === 'number' ? instanceProps.prevRowHeight : null,
                    computeMetadataCallback: function computeMetadataCallback() {
                        return instanceProps.rowSizeAndPositionManager.resetCell(0);
                    },
                    computeMetadataCallbackProps: nextProps,
                    nextCellsCount: nextProps.rowCount,
                    nextCellSize: typeof nextProps.rowHeight === 'number' ? nextProps.rowHeight : null,
                    nextScrollToIndex: nextProps.scrollToRow,
                    scrollToIndex: instanceProps.prevScrollToRow,
                    updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
                        maybeStateB = Grid._getScrollTopForScrollToRowStateUpdate(nextProps, prevState);
                    }
                });
                instanceProps.prevColumnCount = nextProps.columnCount;
                instanceProps.prevColumnWidth = nextProps.columnWidth;
                instanceProps.prevIsScrolling = nextProps.isScrolling === true;
                instanceProps.prevRowCount = nextProps.rowCount;
                instanceProps.prevRowHeight = nextProps.rowHeight;
                instanceProps.prevScrollToColumn = nextProps.scrollToColumn;
                instanceProps.prevScrollToRow = nextProps.scrollToRow;
                // getting scrollBarSize (moved from componentWillMount)
                instanceProps.scrollbarSize = nextProps.getScrollbarSize();
                if (instanceProps.scrollbarSize === undefined) {
                    instanceProps.scrollbarSizeMeasured = false;
                    instanceProps.scrollbarSize = 0;
                } else instanceProps.scrollbarSizeMeasured = true;
                newState.instanceProps = instanceProps;
                return $3536857614fccf62$var$_objectSpread($3536857614fccf62$var$_objectSpread($3536857614fccf62$var$_objectSpread({}, newState), maybeStateA), maybeStateB);
            }
        },
        {
            key: "_getEstimatedColumnSize",
            value: function _getEstimatedColumnSize(props /*: Props*/ ) {
                return typeof props.columnWidth === 'number' ? props.columnWidth : props.estimatedColumnSize;
            }
        },
        {
            key: "_getEstimatedRowSize",
            value: function _getEstimatedRowSize(props /*: Props*/ ) {
                return typeof props.rowHeight === 'number' ? props.rowHeight : props.estimatedRowSize;
            }
        },
        {
            key: "_getScrollToPositionStateUpdate",
            value: /**
     * Get the updated state after scrolling to
     * scrollLeft and scrollTop
     */ function _getScrollToPositionStateUpdate(_ref9 /*:: */ ) /*: $Shape<State>*/ {
                var prevState = _ref9 /*:: */ .prevState, scrollLeft = _ref9 /*:: */ .scrollLeft, scrollTop = _ref9 /*:: */ .scrollTop;
                var newState /*: Object*/  = {
                    scrollPositionChangeReason: $3536857614fccf62$var$SCROLL_POSITION_CHANGE_REASONS.REQUESTED
                };
                if (typeof scrollLeft === 'number' && scrollLeft >= 0) {
                    newState.scrollDirectionHorizontal = scrollLeft > prevState.scrollLeft ? $3536857614fccf62$var$_defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD : $3536857614fccf62$var$_defaultOverscanIndicesGetter.SCROLL_DIRECTION_BACKWARD;
                    newState.scrollLeft = scrollLeft;
                }
                if (typeof scrollTop === 'number' && scrollTop >= 0) {
                    newState.scrollDirectionVertical = scrollTop > prevState.scrollTop ? $3536857614fccf62$var$_defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD : $3536857614fccf62$var$_defaultOverscanIndicesGetter.SCROLL_DIRECTION_BACKWARD;
                    newState.scrollTop = scrollTop;
                }
                if (typeof scrollLeft === 'number' && scrollLeft >= 0 && scrollLeft !== prevState.scrollLeft || typeof scrollTop === 'number' && scrollTop >= 0 && scrollTop !== prevState.scrollTop) return newState;
                return {};
            }
        },
        {
            key: "_wrapSizeGetter",
            value: function _wrapSizeGetter(value /*: CellSize*/ ) /*: CellSizeGetter*/ {
                return typeof value === 'function' ? value : function() {
                    return value /*: any*/ ;
                };
            }
        },
        {
            key: "_getCalculatedScrollLeft",
            value: function _getCalculatedScrollLeft(nextProps /*: Props*/ , prevState /*: State*/ ) {
                var columnCount = nextProps.columnCount, height = nextProps.height, scrollToAlignment = nextProps.scrollToAlignment, scrollToColumn = nextProps.scrollToColumn, width = nextProps.width;
                var scrollLeft = prevState.scrollLeft, instanceProps = prevState.instanceProps;
                if (columnCount > 0) {
                    var finalColumn = columnCount - 1;
                    var targetIndex = scrollToColumn < 0 ? finalColumn : Math.min(finalColumn, scrollToColumn);
                    var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
                    var scrollBarSize = instanceProps.scrollbarSizeMeasured && totalRowsHeight > height ? instanceProps.scrollbarSize : 0;
                    return instanceProps.columnSizeAndPositionManager.getUpdatedOffsetForIndex({
                        align: scrollToAlignment,
                        containerSize: width - scrollBarSize,
                        currentOffset: scrollLeft,
                        targetIndex: targetIndex
                    });
                }
                return 0;
            }
        },
        {
            key: "_getScrollLeftForScrollToColumnStateUpdate",
            value: function _getScrollLeftForScrollToColumnStateUpdate(nextProps /*: Props*/ , prevState /*: State*/ ) /*: $Shape<State>*/ {
                var scrollLeft = prevState.scrollLeft;
                var calculatedScrollLeft = Grid._getCalculatedScrollLeft(nextProps, prevState);
                if (typeof calculatedScrollLeft === 'number' && calculatedScrollLeft >= 0 && scrollLeft !== calculatedScrollLeft) return Grid._getScrollToPositionStateUpdate({
                    prevState: prevState,
                    scrollLeft: calculatedScrollLeft,
                    scrollTop: -1
                });
                return {};
            }
        },
        {
            key: "_getCalculatedScrollTop",
            value: function _getCalculatedScrollTop(nextProps /*: Props*/ , prevState /*: State*/ ) {
                var height = nextProps.height, rowCount = nextProps.rowCount, scrollToAlignment = nextProps.scrollToAlignment, scrollToRow = nextProps.scrollToRow, width = nextProps.width;
                var scrollTop = prevState.scrollTop, instanceProps = prevState.instanceProps;
                if (rowCount > 0) {
                    var finalRow = rowCount - 1;
                    var targetIndex = scrollToRow < 0 ? finalRow : Math.min(finalRow, scrollToRow);
                    var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
                    var scrollBarSize = instanceProps.scrollbarSizeMeasured && totalColumnsWidth > width ? instanceProps.scrollbarSize : 0;
                    return instanceProps.rowSizeAndPositionManager.getUpdatedOffsetForIndex({
                        align: scrollToAlignment,
                        containerSize: height - scrollBarSize,
                        currentOffset: scrollTop,
                        targetIndex: targetIndex
                    });
                }
                return 0;
            }
        },
        {
            key: "_getScrollTopForScrollToRowStateUpdate",
            value: function _getScrollTopForScrollToRowStateUpdate(nextProps /*: Props*/ , prevState /*: State*/ ) /*: $Shape<State>*/ {
                var scrollTop = prevState.scrollTop;
                var calculatedScrollTop = Grid._getCalculatedScrollTop(nextProps, prevState);
                if (typeof calculatedScrollTop === 'number' && calculatedScrollTop >= 0 && scrollTop !== calculatedScrollTop) return Grid._getScrollToPositionStateUpdate({
                    prevState: prevState,
                    scrollLeft: -1,
                    scrollTop: calculatedScrollTop
                });
                return {};
            }
        }
    ]);
}($3536857614fccf62$var$React.PureComponent);
(0, $3536857614fccf62$var$_defineProperty2["default"])($3536857614fccf62$var$Grid, "defaultProps", {
    'aria-label': 'grid',
    'aria-readonly': true,
    autoContainerWidth: false,
    autoHeight: false,
    autoWidth: false,
    cellRangeRenderer: $3536857614fccf62$var$_defaultCellRangeRenderer["default"],
    containerRole: 'row',
    containerStyle: {},
    estimatedColumnSize: 100,
    estimatedRowSize: 30,
    getScrollbarSize: $3536857614fccf62$var$_scrollbarSize["default"],
    noContentRenderer: $3536857614fccf62$var$renderNull,
    onScroll: function onScroll() {},
    onScrollbarPresenceChange: function onScrollbarPresenceChange() {},
    onSectionRendered: function onSectionRendered() {},
    overscanColumnCount: 0,
    overscanIndicesGetter: $3536857614fccf62$var$_defaultOverscanIndicesGetter["default"],
    overscanRowCount: 10,
    role: 'grid',
    scrollingResetTimeInterval: $3536857614fccf62$var$DEFAULT_SCROLLING_RESET_TIME_INTERVAL,
    scrollToAlignment: 'auto',
    scrollToColumn: -1,
    scrollToRow: -1,
    style: {},
    tabIndex: 0,
    isScrollingOptOut: false
});
(0, $8EdHV.polyfill)($3536857614fccf62$var$Grid);
var $3536857614fccf62$var$_default = module.exports["default"] = $3536857614fccf62$var$Grid;

});

parcelRegister("1lm4p", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $0fa8df43015edfcc$var$calculateSizeAndPositionDataAndUpdateScrollOffset;
/**
 * Helper method that determines when to recalculate row or column metadata.
 */ /*:: type Params<T> = {
  // Number of rows or columns in the current axis
  cellCount: number,

  // Width or height of cells for the current axis
  cellSize: ?number,

  // Method to invoke if cell metadata should be recalculated
  computeMetadataCallback: (props: T) => void,

  // Parameters to pass to :computeMetadataCallback
  computeMetadataCallbackProps: T,

  // Newly updated number of rows or columns in the current axis
  nextCellsCount: number,

  // Newly updated width or height of cells for the current axis
  nextCellSize: ?number,

  // Newly updated scroll-to-index
  nextScrollToIndex: number,

  // Scroll-to-index
  scrollToIndex: number,

  // Callback to invoke if the scroll position should be recalculated
  updateScrollOffsetForScrollToIndex: () => void,
};*/ function $0fa8df43015edfcc$var$calculateSizeAndPositionDataAndUpdateScrollOffset(_ref /*:: */ ) {
    var cellCount = _ref /*:: */ .cellCount, cellSize = _ref /*:: */ .cellSize, computeMetadataCallback = _ref /*:: */ .computeMetadataCallback, computeMetadataCallbackProps = _ref /*:: */ .computeMetadataCallbackProps, nextCellsCount = _ref /*:: */ .nextCellsCount, nextCellSize = _ref /*:: */ .nextCellSize, nextScrollToIndex = _ref /*:: */ .nextScrollToIndex, scrollToIndex = _ref /*:: */ .scrollToIndex, updateScrollOffsetForScrollToIndex = _ref /*:: */ .updateScrollOffsetForScrollToIndex;
    // Don't compare cell sizes if they are functions because inline functions would cause infinite loops.
    // In that event users should use the manual recompute methods to inform of changes.
    if (cellCount !== nextCellsCount || (typeof cellSize === 'number' || typeof nextCellSize === 'number') && cellSize !== nextCellSize) {
        computeMetadataCallback(computeMetadataCallbackProps);
        // Updated cell metadata may have hidden the previous scrolled-to item.
        // In this case we should also update the scrollTop to ensure it stays visible.
        if (scrollToIndex >= 0 && scrollToIndex === nextScrollToIndex) updateScrollOffsetForScrollToIndex();
    }
}

});

parcelRegister("l3uqv", function(module, exports) {
"use strict";

var $eGvGZ = parcelRequire("eGvGZ");

Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $f5417addafde8051$var$_objectWithoutProperties2 = $eGvGZ((parcelRequire("gmDkm")));

var $f5417addafde8051$var$_classCallCheck2 = $eGvGZ((parcelRequire("c2Q7G")));

var $f5417addafde8051$var$_createClass2 = $eGvGZ((parcelRequire("iyK4o")));

var $f5417addafde8051$var$_defineProperty2 = $eGvGZ((parcelRequire("l2SD1")));

var $f5417addafde8051$var$_CellSizeAndPositionManager = $eGvGZ((parcelRequire("7UU7y")));

var $9hl0i = parcelRequire("9hl0i");

var $f5417addafde8051$var$_excluded = [
    "maxScrollSize"
];
/*:: import type {Alignment, CellSizeGetter, VisibleCellRange} from '../types';*/ /*:: type ContainerSizeAndOffset = {
  containerSize: number,
  offset: number,
};*/ /*:: type Params = {
  maxScrollSize?: number,
  cellCount: number,
  cellSizeGetter: CellSizeGetter,
  estimatedCellSize: number,
};*/ /**
 * Browsers have scroll offset limitations (eg Chrome stops scrolling at ~33.5M pixels where as Edge tops out at ~1.5M pixels).
 * After a certain position, the browser won't allow the user to scroll further (even via JavaScript scroll offset adjustments).
 * This util picks a lower ceiling for max size and artificially adjusts positions within to make it transparent for users.
 */ /**
 * Extends CellSizeAndPositionManager and adds scaling behavior for lists that are too large to fit within a browser's native limits.
 */ var $f5417addafde8051$var$ScalingCellSizeAndPositionManager = module.exports["default"] = /*#__PURE__*/ function() {
    function ScalingCellSizeAndPositionManager(_ref /*:: */ ) {
        var _ref$maxScrollSize = _ref /*:: */ .maxScrollSize, maxScrollSize = _ref$maxScrollSize === void 0 ? (0, $9hl0i.getMaxElementSize)() : _ref$maxScrollSize, params = (0, $f5417addafde8051$var$_objectWithoutProperties2["default"])(_ref /*:: */ , $f5417addafde8051$var$_excluded);
        (0, $f5417addafde8051$var$_classCallCheck2["default"])(this, ScalingCellSizeAndPositionManager);
        (0, $f5417addafde8051$var$_defineProperty2["default"])(this, "_cellSizeAndPositionManager", void 0);
        (0, $f5417addafde8051$var$_defineProperty2["default"])(this, "_maxScrollSize", void 0);
        // Favor composition over inheritance to simplify IE10 support
        this._cellSizeAndPositionManager = new $f5417addafde8051$var$_CellSizeAndPositionManager["default"](params);
        this._maxScrollSize = maxScrollSize;
    }
    return (0, $f5417addafde8051$var$_createClass2["default"])(ScalingCellSizeAndPositionManager, [
        {
            key: "areOffsetsAdjusted",
            value: function areOffsetsAdjusted() /*: boolean*/ {
                return this._cellSizeAndPositionManager.getTotalSize() > this._maxScrollSize;
            }
        },
        {
            key: "configure",
            value: function configure(params) {
                this._cellSizeAndPositionManager.configure(params);
            }
        },
        {
            key: "getCellCount",
            value: function getCellCount() /*: number*/ {
                return this._cellSizeAndPositionManager.getCellCount();
            }
        },
        {
            key: "getEstimatedCellSize",
            value: function getEstimatedCellSize() /*: number*/ {
                return this._cellSizeAndPositionManager.getEstimatedCellSize();
            }
        },
        {
            key: "getLastMeasuredIndex",
            value: function getLastMeasuredIndex() /*: number*/ {
                return this._cellSizeAndPositionManager.getLastMeasuredIndex();
            }
        },
        {
            key: "getOffsetAdjustment",
            value: function getOffsetAdjustment(_ref2 /*:: */ ) /*: number*/ {
                var containerSize = _ref2 /*:: */ .containerSize, offset = _ref2 /*:: */ .offset;
                var totalSize = this._cellSizeAndPositionManager.getTotalSize();
                var safeTotalSize = this.getTotalSize();
                var offsetPercentage = this._getOffsetPercentage({
                    containerSize: containerSize,
                    offset: offset,
                    totalSize: safeTotalSize
                });
                return Math.round(offsetPercentage * (safeTotalSize - totalSize));
            }
        },
        {
            key: "getSizeAndPositionOfCell",
            value: function getSizeAndPositionOfCell(index /*: number*/ ) {
                return this._cellSizeAndPositionManager.getSizeAndPositionOfCell(index);
            }
        },
        {
            key: "getSizeAndPositionOfLastMeasuredCell",
            value: function getSizeAndPositionOfLastMeasuredCell() {
                return this._cellSizeAndPositionManager.getSizeAndPositionOfLastMeasuredCell();
            }
        },
        {
            key: "getTotalSize",
            value: function getTotalSize() /*: number*/ {
                return Math.min(this._maxScrollSize, this._cellSizeAndPositionManager.getTotalSize());
            }
        },
        {
            key: "getUpdatedOffsetForIndex",
            value: function getUpdatedOffsetForIndex(_ref3 /*:: */ ) {
                var _ref3$align = _ref3 /*:: */ .align, align = _ref3$align === void 0 ? 'auto' : _ref3$align, containerSize = _ref3 /*:: */ .containerSize, currentOffset = _ref3 /*:: */ .currentOffset, targetIndex = _ref3 /*:: */ .targetIndex;
                currentOffset = this._safeOffsetToOffset({
                    containerSize: containerSize,
                    offset: currentOffset
                });
                var offset = this._cellSizeAndPositionManager.getUpdatedOffsetForIndex({
                    align: align,
                    containerSize: containerSize,
                    currentOffset: currentOffset,
                    targetIndex: targetIndex
                });
                return this._offsetToSafeOffset({
                    containerSize: containerSize,
                    offset: offset
                });
            }
        },
        {
            key: "getVisibleCellRange",
            value: function getVisibleCellRange(_ref4 /*:: */ ) /*: VisibleCellRange*/ {
                var containerSize = _ref4 /*:: */ .containerSize, offset = _ref4 /*:: */ .offset;
                offset = this._safeOffsetToOffset({
                    containerSize: containerSize,
                    offset: offset
                });
                return this._cellSizeAndPositionManager.getVisibleCellRange({
                    containerSize: containerSize,
                    offset: offset
                });
            }
        },
        {
            key: "resetCell",
            value: function resetCell(index /*: number*/ ) /*: void*/ {
                this._cellSizeAndPositionManager.resetCell(index);
            }
        },
        {
            key: "_getOffsetPercentage",
            value: function _getOffsetPercentage(_ref5 /*:: */ ) {
                var containerSize = _ref5 /*:: */ .containerSize, offset = _ref5 /*:: */ .offset, totalSize = _ref5 /*:: */ .totalSize;
                return totalSize <= containerSize ? 0 : offset / (totalSize - containerSize);
            }
        },
        {
            key: "_offsetToSafeOffset",
            value: function _offsetToSafeOffset(_ref6 /*:: */ ) /*: number*/ {
                var containerSize = _ref6 /*:: */ .containerSize, offset = _ref6 /*:: */ .offset;
                var totalSize = this._cellSizeAndPositionManager.getTotalSize();
                var safeTotalSize = this.getTotalSize();
                if (totalSize === safeTotalSize) return offset;
                else {
                    var offsetPercentage = this._getOffsetPercentage({
                        containerSize: containerSize,
                        offset: offset,
                        totalSize: totalSize
                    });
                    return Math.round(offsetPercentage * (safeTotalSize - containerSize));
                }
            }
        },
        {
            key: "_safeOffsetToOffset",
            value: function _safeOffsetToOffset(_ref7 /*:: */ ) /*: number*/ {
                var containerSize = _ref7 /*:: */ .containerSize, offset = _ref7 /*:: */ .offset;
                var totalSize = this._cellSizeAndPositionManager.getTotalSize();
                var safeTotalSize = this.getTotalSize();
                if (totalSize === safeTotalSize) return offset;
                else {
                    var offsetPercentage = this._getOffsetPercentage({
                        containerSize: containerSize,
                        offset: offset,
                        totalSize: safeTotalSize
                    });
                    return Math.round(offsetPercentage * (totalSize - containerSize));
                }
            }
        }
    ]);
}();

});

parcelRegister("gmDkm", function(module, exports) {

var $6Ahnn = parcelRequire("6Ahnn");

function $be9d3504f7275c11$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $6Ahnn(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
module.exports = $be9d3504f7275c11$var$_objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("7UU7y", function(module, exports) {
"use strict";

var $eGvGZ = parcelRequire("eGvGZ");

Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $5c394bc892626a52$var$_classCallCheck2 = $eGvGZ((parcelRequire("c2Q7G")));

var $5c394bc892626a52$var$_createClass2 = $eGvGZ((parcelRequire("iyK4o")));

var $5c394bc892626a52$var$_defineProperty2 = $eGvGZ((parcelRequire("l2SD1")));
/*:: import type {Alignment, CellSizeGetter, VisibleCellRange} from '../types';*/ /*:: type CellSizeAndPositionManagerParams = {
  cellCount: number,
  cellSizeGetter: CellSizeGetter,
  estimatedCellSize: number,
};*/ /*:: type ConfigureParams = {
  cellCount: number,
  estimatedCellSize: number,
  cellSizeGetter: CellSizeGetter,
};*/ /*:: type GetUpdatedOffsetForIndex = {
  align: Alignment,
  containerSize: number,
  currentOffset: number,
  targetIndex: number,
};*/ /*:: type GetVisibleCellRangeParams = {
  containerSize: number,
  offset: number,
};*/ /*:: type SizeAndPositionData = {
  offset: number,
  size: number,
};*/ /**
 * Just-in-time calculates and caches size and position information for a collection of cells.
 */ var $5c394bc892626a52$var$CellSizeAndPositionManager = module.exports["default"] = /*#__PURE__*/ function() {
    function CellSizeAndPositionManager(_ref /*:: */ ) {
        var cellCount = _ref /*:: */ .cellCount, cellSizeGetter = _ref /*:: */ .cellSizeGetter, estimatedCellSize = _ref /*:: */ .estimatedCellSize;
        (0, $5c394bc892626a52$var$_classCallCheck2["default"])(this, CellSizeAndPositionManager);
        // Cache of size and position data for cells, mapped by cell index.
        // Note that invalid values may exist in this map so only rely on cells up to this._lastMeasuredIndex
        (0, $5c394bc892626a52$var$_defineProperty2["default"])(this, "_cellSizeAndPositionData", {});
        // Measurements for cells up to this index can be trusted; cells afterward should be estimated.
        (0, $5c394bc892626a52$var$_defineProperty2["default"])(this, "_lastMeasuredIndex", -1);
        // Used in deferred mode to track which cells have been queued for measurement.
        (0, $5c394bc892626a52$var$_defineProperty2["default"])(this, "_lastBatchedIndex", -1);
        (0, $5c394bc892626a52$var$_defineProperty2["default"])(this, "_cellCount", void 0);
        (0, $5c394bc892626a52$var$_defineProperty2["default"])(this, "_cellSizeGetter", void 0);
        (0, $5c394bc892626a52$var$_defineProperty2["default"])(this, "_estimatedCellSize", void 0);
        this._cellSizeGetter = cellSizeGetter;
        this._cellCount = cellCount;
        this._estimatedCellSize = estimatedCellSize;
    }
    return (0, $5c394bc892626a52$var$_createClass2["default"])(CellSizeAndPositionManager, [
        {
            key: "areOffsetsAdjusted",
            value: function areOffsetsAdjusted() {
                return false;
            }
        },
        {
            key: "configure",
            value: function configure(_ref2 /*:: */ ) {
                var cellCount = _ref2 /*:: */ .cellCount, estimatedCellSize = _ref2 /*:: */ .estimatedCellSize, cellSizeGetter = _ref2 /*:: */ .cellSizeGetter;
                this._cellCount = cellCount;
                this._estimatedCellSize = estimatedCellSize;
                this._cellSizeGetter = cellSizeGetter;
            }
        },
        {
            key: "getCellCount",
            value: function getCellCount() /*: number*/ {
                return this._cellCount;
            }
        },
        {
            key: "getEstimatedCellSize",
            value: function getEstimatedCellSize() /*: number*/ {
                return this._estimatedCellSize;
            }
        },
        {
            key: "getLastMeasuredIndex",
            value: function getLastMeasuredIndex() /*: number*/ {
                return this._lastMeasuredIndex;
            }
        },
        {
            key: "getOffsetAdjustment",
            value: function getOffsetAdjustment() {
                return 0;
            }
        },
        {
            key: "getSizeAndPositionOfCell",
            value: function getSizeAndPositionOfCell(index /*: number*/ ) /*: SizeAndPositionData*/ {
                if (index < 0 || index >= this._cellCount) throw Error("Requested index ".concat(index, " is outside of range 0..").concat(this._cellCount));
                if (index > this._lastMeasuredIndex) {
                    var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
                    var offset = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;
                    for(var i = this._lastMeasuredIndex + 1; i <= index; i++){
                        var size = this._cellSizeGetter({
                            index: i
                        });
                        // undefined or NaN probably means a logic error in the size getter.
                        // null means we're using CellMeasurer and haven't yet measured a given index.
                        if (size === undefined || isNaN(size)) throw Error("Invalid size returned for cell ".concat(i, " of value ").concat(size));
                        else if (size === null) {
                            this._cellSizeAndPositionData[i] = {
                                offset: offset,
                                size: 0
                            };
                            this._lastBatchedIndex = index;
                        } else {
                            this._cellSizeAndPositionData[i] = {
                                offset: offset,
                                size: size
                            };
                            offset += size;
                            this._lastMeasuredIndex = index;
                        }
                    }
                }
                return this._cellSizeAndPositionData[index];
            }
        },
        {
            key: "getSizeAndPositionOfLastMeasuredCell",
            value: function getSizeAndPositionOfLastMeasuredCell() /*: SizeAndPositionData*/ {
                return this._lastMeasuredIndex >= 0 ? this._cellSizeAndPositionData[this._lastMeasuredIndex] : {
                    offset: 0,
                    size: 0
                };
            }
        },
        {
            key: "getTotalSize",
            value: function getTotalSize() /*: number*/ {
                var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
                var totalSizeOfMeasuredCells = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;
                var numUnmeasuredCells = this._cellCount - this._lastMeasuredIndex - 1;
                var totalSizeOfUnmeasuredCells = numUnmeasuredCells * this._estimatedCellSize;
                return totalSizeOfMeasuredCells + totalSizeOfUnmeasuredCells;
            }
        },
        {
            key: "getUpdatedOffsetForIndex",
            value: function getUpdatedOffsetForIndex(_ref3 /*:: */ ) /*: number*/ {
                var _ref3$align = _ref3 /*:: */ .align, align = _ref3$align === void 0 ? 'auto' : _ref3$align, containerSize = _ref3 /*:: */ .containerSize, currentOffset = _ref3 /*:: */ .currentOffset, targetIndex = _ref3 /*:: */ .targetIndex;
                if (containerSize <= 0) return 0;
                var datum = this.getSizeAndPositionOfCell(targetIndex);
                var maxOffset = datum.offset;
                var minOffset = maxOffset - containerSize + datum.size;
                var idealOffset;
                switch(align){
                    case 'start':
                        idealOffset = maxOffset;
                        break;
                    case 'end':
                        idealOffset = minOffset;
                        break;
                    case 'center':
                        idealOffset = maxOffset - (containerSize - datum.size) / 2;
                        break;
                    default:
                        idealOffset = Math.max(minOffset, Math.min(maxOffset, currentOffset));
                        break;
                }
                var totalSize = this.getTotalSize();
                return Math.max(0, Math.min(totalSize - containerSize, idealOffset));
            }
        },
        {
            key: "getVisibleCellRange",
            value: function getVisibleCellRange(params /*: GetVisibleCellRangeParams*/ ) /*: VisibleCellRange*/ {
                var containerSize = params.containerSize, offset = params.offset;
                var totalSize = this.getTotalSize();
                if (totalSize === 0) return {};
                var maxOffset = offset + containerSize;
                var start = this._findNearestCell(offset);
                var datum = this.getSizeAndPositionOfCell(start);
                offset = datum.offset + datum.size;
                var stop = start;
                while(offset < maxOffset && stop < this._cellCount - 1){
                    stop++;
                    offset += this.getSizeAndPositionOfCell(stop).size;
                }
                return {
                    start: start,
                    stop: stop
                };
            }
        },
        {
            key: "resetCell",
            value: function resetCell(index /*: number*/ ) /*: void*/ {
                this._lastMeasuredIndex = Math.min(this._lastMeasuredIndex, index - 1);
            }
        },
        {
            key: "_binarySearch",
            value: function _binarySearch(high /*: number*/ , low /*: number*/ , offset /*: number*/ ) /*: number*/ {
                while(low <= high){
                    var middle = low + Math.floor((high - low) / 2);
                    var currentOffset = this.getSizeAndPositionOfCell(middle).offset;
                    if (currentOffset === offset) return middle;
                    else if (currentOffset < offset) low = middle + 1;
                    else if (currentOffset > offset) high = middle - 1;
                }
                if (low > 0) return low - 1;
                else return 0;
            }
        },
        {
            key: "_exponentialSearch",
            value: function _exponentialSearch(index /*: number*/ , offset /*: number*/ ) /*: number*/ {
                var interval = 1;
                while(index < this._cellCount && this.getSizeAndPositionOfCell(index).offset < offset){
                    index += interval;
                    interval *= 2;
                }
                return this._binarySearch(Math.min(index, this._cellCount - 1), Math.floor(index / 2), offset);
            }
        },
        {
            key: "_findNearestCell",
            value: function _findNearestCell(offset /*: number*/ ) /*: number*/ {
                if (isNaN(offset)) throw Error("Invalid offset ".concat(offset, " specified"));
                // Our search algorithms find the nearest match at or below the specified offset.
                // So make sure the offset is at least 0 or no match will be found.
                offset = Math.max(0, offset);
                var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
                var lastMeasuredIndex = Math.max(0, this._lastMeasuredIndex);
                if (lastMeasuredCellSizeAndPosition.offset >= offset) // If we've already measured cells within this range just use a binary search as it's faster.
                return this._binarySearch(lastMeasuredIndex, 0, offset);
                else // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
                // The exponential search avoids pre-computing sizes for the full set of cells as a binary search would.
                // The overall complexity for this approach is O(log n).
                return this._exponentialSearch(lastMeasuredIndex, offset);
            }
        }
    ]);
}();

});

parcelRegister("1qRum", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $10b1b5e1bc77f207$var$createCallbackMemoizer;
/**
 * Helper utility that updates the specified callback whenever any of the specified indices have changed.
 */ function $10b1b5e1bc77f207$var$createCallbackMemoizer() {
    var requireAllKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var cachedIndices = {};
    return function(_ref) {
        var callback = _ref.callback, indices = _ref.indices;
        var keys = Object.keys(indices);
        var allInitialized = !requireAllKeys || keys.every(function(key) {
            var value = indices[key];
            return Array.isArray(value) ? value.length > 0 : value >= 0;
        });
        var indexChanged = keys.length !== Object.keys(cachedIndices).length || keys.some(function(key) {
            var cachedValue = cachedIndices[key];
            var value = indices[key];
            return Array.isArray(value) ? cachedValue.join(',') !== value.join(',') : cachedValue !== value;
        });
        cachedIndices = indices;
        if (allInitialized && indexChanged) callback(indices);
    };
}

});

parcelRegister("1jCVK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SCROLL_DIRECTION_VERTICAL = module.exports.SCROLL_DIRECTION_HORIZONTAL = module.exports.SCROLL_DIRECTION_FORWARD = module.exports.SCROLL_DIRECTION_BACKWARD = void 0;
module.exports["default"] = $0f55c38c8f60f48a$var$defaultOverscanIndicesGetter;
/*:: import type {OverscanIndicesGetterParams, OverscanIndices} from './types';*/ var $0f55c38c8f60f48a$var$SCROLL_DIRECTION_BACKWARD = module.exports.SCROLL_DIRECTION_BACKWARD = -1;
var $0f55c38c8f60f48a$var$SCROLL_DIRECTION_FORWARD = module.exports.SCROLL_DIRECTION_FORWARD = 1;
var $0f55c38c8f60f48a$var$SCROLL_DIRECTION_HORIZONTAL = module.exports.SCROLL_DIRECTION_HORIZONTAL = 'horizontal';
var $0f55c38c8f60f48a$var$SCROLL_DIRECTION_VERTICAL = module.exports.SCROLL_DIRECTION_VERTICAL = 'vertical';
/**
 * Calculates the number of cells to overscan before and after a specified range.
 * This function ensures that overscanning doesn't exceed the available cells.
 */ function $0f55c38c8f60f48a$var$defaultOverscanIndicesGetter(_ref /*:: */ ) /*: OverscanIndices*/ {
    var cellCount = _ref /*:: */ .cellCount, overscanCellsCount = _ref /*:: */ .overscanCellsCount, scrollDirection = _ref /*:: */ .scrollDirection, startIndex = _ref /*:: */ .startIndex, stopIndex = _ref /*:: */ .stopIndex;
    if (scrollDirection === $0f55c38c8f60f48a$var$SCROLL_DIRECTION_FORWARD) return {
        overscanStartIndex: Math.max(0, startIndex),
        overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
    };
    else return {
        overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
        overscanStopIndex: Math.min(cellCount - 1, stopIndex)
    };
}

});

parcelRegister("bjahi", function(module, exports) {
"use strict";

var $eGvGZ = parcelRequire("eGvGZ");

Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $83b97110548ad8f3$var$updateScrollIndexHelper;

var $83b97110548ad8f3$var$_ScalingCellSizeAndPositionManager = $eGvGZ((parcelRequire("l3uqv")));
/*:: import type {Alignment, CellSize} from '../types';*/ /**
 * Helper function that determines when to update scroll offsets to ensure that a scroll-to-index remains visible.
 * This function also ensures that the scroll ofset isn't past the last column/row of cells.
 */ /*:: type Params = {
  // Width or height of cells for the current axis
  cellSize?: CellSize,

  // Manages size and position metadata of cells
  cellSizeAndPositionManager: ScalingCellSizeAndPositionManager,

  // Previous number of rows or columns
  previousCellsCount: number,

  // Previous width or height of cells
  previousCellSize: CellSize,

  previousScrollToAlignment: Alignment,

  // Previous scroll-to-index
  previousScrollToIndex: number,

  // Previous width or height of the virtualized container
  previousSize: number,

  // Current scrollLeft or scrollTop
  scrollOffset: number,

  scrollToAlignment: Alignment,

  // Scroll-to-index
  scrollToIndex: number,

  // Width or height of the virtualized container
  size: number,

  sizeJustIncreasedFromZero: boolean,

  // Callback to invoke with an scroll-to-index value
  updateScrollIndexCallback: (index: number) => void,
};*/ function $83b97110548ad8f3$var$updateScrollIndexHelper(_ref /*:: */ ) {
    var cellSize = _ref /*:: */ .cellSize, cellSizeAndPositionManager = _ref /*:: */ .cellSizeAndPositionManager, previousCellsCount = _ref /*:: */ .previousCellsCount, previousCellSize = _ref /*:: */ .previousCellSize, previousScrollToAlignment = _ref /*:: */ .previousScrollToAlignment, previousScrollToIndex = _ref /*:: */ .previousScrollToIndex, previousSize = _ref /*:: */ .previousSize, scrollOffset = _ref /*:: */ .scrollOffset, scrollToAlignment = _ref /*:: */ .scrollToAlignment, scrollToIndex = _ref /*:: */ .scrollToIndex, size = _ref /*:: */ .size, sizeJustIncreasedFromZero = _ref /*:: */ .sizeJustIncreasedFromZero, updateScrollIndexCallback = _ref /*:: */ .updateScrollIndexCallback;
    var cellCount = cellSizeAndPositionManager.getCellCount();
    var hasScrollToIndex = scrollToIndex >= 0 && scrollToIndex < cellCount;
    var sizeHasChanged = size !== previousSize || sizeJustIncreasedFromZero || !previousCellSize || typeof cellSize === 'number' && cellSize !== previousCellSize;
    // If we have a new scroll target OR if height/row-height has changed,
    // We should ensure that the scroll target is visible.
    if (hasScrollToIndex && (sizeHasChanged || scrollToAlignment !== previousScrollToAlignment || scrollToIndex !== previousScrollToIndex)) updateScrollIndexCallback(scrollToIndex);
    else if (!hasScrollToIndex && cellCount > 0 && (size < previousSize || cellCount < previousCellsCount)) // We need to ensure that the current scroll offset is still within the collection's range.
    // To do this, we don't need to measure everything; CellMeasurer would perform poorly.
    // Just check to make sure we're still okay.
    // Only adjust the scroll position if we've scrolled below the last set of rows.
    {
        if (scrollOffset > cellSizeAndPositionManager.getTotalSize() - size) updateScrollIndexCallback(cellCount - 1);
    }
}

});

parcelRegister("hbetg", function(module, exports) {
"use strict";

var $eGvGZ = parcelRequire("eGvGZ");

Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $c81eb0662207a7c5$var$defaultCellRangeRenderer;

var $c81eb0662207a7c5$var$_react = $eGvGZ((parcelRequire("42omo")));
/*:: import type {CellRangeRendererParams} from './types';*/ /**
 * Default implementation of cellRangeRenderer used by Grid.
 * This renderer supports cell-caching while the user is scrolling.
 */ function $c81eb0662207a7c5$var$defaultCellRangeRenderer(_ref /*:: */ ) {
    var cellCache = _ref /*:: */ .cellCache, cellRenderer = _ref /*:: */ .cellRenderer, columnSizeAndPositionManager = _ref /*:: */ .columnSizeAndPositionManager, columnStartIndex = _ref /*:: */ .columnStartIndex, columnStopIndex = _ref /*:: */ .columnStopIndex, deferredMeasurementCache = _ref /*:: */ .deferredMeasurementCache, horizontalOffsetAdjustment = _ref /*:: */ .horizontalOffsetAdjustment, isScrolling = _ref /*:: */ .isScrolling, isScrollingOptOut = _ref /*:: */ .isScrollingOptOut, parent = _ref /*:: */ .parent, rowSizeAndPositionManager = _ref /*:: */ .rowSizeAndPositionManager, rowStartIndex = _ref /*:: */ .rowStartIndex, rowStopIndex = _ref /*:: */ .rowStopIndex, styleCache = _ref /*:: */ .styleCache, verticalOffsetAdjustment = _ref /*:: */ .verticalOffsetAdjustment, visibleColumnIndices = _ref /*:: */ .visibleColumnIndices, visibleRowIndices = _ref /*:: */ .visibleRowIndices;
    var renderedCells = [];
    // Browsers have native size limits for elements (eg Chrome 33M pixels, IE 1.5M pixes).
    // User cannot scroll beyond these size limitations.
    // In order to work around this, ScalingCellSizeAndPositionManager compresses offsets.
    // We should never cache styles for compressed offsets though as this can lead to bugs.
    // See issue #576 for more.
    var areOffsetsAdjusted = columnSizeAndPositionManager.areOffsetsAdjusted() || rowSizeAndPositionManager.areOffsetsAdjusted();
    var canCacheStyle = !isScrolling && !areOffsetsAdjusted;
    for(var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++){
        var rowDatum = rowSizeAndPositionManager.getSizeAndPositionOfCell(rowIndex);
        for(var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++){
            var columnDatum = columnSizeAndPositionManager.getSizeAndPositionOfCell(columnIndex);
            var isVisible = columnIndex >= visibleColumnIndices.start && columnIndex <= visibleColumnIndices.stop && rowIndex >= visibleRowIndices.start && rowIndex <= visibleRowIndices.stop;
            var key = "".concat(rowIndex, "-").concat(columnIndex);
            var style = void 0;
            // Cache style objects so shallow-compare doesn't re-render unnecessarily.
            if (canCacheStyle && styleCache[key]) style = styleCache[key];
            else // In deferred mode, cells will be initially rendered before we know their size.
            // Don't interfere with CellMeasurer's measurements by setting an invalid size.
            if (deferredMeasurementCache && !deferredMeasurementCache.has(rowIndex, columnIndex)) // Position not-yet-measured cells at top/left 0,0,
            // And give them width/height of 'auto' so they can grow larger than the parent Grid if necessary.
            // Positioning them further to the right/bottom influences their measured size.
            style = {
                height: 'auto',
                left: 0,
                position: 'absolute',
                top: 0,
                width: 'auto'
            };
            else {
                style = {
                    height: rowDatum.size,
                    left: columnDatum.offset + horizontalOffsetAdjustment,
                    position: 'absolute',
                    top: rowDatum.offset + verticalOffsetAdjustment,
                    width: columnDatum.size
                };
                styleCache[key] = style;
            }
            var cellRendererParams = {
                columnIndex: columnIndex,
                isScrolling: isScrolling,
                isVisible: isVisible,
                key: key,
                parent: parent,
                rowIndex: rowIndex,
                style: style
            };
            var renderedCell = void 0;
            // Avoid re-creating cells while scrolling.
            // This can lead to the same cell being created many times and can cause performance issues for "heavy" cells.
            // If a scroll is in progress- cache and reuse cells.
            // This cache will be thrown away once scrolling completes.
            // However if we are scaling scroll positions and sizes, we should also avoid caching.
            // This is because the offset changes slightly as scroll position changes and caching leads to stale values.
            // For more info refer to issue #395
            //
            // If isScrollingOptOut is specified, we always cache cells.
            // For more info refer to issue #1028
            if ((isScrollingOptOut || isScrolling) && !horizontalOffsetAdjustment && !verticalOffsetAdjustment) {
                if (!cellCache[key]) cellCache[key] = cellRenderer(cellRendererParams);
                renderedCell = cellCache[key];
            // If the user is no longer scrolling, don't cache cells.
            // This makes dynamic cell content difficult for users and would also lead to a heavier memory footprint.
            } else renderedCell = cellRenderer(cellRendererParams);
            if (renderedCell == null || renderedCell === false) continue;
            if (!renderedCell.props.role) renderedCell = /*#__PURE__*/ $c81eb0662207a7c5$var$_react["default"].cloneElement(renderedCell, {
                role: 'gridcell'
            });
            renderedCells.push(renderedCell);
        }
    }
    return renderedCells;
}
function $c81eb0662207a7c5$var$warnAboutMissingStyle(parent, renderedCell) {}

});

parcelRegister("4rbRt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SCROLL_DIRECTION_VERTICAL = module.exports.SCROLL_DIRECTION_HORIZONTAL = module.exports.SCROLL_DIRECTION_FORWARD = module.exports.SCROLL_DIRECTION_BACKWARD = void 0;
module.exports["default"] = $33b2e281b7a26778$var$defaultOverscanIndicesGetter;
/*:: import type {OverscanIndicesGetterParams, OverscanIndices} from './types';*/ var $33b2e281b7a26778$var$SCROLL_DIRECTION_BACKWARD = module.exports.SCROLL_DIRECTION_BACKWARD = -1;
var $33b2e281b7a26778$var$SCROLL_DIRECTION_FORWARD = module.exports.SCROLL_DIRECTION_FORWARD = 1;
var $33b2e281b7a26778$var$SCROLL_DIRECTION_HORIZONTAL = module.exports.SCROLL_DIRECTION_HORIZONTAL = 'horizontal';
var $33b2e281b7a26778$var$SCROLL_DIRECTION_VERTICAL = module.exports.SCROLL_DIRECTION_VERTICAL = 'vertical';
/**
 * Calculates the number of cells to overscan before and after a specified range.
 * This function ensures that overscanning doesn't exceed the available cells.
 */ function $33b2e281b7a26778$var$defaultOverscanIndicesGetter(_ref /*:: */ ) /*: OverscanIndices*/ {
    var cellCount = _ref /*:: */ .cellCount, overscanCellsCount = _ref /*:: */ .overscanCellsCount, scrollDirection = _ref /*:: */ .scrollDirection, startIndex = _ref /*:: */ .startIndex, stopIndex = _ref /*:: */ .stopIndex;
    // Make sure we render at least 1 cell extra before and after (except near boundaries)
    // This is necessary in order to support keyboard navigation (TAB/SHIFT+TAB) in some cases
    // For more info see issues #625
    overscanCellsCount = Math.max(1, overscanCellsCount);
    if (scrollDirection === $33b2e281b7a26778$var$SCROLL_DIRECTION_FORWARD) return {
        overscanStartIndex: Math.max(0, startIndex - 1),
        overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
    };
    else return {
        overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
        overscanStopIndex: Math.min(cellCount - 1, stopIndex + 1)
    };
}

});

parcelRegister("jI93b", function(module, exports) {

var $aXG5V = parcelRequire("aXG5V");

const $213f1142a85ab6d6$export$d0a9dfe2556a9577 = (step)=>{
    if (!(step instanceof (0, $aXG5V.ReplaceStep)) && !(step instanceof (0, $aXG5V.ReplaceAroundStep))) return null;
    // @ts-ignore This is by design. Slice is a private property, but accesible, from ReplaceStep.
    // However, we need to read it to found if the step was adding a newline
    const slice = step.slice;
    return slice;
};
module.exports["extractSliceFromStep"] = $213f1142a85ab6d6$export$d0a9dfe2556a9577;

});

parcelRegister("bGUOY", function(module, exports) {
function $9206ac472b47b44d$export$e46323d96cf32194(doc, from, to, predicate) {
    const results = [];
    doc.nodesBetween(from, to, (node, pos, parent)=>{
        if (predicate(node, pos, parent)) results.push({
            node: node,
            pos: pos
        });
    });
    return results;
}
module.exports["filterChildrenBetween"] = $9206ac472b47b44d$export$e46323d96cf32194;

});

parcelRegister("i4oLV", function(module, exports) {
function $2f95adf5eda4267e$export$f3a259b74a77132f(list = [], iteratee = (p)=>p) {
    /**
              .,
    .      _,'f----.._
    |\ ,-'"/  |     ,'
    |,_  ,--.      /
    /,-. ,'`.     (_
    f  o|  o|__     "`-.
    ,-._.,--'_ `.   _.,-`
    `"' ___.,'` j,-'
      `-.__.,--'
    Gotta go fast!
 */ const seen = new Set();
    list.forEach((l)=>seen.add(iteratee(l)));
    return list.filter((l)=>{
        const it = iteratee(l);
        if (seen.has(it)) {
            seen.delete(it);
            return true;
        }
        return false;
    });
}
module.exports["dedupe"] = $2f95adf5eda4267e$export$f3a259b74a77132f;

});

parcelRegister("eDabt", function(module, exports) {

var $5SAOw = parcelRequire("5SAOw");


var $ks2lK = parcelRequire("ks2lK");


var $8m4tT = parcelRequire("8m4tT");


var $jshjN = parcelRequire("jshjN");

// Taken from `editor-plugin-content-insertion`
function $f39dd7712775e946$var$setSelectionToValidTextNode(tr, node, from) {
    const sliceInserted = (0, $5SAOw.Slice).maxOpen((0, $5SAOw.Fragment).from(node));
    const openPosition = Math.min(from + (node.isAtom ? node.nodeSize : sliceInserted.openStart), tr.doc.content.size);
    const FORWARD_DIRECTION = 1;
    const nextSelection = (0, $ks2lK.TextSelection).findFrom(tr.doc.resolve(openPosition), FORWARD_DIRECTION, true);
    if (nextSelection) return tr.setSelection(nextSelection);
}
function $f39dd7712775e946$export$f4c81471ccea5042(tr, node) {
    const { $to: $to, $from: $from, to: to, from: from } = tr.selection;
    const { orderedList: orderedList, bulletList: bulletList, listItem: listItem } = tr.doc.type.schema.nodes;
    const startLinePosition = $from.start();
    const parentStartPosition = $from.depth === 0 ? 0 : $from.before();
    // Setting the start position
    const startMapped = startLinePosition === from ? parentStartPosition : from;
    // Selected nodes
    const selectionParentListItemNode = (0, $8m4tT.findParentNodeOfType)(listItem)(tr.selection);
    const selectionParentListNodeWithPos = (0, $8m4tT.findParentNodeOfType)([
        bulletList,
        orderedList
    ])(tr.selection);
    const selectionParentListNode = selectionParentListNodeWithPos?.node;
    if (!selectionParentListNodeWithPos) return tr;
    // Offsets
    const listWrappingOffset = $to.depth - selectionParentListNodeWithPos.depth + 1; // difference in depth between to position and list node
    const listItemWrappingOffset = $to.depth - selectionParentListNodeWithPos.depth; // difference in depth between to position and list item node
    // Anything to do with nested lists should safeInsert and not be handled here
    const grandParentListNode = (0, $8m4tT.findParentNodeOfTypeClosestToPos)(tr.doc.resolve(selectionParentListNodeWithPos.pos), [
        bulletList,
        orderedList
    ]);
    const selectionIsInNestedList = !!grandParentListNode;
    let selectedListItemHasNestedList = false;
    selectionParentListItemNode?.node.content.forEach((child)=>{
        if ((0, $jshjN.isListNode)(child)) selectedListItemHasNestedList = true;
    });
    if (selectedListItemHasNestedList || selectionIsInNestedList) return (0, $8m4tT.safeInsert)(node)(tr).scrollIntoView();
    // Check if node after the insert position is listItem
    const isNodeAfterInsertPositionIsListItem = tr.doc.nodeAt(to + listItemWrappingOffset)?.type === listItem;
    let replaceTo;
    if (isNodeAfterInsertPositionIsListItem) replaceTo = to + listItemWrappingOffset;
    else if (!isNodeAfterInsertPositionIsListItem) replaceTo = to;
    else replaceTo = to + listWrappingOffset;
    // handle the insertion of the slice
    tr.replaceWith(startMapped, replaceTo, node).scrollIntoView();
    // Get the next list items position (used later to find the split out ordered list)
    const indexOfNextListItem = $to.indexAfter($to.depth - listItemWrappingOffset);
    const positionOfNextListItem = tr.doc.resolve(selectionParentListNodeWithPos.pos + 1).posAtIndex(indexOfNextListItem);
    // Place the selection at the replaced location
    $f39dd7712775e946$var$setSelectionToValidTextNode(tr, node, from);
    // Find the ordered list node after the pasted content so we can set it's order
    const mappedPositionOfNextListItem = tr.mapping.map(positionOfNextListItem);
    if (mappedPositionOfNextListItem > tr.doc.nodeSize) return tr;
    const nodeAfterPastedContentResolvedPos = (0, $8m4tT.findParentNodeOfTypeClosestToPos)(tr.doc.resolve(mappedPositionOfNextListItem), [
        orderedList
    ]);
    // Work out the new split out lists 'order' (the number it starts from)
    const originalParentOrderedListNodeOrder = selectionParentListNode?.attrs.order;
    const nodeOfOriginalList = (0, $8m4tT.findParentNodeOfTypeClosestToPos)(tr.doc.resolve(from - 1), [
        orderedList
    ]);
    const numOfListItemsInOriginalList = nodeOfOriginalList?.node.childCount;
    // Set the new split out lists order attribute
    if (typeof originalParentOrderedListNodeOrder === 'number' && numOfListItemsInOriginalList && nodeAfterPastedContentResolvedPos && // We only want to apply the node markup if we're referring to the split
    // list rather than the original
    nodeOfOriginalList?.node !== nodeAfterPastedContentResolvedPos?.node) tr.setNodeMarkup(nodeAfterPastedContentResolvedPos.pos, orderedList, {
        ...nodeAfterPastedContentResolvedPos.node.attrs,
        order: originalParentOrderedListNodeOrder + numOfListItemsInOriginalList
    });
    return tr;
}
module.exports["transformNodeIntoListItem"] = $f39dd7712775e946$export$f4c81471ccea5042;

});

parcelRegister("8vgNB", function(module, exports) {

var $l9FJJ = parcelRequire("l9FJJ");

function $de1704326a4798fc$export$f63f505240212912(type) {
    return function(state, dispatch) {
        const tr = (0, $l9FJJ.createWrapSelectionTransaction)({
            state: state,
            type: type
        });
        if (dispatch) dispatch(tr);
        return true;
    };
}
module.exports["wrapSelectionIn"] = $de1704326a4798fc$export$f63f505240212912;

});

parcelRegister("b20Th", function(module, exports) {
function $e4c775f2a2211952$export$e9083e8cbe24bec0(state) {
    const { selection: selection } = state;
    return selection.$from.pos === selection.$from.depth;
}
module.exports["atTheBeginningOfDoc"] = $e4c775f2a2211952$export$e9083e8cbe24bec0;

});

parcelRegister("sU9ED", function(module, exports) {
function $55812f9fcfaaa8a8$export$4ca816540352da02(state) {
    const { selection: selection, doc: doc } = state;
    return doc.nodeSize - selection.$to.pos - 2 === selection.$to.depth;
}
module.exports["atTheEndOfDoc"] = $55812f9fcfaaa8a8$export$4ca816540352da02;

});

parcelRegister("fDECt", function(module, exports) {

var $5SAOw = parcelRequire("5SAOw");


var $ks2lK = parcelRequire("ks2lK");

function $0e4ca3cc6c48eb03$export$c2d9390f63354627() {
    return function(state, dispatch) {
        const { $from: $from } = state.selection;
        const parent = $from.parent;
        const { hardBreak: hardBreak } = state.schema.nodes;
        if (hardBreak) {
            const hardBreakNode = hardBreak.createChecked();
            if (parent && parent.type.validContent((0, $5SAOw.Fragment).from(hardBreakNode))) {
                if (dispatch) dispatch(state.tr.replaceSelectionWith(hardBreakNode, false));
                return true;
            }
        }
        if (state.selection instanceof (0, $ks2lK.TextSelection)) {
            if (dispatch) dispatch(state.tr.insertText('\n'));
            return true;
        }
        return false;
    };
}
module.exports["insertNewLine"] = $0e4ca3cc6c48eb03$export$c2d9390f63354627;

});

parcelRegister("gxRcs", function(module, exports) {
function $638cf25bfc4d0697$export$540dbd453ede1ce3(elem) {
    return elem === document.body;
}
module.exports["isBody"] = $638cf25bfc4d0697$export$540dbd453ede1ce3;

});

parcelRegister("ik7A9", function(module, exports) {
function $d25284f73d118799$export$ccbedd67ef6e9417(elem) {
    return elem && elem.nodeType === 3;
}
module.exports["isTextNode"] = $d25284f73d118799$export$ccbedd67ef6e9417;

});

parcelRegister("dFD5l", function(module, exports) {
function $9cbdad74ea43e79c$export$1daf15cbaf649dad(state) {
    const nodeCount = {};
    const extensionNodeCount = {};
    const nodeTypes = state.schema.nodes;
    const extensionNodeTypes = [
        nodeTypes.extension?.name,
        nodeTypes.inlineExtension?.name,
        nodeTypes.bodiedExtension?.name,
        nodeTypes.multiBodiedExtension?.name
    ];
    state.doc.descendants((node)=>{
        const nodeName = node.type.name;
        if (nodeName in nodeCount) nodeCount[nodeName]++;
        else nodeCount[nodeName] = 1;
        let extensionNodeName = nodeName;
        if (extensionNodeTypes.includes(extensionNodeName) && node.attrs?.extensionType) {
            extensionNodeName = `${node.attrs.extensionType} - ${node.attrs?.extensionKey}`;
            if (extensionNodeName in extensionNodeCount) extensionNodeCount[extensionNodeName]++;
            else extensionNodeCount[extensionNodeName] = 1;
        }
        return true;
    });
    return {
        nodeCount: nodeCount,
        extensionNodeCount: extensionNodeCount
    };
}
module.exports["countNodes"] = $9cbdad74ea43e79c$export$1daf15cbaf649dad;

});

parcelRegister("iMBUc", function(module, exports) {
function $261308dffbe558ca$export$f306d9dd555af398(nodeType, pos) {
    return `${nodeType}:${pos}`;
}
module.exports["makeNodePlaceholderId"] = $261308dffbe558ca$export$f306d9dd555af398;

});

parcelRegister("560vg", function(module, exports) {

var $5d9b4 = parcelRequire("5d9b4");


var $5SAOw = parcelRequire("5SAOw");


var $iMBUc = parcelRequire("iMBUc");

const $259e6717bdf1a37f$var$getEditorLineWidth = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((view)=>{
    return view.dom?.clientWidth;
});
// Copied from ProseMirror NodeView
// https://github.com/ProseMirror/prosemirror-view/blob/cfa73eb969777f63bcb39972594fd4a9110f5a93/src/viewdesc.ts#L1095-L1099
function $259e6717bdf1a37f$var$sameOuterDeco(a, b) {
    if (a.length !== b.length) return false;
    for(let i = 0; i < a.length; i++){
        // @ts-expect-error type actually exist on decoration at runtime
        if (!a[i].type) return false;
        // @ts-expect-error type actually exist on decoration at runtime
        if (!a[i].type.eq(b[i].type)) return false;
    }
    return true;
}
class $259e6717bdf1a37f$export$dccb00b9da782c66 {
    ignoreMutation() {
        if (this.node.type.isTextblock) return false;
        return true;
    }
    constructor(_node, view, _getPos, _outerDeco){
        this.dom = void 0;
        this.contentDOM = void 0;
        this.node = void 0;
        this.outerDeco = void 0;
        this.update = (node, outerDeco)=>{
            const prevNode = this.node;
            this.node = node;
            if (!$259e6717bdf1a37f$var$sameOuterDeco(outerDeco, this.outerDeco)) return false;
            // Copying some of the default NodeView update behaviour
            // https://github.com/ProseMirror/prosemirror-view/blob/cfa73eb969777f63bcb39972594fd4a9110f5a93/src/viewdesc.ts#L803
            return !this.node.sameMarkup(prevNode);
        };
        this.node = _node;
        this.outerDeco = _outerDeco;
        if (typeof _node.type?.spec?.toDOM !== 'function') {
            this.dom = document.createElement('div');
            return;
        }
        const toDOMConfiguration = {
            editorLineWidth: $259e6717bdf1a37f$var$getEditorLineWidth(view)
        };
        const fallback = (0, $5SAOw.DOMSerializer).renderSpec(document, _node.type.spec.toDOM(_node, // We are injecting a second parameter to be used by the toDOM lazy node view implementations
        // @ts-expect-error
        toDOMConfiguration));
        this.dom = fallback.dom;
        this.contentDOM = fallback.contentDOM;
        if (this.dom instanceof HTMLElement) {
            // This attribute is mostly used for debugging purposed
            // It will help us to found out when the node was replaced
            this.dom.setAttribute('data-lazy-node-view', _node.type.name);
            // This is used on Libra tests
            // We are using this to make sure all lazy noded were replaced
            // before the test started
            this.dom.setAttribute('data-lazy-node-view-fallback', 'true');
            // This is used by the UFO to identify the node
            this.dom.setAttribute('data-vc', `editor-lnv-fallback--${_node.type.name}`);
            const pos = _getPos();
            if (pos !== undefined) // Used for UFO to identify this as a placeholder
            this.dom.setAttribute('data-editor-lnv-placeholder', (0, $iMBUc.makeNodePlaceholderId)(_node.type.name, pos));
        }
    }
}
module.exports["LazyNodeView"] = $259e6717bdf1a37f$export$dccb00b9da782c66;

});

parcelRegister("26U6p", function(module, exports) {
function $3a24942e88760099$export$ab306cb155a0ca1b(popup) {
    // popup.offsetParent does not exist if the popup element is not mounted
    if (!popup || !popup.offsetParent) return false;
    return true;
}
module.exports["validatePosition"] = $3a24942e88760099$export$ab306cb155a0ca1b;

});

parcelRegister("3yaUF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e990a01e1f886ae319272b03d75a687b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $295d032b5bfd64da$var$_react = $295d032b5bfd64da$var$_interopRequireDefault((parcelRequire("42omo")));

var $295d032b5bfd64da$var$_baseNew = $295d032b5bfd64da$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $295d032b5bfd64da$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextHeadingFive".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for H5 / Heading 5 text style
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $295d032b5bfd64da$var$TextHeadingFiveIcon = (props)=>/*#__PURE__*/ $295d032b5bfd64da$var$_react.default.createElement($295d032b5bfd64da$var$_baseNew.default, Object.assign({
        name: "TextHeadingFiveIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M16 8.5h-3.75a.75.75 0 0 0-.75.75v3c0 .41.34.75.75.75h2.25v1.5h-3V16h3.13c.76 0 1.38-.62 1.38-1.37v-1.75c0-.76-.62-1.37-1.37-1.37H13V10h3zM2.5 6.25V1H1v12h1.5V7.75H8V13h1.5V1H8v5.25z" clip-rule="evenodd"/>`
    }, props));
$295d032b5bfd64da$var$TextHeadingFiveIcon.displayName = 'TextHeadingFiveIcon';
var $295d032b5bfd64da$var$_default = module.exports.default = $295d032b5bfd64da$var$TextHeadingFiveIcon;

});

parcelRegister("aYGvQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a0ec299c9d9d8293148b95b4eb4ef8e6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7fe07c1a1e2df6da$var$_react = $7fe07c1a1e2df6da$var$_interopRequireDefault((parcelRequire("42omo")));

var $7fe07c1a1e2df6da$var$_baseNew = $7fe07c1a1e2df6da$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $7fe07c1a1e2df6da$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextHeadingFour".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for H4 / Heading 4 text style
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7fe07c1a1e2df6da$var$TextHeadingFourIcon = (props)=>/*#__PURE__*/ $7fe07c1a1e2df6da$var$_react.default.createElement($7fe07c1a1e2df6da$var$_baseNew.default, Object.assign({
        name: "TextHeadingFourIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.5 12V8.5H11v3.63c0 .76.62 1.38 1.38 1.38h2.12V16H16V8.5h-1.5V12zm-10-5.75V1H1v12h1.5V7.75H8V13h1.5V1H8v5.25z" clip-rule="evenodd"/>`
    }, props));
$7fe07c1a1e2df6da$var$TextHeadingFourIcon.displayName = 'TextHeadingFourIcon';
var $7fe07c1a1e2df6da$var$_default = module.exports.default = $7fe07c1a1e2df6da$var$TextHeadingFourIcon;

});

parcelRegister("5wdIn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6e4d3b8c2282199229e89fad097e5cbf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $404a946448580db9$var$_react = $404a946448580db9$var$_interopRequireDefault((parcelRequire("42omo")));

var $404a946448580db9$var$_baseNew = $404a946448580db9$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $404a946448580db9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextHeadingOne".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for H1 / Heading 1 text style
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $404a946448580db9$var$TextHeadingOneIcon = (props)=>/*#__PURE__*/ $404a946448580db9$var$_react.default.createElement($404a946448580db9$var$_baseNew.default, Object.assign({
        name: "TextHeadingOneIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.5 6.25V1H1v12h1.5V7.75H8V13h1.5V1H8v5.25zM12 8.5h1.75a.75.75 0 0 1 .75.75V16H13v-6h-1z" clip-rule="evenodd"/>`
    }, props));
$404a946448580db9$var$TextHeadingOneIcon.displayName = 'TextHeadingOneIcon';
var $404a946448580db9$var$_default = module.exports.default = $404a946448580db9$var$TextHeadingOneIcon;

});

parcelRegister("l1461", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7ea50078a5999a2c3fbe51c1b3e78d4a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f4ccde6570b3f973$var$_react = $f4ccde6570b3f973$var$_interopRequireDefault((parcelRequire("42omo")));

var $f4ccde6570b3f973$var$_baseNew = $f4ccde6570b3f973$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $f4ccde6570b3f973$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextHeadingSix".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for H6 / Heading 6 text style
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f4ccde6570b3f973$var$TextHeadingSixIcon = (props)=>/*#__PURE__*/ $f4ccde6570b3f973$var$_react.default.createElement($f4ccde6570b3f973$var$_baseNew.default, Object.assign({
        name: "TextHeadingSixIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15.5 8.5h-2.62c-.76 0-1.37.62-1.37 1.38v4.75c0 .76.62 1.38 1.38 1.38h1.75c.76 0 1.38-.62 1.38-1.37v-1.75c0-.76-.62-1.37-1.37-1.37H13V10h2.5zM13 13h1.5v1.5H13zM2.5 6.25V1H1v12h1.5V7.75H8V13h1.5V1H8v5.25z" clip-rule="evenodd"/>`
    }, props));
$f4ccde6570b3f973$var$TextHeadingSixIcon.displayName = 'TextHeadingSixIcon';
var $f4ccde6570b3f973$var$_default = module.exports.default = $f4ccde6570b3f973$var$TextHeadingSixIcon;

});

parcelRegister("7a8uv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::eb8ba74bc7f968e3347d9c83c15417ee>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $53700db1e302aec7$var$_react = $53700db1e302aec7$var$_interopRequireDefault((parcelRequire("42omo")));

var $53700db1e302aec7$var$_baseNew = $53700db1e302aec7$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $53700db1e302aec7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextHeadingThree".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for H3 / Heading 3 text style
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $53700db1e302aec7$var$TextHeadingThreeIcon = (props)=>/*#__PURE__*/ $53700db1e302aec7$var$_react.default.createElement($53700db1e302aec7$var$_baseNew.default, Object.assign({
        name: "TextHeadingThreeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.5 8.5h3.13c.76 0 1.38.62 1.38 1.38v4.75c0 .76-.62 1.38-1.37 1.38H11.5v-1.5h3V13h-3v-1.5h3V10h-3zm-9-2.25V1H1v12h1.5V7.75H8V13h1.5V1H8v5.25z" clip-rule="evenodd"/>`
    }, props));
$53700db1e302aec7$var$TextHeadingThreeIcon.displayName = 'TextHeadingThreeIcon';
var $53700db1e302aec7$var$_default = module.exports.default = $53700db1e302aec7$var$TextHeadingThreeIcon;

});

parcelRegister("45HPa", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4280f54cb1f2416c8d1b430fc38ff118>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2fa99fa2be73e9ff$var$_react = $2fa99fa2be73e9ff$var$_interopRequireDefault((parcelRequire("42omo")));

var $2fa99fa2be73e9ff$var$_baseNew = $2fa99fa2be73e9ff$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $2fa99fa2be73e9ff$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextHeadingTwo".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for H2 / Heading 2 text style
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2fa99fa2be73e9ff$var$TextHeadingTwoIcon = (props)=>/*#__PURE__*/ $2fa99fa2be73e9ff$var$_react.default.createElement($2fa99fa2be73e9ff$var$_baseNew.default, Object.assign({
        name: "TextHeadingTwoIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.5 8.5h3.13c.76 0 1.38.62 1.38 1.38v1.75c0 .76-.62 1.38-1.37 1.38H13v1.5h3V16h-3.75a.75.75 0 0 1-.75-.75v-2.37c0-.76.62-1.37 1.38-1.37h1.62V10h-3zm-9-2.25V1H1v12h1.5V7.75H8V13h1.5V1H8v5.25z" clip-rule="evenodd"/>`
    }, props));
$2fa99fa2be73e9ff$var$TextHeadingTwoIcon.displayName = 'TextHeadingTwoIcon';
var $2fa99fa2be73e9ff$var$_default = module.exports.default = $2fa99fa2be73e9ff$var$TextHeadingTwoIcon;

});

parcelRegister("eg9hW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::74ca1dacf8943b30998c1339b14fef77>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a619c3c96849ada1$var$_react = $a619c3c96849ada1$var$_interopRequireDefault((parcelRequire("42omo")));

var $a619c3c96849ada1$var$_baseNew = $a619c3c96849ada1$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $a619c3c96849ada1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextParagraph".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Confluence Editor AI action for reformatting paragraphs into multiple shorter paragraphs
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a619c3c96849ada1$var$TextParagraphIcon = (props)=>/*#__PURE__*/ $a619c3c96849ada1$var$_react.default.createElement($a619c3c96849ada1$var$_baseNew.default, Object.assign({
        name: "TextParagraphIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.25 2.5a2.75 2.75 0 0 0 0 5.5H8V2.5zm3.25 0V15H8V9.5H6.25a4.25 4.25 0 0 1 0-8.5h5.5a.75.75 0 0 1 .75.75V15H11V2.5z" clip-rule="evenodd"/>`
    }, props));
$a619c3c96849ada1$var$TextParagraphIcon.displayName = 'TextParagraphIcon';
var $a619c3c96849ada1$var$_default = module.exports.default = $a619c3c96849ada1$var$TextParagraphIcon;

});

parcelRegister("50a25", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f550c803053c031f05bc533bcabb23b5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3a44bc1ac4d13d42$var$_react = $3a44bc1ac4d13d42$var$_interopRequireDefault((parcelRequire("42omo")));

var $3a44bc1ac4d13d42$var$_baseNew = $3a44bc1ac4d13d42$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $3a44bc1ac4d13d42$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextSmall".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing small text style in text editor experiences.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3a44bc1ac4d13d42$var$TextSmallIcon = (props)=>/*#__PURE__*/ $3a44bc1ac4d13d42$var$_react.default.createElement($3a44bc1ac4d13d42$var$_baseNew.default, Object.assign({
        name: "TextSmallIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11 1v1.5H6.251V15h-1.5V2.5H0V1zm3.5 11.375v-.5c0-.621-.504-1.125-1.125-1.125h-1.75A2.625 2.625 0 0 1 9 8.125v-.5A2.625 2.625 0 0 1 11.625 5H13.5A2.5 2.5 0 0 1 16 7.5h-1.5a1 1 0 0 0-1-1h-1.875c-.621 0-1.125.504-1.125 1.125v.5c0 .621.504 1.125 1.125 1.125h1.75A2.625 2.625 0 0 1 16 11.875v.5A2.625 2.625 0 0 1 13.375 15H11.5A2.5 2.5 0 0 1 9 12.5h1.5a1 1 0 0 0 1 1h1.875c.621 0 1.125-.504 1.125-1.125"/>`
    }, props));
$3a44bc1ac4d13d42$var$TextSmallIcon.displayName = 'TextSmallIcon';
var $3a44bc1ac4d13d42$var$_default = module.exports.default = $3a44bc1ac4d13d42$var$TextSmallIcon;

});

parcelRegister("1QXSD", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $cvXh8 = parcelRequire("cvXh8");


var $56M4r = parcelRequire("56M4r");


var $3gadb = parcelRequire("3gadb");


var $k4fPq = parcelRequire("k4fPq");


function $1aa99d1c67aa2efc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1aa99d1c67aa2efc$var$labelStyles = {
    name: "18nns55",
    styles: "display:inline-block;width:100%"
};
const $1aa99d1c67aa2efc$var$spacerStyles = {
    name: "nce1h9",
    styles: "display:flex;flex:1;padding:var(--ds-space-100, 8px)"
};
const $1aa99d1c67aa2efc$var$DropdownButtonItem = (0, $56M4r.default);
const $1aa99d1c67aa2efc$var$SelectedIconBefore = ({ itemSelected: itemSelected, intl: intl, showSelected: showSelected })=>{
    if (showSelected && itemSelected) return /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        "aria-hidden": "true",
        "data-vc": "6aKP8Qmn"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))), {
        label: intl.formatMessage((0, $k4fPq.default).confirmModalOK),
        spacing: "none"
    }));
    return /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        css: $1aa99d1c67aa2efc$var$spacerStyles
    });
};
const $1aa99d1c67aa2efc$export$ed97964d1871885d = (props)=>{
    const { item: item, hide: hide, dispatchCommand: dispatchCommand, editorView: editorView, showSelected: showSelected, intl: intl } = props;
    const itemSelected = item.selected;
    const iconBefore = (0, $42omo.useMemo)(()=>{
        if (item.icon) return item.icon;
        else return /*#__PURE__*/ (0, $9K4OG.jsx)($1aa99d1c67aa2efc$var$SelectedIconBefore, {
            itemSelected: itemSelected,
            showSelected: showSelected,
            intl: intl
        });
    }, [
        itemSelected,
        showSelected,
        intl,
        item.icon
    ]);
    const [tooltipContent, setTooltipContent] = (0, $42omo.useState)(item.tooltip || '');
    const handleItemMouseOut = (0, $42omo.useCallback)(()=>{
        setTooltipContent('');
        if (item.onMouseOut) dispatchCommand(item.onMouseOut);
    }, [
        item.onMouseOut,
        dispatchCommand
    ]);
    const handleItemMouseDown = (0, $42omo.useCallback)((e)=>{
        e.preventDefault(); // ED-16204 - This is needed for safari to get handleItemClick() to work
        if (item.onMouseDown) dispatchCommand(item.onMouseDown);
    }, [
        item.onMouseDown,
        dispatchCommand
    ]);
    const handleItemMouseOver = (0, $42omo.useCallback)(()=>{
        setTooltipContent(item.tooltip || '');
        if (item.onMouseOver) dispatchCommand(item.onMouseOver);
    }, [
        item.tooltip,
        item.onMouseOver,
        dispatchCommand
    ]);
    const handleItemMouseEnter = (0, $42omo.useCallback)((e)=>{
        if (item.onMouseEnter) {
            e.preventDefault();
            dispatchCommand(item.onMouseEnter);
        }
    }, [
        item.onMouseEnter,
        dispatchCommand
    ]);
    const handleItemMouseLeave = (0, $42omo.useCallback)((e)=>{
        if (item.onMouseLeave) {
            e.preventDefault();
            dispatchCommand(item.onMouseLeave);
        }
    }, [
        item.onMouseLeave,
        dispatchCommand
    ]);
    const handleItemOnFocus = (0, $42omo.useCallback)((e)=>{
        if (item.onFocus) {
            e.preventDefault();
            dispatchCommand(item.onFocus);
        }
    }, [
        item.onFocus,
        dispatchCommand
    ]);
    const handleItemOnBlur = (0, $42omo.useCallback)((e)=>{
        if (item.onBlur) {
            e.preventDefault();
            dispatchCommand(item.onBlur);
        }
    }, [
        item.onBlur,
        dispatchCommand
    ]);
    const handleItemClick = (0, $42omo.useCallback)(()=>{
        /**
     * The order of dispatching the event and hide() is important, because
     * the ClickAreaBlock will be relying on the element to calculate the
     * click coordinate.
     * For more details, please visit the comment in this PR https://bitbucket.org/atlassian/atlassian-frontend/pull-requests/5328/edm-1321-set-selection-near-smart-link?link_source=email#chg-packages/editor/editor-core/src/plugins/floating-toolbar/ui/DropdownMenu.tsx
     */ dispatchCommand(item.onClick);
        hide();
        if (!editorView?.hasFocus()) editorView?.focus();
    }, [
        dispatchCommand,
        item.onClick,
        hide,
        editorView
    ]);
    /* ED-16704 - Native mouse event handler to overcome firefox issue on disabled <button> - https://github.com/whatwg/html/issues/5886 */ const labelRef = (0, $42omo.useRef)(null);
    const handleTitleWrapperMouseEvent = (0, $42omo.useCallback)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (e)=>{
        if (item.disabled) {
            e.stopPropagation();
            e.preventDefault();
        }
    }, [
        item.disabled
    ]);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const isAriaChecked = (item)=>{
        const { selected: selected, domItemOptions: domItemOptions } = item;
        return domItemOptions?.type === 'item-checkbox' ? selected : undefined;
    };
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const hasRole = (item)=>{
        // Always return proper menu roles to fix aria-required-children violations
        return item.domItemOptions?.type === 'item-checkbox' ? 'menuitemcheckbox' : 'menuitem';
    };
    (0, $42omo.useEffect)(()=>{
        const labelRefCurrent = labelRef.current;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        labelRefCurrent?.addEventListener('click', handleTitleWrapperMouseEvent);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        labelRefCurrent?.addEventListener('mousedown', handleTitleWrapperMouseEvent);
        return ()=>{
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            labelRefCurrent?.removeEventListener('click', handleTitleWrapperMouseEvent);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            labelRefCurrent?.removeEventListener('mousedown', handleTitleWrapperMouseEvent);
        };
    });
    const itemContent = /*#__PURE__*/ (0, $9K4OG.jsx)($1aa99d1c67aa2efc$var$DropdownButtonItem, {
        isSelected: itemSelected,
        iconBefore: iconBefore,
        iconAfter: item.elemAfter,
        onClick: handleItemClick,
        "data-testid": item.testId,
        isDisabled: item.disabled,
        onMouseDown: handleItemMouseDown,
        onMouseOver: handleItemMouseOver,
        onMouseEnter: handleItemMouseEnter,
        onMouseLeave: handleItemMouseLeave,
        onMouseOut: handleItemMouseOut,
        onFocus: handleItemOnFocus,
        onBlur: handleItemOnBlur,
        role: hasRole(item),
        "aria-checked": isAriaChecked(item)
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        ref: labelRef,
        css: $1aa99d1c67aa2efc$var$labelStyles
    }, item.title));
    if (tooltipContent) return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3gadb.default), {
        content: tooltipContent
    }, itemContent);
    return itemContent;
};
module.exports["DropdownMenuItem"] = $1aa99d1c67aa2efc$export$ed97964d1871885d;

});

parcelRegister("4BNmH", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports -- Ignored via go/DSP-18766; jsx required at runtime for @jsxRuntime classic

var $9K4OG = parcelRequire("9K4OG");

function $0f76d3d3ebe67090$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0f76d3d3ebe67090$var$separatorStyles = {
    name: "1qptm7f",
    styles: "background:var(--ds-border, #0B120E24);height:1px"
};
const $0f76d3d3ebe67090$export$c0340fdc1581055e = ()=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $0f76d3d3ebe67090$var$separatorStyles,
        "data-vc": "LZBNN758"
    });
};
module.exports["DropdownSeparator"] = $0f76d3d3ebe67090$export$c0340fdc1581055e;

});

parcelRegister("glYgz", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $ed4b78129402443c$export$12d66ae3e5b38d26 = (0, $aXWIB.defineMessages)({
    '#DEEBFF': {
        id: "fabric.theme.subtle-blue",
        defaultMessage: "Subtle blue"
    },
    '#B3D4FF': {
        id: "fabric.theme.blue",
        defaultMessage: "Blue"
    },
    '#4C9AFF': {
        id: "fabric.theme.bold-blue",
        defaultMessage: "Bold blue"
    },
    '#E6FCFF': {
        id: "fabric.theme.subtle-teal",
        defaultMessage: "Subtle teal"
    },
    '#B3F5FF': {
        id: "fabric.theme.teal",
        defaultMessage: "Teal"
    },
    '#79E2F2': {
        id: "fabric.theme.bold-teal",
        defaultMessage: "Bold teal"
    },
    '#E3FCEF': {
        id: "fabric.theme.subtle-green",
        defaultMessage: "Subtle green"
    },
    '#ABF5D1': {
        id: "fabric.theme.green",
        defaultMessage: "Green"
    },
    '#57D9A3': {
        id: "fabric.theme.bold-green",
        defaultMessage: "Bold green"
    },
    '#FFFAE6': {
        id: "fabric.theme.subtle-yellow",
        defaultMessage: "Subtle yellow"
    },
    '#FFF0B3': {
        id: "fabric.theme.yellow",
        defaultMessage: "Yellow"
    },
    '#FFC400': {
        id: "fabric.theme.bold-yellow",
        defaultMessage: "Bold yellow"
    },
    '#FFEBE6': {
        id: "fabric.theme.subtle-red",
        defaultMessage: "Subtle red"
    },
    '#FFBDAD': {
        id: "fabric.theme.red",
        defaultMessage: "Red"
    },
    '#FF8F73': {
        id: "fabric.theme.bold-red",
        defaultMessage: "Bold red"
    },
    '#EAE6FF': {
        id: "fabric.theme.subtle-purple",
        defaultMessage: "Subtle purple"
    },
    '#C0B6F2': {
        id: "fabric.theme.purple",
        defaultMessage: "Purple"
    },
    '#998DD9': {
        id: "fabric.theme.bold-purple",
        defaultMessage: "Bold purple"
    },
    '#FFFFFF': {
        id: "fabric.theme.white",
        defaultMessage: "White"
    },
    '#F4F5F7': {
        id: "fabric.theme.gray",
        defaultMessage: "Gray"
    },
    '#B3BAC5': {
        id: "fabric.theme.bold-gray",
        defaultMessage: "Bold gray"
    }
});
module.exports["lightBackgroundPaletteTooltipMessages"] = $ed4b78129402443c$export$12d66ae3e5b38d26;

});

parcelRegister("3Cheb", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $1513e75903e9e16c$export$3db7ab7dd64ad21a = (0, $aXWIB.defineMessages)({
    // Blue color
    '#7AB2FF': {
        id: "fabric.theme.subtle-blue",
        defaultMessage: "Subtle blue"
    },
    '#247FFF': {
        id: "fabric.theme.blue",
        defaultMessage: "Blue"
    },
    '#0055CC': {
        id: "fabric.theme.bold-blue",
        defaultMessage: "Bold blue"
    },
    '#003884': {
        id: "fabric.theme.bolder-blue",
        defaultMessage: "Bolder blue"
    },
    // Teal color
    '#60C6D2': {
        id: "fabric.theme.subtle-teal",
        defaultMessage: "Subtle teal"
    },
    '#1D9AAA': {
        id: "fabric.theme.teal",
        defaultMessage: "Teal"
    },
    '#1D7F8C': {
        id: "fabric.theme.bold-teal",
        defaultMessage: "Bold teal"
    },
    '#206B74': {
        id: "fabric.theme.bolder-teal",
        defaultMessage: "Bolder teal"
    },
    // Green color
    '#6BE1B0': {
        id: "fabric.theme.subtle-green",
        defaultMessage: "Subtle green"
    },
    '#23A971': {
        id: "fabric.theme.green",
        defaultMessage: "Green"
    },
    '#177D52': {
        id: "fabric.theme.bold-green",
        defaultMessage: "Bold green"
    },
    '#055C3F': {
        id: "fabric.theme.bolder-green",
        defaultMessage: "Bolder green"
    },
    // Yellow color
    '#FFDB57': {
        id: "fabric.theme.subtle-yellow",
        defaultMessage: "Subtle yellow"
    },
    '#FFBE33': {
        id: "fabric.theme.yellow",
        defaultMessage: "Yellow"
    },
    '#FF9D00': {
        id: "fabric.theme.bold-yellow",
        defaultMessage: "Bold yellow"
    },
    '#946104': {
        id: "fabric.theme.bolder-yellow",
        defaultMessage: "Bolder yellow"
    },
    // Red color
    '#FF8F73': {
        id: "fabric.theme.subtle-red",
        defaultMessage: "Subtle red"
    },
    '#FC552C': {
        id: "fabric.theme.red",
        defaultMessage: "Red"
    },
    '#D32D03': {
        id: "fabric.theme.bold-red",
        defaultMessage: "Bold red"
    },
    '#A32000': {
        id: "fabric.theme.bolder-red",
        defaultMessage: "Bolder red"
    },
    // Orange color
    '#FAA53D': {
        id: "fabric.theme.subtle-orange",
        defaultMessage: "Subtle orange"
    },
    '#D97008': {
        id: "fabric.theme.orange",
        defaultMessage: "Orange"
    },
    '#B65C02': {
        id: "fabric.theme.bold-orange",
        defaultMessage: "Bold orange"
    },
    '#974F0C': {
        id: "fabric.theme.bolder-orange",
        defaultMessage: "Bolder orange"
    },
    // Magenta color
    '#E774BB': {
        id: "fabric.theme.subtle-magenta",
        defaultMessage: "Subtle magenta"
    },
    '#DA62AC': {
        id: "fabric.theme.magenta",
        defaultMessage: "Magenta"
    },
    '#CD519D': {
        id: "fabric.theme.bold-magenta",
        defaultMessage: "Bold magenta"
    },
    '#943D73': {
        id: "fabric.theme.bolder-magenta",
        defaultMessage: "Bolder magenta"
    },
    // Purple color
    '#B5A7FB': {
        id: "fabric.theme.subtle-purple",
        defaultMessage: "Subtle purple"
    },
    '#8B77EE': {
        id: "fabric.theme.purple",
        defaultMessage: "Purple"
    },
    '#5A43D0': {
        id: "fabric.theme.bold-purple",
        defaultMessage: "Bold purple"
    },
    '#44368B': {
        id: "fabric.theme.bolder-purple",
        defaultMessage: "Bolder purple"
    },
    // Gray color
    '#8993A5': {
        id: "fabric.theme.subtle-gray",
        defaultMessage: "Subtle gray"
    },
    '#8590A2': {
        id: "fabric.theme.gray",
        defaultMessage: "Gray"
    },
    '#758195': {
        id: "fabric.theme.bold-gray",
        defaultMessage: "Bold gray"
    },
    '#44546F': {
        id: "fabric.theme.bolder-gray",
        defaultMessage: "Bolder gray"
    }
});
module.exports["lightChartsColorPaletteTooltipMessages"] = $1513e75903e9e16c$export$3db7ab7dd64ad21a;

});

parcelRegister("ktVJr", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $fd6962b56c6aca1a$export$788a656fb7fb7897 = (0, $aXWIB.defineMessages)({
    '#FFFFFF': {
        id: "fabric.theme.white",
        defaultMessage: "White"
    },
    '#B3D4FF': {
        id: "fabric.theme.subtle-blue",
        defaultMessage: "Subtle blue"
    },
    '#B3F5FF': {
        id: "fabric.theme.subtle-teal",
        defaultMessage: "Subtle teal"
    },
    '#ABF5D1': {
        id: "fabric.theme.subtle-green",
        defaultMessage: "Subtle green"
    },
    '#FFF0B3': {
        id: "fabric.theme.subtle-yellow",
        defaultMessage: "Subtle yellow"
    },
    '#FFBDAD': {
        id: "fabric.theme.subtle-red",
        defaultMessage: "Subtle red"
    },
    '#EAE6FF': {
        id: "fabric.theme.subtle-purple",
        defaultMessage: "Subtle purple"
    },
    '#97A0AF': {
        id: "fabric.theme.gray",
        defaultMessage: "Gray"
    },
    '#4C9AFF': {
        id: "fabric.theme.blue",
        defaultMessage: "Blue"
    },
    '#00B8D9': {
        id: "fabric.theme.teal",
        defaultMessage: "Teal"
    },
    '#36B37E': {
        id: "fabric.theme.green",
        defaultMessage: "Green"
    },
    '#FFC400': {
        id: "fabric.theme.yellow",
        defaultMessage: "Yellow"
    },
    '#FF5630': {
        id: "fabric.theme.red",
        defaultMessage: "Red"
    },
    '#FF991F': {
        id: "fabric.theme.bold-orange",
        defaultMessage: "Bold orange"
    },
    '#6554C0': {
        id: "fabric.theme.purple",
        defaultMessage: "Purple"
    },
    '#0747A6': {
        id: "fabric.theme.bold-blue",
        defaultMessage: "Bold blue"
    },
    '#008DA6': {
        id: "fabric.theme.bold-teal",
        defaultMessage: "Bold teal"
    },
    '#006644': {
        id: "fabric.theme.bold-green",
        defaultMessage: "Bold green"
    },
    '#BF2600': {
        id: "fabric.theme.bold-red",
        defaultMessage: "Bold red"
    },
    '#403294': {
        id: "fabric.theme.bold-purple",
        defaultMessage: "Bold purple"
    },
    '#172B4D': {
        id: "fabric.theme.default",
        defaultMessage: "Default"
    }
});
module.exports["lightTextPaletteTooltipMessages"] = $fd6962b56c6aca1a$export$788a656fb7fb7897;

});

parcelRegister("MnuXJ", function(module, exports) {
function $0ed5e1dbdd626864$export$17092ffd56d3b3b2(colorsPerRow, selectedColor) {
    let selectedRowIndex = -1;
    let selectedColumnIndex = -1;
    colorsPerRow.forEach((row, rowIndex)=>{
        row.forEach(({ value: value }, columnIndex)=>{
            if (value === selectedColor) {
                selectedRowIndex = rowIndex;
                selectedColumnIndex = columnIndex;
            }
        });
    });
    return {
        selectedRowIndex: selectedRowIndex,
        selectedColumnIndex: selectedColumnIndex
    };
}
module.exports["getSelectedRowAndColumn"] = $0ed5e1dbdd626864$export$17092ffd56d3b3b2;

});

parcelRegister("86XId", function(module, exports) {
var $3316eb4c37f4e09b$export$6dcc1033b74c9344 = /*#__PURE__*/ function(LinkAction) {
    LinkAction["SHOW_INSERT_TOOLBAR"] = "SHOW_INSERT_TOOLBAR";
    LinkAction["HIDE_TOOLBAR"] = "HIDE_TOOLBAR";
    LinkAction["SELECTION_CHANGE"] = "SELECTION_CHANGE";
    LinkAction["INSERT_LINK_TOOLBAR"] = "INSERT";
    LinkAction["EDIT_INSERTED_TOOLBAR"] = "EDIT_INSERTED_TOOLBAR";
    LinkAction["SET_CONFIGURE_BUTTON_TARGET_POS"] = "SET_CONFIGURE_BUTTON_TARGET_POS";
    LinkAction["SET_CONFIGURE_DROPDOWN_OPEN"] = "SET_CONFIGURE_DROPDOWN_OPEN";
    return LinkAction;
}({});
module.exports["LinkAction"] = $3316eb4c37f4e09b$export$6dcc1033b74c9344;

});

parcelRegister("6VwLP", function(module, exports) {

var $dQl1W = parcelRequire("dQl1W");


var $i9vfM = parcelRequire("i9vfM");

var $jSDb4 = parcelRequire("jSDb4");

var $86XId = parcelRequire("86XId");


var $1S4f7 = parcelRequire("1S4f7");


var $j9WGh = parcelRequire("j9WGh");

var $l9G9n = parcelRequire("l9G9n");


var $ks2lK = parcelRequire("ks2lK");


var $ftzrq = parcelRequire("ftzrq");

const $3e7869c8210cedd8$var$mapTransactionToState = (state, tr)=>{
    if (!state) return undefined;
    else if (state.type === (0, $jSDb4.InsertStatus).EDIT_LINK_TOOLBAR || state.type === (0, $jSDb4.InsertStatus).EDIT_INSERTED_TOOLBAR) {
        const { pos: pos, deleted: deleted } = tr.mapping.mapResult(state.pos, 1);
        const node = tr.doc.nodeAt(pos);
        // If the position was not deleted & it is still a link
        if (!deleted && !!node.type.schema.marks.link.isInSet(node.marks)) {
            if (node === state.node && pos === state.pos) return state;
            return {
                ...state,
                pos: pos,
                node: node
            };
        }
        // If the position has been deleted, then require a navigation to show the toolbar again
        return;
    } else if (state.type === (0, $jSDb4.InsertStatus).INSERT_LINK_TOOLBAR) return {
        ...state,
        from: tr.mapping.map(state.from),
        to: tr.mapping.map(state.to)
    };
    return;
};
const $3e7869c8210cedd8$var$toState = (state, action, editorState)=>{
    // Show insert or edit toolbar
    if (!state) switch(action){
        case (0, $86XId.LinkAction).SHOW_INSERT_TOOLBAR:
            {
                const { from: from, to: to } = editorState.selection;
                if ((0, $j9WGh.canLinkBeCreatedInRange)(from, to)(editorState)) return {
                    type: (0, $jSDb4.InsertStatus).INSERT_LINK_TOOLBAR,
                    from: from,
                    to: to
                };
                return undefined;
            }
        case (0, $86XId.LinkAction).SELECTION_CHANGE:
            // If the user has moved their cursor, see if they're in a link
            const link = (0, $i9vfM.getActiveLinkMark)(editorState);
            if (link) return {
                ...link,
                type: (0, $jSDb4.InsertStatus).EDIT_LINK_TOOLBAR
            };
            return undefined;
        default:
            return undefined;
    }
    // Update toolbar state if selection changes, or if toolbar is hidden
    if (state.type === (0, $jSDb4.InsertStatus).EDIT_LINK_TOOLBAR) switch(action){
        case (0, $86XId.LinkAction).EDIT_INSERTED_TOOLBAR:
            {
                const link = (0, $i9vfM.getActiveLinkMark)(editorState);
                if (link) {
                    if (link.pos === state.pos && link.node === state.node) return {
                        ...state,
                        type: (0, $jSDb4.InsertStatus).EDIT_INSERTED_TOOLBAR
                    };
                    return {
                        ...link,
                        type: (0, $jSDb4.InsertStatus).EDIT_INSERTED_TOOLBAR
                    };
                }
                return undefined;
            }
        case (0, $86XId.LinkAction).SELECTION_CHANGE:
            const link1 = (0, $i9vfM.getActiveLinkMark)(editorState);
            if (link1) {
                if (link1.pos === state.pos && link1.node === state.node) // Make sure we return the same object, if it's the same link
                return state;
                return {
                    ...link1,
                    type: (0, $jSDb4.InsertStatus).EDIT_LINK_TOOLBAR
                };
            }
            return undefined;
        case (0, $86XId.LinkAction).HIDE_TOOLBAR:
            return undefined;
        default:
            return state;
    }
    // Remove toolbar if user changes selection or toolbar is hidden
    if (state.type === (0, $jSDb4.InsertStatus).INSERT_LINK_TOOLBAR) switch(action){
        case (0, $86XId.LinkAction).SELECTION_CHANGE:
        case (0, $86XId.LinkAction).HIDE_TOOLBAR:
            return undefined;
        default:
            return state;
    }
    return;
};
const $3e7869c8210cedd8$var$getActiveText = (selection)=>{
    const currentSlice = selection.content();
    if (currentSlice.size === 0) return;
    if (currentSlice.content.childCount === 1 && currentSlice.content.firstChild && selection instanceof (0, $ks2lK.TextSelection)) return currentSlice.content.firstChild.textContent;
    return;
};
const $3e7869c8210cedd8$export$77b371d6becc8882 = new (0, $ks2lK.PluginKey)('hyperlinkPlugin');
const $3e7869c8210cedd8$export$ca524d3785e2543 = (dispatch, intl, editorAppearance, _pluginInjectionApi, _onClickCallback, __livePage)=>new (0, $1S4f7.SafePlugin)({
        state: {
            init (_, state) {
                const canInsertLink = (0, $j9WGh.canLinkBeCreatedInRange)(state.selection.from, state.selection.to)(state);
                return {
                    activeText: $3e7869c8210cedd8$var$getActiveText(state.selection),
                    canInsertLink: canInsertLink,
                    timesViewed: 0,
                    activeLinkMark: $3e7869c8210cedd8$var$toState(undefined, (0, $86XId.LinkAction).SELECTION_CHANGE, state),
                    editorAppearance: editorAppearance
                };
            },
            apply (tr, pluginState, oldState, newState) {
                let state = pluginState;
                const action = tr.getMeta($3e7869c8210cedd8$export$77b371d6becc8882) && tr.getMeta($3e7869c8210cedd8$export$77b371d6becc8882).type;
                const inputMethod = tr.getMeta($3e7869c8210cedd8$export$77b371d6becc8882) && tr.getMeta($3e7869c8210cedd8$export$77b371d6becc8882).inputMethod;
                if (tr.docChanged) state = {
                    activeText: state.activeText,
                    canInsertLink: (0, $j9WGh.canLinkBeCreatedInRange)(newState.selection.from, newState.selection.to)(newState),
                    timesViewed: state.timesViewed,
                    inputMethod: inputMethod,
                    activeLinkMark: $3e7869c8210cedd8$var$mapTransactionToState(state.activeLinkMark, tr),
                    editorAppearance: editorAppearance
                };
                if (action) {
                    const stateForAnalytics = [
                        (0, $86XId.LinkAction).SHOW_INSERT_TOOLBAR,
                        (0, $86XId.LinkAction).EDIT_INSERTED_TOOLBAR
                    ].includes(action) ? {
                        timesViewed: ++state.timesViewed,
                        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                        searchSessionId: (0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))()
                    } : {
                        timesViewed: state.timesViewed,
                        searchSessionId: state.searchSessionId
                    };
                    state = {
                        activeText: state.activeText,
                        canInsertLink: state.canInsertLink,
                        inputMethod: inputMethod,
                        activeLinkMark: $3e7869c8210cedd8$var$toState(state.activeLinkMark, action, newState),
                        editorAppearance: editorAppearance,
                        ...stateForAnalytics
                    };
                }
                const hasPositionChanged = oldState.selection.from !== newState.selection.from || oldState.selection.to !== newState.selection.to;
                if (tr.selectionSet && hasPositionChanged) state = {
                    activeText: $3e7869c8210cedd8$var$getActiveText(newState.selection),
                    canInsertLink: (0, $j9WGh.canLinkBeCreatedInRange)(newState.selection.from, newState.selection.to)(newState),
                    activeLinkMark: $3e7869c8210cedd8$var$toState(state.activeLinkMark, (0, $86XId.LinkAction).SELECTION_CHANGE, newState),
                    timesViewed: state.timesViewed,
                    searchSessionId: state.searchSessionId,
                    inputMethod: inputMethod,
                    editorAppearance: editorAppearance
                };
                if (!(0, $l9G9n.shallowEqual)(state, pluginState)) dispatch($3e7869c8210cedd8$export$77b371d6becc8882, state);
                return state;
            }
        },
        key: $3e7869c8210cedd8$export$77b371d6becc8882,
        props: {
            decorations: ()=>{
                return (0, $ftzrq.DecorationSet).empty;
            },
            handleDOMEvents: {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                mouseup: (_, event)=>{
                    // this prevents redundant selection transaction when clicking on link
                    // link state will be update on slection change which happens on mousedown
                    if ($3e7869c8210cedd8$var$isLinkDirectTarget(event)) {
                        event.preventDefault();
                        return true;
                    }
                    return false;
                },
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                mousedown: (view, event)=>{
                    // since link clicks are disallowed by browsers inside contenteditable
                    // so we need to handle shift+click selection ourselves in this case
                    if (!event.shiftKey || !$3e7869c8210cedd8$var$isLinkDirectTarget(event)) return false;
                    const { state: state } = view;
                    const { selection: { $anchor: $anchor } } = state;
                    const newPosition = view.posAtCoords({
                        left: event.clientX,
                        top: event.clientY
                    });
                    if (newPosition?.pos != null && newPosition.pos !== $anchor.pos) {
                        const tr = state.tr.setSelection((0, $ks2lK.TextSelection).create(state.doc, $anchor.pos, newPosition.pos));
                        view.dispatch(tr);
                        return true;
                    }
                    return false;
                }
            }
        }
    });
function $3e7869c8210cedd8$var$isLinkDirectTarget(event) {
    return event?.target instanceof HTMLElement && event.target.tagName === 'A';
}
module.exports["stateKey"] = $3e7869c8210cedd8$export$77b371d6becc8882;
module.exports["plugin"] = $3e7869c8210cedd8$export$ca524d3785e2543;

});

parcelRegister("9rqFK", function(module, exports) {
function $05031b797e1bbbf6$export$8476280b1d47554d(pos) {
    return ({ tr: tr })=>{
        const node = tr.doc.nodeAt(pos);
        return !!node && node.isText;
    };
}
module.exports["isTextAtPos"] = $05031b797e1bbbf6$export$8476280b1d47554d;

});

parcelRegister("cftLn", function(module, exports) {

var $42omo = parcelRequire("42omo");

// Note: Flag 'contentRendered' resolves bug with duplicates messages (NVDA + Firefox)
// https://github.com/nvaccess/nvda/labels/bug%2Fdouble-speaking
let $d94f7dc8793f68cd$var$timer;
const $d94f7dc8793f68cd$var$Announcer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ ariaAtomic: ariaAtomic = 'true', ariaLive: ariaLive = 'polite', ariaRelevant: ariaRelevant = 'all', role: role = 'status', text: text = '', delay: delay = 0 }, ref)=>{
    const [contentRendered, setContentRendered] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        clearTimeout($d94f7dc8793f68cd$var$timer);
        setContentRendered(false);
        $d94f7dc8793f68cd$var$timer = setTimeout(()=>{
            setContentRendered(true);
        }, delay);
        return ()=>clearTimeout($d94f7dc8793f68cd$var$timer);
    }, [
        text,
        delay
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "assistive",
        ref: ref,
        role: role,
        "aria-atomic": ariaAtomic,
        "aria-relevant": ariaRelevant,
        "aria-live": ariaLive,
        "data-vc": "etvNDJtP"
    }, contentRendered && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, text));
});
const $d94f7dc8793f68cd$var$_default_1 = /*#__PURE__*/ (0, $42omo.memo)($d94f7dc8793f68cd$var$Announcer);
var $d94f7dc8793f68cd$export$2e2bcd8739ae039 = $d94f7dc8793f68cd$var$_default_1;
module.exports["default"] = $d94f7dc8793f68cd$export$2e2bcd8739ae039;

});

parcelRegister("liOw1", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $a4550e003cde9c28$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    displayText: {
        id: "fabric.editor.displayText",
        defaultMessage: "Text to display"
    },
    clearText: {
        id: "fabric.editor.clearLinkText",
        defaultMessage: "Clear text"
    },
    clearLink: {
        id: "fabric.editor.clearLink",
        defaultMessage: "Clear link"
    },
    hyperlinkAriaLabel: {
        id: "fabric.editor.hyperlink.ariaLabel",
        defaultMessage: "Hyperlink Edit"
    },
    searchLinkAriaDescription: {
        id: "fabric.editor.hyperlink.searchLinkAriaDescription",
        defaultMessage: "Suggestions will appear below as you type into the field"
    },
    searchLinkResults: {
        id: "fabric.editor.hyperlink.searchLinkResults",
        defaultMessage: "{count, plural, =0 {no results} one {# result} other {# results}} found"
    },
    linkVisibleLabel: {
        id: "fabric.editor.hyperlink.linkVisibleLabel",
        defaultMessage: "Paste or search for link"
    },
    textVisibleLabel: {
        id: "fabric.editor.hyperlink.textVisibleLabel",
        defaultMessage: "Display text (optional)"
    }
});
module.exports["messages"] = $a4550e003cde9c28$export$defe85febe8b728c;

});

parcelRegister("1DCSy", function(module, exports) {
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $aFUXX = parcelRequire("aFUXX");

const $7aa8e252f29636a5$export$b81ddbf3e2eaad80 = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    'input&': {
        background: 'transparent',
        border: `1px solid ${"var(--ds-border-input, #8C8F97)"}`,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
        borderRadius: "var(--ds-radius-small, 3px)",
        boxSizing: 'content-box',
        color: "var(--ds-text, #292A2E)",
        flexGrow: 1,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        fontSize: (0, $aFUXX.relativeFontSizeToBase16)(13),
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: '20px',
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-400, 32px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`,
        minWidth: '145px',
        /* Hides IE10+ built-in [x] clear input button */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&::-ms-clear': {
            display: 'none'
        },
        '&:focus': {
            outline: 'none',
            backgroundColor: "var(--ds-background-input-pressed, #FFFFFF)",
            borderColor: "var(--ds-border-focused, #4688EC)",
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${"var(--ds-border-focused, #4688EC)"}`
        },
        '&::placeholder': {
            color: "var(--ds-text-subtlest, #6B6E76)"
        }
    }
});
const $7aa8e252f29636a5$export$c9f899b6422903f6 = (width)=>/*#__PURE__*/ (0, $9K4OG.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        'input&': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            width: `${width}px`
        }
    });
module.exports["panelTextInput"] = $7aa8e252f29636a5$export$b81ddbf3e2eaad80;
module.exports["panelTextInputWithCustomWidth"] = $7aa8e252f29636a5$export$c9f899b6422903f6;

});

parcelRegister("1j5Rt", function(module, exports) {

var $2Hy4R = parcelRequire("2Hy4R");


var $dWCFT = parcelRequire("dWCFT");


var $c3Z6w = parcelRequire("c3Z6w");


var $61p3e = parcelRequire("61p3e");

const $7d6f549fd898afaa$var$renderAbsoluteOrRelativeDate = (timeStamp, pageAction, intl)=>{
    let pageActionText = '';
    switch(pageAction){
        case 'updated':
            pageActionText = intl.formatMessage((0, $61p3e.default).timeUpdated);
            break;
        case 'viewed':
            pageActionText = intl.formatMessage((0, $61p3e.default).timeViewed);
            break;
    }
    if ((0, $2Hy4R.default)(timeStamp, Date.now()) < -7) return {
        pageAction: pageActionText,
        dateString: (0, $dWCFT.default)(timeStamp, 'MMMM dd, yyyy')
    };
    return {
        pageAction: pageActionText,
        dateString: (0, $c3Z6w.default)(timeStamp, Date.now()),
        timeSince: intl.formatMessage((0, $61p3e.default).timeAgo)
    };
};
const $7d6f549fd898afaa$export$439b9bb86eb9f500 = (intl, lastViewedDate, lastUpdatedDate)=>{
    if (lastViewedDate) return $7d6f549fd898afaa$var$renderAbsoluteOrRelativeDate(lastViewedDate, 'viewed', intl);
    if (lastUpdatedDate) return $7d6f549fd898afaa$var$renderAbsoluteOrRelativeDate(lastUpdatedDate, 'updated', intl);
};
module.exports["transformTimeStamp"] = $7d6f549fd898afaa$export$439b9bb86eb9f500;

});

parcelRegister("enBNf", function(module, exports) {

var $8m4tT = parcelRequire("8m4tT");

const $e22773de7afb6fcb$export$8435d1ef36841a34 = (state, selection)=>{
    const { codeBlock: codeBlock } = state.schema.nodes;
    return (0, $8m4tT.findSelectedNodeOfType)(codeBlock)(selection || state.selection) || (0, $8m4tT.findParentNodeOfType)(codeBlock)(selection || state.selection);
};
module.exports["findCodeBlock"] = $e22773de7afb6fcb$export$8435d1ef36841a34;

});

parcelRegister("8DwGl", function(module, exports) {

var $7XFGZ = parcelRequire("7XFGZ");

const $54077a468fc5a322$export$3d7a3b3f27c57f56 = (state, markType)=>{
    const { $from: $from, from: from, to: to, empty: empty } = state.selection;
    if (empty) return !!markType.isInSet(state.storedMarks || $from.marks());
    let rangeHasMark = false;
    if (state.selection instanceof (0, $7XFGZ.CellSelection)) state.selection.forEachCell((cell, cellPos)=>{
        const from = cellPos;
        const to = cellPos + cell.nodeSize;
        if (!rangeHasMark) rangeHasMark = state.doc.rangeHasMark(from, to, markType);
    });
    else rangeHasMark = state.doc.rangeHasMark(from, to, markType);
    return rangeHasMark;
};
module.exports["anyMarkActive"] = $54077a468fc5a322$export$3d7a3b3f27c57f56;

});

parcelRegister("9cWZh", function(module, exports) {
function $f3c46b07b5a459a4$export$e20225b4cda674a8(type, item) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const isDOMStringList = (t)=>!t.indexOf && !!t.contains;
    return isDOMStringList(type) ? type.contains(item) : type.indexOf(item) > -1;
}
module.exports["checkClipboardTypes"] = $f3c46b07b5a459a4$export$e20225b4cda674a8;

});

parcelRegister("kqmjz", function(module, exports) {

var $3Ter7 = parcelRequire("3Ter7");

const $67ab51ebeb2c1587$export$c20bd22f1bffad40 = (slice, schema)=>{
    const { extension: extension, inlineExtension: inlineExtension } = schema.nodes;
    return (0, $3Ter7.mapSlice)(slice, (node)=>{
        if ([
            extension,
            inlineExtension
        ].includes(node.type) && typeof node.attrs.parameters?.macroMetadata?.macroId?.value !== 'undefined') // Strip the macroId. While pasting on the same page, macroId does not change until the page
        // is published and causes collision with the existing macroId where switching tabs of one
        // node changes the tabs for the other node
        delete node.attrs.parameters.macroMetadata.macroId;
        return node;
    });
};
module.exports["transformSliceToRemoveMacroId"] = $67ab51ebeb2c1587$export$c20bd22f1bffad40;

});

parcelRegister("6h7hA", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $019333017709b529$export$940a17143b866527 = (0, $aXWIB.defineMessages)({
    typeAheadPopupLabel: {
        id: "fabric.editor.typeAhead.popupLabel",
        defaultMessage: "Typeahead results"
    },
    quickInsertPopupLabel: {
        id: "fabric.editor.typeAhead.quickInsertPopupLabel",
        defaultMessage: "Shortcuts for inserts and formatting"
    },
    quickInsertInputLabel: {
        id: "fabric.editor.typeAhead.quickInsertInputLabel",
        defaultMessage: "Begin typing to search or filter shortcut options"
    },
    quickInsertInputPlaceholderLabel: {
        id: "fabric.editor.typeAhead.quickInsertInputPlaceholderLabel",
        defaultMessage: "Search"
    },
    emojiPopupLabel: {
        id: "fabric.editor.typeahead.emojiPopupLabel",
        defaultMessage: "Emoji shortcuts"
    },
    emojiInputLabel: {
        id: "fabric.editor.typeahead.emojiInputLabel",
        defaultMessage: "Begin typing to search or filter emoji options"
    },
    mentionPopupLabel: {
        id: "fabric.editor.typeahead.mentionPopupLabel",
        defaultMessage: "Users you can tag"
    },
    mentionInputLabel: {
        id: "fabric.editor.typeahead.mentionInputLabel",
        defaultMessage: "Begin typing to search for users to tag"
    },
    metionListItemLabel: {
        id: "fabric.editor.typeahead.metionListItemLabel",
        defaultMessage: "User {name} @{shortName}"
    },
    emojiListItemLabel: {
        id: "fabric.editor.typeahead.emojiListItemLabel",
        defaultMessage: "Emoji {name} Text Shortcut {shortcut}"
    },
    inputQueryAssistiveLabel: {
        id: "fabric.editor.inputQueryAssistiveTxt",
        defaultMessage: "When autocomplete results are available use up and down arrows to review and enter to select. Touch device users, explore by touch or with swipe gestures."
    },
    searchResultsLabel: {
        id: "fabric.editor.searchResults",
        defaultMessage: "{itemsLength, plural, one {# search result} other {# search results}} available. Use Up and Down arrow keys to navigate amongst the options. Press Enter to select an option."
    },
    noSearchResultsLabel: {
        id: "fabric.editor.noSearchResults",
        defaultMessage: "No search results"
    },
    descriptionLabel: {
        id: "fabric.editor.description",
        defaultMessage: "Description"
    },
    shortcutLabel: {
        id: "fabric.editor.shortcut",
        defaultMessage: "Text shortcut"
    },
    typeAheadErrorFallbackHeading: {
        id: "fabric.editor.typeAheadErrorFallbackHeading",
        defaultMessage: "Something went wrong"
    },
    typeAheadErrorFallbackDesc: {
        id: "fabric.editor.typeAheadErrorFallbackDescription",
        defaultMessage: "No results available. Try again."
    },
    viewAllInserts: {
        id: "fablric.editor.viewAllInserts",
        defaultMessage: "View all inserts"
    },
    emptySearchResults: {
        id: "fabric.editor.emptySearchResults",
        defaultMessage: "We couldn't find any results."
    },
    emptySearchResultsSuggestion: {
        id: "fabric.editor.emptySearchResultsSuggestion",
        defaultMessage: "Select {buttonName} to browse inserts."
    },
    emptySearchResultsSuggestionNew: {
        id: "fabric.editor.emptySearchResultsSuggestionNew",
        defaultMessage: "Select {askRovoName} for help, or {buttonName} to browse inserts."
    },
    emptySearchResultsSuggestionAskRovoOnly: {
        id: "fabric.editor.emptySearchResultsSuggestionAskRovoOnly",
        defaultMessage: "Select {askRovoName} for help."
    }
});
module.exports["typeAheadListMessages"] = $019333017709b529$export$940a17143b866527;

});

parcelRegister("33Muq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f5b21011f48bf458b340a61b5c22f75f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $23a743f49ab7286b$var$_react = $23a743f49ab7286b$var$_interopRequireDefault((parcelRequire("42omo")));

var $23a743f49ab7286b$var$_baseNew = $23a743f49ab7286b$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $23a743f49ab7286b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextSubscript".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for subscript text formatting.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $23a743f49ab7286b$var$TextSubscriptIcon = (props)=>/*#__PURE__*/ $23a743f49ab7286b$var$_react.default.createElement($23a743f49ab7286b$var$_baseNew.default, Object.assign({
        name: "TextSubscriptIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m6.26 8 3.69 6H8.19L5.4 9.47 2.78 14H1.05l3.46-6-3.46-6h1.73L5.4 6.53 8.19 2h1.76zm7.49.5h.08a.75.75 0 0 1 .67.75V16H13v-6h-1V8.5z"/>`
    }, props));
$23a743f49ab7286b$var$TextSubscriptIcon.displayName = 'TextSubscriptIcon';
var $23a743f49ab7286b$var$_default = module.exports.default = $23a743f49ab7286b$var$TextSubscriptIcon;

});

parcelRegister("6MAS3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4915c62246fa16053f30e48aed5989a6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4f03d38d5ba7e3b0$var$_react = $4f03d38d5ba7e3b0$var$_interopRequireDefault((parcelRequire("42omo")));

var $4f03d38d5ba7e3b0$var$_baseNew = $4f03d38d5ba7e3b0$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $4f03d38d5ba7e3b0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextSuperscript".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for superscript text formatting.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4f03d38d5ba7e3b0$var$TextSuperscriptIcon = (props)=>/*#__PURE__*/ $4f03d38d5ba7e3b0$var$_react.default.createElement($4f03d38d5ba7e3b0$var$_baseNew.default, Object.assign({
        name: "TextSuperscriptIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m6.26 8 3.69 6H8.19L5.4 9.47 2.78 14H1.05l3.46-6-3.46-6h1.73L5.4 6.53 8.19 2h1.76zm7.49-8h.08a.75.75 0 0 1 .67.75V7.5H13v-6h-1V0z"/>`
    }, props));
$4f03d38d5ba7e3b0$var$TextSuperscriptIcon.displayName = 'TextSuperscriptIcon';
var $4f03d38d5ba7e3b0$var$_default = module.exports.default = $4f03d38d5ba7e3b0$var$TextSuperscriptIcon;

});

parcelRegister("lG3Ww", function(module, exports) {
"use strict";

var $eGvGZ = parcelRequire("eGvGZ");

Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "List", {
    enumerable: true,
    get: function get() {
        return $fc80942c2f3218a4$var$_List["default"];
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function get() {
        return $fc80942c2f3218a4$var$_List["default"];
    }
});

var $fc80942c2f3218a4$var$_List = $eGvGZ((parcelRequire("7bDv1")));

});

parcelRegister("c6sGd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.requestAnimationTimeout = module.exports.cancelAnimationTimeout = void 0;

var $eNwbr = parcelRequire("eNwbr");

/*:: export type AnimationTimeoutId = {
  id: number,
};*/ var $8cfc4ad189f47a0d$var$cancelAnimationTimeout = module.exports.cancelAnimationTimeout = function cancelAnimationTimeout(frame /*: AnimationTimeoutId*/ ) {
    return (0, $eNwbr.caf)(frame.id);
};
/**
 * Recursively calls requestAnimationFrame until a specified delay has been met or exceeded.
 * When the delay time has been reached the function you're timing out will be called.
 *
 * Credit: Joe Lambert (https://gist.github.com/joelambert/1002116#file-requesttimeout-js)
 */ var $8cfc4ad189f47a0d$var$requestAnimationTimeout = module.exports.requestAnimationTimeout = function requestAnimationTimeout(callback /*: Function*/ , delay /*: number*/ ) /*: AnimationTimeoutId*/ {
    var start;
    // wait for end of processing current event handler, because event handler may be long
    Promise.resolve().then(function() {
        start = Date.now();
    });
    var _timeout = function timeout() {
        if (Date.now() - start >= delay) callback.call();
        else frame.id = (0, $eNwbr.raf)(_timeout);
    };
    var frame /*: AnimationTimeoutId*/  = {
        id: (0, $eNwbr.raf)(_timeout)
    };
    return frame;
};

});

parcelRegister("9hl0i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getMaxElementSize = void 0;
var $6c15fe7e0ebdc04f$var$DEFAULT_MAX_ELEMENT_SIZE = 1500000;
var $6c15fe7e0ebdc04f$var$CHROME_MAX_ELEMENT_SIZE = 1.67771e7;
var $6c15fe7e0ebdc04f$var$isBrowser = function isBrowser() {
    return typeof window !== 'undefined';
};
var $6c15fe7e0ebdc04f$var$isChrome = function isChrome() {
    return !!window.chrome;
};
var $6c15fe7e0ebdc04f$var$getMaxElementSize = module.exports.getMaxElementSize = function getMaxElementSize() /*: number*/ {
    if ($6c15fe7e0ebdc04f$var$isBrowser()) {
        if ($6c15fe7e0ebdc04f$var$isChrome()) return $6c15fe7e0ebdc04f$var$CHROME_MAX_ELEMENT_SIZE;
    }
    return $6c15fe7e0ebdc04f$var$DEFAULT_MAX_ELEMENT_SIZE;
};

});

parcelRegister("jSDb4", function(module, exports) {
var $0e9293075d6a64cd$export$8dcc3cd59f9a0726 = /*#__PURE__*/ function(InsertStatus) {
    InsertStatus["EDIT_LINK_TOOLBAR"] = "EDIT";
    InsertStatus["INSERT_LINK_TOOLBAR"] = "INSERT";
    InsertStatus["EDIT_INSERTED_TOOLBAR"] = "EDIT_INSERTED";
    return InsertStatus;
}({});
module.exports["InsertStatus"] = $0e9293075d6a64cd$export$8dcc3cd59f9a0726;

});

parcelRegister("eNwbr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.raf = module.exports.caf = void 0;
/*:: type Callback = (timestamp: number) => void;*/ /*:: type CancelAnimationFrame = (requestId: number) => void;*/ /*:: type RequestAnimationFrame = (callback: Callback) => number;*/ // Properly handle server-side rendering.
var $ac5e9b474474ce07$var$win;
if (typeof window !== 'undefined') $ac5e9b474474ce07$var$win = window;
else if (typeof self !== 'undefined') $ac5e9b474474ce07$var$win = self;
else $ac5e9b474474ce07$var$win = {};
// requestAnimationFrame() shim by Paul Irish
// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
var $ac5e9b474474ce07$var$request = $ac5e9b474474ce07$var$win.requestAnimationFrame || $ac5e9b474474ce07$var$win.webkitRequestAnimationFrame || $ac5e9b474474ce07$var$win.mozRequestAnimationFrame || $ac5e9b474474ce07$var$win.oRequestAnimationFrame || $ac5e9b474474ce07$var$win.msRequestAnimationFrame || function(callback /*: Callback*/ ) /*: RequestAnimationFrame*/ {
    return $ac5e9b474474ce07$var$win /*: any*/ .setTimeout(callback, 1000 / 60);
};
var $ac5e9b474474ce07$var$cancel = $ac5e9b474474ce07$var$win.cancelAnimationFrame || $ac5e9b474474ce07$var$win.webkitCancelAnimationFrame || $ac5e9b474474ce07$var$win.mozCancelAnimationFrame || $ac5e9b474474ce07$var$win.oCancelAnimationFrame || $ac5e9b474474ce07$var$win.msCancelAnimationFrame || function(id /*: number*/ ) {
    $ac5e9b474474ce07$var$win /*: any*/ .clearTimeout(id);
};
var $ac5e9b474474ce07$var$raf /*: RequestAnimationFrame*/  = module.exports.raf = $ac5e9b474474ce07$var$request /*: any*/ ;
var $ac5e9b474474ce07$var$caf /*: CancelAnimationFrame*/  = module.exports.caf = $ac5e9b474474ce07$var$cancel /*: any*/ ;

});


$parcel$global.rlb("rFdxz")
//# sourceMappingURL=FullPageEditorComponent.aa4db61d.js.map
